webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	
	
	window.main = true;
	
	if (!window.prefetch) {
	    angular.bootstrap(document.body, ['app']);
	    __webpack_require__("./js/app.js");
	}

/***/ }),

/***/ "./..":
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(__webpack_module_template_argument_0__);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__("../node_modules/style-loader/addStyles.js")(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/less-loader/index.js!./styles.less", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/less-loader/index.js!./styles.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ "./css/app.less":
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__("../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./css/app.less");
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__("../node_modules/style-loader/addStyles.js")(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./app.less", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./app.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./css/app.less":
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "section#addCard h1{margin-bottom:0}section#addCard .prop-img{height:92px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_shield_bags.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){section#addCard .prop-img{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_shield_bags_2x.png\");background-size:206px 92px}}.addressLabel{display:none}@media (min-width:0) and (max-width:30em){section#addCard #notifications,section#updateCard #notifications{margin-top:10px}}.trayOpen #main{float:right;margin-right:-320px;width:100%;border-left:1px solid #ddd;min-height:490px}.trayOpen .maskMember .trayViewMask{width:100%;height:114%;position:absolute;top:-85px;left:-30px;z-index:6;cursor:pointer;background-color:#edf2f5;-webkit-opacity:.5;-moz-opacity:.5;opacity:.5;min-height:550px}.trayOpen .justMember,.trayOpen .paypalHeaderWrapper{opacity:.5}.asideContent{overflow-y:auto;overflow-x:hidden}.sidebar{position:absolute;left:-350px;top:-80px;width:320px}.sidebar .asideContent{overflow-y:auto;overflow-x:hidden}@media (max-width:41.25em){.trayOpen #main{margin-right:-295px}.trayOpen .sidebar{left:-295px;top:-65px;width:295px}.trayOpen .minibrowser #main{min-height:535px;margin-right:-320px}.trayOpen .minibrowser .sidebar{left:-320px;top:-75px;width:320px}.trayOpen .maskMember .trayViewMask{top:-80px;left:0}}#addCard .firstname{float:left;width:48.15%;padding:0}#addCard .lastname{float:right;width:48.15%;padding:0}#addCard .replaced{position:relative;z-index:8;width:100%;height:40px;border:0;line-height:2}#addCard #billingAddress{clear:both;width:100%;margin-top:0}#addCard .dropdown .billingAddress{margin:5px 0 20px}#addCard .addNewBillingAddress{float:right}blockquote,body,code,dd,div,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,html,input,legend,li,ol,p,pre,td,textarea,th,ul{margin:0;padding:0}table{border-collapse:collapse;border-spacing:0}fieldset,img{border:0}address,caption,cite,code,dfn,em,strong,th,var{font-style:normal;font-weight:400}ol,ul{list-style:none}caption,th{text-align:left}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:400}q:after,q:before{content:\"\"}abbr,acronym{border:0;font-variant:normal}sup{vertical-align:text-top}sub{vertical-align:text-bottom}input,select,textarea{font-family:inherit;font-size:inherit;font-weight:inherit;font-size:100%}legend{color:#000}body{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:95%;color:#2c2e2f;line-height:1.35em}h1{font-size:138.5%}h2{font-size:123.1%}h3{font-size:108%}h1,h2,h3{margin:1em 0}h1,h2,h3,h4,h5,h6,strong{font-weight:700}a{color:#0070ba}abbr,acronym{border-bottom:1px dotted #000;cursor:help}em{font-style:italic}blockquote,dl,ol,ul{margin:1em}dl,ol,ul{margin-left:2em}ol{list-style:decimal outside}ul{list-style:disc outside}dl dd{margin-left:1em}td,th{border:1px solid #000;padding:.5em}th{font-weight:700;text-align:center}input{margin-bottom:10px}caption{margin-bottom:.5em;text-align:center}fieldset,legend,p,pre,table{margin-bottom:1em}input[type=password],input[type=text],textarea{width:12.25em;*width:11.9em}.row-fluid{width:100%;*zoom:1}.row-fluid:after,.row-fluid:before{display:table;content:\"\"}.row-fluid:after{clear:both}.row-fluid>[class*=span]{float:left;margin-left:4.12765957%}.row-fluid>[class*=span]:first-child{margin-left:0}.row-fluid>.span24{width:99.99999998%}.row-fluid>.span23{width:95.74468083%}.row-fluid>.span22{width:91.48936168%}.row-fluid>.span21{width:87.23404253%}.row-fluid>.span20{width:82.97872339%}.row-fluid>.span19{width:78.72340424%}.row-fluid>.span18{width:74.46808509%}.row-fluid>.span17{width:70.21276594%}.row-fluid>.span16{width:65.95744679%}.row-fluid>.span15{width:61.70212765%}.row-fluid>.span14{width:54.4468085%}.row-fluid>.span13{width:53.19148935%}.row-fluid>.span12{width:48.9361702%}.row-fluid>.span11{width:44.68085105%}.row-fluid>.span10{width:40.42553191%}.row-fluid>.span9{width:36.17021276%}.row-fluid>.span8{width:31.91489361%}.row-fluid>.span7{width:27.65957446%}.row-fluid>.span6{width:23.40425531%}.row-fluid>.span5{width:19.14893617%}.row-fluid>.span4{width:14.89361702%}.row-fluid>.span3{width:10.63829787%}.row-fluid>.span2{width:6.38297872%}.row-fluid>.span1{width:2.12765957%}.container-fluid{padding-left:20px;padding-right:20px;*zoom:1}.container-fluid:after,.container-fluid:before{display:table;content:\"\"}.container-fluid:after{clear:both}.mt10,.mt15{margin-top:10px}.pt10{padding-top:10px}.pt15{padding-top:15px}.mb10{margin-bottom:10px}.mb15{margin-bottom:15px}.pb10{padding-bottom:10px}.pb15{padding-bottom:15px}.ml10{margin-left:10px}.ml15{margin-left:15px}.pl10{padding-left:10px}.pl15{padding-left:15px}.mr10{margin-right:10px}.mr15{margin-right:15px}.pr10{padding-right:10px}.pr15{padding-right:15px}.btn{height:44px;margin-bottom:0;border:1px solid #0070ba;border-radius:5px;*margin-left:.3em;display:inline-block;*display:inline;*zoom:1;background-color:#0070ba;transition:background-color .4s ease-out 0s;font-size:1em;font-weight:700;line-height:42px;color:#fff;text-align:center;vertical-align:middle;cursor:pointer;outline:none;-webkit-font-smoothing:antialiased}.btn .btn-secondary{-webkit-font-smoothing:auto}.btn:focus,.btn:hover{background-color:#005ea6}.btn:focus{text-decoration:underline}.btn.active,.btn:active{background-color:#005ea6;outline:0}.btn.disabled,.btn[disabled]{background-color:#b2d9ea;border-color:#b2d9ea;cursor:default}.btn.firstHalf{float:left}.btn.firstHalf,.btn.secondHalf{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box}.btn.secondHalf{float:right}a.btn:focus,a.btn:hover{color:#fff}.btn:first-child{*margin-left:0}.btn-large{padding:8px 15px;font-size:18px;line-height:normal;border-radius:5px}.btn-small{padding:5px 9px;font-size:11px;line-height:16px}.btn-mini{padding:2px 6px;font-size:11px;line-height:14px}.btn-secondary{border-style:solid;border-color:#e1e7eb;color:#393f44;background-color:#e1e7eb}.btn-secondary:hover{color:#393f44;border-color:#edf2f5;background-color:#edf2f5;text-decoration:none}.btn-secondary:active,.btn-secondary:focus{border-color:#c5ccd1;background-color:#c5ccd1;text-decoration:underline}.btn-secondary.disabled,.btn-secondary[disabled]{color:#393f55}a.btn-secondary:active,a.btn-secondary:focus,a.btn-secondary:hover{color:#393f44;border-color:#c5ccd1;background-color:#c5ccd1}a.btn-secondary.disabled,a.btn-secondary[disabled]{color:#393f55;background-color:#e7edf0}button.btn,input[type=submit].btn{*padding-top:2px;*padding-bottom:2px}button.btn::-moz-focus-inner,input[type=submit].btn::-moz-focus-inner{padding:0;border:0}button.btn.btn-large,input[type=submit].btn.btn-large{*padding-top:7px;*padding-bottom:7px}button.btn.btn-small,input[type=submit].btn.btn-small{*padding-top:3px;*padding-bottom:3px}button.btn.btn-mini,input[type=submit].btn.btn-mini{*padding-top:1px;*padding-bottom:1px}#largeScreenAccountCreation .buttons #backButton,section .buttons #backButton{width:30%}#largeScreenAccountCreation .buttons #proceedButton,section .buttons #proceedButton{width:65%}#largeScreenAccountCreation .buttons #proceedButton-venmoBA,#largeScreenAccountCreation .buttons #proceedButton.full,section .buttons #proceedButton-venmoBA,section .buttons #proceedButton.full{width:100%}.custom-select-container,select.replaced{position:relative}select.replaced{z-index:8;width:100%;height:44px;border:0;line-height:2;opacity:0;filter:alpha(opacity=0)}.custom-select{position:absolute;top:0;left:0;z-index:1;width:100%;transition:border-color .3s ease 0s;border-radius:5px}.custom-select,.custom-select>span{display:block;background-clip:padding-box}.custom-select>span{padding:7px 30px 7px 13px;border:1px solid #ccd0d4;border-radius:5px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:right -7px top -1178px;color:#000;line-height:28px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.disabled .custom-select>span{background-position:right -7px top -6990px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat right 10px center;background-size:16px;color:#c72e2e;border:1px solid #c72e2e}.custom-select span span{display:block;overflow:hidden;height:28px;text-overflow:ellipsis;white-space:nowrap;font-size:1em}.custom-select.active>span{border:1px solid #009cde;outline:0}#task .custom-select{border-radius:5px;background-clip:padding-box}.mobile .dob label{position:static;top:0;left:0}input[type=date]{padding:5px 38px 3px 6px;border:1px solid #ccd0d4;border-radius:5px;background-clip:padding-box;color:#333;background-size:24px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_cart_icons.png\") no-repeat 100% 61%}input[type=date]:focus{border-color:#39f}.showDropdopwnLabels .labelText{float:left;color:#aaa}.showDropdopwnLabels .valueText{float:right;min-width:90px}@media (min-width:0) and (max-width:40em){.showDropdopwnLabels .labelText{display:none}.showDropdopwnLabels .valueText{float:none;min-width:0}}.multiline-select-container{outline:0 none}.multiline-select-container:active .innerContainer,.multiline-select-container:focus .innerContainer{border-color:#009cde}.multiline-select-container.open:active .innerContainer,.multiline-select-container.open:focus .innerContainer{border-color:#ccd0d4}.multiline-select-container option,.multiline-select-container select{position:absolute!important;left:-9999px}.multiline-select-container .custom-select{position:relative}.multiline-select-container .custom-select span span{height:auto;white-space:normal}.multiline-select-container .custom-select>span{background:none}.multiline-select-container.open .custom-select>span{border-radius:5px 5px 0 0;border-bottom-color:#eee}.multiline-select-container .arrow{background-clip:padding-box;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_forms.png\");background-position:left -8px top -1198px;background-repeat:no-repeat;height:10px;position:absolute;width:14px;top:40%;right:12px}.backendError .multiline-select-container .ng-invalid+.custom-select .arrow,.validated .multiline-select-container .ng-invalid+.custom-select .arrow{display:none}.multiline-select-list{position:absolute;list-style:none;margin:0;background-color:#fff;z-index:1000;border-radius:0 0 5px 5px;border-bottom:1px solid #ccd0d4;max-height:200px;overflow:auto;box-shadow:0 -1px 1px 0 #ccc}.multiline-select-list li{padding:10px;border:1px solid;border-color:#eee #ccd0d4;border-top:0 none;cursor:pointer;line-height:1.35em;vertical-align:middle}.multiline-select-list li:active,.multiline-select-list li:focus,.multiline-select-list li:hover{background-color:#e5f5fc;outline:0 none}.multiline-select-list li:first-of-type{border-top:0 none}.multiline-select-list li:last-of-type{border-bottom:0 none}.multiline-select-list:hover li:focus{background-color:#fff}.multiline-select-list:hover li:focus:active,.multiline-select-list:hover li:focus:hover{background-color:#e5f5fc}#midflash,.accessAid{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}body{-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#fff}a{text-decoration:none;-webkit-tap-highlight-color:rgba(0,0,0,.2)}a:focus,a:hover{color:#005ea6;text-decoration:underline;outline:none}a.dashed{text-decoration:none;border-bottom:1px dashed #0070ba;font-size:.9em}[tabindex=\"-1\"]{outline:none}em{font-style:normal;font-weight:700}fieldset{margin:0;padding:0;border:0}fieldset legend{padding-bottom:.5em;font-size:1.5em}section:focus{outline:none}.show-section{display:block}hr.faded{width:100%;height:1px;margin:10px 0;border:0;background-image:-o-linear-gradient(left,transparent,rgba(0,0,0,.75),transparent)}.alpha{font-size:1.5em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin:.5em 0;line-height:1.154em}#loginSection h1.alpha{max-width:240px}.asideAlpha{font-size:1.44em}aside .aside .header.noButtons .walletHeading{text-align:center;line-height:1.05em}.beta{font-size:1.54em;color:#2c2e2f;font-weight:lighter;line-height:1.2em}.gamma{font-size:1.3em}.gamma,.zeta{font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin-bottom:.75em}.zeta{font-size:1.25em}.delta{font-size:1.1em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;margin-bottom:12px;font-weight:400}.vprop-header{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin:10px 0;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.vprop-content,.vprop-header{color:#2c2e2f;font-weight:lighter;line-height:1.2em}.vprop-content{font-size:1em;font-family:HelveticaNeue,helvetica,arial,sans-serif}.vprop-image{margin-top:25px}.eta{font-size:1.1em}.eta,.theta{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400}.theta{font-size:1em}.value-prop-title{color:#2c2e2f;font-size:24px;font-weight:lighter;margin:10px 0}.props{padding:0 0 0 5px;clear:both;text-align:center}.props li,.props p{line-height:1.154em;line-height:1.2em}.secondary{color:#6c7378;font-size:.85em}.legal{color:#6c7378;font-size:.75em;line-height:1.154em}.legal a{font-weight:700}.mu{font-size:2.46em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-weight:400;text-shadow:0 1px 0 #fff;color:#0079c1}.noHead{margin-top:0}.noBottom{margin-bottom:0}.showTray #task{overflow:hidden;margin-left:0}#spinner,.hide{display:none}.clearfix,.loading #spinner,.media .img img,html[xmlns] .clearfix{display:block}#billingToggleLink{display:inline-block}.left{float:left}.right{float:right}.center{text-align:center}.outerWrapper{position:relative;border-radius:5px;background-clip:padding-box;background-color:#fff}header{z-index:2}.framed #wrapper,html.framed{border-radius:5px;background-clip:padding-box}html.framed .trayOpen #main{height:585px}html.framed .trayOpen .asideContent{height:495px}body>iframe,body>img{display:none}#wrapper{margin:0 auto;max-width:780px;border:1px solid #e3e3e3;border-radius:5px;overflow-y:visible;outline:none}#wrapper,#wrapper #header{-ms-box-sizing:border-box;box-sizing:border-box;background-clip:padding-box;position:relative;background-color:#fff}#wrapper #header{border-radius:5px 5px 0 0;width:100%;z-index:4;box-shadow:0 0 3px 0}#contents{position:relative;z-index:1}.active #wrapper{visibility:visible;-webkit-animation-duration:.4s;-webkit-animation-timing-function:ease;-webkit-animation-name:slideUp}#logo{margin:22px 0 0 20px}.container{clear:both;padding:20px}.containerNoHead{padding-top:0}.noPaddingBottom{padding-bottom:0}.noPaddingTop{padding-top:0}.subContainer{border-top:1px solid #e3e3e3;padding:20px 0;position:relative}#proceedButton{width:46.4%;-ms-box-sizing:border-box;box-sizing:border-box;float:right}#proceedButton.full{width:100%}#proceedButton:focus{color:#fff}#backButton{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box;float:left}#backButton:focus,#backButton:hover{color:#2c2e2f}.middleName{display:none;float:right}.h2,h2{font-size:1.2em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin-top:0;font-weight:400;color:#0666b3}.clearfix:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}* html .clearfix{height:1%}#sliding-area{overflow:hidden}#main{padding:25px 30px 15px;transition:margin .3s ease-out;width:100%;float:right;-ms-box-sizing:border-box;box-sizing:border-box}.loading #main{background:none}.bmlLoadingMessage,.loginLoadingMessage,.loginProcessing .genericLoadingMessage{display:none}.loginProcessing .loginLoadingMessage{display:block}.full{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;text-decoration:none}.trayInner{padding:20px 0}.disclaimer{font-size:.75em;color:#6c7378}.reviewMsg{margin-top:10px;line-height:1.5}.infoTxt{clear:both;padding-top:10px}.help{color:#a9a9a9}.keyValue label{color:#292929}.frontArrow{position:absolute;display:inline-block;width:9px;height:15px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-196px -177px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.frontArrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.focusableIcon:focus{box-shadow:0 0 1px #6c7378}input[type=button],input[type=submit]{-webkit-appearance:none}.inputField input[disabled=disabled],.inputField input[disabled=disabled]:active,input[disabled=disabled]{background:#f7f9fa;border:1px solid #cbd2d6;color:#6c7378}input::-ms-clear{display:none}input.link:hover{cursor:pointer}input.xsmall{width:2em}input.small{width:3.35em;font-size:1em}input.medium{width:7em}input.large{width:14em}input.xlarge{width:20em}.button-as-link{margin:0;padding:0;border:none;width:auto;font-size:.85em;background:transparent;color:#0070ba;cursor:pointer}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.buttons{margin-top:15px;margin-bottom:15px;overflow:hidden}.inputField{position:relative}.inputField input,.inputField label{display:block;vertical-align:top}.ignoreValidation .inputField.error input,.inputField input,.validated .ignoreValidation .inputField input.backendError,.validated .ignoreValidation .inputField input.ng-invalid{width:100%;height:44px;padding:0 14px;border-radius:5px;background-clip:padding-box;border:1px solid #c5ccd1;color:#000;transition:border-color .3s ease 0s;-ms-box-sizing:border-box;box-sizing:border-box;background:none}.ignoreValidation .inputField.error input::-webkit-input-placeholder,.inputField input::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.backendError::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-webkit-input-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-moz-placeholder,.ignoreValidation .inputField.error input::-moz-placeholder,.inputField input:-moz-placeholder,.inputField input::-moz-placeholder,.validated .ignoreValidation .inputField input.backendError:-moz-placeholder,.validated .ignoreValidation .inputField input.backendError::-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-moz-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-ms-input-placeholder,.inputField input:-ms-input-placeholder,.validated .ignoreValidation .inputField input.backendError:-ms-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-ms-input-placeholder{color:#6c7378}.inputField input:active,.inputField input:focus{border:1px solid #009cde;outline:0}.inputField select{font-size:1.5em;margin-bottom:10px}.custom-select-container select{font-size:15px}.inputField label{position:absolute;top:14px;left:14px;cursor:text;text-align:left;color:#666;font-size:1em}.no-js .dropdown label,.no-js .inputField label{position:static}.fieldGroup .inputField{float:left;padding:0 .5em 0 0}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.inputField.error input::-webkit-input-placeholder,.validated .inputField input.backendError::-webkit-input-placeholder,.validated .inputField input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.inputField.error input:-moz-placeholder,.inputField.error input::-moz-placeholder,.validated .inputField input.backendError:-moz-placeholder,.validated .inputField input.backendError::-moz-placeholder,.validated .inputField input.ng-invalid:-moz-placeholder,.validated .inputField input.ng-invalid::-moz-placeholder{color:#c72e2e}.inputField.error input:-ms-input-placeholder,.validated .inputField input.backendError:-ms-input-placeholder,.validated .inputField input.ng-invalid:-ms-input-placeholder{color:#c72e2e}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}.inputField.valid input{background:#fff url(https://www.paypalobjects.com/images/checkout/hermes/icon_checkmark_wallet_2x.png) no-repeat 98%;background-size:14px}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.creditCardField.valid input{background:#fff}.dropdown.error select,.inputField.error select{border:1px solid #c72e2e}.selectLabel{display:block}input::-webkit-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:1em}input:-moz-placeholder,input::-moz-placeholder{color:#6c7378;opacity:1;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}input:-ms-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.checkbox input[type=checkbox]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.checkbox input[type=checkbox]~label,.checkbox input[type=checkbox]~label.bgImgOnSpan span.bgImg{display:inline-block;position:static;min-height:25px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px 0;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.checkbox input[type=checkbox]~label,.checkbox input[type=checkbox]~label.bgImgOnSpan span.bgImg{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.checkbox input[type=checkbox]~label.bgImgOnSpan span.bgImg{display:block;float:left;width:0;height:25px;margin-left:-35px}.checkbox input[type=checkbox]~label.bgImgOnSpan{background-image:none}.checkbox.error input[type=checkbox]:focus~label,.checkbox.error input[type=checkbox]:focus~label.bgImgOnSpan span.bgImg,.checkbox.error input[type=checkbox]~label,.checkbox.error input[type=checkbox]~label.bgImgOnSpan span.bgImg{background-position:-9px -600px}.checkbox input[type=checkbox]:checked~label,.checkbox input[type=checkbox]:checked~label.bgImgOnSpan span.bgImg{background-position:-9px -400px}.checkbox input[type=checkbox]:focus:checked~label,.checkbox input[type=checkbox]:focus:checked~label.bgImgOnSpan span.bgImg{background-position:-9px -4801px}.checkbox input[type=checkbox]:focus~label,.checkbox input[type=checkbox]:focus~label.bgImgOnSpan span.bgImg{background-position:-9px -4601px}.checkbox input[type=checkbox][disabled=disabled]~label,.checkbox input[type=checkbox][disabled=disabled]~label.bgImgOnSpan span.bgImg{background-position:-9px -800px}.checkbox input[type=checkbox][disabled=disabled]:checked~label,.checkbox input[type=checkbox][disabled=disabled]:checked~label.bgImgOnSpan span.bgImg{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:25px 25px}.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label.bgImgOnSpan span.bgImg,.validated .ignoreValidation input[type=checkbox].ng-invalid~label,.validated .ignoreValidation input[type=checkbox].ng-invalid~label.bgImgOnSpan span.bgImg{background-position:-9px 0}.validated .ignoreValidation .sCheckbox.checkbox input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation .sCheckbox.checkbox input[type=checkbox].ng-invalid:focus~label.bgImgOnSpan span.bgImg,.validated .ignoreValidation .sCheckbox.checkbox input[type=checkbox].ng-invalid~label,.validated .ignoreValidation .sCheckbox.checkbox input[type=checkbox].ng-invalid~label.bgImgOnSpan span.bgImg{background-position:-9px 2600px}.validated input[type=checkbox].ng-invalid~label,.validated input[type=checkbox].ng-invalid~label.bgImgOnSpan span.bgImg{background-position:-9px -600px}.validated input[type=radio].ng-invalid+label,.validated input[type=radio].ng-invalid+label.bgImgOnSpan span.bgImg,.validated input[type=radio].ng-invalid:focus+label,.validated input[type=radio].ng-invalid:focus+label.bgImgOnSpan span.bgImg{background-position:-10px -2200px}.validated .sCheckbox.checkbox input[type=checkbox].ng-invalid~label,.validated .sCheckbox.checkbox input[type=checkbox].ng-invalid~label.bgImgOnSpan span.bgImg{background-position:-9px -3200px}.sCheckbox.checkbox{position:relative}.sCheckbox.checkbox input[type=checkbox]~label,.sCheckbox.checkbox input[type=checkbox]~label.bgImgOnSpan span.bgImg{line-height:19px;padding-left:27px;font-size:.85em;background-position:-9px -2600px}.sCheckbox.checkbox input[type=checkbox]~label.bgImgOnSpan span.bgImg{display:block;float:left;width:0;height:19px;margin-left:-27px}.sCheckbox.checkbox input[type=checkbox]~label.bgImgOnSpan{background-image:none}.sCheckbox.checkbox.error input[type=checkbox]:focus~label,.sCheckbox.checkbox.error input[type=checkbox]:focus~label.bgImgOnSpan span.bgImg,.sCheckbox.checkbox.error input[type=checkbox]~label,.sCheckbox.checkbox.error input[type=checkbox]~label.bgImgOnSpan span.bgImg{background-position:-9px -3200px}.sCheckbox.checkbox input[type=checkbox]:checked~label,.sCheckbox.checkbox input[type=checkbox]:checked~label.bgImgOnSpan span.bgImg{background-position:-9px -3000px}.sCheckbox.checkbox input[type=checkbox]:focus:checked~label,.sCheckbox.checkbox input[type=checkbox]:focus:checked~label.bgImgOnSpan span.bgImg{background-position:-9px -5409px}.sCheckbox.checkbox input[type=checkbox]:focus~label,.sCheckbox.checkbox input[type=checkbox]:focus~label.bgImgOnSpan span.bgImg{background-position:-9px -2800px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]~label,.sCheckbox.checkbox input[type=checkbox][disabled=disabled]~label.bgImgOnSpan span.bgImg{background-position:-9px -3400px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]:checked~label,.sCheckbox.checkbox input[type=checkbox][disabled=disabled]:checked~label.bgImgOnSpan span.bgImg{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:18px 19px}.radioButton input[type=radio]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.radioButton input[type=radio]~label{display:inline-block;min-height:26px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px -1600px;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.radioButton input[type=radio]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.radioButton.error input[type=radio]+label,.radioButton.error input[type=radio]:focus+label{background-position:-9px -2200px}.radioButton.warning input[type=radio]+label,.radioButton.warning input[type=radio]:focus+label{background-position:-9px -7405px}.radioButton input[type=radio]:checked+label{background-position:-9px -2000px}.radioButton input[type=radio]:focus:checked+label{background-position:-9px -6010px}.radioButton input[type=radio]:focus+label{background-position:-9px -1800px}.inputField label.nolap{position:relative;top:auto;left:auto;color:#2c2e2f}.inputField.half{width:48.15%;margin-right:3.7%;padding-right:0}.multistepSignupForm .inputField.half,.singlePagePaymentForm .inputField.half{width:48.7%;margin-right:2.6%;padding-right:0}.inputField.half.issueNo{width:42%;margin-top:15px}.inputField.half.startDate{width:54%;margin-right:10px}#cardIssueInfo .inputField.half.startDate{width:48%;margin-right:0}#cardIssueInfo .inputField.half.issueNo{width:48%;margin-top:0;float:right}#cardIssueInfo .inputField.half.issueNo:before{content:\"\\200C\"}.inputField.half.last-child{margin-right:0}.fieldGroup .inputField.last-child{padding-right:0}.fidobDay{width:30%;float:left}.fidobDay .custom-select>span{border-radius:5px 0 0 5px;border-right:0}.fidobMonth{width:30%;float:left}.fidobMonth .custom-select>span{border-radius:0}.fidobYear{width:40%;float:left}.fidobYear .custom-select>span{border-radius:0 5px 5px 0;border-left:0}.cardDOB{width:100%;clear:both}.dobLabel{top:auto;left:auto;position:relative;display:block;bottom:4px}.dobTXT{margin-top:10px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}}.submitted input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.submitted input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.submitted input.ng-invalid:-moz-placeholder,.submitted input.ng-invalid::-moz-placeholder{color:#c72e2e}.submitted input.ng-invalid:-ms-input-placeholder{color:#c72e2e}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.submitted input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}.merchantHeader{height:90px;margin:0 auto}.merchantHeader .headerWrapper{max-width:780px;margin:0 auto;overflow:hidden;max-height:90px;line-height:90px}.merchantHeader .merchantName{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400;width:575px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block}.merchantHeader img{vertical-align:middle}.paypalHeaderWrapper .logo{float:left;width:112px;height:29px;margin-top:5px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.paypalHeaderWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.paypalHeaderWrapper .span14{padding-bottom:20px;border-bottom:1px solid #dbdbdb}.paypalHeaderWrapper .cartContainer{position:static;line-height:29px}.paypalHeaderWrapper .transctionCartDetails{z-index:2}.paypalHeaderWrapper.paypalCredit .logo{height:35px;background-position:0 -129px}.aside .header{padding:15px;vertical-align:middle;line-height:50px;border-bottom:1px solid #e3e3e3}.aside .header.tall{min-height:65px;line-height:normal;padding:13px 15px 10px;margin-bottom:0}.aside .asideAlpha{padding:0 30px;text-align:center;line-height:1.2em}.aside .walletHeading{text-align:center}.aside .close{top:10px;right:15px;padding:5px;border-radius:3px}.aside .close,.aside .close:before{position:absolute;width:19px;height:19px}.aside .close:before{content:\"\";display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .close:focus:before,.aside .close:hover:before{background-position:-223px -22px}.aside .backArrow{position:absolute;top:10px;left:15px;width:9px;height:18px;padding:5px;border-radius:3px}.aside .backArrow:before{content:\"\";display:inline-block;position:absolute;width:9px;height:18px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -46px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .backArrow:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .backArrow:focus:before,.aside .backArrow:hover:before{background-position:-232px -68px}.aside .addOptions{margin-top:20px}.aside .addOptions h2{float:left;width:70%;margin-bottom:0}.aside .addOptions a{float:right;display:block;line-height:1.9em;font-size:.85em}.aside .subHeader{margin-top:20px}.CYCOPage .paypalHeader.span14,.pageSepaAgreementContingency .paypalHeader.span14,.pageSepaMandate .paypalHeader.span14,.pageSepaMandateContingency .paypalHeader.span14{width:100%}#mobileMerchantHeader{display:none}@media (max-width:41.3125em){.merchantHeader{display:none}.paypalHeaderWrapper{height:65px}.paypalHeaderWrapper .cartContainer{margin-top:10px;margin-bottom:-5px;margin-right:15px}.paypalHeaderWrapper .logo{margin:15px 0 0 30px}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}}@media (max-width:30em) and (min-width:0){.paypalHeaderWrapper .cartContainer{margin-top:15px;margin-bottom:-10px;margin-right:0}.paypalHeaderWrapper .logo{margin:15px 0 0}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}.header{height:55px}.aside .header{height:auto}.aside .close{right:15px}}.footer{max-width:780px;margin:10px auto;font-size:.75em}.cancelUrl{float:left;width:39%}.micaLender{display:none;color:#2c2e2f;clear:both}.footerWrapper table{display:inline;float:left;table-layout:fixed;border:none;width:75%}.footerWrapper td,.footerWrapper th,.footerWrapper tr{border:none;font-weight:400;padding-bottom:0;padding-top:0;text-align:left}.footerWrapper .footerLinks th{color:#6c7378}.footerWrapper .footerLinks th.feedbackLink{color:#0070ba}.footerWrapper .footerLinks .underline th{border-bottom:1px solid #ccc}.footerLinks{margin:0;display:inline-block}.footerLinks a{color:#6c7378}.footerLinks a.feedbackLink{color:#0070ba;margin-left:5px}.footerLinks th,td{border:none}.copyright{display:inline;width:auto;vertical-align:top;color:#6c7378}.secureIcon{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:0 -33px;margin-left:3px;margin-right:3px;margin-top:3px;width:10px;height:12px;vertical-align:top}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.secureIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.poweredBy{float:right;margin-top:-49px}.poweredBy .text{float:left;margin-top:8px;margin-right:8px;font-size:12px;font-weight:400;font-style:italic;color:#6c7378}.footerLinks li{padding:0 12px 0 0;display:inline-block}.footerLinks .last{padding-right:18px;border-right:none}.footer .policyInfoWrapper p{line-height:1.3em}.footer .policyInfoWrapper p a{font-weight:700}.minibrowser .APAC.footer,.minibrowser.AU .footer{position:relative;bottom:0;width:auto}.minibrowser .APAC.footer .policyInfoWrapper,.minibrowser.AU .footer .policyInfoWrapper{padding:0}.minibrowser .cancelUrl{display:none}.minibrowser .footerWrapper{padding:0 10px;float:none;width:95%;margin:0}.minibrowser .footerLinks li{padding:0 5px 0 0}.DE .footerWrapper,.fr.CA .footerWrapper,.fr.FR .footerWrapper{float:none;width:auto}.DE .footerWrapper:after,.fr.CA .footerWrapper:after,.fr.FR .footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.DE .footerLinks,.fr.CA .footerLinks,.fr.FR .footerLinks{float:left;width:70%;text-align:left}.DE .footerLinks li:first-child,.fr.CA .footerLinks li:first-child,.fr.FR .footerLinks li:first-child{padding-left:0}.DE .copyright,.fr.CA .copyright,.fr.FR .copyright{float:right;width:30%;margin:0}.DE .cancelUrl,.fr.CA .cancelUrl,.fr.FR .cancelUrl{float:none;margin:5px 0;width:100%}.APAC .policyInfoWrapper{padding:5px 0 10px;color:#6c7378}.APAC .policyInfoWrapper p.moreInfo{padding:15px 0 20px;float:left;line-height:1.3em}.AU .policyInfoWrapper,.en_AU .policyInfoWrapper{padding:20px 0 10px;color:#6c7378}.AU .policyInfoWrapper p.moreInfo,.en_AU .policyInfoWrapper p.moreInfo{padding:15px 0 20px;border-bottom:1px solid #ccc;float:left}.AU .policyInfoWrapper p.moreCopyRight,.en_AU .policyInfoWrapper p.moreCopyRight{padding:5px 0 0;clear:both}.fr_XC .footerWrapper{float:left;width:70%;text-align:left;padding-left:0;margin-left:-7px}@media (max-width:41.25em){.footer{border-top:1px solid #ccc;padding:5px 20px;margin-top:10px}.footer .policyInfoWrapper{padding:0 10px}.footerWrapper{float:none;width:100%;padding:0;margin:0}.footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.cancelUrl{width:95%;padding:0}.footerLinks{float:left;width:70%;text-align:left}.footerLinks .feedback{display:none}.minibrowser .footerLinks .feedback{display:inline-block}.copyright{width:20%}.cancelUrl{float:none;margin:5px 0}}@media (max-width:30em) and (min-width:0){.footer{margin-top:0;padding:5px 10px}.footer .policyInfoWrapper{padding:0}.cancelUrl,.footerWrapper{padding:0;margin:5px 0;width:100%}.DE .footerLinks,.footerLinks,.fr.FR .footerLinks{width:65%}.DE .footerLinks li,.footerLinks li,.fr.FR .footerLinks li{padding:0;margin-right:10px}.DE .footerLinks li.last,.footerLinks li.last,.fr.FR .footerLinks li.last{margin-right:0}.DE .footerLinks .feedback,.footerLinks .feedback,.fr.FR .footerLinks .feedback{display:none}.copyright,.DE .copyright{width:33%;margin:0}.minibrowser .copyright{margin-right:0;width:30%}.minibrowser .footerLinks .feedback{display:inline-block}}.modal-open{overflow:hidden}.modal-open #contents,.modal-open #wrapper,.modal-open .outerWrapper{position:static}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:140;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop,.modal-backdrop.fade.in{opacity:.54}.modal{display:none;overflow:auto;overflow-y:scroll;position:fixed;top:0;right:0;bottom:0;left:0;z-index:150}.modal.fade .modal-wrap{-webkit-transform:translateY(-25%);transform:translateY(-25%);transition:transform .3s ease-out}.modal.fade.in .modal-wrap{-webkit-transform:translate(0);transform:translate(0)}.modal-wrap{position:relative;margin:10px;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.3);border-radius:6px;background-clip:padding-box;box-shadow:0 3px 9px rgba(0,0,0,.3);outline:none}.modal-header{padding:9px 15px;border-bottom:1px solid #eee}.modal-header .close{margin-top:2px}.modal-header h3{margin:0;line-height:30px}.modal-body{position:relative;overflow-y:auto;max-height:400px;padding:15px}.modal-footer,.modal-form{margin-bottom:0}.modal-footer{padding:14px 15px 15px;text-align:right;background-color:#f5f5f5;border-top:1px solid #ddd;border-radius:0 0 6px 6px;background-clip:padding-box;box-shadow:inset 0 1px 0 #fff}.modal-footer:after,.modal-footer:before{display:table;content:\"\";line-height:0}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.spinner{position:absolute}.spinner .spinWrap{position:absolute;top:50%}.spinner .bmlLoadingMessage,.spinner .genericLoadingMessage,.spinner .loginLoadingMessage{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;margin-top:125px;text-align:center;z-index:100}.spinner.preloader{position:fixed;top:0;left:0;z-index:1000;background-color:#fff}.aside{min-height:380px}.aside .container{padding:15px}.asideContent{height:100%}.centerText{text-align:center}.fsIcons{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;min-width:32px;width:25px;height:21px;padding-right:5px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.BALANCE .fsIcons,.DELAYED_TRANSFER .fsIcons,.HOLDING .fsIcons{background-position:0 0}.ELO .fsIcons{background-position:0 -479px}.HIPER .fsIcons{background-position:0 -458px}.HIPERCARD .fsIcons{background-position:0 -500px}.pinlessGlyphIcon{display:inline-block;position:relative;top:-5px;left:-8px;width:32px;height:20px;font-size:3.1rem;padding-right:5px}.BANK .fsIcons,.BANK_ACCOUNT .fsIcons,.IACH .fsIcons{background-position:0 -252px;height:19px;left:19px}.ECHECK .fsIcons,.ELV .fsIcons,.TAB.DELAYED_TRANSFER .fsIcons{background-position:0 -252px;height:19px}.TAB.DELAYED_TRANSFER .fsIcons{left:19px}.BILL_ME_LATER .fsIcons,.BML .fsIcons,.CREDIT_OPTION .fsIcons,.PPCREDIT .fsIcons{background-position:0 -105px}.PAYPAL_SMART_CONNECT .fsIcons{background-position:0 0}.VISA .fsIcons{background-position:0 -21px}.MASTERCARD .fsIcons{background-position:0 -42px}.AMEX .fsIcons{background-position:0 -63px;left:19px;height:20px}.DISC .fsIcons,.DISCOVER .fsIcons{background-position:0 -84px}.JCB .fsIcons{background-position:0 -353px}.CHINA_UNION_PAY .fsIcons{background-position:0 -563px}.ELECTRON .fsIcons{background-position:0 -146px}.MAESTRO .fsIcons,.MSTRO .fsIcons,.SWITCH .fsIcons{background-position:0 -168px}.CB_NATIONALE .fsIcons,.CBN .fsIcons{background-position:0 -210px}.CELEM .fsIcons,.CETELEM .fsIcons{background-position:0 -311px}.COFINOGA .fsIcons,.CONF .fsIcons{background-position:0 -231px}.COFID .fsIcons,.COFIDIS .fsIcons{background-position:0 -437px;left:20px}.INCENTIVE .fsIcons{background-position:0 -271px;height:18px}.PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -374px}.PPSMTCONNECT .fsIcons{background-position:0 0}.ES .PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -521px}.fsIcon{display:block;position:absolute;width:25px;height:21px;left:15px;top:20px;min-width:32px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;background-position:0 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.fsIcon.BANK,.fsIcon.PAD{background-position:6px -252px;height:19px;left:19px}.fsIcon.MASTER,.fsIcon.MASTERCARD,.fsIcon.MCARD{background-position:0 -42px}.fsIcon.ELO{background-position:0 -479px}.fsIcon.HIPER{background-position:0 -458px}.fsIcon.HIPERCARD{background-position:0 -500px}.fsIcon.DISC,.fsIcon.DISCOVER{background-position:0 -84px}.fsIcon.VISA{background-position:0 -21px}.fsIcon.JCB{background-position:0 -353px}.fsIcon.AMEX,.fsIcon.Amex{background-position:6px -63px;left:19px;height:20px}.fsIcon.MAESTRO,.fsIcon.MSTRO,.fsIcon.SWITCH{background-position:0 -168px}.fsIcon.PAYPAL_SMART_CONNECT{background-position:0 0}.fsIcon.CB_NATIONALE,.fsIcon.CBN{background-position:0 -210px}.fsIcon.CELEM,.fsIcon.CETELEM{background-position:0 -311px}.fsIcon.COFID,.fsIcon.COFIDIS{background-position:0 -437px;left:20px;height:20px}.fsIcon.CHINA_UNION_PAY,.fsIcon.CUP{background-position:0 -563px}.fsIcon.COFINOGA,.fsIcon.CONF{background-position:0 -231px}.fsIcon.PAYPAL_EXTRAS_MASTERCARD,.fsIcon.PPXMCARD{background-position:0 -374px}.fsIcon.EBAY_MASTERCARD,.fsIcon.EBAYMCARD{background-position:0 0}.fsIcon.BILL_ME_LATER,.fsIcon .BML,.fsIcon .PPCREDIT{background-position:0 -105px}.fsIcon.PPSMTCONNECT{background-position:0 0}.fsIcon.pinlessIcon{background-image:none;font-size:3.1rem;left:5px;top:14px}.ES .fsIcon.PAYPAL_EXTRAS_MASTERCARD,.ES .fsIcon.PPXMCARD{background-position:0 -521px}.infoIcon{width:19px;height:18px;display:inline-block;position:absolute;top:25px;right:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-89px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.infoIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.addOption{padding:25px 10px;margin:0 0 0 44px;color:#0070ba;font-size:.85em}.plusicon{display:block;position:absolute;left:15px;top:22px;width:20px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.plusicon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.infoIcon+.checkIcon{display:none}.infoMsg{margin:0;overflow:hidden;font-size:.85em}.expiredIcon{background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%;width:16px;height:16px;top:6px}.expiredIcon,.plccIcon{display:inline-block;position:relative}.plccIcon{float:left;height:20px;background:none;width:32px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.fsIcon,.fsIcons{height:20px}}.walletIcons{position:absolute;width:30px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.walletIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons_2x.png\");background-size:90px 970px}}.walletIcons.BANK,.walletIcons.BANK_ACCOUNT{background-position:-50px -460px}.walletIcons.BANK.BOFA,.walletIcons.BANK_ACCOUNT.BOFA{background-position:-50px -10px}.walletIcons.BANK.CHASE,.walletIcons.BANK_ACCOUNT.CHASE{background-position:-50px -130px}.walletIcons.BANK.WELLSFARGO,.walletIcons.BANK_ACCOUNT.WELLSFARGO{background-position:-50px -100px}.walletIcons.BANK.CITI,.walletIcons.BANK_ACCOUNT.CITI{background-position:-50px -40px}.walletIcons.BANK.FIFTHTHIRD,.walletIcons.BANK_ACCOUNT.FIFTHTHIRD{background-position:-50px -220px}.walletIcons.BANK.CAPITAL,.walletIcons.BANK_ACCOUNT.CAPITAL{background-position:-50px -70px}.walletIcons.BANK.AMERITRADE,.walletIcons.BANK_ACCOUNT.AMERITRADE{background-position:-50px -160px}.walletIcons.BANK.SUNTRUST,.walletIcons.BANK_ACCOUNT.SUNTRUST{background-position:-50px -280px}.walletIcons.BANK.USBANK,.walletIcons.BANK_ACCOUNT.USBANK{background-position:-50px -310px}.walletIcons.BANK.USAA,.walletIcons.BANK_ACCOUNT.USAA{background-position:-50px -250px}.walletIcons.CARD.VISA,.walletIcons.PAYMENT_CARD.VISA{background-position:-10px -40px}.walletIcons.CARD.MASTER,.walletIcons.CARD.MASTERCARD,.walletIcons.PAYMENT_CARD.MASTER,.walletIcons.PAYMENT_CARD.MASTERCARD{background-position:-10px -70px}.walletIcons.CARD.DISCOVER,.walletIcons.PAYMENT_CARD.DISCOVER{background-position:-10px -100px}.walletIcons.CARD.AMEX,.walletIcons.PAYMENT_CARD.AMEX{background-position:-10px -130px}hr.sep,hr.sepPlain{padding:0;margin-top:25px;height:auto;border:none;border-top:1px solid #ccc;color:#2c2e2f;text-align:center;overflow:visible}hr.sep:after,hr.sepPlain:after{content:\"or\";display:inline-block;position:relative;top:-.7em;font-size:1em;padding:0 .5em;background:#fff;color:#6c7378;font-weight:400}.de hr.sep:after{content:\"oder\"}.da hr.sep:after{content:\"eller\"}.es hr.sep:after{content:\"o\"}.fr hr.sep:after{content:\"ou\"}.he hr.sep:after{content:\"\\5D0\\5D5\"}.id hr.sep:after{content:\"Atau\"}.it hr.sep:after{content:\"oppure\"}.ja hr.sep:after{content:\"\\307E\\305F\\306F\"}.ko hr.sep:after{content:\"\\B610\\B294\"}.nl hr.sep:after{content:\"of\"}.no hr.sep:after{content:\"eller\"}.pl hr.sep:after{content:\"lub\"}.pt hr.sep:after{content:\"ou\"}.ru hr.sep:after{content:\"\\418\\43B\\438\"}.sv hr.sep:after{content:\"eller\"}.th hr.sep:after{content:\"\\E2B\\E23\\E37\\E2D\"}.tr hr.sep:after{content:\"Veya\"}.zh hr.sep:after{content:\"\\6216\"}hr.sepPlain:after{content:\"\"}@media (min-width:0) and (max-width:23em){#loginSection .xoTitle h1{max-width:10em}}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){body{-webkit-text-size-adjust:100%}.merchantBrand{display:none}.outerWrapper{background-position:left 50px}.centerTray.loginSignup{margin-bottom:60px}#main{padding:0;background:none;z-index:2}#contents{padding:0 20px;-ms-box-sizing:border-box;box-sizing:border-box}.tokenization #contents{padding:0 30px}.paypalHeader{padding:0 20px 20px;-ms-box-sizing:border-box;box-sizing:border-box}.props,header{display:none}.review #wrapper{min-height:512px}#contents{min-height:0;margin-bottom:0}.bmlAppProcessing,.loginProcessing{background-color:#f9f9f9}.loggingIn{margin:0 25px}.mobile .loggingIn{margin:0}.saferEasier,.simpler{display:none}#login .row-fluid{padding-top:0}#login .centerTray{padding:0}#login #signupLink.btn{margin:5px 0}#wrapper{margin:0;width:auto;border-radius:0;background-clip:padding-box;border:none}#task{width:295px}.loading .spinner{background-position-y:35%}.centerTray{width:auto}.accountTerms .tray .inner,.tray .inner{padding:10px}.row-fluid>[class*=span],.signup{width:100%;margin-left:0;float:none}#notifications{width:100%}.delta,.gamma{font-size:1.2em}.inputField label{left:7px;top:13px}.saferEasier{display:none}#fundingInstruments .buttons{height:40px}.cityState select{font-size:14px}.cityState .city{width:100%}.cityState .state{width:55%}.cityState .postalCode{width:40.8%}#tab{margin-top:0;height:125px}.toolTip.whatsthis ul{width:242px;left:9px}.toolTip.whatsthis ul li{font-size:.9em}#expiration.varB .expires{width:49%}#expiration .inputField{padding:0}#expiration .cvc{width:44%;float:right}#expiration.varB .cvc{width:49%}.month{margin-left:46px}.separator{margin-left:5px;margin-top:3px}.year{margin-left:0}#expiration .cardIcon{position:absolute;right:4px}.details{margin-right:2px}.mask #closeButton,.mask #header{display:none}}@media (min-width:30.0625em) and (max-width:41.25em){#notifications,.row-fluid>.span10,.row-fluid>.span12,.row-fluid>.span14{width:100%}.outerWrapper{background-position:left 59px}.props,header{display:none}#wrapper{margin:0;border:none}#main{padding:0}#contents{padding:0 25px}}@media (min-width:41.3125em){.banner{display:block}#wrapper{min-height:0}#wrapper,.footer,.merchantHeader{width:95%}.largeScreen .centerTray{margin-top:0}.signup{margin-bottom:0}#genericError{min-height:375px;background:url(https://www.paypalobjects.com/images/checkout/hermes/scr_cloud_balloon.png) no-repeat bottom}#transactionDetails .merchantName{display:none}}@media (device-height:568px) and (-webkit-min-device-pixel-ratio:2){#contents{min-height:0;margin-bottom:0}.pageLanding #contents{margin:70px auto 40px 0}}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.cardType{display:none}ul.validations li.restriction.active{background:url(https://www.paypalobjects.com/images/checkout/hermes/close3_2x.png) no-repeat 0 2px;background-size:10px}.inputField.error input{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.inputField.error input,.inputField.valid input{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.error .custom-select.active>span,.error .custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}@media only screen and (-webkit-min-device-pixel-ratio:2) and (min-width:41.3125em){#genericError{background-size:640px 242px}}.creditCardInput #currencyConversion{outline:none}.creditCardInput #currencyConversion .toolTip.balloon{margin-left:14px;margin-top:-10px}.creditCardInput #currencyConversion #conversionLink{cursor:pointer}#billingPageCurrencyConversionRates{padding-left:14px;margin-bottom:10px}.FR .cvv input{padding-left:6px}#addCard .msg-error{position:relative;margin-top:20px}#addCard #addressAddedToolTip{margin:-10px 0 7px;border:1px solid #7cda7a;background-image:linear-gradient(180deg,#f9fcfa,#f1f8f2);min-height:17px;border-radius:3px}#addCard .addNewBillingAddress{font-size:.85em;margin-top:2px}#addCard xo-phone-input .inputField{padding:0;float:none}#addCard .otpVerification{margin-bottom:10px;color:#7b8388;font-size:.87em;line-height:1.3em}#addCard .btn{margin-top:10px}#addCard.aside #notifications{padding:0 15px;width:100%;box-sizing:border-box;margin:0 0 5px}#addCard.aside #billingAddressUpdatedMsg #notifications{padding:0}#addCard.aside .msg-error{padding:0;margin-bottom:20px;margin-top:10px}#addCard.aside .btn{margin-top:10px;margin-bottom:15px}#addCard.aside #billingAddressForm .btn{margin-top:0}.creditCardInput .plccCardNumberTitle{margin-bottom:5px}.creditCardInput .cardIconsGroup{padding:10px 13px;height:20px}.creditCardInput .cardIconsGroup,.creditCardInput .debitAndCreditIconsGroup{background-color:#f2f3f4;border:1px solid #e3e3e3;border-radius:4px;margin-bottom:10px}.creditCardInput .debitAndCreditIconsGroup{padding:10px 4px;overflow:auto}.creditCardInput .cardIconTitle{border-bottom:1px solid #dcd9d9;font-size:13px;padding-bottom:10px;margin-bottom:10px}.creditCardInput .creditIconLabel{color:#7b8388;font-size:11px;margin:-5px 0 5px}.creditCardInput .debitIconLabel{color:#7b8388;font-size:11px;margin:5px 0 2px}.creditCardInput .cardIcon{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v10_1x.png\") no-repeat 0 100px;height:22px;float:left;width:32px;padding:0 4px 0 0}.creditCardInput .cardIcon.ELO{background-position:0 -713px}.creditCardInput .cardIcon.CUP{background-position:0 -837px}.creditCardInput .cardIcon.VISA{background-position:0 -31px}.creditCardInput .cardIcon.MASTERCARD{background-position:0 -62px}.creditCardInput .cardIcon.HIPER{background-position:0 -682px}.creditCardInput .cardIcon.HIPERCARD{background-position:0 -744px}.creditCardInput .cardIcon.AMEX{background-position:0 -93px;margin-right:-10px}.creditCardInput .cardIcon.JCB{background-position:0 -527px}.creditCardInput .cardIcon.ELECTRON{background-position:0 -217px}.creditCardInput .cardIcon.MAESTRO,.creditCardInput .cardIcon.SWITCH{background-position:0 -248px}.creditCardInput .cardIcon.DISCOVER{background-position:0 -124px}.creditCardInput .cardIcon.CBNATIONALE{background-position:0 -310px}.creditCardInput .cardIcon.CETELEM{background-position:0 -465px}.creditCardInput .cardIcon.COFIDIS{background-position:0 -651px;margin-right:-10px}.creditCardInput .cardIcon.COFINOGA{background-position:0 -341px}.creditCardInput .cardIcon.QIWI{background-position:0 -806px;width:30px}.creditCardInput .debitcardIcon{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_bank_mx.png\") no-repeat 0 100px;height:21px;float:left;width:68px;padding:0 2px 0 0;margin-top:3px}.creditCardInput .debitcardIcon.BANAMEX{background-position:0 0;clear:both}.creditCardInput .debitcardIcon.BANCOARFACA{background-position:0 -22px}.creditCardInput .debitcardIcon.BBVA{background-position:0 -44px}.creditCardInput .debitcardIcon.BANORTE{background-position:0 -66px}.creditCardInput .debitcardIcon.HSBC{background-position:0 -88px}.creditCardInput .debitcardIcon.INBURSA{background-position:0 -110px}.creditCardInput .debitcardIcon.SANTANDER{background-position:0 -132px}.creditCardInput .cardType{clear:both;display:block}.creditCardInput #cardIssueInfo{display:block}.creditCardInput .expires{position:relative;display:block;top:auto;left:auto;color:#2c2e2f;margin-bottom:5px}.creditCardInput .expirationField{width:48%;float:left}.creditCardInput #expiration label,.creditCardInput label.cvv{margin-bottom:5px}.creditCardInput .expmonth{float:left;width:50%}.creditCardInput .expmonth .custom-select>span{border-radius:5px 0 0 5px;padding-right:30px}.creditCardInput .expmonth.BR .custom-select>span{padding-right:28px!important}.creditCardInput .expyear{float:left;width:50%}.creditCardInput .expyear .custom-select>span{border-radius:0 5px 5px 0;border-left:0}.creditCardInput .expyear .custom-select.active>span{border-left:1px solid #009cde}.creditCardInput .replaced{position:relative;z-index:8;width:100%;line-height:2}.creditCardInput .cvv{position:relative;top:auto;left:auto}.creditCardInput .cvvField{width:48%;float:right}.creditCardInput .cardNumber{clear:both}.creditCardInput .cardNumber input[aria-invalid=true]~xo-tooltip .toolTip{padding:0;border:none}.creditCardInput .cardNumber input[aria-invalid=true]~xo-tooltip .toolTip .tipCreditCard{display:none}.guestWithSignup .creditCardInput .debitAndCreditIconsGroup{padding:0 0 15px}.guestWithSignup .creditCardInput .cardIconTitle{padding:15px 15px 10px}.guestWithSignup .creditCardInput .cardIconsSection{padding:5px 15px 15px}.validated .ng-invalid~#creditCard,.validated input.ng-invalid:active~#creditCard,.validated input.ng-invalid:focus~#creditCard,input.backendError~#creditCard{display:none}.inputField.error #cvv,.validated .inputField input.ng-invalid#cvv{background:none}#securityCode.creditCard,.ccard,.creditCardField .creditCard{position:absolute;right:14px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v10_1x.png\") no-repeat 0 100px;height:22px;width:40px;top:14px}#securityCode.creditCard.VISA,.ccard.VISA,.creditCardField .creditCard.VISA{background-position:0 -31px}#securityCode.creditCard.MASTERCARD,.ccard.MASTERCARD,.creditCardField .creditCard.MASTERCARD{background-position:0 -62px}#securityCode.creditCard.AMEX,.ccard.AMEX,.creditCardField .creditCard.AMEX{background-position:0 -93px;margin-right:-10px}#securityCode.creditCard.DINERSCLUB,#securityCode.creditCard.DISCOVER,.ccard.DINERSCLUB,.ccard.DISCOVER,.creditCardField .creditCard.DINERSCLUB,.creditCardField .creditCard.DISCOVER{background-position:0 -124px}#securityCode.creditCard.JCB,.ccard.JCB,.creditCardField .creditCard.JCB{background-position:0 -527px}#securityCode.creditCard.ccback,#securityCode.creditCard.three,.ccard.ccback,.ccard.three,.creditCardField .creditCard.ccback,.creditCardField .creditCard.three{background-position:0 -589px}#securityCode.creditCard.four,#securityCode.creditCard.front,.ccard.four,.ccard.front,.creditCardField .creditCard.four,.creditCardField .creditCard.front{background-position:0 -620px}#securityCode.creditCard.ELECTRON,.ccard.ELECTRON,.creditCardField .creditCard.ELECTRON{background-position:0 -217px}#securityCode.creditCard.MAESTRO,#securityCode.creditCard.SWITCH,.ccard.MAESTRO,.ccard.SWITCH,.creditCardField .creditCard.MAESTRO,.creditCardField .creditCard.SWITCH{background-position:0 -248px}#securityCode.creditCard.ELO,.ccard.ELO,.creditCardField .creditCard.ELO{background-position:0 -713px}#securityCode.creditCard.CUP,.ccard.CUP,.creditCardField .creditCard.CUP{background-position:0 -837px}#securityCode.creditCard.HIPER,.ccard.HIPER,.creditCardField .creditCard.HIPER{background-position:0 -682px}#securityCode.creditCard.HIPERCARD,.ccard.HIPERCARD,.creditCardField .creditCard.HIPERCARD{background-position:0 -744px}#securityCode.creditCard.CBNATIONALE,.ccard.CBNATIONALE,.creditCardField .creditCard.CBNATIONALE{background-position:0 -310px}#securityCode.creditCard.CETELEM,.ccard.CETELEM,.creditCardField .creditCard.CETELEM{background-position:0 -465px}#securityCode.creditCard.COFIDIS,.ccard.COFIDIS,.creditCardField .creditCard.COFIDIS{background-position:0 -651px;margin-right:-10px}#securityCode.creditCard.COFINOGA,.ccard.COFINOGA,.creditCardField .creditCard.COFINOGA{background-position:0 -341px}#securityCode.creditCard.VISA.QIWI,.ccard.VISA.QIWI,.creditCardField .creditCard.VISA.QIWI{background-position:0 -806px;width:30px}#securityCode.creditCard{/*!@replace: inherit; left: 8px;*/right:4px;height:21px;width:40px;top:14px;background-position:0 -589px;transition:background-position .3s ease}#securityCode.creditCard.four{background-position:0 -620px}.de_DE #securityCode.creditCard{background-position:5px -606px}.de_DE #securityCode.creditCard.four{background-position:5px -693px}@media only screen and (max-device-width:480px){#editCard .disc,#editCard .discover{background-position:0 -585px}#securityCode.creditCard{background-position:0 -608px}#securityCode.creditCard.four{background-position:0 -695px}#editCard .mastercard,#editCard .mcard{background-position:0 -196px}#editCard visa{background-position:0 -96px}#editCard amex{background-position:0 -295px}#editCard maestro{background-position:0 -978px}}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.creditCardInput .cardIconsGroup{padding:10px 15px;height:20px}.creditCardInput .cardIconsGroup,.creditCardInput .debitAndCreditIconsGroup{background-color:#f2f3f4;border:1px solid #e3e3e3;border-radius:4px;margin-bottom:10px}.creditCardInput .debitAndCreditIconsGroup{padding:10px 4px;overflow:auto}.creditCardInput .cardIconTitle{border-bottom:1px solid #dcd9d9;font-size:13px;padding-bottom:10px;margin-bottom:10px}.creditCardInput .creditIconLabel{color:#7b8388;font-size:11px;margin:-5px 0 5px}.creditCardInput .debitIconLabel{color:#7b8388;font-size:11px;margin:5px 0 2px}.creditCardInput .cardIcon{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v10_2x.png\") no-repeat 0 100px;background-size:31px;height:22px;float:left;width:32px;padding:0 4px 0 0}.creditCardInput .cardIcon.ELO{background-position:0 -713px}.creditCardInput .cardIcon.CUP{background-position:0 -837px}.creditCardInput .cardIcon.VISA{background-position:0 -31px}.creditCardInput .cardIcon.MASTERCARD{background-position:0 -62px}.creditCardInput .cardIcon.HIPER{background-position:0 -682px}.creditCardInput .cardIcon.HIPERCARD{background-position:0 -744px}.creditCardInput .cardIcon.AMEX{background-position:0 -93px;margin-right:-10px}.creditCardInput .cardIcon.JCB{background-position:0 -527px}.creditCardInput .cardIcon.ELECTRON{background-position:0 -217px}.creditCardInput .cardIcon.MAESTRO,.creditCardInput .cardIcon.SWITCH{background-position:0 -248px}.creditCardInput .cardIcon.DISCOVER{background-position:0 -124px}.creditCardInput .cardIcon.CBNATIONALE{background-position:0 -310px}.creditCardInput .cardIcon.CETELEM{background-position:0 -465px}.creditCardInput .cardIcon.COFIDIS{background-position:0 -651px;margin-right:-10px}.creditCardInput .cardIcon.COFINOGA{background-position:0 -341px}.creditCardInput .cardIconVISA.QIWI{background-position:0 -806px;width:30px}.creditCardInput .debitcardIcon{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_bank_mx_2x.png\") no-repeat 0 100px;background-size:66px;height:21px;float:left;width:68px;padding:0 2px 0 0;margin-top:3px}.creditCardInput .debitcardIcon.BANAMEX{background-position:0 0;clear:both}.creditCardInput .debitcardIcon.BANCOARFACA{background-position:0 -22px}.creditCardInput .debitcardIcon.BBVA{background-position:0 -44px}.creditCardInput .debitcardIcon.BANORTE{background-position:0 -66px}.creditCardInput .debitcardIcon.HSBC{background-position:0 -88px}.creditCardInput .debitcardIcon.INBURSA{background-position:0 -110px}.creditCardInput .debitcardIcon.SANTANDER{background-position:0 -132px}.creditCardInput .cardType{clear:both;display:block}.guestWithSignup .creditCardInput .debitAndCreditIconsGroup{padding:0 0 15px}.guestWithSignup .creditCardInput .cardIconTitle{padding:15px 15px 10px}.guestWithSignup .creditCardInput .cardIconsSection{padding:5px 15px 15px}#securityCode.creditCard,.ccard,.creditCardField .creditCard{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v10_2x.png\") no-repeat 0 100px;background-size:31px;height:22px;width:32px;top:14px;right:14px}#securityCode.creditCard.VISA,#securityCode.creditCard.visa,.ccard.VISA,.ccard.visa,.creditCardField .creditCard.VISA,.creditCardField .creditCard.visa{background-position:0 -31px}#securityCode.creditCard.MASTERCARD,#securityCode.creditCard.MCARD,#securityCode.creditCard.mcard,.ccard.MASTERCARD,.ccard.MCARD,.ccard.mcard,.creditCardField .creditCard.MASTERCARD,.creditCardField .creditCard.MCARD,.creditCardField .creditCard.mcard{background-position:0 -62px}#securityCode.creditCard.AMEX,#securityCode.creditCard.amex,.ccard.AMEX,.ccard.amex,.creditCardField .creditCard.AMEX,.creditCardField .creditCard.amex{background-position:0 -93px;margin-right:-10px}#securityCode.creditCard.dinersclub,#securityCode.creditCard.DINERSCLUB,#securityCode.creditCard.disc,#securityCode.creditCard.DISC,#securityCode.creditCard.DISCOVER,.ccard.DINERSCLUB,.ccard.dinersclub,.ccard.DISC,.ccard.disc,.ccard.DISCOVER,.creditCardField .creditCard.DINERSCLUB,.creditCardField .creditCard.dinersclub,.creditCardField .creditCard.disc,.creditCardField .creditCard.DISC,.creditCardField .creditCard.DISCOVER{background-position:0 -124px}#securityCode.creditCard.JCB #securityCode.creditCard.jcb,#securityCode.creditCard.JCB .ccard.jcb,#securityCode.creditCard.JCB .creditCardField .creditCard.jcb,.ccard.JCB #securityCode.creditCard.jcb,.ccard.JCB .ccard.jcb,.ccard.JCB .creditCardField .creditCard.jcb,.creditCardField .creditCard.JCB #securityCode.creditCard.jcb,.creditCardField .creditCard.JCB .ccard.jcb,.creditCardField .creditCard.JCB .creditCardField .creditCard.jcb{background-position:0 -527px}#securityCode.creditCard.ccback,#securityCode.creditCard.three,.ccard.ccback,.ccard.three,.creditCardField .creditCard.ccback,.creditCardField .creditCard.three{background-position:0 -589px}#securityCode.creditCard.four,#securityCode.creditCard.front,.ccard.four,.ccard.front,.creditCardField .creditCard.four,.creditCardField .creditCard.front{background-position:0 -620px}#securityCode.creditCard.split,.ccard.split,.creditCardField .creditCard.split{width:60%;float:left}#securityCode.creditCard.ELECTRON,#securityCode.creditCard.electron,.ccard.ELECTRON,.ccard.electron,.creditCardField .creditCard.ELECTRON,.creditCardField .creditCard.electron{background-position:0 -217px}#securityCode.creditCard.MAESTRO,#securityCode.creditCard.maestro,#securityCode.creditCard.mstro,#securityCode.creditCard.MSTRO,#securityCode.creditCard.SWITCH,.ccard.maestro,.ccard.MAESTRO,.ccard.MSTRO,.ccard.mstro,.ccard.SWITCH,.creditCardField .creditCard.MAESTRO,.creditCardField .creditCard.maestro,.creditCardField .creditCard.mstro,.creditCardField .creditCard.MSTRO,.creditCardField .creditCard.SWITCH{background-position:0 -248px}#securityCode.creditCard.ELO,.ccard.ELO,.creditCardField .creditCard.ELO{background-position:0 -713px}#securityCode.creditCard.CUP,.ccard.CUP,.creditCardField .creditCard.CUP{background-position:0 -837px}#securityCode.creditCard.HIPER,.ccard.HIPER,.creditCardField .creditCard.HIPER{background-position:0 -682px}#securityCode.creditCard.HIPERCARD,.ccard.HIPERCARD,.creditCardField .creditCard.HIPERCARD{background-position:0 -744px}#securityCode.creditCard.cbn,#securityCode.creditCard.CBN,#securityCode.creditCard.CBNATIONALE,.ccard.cbn,.ccard.CBN,.ccard.CBNATIONALE,.creditCardField .creditCard.cbn,.creditCardField .creditCard.CBN,.creditCardField .creditCard.CBNATIONALE{background-position:0 -310px}#securityCode.creditCard.celem,#securityCode.creditCard.CELEM,#securityCode.creditCard.CETELEM,.ccard.celem,.ccard.CELEM,.ccard.CETELEM,.creditCardField .creditCard.celem,.creditCardField .creditCard.CELEM,.creditCardField .creditCard.CETELEM{background-position:0 -465px}#securityCode.creditCard.COFID,#securityCode.creditCard.cofid,#securityCode.creditCard.COFIDIS,.ccard.cofid,.ccard.COFID,.ccard.COFIDIS,.creditCardField .creditCard.cofid,.creditCardField .creditCard.COFID,.creditCardField .creditCard.COFIDIS{background-position:0 -651px;margin-right:-10px}#securityCode.creditCard.COFINOGA,#securityCode.creditCard.conf,#securityCode.creditCard.CONF,.ccard.COFINOGA,.ccard.conf,.ccard.CONF,.creditCardField .creditCard.COFINOGA,.creditCardField .creditCard.conf,.creditCardField .creditCard.CONF{background-position:0 -341px}#securityCode.creditCard.VISA.QIWI,.ccard.VISA.QIWI,.creditCardField .creditCard.VISA.QIWI{background-position:0 -806px;width:30px}#securityCode.creditCard{height:21px;width:32px;background-size:31px;background-position:0 -589px}#securityCode.creditCard.four{background-position:0 -620px}}.ccard{width:100%;position:relative;margin-bottom:17px;padding-top:3px;padding-left:50px;height:25px;text-indent:0}.clearfix.hide{display:none}.issueNo .toolTip{right:0;text-align:right;width:auto}#addCard .tipDesc.tipStartDate{left:0;top:50px}#addCard .tipDesc.tipStartDate .tipDescArrowBack,#addCard .tipDesc.tipStartDate .tipDescArrowFront{left:70px}#addCard .tipDesc.tipIssueNo{left:-140px;top:50px;width:230px}#addCard .tipDesc.tipIssueNo .tipDescArrowBack,#addCard .tipDesc.tipIssueNo .tipDescArrowFront{left:160px}#addCard .tipDesc.tipOptionalCsc{left:-100px;top:50px;width:215px}#addCard .tipDesc.tipOptionalCsc .tipDescArrowBack,#addCard .tipDesc.tipOptionalCsc .tipDescArrowFront{left:160px}#ccFields input[type=text]::-ms-clear{display:none}#ccFields .tipDesc.tipCreditCard{top:42px;left:0;width:100%}#ccFields .tipDesc.tipCreditCard .tipDescText{background-color:#828a8d;font-size:13px}.cardType.show{display:block}#issueNo{padding-left:5px}.mxCardIconGroup{margin-bottom:5px}.creditCardInput #expiration{min-height:59px}@media (max-width:40em) and (orientation:landscape),only screen and (-webkit-min-device-pixel-ratio:2) and (min-width:0) and (max-width:25em){#securityCode.creditCard{background-position:0 -589px}#securityCode.creditCard.four{background-position:0 -620px}}@media (min-width:0) and (max-width:30em){.header{margin-bottom:15px}}.sidebar .addBillingTitle{position:absolute;top:-6px;background:#fff;left:45px;font-size:1.44em;width:230px}@media (min-width:0) and (max-width:30em){.sidebar .addBillingTitle{width:215px;top:-4px;left:40px}}.addressForm.TR{margin-top:3.5%}.addressForm.BR .streetNumber{width:31.15%;padding-right:0;float:left}.addressForm.BR .line1{width:66.15%;margin-right:2.7%;padding-right:0;float:left}.addressForm.BR .city{width:48.15%;margin-right:3.7%;padding-right:0;float:left}.addressForm.BR .state{width:48.15%;margin-right:0;padding-right:0;float:right}.addressForm.MX .state,.addressForm.RU .state,.addressForm.US .state{width:48.15%;margin-right:3.7%;padding-right:0;float:left}.addressForm.MX .postalCode,.addressForm.RU .postalCode,.addressForm.US .postalCode{padding-right:0;margin-right:0;width:48.15%;float:left}.addressForm.ES .state{margin-bottom:10px;clear:both}.addressForm.ES .postalCode{display:block;width:49%;float:left}.addressForm.ES .city{width:48%;float:right}.addressForm.GB .state{float:left;width:62%;margin:0 0 10px}.addressForm.GB .postalCode{float:right;width:35.3%}.addressForm.GB .lookupZip{width:100%;margin:0 10px 10px 0;float:none}.addressForm.GB .lookupHeading{margin:15px 0 10px}.addressForm.GB .lookupTitle{font-weight:700}.addressForm.GB .addressLookup{position:relative}.addressForm.GB .lookupFailureMsg{margin:5px 0 8px}.addressForm.GB .singleAddress{border:1px solid #c5ccd1;margin:10px 0;padding:13px;border-radius:4px;line-height:1.35em}.addressForm.BG .city,.addressForm.BG .postalCode,.addressForm.CZ .city,.addressForm.CZ .postalCode,.addressForm.DK .city,.addressForm.DK .postalCode,.addressForm.FI .city,.addressForm.FI .postalCode,.addressForm.FR .city,.addressForm.FR .postalCode,.addressForm.GR .city,.addressForm.GR .postalCode,.addressForm.HU .city,.addressForm.HU .postalCode,.addressForm.LU .city,.addressForm.LU .postalCode,.addressForm.NO .city,.addressForm.NO .postalCode,.addressForm.RO .city,.addressForm.RO .postalCode,.addressForm.TR .city,.addressForm.TR .postalCode,.addressForm.UA .city,.addressForm.UA .postalCode{width:100%}.addressForm.PT #shippingPostalCode{width:103%}.addressForm.EE .state.half,.addressForm.HR .state.half,.addressForm.LT .state.half,.addressForm.LV .state.half,.addressForm.SI .state.half{width:55%}.addressForm.EE .postalCode.half,.addressForm.HR .postalCode.half,.addressForm.LT .postalCode.half,.addressForm.LV .postalCode.half,.addressForm.SI .postalCode.half{width:41%}.addressForm.KR .fieldGroup .inputField,.addressForm.TH .fieldGroup .inputField{padding:0}.addressForm.KR .postalCode,.addressForm.KR .state{width:100%}.addressForm .editAddress{position:absolute;font-size:.85em;top:2px;right:0;color:#0070ba;cursor:pointer}.addressForm .btn{margin-bottom:15px}.addressForm #findAddressButton.processing{vertical-align:middle;font-size:32px}.addressForm #findAddressButton.processing .loader,.addressForm #findAddressButton.processing .spinner{height:25px;width:25px;position:static;display:inline-block}.addressForm #findAddressButton.processing .loader{margin:0;padding:0;background-color:transparent;border-left:2px solid rgba(0,0,0,.2);border-right:2px solid rgba(0,0,0,.2);border-width:1.5px;border-style:solid;border-color:#2180c0 #fff #fff}.addressForm #lookedupDropDown{margin-bottom:20px}.addressForm .addPreferredShipping{margin:0 0 15px}@media screen{.addressForm .buttons{margin-top:0}.TR .city{margin:0 0 10px}}.emailHelper{position:absolute;right:7px;top:14px;z-index:1}.emailHelper .verifyHelp{text-indent:-999em}.emailHelper .verifyHelp img{display:inline-block;height:20px;width:20px;vertical-align:middle;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-164px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.emailHelper .verifyHelp img{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.emailHelper .verifyHelp:focus img{background-position:-164px -44px}.backendError~div.emailHelper,.validated #email.ng-invalid~div.emailHelper{display:none}.passwords .inputField.half .toolTip{width:200%}.passwords .inputField.full{width:100%;padding:0}.passwords .confirmPasswordField.half .toolTip{left:-109%}.passwords #password:focus~div #passwordToolTip.show{display:inline!important}.passwords .showHidePasswordLinks{position:absolute;top:14px;right:14px}.passwords .showHidePasswordLinks a{font-size:.85em}.passwords .rtl{float:right;margin-right:0}.validated #confirmPassword:focus.ng-invalid~div #confirmPasswordToolTip{display:inline!important}.validated #password.ng-invalid~div.showHidePasswordLinks{right:35px}.tipInfoText{text-indent:15px;color:#2c2e2f;border:1px solid #e1e7eb;background:#e1e7eb;margin:0;list-style:none}.tipInfoText .requirement{background:url(https://www.paypalobjects.com/images/checkout/hermes/icon_checkmark_wallet.png) no-repeat 1px 4px;background-size:12px;padding-left:18px;text-indent:0}.tipInfoText .information.active,.tipInfoText .requirement.active{background:url(https://www.paypalobjects.com/images/checkout/hermes/icon_bullet_pw.png) no-repeat 4px 5px}.tipInfoText .restriction.active{background:url(https://www.paypalobjects.com/images/checkout/hermes/close3.png) no-repeat 0 0;display:block}#confirmPasswordValidations li.restriction.active{text-indent:3px}.tipInfoText .information,.tipInfoText .restriction{background:none;display:none;padding-left:18px;text-indent:0}.tipInfo{display:none}#confirmPassword:focus+.tipInfo.active,#password:focus+.tipInfo.active,.error #confirmPassword:focus+.tipInfo.active,.error #password:focus+.tipInfo{display:block}.js .tip ul{position:absolute}.js .tip ul li.restriction{display:none}#confirmPasswordValidations{left:-109%}.tipRight .tipText{right:20px}.mobile .tipError{max-width:280px}@media (min-width:0) and (max-width:30em){.passwords .confirmPasswordField.half .toolTip{left:0}}.countryOfResidence{min-height:70px}.signupFields{padding-left:35px;margin-top:10px}.signupFields label{padding-bottom:3px}.fullSignup{padding-left:0}.legal label{line-height:15px!important}.marketingOptin label{margin-top:10px}.signupFieldsContainer{margin-bottom:25px}.signupFieldsContainer #notifications{margin-bottom:15px}.pomaFieldsContainer{border:1px solid #c5ccd1;border-radius:5px;padding:25px;margin-top:40px}.pomaFieldsContainer h2.alpha{font-size:20px;line-height:1.4;color:#2c2e2f;margin-top:15px}.pomaFieldsContainer .legal{margin-top:10px;font-size:11px;line-height:16px}.pomaFieldsContainer.focusBorder{border:1px solid #009cde;border-radius:5px}.pomaFieldsContainer.active .pomaBgImg{background-position:-77px -77px}.pomaFieldsContainer .pomaBgImg{width:67px;height:67px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/icon-rememberme-sprite.png\");background-position:0 -77px;background-repeat:no-repeat;position:relative;top:-25px;margin:-32px auto;background-color:#fff}.pomaFieldsContainer .hfast{color:#6c7378}.pomaFieldsContainer .noMarginBottom{margin-bottom:0}.pomaFieldsContainer .fastList{margin:0 0 1em 18px}.pomaFieldsContainer .saveMyInfoBox input[type=checkbox]~label{line-height:20px}.pomaFieldsContainer .saveMyInfoBoxB input[type=checkbox]~label{font-size:13px;line-height:18px}.signupFieldGroup{margin-bottom:10px}#billingAgreement{font-size:11px;line-height:1.2em}.validated .guestOnlyFields input.ng-invalid~label:hover~#legalAgreeToolTip,.validated .signupFields input.ng-invalid~label:hover~#legalAgreeToolTip{float:left;top:-30px;position:relative;width:100%;font-size:1.1em}.validated .guestOnlyFields input.ng-invalid~label:hover~#legalAgreeToolTip .legalToolTip,.validated .signupFields input.ng-invalid~label:hover~#legalAgreeToolTip .legalToolTip{display:inline!important}.signupTerms{line-height:15px;font-size:.75em}.legal label.signupTerms,.signupTerms{color:#6c7378}.legal.sepaTerms{margin-top:20px}.validated .guestOption .checkbox .errorTooltip,.validated .onboardOptions .checkbox .errorTooltip,.validated .signupOptions .checkbox .errorTooltip{position:relative;top:0;display:block;margin-bottom:10px}.onboardTitleLine1{margin-bottom:3px}.onboardTitleLine2{margin-bottom:0}@media (max-width:30em) and (min-width:0){#dobComp,#nationalityDropDown,.signupFields .half{width:100%!important}.pomaFieldsContainer.active .pomaBgImg{background-position:-77px 0}.pomaFieldsContainer .pomaBgImg{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/icon-rememberme-sprite.png\");background-position:0 0}}.upsellWrapper{background:#fff;width:620px}.sepaContainer{width:380px;display:block;height:auto!important;margin:0 auto -50px}.sepaContainer .pushLogo{height:60px}@media (min-width:0) and (max-width:30em),(min-width:30.0625em) and (max-width:40em){.sepaContainer{width:100%;top:30px}.sepaContainer .close{top:15px;right:75px}.sepaContainer .sepaContent{width:auto;margin-top:5px;padding:5px;margin:5px}}.close{position:absolute;top:50px;right:50px;width:19px;height:19px;padding:0;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0;text-indent:-1000px;font-size:0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.close{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.close:focus,.close:hover{background-position:-223px -22px}.sepaContent{margin-top:100px;text-align:left;padding-left:75px;padding-right:75px}.sepatitle{margin-top:50px}.bankinfo,.carrierinfo,.sepatitle{margin-bottom:20px}.miniLogo{margin:40px auto 20px;width:30px;height:29px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.miniLogo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){.lboxContainer{width:100%;top:30px}.lboxContainer a.close{top:15px;right:15px}.lboxContainer .sepaContent{width:auto;margin-top:5px;padding:5px;margin:5px}}#currencyConversion .modal{position:fixed;top:0;bottom:0;left:0;right:0;z-index:10}#currencyConversion .modalWrapperAnimation{transition:transform .3s ease-out}.conversionoptions{list-style:none;margin:0}.conversionoptions p{margin:0;padding:0}.conversionoptions .dccDetails{font-size:13px;margin-top:8px}.conversionoptions .dccDetails,.conversionoptions .spread{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;line-height:1.3}.conversionoptions .spread{font-size:11px}.conversionoptions .merchantPrice{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:13px;line-height:1.3;margin-top:20px;margin-bottom:20px}.conversionoptions label{font-weight:700;padding-top:2px}.conversionoptions ul{margin:0 0 0 30px;overflow-y:hidden}.conversionoptions .conversion{margin:0 0 4px 35px}.conversionoptions input[name=ppconversion]{margin-bottom:5px;margin-right:5px;vertical-align:middle}.conversionoptions .conversionCC{margin-top:20px}.conversionoptions li{margin-bottom:5px;margin-left:5px;font-size:.92em}.conversionoptions .radioButton input[type=radio]~label{line-height:1.35em}.conversionoptions li:last-child .radioButton{margin:5px 0}.conversionoptions .margin{padding-top:10px}.conversionoptions li ul{list-style-type:none}.currencyConversion{overflow-y:auto;overflow-x:hidden;height:470px}#conversionSection .modalMask,#conversionSection .modalWrapper{position:fixed;top:0;bottom:0;left:0;right:0;z-index:10}#conversionSection .close{position:absolute;top:20px;right:20px;width:19px;height:10px;padding:5px;border-radius:3px}#conversionSection .close:before{content:\"\";position:absolute;width:19px;height:19px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#conversionSection .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#conversionSection .close:focus:before,#conversionSection .close:hover:before{background-position:-223px -22px}#conversionSection .modalMask{background:#cbd2d6;opacity:.7}#conversionSection .modalWrapperAnimation{transition:transform .3s ease-out}#conversionSection .modalWrapper{background:#fff;width:620px;-ms-box-sizing:border-box;box-sizing:border-box;left:50%;padding:80px 120px 0;overflow:auto;border-radius:5px;background-clip:padding-box;-webkit-transform:translate(-50%,100%);transform:translate(-50%,100%)}#conversionSection .modalWrapper .logo{position:relative;margin-top:-60px;left:170px;width:25px;height:30px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#conversionSection .modalWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#conversionSection .modalContainer{min-height:99%;width:380px;display:block}#conversionSection .modalContainer .pushlogo{height:90px}#conversionSection .processing input{background-color:#f2f3f4}#conversionSection .modalOpen .modalWrapper{-webkit-transform:translate(-50%);transform:translate(-50%)}#conversionSection .modalClose .modalWrapper{-webkit-transform:translate(-50%,100%);transform:translate(-50%,100%)}#conversionSection .heading{margin:5px 0 10px;font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){#conversionSection .modalWrapper{width:100%;padding:60px 15px 0}#conversionSection .modalWrapper .modalContainer{width:auto}}#selectShippingMethod .merchantOptionsStyle{padding-top:2%;padding-bottom:3%}#selectShippingMethod .shippingMethodTitle{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f}#selectShippingMethod #merchantOptions p{display:inline}#selectShippingMethod #merchantOptions .guestMerchantOptions{font-size:.9em;font-weight:400;line-height:1.385em;height:18px;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#7b8388;margin:10px 0}#selectShippingMethod #merchantOptions .zipCodeOptions{color:#7b8388}#selectShippingMethod #merchantOptions .addressOptions,#selectShippingMethod #merchantOptions .zipCodeOptions{font-size:.9em;font-weight:700;line-height:1.385em;margin:10px 0}#selectShippingMethod .shippingMethod{font-size:1.5em;font-weight:400;line-height:1.2em;margin:10px 0}#selectShippingMethod .shippingAmountWithCurrency{font-size:1.5em;font-weight:700;line-height:1.2em;margin:10px 0}#selectShippingMethod .shippingDeliveryTime{font-size:.8em;font-weight:400;line-height:1.2em;margin:10px 0}#selectShippingMethod .pickUpStoreText{font-size:.9em;font-weight:400;line-height:1.2em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;margin:8px 0}#selectShippingMethod .changeShippingMethodEnabled{cursor:pointer;color:#2c2e2f}#selectShippingMethod .changeShippingMethodDisabled{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#cbd2d6;cursor:default;pointer-events:none;text-decoration:none}#selectShippingMethod .normalBackground{background-color:#fff}#selectShippingMethod .processingBackground{opacity:.8;border-radius:2px;background-color:#e1e7eb;color:#cbd2d6}#selectShippingMethod .singleShipping span{color:#dcdcdc}#selectShippingMethod .disableShippingMethod span{color:#cbd2d6}#selectShippingMethod .enableShippingMethod{color:#2c2e2f}#selectShippingMethod #shippingMethodProcessing{vertical-align:middle;font-size:32px;height:10px}#selectShippingMethod #shippingMethodProcessing .loader,#selectShippingMethod #shippingMethodProcessing .spinner{height:25px;width:25px;position:static;display:inline-block}#selectShippingMethod #shippingMethodProcessing .loader{margin:-38px 10px 100px 180px;padding:0;background-color:transparent;border-left:2px solid rgba(0,0,0,.2);border-right:2px solid rgba(0,0,0,.2);border-width:1.5px;border-style:solid;border-color:#2180c0 #fff #fff}#selectShippingMethod .shippingMethodApplyInsuranceContainer{margin-top:10px}.multistepSignupForm .upopMobileNotify,.singlePagePaymentForm .upopMobileNotify{margin-bottom:10px!important}.multistepSignupForm .shippingAddressLabel,.singlePagePaymentForm .shippingAddressLabel{line-height:45px}.multistepSignupForm .backButtonEnabled,.singlePagePaymentForm .backButtonEnabled{float:right;width:67%!important}.multistepSignupForm .infoIcon,.singlePagePaymentForm .infoIcon{width:19px;height:19px;display:inline-block;position:absolute;top:10px;left:13px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v12.png\");background-repeat:no-repeat;background-position:-139px -21px}.multistepSignupForm .infoMsg,.singlePagePaymentForm .infoMsg{background-color:#6c7378;border-radius:4px;color:#fff;display:none;padding:10px 39px;position:absolute;top:45px;z-index:2;font-size:15px;line-height:20px}.multistepSignupForm .errorMsg,.singlePagePaymentForm .errorMsg{background-color:#c72e2e;border-radius:4px;color:#fff;display:none;padding:10px;position:absolute;top:45px;z-index:2;font-size:15px;line-height:20px}.multistepSignupForm .errorMsgRuleSpecific,.singlePagePaymentForm .errorMsgRuleSpecific{position:relative;top:0;display:block;margin-bottom:10px}.multistepSignupForm .showMask,.singlePagePaymentForm .showMask{opacity:.2}.multistepSignupForm .creditCardInput .cvvField,.singlePagePaymentForm .creditCardInput .cvvField{width:48.7%;float:right}.multistepSignupForm .creditCardInput .expirationField,.singlePagePaymentForm .creditCardInput .expirationField{width:48.7%;float:left}.multistepSignupForm .addressForm.MX .state,.multistepSignupForm .addressForm.RU .state,.multistepSignupForm .addressForm.US .state,.singlePagePaymentForm .addressForm.MX .state,.singlePagePaymentForm .addressForm.RU .state,.singlePagePaymentForm .addressForm.US .state{width:48.7%;margin-right:2.6%;padding-right:0;float:left}.multistepSignupForm .addressForm.MX .postalCode,.multistepSignupForm .addressForm.RU .postalCode,.multistepSignupForm .addressForm.US .postalCode,.singlePagePaymentForm .addressForm.MX .postalCode,.singlePagePaymentForm .addressForm.RU .postalCode,.singlePagePaymentForm .addressForm.US .postalCode{padding-right:0;margin-right:0;width:48.7%;float:left}.multistepSignupForm .addressForm.BR .city,.singlePagePaymentForm .addressForm.BR .city{width:48.7%;margin-right:2.6%;padding-right:0;float:left}.multistepSignupForm .addressForm.BR .state,.singlePagePaymentForm .addressForm.BR .state{width:48.7%;margin-right:0;padding-right:0;float:right}.multistepSignupForm .addressForm.ES .postalCode,.singlePagePaymentForm .addressForm.ES .postalCode{display:block;width:48.7%;margin-right:2.6%;float:left}.multistepSignupForm .addressForm.ES .city,.singlePagePaymentForm .addressForm.ES .city{width:48.7%;margin-right:0;float:right}#singlePagePayment h1.alpha{color:#2c2e2f;font-size:24px;font-family:HelveticaNeue-Light,Helvetica Neue Light,Helvetica,Arial,sans-serif;margin-top:25px;margin-bottom:10px}#singlePagePayment .subTitle{color:#6c7378;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:15px;margin-bottom:25px;line-height:1.3em}#singlePagePayment .subTitle a{font-weight:700}#singlePagePayment .sectionTitle{color:#2c2e2f;font-size:1em;font-weight:700;margin:0}.lineWithTextSeparator{height:1px;background-color:#e0e0e0;text-align:center;margin:30px 0}.lineWithTextSeparator span{background-color:#fff;position:relative;top:-10px;color:#5d616f;padding:5px}.singlePagePaymentForm{margin-bottom:15px}.singlePagePaymentForm .form-tabs{color:#6c7378;margin:20px 0;list-style:none;border-bottom:1px solid #dbdbdb}.singlePagePaymentForm .form-tabs>li{width:49%;text-align:center;display:inline-block;margin-right:0}.singlePagePaymentForm .form-tabs>li.bankTab{cursor:pointer}.singlePagePaymentForm .form-tabs>li.cardTab{float:right;cursor:pointer}.singlePagePaymentForm .form-tabs>li{padding:0;font-weight:700;cursor:pointer}.singlePagePaymentForm .form-tabs>li:focus,.singlePagePaymentForm .form-tabs>li:hover{border-color:#ccc #ccc #ddd}.singlePagePaymentForm .form-tabs>li a{display:inline-block;width:100%;line-height:40px;color:#666;text-decoration:none}.singlePagePaymentForm .form-tabs>li.active{cursor:default;color:#fff;margin-right:0;border-bottom:2px solid #009cde}.singlePagePaymentForm .form-tabs>li.active a{color:#2c2e2f}.singlePagePaymentForm .countryList{min-height:55px}.singlePagePaymentForm .rightLink{float:right}.singlePagePaymentForm .entryToggleLinks{margin-bottom:8px}.singlePagePaymentForm .fieldLegend{margin-bottom:8px;padding-bottom:0;font-size:inherit}.singlePagePaymentForm .phoneTypeContainer{width:34%;padding-right:5px;float:left;-ms-box-sizing:border-box;box-sizing:border-box}.singlePagePaymentForm .countryCodeSelect .telephoneField.half{width:100%}.singlePagePaymentForm #returnToMerchantInfo{font-size:11px;font-weight:700;text-align:center;margin-bottom:5px;margin-top:10px}.singlePagePaymentForm #agreeAndContinueAsGuest,.singlePagePaymentForm #continueAsGuestTrigger,.singlePagePaymentForm #guestSubmit,.singlePagePaymentForm #pomaSubmit{width:100%}.singlePagePaymentForm .showShippingAddressHeading{margin:15px 0 10px}.singlePagePaymentForm .showShippingAddressTitle{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f}.singlePagePaymentForm .shippingAddress{border:1px solid #c5ccd1;margin:10px 0;padding:13px;border-radius:4px;line-height:1.35em}.singlePagePaymentForm .editShippingAddress{position:relative;font-size:.85em;top:2px;right:0;left:57%;color:#0070ba;cursor:pointer;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.singlePagePaymentForm .cvvSecurityCode input.backendError~span#securityCode{display:none}.singlePagePaymentForm h2.subTitle{font-size:1em;color:#6c7378}.singlePagePaymentForm .billingLabel,.singlePagePaymentForm .shippingLabel{font-weight:700;line-height:45px}.singlePagePaymentForm .shipToBillingContainer{margin:0 0 10px}.singlePagePaymentForm .getInstallments{margin-bottom:10px;background-color:#fff;border:1px solid #c5ccd1;font-weight:400;text-align:start;padding:0 10px;display:block}.singlePagePaymentForm .getInstallments.installmentsDropDown{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:right -7px top -1181px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.singlePagePaymentForm .getInstallments.installmentsDropDown{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.singlePagePaymentForm .getInstallments.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%;border-radius:5px}.singlePagePaymentForm .getInstallments[disabled]{background-color:#e7edf0}.guestTermsPopup.modal-wrapper .modalContent{padding:0;margin:0;width:580px}.guestTermsPopup.modal-wrapper .modalContent .close{top:30px}.guestTermsPopup.modal-wrapper .paypalHeaderWrapper{margin:25px 0;height:30px}.guestTermsPopup.modal-wrapper .guestModalContent{padding:30px}.guestTermsPopup.modal-wrapper .logo{margin:0 38%}.guestTermsPopup.modal-wrapper .guestModalContent{background-color:#f5f7f9}.guestTermsPopup.modal-wrapper .guestModalContent h1.alpha{margin-top:0;margin-bottom:20px}.guestTermsPopup.modal-wrapper .guestModalContent .signupFields{padding-left:0}.guestTermsPopup.modal-wrapper #agreeAndContinueAsGuest{margin-top:30px}#notifications{margin-top:10px}@media (max-width:30em) and (min-width:0){.guestTermsPopup.modal-wrapper .modalContent{width:80%}}.subTitle{color:#7b8388}.rowPadding{margin-top:10px}.multistepSignupForm #contents{padding-bottom:30px}.multistepSignupForm .agreeSepaTerms{margin-top:10px}.multistepSignupForm .form-tabs{color:#6c7378;margin:20px 0;list-style:none;border-bottom:1px solid #dbdbdb}.multistepSignupForm .form-tabs>li{width:49%;text-align:center;display:inline-block;margin-right:0}.multistepSignupForm .form-tabs>li.bankTab{cursor:pointer}.multistepSignupForm .form-tabs>li.cardTab{float:right;cursor:pointer}.multistepSignupForm .form-tabs>li{padding:0;font-weight:700;cursor:pointer}.multistepSignupForm .form-tabs>li:focus,.multistepSignupForm .form-tabs>li:hover{border-color:#ccc #ccc #ddd}.multistepSignupForm .form-tabs>li a{display:inline-block;width:100%;line-height:40px;color:#666;text-decoration:none}.multistepSignupForm .form-tabs>li.active{cursor:default;color:#fff;margin-right:0;border-bottom:2px solid #009cde}.multistepSignupForm .form-tabs>li.active a{color:#2c2e2f}.multistepSignupForm .countryList{min-height:55px}.multistepSignupForm .rightLink{float:right}.multistepSignupForm .entryToggleLinks{margin-bottom:8px}.multistepSignupForm .fieldLegend{margin-bottom:8px;margin-top:5px;padding-bottom:0;font-size:inherit}.multistepSignupForm .country{min-height:55px}.multistepSignupForm .phoneTypeContainer{width:34%;padding-right:10px;float:left;-ms-box-sizing:border-box;box-sizing:border-box}.multistepSignupForm .telephoneField{width:66%;padding:0;float:right}.multistepSignupForm .inputField.telephoneFieldFull{width:100%;padding:0;float:right}.multistepSignupForm .countryCodeSelect .phoneTypeContainer{width:50%;padding:0 10px 10px 0;float:left;-ms-box-sizing:border-box;box-sizing:border-box}.multistepSignupForm .countryCodeSelect .phoneCodeContainer{width:50%;float:right}.multistepSignupForm .countryCodeSelect .telephoneField{width:100%;padding:0;float:right}.multistepSignupForm h2.subTitle{font-size:1em;color:#6c7378}.multistepSignupForm .creditCardInput{margin-top:15px}.multistepSignupForm .billingLabel,.multistepSignupForm .shippingLabel{font-weight:700;line-height:45px}.multistepSignupForm .shipToBillingContainer{margin:10px 0}.multistepSignupForm .signupFields{padding-left:35px}.multistepSignupForm .fullSignup{padding-left:0}.multistepSignupForm .legal label{line-height:15px!important}.multistepSignupForm .signupFieldsContainer{margin-bottom:30px}.multistepSignupForm .signupFieldGroup{margin-bottom:15px}.multistepSignupForm .signupFlowSubmit{float:right;width:67%}.multistepSignupForm .signupFlowSubmit#addCardSubmit{width:100%}.multistepSignupForm .validated .signupFields input.ng-invalid~label:hover~#legalAgreeToolTip{float:left;top:-30px;position:relative;width:100%;font-size:1.1em}.multistepSignupForm .validated .signupFields input.ng-invalid~label:hover~#legalAgreeToolTip .legalToolTip{display:inline!important}.multistepSignupForm .validated .cvvSecurityCode input.backendError~span#securityCode{display:none}.multistepSignupForm .getInstallments{margin-bottom:10px;background-color:#fff;border:1px solid #c5ccd1;font-weight:400;text-align:start;padding:0 10px;display:block}.multistepSignupForm .getInstallments.installmentsDropDown{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:right -7px top -1181px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.multistepSignupForm .getInstallments.installmentsDropDown{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.multistepSignupForm .getInstallments.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%;border-radius:5px}.multistepSignupForm .getInstallments[disabled]{background-color:#e7edf0}.multistepSignupForm .visible{overflow:visible}.hiddenInput{display:none}.multistepSignup select.backendError+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat right 10px center;background-size:16px;color:#c72e2e;border:1px solid #c72e2e}#createAccountForm .signupFieldsContainer{margin-bottom:36px}.installment{position:relative}.installment .installmentHelper{position:absolute;top:13px;z-index:1px;right:9px}.verifyHelp{display:inline-block;height:20px;width:21px;vertical-align:middle;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-164px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.verifyHelp{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.verifyHelp:focus{background-position:-163px -44px}.shippingSameAsBillingContainer{margin-bottom:10px}.total>span{display:block}.labelHeight{line-height:30px}.billingAddressPadding{margin-top:20px}.legalAgreeCBToolTip{font-size:.8em;color:#2c2e2f}.legalAgreeCBToolTip.balloon{position:absolute;z-index:2;padding:7px;text-align:left;border:1px solid #e1e7eb;border-radius:5px;background:#e1e7eb}.singlePagePaymentForm .nationalID{width:100%!important;float:none}.singlePagePaymentForm .nationalID .custom-select>span{border-right:1px solid #c5ccd1;border-radius:5px 5px 5px 5px!important}.singlePagePaymentForm .nationalID .custom-select.active>span{border-right:1px solid #009cde}.singlePagePaymentForm .nationalIDValue{width:100%;float:none}.singlePagePaymentForm .additionalIDBox{border-radius:5px 5px 5px 5px!important}.nationalID{width:40%!important;float:left}.nationalID .custom-select>span{border-right:0;border-radius:5px 0 0 5px!important}.nationalID .custom-select.active>span{border-right:0}.nationalIDValue{width:60%;float:right}.additionalID{width:26%;float:left}.additionalID .custom-select>span{border-radius:5px 0 0 5px;border-right:0}.additionalIDValue{width:74%;float:right}.additionalIDBox{border-radius:0 5px 5px 0!important;border-left:1px}.additionalIdHelper{position:relative;margin-left:5px;float:right}.additionalIdHelper .verifyHelp{display:inline-block;height:20px;width:20px;vertical-align:middle;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-164px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.additionalIdHelper .verifyHelp{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.additionalIdHelper:focus{background-position:-164px -44px}.lineSpacing{margin-top:10px}.installmentOptions{height:400px;margin-left:-8px;margin-top:-8px}.installmentOptions .cardInfo{background-color:#f7f9fa;padding:15px 0 10px 20px;border-bottom:2px solid #e3e3e3;margin-top:0}.installmentOptions .cardInfo .ccard{background-size:31px;top:-2px;padding-left:48px;padding-bottom:3px;padding-top:0;right:-3px}.installmentOptions .cardInfo .installmentText{color:#6c7378;font-size:15px}.installmentOptions .items{margin:0;padding-left:7px;list-style:none}.installmentOptions .term{float:left}.installmentOptions .display{margin-left:0}.installmentOptions .display .total{margin-top:4px;color:#6c7378;font-size:.85em;width:90%}.installmentOptions .display .total .save{color:#2a5327;background-color:#eaf7e9;padding:4px;display:block;max-width:55%;margin-top:3px}.installmentOptions .installment{margin:0;padding:18px;position:relative;border-bottom:1px solid #e3e3e3;cursor:pointer;width:96%}.installmentOptions .installment:focus,.installmentOptions .installment:hover{background-color:#f7f9fa}.installmentOptions li a{text-decoration:none;color:#292929}.installmentOptions .installment:after{content:\"\";width:96%;display:block;position:absolute;bottom:-2px;left:0}.installmentOptions .asideContent{overflow-y:auto;overflow-x:hidden;height:400px}.MX .installmentOptions{height:1000px}.guestWithSignup .installmentOptions .asideContent{height:auto}@media (min-width:0) and (max-width:30em){.signupflow{margin-left:15px;margin-top:-12px}.installmentOptions .cardInfo,.signupflow .cardInfo{margin-top:5px}.header{margin-bottom:0}}@media (min-width:41.3125em){section#genericError .container{width:400px}.genericError.footerWrapper{float:none;width:99.4%;padding:0 3px}.genericError.footerWrapper .footerLinks{float:left;width:70%;text-align:left}}section#genericError{height:450px;background:none}section#genericError .container{position:relative;margin:0 auto;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}section#genericError .title{font-size:1.5em;margin-bottom:15px;line-height:1.2}section#genericError .message{font-size:1em;margin-bottom:15px;color:#7b8388}section#genericError .secondaryMessage{color:#979797;line-height:20px}section#genericError .logo{width:112px;height:29px;margin:5px 0 20px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){section#genericError .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}section#genericError .cancelLink{margin-top:20px}section#genericError .logoutLink{margin-top:20px;font-weight:400;text-align:center;font-size:.86666667em}section#genericError .logoutLink:focus,section#genericError .logoutLink:hover{text-decoration:underline}section#genericError .full{padding-left:20px;padding-right:20px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}section#genericError .banner{margin-bottom:30px}@media (min-width:41.3125em){section#genericMessage .container{width:400px}.genericMessage.footerWrapper{float:none;width:99.4%;padding:0 3px}.genericMessage.footerWrapper .footerLinks{float:left;width:70%;text-align:left}}section#genericMessage{height:450px;background:none}section#genericMessage .container{position:relative;margin:0 auto;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}section#genericMessage .title{font-size:1.5em;margin-bottom:15px}section#genericMessage .message{font-size:1em;margin-bottom:15px;color:#7b8388}section#genericMessage .secondaryMessage{color:#979797;line-height:20px}section#genericMessage .logo{width:112px;height:29px;margin:5px 0 20px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){section#genericMessage .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}section#genericMessage .cancelLink{margin-top:20px}#selectShippingCountry .disabled,#selectShippingCountry .disabled .custom-select>span,#selectShippingCountry .disabled span{color:#d3d3d3;margin-top:3px}#selectShippingCountry .disabled.country{min-height:53px}#loginSection{padding:25px 0}#loginSection .verticallyCentered{padding-top:12px;float:left;width:53.19148935%}#loginSection .alignRight{float:left;width:42.68085105%;margin-left:4.12765957%}#loginDivider{height:1px;background-color:#e3e3e3;text-align:center;margin-bottom:25px}#loginDivider .textInDivider{background-color:#fff;position:relative;top:-.5em}.confirmationPage{max-width:480px!important}.paypalHeaderWrapper .spanConfirmation{border-bottom:0 solid #dbdbdb!important;padding-bottom:10px}#confirmationFooter{max-width:480px!important;margin:0 auto}#confirmationFooter #defaultCancelLink{display:none}#confirmationFooter .footerWrapper{width:100%!important;text-align:center}#confirmationFooter .footerLinks{float:left}#confirmationFooter .copyright{float:right}#confirmationFooter .footer{width:100%}@media (max-width:30em) and (min-width:0){#confirmationFooter{max-width:480px!important;margin:0 auto;padding-top:10px}#guestUpgrade .btnGrey{margin-bottom:35px;color:#000;border-color:#e1e7eb!important;background-color:#e1e7eb!important}#guestUpgrade .buttons{margin-top:30px;margin-bottom:30px}}#guestUpgrade #circle{top:15px;right:-32px;margin:0 auto 30px;position:relative;width:90px;height:90px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/animation-checkmark.gif\");background-repeat:no-repeat;background-size:90px 90px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#guestUpgrade #circle{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/animation-checkmark.gif\");background-size:90px 90px}}#guestUpgrade .btn{width:100%}#guestUpgrade .btnGrey{color:#000;border-color:#e1e7eb!important;background-color:#e1e7eb!important}#guestUpgrade .legal label{line-height:15px!important}#guestUpgrade .marketing label{margin-top:10px}#guestUpgrade .rtlPhoneType{float:right!important}#guestUpgrade .rtlPhoneField{float:left!important}#guestUpgrade .countryCodeSelect .telephoneField{width:100%;padding:0;float:right}#guestUpgrade #nationalityLabel,#guestUpgrade #occupationLabel{margin-bottom:3px;display:block}#guestUpgrade #nationalityLabel.hide,#guestUpgrade #occupationLabel.hide{display:none}#guestUpgrade #email{padding:0 30px 0 13px!important}#guestUpgrade .floatingLabel #email{padding-top:16px!important}#guestUpgrade .occupation .custom-select span span.noValue{color:#6c7378}#guestUpgrade .tick{width:100%;height:169px;background-color:#f7f9fa;position:relative;left:-30px;padding-right:60px;border-top:1px solid #dbdbdb;border-bottom:1px solid #dbdbdb;margin-bottom:20px}#guestUpgrade .subTitle{margin-top:36px}#guestUpgrade .returnToMerchant{padding-top:10px;font-size:13px;padding-bottom:10px}#guestUpgrade .successTitle{bottom:0;position:absolute;width:100%;text-align:center}#guestUpgrade .titlePadding{margin-top:25px;margin-bottom:25px}#guestUpgrade .contactInfoFont{font-size:.75em;margin-bottom:0!important}#guestUpgrade .confirmCard{margin-top:20px;padding-top:10px;border-top:1px solid #dbdbdb}#guestUpgrade .inputField.half.last-child{margin-right:0}#guestUpgrade .buttons{margin-top:30px;margin-bottom:30px}#guestUpgrade .fullsignup-link{margin-top:15px;text-align:center}.guestUpgradeInterstitial{overflow:hidden}.guestUpgradeInterstitial .fieldGroup .inputField{width:100%}.guestUpgradeInterstitial .fieldGroup .toolTip.balloon{left:0;width:100%}.guestUpgradeInterstitial .upsellWrapper{background:#fff;width:620px;-ms-box-sizing:border-box;box-sizing:border-box;left:50%;padding:0;border-radius:0;-webkit-transform:translate(-50%,100%);transform:translate(-50%,100%);transition:transform .3s ease-out;overflow-x:hidden}.guestUpgradeInterstitial .upsellWrapper .logo{position:relative;width:29px;height:29px;margin:0 auto;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.guestUpgradeInterstitial .upsellWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.guestUpgradeInterstitial .signupFields{padding-left:0}.guestUpgradeInterstitial .upsellContainer{padding:30px 120px 60px;display:block;height:auto!important;margin:0 auto -50px}.guestUpgradeInterstitial .upsellContainer .pushLogo{height:60px}.guestUpgradeInterstitial .upsellOpen .upgradeWrapper{-webkit-transform:translate(-50%);transform:translate(-50%)}.guestUpgradeInterstitial #spinner{top:0;left:0}.guestUpgradeInterstitial .profile{width:100%;box-sizing:border-box;max-height:10px;padding:5px 25px;background-image:linear-gradient(65deg,#640487,#003087);overflow-y:hidden}.guestUpgradeInterstitial .mainTitle{text-align:center;line-height:29px;font-size:24px;font-weight:300;font-family:HelveticaNeue-Light,Helvetica Neue,Helvetica,Arial,sans-serif;margin-bottom:10px}.guestUpgradeInterstitial .intro-content{line-height:20px;margin:0 auto;color:#6c7368}.guestUpgradeInterstitial .email,.guestUpgradeInterstitial .intro-content{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:15px;text-align:center}.guestUpgradeInterstitial .email{line-height:18px;font-weight:300}.guestUpgradeInterstitial .nationalID{width:100%!important;float:none}.guestUpgradeInterstitial .nationalID .custom-select>span{border-right:1px solid #c5ccd1;border-radius:5px 5px 5px 5px!important}.guestUpgradeInterstitial .nationalID .custom-select.active>span{border-right:1px solid #009cde}.guestUpgradeInterstitial .nationalIDValue{width:100%;float:none}.guestUpgradeInterstitial .additionalIDBox{border-radius:5px 5px 5px 5px!important}.guestUpgradeInterstitial .notNow{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:13px;line-height:15px;margin:0 auto 25px;text-align:center;font-weight:300}.guestUpgradeInterstitial .miniLogo{margin:0 auto 20px;width:30px;height:29px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.guestUpgradeInterstitial .miniLogo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.guestUpgradeInterstitial .verifyHelp{width:22px;height:22px}.guestUpgradeInterstitial .verifyHelp:focus{background-position:-163px -44px}.guestUpgradeInterstitial .emailHelper{text-align:center;position:relative;margin:10px 0 25px}.guestUpgradeInterstitial #wpsInterstitialSubmit{margin:35px 0 10px}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){.lboxContainer{width:100%}.lboxContainer .lboxContent{margin:40px 20px}.lboxContainer .lbox{width:100%;top:30px}.lboxContainer .lbox a.close{top:15px;right:15px}.lboxContainer .sepaContent{width:auto;margin-top:5px;padding:5px;margin:5px}}h1.alpha{color:#2c2e2f;font-size:24px;font-family:HelveticaNeue-Light,Helvetica Neue Light,Helvetica,Arial,sans-serif}.subTitle{margin-bottom:5px}.addressSubTitle,.subTitle{color:#6c7378;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:15px}.addressSubTitle{margin-bottom:15px}.pageTitle{color:#2c2e2f;font-family:HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:22px;font-weight:lighter;line-height:39px}.personalInfo{color:#6c7378;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:20px;font-weight:lighter;line-height:1.154em;margin:25px 0 20px}#payUponInvoice .inputField input,#payUponInvoice .inputField label{clear:both}#payUponInvoice .msgPage{padding:0 0 15px}#payUponInvoice .addressArea{position:relative}#payUponInvoice .agreeSepaTerms{margin:13px 0 8px}#payUponInvoice #invoiceSubmit{width:100%}#payUponInvoice .rightLink{float:right}#payUponInvoice .dobHelper{position:absolute;left:103px;top:5px;z-index:1}#payUponInvoice .dobbank{min-height:79px}#payUponInvoice h2.alpha{margin:30px 0 15px}#payUponInvoice h2.subTitle{font-size:1em;color:#6c7378}#payUponInvoice .billingLabel,#payUponInvoice .shippingLabel{font-weight:700}#payUponInvoice .legal label{line-height:15px!important}#payUponInvoice .descText{color:#6c7378}#payUponInvoice .addressDisplay{border:1px solid #c5ccd1;margin-bottom:10px;padding:13px;border-radius:4px;line-height:1.35em}#payUponInvoice .changeShipping{cursor:pointer}#payUponInvoice .cardDOB{clear:both;padding-top:10px;width:100%}#payUponInvoice .billingArea{margin-top:10px}#payUponInvoice .edits{/*!@replace: 7px 10px 4px 0;*/padding:7px 0 4px;position:absolute;top:-6px;right:-1px;color:#0070ba}#payUponInvoice .edits.disabled,#payUponInvoice .edits.disabled:focus,#payUponInvoice .edits.disabled:hover{color:#6c7378;text-decoration:none}#payUponInvoice .edits:focus,#payUponInvoice .edits:hover{text-decoration:underline;color:#005ea6}#payUponInvoice .validated .signupFields input.ng-invalid~label:hover~#legalAgreeToolTip{float:left;top:-30px;position:relative;width:100%;font-size:1.1em}#payUponInvoice .validated .signupFields input.ng-invalid~label:hover~#legalAgreeToolTip .legalToolTip{display:inline!important}@media (min-width:0) and (max-width:30em){.pageTitle{font-size:20px;line-height:39px}#transactionCart{padding:0}.personalInfo{margin-top:40px}}@media (min-width:30.0625em) and (max-width:41.3125em){#contents{padding:10px 25px 30px}.pageTitle{font-size:20px;line-height:47px}#transactionCart{padding:0}.paypalHeaderWrapper .span14{padding:0 20px 20px}}.xo-done #header,.xo-done #wrapper{max-width:480px}.xo-done h2{font-size:1em;color:inherit}.xo-done #defaultCancelLink{width:0;height:0}.xo-done #stm-upsell-content{padding-bottom:10px}.xo-done .item-options{font-size:13px}.xo-done .item-selections{font-size:13px;color:#6c7378}.xo-done .item-selections .item-selection-name{font-weight:700}.xo-done .item-selections .item-selection-value{padding-right:1em}.xo-done .item-number-container{font-size:13px;margin-bottom:10px;color:#6c7378}.xo-done .item-number-container .item-number{word-wrap:break-word}.xo-done .cartContainer{display:none}.xo-done #contents{padding:0}.xo-done #circle{top:15px;right:-5px;margin:0 auto 30px;position:relative;width:90px;height:90px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/animation-checkmark.gif\");background-repeat:no-repeat;background-size:90px 90px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.xo-done #circle{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/animation-checkmark.gif\");background-size:90px 90px}}.xo-done #merchantReturnBtn{margin-top:10px}.xo-done #details-text{text-align:center;position:relative;z-index:1;font-size:15px;margin-top:16px;bottom:5px;color:#0070ba}.xo-done .receipt.basics{height:220px;width:auto;text-align:center;margin-bottom:-27.5px}.xo-done .receipt.basics #paid-text{text-align:center;font-size:24px;margin-bottom:10px;line-height:1.35}.xo-done .receipt.basics #merchant-text{text-align:center;font-size:13px}.xo-done .receipt.statement{font-size:10px}.xo-done .receipt.title{font-weight:700;margin-bottom:10px;margin-top:25px}.xo-done .row .currencyCode{font-size:11px;font-weight:400}.xo-done .essentials{margin:38px 30px 0}.xo-done .essentials.autoReturnSection{text-align:center;margin-bottom:38px}.xo-done .row{margin-bottom:10px}.xo-done .row div{margin-top:5px}.xo-done .amount{float:right;font-weight:500}.xo-done hr{height:1px}.xo-done .text div{margin-bottom:5px}.xo-done #receiptNumber{margin:10px 0}.xo-done .alert{color:#8a6d3b;background-color:#fcf8e3;margin:20px 10px;padding:5px;border:solid transparent;border-radius:4px}.xo-done .details-expand{margin-top:60px;margin-bottom:-57px;padding-bottom:1px;background:#f7f9fa;width:auto;max-height:0;overflow:hidden}.xo-done .details-expand,.xo-done .details-expand.expansion{transition:max-height .5s ease-in}.xo-done .details-expand .grouping{border-bottom:1px double;border-color:#e3e3e3;padding:15px 0 5px}.xo-done .details-expand .totalAmount{border-bottom:20px transparent;margin:15px 0 20px}.xo-done .splash-receipt{padding-left:30px;padding-right:30px;margin-left:-30px;margin-right:-30px;margin-top:-1px;background-color:#f7f9fa;border-top:1px solid #e3e3e3;border-bottom:1px solid #e3e3e3}.xo-done .splash-receipt #details-button{margin:18px auto 0;position:relative;background:#f7f9fa;width:39px;height:39px;text-align:center;border-radius:100%;background-clip:padding-box;border-bottom:1px solid #e3e3e3;top:18px}.xo-done .splash-receipt #details-button .arrow{width:20px;height:16px;display:inline-block;position:absolute;top:17px;right:10px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.xo-done .splash-receipt #details-button .arrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.xo-done .splash-receipt #details-button .arrow.expand{background-position:-174px -144px}.xo-done .splash-receipt #details-button .arrow.collapse{background-position:-174px -156px}.xo-done .msg-warning .icon{background-position:-89px -22px;left:7px}.xo-done .footer{max-width:480px}@media (max-width:41.25em){.xo-done .splash-receipt{margin-left:0;margin-right:0}}@media (max-width:41.25em) and (min-width:30.0625em){.xo-done .merchantHeader,.xo-done header{display:block}.xo-done #wrapper{margin:0 auto;border:1px solid #e3e3e3}.xo-done .essentials{margin:38px 15px 0}.xo-done .essentials.autoReturnSection{text-align:center;margin-bottom:38px}.xo-done .copyright{float:none;width:auto}.xo-done .footerLinks{float:none;width:auto;text-align:center}.xo-done .footer{border:none;margin-top:0;padding-top:0}}[dir=rtl] .xo-done .amount{float:left}[dir=rtl] .xo-done .money-source{float:right}[dir=rtl] .xo-done #paid-text b{direction:ltr;unicode-bidi:bidi-override}.light-box-3ds .light-box{position:fixed;top:0;bottom:0;left:0;right:0;z-index:10}.light-box-3ds .light-box-header{font-size:24px;font-weight:lighter;font-family:HelveticaNeue-Light;line-height:1.2em;margin-top:40px}.light-box-3ds .close{top:20px;right:20px;font-size:0}.light-box-3ds .close:hover{background-position:-223px -22px;text-decoration:none}.light-box-3ds .light-box.mask{background:#cbd2d6;opacity:.7}.light-box-3ds .light-box-iframe{height:400px;width:400px;border:1px solid #999;border-radius:5px;background-clip:padding-box;border-radius:0}.light-box-3ds .light-box.wrapper{background:#fff;width:620px;-ms-box-sizing:border-box;box-sizing:border-box;left:50%;padding:90px 120px 0;overflow:auto;border-radius:5px;background-clip:padding-box;-webkit-transform:translate(-50%,100%);transform:translate(-50%,100%);transition:transform .3s ease-out}.light-box-3ds .light-box.wrapper .logo{margin:30px auto;width:29px;height:29px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.light-box-3ds .light-box.wrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.light-box-3ds .light-box-container{width:420px;display:block;min-height:600px;overflow:scroll}.light-box-3ds .light-box.open .light-box.wrapper{-webkit-transform:translate(-50%);transform:translate(-50%)}.light-box-3ds body.loading .light-box .aside{opacity:.1}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){.light-box-3ds .light-box.wrapper{width:100%;padding:0 15px}.light-box-3ds .light-box.wrapper .light-box.container{width:auto;margin-top:30px}}.spinnerBtn .spinner{margin:8px 0 0;height:25px;width:25px;position:static;display:inline-block;z-index:10;padding:0;background-color:transparent;border-width:1.5px;border-style:solid;border-radius:100%;border-color:#009cde #fff #fff;top:0;left:50%;opacity:1;filter:alpha(opacity=100);-webkit-animation:rotation .7s infinite linear;animation:rotation .7s infinite linear}#upopConfirmation .ppLogoContainer{text-align:center}#upopConfirmation .ppLogoContainer .logo{display:inline-block}#upopConfirmation .modalMask,#upopConfirmation .modalWrapper{position:fixed;top:0;bottom:0;left:0;right:0;z-index:10}#upopConfirmation .close{position:absolute;top:20px;right:20px;width:19px;height:12px;padding:5px;border-radius:3px}#upopConfirmation .close:before{content:\"\";position:absolute;width:19px;height:19px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#upopConfirmation .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#upopConfirmation .close:focus:before,#upopConfirmation .close:hover:before{background-position:-223px -22px}#upopConfirmation .modalMask{background:#cbd2d6;opacity:.7}#upopConfirmation .modalWrapperAnimation{transition:transform .3s ease-out}#upopConfirmation .modalWrapper{background:#fff;width:620px;-ms-box-sizing:border-box;box-sizing:border-box;left:50%;padding:80px 120px 0;overflow:auto;border-radius:5px;background-clip:padding-box;-webkit-transform:translate(-50%,100%);transform:translate(-50%,100%)}#upopConfirmation .modalWrapper .logo{position:relative;margin-top:-60px;width:25px;height:30px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#upopConfirmation .modalWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#upopConfirmation .modalContainer{min-height:99%;width:380px;display:block}#upopConfirmation .modalContainer .pushlogo{height:90px}#upopConfirmation .processing input{background-color:#f2f3f4}#upopConfirmation .upopOpen .modalWrapper{-webkit-transform:translate(-50%);transform:translate(-50%)}#upopConfirmation .upopConfirm .header{border-bottom:none}#upopConfirmation .upopConfirm .timingFields{padding-bottom:35px}#upopConfirmation .upopConfirm .counter{float:left}#upopConfirmation .upopConfirm a.resendCode{float:right}#upopConfirmation .upopConfirm #notifications{padding:0 0 5px}#upopConfirmation .expiration{display:inline-flex}#upopConfirmation .expiration .expires{position:relative;top:auto;left:auto}#upopConfirmation .expiration .expirationField{margin-right:10px}#upopConfirmation .expiration input.ng-invalid{padding-right:13px}#upopConfirmation .expiration label{margin-bottom:5px;color:#000}#upopConfirmation .telephoneField{clear:both;padding:0;float:none}#upopConfirmation .heading{margin:5px 0 10px;font-size:1.6em;font-family:HelveticaNeue-Light,Helvetica Neue Light,Helvetica,Arial,sans-serif}#upopConfirmation .timer{margin-bottom:20px}#upopConfirmation .timeLeft{margin-left:5px;font-weight:700}#upopConfirmation .confirmMsg{color:#6c7378;margin-bottom:20px}#upopConfirmation .resendLink{font-size:.85em}#upopConfirmation .btn{margin-top:10px}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){#upopConfirmation .modalWrapper{width:100%;padding:60px 15px 0}#upopConfirmation .modalWrapper .modalContainer{width:auto}}#addCard.aside #upopConfirmation #notifications{padding:0 0 5px;margin-bottom:0}.dobDropdownTooltip{position:relative;top:45px}form#dobDropdownGroup{border:none}.floatingLabel #dobToolTip .toolTip.balloon,.noFloatingLabel #dobToolTip .toolTip.balloon{background:#c72e2e;border:none;top:49px}.floatingLabel #dobToolTip .tipInfoText,.noFloatingLabel #dobToolTip .tipInfoText{border:none;background:inherit;text-indent:0;color:#fff}.floatingLabel #dobToolTip .tipInfoText .restriction.active,.noFloatingLabel #dobToolTip .tipInfoText .restriction.active{background:none}#soldOut{width:50%;min-width:320px}#soldOut,#soldOut #soldouticon{text-align:center;margin:0 auto;position:relative}#soldOut #soldouticon{display:inline-block;margin-top:47%}#soldOut .left_section{width:40px;height:44px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v14.png\");background-position:-160px -252px;background-repeat:no-repeat;background-color:#fff;float:left}#soldOut .text_lines{float:left;border-top:2px solid #c72e2e;border-bottom:2px solid #c72e2e;box-sizing:border-box;line-height:39px}#soldOut #text{font-family:HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:18px;color:#c72f2e;white-space:nowrap}#soldOut #rightSection{float:left}#soldOut .shape-right{display:inline-block;width:14px;height:45px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v14.png\");background-position:-187px -306px;background-repeat:no-repeat;background-color:#fff}#soldOut .soldOutMessage{width:343px;height:58px;font-family:HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:24px;color:#2c2e2f;line-height:normal;margin-top:20px;float:left;max-width:290px;margin-left:10%}#soldOut #Continue-Shopping{margin-top:60px;margin-bottom:150px;max-width:345px}#soldOut #Continue-Shopping:focus,#soldOut #Continue-Shopping:hover{text-decoration:underline;background-color:#005ea6;border-color:#005ea6}@media (min-width:0) and (max-width:21em){#soldOut #soldouticon{margin-right:10%}#soldOut .left_section{margin-left:inherit}#soldOut .soldOutMessage{margin-left:0;margin-bottom:30px;max-width:280px}#soldOut #Continue-Shopping{margin:40px 10% 40px 0;max-width:280px}#Continue-Shopping:focus,#soldOut #Continue-Shopping:hover{text-decoration:underline;background-color:#005ea6;border-color:#005ea6}.footer{margin-top:25%}.props,header{display:BLOCK;transform:translateY(25%)}}@media (min-width:21em) and (max-width:23.438em){#soldOut .left_section{margin-left:inherit}#soldOut #Continue-Shopping{margin:40px 10% 120px;max-width:280px}#Continue-Shopping:focus,#soldOut #Continue-Shopping:hover{text-decoration:underline;background-color:#005ea6;border-color:#005ea6}#soldOut .soldOutMessage{margin:20px 10% 30px;max-width:280px}.footer{margin-top:25%}.props,header{display:BLOCK;transform:translateY(25%)}}@media (min-width:23.438em) and (max-width:27.188em){#soldOut .left_section{margin-left:inherit}#soldOut #Continue-Shopping{margin:40px 5% 131px;max-width:280px}#Continue-Shopping:focus,#soldOut #Continue-Shopping:hover{text-decoration:underline;background-color:#005ea6;border-color:#005ea6}#soldOut .soldOutMessage{margin:20px 5% 30px;max-width:280px}.footer{margin-top:25%}.props,header{display:BLOCK;transform:translateY(25%)}}.upsellMask,.upsellWrapper{position:fixed;top:0;bottom:0;left:0;right:0;z-index:10}.upsellMask_white{background:#fff;opacity:.7}.upsellMask{background:#cbd2d6;opacity:.7}.whiteNoBlur{background:#fff;width:620px}.whiteNoBlur .cancel{margin-top:35px}.whiteWithBlur{background:#f7f9fa;width:100%}.whiteWithBlur .fill{min-height:125px;width:375px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/Static_OT_Interstitial_grey@1x.png\") no-repeat}.whiteWithBlur .cancel{margin-top:35px}.blackWithBlur{background:#555;width:100%;color:#fff}.blackWithBlur .fill{min-height:125px;width:375px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/Static_OT_Interstitial_darkgrey@1x.png\") no-repeat}.blackWithBlur .cancel{padding-top:13px;padding-bottom:13px;border-radius:4px;border:1px solid #979797;margin-top:15px}.blackWithBlur .cancel>a{color:#fff}.blackWithBlur #pp_min_logo{position:relative;width:29px;height:29px;margin:0 auto;background-position:0 0;background-size:29px 29px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/PayPal_Mark_Rev_White@1x.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.blackWithBlur #pp_min_logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/PayPal_Mark_Rev_White@2x.png\");background-size:21px 25px}}.upsellWrapper{-ms-box-sizing:border-box;box-sizing:border-box;left:50%;padding:90px 120px 0;overflow:auto;border-radius:5px;background-clip:padding-box;-webkit-transform:translate(-50%,100%);transform:translate(-50%,100%);transition:transform .3s ease-out}.upsellWrapper .logo{position:relative;width:29px;height:29px;margin:0 auto;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.upsellWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.upsellContainer{width:380px;display:block;min-height:100%;height:auto!important;height:100%;margin:0 auto -50px}.upsellContainer .pushLogo{height:60px}.upsellContainer .promoHeading{line-height:1.28;font-size:1.2em;margin-left:25px;margin-right:25px}.upsellContainer .cancel{text-align:center}.upsellContainer .buttons{margin-top:35px}.upsellContainer .promo{margin-top:25px;margin-left:25px;margin-right:25px;line-height:17px}.upsellContainer .promo .text{margin-left:74px;font-size:.86em}.upsellContainer .promo .icon.password:before{position:absolute;content:\"\";width:46px;height:19px;margin-top:18px;line-height:1.31em;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_hermes_icons_v1.png\");background-repeat:no-repeat;background-position:-128px -82px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.upsellContainer .promo .icon.password:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_hermes_icons_v1_2x.png\");background-size:257px 209px}}.upsellContainer .promo .icon.merchants:before{position:absolute;content:\"\";width:37px;height:34px;margin:5px 0 0 5px;line-height:1.31em;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_hermes_icons_v1.png\");background-repeat:no-repeat;background-position:-129px -111px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.upsellContainer .promo .icon.merchants:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_hermes_icons_v1_2x.png\");background-size:257px 209px}}.upsellContainer .promo .icon.secure:before{position:absolute;content:\"\";width:27px;height:39px;margin:5px 0 0 11px;line-height:1.31em;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_hermes_icons_v1.png\");background-repeat:no-repeat;background-position:-128px -155px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.upsellContainer .promo .icon.secure:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_hermes_icons_v1_2x.png\");background-size:257px 209px}}.upsellContainer .leftIcon:before{position:absolute;content:\"\";width:12px;height:22px;display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_hermes_icons_v1.png\");background-repeat:no-repeat;background-position:-66px -123px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.upsellContainer .leftIcon:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_hermes_icons_v1_2x.png\");background-size:257px 209px}}.upsellOpen .upsellWrapper{-webkit-transform:translate(-50%);transform:translate(-50%)}.kmliUpsell #spinner{top:0;left:0}body.loading.kmliUpsellActive #main{opacity:1}body.loading.kmliUpsellActive .kmliUpsell .aside{opacity:.1}@media (max-width:41.25em) and (orientation:landscape),(min-width:0) and (max-width:30em){.upsellWrapper{width:100%;padding:0 25px}.upsellWrapper .upsellContainer{width:auto;margin-top:5px}}.loading #main{opacity:.1}.spinner{height:100%;width:100%;position:fixed;top:0;left:0;z-index:10}.spinner .spinWrap{width:200px;height:100px;position:fixed;top:42%;left:50%;margin-left:-100px;margin-top:-50px}.spinner .spinnerImage{margin:28px 0 0 -25px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/icon_ot_spin_lock_skinny.png\") no-repeat}.spinner .loader,.spinner .spinnerImage{height:100px;width:100px;position:absolute;top:0;left:50%;opacity:1;filter:alpha(opacity=100)}.spinner .loader{margin:0 0 0 -55px;background-color:transparent;-webkit-animation:rotation .7s infinite linear;animation:rotation .7s infinite linear;border-left:5px solid #cbcbca;border-right:5px solid #cbcbca;border-bottom:5px solid #cbcbca;border-top:5px solid #2380be;border-radius:100%}.spinner .loadingMessage{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;margin-top:125px;text-align:center;z-index:100;outline:none}@-webkit-keyframes rotation{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(359deg)}}@keyframes rotation{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}@media only screen and (max-width:768px){.spinner .spinWrap{width:200px;height:100px;position:fixed;top:40%;left:50%;margin-left:-93px;margin-top:-50px}}.props .vprop-header{font-size:1.6em;color:#2c2e2f;margin:15px 0 10px;font-weight:lighter;line-height:1.2em}.props .prop-img{background-position:center 0}.props.login{padding:0 10px 0 0}.props.login .prop-img{height:104px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_wallet_card_v3.png\");background-repeat:no-repeat;margin-top:20px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.props.login .prop-img{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_wallet_card_v2_2x.png\");background-size:195px 104px}}.props.review .prop-img{height:92px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_shield_bags.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.props.review .prop-img{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_shield_bags_2x.png\");background-size:206px 92px}}.props.signature .prop-img{height:200px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_ballon.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.props.signature .prop-img{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_ballon_2x.png\");background-size:250px 200px}}.props.addTaxId .prop-img{height:104px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_wallet_card_v3.png\");background-repeat:no-repeat;margin-top:-25px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.props.addTaxId .prop-img{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_wallet_card_v2_2x.png\");background-size:195px 104px}}.props li,.props p{color:#757575;font-size:.9em;font-weight:400;line-height:1.35em;margin:5px 0}.props li a,.props p a{font-weight:700}.errorTooltip{background-color:#c72e2e;border-radius:5px;color:#fff;display:none;padding:7px;position:absolute;top:49px;z-index:2;font-size:.8em}.errorTooltip.fixed{position:relative;top:0;margin-bottom:10px}.errorTooltipRequired{z-index:3}.validated .ng-invalid:focus~.errorTooltipRequired~.errorTooltipRuleSpecific,.validated .ng-invalid:focus~.errorTooltipRuleSpecific{display:block!important}.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~.errorTooltipRuleSpecific,.validated .ignoreValidation input[type=checkbox].ng-invalid~.errorTooltipRuleSpecific,.validated .ng-invalid-required:focus~.errorTooltipRequired~.errorTooltipRuleSpecific,.validated .ng-invalid-required:focus~.errorTooltipRuleSpecific{display:none!important}.validated .ng-invalid-required:focus:not([type=checkbox])~.errorTooltipRequired,.validated input[type=checkbox].ng-invalid.hasErrorTooltipRuleSpecific:focus~.errorTooltipRuleSpecific,.validated input[type=checkbox].ng-invalid:focus:not(.hasErrorTooltipRuleSpecific)~.errorTooltipRequired{display:block!important}.validated input[type=checkbox].ng-invalid+.errorTooltipRequired+.errorTooltipRuleSpecific,.validated input[type=checkbox].ng-invalid+.errorTooltipRuleSpecific{top:35px;left:-20px}.validated .errorTooltip:empty{display:none!important}.backendError:focus~.errorTooltipRuleSpecific{display:block}.custom-select-container>select.backendError+span.custom-select>span,.inputField input.backendError,.validated .ng-invalid,.validated input.ng-invalid:active,.validated input.ng-invalid:focus,input.backendError{border:1px solid #c72e2e}.toolTip{display:none;font-size:.8em;color:#2c2e2f}.toolTip.balloon{position:absolute;z-index:2;padding:7px;text-align:left;border:1px solid #e1e7eb;border-radius:5px;background:#e1e7eb}.toolTip.displayInline{font-size:.9em;padding:10px 30px;font-size:.85em}.highZindexTooltip .toolTip.balloon{z-index:3}.left{left:0}.right{right:0}#notifications{position:relative}.aside #notifications{width:100%;box-sizing:border-box}.msgPage{padding:7px 0 8px;font-size:.85em}.msgPage ul{margin:0;padding-left:25px;list-style:none}.msgPage ul li{line-height:1.35em;margin:1px 8px}.msg-desc,.msg-error,.msg-info,.msg-success,.msg-warning{color:#c72e2e}.msg-desc .icon,.msg-error .icon,.msg-info .icon,.msg-success .icon,.msg-warning .icon{display:inline-block;width:21px;height:18px;position:absolute;left:0;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-63px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.msg-desc .icon,.msg-error .icon,.msg-info .icon,.msg-success .icon,.msg-warning .icon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.msg-info{background-color:#636b6d;border:1px solid #636b6d;color:#fff}.msg-info .icon{background-position:-139px -22px;left:9px}.msg-warning .icon{background-position:-90px -22px;left:9px}.msg-warning,.msg-warning ul li{background-color:#ffad37;color:#5b3300;border:none}.msg-success{padding:5px;background-color:#8fcf8a;border:1px solid #8fcf8a;color:#295425}.msg-success .icon{background-position:-114px -22px;left:10px}.msg-desc{background-color:#fff;border:1px solid #e3e3e3;color:#636b6d}.msg-desc .icon{background-position:-139px -1px;left:9px}.msg-normal{padding:15px 0 0}.msg-normal ul,.msg-normal ul li{color:#636b6d;padding-left:0;margin-left:0;font-size:1.03em;width:100%}@media (max-width:30em) and (min-width:0){#notifications{width:100%}}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){.review #notifications{width:100%}}.languageToggleDisplay{text-decoration:none;font-size:15px;position:absolute;bottom:17px;right:0}.languageToggleDisplay .changeLanguage{display:inline-block;margin:5px 0 0 5px;width:12px;height:7px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-23px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.languageToggleDisplay .changeLanguage{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.languageToggleDisplay .changeLanguage.expand{background-position:-23px -10px}.languageToggleDisplay .displayText{margin-right:2px}.languageToggleDisplay a{cursor:pointer}.languageToggleDisplay a:focus,.languageToggleDisplay a:hover{outline:none;text-decoration:none;border-bottom:1px solid #0070ba;padding-bottom:4px}.footer .languageToggleDisplay{position:static;display:inline-block;font-size:13px}.footer .languageToggleDisplay span{position:relative}.footer .languageToggleDisplay #langDropdownBlock{right:0;margin-bottom:25px}@media (min-width:30.0625em) and (max-width:41.25em){.languageToggleDisplay .popover{left:auto;top:46px;right:3px}}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){.languageToggleDisplay .popover{left:auto;top:50px;right:-6px}}@media (min-width:41.3125em){.pageLogin .languageToggleEnabled .languageToggle.outside{display:block;position:relative;width:100%;max-width:780px;margin:10px auto 0}#login .languageToggle{display:block}}#langDropdownBlock{position:absolute;z-index:10;background:#fff;border:1px solid #ccc;border-radius:6px;margin-top:15px;right:-15px;min-width:100px;background-clip:padding-box;box-shadow:0 5px 10px rgba(0,0,0,.2);white-space:normal;text-align:left}#langDropdownBlock ul{list-style:outside none disc;margin:0;padding:9px 14px}#langDropdownBlock ul li{list-style-type:none;padding:5px 0;white-space:nowrap}#langDropdownBlock>.arrow,#langDropdownBlock>.arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid}#langDropdownBlock>.arrow{border-width:11px}#langDropdownBlock>.arrow:after{border-width:10px;content:\"\"}#langDropdownBlock.top>.arrow{left:50%;margin-left:-11px;border-bottom-width:0;border-top-color:#999;border-top-color:rgba(0,0,0,.25);bottom:-11px}#langDropdownBlock.top>.arrow:after{content:\" \";bottom:1px;margin-left:-10px;border-bottom-width:0;border-top-color:#fff}#langDropdownBlock.right>.arrow{top:50%;left:-11px;margin-top:-11px;border-left-width:0;border-right-color:#999;border-right-color:rgba(0,0,0,.25)}#langDropdownBlock.right>.arrow:after{content:\" \";left:1px;bottom:-10px;border-left-width:0;border-right-color:#fff}#langDropdownBlock.bottom>.arrow{left:50%;margin-left:-11px;border-top-width:0;border-bottom-color:#999;border-bottom-color:rgba(0,0,0,.25);top:-11px}#langDropdownBlock.bottom>.arrow:after{content:\" \";top:1px;margin-left:-10px;border-top-width:0;border-bottom-color:#fff}#langDropdownBlock.left>.arrow{top:50%;right:-11px;margin-top:-11px;border-right-width:0;border-left-color:#999;border-left-color:rgba(0,0,0,.25)}#langDropdownBlock.left>.arrow:after{content:\" \";right:1px;border-right-width:0;border-left-color:#fff;bottom:-10px}.cartContainer{float:left;display:block;width:184px}.formatCurrency{display:inline-block}.cartContainer .hasAmount .cartIcon{margin-right:6px}.cartContainer .hasAmount .pointer{right:57px}.transactionDetailsContainer{border-radius:5px 5px 0 0;background-clip:padding-box;-webkit-tap-highlight-color:rgba(0,0,0,.2)}.transactionDetailsContainer.cart #transactionCart{border-bottom:0 none;border-color:#ddd #ddd -moz-use-text-color}.transactionDetailsContainer.cart #transactionCart .arrow{background-position:-23px -10px}.transactionDetailsContainer.cart .transctionCartDetails{visibility:visible}.transactionDetailsContainer .merchantName{width:calc(92% - 36px);min-height:17px;padding:15px 15px 10px;line-height:1.35em;font-size:13px;margin-top:0;margin-bottom:0}.transactionDetailsContainer .merchantTitle{margin-bottom:-3px}.transactionDetailsContainer .note{color:#6c7378;font-size:12px;line-height:1.35em;padding:0 15px 1em;margin-bottom:0;text-overflow:ellipsis;overflow:hidden}.transactionDetailsContainer .note.noteHighlighted{font-size:13px;padding-top:10px;padding-bottom:10px;color:#6c7378;background-color:#f1f4f5;border-radius:0 0 5px 5px;background-clip:padding-box}.transactionDetails{display:block;padding-right:1px;margin:0 auto;overflow:auto;color:#393f44}.transactionDetails:focus,.transactionDetails:hover{text-decoration:none;background-image:none;color:#6c7378;overflow:visible}.transactionDetails:focus .totalWrapper,.transactionDetails:hover .totalWrapper{overflow:visible}.transactionDetails:focus .totalWrapper #transactionCart,.transactionDetails:hover .totalWrapper #transactionCart{border-bottom:1px solid #2c2e2f;margin-bottom:-1px}.transactionDetails:active{background-image:none}.transactionDetails:active #yourCart{background-position:5px -95px}#transactionCart.hasItems:focus,#transactionCart.hasItems:hover{-webkit-opacity:.7;-moz-opacity:.7;opacity:.7;filter:alpha(opacity=70)}.totalWrapper{display:block;overflow:auto}.hasNoItems .totalWrapper{background-image:none}#yourCart{float:left;left:0}#transactionCart{float:right;z-index:1;padding:8px 0 0;margin-bottom:0;border-bottom:0;-ms-box-sizing:border-box;box-sizing:border-box;border-color:#ddd;font-size:1em;font-weight:700;text-align:right;color:#2c2e2f;text-shadow:1px 1px 1px #fff;background-size:24px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}#transactionCart:active{background-position:right -290px}#transactionCart .cartIcon{display:inline-block;width:15px;height:14px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:0 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#transactionCart .cartIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#transactionCart .arrow{display:inline-block;margin:5px 0 0 5px;width:12px;height:10px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-23px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#transactionCart .arrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#transactionCart span{vertical-align:middle}#transactionCart format-currency span{vertical-align:inherit}#transactionCart format-currency span .currencyCode{font-size:1em}@-moz-document url-prefix(){#transactionCart .cartIcon{margin-top:-2px}}.transctionCartDetails{position:relative;overflow:hidden;visibility:hidden;padding-bottom:0;transition:max-height .7s ease}.transctionCartDetails .pointer{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/icon_flyoutArrow_up_2x.png\") no-repeat scroll 0 0 transparent;height:10px;position:absolute;right:38px;top:0;width:34px}.details{-ms-box-sizing:border-box;box-sizing:border-box;background:#fff;border-radius:5px;background-clip:padding-box;box-shadow:1px 1px 1px 0 #ccc;max-height:450px}.details ul{list-style-type:none;margin:0;font-size:.85em;background-color:#f1f4f5}.details ul.detail-items>li{padding-top:0;padding-bottom:10px;min-height:0}.details ul.itemDetails{width:100%;font-size:1em;max-height:none;margin:0;padding:0}.details ul.itemDetails>li{padding:0;color:#6c7378;border:none;line-height:16px;margin:10px 0 0}.details ul.itemDetails>li .item-selections{font-size:13px}.details ul.itemDetails>li .item-selection-name{font-weight:700}.details ul.itemDetails>li .item-selection-value{padding-right:1em}.details li{margin:0;padding:5px 15px;overflow:auto;line-height:16px;border-bottom:1px solid #ccc}.details li:last-of-type{border-bottom:none}.details li.actions{margin:15px;padding:10px 1px 10px 15px;border-top:1px solid #ccc;border-radius:0 0 5px 5px;background-clip:padding-box;text-align:right}.details a.less,.details a.more{cursor:pointer}.details a.more{display:inline-block;float:right}.details a.more.inline-more{display:inline;float:none}.details ul.detail-extras{border-top:1px solid #ccc;padding-top:10px;padding-bottom:15px}.details ul.detail-extras .itemNameContainer,.details ul.detail-extras .itemPrice{margin-top:5px}.details ul.detail-extras li{overflow:hidden;line-height:normal;border-bottom:0;padding-top:0;padding-bottom:0}.details div.subTotal{font-size:.85em;background-color:#f1f4f5;padding:5px 15px 15px;margin-top:0;font-weight:700;border-top:1px solid #ccc;height:auto;line-height:1;border-radius:0 0 5px 5px;background-clip:padding-box}.scrollable-middle{overflow:auto}.notes{font-weight:400;margin-top:3px;line-height:100%;width:100%;overflow:hidden;min-height:1em;white-space:nowrap;text-overflow:ellipsis}.itemNameContainer{display:inline-block;width:60%;min-height:1em;vertical-align:top;margin-top:10px}.itemName{overflow:hidden;white-space:nowrap;text-overflow:ellipsis;display:block;margin-bottom:0}.expanded .itemName{text-overflow:clip;line-height:16px;white-space:normal}.itemPrice{margin-top:10px;width:38%;overflow:hidden;font-size:1em;text-align:right;white-space:nowrap;text-overflow:ellipsis;-webkit-font-feature-settings:\"tnum\";display:inline-block;vertical-align:top}.currencyCode{float:left;margin-top:5px;font-size:.8em;text-align:right;float:none}#transactionDetails.cart .hasNoItems,.hasNoItems.transactionDetails,.hasNoItems.transactionDetails:active,.hasNoItems.transactionDetails:focus{float:right;background:none;border:none;box-shadow:none;cursor:default}#transactionDetails.cart .hasNoItems #yourCart,.hasNoItems.transactionDetails #yourCart,.hasNoItems.transactionDetails:active #yourCart,.hasNoItems.transactionDetails:focus #yourCart{display:none}#transactionDetails.cart .hasNoItems #transactionCart,.hasNoItems.transactionDetails #transactionCart,.hasNoItems.transactionDetails:active #transactionCart,.hasNoItems.transactionDetails:focus #transactionCart{padding:8px 0 0 30px;width:auto}#transactionDetails.cart .hasNoItems #transactionCart .arrow,.hasNoItems.transactionDetails #transactionCart .arrow,.hasNoItems.transactionDetails:active #transactionCart .arrow,.hasNoItems.transactionDetails:focus #transactionCart .arrow{display:none}#transactionDetails.cart .hasNoItems #transactionCart:focus,#transactionDetails.cart .hasNoItems #transactionCart:hover,.hasNoItems.transactionDetails #transactionCart:focus,.hasNoItems.transactionDetails #transactionCart:hover,.hasNoItems.transactionDetails:active #transactionCart:focus,.hasNoItems.transactionDetails:active #transactionCart:hover,.hasNoItems.transactionDetails:focus #transactionCart:focus,.hasNoItems.transactionDetails:focus #transactionCart:hover{text-decoration:none;background-image:none;color:#393f44}#transactionDetails.cart .hasNoItems #transactionCart .cartIcon,.hasNoItems.transactionDetails #transactionCart .cartIcon,.hasNoItems.transactionDetails:active #transactionCart .cartIcon,.hasNoItems.transactionDetails:focus #transactionCart .cartIcon{background-position:0 0}#closeCart{position:static;float:right;width:10px;height:10px;margin:15px 15px 0 0;padding:5px;border-radius:3px;cursor:pointer}#closeCart:before{content:\"\";position:absolute;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-44px 0;width:10px;height:11px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#closeCart:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#closeCart:focus:before,#closeCart:hover:before{background-position:-44px -15px}.largeScreen .transactionDetails{float:right;margin:0}.largeScreen #transactionDetails{position:relative}.largeScreen #transactionDetails .transctionCartDetails{clear:both}.cartContainer{float:right}.transctionCartDetails{position:absolute;right:43.42553193%;width:320px}.paypalCredit .transctionCartDetails{right:0}.details{margin:10px;box-shadow:0 1px 4px 1px rgba(0,0,0,.3);-webkit-box-shadow:0 1px 2px 1px rgba(0,0,0,.3);-moz-box-shadow:0 1px 2px 1px rgba(0,0,0,.3);list-style-type:none}@media (max-width:41.3125em){.cartContainer{display:block;position:absolute;right:15px;top:10px;z-index:151;width:160px}.minibrowser .cartContainer{right:0}.transctionCartDetails{left:auto;right:0;width:320px}.cartVerB header .cartContainer{display:block}.cartVerB #main .cartContainer{display:none}.incontext .paypalHeaderWrapper .cartContainer{right:35px;top:12px;margin-top:10px;margin-right:41px}.incontext .paypalHeaderWrapper .transctionCartDetails{width:350px}.incontext .cartContainer.hidePayPalLogo{right:214px}.incontext .viewTypeOnePage .hidePayPalLogo .transctionCartDetails{left:-15px}.incontext .viewTypeOnePage .hidePayPalLogo .transctionCartDetails .pointer{right:300px}}@media (min-width:0) and (max-width:30em){.cartContainer{right:0;top:15px}#closeCart{right:20px}.transactionDetails{padding-right:0}}.modal-wrapper .modal-overlay{position:fixed;top:0;left:0;width:100%;height:100%;background:#000;opacity:.8;z-index:150}.modal-wrapper .modal-dialog{overflow:auto;overflow-y:scroll;position:fixed;top:0;right:0;bottom:0;left:0;z-index:150}.modal-wrapper .modal-content{display:block;position:absolute;left:50%;top:45%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.modal-wrapper .modal-default{height:auto;width:200px;padding:30px;background-color:#fff;background-clip:padding-box}.modal-wrapper .modal-default .close{position:absolute;top:15px;right:20px;width:19px;height:19px;padding:0;font-size:0;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.modal-wrapper .modal-default .close{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.modal-wrapper .modal-default .close:focus,.modal-wrapper .modal-default .close:hover{background-position:-223px -22px;text-decoration:none}.modal-wrapper .popLink{word-break:break-all;font-size:.8em}@media (min-height:0) and (max-height:500px){.modal-wrapper .modal-content{top:60%}}@media (min-height:500px) and (max-height:700px){.modal-wrapper .modal-content{top:50%}}@font-face{font-family:consumer-icons;src:url(\"https://www.paypalobjects.com/ui-web/iconfont-consumer/3-4-0/fonts/ConsumerIcons-Regular.eot\");src:url(\"https://www.paypalobjects.com/ui-web/iconfont-consumer/3-4-0/fonts/ConsumerIcons-Regular.eot?#iefix\") format(\"embedded-opentype\"),url(\"https://www.paypalobjects.com/ui-web/iconfont-consumer/3-4-0/fonts/ConsumerIcons-Regular.woff\") format(\"woff\"),url(\"https://www.paypalobjects.com/ui-web/iconfont-consumer/3-4-0/fonts/ConsumerIcons-Regular.ttf\") format(\"truetype\"),url(\"https://www.paypalobjects.com/ui-web/iconfont-consumer/3-4-0/fonts/ConsumerIcons-Regular.svg#69ac2c9fc1e0803e59e06e93859bed03\") format(\"svg\");font-style:normal;font-weight:400}.icon{font-family:consumer-icons;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.icon-small:before{font-size:1.58rem}.icon-medium:before{font-size:2.6rem}.icon-large:before{font-size:7.8rem}.icon-burger-small:before{content:\"\\E000\"}.icon-slider-small:before{content:\"\\E001\"}.icon-slider-half-small:before{content:\"\\E002\"}.icon-close-small:before{content:\"\\E003\"}.icon-add-small:before{content:\"\\E004\"}.icon-arrow-down-small:before{content:\"\\E005\"}.icon-arrow-up-small:before{content:\"\\E006\"}.icon-arrow-left-small:before{content:\"\\E007\"}.icon-arrow-right-small:before{content:\"\\E008\"}.icon-arrow-down-half-small:before{content:\"\\E009\"}.icon-arrow-up-half-small:before{content:\"\\E010\"}.icon-arrow-left-half-small:before{content:\"\\E011\"}.icon-arrow-right-half-small:before{content:\"\\E012\"}.icon-clear-half-small:before{content:\"\\E013\"}.icon-checkmark-small:before{content:\"\\E014\"}.icon-checkmark-small-bold:before{content:\"\\E015\"}.icon-action-arrow-half-small:before{content:\"\\E016\"}.icon-tooltip-outline-small:before{content:\"\\E017\"}.icon-tooltip-small:before{content:\"\\E018\"}.icon-info-small:before{content:\"\\E019\"}.icon-positive-small:before{content:\"\\E020\"}.icon-attention-small:before{content:\"\\E021\"}.icon-critical-small:before{content:\"\\E022\"}.icon-info-large:before{content:\"\\E023\"}.icon-positive-large:before{content:\"\\E024\"}.icon-attention-large:before{content:\"\\E025\"}.icon-critical-large:before{content:\"\\E026\"}.icon-pp-logo:before{content:\"\\E029\"}.icon-visa-logo:before{content:\"\\E030\"}.icon-mastercard-logo:before{content:\"\\E031\"}.icon-maestro-logo:before{content:\"\\E032\"}.icon-amex-logo:before{content:\"\\E033\"}.icon-discover-logo:before{content:\"\\E034\"}.icon-card-half-solid:before{content:\"\\E035\"}.icon-bank-half-solid:before{content:\"\\E036\"}.icon-profile-large:before{content:\"\\E037\"}.icon-profile-add-large:before{content:\"\\E038\"}.icon-notification-small:before{content:\"\\E039\"}.icon-settings-small:before{content:\"\\E040\"}.icon-profile-small:before{content:\"\\E041\"}.icon-funnel-small:before{content:\"\\E042\"}.icon-delete-small:before{content:\"\\E043\"}.icon-edit-small:before{content:\"\\E044\"}.icon-lock-small:before{content:\"\\E045\"}.icon-pdf-small:before{content:\"\\E046\"}.icon-contact-small:before{content:\"\\E047\"}.icon-undo-small:before{content:\"\\E048\"}.icon-cancel-small:before{content:\"\\E049\"}.icon-simple-list-small:before{content:\"\\E050\"}.icon-detailed-list-small:before{content:\"\\E051\"}.icon-print-small:before{content:\"\\E052\"}.icon-camera-small:before{content:\"\\E053\"}.icon-info-outline-small:before{content:\"\\E054\"}.icon-us-dollar-outline-small:before{content:\"\\E055\"}.icon-calendar-half-small:before{content:\"\\E056\"}.icon-hiper-logo:before{content:\"\\E057\"}.icon-hipercard-logo:before{content:\"\\E058\"}.icon-elo-logo:before{content:\"\\E059\"}.icon-star-small:before{content:\"\\E060\"}.icon-jcb-logo:before{content:\"\\E061\"}.icon-attention-outline-small:before{content:\"\\E062\"}.icon-unionpay-logo:before{content:\"\\E063\"}.icon-search-small:before{content:\"\\E064\"}.icon-desktop-small:before{content:\"\\E065\"}.icon-mobile-small:before{content:\"\\E066\"}.icon-laptop-small:before{content:\"\\E067\"}.icon-tablet-small:before{content:\"\\E068\"}.icon-send-money:before{content:\"\\E500\"}.icon-request-money:before{content:\"\\E501\"}.icon-photo:before{content:\"\\E502\"}.icon-gift-cards:before{content:\"\\E503\"}.icon-credit-card:before{content:\"\\E504\"}.icon-truck:before{content:\"\\E505\"}.icon-email:before{content:\"\\E506\"}.icon-email-solid:before{content:\"\\E507\"}.icon-bank-check:before{content:\"\\E508\"}.icon-calendar:before{content:\"\\E509\"}.icon-holiday:before{content:\"\\E510\"}.icon-gift:before{content:\"\\E511\"}.icon-wallet:before{content:\"\\E512\"}.icon-play-video:before{content:\"\\E513\"}.icon-heart:before{content:\"\\E514\"}.icon-shield:before{content:\"\\E515\"}.icon-tunes:before{content:\"\\E516\"}.icon-invoice:before{content:\"\\E517\"}.icon-shopping-bag:before{content:\"\\E518\"}.icon-phone:before{content:\"\\E519\"}.icon-phone-solid:before{content:\"\\E520\"}.icon-tag:before{content:\"\\E521\"}.icon-delivery:before{content:\"\\E522\"}.icon-questionmark:before{content:\"\\E523\"}.icon-cut-coupons:before{content:\"\\E524\"}.icon-register:before{content:\"\\E525\"}.icon-house:before{content:\"\\E526\"}.icon-gift-card:before{content:\"\\E527\"}.icon-messages:before{content:\"\\E528\"}.icon-add-money:before{content:\"\\E529\"}.icon-send-check:before{content:\"\\E530\"}.icon-paypal-me:before{content:\"\\E531\"}.icon-pp-logo-outline:before{content:\"\\E532\"}.icon-money-bag:before{content:\"\\E533\"}.icon-chip-pin:before{content:\"\\E534\"}.icon-boleto-ready:before{content:\"\\E535\"}.icon-boleto-topup:before{content:\"\\E536\"}.icon-clock-pay:before{content:\"\\E537\"}.icon-speeding-cart:before{content:\"\\E538\"}.icon-international-transfer:before{content:\"\\E539\"}.icon-link-small:before{content:\"\\E540\"}@media (min-width:42em){.mobileApp header{display:none}.mobileApp #wrapper{margin:0;max-width:inherit;width:100%}.mobileApp .paypalHeader{width:100%}.mobileApp .footer{max-width:inherit}.mobileApp section .row-fluid .span14{width:100%}.mobileApp .feedback,.mobileApp section .row-fluid .span10{display:none}}@media (min-width:30.0625em) and (max-width:41.3125em){.paypalHeaderWrapper .span14{padding:0 0 20px}.paypalHeaderWrapper .cartContainer{margin-top:15px}}.outerWrapper.rtl{direction:rtl;unicode-bidi:embed}.outerWrapper.rtl input[type=checkbox]~label.bgImgOnSpan span.bgImg{direction:rtl;text-align:right;float:right;margin-left:9px;margin-right:-41px}.outerWrapper.rtl .dccMerchTotal,.outerWrapper.rtl .dccPPTotalAmt,.outerWrapper.rtl .dccSpread{direction:ltr;display:inline-block;unicode-bidi:bidi-override}.outerWrapper.rtl #conversionSection .modalWrapper{left:0;right:50%;-webkit-transform:translate(50%,100%);transform:translate(50%,100%)}.outerWrapper.rtl #conversionSection .modalOpen .modalWrapper{-webkit-transform:translate(50%);transform:translate(50%)}.outerWrapper.rtl #conversionSection .modalClose .modalWrapper{-webkit-transform:translate(50%,100%);transform:translate(50%,100%)}.outerWrapper.rtl .dccDetails{direction:ltr;text-align:right}.outerWrapper.rtl .dccDetails b{direction:rtl;float:right;margin-left:3px}.outerWrapper.rtl #billingPageCurrencyConversionRates{text-align:right;float:right}.outerWrapper.rtl #billingPageCurrencyConversionRates #conversionLink{float:left;margin-right:3px;direction:ltr}.outerWrapper.rtl #currencyConversion .toolTip.balloon{top:auto;margin-top:22px}.outerWrapper.rtl .inputField.checkbox.legal label{text-align:right}.outerWrapper.rtl .tipCreditCard{direction:rtl}.outerWrapper.rtl #upgradeInterstitialForm .inputField.confirmPasswordField{margin-right:0}.outerWrapper.rtl #upgradeInterstitialForm .emailHelper{left:0;right:20px}.outerWrapper.rtl .inputField.floatingLabel.ltrOverride .toolTip.balloon{direction:rtl}.outerWrapper.rtl .inputField.floatingLabel label{left:0;right:14px;transform-origin:right top 0;text-align:right}.outerWrapper.rtl .inputField.floatingLabel.ltrOverride label{left:14px;right:0;transform-origin:left top 0;text-align:left}.outerWrapper.rtl .inputField.floatingLabel .ltrOverride label{left:14px;right:-14px;transform-origin:left top 0;text-align:left}.outerWrapper.rtl #securityCode.creditCard,.outerWrapper.rtl .ccard{text-indent:100%;white-space:nowrap;overflow:hidden;left:10px;right:inherit}.outerWrapper.rtl div #securityCode.creditCard{right:inherit;left:14px}.outerWrapper.rtl div .emailHelper{left:10px;right:inherit}.outerWrapper.rtl div .creditCardField .creditCard{left:inherit;right:10px}.outerWrapper.rtl div.ltrOverride #securityCode.creditCard{right:14px;left:inherit}.outerWrapper.rtl div.ltrOverride .emailHelper{left:inherit;right:10px}.outerWrapper.rtl div.ltrOverride .creditCardField .creditCard{left:10px;right:inherit}.outerWrapper.rtl #langDropdownBlock.bottom>.arrow:after{left:0}.outerWrapper.rtl #closeCart{margin-left:3px}.outerWrapper.rtl .transctionCartDetails{left:43.42553193%;right:auto}.outerWrapper.rtl .transctionCartDetails .pointer{right:auto;left:38px}.outerWrapper.rtl .transctionCartDetails .detail-extras .amounts .itemPrice,.outerWrapper.rtl .transctionCartDetails .detail-items .items .itemPrice,.outerWrapper.rtl .transctionCartDetails .subTotal .itemPrice{text-align:left}.outerWrapper.rtl .transctionCartDetails .detail-extras .amounts .itemName,.outerWrapper.rtl .transctionCartDetails .detail-items .items .itemName,.outerWrapper.rtl .transctionCartDetails .subTotal .itemName{text-align:right}.outerWrapper.rtl .cartContainer .hasAmount .pointer{right:auto;left:57px}.outerWrapper.rtl .languageToggleDisplay{left:0;right:auto}.outerWrapper.rtl .languageToggleDisplay .displayText{margin-right:0}.outerWrapper.rtl .languageToggleDisplay .changeLanguage{margin:5px 10px 0 0}.outerWrapper.rtl .secureIcon{margin-left:-9px}.outerWrapper.rtl #confirmPasswordToolTip>div{left:-5px}@media (max-width:30em) and (min-width:0){.outerWrapper.rtl .confirmPasswordField{margin-right:0!important}.outerWrapper.rtl #confirmPasswordToolTip>div{right:0}}.outerWrapper.rtl .signupFields{padding-left:0;padding-right:35px}.outerWrapper.rtl .fullSignup{padding-right:0}.outerWrapper.rtl .confirmPasswordToolTip ul li,.outerWrapper.rtl .passwordToolTip ul li{background-position:100%;padding-right:18px}.outerWrapper.rtl #loginSection .baslLoginLabelContainer{float:right}.outerWrapper.rtl #loginSection .baslLoginButtonContainer{float:left}.outerWrapper.rtl .cardIcon.VISA{margin-right:-6px}.outerWrapper.rtl #expirationField,.outerWrapper.rtl .icons .cardIcon{float:right}.outerWrapper.rtl #cvvField{float:left}.outerWrapper.rtl .fieldGroup .inputField.half{float:right;margin-right:0}.outerWrapper.rtl .inputField.half.last-child{margin-right:2.6%}.outerWrapper.rtl .row-fluid>[class*=span]{float:right}.outerWrapper.rtl .row-fluid>.span10{float:left;margin-left:0}.outerWrapper.rtl .paypalHeaderWrapper .logo{float:right;margin-right:5px}.outerWrapper.rtl .cartContainer{float:left;right:auto;left:0;margin-left:0}.outerWrapper.rtl #transactionCart{float:left}.outerWrapper.rtl #transactionCart .arrow{margin:5px 5px 0 0}.outerWrapper.rtl #transactionCart .cartIcon{margin:0 0 0 6px}.outerWrapper.rtl #transactionDetails.cart .hasNoItems #transactionCart,.outerWrapper.rtl .hasNoItems.transactionDetails #transactionCart,.outerWrapper.rtl .hasNoItems.transactionDetails:active #transactionCart,.outerWrapper.rtl .hasNoItems.transactionDetails:focus #transactionCart{background-position:right 9px;padding-right:27px;padding-left:0}.outerWrapper.rtl #closeCart{float:left;margin:15px 0 0 15px}.outerWrapper.rtl .checkbox input[type=checkbox]~label{padding-left:0;background-position:right 0;margin-right:-5px;padding-right:40px}.outerWrapper.rtl .checkbox.error input[type=checkbox]:focus~label,.outerWrapper.rtl .checkbox.error input[type=checkbox]~label{background-position:right -600px}.outerWrapper.rtl .checkbox input[type=checkbox]:checked~label{background-position:right -400px}.outerWrapper.rtl .checkbox input[type=checkbox]:focus:checked~label{background-position:right -4801px}.outerWrapper.rtl .checkbox input[type=checkbox]:focus~label{background-position:right -4601px}.outerWrapper.rtl .validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label,.outerWrapper.rtl .validated .ignoreValidation input[type=checkbox].ng-invalid~label{background-position:right 0}.outerWrapper.rtl .validated input[type=checkbox].ng-invalid~label{background-position:right -600px}.outerWrapper.rtl .validated input[type=radio].ng-invalid+label,.outerWrapper.rtl .validated input[type=radio].ng-invalid:focus+label{background-position:right -2200px}.outerWrapper.rtl .sCheckbox.checkbox input[type=checkbox]~label{background-position:right -2600px}.outerWrapper.rtl .sCheckbox.checkbox.error input[type=checkbox]:focus~label,.outerWrapper.rtl .sCheckbox.checkbox.error input[type=checkbox]~label{background-position:right -3200px}.outerWrapper.rtl .sCheckbox.checkbox input[type=checkbox]:checked~label{background-position:right -3000px}.outerWrapper.rtl .sCheckbox.checkbox input[type=checkbox]:focus:checked~label{background-position:right -5409px}.outerWrapper.rtl .sCheckbox.checkbox input[type=checkbox]:focus~label{background-position:right -2800px}.outerWrapper.rtl .radioButton input[type=radio]~label{padding-left:0;background-position:right -1600px;margin-right:-5px;padding-right:40px}.outerWrapper.rtl .radioButton.error input[type=radio]+label,.outerWrapper.rtl .radioButton.error input[type=radio]:focus+label{background-position:right -2200px}.outerWrapper.rtl .radioButton.warning input[type=radio]+label,.outerWrapper.rtl .radioButton.warning input[type=radio]:focus+label{background-position:right -7405px}.outerWrapper.rtl .radioButton input[type=radio]:checked+label{background-position:right -2000px}.outerWrapper.rtl .radioButton input[type=radio]:focus:checked+label{background-position:right -6010px}.outerWrapper.rtl .radioButton input[type=radio]:focus+label{background-position:right -1800px}.outerWrapper.rtl .inputField.error input,.outerWrapper.rtl .validated .inputField input.backendError,.outerWrapper.rtl .validated .inputField input.ng-invalid{background-position:2%;padding-right:12px}.outerWrapper.rtl .inputField.noFloatingLabel#countryOfResidenceDropDown label,.outerWrapper.rtl .inputField.noFloatingLabel#nationalityDropDown label{right:0;text-align:right}.outerWrapper.rtl .dropdown.billingAddress a{float:left}.outerWrapper.rtl .validated select.backendError+.custom-select>span,.outerWrapper.rtl .validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat left 10px center;background-size:18px}.outerWrapper.rtl .inputField.error input,.outerWrapper.rtl .validated .inputField input.backendError,.outerWrapper.rtl .validated .inputField input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat 98% left;background-size:18px;background-position:10px}.outerWrapper.rtl .validated div.inputField.ltrOverride.error input,.outerWrapper.rtl .validated div.inputField.ltrOverride input.backendError,.outerWrapper.rtl .validated div.inputField.ltrOverride input.ng-invalid{background-position:right 10px center}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.outerWrapper.rtl .inputField.error input,.outerWrapper.rtl .validated .inputField input.backendError,.outerWrapper.rtl .validated .inputField input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat 98% left;background-size:18px;background-position:10px}.outerWrapper.rtl .validated select.backendError+.custom-select>span,.outerWrapper.rtl .validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat left 10px center;background-size:18px}}.outerWrapper.rtl .fsIcons{padding-right:0;float:right;margin-left:10px}.outerWrapper.rtl .verifyHelp{text-indent:100%;white-space:nowrap;overflow:hidden}.outerWrapper.rtl .toolTip.balloon{text-align:right;top:50px}.outerWrapper.rtl .frontArrow{position:relative}.outerWrapper.rtl #payUponInvoice .edits{padding:7px 10px 4px 0}.outerWrapper.rtl .cardType.split{float:left}.outerWrapper.rtl .creditCardField.split,.outerWrapper.rtl div#phoneTypeSelection{float:right}.outerWrapper.rtl .custom-select>span{background-position:left 5px top -1178px;padding:7px 13px 7px 30px}.outerWrapper.rtl .error .custom-select.active>span,.outerWrapper.rtl .error .custom-select>span{background-position:left 10px center}.outerWrapper.rtl .footer .languageToggleDisplay #langDropdownBlock{right:-50px;left:5px}.outerWrapper.rtl .footer .languageToggleDisplay #langDropdownBlock.bottom>.arrow:after{margin-left:0;margin-right:-10px}.outerWrapper.rtl .footer .languageToggleDisplay .changeLanguage{margin:5px 5px 0 0}.outerWrapper.rtl .footer .cancelUrl{float:right;width:34%}.outerWrapper.rtl .footer .footerWrapper{float:left;text-align:left;width:65%}.outerWrapper.rtl .footer .footerWrapper .footerLinks{float:none;text-align:left;background-position:100%;padding-right:20px;width:auto}.outerWrapper.rtl .footer .footerWrapper .footerLinks .last{padding-right:6px}.outerWrapper.rtl .footer .footerWrapper .copyright{float:none;width:22%;text-align:right;padding-right:10px;padding-left:10px}.outerWrapper.rtl #guestUpgrade #circle{right:32px}.outerWrapper.rtl #guestUpgrade .tick{left:0;right:-30px;padding-right:0;padding-left:60px}.outerWrapper.rtl #guestUpgrade .rtlPhoneType{margin:0 0 0 3.7%}.outerWrapper.rtl #guestUpgrade .telephoneField{width:64.3%}", ""]);
	
	// exports


/***/ }),

/***/ "../node_modules/css-loader/lib/css-base.js":
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),

/***/ "../node_modules/style-loader/addStyles.js":
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),

/***/ "./components/xo-beaver/dist/logger.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/xo-beaver/dist/level.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('beaver', ['beaver.level']).factory('$Logger', function ($injector, $http, $window, $interval, $timeout, $log, $q, $rootScope, $logLevel, $consoleLogLevel) {
	
	        var logger = {};
	        var HERMES_DEV_COOKIE = 'hermesdev';
	
	        angular.forEach($logLevel, function (level) {
	            logger[level] = function (event, payload, settings) {
	                return this.log(level, event, payload, settings);
	            };
	        });
	
	        var hostname = $window.location && $window.location.hostname || '';
	
	        var uniqueEvents = [];
	
	        angular.extend(logger, {
	
	            autoLog: [$logLevel.WARNING, $logLevel.ERROR],
	            flushInterval: 10 * 60 * 1000,
	            heartbeatInterval: 5000,
	            sizeLimit: 300,
	            debounceInterval: 10,
	            uri: '/api/log',
	            hearbeatMaxThreshold: 50,
	
	            deploy: {
	                isLocal: function isLocal() {
	                    return hostname === 'localhost' || hostname === 'localhost.paypal.com';
	                },
	
	                isStage: function isStage() {
	                    return Boolean(hostname.match(/^.*\.qa\.paypal\.com$/));
	                },
	
	                isLive: function isLive() {
	                    return hostname === 'www.paypal.com';
	                }
	            },
	
	            init: function init() {
	                var self = this;
	
	                this.buffer = [];
	
	                var previousBeforeUnloadHandler = $window.onbeforeunload;
	
	                $window.onbeforeunload = function (event) {
	
	                    if (self.isDone) {
	                        return;
	                    }
	
	                    self.info('window_beforeunload');
	
	                    if (previousBeforeUnloadHandler) {
	                        return previousBeforeUnloadHandler.apply(this, arguments);
	                    }
	                };
	
	                var previousUnloadHandler = $window.onunload;
	
	                $window.onunload = function (event) {
	
	                    if (self.isDone) {
	                        return;
	                    }
	
	                    self.info('window_unload')._flush();
	
	                    self.done();
	
	                    if (previousUnloadHandler) {
	                        return previousUnloadHandler.apply(this, arguments);
	                    }
	                };
	
	                this.heartbeat();
	                this.daemon();
	            },
	
	            heartbeat: function heartbeat() {
	                var self = this;
	
	                if (!window.enablePerformance) {
	                    return;
	                }
	
	                function timestamp() {
	                    var perf = window.performance;
	
	                    return parseInt(perf.now() - (perf.timing.connectEnd - perf.timing.navigationStart), 10);
	                }
	
	                var howBusy = {
	                    lastSampledTime: timestamp(),
	                    lastLag: 0,
	                    maxLag: 0,
	                    dampendedLag: 0
	                };
	
	                var count = 0;
	
	                $interval(function () {
	
	                    if (!self.buffer.length || self.buffer[self.buffer.length - 1].event !== 'heartbeat') {
	                        count = 0;
	                    }
	
	                    if (!self.buffer.length || count > self.hearbeatMaxThreshold) {
	                        return;
	                    }
	
	                    count += 1;
	
	                    var payload = {
	                        count: count
	                    };
	
	                    var now = timestamp();
	
	                    howBusy.lastLag = now - howBusy.lastSampledTime - self.heartbeatInterval;
	                    howBusy.maxLag = howBusy.lastLag > howBusy.maxLag ? howBusy.lastLag : howBusy.maxLag;
	                    howBusy.dampendedLag = (howBusy.lastLag + howBusy.dampendedLag * 2) / 3;
	                    howBusy.lastSampledTime = now;
	
	                    payload.lastLag = howBusy.lastLag.toFixed(4);
	                    payload.maxLag = howBusy.maxLag.toFixed(4);
	                    payload.dampendedLag = howBusy.dampendedLag.toFixed(4);
	                    payload.lastSampledTime = howBusy.lastSampledTime.toFixed(4);
	
	                    if (howBusy.lastLag > 10000) {
	                        self.info('toobusy', {}, {
	                            noConsole: true,
	                            unique: true
	                        });
	                    }
	
	                    self.info('heartbeat', payload, {
	                        noConsole: true
	                    });
	                }, this.heartbeatInterval);
	            },
	
	            done: function done() {
	                this.isDone = true;
	            },
	
	            addPerformanceData: function addPerformanceData(payload) {
	
	                if (window.enablePerformance) {
	                    var performance = window.performance;
	                    var timing = window.performance.timing || {};
	                    var now = performance.now();
	
	                    if (window.clientStartTime && angular.isUndefined(payload.client_elapsed)) {
	                        payload.client_elapsed = parseInt(now - window.clientStartTime, 10);
	                    }
	
	                    if (timing.connectEnd && timing.navigationStart && angular.isUndefined(payload.req_elapsed)) {
	                        payload.req_elapsed = parseInt(now - (timing.connectEnd - timing.navigationStart), 10);
	                    }
	                }
	            },
	
	            addLocaleData: function addLocaleData(payload) {
	
	                var context = {};
	
	                try {
	                    context = $injector.get('$metaBuilder').buildContext();
	                } catch (err) {
	                    return; // Continue without adding locale data
	                }
	                if (context.locale && context.locale.country) {
	                    payload.site_cntry = context.locale.country;
	                }
	            },
	
	            /* jslint maxcomplexity: false */
	            log: function log(level, event, payload, settings) {
	
	                var self = this;
	
	                payload = payload || {};
	
	                if (angular.isArray(payload) || !angular.isObject(payload)) {
	                    payload = {
	                        payload: payload
	                    };
	                }
	                settings = settings || {};
	
	                if (settings.unique) {
	                    var hash = event + ':' + angular.toJson(payload);
	
	                    if (uniqueEvents.indexOf(hash) > -1) {
	                        return self;
	                    }
	                    uniqueEvents.push(hash);
	                }
	
	                payload.pageID = window.meta && window.meta.pageID;
	
	                this.addPerformanceData(payload);
	                this.addLocaleData(payload);
	
	                self.print(level, event, payload, settings);
	
	                if (this.buffer.length >= this.sizeLimit) {
	                    if (this.buffer.length === this.sizeLimit) {
	                        return self.enqueue('info', 'logger_max_buffer_length');
	                    }
	                    return self;
	                }
	
	                return self.enqueue(level, event, payload, settings);
	            },
	
	            getTimestamp: function getTimestamp() {
	                var now = Date.now();
	
	                return window.logOffset ? window.logOffset + now : now;
	            },
	
	            enqueue: function enqueue(level, event, payload, settings) {
	
	                payload = payload || {};
	                settings = settings || {};
	
	                var data = {
	                    level: level,
	                    event: event,
	                    timestamp: this.getTimestamp(),
	                    payload: payload
	                };
	
	                this.buffer.push(data);
	
	                // If the log level is classified as autolog, then flush the data
	                if (this.autoLog.indexOf(level) > -1) {
	                    this.flush();
	                }
	
	                return this;
	            },
	
	            shouldPrintLogsToConsole: function shouldPrintLogsToConsole(settings) {
	
	                if (settings.noConsole) {
	                    return false;
	                }
	
	                if (window.meta && window.meta.corp) {
	                    return true;
	                }
	
	                if (this.deploy.isLocal() || this.deploy.isStage()) {
	                    return true;
	                }
	
	                var cookies = window.cookies || {};
	
	                if (cookies[HERMES_DEV_COOKIE] && cookies[HERMES_DEV_COOKIE] === '1') {
	                    return true;
	                }
	
	                return false;
	            },
	
	            print: function print(level, event, payload, settings) {
	
	                if (!this.shouldPrintLogsToConsole(settings)) {
	                    return;
	                }
	
	                var args = [event];
	
	                if (payload) {
	                    args.push(payload);
	
	                    if (payload.stack || payload.error || payload.warning) {
	                        args.push('\n\n', payload.stack || payload.error || payload.warning);
	                    }
	                }
	
	                $log[$consoleLogLevel[level] || 'info'].apply($log, args);
	            },
	
	            flush: function flush(immediate) {
	                var self = this;
	
	                if (!this.buffer.length) {
	                    return $q.when();
	                }
	
	                if (immediate) {
	                    return $q.when(this._flush());
	                }
	
	                if (self.debouncer_timeout) {
	                    $timeout.cancel(self.debouncer_timeout);
	                }
	
	                self.debouncer_timeout = $timeout(function () {
	
	                    var resolver = self.debouncer_resolver;
	
	                    delete self.debouncer_promise;
	                    delete self.debouncer_resolver;
	                    delete self.debouncer_timeout;
	
	                    self._flush().then(function () {
	                        resolver();
	                    });
	                }, this.debounceInterval);
	
	                self.debouncer_promise = self.debouncer_promise || $q(function (resolver) {
	                    self.debouncer_resolver = resolver;
	                });
	
	                return self.debouncer_promise;
	            },
	
	            _flush: function _flush() {
	                var self = this;
	
	                if (!self.buffer.length) {
	                    return $q.when();
	                }
	
	                var meta = {};
	
	                try {
	                    meta = $injector.get('$metaBuilder').build();
	                } catch (err) {
	                    // @TODO - Log error
	                }
	
	                var req = this.ajax('post', $window.meta.logURL || $window.config.urls.baseUrl + this.uri, {
	                    data: {
	                        events: self.buffer
	                    },
	                    meta: meta
	                });
	
	                self.buffer = [];
	
	                return req;
	            },
	
	            ajax: function ajax(method, url, json) {
	
	                return $q(function (resolve) {
	                    var XRequest = window.XMLHttpRequest || ActiveXObject; // eslint-disable-line no-undef, block-scoped-var
	                    var req = new XRequest('MSXML2.XMLHTTP.3.0');
	                    var logAppName = $window.meta.logAppName;
	
	                    req.open(method.toUpperCase(), url);
	
	                    req.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	                    req.setRequestHeader('Content-type', 'application/json');
	
	                    if (logAppName) {
	                        req.setRequestHeader('x-app-name', logAppName);
	                    }
	
	                    req.onreadystatechange = function () {
	                        if (req.readyState > 3) {
	                            resolve();
	                        }
	                    };
	                    req.send(angular.toJson(json).replace(/&/g, '%26')); // eslint-disable-line angular/ng_json_functions
	                });
	            },
	
	            daemon: function daemon() {
	                this.stop();
	
	                var self = this;
	
	                this.timer = $interval(function () {
	                    self.flush();
	                }, this.flushInterval);
	            },
	
	            stop: function stop() {
	                if (this.timer) {
	                    $interval.cancel(this.timer);
	                }
	            }
	        });
	
	        function Logger(val) {
	            angular.extend(this, val);
	            this.init();
	        }
	
	        Logger.prototype = logger;
	        Logger.prototype.constructor = Logger;
	
	        return Logger;
	    }).factory('$logger', function ($Logger) {
	        return new $Logger();
	    }).run(function ($logger) {
	        angular.forEach(window.beaconQueue, function (payload) {
	            $logger.log(payload.level, payload.event, payload);
	        });
	
	        window.beacon = function (level, events, payload) {
	            angular.forEach(events, function (event) {
	                $logger.log(level, event, payload);
	            });
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-beaver/dist", "components/xo-beaver/dist/logger.js"))

/***/ }),

/***/ "./components/xo-beaver/dist/level.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('beaver.level', []).factory('$logLevel', function () {
	
	        return {
	            INFO: 'info',
	            DEBUG: 'debug',
	            ERROR: 'error',
	            WARN: 'warn',
	            ALERT: 'alert'
	        };
	    }).factory('$consoleLogLevel', function () {
	
	        return {
	            info: 'info',
	            debug: 'debug',
	            error: 'error',
	            warn: 'warn',
	            alert: 'info'
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-beaver/dist", "components/xo-beaver/dist/level.js"))

/***/ }),

/***/ "./pages/xo-checkout/route.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	__webpack_require__("./components/jquery/dist/jquery.min.js");
	
	__webpack_require__("./components/angular-shims-placeholder/dist/angular-shims-placeholder.min.js");
	
	__webpack_require__("./js/lib/index.js");
	
	__webpack_require__("./components/xo-tracking/dist/index.js");
	
	var _middleware = __webpack_require__("./js/lib/middleware.js");
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./js/lib/miniBrowser.js"), __webpack_require__("./pages/xo-checkout/directive.js"), __webpack_require__("./pages/xo-landing/route.js"), __webpack_require__("./pages/xo-generic-error/route.js"), __webpack_require__("./pages/xo-generic-message/route.js"), __webpack_require__("./pages/xo-end/route.js"), __webpack_require__("./pages/xo-guest/route.js"), __webpack_require__("./pages/xo-signup/route.js"), __webpack_require__("./pages/xo-add-card/route.js"), __webpack_require__("./components/xo-guest-components/src/multistep-signup/route.js"), __webpack_require__("./pages/xo-pay-upon-invoice/route.js"), __webpack_require__("./components/xo-page-components/src/done/route.js"), __webpack_require__("./components/xo-page-components/src/route-to-complete/route.js"), __webpack_require__("./components/xo-form-components/src/inventory-soldout/route.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('hermes.page.xo-checkout.route', ['squid', 'hermes.page.xo-landing.route', 'hermes.page.xo-checkout.directive', 'hermes.page.xo-generic-error.route', 'hermes.page.xo-generic-message.route', 'hermes.page.xo-end.route', 'hermes.page.xo-guest.route', 'hermes.page.xo-signup.route', 'hermes.page.xo-add-card.route', 'xo-multistep-signup.route', 'hermes.page.xo-pay-upon-invoice.route', 'xo-done', 'xo-route-to-complete']).factory('$BaseRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('CheckoutRoute', {
	
	            defaultState: 'checkout.landing',
	            middleware: _middleware.$Middleware,
	
	            name: 'checkout',
	            directive: 'xo-checkout',
	            titleContent: 'base.payPal',
	            children: [{
	                name: '$LandingRoute',
	                attributes: {
	                    'is-unbranded': 'isUnbranded'
	                }
	            }, {
	                name: '$GuestRoute',
	                attributes: {
	                    token: 'token',
	                    'is-unbranded': 'isUnbranded',
	                    'payment-method': 'paymentMethod',
	                    'button-params': 'buttonParams'
	                }
	            }, {
	                name: '$SignupRoute',
	                attributes: {
	                    token: 'token',
	                    'button-params': 'buttonParams'
	                }
	
	            }, {
	                name: '$AddCardPageRoute',
	                attributes: {
	                    token: 'token'
	                }
	
	            }, {
	                name: '$xoSoldOutPageRoute'
	            }, {
	                name: '$GenericErrorRoute'
	            }, {
	                name: '$GenericMessageRoute'
	            }, {
	                name: '$EndRoute'
	            }, {
	                name: '$MultistepSignupRoute',
	                attributes: {
	                    token: 'token',
	                    'button-params': 'buttonParams'
	                }
	            }, {
	                name: '$PayUponInvoiceRoute',
	                attributes: {
	                    token: 'token',
	                    'is-unbranded': 'isUnbranded'
	                }
	            }, {
	                name: '$DoneRoute'
	            }, {
	                name: '$RouteToCompleteRoute',
	                attributes: {
	                    token: 'token'
	                }
	            }]
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	_middleware.$Middleware;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-checkout", "pages/xo-checkout/route.js"))

/***/ }),

/***/ "./js/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./js/lib/error.js"), __webpack_require__("./js/lib/fallback.js"), __webpack_require__("./js/lib/contingency.js"), __webpack_require__("./js/lib/metaBuilder.js"), __webpack_require__("./js/lib/middleware.js"), __webpack_require__("./js/lib/miniBrowser.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular) {
	
	    angular.module('hermes.lib', ['hermes.lib.error', 'hermes.lib.fallback', 'hermes.lib.contingency', 'hermes.lib.metadata', 'hermes.lib.middleware', 'hermes.lib.minibrowser']);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "./js/lib/error.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-beaver/dist/logger.js"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/auth/index.js"), __webpack_require__("./components/xo-return-to-merchant/dist/util.js"), __webpack_require__("./js/lib/fallback.js"), __webpack_require__("./js/lib/contingency.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular) {
	
	    var ERROR_STATE;
	    var ERROR_PREVENTED;
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('hermes.lib.error', ['squid', 'beaver', 'xomodel.checkout', 'xomodel.auth', 'xo-return-to-merchant', 'hermes.lib.fallback', 'hermes.lib.contingency']).run(function ($rootScope, $exceptionHandler, $logger) {
	
	        function constructEventName(toState, fromState) {
	            var from = fromState.name.replace(/\./g, '_') || 'start';
	            var to = toState.name.replace(/\./g, '_') || 'end';
	
	            return 'state_change_' + from + '_to_' + to;
	        }
	
	        var stateChangeError = $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, err) {
	            // Set prevent default to avoid angular UI router to keep looping back to same state
	            event.preventDefault();
	            $exceptionHandler(err, constructEventName(toState, fromState));
	        });
	
	        $rootScope.$on('$destroy', stateChangeError);
	
	        var windowError = $rootScope.$on('$windowError', function (event, details) {
	            $logger.error('window_error', details, {
	                debounceFactor: details.message,
	                debounceInterval: 1000
	            });
	        });
	
	        $rootScope.$on('$destroy', windowError);
	    }).factory('$apiErrorHandler', function ($ApiError, $FallbackError, $logger) {
	        return function (err) {
	            if (err instanceof $ApiError) {
	                $logger.error('api_error', {
	                    error: err.toString()
	                });
	
	                throw new $FallbackError({
	                    reason: 'api_error',
	                    product: 'ux'
	                });
	
	                // @TODO - wtf?
	                return true; // eslint-disable-line no-unreachable
	            }
	        };
	    }).factory('$forbiddenHandler', function ($Forbidden, $logger, $AuthModel, $state, $FallbackError) {
	        return function (err) {
	            if (err instanceof $Forbidden) {
	                $logger.warn('forbidden_handler');
	                $AuthModel.instance().invalidate();
	
	                throw new $FallbackError({
	                    reason: 'user_not_logged_in',
	                    product: 'ux'
	                });
	
	                // @TODO - throw, then return? uh what?
	                return true; // eslint-disable-line no-unreachable
	            }
	        };
	    }).factory('$exceptionHandler', function ($injector) {
	
	        return function (err, cause) {
	            return $injector.invoke(function ($util, $logger, $state, $Error, $FallbackError, $fallbackErrorHandler, $contingencyHandler, $forbiddenHandler, $rootScope, $window) {
	
	                if (ERROR_STATE) {
	
	                    if (ERROR_PREVENTED) {
	                        throw err;
	                    }
	
	                    return;
	                }
	
	                // non token based Guest Upgrade Flow
	                if ($util.param('data')) {
	                    $logger.error('guest_upgrade_error', {
	                        error: err
	                    });
	                    $state.go('guestupgrade.genericError', {
	                        code: 'GUEST_UPGRADE_ERROR'
	                    });
	                    return;
	                }
	
	                var handlers = [{
	                    type: '$FallbackError',
	                    handle: $fallbackErrorHandler
	                }, {
	                    type: '$Contingency',
	                    handle: $contingencyHandler
	                }, {
	                    type: '$Forbidden',
	                    handle: $forbiddenHandler
	                }];
	
	                var handled = handlers.some(function (handler) {
	                    if (err instanceof $injector.get(handler.type)) {
	                        handler.handle(err);
	                        return true;
	                    }
	
	                    return false;
	                });
	
	                if (handled) {
	                    return;
	                } else if (!err.transient) {
	                    ERROR_STATE = err;
	                }
	
	                var errType = (err.constructor.name || 'error').toLowerCase();
	                var errName = 'ui_unhandled_' + errType;
	                var errMsg = err.message || '';
	
	                if (errMsg.indexOf('infdig') > -1) {
	                    errName = 'infinite_digest';
	                } else if (errMsg.indexOf('inprog') > -1) {
	                    errName = 'digest_inprog';
	                } else if (errMsg.indexOf('badparse') > -1) {
	                    errName = 'sanitize_badparse';
	                } else if (errMsg.match(/^[\w_]+$/) && !(err instanceof $Error)) {
	                    errName = errMsg;
	                }
	
	                if (['ui_unhandled_error', 'ui_unhandled_typeerror'].indexOf(errName) > -1) {
	                    if (err.stack && err.stack.indexOf('framework') > -1 && err.stack.indexOf('main.js') === -1) {
	                        errName = 'ui_unhandled_framework_error';
	                    }
	                }
	
	                var errObj = {
	                    error: err.stack || err.toString(),
	                    message: errMsg,
	                    cause: cause && cause.toString(),
	                    state: $state.current.name,
	                    url: $window.location.toString()
	                };
	
	                $logger.error(errName, errObj);
	
	                // emit the error object for subscribers like xo-tracking
	                var event = $rootScope.$emit('unhandled_error', {
	                    route: ($state || {}).current,
	                    message: errObj.error,
	                    code: errObj.cause,
	                    currentRoute: $state.current
	                });
	
	                if (event.defaultPrevented) {
	                    ERROR_PREVENTED = true;
	                    throw err;
	                } else if (!err.transient) {
	                    return $fallbackErrorHandler(new $FallbackError({
	                        reason: errName
	                    }));
	                }
	            });
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "js/lib", "js/lib/error.js"))

/***/ }),

/***/ "./components/squid/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _ng = __webpack_require__("./components/squid/dist/ng/index.js");
	
	Object.keys(_ng).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ng[key];
	    }
	  });
	});
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	Object.keys(_core).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _core[key];
	    }
	  });
	});
	
	var _locale = __webpack_require__("./components/squid/dist/locale/index.js");
	
	Object.keys(_locale).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _locale[key];
	    }
	  });
	});
	
	var _paypal = __webpack_require__("./components/squid/dist/paypal/index.js");
	
	Object.keys(_paypal).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _paypal[key];
	    }
	  });
	});

/***/ }),

/***/ "./components/squid/dist/ng/index.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _core = __webpack_require__("./components/squid/dist/ng/core.js");
	
	Object.keys(_core).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _core[key];
	    }
	  });
	});
	
	var _route = __webpack_require__("./components/squid/dist/ng/route.js");
	
	Object.keys(_route).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _route[key];
	    }
	  });
	});
	
	var _component = __webpack_require__("./components/squid/dist/ng/component.js");
	
	Object.keys(_component).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _component[key];
	    }
	  });
	});
	
	var _feature = __webpack_require__("./components/squid/dist/ng/feature.js");
	
	Object.keys(_feature).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _feature[key];
	    }
	  });
	});
	
	var _locale = __webpack_require__("./components/squid/dist/ng/locale.js");
	
	Object.keys(_locale).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _locale[key];
	    }
	  });
	});
	
	var _module = __webpack_require__("./components/squid/dist/ng/module.js");
	
	Object.keys(_module).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _module[key];
	    }
	  });
	});
	
	var _ng = __webpack_require__("./components/squid/dist/ng/ng.js");
	
	Object.keys(_ng).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ng[key];
	    }
	  });
	});
	
	var _directive = __webpack_require__("./components/squid/dist/ng/directive.js");
	
	Object.keys(_directive).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _directive[key];
	    }
	  });
	});
	
	var _events = __webpack_require__("./components/squid/dist/ng/events.js");
	
	Object.keys(_events).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _events[key];
	    }
	  });
	});
	
	var _pxp = __webpack_require__("./components/squid/dist/ng/pxp.js");
	
	Object.keys(_pxp).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _pxp[key];
	    }
	  });
	});

/***/ }),

/***/ "./components/squid/dist/ng/core.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	_core.$event.use({
	    on: function on() {
	        return _angular.$rootScope.$on.apply(_angular.$rootScope, arguments);
	    },
	    once: function once(name, handler) {
	        var cancel = _core.$event.on(name, function () {
	            cancel();
	            handler.apply(this, arguments);
	        }, true);
	
	        return cancel;
	    },
	    emit: function emit() {
	        return _angular.$rootScope.$emit.apply(_angular.$rootScope, arguments);
	    },
	    broadcast: function broadcast() {
	        return _angular.$rootScope.$broadcast.apply(_angular.$rootScope, arguments);
	    }
	});
	
	_core.$promise.use(_angular.$q);
	
	_angular.$q;
	
	_angular.$rootScope;
	
	_core.$event;
	
	_core.$promise;

/***/ }),

/***/ "./components/squid/dist/core/index.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _api = __webpack_require__("./components/squid/dist/core/api.js");
	
	Object.keys(_api).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _api[key];
	    }
	  });
	});
	
	var _class = __webpack_require__("./components/squid/dist/core/class.js");
	
	Object.keys(_class).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _class[key];
	    }
	  });
	});
	
	var _config = __webpack_require__("./components/squid/dist/core/config.js");
	
	Object.keys(_config).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _config[key];
	    }
	  });
	});
	
	var _error = __webpack_require__("./components/squid/dist/core/error.js");
	
	Object.keys(_error).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _error[key];
	    }
	  });
	});
	
	var _event = __webpack_require__("./components/squid/dist/core/event.js");
	
	Object.keys(_event).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _event[key];
	    }
	  });
	});
	
	var _integration = __webpack_require__("./components/squid/dist/core/integration.js");
	
	Object.keys(_integration).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _integration[key];
	    }
	  });
	});
	
	var _model = __webpack_require__("./components/squid/dist/core/model.js");
	
	Object.keys(_model).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _model[key];
	    }
	  });
	});
	
	var _promise = __webpack_require__("./components/squid/dist/core/promise.js");
	
	Object.keys(_promise).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _promise[key];
	    }
	  });
	});
	
	var _util = __webpack_require__("./components/squid/dist/core/util.js");
	
	Object.keys(_util).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _util[key];
	    }
	  });
	});
	
	var _loader = __webpack_require__("./components/squid/dist/core/loader.js");
	
	Object.keys(_loader).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _loader[key];
	    }
	  });
	});
	
	var _dom = __webpack_require__("./components/squid/dist/core/dom.js");
	
	Object.keys(_dom).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _dom[key];
	    }
	  });
	});

/***/ }),

/***/ "./components/squid/dist/core/api.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$Api = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.$getLatestCorrelationID = $getLatestCorrelationID;
	
	var _jquery = __webpack_require__("./components/jquery/dist/jquery.min.js");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _event = __webpack_require__("./components/squid/dist/core/event.js");
	
	var _class = __webpack_require__("./components/squid/dist/core/class.js");
	
	var _util = __webpack_require__("./components/squid/dist/core/util.js");
	
	var _promise = __webpack_require__("./components/squid/dist/core/promise.js");
	
	var _config = __webpack_require__("./components/squid/dist/core/config.js");
	
	var _error = __webpack_require__("./components/squid/dist/core/error.js");
	
	var _loader = __webpack_require__("./components/squid/dist/core/loader.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	 API
	 ---
	
	 This layer is responsible for handling api requests. It has a number of responsibilities:
	
	 - Caching responses
	 - Transparently returning data that has been preloaded into the initial page response
	 - Instrumentation
	 - Batching multiple api calls into a single http request
	 - Handling multiple types of responses and dispatching to the correct handlers
	 - Emitting loading events for all http calls
	 */
	
	_config.$meta.headers = _config.$meta.headers || {};
	_config.$meta.headers['x-cookies'] = _typeof(_config.$meta.headers['x-cookies']) !== 'object' ? JSON.parse(_config.$meta.headers['x-cookies'] || '{}') : _config.$meta.headers['x-cookies'];
	
	// Are we in 'cookies disabled' mode? (Do we need to keep a local store of cookies)
	function cookiesEnabled() {
	    return _util.$util.cookiesEnabled() && window.location.hostname.indexOf('.paypal.com') > -1;
	}
	
	// Cache for api responses, when cache: true
	var cache = {};
	
	var latestCorrelationID = _config.$meta.correlationId;
	
	// Window load promise
	var windowLoad = _util.$util.memoize(function () {
	    return _promise.$promise.resolver(function (resolve) {
	        if (document.readyState === 'complete') {
	            resolve();
	        } else {
	            window.addEventListener('load', resolve);
	        }
	    });
	});
	
	// Buffer for batch requests made within the same frame
	var batchQueue = {};
	
	// Backwards compat
	window.pre = {};
	
	// Transient cache resolvers
	var transientCache = {};
	
	// Transient cache resolvers
	var transientCacheResolvers = {};
	
	// Metabuilder
	var metaBuilder = void 0;
	
	// Add to transientCache
	window.preload = function (method, url, data, name) {
	
	    if (name) {
	        window.pre[name] = {
	            method: method,
	            uri: url,
	            res: data
	        };
	    }
	
	    var key = method + ':' + url;
	    var resolvers = transientCacheResolvers[key] || [];
	
	    transientCache[key] = data;
	
	    while (resolvers.length) {
	        resolvers.pop().call();
	    }
	};
	
	// Preload complete
	var preloadComplete = false;
	
	window.preloadComplete = function () {
	    preloadComplete = true;
	    Object.keys(transientCacheResolvers).forEach(function (key) {
	        var resolvers = transientCacheResolvers[key] || [];
	
	        while (resolvers.length) {
	            resolvers.pop().call();
	        }
	    });
	};
	
	_logger.$logger.info(cookiesEnabled() ? 'cookies_enabled' : 'cookies_disabled');
	
	var $Api = exports.$Api = _class.$Class.extend('$Api', {
	
	    // Cache any GET responses indefinitely
	    cache: false,
	
	    // Http timeout for all requests
	    timeout: 45000,
	
	    // Default number of attempts on aborted requests and 500 server errors
	    getAttempts: 3,
	    postAttempts: 1,
	
	    // POST on a resource with an action name myapi.action('foo') -> POST /my/api/foo
	    action: function action(_action, options) {
	        options.action = _action;
	        return this.post(options);
	    },
	
	    // GET on a resource myapi.retrieve() -> GET /my/api
	    retrieve: function retrieve(options) {
	        options.method = 'get';
	        return this.call(options);
	    },
	
	    // POST on a resource myapi.retrieve() -> POST /my/api
	    post: function post(options) {
	        options.method = 'post';
	        return this.call(options);
	    },
	
	    // Generic handler for calling an api and dispatching requests to the right place
	    call: function call(options) {
	        var self = this;
	
	        // Set up request options and params. `options` is an object which should contain everything
	        // the request needs to run and handle the response
	
	        options.api = this;
	        options.uri = this.getURI(options.model, options.action);
	        options.params = options.params || {};
	        options.cache = options.cache || self.cache && options.method === 'get';
	        options.name = this.buildAPIName(options);
	        options.meta = this.buildMeta();
	        options.transientError = options.transientError || false;
	        options.cacheKey = _util.$util.buildURL(options.uri, options.params);
	
	        _logger.$logger.info(options.name + '_call', {
	            name: options.name,
	            method: options.method,
	            uri: options.uri
	        });
	
	        if (!options.silent) {
	            _event.$event.emit('loading');
	        }
	
	        // Decide where to get the response
	        return _promise.$promise.first([
	
	        // If caching is enabled and we have the data in local cache, use the cache
	        function () {
	            if (options.cache && cache[options.cacheKey]) {
	                return cache[options.cacheKey];
	            }
	        },
	
	        // Otherwise if we have transient cache data for this api, we can use that
	        function () {
	            return _promise.$promise.providing(self.hasTransientCacheData(options), function () {
	
	                // The reason we use self.attemptRequest here is so any errors in the cached response
	                // can trigger the retry code path, as if it were a regular request
	                return self.attemptRequest(options);
	            });
	        },
	
	        // If we're in batch mode, queue up a batch request
	        function () {
	            if (options.batch) {
	                return self.batchRequest(options);
	            }
	        },
	
	        // Otherwise attempt a regular http request (at this point an http call is guaranteed)
	        function () {
	            return self.attemptRequest(options);
	        }])['finally'](function () {
	
	            if (!options.silent) {
	                _event.$event.emit('loaded');
	            }
	        }).then(function (res) {
	
	            // Cache the response if we need to
	            if (options.cache) {
	                cache[options.cacheKey] = res;
	            }
	
	            // Handle the response
	            return self.handleResponse(res.data, options);
	        }, function (err) {
	
	            // $BatchShortCircuit will be thrown if:
	            //
	            // 1. batch api call B depends on api call A, but-
	            // 2. api call A fails
	            //
	            // In which case we end up in a situation where had it been a regular chain of events,
	            // api B would never have been called in the first place.
	            //
	            // One possibility here is to return $unresolved, which prevents the promise from ever
	            // resolving, but this has the potential to cause a lot of difficulty debugging and strange
	            // corner cases.
	            //
	            // Instead we opt to simply reject the promise, and not call any of the response handlers
	
	            if (err instanceof _error.$BatchShortCircuit) {
	                return _promise.$promise.reject(err);
	            }
	
	            // Otherwise, handle the error normally
	            return self.handleErrorResponse(err, options);
	        });
	    },
	
	    // Set up a batch request for processing in the next frame
	    batchRequest: function batchRequest(options) {
	
	        // Batch Requests are an optimization layer on top of regular api calls. The purpose of this
	        // layer is to combine multiple atomic api calls into a single http request, without forcing
	        // developers to create large orchestration layers on the client/server with cross-cutting concerns.
	        //
	        // This layer will queue up multiple requests made in the same frame whenever batch-mode is enabled,
	        // attach them all to an http call to /api/batch/:name, then on the response it will dispatch each
	        // individual api call to the correct handler.
	        //
	        // The way this is implemented is to place each response in the transient api cache, then to yield
	        // control to the regular api request handler, which will handle instrumentation and retries
	
	        // For quick dev-time feedback...
	        _util.$util.assert(options.batch.name, 'Must define a "name" for batch request: ' + options.batch);
	        _util.$util.assert(options.batch.id, 'Must define a "id" for batch request: ' + options.batch);
	
	        var name = options.batch.name;
	        var id = options.batch.id;
	
	        // Add the batch request options to the batchQueue for processing on the next frame
	        var batch = batchQueue[name] = batchQueue[name] || {};
	
	        batch[id] = options;
	
	        // Fire off a batch request. This will be debounced: calls in the same frame will be combined to one
	        return this.buildBatchRequest(name).then(function (results) {
	
	            // We get back a mapping of id->response, so we now extract the response for our api
	            // call. If we have no response, we can assume the call was never made, and short circuit.
	            return results[id].then(function (result) {
	                return result || _promise.$promise.reject(new _error.$BatchShortCircuit());
	            });
	        });
	    },
	
	    // Process all of the accumulated batch api requests
	    buildBatchRequest: _promise.$promise.debounce(function (name) {
	
	        var self = this;
	        var batch = batchQueue[name];
	        var batchIds = _class.$Class.keys(batch);
	        var batchData = {};
	        var headers = {};
	
	        delete batchQueue[name];
	
	        // If we have just a single request, we can short-circuit and just hit that api
	
	        if (batchIds.length === 1) {
	
	            var batchId = batchIds[0];
	            var opts = batch[batchId];
	
	            var results = {};
	
	            results[batchId] = opts.api.attemptRequest(opts);
	            return results;
	        }
	
	        // Build the request to send to the server side. This is an mapping of id->request, each containing
	        // the method, uri, data, and dependencies for each api.
	        //
	        // Specifying a dependency for an api essentially means the back-end will only
	        // call api-B if api-A returns ack=success. Otherwise there will be no response for api B.
	
	        _util.$util.forEach(batch, function (options, id) {
	
	            batchData[id] = {
	                method: options.method,
	                uri: options.api.getURI(options.model, options.action, true),
	                data: options.data,
	                params: options.params,
	                dependencies: options.batch.dependencies
	            };
	
	            _util.$util.extend(headers, options.headers);
	        });
	
	        // Unfortunate circular dependency... $Api depends on another api.
	        //
	        // $batchApi is subject to all of the same rules regarding retries, so if for some reason the server
	        // does not respond the first time, our batch request can still get through.
	
	        return $batchApi.action(name, {
	            data: batchData,
	            headers: headers
	        }).then(function (res) {
	
	            // The final response will be a mapping of id->response-promise.
	            //
	            // However, we do not treat this data as our final response. Instead, we simply use it to
	            // prime our transient cache, then proceed to jump to our regular request handler. This will
	            // take care of retries and instrumentation as if this were a regular request.
	            //
	            // Note that a retry for $batchApi is different to a retry for an individual api. If
	            // an *individual* api call fails, we do not want to re-do the entire batch call; instead we
	            // can just retry the individual api call.
	
	            return self.handleBatchResponse(batch, res.data);
	        });
	    }),
	
	    // Process the responses for all of the batch requests we sent to the server
	    handleBatchResponse: function handleBatchResponse(batch, data) {
	
	        var self = this;
	
	        var promises = {};
	
	        // Loop over each individual api response contained in the batch response, and process the result
	
	        _util.$util.forEach(batch, function (options, id) {
	
	            // Store each response promise so we can check and wait for api dependencies
	
	            promises[id] = _promise.$promise.run(function () {
	
	                // Check if all of the dependencies are present for our individual api call. To do this
	                // we must wait until the dependent api call is entirely complete, including any retries.
	
	                var depsPresent = _promise.$promise.every(options.batch.dependencies || [], function (depName) {
	
	                    if (!batch[depName]) {
	                        _logger.$logger.info('missing_batch_dependency', {
	                            dependency: depName,
	                            available: Object.keys(batch).join('|')
	                        });
	                    }
	
	                    return !batch[depName] || promises[depName].then(function (dependency) {
	                        return dependency && dependency.data && dependency.data.ack === 'success';
	                    });
	                });
	
	                // If our dependencies are present, we can continue, otherwise we are not interested in
	                // the result of the individual api call - if its dependency is not present, it will not be.
	
	                return _promise.$promise.providing(depsPresent, function () {
	
	                    // If there is data returned for the individual call, add it to the transient cache
	
	                    return _promise.$promise.providing(data[id], function (result) {
	                        var uri = options.api.getURI(options.model, options.action);
	                        uri = _util.$util.buildURL(uri, options.params);
	
	                        self.addTransientCacheData(options.method, uri, result);
	                    }).then(function () {
	
	                        // Regardless of whether or not there is data, we can now attempt the request.
	                        // This will either get the data from the transient cache, or make an http call,
	                        // and handle any retries that need to be made.
	
	                        return options.api.attemptRequest(options);
	                    });
	                });
	            });
	        });
	
	        return promises;
	    },
	
	    // Handle the request and any retries, using either the transient cache or http calls
	    attemptRequest: function attemptRequest(options) {
	        var self = this;
	
	        var attempts = options.method === 'get' ? this.getAttempts : this.postAttempts;
	
	        // We allow a certain number of attempts/retries for each api call
	        return _promise.$promise.attempt(attempts, function (remaining) {
	
	            // Query the transient cache
	            return self.getTransientCacheResponse(options).then(function (res) {
	
	                // If we can get a response from the transient cache, then use it
	                if (res) {
	                    return res;
	                }
	
	                // Otherwise resort to making an http call
	                return self.getHttpResponse(options);
	            })['catch'](function (res) {
	
	                // If our request was aborted without even a status code, force a single retry
	                if ((!res || !res.status) && attempts === 1) {
	
	                    _logger.$logger.warn('api_retry_aborted', {
	                        method: options.method,
	                        uri: options.uri
	                    });
	
	                    return self.getHttpResponse(options);
	                }
	
	                return _promise.$promise.reject(res);
	            })['catch'](function (res) {
	
	                // If our request was 401 denied (probably due to a CSRF error), force a single retry
	                if (res.status === 401) {
	
	                    _logger.$logger.warn('api_retry_401', {
	                        method: options.method,
	                        uri: options.uri
	                    });
	
	                    return self.getHttpResponse(options);
	                }
	
	                return _promise.$promise.reject(res);
	            })['catch'](function (res) {
	
	                // Set the correct response and ack for 401
	                if (res.status === 401) {
	                    return {
	                        data: {
	                            ack: 'permission_denied'
	                        }
	                    };
	                }
	
	                // If we have any remaining retries, log and reject
	                if (remaining) {
	
	                    _logger.$logger.warn('api_retry', {
	                        method: options.method,
	                        uri: options.uri
	                    });
	
	                    return _promise.$promise.reject(res);
	                }
	
	                // Otherwise reject the request with the appropriate error
	
	                // We got ack=error in the response
	                if (res && res.data && res.data.ack === 'error') {
	                    return _promise.$promise.reject(new _error.$ApiError('api_error', { // eslint-disable-line no-reserved-keys
	                        name: options.name,
	                        method: options.method,
	                        uri: options.uri,
	                        stack: res.data.stack,
	                        transient: options.transientError
	                    }));
	                }
	
	                // We got a response error status
	                else if (res && res.status) {
	                        return _promise.$promise.reject(new _error.$ApiError('response_status_' + res.status, { // eslint-disable-line no-reserved-keys
	                            uri: options.uri,
	                            transient: options.transientError
	                        }));
	                    } else if (res && res.error) {
	                        return _promise.$promise.reject(new _error.$ApiError('request_' + res.error, { // eslint-disable-line no-reserved-keys
	                            uri: options.uri,
	                            transient: options.transientError
	                        }));
	                    }
	
	                    // The request was aborted
	                    else {
	                            return _promise.$promise.reject(new _error.$ApiError('request_aborted', { // eslint-disable-line no-reserved-keys
	                                uri: options.uri,
	                                transient: options.transientError
	                            }));
	                        }
	            });
	        });
	    },
	
	    // Get an api response via http
	    getHttpResponse: function getHttpResponse(options) {
	        var self = this;
	
	        var startTime = _util.$util.now();
	
	        var request = this.http(options);
	
	        return request['finally'](function () {
	
	            // Calculate the end-to-end duration of the request from the client's perspective
	            options.duration = _util.$util.now() - startTime;
	        })['catch'](function (res) {
	
	            // Turn responses with an ack into a 'success' so it makes it to the standard handlers
	            if (res && res.status && res.data && res.data.ack && res.data.ack !== 'error') {
	                return res;
	            }
	
	            return _promise.$promise.reject(res);
	        }).then(function (res) {
	            self.saveResponseState(res);
	
	            var loggerPayload = {
	                name: options.name,
	                method: options.method,
	                uri: options.uri,
	                server: res.data.server,
	                time: options.duration,
	                duration: options.duration,
	                corrid: res && res.headers('Paypal-Debug-Id')
	            };
	
	            // In certain browsers we can match up this api call to the performance data from the browser
	            if (window.performance && window.performance.getEntries) {
	                _util.$util.forEach(window.performance.getEntries(), function (resource) {
	                    if (resource.name && resource.name.indexOf(options.uri) > -1) {
	                        _util.$util.extend(loggerPayload, resource);
	                    }
	                });
	            }
	
	            _logger.$logger.info('api_response', loggerPayload);
	
	            if (res && res.status) {
	                _logger.$logger.info('http_response_' + res.status);
	            }
	
	            return res;
	        }, function (res) {
	            self.saveResponseState(res);
	
	            if (res && res.status) {
	                _logger.$logger.info('http_response_' + res.status);
	            }
	
	            return _promise.$promise.reject(res);
	        });
	    },
	
	    setTransientCache: function setTransientCache(data) {
	        throw new Error('NotImplemented');
	    },
	
	    // Get an individual api response from the transient cache, as an object
	    getTransientCacheData: function getTransientCacheData(options, pop) {
	
	        if (!_config.$config.enablePreload) {
	            return _promise.$promise.resolve();
	        }
	
	        var preMethod = options.method.toLowerCase();
	        var preUri = _util.$util.buildURL(options.uri, options.params);
	
	        var key = preMethod + ':' + preUri;
	
	        return _promise.$promise.resolver(function (resolve) {
	
	            function res() {
	                var data = transientCache[key];
	
	                if (pop) {
	                    delete transientCache[key];
	                }
	                resolve(data);
	            }
	
	            if (transientCache[key] || document.readyState === 'complete' || preloadComplete) {
	                return res();
	            }
	
	            transientCacheResolvers[key] = transientCacheResolvers[key] || [];
	            transientCacheResolvers[key].push(res);
	
	            windowLoad().then(res);
	        });
	    },
	
	    // Check if the transient cache has the data for a particular api
	    hasTransientCacheData: function hasTransientCacheData(options) {
	        return this.getTransientCacheData(options, false).then(function (data) {
	            return Boolean(data);
	        });
	    },
	
	    // Add data to the transient cache
	    addTransientCacheData: function addTransientCacheData(method, uri, data) {
	        var key = method + ':' + uri;
	        transientCache[key] = data;
	    },
	
	    // Get an individual api response from transient cache, as a res promise with the correct status code
	    getTransientCacheResponse: function getTransientCacheResponse(options) {
	
	        return this.getTransientCacheData(options, true).then(function (data) {
	
	            // Preload data does not come with a response code, so massage it into a response promise
	            if (data) {
	                if (data.ack === 'error') {
	                    return _promise.$promise.reject({
	                        status: 500,
	                        data: data
	                    });
	                } else if (data.ack === 'permission_denied') {
	                    return _promise.$promise.reject({
	                        status: 401,
	                        data: data
	                    });
	                } else if (data.ack === 'contingency' || data.ack === 'validation_error') {
	                    return {
	                        status: 400,
	                        data: data
	                    };
	                } else {
	                    return {
	                        status: 200,
	                        data: data
	                    };
	                }
	            }
	
	            // Log a cache miss if we are currently in the first-page load
	            else if (options.method === 'get' && !_loader.$loader.firstLoad() && !options.silent) {
	                    _logger.$logger.info('preload_cache_miss', {
	                        uri: options.uri
	                    });
	                }
	        });
	    },
	
	    getHeaders: function getHeaders(options) {
	
	        if (!_config.$meta.headers['x-csrf-jwt'] && !_config.$meta.csrfJwt) {
	            _logger.$logger.warn('missing_csrf_jwt');
	        }
	
	        var headers = {
	            'X-Requested-With': 'XMLHttpRequest',
	            'x-csrf-jwt': _config.$meta.headers['x-csrf-jwt'] || _config.$meta.csrfJwt
	        };
	
	        if (!cookiesEnabled()) {
	            headers['x-cookies'] = JSON.stringify(_config.$meta.headers['x-cookies']);
	        }
	
	        if (options.headers) {
	            _util.$util.extend(headers, options.headers);
	        }
	
	        return headers;
	    },
	    http: function http(options) {
	        return this.httpJQuery(options);
	    },
	
	
	    /*
	     // Raw http call
	    httpAngular: function(options) {
	         let request = {
	            method: options.method,
	            url: options.uri,
	            data: {
	                data: options.data,
	                meta: options.meta
	            },
	            headers: this.getHeaders(options),
	            params: options.params,
	            requestType: 'json',
	            responseType: 'json',
	            timeout: this.timeout
	        };
	         if (options.method === 'get' && options.meta && Object.keys(options.meta).length) {
	            request.params.meta = JSON.stringify(options.meta);
	        }
	         return $http(request);
	    },
	     */
	
	    httpJQuery: function httpJQuery(options) {
	
	        var request = {
	            method: options.method,
	            data: options.method === 'get' ? options.params : JSON.stringify({
	                data: options.data,
	                meta: options.meta || {}
	            }),
	            headers: this.getHeaders(options),
	            timeout: this.timeout
	        };
	
	        if (options.method === 'post') {
	            request.headers['Content-Type'] = 'application/json;charset=UTF-8';
	        } else if (options.method === 'get') {
	            request.data.meta = JSON.stringify(options.meta);
	        }
	
	        return _promise.$promise.resolver(function (resolve, reject) {
	
	            function getRes(res, data) {
	                return {
	                    status: res.status,
	                    data: data,
	                    headers: function headers(name) {
	                        return res.getResponseHeader(name);
	                    }
	                };
	            }
	
	            request.success = function (data, status, res) {
	                return resolve(getRes(res, data));
	            };
	
	            request.error = function (res) {
	                if (res && res.status) {
	                    if (res.status >= 400) {
	                        return reject(getRes(res, res.responseJSON));
	                    } else {
	                        return resolve(getRes(res, res.responseJSON));
	                    }
	                }
	
	                return reject({
	                    status: 0,
	                    headers: _util.$util.noop,
	                    error: res && res.statusText
	                });
	            };
	
	            _jquery2['default'].ajax(options.uri, request);
	        });
	    },
	
	    // Save cookies and jwt-csrf token from the response
	    saveResponseState: function saveResponseState(res) {
	
	        if (res.headers('x-csrf-jwt')) {
	            _config.$meta.headers['x-csrf-jwt'] = res.headers('x-csrf-jwt');
	            _config.$meta.csrfJwt = res.headers('x-csrf-jwt');
	            _config.$meta.headers['x-csrf-jwt-hash'] = res.headers('x-csrf-jwt-hash');
	        }
	
	        if (res.headers('X-cookies')) {
	
	            _config.$meta.headers['x-cookies-hash'] = res.headers('x-cookies-hash');
	
	            // Extend local cookie jar of encrypted-cookie-name->encrypted-cookie-value with any new cookies
	            _util.$util.extend(_config.$meta.headers['x-cookies'], JSON.parse(res.headers('X-cookies') || '{}'));
	        }
	
	        latestCorrelationID = res.headers('Paypal-Debug-Id') || latestCorrelationID;
	    },
	
	    // Dispatch the response to the correct handlers
	    handleResponse: function handleResponse(res, options) {
	        var loggerName = 'ui_' + options.name;
	
	        var loggerPayload = {
	            name: options.name,
	            method: options.method,
	            uri: options.uri,
	            time: options.duration,
	            duration: options.duration
	        };
	
	        // Here we dispatch the response to the correct handler based on the ack.
	        //
	        // ack=success     -> options.success()
	        // ack=error       -> options.error()
	        // ack=validation  -> options.validation()
	        // ack=contingency -> options.contingencies[contingency]()
	        //
	        // Why do this rather than just rejecting the promise with a custom error?
	        //
	        // a) Angular promises have no `.catchType()`, so this saves us a lot of `instanceof` checks
	        // b) Angular promises have no `.done()`, so callers can not assert that they have handled
	        //    every error they want to. This is exacerbated by the fact that there is no single thread
	        //    of execution on the front-end a la node, so we can't just call `.done()` at the very end :(
	        //
	        // This way, if somebody passes a handler, it will be called. Otherwise, an error will be thrown
	        // and the global error handler will be invoked. The api responses are also given as promises.
	
	        var resultModel = options.resultModel || options.model;
	
	        /* jshint maxcomplexity: 17 */
	        return _promise.$promise.call(function () {
	
	            // If we are given a `resultModel`, we always extend it with `res.data`, no matter the ack
	
	            if (res.data && resultModel) {
	
	                if (resultModel.populate) {
	                    resultModel.populate(res.data);
	                } else {
	                    _util.$util.extend(resultModel, res.data);
	                }
	            }
	
	            if (res && res.ack === 'success' && resultModel && resultModel.fetchChildren) {
	                return _promise.$promise.resolve(resultModel.fetchChildren()).then(function (children) {
	                    return _util.$util.extend(resultModel, children);
	                });
	            }
	        }).then(function () {
	
	            // Handle each ack type, throw errors accordingly
	
	            if (res.ack === 'success') {
	                _logger.$logger.info(loggerName + '_success', loggerPayload);
	
	                if (options.success) {
	                    if (options.success instanceof Function) {
	                        return options.success(res.data);
	                    }
	                    return options.success;
	                }
	
	                return res;
	            }
	
	            if (options.failSilently) {
	                return;
	            }
	
	            if (res.ack === 'contingency') {
	                _logger.$logger.info(loggerName + '_contingency', _util.$util.extend(loggerPayload, {
	                    contingency: res.contingency
	                }));
	
	                if (!res.contingency) {
	                    throw new _error.$ApiError('expected_contingency_name', {
	                        api: options.name
	                    });
	                }
	
	                var contingency = new _error.$Contingency(res.contingency, { // eslint-disable-line no-reserved-keys
	                    transient: options.transientError
	                });
	
	                if (resultModel) {
	                    resultModel.errorData = res.errorData || {};
	                }
	
	                var handler = options.contingencies && (options.contingencies[contingency.message] || options.contingencies['DEFAULT']);
	
	                _util.$util.extend(contingency, res.errorData);
	
	                if (handler) {
	                    if (handler instanceof Function) {
	                        return handler(contingency.message, contingency);
	                    }
	                    return handler;
	                }
	
	                throw contingency;
	            } else if (res.ack === 'validation') {
	                _logger.$logger.info(loggerName + '_validation', _util.$util.extend(loggerPayload, {
	                    validation: res.validation
	                }));
	
	                if (options.validation) {
	                    return options.validation(res.validation);
	                }
	
	                throw new _error.$ApiError('validation', { // eslint-disable-line no-reserved-keys
	                    transient: options.transientError
	                });
	            } else if (res.ack === 'permission_denied') {
	                _logger.$logger.info(loggerName + '_denied', loggerPayload);
	
	                throw new _error.$Forbidden(options.uri + ': forbidden', { // eslint-disable-line no-reserved-keys
	                    transient: options.transientError
	                });
	            } else {
	                _logger.$logger.info(loggerName + '_noack', loggerPayload);
	
	                throw new _error.$ApiError('noack', { // eslint-disable-line no-reserved-keys
	                    transient: options.transientError
	                });
	            }
	        });
	    },
	
	    // Handle http error responses (ack=error or unhandled errors)
	    handleErrorResponse: function handleErrorResponse(err, options) {
	
	        return _promise.$promise.run(function () {
	
	            // If the caller provides an error handler, let them handle it
	            if (options.error) {
	                return options.error(err);
	            }
	
	            // Otherwise we throw the error. Please not that this is NOT just rejecting the promise,
	            // this will always end up in the global error handler due to how angular promises work.
	            throw err;
	        });
	    },
	
	    // Build the uri for the api call
	    getURI: function getURI(model, action, relative) {
	        var self = this;
	
	        // build the uri as a seriest of segments
	        var uri = [];
	
	        uri.push(this.uri.replace(/\/:[\w\.]+\?/g, function (key) {
	
	            // Add any *optional* dynamic keys from the model (/foo/:bar? -> /foo/{{model.bar}})
	
	            key = key.slice(2);
	            key = key.substring(0, key.length - 1);
	
	            var component = model.get ? model.get(key) : model[key];
	
	            if (!component) {
	                return '';
	            }
	
	            return '/' + component;
	        }).replace(/:[\w\.]+/g, function (key) {
	
	            // Add any dynamic keys from the model (/foo/:bar -> /foo/{{model.bar}})
	
	            key = key.slice(1);
	
	            var component = model.get ? model.get(key) : model[key];
	
	            if (!component) {
	                throw new Error('Property "' + key + '" not found in model for: ' + self.uri);
	            }
	
	            return component;
	        }));
	
	        // Add the action, if provided (`foo.action('bar', {...})` -> /api/foo/bar
	        if (action) {
	            uri.push(action);
	        }
	
	        // Add the extension (e.g. for doing a GET on a .json resource)
	        if (this.ext) {
	            uri[uri.length - 1] += '.' + this.ext;
	        }
	
	        // Join the uri segments and strip any extra slashes
	        uri = '/' + uri.join('/').replace(/\/{2,}/g, '/').replace(/^\//, '');
	
	        // Add on the base uri, e.g. /webapps/hermes
	        if (!relative) {
	            uri = (this.baseURI || _config.$config.urls.baseUrl) + uri;
	        }
	
	        return uri;
	    },
	
	    // Attach meta data provided by the parent app
	    buildMeta: function buildMeta() {
	        if (metaBuilder) {
	            return metaBuilder();
	        }
	    },
	
	    // Build the name of the api for logging. /api/foo/bar -> api_foo_bar
	    buildAPIName: function buildAPIName(options) {
	        var self = this;
	        var apiName = self.uri.replace(/^\/+/, ''). // Remove leading '/'
	        replace(/\//g, '_'). // Replace remaining '/' with '_'
	        replace(/\?(.*)/, ''). // Remove everything after '?'
	        replace(/[^a-zA-Z0-9_]/g, '');
	
	        apiName = options.action ? apiName + '_' + options.action : apiName;
	        apiName = apiName.charAt(0) === '_' ? apiName.slice(1) : apiName;
	        return apiName;
	    }
	});
	
	$Api.reopenClass({
	    clearCache: function clearCache() {
	        cache = {};
	    }
	});
	
	$Api.registerMetaBuilder = function (builder) {
	    metaBuilder = builder;
	};
	
	var $batchApi = new $Api({
	    uri: '/api/batch',
	    postAttempts: 3
	});
	
	function $getLatestCorrelationID() {
	    return latestCorrelationID;
	}
	
	angular.value("$Api", $Api);
	angular.value("$getLatestCorrelationID", $getLatestCorrelationID);
	_logger.$logger;
	
	_event.$event;
	
	_class.$Class;
	
	_util.$util;
	
	_promise.$promise;
	
	_config.$config;
	
	_config.$meta;
	
	_error.$Contingency;
	
	_error.$Forbidden;
	
	_error.$ApiError;
	
	_error.$BatchShortCircuit;
	
	_loader.$loader;

/***/ }),

/***/ "./components/squid/dist/core/event.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$event = undefined;
	
	var _promise = __webpack_require__("./components/squid/dist/core/promise.js");
	
	var handlers = {};
	
	var customEventEmitter = void 0;
	
	var $event = exports.$event = {
	    use: function use(eventEmitter) {
	        customEventEmitter = eventEmitter;
	
	        for (var _iterator = Object.keys(handlers), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	            var _ref;
	
	            if (_isArray) {
	                if (_i >= _iterator.length) break;
	                _ref = _iterator[_i++];
	            } else {
	                _i = _iterator.next();
	                if (_i.done) break;
	                _ref = _i.value;
	            }
	
	            var eventName = _ref;
	
	            if (handlers[eventName]) {
	                for (var _iterator2 = handlers[eventName], _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
	                    var _ref2;
	
	                    if (_isArray2) {
	                        if (_i2 >= _iterator2.length) break;
	                        _ref2 = _iterator2[_i2++];
	                    } else {
	                        _i2 = _iterator2.next();
	                        if (_i2.done) break;
	                        _ref2 = _i2.value;
	                    }
	
	                    var handler = _ref2;
	
	                    customEventEmitter.on(eventName, handler);
	                }
	            }
	        }
	    },
	    on: function on(eventName, method) {
	
	        if (customEventEmitter) {
	            return customEventEmitter.on(eventName, method);
	        }
	
	        handlers[eventName] = handlers[eventName] || [];
	        handlers[eventName].push(method);
	
	        var cancelled = false;
	
	        function cancel() {
	            if (!cancelled) {
	                handlers[eventName].splice(handlers[eventName].indexOf(method), 1);
	                cancelled = true;
	            }
	        }
	
	        cancel.cancel = cancel;
	        return cancel;
	    },
	    once: function once(eventName, method) {
	
	        if (customEventEmitter) {
	            return customEventEmitter.once(eventName, method);
	        }
	
	        var listener = $event.on(eventName, function () {
	            listener.cancel();
	            return method.apply(this, arguments);
	        });
	
	        return listener;
	    },
	    emit: function emit(eventName) {
	        if (customEventEmitter) {
	            var _customEventEmitter;
	
	            return (_customEventEmitter = customEventEmitter).emit.apply(_customEventEmitter, arguments);
	        }
	
	        var event = {
	            preventDefault: function preventDefault() {
	                event.defaultPrevented = true;
	            }
	        };
	
	        if (handlers[eventName]) {
	            for (var _iterator3 = Array.prototype.slice.apply(handlers[eventName]), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
	                var _ref3;
	
	                if (_isArray3) {
	                    if (_i3 >= _iterator3.length) break;
	                    _ref3 = _iterator3[_i3++];
	                } else {
	                    _i3 = _iterator3.next();
	                    if (_i3.done) break;
	                    _ref3 = _i3.value;
	                }
	
	                var handler = _ref3;
	
	                handler.apply(this, [event].concat(Array.prototype.slice.call(arguments)));
	            }
	        }
	
	        return event;
	    },
	    broadcast: function broadcast(eventName) {
	
	        if (customEventEmitter) {
	            var _customEventEmitter2;
	
	            return (_customEventEmitter2 = customEventEmitter).broadcast.apply(_customEventEmitter2, arguments);
	        }
	
	        return $event.emit.apply($event, arguments);
	    },
	
	
	    refCount: function refCount($scope, start, stop) {
	        return _promise.$promise.resolver(function (resolve) {
	
	            var count = 0;
	
	            function res() {
	                if (!count) {
	
	                    if (cancelStartListener && cancelStopListener) {
	                        cancelStartListener();
	                        cancelStopListener();
	                    }
	
	                    return resolve();
	                }
	            }
	
	            var cancelStartListener = $scope.$on(start, function (event, data) {
	                count += 1;
	            });
	
	            var cancelStopListener = $scope.$on(stop, function (event, data) {
	                setTimeout(function () {
	                    count -= 1;
	                    res();
	                }, 50);
	            });
	
	            setTimeout(res, 50);
	        });
	    },
	
	    compose: function compose(start, end, startAll, endAll) {
	        var debounce = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
	
	
	        var count = 0;
	        var active = false;
	
	        $event.on(start, function () {
	            if (!count) {
	                setTimeout(function () {
	                    if (count && !active) {
	                        active = true;
	                        $event.emit(startAll);
	                    }
	                }, debounce);
	            }
	
	            count += 1;
	        });
	
	        $event.on(end, function () {
	
	            setTimeout(function () {
	                count -= 1;
	
	                if (!count && active) {
	                    active = false;
	                    $event.emit(endAll);
	                }
	            }, 0);
	        });
	
	        return {
	            getCount: function getCount() {
	                return count;
	            },
	            isActive: function isActive() {
	                return Boolean(count);
	            },
	            reset: function reset() {
	                count = 0;
	            }
	        };
	    }
	};
	
	angular.value("$event", $event);
	_promise.$promise;

/***/ }),

/***/ "./components/squid/dist/core/promise.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$promise = $promise;
	
	var _util = __webpack_require__("./components/squid/dist/core/util.js");
	
	var Promise = window.Promise;
	
	function $promise(obj) {
	    return Promise.resolve(obj);
	}
	
	_util.$util.extend($promise, {
	    use: function use(CustomPromise) {
	        Promise = CustomPromise;
	    },
	    resolver: function resolver(method) {
	        return new Promise(method);
	    },
	    resolve: function resolve(value) {
	        return Promise.resolve(value);
	    },
	    reject: function reject(value) {
	        return Promise.reject(value);
	    },
	
	
	    run: function run(method) {
	        return Promise.resolve().then(method);
	    },
	
	    call: function call(method) {
	        return Promise.resolve().then(method);
	    },
	
	    sequential: function sequential(methods) {
	
	        var prom = Promise.resolve();
	
	        _util.$util.forEach(methods, function (method) {
	            prom = prom.then(method);
	        });
	
	        return prom;
	    },
	
	    sleep: function sleep(time) {
	        return new Promise(function (resolve) {
	            setTimeout(resolve, time);
	        });
	    },
	
	    map: function map(items, method) {
	
	        var promises = void 0;
	
	        if (items instanceof Array) {
	            promises = [];
	        } else if (items instanceof Object) {
	            promises = {};
	        } else {
	            return Promise.resolve();
	        }
	
	        return this.all(_util.$util.map(items, function (item, key) {
	
	            promises[key] = Promise.resolve(item).then(function (result) {
	                return method(result, key, promises);
	            });
	
	            return promises[key];
	        }));
	    },
	
	    all: function all(items) {
	
	        if (items instanceof Array) {
	            return Promise.all(items);
	        } else if (items instanceof Object) {
	            return this.hash(items);
	        }
	
	        return Promise.resolve([]);
	    },
	
	    hash: function hash(obj) {
	        var results = {};
	
	        return Promise.all(_util.$util.map(obj, function (item, key) {
	            return Promise.resolve(item).then(function (result) {
	                results[key] = result;
	            });
	        })).then(function () {
	            return results;
	        });
	    },
	
	    extend: function extend(obj, hash) {
	        return this.hash(hash || {}).then(function (data) {
	            _util.$util.extend(obj, data);
	        });
	    },
	
	    attempt: function attempt(attempts, method) {
	
	        attempts -= 1;
	
	        return Promise.resolve().then(function () {
	            return method(attempts);
	        })['catch'](function (err) {
	
	            if (attempts) {
	                return $promise.attempt(attempts, method);
	            }
	
	            return Promise.reject(err);
	        });
	    },
	
	    debounce: function debounce(method, time) {
	
	        var timeout = void 0;
	        var resolvers = {};
	
	        return function () {
	
	            var self = this;
	            var args = arguments;
	            var key = JSON.stringify(args);
	
	            resolvers[key] = resolvers[key] || [];
	
	            return new Promise(function (resolve) {
	                resolvers[key].push(resolve);
	                clearTimeout(timeout);
	
	                timeout = setTimeout(function () {
	
	                    var result = method.apply(self, args);
	
	                    _util.$util.forEach(resolvers[key], function (resolver) {
	                        resolver(result);
	                    });
	
	                    delete resolvers[key];
	                }, time);
	            });
	        };
	    },
	
	    every: function every(collection, handler) {
	        return this.map(collection, function (item) {
	            return handler(item);
	        }).then(function (results) {
	            return _util.$util.every(results);
	        });
	    },
	
	    providing: function providing(condition, handler) {
	        return Promise.resolve(condition).then(function (result) {
	            if (result) {
	                return handler(result);
	            }
	        });
	    },
	
	    until: function until(condition, pollTime, timeout, alwaysResolve) {
	
	        return new Promise(function (resolve, reject) {
	            if (condition()) {
	                return resolve();
	            }
	
	            var interval = setInterval(function () {
	                if (condition()) {
	                    clearInterval(interval);
	                    return resolve();
	                }
	            }, pollTime);
	
	            if (timeout) {
	                setTimeout(function () {
	                    clearInterval(interval);
	                    return alwaysResolve ? resolve() : reject();
	                }, timeout);
	            }
	        });
	    },
	
	    first: function first(handlers) {
	
	        var prom = $promise.resolve();
	        var result = void 0;
	
	        _util.$util.forEach(handlers, function (handler) {
	            prom = prom.then(function () {
	                return result || handler();
	            }).then(function (handlerResult) {
	                result = handlerResult;
	                return result;
	            });
	        });
	
	        return prom;
	    }
	});
	
	angular.value("$promise", $promise);
	_util.$util;

/***/ }),

/***/ "./components/squid/dist/core/util.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$unresolved = exports.$util = undefined;
	exports.$getRedirectUrl = $getRedirectUrl;
	exports.$dispatch = $dispatch;
	exports.$experiment = $experiment;
	
	var _event = __webpack_require__("./components/squid/dist/core/event.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _base = __webpack_require__("./components/base64/base64.min.js");
	
	var base64 = _interopRequireWildcard(_base);
	
	var _config = __webpack_require__("./components/squid/dist/core/config.js");
	
	var _integration = __webpack_require__("./components/squid/dist/core/integration.js");
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var redirected = false;
	var paramCache = {};
	
	// incase base64 has been CJS packed, it will export itself
	if (typeof window.atob === 'undefined' || typeof window.btoa === 'undefined') {
	    window.atob = base64.atob;
	    window.btoa = base64.btoa;
	}
	
	var $util = exports.$util = {
	
	    forEach: function forEach(collection, method) {
	        if (collection instanceof Array) {
	            for (var i = 0; i < collection.length; i++) {
	                method(collection[i], i);
	            }
	        } else if (collection instanceof Object) {
	            for (var key in collection) {
	                if (collection.hasOwnProperty(key)) {
	                    method(collection[key], key);
	                }
	            }
	        }
	    },
	
	    idleTimeout: function idleTimeout(time) {
	        setTimeout(function () {
	            _logger.$logger.info('page_idle');
	            $util.reload();
	        }, time);
	    },
	
	
	    reload: function reload() {
	        _logger.$logger.info('reload');
	        _event.$event.emit('loading');
	        window.location.reload();
	    },
	
	    redirect: function redirect(url, options) {
	
	        if (url.toLowerCase().indexOf('javascript:') !== -1) {
	            // eslint-disable-line
	            _logger.$logger.error('unsafe_redirect_url', {
	                url: url
	            });
	            throw new Error('Unsafe redirect url: ' + url);
	        }
	
	        _logger.$logger.info('redirect', {
	            url: url
	        });
	
	        _event.$event.on('$stateChangeStart', function (event) {
	            _logger.$logger.info('state_change_after_redirect');
	            event.preventDefault();
	        });
	
	        function redir() {
	
	            if (redirected) {
	                return;
	            }
	
	            _logger.$logger.info('redirect', {
	                url: url
	            });
	
	            window.onunload = window.onbeforeunload = function () {}; // eslint-disable-line no-empty-function
	
	            if (_integration.$integration.getConfig('REDIRECT_TOP') !== false) {
	                window.top.location = url;
	            } else {
	                window.location = url;
	            }
	
	            redirected = true;
	        }
	
	        _event.$event.emit('loading');
	
	        _logger.$logger.flush().then(redir);
	        setTimeout(redir, 500);
	
	        _logger.$logger.done();
	    },
	
	    cookiesEnabled: function cookiesEnabled() {
	        var cookiesEnabled = void 0;
	
	        document.cookie = '_cookiecheck=1';
	        cookiesEnabled = Boolean(document.cookie.indexOf('_cookiecheck') > -1);
	        document.cookie = '_cookiecheck=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
	        document.cookie = '_cookiecheck; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
	
	        return cookiesEnabled;
	    },
	
	    storageEnabled: function storageEnabled(api) {
	        try {
	            window[api].setItem('__feature_test__', '0');
	            window[api].removeItem('__feature_test__');
	            return true;
	        } catch (e) {
	            return false;
	        }
	    },
	
	    sessionStorageEnabled: function sessionStorageEnabled() {
	        return this.storageEnabled('sessionStorage');
	    },
	
	    localStorageEnabled: function localStorageEnabled() {
	        return this.storageEnabled('localStorage');
	    },
	
	    params: function params(string) {
	
	        if (typeof string !== 'string') {
	            string = this.queryString().slice(1);
	        }
	
	        var params = {};
	
	        if (!string) {
	            return params;
	        }
	
	        if (paramCache[string]) {
	            return $util.extend({}, paramCache[string]);
	        }
	
	        $util.forEach(string.split('&'), function (pair) {
	            pair = pair.split('=');
	
	            if (pair[0]) {
	                params[decodeURIComponent(pair[0])] = pair[1] && decodeURIComponent(pair[1]);
	            }
	        });
	
	        paramCache[string] = params;
	
	        return params;
	    },
	
	    queryString: function queryString() {
	        if (window.location.search) {
	            return window.location.search;
	        } else {
	            var string = window.location.href;
	            var idx = string.indexOf('&');
	            var rIdx = string.lastIndexOf('#');
	
	            if (idx) {
	                return '?' + string.substring(idx, rIdx >= 0 ? rIdx : string.length);
	            }
	        }
	        return '';
	    },
	
	    queryStringSplice: function queryStringSplice(qs, insert, remove) {
	        if (qs.indexOf('?') === 0) {
	            qs = qs.slice(1);
	        }
	
	        var params = $util.extend(this.params(qs), insert);
	
	        $util.forEach(remove, function (key) {
	            delete params[key];
	        });
	
	        return '?' + this.paramToQueryString(params);
	    },
	
	    extend: function extend(obj, source) {
	
	        if (!source) {
	            return obj;
	        }
	
	        for (var key in source) {
	            if (source.hasOwnProperty(key)) {
	                obj[key] = source[key];
	            }
	        }
	
	        return obj;
	    },
	
	
	    paramToQueryString: function paramToQueryString(params) {
	        return this.filter(this.map(Object.keys(params).sort(), function (key) {
	            if (!params[key]) {
	                return;
	            }
	
	            return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
	        })).join('&');
	    },
	
	    param: function $param(name) {
	        return this.params()[name];
	    },
	
	    hashParam: function hashParam(name) {
	        return this.params(window.location.hash.slice(1))[name];
	    },
	
	    base64Decode: function base64Decode(encodedString) {
	        return encodedString && window.atob(encodedString); // eslint-disable-line block-scoped-var,no-undef
	    },
	
	    /*
	     * decodeAndParse :
	     * 1 - Base64Decode
	     * 2 - URI Decode
	     * 3 - Split string into a nvp object
	     * return obj
	     */
	    decodeAndParse: function decodeAndParse(encodedString) {
	        if (encodedString) {
	            return this.params(decodeURIComponent(this.base64Decode(encodedString)));
	        }
	    },
	
	    assert: function $assert(value, message, payload) {
	        if (!value) {
	            throw new Error(message, payload || {});
	        }
	    },
	
	    map: function $map(array, method) {
	
	        array = array || [];
	
	        var results = void 0;
	
	        if (array instanceof Array) {
	            results = [];
	
	            $util.forEach(array, function () {
	                results.push(method.apply(this, arguments));
	            });
	
	            return results;
	        } else if (array instanceof Object) {
	
	            results = {};
	
	            $util.forEach(array, function (val, key) {
	                results[key] = method.apply(this, arguments);
	            });
	
	            return results;
	        } else {
	            throw new Error('$util.map expects array or object');
	        }
	    },
	
	    filter: function $filter(array, method) {
	        method = method || Boolean;
	        var results = [];
	
	        $util.forEach(array, function (item) {
	            if (method.apply(this, arguments)) {
	                results.push(item);
	            }
	        });
	
	        return results;
	    },
	
	    find: function $find(array, method) {
	
	        if (!array) {
	            return;
	        }
	
	        for (var i = 0; i < array.length; i++) {
	            if (method(array[i])) {
	                return array[i];
	            }
	        }
	    },
	
	    findIndex: function $find(array, method) {
	
	        if (!array) {
	            return;
	        }
	
	        for (var i = 0; i < array.length; i++) {
	            if (method(array[i])) {
	                return i;
	            }
	        }
	    },
	
	    range: function range(start, end) {
	        if (!end) {
	            end = start;
	            start = 0;
	        }
	
	        var result = [];
	
	        for (var i = start; i < end; i++) {
	            result.push(i);
	        }
	
	        return result;
	    },
	
	    pad: function $pad(string, n, char) {
	
	        n = n || 0;
	        char = char || '0';
	
	        var padding = Array(n + 1).join(char.toString());
	
	        return (padding + string).slice(-n);
	    },
	
	    /**
	     * Deprecated.
	     *
	     * If you have an array, use Array#some()
	     * If you have an object, use the lodash or underscore .some() method
	     *
	     * @deprecated
	     */
	    some: function $some(array, method) {
	        if (_config.$config.deploy.isLocal() || _config.$config.deploy.isStage()) {
	            _angular.$log.warn('deprecated_method: squid.$util.some() is deprecated, use Array#some or\n                        lodash/underscore.some() instead.');
	        }
	
	        var result = void 0;
	
	        $util.forEach(array, function (item, key) {
	            if (!result) {
	                result = method(item, key);
	            }
	        });
	
	        return result;
	    },
	
	    every: function $every(array, method) {
	        method = method || Boolean;
	
	        var result = true;
	
	        $util.forEach(array, function (item) {
	            if (!method(item)) {
	                result = false;
	            }
	        });
	
	        return result;
	    },
	
	    reduce: function $reduce(array, method, intial) {
	        $util.forEach(array, function (item) {
	            intial = method(intial, item);
	        });
	
	        return intial;
	    },
	
	    isPopup: function isPopup() {
	        return _integration.$integration.isPopup();
	    },
	
	    isIFrame: function isIFrame() {
	        return _integration.$integration.isIFrame();
	    },
	
	    buildURL: function buildURL(url, params) {
	        /*
	         * Do NOT add a check for anchor cause this function is also used for building XO success / cancel urls.
	         * These urls are defined by the merchants and can also contain urls like "abc.com#merchantanchor" and merchants
	         * expect (!) the following outcome: abc.com#merchantanchor?paypalparam=2
	         */
	        this.assert(url, 'buildURL :: expected url');
	
	        var paramKeys = Object.keys(params || {});
	
	        if (JSON.stringify(params) === '{}') {
	            return url;
	        }
	
	        if (!paramKeys.length) {
	            return url;
	        }
	
	        if (url.indexOf('?') === -1) {
	            url += '?';
	        } else {
	            url += '&';
	        }
	
	        url += this.paramToQueryString(params);
	
	        return url;
	    },
	
	    paypalURL: function paypalURL(url, params) {
	        url = 'https://' + (_config.$meta.stage ? _config.$meta.stage : window.location.host) + url;
	
	        return this.buildURL(url, params);
	    },
	
	    override: function override(obj, methodName, handler) {
	        var existing = obj[methodName];
	
	        obj[methodName] = function () {
	            if (existing) {
	                try {
	                    existing.apply(obj, arguments);
	                } catch (err) {
	                    _logger.$logger.error(methodName + 'event_error', {
	                        error: err.toString
	                    });
	                }
	            }
	
	            return handler.apply(obj, arguments);
	        };
	    },
	
	    result: function result(method) {
	        return method();
	    },
	
	    memoize: function memoize(method) {
	        var result = void 0;
	        var called = false;
	
	        function memoized() {
	            if (!called) {
	                result = method.apply(this, arguments);
	            }
	            called = true;
	            return result;
	        }
	
	        memoized.flush = function () {
	            called = false;
	        };
	
	        return memoized;
	    },
	
	    now: function now() {
	        return window.enablePerformance ? parseInt(window.performance.now(), 10) : Date.now();
	    },
	
	    bindObject: function bindObject(obj, self) {
	        return $util.map(obj, function (method) {
	            return method.bind(self);
	        });
	    },
	
	    hashStr: function hashStr(str) {
	        var hash = 0;
	        var i = void 0;
	        var chr = void 0;
	        var len = void 0;
	
	        if (str.length === 0) {
	            return hash;
	        }
	        for (i = 0, len = str.length; i < len; i++) {
	            chr = str.charCodeAt(i);
	            hash = (hash << 5) - hash + chr; // eslint-disable-line no-bitwise, no-extra-parens
	            // Convert to 32bit integer
	            hash |= 0; // eslint-disable-line no-bitwise
	        }
	        return Math.abs(hash);
	    },
	
	    hash: function hash() {
	        return this.hashStr(Math.random());
	    },
	
	    popup: function popup(name, url, options, callback) {
	
	        callback = $util.once(callback);
	
	        var win = window.open(url, name, $util.map(Object.keys(options), function (key) {
	            return key + '=' + options[key];
	        }).join(', '));
	
	        var interval = void 0;
	
	        function checkWindowClosed() {
	            if (win.closed) {
	                clearInterval(interval);
	                callback();
	            }
	        }
	
	        interval = setInterval(checkWindowClosed, 50);
	        setTimeout(checkWindowClosed);
	
	        try {
	            var close = win.close;
	
	            win.close = function () {
	                close.apply(this, arguments);
	                checkWindowClosed();
	            };
	        } catch (err) {
	            // pass
	        }
	
	        return win;
	    },
	
	    unique: function unique(collection) {
	        return collection.filter(function (value, index, self) {
	            return self.indexOf(value) === index;
	        });
	    },
	
	    monkeyPatch: function monkeyPatch(mod, prop, method) {
	        var original = mod[prop];
	
	        mod[prop] = function () {
	            var _this = this,
	                _arguments = arguments;
	
	            return method.call(this, arguments, function (self, args) {
	                if (original) {
	                    return original.apply(self || _this, args || _arguments);
	                }
	            });
	        };
	    },
	    once: function once(method) {
	        var called = false;
	
	        return function () {
	            if (!called) {
	                called = true;
	                return method.apply(this, arguments);
	            }
	        };
	    },
	    camelToDasherize: function camelToDasherize(string) {
	        return string.replace(/([A-Z])/g, function (g) {
	            return '-' + g.toLowerCase();
	        });
	    },
	    camelToCapsUnderscore: function camelToCapsUnderscore(string) {
	        return string.replace(/([a-z][A-Z])/g, function (g) {
	            return g[0] + '_' + g[1];
	        }).toUpperCase();
	    },
	    dasherizeToCamel: function dasherizeToCamel(string) {
	        return string.replace(/-([a-z])/g, function (g) {
	            return g[1].toUpperCase();
	        });
	    },
	
	
	    parentWindow: function parentWindow() {
	        if (window.opener) {
	            return window.opener;
	        } else if (window.parent !== window) {
	            return window.parent;
	        }
	    },
	
	    hasRTL: function hasRTL(str) {
	        return new RegExp('[\u0590-\u07BF]').test(str);
	    },
	    noop: function noop() {// eslint-disable-line no-empty-function
	
	    }
	};
	
	var $unresolved = exports.$unresolved = { then: $util.noop, 'catch': $util.noop };
	
	function $getRedirectUrl(product, params) {
	    var url = '';
	    var urlParams = $util.params();
	
	    if (_config.$config.deploy.isLocal() || _config.$config.deploy.isStage()) {
	        url = _config.$config.urls.dispatch && _config.$config.urls.dispatch[product] || '';
	    }
	
	    url += _config.$config.urls.fallbackUrl[product];
	
	    $util.extend(urlParams, params || {});
	
	    // cmd is a reserved slingshot param
	    if (urlParams.cmd) {
	        delete urlParams.cmd;
	    }
	
	    return $util.buildURL(url, urlParams);
	}
	
	function $dispatch(product, params, stateChange) {
	    $util.assert(product, 'expected product');
	
	    _logger.$logger.log('info', 'dispatch', {
	        product: product
	    });
	
	    _event.$event.emit('loading');
	
	    var url = '';
	
	    url = $getRedirectUrl(product, params);
	
	    // fire an event for xo-tracking to listen to and do fpti logging
	    if (stateChange) {
	        _event.$event.emit('page_loaded', stateChange.fromState, stateChange.toState);
	    }
	
	    return $util.redirect(url);
	}
	
	function $experiment(name, sample, id, loggerPayload) {
	
	    var throttle = $util.hashStr(name + '_' + id) % 100;
	
	    var group = void 0;
	
	    if ($util.param(name) === 'true') {
	        group = 'test_forced';
	    } else if ($util.param(name) === 'false') {
	        group = 'control_forced';
	    } else if (throttle < sample) {
	        group = 'test';
	    } else if (sample >= 50 || sample <= throttle && throttle < sample * 2) {
	        // eslint-disable-line no-extra-parens
	        group = 'control';
	    } else {
	        group = 'throttle';
	    }
	
	    _logger.$logger.info('fpti_pxp_check', {
	        from: 'PXP_CHECK',
	        to: 'process_pxp_check',
	        pxp_exp_id: name,
	        pxp_trtmnt_id: group
	    });
	
	    _logger.$logger.info(name + '_' + group, loggerPayload || {});
	
	    if (group === 'test' || group === 'test_forced') {
	        return true;
	    } else if (group === 'control') {
	        return false;
	    }
	}
	
	angular.value("$util", $util);
	angular.value("$unresolved", $unresolved);
	angular.value("$getRedirectUrl", $getRedirectUrl);
	angular.value("$dispatch", $dispatch);
	angular.value("$experiment", $experiment);
	_event.$event;
	
	_logger.$logger;
	
	_config.$config;
	
	_config.$meta;
	
	_integration.$integration;
	
	_angular.$log;

/***/ }),

/***/ "./components/base64/base64.min.js":
/***/ (function(module, exports, __webpack_require__) {

	!function(){function t(t){this.message=t}var r= true?exports:this,e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";t.prototype=new Error,t.prototype.name="InvalidCharacterError",r.btoa||(r.btoa=function(r){for(var o,n,a=String(r),i=0,c=e,d="";a.charAt(0|i)||(c="=",i%1);d+=c.charAt(63&o>>8-i%1*8)){if(n=a.charCodeAt(i+=.75),n>255)throw new t("'btoa' failed: The string to be encoded contains characters outside of the Latin1 range.");o=o<<8|n}return d}),r.atob||(r.atob=function(r){var o=String(r).replace(/=+$/,"");if(o.length%4==1)throw new t("'atob' failed: The string to be decoded is not correctly encoded.");for(var n,a,i=0,c=0,d="";a=o.charAt(c++);~a&&(n=i%4?64*n+a:a,i++%4)?d+=String.fromCharCode(255&n>>(-2*i&6)):0)a=e.indexOf(a);return d})}();


/***/ }),

/***/ "./components/squid/dist/core/config.js":
/***/ (function(module, exports) {

	
	
	exports.__esModule = true;
	var $meta = exports.$meta = window.meta || {};
	var $cookies = exports.$cookies = window.cookies || {};
	var $config = exports.$config = window.config || {};
	angular.value("$meta", $meta);
	angular.value("$cookies", $cookies);
	angular.value("$config", $config);

/***/ }),

/***/ "./components/squid/dist/core/integration.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$integration = exports.$CONTEXT = exports.$DEFAULT = undefined;
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var $DEFAULT = exports.$DEFAULT = 'DEFAULT';
	
	var $CONTEXT = exports.$CONTEXT = {
	
	    // Full page checkout
	    FULLPAGE: 'FULLPAGE',
	
	    // Checkout in popup
	    POPUP: 'POPUP',
	
	    // Checkout in lightbox (iframe)
	    LIGHTBOX: 'LIGHTBOX',
	
	    // Web view
	    WEBVIEW: 'WEBVIEW',
	
	    // Native checkout
	    NATIVE_CHECKOUT: 'NATIVE_CHECKOUT'
	};
	
	var $integration = exports.$integration = {
	
	    flow: $DEFAULT,
	
	    init: function init(flow, config) {
	        this.config = config || {};
	
	        if (flow) {
	            this.setFlow(flow);
	        }
	
	        this.setContext(this.getContext());
	    },
	    getContext: function getContext() {
	
	        if (this.isIFrame()) {
	            return $CONTEXT.LIGHTBOX;
	        } else if (this.isPopup()) {
	            return $CONTEXT.POPUP;
	        } else {
	            return $CONTEXT.FULLPAGE;
	        }
	    },
	    isPopup: function isPopup() {
	        return Boolean(window.opener);
	    },
	    isIFrame: function isIFrame() {
	        return window.top !== window.self;
	    },
	    setContext: function setContext(context) {
	        _logger.$logger.info('integration_context_' + context);
	        this.context = context;
	    },
	    setFlow: function setFlow(flow) {
	        _logger.$logger.info('integration_flow_' + flow);
	        this.flow = flow;
	    },
	    is: function is(context, flow) {
	        return this.isContext(context) && this.isFlow(flow);
	    },
	    isContext: function isContext(context) {
	        return this.context === context;
	    },
	    isFlow: function isFlow(flow) {
	        return this.flow === flow;
	    },
	    getConfig: function getConfig(key) {
	
	        this.context = this.getContext();
	
	        if (!this.config) {
	            return;
	        }
	
	        if (this.config.hasOwnProperty(this.context) && this.config[this.context].hasOwnProperty(this.flow) && this.config[this.context][this.flow].hasOwnProperty(key)) {
	
	            return this.config[this.context][this.flow][key];
	        }
	
	        if (this.config.hasOwnProperty(this.context) && this.config[this.context].hasOwnProperty(key)) {
	
	            return this.config[this.context][key];
	        }
	
	        if (this.config.hasOwnProperty($DEFAULT) && this.config[$DEFAULT].hasOwnProperty(this.flow) && this.config[$DEFAULT][this.flow].hasOwnProperty(key)) {
	
	            return this.config[$DEFAULT][this.flow][key];
	        }
	
	        if (this.config.hasOwnProperty($DEFAULT) && this.config[$DEFAULT].hasOwnProperty(key)) {
	
	            return this.config[$DEFAULT][key];
	        }
	    },
	    error: function error(message) {
	        return new Error('Integration error: ' + this.context + ' / ' + this.flow + ' :: ' + message);
	    }
	};
	
	angular.value("$integration", $integration);
	_logger.$logger;

/***/ }),

/***/ "./components/squid/dist/core/class.js":
/***/ (function(module, exports) {

	
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*
	 Class
	 -----
	
	 A class pattern, adding sugar on top of javascript prototypes
	
	 ### Basic Usage
	
	 let MyClass = Class.extend({
	 foo: 'bar';
	 });
	
	 myInstance = new MyClass({
	 hello: 'world'
	 });
	
	 console.log(myInstance.foo, myInstance.hello)
	
	 In this example, `foo` becomes a property on `MyClass`'s prototype,
	 and `hello` becomes a property on `myInstance`.
	
	 ### Default Object Methods
	
	 - `init()`: Called after the object is first instantiated, with all properties available
	
	 - `get(<path>, <default>)`: Get an object an arbitrary number of levels deep, or return a default
	
	 e.g. `myInstance.get('foo.bar.baz', 'some_default');`
	
	 Default return value is undefined
	
	 - `set(<path>, <value>)`: Set an object an arbitrary number of levels deep
	
	 e.g. `myInstance.set('foo.bar.baz', 'some_value');`
	
	 Error is thrown if no object is found to set the value on
	
	 - `setProperties(<object>)`: Set all the properties from an object onto your object
	
	 e.g. `myInstance.setProperties({foo: 'bar', hello: 'world'})`
	
	 Can not be used with nested properties
	
	 - `forEach(<callback>)`: Loop through the object and call callback(<key>, <value>) for each key/val pair
	
	 */
	
	// Object Create
	// -------------
	//
	// Shim for Object.create, if it is not supported by our browser
	//
	// let myPrototype = {foo: 'bar'}
	// let myObject = create(myPrototype)
	
	// Create an empty anonymous constructor with no side effects, for re-use later
	var EmptyConstructor = function EmptyConstructor() {}; // eslint-disable-line no-empty-function
	
	var create = Object.create || function create(obj) {
	
	    // Set a temporary prototype
	    EmptyConstructor.prototype = obj;
	
	    // Create an object using our temporary constructor/prototype
	    var instance = new EmptyConstructor();
	
	    // Reset the prototype for next time
	    EmptyConstructor.prototype = null;
	
	    // Return our new object, created without side effects
	    return instance;
	};
	
	function _extend(obj, source) {
	
	    if (!source) {
	        return obj;
	    }
	
	    for (var key in source) {
	        if (source.hasOwnProperty(key)) {
	            obj[key] = source[key];
	        }
	    }
	
	    return obj;
	}
	
	// Is Object
	// ---------
	//
	// Check of a let is an object or not
	//
	// isobject({}) -> true
	// isobject('foo') -> false
	
	function isobject(obj) {
	    return obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && obj instanceof Object;
	}
	
	// Transpose properties
	// -------------------------------------------------------------------
	//
	// Transpose properties from a list of objects onto a recipient object
	//
	// let recipient = {};
	// transpose(recipient, [{a: 1, b: 2}, {c: 3}])
	// recipient -> {a: 1, b: 2, c:3}
	
	function transpose(recipient, args) {
	
	    // Loop through all args
	    for (var i = 0; i < args.length; i++) {
	        var ob = args[i];
	
	        // Ignore anything that is not an object
	        if (!isobject(ob)) {
	            continue;
	        }
	
	        // Loop through all keys in our object
	        for (var key in ob) {
	
	            // Ignore any prototypal properties
	            if (!ob.hasOwnProperty(key)) {
	                continue;
	            }
	
	            var item = ob[key];
	
	            // Give the function a name
	            if (item instanceof Function) {
	                item.__name__ = key;
	            }
	
	            recipient[key] = item;
	        }
	    }
	}
	
	// Construct a Class
	// -----------------
	//
	// This is the primary constructor for all $Class objects
	
	function construct() {
	    // eslint-disable-line no-unused-vars
	
	    // Call any custom constructor;
	    if (this.construct) {
	        var ob = this.construct.apply(this, arguments);
	
	        // If we get a new object back, return that to the user
	        if (isobject(ob)) {
	            return ob;
	        }
	    }
	
	    // Load any provided properties directly onto the object
	    transpose(this, arguments);
	
	    // Initialize the object
	    if (this.init) {
	        this.init();
	    }
	}
	
	// Reopen an object
	// ----------------
	//
	// Add properties to the constructor's prototype
	//
	//     let Animal = $Class.extend();
	//
	//     Animal.reopen({
	//       type: 'animal',
	//     });
	//
	//     let cat = new Animal;
	//     console.log(cat.type);
	function reopen() {
	
	    // Add some more properies to our prototype
	    transpose(this.prototype, arguments);
	
	    return this;
	}
	
	// Reopen a class
	// --------------
	//
	// Add properties to the constructor. These will propogate through future extends
	//
	//     let Animal = $Class.extend();
	//
	//     Animal.reopenClass({
	//       fromCache: function(id) {
	//         return cache[id] || new this({id: id});
	//       }
	//     }
	//
	//     let cat = Animal.fromCache('cat_54');
	
	function reopenClass() {
	
	    // Add some more properies to our class
	    transpose(this, arguments);
	
	    // Add to __classmethods__
	    transpose(this.__classmethods__, arguments);
	
	    return this;
	}
	
	function isChild(Cls) {
	    return Cls && Cls.prototype instanceof this;
	}
	
	// Generate a new class
	// --------------------
	//
	// Generate a new constructor, with the specified name, and attach all static and prototypal methods
	
	var id = 0;
	
	function extend(name) {
	    var Cls = void 0;
	    var className = void 0;
	    var args = void 0;
	    var argsLength = void 0;
	    var startIndex = void 0;
	
	    // Accept an optional class name
	    if (typeof name === 'string') {
	
	        // Guard against javascript injection
	        if (!name.match(/^[\w$][\w\d]*$/)) {
	            throw new Error('Class name can not include special characters: ' + name);
	        }
	
	        // Use the provided name and slice out the first argument
	        className = name;
	        argsLength = arguments.length && arguments.length - 1;
	        startIndex = 1;
	    } else {
	
	        // Otherwise default to the parent name, or 'Object' if generating our first class
	        className = this.name || 'Object';
	        argsLength = arguments.length;
	        startIndex = 0;
	    }
	
	    args = new Array(argsLength);
	    for (var i = startIndex; i < arguments.length; i++) {
	        args[i - startIndex] = arguments[i];
	    }
	
	    // Dynamically create our constructor with a custom name
	    eval('Cls = function ' + className + '() { return construct.apply(this, arguments) }'); // eslint-disable-line no-eval
	
	    // Store the class name for future reference
	    Cls.__name__ = className;
	
	    // Set up a classmethods object. These will be inherited through subsequent extend() calls
	    Cls.__classmethods__ = {
	        extend: extend,
	        reopen: reopen,
	        reopenClass: reopenClass,
	        isChild: isChild
	    };
	
	    id += 1;
	    Cls.id = id;
	
	    // If we're being called on an existing class, e.g. Class.extend(), we should inherit from that class
	    if (this && this !== window) {
	
	        // Inherit everything from superclass prototype
	        Cls.prototype = create(this.prototype);
	
	        // Re-set the constructor, which is overwritten by create
	        Cls.prototype.constructor = Cls;
	
	        // Add a reference to the superclass prototype for super method calls
	        Cls.prototype._super = this.prototype;
	
	        // Inherit any class methods from the superclass
	        _extend(Cls.__classmethods__, this.__classmethods__);
	    }
	
	    // Add the class methods to our existing class
	    _extend(Cls, Cls.__classmethods__);
	
	    // Load any provided properties onto the constructor's prototype
	    transpose(Cls.prototype, args);
	
	    // Temporary: allow access from console/debugger
	    if (className.indexOf('$') === 0) {
	        window[className] = Cls;
	    } else {
	        window['$' + className] = Cls;
	    }
	
	    return Cls;
	}
	
	// Multi-layer get
	// ---------------
	//
	// Recursively gets a deep path from an object, returning a default value if any level is not found
	//
	// let obj = {bar: {baz: 1}}
	// get(obj, 'bar.baz', 'default') -> 1
	// get(obj, 'aaa.bbb', 'default') -> default
	
	function _get(item, path, def) {
	
	    if (!path) {
	        return def;
	    }
	
	    path = path.split('.');
	
	    // Loop through each section of our key path
	    for (var i = 0; i < path.length; i++) {
	
	        // If we have an object, we can get the key
	        if (isobject(item)) {
	            item = item[path[i]];
	            // Otherwise, we should return the default (undefined if not provided)
	        } else {
	            return def;
	        }
	    }
	
	    // If our final result is undefined, we should return the default
	    return item === undefined ? def : item;
	}
	
	// Multi-layer set
	// ---------------
	//
	// Recursively sets a deep path from an object
	//
	// let obj = {bar: {baz: 1}}
	// set(obj, 'bar.baz', 2)
	// obj.bar.baz -> 1
	
	function _set(item, path, value) {
	    path = path.split('.');
	
	    // Loop through each section of our key path except the last
	    for (var i = 0; i < path.length - 1; i++) {
	
	        // Get the next item down
	        item = item[path[i]];
	
	        // If we have an object, we're good
	        if (isobject(item)) {
	            continue;
	            // Otherwise, there's nothing to set our key on
	        } else {
	            throw new Error(path[i - 1] + '.' + path[i] + ' is not an object');
	        }
	    }
	
	    // Do the set on the retrieved object with our value
	    item[path[path.length - 1]] = value;
	}
	
	// Loop through object
	// -------------------
	//
	// Loop an object and apply a function for each key/value
	//
	// let ob = {a: 1, b: 2, c: 3}
	// each(ob, console.log) -> a 1  b 2  c 3
	
	function each(ob, callback) {
	    for (var key in ob) {
	        if (ob.hasOwnProperty(key)) {
	            callback.call(ob, key, ob[key]);
	        }
	    }
	}
	
	// Gey keys of object
	// ------------------
	//
	// Shim for Object.keys if it does not already exist
	//
	// let ob = {a: 1, b: 2, c: 3}
	// keys(ob) -> ['a', 'b', 'c']
	
	function _keys(ob) {
	
	    if (Object.keys) {
	        return Object.keys(ob);
	    }
	
	    var result = [];
	
	    for (var key in ob) {
	        if (ob.hasOwnProperty(key)) {
	            result.push(key);
	        }
	    }
	
	    return result;
	}
	
	// Create a base class that can be inherited from
	// ----------------------------------------------
	//
	// This is the public interface to the Class module.
	// All classes with extend from Class and be provided with a set of base convenience methods.
	
	var $Class = exports.$Class = extend('Class', {
	
	    init: function init() {
	        // Empty init class, so calls to _super can be safely made
	    },
	
	    get: function get(path, def) {
	        return _get(this, path, def);
	    },
	
	    set: function set(path, value) {
	        _set(this, path, value);
	    },
	
	    setProperties: function setProperties() {
	        transpose(this, arguments);
	    },
	
	    forEach: function forEach(callback) {
	        each(this, callback);
	    },
	
	    keys: function keys() {
	        return _keys(this);
	    }
	});
	
	$Class.get = _get;
	$Class.set = _set;
	$Class.keys = _keys;
	
	angular.value("$Class", $Class);

/***/ }),

/***/ "./components/squid/dist/core/error.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$FallbackError = exports.$BatchShortCircuit = exports.$ApiError = exports.$Forbidden = exports.$Contingency = exports.$Error = undefined;
	
	var _event = __webpack_require__("./components/squid/dist/core/event.js");
	
	var _class = __webpack_require__("./components/squid/dist/core/class.js");
	
	var _util = __webpack_require__("./components/squid/dist/core/util.js");
	
	_util.$util.monkeyPatch(window, 'onerror', function (_ref, original) {
	    var message = _ref[0],
	        file = _ref[1],
	        line = _ref[2],
	        col = _ref[3],
	        err = _ref[4];
	
	
	    original();
	
	    _event.$event.emit('$windowError', {
	        message: message && (message.stack || message).toString(),
	        file: file && file.toString(),
	        line: line && line.toString(),
	        col: col && col.toString(),
	        stack: err && (err.stack || err).toString()
	    });
	});
	
	var $Error = exports.$Error = _class.$Class.extend.call(Error, '$Error', {
	
	    construct: function construct(err, properties) {
	
	        if (err instanceof Error) {
	            err = err.message;
	        }
	
	        if (properties) {
	            _util.$util.extend(this, properties);
	        }
	
	        this.payload = properties;
	
	        this.message = err;
	    }
	});
	
	var $Contingency = exports.$Contingency = $Error.extend('$Contingency', {
	    handle: function handle(handlers) {
	        var handler = handlers[this.message] || handlers['DEFAULT'];
	
	        if (handler) {
	            var result = handler.call(this, this.message, this);
	
	            if (typeof result !== 'undefined') {
	                return result;
	            }
	            return true;
	        }
	    }
	});
	
	var $Forbidden = exports.$Forbidden = $Error.extend('$Forbidden');
	
	var $ApiError = exports.$ApiError = $Error.extend('$ApiError');
	
	var $BatchShortCircuit = exports.$BatchShortCircuit = $Error.extend('$BatchShortCircuit');
	
	var $FallbackError = exports.$FallbackError = $Error.extend('$FallbackError', {
	    init: function init() {
	        this.reason = this.reason || '';
	        this.product = this.product || '';
	        this.entryPoint = this.entryPoint || '';
	    }
	});
	
	angular.value("$Error", $Error);
	angular.value("$Contingency", $Contingency);
	angular.value("$Forbidden", $Forbidden);
	angular.value("$ApiError", $ApiError);
	angular.value("$BatchShortCircuit", $BatchShortCircuit);
	angular.value("$FallbackError", $FallbackError);
	_event.$event;
	
	_class.$Class;
	
	_util.$util;

/***/ }),

/***/ "./components/squid/dist/core/loader.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$loader = undefined;
	
	var _event = __webpack_require__("./components/squid/dist/core/event.js");
	
	var _firstLoad = false;
	
	var loader = _event.$event.compose('loading', 'loaded', 'startLoad', 'allLoaded', 100);
	
	var $loader = exports.$loader = {
	
	    isLoading: function isLoading() {
	        return Boolean(loader.getCount());
	    },
	    firstLoad: function firstLoad() {
	        return _firstLoad;
	    },
	    reset: function reset() {
	        loader.reset();
	    }
	};
	
	_event.$event.on('allLoaded', function () {
	    _firstLoad = true;
	});
	
	angular.value("$loader", $loader);
	_event.$event;

/***/ }),

/***/ "./components/squid/dist/core/model.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {
	
	exports.__esModule = true;
	exports.$Model = undefined;
	
	var _class = __webpack_require__("./components/squid/dist/core/class.js");
	
	var _util = __webpack_require__("./components/squid/dist/core/util.js");
	
	var _promise = __webpack_require__("./components/squid/dist/core/promise.js");
	
	var $Model = exports.$Model = _class.$Class.extend('$Model', {
	
	    init: function init() {
	
	        if (this.keys().length) {
	            this.onPopulate();
	        }
	
	        if (this.id) {
	            var _cache = this.constructor._modelCache = this.constructor._modelCache || {};
	
	            _cache[this.id] = this;
	        }
	
	        this.meta = {
	            populated: false
	        };
	    },
	
	    /**
	     * Add the passed in properties to this Model.
	     * Sets the meta.populated to true. This flag
	     * can be used later to determine if the model is populated.
	     * Calls onPopulate() in the end.
	     */
	    populate: function populate() {
	
	        this.meta.populated = true;
	        this.setProperties.apply(this, arguments);
	        delete this.meta.invalidated;
	        this.onPopulate();
	        return this;
	    },
	
	    fetchChildren: function fetchChildren() {
	        return _promise.$promise.resolve();
	    },
	
	    /**
	     * Override this method, to execute any logic after model is populated.
	     */
	    onPopulate: function onPopulate() {// eslint-disable-line no-empty-function
	
	    },
	
	    /**
	     * Override this method to return a Mock instance. Must return a promise which resolves to model.
	     */
	    fetchMock: function fetchMock() {// eslint-disable-line no-empty-function
	
	    },
	
	    /**
	     * Retrieves the model.
	     *
	     * If model is already populated just returns a promise which resolves to `this`
	     * If there is a retriever for this model, then return the retreiver.
	     * Else calls the api to retrieve the model.
	     *
	     * @param options
	     * @returns {*}
	     */
	    retrieve: function retrieve(options) {
	        var self = this;
	
	        options = options || {};
	
	        if (self.meta.populated) {
	
	            if (options.success) {
	                return _promise.$promise.resolve(options.success(self));
	            }
	
	            return _promise.$promise.resolve(this);
	        }
	
	        if (this.retriever) {
	            return this.retriever;
	        }
	
	        if (!this.api) {
	            throw new Error('Tried to populate a model with no api');
	        }
	
	        options.model = this;
	
	        this.retriever = this.api.retrieve(options).then(function (res) {
	            return self;
	        })['finally'](function () {
	            delete self.retriever;
	        });
	
	        return this.retriever;
	    },
	
	    /**
	     * Calls a post on the api to save this model. Takes options as parameters.
	     * options will passed down to api.post.
	     *
	     * @param options
	     * @returns {*|HttpPromise}
	     */
	    save: function save(options) {
	        options = options || {};
	        options.model = this;
	
	        options.data = options.data || this.serialize();
	
	        return this.api.post(options);
	    },
	
	    /**
	     * Calls Api.action to perform any action on the model.
	     *
	     * Takes action name and optional 'options' object as parameters.
	     *
	     * Ex: $CheckoutSession.actions('create', [options])
	     *
	     * @param action
	     * @param options
	     * @returns {*}
	     */
	    action: function action(_action, options) {
	        options = options || {};
	        options.model = this;
	
	        return this.api.action(_action, options);
	    },
	
	    /**
	     * Use this method to force a api call to get the data.
	     *
	     * @param options
	     * @returns {*}
	     */
	    reload: function reload(options) {
	        this.meta.populated = false;
	        return this.retrieve(options);
	    },
	
	    stringify: function stringify() {
	        return JSON.stringify(this, 2);
	    },
	
	    log: function log() {
	        console.log(this.stringify());
	    },
	
	    serialize: function serialize() {// eslint-disable-line no-empty-function
	
	    },
	
	    /**
	     * Invalidate the current model. Sets the meta.populated to false and sets meta.invalidated to true.
	     */
	    invalidate: function invalidate() {
	        this.meta.populated = false;
	        this.meta.invalidated = true;
	    },
	
	    /**
	     * Creates a new Class with properties from `child`. Then assigns `this` as parent to the new Class.
	     *
	     * @param Cls
	     * @param child
	     * @returns {*}
	     */
	    child: function child(Cls, _child) {
	
	        if (!_child) {
	            return;
	        }
	
	        return Cls.create(_child.id || this.id, { parent: this }).populate(_child);
	    },
	
	    /**
	     *
	     * @param Cls
	     * @param children
	     * @returns {*}
	     */
	    children: function children(Cls, _children) {
	        var self = this;
	
	        if (!_children) {
	            return _children;
	        }
	
	        return _util.$util.map(_children, function (child) {
	            return self.child(Cls, child);
	        });
	    }
	});
	
	var cache = {};
	
	$Model.reopenClass({
	
	    instance: function instance(id) {
	
	        var modelCache = cache[this.id] = cache[this.id] || {};
	        var instance = modelCache[id || 0] || this.create.apply(this, arguments);
	
	        return instance;
	    },
	
	    retrieveInstance: function retrieveInstance() {
	        return this.instance.apply(this, arguments).retrieve();
	    },
	
	    create: function create(id) {
	
	        var modelCache = cache[this.id] = cache[this.id] || {};
	        var instance = modelCache[id || 0] = new this({ // eslint-disable-line new-cap
	            id: id || 0
	        });
	
	        instance.setProperties.apply(instance, Array.prototype.slice.call(arguments, 1));
	
	        return instance;
	    },
	
	    fetch: function fetch() {
	        console.warn('Model.fetch is deprecated, please use Model.instance');
	        return this.instance.apply(this, arguments);
	    },
	
	    clearCache: function clearCache() {
	        cache = {};
	    }
	});
	
	angular.value("$Model", $Model);
	_class.$Class;
	
	_util.$util;
	
	_promise.$promise;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ }),

/***/ "./components/squid/dist/core/dom.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$dom = undefined;
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _promise = __webpack_require__("./components/squid/dist/core/promise.js");
	
	var _util = __webpack_require__("./components/squid/dist/core/util.js");
	
	var $dom = exports.$dom = {
	
	    elementReady: function elementReady(id) {
	
	        return _promise.$promise.resolver(function (resolve, reject) {
	
	            if (document.getElementById(id)) {
	                return resolve();
	            }
	
	            var interval = setInterval(function () {
	                if (document.getElementById(id)) {
	                    clearInterval(interval);
	                    return resolve();
	                }
	            }, 10);
	
	            setTimeout(60000, reject);
	        });
	    },
	
	    loadScript: function loadScript(name, src, timeout) {
	        var attributes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	        return _promise.$promise.resolver(function (resolve, reject) {
	            var script = document.createElement('script');
	            var loadTimeout = void 0;
	
	            function clearScriptLoadTimeout() {
	                if (loadTimeout) {
	                    clearTimeout(loadTimeout);
	                    loadTimeout = undefined;
	                }
	            }
	
	            script.onload = function () {
	                clearScriptLoadTimeout();
	                setTimeout(resolve, 10);
	            };
	
	            // For Internet explorer 8 support
	            script.onreadystatechange = function () {
	                if (this.readyState === 'complete' || this.readyState === 'loaded') {
	                    clearScriptLoadTimeout();
	                    setTimeout(resolve, 10);
	                }
	            };
	
	            script.onerror = function (event) {
	                _logger.$logger.info('script_error', {
	                    script: src
	                });
	                return reject(new Error(name + '_loading_error'));
	            };
	
	            if (timeout) {
	                loadTimeout = setTimeout(function () {
	                    _logger.$logger.info('script_load_timedout', {
	                        script: src
	                    });
	                    return reject(new Error(name + '_loading_timed_out'));
	                }, timeout);
	            }
	
	            script.setAttribute('src', src);
	
	            for (var _iterator = Object.keys(attributes), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	                var _ref;
	
	                if (_isArray) {
	                    if (_i >= _iterator.length) break;
	                    _ref = _iterator[_i++];
	                } else {
	                    _i = _iterator.next();
	                    if (_i.done) break;
	                    _ref = _i.value;
	                }
	
	                var attribute = _ref;
	
	                script.setAttribute(attribute, attributes[attribute]);
	            }
	
	            document.body.appendChild(script);
	        });
	    },
	
	    cssReady: function cssReady(id) {
	
	        var el = document.getElementById(id);
	
	        return _promise.$promise.resolver(function (resolve, reject) {
	
	            var timeout = void 0;
	            var interval = void 0;
	
	            function check() {
	                _util.$util.forEach(document.styleSheets, function (stylesheet) {
	                    if (stylesheet.href === el.href) {
	                        clearInterval(interval);
	                        clearTimeout(timeout);
	                        resolve();
	                    }
	                });
	            }
	
	            timeout = setTimeout(function () {
	                clearInterval(interval);
	                reject();
	                throw new Error('css_loading_timed_out');
	            }, 30000);
	
	            interval = setInterval(check, 20);
	            check();
	        });
	    }
	};
	
	angular.value("$dom", $dom);
	_logger.$logger;
	
	_promise.$promise;
	
	_util.$util;

/***/ }),

/***/ "./components/squid/dist/ng/route.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$ComponentRoute = exports.$Route = undefined;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	var _locale = __webpack_require__("./components/squid/dist/locale/index.js");
	
	var _component = __webpack_require__("./components/squid/dist/ng/component.js");
	
	var _ng = __webpack_require__("./components/squid/dist/ng/ng.js");
	
	var $Route = exports.$Route = _core.$Class.extend('$ComponentRoute', {
	
	    childSpec: {},
	
	    init: function init() {
	        var _this = this;
	
	        this.validate();
	
	        this.url = '/' + (this.path || this.name);
	
	        if (this.query) {
	            this.url += '?' + this.query.join('&');
	        }
	
	        this.hasResolver = Boolean(this.resolve);
	
	        var controller = this.controller = function ($scope) {
	            $scope.route = _this;
	            if ($scope.componentScope) {
	                delete $scope.componentScope.view;
	            }
	        };
	
	        if (this.get('resolve.action')) {
	            this.controller = function ($scope, action) {
	                _angular.$injector.invoke(controller, this, { $scope: $scope });
	                if (action) {
	                    if (!action.newState) {
	                        _angular.$location.replace();
	                    }
	
	                    if (angular.isObject(action) && action.to) {
	                        _uiRouter.$state.go(action.to, action.params);
	                    } else {
	                        _uiRouter.$state.go(action);
	                    }
	                }
	            };
	        }
	    },
	
	    validate: function validate() {
	
	        if (_core.$config.deploy.isLive() && !_core.$config.deploy.isTest()) {
	            return;
	        }
	
	        var routeName = this.constructor.name;
	
	        if (!this.name && !this.path) {
	            throw new Error(routeName + ' :: expected property \'path\'');
	        }
	
	        if (this.url) {
	            _logger.$logger.warn(routeName + ' :: unexpected property \'url\' :: ' + this.url);
	        }
	
	        if (this.query && !(this.query instanceof Array)) {
	            throw new Error(routeName + ' :: expected property \'query\' to be array of query params');
	        }
	
	        if (this.controller) {
	            // throw new Error(`${routeName} :: unexpected property 'controller'`);
	        }
	
	        if (this.resolve) {
	            if (this.resolve.action && !(this.resolve.action instanceof Function)) {
	                throw new Error(routeName + ' :: expected property \'resolve.action\' to be a function');
	            }
	
	            Object.keys(this.resolve).forEach(function (name) {
	                if (name === 'data') {
	                    _logger.$logger.warn(routeName + ' :: unexpected resolver :: ' + name);
	                } else if (name !== 'action') {
	                    throw new Error(routeName + ' :: unexpected resolver :: ' + name);
	                }
	            });
	        }
	
	        if (this.template) {
	            throw new Error(routeName + ' :: unexpected property \'template\'');
	        }
	
	        if (!this.directive && !this.resolve && !this.resolve.action) {
	            throw new Error(routeName + ' :: expected property \'directive\'');
	        }
	
	        if (this.directive && angular.isString(this.directive) && !this.getDirective()) {
	            throw new Error(routeName + ' :: unknown directive \'' + this.directive + '\'');
	        }
	
	        if (this.directive && !angular.isString(this.directive) && !_component.$Component.isChild(this.directive)) {
	            throw new Error(routeName + ' :: expected directive to be subclass of $Component');
	        }
	
	        if (this.children) {
	            this.children.forEach(function (childSpec) {
	
	                if (!childSpec.route && !childSpec.name) {
	                    throw new Error(routeName + ' :: child expected property \'route\'');
	                }
	
	                var ChildRoute = childSpec.route;
	                var childName = childSpec.name || ChildRoute.name;
	
	                if (!ChildRoute && childSpec.name) {
	                    try {
	                        ChildRoute = _angular.$injector.get(childSpec.name);
	                    } catch (err) {
	                        throw new Error(routeName + ' :: could not find child route \'' + childName + '\'');
	                    }
	                }
	
	                if (!$Route.isChild(ChildRoute)) {
	                    throw new Error(routeName + ' :: ' + childName + ' :: expected child to be instance of $Route');
	                }
	            });
	        }
	    },
	    goto: function goto(route) {
	        return _uiRouter.$state.go(route.replace('this.', this.absolutePath + '.'));
	    },
	    getDirective: function getDirective() {
	        return _angular.$injector.get(_core.$util.dasherizeToCamel(this.getDirectiveTag() + 'Directive'))[0];
	    },
	    getDirectiveTag: function getDirectiveTag() {
	        return angular.isString(this.directive) ? this.directive : this.directive.prototype.tag;
	    },
	
	
	    bootstrap: function bootstrap(defaultState, middleware) {
	        var _this2 = this;
	
	        return (0, _ng.$angularInvoke)(function () {
	            // only bootstrap if not bootstrapped already
	            var element = angular.element(document.body);
	
	            if (!element.injector()) {
	                angular.bootstrap(element, ['app']);
	            }
	
	            return _this2.load(defaultState, middleware);
	        });
	    },
	
	    load: function load(defaultState, middleware) {
	
	        defaultState = defaultState || this.defaultState;
	        middleware = middleware || this.middleware;
	
	        _logger.$logger.info('bootstrap_route', {
	            route: this.path || this.name
	        });
	
	        (0, _ng.$once)('$stateNotFound', function (event, unfoundState, fromState, fromParams) {
	            event.preventDefault();
	
	            _logger.$logger.error('state_not_found', {
	                name: unfoundState.to,
	                from: fromState.name,
	                fromParams: fromParams,
	                hash: window.location.hash
	            });
	
	            throw new Error('state_not_found: ' + unfoundState.to);
	        });
	
	        this.register();
	
	        _uiRouter.$urlRouterProvider.otherwise(function () {
	            return _logger.$logger.info('otherwise_after_bootstrap', {
	                hash: window.location.hash
	            });
	        });
	
	        this.runMiddleware(middleware).then(function () {
	            var targetState = void 0;
	            var targetParams = void 0;
	
	            if (window.location.hash && window.location.hash.indexOf('#/') === 0) {
	
	                targetState = window.location.hash.slice(2).split('?')[0].replace(/^\/+/, '').replace(/\/+$/, '').replace(/\//g, '.');
	
	                targetParams = _core.$util.params(window.location.hash.slice(2).split('?')[1] || '');
	            }
	
	            _logger.$logger.info('initializing_route', {
	                target: targetState,
	                defaultState: defaultState,
	                hash: window.location.hash
	            });
	
	            _angular.$location.replace();
	
	            if (targetState) {
	                if (_uiRouter.$state.get(targetState)) {
	                    _logger.$logger.info('existing_state', {
	                        stateName: targetState
	                    });
	                    return _uiRouter.$state.go(targetState, targetParams)['catch'](function (err) {
	                        // lib/js/security.js event listener handles auth required state changes
	                        // and cancels transitions if user not authenticated
	                        if (err.message === 'transition prevented') {
	                            _logger.$logger.warn('transition_prevented', {
	                                targetState: targetState
	                            });
	                            return _core.$promise.resolve();
	                        }
	                        return _core.$promise.reject(err);
	                    });
	                }
	
	                _logger.$logger.info('unknown_state', {
	                    stateName: targetState
	                });
	            }
	
	            if (_uiRouter.$state.get(defaultState)) {
	                _logger.$logger.info('default_state', {
	                    stateName: defaultState
	                });
	                return _uiRouter.$state.go(defaultState)['catch'](function (err) {
	                    if (err.message === 'transition prevented') {
	                        _logger.$logger.warn('transition_prevented', {
	                            targetState: defaultState
	                        });
	                        return _core.$promise.resolve();
	                    }
	                    return _core.$promise.reject(err);
	                });
	            }
	
	            throw new Error('Default state not found: ' + defaultState);
	        })['catch'](function (err) {
	            return _angular.$injector.get('$exceptionHandler')(err);
	        });
	    },
	
	    runMiddleware: function runMiddleware(middleware) {
	
	        _logger.$logger.info('middleware', {
	            priority: _core.$util.map(middleware, function (method) {
	                return method.name;
	            }).join('|')
	        });
	
	        var promise = _core.$promise.resolve();
	
	        angular.forEach(middleware, function (method) {
	            promise = promise.then(function () {
	
	                if (method.name) {
	                    _logger.$logger.info('middleware_' + method.name);
	                }
	
	                return method();
	            });
	        });
	
	        return promise;
	    },
	
	    register: function register() {
	        var _this3 = this;
	
	        this.template = this.constructTemplate(this.childAttributes || {});
	
	        this.absolutePath = this.path || this.name;
	
	        if (this.parent) {
	            this.absolutePath = this.parent.absolutePath + '.' + this.absolutePath;
	        }
	
	        if (!_uiRouter.$state.get(this.absolutePath)) {
	            _uiRouter.$stateProvider.state(this.absolutePath, this);
	        }
	
	        angular.forEach(this.children, function (childSpec) {
	
	            var ChildRoute = childSpec.route || _angular.$injector.get(childSpec.name);
	
	            var childRoute = new ChildRoute({
	                parent: _this3,
	                childSpec: childSpec,
	                childAttributes: childSpec.attributes
	            });
	
	            childRoute.register();
	        });
	    },
	
	    /**
	     * Constructs the template string for this route. If route.directive = 'xo-add-bank', then the template will be
	     * '<xo-add-bank/>'.
	     * If attributes are specified, they will be passed to directive. Ex: <xo-add-bank attrname = "attrvalue"/>
	     *
	     * @param attributes - A map of name value pairs - {name: value}.
	     * @returns {string}
	     */
	    constructTemplate: function constructTemplate(attributes) {
	        var self = this;
	
	        if (!self.directive) {
	            return;
	        }
	
	        attributes['component-route'] = 'route';
	
	        if (this.parent) {
	            attributes['export'] = 'view';
	        }
	
	        var tag = this.getDirectiveTag();
	
	        var paramString = '';
	
	        angular.forEach(attributes, function (value, key) {
	            paramString += ' ' + key + '="' + value + '"';
	        });
	
	        return '<div ' + tag + ' ' + paramString + '></div>';
	    }
	});
	
	_uiRouter.$stateProvider.state('default', {
	    auth: false
	});
	
	$Route.reopenClass({
	    render: function render() {
	
	        _core.$Model.clearCache();
	        _core.$Api.clearCache();
	
	        _core.$event.emit('$resetState');
	        (0, _locale.$flushContent)();
	
	        _core.$loader.reset();
	
	        _uiRouter.$state.go('default');
	
	        setTimeout.flush();
	
	        var $scope = _angular.$rootScope.$new();
	        var cleanRootScope = (0, _ng.$cleanRootScope)(_angular.$rootScope);
	        var element = (0, _angular.$compile)('<div><ui-view></ui-view></div>')($scope);
	
	        afterEach(_core.$util.once(function () {
	            $scope.$destroy();
	            cleanRootScope();
	            _core.$loader.reset();
	            _core.$Model.clearCache();
	            _core.$Api.clearCache();
	        }));
	
	        var route = new this();
	
	        route.bootstrap();
	        setTimeout.flush();
	
	        element.isolateScope = function () {
	            throw new Error('Please test this element by interfacing with its public api: define mock endpoints, and interact with html links, buttons and form fields');
	        };
	
	        return element;
	    },
	
	
	    assertActive: function assertActive() {
	        assert(_uiRouter.$state.current instanceof this, 'Current state should be "' + (this.prototype.path || this.prototype.name) + '", found "' + _uiRouter.$state.current.name + '"');
	    }
	});
	
	function getPageTitle(stateName) {
	
	    var state = _uiRouter.$state.get(stateName);
	
	    if (!state) {
	        return;
	    }
	
	    if (state.titleContent) {
	        return _locale.$locale.content.get(state.titleContent);
	    }
	}
	
	function changePageTitle() {
	
	    document.documentElement.setAttribute('lang', _locale.$locale.lang);
	
	    if (!_uiRouter.$state.current || !_uiRouter.$state.current.name) {
	        return;
	    }
	
	    var fullStateTitle = [];
	
	    _uiRouter.$state.current.name.split('.').reduce(function (a, b) {
	
	        var stateName = [a, b].filter(Boolean).join('.');
	        var stateTitle = getPageTitle(stateName);
	
	        if (stateTitle) {
	            fullStateTitle.push(stateTitle);
	        }
	
	        return stateName;
	    }, null);
	
	    document.title = _core.$util.unique(fullStateTitle).join(' - ');
	}
	
	_core.$event.on('$stateChangeSuccess', changePageTitle);
	_core.$event.on('contentChange', changePageTitle);
	
	var $ComponentRoute = exports.$ComponentRoute = $Route;
	
	angular.value("$Route", $Route);
	angular.value("$ComponentRoute", $ComponentRoute);
	_angular.$rootScope;
	
	_angular.$location;
	
	_angular.$injector;
	
	_angular.$compile;
	
	_uiRouter.$state;
	
	_uiRouter.$stateProvider;
	
	_uiRouter.$urlRouterProvider;
	
	_logger.$logger;
	
	_core.$config;
	
	_core.$Class;
	
	_core.$Model;
	
	_core.$Api;
	
	_core.$util;
	
	_core.$promise;
	
	_core.$event;
	
	_core.$loader;
	
	_locale.$locale;
	
	_locale.$flushContent;
	
	_component.$Component;
	
	_ng.$cleanRootScope;
	
	_ng.$once;
	
	_ng.$angularInvoke;

/***/ }),

/***/ "./components/squid/dist/locale/index.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _locale = __webpack_require__("./components/squid/dist/locale/locale.js");
	
	Object.keys(_locale).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _locale[key];
	    }
	  });
	});
	
	var _currency = __webpack_require__("./components/squid/dist/locale/currency.js");
	
	Object.keys(_currency).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _currency[key];
	    }
	  });
	});
	
	var _feature = __webpack_require__("./components/squid/dist/locale/feature.js");
	
	Object.keys(_feature).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _feature[key];
	    }
	  });
	});
	
	var _name = __webpack_require__("./components/squid/dist/locale/name.js");
	
	Object.keys(_name).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _name[key];
	    }
	  });
	});
	
	var _quantity = __webpack_require__("./components/squid/dist/locale/quantity.js");
	
	Object.keys(_quantity).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _quantity[key];
	    }
	  });
	});

/***/ }),

/***/ "./components/squid/dist/locale/locale.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$localeHelper = exports.$locale = exports.$LocaleModel = exports.$MetadataModel = exports.$ContentModel = undefined;
	exports.sanitize = sanitize;
	exports.Content = Content;
	exports.$contentVersion = $contentVersion;
	exports.$renderContent = $renderContent;
	exports.$flushContent = $flushContent;
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	function sanitize(html) {
	    return html && html.toString().replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/\//g, '&#x2F;');
	}
	
	var JSONStringify = JSON.stringify;
	
	JSON.stringify = function (item) {
	    if (item instanceof Content) {
	        return item.toString();
	    }
	    return JSONStringify.apply(this, arguments);
	};
	
	function Content(key, props) {
	    this.key = key;
	    this.props = props;
	}
	
	Content.cache = {};
	
	Content.get = function (key, props) {
	
	    if (!key) {
	        return '';
	    }
	
	    props = props || {};
	
	    var cacheKey = $locale.country + '_' + $locale.lang + '_' + key + '_' + JSONStringify.call(JSON, props);
	    var cacheVal = Content.cache[cacheKey];
	
	    if (cacheVal !== undefined) {
	        return cacheVal;
	    }
	
	    cacheVal = Content.cache[cacheKey] = new Content(key, props);
	
	    return cacheVal;
	};
	
	Content.prototype.toString = Content.prototype.valueOf = function () {
	    if (this.string) {
	        return this.string;
	    }
	
	    this.string = this.render(false);
	
	    return this.string;
	};
	
	Content.prototype.toSafeString = function () {
	    if (this.safeString) {
	        return this.safeString;
	    }
	
	    this.safeString = this.render(true);
	
	    return this.safeString;
	};
	
	Content.prototype.render = function (safe) {
	    var _this = this;
	
	    if (!this.key) {
	        return '';
	    }
	
	    var value = contentCache[$locale.country] && contentCache[$locale.country][$locale.lang];
	    var keys = this.key.split('.');
	
	    for (var i = 0; i < keys.length; i++) {
	        if (value) {
	            value = value[keys[i]];
	        } else {
	            break;
	        }
	    }
	
	    if (!value) {
	        return '';
	    }
	
	    return value.replace(/\{\w+\}/g, function (prop) {
	        prop = prop.slice(1, prop.length - 1);
	
	        if (prop === 'country') {
	            return $locale.country;
	        }
	
	        if (prop === 'lang') {
	            return $locale.lang;
	        }
	
	        if (_this.props[prop] === undefined) {
	            if (!_core.$loader.isLoading()) {
	                _logger.$logger.warn('missing_content_prop', {
	                    key: _this.key,
	                    prop: prop
	                }, { unique: true });
	            }
	
	            return '';
	        }
	
	        var propStr = _this.props[prop].toString();
	
	        if (safe) {
	            return sanitize(propStr);
	        }
	
	        return propStr;
	    });
	};
	
	var contentCache = {};
	var currentVersion = void 0;
	
	window.addContent = function (country, lang, content, version) {
	    var countryCache = contentCache[country] = contentCache[country] || {};
	
	    countryCache[lang] = content;
	    currentVersion = version;
	};
	
	var metadataCache = {};
	
	window.addMetadata = function (country, lang, metadata) {
	    var countryCache = metadataCache[country] = metadataCache[country] || {};
	
	    countryCache[lang] = metadata;
	};
	
	function $contentVersion() {
	    return currentVersion || '';
	}
	
	var PP_SPECIAL_COUNTRIES_ISO_CODES = {
	    C2: 'CN'
	};
	
	var $ContentModel = exports.$ContentModel = _core.$Model.extend('$ContentModel', {
	    api: new _core.$Api({
	
	        baseURI: _core.$meta.staticUrl,
	        uri: '/locales/:countryCode/:lang',
	        ext: 'js',
	
	        retrieve: function retrieve(options) {
	            var self = this;
	            var model = options.model;
	
	            var uri = self.getURI(model);
	
	            return _core.$promise.resolve().then(function () {
	
	                if (contentCache[model.countryCode] && contentCache[model.countryCode][model.lang]) {
	                    _logger.$logger.info('cached_content');
	                    return contentCache[model.countryCode][model.lang];
	                }
	
	                _logger.$logger.info('retrieve_content', {
	                    uri: uri
	                });
	
	                _core.$event.emit('loading');
	
	                return _core.$promise.attempt(3, function () {
	                    return _core.$dom.loadScript('content', uri, 10000).then(function () {
	                        if (contentCache[model.countryCode] && contentCache[model.countryCode][model.lang]) {
	                            _logger.$logger.info('content_retrieved');
	                            return contentCache[model.countryCode][model.lang];
	                        }
	
	                        throw new Error('content_not_available');
	                    });
	                })['catch'](function (err) {
	                    throw err;
	                })['finally'](function () {
	                    _core.$event.emit('loaded');
	                });
	            }).then(function (content) {
	                model.setProperties(content);
	                return content;
	            });
	        }
	    }),
	
	    change: function change(country, lang) {
	
	        if (country === this.countryCode && lang === this.lang) {
	            return _core.$promise.resolve(this);
	        }
	
	        this.countryCode = country;
	        this.lang = lang;
	
	        return this.reload().then(function () {
	            _core.$event.broadcast('contentChange');
	        });
	    }
	});
	
	var $MetadataModel = exports.$MetadataModel = _core.$Model.extend('$MetadataModel', {
	
	    api: new _core.$Api({
	
	        baseURI: _core.$meta.staticUrl,
	        uri: '/metadata/:country/:lang/metadata',
	        ext: 'js',
	
	        retrieve: function retrieve(options) {
	            var self = this;
	            var model = options.model;
	
	            var uri = self.getURI(model);
	
	            return _core.$promise.resolve().then(function () {
	
	                if (metadataCache[model.country] && metadataCache[model.country][model.lang]) {
	                    _logger.$logger.info('cached_metadata');
	                    return metadataCache[model.country][model.lang];
	                }
	
	                _logger.$logger.info('retrieve_metadata', {
	                    uri: uri
	                });
	
	                _core.$event.emit('loading');
	
	                return _core.$promise.attempt(3, function () {
	                    return _core.$dom.loadScript('metadata', uri, 10000).then(function () {
	                        if (metadataCache[model.country] && metadataCache[model.country][model.lang]) {
	                            _logger.$logger.info('metadata_retrieved', {
	                                uri: uri
	                            });
	                            return metadataCache[model.country][model.lang];
	                        }
	
	                        // Retry if not found in cache
	                        _logger.$logger.info('metadata_not_available', {
	                            uri: uri
	                        });
	                        return _core.$promise.reject(new Error('metadata_not_available'));
	                    });
	                })['catch'](function (err) {
	                    throw err;
	                })['finally'](function () {
	                    _core.$event.emit('loaded');
	                });
	            }).then(function (metadata) {
	                model.setProperties(metadata);
	                return metadata;
	            });
	        }
	    }),
	
	    change: function change(country, lang) {
	        var _this2 = this;
	
	        this.country = country;
	        this.lang = lang;
	
	        return this.reload().then(function () {
	            if (!_this2.noBroadcast) {
	                _core.$event.broadcast('metadataChange');
	            }
	        });
	    },
	
	    choose: function choose(country, lang, override) {
	
	        if (country && (!this.chosenCountry || override !== false)) {
	            this.chosenCountry = country;
	        }
	
	        if (lang && (!this.chosenLang || override !== false)) {
	            this.chosenLang = lang;
	        }
	
	        country = this.chosenCountry || this.country;
	        lang = this.chosenLang;
	
	        if (_core.$config.supportedCountries) {
	            if (!_core.$config.supportedCountries[country]) {
	                country = this.country;
	            }
	
	            if (_core.$config.supportedCountries[country].indexOf(lang) === -1) {
	                lang = _core.$config.supportedCountries[country][0];
	            }
	        }
	
	        if (!lang) {
	            lang = this.lang;
	        }
	
	        return this.change(country, lang);
	    },
	
	    normalizeAddressFields: function normalizeAddressFields(content) {
	
	        var CONTENT_MAPPING = {
	            line1Label: 'streetAddress',
	            line2Label: 'streetAddress2',
	            cityLabel: 'city',
	            stateLabel: 'state',
	            postcodeLabel: 'postalCode'
	        };
	
	        // Loop over all layout props, if they don't exist in Griffin, get them from xo-content
	        for (var prop in CONTENT_MAPPING) {
	            if (this.addressEntry && this.addressEntry.strings[prop]) {
	                this.addressEntry.strings[prop] = this.addressEntry.strings[prop] || content.get('common.' + CONTENT_MAPPING[prop]);
	            }
	        }
	    }
	});
	
	function mapLanguage(lang) {
	    var unselectableLanguages = _core.$config.unselectableLanguages || [];
	
	    if (unselectableLanguages.indexOf(lang) !== -1) {
	        if (!(_core.$meta.corp && _core.$config.betaLanguages && _core.$config.betaLanguages.indexOf(lang) !== -1)) {
	            return 'en';
	        }
	    }
	
	    var unsupportedLanguages = _core.$config.unsupportedLanguages || [];
	
	    if (unsupportedLanguages.indexOf(lang) !== -1) {
	        if (!(_core.$meta.corp && _core.$config.betaLanguages && _core.$config.betaLanguages.indexOf(lang) !== -1)) {
	            var s = lang + '_locale_not_supported';
	
	            throw new Error(s);
	        }
	    }
	
	    return lang;
	}
	
	var $LocaleModel = exports.$LocaleModel = _core.$Model.extend('LocaleModel', {
	    api: new _core.$Api({
	        uri: '/api/locale'
	    }),
	
	    init: function init() {
	        this._super.init.apply(this);
	        this.content = $ContentModel.instance();
	        this.metadata = $MetadataModel.instance();
	    },
	
	    retrieve: function retrieve() {
	        var self = this;
	
	        return this._super.retrieve.apply(this, arguments).then(function (result) {
	            self.lang = mapLanguage(self.lang);
	            return _core.$promise.all([self.content.change(self.country, self.lang), self.metadata.change(self.country, self.lang)]).then(function () {
	
	                // TODO: This at build time... or make sure griffin metadata is complete
	                self.metadata.normalizeAddressFields(self.content);
	
	                return result;
	            });
	        });
	    },
	
	    change: function change(country, lang) {
	
	        var self = this;
	
	        lang = mapLanguage(lang);
	
	        if (country === this.country && lang === this.lang) {
	            return _core.$promise.resolve(this);
	        }
	
	        _logger.$logger.info('locale_change', {
	            country: country,
	            lang: lang
	        });
	
	        this.country = country;
	        this.lang = lang;
	
	        return _core.$promise.all([this.content.change(country, lang), this.metadata.change(country, lang)]).then(function (loadedData) {
	
	            // TODO: This at build time... or make sure griffin metadata is complete
	            self.metadata.normalizeAddressFields(self.content);
	
	            _core.$event.broadcast('localeChange'); // broadcast only when data has all been loaded
	            return loadedData;
	        });
	    },
	
	    choose: function choose(country, lang, override) {
	
	        if (country && (!this.chosenCountry || override !== false)) {
	            this.chosenCountry = country;
	        }
	
	        if (lang && (!this.chosenLang || override !== false)) {
	            this.chosenLang = lang;
	        }
	
	        country = this.chosenCountry || this.country;
	        lang = this.chosenLang;
	
	        if (!_core.$config.supportedCountries[country]) {
	            country = this.country;
	        }
	
	        if (_core.$config.supportedCountries[country].indexOf(lang) === -1) {
	            lang = _core.$config.supportedCountries[country][0];
	        }
	
	        if (!lang) {
	            lang = this.lang;
	        }
	
	        return this.change(country, lang);
	    },
	
	    chooseCountry: function chooseCountry(country) {
	        return this.choose(country, null);
	    },
	
	    chooseLang: function chooseLang(lang) {
	        return this.choose(null, lang);
	    },
	
	    getLocaleCode: function getLocaleCode() {
	        return this.lang + '_' + this.country;
	    },
	
	    getCountryCodeISO: function getCountryCodeISO() {
	        return PP_SPECIAL_COUNTRIES_ISO_CODES[this.country] || this.country;
	    }
	});
	
	var $locale = exports.$locale = $LocaleModel.instance();
	
	function $renderContent(key, props) {
	    return Content.get(key, props);
	}
	
	function $flushContent() {
	    contentCache = {};
	    Content.cache = {};
	    $locale.content = $ContentModel.create();
	    $locale.metadata = $MetadataModel.create();
	    metadataCache = {};
	}
	
	var $localeHelper = exports.$localeHelper = {
	    /**
	     *
	     * @param locale - Ex: en_US
	     * @returns {{country: *, dialect}}
	     */
	    normalizeLocale: function normalizeLocale(locale) {
	        if (!locale) {
	            return {};
	        }
	
	        locale = locale.replace('-', '_');
	
	        var country = void 0;
	        var language = void 0;
	
	        if (locale.match(/^\w{2}_\w{2}$/)) {
	            locale = locale.split('_');
	
	            language = locale[0];
	            country = locale[1];
	        } else {
	            language = locale;
	        }
	
	        return {
	            country: country,
	            language: language
	        };
	    }
	};
	
	angular.value("sanitize", sanitize);
	angular.value("Content", Content);
	angular.value("$contentVersion", $contentVersion);
	angular.value("$ContentModel", $ContentModel);
	angular.value("$MetadataModel", $MetadataModel);
	angular.value("$LocaleModel", $LocaleModel);
	angular.value("$locale", $locale);
	angular.value("$renderContent", $renderContent);
	angular.value("$flushContent", $flushContent);
	angular.value("$localeHelper", $localeHelper);
	_logger.$logger;
	
	_core.$event;
	
	_core.$Model;
	
	_core.$Api;
	
	_core.$meta;
	
	_core.$promise;
	
	_core.$config;
	
	_core.$loader;
	
	_core.$dom;

/***/ }),

/***/ "./components/squid/dist/locale/currency.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.roundingAndSeparators = roundingAndSeparators;
	exports.formatCurrency = formatCurrency;
	
	var _locale = __webpack_require__("./components/squid/dist/locale/locale.js");
	
	var ALL_NON_BREAKING_SPACE = new RegExp('\xa0+', 'g'); // everything to do with currency formatting
	
	// quick Griffin reference on currency format:
	// ¤ : Currency Symbol = $
	// # : Amount = 186432.431
	// C : Currency Code = USD
	
	var CODE_IN_FRONT = new RegExp('^([^¤#]*)(C[\\s]*)(.*)$'); // matching groups: (any negative symbol)(code)(the rest)
	var ENDS_IN_WHITESPACE = new RegExp('\s$');
	var THOUSANDS_SPLITTER = /\B(?=(\d{3})+(?!\d))/g; // eslint-disable-line fasec/no-unsafe-regex
	var HUNDREDS_SPLITTER = /(\d)(?=(\d\d)+\d$)/g; // eslint-disable-line fasec/no-unsafe-regex
	
	// This seems to be the only currency / locale specific exception in Griffin
	var STYLE_EXCEPTION = {
	    'tr TR TRY': '# ¤;-# ¤'
	};
	
	// Griffin exceptions for separators at hundreds- xx,xx,xxx format
	var HUNDREDS_SEPARATOR_EXCEPTION = ['IN', 'BT', 'MV', 'NP'];
	
	// Griffin "fuzzy logic"
	// apparently if the symbol is at least "66% similar" to the code, ignore it
	function maybeIgnoreSymbol(style, symbol, code) {
	
	    // THIS IS NOT COMMUTATIVE
	    function fuzzyMatch(code, symbol) {
	        // eslint-disable-line no-shadow
	        if (code === symbol) {
	            return 100;
	        } else {
	            var codeParts = code.split('');
	            var symbolParts = symbol.split('');
	
	            var equivalency = codeParts.reduce(function (equiv, codePart) {
	                var symbolPos = symbolParts.indexOf(codePart);
	
	                if (symbolPos !== -1) {
	                    symbolParts.splice(symbolPos, 1);
	                    return equiv + 1;
	                }
	                return equiv;
	            }, 0);
	
	            var weight = equivalency / codeParts.length;
	
	            return weight * 100;
	        }
	    }
	
	    var ignoreSymbol = symbol.length > 1 && fuzzyMatch(code, symbol) >= 66;
	
	    return ignoreSymbol ? style.replace(/¤\s*/g, '') : style;
	}
	
	// deal with rounding due to truncation (Griffin rounds up) as well as dot/comma symbols
	// and thousand separators
	function roundingAndSeparators(amountString, _ref, _ref2) {
	    var lang = _ref.lang,
	        country = _ref.country;
	    var decimalPlaces = _ref2.decimalPlaces,
	        dot = _ref2.dot,
	        comma = _ref2.comma;
	
	    var value = parseFloat(amountString);
	    var truncate = decimalPlaces === 0;
	    var amountParts = truncate && !isNaN(value) ? Math.round(value).toString().split('.') : amountString.split('.');
	
	    var exception = HUNDREDS_SEPARATOR_EXCEPTION.indexOf(country) > -1; // special exceptions
	    var wholeString = exception ? amountParts[0].replace(HUNDREDS_SPLITTER, '$1,') : amountParts[0].replace(THOUSANDS_SPLITTER, comma);
	
	    var decimalString = amountParts[1] || '00';
	    return truncate ? wholeString : '' + wholeString + dot + decimalString;
	}
	
	// this is an agreement with UED for visual consistency - the currency code, if displayed, is always on the right
	function forceCodeToRight(style) {
	    var parts = CODE_IN_FRONT.exec(style) || [];
	    var endsWithWhitespace = ENDS_IN_WHITESPACE.test(style);
	    var newStyle = style;
	
	    // if CODE_IN_FRONT regex matches, array indexes -
	    // [1] negative symbol plus whitespace, if any,
	    // [2] the "C" plus any whitespace,
	    // [3] whatever is after "C"
	    if (parts.length === 4) {
	        newStyle = parts[1] + parts[3] + (endsWithWhitespace ? 'C' : ' C');
	    }
	
	    return newStyle;
	}
	
	// deal with
	// 1. exceptions for specific locales
	// 2. positive and negative styles
	// 3. griffin fuzzy logic
	// 4. UED consistency logic
	function getFinalStyle() {
	    var styleString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ';';
	    var _ref3 = arguments[1];
	    var lang = _ref3.lang,
	        country = _ref3.country;
	    var _ref4 = arguments[2];
	    var value = _ref4.value,
	        _ref4$symbol = _ref4.symbol,
	        symbol = _ref4$symbol === undefined ? '' : _ref4$symbol,
	        code = _ref4.code;
	
	
	    var exception = STYLE_EXCEPTION[[lang, country, code].join(' ')]; // special exceptions
	    var currencyStyle = exception || styleString;
	
	    var _currencyStyle$split = currencyStyle.split(';'),
	        positiveStyle = _currencyStyle$split[0],
	        negativeStyle = _currencyStyle$split[1]; // the style is separated by postive and negative notation via a ;
	
	    var baseStyle = value < 0 ? negativeStyle || '-¤# C' : positiveStyle || '¤# C';
	    var griffinStyle = exception ? baseStyle : maybeIgnoreSymbol(baseStyle, symbol, code); // don't apply fuzzy logic on exceptions
	
	    return forceCodeToRight(griffinStyle);
	}
	
	// take the style and the formatted amount (rounded / truncated / thousands separator / decimal separator)
	// and produce the final result.
	//
	// wrapCodeInSpan - wraps the currency code in a span.currencyCode for styling purposes
	function applyCurrencyStyle(finalStyle, amountFormatted, _ref5) {
	    var symbol = _ref5.symbol,
	        code = _ref5.code,
	        _ref5$wrapCodeInSpan = _ref5.wrapCodeInSpan,
	        wrapCodeInSpan = _ref5$wrapCodeInSpan === undefined ? false : _ref5$wrapCodeInSpan;
	
	    // the style will take care of negative symbol (see getFinalStyle function above)
	    var absoluteAmountFormatted = amountFormatted.replace('-', '');
	
	    // parallel operation is safer than serial replace
	    return finalStyle.split('').map(function (char) {
	        switch (char) {
	            case 'C':
	                return wrapCodeInSpan ? '<span class="currencyCode">' + code + '</span>' : code;
	            case '¤':
	                return symbol;
	            case '#':
	                return absoluteAmountFormatted;
	            default:
	                return char;
	        }
	    }).join('').replace(ALL_NON_BREAKING_SPACE, ' ');
	}
	
	function formatCurrency(amount, code, wrapCodeInSpan) {
	    var style = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'SymbolISOCurrency';
	
	    var _ref6 = _locale.$locale.metadata || {},
	        _ref6$number = _ref6.number,
	        numberConfig = _ref6$number === undefined ? {} : _ref6$number,
	        _ref6$currency = _ref6.currency,
	        currencyConfig = _ref6$currency === undefined ? {} : _ref6$currency;
	
	    var _currencyConfig$digit = currencyConfig.digits,
	        digits = _currencyConfig$digit === undefined ? {} : _currencyConfig$digit,
	        _currencyConfig$style = currencyConfig.styles,
	        styles = _currencyConfig$style === undefined ? {} : _currencyConfig$style,
	        _currencyConfig$suppo = currencyConfig.supportedSymbols,
	        currencySymbols = _currencyConfig$suppo === undefined ? {} : _currencyConfig$suppo;
	
	    var value = parseFloat(amount);
	
	    var dot = numberConfig.DECIMAL_SEP === undefined ? '.' : numberConfig.DECIMAL_SEP;
	    var comma = numberConfig.GROUP_SEP === undefined ? ',' : numberConfig.GROUP_SEP;
	
	    var amountFormatted = roundingAndSeparators(amount.toString(), _locale.$locale, { decimalPlaces: digits[code], dot: dot, comma: comma });
	
	    if (code) {
	        var symbol = currencySymbols[code];
	        var finalStyle = getFinalStyle(styles[style], _locale.$locale, { value: value, symbol: symbol, code: code });
	
	        return applyCurrencyStyle(finalStyle, amountFormatted, { symbol: symbol, code: code, wrapCodeInSpan: wrapCodeInSpan });
	    }
	
	    return amountFormatted; // HTML?
	}
	
	_locale.$locale;

/***/ }),

/***/ "./components/squid/dist/locale/feature.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$feature = $feature;
	exports.$featureCountries = $featureCountries;
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	var _locale = __webpack_require__("./components/squid/dist/locale/locale.js");
	
	function $feature(prop, def, country) {
	
	    var features = _core.$config.features || {};
	
	    country = country || _locale.$locale.country;
	    // 1. Check the feature is present in country
	    var result = _core.$Class.get(features[country], prop);
	
	    if (result !== undefined) {
	        return result;
	    }
	    // 2. Check the feature is present in feature group
	
	    Object.keys(_core.$config.regions).some(function (region) {
	        if (_core.$config.regions[region].indexOf(country) !== -1) {
	            result = _core.$Class.get(features[region], prop);
	            return result !== undefined;
	        }
	
	        return false;
	    });
	
	    if (result !== undefined) {
	        return result;
	    }
	    // 3. Check the feature is present in default group
	    result = _core.$Class.get(features.DEFAULT, prop);
	
	    if (result !== undefined) {
	        return result;
	    }
	    return def;
	}
	
	// Build a list of all countries in our feature list and regions
	// populate countries with out REGION names in the list
	var allCountries = _core.$Class.keys(_core.$config.features || {}).filter(function (country) {
	    return country !== 'DEFAULT' && !(_core.$config.regions && _core.$config.regions.hasOwnProperty(country));
	});
	
	// populate all the region countries in to allcountries
	_core.$util.forEach(_core.$config.regions, function (countries, region) {
	    _core.$util.forEach(countries, function (country) {
	        if (allCountries.indexOf(country) === -1) {
	            allCountries.push(country);
	        }
	    });
	});
	
	function $featureCountries(prop) {
	    // Find the countries with a certain feature enabled
	    return allCountries.filter(function (country) {
	        return $feature(prop, false, country);
	    });
	}
	
	angular.value("$feature", $feature);
	angular.value("$featureCountries", $featureCountries);
	_core.$config;
	
	_core.$Class;
	
	_core.$util;
	
	_locale.$locale;

/***/ }),

/***/ "./components/squid/dist/locale/name.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.formatNameInformal = formatNameInformal;
	
	var _locale = __webpack_require__("./components/squid/dist/locale/locale.js");
	
	// Mapping of Griffin fields to name fields that should be used
	var SUBSTITUTED_FIELDS = {
	    givenName: 'first_name',
	    surname: 'last_name'
	};
	
	// Taken from griffin-paypal: test if a string is Latin
	function isLatin(str) {
	    if (!str) {
	        return true;
	    }
	
	    for (var i = 0; i < str.length; i++) {
	        if (str.charCodeAt(i) > 0x24F) {
	            return false;
	        }
	    }
	
	    return true;
	}
	
	/**
	 * Formats name into informal format based on Griffin metadata
	 * @param  {Object} name The name to be formatted, containing first_name and last_name properties
	 * @return {String}      The formatted string, or null if data is missing
	 */
	function formatNameInformal(name) {
	    var layoutMetadata = _locale.$locale.metadata.nameInformal;
	    var layout = null;
	
	    if (!layoutMetadata) {
	        return name.first_name || null; // Default to first name if metadata not loaded
	    }
	
	    // According to Griffin, if the name is all Latin and there is a Latin formatting variant, use that one
	    if (layoutMetadata['latinLayout'] && isLatin(name.first_name) && isLatin(name.last_name)) {
	        layout = layoutMetadata['latinLayout'];
	    } else {
	        layout = layoutMetadata['layout'];
	    }
	
	    // Map griffin layout parts to the name passed in. If it requires a value not passed in name, returns null early
	    var formattedName = [];
	
	    for (var i = 0; i < layout.length; i++) {
	        var namePart = layout[i];
	
	        if (name[SUBSTITUTED_FIELDS[namePart['$']]]) {
	            formattedName.push(name[SUBSTITUTED_FIELDS[namePart['$']]]);
	        } else if (namePart['$'] === 'separator') {
	            formattedName.push(namePart._);
	        }
	    }
	
	    return formattedName.join('');
	}
	
	_locale.$locale;

/***/ }),

/***/ "./components/squid/dist/locale/quantity.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.formatQuantity = formatQuantity;
	
	var _locale = __webpack_require__("./components/squid/dist/locale/locale.js");
	
	var _currency = __webpack_require__("./components/squid/dist/locale/currency.js");
	
	// format a quantity to add a thousand separator based on a locality
	function formatQuantity(quantity) {
	    var _ref = _locale.$locale.metadata || {},
	        _ref$number = _ref.number,
	        numberConfig = _ref$number === undefined ? {} : _ref$number;
	
	    var dot = '';
	    var comma = numberConfig.GROUP_SEP === undefined ? ',' : numberConfig.GROUP_SEP;
	
	    return (0, _currency.roundingAndSeparators)(quantity.toString(), _locale.$locale, { decimalPlaces: 0, dot: dot, comma: comma });
	}
	
	_locale.$locale;
	
	_currency.roundingAndSeparators;

/***/ }),

/***/ "./components/squid/dist/ng/component.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {
	
	exports.__esModule = true;
	exports.$Component = undefined;
	exports.$populate = $populate;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	var _ng = __webpack_require__("./components/squid/dist/ng/ng.js");
	
	var _directive = __webpack_require__("./components/squid/dist/ng/directive.js");
	
	(0, _directive.$registerDirective)('prevent-default', function () {
	
	    return {
	        restrict: 'A',
	        link: function link($scope, $element, $attrs) {
	            $element.on('click', function (event) {
	                event.preventDefault();
	            });
	        }
	    };
	});
	
	(0, _directive.$registerDirective)('stop-propagation', function () {
	
	    return {
	        restrict: 'A',
	        link: function link($scope, $element, $attrs) {
	            $element.on('click keydown keypress keyup', function (event) {
	                event.stopPropagation();
	            });
	        }
	    };
	});
	
	(0, _directive.$registerDirective)('validate-submit', function () {
	
	    return {
	        link: function link($scope, $element, $attrs) {
	
	            var $form = $element.closest('form');
	            var form = $scope[$form.prop('name')];
	
	            $element.on('click', function (event) {
	                event.preventDefault();
	
	                $form.addClass('validated');
	                $scope.validated = true;
	                form.$setSubmitted();
	
	                if (form.$valid) {
	                    try {
	                        $scope.$eval($attrs.validateSubmit);
	                    } catch (err) {
	                        _angular.$injector.get('$exceptionHandler')(err);
	                    }
	                } else {
	                    $form.find('.ng-invalid:first').focus();
	                }
	            });
	        }
	    };
	});
	
	function assertModelsRetrievedOrEmpty(items) {
	    if (_core.$config.deploy.isLocal() || _core.$config.deploy.isStage()) {
	        angular.forEach(items, function (item, name) {
	            if (item instanceof _core.$Model) {
	                if (item.meta.populated) {
	                    throw new Error(name + ' is already populated. Please call .retrieve() to ensure your code is not relying on cache being present.');
	                }
	            }
	        });
	    }
	}
	
	function setUpComponentRoute($scope, $Component, angular) {
	    var componentRoute = $scope.componentRoute;
	
	    componentRoute.scope = $scope;
	
	    componentRoute.scope.goto = function (route) {
	        componentRoute.goto(route);
	    };
	
	    var parentRoute = componentRoute.parent;
	
	    if (parentRoute) {
	        var parentScope = parentRoute.scope;
	        var parentDirective = parentRoute.getDirective();
	        var childSpec = componentRoute.childSpec;
	
	        if (childSpec.config) {
	            if (parentDirective instanceof $Component) {
	                parentScope.viewConfig = childSpec.config.call(parentScope);
	            } else {
	                throw new Error('In order to use config() for child routes,\n                    ' + parentRoute.getDirectiveTag() + ' must be instance of new\n                    style $Component');
	            }
	        }
	
	        if (childSpec.props) {
	            if (parentDirective instanceof $Component) {
	                angular.extend($scope, childSpec.props.call(parentScope));
	            } else {
	                throw new Error('In order to use props() for child routes,\n                    ' + parentRoute.getDirectiveTag() + ' must be instance of new\n                    style $Component');
	            }
	        }
	    }
	}
	
	var $Component = exports.$Component = _core.$Class.extend('$Component', {
	
	    onPopulate: angular.noop,
	
	    init: function init() {
	        var _this = this,
	            _arguments = arguments;
	
	        this.validate();
	
	        this.name = _core.$util.dasherizeToCamel(this.tag);
	        this.template = '<div class="' + this.tag + '-wrapper" ng-if="populated && display">' + this.template + '</div>';
	
	        this.scope = this.scope || {};
	        this.resolve = this.resolve || {};
	        this.props = this.props || {};
	        this.rootEvents = this.rootEvents || {};
	
	        this.actions = this.actions || {};
	
	        this.lifecycle = this.lifecycle || {};
	        this.lifecycle.enter = this.lifecycle.enter || angular.noop;
	        this.lifecycle.reenter = this.lifecycle.reenter || angular.noop;
	        this.lifecycle.exit = this.lifecycle.exit || angular.noop;
	        this.lifecycle.populate = this.lifecycle.populate || angular.noop;
	
	        if (this.scope && Object.keys(this.scope).length) {
	
	            if (this.props && Object.keys(this.props).length) {
	                throw new Error('Can not defined scope and props on the same component');
	            }
	
	            this.scope.componentRoute = '=';
	            this.scope['export'] = '@';
	
	            this.props = _core.$util.map(this.scope, function (type, key) {
	                return {
	                    type: {
	                        '=': 'var',
	                        '@': 'str'
	                    }[type],
	                    required: false
	                };
	            });
	        } else {
	
	            this.props.componentRoute = {
	                type: 'var',
	                required: false
	            };
	
	            this.props['export'] = {
	                type: 'str',
	                required: false
	            };
	
	            this.scope = _core.$util.map(this.props, function (spec, key) {
	                return {
	                    'var': '=',
	                    'str': '@'
	                }[spec.type || 'var'];
	            });
	        }
	
	        var originalController = this.controller || angular.noop;
	
	        this.controller = function ($scope, $element) {
	            $scope.$element = $element;
	
	            $scope.$on('$destroy', function () {
	                if ($scope.componentRoute && $scope.componentRoute.parent && $scope.componentRoute.parent.scope) {
	                    delete $scope.componentRoute.parent.scope.viewConfig;
	                }
	                _this.lifecycle.exit.call($scope);
	            });
	
	            $scope.props = {};
	
	            if ($scope.componentRoute) {
	                setUpComponentRoute($scope, $Component, angular);
	            }
	
	            angular.forEach(_this.props, function (type, key) {
	
	                var prop = _this.props[key];
	                var required = prop.required !== false;
	                var def = void 0;
	
	                if (prop['default'] instanceof Function) {
	                    def = _core.$util.memoize(prop['default'].bind($scope));
	                } else {
	                    def = function def() {
	                        return prop['default'];
	                    };
	                }
	
	                var UNDEFINED = {
	                    'var': undefined,
	                    str: ''
	                }[prop.type];
	
	                Object.defineProperty($scope.props, key, {
	                    get: function get() {
	                        var val = $scope[key];
	
	                        if (val === UNDEFINED) {
	                            if (required) {
	                                throw new Error('Prop required for component :: ' + _this.tag + ' :: ' + key);
	                            }
	
	                            return def();
	                        }
	
	                        return val;
	                    },
	
	                    set: function set() {
	                        throw new Error('Prop is immutable :: ' + _this.tag + ' :: ' + key);
	                    }
	                });
	            });
	
	            $scope.fields = {};
	
	            $scope.actions = _core.$util.bindObject(_this.actions, $scope);
	
	            Object.keys(_this.rootEvents).forEach(function (eventName) {
	                var cancel = _core.$event.on(eventName, function (event) {
	                    _this.rootEvents[eventName].apply($scope, _arguments);
	                });
	
	                $scope.$on('$destroy', cancel);
	            });
	
	            $scope.display = true;
	
	            $scope.reload = function () {
	
	                if (!$scope.populated) {
	                    throw new Error('Can not reload unpopulated component');
	                }
	
	                $scope.display = false;
	                setTimeout(function () {
	                    $scope.display = true;
	                });
	            };
	
	            $scope.componentScope = $scope;
	
	            if ($scope.props['export'] && $scope.$parent.componentScope) {
	
	                $scope.exports = angular.extend({}, _this.exports || {}, {
	                    reload: $scope.reload
	                });
	
	                Object.defineProperty($scope.$parent.componentScope, $scope.props['export'], {
	                    get: function get() {
	                        return $scope.exports;
	                    },
	
	                    configurable: true
	                });
	            }
	
	            $scope._enablePopulateEvents = true;
	
	            _angular.$injector.invoke(originalController, _this, { $scope: $scope, $element: $element });
	            _this.lifecycle.enter.call($scope);
	
	            $scope._enablePopulateEvents = false;
	
	            var cancelReEnterEvent = _core.$event.on('$stateChangeSuccess', function (event, toState) {
	                if (toState === $scope.props.componentRoute) {
	                    _this.lifecycle.reenter.call($scope);
	                }
	            });
	
	            $scope.$on('$destroy', cancelReEnterEvent);
	
	            return _core.$promise.sequential([function () {
	                $scope.$emit('_populating');
	            }, function () {
	                return _core.$promise.map(_this.resolve, function (resolver, name, resolverPromises) {
	
	                    if (angular.isObject(resolver)) {
	                        $scope[name] = resolver;
	                        return resolver;
	                    }
	
	                    return _core.$promise.resolve(resolver.call($scope, resolverPromises)).then(function (data) {
	                        assertModelsRetrievedOrEmpty(data);
	
	                        return _core.$promise.hash(data).then(function (resolvedData) {
	
	                            $scope[name] = resolvedData;
	                            return resolvedData;
	                        });
	                    });
	                });
	            }, function () {
	
	                $scope.populated = true;
	
	                $scope.$emit('_populated');
	
	                _core.$event.refCount($scope, '_populating', '_populated').then(function () {
	
	                    $scope.$on('populated', function (populatedEvent) {
	                        populatedEvent.stopPropagation();
	                    });
	
	                    $scope.$emit('populated');
	                    _this.onPopulate.call($scope);
	                    _this.lifecycle.populate.call($scope);
	                });
	            }]);
	        };
	    },
	
	    validate: function validate() {
	
	        if (_core.$config.deploy.isLive() && !_core.$config.deploy.isTest()) {
	            return;
	        }
	
	        var componentName = this.constructor.name;
	
	        if (!this.tag) {
	            throw new Error(componentName + ' :: expected property \'tag\'');
	        }
	
	        if (!this.tag.match(/^[a-z0-9-]+$/)) {
	            throw new Error(componentName + ' :: tag should contain only lowercase alphanumeric characters and dashes');
	        }
	
	        if (!this.template) {
	            throw new Error(componentName + ' :: expected property \'template\'');
	        }
	
	        if (this.resolve) {
	            angular.forEach(this.resolve, function (resolver, name) {
	                if (!(resolver instanceof Function)) {
	                    throw new Error(componentName + ' :: expected \'resolve.' + name + '\' to be a function');
	                }
	            });
	        }
	
	        if (this.props) {
	            angular.forEach(this.props, function (prop, name) {
	
	                if (!(prop instanceof Object)) {
	                    throw new Error(componentName + ' :: expected \'props.' + name + '\' to be a function');
	                }
	
	                if (prop.type && ['var', 'str'].indexOf(prop.type) === -1) {
	                    throw new Error(componentName + ' :: expected \'props.' + name + '.type\' to be one of var, str');
	                }
	
	                if (prop['default'] && prop.required) {
	                    throw new Error(componentName + ' :: unnecessary \'props.' + name + '.default\', since prop is required');
	                }
	
	                if (prop['default'] && prop['default'] instanceof Object && !(prop['default'] instanceof Function)) {
	                    throw new Error(componentName + ' :: expected \'props.' + name + '.default\' to be a primitive or a function - please do not pass mutable objects');
	                }
	            });
	        }
	
	        if (this.actions) {
	            angular.forEach(this.actions, function (action, name) {
	                if (!(action instanceof Function)) {
	                    throw new Error(componentName + ' :: expected \'actions.' + name + '\' to be a function');
	                }
	            });
	        }
	
	        if (this.lifecycle) {
	            Object.keys(this.lifecycle).forEach(function (name) {
	                if (['enter', 'populate', 'exit', 'reenter'].indexOf(name) === -1) {
	                    throw new Error(componentName + ' :: unexpected \'lifecycle.' + name + '\'');
	                }
	            });
	        }
	    }
	});
	
	$Component.reopenClass({
	
	    extend: function extend() {
	
	        var SubClass = _core.$Class.extend.apply(this, arguments);
	        var spec = new SubClass();
	
	        angular.module().directive(spec.name, function () {
	            return spec;
	        });
	
	        return SubClass;
	    },
	
	    render: function render(scope) {
	        _core.$Model.clearCache();
	        _core.$Api.clearCache();
	        _core.$event.emit('$resetState');
	
	        var $scope = _angular.$rootScope.$new();
	
	        angular.extend($scope, scope);
	
	        var attrs = Object.keys(scope).map(function (key) {
	            return _core.$util.camelToDasherize(key) + '="' + (this.prototype.props[key].type === 'var' ? key : scope[key]) + '"';
	        }.bind(this)).join(' ');
	
	        var cleanRootScope = (0, _ng.$cleanRootScope)(_angular.$rootScope);
	        var html = '<' + this.prototype.tag + ' ' + attrs + '></' + this.prototype.tag + '>';
	
	        console.log('RENDER', html, scope);
	
	        var element = (0, _angular.$compile)(html)($scope);
	
	        afterEach(_core.$util.once(function () {
	            $scope.$destroy();
	            cleanRootScope();
	        }));
	
	        setTimeout.flush();
	
	        element.isolateScope = function () {
	            throw new Error('Please test this element by interfacing with its public api: define mock endpoints, and interact with html links, buttons and form fields');
	        };
	
	        return element;
	    }
	});
	
	function autoConvertDirectiveToComponent(_ref, original) {
	    var name = _ref[0],
	        factory = _ref[1];
	
	
	    if (!angular.isFunction(factory)) {
	        return original();
	    }
	
	    var tag = _core.$util.camelToDasherize(name);
	    var spec = _angular.$injector.invoke(factory);
	
	    if (spec.controller) {
	        var originalController = spec.controller;
	
	        spec.controller = function ($scope, $element) {
	            $scope._enablePopulateEvents = true;
	            var result = _angular.$injector.invoke(originalController, this, { $scope: $scope, $element: $element });
	
	            $scope._enablePopulateEvents = false;
	            return result;
	        };
	    }
	
	    if (spec instanceof $Component || !spec.template || !spec.controller || name.indexOf('xo') !== 0 || spec.transclude) {
	        return original(this, [name, function () {
	            return spec;
	        }]);
	    }
	
	    if (spec.componentize) {
	
	        $Component.extend('$' + name + 'Component', spec, {
	            tag: tag
	        });
	
	        return this;
	    }
	
	    return original(this, [name, function () {
	        return spec;
	    }]);
	}
	
	_core.$util.monkeyPatch(_angular.$compileProvider, 'directive', autoConvertDirectiveToComponent);
	_core.$util.monkeyPatch(angular.module(), 'directive', autoConvertDirectiveToComponent);
	
	// $populate needs to go away
	
	function $populate($scope, instances) {
	
	    $scope.$on = $scope.$on || angular.noop;
	    $scope.$emit = $scope.$emit || angular.noop;
	
	    var _enablePopulateEvents = $scope._enablePopulateEvents;
	
	    if (_enablePopulateEvents) {
	        _core.$event.refCount($scope, '_populating', '_populated').then(function () {
	            $scope.$emit('populated');
	        });
	    }
	
	    $scope.$on('populated', function (populatedEvent) {
	        populatedEvent.stopPropagation();
	    });
	
	    if (_enablePopulateEvents) {
	        $scope.$emit('_populating');
	    }
	
	    return _core.$promise.all(_core.$util.map(instances, function (instance, name) {
	
	        var promise = void 0;
	
	        if (instance.then) {
	            promise = instance;
	        } else {
	            promise = instance.retrieve();
	            $scope[name] = instance;
	        }
	
	        return promise.then(function (result) {
	            $scope[name] = result;
	            return result;
	        });
	    })).then(function (result) {
	
	        if (_enablePopulateEvents) {
	            $scope.$emit('_populated');
	        }
	
	        return result;
	    });
	}
	
	angular.value("$Component", $Component);
	angular.value("$populate", $populate);
	_angular.$rootScope;
	
	_angular.$compile;
	
	_angular.$injector;
	
	_angular.$compileProvider;
	
	_core.$Class;
	
	_core.$Model;
	
	_core.$Api;
	
	_core.$util;
	
	_core.$promise;
	
	_core.$config;
	
	_core.$event;
	
	_ng.$cleanRootScope;
	
	_directive.$registerDirective;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ }),

/***/ "./components/squid/dist/ng/ng.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$angularInvoke = $angularInvoke;
	exports.$once = $once;
	exports.$cleanRootScope = $cleanRootScope;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	function $angularInvoke(method) {
	    try {
	        return method();
	    } catch (err) {
	        _angular.$injector.get('$exceptionHandler')(err);
	    }
	}
	
	function $once(name, handler) {
	    var cancel = _core.$event.on(name, function () {
	        cancel();
	        handler.apply(this, arguments);
	    }, true);
	}
	
	function $cleanRootScope(rootScope) {
	
	    var keys = Object.keys(rootScope);
	
	    var autoCleanupEventHandlers = [];
	    var eventHandlers = [];
	    var eventCancelers = [];
	
	    _core.$util.monkeyPatch(rootScope, '$on', function (_ref, original) {
	        var name = _ref[0],
	            handler = _ref[1],
	            once = _ref[2];
	
	
	        var cancel = original();
	
	        var $state = void 0;
	
	        try {
	            $state = _angular.$injector.get('$state');
	        } catch (err) {
	            // pass
	        }
	
	        if (name === '$destroy' || !$state || !$state.current || !$state.current.name || $state.current.name === 'default') {
	            autoCleanupEventHandlers.push(cancel);
	            return function autoCleanedUpCancel() {}; // eslint-disable-line no-empty-function
	        }
	
	        if (once) {
	            eventCancelers.push(cancel);
	            return cancel;
	        }
	
	        // Let ng-router do its thing
	        if (handler.toString().indexOf('updateView') !== -1) {
	            return cancel;
	        }
	
	        var stack = void 0;
	
	        try {
	            throw new Error('$rootScope.$on');
	        } catch (err) {
	            stack = err.stack;
	        }
	
	        var reference = {
	            name: name,
	            handler: handler.toString(),
	            stack: stack
	        };
	
	        eventHandlers.push(reference);
	
	        return function () {
	            cancel();
	            eventHandlers.splice(eventHandlers.indexOf(reference), 1);
	        };
	    });
	
	    return function () {
	
	        _core.$event.emit('$destroy');
	
	        autoCleanupEventHandlers.forEach(function (canceler) {
	            return canceler();
	        });
	        autoCleanupEventHandlers = [];
	
	        Object.keys(rootScope).forEach(function (key) {
	            if (keys.indexOf(key) === -1) {
	                delete rootScope[key];
	            }
	        });
	
	        if (eventHandlers.length) {
	            throw new Error('$rootScope event handlers not cleaned up:\n\n' + eventHandlers.map(function (eventHandler) {
	                return eventHandler.name + '\n\n' + eventHandler.handler + '\n\n' + eventHandler.stack;
	            }).join('\n\n'));
	        }
	
	        eventCancelers.forEach(function (cancel) {
	            return cancel();
	        });
	    };
	}
	
	angular.value("$angularInvoke", $angularInvoke);
	angular.value("$once", $once);
	angular.value("$cleanRootScope", $cleanRootScope);
	_angular.$injector;
	
	_core.$util;
	
	_core.$event;

/***/ }),

/***/ "./components/squid/dist/ng/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$registerDirective = $registerDirective;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function $registerDirective(tag, definition) {
	
	    var directiveName = tag.replace(/-([a-z])/g, function (g) {
	        return g[1].toUpperCase();
	    });
	
	    return _angular2["default"].module().directive(directiveName, definition);
	}
	
	_angular2["default"].value("$registerDirective", $registerDirective);

/***/ }),

/***/ "./components/squid/dist/ng/feature.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	var _directive = __webpack_require__("./components/squid/dist/ng/directive.js");
	
	var _locale = __webpack_require__("./components/squid/dist/locale/index.js");
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	(0, _directive.$registerDirective)('feature', function () {
	    return {
	        restrict: 'A',
	        transclude: true,
	        scope: {},
	        template: '<span ng-if="enabled()" ng-transclude></span>',
	        link: function link($scope, element, attr) {
	            $scope.enabled = function () {
	                return (0, _locale.$feature)(attr.feature) || _core.$integration.getConfig(attr.feature);
	            };
	        }
	    };
	});
	
	(0, _directive.$registerDirective)('unless-feature', function () {
	    return {
	        restrict: 'A',
	        transclude: true,
	        scope: {},
	        template: '<span ng-if="!enabled()" ng-transclude></span>',
	        link: function link($scope, element, attr) {
	            $scope.enabled = function () {
	                return (0, _locale.$feature)(attr.unlessFeature) || _core.$integration.getConfig(attr.unlessFeature);
	            };
	        }
	    };
	});
	_directive.$registerDirective;
	
	_locale.$feature;
	
	_core.$integration;

/***/ }),

/***/ "./components/squid/dist/ng/locale.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	var _locale = __webpack_require__("./components/squid/dist/locale/index.js");
	
	(0, _angular.$registerDirective)('content', function () {
	    return {
	        restrict: 'A',
	
	        link: function link($scope, element, attributes) {
	            $scope.content = $scope.htmlContent = function (key, props) {
	                if (attributes.content) {
	                    key = attributes.content + '.' + key;
	                }
	                var content = _locale.Content.get(key, props);
	
	                if (content.toString()) {
	                    return content;
	                } else {
	                    return;
	                }
	            };
	        }
	    };
	});
	
	(0, _angular.$registerDirective)('bind-html-compile', function () {
	
	    return {
	        restrict: 'A',
	        link: function link($scope, $element, $attrs) {
	            $scope.$watch(function () {
	                return $scope.$eval($attrs.bindHtmlCompile);
	            }, function (value) {
	                $element.html(value && value.toString());
	                (0, _angular.$compile)($element.contents())($scope);
	            });
	        }
	    };
	});
	
	(0, _angular.$registerDirective)('format-currency', function () {
	
	    return {
	        restrict: 'E',
	        template: '<span ng-bind-html="amount_formatted" class="ltrOverride"></span>',
	        scope: {
	            amount: '=',
	            symbol: '=',
	            code: '=',
	            currencyStyle: '@'
	        },
	        controller: function controller($scope) {
	
	            function format() {
	                $scope.amount_formatted = _angular.$sce.trustAsHtml((0, _locale.formatCurrency)($scope.amount, $scope.code, true, $scope.currencyStyle));
	            }
	
	            $scope.$on('$destroy', _core.$event.on('localeChange', format));
	
	            $scope.$watch('amount', function (newValue, oldValue) {
	                if (newValue !== oldValue && _locale.$locale.country) {
	                    format();
	                }
	            });
	
	            if (_locale.$locale.country) {
	                format();
	            }
	        } // controller
	    }; // return
	}); // registerDirective
	
	
	(function exportProviders(angular) {
	    angular && angular.exportProviders(module, exports, __dirname, __filename);
	})(window.angular);
	
	angular.module().value('$sanitize', function (val) {
	    if (val instanceof _locale.Content) {
	        return val.toSafeString();
	    }
	    return (0, _locale.sanitize)(val);
	});
	
	_angular.$sce;
	
	_angular.$registerDirective;
	
	_angular.$compile;
	
	_core.$event;
	
	_locale.formatCurrency;
	
	_locale.sanitize;
	
	_locale.Content;
	
	_locale.$locale;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/squid/dist/ng", "components/squid/dist/ng/locale.js"))

/***/ }),

/***/ "./components/squid/dist/ng/module.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.module = undefined;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _module = _angular2['default'].module;
	exports.module = _module;

/***/ }),

/***/ "./components/squid/dist/ng/events.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	angular.module().run(function () {
	
	    _core.$event.on('$stateChangeStart', function (event) {
	        _core.$event.emit('loading');
	        _core.$event.emit('loaded');
	    });
	
	    var startLoadTime = 0;
	    var currentState = 'checkout_init';
	
	    function currentStateName() {
	        return _uiRouter.$state.current.name && _uiRouter.$state.current.name.replace(/\./g, '_');
	    }
	
	    _core.$event.on('startLoad', function () {
	
	        if (startLoadTime) {
	            startLoadTime = _core.$util.now();
	        } else if (window.enablePerformance && window.performance.timing.connectEnd && window.performance.timing.navigationStart) {
	
	            var performance = window.performance;
	            var timing = window.performance.timing || {};
	            var now = performance.now();
	
	            startLoadTime = parseInt(now - (timing.connectEnd - timing.navigationStart), 10);
	        }
	    });
	
	    _core.$event.on('allLoaded', function () {
	
	        var newState = currentStateName();
	
	        if (!newState) {
	            return;
	        }
	
	        if (currentState === newState) {
	            _core.$event.emit('page_reloaded', currentState);
	        } else {
	
	            var duration = void 0;
	
	            if (startLoadTime) {
	                duration = _core.$util.now() - startLoadTime;
	            }
	
	            var payload = {
	                start: currentState,
	                end: newState,
	                time: duration,
	                duration: duration
	            };
	
	            _core.$event.emit('$transition', {
	                from: currentState,
	                toState: _uiRouter.$state.current,
	                duration: duration
	            });
	
	            _logger.$logger.info('transition', payload);
	            _logger.$logger.info('transition_' + currentState + '_to_' + newState, payload);
	
	            _core.$event.emit('page_loaded', currentState, newState);
	            _logger.$logger.flush();
	
	            currentState = newState;
	        }
	    });
	
	    _core.$event.emit('loading');
	
	    var cancel = _core.$event.on('$stateChangeSuccess', function () {
	        if (_uiRouter.$state.current.template) {
	            cancel();
	            setTimeout(function () {
	                _core.$event.emit('loaded');
	            }, 50);
	        }
	    });
	});
	
	_uiRouter.$state;
	
	_logger.$logger;
	
	_core.$event;
	
	_core.$util;

/***/ }),

/***/ "./components/squid/dist/ng/pxp.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	_core.$event.on('pxp_res', function (event, pxpRes) {
	    _uiRouter.$state.current.trackingData = _uiRouter.$state.current.trackingData || {};
	    _uiRouter.$state.current.trackingData.pxpData = _uiRouter.$state.current.trackingData.pxpData || [];
	    _uiRouter.$state.current.trackingData.pxpData.push(pxpRes);
	});
	
	_uiRouter.$state;
	
	_core.$event;

/***/ }),

/***/ "./components/squid/dist/paypal/index.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _env = __webpack_require__("./components/squid/dist/paypal/env.js");
	
	Object.keys(_env).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _env[key];
	    }
	  });
	});
	
	var _config = __webpack_require__("./components/squid/dist/paypal/config.js");
	
	Object.keys(_config).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _config[key];
	    }
	  });
	});
	
	var _pxp = __webpack_require__("./components/squid/dist/paypal/pxp.js");
	
	Object.keys(_pxp).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _pxp[key];
	    }
	  });
	});

/***/ }),

/***/ "./components/squid/dist/paypal/env.js":
/***/ (function(module, exports) {

	
	
	exports.__esModule = true;
	var $env = exports.$env = {
	
	    isLocal: function isLocal() {
	        return window.location.hostname === 'localhost' || window.location.hostname === 'localhost.paypal.com';
	    },
	
	    isStage: function isStage() {
	        return Boolean(window.location.hostname.match(/^.*\.qa\.paypal\.com$/));
	    },
	
	    isSandbox: function isSandbox() {
	        return Boolean(window.location.hostname.match(/^.*\.sandbox\.paypal\.com$/));
	    },
	
	    isLive: function isLive() {
	        return window.location.hostname === 'www.paypal.com';
	    },
	
	    isTest: function isTest() {
	        return false;
	    }
	};
	
	angular.value("$env", $env);

/***/ }),

/***/ "./components/squid/dist/paypal/config.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	var _env = __webpack_require__("./components/squid/dist/paypal/env.js");
	
	_core.$config.deploy = _core.$config.deploy || _env.$env;
	
	_core.$config;
	
	_env.$env;

/***/ }),

/***/ "./components/squid/dist/paypal/pxp.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$PXPModel = undefined;
	exports.$getPxpTreatments = $getPxpTreatments;
	exports.$pxp = $pxp;
	exports.$pxpMatch = $pxpMatch;
	exports.$pxpFactors = $pxpFactors;
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	var _locale = __webpack_require__("./components/squid/dist/locale/index.js");
	
	var $PXPModel = exports.$PXPModel = _core.$Model.extend({
	    api: new _core.$Api({
	        uri: '/api/pxp/:pagename'
	    })
	});
	
	function logPxp(pxpRes, params, logPayload) {
	    var exp_name = [];
	    var xe = [];
	    var xt = [];
	
	    angular.forEach(pxpRes.treatments, function (treatment) {
	
	        _logger.$logger.info('treatment_' + treatment.treatment_name, angular.extend({
	            experiment: pxpRes.pagename,
	            treatment: treatment.treatment_name,
	            experiment_id: treatment.experiment_id,
	            treatment_id: treatment.treatment_id,
	            loc_country: _locale.$locale.country,
	            loc_lang: _locale.$locale.lang
	        }, params, logPayload));
	
	        exp_name.push(treatment.treatment_name);
	        xe.push(treatment.experiment_id);
	        xt.push(treatment.treatment_id);
	    });
	
	    _logger.$logger.info('pxp_' + pxpRes.pagename, angular.extend({
	        pxp_exp_id: xe.join('|'),
	        pxp_trtmnt_id: xt.join('|'),
	        treatments: exp_name.join('|'),
	        loc_country: _locale.$locale.country,
	        loc_lang: _locale.$locale.lang
	    }, params, logPayload));
	
	    _logger.$logger.info('fpti_pxp_check', {
	        from: 'PXP_CHECK',
	        to: 'process_pxp_check',
	        pxp_exp_id: xe.join(','),
	        pxp_trtmnt_id: xt.join(',')
	    });
	
	    _core.$event.emit('pxp_res', pxpRes);
	}
	
	function $getPxpTreatments(id, params, logPayload) {
	    var forceApiCall = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	
	    return _core.$promise.run(function () {
	        var pxp = $PXPModel.instance(_core.$util.buildURL(id, params), { pagename: id });
	        var forceTreatments = _core.$util.param('pxp_' + id);
	
	        if (forceTreatments) {
	            var treatments = forceTreatments.split(',').filter(Boolean);
	
	            pxp.treatments = treatments.map(function (treatment_name) {
	                return {
	                    treatment_name: treatment_name
	                };
	            });
	
	            return pxp;
	        }
	
	        if (forceApiCall) {
	            return pxp.reload({
	                params: params
	            });
	        }
	
	        return pxp.retrieve({
	            params: params
	        });
	    }).then(function (pxp) {
	
	        if (!pxp.cached) {
	            logPxp(pxp, params, logPayload);
	        }
	
	        pxp.cached = true;
	
	        return pxp;
	    });
	}
	
	function $pxp(id, params, pattern) {
	    var forceApiCall = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	    if (!pattern) {
	        pattern = params;
	        params = {};
	    }
	
	    pattern = new RegExp('^' + pattern + '$');
	
	    return exports.$getPxpTreatments(id, params, null, forceApiCall).then(function (pxpResponse) {
	        var result = void 0;
	
	        (pxpResponse.treatments || []).some(function (treatment) {
	            if (!pattern.test(treatment.treatment_name)) {
	                return false;
	            }
	
	            result = {
	                treatment_name: treatment.treatment_name,
	                factors: treatment.factors
	            };
	
	            return true;
	        });
	
	        return result;
	    });
	}
	
	function $pxpMatch(id, params, patterns, logPayload) {
	    if (!patterns) {
	        patterns = params;
	        params = {};
	    }
	
	    return exports.$getPxpTreatments(id, params, logPayload).then(function (pxpResponse) {
	        var result = {};
	
	        angular.forEach(patterns, function (pattern, name) {
	            pattern = new RegExp('^' + pattern + '$');
	            result[name] = false;
	
	            (pxpResponse.treatments || []).some(function (treatment) {
	                if (!pattern.test(treatment.treatment_name)) {
	                    return false;
	                }
	
	                result[name] = true;
	                return true;
	            });
	        });
	
	        return result;
	    });
	}
	
	function $pxpFactors(id, params, pattern) {
	    params.factors = 'true';
	    return $pxp(id, params, pattern).then(function (pxpResponse) {
	        var result = void 0;
	
	        if (pxpResponse && pxpResponse.factors) {
	            result = { treatment_name: pxpResponse.treatment_name };
	            var pxpFactors = pxpResponse.factors;
	            var length = pxpFactors.length;
	
	            for (var i = 0; i < length; i++) {
	                result[pxpFactors[i].name] = pxpFactors[i].value;
	            }
	        }
	
	        return result;
	    });
	}
	
	window.$pxp = $pxp;
	
	angular.value("$getPxpTreatments", $getPxpTreatments);
	angular.value("$pxp", $pxp);
	angular.value("$pxpMatch", $pxpMatch);
	angular.value("$pxpFactors", $pxpFactors);
	_logger.$logger;
	
	_core.$Model;
	
	_core.$Api;
	
	_core.$util;
	
	_core.$promise;
	
	_core.$event;
	
	_locale.$locale;

/***/ }),

/***/ "./components/xo-models/src/checkout/index.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$CheckoutSessionModel = exports.$CheckoutPlanModel = exports.$CheckoutShippingAddressesModel = exports.$CreditOptionsModel = exports.$CheckoutPayeeModel = exports.$ShippingAddressModel = exports.$CheckoutShippingAddressModel = exports.$FlowEligibilityModel = exports.$InstallmentOptionsModel = exports.$FundingOptionsModel = exports.$FundingSourceModel = exports.$CheckoutAppDataModel = exports.$CheckoutCartModel = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $CheckoutCartModel = exports.$CheckoutCartModel = _squid.$Model.extend('$CheckoutCartModel', {
	    api: new _squid.$Api({
	        uri: '/api/checkout/:id/cart',
	        cache: true
	    }),
	
	    isPurchase: function isPurchase() {
	        return Boolean(this.purchase);
	    },
	
	    isBilling: function isBilling() {
	        return Boolean(this.billing);
	    },
	
	    isBillingPurchase: function isBillingPurchase() {
	        return this.isPurchase() && this.isBilling();
	    },
	
	    isBillingNoPurchase: function isBillingNoPurchase() {
	        return this.isBilling() && !this.isPurchase();
	    },
	
	    getBillingDescription: function getBillingDescription() {
	        return this.billing && this.billing.description;
	    },
	
	    isMultiSellerPurchase: function isMultiSellerPurchase() {
	        return this.purchaseUnits && this.purchaseUnits.length > 1;
	    },
	
	    isShippingMethodStorePickUp: function isShippingMethodStorePickUp() {
	        return this.purchase && (this.purchase.shipping_method === '29' || this.purchase.shipping_method === '21');
	    },
	
	    isWalletTokenization: function isWalletTokenization() {
	        return this.billing && this.billing.intent === 'TOKENIZED_WALLET';
	    },
	    getExternalCallbackOptions: function getExternalCallbackOptions() {
	        return this.purchaseUnits && this.purchaseUnits[0] && this.purchaseUnits[0].external_callback_options;
	    }
	});
	
	var $CheckoutAppDataModel = exports.$CheckoutAppDataModel = _squid.$Model.extend('$CheckoutAppDataModel', {
	
	    api: new _squid.$Api({
	        uri: '/api/checkout/:id/appData'
	    }),
	
	    useraction: function useraction() {
	        // user_action from session takes precedence over CGI param.
	        var incontext_integration = window.xchild && window.xchild.props.commit ? 'commit' : false;
	        var rest_integration = this.flags && this.flags.user_action === 'PAY' ? 'commit' : false;
	
	        return rest_integration || incontext_integration || _squid.$util.param('useraction');
	    },
	
	    doec_on_approve: function doec_on_approve() {
	        return this.flags && this.flags.doec_on_approve;
	    }
	});
	
	var $FundingSourceModel = exports.$FundingSourceModel = _squid.$Model.extend('$FundingSourceModel', {
	
	    formatLast4: function formatLast4() {
	        var last4;
	
	        if (this.last4) {
	            last4 = this.last4;
	
	            if (!this.parent.isAuthRequired) {
	                last4 = 'x-' + last4;
	            }
	        }
	
	        return last4;
	    }
	});
	
	var $FundingOptionsModel = exports.$FundingOptionsModel = _squid.$Model.extend('$FundingOptionsModel', {
	    api: new _squid.$Api({
	        uri: '/api/checkout/:id/fundingOptions',
	        postAttempts: 2
	    }),
	
	    eachPlan: function eachPlan(method, context) {
	        angular.forEach(this.plans, method, this);
	    },
	
	    hasECheck: function hasECheck() {
	        return _squid.$util.some(this.instruments, function (instrument) {
	            return instrument.type === 'ECHECK' || instrument.subtype === 'ECHECK';
	        });
	    },
	
	    hasCredit: function hasCredit() {
	        return _squid.$util.some(this.instruments, function (instrument) {
	            return instrument.type === 'CREDIT';
	        });
	    },
	
	    getBankPlanIdByInstrumentId: function getBankPlanIdByInstrumentId(id, subType) {
	        var fundingInstrument = _squid.$util.find(this.plans, function (plan) {
	            return plan.primaryFs && plan.primaryFs.type === 'BANK' && plan.primaryFs.id === id && plan.primaryFs.subtype === subType;
	        });
	
	        return fundingInstrument && fundingInstrument.planId;
	    },
	
	    onPopulate: function onPopulate() {
	        var self = this;
	        angular.forEach(this.plans, function (plan) {
	            if (plan.primaryFs && plan.primaryFs.type === 'BANK' && (plan.primaryFs.subtype === 'IACH' || plan.primaryFs.subtype === 'PAD')) {
	                Object.defineProperty(plan.primaryFs, plan.primaryFs.subtype === 'IACH' ? 'padPlanId' : 'iachPlanId', {
	                    enumerable: true,
	                    configurable: false,
	                    writeable: false,
	                    value: self.getBankPlanIdByInstrumentId(plan.primaryFs.id, plan.primaryFs.subtype === 'IACH' ? 'PAD' : 'IACH')
	                });
	            }
	        });
	    },
	
	    getBankPadPlanIdByInstrumentId: function getBankPadPlanIdByInstrumentId(id, subtype) {
	        var bankPadPlan = this.plans.find(function (plan) {
	            return plan.primaryFs && plan.primaryFs.id === id && plan.primaryFs.type === 'BANK' && plan.primaryFs.subtype === subtype;
	        });
	
	        return bankPadPlan.primaryFs && (bankPadPlan.primaryFs.subtype === 'IACH' ? bankPadPlan.primaryFs.padPlanId : bankPadPlan.primaryFs.iachPlanId);
	    },
	
	    isPadToggleApplicable: function isPadToggleApplicable() {
	        var padToggleApplicable = false;
	        this.eachPlan(function (plan) {
	            if (!padToggleApplicable && plan.primaryFs && plan.primaryFs.type === 'BANK') {
	                if (plan.primaryFs.subtype === 'IACH' && plan.primaryFs.hasOwnProperty('padPlanId')) {
	                    padToggleApplicable = plan.primaryFs.padPlanId ? true : false;
	                } else if (plan.primaryFs.subtype === 'PAD' && plan.primaryFs.hasOwnProperty('iachPlanId')) {
	                    padToggleApplicable = plan.primaryFs.iachPlanId ? true : false;
	                }
	            }
	        }, this);
	
	        return padToggleApplicable;
	    },
	
	    isPadToggleApplicableForFS: function isPadToggleApplicableForFS(planId) {
	        var padToggleApplicable = false;
	        var selectedPlan = _squid.$util.find(this.plans, function (plan) {
	            return plan.planId === planId;
	        });
	
	        if (selectedPlan.primaryFs && selectedPlan.primaryFs.type === 'BANK' && (selectedPlan.primaryFs.subtype === 'IACH' && selectedPlan.primaryFs.padPlanId || selectedPlan.primaryFs.subtype === 'PAD' && selectedPlan.primaryFs.iachPlanId)) {
	            padToggleApplicable = true;
	        }
	
	        return padToggleApplicable;
	    },
	
	    getPreferred: function getPreferred() {
	        return _squid.$util.find(this.plans, function (plan) {
	            return plan.primaryFs.isPreferred;
	        });
	    }
	});
	
	var $InstallmentOptionsModel = exports.$InstallmentOptionsModel = _squid.$Model.extend('$InstallmentOptionsModel', {
	    api: new _squid.$Api({
	        uri: '/api/checkout/:id/installmentOptions/',
	        postAttempts: 2
	    })
	});
	
	var $FlowEligibilityModel = exports.$FlowEligibilityModel = _squid.$Model.extend('$FlowEligibilityModel', {
	    api: new _squid.$Api({
	        uri: '/api/checkout/:id/flowEligibility'
	    })
	});
	
	var $CheckoutShippingAddressModel = exports.$CheckoutShippingAddressModel = _squid.$Model.extend('$CheckoutShippingAddressModel', {
	    api: new _squid.$Api({
	        uri: '/api/checkout/:parent.id/shipping/:id'
	    })
	});
	
	var $ShippingAddressModel = exports.$ShippingAddressModel = _squid.$Model.extend('$ShippingAddressModel', {
	    api: new _squid.$Api({
	        uri: '/api/checkout/:id/shipping/add'
	    }),
	
	    serialize: function serialize() {
	        return {
	            first_name: this.first_name,
	            last_name: this.last_name,
	            recipient_name: this.recipient_name,
	            line1: this.line1,
	            line2: this.line2,
	            city: this.city,
	            state: this.state,
	            postal_code: this.postal_code,
	            country: this.country
	        };
	    }
	});
	
	var $CheckoutPayeeModel = exports.$CheckoutPayeeModel = _squid.$Model.extend('$CheckoutPayeeModel', {
	    api: new _squid.$Api({
	        uri: '/api/checkout/:id/payee'
	    }),
	
	    getId: function getId() {
	        return this.merchant && this.merchant.id;
	    },
	
	    isGambling: function isGambling() {
	        return this.merchant && this.merchant.isGambling;
	    }
	});
	
	var $CreditOptionsModel = exports.$CreditOptionsModel = {
	    sacEligibleAmount: {
	        US: 99,
	        GB: 150
	    }
	};
	
	var $CheckoutShippingAddressesModel = exports.$CheckoutShippingAddressesModel = _squid.$Model.extend('$CheckoutShippingAddressesModel', {
	    api: new _squid.$Api({
	        uri: '/api/checkout/:id/shipping'
	    }),
	
	    onPopulate: function onPopulate() {
	        this.addresses = this.children($CheckoutShippingAddressModel, this.addresses);
	    },
	
	    getPreferredShippingAddress: function getPreferredShippingAddress() {
	        var preferredAddress = {};
	
	        if (this.addresses) {
	            var i = void 0;
	            var address = void 0;
	
	            for (i = 0; i < this.addresses.length; i++) {
	                address = this.addresses[i];
	
	                if (address && address.preferred_address) {
	                    preferredAddress = {
	                        'line1': address.line1,
	                        'line2': address.line2,
	                        'city': address.city,
	                        'state': address.state,
	                        'postal_code': address.postal_code,
	                        'country_code': address.country_code
	                    };
	
	                    break;
	                }
	            }
	        }
	        return preferredAddress;
	    },
	
	    getPrimaryShippingAddress: function getPrimaryShippingAddress() {
	        var primaryAddress = {};
	
	        if (this.addresses) {
	            var i = void 0;
	            var address = void 0;
	
	            for (i = 0; i < this.addresses.length; i++) {
	                address = this.addresses[i];
	
	                if (address && address.primary_address) {
	                    primaryAddress = {
	                        'line1': address.line1,
	                        'line2': address.line2,
	                        'city': address.city,
	                        'state': address.state,
	                        'postal_code': address.postal_code,
	                        'country_code': address.country_code
	                    };
	
	                    break;
	                }
	            }
	        }
	        return primaryAddress;
	    }
	});
	
	var $CheckoutPlanModel = exports.$CheckoutPlanModel = _squid.$Model.extend('$CheckoutPlanModel', {
	
	    onPopulate: function onPopulate() {
	        this.sources = this.children($FundingSourceModel, this.sources);
	    },
	
	    eachSource: function eachSource(method, context) {
	        angular.forEach(this.sources, method, this);
	    },
	
	    hasFundingMethodType: function hasFundingMethodType(name) {
	        var found = false;
	
	        this.eachSource(function (source) {
	            if (source.type === name) {
	                found = true;
	            }
	        }, this);
	
	        return found;
	    },
	
	    hasFundingMethodSubType: function hasFundingMethodSubType(name) {
	        var found = false;
	
	        this.eachSource(function (source) {
	            if (source.sub_type === name) {
	                found = true;
	            }
	        }, this);
	
	        return found;
	    },
	
	    isPAD: function isPAD() {
	        return this.hasFundingMethodSubType('DELAYED_TRANSFER');
	    },
	
	    isIACH: function isIACH() {
	        var found = false;
	
	        this.eachSource(function (source) {
	            if (source.type === 'BANK_ACCOUNT' && source.sub_type === 'INSTANT_TRANSFER') {
	                found = true;
	            }
	        }, this);
	
	        return found;
	    },
	
	    isSplitPaymentWithBalanceAndIach: function isSplitPaymentWithBalanceAndIach() {
	        return this.sources && this.sources.length > 1 && this.hasFundingMethodType('BALANCE') && this.isIACH();
	    },
	
	    isMSB: function isMSB() {
	        return this.sources && this.sources.length === 1 && this.sources[0].type === 'INCENTIVE';
	    },
	
	    isBalance: function isBalance() {
	        return this.sources && this.sources.length === 1 && this.sources[0].type === 'BALANCE';
	    },
	
	    hasConversion: function hasConversion() {
	        return this.conversion !== null && _typeof(this.conversion) === 'object';
	    }
	});
	
	var $CheckoutSessionModel = exports.$CheckoutSessionModel = _squid.$Model.extend('$CheckoutSessionModel', {
	
	    api: new _squid.$Api({
	        uri: '/api/checkout/:id/session',
	        postAttempts: 2
	    }),
	
	    invalidateOnLogout: true, // invalidate this model when auth.logout() gets called
	
	    onPopulate: function onPopulate() {
	        this.plan = new $CheckoutPlanModel(this.plan);
	        this.shipping = this.child($CheckoutShippingAddressModel, this.shipping);
	        this.fundingOptions = this.child($FundingOptionsModel, this.fundingOptions);
	    },
	
	    getSelectedStickyInstrument: function getSelectedStickyInstrument() {
	
	        if (this.selectedFuturePaymentInstrument) {
	            return this.selectedFuturePaymentInstrument;
	        }
	
	        if (!this.futurePaymentInstruments) {
	            return;
	        }
	
	        if (!(this.plan && this.plan.sources) && this.futurePaymentInstruments) {
	            return this.futurePaymentInstruments[0];
	        }
	
	        var selectedInstrumentId = _squid.$util.some(this.plan.sources, function (fi) {
	            return fi.instrument_id ? fi.instrument_id : undefined;
	        });
	
	        var stickyInstrument = _squid.$util.find(this.futurePaymentInstruments, function (fi) {
	            return fi.instrument_id === selectedInstrumentId;
	        });
	
	        return stickyInstrument;
	    },
	
	    getPlanList: function getPlanList() {
	        return this.fundingOptions && this.fundingOptions.plans;
	    },
	
	    // returns true if more than one plan uses BALANCE as the primary FI
	    isMultipleBalancePlan: function isMultipleBalancePlan() {
	        var matchingBalancePlans = 0;
	
	        return this.fundingOptions && this.fundingOptions.plans && this.fundingOptions.plans.some(function (plan) {
	            // if BALANCE is the primary FI...
	            if (plan.primaryFs.name === 'BALANCE') {
	                // increment number of balance plans found
	                matchingBalancePlans++;
	            }
	            // exit once we have more than one balance plan
	            return matchingBalancePlans > 1;
	        });
	    },
	
	    getDisallowedInstruments: function getDisallowedInstruments() {
	        return this.fundingOptions && this.fundingOptions.disallowedInstruments;
	    },
	
	    getDisallowedPreferred: function getDisallowedPreferred() {
	        var disallowedInstrument = this.getDisallowedInstruments();
	
	        // find only the disallowed instrument that has been marked as preferred.
	        disallowedInstrument = disallowedInstrument && _squid.$util.find(disallowedInstrument, function (fi) {
	            return fi.isPreferred;
	        });
	
	        // if the disallowed instrument is in the plan list (in the case that the instrument has a BUF)
	        // we do not show it in the disallowed section.
	        var isDisallowedInstrumentInPlanList = disallowedInstrument && _squid.$util.some(this.getPlanList(), function (plan) {
	            var instrumentID = plan.primaryFs && plan.primaryFs.id;
	            if (instrumentID && disallowedInstrument.id) {
	                return instrumentID === disallowedInstrument.id;
	            } else {
	                return false;
	            }
	        });
	
	        return !isDisallowedInstrumentInPlanList && disallowedInstrument;
	    },
	
	    getShippingAddressMinimalDetails: function getShippingAddressMinimalDetails() {
	        return {
	            'line1': this.shipping.line1,
	            'line2': this.shipping.line2,
	            'city': this.shipping.city,
	            'state': this.shipping.state,
	            'postal_code': this.shipping.postal_code,
	            'country_code': this.shipping.country
	        };
	    }
	});
	
	angular.value("$CheckoutCartModel", $CheckoutCartModel);
	angular.value("$CheckoutAppDataModel", $CheckoutAppDataModel);
	angular.value("$FundingSourceModel", $FundingSourceModel);
	angular.value("$FundingOptionsModel", $FundingOptionsModel);
	angular.value("$InstallmentOptionsModel", $InstallmentOptionsModel);
	angular.value("$FlowEligibilityModel", $FlowEligibilityModel);
	angular.value("$CheckoutShippingAddressModel", $CheckoutShippingAddressModel);
	angular.value("$ShippingAddressModel", $ShippingAddressModel);
	angular.value("$CheckoutPayeeModel", $CheckoutPayeeModel);
	angular.value("$CreditOptionsModel", $CreditOptionsModel);
	angular.value("$CheckoutShippingAddressesModel", $CheckoutShippingAddressesModel);
	angular.value("$CheckoutPlanModel", $CheckoutPlanModel);
	angular.value("$CheckoutSessionModel", $CheckoutSessionModel);
	_squid.$Model;
	
	_squid.$Api;
	
	_squid.$util;

/***/ }),

/***/ "./components/xo-models/src/auth/index.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$ULoginModel = exports.$AuthModel = exports.$AuthApi = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $AuthApi = exports.$AuthApi = _squid.$Model.extend('$AuthApi', {
	    api: new _squid.$Api({
	        uri: '/api/auth',
	        postAttempts: 3
	    })
	});
	
	var $AuthModel = exports.$AuthModel = _squid.$Model.extend('$AuthModel', {
	    api: new _squid.$Api({
	        uri: '/api/auth',
	        postAttempts: 3
	    }),
	
	    invalidateOnLogout: true, // invalidate this model when auth.logout() gets called
	
	    loggedIn: function loggedIn() {
	        return this.logged_in;
	    },
	
	    visitorId: function visitorId() {
	        return this.visitor_id;
	    },
	
	    accessToken: function accessToken() {
	        return this.access_token;
	    },
	
	    accessTokenPresent: function accessTokenPresent() {
	        return this.access_token_present;
	    },
	
	    refreshToken: function refreshToken() {
	        return this.refresh_token;
	    },
	
	    rememberedOT: function rememberedOT() {
	        return this.remembered && this.remembered_device_token;
	    },
	
	    logout: function logout() {
	        _squid.$Model.bulkInvalidate('invalidateOnLogout');
	        return this.action('logout');
	    }
	});
	
	var $ULoginModel = exports.$ULoginModel = _squid.$Model.extend('$ULoginModel', {
	    api: new _squid.$Api({
	        uri: '/api/auth/ulogin',
	        postAttempts: 1,
	        cache: false
	    })
	});
	
	angular.value("$AuthApi", $AuthApi);
	angular.value("$AuthModel", $AuthModel);
	angular.value("$ULoginModel", $ULoginModel);
	_squid.$Model;
	
	_squid.$Api;

/***/ }),

/***/ "./components/xo-return-to-merchant/dist/util.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	function match(str, pattern) {
	    var regmatch = str.match(pattern);
	    if (regmatch) {
	        return regmatch[1];
	    }
	}
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-beaver/dist/logger.js"), __webpack_require__("./components/xo-device-info/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-return-to-merchant', ['squid', 'xo-device-info']).factory('$ReturnToMerchant', function ($window, $DeviceInfo, $rootScope, $util, $feature, $logger, $state, $timeout, $CheckoutSessionModel, $CheckoutCartModel) {
	        return {
	            goTo: function goTo(url, forceRedirect) {
	
	                $logger.info(url.indexOf('PayerID') > -1 ? 'return_to_merchant' : 'cancel_to_merchant', {
	                    url: url
	                });
	
	                // if V4 in-context integration, we'll terminate and call the close handler.
	                if (window.xchild) {
	                    $logger.done();
	                    $rootScope.$emit('loading');
	
	                    var params = {
	                        paymentToken: match(url, /token=((EC-)?[A-Z0-9]+)/),
	                        billingToken: match(url, /ba_token=((BA-)?[A-Z0-9]+)/),
	                        payerID: match(url, /PayerID=([A-Z0-9]+)/),
	                        paymentID: match(url, /paymentId=((PAY-)?[A-Z0-9]+)/),
	                        intent: $CheckoutCartModel.instance($rootScope.token).payment_action
	                    };
	
	                    if (window.xprops.onCancel) {
	                        params.cancelUrl = url;
	                        return window.xprops.onCancel(params);
	                    }
	
	                    return window.xchild.close();
	                }
	
	                var isHTTPUrl = Boolean(url.indexOf('http') === 0 || url.indexOf('www') === 0);
	                var showPaymentSuccess = Boolean($DeviceInfo.isDevice() && !isHTTPUrl);
	
	                if (showPaymentSuccess) {
	                    $logger.info('redirect', {
	                        url: url
	                    });
	                    $window.onunload = $window.onbeforeunload = function () {};
	                    $window.location = url;
	                    return $state.go('checkout.genericMessage', {
	                        code: 'PAYMENT_SUCCESS'
	                    });
	                }
	
	                if (forceRedirect) {
	                    $util.redirect(url);
	                } else {
	                    var isVZeroIframe = Boolean($rootScope.partnerIntegration) && $util.isIFrame();
	
	                    if (isVZeroIframe) {
	                        $util.redirect(url, { redirectImmediateParent: true });
	                    }
	
	                    // If we are not in minibrowser, do a hard redirect
	                    else if ($rootScope.partnerIntegration || !$rootScope.miniBrowser && !$util.isIFrame()) {
	                            $util.redirect(url);
	                        } else {
	
	                            // Construct a message to send to the parent
	                            var result = this.postToMerchant({
	                                operation: 'return_to_merchant',
	                                returnUrl: url,
	                                updateParent: true
	                            });
	
	                            // Otherwise we have no choice but to return to the merchant
	                            if (!result) {
	                                $util.redirect(url);
	                            }
	                        }
	                }
	
	                var userStatus = function userStatus() {
	                    $logger.info('redirected_user_still_on_page_second_checkpoint');
	                };
	
	                $timeout(function () {
	                    $logger.info('redirected_user_still_on_page_first_checkpoint');
	                    $timeout(userStatus, 10000);
	                }, 10000);
	            },
	
	            postToMerchant: function postToMerchant(msg) {
	
	                try {
	                    msg = angular.toJson(msg, 0);
	
	                    // If we are not in IE, attempt to send a postMessage
	                    if ($window.opener && ($window.navigator.userAgent.match(/edge/i) || $window.opener.postMessage && !$window.navigator.userAgent.match(/msie|trident/i))) {
	                        $window.opener.postMessage(msg, '*');
	                        $logger.info('minibrowser_postmessage');
	                        return true;
	                    }
	                    // Otherwise, attempt to send a message through the iframe bridge
	                    var bridge = $window.opener && $window.opener.frames && $window.opener.frames.length && $window.opener.frames.PayPalBridge;
	
	                    if (bridge && bridge.returnToParent) {
	                        bridge.returnToParent(msg);
	                        $logger.info('minibrowser_bridgemessage');
	                        return true;
	                    }
	
	                    $logger.warn('minibrowser_nopostback');
	                } catch (err) {
	                    $logger.error('minibrowser_postback_error', {
	                        error: err.stack || err.toString()
	                    });
	                }
	
	                return false;
	            },
	
	            postTo: function postTo(url, msg) {
	                var form = document.createElement('form');
	                form.method = 'POST';
	                form.action = url;
	                form.className = 'hide';
	
	                for (var key in msg) {
	                    var input = document.createElement('input');
	                    input.name = key;
	                    input.value = msg[key];
	                    form.appendChild(input);
	                }
	
	                $window.document.body.appendChild(form);
	                form.submit();
	                $logger.info('web_postmessage');
	                return true;
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-return-to-merchant/dist", "components/xo-return-to-merchant/dist/util.js"))

/***/ }),

/***/ "./components/xo-device-info/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('xo-device-info', ['squid']).factory('$DeviceInfo', function ($window, $meta, $logger) {
	        var userAgent = $window.navigator.userAgent;
	        var standalone = $window.navigator.standalone;
	        var DEVICE_PATTERN = /iPod|iPhone|iPad|Android|BlackBerry|BB10|Palm|CriOS|IEMobile|Windows Phone OS|webOS|Symbian|silk|Kindle|Opera Mini|mobile/i;
	        var TABLET_PATTERN = /ip(a|ro)d|silk|xoom|playbook|tablet|kindle|Nexus 7|GT-P10|SC-01C|SHW-M180S|SM-T320|SGH-T849|SCH-I800|SHW-M180L|SPH-P100|SGH-I987|zt180|HTC( Flyer|_Flyer)|Sprint ATP51|ViewPad7|pandigital(sprnova|nova)|Ideos S7|Dell Streak 7|Advent Vega|A101IT|A70BHT|MID7015|Next2|nook|FOLIO|MB511.*RUTEM|Mac OS.*Silk/i;
	
	        // Supports iOS and Android. Updated / more accurate method of detecting webviews
	        function isWebView() {
	            var logEnabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	            var ua = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : userAgent;
	
	            var ios = /iphone|ipod|ipad/i.test(ua),
	                android = /Android/i.test(ua);
	
	            if (ios) {
	                // Unfortunately no perfectly reliable way, this will detect some 3rd party browsers as ui webview
	                // Major browsers: chrome, safari, firefox, uc browser, puffin, are detected reliably.
	                var ios_uiwebview = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(ua);
	
	                if (!standalone && ios_uiwebview && !isSafariViewController()) {
	                    // uiwebview
	                    logWebView('iOS');
	                    return true;
	                }
	            } else if (android) {
	                // not iOS, Android platform handling
	                // Whitelist for x-requested-with header values for web view detection
	                var allowedXRequestedWithRegexMap = {
	                    ajax: /XMLHttpRequest/i,
	                    baiduBrowser: /com.baidu.browser.inter/i,
	                    operaMini: /com.opera.mini.native/i,
	                    maxthon: /com.mx.browser/i,
	                    litterPenguinBrowser: /com.explore.web.browser/i
	                };
	                var xRequestedWithHeaderVal = $meta.requestHeaders['x-requested-with'];
	
	                if (xRequestedWithHeaderVal) {
	                    // check if x-requested-with header val is in whitelist
	                    for (var key in allowedXRequestedWithRegexMap) {
	                        if (allowedXRequestedWithRegexMap.hasOwnProperty(key)) {
	                            if (allowedXRequestedWithRegexMap[key].test(xRequestedWithHeaderVal)) {
	                                return false;
	                            }
	                        }
	                    }
	                    logWebView('Android');
	                    return true;
	                }
	            }
	
	            return false;
	
	            function logWebView(device) {
	                if (!logEnabled) {
	                    return;
	                }
	                // cal log
	                $logger.info('WebView :: ' + device);
	            }
	        }
	
	        /**
	         * Check if the given the user-agent string is belongs to a device.
	         */
	        function isDevice() {
	            if (angular.isString(userAgent)) {
	                return DEVICE_PATTERN.test(userAgent) || TABLET_PATTERN.test(userAgent);
	            }
	
	            return false;
	        }
	
	        /**
	         * Check if the given the user-agent string is belongs to a tablet.
	         */
	        function isTablet() {
	            if (angular.isString(userAgent)) {
	                return TABLET_PATTERN.test(userAgent);
	            }
	
	            return false;
	        }
	
	        /**
	         * Check if the given the user-agent string is belongs to a mobile
	         */
	        function isMobile() {
	            return isDevice(userAgent) && !isTablet(userAgent);
	        }
	
	        /**
	         * Get the mobile platform value given the user-agent string.
	         */
	        function getDevicePlatform() {
	            if (angular.isString(userAgent)) {
	                var matched = userAgent.match(/iPod|iPhone|iPad|Android|BlackBerry|Windows Phone OS|webOS|Symbian|mobile/g);
	
	                if (matched && matched.length > 0) {
	                    return matched[0];
	                }
	            }
	        }
	
	        /**
	         * Check if the give user agent is from an app.
	         */
	        function isApp(uaString) {
	            userAgent = uaString || userAgent;
	
	            if (DEVICE_PATTERN.test(userAgent) || TABLET_PATTERN.test(userAgent)) {
	                if (getDevicePlatform(userAgent) === 'Android') {
	                    return (/Version\/\d.\d/i.test(userAgent)
	                    );
	                }
	
	                return (/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)|PLAYSTATION|iPadApp/i.test(userAgent)
	                );
	            }
	
	            return false;
	        }
	
	        function isSafariViewController() {
	            if (angular.isString(userAgent)) {
	                var ios = /iphone|ipod|ipad/i.test(userAgent);
	                return ios && $window.indexedDB && isApp();
	            } else {
	                return false;
	            }
	        }
	
	        /**
	         * Get the device capabilities
	         */
	        function getCapabilities() {
	            var capabilities = {},
	                device = DEVICE_PATTERN.test(userAgent),
	                tablet = TABLET_PATTERN.test(userAgent),
	                app = isApp(userAgent);
	
	            if (angular.isString(userAgent)) {
	                capabilities.isWireless = device || tablet;
	                capabilities.isTablet = tablet;
	                capabilities.isMobile = device && !tablet;
	                capabilities.isDesktop = !device;
	                capabilities.isApp = app;
	            }
	
	            return capabilities;
	        }
	
	        /**
	         * Get various AppIntegrationType
	         */
	        function getAppIntegrationType() {
	            var app_int_type;
	            if (isDevice()) {
	                if (isApp()) {
	                    if (isSafariViewController()) {
	                        app_int_type = 'SFVC';
	                    } else {
	                        app_int_type = 'WebView';
	                    }
	                } else {
	                    app_int_type = 'Browser';
	                }
	            }
	            return app_int_type;
	        }
	
	        return {
	            isDevice: isDevice,
	            isTablet: isTablet,
	            isMobile: isMobile,
	            isApp: isApp,
	            isSafariViewController: isSafariViewController,
	            getCapabilities: getCapabilities,
	            getAppIntegrationType: getAppIntegrationType,
	            isWebView: isWebView
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-device-info/dist", "components/xo-device-info/dist/index.js"))

/***/ }),

/***/ "./js/lib/fallback.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-models/src/user/index.js"), __webpack_require__("./components/xo-beaver/dist/logger.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('hermes.lib.fallback', ['squid', 'beaver', 'xomodel.user']).factory('$fallbackErrorHandler', function ($FallbackError, $q, $config, $meta, $timeout, $window, $logger, $log, $rootScope, $CheckoutAppDataModel, $CheckoutInputDataModel, $CheckoutCartModel, $ReturnToMerchant, $locale, $util, $state, $experiment) {
	
	        function goToUrl(url, wpsParams, xoAppData) {
	            if (xoAppData.doec_on_approve()) {
	                return $ReturnToMerchant.postTo(url, wpsParams);
	            }
	            return $ReturnToMerchant.goTo(url);
	        }
	
	        return function (err) {
	
	            function goToGenericError(reason) {
	                $state.go('checkout.genericError', {
	                    code: reason
	                });
	                return true;
	            }
	
	            /**
	             * This function contains an additional determination of fallback url in case of an UX fallback
	             *
	             * @param {object} checkoutAppDataModel
	             * @param {string} fallbackUrl
	             * @returns {string}
	             */
	            function determineUrlForUxFallback(checkoutAppDataModel, fallbackUrl) {
	                var experienceInitiator = checkoutAppDataModel.get('flags.payment_experience_initiator');
	
	                // in case of UX fallback + PPPlus transaction -> fallback url is merchants cancel_url with added
	                // parameter ppp_msg=1
	                if (experienceInitiator === 'PAYPAL_PLUS') {
	                    var merchantCancelUrl = checkoutAppDataModel.urls.cancel_url;
	                    var ppplusParams = {
	                        ppp_msg: '1'
	                    };
	
	                    fallbackUrl = $util.buildURL(merchantCancelUrl, ppplusParams);
	                }
	
	                return fallbackUrl;
	            }
	
	            var checkoutCart = $CheckoutCartModel.instance($rootScope.token);
	            if (checkoutCart.isWalletTokenization()) {
	                return goToGenericError();
	            }
	            var checkoutAppData = $CheckoutAppDataModel.instance($rootScope.token);
	
	            if (checkoutAppData.doec_on_approve() && $rootScope.paymentComplete) {
	                // Do not fallback. UX has no context of hermes token and will result in duplicate payment
	                $logger.info('wps_error_payment_already_done', {
	                    reason: err.reason
	                });
	
	                return goToGenericError('PAYMENT_ALREADY_DONE');
	            }
	
	            if (err instanceof $FallbackError) {
	                var reason = err.reason;
	                var product = err.product;
	                var entry_point = err.entryPoint;
	
	                if ($CheckoutInputDataModel.instance($rootScope.token).requiresOAuth()) {
	                    // there is no fallback for flows that require oauth code return (ex:PROX Signup),
	                    // so we show a generic error page
	                    $logger.log('error', 'fallback_inhibited_for_oauth_return_flows', {
	                        reason: reason
	                    });
	                    return goToGenericError(reason);
	                }
	
	                if (product === 'ux' && $rootScope.partnerIntegration) {
	                    $logger.info('partner_integration_fallback_to_UX');
	                    $window.resizeTo(screen.availWidth, screen.availHeight);
	                }
	
	                // For checkout-order tokens symphony sets checkoutAppData.flags.disable_legacy_fallback flag to 'true'.
	                // In such cases we disable fallback to UX and show the generic error page.
	                if (checkoutAppData.flags && checkoutAppData.flags.disable_legacy_fallback) {
	                    $logger.log('error', 'fallback_inhibited_for_checkout_order_tokens', {
	                        reason: reason
	                    });
	                    return goToGenericError(reason);
	                }
	
	                $util.assert(reason, 'expected fallback reason');
	
	                $logger.log(product ? 'info' : 'error', 'fallback', {
	                    reason: reason,
	                    product: product,
	                    entry_point: entry_point
	                });
	
	                var country = $locale.country;
	                var fallbackToUx = ($config.fallbackAriesUnsupportedToUx || []).indexOf(country) > -1;
	
	                if (fallbackToUx) {
	                    product = 'ux';
	                } else {
	                    product = product || 'ux';
	                }
	
	                $logger.info('fallback_reason_' + reason);
	
	                if (checkoutAppData.doec_on_approve()) {
	                    $logger.log('info', 'wps_fallback', {
	                        token: $meta.token,
	                        reason: reason
	                    });
	                    $logger.info('wps_fallback_reason_' + reason, {
	                        reason: reason
	                    });
	                }
	
	                if (!$config.fallbackEnabled && !entry_point) {
	                    return $log.info('Fallback inhibited by config');
	                }
	
	                if ($config.deploy.isLocal() && !entry_point) {
	                    return $log.info('Fallback inhibited in local mode. Please refresh to re-enable error logging');
	                }
	
	                // Fallback whitelist experiment in config to determine if we should fallback or instead redirect to generic error page.
	                // We go to generic error page if the reason is not in the whitelist and random number is below the throttle value
	                var fallbackWhitelist = $config.fallbackWhitelist;
	
	                if (fallbackWhitelist && fallbackWhitelist.throttle > 0) {
	                    var whitelist = fallbackWhitelist.whitelisted || [];
	
	                    if (whitelist.indexOf(reason) === -1) {
	                        if (window.sessionStorage && $experiment('fallback_reason_not_whitelisted', fallbackWhitelist.throttle, $rootScope.token, { reason: reason })) {
	                            // we're using sessionStorage for retry detection
	                            var RETRY_KEY = 'retry_page_shown';
	                            var RETRY_PAGE_LIMIT = 3; // Only show the retry page at most 3 times
	                            var timesSeen = Number(window.sessionStorage[RETRY_KEY]);
	                            var destination = 'RETRY';
	
	                            if (!timesSeen || timesSeen < 0) {
	                                // Reset if there's an invalid value for timesSeen for some reason
	                                timesSeen = 0;
	                            }
	
	                            if (timesSeen < RETRY_PAGE_LIMIT) {
	                                // Only try to go to retry page if we're within retry attempts
	                                timesSeen++;
	                                window.sessionStorage[RETRY_KEY] = timesSeen;
	                            } else {
	                                destination = 'DEFAULT';
	                            }
	
	                            $logger.info('checkout_fpti', {
	                                'enable_refresh_prompt': reason
	                            });
	
	                            return goToGenericError(destination);
	                        }
	                    } else {
	                        $logger.info('fallback_reason_whitelisted', {
	                            reason: reason,
	                            product: product
	                        });
	                    }
	                }
	
	                $rootScope.$emit('loading');
	
	                var urlParams = {
	                    token: $meta.token,
	                    fallback: 1,
	                    landing: entry_point,
	                    useraction: $util.param('useraction')
	                };
	
	                if ($rootScope.partnerIntegration) {
	                    urlParams.incontext = '1';
	                    urlParams.nolegacy = '1';
	                } else if ($rootScope.miniBrowser) {
	                    urlParams.incontext = '1';
	                }
	
	                var base = $config.urls.fallbackUrl[product];
	                var wpsParams = void 0;
	
	                if (checkoutAppData.doec_on_approve()) {
	                    base = checkoutAppData.flags.is_cart_upload_flow || checkoutAppData.flags.is_shopping_cart_flow ? $config.urls.fallbackUrl['cartUpload'] : $config.urls.fallbackUrl['buyNow'];
	                    wpsParams = $util.decodeAndParse($meta.xclickParams);
	                }
	
	                if (checkoutAppData.flags.is_invoice_flow) {
	                    urlParams.id = checkoutAppData.invoice_id;
	                    base = $config.urls.fallbackUrl['invoice'];
	                }
	
	                var url = $meta.stage ? $meta.stage : $window.location.hostname;
	                url = $util.buildURL('https://' + url + base, urlParams);
	
	                if (checkoutAppData.doec_on_approve() || checkoutAppData.flags.is_invoice_flow) {
	                    goToUrl(url, wpsParams, checkoutAppData);
	                    return true;
	                }
	
	                if (product === 'ux') {
	
	                    url = determineUrlForUxFallback(checkoutAppData, url);
	
	                    // Otherwise we can make a decision based on whether we're in the minibrowser or not
	
	                    return checkoutAppData.action('updateFallbackAction', {
	                        data: {
	                            fallback_action: 'CA_FALLBACK_USER_ACTION_LOGIN_GUEST_TAB_SELECTION'
	                        },
	                        success: function success() {
	                            $ReturnToMerchant.goTo(url);
	                            return true;
	                        },
	                        contingencies: {
	                            DEFAULT: function DEFAULT() {
	                                $ReturnToMerchant.goTo(url);
	                                return true;
	                            }
	                        }
	                    })['catch'](function () {
	                        $ReturnToMerchant.goTo(url);
	                        return true;
	                    });
	                }
	
	                // Safe to always return to Aries
	                $util.redirect(url);
	
	                return true;
	            }
	
	            return false;
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "js/lib", "js/lib/fallback.js"))

/***/ }),

/***/ "./components/xo-models/src/user/index.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xomodel.user', ['squid']).factory('$CheckoutClientDataModel', function ($Model, $Api) {
	
	        return $Model.extend('CheckoutClientDataModel', {
	
	            api: new $Api({
	                uri: '/api/user/:id/clientData'
	            }),
	
	            merchantIdentityData: function merchantIdentityData() {
	                return {
	                    email: this.email,
	                    brand_name: this.display_name,
	                    logo_uri: this.logo_uri,
	                    identity_uri: this.identity_uri
	                };
	            },
	
	            validateClient: function validateClient() {
	                if (this.partner_id && this.identity_uri) {
	                    return {
	                        success: true
	                    };
	                } else {
	                    return {
	                        success: false,
	                        error: 'invalid_client'
	                    };
	                }
	            },
	            validateRedirectUri: function validateRedirectUri(redirectUrl) {
	                if (this.identity_uri && this.identity_uri.indexOf(redirectUrl) > -1) {
	                    return {
	                        success: true
	                    };
	                } else {
	                    return {
	                        success: false,
	                        error: 'invalid_redirect_url'
	                    };
	                }
	            }
	        });
	    }).factory('$CheckoutInputDataModel', function ($Model, $Api, $config, $util) {
	
	        var ACTION = {
	            login: 'login',
	            resolve: 'resolve',
	            addCard: 'addCard',
	            addBank: 'addBank',
	            changeCurrencyConv: 'changeCurrencyConv',
	            signup: 'signup',
	            mandate: 'mandate',
	            addCredit: 'addCredit',
	            ulReturn: 'ulReturn',
	            creditReturn: 'creditReturn',
	            guestCurrencyConversion: 'guestCurrencyConversion'
	        };
	
	        return $Model.extend('CheckoutInputDataModel', {
	
	            init: function init() {
	                this._super.init.apply(this);
	                this.setProperties({
	                    client_id: $util.param('client_id'),
	                    action: $util.param('action'),
	                    redirect_uri: $util.param('redirect_uri'),
	                    scope: $util.param('scope'),
	                    state: $util.param('state'),
	                    flow: $util.param('flow'),
	                    payer_id: $util.param('payer_id'),
	                    mandate_reference_number: $util.param('mandate_reference_number'),
	                    funding_option_id: $util.param('funding_option_id'),
	                    locale: $util.param('locale'),
	                    logout: $util.param('logout'),
	                    refresh_parent: $util.param('refresh_parent'),
	                    escape_hatch: $util.param('escape_hatch'),
	                    failedBecause: $util.param('failedBecause'),
	                    redirectReferrer: $util.param('redirectReferrer'),
	                    id_token: $util.param('prox_id'),
	                    nonce: $util.param('nonce'),
	                    hide_rm: $util.param('hideRM'),
	                    payloadEnc: $util.param('payloadEnc'),
	                    xcancel: $util.param('x-cancel'),
	                    xsuccess: $util.param('x-success')
	                });
	            },
	
	            api: new $Api({
	                baseURI: $config.urls.baseUrl,
	                uri: '/api/user/:id/payerId'
	            }),
	
	            isEbayTxn: function isEbayTxn() {
	                return Boolean(this.client_id);
	            },
	
	            validAction: function validAction() {
	                var actions = {
	                    login: 'login',
	                    resolve: 'resolve',
	                    addCard: 'addCard',
	                    addBank: 'addBank',
	                    changeCurrencyConv: 'changeCurrencyConv',
	                    signup: 'signup',
	                    mandate: 'mandate',
	                    addCredit: 'addCredit',
	                    ulReturn: 'ulReturn',
	                    creditReturn: 'creditReturn',
	                    guestCurrencyConversion: 'guestCurrencyConversion'
	                };
	
	                return actions.hasOwnProperty(this.action);
	            },
	
	            showRYP: function showRYP() {
	                return !this.isEbayTxn();
	            },
	
	            requiresOAuth: function requiresOAuth() {
	                return this.action === ACTION.login || this.action === ACTION.signup;
	            },
	
	            requiresRedirectUri: function requiresRedirectUri() {
	                return this.action === ACTION.mandate || !this.requiresOAuth();
	            },
	
	            validRedirectUri: function validRedirectUri() {
	                if (this.requiresRedirectUri()) {
	                    return Boolean(this.redirect_uri);
	                }
	                return true;
	            },
	
	            validate: function validate() {
	                var error;
	                var success = true;
	
	                if (this.isEbayTxn()) {
	                    if (!this.validAction()) {
	                        success = false;
	                        error = 'invalid_action';
	                    } else if (!this.validRedirectUri()) {
	                        success = false;
	                        error = 'invalid_redirect_uri';
	                    }
	                }
	
	                return {
	                    success: success,
	                    error: error
	                };
	            },
	
	            errorUrl: function errorUrl(err, errorDesc) {
	                var url = this.redirect_uri;
	
	                url += url && url.indexOf('?') < 0 ? '?' : '&';
	                url += 'state=' + encodeURIComponent(this.state);
	
	                if (err) {
	                    url += '&error=' + err;
	                }
	                if (errorDesc) {
	                    url += '&error_description=' + errorDesc;
	                }
	
	                return url;
	            },
	
	            successUrl: function successUrl(code) {
	                var url = this.redirect_uri;
	
	                url += url && url.indexOf('?') < 0 ? '?' : '&';
	                url += 'state=' + encodeURIComponent(this.state);
	
	                url += '&code=' + code;
	
	                return url;
	            },
	
	            rmEnabled: function rmEnabled(featureEnabled) {
	                return featureEnabled && this.action === ACTION.login;
	            },
	
	            hideRM: function hideRM() {
	                return angular.isDefined(this.hide_rm) ? this.hide_rm.toLowerCase() === 'true' : false;
	            }
	        });
	    }).factory('$UserInfoModel', function ($Model, $Api) {
	        return $Model.extend('UserInfoModel', {
	            api: new $Api({
	                uri: '/api/user/:id/session'
	            })
	        });
	    }).factory('$ValidatePhoneModel', function ($Model, $Api) {
	
	        return $Model.extend('validatePhoneModel', {
	            api: new $Api({
	                uri: '/api/user/:token/session/validatePhone',
	                cache: false
	            })
	        });
	    }).factory('$AddKYCModel', function ($Model, $Api) {
	        return $Model.extend('AddKYCModel', {
	            api: new $Api({
	                uri: '/api/user/:token/session/addKYC'
	            })
	        });
	    }).factory('$PatchPhoneModel', function ($Model, $Api) {
	
	        return $Model.extend('patchPhoneModel', {
	            api: new $Api({
	                uri: '/api/checkout/:token/session/patch',
	                cache: false
	            })
	        });
	    }).factory('$WaxUserModel', function ($Model, $Api) {
	        return $Model.extend('WaxUserModel', {
	            api: new $Api({
	                uri: '/api/user/:id/waxUser'
	            })
	        });
	    }).factory('$EConsentModel', function ($Model, $Api) {
	        return $Model.extend('EConsentModel', {
	            api: new $Api({
	                uri: '/api/user/eConsent'
	            }),
	
	            invalidateOnLogout: true // invalidate this model when auth.logout() gets called
	        });
	    }).factory('$UserPhotoModel', function ($Model, $Api, $config) {
	        return $Model.extend('UserPhotoModel', {
	            api: new $Api({
	                baseURI: $config.urls.baseUrl,
	                uri: 'api/user/photo'
	            }),
	
	            invalidateOnLogout: true // invalidate this model when auth.logout() gets called
	        });
	    }).factory('$AuthConsentModel', function ($Model, $Api) {
	        return $Model.extend('AuthConsentModel', {
	            api: new $Api({
	                uri: '/api/user/authConsent'
	            })
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/user", "components/xo-models/src/user/index.js"))

/***/ }),

/***/ "./js/lib/contingency.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-beaver/dist/logger.js"), __webpack_require__("./js/lib/fallback.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('hermes.lib.contingency', ['squid', 'beaver', 'hermes.lib.fallback']).factory('$contingencyHandler', function ($Contingency, $logger, $location, $state, $locale, $FallbackError, $Forbidden) {
	
	        function showGenericError(code) {
	            return function (errCode) {
	                errCode = code ? code : errCode;
	                // Encode error text
	                errCode = errCode ? window.btoa(errCode) : errCode;
	                $state.go('checkout.genericError', {
	                    code: errCode
	                });
	            };
	        }
	
	        /**
	         * Route with default parameters unless special handler implemented otherwise
	         *
	         * To satisfy url: '/pageAddCard/:country/:fiType' in the route definition.
	         * {country: ..., fiType: ...} must be passed for ui.router..
	         *
	         */
	        function route(path, params) {
	            return function () {
	                $state.go(path, params);
	            };
	        }
	
	        var routeToAddCC = function routeToAddCC(msg, contingency) {
	            var gamblingCauses = ['PAYER_FUNDING_INSTRUMENT_INELIGIBLE', 'PAYER_FINANCIAL_INSTRUMENT_OUT_OF_COUNTRY', 'PAYER_FINANCIAL_INSTRUMENT_UNDER_AGE'];
	            var isGambling = gamblingCauses.indexOf(contingency.cause) > -1;
	            var param = isGambling ? {
	                gaming: '1'
	            } : {};
	
	            return route('checkout.pageAddCard.addCardFlow.addCard', param);
	        };
	
	        function forbidden(err) {
	            throw new $Forbidden(err);
	        }
	
	        function fallback(product) {
	            return function (err) {
	                throw new $FallbackError({
	                    reason: err,
	                    product: product
	                });
	            };
	        }
	
	        return function (contingency) {
	            if (contingency instanceof $Contingency) {
	
	                // Leave a footprint here. The subsequent state where log how it goes..
	                $logger.warn('contingency_handler', contingency);
	
	                return contingency.handle({
	                    // TODO : modify these routes
	                    // Route
	                    NEED_CREDIT_CARD: routeToAddCC,
	                    NEED_CONFIRMED_CARD: routeToAddCC,
	                    NEED_CREDIT_CARD_OR_BANK_ACCOUNT: routeToAddCC,
	                    EXPIRED_CREDIT_CARD: routeToAddCC,
	
	                    // Generic Error Pages
	                    CURRENCY_COMPLIANCE: showGenericError(),
	                    INVALID_RESOURCE_ID: showGenericError(),
	                    PAYMENT_ALREADY_DONE: showGenericError(),
	                    PAYEE_BLOCKED_TRANSACTION: showGenericError(),
	                    RESTRICTED_USER: showGenericError(),
	                    PAYMENT_DENIED: showGenericError(),
	                    PAYER_CANNOT_PAY: showGenericError(),
	                    PAYEE_ACCOUNT_RESTRICTED: showGenericError(),
	                    PAYER_COUNTRY_NOT_ALLOWED: showGenericError(),
	                    PAYER_COUNTRY_NOT_ALLOWED_DCF: showGenericError('XOON_PAYER_COUNTRY_NOT_ALLOWED_DCF'),
	                    PAYER_COUNTRY_NOT_ENABLED: showGenericError(),
	                    PAYER_LOGIN_COUNTRY_NOT_ALLOWED: showGenericError(),
	                    GAMING_FUNDING_SOURCE_VALIDATION_FAILED: showGenericError(),
	
	                    // Fallbacks
	                    TRANSACTION_REFUSED: fallback('ux'),
	                    VERIFY_USER_IDENTITY: fallback('ux'),
	                    SENDING_LIMIT_EXCEEDED: fallback('ux'),
	                    PAYER_INVALID_FOR_PAYMENT: fallback('ux'),
	                    PAYMENT_CANNOT_BE_INITIATED: fallback('ux'),
	                    PERMISSION_DENIED: fallback('ux'),
	                    NEGATIVE_BALANCE_TRANSACTION_REFUSED: fallback('ux'),
	                    INVALID_TOKEN: fallback('ux'),
	                    INVALID_FUNDING_OPTION: fallback('ux'),
	                    INTERNAL_SERVICE_ERROR: fallback('ux'),
	                    VALIDATION_ERROR: fallback('ux'),
	                    SHIPPING_ADDRESS_INVALID: fallback('ux'),
	                    RISK_DENIED: fallback('ux'),
	                    DOMESTIC_TRANSACTION_REQUIRED: fallback('ux'),
	                    INVALID_ARGUMENT: fallback('ux'),
	                    CREDIT_PAYMENT_NOT_ALLOWED: fallback('ux'),
	                    UNSUPPORTED_PAYEE_CURRENCY: fallback('ux'),
	                    PAYEE_ACCOUNT_LOCKED_OR_CLOSED: fallback('ux'),
	                    CANNOT_PAY_SELF: fallback('hermes'),
	
	                    // Forbidden
	                    BUYER_NOT_SET: forbidden,
	
	                    // TODO: duplicate - PAYER_INVALID_FOR_PAYMENT: forbidden,
	                    // Default
	                    DEFAULT: function logUnhandledContingency() {
	                        $logger.warn('ui_unhandled_contingency_' + this.message);
	
	                        throw new $FallbackError({
	                            reason: 'unhandled_contingency',
	                            product: 'ux'
	                        });
	                    }
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "js/lib", "js/lib/contingency.js"))

/***/ }),

/***/ "./js/lib/metaBuilder.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$metaBuilder = undefined;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _model = __webpack_require__("./components/xo-tracking/dist/model.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	function buildMeta() {
	    return {
	        token: _angular.$rootScope.token || _squid.$config.token || _squid.$meta.token || _squid.$util.param('token'),
	        cartId: _squid.$util.param('cart_id'),
	        calc: _model.$CalDataModel.getCalCorrId(),
	        csci: _model.$CalDataModel.getUUID(),
	        locale: {
	            country: _squid.$locale && _squid.$locale.country,
	            language: _squid.$locale && _squid.$locale.lang
	        },
	        state: 'ui_' + (_angular.$rootScope.currentState || 'checkout_init'),
	        app_name: 'xoonboardingnodeweb'
	    };
	}
	
	_squid.$Api.registerMetaBuilder(buildMeta);
	
	var $metaBuilder = exports.$metaBuilder = {
	    build: buildMeta
	};
	
	angular.value("$metaBuilder", $metaBuilder);
	_angular.$rootScope;
	
	_model.$CalDataModel;
	
	_squid.$util;
	
	_squid.$meta;
	
	_squid.$Api;
	
	_squid.$locale;
	
	_squid.$config;

/***/ }),

/***/ "./components/xo-tracking/dist/model.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/node-uuid/uuid.js") // Using the same module as used in NodeInfra
	], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid, uuid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('tracking.model', ['squid']).constant('$FptiConstants', {
	        // The prototype of buzname data object
	        buznameMap: {
	            country: {
	                placeHolder: 'glb',
	                fptiKey: 'ccpg'
	            },
	
	            flowgatename: {
	                placeHolder: '',
	                fptiKey: 'fltp'
	            },
	
	            'flowname': {
	                placeHolder: 'ec:hermes:',
	                fptiKey: 'flnm'
	            },
	            'hier1': {
	                placeHolder: 'main_ec_hermes_',
	                fptiKey: 'shir'
	            },
	            /*
	             * No key defined in FPTI
	             */
	            //            'hier2': '',
	            //            'hier3': '',
	            //            'hier4': '',
	            //            'hier5': '',
	            'inout': {
	                placeHolder: 'inout',
	                fptiKey: 'lgin'
	            },
	            'pagename': {
	                placeHolder: 'main:ec:hermes',
	                fptiKey: 'pgrp'
	            },
	            'pagename2': {
	                placeHolder: 'main:ec:hermes',
	                fptiKey: 'page'
	            },
	            'version': {
	                placeHolder: 'hermes',
	                fptiKey: 'vers'
	                /*
	                 * Deprecated SiteCatalyst keys
	                 */
	                //            'feature': 'ec',
	                //            'oldpagename': '',
	                //            'product': ';ec',
	                //            'subfeature1': 'hermes',
	                //            'subfeature2': '',
	                //            'website': 'main'
	            } },
	
	        // Full list of FPTI keys indexed by readable names
	        // This mapping can also be served as default decorator
	        fptiKeys: {
	            'businessType': 'bztp',
	            'correlationId': 'calc', // CalDataModel
	            'countryOfPage': 'ccpg', // buzname
	            'cust': 'cust',
	            'errorCode': 'eccd',
	            'fieldError': 'erfd',
	            'flowgatename': 'fltp', // buzname
	            'flowname': 'flnm', // buzname
	            'locale': 'rsta', // LocaleModel
	            'loggedIn': 'lgin', // buzname
	            'merchantId': 'mrid',
	            'merchantType': 'mbtp',
	            'pageError': 'erpg',
	            'pageGoal': 'goal', // route
	            'pageGroup': 'pgrp', // buzname
	            'pageName': 'page', // buzname
	            'pageQualifer': 'qual', // buzname
	            'pageStartTime': 'pgst', // FptiBuilder
	            'pageTechnologyFlag': 'pgtf', // productConfig
	            'paymentFlowId': 'pfid',
	            'rLogId': 'teal',
	            'sessionId': 'fpti',
	            'siteHierarchy': 'shir', // buzname
	            'sourceCi': 's', // productConfig
	            'tealeaf': 'teal',
	            'templateName': 'tmpl', // route
	            'transition_time': 'transition_time',
	            'uuid': 'csci', // CalDataModel
	            'version': 'vers', // buzname
	            'visitorId': 'vid',
	            'ecToken': 'fltk', // metadata
	            'pxpExpSelected': 'xe',
	            'pxpTreatementSelected': 'xt',
	            'pxpQualifiedTreatment': 'qt',
	            'pxpContextId': 'qc',
	            'dc': 'dc',
	            'az': 'az',
	            'comp': 'comp'
	        },
	
	        landing_page: {
	            login: 'LOGIN',
	            econsent: 'eConsent',
	            review: 'Review',
	            error_page: 'error_page',
	            add_card: 'add_card',
	            add_bank: 'add_bank',
	            billing: 'billing',
	            done_page: 'done_page',
	            shoppingCart: 'shoppingCart',
	            emptyCart: 'emptyCart',
	            soldout: 'soldout',
	            openButton: 'openButton'
	        },
	
	        stateName: {
	            checkout_login: 'login',
	            checkout_genericError: 'error_page',
	            checkout_fastlogin: 'login',
	            checkout_econsent: 'econsent',
	            checkout_review: 'review',
	            checkout_pageAddCard_addCardFlow_addCard: 'add_card',
	            checkout_updateCard_addCardFlow_addCard: 'add_card',
	            checkout_pageAddFi_bank_add: 'add_bank',
	            guest: 'billing',
	            checkout_done: 'done_page',
	            checkout_guest: 'billing',
	            checkout_signup: 'billing',
	            guestupgrade_genericError: 'error_page',
	            checkout_multistepsignup_multistepsignupaddcard: 'billing',
	            checkout_shoppingCart: 'shoppingCart',
	            checkout_emptyCart: 'emptyCart',
	            checkout_soldout: 'soldout',
	            checkout_openButton: 'openButton'
	        }
	    }).factory('$FptiDataModel', function ($Class, $FptiConstants, $util, $config) {
	        var productConfig = {};
	        // TODO to read from config.json
	        productConfig[$FptiConstants.fptiKeys.sourceCi] = 'ci';
	        productConfig[$FptiConstants.fptiKeys.pageTechnologyFlag] = 'NodeJS';
	
	        /**
	         * Utilizing Decorator pattern to allow defining additional logic for specific keys
	         */
	        return $Class.extend('FptiDataModel', {
	            init: function init() {
	                this._dataObj = angular.extend({}, productConfig);
	                this._decoratorList = [];
	            },
	            decorators: {
	                buzname: function buzname(trackingData, pageQualifier, isInContext, productOverride) {
	
	                    if (!trackingData) {
	                        return;
	                    }
	
	                    var buzname = trackingData.buzname;
	                    if (!buzname) {
	                        return;
	                    }
	
	                    var buznameDiff = buzname[pageQualifier];
	                    if (!buznameDiff) {
	                        return;
	                    }
	
	                    var dataObj = this._dataObj;
	                    var buznameMap = $FptiConstants.buznameMap;
	                    // read app specific place holder from config
	                    var placeHolderConfig = $config && $config.fpti && $config.fpti.buznameEntryPlaceHolder;
	
	                    Object.keys(buznameMap).forEach(function (key) {
	                        var buznameEntry = buznameMap[key];
	                        var fptiKey = buznameEntry.fptiKey;
	                        var placeHolder = buznameEntry.placeHolder;
	
	                        if (buznameDiff[key]) {
	                            if (placeHolderConfig && placeHolderConfig[key]) {
	                                placeHolder = placeHolderConfig[key];
	                            }
	
	                            if (productOverride) {
	                                var _placeHolder$split = placeHolder.split(':'),
	                                    main = _placeHolder$split[0],
	                                    hermes = _placeHolder$split[2];
	
	                                placeHolder = main + ':' + productOverride + ':' + hermes;
	                            }
	
	                            dataObj[fptiKey] = buznameDiff[key].replace('%', placeHolder);
	                        } else {
	                            dataObj[fptiKey] = placeHolder;
	                        }
	                    });
	                    dataObj[$FptiConstants.fptiKeys.pageQualifer] = pageQualifier;
	                },
	
	                locale: function locale(_locale) {
	                    if (_locale && _locale.country) {
	                        this._dataObj[$FptiConstants.fptiKeys.locale] = _locale.country;
	                    }
	                },
	
	                pxptrackingdata: function pxptrackingdata(pxpData) {
	                    var qt = [];
	                    var qc = [];
	                    var xe = [];
	                    var xt = [];
	                    $util.some(pxpData, function (trackInfo) {
	                        var match = trackInfo && trackInfo.tracking_tags && trackInfo.tracking_tags.match('\\bqt=([^;]+);');
	                        if (match) {
	                            qt.push(match[1]);
	                        }
	
	                        match = trackInfo && trackInfo.tracking_tags && trackInfo.tracking_tags.match('\\bqc=([^;]+);');
	                        if (match) {
	                            qc.push(match[1]);
	                        }
	
	                        $util.some(trackInfo.treatments, function (treatment) {
	                            xe.push(treatment.experiment_id);
	                            xt.push(treatment.treatment_id);
	                        });
	                    });
	
	                    this._dataObj[$FptiConstants.fptiKeys.pxpQualifiedTreatment] = qt.join(',');
	                    this._dataObj[$FptiConstants.fptiKeys.pxpContextId] = qc.join(',');
	                    this._dataObj[$FptiConstants.fptiKeys.pxpExpSelected] = xe.join(',');
	                    this._dataObj[$FptiConstants.fptiKeys.pxpTreatementSelected] = xt.join(',');
	                },
	
	                templateName: function templateName(trackingData, pageQualifier, isInContext) {
	                    if (trackingData && trackingData.templateName) {
	                        var templateName = (trackingData.templateName || '') + (pageQualifier ? ':' + pageQualifier : '');
	
	                        this._dataObj[$FptiConstants.fptiKeys.templateName] = templateName;
	                    }
	                },
	
	                fieldError: function fieldError(err) {
	                    if (err && err.type === 'fieldError') {
	                        this._dataObj[$FptiConstants.fptiKeys.fieldError] = err.field;
	                        this._dataObj[$FptiConstants.fptiKeys.errorCode] = err.code;
	                    }
	                },
	
	                pageError: function pageError(err) {
	                    if (err && err.type === 'pageError') {
	
	                        this._dataObj[$FptiConstants.fptiKeys.pageError] = err.msg;
	                        this._dataObj[$FptiConstants.fptiKeys.errorCode] = err.code;
	                    }
	                }
	
	            },
	            decorate: function decorate(name) {
	                this._decoratorList.push({
	                    name: name,
	                    params: Array.prototype.slice.call(arguments, 1)
	                });
	                return this;
	            },
	            getDataObject: function getDataObject(isInContext) {
	                var i;
	                var decorator;
	
	                for (i = 0; i < this._decoratorList.length; i++) {
	                    decorator = this._decoratorList[i];
	                    if (!decorator) {
	                        continue;
	                    }
	                    var name = decorator.name;
	                    var params = decorator.params;
	                    if (angular.isFunction(this.decorators[name])) {
	                        // Invoke the decorator and pass in the parameter list
	                        this.decorators[name].apply(this, params);
	                    } else {
	                        var fptiKey = $FptiConstants.fptiKeys[name];
	                        // If the fptiKey is defined and value is present, add the k-v pair
	                        if (fptiKey && params && params.length > 0) {
	                            this._dataObj[fptiKey] = params[0];
	                        }
	                    }
	                }
	
	                // 'fullpage' was widely used as default key in page routs definition
	                // finally replace it here if it's incontext
	                var dataObj = this._dataObj;
	                if (isInContext) {
	                    Object.keys(dataObj).forEach(function (k) {
	                        if (angular.isString(dataObj[k])) {
	                            // some values can be number
	                            dataObj[k] = dataObj[k].replace('fullpage', 'incontext');
	                        }
	                    });
	                }
	
	                return this._dataObj;
	            }
	        });
	    }).factory('$CalDataModel', function ($Model) {
	
	        var uuid_v4_mask = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
	        var uuid_v1_mask = 'XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX';
	
	        function _generateCorrelationId() {
	            var uidRandomArr = (uuid.v4() || uuid_v4_mask).split('-');
	            var uidTime = (uuid.v1() || uuid_v1_mask).split('-');
	            return uidTime[0] + uidRandomArr[0].substr(0, 5);
	        }
	
	        function _generateUUID() {
	            return (uuid.v4() || uuid_v4_mask).replace(/-/g, '');
	        }
	
	        var CalModel = $Model.extend({
	            _calCorrId: _generateCorrelationId(),
	            _uuid: _generateUUID(),
	
	            generateCalCorrId: function generateCalCorrId() {
	                this._calCorrId = _generateCorrelationId();
	            },
	            generateUUID: function generateUUID() {
	                this._uuid = _generateUUID();
	            },
	            generateMetaIds: function generateMetaIds() {
	                this.generateCalCorrId();
	                this.generateUUID();
	            },
	
	            getCalCorrId: function getCalCorrId() {
	                return this._calCorrId;
	            },
	
	            getUUID: function getUUID() {
	                return this._uuid;
	            }
	        });
	
	        return new CalModel();
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-tracking/dist", "components/xo-tracking/dist/model.js"))

/***/ }),

/***/ "./components/node-uuid/uuid.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(console) {
	
	//     uuid.js
	//
	//     Copyright (c) 2010-2012 Robert Kieffer
	//     MIT License - http://opensource.org/licenses/mit-license.php
	
	/*global window, require, define */
	(function (_window) {
	  
	
	  // Unique ID creation requires a high quality random # generator.  We feature
	  // detect to determine the best RNG source, normalizing to a function that
	  // returns 128-bits of randomness, since that's what's usually required
	
	  var _rng, _mathRNG, _nodeRNG, _whatwgRNG, _previousRoot;
	
	  function setupBrowser() {
	    // Allow for MSIE11 msCrypto
	    var _crypto = _window.crypto || _window.msCrypto;
	
	    if (!_rng && _crypto && _crypto.getRandomValues) {
	      // WHATWG crypto-based RNG - http://wiki.whatwg.org/wiki/Crypto
	      //
	      // Moderately fast, high quality
	      try {
	        var _rnds8 = new Uint8Array(16);
	        _whatwgRNG = _rng = function whatwgRNG() {
	          _crypto.getRandomValues(_rnds8);
	          return _rnds8;
	        };
	        _rng();
	      } catch (e) {}
	    }
	
	    if (!_rng) {
	      // Math.random()-based (RNG)
	      //
	      // If all else fails, use Math.random().  It's fast, but is of unspecified
	      // quality.
	      var _rnds = new Array(16);
	      _mathRNG = _rng = function _rng() {
	        for (var i = 0, r; i < 16; i++) {
	          if ((i & 0x03) === 0) {
	            r = Math.random() * 0x100000000;
	          }
	          _rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
	        }
	
	        return _rnds;
	      };
	      if ('undefined' !== typeof console && console.warn) {
	        console.warn("[SECURITY] node-uuid: crypto not usable, falling back to insecure Math.random()");
	      }
	    }
	  }
	
	  function setupNode() {
	    // Node.js crypto-based RNG - http://nodejs.org/docs/v0.6.2/api/crypto.html
	    //
	    // Moderately fast, high quality
	    if (true) {
	      try {
	        var _rb = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"crypto\""); e.code = 'MODULE_NOT_FOUND'; throw e; }())).randomBytes;
	        _nodeRNG = _rng = _rb && function () {
	          return _rb(16);
	        };
	        _rng();
	      } catch (e) {}
	    }
	  }
	
	  if (_window) {
	    setupBrowser();
	  } else {
	    setupNode();
	  }
	
	  // Buffer class to use
	  var BufferClass = 'function' === typeof Buffer ? Buffer : Array;
	
	  // Maps for number <-> hex string conversion
	  var _byteToHex = [];
	  var _hexToByte = {};
	  for (var i = 0; i < 256; i++) {
	    _byteToHex[i] = (i + 0x100).toString(16).substr(1);
	    _hexToByte[_byteToHex[i]] = i;
	  }
	
	  // **`parse()` - Parse a UUID into it's component bytes**
	  function parse(s, buf, offset) {
	    var i = buf && offset || 0,
	        ii = 0;
	
	    buf = buf || [];
	    s.toLowerCase().replace(/[0-9a-f]{2}/g, function (oct) {
	      if (ii < 16) {
	        // Don't overflow!
	        buf[i + ii++] = _hexToByte[oct];
	      }
	    });
	
	    // Zero out remaining bytes if string was short
	    while (ii < 16) {
	      buf[i + ii++] = 0;
	    }
	
	    return buf;
	  }
	
	  // **`unparse()` - Convert UUID byte array (ala parse()) into a string**
	  function unparse(buf, offset) {
	    var i = offset || 0,
	        bth = _byteToHex;
	    return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
	  }
	
	  // **`v1()` - Generate time-based UUID**
	  //
	  // Inspired by https://github.com/LiosK/UUID.js
	  // and http://docs.python.org/library/uuid.html
	
	  // random #'s we need to init node and clockseq
	  var _seedBytes = _rng();
	
	  // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
	  var _nodeId = [_seedBytes[0] | 0x01, _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]];
	
	  // Per 4.2.2, randomize (14 bit) clockseq
	  var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;
	
	  // Previous uuid creation time
	  var _lastMSecs = 0,
	      _lastNSecs = 0;
	
	  // See https://github.com/broofa/node-uuid for API details
	  function v1(options, buf, offset) {
	    var i = buf && offset || 0;
	    var b = buf || [];
	
	    options = options || {};
	
	    var clockseq = options.clockseq != null ? options.clockseq : _clockseq;
	
	    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
	    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
	    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
	    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
	    var msecs = options.msecs != null ? options.msecs : new Date().getTime();
	
	    // Per 4.2.1.2, use count of uuid's generated during the current clock
	    // cycle to simulate higher resolution clock
	    var nsecs = options.nsecs != null ? options.nsecs : _lastNSecs + 1;
	
	    // Time since last uuid creation (in msecs)
	    var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000;
	
	    // Per 4.2.1.2, Bump clockseq on clock regression
	    if (dt < 0 && options.clockseq == null) {
	      clockseq = clockseq + 1 & 0x3fff;
	    }
	
	    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
	    // time interval
	    if ((dt < 0 || msecs > _lastMSecs) && options.nsecs == null) {
	      nsecs = 0;
	    }
	
	    // Per 4.2.1.2 Throw error if too many uuids are requested
	    if (nsecs >= 10000) {
	      throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
	    }
	
	    _lastMSecs = msecs;
	    _lastNSecs = nsecs;
	    _clockseq = clockseq;
	
	    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
	    msecs += 12219292800000;
	
	    // `time_low`
	    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
	    b[i++] = tl >>> 24 & 0xff;
	    b[i++] = tl >>> 16 & 0xff;
	    b[i++] = tl >>> 8 & 0xff;
	    b[i++] = tl & 0xff;
	
	    // `time_mid`
	    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
	    b[i++] = tmh >>> 8 & 0xff;
	    b[i++] = tmh & 0xff;
	
	    // `time_high_and_version`
	    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
	    b[i++] = tmh >>> 16 & 0xff;
	
	    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
	    b[i++] = clockseq >>> 8 | 0x80;
	
	    // `clock_seq_low`
	    b[i++] = clockseq & 0xff;
	
	    // `node`
	    var node = options.node || _nodeId;
	    for (var n = 0; n < 6; n++) {
	      b[i + n] = node[n];
	    }
	
	    return buf ? buf : unparse(b);
	  }
	
	  // **`v4()` - Generate random UUID**
	
	  // See https://github.com/broofa/node-uuid for API details
	  function v4(options, buf, offset) {
	    // Deprecated - 'format' argument, as supported in v1.2
	    var i = buf && offset || 0;
	
	    if (typeof options === 'string') {
	      buf = options === 'binary' ? new BufferClass(16) : null;
	      options = null;
	    }
	    options = options || {};
	
	    var rnds = options.random || (options.rng || _rng)();
	
	    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	    rnds[6] = rnds[6] & 0x0f | 0x40;
	    rnds[8] = rnds[8] & 0x3f | 0x80;
	
	    // Copy bytes to buffer, if provided
	    if (buf) {
	      for (var ii = 0; ii < 16; ii++) {
	        buf[i + ii] = rnds[ii];
	      }
	    }
	
	    return buf || unparse(rnds);
	  }
	
	  // Export public API
	  var uuid = v4;
	  uuid.v1 = v1;
	  uuid.v4 = v4;
	  uuid.parse = parse;
	  uuid.unparse = unparse;
	  uuid.BufferClass = BufferClass;
	  uuid._rng = _rng;
	  uuid._mathRNG = _mathRNG;
	  uuid._nodeRNG = _nodeRNG;
	  uuid._whatwgRNG = _whatwgRNG;
	
	  if ('undefined' !== typeof module && module.exports) {
	    // Publish as node.js module
	    module.exports = uuid;
	  } else if (true) {
	    // Publish as AMD module
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return uuid;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else {
	    // Publish as global (in browsers)
	    _previousRoot = _window.uuid;
	
	    // **`noConflict()` - (browser only) to reset global 'uuid' var**
	    uuid.noConflict = function () {
	      _window.uuid = _previousRoot;
	      return uuid;
	    };
	
	    _window.uuid = uuid;
	  }
	})('undefined' !== typeof window ? window : null);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ }),

/***/ "./js/lib/middleware.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./js/lib/miniBrowser.js"), __webpack_require__("./components/xo-locale/dist/index.js"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/app/index.js"), __webpack_require__("./components/xo-models/src/onboard/index.js"), __webpack_require__("./components/xo-models/src/auth/lib/xoAPayUtils.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('hermes.lib.middleware', ['squid', 'xolocale', 'xomodel.checkout', 'xomodel.app', 'xomodel.user', 'xomodel.onboard']).factory('$Middleware', function ($rootScope, $q, $util, $LocaleResolver, $CheckoutAppDataModel, $CheckoutCartModel, $GuestUpgradeModel, $CheckoutInputDataModel, $CheckoutClientDataModel, $CheckoutPayeeModel, $config, $meta, $pxp, $MiniBrowser, $FallbackError, $locale, $populate, $promise, $feature, $featureCountries, $AuthModel, $window, $timeout, $experiment, $TransactionEligibilityModel, $logger, $dispatch, $xoAPayUtils) {
	
	        return [function checkToken() {
	            var urlToken = $util.param('token');
	            var bodyToken = $meta.token;
	            // wps tokens are not preceeded with 'EC-'
	            var wpsPattern = /^[0-9A-Z]{17}$/;
	
	            if (urlToken !== $meta.token) {
	                $logger.error('token_mismatch', {
	                    server: $meta.token,
	                    client: urlToken
	                });
	            }
	
	            if (!urlToken && !bodyToken && !$util.param('data')) {
	                throw new Error('No token or data found in page url');
	            }
	
	            // first set regular token (EC transactions)
	            $rootScope.token = bodyToken || urlToken;
	
	            $window.root = $rootScope;
	
	            // now test for WPS, set flags as necessary and log.
	            // make sure ebay transactions aren't counted
	            var isEbay = $CheckoutInputDataModel.instance($rootScope.token).isEbayTxn();
	
	            // identify WPS vs checkout-order token
	            if (!isEbay && wpsPattern.test($rootScope.token)) {
	                return $CheckoutAppDataModel.instance($rootScope.token).retrieve().then(function (appData) {
	                    // For WPS tokens appData.doec_on_approve() will always return 'true'.
	                    if (appData.doec_on_approve()) {
	                        $logger.info('xoon_wps_flow', {
	                            token: $rootScope.token
	                        });
	                    } else {
	                        $logger.info('xoon_xo_order_flow', {
	                            token: $rootScope.token
	                        });
	                    }
	                });
	            }
	        }, function resolveLocale() {
	
	            var models = {};
	
	            if ($rootScope.token) {
	                return $populate(models, {
	                    appData: $CheckoutAppDataModel.instance($rootScope.token).retrieve({
	                        contingencies: {
	                            DEFAULT: angular.noop
	                        }
	                    }),
	                    cart: $CheckoutCartModel.instance($rootScope.token)
	                })['finally'](function () {
	                    return $locale.retrieve({
	                        params: {
	                            ipCountry: $meta.ipcountry,
	                            localeTestUrlParam: $util.param('locale.test'),
	                            checkoutBillingCountry: models.cart.get('payer_info.billing_address.country_code'),
	                            checkoutShippingCountry: models.cart.get('purchase.shipping_address.country_code'),
	                            merchantCountry: models.appData.get('merchant.merchant_country'),
	                            checkoutSessionLocale: models.appData.get('merchant.merchant_locale'),
	                            countryParam: $util.param('country.x'),
	                            localeParam: $util.param('locale.x')
	                        }
	                    });
	                });
	            } else if ($util.param('data')) {
	                var options = {
	                    params: {
	                        data: $util.param('data')
	                    }
	                };
	
	                return $populate(models, {
	                    guestAccountData: $GuestUpgradeModel.instance().retrieve({
	                        options: options,
	                        contingencies: {
	                            MAYFLY_ERROR: angular.noop,
	                            DEFAULT: angular.noop
	                        }
	                    })
	                }).then(function () {
	                    return $locale.retrieve({
	                        params: {
	                            ipCountry: $meta.ipcountry,
	                            localeTestUrlParam: $util.param('locale.test'),
	                            countryParam: models.guestAccountData.get('user.country')
	                        }
	                    });
	                });
	            }
	        }, function logout() {
	            return $AuthModel.instance().retrieve().then(function (auth) {
	                if (auth.logged_in || auth.email) {
	                    return auth.action('logout');
	                }
	            });
	        }, function checkTransactionEligibility() {
	            // skip XOE call for prox upgrade and prox sign up flows
	            // prox upgrade identification - data is a query param in the url for prox upgrade
	            // prox signup flow identification - ebay flag from $CheckoutInputDataModel indicates prox signup flow.
	            if ($rootScope.token && $CheckoutInputDataModel.instance($rootScope.token).isEbayTxn()) {
	                return $logger.info('prox_transaction_ignore_XOE_CALL');
	            } else if ($util.param('data')) {
	                return $logger.info('prox_upgrade_transaction_ignore_XOE_CALL');
	            } else {
	                return $promise.hash({
	                    transactionEligibility: $TransactionEligibilityModel.instance($rootScope.token).retrieve()
	                }).then(function (data) {
	                    if (data.transactionEligibility.eligible && !data.transactionEligibility.lipp) {
	                        return $logger.info('transaction_eligible');
	                    }
	
	                    $logger.info('transaction_ineligible');
	
	                    return $q.reject(new $FallbackError({
	                        reason: 'transaction_ineligible',
	                        product: 'ux'
	                    }));
	                });
	            }
	        },
	
	        /**
	         * Redirect back to Hermes if Android user with PayPal available through Android pay who
	         * landed on Xoon due to BASL. 2 checks need to be done to determine if user has PayPal 
	         * in Android pay wallet: 1. chrome version >=58 (this version support payment api) 
	         * 2. call canMakePayment api call to validate if PayPal is already available in Android pay
	         */
	        function checkAPayBASLRedirect() {
	            // Check if browser supports PaymentRequest API.
	            if (!$xoAPayUtils.isAPayAPISupported()) {
	                return;
	            }
	
	            var models = {};
	
	            return $populate(models, {
	                cart: $CheckoutCartModel.instance($rootScope.token).retrieve()
	            }).then(function () {
	                // Do nothing for APay onboarding flow.
	                if (models.cart.isWalletTokenization()) {
	                    return;
	                }
	
	                // Call PaymentRequest API to check if paypal as payment available
	                return $xoAPayUtils.canMakeAPayPayment().then(function (result) {
	                    if (result) {
	                        return $dispatch('hermes', {
	                            token: $rootScope.token,
	                            hermesLoginRedirect: 'xoon',
	                            'locale.x': $locale.lang + '_' + $locale.country,
	                            'country.x': $locale.country
	                        });
	                    }
	                    return;
	                });
	            });
	        }, function xcomponent() {
	
	            if (window.xprops && window.xprops.init) {
	
	                return $q.all([$CheckoutAppDataModel.instance($rootScope.token).retrieve(), $CheckoutPayeeModel.instance($rootScope.token).retrieve()]).then(function (_ref) {
	                    var checkoutAppData = _ref[0],
	                        checkoutPayee = _ref[1];
	
	
	                    return window.xprops.init({
	                        paymentToken: $rootScope.token,
	                        merchantID: checkoutPayee.merchant.id,
	                        cancelUrl: checkoutAppData.urls.cancel_url
	                    });
	                });
	            }
	        }, function updateMerchantData() {
	            if ($CheckoutInputDataModel.instance($rootScope.token).isEbayTxn()) {
	                return $CheckoutAppDataModel.instance($rootScope.token).retrieve().then(function (appData) {
	                    return $CheckoutClientDataModel.instance($rootScope.token).retrieve().then(function (clientData) {
	                        var checkoutInputData = $CheckoutInputDataModel.instance($rootScope.token);
	                        var identityData = clientData.merchantIdentityData();
	
	                        appData.merchant = {
	                            merchant_email: identityData.email,
	                            brand_name: identityData.brand_name,
	                            logo_url: identityData.logo_uri
	                        };
	
	                        appData.urls = {
	                            cancel_url: checkoutInputData.errorUrl('user_cancelled')
	                        };
	                    });
	                });
	            }
	        }, function checkJavaScriptInjection() {
	            if ($CheckoutInputDataModel.instance($rootScope.token).isEbayTxn()) {
	                $logger.info('prox_signup_start', { cart_id: $rootScope.token });
	                var redirectUri = $util.param('redirect_uri');
	
	                if (redirectUri && redirectUri.indexOf('http') !== 0) {
	                    $logger.warn('XOON_FLOW_INVALID_REDIRECT_URI_JAVASCRIPT_INJECTION', {
	                        uri: redirectUri
	                    });
	                    return $q.reject(new $FallbackError({
	                        reason: 'invalidRedirectURI',
	                        product: 'ux'
	                    }));
	                }
	            }
	        }, function verifyRedirectURI() {
	            if ($CheckoutInputDataModel.instance($rootScope.token).isEbayTxn()) {
	                var redirectUri = $util.param('redirect_uri');
	
	                return $CheckoutClientDataModel.instance($rootScope.token).retrieve().then(function (clientData) {
	                    var isValidUri = clientData.validateRedirectUri(redirectUri) || {};
	
	                    if (!isValidUri.success) {
	                        $logger.warn('XOON_FLOW_INVALID_REDIRECT_URI', {
	                            uri: redirectUri
	                        });
	                        return $q.reject(new $FallbackError({
	                            reason: 'invalidRedirectURI',
	                            product: 'ux'
	                        }));
	                    }
	                });
	            }
	        },
	
	        // allow PROX to support country content separate from Hermes
	        function proxFallbackManager() {
	            if ($CheckoutInputDataModel.instance($rootScope.token).isEbayTxn()) {
	                $featureCountries('guestFallback').forEach(function (country, index) {
	                    $config.features[country].guestFallback = false;
	                });
	            }
	        }, function handleTagManager() {
	
	            $window.dataLayer = {
	                // Two letter country code of the current page's content
	                contentCountry: $locale.country.toLowerCase(),
	                // Two letter locale
	                contentLanguage: $locale.lang.toLowerCase()
	            };
	
	            var tagManagerUrl = '//www.paypalobjects.com/tagmgmt/bootstrap.js';
	
	            // Based on the environment, Tag Manager end point can be changed. For now the local and stage end points are same.
	            if ($window.location.href.indexOf('qa.paypal.com') > -1 || $window.location.href.indexOf('localhost') > -1) {
	                tagManagerUrl = '//nexus.ensighten.com/paypal/stage/Bootstrap.js';
	            }
	            (function (i, s, o, g, r, a, m) {
	                i.tagManagerObjec = r;
	                i[r] = i[r] || function () {
	                    (i[r].q = i[r].q || []).push(arguments);
	                };
	                i[r].l = 1 * new Date();
	                a = s.createElement(o);
	                m = s.getElementsByTagName(o)[0];
	                a.async = 1;
	                a.src = g;
	                m.parentNode.insertBefore(a, m);
	            })($window, document, 'script', tagManagerUrl, 'tagManager');
	        }, function setupMiniBrowser() {
	            if ($util.param('data')) {
	                return $MiniBrowser.initialize($util.param('cancel_url'));
	            }
	
	            return $CheckoutAppDataModel.instance($rootScope.token).retrieve().then(function (appData) {
	                return $MiniBrowser.initialize(appData.urls.cancel_url);
	            });
	        }, function logStart() {
	            $logger.info('app_start_design', {
	                is_directintegration: $MiniBrowser.isDirectIntegration ? 1 : 0,
	                is_incontext: $MiniBrowser.isMiniBrowser || $MiniBrowser.isFrame ? 1 : 0
	            });
	        }];
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "js/lib", "js/lib/middleware.js"))

/***/ }),

/***/ "./js/lib/miniBrowser.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	var _integration = __webpack_require__("./js/lib/integration.js");
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('hermes.lib.minibrowser', ['squid']).factory('$MiniBrowser', function ($rootScope, $q, $window, $Class, $populate, $CheckoutAppDataModel, $ReturnToMerchant, $logger, $util, $locale, $feature) {
	
	        var MiniBrowser = $Class.extend('MiniBrowser', {
	
	            isMiniBrowser: false,
	            partnerIntegration: false,
	            isDirectIntegration: false,
	
	            _isMiniBrowser: function _isMiniBrowser() {
	                return window.name && window.name.indexOf('PPFrame') === 0 && $util.isPopup() || $util.param('incontext') === '1' || window.xchild && $util.isPopup();
	            },
	            _isFrame: function _isFrame() {
	                return $util.isIFrame();
	            },
	
	
	            initialize: function initialize(cancel_url) {
	                this.isMiniBrowser = $rootScope.miniBrowser = this._isMiniBrowser();
	                this.isFrame = this._isFrame();
	                this.partnerIntegration = $rootScope.partnerIntegration = $window.name === 'PPFrameRedirect' || $util.param('nolegacy') === '1';
	
	                //  this.nativeIntegration is true, whenever the query param native_xo=1 when hermes was launched
	                this.nativeIntegration = $util.param('native_xo') === '1';
	
	                this.isDirectIntegration = this.isMiniBrowser || this.partnerIntegration || Boolean($util.param('incontext')) || $window.location.pathname.indexOf('/checkoutnow') > -1;
	
	                if (this.partnerIntegration) {
	                    _integration.$integration.setFlow(_integration.$FLOWS.PARTNER);
	                    $logger.info('partner_integration_flow');
	                } else if (this.nativeIntegration && $feature('nativexoSupport')) {
	                    // we are setting the flow to be native checkout type
	                    // whenever the nativeIntegration flag is on
	                    // setting this flow will enable the redirect_uri query param
	                    // passed to hermes to override the merchant's redirect url
	                    // on cancel or redirect after a successful payment
	
	                    _integration.$integration.setFlow(_integration.$FLOWS.NATIVE_CHECKOUT);
	                    $logger.info('nativexo_integration_flow');
	                }
	
	                if (this.isMiniBrowser && !this.partnerIntegration) {
	                    var msg;
	
	                    try {
	                        msg = {
	                            cancelUrl: cancel_url,
	                            landingUrl: $window.location.href,
	                            secureWindowmsg: $locale.content.scripts.secureWindowmsg
	                        };
	                    } catch (err) {
	                        return $logger.error('minibrowser_msg_construction_failed', {
	                            error: err
	                        });
	                    }
	
	                    if (!$ReturnToMerchant.postToMerchant(msg)) {
	                        $logger.error('minibrowser_post_failed');
	                    }
	                }
	            }
	        });
	
	        return new MiniBrowser();
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	_integration.$integration;
	
	_integration.$FLOWS;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "js/lib", "js/lib/miniBrowser.js"))

/***/ }),

/***/ "./js/lib/integration.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$CONTEXT = exports.$integration = exports.$FLOWS = undefined;
	
	var _$DEFAULT, _$CONTEXT$FULLPAGE, _$integration$init;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	Object.defineProperty(exports, '$integration', {
	    enumerable: true,
	    get: function get() {
	        return _squid.$integration;
	    }
	});
	Object.defineProperty(exports, '$CONTEXT', {
	    enumerable: true,
	    get: function get() {
	        return _squid.$CONTEXT;
	    }
	});
	var $FLOWS = exports.$FLOWS = {
	
	    // Regular end-to-end checkout flow with one entry and one exit point
	    CHECKOUT: 'CHECKOUT',
	
	    // Partner flow [ TODO: FACTOR THIS OUT ]
	    PARTNER: 'PARTNER',
	
	    // Native checkout flow
	    NATIVE_CHECKOUT: 'NATIVE_CHECKOUT'
	};
	
	_squid.$integration.init($FLOWS.CHECKOUT, (_$integration$init = {}, _$integration$init[_squid.$DEFAULT] = (_$DEFAULT = {
	
	    REDIRECT_TOP: true,
	    REDIRECT_QUERY_PARAM: false
	
	}, _$DEFAULT[$FLOWS.PARTNER] = {
	
	    REDIRECT_TOP: false
	}, _$DEFAULT), _$integration$init[_squid.$CONTEXT.FULLPAGE] = (_$CONTEXT$FULLPAGE = {}, _$CONTEXT$FULLPAGE[$FLOWS.NATIVE_CHECKOUT] = {
	
	    REDIRECT_QUERY_PARAM: true
	
	}, _$CONTEXT$FULLPAGE), _$integration$init));
	
	_squid.$integration;
	
	_squid.$DEFAULT;
	
	_squid.$CONTEXT;

/***/ }),

/***/ "./components/xo-locale/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-beaver/dist/logger.js"), __webpack_require__("./components/xo-locale/dist/resolvers.js"), __webpack_require__("./components/xo-locale/dist/language.js"), __webpack_require__("./components/xo-locale/dist/helper.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    return angular.module('xolocale', ['squid', 'beaver', 'locale.resolvers', 'locale.resolvers.language', 'locale.helper']);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "./components/xo-locale/dist/resolvers.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-locale/dist/country.js"), __webpack_require__("./components/xo-locale/dist/language.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('locale.resolvers', ['locale.resolvers.country', 'locale.resolvers.language']).service('$LocaleResolver', function ($locale, $Class, $util, $logger, $CountryResolvers, $LanguageResolvers, $config, $q) {
	
	        var LocaleResolver = $Class.extend('LocaleResolver', {
	
	            registerCountryResolver: function registerCountryResolver(name, resolver) {
	                $CountryResolvers[name] = resolver;
	            },
	
	            registerLangResolver: function registerLangResolver(name, resolver) {
	                $LanguageResolvers[name] = resolver;
	            },
	
	            resolvePromiseChain: function resolvePromiseChain(resolvers, validator, args) {
	
	                var self = this;
	                var promise = $q.when();
	                var result;
	
	                angular.forEach(resolvers, function (resolver) {
	
	                    promise = promise.then(function () {
	
	                        if (result) {
	                            return result;
	                        }
	
	                        return $q.when(resolver.method.apply(self, args || [])).then(function (resolved) {
	
	                            if (resolved && validator(resolved)) {
	                                result = {
	                                    resolver: resolver.name,
	                                    resolved: resolved
	                                };
	                                return result;
	                            }
	                        });
	                    }, angular.noop);
	                });
	
	                return promise;
	            },
	
	            resolveCountry: function resolveCountry() {
	
	                var validator = function validator(country) {
	                    return Boolean(country && $config.supportedCountries[country]);
	                };
	
	                var resolvers = $util.map($config.locale.country.resolvers, function (name) {
	                    $CountryResolvers[name].name = name;
	                    return $CountryResolvers[name];
	                });
	
	                return this.resolvePromiseChain(resolvers, validator).then(function (resolved) {
	                    $logger.debug('resolve_country', {
	                        country: resolved.resolved,
	                        resolver: resolved.resolver
	                    });
	                    return resolved.resolved;
	                });
	            },
	
	            resolveLanguage: function resolveLanguage(country) {
	
	                var validator = function validator(language) {
	                    return Boolean($config.supportedCountries[country].indexOf(language) > -1);
	                };
	
	                var resolvers = $util.map($config.locale.lang.resolvers, function (name) {
	                    $LanguageResolvers[name].name = name;
	                    return $LanguageResolvers[name];
	                });
	
	                return this.resolvePromiseChain(resolvers, validator, [country]).then(function (resolved) {
	                    $logger.debug('resolve_lang', {
	                        lang: resolved.resolved,
	                        resolver: resolved.resolver
	                    });
	                    return resolved.resolved;
	                });
	            },
	
	            setUserPreferredCountry: function setUserPreferredCountry(country) {
	                $util.assert(country, 'No country provided');
	                this.userPreferredCountry = country;
	            },
	
	            setUserPreferredLanguage: function setUserPreferredLanguage(language) {
	                $util.assert(language, 'No language provided');
	                this.userPreferredLanguage = language;
	            },
	
	            resolve: function resolve(preventContentLoad) {
	
	                var self = this;
	
	                function resolveCountry() {
	                    if (self.userPreferredCountry) {
	                        return $q.when(self.userPreferredCountry);
	                    }
	
	                    return self.resolveCountry();
	                }
	
	                function resolveLanguage(country) {
	                    if (self.userPreferredLanguage) {
	                        return $q.when(self.userPreferredLanguage);
	                    }
	
	                    return self.resolveLanguage(country);
	                }
	
	                return resolveCountry().then(function (country) {
	                    return resolveLanguage(country).then(function (language) {
	                        return {
	                            language: language,
	                            country: country
	                        };
	                    });
	                }).then(function (result) {
	                    return $locale.change(result.country, result.language, preventContentLoad);
	                });
	            }
	
	        });
	
	        return new LocaleResolver();
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-locale/dist", "components/xo-locale/dist/resolvers.js"))

/***/ }),

/***/ "./components/xo-locale/dist/country.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-locale/dist/helper.js"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/auth/index.js"), __webpack_require__("./components/xo-models/src/app/index.js"), __webpack_require__("./components/xo-models/src/onboard/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('locale.resolvers.country', ['squid', 'locale.helper', 'xomodel.checkout', 'xomodel.auth', 'xomodel.app', 'xomodel.onboard']).factory('$CountryResolvers', function ($q, $rootScope, $populate, $util, $meta, $localeHelper, $locale, $AuthModel, $CheckoutCartModel, $AppDataModel, $CheckoutAppDataModel, $GuestUpgradeModel) {
	
	        return {
	
	            viaCountryPreference: {
	                method: function method() {
	                    return $locale.chosenCountry;
	                }
	            },
	
	            viaLocaleTestUrlParam: {
	                desc: 'For non-LIVE test, read from locale.test url param, e.g. http://localhost.com:3000/?locale.test=fr_FR',
	                method: function method() {
	                    var locale = $util.param('locale.test');
	
	                    if (locale) {
	                        return $localeHelper.normalizeLocale(locale).country;
	                    }
	                }
	            },
	
	            viaMerchantParam: {
	                desc: 'As part of url merchants can pass the locale.x=en_FR or country.x=FR. Here we extract the country param',
	                method: function method() {
	                    var country = $util.param('country.x');
	
	                    if (country) {
	                        return country;
	                    }
	
	                    var locale = $util.param('locale.x');
	
	                    return $localeHelper.normalizeLocale(locale).country;
	                }
	            },
	
	            viaUserProfile: {
	                desc: 'From AuthModel. Country comes as "US", "FR" etc. ',
	                method: function method() {
	                    var data = {};
	
	                    return $populate(data, {
	                        auth: $AuthModel.instance()
	                    }).then(function () {
	                        return data.auth.country;
	                    });
	                }
	            },
	
	            viaCheckoutSession: {
	                desc: 'From Merchant locale in CheckoutAppDataModel. merchant_locale comes as en_US etc.',
	                method: function method() {
	                    // check before creating $CheckoutAppDataModel
	                    if (!$rootScope.token) {
	                        return;
	                    }
	
	                    var data = {};
	
	                    return $populate(data, {
	                        checkoutAppData: $CheckoutAppDataModel.instance($rootScope.token)
	                    }).then(function () {
	                        var merchant_locale = data.checkoutAppData.get('merchant.merchant_locale');
	
	                        if (!merchant_locale) {
	                            return;
	                        }
	
	                        if (merchant_locale.match(/^\w{2}_\w{2}$/)) {
	                            return $localeHelper.normalizeLocale(merchant_locale).country;
	                        }
	
	                        return merchant_locale;
	                    });
	                }
	            },
	
	            viaCheckoutBilling: {
	                desc: 'From Merchant passed billingAddress in CheckoutCart.',
	                method: function method() {
	                    // check before creating $CheckoutCartModel
	                    if (!$rootScope.token) {
	                        return;
	                    }
	
	                    var data = {};
	                    return $populate(data, {
	                        checkoutCart: $CheckoutCartModel.instance($rootScope.token)
	                    }).then(function () {
	                        return data.checkoutCart.get('payer_info.billing_address.country_code');
	                    });
	                }
	            },
	
	            viaCheckoutShipping: {
	                method: function method() {
	                    // check before creating $CheckoutCartModel
	                    if (!$rootScope.token) {
	                        return;
	                    }
	
	                    var data = {};
	
	                    return $populate(data, {
	                        checkoutCart: $CheckoutCartModel.instance($rootScope.token)
	                    }).then(function () {
	                        return data.checkoutCart.get('purchase.shipping_address.country_code');
	                    });
	                }
	            },
	
	            viaMerchantCountry: {
	                method: function method() {
	                    // check before creating $CheckoutAppDataModel
	                    if (!$rootScope.token) {
	                        return;
	                    }
	
	                    var data = {};
	
	                    return $populate(data, {
	                        checkoutAppData: $CheckoutAppDataModel.instance($rootScope.token)
	                    }).then(function () {
	                        return data.checkoutAppData.get('merchant.merchant_country');
	                    });
	                }
	            },
	
	            viaGuestAccountCountry: {
	                desc: 'From Guest account legal country in ISO country code format (e.g. US, AU)',
	                method: function method() {
	                    // only perform this resolver for guest-upgrade flow (has data param)
	                    if (!$util.param('data')) {
	                        return;
	                    }
	
	                    return $GuestUpgradeModel.instance().retrieve({
	                        error: angular.noop,
	                        transientError: true
	                    }).then(function (model) {
	                        return model.get('user.country');
	                    });
	                }
	            },
	
	            viaCountryCoBrand: {
	                method: function method() {
	                    return $AppDataModel.instance($rootScope.token).retrieve().then(function (appData) {
	                        return appData.get('locale_info.cobrand');
	                    });
	                }
	            },
	
	            viaLangCookie: {
	                method: function method() {
	                    return $AppDataModel.instance($rootScope.token).retrieve().then(function (appData) {
	                        return appData.get('locale_info.lang_cookie.country');
	                    });
	                }
	            },
	
	            viaBrowserPref: {
	                method: function method() {
	                    return $AppDataModel.instance($rootScope.token).retrieve().then(function (appData) {
	                        return appData.get('locale_info.browser_lang.country');
	                    });
	                }
	            },
	
	            viaIP: {
	                method: function method() {
	                    return $meta.ipcountry;
	                }
	            },
	
	            viaDefault: {
	                method: function method() {
	                    return 'US';
	                }
	            }
	
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-locale/dist", "components/xo-locale/dist/country.js"))

/***/ }),

/***/ "./components/xo-locale/dist/helper.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('locale.helper', ['squid']).factory('$localeHelper', function () {
	        return {
	            /**
	             *
	             * @param locale - Ex: en_US
	             * @returns {{country: *, dialect}}
	             */
	            normalizeLocale: function normalizeLocale(locale) {
	                if (!locale) {
	                    return {};
	                }
	
	                locale = locale.replace('-', '_');
	
	                var country;
	                var language;
	
	                if (locale.match(/^\w{2}_\w{2}$/)) {
	                    locale = locale.split('_');
	
	                    language = locale[0];
	                    country = locale[1];
	                } else {
	                    language = locale;
	                }
	
	                return {
	                    country: country,
	                    language: language
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-locale/dist", "components/xo-locale/dist/helper.js"))

/***/ }),

/***/ "./components/xo-models/src/app/index.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xomodel.app', ['squid']).factory('$TransactionEligibilityModel', function ($Model, $Api) {
	        return $Model.extend('TransactionEligibilityModel', {
	            api: new $Api({
	                uri: '/api/eligibility/transaction/:id'
	            })
	        });
	    }).factory('$BuyerEligibilityModel', function ($Model, $Api) {
	        return $Model.extend('BuyerEligibilityModel', {
	            api: new $Api({
	                uri: '/api/eligibility/buyer/:id'
	            }),
	
	            invalidateOnLogout: true // invalidate this model when auth.logout() gets called
	        });
	    }).factory('$PXPModel', function ($Model, $Api) {
	        return $Model.extend({
	            api: new $Api({
	                uri: '/api/pxp/:id'
	            })
	        });
	    }).factory('$LocaleConfigModel', function ($Model, $Api) {
	        return $Model.extend({
	            api: new $Api({
	                uri: '/api/localeConfig'
	            })
	        });
	    }).factory('$AppDataModel', function ($Model, $Api) {
	        return $Model.extend('AppDataModel', {
	            api: new $Api({
	                uri: '/api/app'
	            }),
	
	            isMobile: function isMobile() {
	                return this.platform === 'mobile';
	            }
	        });
	    }).factory('$MessengerIntegrationDataModel', function ($Model, $Api) {
	        return $Model.extend('MessengerIntegrationDataModel', {
	            api: new $Api({
	                uri: '/api/messenger'
	            })
	        });
	    }).factory('$TokenizedWalletEligibilityModel', function ($Model, $Api) {
	        return $Model.extend('TokenizedWalletEligibilityModel', {
	            api: new $Api({
	                uri: '/api/eligibility/tokenizedWallet/:id'
	            }),
	
	            invalidateOnLogout: true, // invalidate this model when auth.logout() gets called
	
	            isEligible: function isEligible() {
	                return this.eligible;
	            }
	        });
	    }).factory('$TokenizedWalletPinModel', function ($Model, $Api) {
	        return $Model.extend('TokenizedWalletPinModel', {
	            api: new $Api({
	                uri: '/api/pin/tokenizedWallet/:id'
	            }),
	
	            invalidateOnLogout: true, // invalidate this model when auth.logout() gets called
	
	            getPinOrigin: function getPinOrigin() {
	                return this.pinOrigin;
	            },
	            getSuggestedPin: function getSuggestedPin() {
	                return this.suggestedPin;
	            },
	            getSuggestedKey: function getSuggestedKey() {
	                return this.suggestedKey;
	            },
	            getPinId: function getPinId() {
	                return this.pinId;
	            },
	            isPinIdPresent: function isPinIdPresent() {
	                return !!this.pinId;
	            },
	            isSetupEligible: function isSetupEligible() {
	                return this.pinOrigin === 'UNSET' || this.pinOrigin === 'SYSTEM';
	            }
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/app", "components/xo-models/src/app/index.js"))

/***/ }),

/***/ "./components/xo-models/src/onboard/index.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$SingleStepModel = exports.$GuestUpgradeModel = exports.$OnboardPhoneModel = exports.$OnboardUserModel = exports.$OnboardModel = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _index = __webpack_require__("./components/xo-models/src/fi/index.js");
	
	var _directive = __webpack_require__("./components/xo-form-components/src/national-id-input/directive.js");
	
	var $OnboardModel = exports.$OnboardModel = _squid.$Model.extend('$OnboardModel', {
	    api: new _squid.$Api({
	        uri: '/api/onboard'
	    }),
	
	    init: function init() {
	        this._super.init.apply(this);
	        this.fiMode = this.fiMode || 'card'; // Supports card or bank
	        this.bank = this.bank || new _index.$BankModel();
	        this.card = this.card || new _index.$CardModel();
	    },
	
	    serialize: function serialize() {
	        var data = {
	            user: this.user.serialize(),
	            billing_address: this.billing_address.serialize(),
	            shipping_address: this.shipping_address.serialize(),
	            phone: this.phone.serialize(),
	            marketing_optin: this.marketingOptin,
	            shipping_address_validation: this.shipping_address_validation,
	            payment_experience_initiator: this.payment_experience_initiator,
	            poma_flow: this.poma_flow,
	            prox_flow: this.prox_flow,
	            testParams: this.testParams,
	            content_identifier: this.content_identifier
	        };
	
	        if (this.nationalIdModel) {
	            data.nationalIdModel = {
	                'secondaryIdType': this.nationalIdModel.secondaryIdType,
	                'secondaryIdValue': this.nationalIdModel.secondaryIdValue
	            };
	
	            if (this.nationalIdModel.nationalId) {
	                data.nationalIdModel.nationalId = {
	                    type: this.nationalIdModel.nationalId.type,
	                    subType: this.nationalIdModel.nationalId.subType,
	                    value: this.nationalIdModel.nationalId.value
	                };
	            }
	        }
	
	        if (this.fiMode === 'card') {
	            data.card = this.card.serialize();
	        } else {
	            data.bank = this.bank.serialize();
	        }
	
	        data.skipInitiateAuth = this.skipInitiateAuth;
	
	        return data;
	    }
	});
	
	var $OnboardUserModel = exports.$OnboardUserModel = _squid.$Model.extend('$OnboardUserModel', {
	    serialize: function serialize() {
	        var onboardUserModel = {
	            first_name: this.first_name,
	            last_name: this.last_name,
	            email: this.email,
	            password: this.password,
	            countryOfResidence: this.countryOfResidence,
	            country: this.country,
	            dob_day: this.dob_day,
	            dob_month: this.dob_month,
	            dob_year: this.dob_year,
	            occupation: this.occupation,
	            nationality: this.nationality,
	            gender_type: this.gendertype,
	            place_of_birth: this.placeofbirth
	        };
	
	        if (this.nativeName) {
	            onboardUserModel.nativeName = {
	                first_name: this.nativeName.first_name,
	                last_name: this.nativeName.last_name,
	                middle_name: this.nativeName.middle_name
	            };
	        }
	
	        return onboardUserModel;
	    }
	});
	
	var $OnboardPhoneModel = exports.$OnboardPhoneModel = _squid.$Model.extend('$OnboardPhoneModel', {
	    serialize: function serialize() {
	        return {
	            type: this.phoneType,
	            number: this.telephone,
	            countryCode: this.IntDialingCountryCode
	        };
	    }
	});
	
	/**
	 * A model for handling onboarding guest accounts
	 * into PayPal accounts (happens post transaction)
	 */
	
	var $GuestUpgradeModel = exports.$GuestUpgradeModel = _squid.$Model.extend('$GuestUpgradeModel', {
	    api: new _squid.$Api({
	        uri: '/api/onboard/guest-upgrade'
	    }),
	
	    serialize: function serialize() {
	        var data = {
	            user: this.user.serialize(),
	            phone: this.phone.serialize(),
	            billing_address: this.billing_address.serialize(),
	            payerId: this.payerId,
	            transaction: this.transaction,
	            marketing_optin: this.marketing_optin,
	            contentIdentifier: this.contentIdentifier,
	            experienceIdentifier: this.experienceIdentifier,
	            experienceChannel: this.experienceChannel,
	            nationalId: this.nationalIdModel ? this.nationalIdModel.serialize() : _directive.$NationalIdModel.instance().serialize()
	        };
	
	        // append additional phone data
	        data.phone.country_prefix = this.phone && this.phone.IntDialingCountryCode;
	
	        // append additional billing_address data
	        data.billing_address.normalization_status = this.billing_address && this.billing_address.normalization_status;
	
	        return data;
	    },
	
	    serializeEmailFlow: function serializeEmailFlow() {
	        var data = {
	            user: this.user.serialize(),
	            phone: this.phone.serialize(),
	            billing_address: this.billing_address.serialize(),
	            payerId: this.payerId,
	            transaction: this.transaction,
	            receiptId: this.receiptId,
	            marketing_optin: this.marketing_optin,
	            card: this.card
	        };
	
	        return data;
	    }
	});
	
	var $SingleStepModel = exports.$SingleStepModel = _squid.$Model.extend('$SingleStepModel', {});
	
	angular.value("$OnboardModel", $OnboardModel);
	angular.value("$OnboardUserModel", $OnboardUserModel);
	angular.value("$OnboardPhoneModel", $OnboardPhoneModel);
	angular.value("$GuestUpgradeModel", $GuestUpgradeModel);
	angular.value("$SingleStepModel", $SingleStepModel);
	_squid.$Model;
	
	_squid.$Api;
	
	_index.$CardModel;
	
	_index.$BankModel;
	
	_directive.$NationalIdModel;

/***/ }),

/***/ "./components/xo-models/src/fi/index.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	var _index = __webpack_require__("./components/xo-device-info/dist/index.js");
	
	var BILLING_ADDRESS_FORMAT = {
	    DEFAULT: {
	        ',': ', ',
	        ' ': ' '
	    },
	    IL: {
	        he: {
	            ',': '‏, ‏',
	            ' ': '‏ ‏'
	        }
	    }
	};
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xomodel.fi', ['squid']).factory('$CardModel', function ($Model, $util) {
	        return $Model.extend('CardModel', {
	
	            serialize: function serialize() {
	
	                return {
	                    type: this.type,
	                    number: this.number.replace(/[^\d]+/g, ''),
	                    security_code: this.security_code,
	                    expiry_month: this.expiry_month && $util.pad(this.expiry_month, 2),
	                    expiry_year: this.expiry_year,
	                    issue_number: this.issue_number ? this.issue_number : undefined,
	                    start_month: this.start_month ? $util.pad(this.start_month, 2) : undefined,
	                    start_year: this.start_year ? this.start_year : undefined
	                };
	            },
	
	            last4: function last4() {
	                var cardNumber = this.number;
	
	                return cardNumber.substr(cardNumber.length - 4);
	            },
	
	            isExisting: function isExisting() {
	                return this.number && Boolean(this.number.match(/^xxxx-xxxx-xxxx-[\d]{4}$/));
	            }
	        });
	    }).factory('$AddCardModel', function ($Model, $Api, $CardModel) {
	        return $Model.extend('AddCardModel', {
	
	            api: new $Api({
	                uri: '/api/fi/card/:id?'
	            }),
	
	            init: function init() {
	                this._super.init.apply(this);
	                this.card = new $CardModel();
	            },
	
	            serialize: function serialize() {
	                var id = this.address.id && this.address.id !== '0' ? this.address.id : undefined;
	
	                return {
	                    cardType: this.cardType ? this.cardType : 'creditCard',
	                    sponsor_id: this.sponsor_id,
	                    preference: this.preference,
	                    user: this.user,
	                    card: this.card.serialize(),
	                    address: id ? {
	                        id: id
	                    } : this.address.serialize()
	                };
	            },
	
	            clearId: function clearId() {
	                delete this.id;
	            }
	        });
	    }).factory('$CardTypesModel', function ($Model, $Api, $locale, $util, $feature) {
	        return $Model.extend('CardTypesModel', {
	
	            api: new $Api({
	                uri: '/api/fi/card/types?country=:country&token=:token'
	            }),
	
	            retrieve: function retrieve() {
	                return this._super.retrieve.apply(this, arguments).then(function (result) {
	                    // QIWI is VISA cobranded card supported currently in Russia.
	                    if ($feature('qiwiCardSupported') && result.allowed && result.allowed.indexOf('VISA') > -1 && result.allowed.indexOf('QIWI') === -1) {
	                        result.allowed.push('QIWI');
	                    }
	                    return result;
	                });
	            },
	
	            supportedNames: function supportedNames() {
	                return $util.map(this.allowed, function (type) {
	                    return $locale.content.cardTypes[type];
	                });
	            }
	        });
	    }).factory('$BankModel', function ($Model) {
	        return $Model.extend('BankModel', {
	
	            init: function init() {
	                this._super.init.apply(this);
	                this.bank_account_number = '';
	                this.bank_routing_number = '';
	                this.iban_number = '';
	            },
	
	            serialize: function serialize() {
	                var data = {};
	
	                if (this.bank_account_number) {
	                    data.bank_account_number = this.bank_account_number;
	                }
	                if (this.bank_routing_number) {
	                    data.bank_routing_number = this.bank_routing_number;
	                }
	                if (this.iban_number) {
	                    data.iban_number = this.iban_number.replace(/\s/g, '').toUpperCase();
	                }
	                return data;
	            }
	        });
	    }).factory('$AddBankModel', function ($Model, $Api, $BankModel) {
	
	        return $Model.extend('AddBankModel', {
	
	            api: new $Api({
	                uri: '/api/fi/bank'
	            }),
	
	            init: function init() {
	                this._super.init.apply(this);
	                this.user = this.user || {
	                    first_name: '',
	                    dob_day: '',
	                    dob_month: '',
	                    dob_year: '',
	                    currency_code: '',
	                    country: ''
	                };
	                this.bank = this.bank || new $BankModel();
	                this.address = this.address || {};
	                this.creditorDetails = this.creditorDetails || {};
	                this.fiDetails = this.fiDetails || {};
	            },
	
	            getBankData: function getBankData() {
	                var data = {};
	
	                // Set user info
	                data.user = this.user;
	
	                // Set bank info
	                var bank = {};
	
	                this.bank = this.bank || {};
	
	                if (this.candidate_id) {
	                    data.candidate_id = this.candidate_id;
	                }
	
	                if (this.bank.bank_account_number) {
	                    bank.bank_account_number = this.bank.bank_account_number;
	                }
	
	                if (this.bank.bank_routing_number) {
	                    bank.bank_routing_number = this.bank.bank_routing_number;
	                }
	
	                if (this.bank.iban_number) {
	                    bank.iban_number = this.bank.iban_number.replace(/\s/g, '');
	                }
	                data.bank = bank;
	
	                // Set address info
	                if (this.address) {
	                    data.address = {
	                        line1: this.address.line1,
	                        line2: this.address.line2,
	                        city: this.address.city,
	                        country: this.address.country,
	                        postal_code: this.address.postal_code
	                    };
	                }
	
	                return data;
	            }
	        });
	    }).factory('$PreferredFi', function ($Model, $Api) {
	        return $Model.extend('PreferredFi', {
	            api: new $Api({
	                uri: '/api/fi/preferred'
	            }),
	
	            init: function init() {
	                this._super.init.apply(this);
	
	                // Get the type of device to send to FI for logging
	                function getUiChannel() {
	                    var capabilities = _index.$DeviceInfo.getCapabilities();
	                    if (capabilities.isTablet) {
	                        return 'Tablet';
	                    } else if (capabilities.isMobile) {
	                        return 'Mobile';
	                    } else if (capabilities.isDesktop) {
	                        return 'Desktop';
	                    } else if (capabilities.isApp) {
	                        return 'App';
	                    } else {
	                        return null;
	                    }
	                }
	
	                this.uiChannel = getUiChannel();
	            },
	
	            serialize: function serialize() {
	                return {
	                    preferred: this.preferred,
	                    uiChannel: this.uiChannel
	                };
	            }
	        });
	    }).factory('$SepaModel', function ($Model, $Api) {
	        return $Model.extend('SepaModel', {
	            api: new $Api({
	                uri: '/api/fi/bank'
	            })
	        });
	    }).factory('$DeleteCardModel', function ($Model, $Api) {
	        return $Model.extend('DeleteCardModel', {
	            api: new $Api({
	                uri: '/api/fi/card/:id/delete'
	            })
	        });
	    }).factory('$AddBillingAddressModel', function ($Model, $Api) {
	        return $Model.extend('AddBillingAddressModel', {
	            api: new $Api({
	                uri: '/api/fi/:instrumentid/addbillingaddress'
	            })
	        });
	    }).factory('$BillingAddressModel', function ($Model, $Api, $config, $util, $locale) {
	        return $Model.extend('BillingAddressModel', {
	            api: new $Api({
	                uri: '/api/fi/billingaddress/validate'
	            }),
	
	            format: function format() {
	
	                var langConfig = (BILLING_ADDRESS_FORMAT[$locale.country] || {})[$locale.lang] || {};
	
	                var comma = angular.isUndefined(langConfig[',']) ? BILLING_ADDRESS_FORMAT['DEFAULT'][','] : langConfig[','];
	                var space = angular.isUndefined(langConfig[' ']) ? BILLING_ADDRESS_FORMAT['DEFAULT'][' '] : langConfig[' '];
	
	                return $util.filter([this.line1, this.line2, this.city, this.state, this.country]).join(comma) + space + $util.filter([this.postal_code]);
	            },
	
	            serialize: function serialize() {
	                return {
	                    line1: this.line1 && this.line1.trim(),
	                    line2: this.line2 && this.line2.trim(),
	                    city: this.city && this.city.trim(),
	                    state: this.state && this.state.trim(),
	                    postal_code: this.postal_code && this.postal_code.trim(),
	                    normalization_status: this.normalization_status,
	                    country: this.country
	                };
	            }
	        });
	    }).factory('$BillingAddressesModel', function ($Model, $BillingAddressModel, $Api, $config, $util) {
	        return $Model.extend('BillingAddressesModel', {
	            api: new $Api({
	                uri: '/api/fi/billingaddress'
	            }),
	
	            onPopulate: function onPopulate() {
	                this.addresses = this.children($BillingAddressModel, this.addresses);
	            }
	        });
	    }).factory('$CardTypeFromBinModel', function ($Model, $Api) {
	        return $Model.extend('CardTypeFromBinModel', {
	            api: new $Api({
	                uri: '/api/fi/cardTypeFromBin?country=:country&bin=:bin&user_country=:user_country'
	            })
	        });
	    }).factory('$Resolve3DS', function ($Model, $Api) {
	        return $Model.extend('Resolve3DS', {
	            api: new $Api({
	                uri: '/api/fi/3ds/:id'
	            })
	        });
	    }).factory('$ResolveOTP', function ($Model, $Api) {
	        return $Model.extend('ResolveOTP', {
	            api: new $Api({
	                uri: '/api/fi/otp/:id'
	            })
	        });
	    }).factory('$WalletPreferences', function ($Model, $Api, $config) {
	        return $Model.extend('WalletPreferences', {
	            api: new $Api({
	                uri: '/api/fi/wallet/preferences'
	            }),
	
	            invalidateOnLogout: true, // invalidate this model when auth.logout() gets called
	
	            init: function init() {
	                this._super.init.apply(this);
	                this.topup = {};
	            },
	
	            serialize: function serialize() {
	                return {
	                    topup: {
	                        amount: this.topup.amount,
	                        instrument_id: this.topup.fundingSource.instrument_id,
	                        autoload_minimum_threshold: $config.topup.autoload_minimum_threshold
	                    }
	                };
	            }
	        });
	    }).factory('$WalletInstrumentNameMapping', function ($Model, $util) {
	        return $Model.extend('WalletInstrumentNameMapping', {
	
	            init: function init() {
	                this._super.init.apply(this);
	                this.INSTRUMENT_MAP = {
	                    AMSOUTH: /AMSOUTH,/,
	                    BOFA: /BANK OF AMERICA/,
	                    CAPITAL: /CAPITAL/,
	                    CHASE: /CHASE/,
	                    CITI: /CITIBANK/,
	                    FIFTHTHIRD: /FIFTH THIRD BANK/,
	                    HUNTINGTON: /HUNTINGTON/,
	                    INGDIRECT: /ING DIRECT/,
	                    NATIONALCITY: /NATIONAL CITY/,
	                    PNC: /PNC/,
	                    REGIONS: /REGIONS/,
	                    SUNTRUST: /SUNTRUST/,
	                    TDWATERHOUSE: /TD WATERHOUSE/,
	                    USAA: /USAA/,
	                    USBANK: /US BANK/,
	                    VISA: /VISA/,
	                    WAMUTUAL: /WASHINGTON MUTUAL/,
	                    WELLSFARGO: /WELLS FARGO/
	                };
	                this.INSTRUMENT_NAMES = Object.keys(this.INSTRUMENT_MAP);
	            },
	
	            getInstrumentNameNormalized: function getInstrumentNameNormalized(fsName) {
	                var _this = this;
	
	                if (!fsName) {
	                    return;
	                }
	
	                fsName = fsName.toUpperCase();
	
	                return $util.find(this.INSTRUMENT_NAMES, function (instName) {
	                    if (_this.INSTRUMENT_MAP[instName].test(fsName)) {
	                        return true;
	                    }
	                    return false;
	                });
	            }
	        });
	    }).factory('$CardInfoModel', function ($Model, $Api) {
	        return $Model.extend('$CardInfoModel', {
	            api: new $Api({
	                uri: '/api/fi/card/:id'
	            })
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	_index.$DeviceInfo;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/fi", "components/xo-models/src/fi/index.js"))

/***/ }),

/***/ "./components/xo-form-components/src/national-id-input/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	__webpack_require__("./components/xo-ui-components/src/directionality/directive.js");
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-form-components/src/national-id-input/template.html"), __webpack_require__("./components/xo-ui-components/src/tooltip/directive.js"), __webpack_require__("./components/xo-form-components/src/dob-input/directive.js"), __webpack_require__("./components/xo-models/src/checkout/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid, template) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-national-id-input.directive', ['squid', 'xo-tooltip.directive', 'xo-dob-input.directive', 'xomodel.checkout']).directive('brIdValidations', function () {
	        return {
	            require: 'ngModel',
	
	            link: function link(scope, element, attr, ctrl) {
	                scope.cpfValidator = function cpfValidator(ngModelValue) {
	                    var value = ngModelValue.replace(/[^0-9]/gi, '');
	                    var len = value.length;
	
	                    if (len !== 11) {
	                        ctrl.$setValidity('nationalId', false);
	                        return ngModelValue;
	                    }
	
	                    var x = value.match(/\b(\d)\1+\b/);
	
	                    if (x) {
	                        ctrl.$setValidity('nationalId', false);
	                        return ngModelValue;
	                    }
	
	                    var v1 = 0;
	                    var v2 = 0;
	                    var dv1;
	                    var dv2;
	                    var i;
	                    var j;
	
	                    for (i = 0, j = 10; i < 9, j > 1; i++, j--) {
	                        // eslint-disable-line no-sequences
	                        v1 += j * +value[i];
	                    }
	
	                    v1 = v1 % 11;
	                    dv1 = 11 - v1 < 10 ? 11 - v1 : 0;
	
	                    for (i = 0, j = 11; i < 9, j > 2; i++, j--) {
	                        // eslint-disable-line no-sequences
	                        v2 += j * +value[i];
	                    }
	
	                    v2 += dv1 * 2;
	                    v2 = v2 % 11;
	                    dv2 = 11 - v2 < 10 ? 11 - v2 : 0;
	
	                    scope.isValid = dv1 === parseInt(value[9], 10) && dv2 === parseInt(value[10], 10);
	
	                    ctrl.$setValidity('nationalId', scope.isValid);
	
	                    return ngModelValue;
	                };
	
	                ctrl.$parsers.push(scope.cpfValidator);
	            }
	        };
	    }).directive('sgIdValidations', function () {
	        return {
	            require: 'ngModel',
	
	            link: function link(scope, element, attr, ctrl) {
	                scope.nricFinValidator = function nricFinValidator(ngModelValue) {
	                    var idType = scope.$parent.nationalIdModel.nationalId.type;
	                    if (idType === 'NATIONAL_ID') {
	                        scope.isValid = false;
	
	                        // Valid if first char is "S", "T", "F" or "G" and the rest 7 are digits.
	                        if (ngModelValue.match(/^[S|T|G|F]\d{7}$/gi)) {
	                            scope.isValid = true;
	                        }
	                    } else {
	                        scope.isValid = true;
	                    }
	                    ctrl.$setValidity('nationalId', scope.isValid);
	                    return ngModelValue;
	                };
	                ctrl.$parsers.push(scope.nricFinValidator);
	            }
	        };
	    }).directive('ruIdValidations', function () {
	        return {
	            require: 'ngModel',
	
	            link: function link(scope, element, attr, ctrl) {
	
	                function validateSNILSChunk(sum, checksum) {
	                    if (sum < 100 && sum === checksum) {
	                        return true;
	                    } else if ((sum === 100 || sum === 101) && checksum === 0) {
	                        return true;
	                    } else if (sum > 101) {
	                        var remainder = sum % 101;
	                        return validateSNILSChunk(remainder, checksum);
	                    }
	
	                    return false;
	                }
	
	                function validateSNILS(value) {
	                    if (value.length === 11) {
	                        if (Number(value) > 1001998) {
	                            var snilsNumber = value.substring(0, 9);
	                            var checksum = Number(value.substring(9));
	                            var sum = 0;
	                            var multiplier = 1;
	
	                            for (var i = snilsNumber.length - 1; i >= 0; i--) {
	                                sum = sum + Number(snilsNumber.charAt(i)) * multiplier;
	                                multiplier++;
	                            }
	
	                            return validateSNILSChunk(sum, checksum);
	                        }
	
	                        return true;
	                    }
	
	                    return false;
	                }
	
	                function validateINNChecksum(value, factor, valueLength, match) {
	                    var n;
	                    var sumn = 0;
	                    for (var i = 0; i < valueLength; i++) {
	                        sumn = sumn + Number(value[i]) * Number(factor[i]);
	                    }
	                    n = sumn % 11;
	                    n = n === 10 ? 0 : n;
	
	                    if (n !== Number(match)) {
	                        return false;
	                    }
	
	                    return true;
	                }
	
	                function validateINN(value) {
	                    if (value.length === 12) {
	                        var factor = [7, 2, 4, 10, 3, 5, 9, 4, 6, 8];
	
	                        if (!validateINNChecksum(value, factor, value.length - 2, value[10])) {
	                            return false;
	                        }
	
	                        factor.unshift(3);
	
	                        if (!validateINNChecksum(value, factor, value.length - 1, value[11])) {
	                            return false;
	                        }
	
	                        return true;
	                    }
	
	                    return false;
	                }
	
	                function validateOMS(value) {
	                    if (value.length >= 11 && value.length <= 16) {
	                        return true;
	                    }
	
	                    return false;
	                }
	
	                scope.idValidator = function idValidator(ngModelValue) {
	                    var value = ngModelValue.replace(/[^0-9]/gi, '');
	                    var secondaryType = scope.nationalIdModel.secondaryIdType;
	
	                    if (secondaryType === 'SNILS') {
	                        scope.isValid = validateSNILS(value);
	                    } else if (secondaryType === 'INN') {
	                        scope.isValid = validateINN(value);
	                    } else if (secondaryType === 'OMS') {
	                        scope.isValid = validateOMS(value);
	                    }
	
	                    ctrl.$setValidity('secondaryId', scope.isValid);
	
	                    return ngModelValue;
	                };
	
	                ctrl.$parsers.push(scope.idValidator);
	            }
	        };
	    }).directive('xoNationalIdInput', function () {
	        return {
	            template: template,
	            scope: {
	                user: '=',
	                country: '@'
	            },
	
	            link: function link(scope, element, attr) {
	                var passportMask = '0000000000';
	
	                element.on('keyup', function (event) {
	                    if (scope.user.countryOfResidence === 'RU') {
	                        $('#nationalId').mask(passportMask, {
	                            'translation': {
	                                0: { pattern: /[0-9]/ }
	                            }
	                        });
	                    } else {
	                        $('#nationalId').unmask(passportMask);
	                    }
	                });
	            },
	
	            controller: function controller($scope, $feature, $locale, $rootScope, $CheckoutCartModel, $NationalIdModel, $util) {
	
	                $scope.nationalIdModel = $NationalIdModel.instance($rootScope.token);
	                $scope.checkoutCart = $CheckoutCartModel.instance($rootScope.token);
	                $scope.user = $scope.user || {};
	                $scope.user.countryOfResidence = $scope.user.countryOfResidence || $scope.country;
	                $scope.formattedValues = {};
	                $scope.showNationalIdFields = false;
	
	                function sortCountryList() {
	                    $scope.metadata = angular.copy($locale.metadata);
	                    return $scope.metadata.territory;
	                }
	
	                $scope.countries = sortCountryList();
	
	                if ($scope.checkoutCart.payer && $scope.checkoutCart.payer.tax_id) {
	                    $scope.nationalIdModel.nationalId.value = $scope.checkoutCart.payer.tax_id;
	                }
	
	                $scope.countryChanged = function () {
	                    if ($scope.user.countryOfResidence === 'RU') {
	                        $scope.showNationalIdFields = true;
	                        $scope.minLengthNatId = 10;
	                        $scope.maxLengthNatId = 10;
	                    } else {
	                        $scope.showNationalIdFields = false;
	                        $scope.minLengthNatId = 6;
	                        $scope.maxLengthNatId = 15;
	                    }
	                };
	
	                $scope.cpfMasking = function (newValue) {
	                    if (newValue) {
	                        var unformatted = newValue.replace(/[^0-9]/gi, '');
	                        var formatted = [['', unformatted.slice(0, 3)], ['.', unformatted.slice(3, 6)], ['.', unformatted.slice(6, 9)], ['-', unformatted.slice(9)]].map(function (x) {
	                            return x[1] && x[0] + x[1] || '';
	                        }).join('');
	
	                        $scope.formattedValues.nationalId = formatted;
	                        $scope.nationalIdModel.nationalId.value = unformatted;
	                    } else {
	                        $scope.nationalIdModel.nationalId.value = '';
	                    }
	                };
	
	                $scope.secondaryIdFormatting = function () {
	                    var $el = $('#idValue');
	
	                    if ($scope.nationalIdModel.secondaryIdType === 'SNILS' && $el.length > 0) {
	                        var unformatted = $el.val().replace(/[^0-9]/gi, '');
	                        var formatted = [['', unformatted.slice(0, 3)], ['-', unformatted.slice(3, 6)], ['-', unformatted.slice(6, 9)], [' ', unformatted.slice(9)]].map(function (x) {
	                            return x[1] && x[0] + x[1] || '';
	                        }).join('');
	
	                        $scope.nationalIdModel.secondaryIdValue = formatted;
	                    }
	                };
	
	                $scope.secondaryIdChange = function () {
	                    var currentSecondaryId = $scope.secondaryIds[$scope.nationalIdModel.secondaryIdType];
	
	                    $scope.nationalIdModel.secondaryIdValue = '';
	                    $scope.maxLength = currentSecondaryId.length;
	                    $scope.minLength = currentSecondaryId.minlength ? currentSecondaryId.minlength : currentSecondaryId.length;
	
	                    $scope.maskCharLength = currentSecondaryId.maskCharLength ? currentSecondaryId.maskCharLength : 0;
	                };
	
	                $scope.sgIdChange = function () {
	                    $scope.nationalIdModel.nationalId.value = '';
	                };
	
	                function setLocalizedNatIDLabels() {
	                    $scope.nationalIds = {
	                        'NATID': { name: 'NATIONAL_ID', value: $locale.content.addTaxId.natid },
	                        'PASSPORT': { name: 'PASSPORT_NUMBER', value: $locale.content.addTaxId.passport }
	                    };
	                    // ID type change from “Driver’s License” to “TEMPORARY_NATIONAL_ID” for HK only,
	                    // other countries show "Driver’s License" in th national ID drop down
	                    if ($locale.country === 'HK' && $feature('driverLicenseToTempNationalID', false, $locale.country)) {
	                        $scope.nationalIds.TNID = { name: 'TEMPORARY_NATIONAL_ID', value: $locale.content.addTaxId.tnid };
	                    } else {
	                        $scope.nationalIds.DL = { name: 'DRIVERS_LICENSE', value: $locale.content.addTaxId.dl };
	                    }
	                }
	
	                if ($locale.country === 'BR') {
	                    $scope.nationalIdModel.nationalId.type = 'TAX_ID';
	                    $scope.nationalIdModel.nationalId.subType = 'CPF';
	
	                    $scope.cpfMasking($scope.nationalIdModel.nationalId.value);
	                } else if ($scope.country === 'RU') {
	                    $scope.nationalIdModel.nationalId.type = 'PASSPORT';
	                    $scope.nationalIdModel.nationalId.subType = '';
	                    $scope.user.nativeName = $scope.user.nativeName || {};
	                    $scope.secondaryIds = {
	                        'INN': { name: 'INN', value: $locale.content.addTaxId.INN, length: 12 },
	                        'SNILS': { name: 'SNILS', value: $locale.content.addTaxId.SNILS, length: 14, maskCharLength: 3 },
	                        'OMS': { name: 'OMS', value: $locale.content.addTaxId.OMS, length: 16, minlength: 11 }
	                    };
	
	                    if (!$scope.nationalIdModel.secondaryIdType) {
	                        $scope.nationalIdModel.secondaryIdType = $scope.secondaryIds.INN.name;
	                    }
	
	                    $scope.secondaryIdChange();
	
	                    $scope.countryChanged();
	                } else if ($scope.country === 'KR') {
	                    $scope.nationalIds = {
	                        'PASSPORT': { name: 'PASSPORT_NUMBER', value: $locale.content.addTaxId.passport },
	                        'DL': { name: 'DRIVERS_LICENSE', value: $locale.content.addTaxId.dl }
	
	                    };
	                    $scope.nationalIdModel.nationalId.type = 'PASSPORT_NUMBER';
	                    $scope.nationalIdModel.nationalId.subType = '';
	                } else {
	                    // Default behaviour - set to 3pl countries
	                    setLocalizedNatIDLabels();
	                    $scope.nationalIdModel.nationalId.type = 'NATIONAL_ID';
	                    $scope.nationalIdModel.nationalId.subType = '';
	                }
	
	                $scope.$on('contentChange', function () {
	                    setLocalizedNatIDLabels();
	                });
	            }
	        };
	    }).factory('$NationalIdModel', function ($Model) {
	
	        return $Model.extend('NationalIdModel', {
	
	            init: function init() {
	                this._super.init.apply(this);
	                this.nationalId = this.nationalId || {};
	            },
	
	            serialize: function serialize() {
	                return this.nationalId;
	            }
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-form-components/src/national-id-input", "components/xo-form-components/src/national-id-input/directive.js"))

/***/ }),

/***/ "./components/xo-ui-components/src/directionality/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/directionality/styles.less");
	
	/**
	 * This directive watches the model and listens to user input to look for arabic/hebrew/right-to-left language
	 * unicode chars, then adds dir="rtl" or dir="ltr" attribute to input field
	 *
	 * Add directionality to the container html div element of a input field.
	 * <div directionality><input type=text ng-model="user.name"></div>
	 */
	(0, _angular.$registerDirective)('directionality', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element) {
	            var currentWatchDeregister = void 0;
	            var input = element.find('input');
	            if (!input.length) {
	                listenForInputRendered();
	                return;
	            }
	
	            // If the input has not yet been rendered inside the container, listen for dom node inserted
	            // then, if the node inserted is an input, we will use that element and init the directionality 
	            // listeners. The first input rendered is the one that will be captured by this directive.
	            function listenForInputRendered() {
	                element.bind('DOMNodeInserted', checkDOMNodeInserted);
	
	                function checkDOMNodeInserted(event) {
	                    if (event && event.target && event.target.tagName === 'INPUT') {
	                        element.unbind('DOMNodeInserted', checkDOMNodeInserted);
	                        input = angular.element(event.target);
	                        init();
	                    }
	                }
	            }
	
	            function setDirectionality(value) {
	                if (value) {
	                    // set directionality to 'rtl' if the value has hebrew/arabic unicode chars.
	                    element.toggleClass('ltrOverride', !_squid.$util.hasRTL(value));
	                } else {
	                    element.toggleClass('ltrOverride', _angular.$document.prop('documentElement').getAttribute('dir') !== 'rtl');
	                }
	            }
	
	            function jqueryOnKeyupHandler(event) {
	                setDirectionality(event.target.value);
	            }
	
	            // Reset directionality listeners when we transition from ltr -> rtl locale or vice versa
	            function resetDirectionalityListener() {
	                // remove directionality listeners that were set on prior locale
	                input.unbind('keyup', jqueryOnKeyupHandler);
	                if (currentWatchDeregister) {
	                    currentWatchDeregister();
	                }
	
	                // set new directionality listeners for the current locale if 'rtl'
	                if (document.documentElement.getAttribute('dir') === 'rtl') {
	                    (0, _angular.$timeout)(function () {
	                        // Watch ng-model on input to set directionality if it contains RTL char
	                        currentWatchDeregister = scope.$watch(input.attr('ng-model'), function (value) {
	                            setDirectionality(value);
	                        });
	                        // jQuery listener for cases where ng-model is not populated until post validation
	                        input.on('keyup', jqueryOnKeyupHandler);
	                    });
	                }
	            }
	
	            function init() {
	                resetDirectionalityListener();
	                scope.$on('localeChange', function () {
	                    resetDirectionalityListener();
	                });
	            }
	
	            init();
	        }
	    };
	});
	
	/**
	 * This directive watches the model for arabic/hebrew/right-to-left language unicode chars, then adds dir="rtl"
	 * or dir="ltr" attribute to the html element.
	 *
	 * Add directionality-text="<<model>>" to the div or span or any element containing text.
	 * <span directionality-text="user.name"><{{user.name}}</span>
	 */
	(0, _angular.$registerDirective)('directionality-text', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            if (document.documentElement.getAttribute('dir') === 'rtl') {
	                var $element = $(element);
	
	                (0, _angular.$timeout)(function () {
	                    if (attrs.directionalityText) {
	                        scope.$watch(attrs.directionalityText, function () {
	                            $element.toggleClass('ltrOverride', !_squid.$util.hasRTL((0, _angular.$parse)(attrs.directionalityText)(scope)));
	                        });
	                    } else {
	                        $element.toggleClass('ltrOverride', !_squid.$util.hasRTL(element.text()));
	                    }
	                });
	            }
	        }
	    };
	});
	
	_angular.$document;
	
	_angular.$parse;
	
	_angular.$registerDirective;
	
	_angular.$timeout;
	
	_squid.$util;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "./components/xo-ui-components/src/directionality/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-ui-components/src/directionality/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-ui-components/src/directionality/styles.less":
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, ".ltrOverride{direction:ltr!important;unicode-bidi:bidi-override!important}", ""]);
	
	// exports


/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-form-components/src/national-id-input/template.html":
/***/ (function(module, exports) {

	module.exports = "<div id=\"nationalIdFields\" class=\"clearfix\" content>\n    <div class=\"bankField restricted\">\n        <div ng-switch=\"country\">\n            <div ng-switch-when=\"SG\">\n                <div class=\"dropdown nationalID fidobDay inputField\" floating-label-dropdown>\n                    <select xo-dropdown name=\"idType\"\n                            ng-model=\"nationalIdModel.nationalId.type\"\n                            id=\"idType\"\n                            ng-change=\"sgIdChange()\"\n                            aria-required=\"true\">\n                        <option ng-repeat=\"items in nationalIds\" value=\"{{items.name}}\" ng-selected=\"nationalIdModel.nationalId.type==='{{items.name}}'\">{{items.value}}</option>\n                    </select>\n                    <label for=\"idType\">{{content('signupAccountCreation.idType')}}</label>\n                </div>\n\n                <div class=\"inputField nationalIDValue\" floating-label directionality>\n                    <input ng-model=\"nationalIdModel.nationalId.value\"\n                           name=\"idValue\"\n                           id=\"idValue\"\n                           class=\"additionalIDBox\"\n                           value=\"\"\n                           autocapitalize=\"off\"\n                           aria-required=\"true\"\n                           autocomplete=\"off\"\n                           valid-letters=\"data.validLetters\"\n                           sg-id-validations\n                           required/>\n                    <label for=\"idValue\">{{content('signupAccountCreation.idNumber')}}</label>\n                </div>\n            </div>\n\n            <div ng-switch-when=\"BR\">\n\n                <div class=\"inputField confidential nationalId\" floating-label directionality>\n                    <input ng-model=\"formattedValues.nationalId\"\n                           name=\"nationalId\"\n                           id=\"nationalId\"\n                           value=\"\"\n                           autocapitalize=\"off\"\n                           aria-required=\"true\"\n                           autocomplete=\"off\"\n                           xo-error-tooltip\n                           br-id-validations\n                           maxlength=\"14\"\n                           ng-change=\"cpfMasking(formattedValues.nationalId)\"\n                           required/>\n                    <label for=\"nationalId\">{{content('addTaxId.cpf')}}</label>\n                </div>\n\n            </div>\n\n            <div ng-switch-when=\"KR\">\n\n                <div class=\"dropdown nationalID fidobDay inputField\" floating-label-dropdown>\n                    <select xo-dropdown name=\"idType\"\n                            ng-model=\"nationalIdModel.nationalId.type\"\n                            id=\"idType\"\n                            aria-required=\"false\">\n                        <option ng-repeat=\"items in nationalIds\" value=\"{{items.name}}\" ng-selected=\"nationalIdModel.nationalId.type==='{{items.name}}'\">{{items.value}}</option>\n                    </select>\n                    <label for=\"idType\">{{content('signupAccountCreation.idType')}}</label>\n                </div>\n\n                <div class=\"inputField nationalIDValue\" floating-label directionality>\n                    <input ng-model=\"nationalIdModel.nationalId.value\"\n                           name=\"idValue\"\n                           id=\"idValue\"\n                           class=\"additionalIDBox\"\n                           value=\"\"\n                           autocapitalize=\"off\"\n                           aria-required=\"false\"\n                           autocomplete=\"off\"/>\n                    <label for=\"idValue\">{{content('signupAccountCreation.idNumber')}}</label>\n                </div>\n\n            </div>\n\n            <div ng-switch-when=\"RU\">\n\n                <div class=\"nationalId\">\n                    <div class=\"dropdown confidential country clearfix inputField\" floating-label-dropdown>\n                        <select xo-dropdown name=\"country\" ng-model=\"user.countryOfResidence\" id=\"country\"\n                                        aria-labelledby=\"countryLabel\" ng-change=\"countryChanged()\" xo-error-tooltip required>\n                            <option ng-repeat=\"country in countries\" value=\"{{country.code}}\" ng-selected=\"user.countryOfResidence === country.code\">{{country.name}}</option>\n                        </select>\n                        <label for=\"country\" id=\"countryLabel\">{{content('common.country')}}</label>\n                    </div>\n\n                    <div ng-if=\"showNationalIdFields\">\n                        <xo-name-input user=\"user.nativeName\"></xo-name-input>\n\n                        <div class=\"inputField confidential full\" floating-label directionality>\n                            <input ng-model=\"user.nativeName.middle_name\"\n                                   name=\"middleName\"\n                                   id=\"middleName\"\n                                   value=\"\"\n                                   autocapitalize=\"off\"\n                                   aria-required=\"true\"\n                                   autocomplete=\"off\"\n                                   required />\n                            <label for=\"middleName\" id=\"middleNameLabel\">{{content('common.middleName')}}</label>\n                        </div>\n                    </div>\n\n                    <div class=\"fieldGroup\">\n                        <div class=\"inputField full\" floating-label directionality>\n                                <input ng-model=\"nationalIdModel.nationalId.value\"\n                                       name=\"nationalId\"\n                                       id=\"nationalId\"\n                                       value=\"\"\n                                       autocapitalize=\"off\"\n                                       aria-required=\"true\"\n                                       autocomplete=\"off\"\n                                       minlength=\"{{minLengthNatId}}\"\n                                       maxlength=\"{{maxLengthNatId}}\"\n                                       placeholder=\"{{user.countryOfResidence === 'RU' && content('addTaxId.passportRU') || content('addTaxId.passportEN')}}\"\n                                       xo-validation='{\"validator\": \"validRUPassport\"}'\n                                       xo-error-tooltip\n                                       required />\n\n                                <label for=\"nationalId\">{{content('addTaxId.passport')}}</label>\n                        </div>\n\n                        <div class=\"full last-child\">\n                            <xo-dob-input user=\"user\"></xo-dob-input>\n                        </div>\n                    </div>\n\n                    <div ng-if=\"showNationalIdFields\">\n                        <legend class=\"fieldLegend\" for=\"additionalId\">{{content('addTaxId.additionalInfo')}}\n                            <div class=\"additionalIdHelper\">\n                                <a href=\"#\" id=\"verifyHelpAdditionalId\" alt=\"Why do we need this\" class=\"verifyHelp\"></a>\n                            </div>\n                            <div class=\"lineSpacing\">\n                                <xo-tooltip trigger=\"#verifyHelpAdditionalId\">\n                                    <div class=\"tip tipDesc\">\n                                        {{content('addTaxId.additionalInfoNote')}}\n                                    </div>\n                                </xo-tooltip>\n                            </div>\n                        </legend>\n\n                        <div id=\"additionalId\">\n                            <div class=\"dropdown additionalID inputField\" floating-label-dropdown>\n                                <select xo-dropdown name=\"idType\"\n                                        ng-model=\"nationalIdModel.secondaryIdType\"\n                                        id=\"idType\"\n                                        aria-label=\"{{ content('signup.accountCreationGuest.dobDay') }}\"\n                                        ng-change=\"secondaryIdChange()\"\n                                        aria-required=\"true\">\n                                    <option ng-repeat=\"items in secondaryIds\" value=\"{{items.name}}\" ng-selected=\"nationalIdModel.secondaryIdType==='{{items.name}}'\">{{items.value}}</option>\n                                </select>\n                                <label for=\"idType\">{{content('signupAccountCreation.idType')}}</label>\n                            </div>\n\n                            <div class=\"inputField additionalIDValue\" floating-label directionality>\n                                <input ng-model=\"nationalIdModel.secondaryIdValue\"\n                                       name=\"idValue\"\n                                       id=\"idValue\"\n                                       class=\"additionalIDBox\"\n                                       value=\"\"\n                                       maxlength=\"{{maxLength}}\"\n                                       minlength=\"{{minLength}}\"\n                                       autocapitalize=\"off\"\n                                       aria-required=\"true\"\n                                       autocomplete=\"off\"\n                                       placeholder=\"{{(maxLength - maskCharLength)}} {{content('addTaxId.digits')}}\"\n                                       required\n                                       ru-id-validations\n                                       ng-change=\"secondaryIdFormatting()\"/>\n                                <label for=\"idValue\">{{content('signupAccountCreation.idNumber')}}</label>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <div ng-switch-default>\n              <div class=\"dropdown nationalID fidobDay inputField\" floating-label-dropdown>\n                  <select xo-dropdown name=\"idType\"\n                          ng-model=\"nationalIdModel.nationalId.type\"\n                          id=\"idType\"\n                          aria-required=\"true\">\n                      <option ng-repeat=\"items in nationalIds\" value=\"{{items.name}}\" ng-selected=\"nationalIdModel.nationalId.type==='{{items.name}}'\">{{items.value}}</option>\n                  </select>\n                  <label for=\"idType\">{{content('signupAccountCreation.idType')}}</label>\n              </div>\n\n              <div class=\"inputField nationalIDValue\" floating-label directionality>\n                  <input ng-model=\"nationalIdModel.nationalId.value\"\n                         name=\"idValue\"\n                         id=\"idValue\"\n                         class=\"additionalIDBox\"\n                         value=\"\"\n                         autocapitalize=\"off\"\n                         aria-required=\"true\"\n                         autocomplete=\"off\"\n                         required/>\n                  <label for=\"idValue\">{{content('signupAccountCreation.idNumber')}}</label>\n              </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "./components/xo-ui-components/src/tooltip/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-ui-components/src/tooltip/template.html"), __webpack_require__("./components/jquery/dist/jquery.min.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template, $) {
	    squid.module('xo-tooltip.directive', ['squid']).directive('xoTooltip', function () {
	
	        return {
	            template: template,
	            restrict: 'E',
	            transclude: true,
	            scope: {
	                trigger: '@',
	                showEvent: '@',
	                hideEvent: '@',
	                displayInline: '=',
	                align: '@' // can take left/right
	            },
	
	            link: function link($scope, $element) {
	                $($element).find('.toolTip').on('click', function (event) {
	                    event.stopPropagation();
	                });
	            },
	
	            controller: function controller($scope, $element, $timeout) {
	
	                function isLink() {
	                    return $($scope.trigger).is('a');
	                }
	
	                $timeout(function () {
	                    var $trigger = $($scope.trigger);
	                    var isMouseOver = false;
	                    var toolTip = $($element).find('.toolTip');
	
	                    var toolTipID = $scope.toolTipID = 'toolTip_' + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 7);
	
	                    $scope.showEvent = $scope.showEvent || (isLink() ? 'click' : 'focus');
	                    $scope.hideEvent = $scope.hideEvent || 'blur';
	
	                    $scope.toggle = function (event) {
	
	                        if (event) {
	                            event.stopPropagation();
	                            event.preventDefault();
	                        }
	
	                        if (toolTip.length && $(toolTip).is(':visible')) {
	                            $scope.close();
	                        } else {
	                            $scope.show();
	                        }
	                    };
	
	                    $scope.show = function (event) {
	
	                        if (event) {
	                            event.stopPropagation();
	                            event.preventDefault();
	                        }
	
	                        // Associate toolTipId with trigger element aria-describedby
	                        var describedByIds;
	                        if ($trigger.attr('aria-describedby')) {
	                            describedByIds = $trigger.attr('aria-describedby').split(' ');
	                        } else {
	                            describedByIds = [];
	                        }
	
	                        if (!~describedByIds.indexOf(toolTipID)) {
	                            describedByIds.push(toolTipID);
	                        }
	
	                        $trigger.attr('aria-describedBy', describedByIds.join(' '));
	
	                        // Show the tooltip and position the page scroll to include the element on page
	                        $($element).show();
	                        $(toolTip).slideDown({
	                            progress: function progress() {
	                                var windowBot = $(window).scrollTop() + $(window).height();
	                                var toolTipBot = toolTip.offset().top + toolTip.outerHeight();
	                                if (toolTipBot > windowBot) {
	                                    $(window).scrollTop(toolTipBot - $(window).height());
	                                }
	                            }
	                        });
	                    };
	
	                    $scope.close = function (event) {
	                        if (event) {
	                            event.stopPropagation();
	                            event.preventDefault();
	                        }
	
	                        if (!isMouseOver) {
	                            if (toolTip.length && $(toolTip).is(':visible')) {
	                                $(toolTip).slideUp(100, function () {
	                                    $($element).hide();
	                                });
	                            } else {
	                                $($element).hide();
	                            }
	
	                            // Remove tooltipId from aria-describedby
	                            var describedByIds = $trigger.attr('aria-describedby');
	                            if (describedByIds && ~describedByIds.indexOf(toolTipID)) {
	                                describedByIds = describedByIds.split(' ').filter(function (id) {
	                                    return id !== toolTipID;
	                                });
	                                $trigger.attr('aria-describedby', describedByIds.join(' '));
	                            }
	                        }
	                    };
	
	                    $($element).on('click', '.close', function (event) {
	                        $scope.close(event);
	                    });
	
	                    $($element).on('mouseover', function (event) {
	                        isMouseOver = true;
	                    });
	
	                    $($element).on('mouseleave', function (event) {
	                        isMouseOver = false;
	                    });
	
	                    $(document).on('click.toolTip', function (event) {
	                        $scope.close();
	                    });
	
	                    if (isLink()) {
	                        $trigger.on('click.toolTip', $scope.toggle);
	                        $trigger.on('blur.toolTip', $scope.close);
	                    } else if ($scope.showEvent === $scope.hideEvent) {
	                        $trigger.on($scope.showEvent + '.toolTip', function (event) {
	                            $scope.toggle(event);
	                        });
	                    } else {
	                        $trigger.on($scope.showEvent + '.toolTip', function (event) {
	                            $scope.show(event);
	                        });
	
	                        $trigger.on($scope.hideEvent + '.toolTip', function (event) {
	                            $scope.close(event);
	                        });
	                    }
	
	                    // Clean up document listener on close
	                    $scope.$on('$destroy', function () {
	                        $(document).off('click.toolTip');
	                        $trigger.off($scope.showEvent + '.toolTip');
	                        $trigger.off($scope.hideEvent + '.toolTip');
	                        $scope.close();
	                    });
	                }, 50);
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-ui-components/src/tooltip/template.html":
/***/ (function(module, exports) {

	module.exports = "<div class=\"toolTip {{align}}\" ng-class=\"{'displayInline': displayInline, 'balloon': !displayInline}\" ng-transclude role=\"tooltip\" id=\"{{toolTipID}}\">\n</div>\n"

/***/ }),

/***/ "./components/xo-form-components/src/dob-input/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	__webpack_require__("./components/xo-ui-components/src/directionality/directive.js");
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-form-components/src/dob-input/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid, template) {
	
	    squid.module('xo-dob-input.directive', ['squid']).directive('dobValidation', function () {
	
	        return {
	            require: 'ngModel',
	            link: function link(scope, element, attr, ctrl) {
	
	                // init scope vars
	                // age - above 18 yrs
	                // validDate - months <= 12 and day <= 31 or based on month
	                scope.isValidDate = true;
	                scope.isValidAge = true;
	                scope.isValid = false;
	                scope.dobToolTip = 'hide';
	
	                function isValidDate(year, month, day) {
	                    // dates like 02/31 33/33 should return false
	                    var date = new Date(year, month, day);
	
	                    var fullYear = date.getFullYear();
	                    var dateMonth = date.getMonth();
	                    var dateDay = date.getDate();
	
	                    // If birth year is in the future or before 1900, dob is invalid
	                    var now = new Date();
	                    if (fullYear > now.getFullYear() || fullYear < 1900) {
	                        return false;
	                    }
	
	                    if (fullYear === parseInt(year, 10) && dateMonth === parseInt(month, 10) && dateDay === parseInt(day, 10)) {
	                        return true;
	                    }
	                    return false;
	                }
	
	                function isOfLegalAge(birthDate) {
	                    // user should be of exact 18 years of age or older
	                    var tempDate = new Date(birthDate.getFullYear() + 18, birthDate.getMonth(), birthDate.getDate());
	                    return tempDate <= new Date().setHours(0, 0, 0, 0);
	                }
	
	                /**
	                 * Parses input value to set corresponding day, month, year values for scope
	                 * @param {String} inputVal - the value to be parsed
	                 */
	                function parseDob(inputVal) {
	                    var day;
	                    var month;
	                    var year;
	
	                    var sep = scope.dateSeparator();
	                    var partsArr = inputVal.split(sep);
	                    var first = partsArr[0];
	                    var sec = partsArr[1];
	                    var third = partsArr[2];
	
	                    if (scope.dateFormat() === 'DMY') {
	                        day = first;
	                        month = sec;
	                        year = third;
	                    } else if (scope.dateFormat() === 'YMD') {
	                        year = first;
	                        month = sec;
	                        day = third;
	                    } else {
	                        month = first;
	                        day = sec;
	                        year = third;
	                    }
	
	                    // Validate only on entering the last digit of the dob
	                    var dayLen = ('' + day).length;
	                    var monLen = ('' + month).length;
	                    var yrLen = ('' + year).length;
	                    var validDay = dayLen === 1 || dayLen === 2;
	                    var validMon = monLen === 1 || monLen === 2;
	                    var validYr = yrLen === 4;
	                    var requirement = validDay && validMon && validYr;
	
	                    if (requirement) {
	                        scope.isValidDate = isValidDate(year, month - 1, day);
	
	                        scope.isValidAge = isOfLegalAge(new Date(year, month - 1, day));
	                        scope.isValid = scope.isValidDate && scope.isValidAge;
	                        scope.dobToolTip = scope.isValid ? 'hide' : 'show';
	
	                        scope.user.dob_day = day;
	                        scope.user.dob_month = month;
	                        scope.user.dob_year = year;
	                    } else {
	                        scope.isValid = false;
	                    }
	
	                    ctrl.$setValidity('dobText', scope.isValid);
	
	                    return inputVal;
	                }
	
	                /**
	                 * Validates the inputted DOB value
	                 * @param {string} ngModelValue - the to-be mutated input value
	                 * onComplete for mask listener - called when user copy/pastes DOB into the field
	                 */
	                scope.dobValidator = function dobValidator(ngModelValue) {
	                    var input = element;
	                    var dateMask = scope.dateMask();
	                    input.mask(dateMask, {
	                        translation: {
	                            'Z': {
	                                pattern: /[0-9]/, optional: true
	                            },
	                            '0': {
	                                pattern: /[0-9]/, optional: false
	                            }
	                        },
	                        onComplete: function onComplete(val) {
	                            ngModelValue = val;
	                            return parseDob(ngModelValue);
	                        }
	                    });
	
	                    return parseDob(ngModelValue);
	                };
	
	                scope.dobTester = function dobTester(val) {
	                    return parseDob(val);
	                };
	
	                ctrl.$parsers.push(scope.dobValidator);
	            }
	        };
	    }).directive('xoDobInput', function () {
	        return {
	            template: template,
	            restrict: 'E',
	            scope: {
	                user: '='
	            },
	            controller: function controller($scope, $locale) {
	
	                // To support additional date separators, simply add separator to getDateSeparators function
	                var DateManager = {
	                    dateSeparator: undefined,
	                    dateFormat: undefined,
	                    griffinDateEntry: undefined,
	
	                    _init_: function _init_() {
	                        this.griffinDateEntry = $locale.metadata.dateEntry;
	                        this.dateSeparator = this.getDateSeparator(this.griffinDateEntry);
	                        this.dateFormat = undefined;
	                        this.dateFormat = this.getDateFormat();
	                        this.dateRegex = this.getDateRegex();
	                        // dob validator depends on dateFormat function in $scope, so context is bound.
	                        $scope.dateFormat = this.getDateFormat.bind(this);
	                        $scope.dateSeparator = this.getDateSeparator.bind(this, this.griffinDateEntry);
	                        $scope.dateMask = this.getDateMask.bind(this, this.dateSeparator);
	                    },
	                    getDateFormat: function getDateFormat() {
	                        // cache date format value, must be unset on init
	                        if (this.dateFormat) {
	                            return this.dateFormat;
	                        }
	
	                        var griffinDateFormat = $locale.metadata.dateFormat.toUpperCase();
	                        var dateFormatComponents = griffinDateFormat.split(this.dateSeparator);
	
	                        var dIdx = dateFormatComponents.indexOf('DD'),
	                            mIdx = dateFormatComponents.indexOf('MM');
	
	                        var formatComponentMap = this.getFormatComponentIdxMappings();
	                        if (formatComponentMap['DMY'].day === dIdx && formatComponentMap['DMY'].month === mIdx) {
	                            return 'DMY';
	                        } else if (formatComponentMap['MDY'].day === dIdx && formatComponentMap['MDY'].month === mIdx) {
	                            return 'MDY';
	                        }
	                        return 'YMD';
	                    },
	                    setDobTextPlaceHolder: function setDobTextPlaceHolder() {
	                        $scope.dobTextPlaceholder = this.griffinDateEntry.toUpperCase();
	                    },
	                    dobTextKeyupHandler: function dobTextKeyupHandler(event) {
	                        this.updateDobBindings(true);
	                    },
	                    /**
	                     * Absolutely makes sure that dob input doesn't contain bad characters.
	                     * Called on any chatacter input AND on locale change.
	                     */
	                    updateDobBindings: function updateDobBindings(change) {
	                        var cleanedDob = ($scope.dob.value || '').replace(this.dateRegex, '');
	                        $scope.dob.value = cleanedDob;
	
	                        // This way, our dob value is always formatted correctly.
	                        if (change) {
	                            $scope.dob.value = $('#dobText').val();
	                        }
	                    },
	                    // Dynamically construct regex to only include date separator supported by country and nondigits
	                    getDateRegex: function getDateRegex() {
	                        var escapedRegexChars = ['.', '$', '^', '{', '[', '(', '|', ')', '*', '+', '?', '\\'];
	                        var sep = this.dateSeparator;
	                        var assembledRegex = '[^0-9' + (escapedRegexChars.indexOf(sep) !== -1 ? '\\' + sep : sep) + ']';
	                        return new RegExp(assembledRegex, 'gi');
	                    },
	                    getDateMask: function getDateMask(dateSeparator) {
	                        var dateFormat = this.dateFormat;
	                        if (dateFormat === 'DMY' || dateFormat === 'MDY') {
	                            return '0Z' + dateSeparator + '0Z' + dateSeparator + '0000';
	                        }
	
	                        return '0000' + dateSeparator + '0Z' + dateSeparator + '0Z';
	                    },
	                    getDateSeparator: function getDateSeparator(dateEntry) {
	                        var ret = '';
	                        this.getDateSeparators().forEach(function (ele, iter) {
	                            // eslint-disable-line
	                            if (dateEntry.indexOf(ele) !== -1) {
	                                ret = ele;
	                            }
	                        });
	                        return ret;
	                    },
	                    // To add any additional date separators, simply add them to the returned array.
	                    getDateSeparators: function getDateSeparators() {
	                        return ['-', '.', '/'];
	                    },
	                    // Handles changes in date component order or date separator change.
	                    updateDateInputForFormat: function updateDateInputForFormat(oldFormat, newFormat, oldSeparator) {
	                        var curDateVal = $scope.dob.value || '';
	
	                        // Clear dob input if date is incomplete so user can see updated placeholder
	                        if (curDateVal.length < 8) {
	                            $scope.dob.value = '';
	                            return;
	                        }
	
	                        var formatComponentIdxMappings = this.getFormatComponentIdxMappings(),
	                            oldFormatIdxMapping = formatComponentIdxMappings[oldFormat],
	                            newFormatIdxMapping = formatComponentIdxMappings[newFormat];
	                        var oldDateComponents = curDateVal.split(oldSeparator),
	                            newDateComponents = ['', '', ''];
	
	                        newDateComponents[newFormatIdxMapping.day] = oldDateComponents[oldFormatIdxMapping.day];
	                        newDateComponents[newFormatIdxMapping.month] = oldDateComponents[oldFormatIdxMapping.month];
	                        newDateComponents[newFormatIdxMapping.year] = oldDateComponents[oldFormatIdxMapping.year];
	                        $scope.dob.value = newDateComponents.join(this.dateSeparator);
	                    },
	                    getFormatComponentIdxMappings: function getFormatComponentIdxMappings() {
	                        return {
	                            'DMY': {
	                                'day': 0,
	                                'month': 1,
	                                'year': 2
	                            },
	                            'MDY': {
	                                'day': 1,
	                                'month': 0,
	                                'year': 2
	                            },
	                            'YMD': {
	                                'day': 2,
	                                'month': 1,
	                                'year': 0
	                            }
	                        };
	                    },
	                    prefillFetchedDob: function prefillFetchedDob() {
	                        if ($scope.user && $scope.user.dob_day && $scope.user.dob_month && $scope.user.dob_year) {
	                            if (!$scope.dob) {
	                                $scope.dob = {};
	                            }
	
	                            if (this.dateFormat === 'DMY') {
	                                $scope.dob.value = $scope.user.dob_day + this.dateSeparator + $scope.user.dob_month + this.dateSeparator + $scope.user.dob_year;
	                            } else if (this.dateFormat === 'YMD') {
	                                $scope.dob.value = $scope.user.dob_year + this.dateSeparator + $scope.user.dob_month + this.dateSeparator + $scope.user.dob_day;
	                            } else {
	                                $scope.dob.value = $scope.user.dob_month + this.dateSeparator + $scope.user.dob_day + this.dateSeparator + $scope.user.dob_year;
	                            }
	                        } else {
	                            $scope.dob = {
	                                value: ''
	                            };
	                        }
	                    }
	                };
	
	                DateManager._init_();
	                DateManager.setDobTextPlaceHolder();
	                DateManager.prefillFetchedDob();
	
	                $scope.onDobTextKeyup = function (event) {
	                    DateManager.dobTextKeyupHandler(event);
	                };
	
	                $scope.$on('localeChange', function () {
	                    var oldDateFormat = DateManager.dateFormat;
	                    var oldSeparator = DateManager.dateSeparator;
	                    DateManager._init_();
	                    DateManager.updateDateInputForFormat(oldDateFormat, DateManager.dateFormat, oldSeparator);
	                    DateManager.updateDobBindings(false);
	                    DateManager.setDobTextPlaceHolder();
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-form-components/src/dob-input/template.html":
/***/ (function(module, exports) {

	module.exports = "<div id=\"dobComp\" class=\"dobbank\" ng-class=\"{dobTXT: dobInputType()==='TXT'}\" content>\n    <div class=\"dobField full inputField last-child\" floating-label directionality>\n        <input ng-model=\"dob.value\"\n               name=\"dobText\"\n               id=\"dobText\"\n               value=\"\"\n               maxlength=\"10\"\n               autocapitalize=\"off\"\n               aria-required=\"true\"\n               autocomplete=\"off\"\n               placeholder=\"{{ dobTextPlaceholder }}\"\n               xo-error-tooltip\n               dob-validation\n               ng-keyup=\"onDobTextKeyup($event)\"\n               required />\n        <div ng-class=\"dobToolTip\">\n            <xo-tooltip trigger=\"#dobText\" show-event=\"keyup\" ng-class=\"dobToolTip\" id=\"dobToolTip\">\n                <div class=\"tip tipDesc dobToolTip\">\n                  <p class=\"tipInfoText restriction active\" ng-if=\"!isValidDate\">{{ content('scripts.validDate') }}</p>\n                  <p class=\"tipInfoText restriction active\" ng-if=\"isValidDate && !isValidAge\">{{ content('scripts.legalAge') }}</p>\n                </div>\n            </xo-tooltip>\n        </div>\n        <label id=\"dobLabel\" for=\"dob\">{{ content('signup.accountCreationGuest.dobLabel') }}</label>\n    </div>\n</div>\n"

/***/ }),

/***/ "./components/xo-locale/dist/language.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-locale/dist/helper.js"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/auth/index.js"), __webpack_require__("./components/xo-models/src/app/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('locale.resolvers.language', ['squid', 'locale.helper', 'xomodel.checkout', 'xomodel.auth', 'xomodel.app']).factory('$LanguageResolvers', function ($q, $rootScope, $populate, $util, $AuthModel, $config, $locale, $localeHelper, $CheckoutCartModel, $AppDataModel, $CheckoutAppDataModel) {
	
	        var browserPrefCountries = ['US', 'GB', 'CA'];
	
	        return {
	            viaLanguagePreference: {
	                method: function method(country) {
	                    return $locale.chosenLang;
	                }
	            },
	
	            viaLocaleTestUrlParam: {
	                desc: 'For non-LIVE test, read from locale.test url param, e.g. http://localhost.com:3000/?locale.test=fr_FR',
	                method: function method() {
	                    var locale = $util.param('locale.test');
	
	                    if (locale) {
	                        return $localeHelper.normalizeLocale(locale).language;
	                    }
	                }
	            },
	
	            viaMerchantParam: {
	                desc: 'As part of url merchants can pass the locale.x=en_FR, were we extract the language param',
	                method: function method() {
	                    var locale = $util.param('locale.x');
	
	                    if (locale) {
	                        return $localeHelper.normalizeLocale(locale).language;
	                    }
	                }
	            },
	
	            viaUserProfile: {
	                method: function method(country) {
	                    var data = {};
	
	                    return $populate(data, {
	                        auth: $AuthModel.instance()
	                    }).then(function () {
	                        var locale = $localeHelper.normalizeLocale(data.auth.language);
	
	                        return locale && locale.language;
	                    });
	                }
	            },
	
	            viaMerchantLocale: {
	                method: function method() {
	                    // check before creating $CheckoutAppDataModel
	                    if (!$rootScope.token) {
	                        return;
	                    }
	
	                    var data = {};
	
	                    return $populate(data, {
	                        checkoutAppData: $CheckoutAppDataModel.instance($rootScope.token)
	                    }).then(function () {
	                        var merchant_locale = data.checkoutAppData.get('merchant.merchant_locale');
	
	                        if (!merchant_locale) {
	                            return;
	                        }
	
	                        if (!merchant_locale.match(/^\w{2}_\w{2}$/)) {
	                            return;
	                        }
	
	                        return $localeHelper.normalizeLocale(merchant_locale && merchant_locale).language;
	                    });
	                }
	            },
	
	            viaLangCookie: {
	                method: function method(country) {
	                    return $AppDataModel.instance($rootScope.token).retrieve().then(function (appData) {
	                        var lang_cookie = appData.get('locale_info.lang_cookie', {});
	
	                        if (lang_cookie.country === country) {
	                            return lang_cookie.language;
	                        }
	                    });
	                }
	            },
	
	            viaBrowserPref: {
	                method: function method(country) {
	                    if (browserPrefCountries.indexOf(country) === -1) {
	                        return $q.when();
	                    }
	
	                    return $AppDataModel.instance($rootScope.token).retrieve().then(function (appData) {
	                        return appData.get('locale_info.browser_lang.language');
	                    });
	                }
	            },
	
	            viaDefault: {
	                method: function method(country) {
	                    return $config.supportedCountries[country][0];
	                }
	            }
	
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-locale/dist", "components/xo-locale/dist/language.js"))

/***/ }),

/***/ "./components/xo-models/src/auth/lib/xoAPayUtils.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-beaver/dist/logger.js"), __webpack_require__("./components/xo-device-info/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xoAPayUtils', ['squid']).factory('$xoAPayUtils', function ($q, $logger, $DeviceInfo, $config, $http) {
	        var _jwtToken = '';
	        var _authenticated;
	
	        // Call browser PaymentRequest API that returns a promise
	        function createPaymentRequest() {
	            var supportedInstruments = [{
	                supportedMethods: ['https://android.com/pay'],
	                data: {
	                    minGooglePlayServicesVersion: '10400000',
	                    paymentMethodTokenizationParameters: {
	                        tokenizationType: 'GATEWAY_TOKEN',
	                        parameters: {
	                            gateway: 'paypal'
	                        }
	                    }
	                }
	            }];
	            var details = {
	                // Payment request requires an amount. Hardcode the value for now.
	                total: { label: 'Checkout', amount: { currency: 'USD', value: '5.00' } }
	            };
	
	            var options = {};
	            try {
	                return new PaymentRequest(supportedInstruments, details, options); // eslint-disable-line no-undef
	            } catch (e) {
	                $logger.info('PAYMENT_REQUEST_NOT_SUPPORTED');
	            }
	        }
	
	        function updateCookie(url, params) {
	            $http({
	                method: 'GET',
	                url: url,
	                params: params
	            });
	        }
	
	        function isPaymentRequestAPISupported() {
	            var currentVersionMatch = navigator.userAgent.match(/Chrome\/([0-9]+)\./i);
	            return $DeviceInfo.isMobile() && window.navigator.vendor === 'Google Inc.' && 'PaymentRequest' in window && navigator.userAgent.match(/Android/i) && currentVersionMatch && Number(currentVersionMatch[1]) >= 58;
	        }
	
	        return {
	            isAPayAPISupported: function isAPayAPISupported() {
	                return isPaymentRequestAPISupported();
	            },
	
	            canMakeAPayPayment: function canMakeAPayPayment() {
	                if (!isPaymentRequestAPISupported()) {
	                    return $q.resolve(false);
	                }
	
	                var paymentRequest = window.appPaymentRequest || createPaymentRequest();
	
	                if (paymentRequest && paymentRequest.canMakePayment) {
	                    $logger.info('APAY_CHECK_CAN_MAKE_PAYMENT');
	                    $logger.info('checkout_fpti', {
	                        from: 'payment_request_check_payment',
	                        to: 'prepare_payment_request_check_payment'
	                    });
	
	                    return paymentRequest.canMakePayment().then(function (result) {
	                        if (result) {
	
	                            $logger.info('APAY_CAN_MAKE_PAYMENT');
	                            $logger.info('checkout_fpti', {
	                                from: 'payment_request_check_payment',
	                                to: 'process_payment_request_can_make_payment'
	                            });
	                            return true;
	                        } else {
	                            $logger.info('APAY_CAN_NOT_MAKE_PAYMENT_NO_PAYMENT');
	                            $logger.info('checkout_fpti', {
	                                from: 'payment_request_can_make_payment',
	                                to: 'process_payment_request_can_not_make_payment',
	                                error_source: 'PaymentRequestAPI',
	                                error_type: 'no_payment'
	
	                            });
	                            return false;
	                        }
	                    })['catch'](function (err) {
	                        $logger.info('APAY_CAN_NOT_MAKE_PAYMENT_SOFT_DECLINE', {
	                            msg: err && err.message,
	                            name: err && err.name
	                        });
	
	                        $logger.info('checkout_fpti', {
	                            from: 'payment_request_can_make_payment',
	                            to: 'prepare_payment_request_can_make_payment_soft_decline',
	                            int_error_code: err && err.name,
	                            int_error_description: err && err.message,
	                            error_source: 'PaymentRequestAPI',
	                            error_type: 'soft_decline'
	                        });
	
	                        return false;
	                    });
	                } else {
	                    return $q.resolve(false);
	                }
	            },
	
	            authenticateAPay: function authenticateAPay() {
	                var forceAuthenticate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	                if (!forceAuthenticate && _authenticated !== undefined) {
	                    return $q.resolve(_authenticated);
	                }
	
	                _authenticated = false;
	                _jwtToken = '';
	
	                // Do not proceed if PaymentRequest is not supported.
	                if (!isPaymentRequestAPISupported()) {
	                    return $q.resolve(false);
	                }
	
	                var paymentRequest = window.appPaymentRequest || createPaymentRequest();
	                if (paymentRequest) {
	                    $logger.info('APAY_AUTHENTICATION_BEGIN');
	                    $logger.info('checkout_fpti', {
	                        from: 'payment_request_auth',
	                        to: 'prepare_payment_request_auth'
	                    });
	
	                    return paymentRequest.show().then(function (result) {
	                        result.complete('success');
	
	                        $logger.info('APAY_AUTHENTICATION_SUCCEEDED');
	                        $logger.info('checkout_fpti', {
	                            from: 'payment_request_auth',
	                            to: 'process_payment_request_auth',
	                            param_type: 'JWT'
	                        });
	
	                        var paymentMethodToken = result.details && result.details.paymentMethodToken && JSON.parse(result.details.paymentMethodToken);
	                        _jwtToken = paymentMethodToken.authJwt;
	                        _authenticated = true;
	                        return true;
	                    })['catch'](function (err) {
	                        $logger.info('APAY_AUTHENTICATION_FAILED', {
	                            msg: err && err.message,
	                            name: err && err.name
	                        });
	
	                        $logger.info('checkout_fpti', {
	                            from: 'payment_request_auth',
	                            to: 'process_payment_request_auth',
	                            int_error_code: err && err.name,
	                            int_error_description: err && err.message,
	                            error_source: 'PaymentRequestAPI',
	                            error_type: 'soft_decline'
	
	                        });
	
	                        return false;
	                    });
	                } else {
	                    return $q.resolve(false);
	                }
	            },
	
	            getAPayAuthToken: function getAPayAuthToken() {
	                return _jwtToken;
	            },
	
	            setAPayCookie: function setAPayCookie(token) {
	                if ($config.tokenizedWalletCookieURL) {
	                    updateCookie($config.tokenizedWalletCookieURL, {
	                        op: 'set',
	                        token: token
	                    });
	                }
	            },
	
	            clearAPayCookie: function clearAPayCookie(token) {
	                if ($config.tokenizedWalletCookieURL) {
	                    updateCookie($config.tokenizedWalletCookieURL, {
	                        op: 'clear',
	                        token: token
	                    });
	                }
	            },
	
	            setOTAPayCookie: function setOTAPayCookie(token) {
	                if ($config.tokenizedWalletCookieURL) {
	                    updateCookie($config.tokenizedWalletCookieURL, {
	                        op: 'setot',
	                        token: token
	                    });
	                }
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/auth/lib", "components/xo-models/src/auth/lib/xoAPayUtils.js"))

/***/ }),

/***/ "./components/xo-tracking/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	/**
	 * xo-tracking encapsulates all the details about instrumentation
	 * and only register event listeners during bootstrap
	 *
	 */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/xo-tracking/dist/listener.js"), __webpack_require__("./components/xo-tracking/dist/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular) {
	
	    // Declare the dependency to register the listeners
	    return angular.module('tracking', ['tracking.listener', 'tracking.directive']);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "./components/xo-tracking/dist/listener.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(console) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/xo-beaver/dist/logger.js"), __webpack_require__("./components/xo-tracking/dist/fpti.js"), __webpack_require__("./components/xo-tracking/dist/button.js"), __webpack_require__("./components/xo-models/src/auth/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, $) {
	    angular.module('tracking.listener', ['beaver', 'tracking.fpti', 'button.tracking']).run(function ($rootScope, $logger, $CalDataModel, $AuthModel, $fpti, $fptiError, $FptiConstants, $ButtonTrackingService, $timeout, $FptiBuilder, $meta, $config, $experiment, $util) {
	
	        function logTransition(state) {
	            return !(state.trackingData && state.trackingData.suppressTransitionLog);
	        }
	
	        function logStateExit(state) {
	            return state.trackingData && state.trackingData.trackStateExit;
	        }
	
	        function getBeaconUrl() {
	            // Logic to switch between production/staging urls. This way we don't pollute live logs,
	            // and we are able to test on stage using the fpti log viewing tool.
	            return $config.deploy.isLocal() || $config.deploy.isStage() ? 'https://tracking.qa.paypal.com/webapps/tracking/ts' // stage url
	            : $config.urls && $config.urls.fptiBeaconUrl;
	        }
	
	        /*
	         * Triggers pa.js recordClick with custom parameters
	         */
	        function fptiCustomRecordClick(route, customData) {
	            var analyticsInstance, fptiData, fptiDataObj;
	            var PAYPAL = window.PAYPAL;
	
	            if (PAYPAL && typeof PAYPAL.analytics !== 'undefined') {
	                PAYPAL.core = PAYPAL.core || {};
	
	                analyticsInstance = new PAYPAL.analytics.Analytics();
	
	                fptiData = new $FptiBuilder({
	                    trackingData: route.trackingData,
	                    isInContext: $rootScope.miniBrowser,
	                    comp: 'hermesnodeweb'
	                    // ... Other flow data pass-in here to resolve page qualifier
	                }).build();
	
	                // Grab the fpti data object and extend with custom params
	                // The fpti data obj should include pxp params as well
	                fptiDataObj = fptiData._dataObj;
	                $.extend(fptiDataObj, customData);
	
	                analyticsInstance.setRequestData(fptiDataObj);
	                analyticsInstance.recordClick({
	                    url: getBeaconUrl()
	                });
	            }
	        }
	
	        $rootScope.$on('trackInput', function (event, trackInput) {
	            if (!trackInput) {
	                return;
	            }
	            var customData = {
	                link: trackInput.transition,
	                page: trackInput.page
	            };
	
	            fptiCustomRecordClick(trackInput.currentRoute, customData);
	        });
	
	        $rootScope.$on('trackClick', function (event, trackClick) {
	            if (!trackClick) {
	                return;
	            }
	
	            var customData = {
	                link: trackClick.transition
	            };
	
	            fptiCustomRecordClick(trackClick.currentRoute, customData);
	        });
	
	        $rootScope.$on('trackSubmit', function (event, trackSubmit) {
	            if (!trackSubmit) {
	                return;
	            }
	            var currentRoute = trackSubmit.currentRoute;
	            var routeName = currentRoute ? currentRoute.name : 'noRoute';
	
	            $logger.info('track_submit', {
	                route_name: routeName
	                // ID stuff here later
	            });
	
	            if (logTransition(currentRoute)) {
	                routeName = routeName.replace(/\./g, '_');
	                var state = currentRoute.trackingData && currentRoute.trackingData.fptiState || routeName;
	                var transition = trackSubmit.transition || state;
	
	                $logger.info(routeName + '_exit', {
	                    fptiState: state,
	                    fptiTransition: transition
	                });
	            }
	
	            if (trackSubmit.errors && trackSubmit.errors.length) {
	                var fptiFieldErrors = JSON.stringify(trackSubmit.errors);
	                $logger.info('checkout_fpti', {
	                    form_field_errors: fptiFieldErrors
	                });
	            }
	
	            var errors = trackSubmit.errors;
	            if (angular.isArray(errors)) {
	                errors.forEach(function (err) {
	                    $logger.debug('track_submit_error', err);
	                    if ($fpti) {
	                        $fpti.setupDataString(currentRoute, new $fptiError({
	                            type: 'fieldError',
	                            field: err.fieldName,
	                            code: err.errorMessage
	                        }));
	                    }
	                });
	
	                if (errors.length) {
	                    $logger.flush(true);
	                }
	            }
	        });
	
	        $rootScope.$on('unhandled_error', function (event, exception) {
	            if ($fpti) {
	                $fpti.setupDataString(exception.currentRoute, new $fptiError({
	                    type: 'pageError',
	                    message: exception.message,
	                    code: exception.cause
	                }));
	            }
	        });
	
	        $rootScope.$on('trackLink', function (event, trackLink) {
	            if (!trackLink) {
	                return;
	            }
	
	            var currentRoute = trackLink.currentRoute;
	            var routeName = (currentRoute ? currentRoute.name : 'noRoute').replace(/\./g, '_');
	            var state = currentRoute.trackingData && currentRoute.trackingData.fptiState || routeName;
	
	            $logger.info(routeName + '_exit', {
	                fptiState: state,
	                fptiTransition: trackLink.transition
	            });
	        });
	
	        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
	
	            var from = fromState.name.replace(/\./g, '_');
	            var to = toState.name.replace(/\./g, '_');
	            if (from && logTransition(fromState) && logStateExit(fromState)) {
	                var trackingData = fromState.trackingData && fromState.trackingData || {};
	                $logger.info(from + '_exit', { fptiState: trackingData.fptiState || from, fptiTransition: trackingData.fptiState || from });
	            }
	
	            $logger.info('state_change', {
	                from: from || 'start',
	                to: to || 'end'
	            });
	
	            // Generate a new CAL correlation_id to be shared until next flow transition (only for view states)
	            if (toState.template) {
	                $CalDataModel.generateMetaIds();
	            }
	
	            $rootScope.currentState = to;
	
	            if (to && logTransition(toState)) {
	                $logger.info(to + '_enter', { fptiState: toState.trackingData && toState.trackingData.fptiState || to });
	            }
	        });
	
	        $rootScope.$on('page_loaded', function (event, from, to) {
	            if (from !== 'checkout_init') {
	                return;
	            }
	            var key = $FptiConstants.stateName[to] || 'review';
	            var landing_page = $FptiConstants.landing_page[key];
	            $logger.info('landing_page', {
	                'from': landing_page,
	                'to': 'process_page_loaded',
	                fpti_landing_page: landing_page
	            });
	        });
	
	        $rootScope.$on('page_reloaded', function () {
	            $logger.flush(true);
	            $CalDataModel.generateMetaIds();
	        });
	
	        $rootScope.$on('$stateChangeSuccess', function (event, toState) {
	            var to = toState.name.replace(/\./g, '_');
	            if (toState.hasResolver && to) {
	                $logger.info(to + '_load');
	            } else if (to) {
	                $logger.info(to + '_rendering');
	            }
	        });
	
	        $rootScope.$on('addrDiff', function (event, addrDiff) {
	            if (!addrDiff) {
	                return;
	            }
	
	            $logger.info('checkout_fpti', addrDiff);
	        });
	
	        function getHash(url) {
	            if (!url || !~url.indexOf('#')) {
	                // eslint-disable-line no-bitwise
	                return;
	            }
	
	            url = url.split('#');
	            return url[url.length - 1];
	        }
	
	        var oldHash = window.location.hash;
	
	        window.addEventListener('hashchange', function (event) {
	            $logger.info('hashchange', {
	                from: getHash(event.oldURL || oldHash),
	                to: getHash(event.newURL || window.location.hash)
	            });
	            oldHash = window.location.hash;
	        });
	
	        $(document).on('click', function (event) {
	            if (event && event.target && event.target.tagName) {
	                var name = event.target.tagName.toLowerCase();
	
	                if (event.target.id) {
	                    name += '#' + event.target.id;
	                } else if (event.target.attributes && event.target.attributes['ng-model']) {
	                    name += ':' + event.target.attributes['ng-model'].value;
	                } else if (event.target.className) {
	                    name += '.' + event.target.className.split(' ').join('.');
	                }
	
	                $logger.info('click', {
	                    el: name
	                });
	            }
	        });
	
	        var cplSettings = $config.enableCPL;
	
	        var token = window.meta.token;
	
	        var addTrackingData = function addTrackingData(object) {
	            return $util.extend(object, {
	                dc: $meta.dc,
	                az: $meta.az,
	                cust: $AuthModel.instance().buyer_id || '',
	                comp: 'hermesnodeweb'
	            });
	        };
	
	        var passesCplThrottle = cplSettings && (typeof cplSettings.throttle === 'undefined' || $experiment('cpl_tracking', cplSettings.throttle, token));
	
	        if (passesCplThrottle || $util.params().forceEnableCPL) {
	
	            window.fptiserverurl = getBeaconUrl();
	
	            var firstInvocation = true;
	            var trackPageStart = function trackPageStart() {
	                if (firstInvocation) {
	                    firstInvocation = false;
	                    return;
	                }
	                try {
	                    window.PAYPAL.analytics.startCPLTracking();
	                } catch (e) {
	                    console.log('error starting cpl tracking', e);
	                }
	            };
	
	            var firstDone = true;
	            var trackDone = function trackDone(beaconData) {
	                window.PAYPAL.analytics.endCPLTracking({
	                    pageData: addTrackingData(beaconData),
	                    inferStart: firstDone
	                });
	                firstDone = false;
	            };
	
	            var currentRoute = null;
	
	            $rootScope.$on('startLoad', function () {
	                return trackPageStart();
	            });
	
	            $rootScope.$on('$stateChangeSuccess', function (e, route) {
	                currentRoute = route;
	            });
	
	            $rootScope.$on('allLoaded', function () {
	                try {
	                    var buildParams = {
	                        productOverride: window.fptiProductOverride,
	                        trackingData: $fpti.getPageTrackingData(currentRoute)
	                    };
	
	                    var legacyFptiData = new $FptiBuilder(buildParams).build()._dataObj;
	
	                    var product = window.fptiProductOverride || 'ec';
	                    legacyFptiData.pgrp = 'main:' + product + ':hermes';
	
	                    legacyFptiData.flid = token;
	
	                    trackDone(legacyFptiData);
	                } catch (e) {
	                    console.log('error tracking CPL data', e);
	                }
	            });
	        } else {
	            $rootScope.$on('$transition', function (event, data) {
	
	                $timeout(function () {
	                    if ($fpti) {
	                        var fptiData = $fpti.setupDataString(data.toState, null, addTrackingData({
	                            transition_time: data.duration
	                        }));
	
	                        // Fire and forget button tracking beacon.
	                        $ButtonTrackingService.fireBeacon(fptiData);
	                    }
	                });
	            });
	        }
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ }),

/***/ "./components/xo-tracking/dist/fpti.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-tracking/dist/builder.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('tracking.fpti', ['squid', 'tracking.builder']).factory('$fpti', function ($config, $FptiBuilder, $rootScope, $window, $util) {
	
	        var _beaconUrl;
	
	        // Logic to switch between production/staging urls. This way we don't pollute live logs,
	        // and we are able to test on stage using the fpti log viewing tool.
	        if ($config.deploy.isLocal() || $config.deploy.isStage()) {
	            _beaconUrl = 'https://tracking.qa.paypal.com/webapps/tracking/ts'; // stage url
	        } else {
	            _beaconUrl = $config.urls && $config.urls.fptiBeaconUrl;
	        }
	
	        return {
	            // Get all the tracking data defined at the page level
	            getPageTrackingData: function getPageTrackingData(route) {
	                route = route || {};
	
	                var trackingData = route.trackingData || {};
	                var routeParent = route.parent;
	
	                trackingData.token = $rootScope.token;
	
	                while (routeParent) {
	                    trackingData = angular.merge({}, routeParent.trackingData || {}, trackingData);
	                    routeParent = routeParent.parent;
	                }
	                return trackingData;
	            },
	
	            setupDataString: function setupDataString(route, err, data) {
	
	                var trackingData = this.getPageTrackingData(route);
	                var fptiData;
	
	                var PAYPAL = window.PAYPAL;
	                if (PAYPAL && typeof PAYPAL.analytics !== 'undefined') {
	                    PAYPAL.core = PAYPAL.core || {};
	
	                    var payload = {
	                        trackingData: trackingData,
	                        error: err,
	                        isInContext: $rootScope.miniBrowser
	                    };
	
	                    angular.extend(payload, data || {});
	
	                    fptiData = new $FptiBuilder(payload).build().toString();
	
	                    // FPTI client side tracking only if we have template
	                    if (route && route.template && angular.isFunction(PAYPAL.analytics.setup)) {
	                        PAYPAL.core.pta = PAYPAL.analytics.setup({
	                            data: fptiData,
	                            url: _beaconUrl
	                        });
	                    }
	                }
	
	                return fptiData;
	            }
	        };
	    }).factory('$fptiError', function ($Error) {
	        function stringifyErrorMessage(msg) {
	            return encodeURIComponent(angular.isString(msg) ? msg.split('\n').slice(0, 2).join('@') // Get the first two lines of stack
	            : (angular.toJson(msg) || 'undefined').substring(0, 128));
	        }
	
	        return $Error.extend({
	            construct: function construct(err) {
	                if (!err) {
	                    return;
	                }
	                this.type = err.type;
	                this.field = err.field;
	                this.msg = stringifyErrorMessage(err.message || err.error);
	                this.code = err.code || err.cause;
	            }
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-tracking/dist", "components/xo-tracking/dist/fpti.js"))

/***/ }),

/***/ "./components/xo-tracking/dist/builder.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-tracking/dist/model.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('tracking.builder', ['squid', 'tracking.model']).factory('$FptiBuilder', function ($Class, $locale, $rootScope, $FptiConstants, $FptiDataModel, $CalDataModel, $util, $getLatestCorrelationID) {
	        /**
	         *  Build the front-end FPTI event from three data sources
	         *      1. the per-product configuration
	         *      2. the buzname defined per-route
	         *      3. the additional attributes that only available at a specific checkpoint
	         *
	         */
	
	        return $Class.extend('FptiBuilder', {
	
	            resolvePageQualifier: function resolvePageQualifier(trackingData) {
	                // The pages can populated pageQualifier to override the default one
	                this.pageQualifier = trackingData && trackingData.pageQualifier ? trackingData.pageQualifier
	                // because 'fullpage' has been widely embedded into routes
	                // we had better to keep it as a place holder
	                : 'fullpage'; // update later if it's in-context
	            },
	
	            build: function build() {
	
	                if (!this.trackingData && !this.error) {
	                    // do nothing if neither page nor error tracking
	                    return this;
	                }
	
	                this.resolvePageQualifier(this.trackingData);
	
	                this._dataObj = new $FptiDataModel().decorate('buzname', this.trackingData, this.pageQualifier, undefined, this.productOverride).decorate('templateName', this.trackingData, this.pageQualifier).decorate('locale', $locale).decorate('pageGoal', this.trackingData.pageGoal).decorate('ecToken', this.trackingData.token).decorate('correlationId', $getLatestCorrelationID()).decorate('uuid', $CalDataModel.getUUID()).decorate('fieldError', this.error).decorate('pageError', this.error).decorate('pageStartTime', new Date().getTime()).decorate('pxptrackingdata', this.trackingData.pxpData).decorate('transition_time', this.transition_time).decorate('cust', this.cust).decorate('dc', this.dc).decorate('az', this.az).decorate('comp', this.comp).getDataObject(this.isInContext);
	
	                return this;
	            },
	
	            toString: function toString() {
	
	                var dataAry = [];
	                angular.forEach(this._dataObj, function (v, k) {
	                    dataAry.push(k + '=' + v);
	                });
	
	                return dataAry.join('&');
	            }
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-tracking/dist", "components/xo-tracking/dist/builder.js"))

/***/ }),

/***/ "./components/xo-tracking/dist/button.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-models/src/checkout/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('button.tracking', ['squid', 'xomodel.checkout']).factory('$ButtonTrackingService', function ($rootScope, $http, $populate, $CheckoutAppDataModel, $CheckoutPayeeModel, $meta, $cookies) {
	
	        var _beaconUrl = 'https://www.paypalobjects.com/en_US/i/scr/btn_tracking_pixel.gif?teal=null&Id=null&ru=null';
	        var _beaconParams = ['fltk', 'calc', 'page', 'xe', 'xt'];
	        var _alreadyFired = false;
	
	        function _strToElements(str) {
	            var elements = {};
	            if (str && str.length) {
	                str.split('&').forEach(function (param) {
	                    var nvp = param.split('=');
	                    elements[nvp[0]] = nvp[1];
	                });
	            }
	            return elements;
	        }
	
	        function _fireButtonTrackingBeacon(elements) {
	            var url = _beaconUrl;
	            var xoData = {};
	
	            function buildParam(param, value) {
	                var p = '&' + param + '=' + (value ? value : 'null');
	                return p;
	            }
	
	            function getGUIID(ts) {
	                return _strToElements(ts).vr;
	            }
	
	            function addToDocument(uri) {
	                var img = document.createElement('img');
	                img.setAttribute('src', uri);
	                document.body.appendChild(img);
	            }
	
	            // Get some params from FPTI data.
	            _beaconParams.forEach(function (param) {
	                url += buildParam(param, elements[param]);
	            });
	
	            // Build the rest of the params.
	            url += buildParam('fpti', getGUIID($cookies && $cookies.ts));
	            url += buildParam('WWW_AKA_MVT_BUTTONS', $cookies && $cookies.WWW_AKA_MVT_BUTTONS);
	            url += buildParam('WWW_AKA_MVT_ID', $cookies && $cookies.WWW_AKA_MVT_ID);
	            url += buildParam('ip', $meta && $meta.ipaddress);
	
	            if ($rootScope.token) {
	                $populate(xoData, {
	                    payee: $CheckoutPayeeModel.instance($rootScope.token),
	                    appData: $CheckoutAppDataModel.instance($rootScope.token)
	                }).then(function () {
	                    url += buildParam('mrid', xoData.payee && xoData.payee.getId());
	                    url += buildParam('calf', xoData.appData && xoData.appData.flow_id);
	
	                    addToDocument(url);
	                });
	            } else {
	                url += buildParam('mrid', null);
	                url += buildParam('calf', null);
	                addToDocument(url);
	            }
	        }
	
	        return {
	            fireBeacon: function fireBeacon(fptiData) {
	                if (!_alreadyFired && fptiData) {
	                    var elements = _strToElements(fptiData);
	
	                    // Fire the beacon if this is a page render.
	                    if (elements.page) {
	                        _alreadyFired = true;
	                        return _fireButtonTrackingBeacon(elements);
	                    }
	                }
	            },
	            resetAlreadyFired: function resetAlreadyFired() {
	                _alreadyFired = false;
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-tracking/dist", "components/xo-tracking/dist/button.js"))

/***/ }),

/***/ "./components/xo-tracking/dist/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular) {
	
	    angular.module('tracking.directive', ['ui.router']).directive('trackSubmit', function ($state, $rootScope) {
	        return {
	            restrict: 'AE',
	            link: function link($scope, element, attr) {
	                element.on('mousedown', function (event) {
	                    var transition = attr && attr.trackSubmit;
	                    var trackSubmit = {
	                        currentRoute: $state.current,
	                        transition: transition,
	                        errors: []
	                    };
	
	                    angular.forEach($('input.ng-invalid, select.ng-invalid'), function (el) {
	                        var elem = $(el);
	                        var elementId = elem.attr('id');
	                        var elementName = elem.attr('name');
	                        var errorKey = elem.attr('data-error-key');
	                        var errorText = elem.has('required') ? 'required' : 'no error key';
	                        var fieldName = elementId ? elementId : elementName;
	
	                        if (!fieldName) {
	                            var elementModel = elem.attr('ng-model');
	                            fieldName = elementModel ? elementModel : 'unnamed-field';
	                        }
	
	                        trackSubmit.errors.push({
	                            fieldName: fieldName,
	                            errorMessage: errorKey ? errorKey : errorText
	                        });
	                    });
	
	                    $rootScope.$broadcast('trackSubmit', trackSubmit);
	                });
	            }
	        };
	    }).directive('trackLink', function ($state, $rootScope) {
	        return {
	            restrict: 'AE',
	            link: function link($scope, element, attr) {
	                element.on('mousedown', function (event) {
	
	                    var state = attr && attr.trackLink;
	
	                    if (state) {
	                        var trackLink = {
	                            currentRoute: $state.current,
	                            transition: state
	                        };
	                        $rootScope.$broadcast('trackLink', trackLink);
	                    }
	                });
	            }
	        };
	    }).directive('trackClick', function ($state, $rootScope) {
	        return {
	            restrict: 'AE',
	            link: function link($scope, element, attr) {
	                element.on('click', function (event) {
	                    var state = attr && attr.trackClick;
	
	                    if (state) {
	                        var trackClick = {
	                            currentRoute: $state.current,
	                            transition: state
	                        };
	                        $rootScope.$broadcast('trackClick', trackClick);
	                    }
	                });
	            }
	        };
	    }).directive('trackInput', function ($state, $rootScope) {
	        /*
	         * Track an input tag with track-input attribute
	         * you can use the value of track-input attribute as
	         * a tracking attr Eg.: track-input="xo_guest_yes"
	         */
	        return {
	            restrict: 'AE',
	            link: function link($scope, element, attr) {
	                element.on('click', function (event) {
	
	                    var state;
	
	                    if (event.target.type === 'checkbox') {
	                        if (event.target.checked) {
	                            state = attr && attr.trackInput + '_CHECKED';
	                        } else {
	                            state = attr && attr.trackInput + '_UNCHECKED';
	                        }
	                    } else {
	                        state = attr && attr.trackInput;
	                    }
	
	                    var trackInput = {
	                        currentRoute: $state.current,
	                        page: 'main:ec:hermes::fullpage-billing:guest:aries:'
	                    };
	
	                    if (state) {
	                        trackInput.transition = state;
	                    }
	
	                    $rootScope.$broadcast('trackInput', trackInput);
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "./pages/xo-landing/route.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-beaver/dist/logger.js"), __webpack_require__("./components/xo-models/src/user/index.js"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/inventory/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('hermes.page.xo-landing.route', ['squid', 'beaver', 'xomodel.user']).factory('$LandingRoute', function ($ComponentRoute, $dispatch, $feature, $logger, $locale, $util, $FallbackError, $meta, $pxp, $CheckoutInputDataModel, $CheckoutAppDataModel, $rootScope, $populate, $config, $CheckoutCartModel, $CheckoutPayeeModel, $InventoryModel, $FlowEligibilityModel) {
	
	        // controller is added in squid/route.js
	        return $ComponentRoute.extend('LandingRoute', {
	            name: 'landing',
	            titleContent: 'accountCreationGuest.heading',
	            scope: {
	                isUnbranded: '='
	            },
	            trackingData: {
	                fptiState: 'landing',
	                trackStateExit: true
	            },
	            resolve: {
	                action: function action($util) {
	                    // eslint-disable-line no-shadow
	
	                    var models = {};
	                    return $populate(models, {
	                        checkoutCart: $CheckoutCartModel.instance($rootScope.token),
	                        checkoutPayeeModel: $CheckoutPayeeModel.instance($rootScope.token),
	                        checkoutAppData: $CheckoutAppDataModel.instance($rootScope.token),
	                        checkoutInputData: $CheckoutInputDataModel.instance($rootScope.token)
	                    }).then(function () {
	                        // C2 ramp - force CN country code to C2 upon landing
	                        if ($locale.country === 'CN') {
	                            $locale.change('C2', $locale.lang);
	                            $logger.info('CN_locale_forced_to_C2');
	                        }
	                    }).then(function () {
	                        var landingFlow = function landingFlow() {
	
	                            function callEPM() {
	                                if ($config.deploy.isLocal() || $config.deploy.isStage()) {
	                                    var passedInExp = $util.param('showExp');
	                                    if ('guest'.indexOf(passedInExp) > -1) {
	                                        return 'checkout.guest';
	                                    }
	
	                                    if ('signup'.indexOf(passedInExp) > -1) {
	                                        return 'checkout.signup';
	                                    }
	                                }
	                                return $FlowEligibilityModel.instance($rootScope.token).retrieve({
	                                    params: {
	                                        'localeCountry': $locale.country
	                                    }
	                                }).then(function (flowEligibility) {
	                                    var mode = flowEligibility.guest ? 'guest' : 'signup';
	                                    var flow_offered = flowEligibility.guest ? 0 : 1;
	                                    if (mode === 'signup') {
	                                        $logger.info(mode + '_flow_offered_by_epm_at_route');
	                                        $logger.info('checkout_fpti', {
	                                            from: 'LANDING_PAGE_PARAM',
	                                            forced_signup_offered: flow_offered
	                                        });
	                                        return 'checkout.signup';
	                                    }
	                                    $logger.info('guest_flow_offered_by_epm_at_route');
	                                    return 'checkout.guest';
	                                });
	                            }
	
	                            var merchantCountry = models.checkoutAppData.get('merchant.merchant_country');
	                            var paymentMethodViaUrl = $util.param('paymentMethod');
	                            var paymentMethodViaCheckoutAppData = models.checkoutAppData.get('user_selected_funding_source_type') === 'PAY_UPON_INVOICE' ? 'invoice' : undefined;
	
	                            var paymentMethod = paymentMethodViaCheckoutAppData || paymentMethodViaUrl;
	                            var isUnbranded = paymentMethod !== undefined;
	
	                            if (isUnbranded) {
	                                var isUnbrandedAllowed = $feature('unbranded', true, merchantCountry);
	                                var isPuiAllowed = $feature('invoicePayment', true, merchantCountry);
	
	                                if (isUnbrandedAllowed && isPuiAllowed && paymentMethod === 'invoice') {
	                                    return 'checkout.pay-upon-invoice';
	                                }
	                                return 'checkout.guest';
	                            } else if (models.checkoutAppData.get('flags.payment_experience_initiator') === 'PAYPAL_PLUS' && $util.param('exp') === 'signup') {
	                                return 'checkout.signup';
	                            } else if ($feature('multiStepSignup', false, $locale.country)) {
	                                return 'checkout.multistepsignup';
	                            } else if (models.checkoutInputData.isEbayTxn()) {
	                                // force signup for eBay users
	                                $logger.info('ebay_flow_signup');
	                                return 'checkout.signup';
	                            } else {
	                                // if you here means, now we need to determine the route based on symphony EPM call.
	                                return callEPM();
	                            }
	                        };
	
	                        var cartHasInventory = models.checkoutCart.get('cartHasInventory');
	                        if ($config.enableInventoryWPS && cartHasInventory) {
	                            var inventoryModel = $InventoryModel.instance($rootScope.token);
	                            var inventoryInput = {
	                                items: models.checkoutCart.get('purchase.items'),
	                                merchantId: models.checkoutPayeeModel.getId()
	                            };
	                            return inventoryModel.action('getInventory', {
	                                data: inventoryInput,
	                                success: function success(inventoryResponse) {
	                                    if (inventoryResponse.showSoldoutPage) {
	                                        return {
	                                            to: 'checkout.soldout',
	                                            params: {
	                                                items: encodeURIComponent(inventoryResponse.soldoutItems),
	                                                soldOutUrl: encodeURIComponent(inventoryResponse.soldoutUrl)
	                                            }
	                                        };
	                                    } else {
	                                        inventoryModel.setInvetoryItems(inventoryResponse);
	                                        return landingFlow();
	                                    }
	                                }
	                            });
	                        } else {
	                            return landingFlow();
	                        }
	                    });
	                }
	            }
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-landing", "pages/xo-landing/route.js"))

/***/ }),

/***/ "./components/xo-models/src/inventory/index.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xomodel.inventory', ['squid']).factory('$InventoryModel', function ($Model, $Api) {
	        return $Model.extend('$InventoryModel', {
	            api: new $Api({
	                uri: '/api/catalog/:id/item/',
	                postAttempts: 2,
	                cache: true
	            }),
	
	            setInvetoryItems: function setInvetoryItems(inventoryItems) {
	                this.inventoryItems = inventoryItems;
	            },
	
	            getInventoryItems: function getInventoryItems() {
	                return this.inventoryItems;
	            }
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/inventory", "components/xo-models/src/inventory/index.js"))

/***/ }),

/***/ "./pages/xo-generic-error/route.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./pages/xo-generic-error/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('hermes.page.xo-generic-error.route', ['squid', 'hermes.page.xo-generic-error.directive']).factory('$GenericErrorRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('GenericErrorRoute', {
	            name: 'genericError',
	            directive: 'xo-generic-error-page',
	            titleContent: 'genericError.pleaseTryAgain',
	            query: ['code'],
	            // need to find these values
	            trackingData: {
	                templateName: 'genericError.dust',
	                pageGoal: 'Generic Error',
	                buzname: {
	                    'fullpage': {
	                        'pagename': '%::fullpage-generic-error',
	                        'pagename2': '%::fullpage-generic-error:member:hermes:',
	                        'version': 'member:%:'
	                    }
	                }
	            },
	            children: []
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-generic-error", "pages/xo-generic-error/route.js"))

/***/ }),

/***/ "./pages/xo-generic-error/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoGenericErrorPageComponent = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _template = __webpack_require__("./pages/xo-generic-error/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-models/src/checkout/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/generic-error/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/message/directive.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoGenericErrorPageComponent = exports.$xoGenericErrorPageComponent = _squid.$Component.extend('$xoGenericErrorPageComponent', {
	    tag: 'xo-generic-error-page',
	    template: _template2['default'],
	
	    controller: function controller($scope, $rootScope, // eslint-disable-line no-shadow
	    $locale, $CheckoutInputDataModel, $util, $logger, $state) {
	
	        $scope.token = $rootScope.token;
	        var terminalKey = 'terminal-error-' + $scope.token,
	            refreshKey = 'has-seen-error-' + $scope.token;
	
	        function renderErrorPage() {
	            // prevent render flicker
	            $scope.shouldRender = true;
	
	            if ($CheckoutInputDataModel.instance($scope.token).isEbayTxn()) {
	                $scope.cancelUrl = $util.param('redirect_uri');
	                $scope.merchant = $locale.content.get('signup.ebay');
	            }
	        }
	
	        if (!window.sessionStorage || !$scope.token || window.sessionStorage[terminalKey]) {
	            return renderErrorPage();
	        }
	
	        // is not a refresh, user landing for the first time on generic error page.
	        if (!window.sessionStorage[refreshKey]) {
	            window.sessionStorage[refreshKey] = 'true';
	            return renderErrorPage();
	        } else {
	            // This is a refresh. Go to guest page if a refresh happens, don't show generic error page
	            $logger.info('checkout_fpti', {
	                user_refresh: 1
	            });
	            // delete the refresh key, so that next time renders the error page.
	            delete window.sessionStorage[refreshKey];
	            // go guest page if a refresh happens
	            $state.go('checkout.guest')['catch'](function () {
	                // don't try to do this again
	                window.sessionStorage[terminalKey] = 'true';
	            });
	        }
	    }
	});
	
	angular.value("$xoGenericErrorPageComponent", $xoGenericErrorPageComponent);
	_squid.$Component;

/***/ }),

/***/ "./pages/xo-generic-error/template.html":
/***/ (function(module, exports) {

	module.exports = "<xo-generic-error ng-if=shouldRender token=\"token\" merchant={{merchant}} cancel-url={{cancelUrl}} is-unbranded=\"isUnbranded\"></xo-generic-error>\n"

/***/ }),

/***/ "./components/xo-ui-components/src/generic-error/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _index = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _index2 = __webpack_require__("./components/xo-models/src/auth/index.js");
	
	var _util = __webpack_require__("./components/xo-return-to-merchant/dist/util.js");
	
	var _jquery = __webpack_require__("./components/jquery/dist/jquery.min.js");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _template = __webpack_require__("./components/xo-ui-components/src/generic-error/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-ui-components/src/generic-error/styles.less");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TITLE_KEY_MAPPING = {
	    PAYMENT_PROCESS_ERROR: 'paymentProcessError',
	    BLOCK_NON_DOMESTIC_SHIPPING: 'blockNonDomesticShippingTitle',
	    BLOCK_PPC_INELIGIBLE_USER: 'blockPPCIneligibleTitle',
	    PAYER_COUNTRY_NOT_ALLOWED: 'payerCountryNotAllowedTitle',
	    XOON_PAYER_COUNTRY_NOT_ALLOWED_DCF: 'payerCountryNotAllowedTitleSignupDCF',
	    HERMES_PAYER_COUNTRY_NOT_ALLOWED_DCF: 'payerCountryNotAllowedTitleMemberDCF',
	    PAYER_COUNTRY_NOT_ENABLED: 'payerCountryNotAllowedTitle',
	    PAYER_LOGIN_COUNTRY_NOT_ALLOWED: 'payerCountryNotAllowedTitle',
	    TRANSACTION_REFUSED: 'transactionRefusedTitle',
	    COMPLIANCE_VIOLATION: 'transactionRefusedTitle',
	    DOMESTIC_TRANSACTION_REQUIRED: 'domesticTransactionRequiredTitle',
	    INTERNAL_SERVICE_ERROR: 'transactionRefusedTitle',
	    NEGATIVE_BALANCE_TRANSACTION_REFUSED: 'negativeBalanceRefusedTitle',
	    STUDENT_ACCOUNT: 'studentAccountTitle',
	    RETRY: 'sorry'
	};
	
	var CONTENT_KEY_MAPPING = {
	    INVALID_RESOURCE_ID: 'expiredOrTokenNotFoundError',
	    EXPIRED_SESSION: 'expiredOrTokenNotFoundError',
	    PAYMENT_ALREADY_DONE: 'paymentAlreadyCompletedError',
	    PAYEE_BLOCKED_TRANSACTION: 'paymentDeniedError',
	    PAYER_CANNOT_PAY: 'paymentDeniedError',
	    RESTRICTED_USER: 'buyerRestrictedError',
	    PAYMENT_DENIED: 'paymentDeniedError',
	    UNSUPPORTED_PAYEE_CURRENCY: 'unsupportedPayeeCurrency',
	    GUEST_UPGRADE_SESSION_ERROR: 'guestUpgradeSessionError',
	    GUEST_UPGRADE_ERROR: 'guestUpgradeError',
	    BLOCK_NON_DOMESTIC_SHIPPING: 'blockNonDomesticShippingMessage',
	    BLOCK_PPC_INELIGIBLE_USER: 'blockPPCIneligibleMessage',
	    PAYER_COUNTRY_NOT_ALLOWED: 'unauthorizedCountryAccountRegistered',
	    XOON_PAYER_COUNTRY_NOT_ALLOWED_DCF: 'unauthorizedCountryAccountSignupDCF',
	    HERMES_PAYER_COUNTRY_NOT_ALLOWED_DCF: 'unauthorizedCountryAccountMemberDCF',
	    PAYER_COUNTRY_NOT_ENABLED: 'rpUnauthorizedCountryMessage',
	    PAYER_LOGIN_COUNTRY_NOT_ALLOWED: 'unauthorizedCountryLogin',
	    PAYMENT_PROCESS_ERROR: 'chooseOtherWayToPay',
	    GAMING_FUNDING_SOURCE_VALIDATION_FAILED: 'unauthorizedCountryAccountRegistered',
	    SENDING_LIMIT_EXCEEDED: 'sendingLimitExceeded',
	    TRANSACTION_LIMIT_EXCEEDED: 'transactionLimitExceeded',
	    TRANSACTION_REFUSED: 'transactionRefusedMessage',
	    COMPLIANCE_VIOLATION: 'complianceViolationMessage',
	    DOMESTIC_TRANSACTION_REQUIRED: 'domesticTransactionRequiredMessage',
	    INTERNAL_SERVICE_ERROR: 'transactionRefusedMessage',
	    DEFAULT: 'genericError',
	    NEGATIVE_BALANCE_TRANSACTION_REFUSED: 'negativeBalanceRefusedMessage',
	    ACCOUNT_CANNOT_BE_FETCHED: 'genericError',
	    STUDENT_ACCOUNT: 'studentAccountMessage',
	    RETRY: 'thingsNotWorking',
	    DEFAULT_ANDROID_PAY_ERROR: 'androidPayGenericError',
	    ANDROID_PAY_ELIGIBILITY_ERROR: 'androidPayGenericError',
	    DUPLICATE_INVOICE_ID: 'duplicateInvoiceId',
	    UNSUPPORTED_COUNTRY: 'unsupportedCountry',
	    ANDROID_PAY_ALREADY_PROVISIONED: 'androidPayAlreadyProvisioned'
	};
	
	// pass merchantName attribute, if undefined, then suffix 'Default' to key
	var renderContentWithMerchantName = function renderContentWithMerchantName(key) {
	    var merchantName = this.props.merchant;
	
	    if (merchantName) {
	        return (0, _squid.$renderContent)(key, { merchantName: merchantName });
	    }
	
	    return (0, _squid.$renderContent)(key + 'Default');
	};
	
	// handle non-standard merchant error title strings
	var TITLE_KEY_HANDLER = {
	    DOMESTIC_TRANSACTION_REQUIRED: renderContentWithMerchantName,
	    XOON_PAYER_COUNTRY_NOT_ALLOWED_DCF: renderContentWithMerchantName,
	    HERMES_PAYER_COUNTRY_NOT_ALLOWED_DCF: renderContentWithMerchantName
	};
	
	// handle non-standard merchant error content strings
	var CONTENT_KEY_HANDLER = {
	    DOMESTIC_TRANSACTION_REQUIRED: renderContentWithMerchantName,
	    XOON_PAYER_COUNTRY_NOT_ALLOWED_DCF: renderContentWithMerchantName,
	    HERMES_PAYER_COUNTRY_NOT_ALLOWED_DCF: renderContentWithMerchantName
	};
	
	var SHOW_LOGOUT_LINK_CODES = ['HERMES_PAYER_COUNTRY_NOT_ALLOWED_DCF', 'ANDROID_PAY_COUNTRY_NOT_SUPPORTED', 'ANDROID_PAY_ALREADY_PROVISIONED'];
	
	var HIDE_CANCEL_LINK_CODES = ['PAYER_COUNTRY_NOT_ALLOWED', 'GAMING_FUNDING_SOURCE_VALIDATION_FAILED', 'PAYER_LOGIN_COUNTRY_NOT_ALLOWED'];
	
	var RETRY_LINK = ['RETRY'];
	
	var TRANSACTION_REFUSED_BA_TITLE_MSG = {
	    BA_NO_PURCHASE: 'transactionRefusedBAnoPurchaseTitle',
	    BA_WITH_PURCHASE: 'transactionRefusedBAPurchaseTitle'
	};
	
	/* eslint-disable fasec/no-unsafe-regex */
	var base64regex = new RegExp('^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$');
	
	exports['default'] = _squid.$Component.extend('$xoGenericErrorComponent', {
	
	    tag: 'xo-generic-error',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            type: 'var',
	            required: false
	        },
	        logout: {
	            type: 'var',
	            required: false
	        },
	        isUnbranded: {
	            type: 'var',
	            required: false
	        },
	        cancelUrl: {
	            type: 'str',
	            required: false
	        },
	        merchant: {
	            type: 'str',
	            required: false,
	            'default': function _default() {
	                if (this.models && this.models.checkoutAppData && this.models.checkoutAppData.merchant) {
	                    var merchant = this.models.checkoutAppData.merchant;
	                    return merchant.brand_name || merchant.merchant_name;
	                }
	            }
	        }
	    },
	
	    resolve: {
	        models: function models() {
	            if (this.props.token) {
	                return {
	                    checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve()['catch'](angular.noop),
	                    cart: _index.$CheckoutCartModel.instance(this.props.token).retrieve()['catch'](angular.noop),
	                    checkoutPayee: _index.$CheckoutPayeeModel.instance(this.props.token).retrieve()['catch'](angular.noop),
	                    auth: _index2.$AuthModel.instance().retrieve()['catch'](angular.noop)
	                };
	            }
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var _this = this;
	
	            var cancelPreventStateChange = _angular.$rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
	                event.preventDefault();
	            });
	
	            this.$on('$destroy', cancelPreventStateChange);
	
	            var self = this;
	
	            // to not break other application's error integration, we'll still support base64 decoded code parameters
	            if (_uiRouter.$stateParams.code && base64regex.test(_uiRouter.$stateParams.code)) {
	                self.errorCode = _squid.$util.base64Decode(_uiRouter.$stateParams.code);
	            } else {
	                self.errorCode = _uiRouter.$stateParams.code;
	            }
	
	            self.hideCancelLink = HIDE_CANCEL_LINK_CODES.indexOf(self.errorCode) > -1;
	            self.retryLink = RETRY_LINK.indexOf(self.errorCode) > -1;
	
	            _angular.$rootScope.allowUnload = true;
	            self.cancelLink = self.props.cancelUrl;
	
	            self.cancelRedirect = function ($event) {
	                $event.preventDefault();
	                var redirectUrl = self.cancelLink;
	
	                if (_angular.$rootScope.partnerIntegration) {
	                    _logger.$logger.info('genericerror_partner_integration');
	                    redirectUrl = _squid.$util.buildURL(self.cancelLink, { error: 'true' });
	                }
	
	                _util.$ReturnToMerchant.goTo(redirectUrl);
	            };
	
	            self.retryCheckout = function ($event) {
	                $event.preventDefault();
	
	                _squid.$util.reload();
	            };
	
	            self.isMessengerBAIntegration = _squid.$integration.getConfig('IS_MESSENGER_BA_INTEGRATION');
	
	            self.loggingOut = function ($event) {
	                $event.preventDefault();
	                cancelPreventStateChange();
	                self.props.logout();
	            };
	
	            (0, _jquery2['default'])('.paypalHeaderWrapper').hide();
	            // Cancel link should be shown for "Credit Ineligible" page for DE
	            if (self.errorCode !== 'BLOCK_PPC_INELIGIBLE_USER') {
	                (0, _jquery2['default'])('#defaultCancelLink').hide();
	            }
	            (0, _jquery2['default'])('.footerWrapper').addClass('genericError');
	
	            self.$on('$destroy', function (event) {
	                (0, _jquery2['default'])('.paypalHeaderWrapper').show();
	                if (self.errorCode !== 'BLOCK_PPC_INELIGIBLE_USER') {
	                    (0, _jquery2['default'])('#defaultCancelLink').show();
	                }
	                (0, _jquery2['default'])('.footerWrapper').removeClass('genericError');
	            });
	
	            // Returns the title string, based on custom key handler
	            self.getTitle = function () {
	                var key = self.titleKey;
	
	                if (TITLE_KEY_HANDLER.hasOwnProperty(self.errorCode)) {
	                    return TITLE_KEY_HANDLER[self.errorCode].call(_this, key);
	                }
	
	                return (0, _squid.$renderContent)(key);
	            };
	
	            // Returns the content string, based on custom key handler
	            self.getContent = function () {
	
	                var key = self.contentKey;
	
	                if (CONTENT_KEY_HANDLER.hasOwnProperty(self.errorCode)) {
	                    return CONTENT_KEY_HANDLER[self.errorCode].call(_this, key);
	                }
	
	                return (0, _squid.$renderContent)(key);
	            };
	
	            // Returns the cancel button label, based on presence of brand/merchant name
	            self.getCancelLabel = function () {
	                if (self.walletTokenization) {
	                    if (self.errorCode === 'ANDROID_PAY_ALREADY_PROVISIONED') {
	                        return (0, _squid.$renderContent)('common.backToAndroidPayB');
	                    } else {
	                        return (0, _squid.$renderContent)('common.backToAndroidPay');
	                    }
	                } else {
	                    var merchantName = _this.props.merchant;
	                    if (merchantName) {
	                        return (0, _squid.$renderContent)('common.returnToMerchant', { merchantName: merchantName });
	                    }
	
	                    return (0, _squid.$renderContent)('common.returnToDefaultMerchant');
	                }
	            };
	            this.personalizedBanner = {
	                show: false
	            };
	        },
	        populate: function populate() {
	            if (this.models.checkoutAppData) {
	                this.cancelLink = this.models.checkoutAppData.urls.cancel_url;
	            }
	
	            if (this.models.checkoutPayee) {
	                var merchant = this.models.checkoutPayee.merchant;
	
	                if (merchant.id && !this.hideCancelLink) {
	                    var hcl = _squid.$config.hideCancelLinkForMerchant;
	
	                    var shouldHide = hcl && hcl.indexOf(merchant.id) !== -1;
	                    if (shouldHide) {
	                        this.hideCancelLink = true;
	                    }
	                }
	            }
	
	            if (this.models.cart) {
	                this.walletTokenization = this.models.cart.isWalletTokenization();
	            }
	
	            this.personalizedBanner.show = this.models.auth && this.models.auth.rememberedOT() && (0, _squid.$feature)('oneTouchPersonalization');
	
	            if (this.models.auth) {
	                this.showLogoutLink = this.models.auth.is_auth_api_call && _squid.$util.param('source') !== 'consumerApp' && this.props.logout && SHOW_LOGOUT_LINK_CODES.indexOf(this.errorCode) > -1;
	
	                this.formattedNameInformal = (0, _squid.formatNameInformal)({
	                    first_name: this.models.auth.first_name,
	                    last_name: this.models.auth.last_name
	                }) || this.models.auth.email;
	            }
	
	            // Map error code for Android Pay
	            if (this.walletTokenization) {
	                // For Android Pay, map all errors to generic Android Pay error except for
	                // ANDROID_PAY_ALREADY_PROVISIONED
	                if (this.errorCode !== 'ANDROID_PAY_ALREADY_PROVISIONED') {
	                    this.errorCode = 'DEFAULT_ANDROID_PAY_ERROR';
	                }
	            }
	
	            var titleKey = this.errorCode && TITLE_KEY_MAPPING[this.errorCode];
	            if (titleKey) {
	                if (titleKey === 'transactionRefusedTitle' && this.models.cart && this.models.cart.isBillingNoPurchase()) {
	                    this.titleKey = 'genericError.' + TRANSACTION_REFUSED_BA_TITLE_MSG['BA_NO_PURCHASE'];
	                } else if (titleKey === 'transactionRefusedTitle' && this.models.cart && this.models.cart.isBillingPurchase()) {
	                    this.titleKey = 'genericError.' + TRANSACTION_REFUSED_BA_TITLE_MSG['BA_WITH_PURCHASE'];
	                } else {
	                    this.titleKey = 'genericError.' + titleKey;
	                }
	            }
	
	            var contentKey = this.errorCode && CONTENT_KEY_MAPPING[this.errorCode] || CONTENT_KEY_MAPPING.DEFAULT;
	            this.contentKey = 'genericError.' + contentKey;
	        }
	    }
	
	});
	
	
	_angular.$rootScope;
	
	_uiRouter.$stateParams;
	
	_squid.$Component;
	
	_squid.$util;
	
	_squid.$renderContent;
	
	_squid.$config;
	
	_squid.formatNameInformal;
	
	_squid.$integration;
	
	_squid.$feature;
	
	_logger.$logger;
	
	_index.$CheckoutAppDataModel;
	
	_index.$CheckoutCartModel;
	
	_index.$CheckoutPayeeModel;
	
	_index2.$AuthModel;
	
	_util.$ReturnToMerchant;
	module.exports = exports['default'];

/***/ }),

/***/ "./components/xo-ui-components/src/generic-error/template.html":
/***/ (function(module, exports) {

	module.exports = "<section id=\"genericError\" content>\n    <div class=\"container\">\n        <div class=\"logo\" ng-if=\"!props.isUnbranded\"></div>\n\n        <xo-banner ng-if=\"personalizedBanner.show && !isMessengerBAIntegration && showLogoutLink\" buyer-id=\"models.auth.buyer_id\" class=\"banner\">\n            <p class=\"userEmail\" id=\"reviewUserInfo\">\n                {{ content('memberReview.loggedInWithOneTouch', {userName: formattedNameInformal, lastName: models.auth.last_name, firstName: models.auth.first_name}) }}\n                <a track-link=\"login_with_diff_user\" href=\"\" class=\"textLink\" ng-click=\"loggingOut($event)\">{{ content('memberReview.notYou')}}</a>\n            </p>\n        </xo-banner>\n        <div ng-if=\"!personalizedBanner.show && !isMessengerBAIntegration && showLogoutLink\" class=\"banner\">\n            <p class=\"userEmail\" id=\"reviewUserInfo\">\n                {{ content('creditcard.hi', {userName: formattedNameInformal}) }}\n                <a track-link=\"login_with_diff_user\" href=\"\" class=\"textLink\" ng-click=\"loggingOut($event)\">{{ content('memberReview.notYou')}}</a>\n            </p>\n        </div>\n\n        <div class=\"title\" ng-if=\"titleKey\">\n            {{ getTitle() }}\n        </div>\n        <div class=\"message\"\n            ng-if=\"contentKey\"\n            ng-bind-html=\"getContent()\">\n        </div>\n        <p class=\"retryLink\" ng-if=\"retryLink\">\n            <a link-button ng-click=\"retryCheckout($event)\" id=\"retryLink\" class=\"btn full\">\n                {{ content('genericError.tryAgain') }}\n            </a>\n        </p>\n        <p class=\"cancelLink\" ng-if=\"cancelLink && !hideCancelLink\">\n            <a href=\"{{cancelLink}}\" ng-click=\"cancelRedirect($event)\" id=\"cancelLink\" ng-class=\"['btn', 'full', {'btn-secondary': retryLink}]\">\n                {{ getCancelLabel() }}\n            </a>\n        </p>\n    </div>\n</section>\n"

/***/ }),

/***/ "./components/xo-ui-components/src/generic-error/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-ui-components/src/generic-error/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-ui-components/src/generic-error/styles.less":
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "blockquote,body,code,dd,div,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,html,input,legend,li,ol,p,pre,td,textarea,th,ul{margin:0;padding:0}table{border-collapse:collapse;border-spacing:0}fieldset,img{border:0}address,caption,cite,code,dfn,em,strong,th,var{font-style:normal;font-weight:400}ol,ul{list-style:none}caption,th{text-align:left}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:400}q:after,q:before{content:\"\"}abbr,acronym{border:0;font-variant:normal}sup{vertical-align:text-top}sub{vertical-align:text-bottom}input,select,textarea{font-family:inherit;font-size:inherit;font-weight:inherit;font-size:100%}legend{color:#000}body{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:95%;color:#2c2e2f;line-height:1.35em}h1{font-size:138.5%}h2{font-size:123.1%}h3{font-size:108%}h1,h2,h3{margin:1em 0}h1,h2,h3,h4,h5,h6,strong{font-weight:700}a{color:#0070ba}abbr,acronym{border-bottom:1px dotted #000;cursor:help}em{font-style:italic}blockquote,dl,ol,ul{margin:1em}dl,ol,ul{margin-left:2em}ol{list-style:decimal outside}ul{list-style:disc outside}dl dd{margin-left:1em}td,th{border:1px solid #000;padding:.5em}th{font-weight:700;text-align:center}input{margin-bottom:10px}caption{margin-bottom:.5em;text-align:center}fieldset,legend,p,pre,table{margin-bottom:1em}input[type=password],input[type=text],textarea{width:12.25em;*width:11.9em}.row-fluid{width:100%;*zoom:1}.row-fluid:after,.row-fluid:before{display:table;content:\"\"}.row-fluid:after{clear:both}.row-fluid>[class*=span]{float:left;margin-left:4.12765957%}.row-fluid>[class*=span]:first-child{margin-left:0}.row-fluid>.span24{width:99.99999998%}.row-fluid>.span23{width:95.74468083%}.row-fluid>.span22{width:91.48936168%}.row-fluid>.span21{width:87.23404253%}.row-fluid>.span20{width:82.97872339%}.row-fluid>.span19{width:78.72340424%}.row-fluid>.span18{width:74.46808509%}.row-fluid>.span17{width:70.21276594%}.row-fluid>.span16{width:65.95744679%}.row-fluid>.span15{width:61.70212765%}.row-fluid>.span14{width:54.4468085%}.row-fluid>.span13{width:53.19148935%}.row-fluid>.span12{width:48.9361702%}.row-fluid>.span11{width:44.68085105%}.row-fluid>.span10{width:40.42553191%}.row-fluid>.span9{width:36.17021276%}.row-fluid>.span8{width:31.91489361%}.row-fluid>.span7{width:27.65957446%}.row-fluid>.span6{width:23.40425531%}.row-fluid>.span5{width:19.14893617%}.row-fluid>.span4{width:14.89361702%}.row-fluid>.span3{width:10.63829787%}.row-fluid>.span2{width:6.38297872%}.row-fluid>.span1{width:2.12765957%}.container-fluid{padding-left:20px;padding-right:20px;*zoom:1}.container-fluid:after,.container-fluid:before{display:table;content:\"\"}.container-fluid:after{clear:both}.mt10,.mt15{margin-top:10px}.pt10{padding-top:10px}.pt15{padding-top:15px}.mb10{margin-bottom:10px}.mb15{margin-bottom:15px}.pb10{padding-bottom:10px}.pb15{padding-bottom:15px}.ml10{margin-left:10px}.ml15{margin-left:15px}.pl10{padding-left:10px}.pl15{padding-left:15px}.mr10{margin-right:10px}.mr15{margin-right:15px}.pr10{padding-right:10px}.pr15{padding-right:15px}.btn{height:44px;margin-bottom:0;border:1px solid #0070ba;border-radius:5px;*margin-left:.3em;display:inline-block;*display:inline;*zoom:1;background-color:#0070ba;transition:background-color .4s ease-out 0s;font-size:1em;font-weight:700;line-height:42px;color:#fff;text-align:center;vertical-align:middle;cursor:pointer;outline:none;-webkit-font-smoothing:antialiased}.btn .btn-secondary{-webkit-font-smoothing:auto}.btn:focus,.btn:hover{background-color:#005ea6}.btn:focus{text-decoration:underline}.btn.active,.btn:active{background-color:#005ea6;outline:0}.btn.disabled,.btn[disabled]{background-color:#b2d9ea;border-color:#b2d9ea;cursor:default}.btn.firstHalf{float:left}.btn.firstHalf,.btn.secondHalf{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box}.btn.secondHalf{float:right}a.btn:focus,a.btn:hover{color:#fff}.btn:first-child{*margin-left:0}.btn-large{padding:8px 15px;font-size:18px;line-height:normal;border-radius:5px}.btn-small{padding:5px 9px;font-size:11px;line-height:16px}.btn-mini{padding:2px 6px;font-size:11px;line-height:14px}.btn-secondary{border-style:solid;border-color:#e1e7eb;color:#393f44;background-color:#e1e7eb}.btn-secondary:hover{color:#393f44;border-color:#edf2f5;background-color:#edf2f5;text-decoration:none}.btn-secondary:active,.btn-secondary:focus{border-color:#c5ccd1;background-color:#c5ccd1;text-decoration:underline}.btn-secondary.disabled,.btn-secondary[disabled]{color:#393f55}a.btn-secondary:active,a.btn-secondary:focus,a.btn-secondary:hover{color:#393f44;border-color:#c5ccd1;background-color:#c5ccd1}a.btn-secondary.disabled,a.btn-secondary[disabled]{color:#393f55;background-color:#e7edf0}button.btn,input[type=submit].btn{*padding-top:2px;*padding-bottom:2px}button.btn::-moz-focus-inner,input[type=submit].btn::-moz-focus-inner{padding:0;border:0}button.btn.btn-large,input[type=submit].btn.btn-large{*padding-top:7px;*padding-bottom:7px}button.btn.btn-small,input[type=submit].btn.btn-small{*padding-top:3px;*padding-bottom:3px}button.btn.btn-mini,input[type=submit].btn.btn-mini{*padding-top:1px;*padding-bottom:1px}#largeScreenAccountCreation .buttons #backButton,section .buttons #backButton{width:30%}#largeScreenAccountCreation .buttons #proceedButton,section .buttons #proceedButton{width:65%}#largeScreenAccountCreation .buttons #proceedButton-venmoBA,#largeScreenAccountCreation .buttons #proceedButton.full,section .buttons #proceedButton-venmoBA,section .buttons #proceedButton.full{width:100%}.custom-select-container,select.replaced{position:relative}select.replaced{z-index:8;width:100%;height:44px;border:0;line-height:2;opacity:0;filter:alpha(opacity=0)}.custom-select{position:absolute;top:0;left:0;z-index:1;width:100%;transition:border-color .3s ease 0s;border-radius:5px}.custom-select,.custom-select>span{display:block;background-clip:padding-box}.custom-select>span{padding:7px 30px 7px 13px;border:1px solid #ccd0d4;border-radius:5px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:right -7px top -1178px;color:#000;line-height:28px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.disabled .custom-select>span{background-position:right -7px top -6990px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat right 10px center;background-size:16px;color:#c72e2e;border:1px solid #c72e2e}.custom-select span span{display:block;overflow:hidden;height:28px;text-overflow:ellipsis;white-space:nowrap;font-size:1em}.custom-select.active>span{border:1px solid #009cde;outline:0}#task .custom-select{border-radius:5px;background-clip:padding-box}.mobile .dob label{position:static;top:0;left:0}input[type=date]{padding:5px 38px 3px 6px;border:1px solid #ccd0d4;border-radius:5px;background-clip:padding-box;color:#333;background-size:24px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_cart_icons.png\") no-repeat 100% 61%}input[type=date]:focus{border-color:#39f}.showDropdopwnLabels .labelText{float:left;color:#aaa}.showDropdopwnLabels .valueText{float:right;min-width:90px}@media (min-width:0) and (max-width:40em){.showDropdopwnLabels .labelText{display:none}.showDropdopwnLabels .valueText{float:none;min-width:0}}.multiline-select-container{outline:0 none}.multiline-select-container:active .innerContainer,.multiline-select-container:focus .innerContainer{border-color:#009cde}.multiline-select-container.open:active .innerContainer,.multiline-select-container.open:focus .innerContainer{border-color:#ccd0d4}.multiline-select-container option,.multiline-select-container select{position:absolute!important;left:-9999px}.multiline-select-container .custom-select{position:relative}.multiline-select-container .custom-select span span{height:auto;white-space:normal}.multiline-select-container .custom-select>span{background:none}.multiline-select-container.open .custom-select>span{border-radius:5px 5px 0 0;border-bottom-color:#eee}.multiline-select-container .arrow{background-clip:padding-box;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_forms.png\");background-position:left -8px top -1198px;background-repeat:no-repeat;height:10px;position:absolute;width:14px;top:40%;right:12px}.backendError .multiline-select-container .ng-invalid+.custom-select .arrow,.validated .multiline-select-container .ng-invalid+.custom-select .arrow{display:none}.multiline-select-list{position:absolute;list-style:none;margin:0;background-color:#fff;z-index:1000;border-radius:0 0 5px 5px;border-bottom:1px solid #ccd0d4;max-height:200px;overflow:auto;box-shadow:0 -1px 1px 0 #ccc}.multiline-select-list li{padding:10px;border:1px solid;border-color:#eee #ccd0d4;border-top:0 none;cursor:pointer;line-height:1.35em;vertical-align:middle}.multiline-select-list li:active,.multiline-select-list li:focus,.multiline-select-list li:hover{background-color:#e5f5fc;outline:0 none}.multiline-select-list li:first-of-type{border-top:0 none}.multiline-select-list li:last-of-type{border-bottom:0 none}.multiline-select-list:hover li:focus{background-color:#fff}.multiline-select-list:hover li:focus:active,.multiline-select-list:hover li:focus:hover{background-color:#e5f5fc}#midflash,.accessAid{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}body{-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#fff}a{text-decoration:none;-webkit-tap-highlight-color:rgba(0,0,0,.2)}a:focus,a:hover{color:#005ea6;text-decoration:underline;outline:none}a.dashed{text-decoration:none;border-bottom:1px dashed #0070ba;font-size:.9em}[tabindex=\"-1\"]{outline:none}em{font-style:normal;font-weight:700}fieldset{margin:0;padding:0;border:0}fieldset legend{padding-bottom:.5em;font-size:1.5em}section:focus{outline:none}.show-section{display:block}hr.faded{width:100%;height:1px;margin:10px 0;border:0;background-image:-o-linear-gradient(left,transparent,rgba(0,0,0,.75),transparent)}.alpha{font-size:1.5em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin:.5em 0;line-height:1.154em}#loginSection h1.alpha{max-width:240px}.asideAlpha{font-size:1.44em}aside .aside .header.noButtons .walletHeading{text-align:center;line-height:1.05em}.beta{font-size:1.54em;color:#2c2e2f;font-weight:lighter;line-height:1.2em}.gamma{font-size:1.3em}.gamma,.zeta{font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin-bottom:.75em}.zeta{font-size:1.25em}.delta{font-size:1.1em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;margin-bottom:12px;font-weight:400}.vprop-header{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin:10px 0;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.vprop-content,.vprop-header{color:#2c2e2f;font-weight:lighter;line-height:1.2em}.vprop-content{font-size:1em;font-family:HelveticaNeue,helvetica,arial,sans-serif}.vprop-image{margin-top:25px}.eta{font-size:1.1em}.eta,.theta{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400}.theta{font-size:1em}.value-prop-title{color:#2c2e2f;font-size:24px;font-weight:lighter;margin:10px 0}.props{padding:0 0 0 5px;clear:both;text-align:center}.props li,.props p{line-height:1.154em;font-size:.9em;font-weight:400;line-height:1.2em;margin:5px 0}.secondary{color:#6c7378;font-size:.85em}.legal{color:#6c7378;font-size:.75em;line-height:1.154em}.legal a{font-weight:700}.mu{font-size:2.46em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-weight:400;text-shadow:0 1px 0 #fff;color:#0079c1}.noHead{margin-top:0}.noBottom{margin-bottom:0}.showTray #task{overflow:hidden;margin-left:0}#spinner,.hide{display:none}.clearfix,.loading #spinner,.media .img img,html[xmlns] .clearfix{display:block}#billingToggleLink{display:inline-block}.left{float:left}.right{float:right}.center{text-align:center}.outerWrapper{position:relative;border-radius:5px;background-clip:padding-box;background-color:#fff}header{z-index:2}.framed #wrapper,html.framed{border-radius:5px;background-clip:padding-box}html.framed .trayOpen #main{height:585px}html.framed .trayOpen .asideContent{height:495px}body>iframe,body>img{display:none}#wrapper{margin:0 auto;max-width:780px;border:1px solid #e3e3e3;border-radius:5px;overflow-y:visible;outline:none}#wrapper,#wrapper #header{-ms-box-sizing:border-box;box-sizing:border-box;background-clip:padding-box;position:relative;background-color:#fff}#wrapper #header{border-radius:5px 5px 0 0;width:100%;z-index:4;box-shadow:0 0 3px 0}#contents{position:relative;z-index:1}.active #wrapper{visibility:visible;-webkit-animation-duration:.4s;-webkit-animation-timing-function:ease;-webkit-animation-name:slideUp}#logo{margin:22px 0 0 20px}.container{clear:both;padding:20px}.containerNoHead{padding-top:0}.noPaddingBottom{padding-bottom:0}.noPaddingTop{padding-top:0}.subContainer{border-top:1px solid #e3e3e3;padding:20px 0;position:relative}#proceedButton{width:46.4%;-ms-box-sizing:border-box;box-sizing:border-box;float:right}#proceedButton.full{width:100%}#proceedButton:focus{color:#fff}#backButton{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box;float:left}#backButton:focus,#backButton:hover{color:#2c2e2f}.middleName{display:none;float:right}.h2,h2{font-size:1.2em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin-top:0;font-weight:400;color:#0666b3}.clearfix:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}* html .clearfix{height:1%}#sliding-area{overflow:hidden}#main{padding:25px 30px 15px;transition:margin .3s ease-out;width:100%;float:right;-ms-box-sizing:border-box;box-sizing:border-box}.loading #main{background:none}.bmlLoadingMessage,.loginLoadingMessage,.loginProcessing .genericLoadingMessage{display:none}.loginProcessing .loginLoadingMessage{display:block}.full{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;text-decoration:none}.trayInner{padding:20px 0}.disclaimer{font-size:.75em;color:#6c7378}.reviewMsg{margin-top:10px;line-height:1.5}.infoTxt{clear:both;padding-top:10px}.help{color:#a9a9a9}.keyValue label{color:#292929}.frontArrow{position:absolute;display:inline-block;width:9px;height:15px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-196px -177px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.frontArrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.focusableIcon:focus{box-shadow:0 0 1px #6c7378}input[type=button],input[type=submit]{-webkit-appearance:none}.inputField input[disabled=disabled],.inputField input[disabled=disabled]:active,input[disabled=disabled]{background:#f7f9fa;border:1px solid #cbd2d6;color:#6c7378}input::-ms-clear{display:none}input.link:hover{cursor:pointer}input.xsmall{width:2em}input.small{width:3.35em;font-size:1em}input.medium{width:7em}input.large{width:14em}input.xlarge{width:20em}.button-as-link{margin:0;padding:0;border:none;width:auto;font-size:.85em;background:transparent;color:#0070ba;cursor:pointer}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.buttons{margin-top:15px;margin-bottom:15px;overflow:hidden}.inputField{position:relative}.inputField input,.inputField label{display:block;vertical-align:top}.ignoreValidation .inputField.error input,.inputField input,.validated .ignoreValidation .inputField input.backendError,.validated .ignoreValidation .inputField input.ng-invalid{width:100%;height:44px;padding:0 14px;border-radius:5px;background-clip:padding-box;border:1px solid #c5ccd1;color:#000;transition:border-color .3s ease 0s;-ms-box-sizing:border-box;box-sizing:border-box;background:none}.ignoreValidation .inputField.error input::-webkit-input-placeholder,.inputField input::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.backendError::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-webkit-input-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-moz-placeholder,.ignoreValidation .inputField.error input::-moz-placeholder,.inputField input:-moz-placeholder,.inputField input::-moz-placeholder,.validated .ignoreValidation .inputField input.backendError:-moz-placeholder,.validated .ignoreValidation .inputField input.backendError::-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-moz-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-ms-input-placeholder,.inputField input:-ms-input-placeholder,.validated .ignoreValidation .inputField input.backendError:-ms-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-ms-input-placeholder{color:#6c7378}.inputField input:active,.inputField input:focus{border:1px solid #009cde;outline:0}.inputField select{font-size:1.5em;margin-bottom:10px}.custom-select-container select{font-size:15px}.inputField label{position:absolute;top:14px;left:14px;cursor:text;text-align:left;color:#666;font-size:1em}.no-js .dropdown label,.no-js .inputField label{position:static}.fieldGroup .inputField{float:left;padding:0 .5em 0 0}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.inputField.error input::-webkit-input-placeholder,.validated .inputField input.backendError::-webkit-input-placeholder,.validated .inputField input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.inputField.error input:-moz-placeholder,.inputField.error input::-moz-placeholder,.validated .inputField input.backendError:-moz-placeholder,.validated .inputField input.backendError::-moz-placeholder,.validated .inputField input.ng-invalid:-moz-placeholder,.validated .inputField input.ng-invalid::-moz-placeholder{color:#c72e2e}.inputField.error input:-ms-input-placeholder,.validated .inputField input.backendError:-ms-input-placeholder,.validated .inputField input.ng-invalid:-ms-input-placeholder{color:#c72e2e}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}.inputField.valid input{background:#fff url(https://www.paypalobjects.com/images/checkout/hermes/icon_checkmark_wallet_2x.png) no-repeat 98%;background-size:14px}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.creditCardField.valid input{background:#fff}.dropdown.error select,.inputField.error select{border:1px solid #c72e2e}.selectLabel{display:block}input::-webkit-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:1em}input:-moz-placeholder,input::-moz-placeholder{color:#6c7378;opacity:1;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}input:-ms-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.checkbox input[type=checkbox]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.checkbox input[type=checkbox]~label,.checkbox input[type=checkbox]~label.bgImgOnSpan span.bgImg{display:inline-block;position:static;min-height:25px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px 0;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.checkbox input[type=checkbox]~label,.checkbox input[type=checkbox]~label.bgImgOnSpan span.bgImg{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.checkbox input[type=checkbox]~label.bgImgOnSpan span.bgImg{display:block;float:left;width:0;height:25px;margin-left:-35px}.checkbox input[type=checkbox]~label.bgImgOnSpan{background-image:none}.checkbox.error input[type=checkbox]:focus~label,.checkbox.error input[type=checkbox]:focus~label.bgImgOnSpan span.bgImg,.checkbox.error input[type=checkbox]~label,.checkbox.error input[type=checkbox]~label.bgImgOnSpan span.bgImg{background-position:-9px -600px}.checkbox input[type=checkbox]:checked~label,.checkbox input[type=checkbox]:checked~label.bgImgOnSpan span.bgImg{background-position:-9px -400px}.checkbox input[type=checkbox]:focus:checked~label,.checkbox input[type=checkbox]:focus:checked~label.bgImgOnSpan span.bgImg{background-position:-9px -4801px}.checkbox input[type=checkbox]:focus~label,.checkbox input[type=checkbox]:focus~label.bgImgOnSpan span.bgImg{background-position:-9px -4601px}.checkbox input[type=checkbox][disabled=disabled]~label,.checkbox input[type=checkbox][disabled=disabled]~label.bgImgOnSpan span.bgImg{background-position:-9px -800px}.checkbox input[type=checkbox][disabled=disabled]:checked~label,.checkbox input[type=checkbox][disabled=disabled]:checked~label.bgImgOnSpan span.bgImg{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:25px 25px}.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label.bgImgOnSpan span.bgImg,.validated .ignoreValidation input[type=checkbox].ng-invalid~label,.validated .ignoreValidation input[type=checkbox].ng-invalid~label.bgImgOnSpan span.bgImg{background-position:-9px 0}.validated .ignoreValidation .sCheckbox.checkbox input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation .sCheckbox.checkbox input[type=checkbox].ng-invalid:focus~label.bgImgOnSpan span.bgImg,.validated .ignoreValidation .sCheckbox.checkbox input[type=checkbox].ng-invalid~label,.validated .ignoreValidation .sCheckbox.checkbox input[type=checkbox].ng-invalid~label.bgImgOnSpan span.bgImg{background-position:-9px 2600px}.validated input[type=checkbox].ng-invalid~label,.validated input[type=checkbox].ng-invalid~label.bgImgOnSpan span.bgImg{background-position:-9px -600px}.validated input[type=radio].ng-invalid+label,.validated input[type=radio].ng-invalid+label.bgImgOnSpan span.bgImg,.validated input[type=radio].ng-invalid:focus+label,.validated input[type=radio].ng-invalid:focus+label.bgImgOnSpan span.bgImg{background-position:-10px -2200px}.validated .sCheckbox.checkbox input[type=checkbox].ng-invalid~label,.validated .sCheckbox.checkbox input[type=checkbox].ng-invalid~label.bgImgOnSpan span.bgImg{background-position:-9px -3200px}.sCheckbox.checkbox{position:relative}.sCheckbox.checkbox input[type=checkbox]~label,.sCheckbox.checkbox input[type=checkbox]~label.bgImgOnSpan span.bgImg{line-height:19px;padding-left:27px;font-size:.85em;background-position:-9px -2600px}.sCheckbox.checkbox input[type=checkbox]~label.bgImgOnSpan span.bgImg{display:block;float:left;width:0;height:19px;margin-left:-27px}.sCheckbox.checkbox input[type=checkbox]~label.bgImgOnSpan{background-image:none}.sCheckbox.checkbox.error input[type=checkbox]:focus~label,.sCheckbox.checkbox.error input[type=checkbox]:focus~label.bgImgOnSpan span.bgImg,.sCheckbox.checkbox.error input[type=checkbox]~label,.sCheckbox.checkbox.error input[type=checkbox]~label.bgImgOnSpan span.bgImg{background-position:-9px -3200px}.sCheckbox.checkbox input[type=checkbox]:checked~label,.sCheckbox.checkbox input[type=checkbox]:checked~label.bgImgOnSpan span.bgImg{background-position:-9px -3000px}.sCheckbox.checkbox input[type=checkbox]:focus:checked~label,.sCheckbox.checkbox input[type=checkbox]:focus:checked~label.bgImgOnSpan span.bgImg{background-position:-9px -5409px}.sCheckbox.checkbox input[type=checkbox]:focus~label,.sCheckbox.checkbox input[type=checkbox]:focus~label.bgImgOnSpan span.bgImg{background-position:-9px -2800px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]~label,.sCheckbox.checkbox input[type=checkbox][disabled=disabled]~label.bgImgOnSpan span.bgImg{background-position:-9px -3400px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]:checked~label,.sCheckbox.checkbox input[type=checkbox][disabled=disabled]:checked~label.bgImgOnSpan span.bgImg{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:18px 19px}.radioButton input[type=radio]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.radioButton input[type=radio]~label{display:inline-block;min-height:26px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px -1600px;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.radioButton input[type=radio]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.radioButton.error input[type=radio]+label,.radioButton.error input[type=radio]:focus+label{background-position:-9px -2200px}.radioButton.warning input[type=radio]+label,.radioButton.warning input[type=radio]:focus+label{background-position:-9px -7405px}.radioButton input[type=radio]:checked+label{background-position:-9px -2000px}.radioButton input[type=radio]:focus:checked+label{background-position:-9px -6010px}.radioButton input[type=radio]:focus+label{background-position:-9px -1800px}.inputField label.nolap{position:relative;top:auto;left:auto;color:#2c2e2f}.inputField.half{width:48.15%;margin-right:3.7%;padding-right:0}.multistepSignupForm .inputField.half,.singlePagePaymentForm .inputField.half{width:48.7%;margin-right:2.6%;padding-right:0}.inputField.half.issueNo{width:42%;margin-top:15px}.inputField.half.startDate{width:54%;margin-right:10px}#cardIssueInfo .inputField.half.startDate{width:48%;margin-right:0}#cardIssueInfo .inputField.half.issueNo{width:48%;margin-top:0;float:right}#cardIssueInfo .inputField.half.issueNo:before{content:\"\\200C\"}.inputField.half.last-child{margin-right:0}.fieldGroup .inputField.last-child{padding-right:0}.fidobDay{width:30%;float:left}.fidobDay .custom-select>span{border-radius:5px 0 0 5px;border-right:0}.fidobMonth{width:30%;float:left}.fidobMonth .custom-select>span{border-radius:0}.fidobYear{width:40%;float:left}.fidobYear .custom-select>span{border-radius:0 5px 5px 0;border-left:0}.cardDOB{width:100%;clear:both}.dobLabel{top:auto;left:auto;position:relative;display:block;bottom:4px}.dobTXT{margin-top:10px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}}.submitted input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.submitted input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.submitted input.ng-invalid:-moz-placeholder,.submitted input.ng-invalid::-moz-placeholder{color:#c72e2e}.submitted input.ng-invalid:-ms-input-placeholder{color:#c72e2e}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.submitted input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}.merchantHeader{height:90px;margin:0 auto}.merchantHeader .headerWrapper{max-width:780px;margin:0 auto;overflow:hidden;max-height:90px;line-height:90px}.merchantHeader .merchantName{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400;width:575px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block}.merchantHeader img{vertical-align:middle}.paypalHeaderWrapper .logo{float:left;width:112px;height:29px;margin-top:5px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.paypalHeaderWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.paypalHeaderWrapper .span14{padding-bottom:20px;border-bottom:1px solid #dbdbdb}.paypalHeaderWrapper .cartContainer{position:static;line-height:29px}.paypalHeaderWrapper .transctionCartDetails{z-index:2}.paypalHeaderWrapper.paypalCredit .logo{height:35px;background-position:0 -129px}.aside .header{padding:15px;vertical-align:middle;line-height:50px;border-bottom:1px solid #e3e3e3}.aside .header.tall{min-height:65px;line-height:normal;padding:13px 15px 10px;margin-bottom:0}.aside .asideAlpha{padding:0 30px;text-align:center;line-height:1.2em}.aside .walletHeading{text-align:center}.aside .close{top:10px;right:15px;padding:5px;border-radius:3px}.aside .close,.aside .close:before{position:absolute;width:19px;height:19px}.aside .close:before{content:\"\";display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .close:focus:before,.aside .close:hover:before{background-position:-223px -22px}.aside .backArrow{position:absolute;top:10px;left:15px;width:9px;height:18px;padding:5px;border-radius:3px}.aside .backArrow:before{content:\"\";display:inline-block;position:absolute;width:9px;height:18px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -46px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .backArrow:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .backArrow:focus:before,.aside .backArrow:hover:before{background-position:-232px -68px}.aside .addOptions{margin-top:20px}.aside .addOptions h2{float:left;width:70%;margin-bottom:0}.aside .addOptions a{float:right;display:block;line-height:1.9em;font-size:.85em}.aside .subHeader{margin-top:20px}.CYCOPage .paypalHeader.span14,.pageSepaAgreementContingency .paypalHeader.span14,.pageSepaMandate .paypalHeader.span14,.pageSepaMandateContingency .paypalHeader.span14{width:100%}#mobileMerchantHeader{display:none}@media (max-width:41.3125em){.merchantHeader{display:none}.paypalHeaderWrapper{height:65px}.paypalHeaderWrapper .cartContainer{margin-top:10px;margin-bottom:-5px;margin-right:15px}.paypalHeaderWrapper .logo{margin:15px 0 0 30px}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}}@media (max-width:30em) and (min-width:0){.paypalHeaderWrapper .cartContainer{margin-top:15px;margin-bottom:-10px;margin-right:0}.paypalHeaderWrapper .logo{margin:15px 0 0}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}.header{height:55px}.aside .header{height:auto}.aside .close{right:15px}}.footer{max-width:780px;margin:10px auto;font-size:.75em}.cancelUrl{float:left;width:39%}.micaLender{display:none;color:#2c2e2f;clear:both}.footerWrapper table{display:inline;float:left;table-layout:fixed;border:none;width:75%}.footerWrapper td,.footerWrapper th,.footerWrapper tr{border:none;font-weight:400;padding-bottom:0;padding-top:0;text-align:left}.footerWrapper .footerLinks th{color:#6c7378}.footerWrapper .footerLinks th.feedbackLink{color:#0070ba}.footerWrapper .footerLinks .underline th{border-bottom:1px solid #ccc}.footerLinks{margin:0;display:inline-block}.footerLinks a{color:#6c7378}.footerLinks a.feedbackLink{color:#0070ba;margin-left:5px}.footerLinks th,td{border:none}.copyright{display:inline;width:auto;vertical-align:top;color:#6c7378}.secureIcon{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:0 -33px;margin-left:3px;margin-right:3px;margin-top:3px;width:10px;height:12px;vertical-align:top}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.secureIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.poweredBy{float:right;margin-top:-49px}.poweredBy .text{float:left;margin-top:8px;margin-right:8px;font-size:12px;font-weight:400;font-style:italic;color:#6c7378}.footerLinks li{padding:0 12px 0 0;display:inline-block}.footerLinks .last{padding-right:18px;border-right:none}.footer .policyInfoWrapper p{line-height:1.3em}.footer .policyInfoWrapper p a{font-weight:700}.minibrowser .APAC.footer,.minibrowser.AU .footer{position:relative;bottom:0;width:auto}.minibrowser .APAC.footer .policyInfoWrapper,.minibrowser.AU .footer .policyInfoWrapper{padding:0}.minibrowser .cancelUrl{display:none}.minibrowser .footerWrapper{padding:0 10px;float:none;width:95%;margin:0}.minibrowser .footerLinks li{padding:0 5px 0 0}.DE .footerWrapper,.fr.CA .footerWrapper,.fr.FR .footerWrapper{float:none;width:auto}.DE .footerWrapper:after,.fr.CA .footerWrapper:after,.fr.FR .footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.DE .footerLinks,.fr.CA .footerLinks,.fr.FR .footerLinks{float:left;width:70%;text-align:left}.DE .footerLinks li:first-child,.fr.CA .footerLinks li:first-child,.fr.FR .footerLinks li:first-child{padding-left:0}.DE .copyright,.fr.CA .copyright,.fr.FR .copyright{float:right;width:30%;margin:0}.DE .cancelUrl,.fr.CA .cancelUrl,.fr.FR .cancelUrl{float:none;margin:5px 0;width:100%}.APAC .policyInfoWrapper{padding:5px 0 10px;color:#6c7378}.APAC .policyInfoWrapper p.moreInfo{padding:15px 0 20px;float:left;line-height:1.3em}.AU .policyInfoWrapper,.en_AU .policyInfoWrapper{padding:20px 0 10px;color:#6c7378}.AU .policyInfoWrapper p.moreInfo,.en_AU .policyInfoWrapper p.moreInfo{padding:15px 0 20px;border-bottom:1px solid #ccc;float:left}.AU .policyInfoWrapper p.moreCopyRight,.en_AU .policyInfoWrapper p.moreCopyRight{padding:5px 0 0;clear:both}.fr_XC .footerWrapper{float:left;width:70%;text-align:left;padding-left:0;margin-left:-7px}@media (max-width:41.25em){.footer{border-top:1px solid #ccc;padding:5px 20px;margin-top:10px}.footer .policyInfoWrapper{padding:0 10px}.footerWrapper{float:none;width:100%;padding:0;margin:0}.footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.cancelUrl{width:95%;padding:0}.footerLinks{float:left;width:70%;text-align:left}.footerLinks .feedback{display:none}.minibrowser .footerLinks .feedback{display:inline-block}.copyright{width:20%}.cancelUrl{float:none;margin:5px 0}}@media (max-width:30em) and (min-width:0){.footer{margin-top:0;padding:5px 10px}.footer .policyInfoWrapper{padding:0}.cancelUrl,.footerWrapper{padding:0;margin:5px 0;width:100%}.DE .footerLinks,.footerLinks,.fr.FR .footerLinks{width:65%}.DE .footerLinks li,.footerLinks li,.fr.FR .footerLinks li{padding:0;margin-right:10px}.DE .footerLinks li.last,.footerLinks li.last,.fr.FR .footerLinks li.last{margin-right:0}.DE .footerLinks .feedback,.footerLinks .feedback,.fr.FR .footerLinks .feedback{display:none}.copyright,.DE .copyright{width:33%;margin:0}.minibrowser .copyright{margin-right:0;width:30%}.minibrowser .footerLinks .feedback{display:inline-block}}.modal-open{overflow:hidden}.modal-open #contents,.modal-open #wrapper,.modal-open .outerWrapper{position:static}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:140;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop,.modal-backdrop.fade.in{opacity:.54}.modal{display:none;overflow:auto;overflow-y:scroll;position:fixed;top:0;right:0;bottom:0;left:0;z-index:150}.modal.fade .modal-wrap{-webkit-transform:translateY(-25%);transform:translateY(-25%);transition:transform .3s ease-out}.modal.fade.in .modal-wrap{-webkit-transform:translate(0);transform:translate(0)}.modal-wrap{position:relative;margin:10px;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.3);border-radius:6px;background-clip:padding-box;box-shadow:0 3px 9px rgba(0,0,0,.3);outline:none}.modal-header{padding:9px 15px;border-bottom:1px solid #eee}.modal-header .close{margin-top:2px}.modal-header h3{margin:0;line-height:30px}.modal-body{position:relative;overflow-y:auto;max-height:400px;padding:15px}.modal-footer,.modal-form{margin-bottom:0}.modal-footer{padding:14px 15px 15px;text-align:right;background-color:#f5f5f5;border-top:1px solid #ddd;border-radius:0 0 6px 6px;background-clip:padding-box;box-shadow:inset 0 1px 0 #fff}.modal-footer:after,.modal-footer:before{display:table;content:\"\";line-height:0}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.spinner{height:100%;width:100%;position:absolute;z-index:10}.spinner .spinWrap{width:200px;height:100px;position:absolute;top:50%;left:50%;margin-left:-100px;margin-top:-50px}.spinner .spinnerImage{margin:28px 0 0 -25px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/icon_ot_spin_lock_skinny.png\") no-repeat}.spinner .loader,.spinner .spinnerImage{height:100px;width:100px;position:absolute;top:0;left:50%;opacity:1;filter:alpha(opacity=100)}.spinner .loader{margin:0 0 0 -55px;background-color:transparent;-webkit-animation:rotation .7s infinite linear;animation:rotation .7s infinite linear;border-left:5px solid #cbcbca;border-right:5px solid #cbcbca;border-bottom:5px solid #cbcbca;border-top:5px solid #2380be;border-radius:100%}.spinner .bmlLoadingMessage,.spinner .genericLoadingMessage,.spinner .loginLoadingMessage{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;margin-top:125px;text-align:center;z-index:100}.spinner.preloader{position:fixed;top:0;left:0;z-index:1000;background-color:#fff}@-webkit-keyframes rotation{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(359deg)}}@keyframes rotation{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.aside{min-height:380px}.aside .container{padding:15px}.asideContent{height:100%}.centerText{text-align:center}.fsIcons{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;min-width:32px;width:25px;height:21px;padding-right:5px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.BALANCE .fsIcons,.DELAYED_TRANSFER .fsIcons,.HOLDING .fsIcons{background-position:0 0}.ELO .fsIcons{background-position:0 -479px}.HIPER .fsIcons{background-position:0 -458px}.HIPERCARD .fsIcons{background-position:0 -500px}.pinlessGlyphIcon{display:inline-block;position:relative;top:-5px;left:-8px;width:32px;height:20px;font-size:3.1rem;padding-right:5px}.BANK .fsIcons,.BANK_ACCOUNT .fsIcons,.IACH .fsIcons{background-position:0 -252px;height:19px;left:19px}.ECHECK .fsIcons,.ELV .fsIcons,.TAB.DELAYED_TRANSFER .fsIcons{background-position:0 -252px;height:19px}.TAB.DELAYED_TRANSFER .fsIcons{left:19px}.BILL_ME_LATER .fsIcons,.BML .fsIcons,.CREDIT_OPTION .fsIcons,.PPCREDIT .fsIcons{background-position:0 -105px}.PAYPAL_SMART_CONNECT .fsIcons{background-position:0 0}.VISA .fsIcons{background-position:0 -21px}.MASTERCARD .fsIcons{background-position:0 -42px}.AMEX .fsIcons{background-position:0 -63px;left:19px;height:20px}.DISC .fsIcons,.DISCOVER .fsIcons{background-position:0 -84px}.JCB .fsIcons{background-position:0 -353px}.CHINA_UNION_PAY .fsIcons{background-position:0 -563px}.ELECTRON .fsIcons{background-position:0 -146px}.MAESTRO .fsIcons,.MSTRO .fsIcons,.SWITCH .fsIcons{background-position:0 -168px}.CB_NATIONALE .fsIcons,.CBN .fsIcons{background-position:0 -210px}.CELEM .fsIcons,.CETELEM .fsIcons{background-position:0 -311px}.COFINOGA .fsIcons,.CONF .fsIcons{background-position:0 -231px}.COFID .fsIcons,.COFIDIS .fsIcons{background-position:0 -437px;left:20px}.INCENTIVE .fsIcons{background-position:0 -271px;height:18px}.PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -374px}.PPSMTCONNECT .fsIcons{background-position:0 0}.ES .PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -521px}.fsIcon{display:block;position:absolute;width:25px;height:21px;left:15px;top:20px;min-width:32px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;background-position:0 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.fsIcon.BANK,.fsIcon.PAD{background-position:6px -252px;height:19px;left:19px}.fsIcon.MASTER,.fsIcon.MASTERCARD,.fsIcon.MCARD{background-position:0 -42px}.fsIcon.ELO{background-position:0 -479px}.fsIcon.HIPER{background-position:0 -458px}.fsIcon.HIPERCARD{background-position:0 -500px}.fsIcon.DISC,.fsIcon.DISCOVER{background-position:0 -84px}.fsIcon.VISA{background-position:0 -21px}.fsIcon.JCB{background-position:0 -353px}.fsIcon.AMEX,.fsIcon.Amex{background-position:6px -63px;left:19px;height:20px}.fsIcon.MAESTRO,.fsIcon.MSTRO,.fsIcon.SWITCH{background-position:0 -168px}.fsIcon.PAYPAL_SMART_CONNECT{background-position:0 0}.fsIcon.CB_NATIONALE,.fsIcon.CBN{background-position:0 -210px}.fsIcon.CELEM,.fsIcon.CETELEM{background-position:0 -311px}.fsIcon.COFID,.fsIcon.COFIDIS{background-position:0 -437px;left:20px;height:20px}.fsIcon.CHINA_UNION_PAY,.fsIcon.CUP{background-position:0 -563px}.fsIcon.COFINOGA,.fsIcon.CONF{background-position:0 -231px}.fsIcon.PAYPAL_EXTRAS_MASTERCARD,.fsIcon.PPXMCARD{background-position:0 -374px}.fsIcon.EBAY_MASTERCARD,.fsIcon.EBAYMCARD{background-position:0 0}.fsIcon.BILL_ME_LATER,.fsIcon .BML,.fsIcon .PPCREDIT{background-position:0 -105px}.fsIcon.PPSMTCONNECT{background-position:0 0}.fsIcon.pinlessIcon{background-image:none;font-size:3.1rem;left:5px;top:14px}.ES .fsIcon.PAYPAL_EXTRAS_MASTERCARD,.ES .fsIcon.PPXMCARD{background-position:0 -521px}.infoIcon{width:19px;height:18px;display:inline-block;position:absolute;top:25px;right:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-89px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.infoIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.addOption{padding:25px 10px;margin:0 0 0 44px;color:#0070ba;font-size:.85em}.plusicon{display:block;position:absolute;left:15px;top:22px;width:20px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.plusicon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.infoIcon+.checkIcon{display:none}.infoMsg{margin:0;overflow:hidden;font-size:.85em}.expiredIcon{background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%;width:16px;height:16px;top:6px}.expiredIcon,.plccIcon{display:inline-block;position:relative}.plccIcon{float:left;height:20px;background:none;width:32px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.fsIcon,.fsIcons{height:20px}}.walletIcons{position:absolute;width:30px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.walletIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons_2x.png\");background-size:90px 970px}}.walletIcons.BANK,.walletIcons.BANK_ACCOUNT{background-position:-50px -460px}.walletIcons.BANK.BOFA,.walletIcons.BANK_ACCOUNT.BOFA{background-position:-50px -10px}.walletIcons.BANK.CHASE,.walletIcons.BANK_ACCOUNT.CHASE{background-position:-50px -130px}.walletIcons.BANK.WELLSFARGO,.walletIcons.BANK_ACCOUNT.WELLSFARGO{background-position:-50px -100px}.walletIcons.BANK.CITI,.walletIcons.BANK_ACCOUNT.CITI{background-position:-50px -40px}.walletIcons.BANK.FIFTHTHIRD,.walletIcons.BANK_ACCOUNT.FIFTHTHIRD{background-position:-50px -220px}.walletIcons.BANK.CAPITAL,.walletIcons.BANK_ACCOUNT.CAPITAL{background-position:-50px -70px}.walletIcons.BANK.AMERITRADE,.walletIcons.BANK_ACCOUNT.AMERITRADE{background-position:-50px -160px}.walletIcons.BANK.SUNTRUST,.walletIcons.BANK_ACCOUNT.SUNTRUST{background-position:-50px -280px}.walletIcons.BANK.USBANK,.walletIcons.BANK_ACCOUNT.USBANK{background-position:-50px -310px}.walletIcons.BANK.USAA,.walletIcons.BANK_ACCOUNT.USAA{background-position:-50px -250px}.walletIcons.CARD.VISA,.walletIcons.PAYMENT_CARD.VISA{background-position:-10px -40px}.walletIcons.CARD.MASTER,.walletIcons.CARD.MASTERCARD,.walletIcons.PAYMENT_CARD.MASTER,.walletIcons.PAYMENT_CARD.MASTERCARD{background-position:-10px -70px}.walletIcons.CARD.DISCOVER,.walletIcons.PAYMENT_CARD.DISCOVER{background-position:-10px -100px}.walletIcons.CARD.AMEX,.walletIcons.PAYMENT_CARD.AMEX{background-position:-10px -130px}hr.sep,hr.sepPlain{padding:0;margin-top:25px;height:auto;border:none;border-top:1px solid #ccc;color:#2c2e2f;text-align:center;overflow:visible}hr.sep:after,hr.sepPlain:after{content:\"or\";display:inline-block;position:relative;top:-.7em;font-size:1em;padding:0 .5em;background:#fff;color:#6c7378;font-weight:400}.de hr.sep:after{content:\"oder\"}.da hr.sep:after{content:\"eller\"}.es hr.sep:after{content:\"o\"}.fr hr.sep:after{content:\"ou\"}.he hr.sep:after{content:\"\\5D0\\5D5\"}.id hr.sep:after{content:\"Atau\"}.it hr.sep:after{content:\"oppure\"}.ja hr.sep:after{content:\"\\307E\\305F\\306F\"}.ko hr.sep:after{content:\"\\B610\\B294\"}.nl hr.sep:after{content:\"of\"}.no hr.sep:after{content:\"eller\"}.pl hr.sep:after{content:\"lub\"}.pt hr.sep:after{content:\"ou\"}.ru hr.sep:after{content:\"\\418\\43B\\438\"}.sv hr.sep:after{content:\"eller\"}.th hr.sep:after{content:\"\\E2B\\E23\\E37\\E2D\"}.tr hr.sep:after{content:\"Veya\"}.zh hr.sep:after{content:\"\\6216\"}hr.sepPlain:after{content:\"\"}@media (min-width:0) and (max-width:23em){#loginSection .xoTitle h1{max-width:10em}}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){body{-webkit-text-size-adjust:100%}.merchantBrand{display:none}.outerWrapper{background-position:left 50px}.centerTray.loginSignup{margin-bottom:60px}#main{padding:0;background:none;z-index:2}#contents{padding:0 20px;-ms-box-sizing:border-box;box-sizing:border-box}.tokenization #contents{padding:0 30px}.paypalHeader{padding:0 20px 20px;-ms-box-sizing:border-box;box-sizing:border-box}.props,header{display:none}.review #wrapper{min-height:512px}#contents{min-height:0;margin-bottom:0}.bmlAppProcessing,.loginProcessing{background-color:#f9f9f9}.loggingIn{margin:0 25px}.mobile .loggingIn{margin:0}.saferEasier,.simpler{display:none}#login .row-fluid{padding-top:0}#login .centerTray{padding:0}#login #signupLink.btn{margin:5px 0}#wrapper{margin:0;width:auto;border-radius:0;background-clip:padding-box;border:none}#task{width:295px}.loading .spinner{background-position-y:35%}.centerTray{width:auto}.accountTerms .tray .inner,.tray .inner{padding:10px}.row-fluid>[class*=span],.signup{width:100%;margin-left:0;float:none}#notifications{width:100%}.delta,.gamma{font-size:1.2em}.inputField label{left:7px;top:13px}.saferEasier{display:none}#fundingInstruments .buttons{height:40px}.cityState select{font-size:14px}.cityState .city{width:100%}.cityState .state{width:55%}.cityState .postalCode{width:40.8%}#tab{margin-top:0;height:125px}.toolTip.whatsthis ul{width:242px;left:9px}.toolTip.whatsthis ul li{font-size:.9em}#expiration.varB .expires{width:49%}#expiration .inputField{padding:0}#expiration .cvc{width:44%;float:right}#expiration.varB .cvc{width:49%}.month{margin-left:46px}.separator{margin-left:5px;margin-top:3px}.year{margin-left:0}#expiration .cardIcon{position:absolute;right:4px}.details{margin-right:2px}.mask #closeButton,.mask #header{display:none}}@media (min-width:30.0625em) and (max-width:41.25em){#notifications,.row-fluid>.span10,.row-fluid>.span12,.row-fluid>.span14{width:100%}.outerWrapper{background-position:left 59px}.props,header{display:none}#wrapper{margin:0;border:none}#main{padding:0}#contents{padding:0 25px}}@media (min-width:41.3125em){.banner{display:block}#wrapper{min-height:0}#wrapper,.footer,.merchantHeader{width:95%}.largeScreen .centerTray{margin-top:0}.signup{margin-bottom:0}#genericError{min-height:375px;background:url(https://www.paypalobjects.com/images/checkout/hermes/scr_cloud_balloon.png) no-repeat bottom}#transactionDetails .merchantName{display:none}}@media (device-height:568px) and (-webkit-min-device-pixel-ratio:2){#contents{min-height:0;margin-bottom:0}.pageLanding #contents{margin:70px auto 40px 0}}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.cardType{display:none}ul.validations li.restriction.active{background:url(https://www.paypalobjects.com/images/checkout/hermes/close3_2x.png) no-repeat 0 2px;background-size:10px}.inputField.error input{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.inputField.error input,.inputField.valid input{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.error .custom-select.active>span,.error .custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}@media only screen and (-webkit-min-device-pixel-ratio:2) and (min-width:41.3125em){#genericError{background-size:640px 242px}}@media (min-width:41.3125em){section#genericError .container{width:400px}.genericError.footerWrapper{float:none;width:99.4%;padding:0 3px}.genericError.footerWrapper .footerLinks{float:left;width:70%;text-align:left}}section#genericError{height:450px;background:none}section#genericError .container{position:relative;margin:0 auto;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}section#genericError .title{font-size:1.5em;margin-bottom:15px;line-height:1.2}section#genericError .message{font-size:1em;margin-bottom:15px;color:#7b8388}section#genericError .secondaryMessage{color:#979797;line-height:20px}section#genericError .logo{width:112px;height:29px;margin:5px 0 20px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){section#genericError .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}section#genericError .cancelLink{margin-top:20px}section#genericError .logoutLink{margin-top:20px;font-weight:400;text-align:center;font-size:.86666667em}section#genericError .logoutLink:focus,section#genericError .logoutLink:hover{text-decoration:underline}section#genericError .full{padding-left:20px;padding-right:20px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}section#genericError .banner{margin-bottom:30px}", ""]);
	
	// exports


/***/ }),

/***/ "./components/xo-ui-components/src/message/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-ui-components/src/message/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	
	    squid.module('xo-message.directive', ['squid']).directive('xoMessage', function ($timeout, $loader, $rootScope) {
	        return {
	            scope: {
	                message: '=' // Expected type - {msgs: [], type: "info|error|success|warning"}
	            },
	            template: template,
	            link: function link(scope, element, attrs) {
	
	                // Hide and show the alerts so that messages can be registered by
	                // screen reader even if they are repeats. Uses $timeout to
	                // wait for DOM before showing alerts again.
	                var toggleAlert = function toggleAlert() {
	                    var $alert = element.find('ul');
	                    $alert.detach();
	                    $timeout(function () {
	                        element.find('#pageLevelErrors').append($alert);
	                    });
	                };
	
	                // Toggle the alert whenever message changes by removing it and reappending it
	                // to the DOM. Should fire even if message
	                // is changed to the same, as assumes that the message should be reapplied.
	                var cancel;
	                scope.$watchCollection('message', function () {
	                    if ($loader.isLoading() && !cancel) {
	                        // If loading, toggle the alert after all loading calls have been made.
	                        // This is so that the alert can be read by screen reader after focus
	                        cancel = $rootScope.$on('allLoaded', function () {
	                            cancel();
	                            toggleAlert();
	
	                            cancel = null;
	                        });
	                    } else {
	                        toggleAlert();
	                    }
	                });
	
	                scope.$on('$destroy', function () {
	                    if (cancel) {
	                        cancel();
	                    }
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-ui-components/src/message/template.html":
/***/ (function(module, exports) {

	module.exports = "<div role=\"alert\" aria-live=\"assertive\">\n    <div id=\"notifications\" ng-if=\"message.msgs || message.msgKeys\" content >\n        <div id=\"pageLevelErrors\" class=\"msgPage msg-{{message.type}}\">\n            <span class=\"icon\"></span>\n            <ul role=\"presentation\">\n                <li ng-repeat=\"msg in message.msgs\">\n                    <span data-ng-bind-html=\"msg\"></span>\n                </li>\n                <li ng-repeat=\"keys in message.msgKeys\" ng-if=\"message.msgKeys\">\n                    <div data-ng-bind-html=\"htmlContent(keys)\"></div>\n                </li>\n            </ul>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "./pages/xo-generic-message/route.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./pages/xo-generic-message/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('hermes.page.xo-generic-message.route', ['squid', 'hermes.page.xo-generic-message.directive']).factory('$GenericMessageRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('GenericMessageRoute', {
	            name: 'genericMessage',
	            directive: 'xo-generic-message-page',
	            titleContent: 'genericError.pleaseTryAgain',
	            query: ['code'],
	            // need to find these values
	            trackingData: {},
	            children: []
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-generic-message", "pages/xo-generic-message/route.js"))

/***/ }),

/***/ "./pages/xo-generic-message/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./pages/xo-generic-message/template.html"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-ui-components/src/generic-message/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid, template) {
	    return angular.module('hermes.page.xo-generic-message.directive', ['squid', 'xomodel.checkout', 'xo-generic-message.directive']).directive('xoGenericMessagePage', function ($rootScope) {
	
	        return {
	            template: template,
	
	            controller: function controller($scope, $rootScope, // eslint-disable-line no-shadow
	            $stateParams, $state, $logger, $CheckoutAppDataModel, $util, $q, $populate) {
	
	                $scope.token = $rootScope.token;
	                angular.element('#defaultCancelLink').hide();
	
	                var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
	                    event.preventDefault();
	                });
	
	                $rootScope.$on('$destroy', stateChangeStart);
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./pages/xo-generic-message/template.html":
/***/ (function(module, exports) {

	module.exports = "<xo-generic-message token=token></xo-generic-message>\n"

/***/ }),

/***/ "./components/xo-ui-components/src/generic-message/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-ui-components/src/generic-message/template.html"), __webpack_require__("./components/xo-models/src/checkout/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular, squid, template) {
	
	    return angular.module('xo-generic-message.directive', ['squid', 'xomodel.checkout']).directive('xoGenericMessage', function ($rootScope) {
	
	        return {
	            template: template,
	
	            scope: {
	                token: '='
	            },
	
	            controller: function controller($scope, $rootScope, // eslint-disable-line no-shadow
	            $stateParams, $state, $logger, $CheckoutAppDataModel, $populate) {
	
	                $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
	                    event.preventDefault();
	                });
	
	                $('.paypalHeaderWrapper').hide();
	                $('.footerWrapper').addClass('genericMessage');
	
	                var titleKeyMapping = {
	                    PAYMENT_SUCCESS: 'paymentSuccessTitle',
	                    DEFAULT: 'paymentSuccessTitle'
	                };
	
	                $scope.titleKey = 'genericMessage.' + ($stateParams.code && titleKeyMapping[$stateParams.code]) || titleKeyMapping.DEFAULT;
	
	                var contentKeyMapping = {
	                    PAYMENT_SUCCESS: 'paymentSuccessMessage',
	                    DEFAULT: 'paymentSuccessMessage'
	                };
	                var contentKey = $stateParams.code && contentKeyMapping[$stateParams.code];
	
	                if (contentKey) {
	                    $scope.contentKey = 'genericMessage.' + contentKey;
	                }
	
	                $populate($scope, {
	                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token)
	                }).then(function () {
	                    var merchant = $scope.checkoutAppData.merchant;
	                    $scope.merchant = merchant.brand_name || merchant.merchant_name || merchant.merchant_email;
	                });
	
	                $scope.$on('$destroy', function (event) {
	                    $('.paypalHeaderWrapper').show();
	                    $('.footerWrapper').removeClass('genericMessage');
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-ui-components/src/generic-message/template.html":
/***/ (function(module, exports) {

	module.exports = "<section id=\"genericMessage\" content>\n    <div class=\"container\">\n        <div class=\"logo\"></div>\n        <div class=\"title\" ng-if=\"titleKey\">\n            {{content(titleKey)}}\n        </div>\n        <div class=\"message\" ng-if=\"contentKey\">\n            {{content(contentKey)}}\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "./pages/xo-end/route.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	var _returnParams = __webpack_require__("./components/xo-page-components/src/returnParams/index.js");
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-models/src/user/index.js"), __webpack_require__("./components/xo-models/src/auth/index.js"), __webpack_require__("./components/xo-models/src/onboard/index.js"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/profilemanagement/index.js"), __webpack_require__("./components/xo-return-to-merchant/dist/util.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('hermes.page.xo-end.route', ['squid', 'xomodel.user', 'xomodel.auth', 'xomodel.onboard', 'xomodel.checkout', 'xomodel.profilemanagement', 'xo-return-to-merchant']).factory('$EndRoute', function ($ComponentRoute, $unresolved, $integration) {
	
	        return $ComponentRoute.extend('EndRoute', {
	            name: 'end',
	            resolve: {
	                action: function action($window, $util, $config, $CheckoutInputDataModel, $AuthModel, $OnboardUserModel, $CheckoutAppDataModel, $MerchantPreferenceModel, $CheckoutPayeeModel, $CheckoutCartModel, $CheckoutSessionModel, $ReturnToMerchant, $rootScope, $state, $populate, $q, $FallbackError, $logger, $DeviceInfo) {
	
	                    function returnMethod(merchantPreferences) {
	                        if (merchantPreferences) {
	                            return merchantPreferences.returnMethod();
	                        }
	                        return 'GET';
	                    }
	
	                    function returnUrl(checkoutAppData, merchantPreferences) {
	                        if (checkoutAppData.doec_on_approve() && merchantPreferences) {
	                            return checkoutAppData.urls.return_url || merchantPreferences.returnUrl();
	                        } else {
	                            return checkoutAppData.urls.return_url;
	                        }
	                    }
	
	                    function getMerchantPreferences(dataModel) {
	                        return $populate(dataModel, {
	                            merchantPreferences: $MerchantPreferenceModel.instance(dataModel.payee.merchant.id)
	                        });
	                    }
	
	                    function postToMerchant(wpsURL, wpsData) {
	                        $ReturnToMerchant.postTo(wpsURL, wpsData);
	                    }
	
	                    function goToMerchant(wpsURL, wpsData) {
	                        // if PDT is disabled don't send params in the url
	                        if ($state.merchantPreferences && !$state.merchantPreferences.pdtEnabled()) {
	                            return $ReturnToMerchant.goTo(wpsURL);
	                        }
	                        return $ReturnToMerchant.goTo($util.buildURL(wpsURL, wpsData));
	                    }
	
	                    return $populate($state, {
	                        checkoutAppData: $CheckoutAppDataModel.instance($rootScope.token),
	                        checkoutCart: $CheckoutCartModel.instance($rootScope.token),
	                        checkoutSession: $CheckoutSessionModel.instance($rootScope.token),
	                        payee: $CheckoutPayeeModel.instance($rootScope.token)
	                    }).then(function () {
	
	                        /*
	                            If we're in an in-context flow, the parent button
	                            iframe may need the access token to continue running
	                            and execute the payment (e.g. in 3rd party cookies
	                            disabled mode)
	                             We reload the auth model, since after the user is
	                            onboarded this model is not updated, then pass the
	                            access token up. The token will only be passed if
	                            we're on the same-domain as the parent button.
	                        */
	
	                        if (window.xprops && window.xprops.onAuth) {
	                            var auth = $AuthModel.instance();
	
	                            return auth.reload().then(function () {
	                                window.xprops.onAuth(auth.access_token);
	                            });
	                        }
	                    }).then(function () {
	
	                        if ($state.checkoutAppData.doec_on_approve()) {
	                            return getMerchantPreferences($state);
	                        }
	                    }).then(function () {
	
	                        // handle the return url with post and get , with and without PDT for WPS alone
	                        // PDT - Payment Data Transfer
	                        if ($state.checkoutAppData.doec_on_approve()) {
	                            var wpsURL = returnUrl($state.checkoutAppData, $state.merchantPreferences);
	                            var returnToMerchantMethod = returnMethod($state.merchantPreferences);
	                            var isWPSCart = $state.checkoutAppData.flags.is_cart_upload_flow || $state.checkoutAppData.flags.is_shopping_cart_flow;
	                            var wpsParams = (0, _returnParams.$returnParams)($state.checkoutCart, $state.checkoutSession, returnToMerchantMethod, 'WPS', isWPSCart);
	
	                            return returnToMerchantMethod === 'POST' ? postToMerchant(wpsURL, wpsParams) : goToMerchant(wpsURL, wpsParams);
	                        }
	
	                        var params = {};
	                        // Creating the checkoutInputData here so that it would not make payer-id call.
	                        var checkoutInputData = $CheckoutInputDataModel.instance($rootScope.token);
	
	                        // Don't post PayerID for RT without purchase
	                        if (!$state.checkoutCart.isBillingNoPurchase()) {
	                            params.PayerID = $state.checkoutSession.payer.id;
	                        }
	
	                        var billingData = $state.checkoutCart.billing;
	
	                        // exclude BA token in the returnUrl for external merchant - (merchant not calling BEAM directly)
	                        if (billingData && billingData.ba_token && !$state.checkoutAppData.legacy_billing_integration) {
	                            params.ba_token = billingData.ba_token;
	                        }
	
	                        // When "redirect_uri" is passed as a query param
	                        if ($integration.getConfig('REDIRECT_QUERY_PARAM')) {
	                            //  this is specifically for nativexo where redirect_uri is passed in query param
	                            //  the following query params need to be appended to the redirect_uri
	                            params.return_uri = $state.checkoutAppData.get('urls.return_url');
	                            params.opType = 'payment';
	                        }
	
	                        function handleRedirection(url) {
	                            var isHTTPUrl = Boolean(url.indexOf('http') === 0 || url.indexOf('www') === 0);
	                            var isMobileDevice = Boolean($DeviceInfo.isDevice() && !isHTTPUrl);
	
	                            /* Webview to App view switching is not happening properly
	                            * so to handle , adding a work around by adding cancel / return to merchant url
	                            * on success page
	                            * routeToComplete is the route which shows cancel / return to merchant url*/
	                            if (isMobileDevice) {
	                                $logger.info('Switching_Webview_To_App_view', {
	                                    url: url
	                                });
	                                $window.onunload = $window.onbeforeunload = function () {
	                                    // leave this blank , having this comment for lint warning - Unexpected Empty Function
	                                };
	                                $window.location = url;
	
	                                return $state.go('checkout.routeToComplete', {
	                                    url: url,
	                                    urlType: 'success'
	                                });
	                            } else {
	                                if (window.xchild) {
	                                    $logger.done();
	                                    $rootScope.$emit('loading');
	
	                                    var xparams = {
	                                        paymentToken: $rootScope.token,
	                                        billingToken: params['ba_token'],
	                                        payerID: params['PayerID'],
	                                        paymentID: params['paymentId'] || $state.checkoutAppData.payment_id,
	                                        intent: $state.checkoutCart.payment_action
	                                    };
	
	                                    xparams.returnUrl = url;
	                                    return window.xprops.onAuthorize(xparams);
	                                }
	                                $ReturnToMerchant.goTo(url);
	                            }
	
	                            return $unresolved;
	                        }
	
	                        if (!checkoutInputData.isEbayTxn()) {
	                            // non-Ebay/xoon flow
	                            return $q.when().then(function () {
	                                if ($integration.getConfig('REDIRECT_QUERY_PARAM')) {
	                                    var redirect = $util.buildURL($util.param('redirect_uri'));
	                                    $logger.info('Nativeapp_Redirection', {
	                                        redirect: redirect
	                                    });
	                                    return handleRedirection($util.buildURL(redirect, params));
	                                } else {
	                                    return handleRedirection($util.buildURL($state.checkoutAppData.get('urls.return_url'), params));
	                                }
	                            });
	                        } else {
	                            // PrOX flow only
	                            return $q.when().then(function () {
	
	                                if ($util.param('fromLipp') === 'true') {
	                                    var lippParamList = {
	                                        client_id: $util.param('client_id'),
	                                        scope: $util.param('scope'),
	                                        state: $util.param('state'),
	                                        redirect_uri: $util.param('redirect_uri'),
	                                        metadata_id: $util.param('cart_id')
	                                    };
	                                    // reroute to LIPP to generate authcode if send from lipp
	                                    var lippUrl = $util.buildURL($window.location.protocol + '//' + $window.location.host + $config.urls.lippRedirectUrl, lippParamList);
	                                    return $ReturnToMerchant.goTo(lippUrl, true);
	                                } else {
	                                    // for Prox Signup flow (eBay), generate auth code
	                                    var auth = $AuthModel.instance();
	                                    $logger.info('prox_exit_login_code_start');
	
	                                    return auth.action('loginCode', {
	                                        data: {
	                                            user: {},
	                                            client: {
	                                                client_id: $config.proxStsClientId,
	                                                redirect_uri: checkoutInputData.redirect_uri,
	                                                scope: checkoutInputData.scope,
	                                                id_token: '',
	                                                nonce: auth.nonce,
	                                                response_type: 'code',
	                                                skip_oauth: false,
	                                                skip_consent: true,
	                                                target_client_id: $util.base64Decode(checkoutInputData.client_id),
	                                                visitor_id: auth.visitor_id,
	                                                scope_consent_context: 'access_token'
	                                            }
	                                        }
	
	                                    })['catch'](function (err) {
	                                        $logger.error('prox_exit_login_code_error', err);
	                                        $ReturnToMerchant.goTo(checkoutInputData.errorUrl(err.message));
	
	                                        return $unresolved;
	                                    }).then(function (loginCodeResult) {
	                                        if (loginCodeResult && loginCodeResult.data && loginCodeResult.data.code) {
	                                            $logger.info('prox_exit_login_code_success');
	                                            return handleRedirection(checkoutInputData.successUrl(loginCodeResult.data.code));
	                                        } else {
	                                            $logger.error('prox_exit_login_code_not_found');
	                                            $ReturnToMerchant.goTo(checkoutInputData.errorUrl('auth_code_error'));
	
	                                            return $unresolved;
	                                        }
	                                    });
	                                }
	                            });
	                        }
	                    });
	                }
	            }
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	_returnParams.$returnParams;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-end", "pages/xo-end/route.js"))

/***/ }),

/***/ "./components/xo-page-components/src/returnParams/index.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	var addValidParam = __webpack_require__("./components/xo-page-components/src/utils/index.js").addValidParam;
	
	function returnWPSParams(checkoutCart, checkoutSession, returnToMerchantMethod, is_cart_upload_flow) {
	    var params = {};
	    var customData = checkoutCart.get('purchase.custom');
	
	    if (returnToMerchantMethod === 'POST') {
	        // TODO: find out why we get postbackData as undefined
	        // UPDATE: couldn't reproduce an issue on the stage for now
	        if (checkoutSession.postbackData) {
	            params = checkoutSession.postbackData;
	        }
	    } else {
	        var transactionDetail = checkoutSession.transactionDetails;
	
	        if (transactionDetail) {
	            addValidParam(params, 'tx', transactionDetail.id);
	            addValidParam(params, 'st', transactionDetail.state);
	
	            if (transactionDetail.amount) {
	                addValidParam(params, 'amt', transactionDetail.amount.total);
	                addValidParam(params, 'cc', transactionDetail.amount.currency);
	            }
	        }
	
	        // Cart uploads can have more than one item so we don't add any in return URL
	        if (!is_cart_upload_flow) {
	            var itemDetail = checkoutSession.get('itemsList.0');
	            if (itemDetail) {
	                addValidParam(params, 'item_name', itemDetail.name);
	                addValidParam(params, 'item_number', itemDetail.sku);
	            }
	        }
	
	        addValidParam(params, 'cm', customData);
	    }
	    return params;
	}
	
	/**
	 * this API function is used by hermesnodeweb/public/pages/xo-end and xoonboardingnodeweb/public/pages/xo-end
	 * Create params to return back to the merchant after clicking on "Return to merchant" on the Done page.
	 * buy-now and cart-upload params are slightly different: given cart-upload might have multiple items,
	 * please refer https://github.paypal.com/NodeXOShared/xo-hermes-checkout/blob/master/apis/session/postBackDataMapper.js
	 * to know more details about post back data
	
	 * @param {Object (angular model)} cart model
	 * @param {Object (angular model)} session model
	 * @param {String} http method, either "POST" or "GET"
	 * @param {String} feature type (WPS only for now)
	 * @param {Boolean} flag that indicates if it's a cart upload or not
	 * @returns {object} params to pass back to the merchant
	*/
	module.exports = {
	    $returnParams: function $returnParams(checkoutCart, checkoutSession, returnToMerchantMethod, feature, is_cart_upload_flow) {
	        if (feature === 'WPS') {
	            return returnWPSParams(checkoutCart, checkoutSession, returnToMerchantMethod, is_cart_upload_flow);
	        }
	        return {};
	    }
	};

/***/ }),

/***/ "./components/xo-page-components/src/utils/index.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	/* eslint-disable angular/typecheck-string */
	
	var _fbMessenger = __webpack_require__("./components/xo-page-components/src/constants/fbMessenger.js");
	
	var _fbMessenger2 = _interopRequireDefault(_fbMessenger);
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _index = __webpack_require__("./components/xo-device-info/dist/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	module.exports = {
	    /**
	     * add non empty key, value to the object
	     * @param {Object} object where to add new key, value
	     * @param {String} key
	     * @param {Any type} value, can not be empty
	     * @returns {void}
	     */
	    addValidParam: function addValidParam(obj, key, val) {
	        if (!obj) {
	            return;
	        }
	        if (typeof key === 'string' && key && val !== undefined && val !== null) {
	            obj[key] = val;
	        }
	    },
	
	    // Get PXP context for Messenger feature
	    getMessengerPXPContext: function getMessengerPXPContext() {
	        var isMobile = _index.$DeviceInfo.isMobile() || _index.$DeviceInfo.isTablet();
	        var overrideMobileUserFlag = _squid.$util.param(_fbMessenger2['default'].OVERRIDE_FBPP_MOBILE_FLAG);
	        var channelVal = isMobile ? _fbMessenger2['default'].MOBILE_CHANNEL : _fbMessenger2['default'].WEB_CHANNEL;
	
	        var pxpContext = {
	            'ctx.COUNTRY': _squid.$locale.country,
	            'ctx.CHANNEL': overrideMobileUserFlag ? _fbMessenger2['default'].WEB_CHANNEL : channelVal,
	            'ctx.LANGUAGE': _squid.$locale.lang + '_' + _squid.$locale.country
	        };
	
	        return pxpContext;
	    }
	};
	_squid.$util;
	
	_squid.$locale;
	
	_index.$DeviceInfo;

/***/ }),

/***/ "./components/xo-page-components/src/constants/fbMessenger.js":
/***/ (function(module, exports) {

	
	
	/* Constants for FB messenger related components */
	
	module.exports = {
	    OVERRIDE_FBPP_REPEAT_FLAG: 'override_fbpp_repeat',
	    OVERRIDE_FBPP_MOBILE_FLAG: 'override_fbpp_mobile',
	    FB_BA_SHOWN_FLAG: 'is_xo_wps_fb_messenger_plugin_match_withba_shown',
	    MOBILE_CHANNEL: 'MOBILE',
	    WEB_CHANNEL: 'WEB',
	    FB_USER_API_MOBILE_URL: 'https://m.facebook.com/paypal/user_identifier',
	    FB_USER_API_URL: 'https://www.facebook.com/paypal/user_identifier',
	    FB_PROD_APP_ID: '1084613224964631',
	    FB_PROD_PAGE_ID: {
	        US: '55982004572',
	        AU: '171522459698178',
	        CA: '164660263560926',
	        GB: '167465479930420'
	    },
	    FB_TEST_PAGE_ID: '676472402496128',
	    PXP_MESSENGER_EXPT: 'xo_wps_fb_messenger_plugin',
	    PXP_SHOW_MESSENGER_PLUGIN_TREATMENT: 'xo_wps_fb_messenger_plugin_1_treatment',
	    PXP_MESSENGER_G11N: 'xo_wps_fb_messenger_plugin_g11n',
	    PXP_MESSENGER_PLUGIN_TREATMENT_G11N: 'xo_wps_fb_messenger_plugin_g11n_treatment'
	};

/***/ }),

/***/ "./components/xo-models/src/profilemanagement/index.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xomodel.profilemanagement', ['squid']).factory('$MerchantPreferenceModel', function ($Model, $Api, $config, $util) {
	
	        return $Model.extend('MerchantPreferenceModel', {
	
	            init: function init() {
	
	                this._super.init.apply(this);
	
	                this.setProperties({
	                    rm: $util.param('rm'), // Return Method
	                    return_url: $util.param('return'),
	                    auto_return: {
	                        enabled: false
	                    },
	                    pdt: {
	                        enabled: false
	                    }
	                });
	            },
	
	            api: new $Api({
	                baseURI: $config.urls.baseUrl,
	                uri: '/api/profilemanagement/:id/getMerchantPreferences'
	            }),
	
	            autoReturn: function autoReturn() {
	                return this.auto_return.enabled;
	            },
	
	            pdtEnabled: function pdtEnabled() {
	                return this.pdt && this.pdt.enabled;
	            },
	
	            returnUrl: function returnUrl() {
	                return this.return_url || this.auto_return.url;
	            },
	
	            /**
	             * 0 – redirect using GET method ( default behavior )
	             * 1 – redirect using the GET method, but no payment variables are included
	             * 2 – redirect using the POST method, and include all payment variables
	             */
	            returnMethod: function returnMethod() {
	                var rm = this.rm;
	
	                if (rm === '2') {
	                    return this.pdtEnabled() ? 'GET' : 'POST';
	                } else {
	                    return 'GET';
	                }
	            },
	
	            returnMethodSupported: function returnMethodSupported() {
	                return this.returnMethod() === 'GET';
	            },
	
	            /**
	             * Determines if payment details need to be sent back to the merchant.
	             * @returns {boolean}
	             */
	            postPaymentData: function postPaymentData() {
	                return this.rm === '2' && !this.pdtEnabled() && this.returnUrl();
	            },
	
	            // charset of merchant having in profile
	            charSet: function charSet() {
	                return this.charset;
	            }
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/profilemanagement", "components/xo-models/src/profilemanagement/index.js"))

/***/ }),

/***/ "./pages/xo-guest/route.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./pages/xo-guest/directive.js"), __webpack_require__("./pages/xo-sidebar/route.js"), __webpack_require__("./components/xo-login-components/src/onetouch-interstitial/route.js"), __webpack_require__("./components/xo-guest-components/src/guest-upgrade-interstitial/route.js"), __webpack_require__("./components/xo-guest-components/src/guest/currencyConversion/route.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('hermes.page.xo-guest.route', ['squid', 'hermes.page.xo-guest.directive', 'hermes.page.xo-sidebar.route']).factory('$GuestRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('GuestRoute', {
	            name: 'guest',
	            directive: 'xo-guest',
	            titleContent: 'accountCreationGuest.heading',
	            trackingData: {
	                fptiState: 'guest_xo',
	                trackStateExit: false,
	                templateName: 'guest.dust',
	                pageGoal: 'Payment Start',
	                pageQualifier: 'guest',
	                buzname: {
	                    'guest': {
	                        'pagename': '%::fullpage-guest',
	                        'pagename2': '%::fullpage-guest:member:hermes:',
	                        'version': 'guest:%:'
	                    },
	                    'signup': {
	                        'pagename': '%::fullpage-guestSignup',
	                        'pagename2': '%::fullpage-guestSignup:member:hermes:',
	                        'version': 'guestSignup:%:'
	                        // More page qualifiers come here...
	                    } }
	            },
	            children: [{
	                name: '$SidebarRoute',
	                attributes: {
	                    'back-uri': 'backUri',
	                    'parent-model': 'singleStepModel'
	                }
	            }, {
	                name: '$OneTouchUpsellRoute',
	                attributes: {
	                    token: 'token',
	                    'on-complete': 'onComplete',
	                    'disable-close-button': 'true',
	                    'ignore-bg-clicks': 'true'
	                }
	            }, {
	                name: '$GuestUpgradeInterstitialRoute',
	                attributes: {
	                    token: 'token',
	                    'parent-model': 'singleStepModel'
	                }
	            }, {
	                name: '$CurrencyConversionOptionsRoute',
	                attributes: {
	                    token: 'token',
	                    'parent-model': 'singleStepModel',
	                    'is-pre-plan': 'true',
	                    'done-fn': 'onCurrencyConversionDone'
	                }
	            }]
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-guest", "pages/xo-guest/route.js"))

/***/ }),

/***/ "./pages/xo-guest/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/module.js"), __webpack_require__("../node_modules/noop-loader/index.js!./pages/xo-guest/template.html"), __webpack_require__("./components/xo-page-components/src/value-props/directive.js"), __webpack_require__("./components/xo-guest-components/src/guest/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, module, template) {
	
	    return angular.module('hermes.page.xo-guest.directive', ['squid', 'xo-value-props.directive', 'xo-onboard.payment.directive']).directive('xoGuest', function ($rootScope, $SingleStepModel) {
	
	        return {
	            template: template,
	
	            scope: {
	                token: '=',
	                parentCallbacks: '=',
	                isUnbranded: '=',
	                paymentMethod: '=',
	                buttonParams: '='
	            },
	
	            controller: function controller($scope, $state) {
	                $scope.mode = 'guest';
	                $scope.backUri = 'checkout.guest';
	                $scope.singleStepModel = new $SingleStepModel();
	
	                $scope.onComplete = function () {
	                    $state.go('checkout.end');
	                };
	
	                $scope.onCurrencyConversionDone = function () {
	                    $state.go($scope.backUri);
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "./components/squid/dist/module.js":
/***/ (function(module, exports) {

	
	
	module.exports = angular.module;

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./pages/xo-guest/template.html":
/***/ (function(module, exports) {

	module.exports = "<section class=\"guestWithSignup\" id=\"guestWithSignup\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <xo-onboard-payment token=\"token\" mode=\"mode\" is-unbranded=\"isUnbranded\"\n                                payment-method=\"paymentMethod\"\n                                single-step-model=\"singleStepModel\" button-params=\"buttonParams\"></xo-onboard-payment>\n        </div>\n        <div class=\"span10\">\n            <xo-value-props  ng-if=\"!isUnbranded\" type=\"review\" title=\"{{content('guestVerify.propHead')}}\" text-content=\"guestVerify.propVal\"></xo-value-props>\n            <xo-value-props  ng-if=\"isUnbranded\" type=\"review\" title=\"{{content('guestVerify.unbrandedPropHead')}}\" text-content=\"guestVerify.unbrandedPropVal\"></xo-value-props>\n        </div>\n    </div>\n    <div ui-view></div>\n</section>\n"

/***/ }),

/***/ "./components/xo-page-components/src/value-props/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-page-components/src/value-props/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	
	    squid.module('xo-value-props.directive', ['squid']).directive('xoValueProps', function () {
	        return {
	            template: template,
	            restrict: 'E',
	            scope: {
	                type: '@',
	                title: '@',
	                text: '@',
	                textContent: '@',
	                imageUrl: '@'
	            },
	            link: function link(scope, element, attrs) {
	                if (angular.isString(attrs.imageUrl)) {
	                    // Only do this when image-url is defined so that we do not affect default behavior. These image-url
	                    // are configured through pxp tool for factor based experiments, hence they should all should adhere
	                    // to standard size i.e. 150X150 pixels.
	                    attrs.$observe('imageUrl', function (imageUrl) {
	                        var url = imageUrl;
	                        var propImg = angular.element(element[0].querySelector('div.prop-img'));
	                        var isRetina = window && window.matchMedia && window.matchMedia('(-webkit-min-device-pixel-ratio: 2), ' + '(min--moz-device-pixel-ratio: 2), ' + '(-o-min-device-pixel-ratio: 2/1),' + '(min-device-pixel-ratio: 2),' + '(min-resolution: 192dpi), ' + '(min-resolution: 2dppx)').matches;
	
	                        if (isRetina) {
	                            var index = url.lastIndexOf('.'); // index at which file extension start
	                            url = url.substring(0, index) + '_2x' + url.substring(index, url.length);
	                            propImg.css({
	                                'background-image': 'url(' + url + ')',
	                                'height': '150px',
	                                'background-size': '150px 150px',
	                                'margin-top': '0px'
	                            });
	                        } else {
	                            propImg.css({
	                                'background-image': 'url(' + url + ')',
	                                'height': '150px',
	                                'margin-top': '0px'
	                            });
	                        }
	                    });
	                }
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-page-components/src/value-props/template.html":
/***/ (function(module, exports) {

	module.exports = "<div class=\"props {{type}}\" content>\n    <div class=\"prop-img\"></div>\n    <h2 class=\"vprop-header\">{{ title }}</h2>\n    <p ng-if=\"textContent\" ng-bind-html=\"htmlContent(textContent)\"></p>\n    <p ng-if=\"!textContent\" ng-bind-html=\"text\"></p>\n</div>\n"

/***/ }),

/***/ "./components/xo-guest-components/src/guest/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	
	exports.__esModule = true;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _ul = __webpack_require__("./components/xo-login-components/src/unified-login/ul.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _index = __webpack_require__("./components/squid/dist/index.js");
	
	var _index2 = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _index3 = __webpack_require__("./components/xo-models/src/user/index.js");
	
	var _index4 = __webpack_require__("./components/xo-models/src/shoppingcart/index.js");
	
	var _index5 = __webpack_require__("./components/xo-models/src/shippingMethod/index.js");
	
	var _index6 = __webpack_require__("./components/xo-models/src/inventory/index.js");
	
	var _index7 = __webpack_require__("./components/xo-models/src/onboard/index.js");
	
	var _index8 = __webpack_require__("./components/xo-models/src/fi/index.js");
	
	var _fiApis = __webpack_require__("./components/xo-models/src/fi/lib/fiApis.js");
	
	var _index9 = __webpack_require__("./components/xo-models/src/auth/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _index10 = __webpack_require__("./components/xo-device-info/dist/index.js");
	
	var _index11 = __webpack_require__("./components/xo-models/src/marketingoffer/index.js");
	
	var _directive = __webpack_require__("./components/xo-form-components/src/national-id-input/directive.js");
	
	var _util = __webpack_require__("./components/xo-wallet-components/src/fi-contingency-list/util.js");
	
	var _sticky = __webpack_require__("./components/xo-guest-components/src/guest/sticky.js");
	
	var _util2 = __webpack_require__("./components/xo-guest-components/src/lib/util.js");
	
	var _errorHandlerHelper = __webpack_require__("./components/xo-guest-components/src/guest/lib/errorHandlerHelper.js");
	
	var errorHandlerHelper = _interopRequireWildcard(_errorHandlerHelper);
	
	var _pxpExperimentConstants = __webpack_require__("./components/xo-guest-components/src/guest/constants/pxpExperimentConstants.js");
	
	var _pxpExperimentConstants2 = _interopRequireDefault(_pxpExperimentConstants);
	
	var _constants = __webpack_require__("./components/xo-guest-components/src/guest/constants/constants.js");
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _template = __webpack_require__("./components/xo-guest-components/src/guest/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-guest-components/src/guest/countryList/directive.js");
	
	__webpack_require__("./components/xo-guest-components/src/guest/emailInput/directive.js");
	
	__webpack_require__("./components/xo-guest-components/src/guest/passwordInput/directive.js");
	
	__webpack_require__("./components/xo-guest-components/src/guest/onboardOptions/directive.js");
	
	__webpack_require__("./components/xo-guest-components/src/guest/currencyConversion/directive.js");
	
	__webpack_require__("./components/xo-guest-components/src/guest/select-shipping-method/directive.js");
	
	__webpack_require__("./components/xo-form-components/src/select-shipping-country/directive.js");
	
	__webpack_require__("./components/xo-address-components/src/add-address/directive.js");
	
	__webpack_require__("./components/xo-guest-components/src/guest/sepa/directive.js");
	
	__webpack_require__("./components/xo-form-components/src/phone/phoneInput/directive.js");
	
	__webpack_require__("./components/xo-form-components/src/name-input/directive.js");
	
	__webpack_require__("./components/xo-wallet-components/src/add-bank/bank-input/directive.js");
	
	__webpack_require__("./components/xo-address-components/src/address-normalization/directive.js");
	
	__webpack_require__("./components/xo-wallet-components/src/3ds/directive.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	exports['default'] = _index.$Component.extend('xoOnboardPayment', {
	    tag: 'xo-onboard-payment',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            type: 'var'
	        },
	        mode: {
	            type: 'var'
	        },
	        isUnbranded: {
	            type: 'var'
	        },
	        paymentMethod: {
	            type: 'var'
	        },
	        singleStepModel: {
	            type: 'var'
	        },
	        buttonParams: {
	            type: 'var'
	        }
	    },
	
	    resolve: {
	        models: function models() {
	            return {
	                auth: _index9.$AuthModel.instance(this.token).retrieve(),
	                payee: _index2.$CheckoutPayeeModel.instance(this.props.token).retrieve(),
	                checkoutAppData: _index2.$CheckoutAppDataModel.instance(this.props.token).retrieve(),
	                checkoutCart: _index2.$CheckoutCartModel.instance(this.token).retrieve(),
	                checkoutInputData: _index3.$CheckoutInputDataModel.instance(this.token).retrieve()
	            };
	        },
	        shippingRule: function shippingRule(resolvers) {
	            var _this = this;
	
	            return resolvers.models.then(function (models) {
	                if (models.checkoutAppData.doec_on_approve()) {
	                    return {
	                        profileRulesSummary: _index5.$ShippingRuleSummaryModel.instance(_this.token).retrieve({
	                            params: {
	                                merchant_id: models.payee.merchant.id,
	                                currency_code: models.checkoutCart.purchase.amounts.total.currency_code
	                            }
	                        })
	                    };
	                }
	            });
	        },
	        experiments: function experiments() {
	            return {
	                signupOnetouch: (0, _squid.$pxp)('xo_xoonboardingnode_signup_onetouch', { 'ctx.COUNTRY': _index.$locale.country }, '(signup_onetouch_)(.*)'),
	                signupComplianceUS: (0, _squid.$pxp)('xo_xoonboarding_signupcompliance_us', { 'ctx.COUNTRY': _index.$locale.country }, '(xo_xoonboarding_signupcompliance_us_)(.*)'),
	                nonVisaDcc: (0, _squid.$pxp)('xo_xoonboarding_dcc_nonvisa', { 'ctx.COUNTRY': _index.$locale.country }, 'xo_xoonboarding_dcc_nonvisa_test'),
	                sepaOverlay: (0, _squid.$pxp)('XO_XOONBOARDING_SEPA_OVERLAY', { 'ctx.COUNTRY': _index.$locale.country }, 'XO_XOONBOARDING_SEPA_OVERLAY_TEST')
	            };
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var _this2 = this;
	
	            this.locale = _index.$locale;
	            this.currentState = _uiRouter.$state.current.name;
	            this.upsellOptInDisplayed = false;
	            this.flags = {
	                shipToBilling: true,
	                allowEditShipping: true,
	                showSingleAddress: false,
	                showShippingLabel: true,
	                cupDetected: false,
	                hideShippingAddress: false,
	                allowPayWithSnT: false,
	                allowSnTCall: true,
	                instantUpdateShippingRegionSupported: true
	            };
	
	            this.sepa = {
	                sepaGuestAgree: false,
	                sepaAgree: false,
	                show: false
	            };
	
	            var app_int_type = _index10.$DeviceInfo.isWebView() ? 'WebView' : _index10.$DeviceInfo.getAppIntegrationType();
	
	            // fpti log for app integration type
	            _logger.$logger.info('checkout_fpti', {
	                'app_int_type': app_int_type
	            });
	
	            _logger.$logger.info('checkout_fpti', {
	                page: 'main:ec:hermes::fullpage-billing:guest:hermes:'
	            });
	
	            // set the china upop flag on event heard
	            this.$watch('onboard.card.type', function (newVal) {
	                _this2.flags.cupDetected = newVal === 'CUP';
	            });
	
	            $(document).on('click', '#pomaLegalterms a', function () {
	                _angular.$rootScope.$broadcast('trackInput', {
	                    currentRoute: _uiRouter.$state.current,
	                    page: 'main:ec:hermes::fullpage-billing:guest:aries:',
	                    transition: $(_this2).text().replace(/\s/g, '_')
	                });
	            });
	
	            // This is needed in Sepa directive
	            this.sectionElement = '#singlePagePayment';
	
	            this.countries = function () {
	                return _index.$locale.content.countryList;
	            };
	
	            var triggerPageDesignFPTILog = function triggerPageDesignFPTILog() {
	                var pageContext = 'Full-context';
	                if (_angular.$rootScope.miniBrowser) {
	                    pageContext = 'In-context';
	                }
	
	                _logger.$logger.info('checkout_fpti', {
	                    'design': pageContext
	                });
	            };
	            // Log Initial Page Design
	            triggerPageDesignFPTILog();
	            // Trigger Design FPTI Log on Page Design Change
	            _angular.$rootScope.$watch('miniBrowser', triggerPageDesignFPTILog);
	
	            var getPresetPaymentMethod = function getPresetPaymentMethod() {
	
	                var paymentMethod = _this2.paymentMethod && _this2.paymentMethod.toLowerCase();
	
	                if (!paymentMethod || paymentMethod !== 'bank' && paymentMethod !== 'card') {
	                    return;
	                }
	
	                return paymentMethod === 'bank' ? 'bank' : 'card';
	            };
	
	            this.showFISwitchTab = function () {
	                if (getPresetPaymentMethod()) {
	                    return false;
	                }
	                return (0, _index.$feature)('fiSwitchTab', false, _index.$locale.country);
	            };
	
	            this.getDefaultFIMode = function () {
	                var presetPayMentMethod = getPresetPaymentMethod();
	
	                if (presetPayMentMethod) {
	                    return presetPayMentMethod;
	                }
	
	                if (_index.$locale.country === 'DE') {
	                    return 'bank';
	                }
	                return 'card';
	            };
	
	            this.onboard = new _index7.$OnboardModel({
	
	                user: _index7.$OnboardUserModel.instance(this.token, {
	                    country: _index.$locale.country,
	                    countryOfResidence: _index.$locale.country,
	                    nationality: _index.$locale.country
	                }),
	
	                card: new _index8.$CardModel(),
	
	                bank: new _index8.$BankModel(),
	
	                fiMode: this.getDefaultFIMode(),
	
	                billing_address: _index8.$BillingAddressModel.create(this.token, {
	                    country: _index.$locale.country
	                }),
	                shipping_address: _index2.$ShippingAddressModel.create(this.token, {
	                    country: _index.$locale.country
	                }),
	
	                phone: new _index7.$OnboardPhoneModel(),
	
	                // If the country does NOT have a UI option for marketingOptin for user, then default this flag to true.
	                // If the country has marketing offer UI option then this value is controlled by what user selects
	                marketingOptin: !(0, _index.$feature)('marketingOptinMember'),
	
	                shipping_address_validation: false,
	                poma_flow: false
	            });
	
	            this.onboard.card.ppconversion = 'PAYPAL';
	        },
	        populate: function populate() {
	            var _this3 = this;
	
	            if (this.shippingRule && this.shippingRule.profileRulesSummary) {
	                this.flags.wps_SnT_flow = this.shippingRule.profileRulesSummary.isSnTEnabled;
	            }
	
	            // pre-fill user first name and last name.
	            // override happens at handlePrefillShippingAndBillingAddress if merchant passing
	            // shipping address during cart creation.
	            this.onboard.user.first_name = this.models.checkoutCart.payer && this.models.checkoutCart.payer.first_name;
	            this.onboard.user.last_name = this.models.checkoutCart.payer && this.models.checkoutCart.payer.last_name;
	
	            var setAllowShipToBilling = function setAllowShipToBilling(allow) {
	                // Toggle checkbox
	                _this3.flags.disallowShipToBilling = !allow;
	                // Show/Hide shipping address section
	                _this3.flags.shipToBilling = allow;
	            };
	
	            var checkProcessorDecline = function checkProcessorDecline() {
	                var processorDeclined = _this3.models.checkoutAppData.get('flags.processor_declined');
	                if (processorDeclined) {
	                    _this3.errorMessage = {
	                        msgs: [(0, _squid.$renderContent)('payment.processorDeclineMemberNoFIGeneric')],
	                        type: 'warning'
	                    };
	                }
	            };
	
	            var setChangeShippingCountryAlertMsg = function setChangeShippingCountryAlertMsg() {
	                var countryName = (0, _squid.$renderContent)('shippingCountry.' + _this3.merchantCountry);
	                var infoMessage = (0, _squid.$renderContent)('largeScreenPayment.blockNonDomesticShippingAlert', { shippingCountry: countryName });
	                _this3.changeShippingCountryAlert = {
	                    msgs: [infoMessage],
	                    type: 'info'
	                };
	            };
	
	            // pre-populate shipping and billing address
	            var updateShippingAndBillingAddress = function updateShippingAndBillingAddress(shippingAddress, billingAddress) {
	                // Detect invalid length country codes in which case we invalidate the country code.
	                // A default value of $locale.country will subsequently be picked up for invalidated country codes in the model creation.
	                if (shippingAddress && shippingAddress.country_code && shippingAddress.country_code.length !== 2) {
	                    shippingAddress.country_code = undefined;
	                }
	
	                if (billingAddress && billingAddress.country_code && billingAddress.country_code.length !== 2) {
	                    billingAddress.country_code = undefined;
	                }
	                // pre-fill billing address with shipping address
	                _this3.onboard.shipping_address = _index2.$ShippingAddressModel.create(_this3.token, {
	                    country: shippingAddress.country_code || _index.$locale.country
	                }, shippingAddress);
	
	                // pre-fill provided billing address
	                _this3.onboard.billing_address = _index8.$BillingAddressModel.create(_this3.token, {
	                    country: billingAddress.country_code || _index.$locale.country
	                }, billingAddress);
	            };
	
	            var showGenericError = function showGenericError(code) {
	                return function () {
	                    _uiRouter.$state.go('checkout.genericError', { code: code });
	                };
	            };
	            // handle billing and shipping address prefill scenarios
	            var handlePrefillShippingAndBillingAddress = function handlePrefillShippingAndBillingAddress(allowPrefillShippingAddress, prefilledAddress, prefilledBillingAddress) {
	                // if both shipping and billing addresses are provided
	                if (allowPrefillShippingAddress && prefilledAddress && prefilledBillingAddress) {
	                    updateShippingAndBillingAddress(prefilledAddress, prefilledBillingAddress);
	
	                    // uncheck ship to billing checkbox
	                    _this3.flags.shipToBilling = false;
	                } else if (allowPrefillShippingAddress && prefilledAddress) {
	                    // if only shipping address is provided
	
	                    // pre-fill user first name and last name
	                    _this3.onboard.user.first_name = prefilledAddress.first_name;
	                    _this3.onboard.user.last_name = prefilledAddress.last_name;
	
	                    updateShippingAndBillingAddress(prefilledAddress, prefilledAddress);
	                    if (!_this3.flags.allowEditShipping) {
	                        _this3.flags.shipToBilling = false;
	                    }
	                } else if (prefilledBillingAddress) {
	                    // if only billing address is provided
	                    updateShippingAndBillingAddress(prefilledBillingAddress, prefilledBillingAddress);
	                }
	            };
	
	            // remove this upon oas ramp completion
	            this.onboard.testParams = {
	                oas: _index.$util.param('oas'),
	                cardCandidate: _index.$util.param('cardCandidate')
	            };
	
	            this.$on('localeChange', function () {
	                _this3.onboard.fiMode = _this3.getDefaultFIMode();
	                _this3.onboard.billing_address.country = _index.$locale.country;
	                _this3.onboard.user.country = _index.$locale.country;
	                _this3.onboard.user.nationality = _index.$locale.country;
	                _this3.onboard.marketingOptin = !(0, _index.$feature)('marketingOptinMember');
	                _this3.setBackButtonForWebview();
	
	                if (_this3.flags.disableChangeShippingCountry) {
	                    if (_this3.flags.allowEditShipping) {
	                        setAllowShipToBilling(_index.$locale.country === _this3.merchantCountry);
	                    }
	                } else {
	                    _this3.onboard.shipping_address.country = _index.$locale.country;
	                }
	            });
	
	            this.$on('contentChange', function () {
	                if (_this3.flags.disableChangeShippingCountry) {
	                    setChangeShippingCountryAlertMsg();
	                }
	            });
	
	            this.$on('signupClickedTimerStarted', function (event, time) {
	                _this3.signupClickedStartTime = time;
	            });
	
	            this.redirect = function () {
	                _logger.$logger.info('basl_throttle_test_login');
	                (0, _squid.$dispatch)('hermes', {
	                    hermesLoginRedirect: 'xoon',
	                    token: _this3.token,
	                    'locale.x': _index.$locale.lang + '_' + _index.$locale.country,
	                    'country.x': _index.$locale.country
	                });
	            };
	
	            this.$watch('flags.shipToBilling', function (shipToBilling) {
	                if (!shipToBilling && _this3.flags.allowEditShipping) {
	                    $.each(_this3.onboard.billing_address, function (key, val) {
	                        if (angular.isString(_this3.onboard.billing_address[key]) && !_this3.onboard.shipping_address[key]) {
	                            _this3.onboard.shipping_address[key] = val;
	                        }
	                    });
	
	                    _this3.onboard.shipping_address.first_name = _this3.onboard.shipping_address.first_name || _this3.onboard.user.first_name;
	                    _this3.onboard.shipping_address.last_name = _this3.onboard.shipping_address.last_name || _this3.onboard.user.last_name;
	                }
	            });
	
	            // Format address to display when store pick is selected
	            var formatAddress = function formatAddress(address) {
	
	                var COMMA = ', ';
	                var SPACE = ' ';
	
	                function prefix(str, prefixStr) {
	                    if (str) {
	                        return (prefixStr ? prefixStr : '') + str;
	                    }
	                    return '';
	                }
	
	                var displayLine1 = (address.line1 ? address.line1 : '') + (address.line2 ? prefix(address.line2, COMMA) : '');
	                var displayLine2 = (address.city ? prefix(address.city) : '') + (address.state ? prefix(address.state, COMMA) : '') + (address.postal_code ? prefix(address.postal_code, SPACE) : '');
	                var displayLine3 = address.country ? prefix(address.country) : '';
	
	                return {
	                    displayLine1: displayLine1,
	                    displayLine2: displayLine2,
	                    displayLine3: displayLine3
	                };
	            };
	
	            var storePickUpSelected = _angular.$rootScope.$on('store_pick_up_selected', function (event) {
	                if (_this3.flags.shipToBilling) {
	                    _this3.shippingAddress = formatAddress(_this3.onboard.billing_address);
	                } else {
	                    _this3.shippingAddress = formatAddress(_this3.onboard.shipping_address);
	                }
	            });
	
	            this.$on('$destroy', storePickUpSelected);
	
	            var showErrorFields = _angular.$rootScope.$on('showErrorFields', function (event) {
	                _this3.toggleAddressFieldsValidation(true);
	            });
	
	            this.$on('$destroy', showErrorFields);
	
	            var hideErrorFields = _angular.$rootScope.$on('hideErrorFields', function (event) {
	                _this3.toggleAddressFieldsValidation(false);
	            });
	
	            this.$on('$destroy', hideErrorFields);
	
	            // useraction flag
	            var useraction = this.models.checkoutAppData.useraction();
	            this.flags.commit = useraction && useraction.toLowerCase() === 'commit';
	            _logger.$logger.info('checkout_fpti', {
	                'billing_page_button_text': this.flags.commit ? 'paynow_y' : 'paynow_n'
	            });
	
	            this.wpsFlow = this.models.checkoutAppData.doec_on_approve();
	
	            // show shipping address based on merchant passed in parameter
	            this.showShippingAddress = Boolean(!this.models.checkoutAppData.flags.hide_shipping_address && this.models.checkoutAppData.flags.shipping_address_required);
	
	            this.isInstantUpdateFlow = this.models.checkoutCart.instantUpdateIntegration;
	            if (this.isInstantUpdateFlow) {
	                this.trackSntReq = {};
	            }
	
	            // flags.allowEditShipping = false, skip saving shipping address validation otherwise don't skip.
	            this.flags.allowEditShipping = this.models.checkoutAppData.get('flags.allow_change_shipping', false);
	
	            // saving in to user object so that email field pre-populate if its passed in from setEc.
	            this.onboard.user.email = this.models.checkoutCart.payer && this.models.checkoutCart.payer.email;
	
	            this.getPageTitle = function () {
	                if (_this3.models.checkoutInputData.isEbayTxn()) {
	                    // prox signup flow title
	                    return _index.$locale.content.get('signupAccountCreation.heading');
	                } else if (_this3.onboard.fiMode === 'bank') {
	                    return _index.$locale.content.get('largeScreenPayment.bankTitle');
	                } else if (_this3.models.checkoutCart.isWalletTokenization()) {
	                    return _index.$locale.content.get('common.createPayPalSubTitleSignup');
	                } else if (_this3.mode === 'signup') {
	                    return _index.$locale.content.get('largeScreenPayment.signupTitle');
	                } else {
	                    return _index.$locale.content.get('largeScreenPayment.title');
	                }
	            };
	            this.getPageTitleProps = function () {
	                if (_this3.models.checkoutCart.isWalletTokenization()) {
	                    return _index.$locale.content.get('signup.androidPayTitleProp');
	                } else {
	                    return _index.$locale.content.get('largeScreenPayment.titleProp');
	                }
	            };
	
	            // *** NOTE:
	            // PXP was initially intended to be used with login button, but we've opted to use back button
	            // page name and treatments still have login in the name though.
	            this.flags.backButtonWebview = false;
	            this.setBackButtonForWebview = function () {
	                if (_index10.$DeviceInfo.isWebView(false)) {
	                    var floatThrottle = parseFloat((0, _index.$feature)('webviewBackButtonThrottle', 0, _index.$locale.country));
	                    if (isNaN(floatThrottle)) {
	                        return;
	                    }
	
	                    _this3.flags.backButtonWebview = floatThrottle && (0, _squid.$experiment)('webview_backbutton_throttle', floatThrottle, _angular.$rootScope.token, {}) ? true : false;
	                    if (_this3.flags.backButtonWebview) {
	                        _logger.$logger.info('BACK_BUTTON_SHOWN_FOR_WEBVIEW');
	                    }
	                }
	            };
	
	            this.setBackButtonForWebview();
	
	            // Set the upop interstitional continue button content key value
	            if (this.wpsFlow) {
	                this.upopConfirmButtonTextKey = 'confirmUpop.confirmAndContinue';
	            } else if (this.flags.commit) {
	                this.upopConfirmButtonTextKey = 'confirmUpop.confirmAndPay';
	            } else {
	                this.upopConfirmButtonTextKey = 'confirmUpop.confirmAndContinueToMerch';
	            }
	
	            this.landingAbTestCheck = function () {
	                /**
	                 * Show the login button on xoon when:
	                 * - hermes redirects to xoon in xo-landing-router
	                 **/
	                return _squid.$meta.query && _squid.$meta.query.abTestThrottle === 'xoon' ? true : false;
	            };
	
	            // Get merchant passed shipping address from either purchase plan or billing agreement plan
	            var prefilledAddress = this.models.checkoutCart.get('purchase.shipping_address') || this.models.checkoutCart.get('billing.shipping_address');
	
	            var prefilledNumber = this.models.checkoutCart.get('purchase.phone_fields') || this.models.checkoutCart.get('billing.phone_fields');
	
	            if (prefilledNumber && prefilledNumber.telephone_country === _index.$locale.country) {
	                this.onboard.phone.telephone = prefilledNumber.normalized_phone_number;
	            }
	
	            var allowPrefillShippingAddress = !!prefilledAddress;
	
	            var prefilledBillingAddress = this.models.checkoutCart.get('billing_address');
	
	            this.merchantCountry = this.models.checkoutAppData.get('merchant.merchant_country', 'US');
	            var merchant = this.models.checkoutAppData.merchant;
	            this.merchant = merchant.brand_name || merchant.merchant_name || merchant.merchant_email;
	
	            if ((0, _index.$feature)('supportBlockNonDomesticShipping', false, this.merchantCountry)) {
	                this.flags.disableChangeShippingCountry = this.models.checkoutAppData.get('flags.block_non_domestic_shipping', false);
	
	                if (this.flags.disableChangeShippingCountry) {
	
	                    _logger.$logger.info('onboard_block_non_domestic_shipping', {
	                        block_non_domestic_shipping: this.flags.disableChangeShippingCountry,
	                        allow_change_shipping: this.flags.allowEditShipping,
	                        setec_shipping_country_code: prefilledAddress && prefilledAddress.country_code
	                    });
	
	                    if (!this.flags.allowEditShipping && prefilledAddress && prefilledAddress.country_code !== this.merchantCountry && prefilledAddress.country_code !== '') {
	                        _uiRouter.$state.go('checkout.genericError', {
	                            code: 'BLOCK_NON_DOMESTIC_SHIPPING'
	                        });
	                    }
	
	                    if (prefilledAddress && prefilledAddress.country_code !== this.merchantCountry) {
	                        allowPrefillShippingAddress = false;
	                    }
	
	                    setChangeShippingCountryAlertMsg();
	                    this.onboard.shipping_address.country = this.merchantCountry;
	
	                    // Show shipping address section if user locale is different from merchant country
	                    if (this.flags.allowEditShipping && _index.$locale.country !== this.merchantCountry) {
	                        setAllowShipToBilling(false);
	                    }
	                }
	            }
	
	            /**
	             * Handle Card-Type based Installments e.g. Brazil is card_type based installments,
	             * so fetch the installments during page load.
	             */
	            var handleCardTypeBasedInstallments = function handleCardTypeBasedInstallments() {
	
	                _this3.$watch('singlePagePaymentForm.$valid', function (newVal, oldVal) {
	                    var cardModel = _this3.onboard.card;
	
	                    if (newVal.luhn && newVal.luhn[0].$name === 'cardNumber') {
	                        cardModel.valid = false;
	                    } else {
	                        cardModel.valid = true;
	                    }
	                });
	
	                _this3.$watch(_this3.onboard.card.type, function (newValue, oldValue) {
	                    // Sanitize the values
	                    newValue = newValue ? newValue.replace(/ /g, '').toLowerCase() : null;
	
	                    var cardNetwork = void 0;
	                    if (newValue && _this3.installments && _this3.installments.length > 0) {
	
	                        _this3.installments.some(function cardCheck(card, index, array) {
	                            if (card.cardInfo && card.cardInfo.card_type && card.cardInfo.card_type.toLowerCase() === newValue) {
	                                // Card Network Found
	                                cardNetwork = card;
	                                return true;
	                            }
	                        });
	
	                        if (cardNetwork && cardNetwork.installment_options && cardNetwork.installment_options.length > 0) {
	                            // Card network && installments found
	                            if (cardNetwork.installment_options.length === 1) {
	                                _this3.singleStepModel.selectedInstallmentData = {
	                                    installment_option_selected: cardNetwork.installment_options[0],
	                                    preventChange: true
	                                };
	                            }
	
	                            _this3.singleStepModel.allowInstallments = true;
	                        } else {
	                            // Card network does not exists Or No installment found
	                            _this3.singleStepModel.allowInstallments = false;
	                        }
	                    } else {
	                        _this3.singleStepModel.allowInstallments = false;
	                    }
	                });
	                var installments = _index2.$InstallmentOptionsModel.instance(_this3.token);
	                installments.save({
	                    data: {
	                        payee: _this3.models.payee,
	                        checkoutCart: _this3.models.checkoutCart,
	                        checkoutAppData: _this3.models.checkoutAppData
	                    },
	                    success: function success(result) {
	                        _this3.installments = result.installments;
	                    }
	                });
	            };
	
	            /**
	             * Handle Issuer based Installments e.g. Mexico is issuer_based (bank) installments, so fetch the
	             * installments after user enters card number
	             */
	            var handleIssuerBasedInstallments = function handleIssuerBasedInstallments() {
	
	                _this3.cardNumberChanged = function (unformattedCardNumber) {
	
	                    if (unformattedCardNumber && unformattedCardNumber !== _this3.prevCardNumber) {
	
	                        // Make sure the Installments server is hit only once for a cardNumber
	                        _this3.prevCardNumber = unformattedCardNumber;
	                        var installments = _index2.$InstallmentOptionsModel.instance(_this3.token);
	                        installments.save({
	                            silent: true,
	                            data: {
	                                payee: _this3.models.payee,
	                                checkoutCart: _this3.models.checkoutCart,
	                                checkoutAppData: _this3.models.checkoutAppData,
	                                cc: unformattedCardNumber
	                            },
	                            success: function success(result) {
	
	                                _this3.installments = result;
	
	                                if (result.installment_options && result.installment_options.length > 0) {
	
	                                    _this3.issuerBasedInstallmentsRetrieved = true;
	
	                                    // reset the previously selected installment
	                                    _this3.singleStepModel.selectedInstallmentData = undefined;
	                                    if (result.installment_options.length === 1) {
	                                        _this3.singleStepModel.selectedInstallmentData = {
	                                            installment_option_selected: result.installment_options[0],
	                                            preventChange: true
	                                        };
	                                    }
	
	                                    _this3.singleStepModel.allowInstallments = true;
	                                } else {
	                                    _this3.singleStepModel.allowInstallments = false;
	                                }
	                            }
	                        });
	                    }
	                };
	            };
	
	            // Lookup installments only when amount is greater than zero.
	            // for ex: Billing Agreements can create with amount=zero.
	            if ((0, _index.$feature)('installments', false, _index.$locale.country) && this.models.checkoutCart.get('purchase.amounts.total.amount', 0) > 0) {
	
	                if ((0, _index.$feature)('issuerBasedInstallments', false, _index.$locale.country)) {
	                    // e.g. Mexico is issuer_based (bank) installments, so fetch the installments after user enters card number
	                    handleIssuerBasedInstallments();
	                } else {
	                    // e.g. Brazil is card_type based installments, so fetch the installments during page load.
	                    handleCardTypeBasedInstallments();
	                }
	            }
	
	            this.isInstallmentsVisible = function () {
	                if (!_this3.singleStepModel) {
	                    return false;
	                }
	                _this3.singleStepModel.onboard = _this3.onboard;
	
	                var model = _this3.onboard;
	                var hasConditionMet = _this3.singleStepModel.allowInstallments && model.card.number && (model.card.valid || _this3.issuerBasedInstallmentsRetrieved);
	                var isBilling = _this3.models.checkoutCart.isBilling();
	
	                return !isBilling && hasConditionMet;
	            };
	
	            checkProcessorDecline();
	
	            handlePrefillShippingAndBillingAddress(allowPrefillShippingAddress, prefilledAddress, prefilledBillingAddress);
	
	            var experienceInitiator = this.models.checkoutAppData.get('flags.payment_experience_initiator');
	            this.onboard.payment_experience_initiator = experienceInitiator;
	
	            this.isApac = function () {
	                return _index.$config.apacCountries && _index.$config.apacCountries.indexOf(_this3.locale.country) > -1;
	            };
	
	            this.$on('MORSDisplayed', function (event, args) {
	                _this3.MORSDisplayed = args;
	            });
	
	            this.$on('MORSNotDisplayed', function (event, args) {
	                _this3.MORSDisplayed = {};
	            });
	
	            var handleCardContingencySignup = function handleCardContingencySignup() {
	                if (_this3.models.checkoutInputData.isEbayTxn()) {
	                    (0, _squid.$dispatch)('prox', {
	                        action: 'login'
	                    });
	                } else {
	                    // redirect to hermes and we will see add card page
	                    (0, _squid.$dispatch)('hermes', {
	                        redirectToHermes: true,
	                        token: _this3.token,
	                        'locale.x': _index.$locale.lang + '_' + _index.$locale.country,
	                        'country.x': _index.$locale.country
	                    });
	                }
	            };
	
	            var handleCardContingencyGuest = function handleCardContingencyGuest() {
	                var msg = void 0;
	
	                if (_this3.models.payee.isGambling()) {
	                    msg = _index.$locale.content.get('creditcard.noEligibleFI');
	                } else if (_this3.onboard.billing_address.country === 'DE') {
	                    if (_this3.onboard.fiMode === 'bank') {
	                        delete _this3.onboard.bank;
	                        msg = _index.$locale.content.get('creditcard.cannotUseBank');
	                        _this3.onboard.fiMode = 'card';
	                    } else {
	                        msg = _index.$locale.content.get('creditcard.cannotUseCard');
	                    }
	                } else {
	                    msg = _index.$locale.content.get('creditcard.errorInstrumentRefused');
	                }
	
	                _this3.errorMessage = {
	                    msgs: [msg],
	                    type: 'error'
	                };
	                return _angular.$q.reject();
	            };
	
	            var handleCardContingency = function handleCardContingency(action) {
	                return _this3.flags.mode === 'signup' ? handleCardContingencySignup() : handleCardContingencyGuest();
	            };
	
	            var show3DSLightbox = function show3DSLightbox(checkoutSession) {
	
	                _this3.resolve_3ds_data = {
	                    cc_id: checkoutSession.get('resolve_3ds.ccId'),
	                    flow_id: 'HERMES',
	                    merchant_id: _this3.models.payee.get('merchant.id'),
	                    merchant_country_code: _this3.models.checkoutAppData.get('merchant.merchant_country'),
	                    transaction_amount_currency: _this3.models.checkoutCart.get('purchase.amounts.total.currency_code'),
	                    transaction_amount_value: _this3.models.checkoutCart.get('purchase.amounts.total.amount')
	
	                };
	                _this3.launch3DSResolver = true;
	            };
	
	            var isDCCEligible = function isDCCEligible(checkoutSession) {
	                var isGuest = _this3.flags.mode !== 'signup';
	                var hasCurrencyConversion = checkoutSession.get('plan.conversion.paypal') && checkoutSession.get('plan.conversion.changeable');
	
	                if (!(isGuest && hasCurrencyConversion)) {
	                    return false;
	                }
	
	                return _this3.flags.dccCountryEligibility;
	            };
	
	            /*
	             * This function will determine final route of the transaction:
	             * 1. return to merchant for all none WPS traffic
	             * 2. go to checkout done page for WPS with not eligible interstitial traffic
	             * 3. got to WPS interstitial for eligible(passes upgrade eligibility) WPS traffic
	             */
	            var finalRoute = function finalRoute() {
	
	                if (_this3.wpsFlow) {
	                    _this3.singleStepModel.onboard = _this3.onboard;
	                    _this3.singleStepModel.flags = _this3.flags;
	                    // set signup/guest flag so done page
	                    // renders the proper content
	                    _angular.$rootScope.mode = _this3.flags && _this3.flags.mode;
	                    if (_this3.flags.wpsInterstitialEligible) {
	                        if (_this3.flags.buyerMode === 'signup') {
	                            return _uiRouter.$state.go('checkout.done');
	                        }
	                        return _this3.onboard.action('upgradeValidate', {
	
	                            data: _this3.onboard.serialize(),
	
	                            success: function success() {
	                                return _uiRouter.$state.go('checkout.guest.guestUpgradeInterstitial');
	                            },
	                            contingencies: {
	                                CC_LINKED: function CC_LINKED() {
	                                    _logger.$logger.info('wps_interstitial_ineligible_CC_LINKED');
	                                    return _uiRouter.$state.go('checkout.done'); // guest done page
	                                },
	                                EXISTING_MEMBER: function EXISTING_MEMBER() {
	                                    _logger.$logger.info('wps_interstitial_ineligible_EXISTING_MEMBER');
	                                    return _uiRouter.$state.go('checkout.done'); // guest done page
	                                },
	                                CC_LINKED_TO_FULL_ACCOUNT: function CC_LINKED_TO_FULL_ACCOUNT() {
	                                    _logger.$logger.info('wps_interstitial_ineligible_CC_LINKED_TO_FULL_ACCOUNT');
	                                    return _uiRouter.$state.go('checkout.done');
	                                },
	                                VALIDATION_ERROR: function VALIDATION_ERROR() {
	                                    _logger.$logger.info('wps_interstitial_ineligible_VALIDATION_ERROR');
	                                    return _uiRouter.$state.go('checkout.done');
	                                },
	                                DEFAULT: function DEFAULT() {
	                                    _logger.$logger.info('wps_interstitial_ineligible - Unhandled contingency');
	                                    return _uiRouter.$state.go('checkout.done');
	                                }
	                            },
	                            validation: function validation(res) {
	                                _logger.$logger.info('wps_interstitial_ineligible_SERVICE_VALIDATION_ERROR');
	                                return _uiRouter.$state.go('checkout.done');
	                            },
	                            error: function error(res) {
	                                _logger.$logger.info('wps_interstitial_ineligible_SERVICE_ERROR');
	                                return _uiRouter.$state.go('checkout.done');
	                            }
	                        });
	                    } else {
	                        if (_this3.flags.poma_flow) {
	                            _logger.$logger.info('LOGGING_OUT_WPS_POMA_FLOW_FOR_CLEARING_COOKIES');
	                            // Logging out the user only for POMA before going to END state.
	                            // why are we logging out?
	                            // ACCESS_TOKEN dropped during passive login is 8hr expiration, due to which
	                            // user is not authenticated in subsequent transaction in hermes review page
	                            // while adding FI or Shipping Address.
	                            // so by logging out the user, removes all the cookies except RT from the
	                            // browser in which hermes does RT to AT exchange in the absence of AT and gets
	                            // the limited AccessToken.
	                            return _this3.models.auth.action('logout').then(function () {
	                                return _uiRouter.$state.go('checkout.done');
	                            });
	                        }
	                        // wps done route
	                        return _uiRouter.$state.go('checkout.done');
	                    }
	                } else {
	                    if (_this3.flags.poma_flow) {
	                        _logger.$logger.info('LOGGING_OUT_POMA_FLOW_FOR_CLEARING_COOKIES');
	                        // Logging out the user only for POMA before going to END state.
	                        // why are we logging out?
	                        // ACCESS_TOKEN dropped during passive login is 8hr expiration, due to which
	                        // user is not authenticated in subsequent transaction in hermes review page
	                        // while adding FI or Shipping Address.
	                        // so by logging out the user, removes all the cookies except RT from the
	                        // browser in which hermes does RT to AT exchange in the absence of AT and gets
	                        // the limited AccessToken.
	                        return _this3.models.auth.action('logout').then(function () {
	                            return _uiRouter.$state.go('checkout.end');
	                        });
	                    }
	                    // end otherwise
	                    return _uiRouter.$state.go('checkout.end');
	                }
	            };
	
	            // TODO: need to test this
	            var handleSignupFlow = function handleSignupFlow() {
	
	                if (_this3.experiments.signupOnetouch) {
	                    /* Returns the flow name */
	                    var flowName = _pxpExperimentConstants2['default'].test['onetouch'][_this3.experiments.signupOnetouch.treatment_name];
	                    if (['signUpVariantOne', 'signUpVariantTwo'].indexOf(flowName) > -1) {
	                        return upsellOptInDisplayed().then(function () {
	                            if (_this3.upsellOptInDisplayed) {
	                                // If the optin upsell is already displayed, no need to display again.
	                                // go to end state.
	                                return _uiRouter.$state.go('checkout.end');
	                            } else {
	                                /* Route to one touch interstitial page*/
	                                return _uiRouter.$state.go('checkout.signup.oneTouchUpsell', { oneTouchFlowName: flowName });
	                            }
	                        });
	                    }
	                }
	                // goto end state
	                return finalRoute();
	            };
	
	            var handleSignupOrEnd = function handleSignupOrEnd() {
	                if (_this3.mode === 'signup') {
	                    return handleSignupFlow();
	                } else {
	                    return finalRoute();
	                }
	            };
	
	            var authorize = function authorize() {
	                var checkoutSession = _index2.$CheckoutSessionModel.instance(_this3.token);
	
	                return checkoutSession.action('authorize', {
	                    success: function success() {
	                        if (_this3.wpsFlow) {
	                            return checkInventoryAndPay(checkoutSession);
	                        } else if (_this3.models.checkoutInputData.isEbayTxn()) {
	                            return finalRoute();
	                        } else {
	                            return handleSignupOrEnd();
	                        }
	                    }
	                });
	            };
	
	            var postCheckoutSessionOperations = function postCheckoutSessionOperations(dccComplete) {
	                var checkoutSession = _index2.$CheckoutSessionModel.instance(_this3.token);
	
	                if (!dccComplete && isDCCEligible(checkoutSession) && !_this3.experiments.nonVisaDcc) {
	                    _logger.$logger.info('render_currency_conversion_lightbox');
	                    if (_this3.flags.wpsInterstitialEligible) {
	                        _logger.$logger.info('wps_interstitial_render_dcc');
	                    }
	                    _this3.launchCurrencyConversionLightbox = true;
	                    return;
	                }
	
	                if (checkoutSession.resolve_3ds) {
	                    return show3DSLightbox(checkoutSession);
	                }
	
	                return _angular.$q.when((0, _sticky.setStickyInstrument)(checkoutSession))['catch'](function (err) {
	                    _logger.$logger.info('setStickyFI Failed', err);
	                })['finally'](authorize);
	            };
	
	            this.onCompleteDCC = function (result) {
	                if (result === 'close') {
	                    _this3.launchCurrencyConversionLightbox = false;
	                    return;
	                } else {
	                    _this3.launchCurrencyConversionLightbox = false;
	                    return postCheckoutSessionOperations(true);
	                }
	            };
	
	            var upsellOptInDisplayed = function upsellOptInDisplayed() {
	                return _index9.$AuthModel.instance().retrieve().then(function (auth) {
	                    if (auth.upsellOptInDisplayed) {
	                        _this3.upsellOptInDisplayed = true;
	                    }
	                });
	            };
	
	            var makePayment = function makePayment(checkoutSession) {
	                var wpsParams = _index.$util.decodeAndParse(_squid.$meta.xclickParams);
	
	                return checkoutSession.action('createPayment', {
	                    data: {
	                        payer_id: checkoutSession.payer && checkoutSession.payer.id,
	                        intent: _this3.models.checkoutCart.payment_action,
	                        wa_type: wpsParams && wpsParams.wa_type,
	                        correlation_id: _squid.$meta.correlationId,
	                        merchant_id: _this3.models.payee.get('merchant.id'),
	                        custom: _this3.models.checkoutCart.get('purchase.custom'),
	                        invoice: _this3.models.checkoutCart.get('purchase.invoice')
	                    },
	
	                    success: function success(result) {
	                        _angular.$rootScope.paymentComplete = true;
	                        _this3.onboard.payerId = checkoutSession.payer && checkoutSession.payer.id;
	                        _this3.onboard.transaction = result.transactionDetails && result.transactionDetails.id;
	                        if (_index.$config.enableShoppingCartWPS && _this3.models.checkoutAppData.flags.is_shopping_cart_flow) {
	                            markCartCheckedout();
	                        }
	                        return finalRoute();
	                    },
	                    contingencies: {
	                        TRANSACTION_REFUSED: handlePaymentContingencies('TRANSACTION_REFUSED'),
	                        INSTRUMENT_DECLINED: function INSTRUMENT_DECLINED() {
	                            inventoryOperation('failed');
	                            var param = {
	                                mode: _this3.flags.mode
	                            };
	                            _uiRouter.$state.go('checkout.pageAddCard.addCardFlow.addCard', param);
	                        },
	                        PAYEE_BLOCKED_TRANSACTION: handlePaymentContingencies('PAYMENT_DENIED'),
	                        DUPLICATE_TRANSACTION: handlePaymentContingencies('PAYMENT_ALREADY_DONE'),
	                        DEFAULT: handlePaymentContingencies('DEFAULT')
	                    },
	                    error: function error(err) {
	                        _logger.$logger.info('createPayment Failed due to service error', err);
	                        inventoryOperation('failed');
	                        return _uiRouter.$state.go('checkout.genericError', { code: 'DEFAULT' });
	                    }
	                });
	            };
	
	            var inventoryOperation = function inventoryOperation(paymentStatus) {
	                var cartHasInventory = _this3.models.checkoutCart.get('cartHasInventory');
	                if (cartHasInventory) {
	                    var inventoryModel = _index6.$InventoryModel.instance(_angular.$rootScope.token);
	                    var inventoryItems = inventoryModel.getInventoryItems();
	                    var purchaseItems = _this3.models.checkoutCart.get('purchaseUnits');
	                    var cartItems = void 0,
	                        inventoryPatchInput = {};
	                    if (purchaseItems && purchaseItems[0] && purchaseItems[0].item_list) {
	                        cartItems = purchaseItems[0].item_list.items;
	                    }
	                    paymentStatus = paymentStatus ? paymentStatus : 'success';
	                    if (cartItems && inventoryItems) {
	                        inventoryPatchInput = {
	                            inventoryItems: inventoryItems,
	                            cartItems: cartItems,
	                            merchantId: _this3.models.payee.get('merchant.id', ''),
	                            paymentStatus: paymentStatus
	                        };
	                    } else {
	                        return _angular.$q.when(); // don't need to call patchInventory if items not present
	                    }
	
	                    return inventoryModel.action('patchInventory', {
	                        data: inventoryPatchInput,
	                        success: function success(patchResponse) {
	                            if (patchResponse) {
	                                if (patchResponse.showSoldoutPage) {
	                                    // show soldout page
	                                    return {
	                                        soldoutpage: true,
	                                        items: patchResponse.soldoutItems,
	                                        soldOutUrl: patchResponse.soldoutUrl
	                                    };
	                                } else if (patchResponse.patchCart) {
	                                    var purchase_unit = _this3.models.checkoutCart.get('purchaseUnits')[0];
	                                    purchase_unit.item_list.items = patchResponse.cartItems;
	                                    var patchCartPayload = {
	                                        id: _this3.token,
	                                        patchEntities: [{
	                                            field: 'inventoryItems',
	                                            value: purchase_unit.item_list.items
	                                        }]
	                                    };
	
	                                    return _this3.models.checkoutCart.action('patchCartData', {
	                                        data: patchCartPayload
	                                    });
	                                }
	                            } else {
	                                return;
	                            }
	                        }
	                    });
	                } else {
	                    return _angular.$q.when(); // not an inventory request proceed with existing flow
	                }
	            };
	
	            var checkInventoryAndPay = function checkInventoryAndPay(checkoutSession) {
	                return inventoryOperation().then(function (result) {
	                    if (result && result.soldoutpage) {
	                        return _uiRouter.$state.go('checkout.soldout', {
	                            items: encodeURIComponent(result.items),
	                            soldOutUrl: encodeURIComponent(result.soldOutUrl)
	                        });
	                    }
	                    return makePayment(checkoutSession);
	                });
	            };
	
	            var handlePaymentContingencies = function handlePaymentContingencies(code) {
	                return function () {
	                    inventoryOperation('failed');
	                    return _uiRouter.$state.go('checkout.genericError', { code: code });
	                };
	            };
	
	            var markCartCheckedout = function markCartCheckedout() {
	                var shoppingCartModel = _index4.$ShoppingCartModel.instance(_angular.$rootScope.token);
	                return shoppingCartModel.action('cartCheckedOut', {
	                    data: {
	                        payee_email: _this3.models.checkoutAppData.get('merchant.merchant_email')
	                    },
	                    success: function success(result) {
	                        _logger.$logger.info('cart checked out successfully');
	                    }
	                });
	            };
	
	            var mapValidationErrors = function mapValidationErrors(err) {
	                var fields = err && err.fields || [];
	                fields.forEach(function (fieldError) {
	                    if (fieldError && fieldError.property) {
	                        fieldError.field = fieldError.property;
	                    }
	                });
	                return {
	                    fields: fields
	                };
	            };
	
	            this.handleFIContingencies = function (data, fundingInstrument) {
	                _this3.errorMessage = _util.$fiErrorUtil.addPageErrors(data, fundingInstrument);
	
	                if (!_this3.errorMessage) {
	                    _this3.errorMessage = {
	                        msgs: [_index.$locale.content.get(fundingInstrument + '.errorGeneral')],
	                        type: 'error'
	                    };
	                }
	
	                errorHandlerHelper.scrollToElement();
	            };
	
	            var getContentIdentifier = function getContentIdentifier(tcpaIdentifier) {
	                return _index.$locale.country + ':' + _index.$locale.lang + ':' + (0, _squid.$contentVersion)() + ':' + tcpaIdentifier;
	            };
	
	            /*
	             * onBoardAccount and functions calling onBoardAccount
	             */
	            this.onBoardAccount = function () {
	
	                // remove the page level errors
	                _this3.errorMessage = '';
	
	                // creating this variable shipping_address_validation for back-end whether to validate
	                // the shipping address or not.
	                // shipping address validation required only when shipping address is different than Billing Address
	                // shipToBilling flag will be false when user tries to expand the shipping address in Billing Page
	                _this3.onboard.shipping_address_validation = _this3.flags.allowEditShipping && !_this3.flags.shipToBilling;
	                _this3.onboard.billing_address.country = _index.$locale.country;
	
	                _this3.onboard.skipInitiateAuth = true;
	
	                _this3.onboard.poma_flow = _this3.flags.poma_flow;
	                _this3.onboard.content_identifier = getContentIdentifier(_this3.flags.tcpa_identifier);
	                _this3.onboard.prox_flow = _this3.models.checkoutInputData.isEbayTxn();
	
	                var action = void 0;
	                // POMA should go in Singup rails, because poma usecase is passwordless member
	                if (_this3.flags.poma_flow) {
	                    action = 'signup';
	                } else {
	                    action = _this3.flags.mode === 'signup' ? 'signup' : 'guest';
	                }
	
	                return _this3.onboard.action(action, {
	
	                    data: _this3.onboard.serialize(),
	
	                    success: function success() {
	                        return _angular.$q.when().then(function () {
	                            if (_this3.flags.poma_flow) {
	                                var locale_code = _index.$locale.lang + '_' + _index.$locale.country;
	                                var locale_country = _index.$locale.country;
	                                return _ul.$ul.optInToOneTouch(_this3.token, locale_country, locale_code).then(function (success) {
	                                    _logger.$logger.info('UL_SUCCESSFULLY_DROPPED_RT_IN_COOKIE');
	                                }, function (err) {
	                                    // eslint-disable-line handle-callback-err
	                                    _logger.$logger.info('UL_FAILED_DROPPED_RT_IN_COOKIE');
	                                });
	                            }
	                        }).then(function () {
	                            if (_this3.models.checkoutCart.isWalletTokenization()) {
	                                (0, _squid.$dispatch)('hermes', {
	                                    token: _this3.token,
	                                    'locale.x': _index.$locale.lang + '_' + _index.$locale.country,
	                                    'country.x': _index.$locale.country
	                                });
	                            } else {
	                                // fire conversion url for MORS offer in the sign up section, ad_id = 202002
	                                if (_this3.MORSDisplayed && _this3.MORSDisplayed.placementId === '202002') {
	                                    _index11.$fireMORSBeacon.fireBeacon(_this3.MORSDisplayed.clickURL);
	                                }
	
	                                if (_this3.onboard.card && _this3.onboard.card.type === 'CUP' && _this3.onboard.fundingId) {
	                                    _this3.onboard.card.id = _this3.onboard.fundingId;
	                                    _this3.launchUpopScreen = true;
	                                } else {
	                                    // Create Checkout-Session
	                                    return createXO();
	                                }
	                            }
	                        });
	                    },
	
	                    contingencies: {
	                        TRANSACTION_REFUSED: showGenericError('TRANSACTION_REFUSED'),
	                        CC_LINKED_TO_FULL_ACCOUNT: function CC_LINKED_TO_FULL_ACCOUNT() {
	                            _this3.errorMessage = {
	                                msgs: errorHandlerHelper.getPageError('creditcard.linkedCardToAddNewCard'),
	                                type: 'error'
	                            };
	                        },
	                        BANK_LINKED_TO_FULL_ACCOUNT: function BANK_LINKED_TO_FULL_ACCOUNT() {
	                            _this3.errorMessage = {
	                                msgs: errorHandlerHelper.getPageError('bank.linkedBankError'),
	                                type: 'error'
	                            };
	                        },
	                        EXISTING_ACCOUNT_RESTRICTED: function EXISTING_ACCOUNT_RESTRICTED() {
	                            _this3.errorMessage = {
	                                msgs: errorHandlerHelper.getPageError('creditcard.riskDisallowed'),
	                                type: 'error'
	                            };
	                        },
	                        TOO_MANY_REQUESTS: function TOO_MANY_REQUESTS() {
	                            _this3.errorMessage = {
	                                msgs: errorHandlerHelper.getPageError('genericError.genericError'),
	                                type: 'error'
	                            };
	                        },
	                        VALIDATE_BANK_CONTINGENCY: function VALIDATE_BANK_CONTINGENCY(name, data) {
	                            _this3.errorMessage = _util.$fiErrorUtil.addPageErrors(data, _this3.locale, 'bank');
	                            _util.$fiErrorUtil.addFieldErrors(data, _this3.sectionElement);
	                        },
	                        ADD_CARD_CONTINGENCY: function ADD_CARD_CONTINGENCY(result, err) {
	                            _this3.handleFIContingencies(err, 'creditcard');
	                        },
	                        ADD_BANK_CONTINGENCY: function ADD_BANK_CONTINGENCY(result, err) {
	                            _this3.handleFIContingencies(err, 'bank');
	                        },
	                        RISK_DISALLOWED: function RISK_DISALLOWED() {
	                            _this3.errorMessage = {
	                                msgs: errorHandlerHelper.getPageError('creditcard.riskDisallowed'),
	                                type: 'error'
	                            };
	                        },
	                        VALIDATION_ERROR: function VALIDATION_ERROR(message, errorData) {
	                            var errorMsgs = errorHandlerHelper.errorHandler(message, errorData, _this3.actions.positionToErrorField);
	
	                            if (errorMsgs && errorMsgs.length > 0) {
	                                _this3.errorMessage = {
	                                    msgs: errorMsgs,
	                                    type: 'error'
	                                };
	                            }
	                        }
	                    },
	
	                    validation: function validation(res) {
	                        // should catch any primary check failures like schema validations etc
	                        _util.$fiErrorUtil.addFieldErrors(mapValidationErrors(res), _this3.sectionElement);
	                    }
	                });
	            };
	
	            var addShippingAddress = function addShippingAddress() {
	
	                return _squid.$promise.call(function () {
	                    // Add shipping address if edit shipping is allowed. this.flags.allowEditShipping flag used
	                    // to show "ship to Billing" checkbox
	                    if (_this3.flags.allowEditShipping) {
	                        var shippingAddress = _this3.onboard.shipping_address;
	                        shippingAddress.recipient_name = shippingAddress.first_name + ' ' + shippingAddress.last_name;
	                        return shippingAddress.save({
	                            data: _this3.onboard.shipping_address.serialize(),
	                            validation: function validation(message, errorData) {
	                                var errorMsgs = errorHandlerHelper.errorHandler(message, errorData, _this3.actions.positionToErrorField);
	
	                                if (errorMsgs && errorMsgs.length > 0) {
	                                    _this3.errorMessage = {
	                                        msgs: errorMsgs,
	                                        type: 'error'
	                                    };
	                                }
	                            }
	                        });
	                    }
	                });
	            };
	
	            var createXO = function createXO() {
	                var checkoutSession = _index2.$CheckoutSessionModel.instance(_this3.token);
	
	                return checkoutSession.action('create', {
	                    data: {
	                        fraudnet_id: _this3.models.checkoutCart.supplementary && _this3.models.checkoutCart.supplementary.risk_correlation_id,
	                        baToken: _this3.models.checkoutCart.billing && _this3.models.checkoutCart.billing.ba_token
	                    },
	
	                    success: function success() {
	
	                        return _angular.$q.when().then(function () {
	
	                            return addShippingAddress();
	                        }).then(function () {
	                            /*
	                             * If checkoutSession has DCC enabled, then we do updateConversion call and upate to VENDOR if:
	                             * 1. Pre-Plan (Non-Visa DCC) if VENDOR was selected in interstitial from link on Billing page,
	                             *    otherwise PAYPAL is default selection.
	                             * 2. Post-Plan (Visa DCC) default selection to VENDOR for signup case, since we don't show DCC
	                             *    interstitial for signup experience.
	                             */
	                            if (checkoutSession.get('plan.conversion.paypal') && checkoutSession.get('plan.conversion.changeable') && (_this3.flags.mode === 'signup' && !_this3.experiments.nonVisaDcc || _this3.onboard.card.ppconversion === 'VENDOR')) {
	                                return _index2.$FundingOptionsModel.instance(_this3.token).action('updateConversion', {
	                                    data: {
	                                        conversionType: 'VENDOR',
	                                        planId: checkoutSession.plan.id
	                                    }
	                                })['catch']();
	                            }
	                        }).then(function () {
	                            if (checkoutSession.get('cvvData')) {
	                                checkoutSession.set('cvvData.security_code', _this3.onboard.get('card.security_code'));
	                            }
	
	                            return _fiApis.$fiApis.patchCvv(checkoutSession).then(postCheckoutSessionOperations, function (err) {
	                                _logger.$logger.error('patchCvv error', err);
	                            });
	                        });
	                    },
	
	                    contingencies: {
	                        TRANSACTION_REFUSED: showGenericError('TRANSACTION_REFUSED'),
	                        NEED_SHIPPING_ADDRESS: function NEED_SHIPPING_ADDRESS() {
	                            return _this3.onboard.shipping_address.save({
	                                data: _this3.onboard.shipping_address.serialize(),
	                                validation: function validation(message, errorData) {
	                                    var errorMsgs = errorHandlerHelper.errorHandler(message, errorData, _this3.actions.positionToErrorField);
	
	                                    if (errorMsgs && errorMsgs.length > 0) {
	                                        _this3.errorMessage = {
	                                            msgs: errorMsgs,
	                                            type: 'error'
	                                        };
	                                    }
	                                }
	                            });
	                        },
	                        NEED_CREDIT_CARD_OR_BANK_ACCOUNT: function NEED_CREDIT_CARD_OR_BANK_ACCOUNT() {
	                            return handleCardContingency();
	                        },
	                        NEED_CREDIT_CARD: function NEED_CREDIT_CARD() {
	                            return handleCardContingency();
	                        },
	                        SENDING_LIMIT_EXCEEDED: function SENDING_LIMIT_EXCEEDED() {
	                            /* 1. Introducing config attribute sendingLimitNoFallback for certain countries right now
	                             only Japan, to go to generic error page in case of sending limit exceeded. this config
	                             will be removed once all countries have proper content available.
	                             2. Currently only guest mode will go to generic error page as signup mode need to handle
	                             SENDING_LIMIT_EXCEEDED AND TRANSACTION_LIMIT_EXCEEDED separately but we are not getting expected
	                             contingency from Symphony yet. Will remove scope.flags.mode === 'guest' condition once we are getting
	                             expected contingency back.
	                             */
	                            if ((0, _index.$feature)('sendingLimitNoFallback') && _this3.flags.mode === 'guest') {
	                                _uiRouter.$state.go('checkout.genericError', { code: 'TRANSACTION_LIMIT_EXCEEDED' });
	                            } else {
	                                throw new _index.$FallbackError({
	                                    reason: 'sending_limit_exceeded',
	                                    product: 'ux'
	                                });
	                            }
	                        },
	                        NEED_AUTHENTICATED_CARD: function NEED_AUTHENTICATED_CARD() {
	                            // Contingency purpose - Show OTP confirmation popup
	                            // As we have already presented user with OTP popup with
	                            // init call after add card (flag - launchUpopScreen),
	                            // we need to redirect user to hermes at this point
	                            (0, _squid.$dispatch)('hermes', {
	                                token: _this3.token,
	                                'locale.x': _index.$locale.lang + '_' + _index.$locale.country,
	                                'country.x': _index.$locale.country
	                            });
	                        }
	
	                    }
	                });
	            };
	
	            this.onUpopSuccess = function () {
	                _this3.launchUpopScreen = false;
	                return createXO();
	            };
	
	            this.onUpopCancel = function (errorData) {
	                _this3.launchUpopScreen = false;
	
	                if (_this3.flags.mode === 'signup') {
	                    // If signup user closes the OTP popup window(or some error in flow)
	                    // then call create checkout session, and this will intern redirect
	                    // to hermes with NEED_AUTHENTICATED_CARD contingency
	                    return createXO();
	                } else if (errorData) {
	
	                    // If guest user closes the OTP popup window(or some error in flow)
	                    // then show a page level error to the user
	                    // There is no redirect to hermes in guest case
	                    if (errorData && errorData.errorCodes && errorData.errorCodes[0] === 'RESTRICTED_CARD') {
	                        // Custom error messaging for RESTRICTED_CARD errorCode.
	                        // RESTRICTED_CARD_GUEST content key is applicable for both Guest & Signup flows.
	                        errorData.errorCodes[0] = 'RESTRICTED_CARD_GUEST';
	                    }
	
	                    // prop for last 4 digits of card in error message
	                    var prop = {
	                        number: _this3.onboard.card.last4()
	                    };
	                    _this3.errorMessage = _util.$fiErrorUtil.addPageErrors(errorData, 'confirmUpop', prop, 'error');
	                }
	            };
	
	            this.uponNormalization = function (normalizedAddress, isBack) {
	                _this3.showAddressNormalizationLightbox = false;
	
	                var newBilling = _index8.$BillingAddressModel.create(_this3.token, normalizedAddress, {
	                    id: '0'
	                });
	
	                _this3.onboard.billing_address = newBilling;
	
	                if (_this3.flags.shipToBilling) {
	                    _this3.onboard.shipping_address.first_name = _this3.onboard.user.first_name;
	                    _this3.onboard.shipping_address.last_name = _this3.onboard.user.last_name;
	                }
	
	                return _this3.onBoardAccount();
	            };
	
	            this.toggleAddressFieldsValidation = function (toggle) {
	
	                if (_this3.flags.shipToBilling) {
	                    _this3.billingAddressValidated = toggle;
	                } else {
	                    _this3.shippingAddressValidated = toggle;
	                }
	            };
	
	            /*
	             * Before submit the transaction, need to update shipping address if this.flags.shipToBilling is set
	             * Also update city/state/zip value if the city/state/zip element is not present for the selected country
	             * TODO: should enhance this function to compare the address entry from metadata based on country,
	             *       the tricky part is need to consider to load metadata separately for billing and shipping
	             *       if their country is different
	             */
	            this.updateAddressOnSubmit = function () {
	                var billingState = $('#billingAddress #state')[0] || $('#billingAddress #billingState')[0];
	                var shippingState = $('#shippingAddress #state')[0] || $('#shippingAddress #shippingState')[0];
	                var billingCity = $('#billingAddress #city')[0] || $('#billingAddress #billingCity')[0];
	                var shippingCity = $('#shippingAddress #city')[0] || $('#shippingAddress #shippingCity')[0];
	                var billingZip = $('#billingAddress #postalCode')[0] || $('#billingAddress #billingPostalCode')[0];
	                var shippingZip = $('#shippingAddress #postalCode')[0] || $('#shippingAddress #shippingPostalCode')[0];
	
	                // Before submit the onboarding request, we need to make sure billing address country code is user selected country
	                _this3.onboard.billing_address.country = _index.$locale.country;
	
	                if (!billingCity) {
	                    delete _this3.onboard.billing_address.city;
	                }
	
	                if (!billingState) {
	                    delete _this3.onboard.billing_address.state;
	                }
	
	                if (!billingZip) {
	                    delete _this3.onboard.billing_address.postal_code;
	                }
	
	                if (_this3.flags.shipToBilling) {
	                    _this3.onboard.shipping_address = _index2.$ShippingAddressModel.create(_this3.token, _this3.onboard.billing_address, {
	                        first_name: _this3.onboard.user.first_name,
	                        last_name: _this3.onboard.user.last_name
	                    });
	                } else {
	                    _this3.onboard.shipping_address.first_name = _this3.onboard.shipping_address.first_name || _this3.onboard.user.first_name;
	                    _this3.onboard.shipping_address.last_name = _this3.onboard.shipping_address.last_name || _this3.onboard.user.last_name;
	
	                    if (!shippingState) {
	                        delete _this3.onboard.shipping_address.state;
	                    }
	
	                    if (!shippingCity) {
	                        delete _this3.onboard.shipping_address.city;
	                    }
	
	                    if (!shippingZip) {
	                        delete _this3.onboard.shipping_address.postal_code;
	                    }
	
	                    // Shipping / Billing Address Difference Detection
	                    var addrDiffDetected = compareShippingBillingAddrs(_this3.onboard.shipping_address, _this3.onboard.billing_address);
	                    if (addrDiffDetected) {
	                        var addrDiff = {
	                            is_ship_addr_diff: 1,
	                            page: 'main:ec:hermes::fullpage-billing:guest:hermes:'
	                        };
	                        _angular.$rootScope.$broadcast('addrDiff', addrDiff);
	                    }
	                }
	            };
	
	            // Case insensitively compare all string properties of shipping and billing address to detect difference.
	            // This method is designed to work with any country with any set of address input fields.
	            var compareShippingBillingAddrs = function compareShippingBillingAddrs(shipping_addr, billing_addr) {
	                var diffDetected = false;
	
	                for (var prop in shipping_addr) {
	                    if (shipping_addr.hasOwnProperty(prop) && billing_addr.hasOwnProperty(prop)) {
	                        if (angular.isString(shipping_addr[prop]) && angular.isString(billing_addr[prop])) {
	                            if (shipping_addr[prop].toUpperCase() !== billing_addr[prop].toUpperCase()) {
	                                // Special handling for postal code
	                                if (prop === 'postal_code') {
	                                    diffDetected = checkZip(shipping_addr[prop], billing_addr[prop]);
	                                } else {
	                                    diffDetected = true;
	                                }
	                            }
	                        }
	                    }
	                }
	
	                // Special case zip check to ignore differences in zipcode format
	                function checkZip(zip1, zip2) {
	                    var longerZip = zip1.length > zip2.length ? zip1 : zip2;
	                    var shorterZip = longerZip === zip1 ? zip2 : zip1;
	                    if (longerZip.indexOf(shorterZip) > -1) {
	                        return false;
	                    }
	                    return true;
	                }
	
	                return diffDetected;
	            };
	
	            var enableSnT = function enableSnT() {
	                if (_this3.flags.wps_SnT_flow && !_this3.flags.allowSnTCall) {
	                    // SnT should be allowed if there is an contingency during OnBoard.
	                    _this3.flags.allowSnTCall = true;
	                }
	            };
	
	            var handleAllLoadedForSnT = _angular.$rootScope.$on('allLoaded', enableSnT);
	
	            this.$on('$destroy', handleAllLoadedForSnT);
	
	            var routeToHermesOn3DSDeclineForSignUp = function routeToHermesOn3DSDeclineForSignUp() {
	                // dispatch to hermesnodeweb up on 3DS authenticate decline.
	                _logger.$logger.info('xoon_to_hermes_redirect_on_signup_3DS_Authentication_decline');
	                (0, _squid.$dispatch)('hermes', {
	                    redirectToHermesOn3DSDecline: 'xoon',
	                    token: _this3.token,
	                    'locale.x': _index.$locale.lang + '_' + _index.$locale.country,
	                    'country.x': _index.$locale.country
	                });
	            };
	
	            /**
	             * call patchXO API to clear the 3DS contingency and then call authorize API.
	             */
	            var clear3DSContingency = function clear3DSContingency() {
	                var checkoutSession = _index2.$CheckoutSessionModel.instance(_this3.token);
	                return checkoutSession.action('clear3DSContingency', {
	                    data: {
	                        ccId: checkoutSession.resolve_3ds.ccId
	                    },
	                    success: function success() {
	                        // don't call authorize if the contingency is not cleared
	                        if (!checkoutSession.resolve_3ds) {
	                            return authorize();
	                        } else {
	                            _this3.errorMessage = {
	                                msgs: errorHandlerHelper.get3dsPageWarning(checkoutSession.resolve_3ds, 'threeDS.guestDeclineAfter3DSAccept'),
	                                type: 'warning'
	                            };
	                        }
	                    },
	                    contingencies: {
	                        // contingency may be "no cc" or any thing from clear3DSContingency(patch on xosession)
	                        // for "no cc" symphony throws NEED_CREDIT_CARD or NEED_CREDIT_CARD_OR_BANK_ACCOUNT
	                        DEFAULT: function DEFAULT(name, contingency) {
	                            _logger.$logger.info('clear3DSContingency_contingency', {
	                                'int_error_description': contingency && contingency.message,
	                                'contingency_name': name
	                            });
	
	                            if (_this3.flags.mode === 'signup') {
	                                // route to member review page upon patch xo throws contingency for signup
	                                routeToHermesOn3DSDeclineForSignUp();
	                            } else {
	                                _this3.errorMessage = {
	                                    msgs: errorHandlerHelper.get3dsPageWarning(checkoutSession.resolve_3ds, 'threeDS.guestDeclineAfter3DSAccept'),
	                                    type: 'warning'
	                                };
	                            }
	                        }
	                    }
	                });
	            };
	
	            this.onComplete3DSHandler = function (status) {
	                _this3.launch3DSResolver = false;
	                var checkoutSession = _index2.$CheckoutSessionModel.instance(_this3.token);
	                if (status === 'decline') {
	                    // Flow should route to member review page for sign up case
	                    // up on receiving "decline" response from 3DS authenticate call
	                    if (_this3.flags.mode === 'signup') {
	                        routeToHermesOn3DSDeclineForSignUp();
	                    } else {
	                        // guest case
	                        _this3.errorMessage = {
	                            msgs: errorHandlerHelper.get3dsPageWarning(checkoutSession.resolve_3ds, 'threeDS.guestDecline'),
	                            type: 'warning'
	                        };
	                    }
	                } else if (status === 'close') {
	                    // Closing the 3DS page should route the flow to member review for sign up case
	                    // because the member account is created already.
	                    // Guest remains in the Billing page, no re-direction.
	                    if (_this3.flags.mode === 'signup') {
	                        routeToHermesOn3DSDeclineForSignUp();
	                    }
	                } else if (status === 'success') {
	                    // Up on Successful authenticate, perform Patch on XO session and authorise.
	                    clear3DSContingency();
	                }
	            };
	
	            if (this.experiments.signupComplianceUS && this.experiments.signupComplianceUS.treatment_name === 'xo_xoonboarding_signupcompliance_us_test') {
	                this.showNewSignupComplianceExp = true;
	            }
	
	            // Get the submit button text content key based on different conditions
	            var getSubmitButtonTextKey = function getSubmitButtonTextKey() {
	
	                var getCommitOrContinueText = function getCommitOrContinueText(mode) {
	                    return _constants2['default'].submitButtonTextKeyMap[mode][_this3.showNewSignupComplianceExp ? 'US' : 'ROW'][_this3.flags.commit ? 'commit' : 'notCommit'];
	                };
	
	                if (_this3.flags.show_poma_ui) {
	                    return getCommitOrContinueText(_this3.flags.poma_flow ? 'pomaSignup' : 'guest');
	                } else {
	                    return getCommitOrContinueText(_this3.flags.mode === 'signup' ? 'signup' : 'guest');
	                }
	            };
	            // Added a function to set SepaOverlay flag based on pxp call
	            var setSepaOverlayFlag = function setSepaOverlayFlag() {
	                var sepaOverlayPXP = _this3.experiments.sepaOverlay;
	                if (sepaOverlayPXP && _this3.isUnbranded) {
	                    _logger.$logger.info('checkout_fpti', { is_sepaOverlay: 1 });
	
	                    _this3.flags.show_sepa_overlay = true;
	                } else {
	                    _logger.$logger.info('checkout_fpti', { is_sepaOverlay: 0 });
	                    _this3.flags.show_sepa_overlay = false;
	                }
	            };
	
	            setSepaOverlayFlag();
	
	            // will be called upon change in flags.mode and flags.poma_flow - opt-in or opt-out
	            var setSubmitButtonText = function setSubmitButtonText() {
	                _this3.submitButtonText = (0, _squid.$renderContent)(getSubmitButtonTextKey());
	            };
	
	            this.$watch('flags.mode', setSubmitButtonText);
	            this.$watch('flags.poma_flow', setSubmitButtonText);
	
	            this.openAndContinueSepaOverlay = function () {
	                if (_this3.flags.show_sepa_overlay && !_this3.sepa.sepaGuestAgree) {
	                    _this3.sepa.show = true;
	                    return true;
	                } else {
	                    return false;
	                }
	            };
	        } // populate
	
	    },
	
	    actions: {
	        toggleFIMode: function toggleFIMode(event, mode) {
	            event.preventDefault();
	            this.onboard.fiMode = mode;
	        },
	        goBack: function goBack(event) {
	            (0, _squid.$dispatch)('hermes', {
	                redirectToHermes: true,
	                token: this.token
	            });
	        },
	
	
	        // Enable user to edit shipping address
	        editShippingAddress: function editShippingAddress() {
	            this.flags.showSingleAddress = false;
	            this.flags.allowEditShipping = true;
	            this.flags.disallowShipToBilling = true;
	            this.flags.shipToBilling = false;
	            this.flags.hideShippingAddress = false;
	            _angular.$rootScope.$emit('change_in_shipping_address');
	        },
	        logWebviewBackButtonClick: function logWebviewBackButtonClick() {
	            if (this.flags.backButtonWebview) {
	                _logger.$logger.info('BACK_BUTTON_FOR_WEBVIEW_CLICKED');
	            }
	        },
	        onSubmit: function onSubmit() {
	
	            // Added a condition check for pxp experimentation for Sepa Overlay US755520
	            if (this.openAndContinueSepaOverlay()) {
	                return;
	            }
	
	            if (this.isInstantUpdateFlow) {
	                var currentShippingAddress = this.flags.shipToBilling ? this.onboard.billing_address : this.onboard.shipping_address;
	                if ((0, _util2.hasAddressChanged)(this.trackSntReq.address, currentShippingAddress)) {
	                    _logger.$logger.info('address_changed_trigger_snt');
	                    _angular.$rootScope.$emit('submission_triggered');
	                    return;
	                }
	                if (!this.flags.instantUpdateShippingRegionSupported) {
	                    _logger.$logger.info(this.flags.mode + '_submit_not_allowed_instant_update_shipping_region_unsupported');
	                    return;
	                }
	            }
	
	            if (this.flags.wps_SnT_flow || this.isInstantUpdateFlow) {
	                /**
	                 * During submit , if SnT is triggered , do not allow Pay .
	                 */
	                if (!this.flags.allowPayWithSnT) {
	                    _logger.$logger.info(this.flags.mode + '_submit_not_allowed_without_SnT_completion');
	                    return;
	                }
	                // Any SnT Call triggered when xoon updates the address for checkout should not be allowed.
	                this.flags.allowSnTCall = false;
	            }
	
	            _logger.$logger.info(this.flags.mode + '_submit', {
	                type: this.onboard.fiMode === 'bank' ? 'BANK' : this.onboard.card.type,
	                country: _index.$locale.country,
	                lang: _index.$locale.lang
	            }).flush();
	
	            if (this.flags.nationalIdFlag) {
	                this.onboard.nationalIdModel = _directive.$NationalIdModel.instance(_angular.$rootScope.token);
	            }
	
	            if (this.flags.mode !== 'signup') {
	                delete this.onboard.user.password;
	            }
	
	            this.updateAddressOnSubmit();
	
	            if (this.onboard.card.type === 'CUP' && this.onboard.card.isCupSecureCard) {
	                this.flags.allowSnTCall = true;
	                // CUP Secure card is not supported in our flow
	                return this.handleFIContingencies({}, 'creditcard');
	            }
	
	            if ((0, _index.$feature)('addressNormalization')) {
	                this.showAddressNormalizationLightbox = true;
	            } else {
	                return this.onBoardAccount();
	            }
	        },
	        positionToErrorField: function positionToErrorField() {
	            var _this4 = this;
	
	            var errorFields = $('.backendError:visible, input:visible.ng-invalid, select:visible.ng-invalid');
	            var firstErrorField = errorFields && errorFields.length && errorFields[0];
	
	            // Sets the styling for validation on singlePagePaymentForm
	            this.validated = true;
	
	            // AB testing - fixes the revious bug of marking the email and password
	            // as required when the user selects the 'yes' button for the first time
	            this.flags.ignoreValidationTheFirstTime = false;
	
	            if (firstErrorField) {
	                firstErrorField.focus();
	            } else {
	                errorHandlerHelper.scrollToElement();
	            }
	
	            $('.backendError:visible').on('blur', function (event) {
	                $(_this4).removeClass('backendError');
	            });
	
	            if ($('#installments').length) {
	                $('#paymentMethod').addClass('ng-invalid');
	            } else {
	                $('#paymentMethod').removeClass('ng-invalid');
	            }
	
	            return true;
	        }
	    }
	});
	
	
	_angular.$q;
	
	_angular.$rootScope;
	
	_ul.$ul;
	
	_squid.$contentVersion;
	
	_squid.$experiment;
	
	_squid.$promise;
	
	_squid.$renderContent;
	
	_squid.$pxp;
	
	_squid.$dispatch;
	
	_squid.$meta;
	
	_index.$Component;
	
	_index.$FallbackError;
	
	_index.$config;
	
	_index.$feature;
	
	_index.$locale;
	
	_index.$util;
	
	_index2.$CheckoutSessionModel;
	
	_index2.$FundingOptionsModel;
	
	_index2.$CheckoutAppDataModel;
	
	_index2.$CheckoutPayeeModel;
	
	_index2.$CheckoutCartModel;
	
	_index2.$ShippingAddressModel;
	
	_index2.$InstallmentOptionsModel;
	
	_index3.$CheckoutInputDataModel;
	
	_index4.$ShoppingCartModel;
	
	_index5.$ShippingRuleSummaryModel;
	
	_index6.$InventoryModel;
	
	_index7.$OnboardModel;
	
	_index7.$OnboardUserModel;
	
	_index7.$OnboardPhoneModel;
	
	_index8.$BankModel;
	
	_index8.$CardModel;
	
	_index8.$BillingAddressModel;
	
	_fiApis.$fiApis;
	
	_index9.$AuthModel;
	
	_logger.$logger;
	
	_uiRouter.$state;
	
	_index10.$DeviceInfo;
	
	_index11.$fireMORSBeacon;
	
	_directive.$NationalIdModel;
	
	_util.$fiErrorUtil;
	
	_sticky.setStickyInstrument;
	
	_util2.hasAddressChanged;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "./components/xo-login-components/src/unified-login/ul.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$ul = undefined;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _config = __webpack_require__("./components/squid/dist/core/config.js");
	
	var _model = __webpack_require__("./components/xo-tracking/dist/model.js");
	
	var _auth = __webpack_require__("./components/xo-models/src/auth/index.js");
	
	var $ul = exports.$ul = {
	
	    optInToOneTouch: function optInToOneTouch(token, locale_country, locale_code, silent, fptiData, flowName) {
	
	        return (0, _angular.$q)(function (resolve, reject) {
	
	            var PAYPAL = window.PAYPAL || {};
	            var ulTimeOutValue = 10000;
	            var ulTimeoutPromise = null;
	
	            function logSubmit(data) {
	                var fptiPayload = {
	                    'from': fptiData && fptiData.stateName ? fptiData.stateName : 'poma_page',
	                    'to': fptiData && fptiData.transInfix ? fptiData.transInfix : 'process_kmli_optin'
	                };
	                if (data && data.errorCode) {
	                    angular.extend(fptiPayload, {
	                        'int_error_code': data.errorCode,
	                        'error_type': 'hard_decline',
	                        'error_source': 'unifiedloginnodeweb'
	                    });
	                }
	                _logger.$logger.info('checkout_fpti', fptiPayload);
	            }
	
	            function failureHandler(reason) {
	                logSubmit({ errorCode: reason });
	                _logger.$logger.info('UL_Loading_error_' + reason);
	                return reject(new Error('UL_Loading_error_' + reason));
	            }
	
	            function startTimer(tag) {
	                _logger.$logger.info('UL_START_TIMER_' + tag);
	                ulTimeoutPromise = (0, _angular.$timeout)(function () {
	                    failureHandler('timed_out');
	                    if (!silent) {
	                        _angular.$rootScope.$emit('loaded');
	                    }
	                }, ulTimeOutValue);
	            }
	
	            function stopTimer(tag) {
	                if (!silent) {
	                    _angular.$rootScope.$emit('loaded');
	                }
	                _logger.$logger.info('UL_STOP_TIMER_' + tag);
	
	                if (ulTimeoutPromise) {
	                    _angular.$timeout.cancel(ulTimeoutPromise);
	                    ulTimeoutPromise = null;
	                }
	            }
	
	            var ulEventHandlers = {
	                'oneTouchInterstitialOptInLoaded': function oneTouchInterstitialOptInLoaded(data) {
	                    // Don't start or stop timer. Flow should not get block even the post messages is not returned from UL
	                },
	                'oneTouchInterstitialOptInAttempted': function oneTouchInterstitialOptInAttempted(data) {
	                    // Don't start or stop timer. Flow should not get block even the post messages is not returned from UL
	                },
	                'oneTouchInterstitialOptInSuccess': function oneTouchInterstitialOptInSuccess(data) {
	                    stopTimer(data.event);
	                    logSubmit();
	                    // UL will drop RT cookie and respond oneTouchInterstitialOptInSuccess postmessage.
	                    _auth.$AuthModel.instance().retrieve().then(function (auth) {
	                        auth.refresh_token = true;
	                    });
	                    return resolve();
	                },
	                'oneTouchInterstitialOptInFailed': function oneTouchInterstitialOptInFailed(data) {
	                    stopTimer(data.event);
	                    failureHandler(data.event);
	                },
	                'oneTouchInterstitialOptInNotAuthorized': function oneTouchInterstitialOptInNotAuthorized(data) {
	                    // removing the element - ulTargetAttribute from DOM, to avoid any other accidental
	                    // actions on the element which is causing excess spinners later.
	                    var child = document.getElementById('ulTargetAttribute');
	                    child.parentNode.removeChild(child);
	                    stopTimer(data.event);
	                    failureHandler(data.event);
	                }
	            };
	
	            function postMessageHandler(response) {
	                (0, _angular.$timeout)(function () {
	                    _logger.$logger.info('ul_postmessaged_received', response);
	                    var data = response.data || response.error;
	                    var eventId = data && data.event;
	                    if (eventId) {
	                        _logger.$logger.debug('UL' + eventId, response);
	                        var handler = ulEventHandlers[eventId];
	                        if (handler) {
	                            handler(data);
	                        }
	                    }
	                });
	            }
	
	            function loadOneTouchUpsell() {
	                if (!silent) {
	                    _angular.$rootScope.$emit('loading');
	                }
	
	                var ulTargetAttribute = document.createElement('div');
	                ulTargetAttribute.setAttribute('id', 'ulTargetAttribute');
	
	                // setting display to None leading FireFox hiding all the ul elements due to which body click doesn't work
	                // ulTargetAttribute.style.display = "None";
	
	                // Making 0px, it works for FF, Chrome, Safari
	                ulTargetAttribute.style.width = '0px';
	                ulTargetAttribute.style.margin = '0px';
	                ulTargetAttribute.style.height = '0px';
	                ulTargetAttribute.style.padding = '0px';
	
	                document.body.appendChild(ulTargetAttribute);
	
	                var options = {
	                    targetElement: document.getElementById('ulTargetAttribute'),
	                    queryParams: {
	                        'country.x': locale_country,
	                        'locale.x': locale_code,
	                        'flowId': token,
	                        'correlationId': _model.$CalDataModel.getCalCorrId(),
	                        'flowName': flowName ? flowName : 'checkoutOnlyMember' // default is poma flow
	                    },
	                    iframePathname: '/signin/activate-one-touch',
	                    onPostMessage: postMessageHandler
	                };
	
	                if (_config.$config.deploy.isLocal()) {
	                    if (_config.$meta.stage) {
	                        options.origin = 'https://' + _config.$meta.stage;
	                    } else {
	                        // if no stage url shows up then use any backup url for origin
	                        options.origin = _config.$config.onboarding.url.split('/webapps/')[0];
	                    }
	                }
	
	                if (PAYPAL && PAYPAL.unifiedLogin) {
	                    startTimer('initializeUl');
	                    PAYPAL.unifiedLogin.inject(options);
	                } else {
	                    failureHandler('PAYPAL.unifiedLogin_undefined');
	                }
	            }
	
	            loadOneTouchUpsell();
	        });
	    }
	}; /**
	    * Created by upigilam on 4/8/16.
	    * UL handler is to exchange ST to RT exchanges.
	    */
	
	angular.value("$ul", $ul);
	_angular.$rootScope;
	
	_angular.$q;
	
	_angular.$timeout;
	
	_logger.$logger;
	
	_config.$config;
	
	_config.$meta;
	
	_model.$CalDataModel;
	
	_auth.$AuthModel;

/***/ }),

/***/ "./components/xo-models/src/shoppingcart/index.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xomodel.shoppingcart', ['squid']).factory('$ShoppingCartModel', function ($Model, $Api) {
	        return $Model.extend('$ShoppingCartModel', {
	            api: new $Api({
	                uri: '/api/shoppingcart/:id',
	                postAttempts: 2,
	                cache: false
	            })
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/shoppingcart", "components/xo-models/src/shoppingcart/index.js"))

/***/ }),

/***/ "./components/xo-models/src/shippingMethod/index.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xomodel.shippingMethod', ['squid']).factory('$ShippingMethodModel', function ($Model, $Api) {
	        return $Model.extend('ShippingMethodModel', {
	            api: new $Api({
	                uri: '/api/shippingtax/charges'
	            }),
	
	            getShippingMethodId: function getShippingMethodId(shippingMethodType) {
	                var shippingMethodsMap = {
	                    DEFAULT: '0',
	                    AIR_SERVICE: '1',
	                    ECONOMY: '2',
	                    EXPEDITED_AIR_SERVICE: '3',
	                    EXPEDITED_FLAT_RATE_SHIPPING: '4',
	                    EXPRESS: '5',
	                    EXPRESS_DOMESTIC: '6',
	                    FREE_SHIPPING: '7',
	                    GROUND: '8',
	                    GLOBAL_PRIORITY: '9',
	                    INTERNATIONAL_ECONOMY: '10',
	                    INTERNATIONAL_EXPEDITED: '11',
	                    INTERNATIONAL_EXPRESS: '12',
	                    INTERNATIONAL_EXPRESS_AIR: '13',
	                    INTERNATIONAL_PRIORITY_AIR: '14',
	                    NEXT_DAY: '15',
	                    NEXT_DAY_AIR: '16',
	                    NEXT_DAY_AIR_ECONOMY: '17',
	                    ONE_DAY_SHIPPING: '18',
	                    OVERNIGHT: '19',
	                    OVERNIGHT_FLAT_RATE_SHIPPING: '20',
	                    PICKUP: '21',
	                    PRIORITY: '22',
	                    RUSH_DELIVERY: '23',
	                    STANDARD_DOMESTIC: '24',
	                    STANDARD_EXPEDITED: '25',
	                    STANDARD_FLAT_RATE_SHIPPING: '26',
	                    STANDARD_INTERNATIONAL: '27',
	                    STANDARD_SHIPPING: '28',
	                    STORE_PICKUP: '29',
	                    TWO_DAY_SHIPPING: '30',
	                    WORLDWIDE_SHIPPING: '31',
	                    TWO_DAY_AIR: '32'
	                };
	
	                return shippingMethodsMap[shippingMethodType];
	            },
	
	            isStorePickUp: function isStorePickUp(shipping_method_type) {
	                return shipping_method_type === 'STORE_PICKUP' || shipping_method_type === 'PICKUP';
	            }
	        });
	    }).factory('$ShippingRuleSummaryModel', function ($Model, $Api) {
	        return $Model.extend('ShippingRuleSummaryModel', {
	            api: new $Api({
	                uri: '/api/shippingtax/:id/rulesSummary'
	            })
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/shippingMethod", "components/xo-models/src/shippingMethod/index.js"))

/***/ }),

/***/ "./components/xo-models/src/fi/lib/fiApis.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('fi.apis', ['squid']).factory('$fiApis', function ($q) {
	        return {
	            patchCvv: function patchCvv(checkoutSession) {
	                var cvvData = checkoutSession.get('cvvData');
	
	                if (cvvData) {
	                    return checkoutSession.action('patchCvv', {
	                        data: {
	                            id: cvvData.id,
	                            cvv: cvvData.security_code,
	                            type: cvvData.type,
	                            number: cvvData.number
	                        }
	                    });
	                }
	
	                return $q.when();
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/fi/lib", "components/xo-models/src/fi/lib/fiApis.js"))

/***/ }),

/***/ "./components/xo-models/src/marketingoffer/index.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/node-uuid/uuid.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, uuid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xomodel.marketingoffer', ['squid']).factory('$MarketingOfferModel', function ($Model, $Api) {
	        return $Model.extend('$MarketingOfferModel', {
	            api: new $Api({
	                uri: '/api/checkout/offer/search-ads',
	                postAttempts: 1
	
	            }),
	
	            serialize: function serialize() {
	                var data = {
	                    'site': this.site,
	                    'locale': this.locale,
	                    'si': this.si,
	                    'visit_id': uuid.v4(),
	                    'page': this.page,
	                    'epu': this.payer,
	                    'pu_type': this.puType || 'ANONYMOUS',
	                    'country_code': this.countryCode,
	                    'payment_context': {
	                        'total_transaction_amount': this.totalTransactionAmount,
	                        'total_shipping_amount': this.totalShippingAmount,
	                        'business_case': 'NONE',
	                        'business_case_variation': '',
	                        'validate_existing_offer': 'false',
	                        'payment_units': [{
	                            'transaction_amount': this.totalTransactionAmount,
	                            'transaction_id': '',
	                            'encrypted_transaction_id': '',
	                            'activity_id': '',
	                            'payee': {
	                                'pu_type': 'BUSINESS',
	                                'country_code': this.countryCode,
	                                'epu': this.payee,
	                                'pu': ''
	                            }
	                        }]
	                    },
	                    'target_placements': this.targetPlacements,
	                    'wallet_instruments': this.walletInstruments,
	                    'addl_property_installments_not_allowed': this.installmentsNotAllowed
	                };
	
	                return data;
	            }
	        });
	    }).service('$fireMORSBeacon', function ($q) {
	        this.fireBeacon = function (uri) {
	            var img = document.createElement('img');
	
	            img.setAttribute('src', uri);
	            document.body.appendChild(img);
	
	            return;
	        };
	    }).factory('$MemberSegmentModel', function ($Model, $Api) {
	        return $Model.extend('$MemberSegmentModel', {
	            api: new $Api({
	                uri: '/api/segment/memberSegment',
	                postAttempts: 1
	            }),
	
	            invalidateOnLogout: true, // invalidate this model when auth.logout() gets called
	
	            getMemberSegment: function getMemberSegment() {
	                return this.memberSegment;
	            },
	
	            getCreditOffer: function getCreditOffer() {
	                return this.creditOffer;
	            },
	
	            isNewMember: function isNewMember() {
	                return this.memberSegment === 'NEW_MEMBER' || this.memberSegment === 'YOUNG_MEMBER';
	            }
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/marketingoffer", "components/xo-models/src/marketingoffer/index.js"))

/***/ }),

/***/ "./components/xo-wallet-components/src/fi-contingency-list/util.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-wallet-components/src/fi-contingency-list/contingencies.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular, squid, contingencyList) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('fi.errorUtil', ['squid']).factory('$fiErrorUtil', function ($renderContent) {
	        return {
	            addPageErrors: function addPageErrors(errorData, contentBundle, prop, defaultKey) {
	
	                // error handling for filifecycle and fimanagement. 
	                if (!errorData.errorCodes) {
	                    errorData.errorCodes = errorData && [errorData['0']];
	                }
	
	                var messages = [];
	                if (errorData.errorCodes && errorData.errorCodes.length) {
	                    errorData.errorCodes.forEach(function (errorCode) {
	                        var contentKey = contingencyList[errorCode] || defaultKey || 'errorGeneral';
	                        var message;
	                        if (angular.isArray(contentKey)) {
	                            for (var i = 0; i < contentKey.length; i++) {
	                                message = $renderContent(contentBundle + '.' + contentKey[i], prop);
	                                if (message && message.string) {
	                                    break;
	                                }
	                            }
	                        } else {
	                            message = $renderContent(contentBundle + '.' + contentKey, prop);
	                        }
	
	                        messages.push(message);
	                    });
	
	                    return {
	                        msgs: messages,
	                        type: 'error'
	                    };
	                }
	            },
	
	            /**
	             * Highlight the Error Fields by ng-model
	             * @param errorData
	             * @param element
	             * @param modelPrefix
	             */
	            addFieldErrors: function addFieldErrors(errorData, element, modelPrefix) {
	
	                if (errorData.fields && errorData.fields.length) {
	                    errorData.fields.forEach(function (field) {
	                        var $field = $(element).find('[ng-model="' + (modelPrefix ? modelPrefix : '') + field.field + '"]');
	                        $field.addClass('backendError');
	                        $field.attr('aria-invalid', true);
	                    });
	                }
	                $(element).find('.backendError:first').focus();
	            },
	
	            /**
	             * Highlight the Error Fields by element name
	             * @param errorData
	             * @param element
	             * @param modelPrefix
	             */
	            addFieldErrorsByName: function addFieldErrorsByName(errorData, element, modelPrefix) {
	
	                if (errorData.fields && errorData.fields.length) {
	                    errorData.fields.forEach(function (field) {
	                        var fieldName = void 0;
	                        if (modelPrefix && field.field && field.field.length > 0) {
	                            // Add prefix with CamelCase of field name
	                            fieldName = modelPrefix + field.field[0].toUpperCase() + field.field.substring(1);
	                        } else {
	                            fieldName = field.field;
	                        }
	                        var $field = $(element).find('[name="' + fieldName + '"]');
	                        $field.addClass('backendError');
	                        $field.attr('aria-invalid', true);
	                    });
	                }
	                $(element).find('.backendError:first').focus();
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-wallet-components/src/fi-contingency-list", "components/xo-wallet-components/src/fi-contingency-list/util.js"))

/***/ }),

/***/ "./components/xo-wallet-components/src/fi-contingency-list/contingencies.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	    var contingencyList = {
	        INSTRUMENT_COUNT_EXCEEDED: 'errorInstrumentCountExceeded',
	        INSTRUMENT_COUNT_EXCEEDED_VERIFIED: 'errorInstrumentCountExceeded',
	        INSTRUMENT_COUNT_LIMIT_EXCEEDED: 'errorInstrumentCountExceeded',
	        INSTRUMENT_COUNT_LIMIT_EXCEEDED_VERIFIED: 'errorInstrumentCountExceeded',
	        INSTRUMENT_UNAVAILABLE: 'errorInstrumentUnavailable',
	        INSTRUMENT_REFUSED_DUE_TO_MAX_LIMIT: 'errorInstrumentRefused',
	        INSTRUMENT_REFUSED_DUE_TO_MAX_SHARED_INSTRUMENT_LIMIT: ['errorInstrumentUnavailable', 'errorInstrumentRefused'],
	        INSTRUMENT_ALREADY_EXISTS: 'errorInstrumentAlreadyExists',
	        INSTRUMENT_BILLING_ADDRESS_NOT_ACCEPTED: 'errorInstrumentBillingAddressNotAccepted',
	        BILLING_ADDRESS1: 'errorInstrumentBillingAddressNotAccepted',
	        BILLING_CITY: 'errorInstrumentBillingAddressNotAccepted',
	        BILLING_COUNTRY: 'errorInstrumentBillingAddressNotAccepted',
	        BILLING_DIFFERENT_COUNTRY: ['errorInstrumentBillingAddressUnavailableIntl', 'errorInstrumentBillingAddressNotAccepted'],
	        INSTRUMENT_UPDATE_NO_CHANGE: 'errorInstrumentUpdateNoChange',
	        INSTRUMENT_DUPLICATE_LIMIT_REACHED: 'errorInstrumentRefused',
	        NOT_ELIGIBLE_TO_EDIT_CARD: 'notEligibleToEditCard',
	        INTERNAL_ERROR: 'errorInternalError',
	        INSTRUMENT_REFUSED: 'errorInstrumentRefused',
	        INSTRUMENT_INTERNATIONAL: 'errorIssuerRejectIntl',
	        REJECT_REFUSED: ['errorIssuerReject', 'errorInstrumentRefused'],
	        PAYPAL_DEBIT_CARD_REFUSED: ['errorPaypalDebitRefused', 'errorGeneral'],
	        PAYPAL_CREDIT_CARD_REFUSED: ['errorPaypalCreditRefused', 'errorGeneral'],
	        PAYPAL_CARD_REFUSED: ['errorPaypalRefused', 'errorGeneral'],
	        EXCESSIVE_REJECTIONS: ['errorExcessiveRejectGuest', 'errorInstrumentRefused'],
	        CC_INVALID_CSC: ['errorCheckDigits', 'errorGeneral'],
	        INVALID_EXPIRATION_DATE: 'errorInvalidExpirationDate',
	        CHECK_DIGITS_NOT_PRESENT: ['errorCheckDigitsNotPresent', 'errorGeneral'],
	        REJECT_UNKNOWN: ['errorIssuerReject', 'errorInstrumentRefused'],
	        SETTLEMENT_DENIED: 'errorInstrumentRefused',
	        MAX_AMOUNT_EXCEEDED: ['errorMaxAmountExceeded', 'errorInstrumentRefused'],
	        ISSUER_ERROR: ['errorIssuerDenied', 'errorInstrumentRefused'],
	        MISSING_FIELD: ['errorInvalidData', 'errorGeneral'],
	        INVALID_PARAMETERS: ['errorInvalidData', 'errorGeneral'],
	        INVALID_DATA: ['errorInvalidData', 'errorGeneral'],
	        INVALID_ACCOUNT: ['errorInvalidAccount', 'errorGeneral'],
	        INVALID_INSTRUMENT_ID: ['errorInvalidAccount', 'errorGeneral'],
	        ACCOUNT_RESTRICTED: ['errorAccountRestricted', 'errorGeneral'],
	        ISSUER_RESTRICTED: ['errorIssuerReject', 'errorGeneral'],
	        ISSUER_REJECTED: ['errorIssuerReject', 'errorGeneral'],
	        ADDRESS_MISMATCH: 'errorInstrumentBillingAddressNotMatch',
	        CHECK_DIGITS_NOT_PROC: ['errorCheckDigitsNotPresent', 'errorGeneral'],
	        CHECK_DIGITS_UNSUPPORTED: ['errorCheckDigits', 'errorGeneral'],
	        CHECK_DIGITS_UNAVAILABLE: ['errorCheckDigits', 'errorGeneral'],
	        BILL_ADDR_UNAVAILABLE: ['errorInstrumentBillingAddressUnavailable', 'errorInstrumentBillingAddressNotAccepted'],
	        BILL_ADDR_UNSUPPORTED: ['errorInstrumentBillingAddressUnsupported', 'errorInstrumentBillingAddressNotAccepted'],
	        BILL_ADDR_UNAVAILABLE_GLOBAL: ['errorInstrumentBillingAddressUnavailableIntl', 'errorInstrumentBillingAddressNotAccepted'],
	        BILL_ADDR_NOT_ALLOWED: ['errorInstrumentBillingAddressNotAccepted', 'errorAddressNotAllowed'],
	        BILL_ADDR_UNAVAILABLE_INTL: ['errorInstrumentBillingAddressUnavailableIntl', 'errorInstrumentBillingAddressNotAccepted'],
	        INSTRUMENT_DISABLED: 'errorInstrumentRefused',
	        PI_TYPE_NOT_SUPPORTED: 'errorInvalidCCNumberOrType_global',
	        REJECT_AMEX_ADULT: ['errorAmexAdult', 'errorGeneral'],
	        INVALID_BANK_ROUTING_NUMBER: 'invalidRoutingNumber',
	        BANK_ROUTING_NUMBER_IS_EMPTY: 'invalidPINumber',
	        INVALID_BANK_ACCOUNT_NUMBER: 'invalidPINumber',
	        BANK_ACCOUNT_NUMBER_IS_EMPTY: 'invalidPINumber',
	        INVALID_BANK_IBAN: 'invalidPINumber',
	        INVALID_IBAN_CODE: 'invalidPINumber',
	        INVALID_BANK_IBAN_CONVERSION_ERROR: 'invalidPINumber',
	        INVALID_BENEFICIARY_FIRST_NAME: 'errorInvalidFirstName',
	        INVALID_BENEFICIARY_NAME: 'errorInvalidFirstName',
	        INVALID_BANK_BENEFICIARY_NUMBER: 'errorGeneral',
	        INVALID_BANK_ADDRESS: 'errorGeneral',
	        INVALID_CARD_NUMBER: 'errorInvalidCCNumberOrType',
	        INVALID_CARD_TYPE: 'errorInvalidCCNumberOrType',
	        INVALID_SECURITY_CODE: 'errorInvalidCSC',
	        INVALID_FIRST_NAME: 'errorInvalidFirstName',
	        INVALID_LAST_NAME: 'errorInvalidLastName',
	        INVALID_EXPIRY: 'errorInvalidExpirationDate',
	        INVALID_PHONE: 'errorInvalidPhone',
	        BANK_ADDRESS_IS_EMPTY: 'errorGeneral',
	        INVALID_BANK_BRANCH_NUMBER: 'errorGeneral',
	        ADD_REFUSED_DUE_TO_EXCEEDING_MAX_DUPLICATE_INSTRUMENT_LIMIT: 'errorInstrumentUnavailable',
	        EMPTY_DATA: 'errorGeneral',
	        ISSUER_DECLINE: 'errorIssuerReject',
	        WRONG_CONFIRMATION_VALUES: 'wrongConfirmationValue',
	        CONFIRMATION_RESEND_COUNT_EXCEEDED: 'resendValExceeded',
	        FREQUENT_REQUEST_VERIFICATION_CODE: 'frequentVerificationCodeReq',
	        TRANSACTION_TIMEOUT: 'transactionTimeout',
	        NOT_CONFIRMED: 'notConfirmed',
	        CONTACT_CARD_ISSUER_TO_VERIFY: 'issuerVerify',
	        CARD_NOT_ACTIVATED_FOR_UPOP: 'cardNotActivatedUpop',
	        RESTRICTED_CARD: 'cardRestricted',
	        RESTRICTED_CARD_GUEST: 'cardRestrictedGuest',
	        INVALID_ONE_TIME_PASSWORD: 'errorInvalidOtpCode',
	        DUPLICATED_TRANSACTION: 'duplicateTransaction'
	
	    };
	
	    return contingencyList;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "./components/xo-guest-components/src/guest/sticky.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.setStickyInstrument = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	/**
	 * Makes billing agreement financial instrument sticky if necessary
	 *
	 * @param {CheckoutSession} checkoutSession
	 * @return {Promise}
	 */
	var setStickyInstrument = exports.setStickyInstrument = function setStickyInstrument(checkoutSession) {
	    if (!checkoutSession) {
	        throw new TypeError('missing checkoutSession');
	    }
	
	    if (checkoutSession.selectedFuturePaymentInstrument) {
	        // session already has a sticky instrument
	        return _squid.$promise.resolve();
	    }
	
	    var stickyInstrument = checkoutSession.getSelectedStickyInstrument();
	
	    if (stickyInstrument) {
	        return checkoutSession.action('setStickyFI', {
	            data: {
	                instrument_id: stickyInstrument.instrument_id
	            }
	        });
	    }
	
	    return _squid.$promise.resolve();
	};
	
	_squid.$promise;

/***/ }),

/***/ "./components/xo-guest-components/src/lib/util.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.decodeEntities = exports.hasAddressChanged = exports.pxpTreatments = undefined;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _index = __webpack_require__("./components/xo-device-info/dist/index.js");
	
	// Flags for single password
	function getSinglePassword(country) {
	    if (country !== 'US' && _index.$DeviceInfo.isDevice()) {
	        return _angular.$q.when(true);
	    }
	
	    return (0, _squid.$pxp)('xoon_single_password', { 'ctx.COUNTRY': country }, '(xoon_single_password_)(.*)').then(function (result) {
	        if (result && result.treatment_name === 'xoon_single_password_test') {
	            return true;
	        }
	        return false;
	    });
	}
	
	var pxpTreatments = {
	    getSinglePassword: getSinglePassword
	};
	
	function isString(value) {
	    return angular.isString(value) || value instanceof String;
	}
	
	function areAddressFieldsEqual(addressElement1, addressElement2) {
	    if (addressElement1 === addressElement2) {
	        return true;
	    }
	    if (addressElement1 === undefined && addressElement2 === '' || addressElement1 === '' && addressElement2 === undefined) {
	        return true;
	    }
	    if (isString(addressElement1) && isString(addressElement2)) {
	        return addressElement1.toUpperCase() === addressElement2.toUpperCase();
	    }
	    return false;
	}
	
	var hasAddressChanged = function hasAddressChanged(address1, address2) {
	    var fieldsToCompare = [[address1.line1, address2.line1], [address1.line2, address2.line2], [address1.city, address2.city], [address1.state, address2.state], [address1.postal_code, address2.postal_code], [address1.country_code, address2.country]];
	    for (var i = 0; i < fieldsToCompare.length; i++) {
	        if (!areAddressFieldsEqual(fieldsToCompare[i][0], fieldsToCompare[i][1])) {
	            return true;
	        }
	    }
	    return false;
	};
	
	function decodeEntities(input) {
	    // A constant key that can be used to find the element
	    var ENTITY_ELEM = '__xpc_entitydecoder__';
	
	    // Create the element if this is the first time this is called
	    if (!window[ENTITY_ELEM]) {
	        window[ENTITY_ELEM] = document.createElement('p');
	    }
	    var converter = window[ENTITY_ELEM];
	    converter.innerHTML = input;
	    return converter.innerText || converter.text || converter.textContent;
	}
	
	exports.pxpTreatments = pxpTreatments;
	exports.hasAddressChanged = hasAddressChanged;
	exports.decodeEntities = decodeEntities;
	
	
	_angular.$q;
	
	_squid.$pxp;
	
	_index.$DeviceInfo;

/***/ }),

/***/ "./components/xo-guest-components/src/guest/lib/errorHandlerHelper.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	
	exports.__esModule = true;
	exports.errorHandler = exports.addFieldError = exports.get3dsPageWarning = exports.getPageError = exports.scrollToElement = undefined;
	
	var _errorHandlerConstants = __webpack_require__("./components/xo-guest-components/src/guest/constants/errorHandlerConstants.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _util = __webpack_require__("./components/xo-wallet-components/src/fi-contingency-list/util.js");
	
	var SECTION_ELEMENT = '#singlePagePayment';
	
	var scrollToElement = function scrollToElement(fieldName) {
	    var element = $('[name=' + fieldName + ']');
	    var notifications = $('#notifications');
	    var logo = $('#paypalLogo');
	
	    if (element.length) {
	        element.focus();
	    } else {
	        var focusDiv = notifications.length ? notifications : logo;
	
	        // Focus notifications div or logo div
	        // This triggers scroll to notifications or logo from
	        // hideSpinner() function
	        focusDiv.attr('tabindex', '-1').focus();
	    }
	};
	
	var getPageError = function getPageError(contentKey, compileMessageWith) {
	    var messages = [];
	    var msg = void 0;
	
	    if (compileMessageWith) {
	        msg = (0, _squid.$renderContent)(contentKey, compileMessageWith);
	    } else {
	        msg = _squid.$locale.content.get(contentKey);
	    }
	
	    messages.push(msg);
	
	    scrollToElement();
	
	    return messages;
	};
	
	var get3dsPageWarning = function get3dsPageWarning(resolve3DS, contentKey) {
	    var messages = [];
	    var cardType = resolve3DS.type;
	    var cardLast4 = resolve3DS.number;
	    messages.push((0, _squid.$renderContent)(contentKey, { cardType: cardType, last4: cardLast4 }));
	    scrollToElement();
	    return messages;
	};
	
	var addFieldError = function addFieldError(errorData) {
	    var sectionElement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SECTION_ELEMENT;
	
	    (errorData.fields || []).forEach(function (field) {
	        var $field = $(sectionElement).find('[ng-model="' + field + '"]');
	        $field.addClass('backendError');
	    });
	};
	
	var errorHandler = function errorHandler(message, errorData, positionToErrorField) {
	    var sectionElement = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : SECTION_ELEMENT;
	
	    var messages = [];
	
	    if (errorData && errorData.message === 'VALIDATION_ERROR') {
	        angular.forEach(errorData.errorCodes, function (errCode) {
	
	            var validationPageError = _errorHandlerConstants.validationErrorMap[errCode];
	
	            if (validationPageError) {
	                messages = getPageError(validationPageError.contentKey);
	                _logger.$logger.info('HANDLED_VALIDATION_ERROR', errCode);
	            } else {
	                // There are multiple services that can throw generic VALIDATION_ERROR.
	                // We have chosen to use genericError for the time being since we can't pinpoint the error class.
	                messages = getPageError('genericError.genericError');
	                _logger.$logger.info('UNHANDLED_VALIDATION_ERROR', errCode);
	            }
	        });
	    }
	
	    var scrollToTop = false;
	    angular.forEach(errorData, function (err) {
	
	        // TODO: need to break if case nesting
	        if (err) {
	            var errElMap = _errorHandlerConstants.errorElementMap[err] || _errorHandlerConstants.errorElementMap[err.errorCode] || _errorHandlerConstants.errorElementMap[err.code];
	            if (errElMap) {
	                var element = sectionElement + (errElMap.element ? ' ' + errElMap.element : '');
	                if (errElMap.name) {
	                    // Highlight the Error Fields by name
	                    _util.$fiErrorUtil.addFieldErrorsByName(errElMap.fields && errElMap || err.details || err, element, errElMap.name);
	                } else {
	                    // Highlight the Error Fields by ng-model
	                    _util.$fiErrorUtil.addFieldErrors(errElMap.fields && errElMap || err.details || err, element, errElMap.model);
	                }
	
	                if (errElMap.pageError) {
	                    messages = getPageError(errElMap.pageError.contentKey, errElMap.compileMessageWith);
	                    scrollToTop = errElMap.scrollToTop ? true : false;
	                }
	            } else {
	                addFieldError(err);
	            }
	        }
	    });
	
	    if (!scrollToTop) {
	        positionToErrorField();
	    }
	
	    return messages;
	};
	
	exports.scrollToElement = scrollToElement;
	exports.getPageError = getPageError;
	exports.get3dsPageWarning = get3dsPageWarning;
	exports.addFieldError = addFieldError;
	exports.errorHandler = errorHandler;
	
	
	_errorHandlerConstants.errorElementMap;
	
	_errorHandlerConstants.validationErrorMap;
	
	_squid.$renderContent;
	
	_squid.$locale;
	
	_logger.$logger;
	
	_util.$fiErrorUtil;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "./components/xo-guest-components/src/guest/constants/errorHandlerConstants.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.validationErrorMap = exports.errorElementMap = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var loginRedirectUrl = (0, _squid.$getRedirectUrl)('hermes', {
	    hermesLoginRedirect: 'xoon'
	});
	
	// TODO: should we have fields in a different constant
	var errorElementMap = {
	    INVALID_FIRST_NAME: {
	        fields: [{ field: 'user.first_name' }]
	    },
	    INVALID_LAST_NAME: {
	        fields: [{ field: 'user.last_name' }]
	    },
	    INVALID_PHONE_TYPE: {
	        fields: [{ field: 'phone.phoneType' }]
	    },
	    INVALID_PHONE_NUMBER: {
	        fields: [{ field: 'phone.telephone' }]
	    },
	    INVALID_CITY_STATE_ZIPCODE: {
	        fields: [{ field: 'address.city' }, { field: 'address.state' }, { field: 'zipCode' }]
	    },
	    INVALID_LINE1: {
	        fields: [{ field: 'address.line1' }]
	    },
	    INVALID_CITY: {
	        fields: [{ field: 'address.city' }]
	    },
	    INVALID_STATE: {
	        fields: [{ field: 'address.state' }]
	    },
	    INVALID_ZIPCODE: {
	        fields: [{ field: 'zipCode' }]
	    },
	
	    INVALID_NATIONAL_ID_TYPE: {
	        element: '#nationalIdFields',
	        fields: [{ field: 'type' }],
	        model: 'nationalIdModel.nationalId.'
	    },
	    INVALID_NATIONAL_ID: {
	        element: '#nationalIdFields',
	        fields: [{ field: 'Value' }],
	        name: 'id'
	    },
	    INVALID_SECONDARY_ID_TYPE: {
	        element: '#nationalIdFields',
	        fields: [{ field: 'secondaryIdType' }],
	        model: 'nationalIdModel.'
	    },
	    INVALID_SECONDARY_ID: {
	        element: '#nationalIdFields',
	        fields: [{ field: 'secondaryIdValue' }],
	        model: 'nationalIdModel.'
	    },
	
	    INVALID_BILLING_ADDRESS: {
	        element: '#billingAddress',
	        name: 'billing'
	    },
	    INVALID_SHIPPING_ADDRESS: {
	        element: '#shippingAddress',
	        name: 'shipping'
	    },
	    INVALID_EXPIRATION_DATE: {
	        element: '#expiration',
	        model: 'card.',
	        fields: [{ field: 'expiry_month' }, { field: 'expiry_year' }]
	    },
	    PASSWORD_TOO_LONG: {
	        element: '#signupContainer',
	        model: 'user.',
	        fields: [{ field: 'password' }, { field: 'confirmPassword' }]
	    },
	    PASSWORD_CONTAINS_FORBIDDEN_WORDS: {
	        element: '#signupContainer',
	        model: 'user.',
	        fields: [{ field: 'password' }, { field: 'confirmPassword' }]
	    },
	    PASSWORD_HAS_ILLEGAL_CHARACTERS: {
	        element: '#signupContainer',
	        model: 'user.',
	        fields: [{ field: 'password' }, { field: 'confirmPassword' }]
	    },
	    ACCOUNT_ALREADY_EXISTS: {
	        fields: [{ field: 'user.email' }],
	        pageError: {
	            contentKey: 'login.userMayHaveAccount'
	        },
	        compileMessageWith: {
	            href: loginRedirectUrl
	        },
	        scrollToTop: true
	    },
	    INVALID_EMAIL_ID: {
	        fields: [{ field: 'user.email' }]
	    },
	    DOB_INVALID: {
	        element: '#dob, #dobBank',
	        name: 'dob',
	        fields: [{ field: 'Day' }, { field: 'Month' }, { field: 'Year' }, { field: 'Text' }]
	    },
	    REJECT_REFUSED: {
	        pageError: {
	            contentKey: 'creditcard.errorInstrumentRefused'
	        }
	    },
	    INVALID_INSTRUMENT_ID: {
	        pageError: {
	            contentKey: 'creditcard.errorInvalidData'
	        }
	    },
	    ADDRESS_MISMATCH: {
	        pageError: {
	            contentKey: 'creditcard.errorInstrumentBillingAddressNotMatch'
	        }
	    },
	    CHECK_DIGITS_REJECTED: {
	        pageError: {
	            contentKey: 'creditcard.errorCheckDigits'
	        }
	    },
	    OAS_GENERIC_ERROR: {
	        pageError: {
	            contentKey: 'genericError.genericError'
	        },
	        scrollToTop: true
	    }
	};
	
	var validationErrorMap = {
	    INVALID_ROUTING_NUMBER: {
	        contentKey: 'bank.invalidRoutingNumber'
	    },
	    INVALID_ACCOUNT: {
	        contentKey: 'creditcard.errorInvalidData'
	    },
	    ISSUER_DENIED: {
	        contentKey: 'creditcard.errorIssuerDenied'
	    },
	    ISSUER_REJECTED: {
	        contentKey: 'creditcard.errorIssuerReject'
	    },
	    REJECT_REFUSED: {
	        contentKey: 'creditcard.errorInstrumentRefused'
	    },
	    INVALID_INSTRUMENT_ID: {
	        contentKey: 'creditcard.errorInvalidData'
	    }
	};
	
	exports.errorElementMap = errorElementMap;
	exports.validationErrorMap = validationErrorMap;
	
	
	_squid.$getRedirectUrl;

/***/ }),

/***/ "./components/xo-guest-components/src/guest/constants/pxpExperimentConstants.js":
/***/ (function(module, exports) {

	
	
	exports.__esModule = true;
	var onetouch = {
	    signup_onetouch_variant1_graphic: 'signUpVariantOne',
	    signup_onetouch_variant2: 'signUpVariantTwo',
	    signup_onetouch_control: 'control'
	};
	
	var singlepassword = {
	    singlepassword_test: 'xoon_single_password_test'
	};
	
	var xoon_optional_signup_content_change = {
	    xoon_optional_signup_content_change_gb_test: {
	        subTitle: 'common.createPayPalPropTest1',
	        yesCreateAccount: 'common.yesCreateAccountTest1'
	    },
	    xoon_optional_signup_content_change_test1: {
	        title: 'common.getBenefitsLine1Test1',
	        subTitle: 'common.createPayPalPropTest1'
	    },
	    xoon_optional_signup_content_change_test2: {
	        title: 'common.getBenefitsLine1Test1',
	        subTitle: 'common.createPayPalPropTest2'
	    },
	    xoon_optional_signup_content_change_test3: {
	        title: 'common.getBenefitsLine1Test2',
	        subTitle: 'common.createPayPalPropTest3'
	    },
	    xoon_optional_signup_content_change_test4: {
	        title: 'common.getBenefitsLine1Test2',
	        subTitle: 'common.createPayPalPropTest4'
	    }
	};
	
	var xoon_wps_interstitial_optional_signup = {
	    XO_XOONBOARDING_WPS_INTERSTITIAL_OPTIONAL_SIGNUP_Control: {
	        mode: 'guestonly',
	        interstitialEligible: true
	    },
	    XO_XOONBOARDING_WPS_INTERSTITIAL_OPTIONAL_SIGNUP_Treatment1: {
	        mode: 'guest',
	        interstitialEligible: false
	    },
	    XO_XOONBOARDING_WPS_INTERSTITIAL_OPTIONAL_SIGNUP_Treatment2: {
	        mode: 'guest',
	        buyerMode: 'guest',
	        interstitialEligible: true
	    }
	};
	
	exports['default'] = {
	    test: {
	        onetouch: onetouch,
	        singlepassword: singlepassword,
	        xoon_optional_signup_content_change: xoon_optional_signup_content_change,
	        xoon_wps_interstitial_optional_signup: xoon_wps_interstitial_optional_signup
	    }
	};
	module.exports = exports['default'];

/***/ }),

/***/ "./components/xo-guest-components/src/guest/constants/constants.js":
/***/ (function(module, exports) {

	
	
	exports.__esModule = true;
	var _submitButtonGuestTextKeyMap = {
	    commit: 'common.payLabel',
	    notCommit: 'common.continueLabel'
	};
	
	var _submitButtonSignupTextKeyMap = {
	    commit: 'common.createAccountAndPayNow',
	    notCommit: 'common.agreeAndCreateAccount'
	};
	
	var submitButtonTextKeyMap = {
	    signup: {
	        US: _submitButtonSignupTextKeyMap,
	        ROW: {
	            commit: 'common.agreeAndPay',
	            notCommit: 'common.agreeAndContinue'
	        }
	    },
	    pomaSignup: {
	        US: _submitButtonSignupTextKeyMap,
	        ROW: {
	            commit: 'common.agreeAndPayNowPoma',
	            notCommit: 'common.agreeAndContinue'
	        }
	    },
	    guest: {
	        US: _submitButtonGuestTextKeyMap,
	        ROW: _submitButtonGuestTextKeyMap
	    }
	};
	
	exports['default'] = {
	    submitButtonTextKeyMap: submitButtonTextKeyMap
	};
	module.exports = exports['default'];

/***/ }),

/***/ "./components/xo-guest-components/src/guest/template.html":
/***/ (function(module, exports) {

	module.exports = "<div content class=\"singlePagePayment\" id=\"singlePagePayment\">\n    <xo-login-button ng-if=\"landingAbTestCheck()\" redirect=\"redirect\"></xo-login-button>\n    <xo-message message=\"errorMessage\"></xo-message>\n    <h1 class=\"alpha\" id=\"pageTitle\">{{getPageTitle()}}</h1>\n    <p class=\"subTitle\" id=\"pageTitleProps\">{{getPageTitleProps()}}</p>\n\n    <form id=\"singlePagePaymentForm\" name=\"singlePagePaymentForm\" class=\"singlePagePaymentForm\" ng-submit=\"singlePagePaymentForm.$valid && actions.onSubmit()\" ng-class=\"{'validated': validated, 'APAC': isApac()}\" novalidate>\n\n        <xo-country-list is-unbranded=\"isUnbranded\" token=\"token\" show-mask=\"showMask\"></xo-country-list>\n\n        <div ng-class=\"{'showMask': showMask}\" disable-form=\"showMask\">\n            <span ng-if=\"showFISwitchTab()\">\n                <ul class=\"form-tabs\" id=\"paymentTab\">\n                    <li class=\"bank {{onboard.fiMode === 'bank' ? 'active' : ''}}\" ui-sref-active=\"active\">\n                        <a ng-click=\"actions.toggleFIMode($event, 'bank')\" href=\"#\" class=\"bankTab\" for=\"'bankTab\">{{content('bank.bank')}}</a>\n                    </li>\n                    <li class=\"card {{onboard.fiMode === 'card' ? 'active' : ''}}\" ui-sref-active=\"active\">\n                        <a ng-click=\"actions.toggleFIMode($event, 'card')\" href=\"#\" class=\"cardTab\" for=\"cardTab\">{{content('bank.card')}}</a>\n                    </li>\n                </ul>\n            </span>\n\n            <div ng-if=\"onboard.fiMode === 'card'\" id=\"cardFields\">\n                <xo-credit-card token=\"token\" card=\"onboard.card\" user=\"onboard.user\" name-below=\"true\" card-number-changed=\"cardNumberChanged\"></xo-credit-card>\n\n                <div ng-if=\"isInstallmentsVisible()\" class=\"installment\">\n                    <a ng-if=\"!singleStepModel.selectedInstallmentData.preventChange\" id=\"paymentMethod\" ui-sref=\"{{currentState}}.sidebar.installmentOptions\" class=\"getInstallments installmentsDropDown btn btn-secondary\" scroll-to-top>\n                            <span ng-if=\"singleStepModel.selectedInstallmentData\">\n                                {{singleStepModel.selectedInstallmentData.installment_option_selected.term}}X {{content('paymentMethod.of')}} {{singleStepModel.selectedInstallmentData.installment_option_selected.monthly_payment.formatted_value}}\n                            </span>\n                            <span ng-if=\"!singleStepModel.selectedInstallmentData\">\n                                {{content('paymentMethod.changeInstallmentLongLink') }}\n                            </span>\n                    </a>\n                    <a ng-if=\"singleStepModel.selectedInstallmentData.preventChange\"\n                       class=\"getInstallments btn btn-secondary\" disabled>\n                            <span ng-if=\"singleStepModel.selectedInstallmentData\">\n                                {{singleStepModel.selectedInstallmentData.installment_option_selected.term}}X {{content('paymentMethod.of')}} {{singleStepModel.selectedInstallmentData.installment_option_selected.monthly_payment.formatted_value}}\n                            </span>\n                    </a>\n                    <div ng-if=\"singleStepModel.selectedInstallmentData.preventChange\" class=\"installmentHelper\">\n                        <a href=\"#\" id=\"installmentHelp\" alt=\"{{ content('common.altHelp') }}\" class=\"verifyHelp\">\n                        </a>\n                    </div>\n                    <xo-tooltip ng-if=\"singleStepModel.selectedInstallmentData.preventChange\" trigger=\"#installmentHelp\">\n                        <div class=\"tip tipDesc emailToolTip\">\n                            {{content('paymentMethod.installmentPreselectedHelp')}}\n                        </div>\n                    </xo-tooltip>\n                </div>\n\n                <input ng-if=\"isInstallmentsVisible() && !singleStepModel.selectedInstallmentData\"\n                       type=\"text\"\n                       name=\"installments\"\n                       id=\"installments\"\n                       ng-model=\"singleStepModel.selectedInstallmentData.installment_option_selected.term\"\n                       value=\"\"\n                       class=\"hiddenInput ng-pristine\"\n                       required/>\n\n                <xo-name-input  user=\"onboard.user\"></xo-name-input>\n            </div>\n\n            <div ng-if=\"onboard.fiMode === 'bank'\" id=\"bankFields\">\n                <xo-name-input  user=\"onboard.user\"></xo-name-input>\n                <xo-bank-input token=\"token\" bank=\"onboard.bank\" is-unbranded=\"isUnbranded\" user=\"onboard.user\"></xo-bank-input>\n            </div>\n\n            <xo-phone-input ng-if=\"!flags.allowChoice && !flags.cupDetected\" phone=\"onboard.phone\" countryCode=\"locale.country\"></xo-phone-input>\n\n\n            <h2 class=\"billingLabel sectionTitle\">{{content('addressBook.billingAddress')}}</h2>\n            <div id=\"billingAddress\" ng-class=\"{'validated': billingAddressValidated }\">\n                <xo-add-address address=\"onboard.billing_address\" country=\"locale.country\" trigger-zip-code-blur=\"(wpsFlow && flags.wps_SnT_flow) || isInstantUpdateFlow\" trigger-zip-code-key-press=\"(wpsFlow && flags.wps_SnT_flow) || isInstantUpdateFlow\"></xo-add-address>\n            </div>\n\n\n            <div class=\"row-fluid checkbox shipToBillingContainer\" ng-if=\"flags.allowEditShipping && !flags.disallowShipToBilling\">\n                <input ng-model=\"flags.shipToBilling\" type=\"checkbox\" name=\"shipToBilling\" id=\"shipToBilling\" class=\"shipToBilling\"/>\n                <label class=\"noBottom\" for=\"shipToBilling\" ng-bind-html=\"htmlContent('largeScreenPayment.shipTo')\"></label>\n            </div>\n\n            <h2 ng-if=\"flags.showShippingLabel && (flags.wps_SnT_flow || isInstantUpdateFlow)\" class=\"nolap shippingLabel sectionTitle\">{{content('shipping.shippingLabel')}}</h2>\n\n            <div id=\"showShippingAddress\" ng-if=\"flags.showSingleAddress\">\n                <div class=\"showShippingAddressHeading\">\n                    <span class=\"showShippingAddressTitle\">{{ content('shipping.shippingTitle') }}</span>\n                    <a class=\"editShippingAddress\"\n                       ng-click=\"actions.editShippingAddress()\">{{ content('common.change') }}</a>\n                </div>\n                <div class=\"shippingAddress\">\n                    {{shippingAddress.displayLine1}}<br/>\n                    {{shippingAddress.displayLine2}}<br/>\n                    {{shippingAddress.displayLine3}}\n                </div>\n            </div>\n\n            <div ng-if=\"!flags.shipToBilling && flags.allowEditShipping\" ng-hide=\"(flags.wps_SnT_flow || isInstantUpdateFlow) && flags.hideShippingAddress\" id=\"shippingAddress\" ng-class=\"{'validated': shippingAddressValidated }\">\n\n                <label class=\"nolap shippingAddressLabel sectionTitle\">{{content('shipping.shippingTitle')}}</label>\n\n                <xo-message message=\"changeShippingCountryAlert\"></xo-message>\n\n                <xo-select-shipping-country token=\"token\" shipping-address=\"onboard.shipping_address\"\n                                            disable-change-shipping-country=\"flags.disableChangeShippingCountry\"></xo-select-shipping-country>\n\n                <xo-add-address address=\"onboard.shipping_address\" is-shipping=\"true\" token=\"token\" country=\"onboard.shipping_address.country\" trigger-zip-code-blur=\"(wpsFlow && flags.wps_SnT_flow) || isInstantUpdateFlow\" trigger-zip-code-key-press=\"(wpsFlow && flags.wps_SnT_flow) || isInstantUpdateFlow\"></xo-add-address>\n\n            </div>\n\n            <div id=\"shippingMethod\" ng-if=\"flags.wps_SnT_flow || isInstantUpdateFlow\">\n                <xo-guest-select-shipping-method token=\"token\"\n                                                 show-shipping =\"showShippingAddress\"\n                                                 billing-address=\"onboard.billing_address\"\n                                                 shipping-address=\"onboard.shipping_address\"\n                                                 track-snt-req=\"trackSntReq\"\n                                                 is-shipping-same-as-billing=\"flags.shipToBilling\"\n                                                 button-params=\"buttonParams\"\n                                                 page-level-error-message=\"errorMessage\"\n                                                 flags = \"flags\"></xo-guest-select-shipping-method>\n            </div>\n\n            <div ng-if=\"flags.allowChoice || flags.cupDetected\">\n                <h2 class=\"nolap billingLabel sectionTitle\">{{content('addPhone.contactInformation')}}</h2>\n                <p ng-if=\"flags.cupDetected\" class=\"subTitle upopMobileNotify\" ng-bind-html=\"htmlContent('confirmUpop.debitInitOtp')\"></p>\n                <xo-phone-input phone=\"onboard.phone\" show-phone-type=\"!flags.cupDetected\" countryCode=\"locale.country\"></xo-phone-input>\n                <xo-email-input class=\"emailInputContactSection\" flags=\"flags\" user=\"onboard.user\"></xo-email-input>\n            </div>\n\n            <xo-onboard-options single-page-payment-form=\"singlePagePaymentForm\" validated=\"validated\" token=\"token\" flags=\"flags\" mode=\"mode\" is-unbranded=\"isUnbranded\"\n                onboard=\"onboard\" sepa=\"sepa\" merchant=\"merchant\"></xo-onboard-options>\n\n            <div class=\"buttons\">\n                <div id=\"returnToMerchantInfo\" ng-if=\"showNewSignupComplianceExp && !flags.commit\">\n                    <p>{{ content('common.textAboveAgreeButton') }}</p>\n                </div>\n\n                <a id=\"backButton\" ng-if=\"flags.backButtonWebview\" href=\"#/checkout/login\" class=\"btn btn-secondary half\" ng-click=\"actions.logWebviewBackButtonClick(); actions.goBack($event)\">\n                    {{ content('common.back') }}\n                </a>\n\n                <input track-submit=\"{{flags.track_submit_transition}}\" id=\"guestSubmit\" type=\"submit\"\n                value=\"{{ this.submitButtonText }}\" class=\"btn\" ng-click=\"actions.positionToErrorField()\"\n                    ng-if=\"!flags.show_poma_ui\" ng-class=\"{backButtonEnabled: flags.backButtonWebview}\"/>\n\n                <input track-submit=\"{{flags.track_submit_transition}}\" track-input=\"{{flags.poma_flow ? (flags.commit ? 'Agree_Pay_Now' : 'Agree_Continue') : (flags.commit ? 'Pay_Now' : 'Continue')}}\" id=\"pomaSubmit\" type=\"submit\"\n                    value=\"{{ this.submitButtonText }}\" class=\"btn\" ng-click=\"actions.positionToErrorField()\"\n                    ng-if=\"flags.show_poma_ui\" ng-class=\"{backButtonEnabled: flags.backButtonWebview}\"/>\n\n            </div>\n        </div>\n    </form>\n</div>\n\n<xo-modal ng-if=\"showAddressNormalizationLightbox\" show=\"true\">\n    <xo-address-normalization token=\"token\" address=\"onboard.billing_address\" hide-back-button=\"true\" done-fn=\"uponNormalization\"></xo-address-normalization>\n</xo-modal>\n\n<xo-guest-sepa-lightbox single-page-payment-form=\"singlePagePaymentForm\" \n    onboard=\"onboard\" section-element=\"sectionElement\" error-message=\"errorMessage\" address=\"onboard.billing_address\" is-unbranded=\"isUnbranded\" flags=\"flags\"\n    validated=\"validated\" sepa=\"sepa\" done-fn=\"actions.onSubmit\"></xo-guest-sepa-lightbox>\n\n<xo-3ds on-complete-3ds-handler=\"onComplete3DSHandler\" token=\"token\" data=\"resolve_3ds_data\" ng-if=\"launch3DSResolver\"></xo-3ds>\n<xo-confirm-upop token=\"token\" card-model=\"onboard.card\" phone=\"onboard.phone\" on-success=\"onUpopSuccess\" on-cancel=\"onUpopCancel\" on-init-error=\"onUpopCancel\" ng-if=\"launchUpopScreen\" button-text-key=\"upopConfirmButtonTextKey\"></xo-confirm-upop>\n<xo-currency-conversion-lightbox token=\"token\" done-fn=\"onCompleteDCC\" ng-if=\"launchCurrencyConversionLightbox\"></xo-currency-conversion-lightbox>\n"

/***/ }),

/***/ "./components/xo-guest-components/src/guest/countryList/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _index = __webpack_require__("./components/squid/dist/index.js");
	
	var _index2 = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _index3 = __webpack_require__("./components/xo-models/src/user/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	__webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/floating-label/directive.js");
	
	var _template = __webpack_require__("./components/xo-guest-components/src/guest/countryList/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _index.$Component.extend('xoCountryList', {
	    tag: 'xo-country-list',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            type: 'var',
	            required: true
	        },
	        showMask: {
	            type: 'var',
	            required: true
	        }
	    },
	
	    resolve: {
	        models: function models() {
	            return {
	                checkoutInputData: _index3.$CheckoutInputDataModel.instance(this.token).retrieve(),
	                payee: _index2.$CheckoutPayeeModel.instance(this.token).retrieve(),
	                checkoutAppData: _index2.$CheckoutAppDataModel.instance(this.token).retrieve(),
	                checkoutCart: _index2.$CheckoutCartModel.instance(this.token).retrieve()
	            };
	        }
	    },
	
	    lifecycle: {
	        populate: function populate() {
	            var _this = this;
	
	            var proxSignUpFlow = this.models.checkoutInputData.isEbayTxn();
	
	            this.merchantCountry = this.models.checkoutAppData.get('merchant.merchant_country');
	            this.merchantComplianceRestricted = (0, _index.$feature)('merchantComplianceRestricted', false, this.merchantCountry);
	
	            this.fallbackOnUnsupportedCountry = function (selectedCountry) {
	                if (!(0, _index.$feature)('guest', false, selectedCountry) || (0, _index.$feature)('guestFallback', false, selectedCountry)) {
	                    throw new _index.$FallbackError({
	                        reason: 'other_country_selected_for_guest',
	                        product: 'ux'
	                    });
	                }
	            };
	
	            this.fallbackOnUnsupportedCountry(_index.$locale.country);
	
	            this.isMerchantCountrySameAsSelectedCountry = function (merchantCountry, selectedCountry) {
	                var countriesWithMultipleCodes = {
	                    CN: ['CN', 'C2'],
	                    C2: ['CN', 'C2']
	                };
	                var merchantCountryList = countriesWithMultipleCodes[merchantCountry] || [merchantCountry];
	
	                return merchantCountryList.indexOf(selectedCountry) > -1;
	            };
	
	            /**
	             * This function will determine the country list will be shown to user:
	             * 1. Get supported country list from griffin
	             * 2. Filter out blocked countries configured in our app's config file
	             * 3. Add default 'Country' option to the list if needed: ie. for merchant compliance restricted case
	             */
	            this.populateSupportedCountries = function () {
	                var guestBlockedCountries = _index.$config.guestBlockedCountries || [];
	                _this.metadata = _angular2['default'].copy(_index.$locale.metadata);
	
	                if (proxSignUpFlow) {
	                    // only show the countries that are in $config.proxSupportedCountries
	                    _this.supportedCountries = _this.metadata.territory.filter(function (c) {
	                        if (c.code === _index.$locale.country) {
	                            _this.selectedCountryObj = c;
	                        }
	                        return _index.$config.proxSupportedCountries.indexOf(c.code) > -1;
	                    });
	                } else {
	                    _this.supportedCountries = _this.metadata.territory.filter(function (c) {
	                        if (c.code === _index.$locale.country) {
	                            _this.selectedCountryObj = c;
	                        }
	                        return !(guestBlockedCountries.indexOf(c.code) > -1);
	                    });
	
	                    if (_this.merchantComplianceRestricted && _this.isMerchantCountrySameAsSelectedCountry(_this.merchantCountry, _this.selectedCountryObj.code)) {
	                        var defaultOption = {
	                            code: '',
	                            name: _index.$locale.content.common.country
	                        };
	                        _this.supportedCountries.push(defaultOption);
	                        _this.selectedCountryObj = defaultOption;
	                    }
	
	                    if (_this.merchantComplianceRestricted && _this.isMerchantCountrySameAsSelectedCountry(_this.merchantCountry, _index.$locale.country)) {
	                        _this.showMask = true;
	                    }
	                }
	            };
	
	            this.populateSupportedCountries();
	
	            // TODO: to be removed - currently locale change and metadata change is not in sync which need to be fixed.
	            this.$on('metadataChange', function () {
	                _this.populateSupportedCountries();
	            });
	
	            /*
	             * merchants can block international PayPal accounts using the merchant setting Block payments from users
	             * who have non-merchant country PayPal accounts, if resolved country is not merchant country, default to merchant country
	             * and disable the country list
	             */
	            this.blockNonDomesticPayer = this.models.checkoutAppData.get('flags.block_non_domestic_payer') && (0, _index.$feature)('blockNonDomesticPayer', false, this.merchantCountry);
	            this.disableCountryList = this.blockNonDomesticPayer || this.models.checkoutCart.isWalletTokenization();
	            if (this.disableCountryList && this.merchantCountry !== _index.$locale.country) {
	                _logger.$logger.info('merchant block_non_domestic_payer', {
	                    merchantCountry: this.merchantCountry,
	                    resolvedCountry: _index.$locale.country
	                });
	                this.actions.countryChanged(this.merchantCountry);
	            }
	        }
	    },
	
	    actions: {
	        countryChanged: function countryChanged(selectedCountry) {
	            var _this2 = this;
	
	            _logger.$logger.info('country_updated', { 'to': selectedCountry, 'from': _index.$locale.country });
	            this.selectedCountry = selectedCountry;
	            this.fallbackOnUnsupportedCountry(selectedCountry);
	
	            if (this.merchantComplianceRestricted) {
	                this.showMask = false;
	                this.showMessage = false;
	
	                if (!selectedCountry) {
	                    this.showMask = true;
	                    return;
	                } else if (this.isMerchantCountrySameAsSelectedCountry(this.merchantCountry, selectedCountry)) {
	                    this.showMask = true;
	                    this.showMessage = true;
	                    return;
	                }
	            }
	
	            var resolveLang = function resolveLang() {
	
	                var merchantLocale = _this2.models.checkoutAppData.get('merchant.merchant_locale');
	                merchantLocale = merchantLocale && _index.$localeHelper.normalizeLocale(merchantLocale).language;
	                merchantLocale = merchantLocale && merchantLocale.toLowerCase();
	
	                var supportedLocales = _index.$config.supportedCountries;
	                var selectedLang = supportedLocales[selectedCountry] && supportedLocales[selectedCountry][0];
	
	                var resolvedLang = merchantLocale && supportedLocales[selectedCountry] && supportedLocales[selectedCountry].indexOf(merchantLocale) !== -1 ? merchantLocale : selectedLang;
	                return resolvedLang;
	            };
	
	            if (_index.$locale.country !== this.selectedCountry) {
	                // Perform Language Resolution only when the country is changed, as below code does not consider locale.x merchant parameter
	                _index.$locale.choose(this.selectedCountry, resolveLang(selectedCountry)).then(function () {
	                    _uiRouter.$state.go('checkout.landing');
	                });
	            }
	        }
	    }
	
	});
	
	
	_index.$Component;
	
	_index.$FallbackError;
	
	_index.$config;
	
	_index.$feature;
	
	_index.$locale;
	
	_index.$localeHelper;
	
	_index2.$CheckoutAppDataModel;
	
	_index2.$CheckoutPayeeModel;
	
	_index2.$CheckoutCartModel;
	
	_index3.$CheckoutInputDataModel;
	
	_logger.$logger;
	
	_uiRouter.$state;
	module.exports = exports['default'];

/***/ }),

/***/ "./components/xo-ui-components/src/error-tooltip/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _angularAria = __webpack_require__("./components/angular-aria/angular-aria.min.js");
	
	// Configure angular aria.
	// Note that aria configuration applies globally
	_angularAria.$ariaProvider.config({ // eslint-disable-line angular/di
	    // Remove bindRoleForClick since we use ngClick for several items that shouldn't be treated as buttons.
	    bindRoleForClick: false,
	
	    // Remove ariaInvalid and ariaRequired as we want to handle them ourselves.
	    // These attributes should only be set once the form is submitted, to match what
	    // visually what we display
	    ariaInvalid: false,
	    ariaRequired: false
	});
	
	(0, _angular.$registerDirective)('xo-error-tooltip', function () {
	
	    return {
	        restrict: 'A',
	        require: ['?^form', '?ngModel'],
	        link: function link(scope, element, attrs, ctrls) {
	            var formCtrl = ctrls[0],
	                modelCtrl = ctrls[1];
	
	
	            function shouldBeRequired() {
	                if (formCtrl) {
	                    // If input is a checkbox and has error-text or error-key, show the error text instead of the required text.
	                    // error-text is a legacy thing for backward compatibility, we can get rid of this once all teams
	                    // adopt error-key in all input tags
	                    var showCheckboxRequired = !(element.attr('type') === 'checkbox' && (attrs.errorText || attrs.errorKey));
	                    return formCtrl.$submitted && modelCtrl.$error.required && showCheckboxRequired;
	                } else {
	                    return modelCtrl.$error.required;
	                }
	            }
	
	            function shouldBeInvalid() {
	                if (formCtrl) {
	                    return formCtrl.$submitted && modelCtrl.$invalid;
	                } else {
	                    return modelCtrl.$invalid;
	                }
	            }
	
	            // Add or remove a string into a space split string (eg. aria-describedby ids, class names)
	            function formatSpaceSplitString(str, id, add) {
	                var strArray;
	                if (str) {
	                    strArray = str.split(' ');
	                } else {
	                    strArray = [];
	                }
	
	                var idIndex = strArray.indexOf(id);
	
	                if (~idIndex && !add) {
	                    strArray.splice(idIndex, 1);
	                } else if (!~idIndex && add) {
	                    strArray.push(id);
	                }
	
	                return strArray.join(' ');
	            }
	
	            // Add tooltip behavior after DOM settles
	            (0, _angular.$timeout)(function () {
	                var generateId = function generateId() {
	                    return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 7);
	                };
	
	                var requiredId = generateId();
	                var invalidId = generateId();
	                var requiredError;
	                var invalidError;
	
	                if (attrs.errorKey) {
	                    element.addClass('hasErrorTooltipRuleSpecific');
	                    invalidError = (0, _angular.$compile)('<div class="errorTooltip errorTooltipRuleSpecific" id="' + invalidId + '">{{content("' + attrs.errorKey + '")}}</div>')(scope);
	                    element.after(invalidError);
	                } else if (attrs.errorText) {
	                    // errorText if case is for backward compatibility, we can get rid of this once
	                    // all teams adopt error-key in all input tags for tooltip message display
	                    element.addClass('hasErrorTooltipRuleSpecific');
	                    invalidError = $('<div class="errorTooltip errorTooltipRuleSpecific" id="' + invalidId + '">' + attrs.errorText + '</div>');
	                    element.after(invalidError);
	                }
	
	                if (attrs.required || (0, _angular.$parse)(attrs.ngRequired)(scope)) {
	                    element.addClass('hasErrorTooltipRequired');
	                    requiredError = (0, _angular.$compile)('<div class="errorTooltip errorTooltipRequired" id="' + requiredId + '">{{content("validation.required")}}</div>')(scope);
	                    element.after(requiredError);
	
	                    element.removeAttr('aria-required');
	                }
	
	                function setAriaAttributes() {
	                    var addTooltips = {
	                        required: false,
	                        invalid: false
	                    };
	
	                    // Do not associate "Required" error with aria-describedby
	                    // because this should already be read out either by "required"
	                    // attribute or "aria-required"=true, and only associate "Invalid"
	                    // error if "Required" is not showing to match visuals
	                    if (shouldBeRequired()) {
	                        addTooltips.required = true;
	                    } else if (shouldBeInvalid()) {
	                        addTooltips.invalid = true;
	                    }
	
	                    var describedby = element.attr('aria-describedby');
	                    describedby = formatSpaceSplitString(describedby, requiredId, addTooltips.required);
	                    describedby = formatSpaceSplitString(describedby, invalidId, addTooltips.invalid);
	                    element.attr('aria-describedby', describedby);
	                }
	
	                scope.$watch(shouldBeRequired, function (newVal) {
	                    setAriaAttributes();
	                });
	                scope.$watch(shouldBeInvalid, function (newVal) {
	                    element.attr('aria-invalid', newVal);
	                    setAriaAttributes();
	                });
	
	                // Set scroll so that the error message is in view when element receives focus
	                element.on('focus', function (event) {
	                    var windowBot = $(window).scrollTop() + $(window).height();
	                    var requiredBot = requiredError ? requiredError.offset().top + requiredError.outerHeight() : 0;
	                    var invalidBot = invalidError ? invalidError.offset().top + invalidError.outerHeight() : 0;
	                    if (windowBot < Math.max(requiredBot, invalidBot)) {
	                        $(window).scrollTop(Math.max(requiredBot, invalidBot) - $(window).height());
	                    }
	                });
	            });
	        }
	    };
	});
	
	_angular.$registerDirective;
	
	_angular.$parse;
	
	_angular.$compile;
	
	_angular.$timeout;
	
	_angularAria.$ariaProvider;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "./components/xo-ui-components/src/floating-label/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/floating-label/styles.less");
	
	var treatmentType;
	var newLocale;
	var oldLocale;
	
	function getTreatment() {
	
	    if (treatmentType !== undefined) {
	        return treatmentType;
	    }
	    if ((0, _squid.$feature)('floatingLabels')) {
	        return true;
	    }
	    var token = _angular.$rootScope.token;
	    var throttle = _squid.$config['floatingLabelLocales'] && _squid.$config['floatingLabelLocales'][_squid.$locale.country] && _squid.$config['floatingLabelLocales'][_squid.$locale.country][_squid.$locale.lang];
	    var id = _squid.$locale.lang + '_' + _squid.$locale.country + token;
	    treatmentType = throttle && (0, _squid.$experiment)('floating_label_exp', throttle, id, {}) ? true : false;
	    return treatmentType;
	}
	
	(0, _angular.$registerDirective)('floating-label', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	
	            scope.$on('localeChange', function () {
	                newLocale = _squid.$locale.country + '_' + _squid.$locale.lang;
	                if (oldLocale !== newLocale) {
	                    treatmentType = undefined;
	                    oldLocale = newLocale;
	                }
	                scope.showFloatingLabels = getTreatment();
	            });
	
	            (0, _angular.$timeout)(function () {
	                scope.showFloatingLabels = getTreatment();
	
	                scope.$watch('showFloatingLabels', function (val) {
	                    // remove else block after experimentation is complete
	                    if (val) {
	                        element.addClass('floatingLabel');
	                        element.removeClass('noFloatingLabel');
	                    } else {
	                        element.removeClass('floatingLabel');
	                        element.addClass('noFloatingLabel');
	                    }
	                });
	
	                var input = element.find('input');
	
	                if (input.attr('placeholder')) {
	                    input.addClass('hasPlaceholder');
	                }
	
	                // To hide the placeholder labels for pre-populated input fields
	                scope.$watch(input.attr('ng-model'), function (value) {
	                    input.toggleClass('focused', !!value);
	                });
	
	                // We're using this as an alternative to watching 'ng-model' since this properly triggers the focused CSS property on email input.
	                input.on('keyup', function (event) {
	                    var val = event.target.value;
	                    input.toggleClass('focused', !!val);
	                });
	
	                input.on('focus blur click', function (event) {
	                    if (scope.showFloatingLabels) {
	                        input.toggleClass('focused', event.type === 'focus' || this.value.length > 0);
	                    }
	                }).trigger('blur');
	            });
	        }
	    };
	});
	
	(0, _angular.$registerDirective)('floating-label-dropdown', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	
	            scope.$on('localeChange', function () {
	                newLocale = _squid.$locale.country + '_' + _squid.$locale.lang;
	                if (oldLocale !== newLocale) {
	                    treatmentType = undefined;
	                    oldLocale = newLocale;
	                }
	                scope.showFloatingLabels = getTreatment();
	            });
	
	            (0, _angular.$timeout)(function () {
	
	                scope.showFloatingLabels = getTreatment();
	
	                scope.$watch('showFloatingLabels', function (val) {
	                    // remove else block after experimentation is complete
	                    if (val) {
	                        element.addClass('floatingLabel');
	                        element.removeClass('noFloatingLabel');
	                    } else {
	                        element.removeClass('floatingLabel');
	                        element.addClass('noFloatingLabel');
	                    }
	                });
	
	                var select = element.find('select');
	                var label = element.find('label');
	                var flSpan = element.find('.custom-select span span');
	
	                select.on('change mouseenter mouseleave blur', function (event) {
	                    select.toggleClass('focused', event.type === 'change' || this.value.length > 0);
	                    flSpan.toggleClass('noValue', this.value.length < 1);
	                    label.toggleClass('hide', this.value.length < 1);
	                }).trigger('mouseleave');
	            });
	        }
	    };
	});
	
	_angular.$timeout;
	
	_angular.$rootScope;
	
	_angular.$registerDirective;
	
	_squid.$locale;
	
	_squid.$experiment;
	
	_squid.$config;
	
	_squid.$feature;

/***/ }),

/***/ "./components/xo-ui-components/src/floating-label/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-ui-components/src/floating-label/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-ui-components/src/floating-label/styles.less":
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "blockquote,body,code,dd,div,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,html,input,legend,li,ol,p,pre,td,textarea,th,ul{margin:0;padding:0}table{border-collapse:collapse;border-spacing:0}fieldset,img{border:0}address,caption,cite,code,dfn,em,strong,th,var{font-style:normal;font-weight:400}ol,ul{list-style:none}caption,th{text-align:left}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:400}q:after,q:before{content:\"\"}abbr,acronym{border:0;font-variant:normal}sup{vertical-align:text-top}sub{vertical-align:text-bottom}input,select,textarea{font-family:inherit;font-size:inherit;font-weight:inherit;font-size:100%}legend{color:#000}body{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:95%;color:#2c2e2f;line-height:1.35em}h1{font-size:138.5%}h2{font-size:123.1%}h3{font-size:108%}h1,h2,h3{margin:1em 0}h1,h2,h3,h4,h5,h6,strong{font-weight:700}a{color:#0070ba}abbr,acronym{border-bottom:1px dotted #000;cursor:help}em{font-style:italic}blockquote,dl,ol,ul{margin:1em}dl,ol,ul{margin-left:2em}ol{list-style:decimal outside}ul{list-style:disc outside}dl dd{margin-left:1em}td,th{border:1px solid #000;padding:.5em}th{font-weight:700;text-align:center}input{margin-bottom:10px}caption{margin-bottom:.5em;text-align:center}fieldset,legend,p,pre,table{margin-bottom:1em}input[type=password],input[type=text],textarea{width:12.25em;*width:11.9em}.row-fluid{width:100%;*zoom:1}.row-fluid:after,.row-fluid:before{display:table;content:\"\"}.row-fluid:after{clear:both}.row-fluid>[class*=span]{float:left;margin-left:4.12765957%}.row-fluid>[class*=span]:first-child{margin-left:0}.row-fluid>.span24{width:99.99999998%}.row-fluid>.span23{width:95.74468083%}.row-fluid>.span22{width:91.48936168%}.row-fluid>.span21{width:87.23404253%}.row-fluid>.span20{width:82.97872339%}.row-fluid>.span19{width:78.72340424%}.row-fluid>.span18{width:74.46808509%}.row-fluid>.span17{width:70.21276594%}.row-fluid>.span16{width:65.95744679%}.row-fluid>.span15{width:61.70212765%}.row-fluid>.span14{width:54.4468085%}.row-fluid>.span13{width:53.19148935%}.row-fluid>.span12{width:48.9361702%}.row-fluid>.span11{width:44.68085105%}.row-fluid>.span10{width:40.42553191%}.row-fluid>.span9{width:36.17021276%}.row-fluid>.span8{width:31.91489361%}.row-fluid>.span7{width:27.65957446%}.row-fluid>.span6{width:23.40425531%}.row-fluid>.span5{width:19.14893617%}.row-fluid>.span4{width:14.89361702%}.row-fluid>.span3{width:10.63829787%}.row-fluid>.span2{width:6.38297872%}.row-fluid>.span1{width:2.12765957%}.container-fluid{padding-left:20px;padding-right:20px;*zoom:1}.container-fluid:after,.container-fluid:before{display:table;content:\"\"}.container-fluid:after{clear:both}.mt10,.mt15{margin-top:10px}.pt10{padding-top:10px}.pt15{padding-top:15px}.mb10{margin-bottom:10px}.mb15{margin-bottom:15px}.pb10{padding-bottom:10px}.pb15{padding-bottom:15px}.ml10{margin-left:10px}.ml15{margin-left:15px}.pl10{padding-left:10px}.pl15{padding-left:15px}.mr10{margin-right:10px}.mr15{margin-right:15px}.pr10{padding-right:10px}.pr15{padding-right:15px}.btn{height:44px;margin-bottom:0;border:1px solid #0070ba;border-radius:5px;*margin-left:.3em;display:inline-block;*display:inline;*zoom:1;background-color:#0070ba;transition:background-color .4s ease-out 0s;font-size:1em;font-weight:700;line-height:42px;color:#fff;text-align:center;vertical-align:middle;cursor:pointer;outline:none;-webkit-font-smoothing:antialiased}.btn .btn-secondary{-webkit-font-smoothing:auto}.btn:focus,.btn:hover{background-color:#005ea6}.btn:focus{text-decoration:underline}.btn.active,.btn:active{background-color:#005ea6;outline:0}.btn.disabled,.btn[disabled]{background-color:#b2d9ea;border-color:#b2d9ea;cursor:default}.btn.firstHalf{float:left}.btn.firstHalf,.btn.secondHalf{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box}.btn.secondHalf{float:right}a.btn:focus,a.btn:hover{color:#fff}.btn:first-child{*margin-left:0}.btn-large{padding:8px 15px;font-size:18px;line-height:normal;border-radius:5px}.btn-small{padding:5px 9px;font-size:11px;line-height:16px}.btn-mini{padding:2px 6px;font-size:11px;line-height:14px}.btn-secondary{border-style:solid;border-color:#e1e7eb;color:#393f44;background-color:#e1e7eb}.btn-secondary:hover{color:#393f44;border-color:#edf2f5;background-color:#edf2f5;text-decoration:none}.btn-secondary:active,.btn-secondary:focus{border-color:#c5ccd1;background-color:#c5ccd1;text-decoration:underline}.btn-secondary.disabled,.btn-secondary[disabled]{color:#393f55}a.btn-secondary:active,a.btn-secondary:focus,a.btn-secondary:hover{color:#393f44;border-color:#c5ccd1;background-color:#c5ccd1}a.btn-secondary.disabled,a.btn-secondary[disabled]{color:#393f55;background-color:#e7edf0}button.btn,input[type=submit].btn{*padding-top:2px;*padding-bottom:2px}button.btn::-moz-focus-inner,input[type=submit].btn::-moz-focus-inner{padding:0;border:0}button.btn.btn-large,input[type=submit].btn.btn-large{*padding-top:7px;*padding-bottom:7px}button.btn.btn-small,input[type=submit].btn.btn-small{*padding-top:3px;*padding-bottom:3px}button.btn.btn-mini,input[type=submit].btn.btn-mini{*padding-top:1px;*padding-bottom:1px}#largeScreenAccountCreation .buttons #backButton,section .buttons #backButton{width:30%}#largeScreenAccountCreation .buttons #proceedButton,section .buttons #proceedButton{width:65%}#largeScreenAccountCreation .buttons #proceedButton-venmoBA,#largeScreenAccountCreation .buttons #proceedButton.full,section .buttons #proceedButton-venmoBA,section .buttons #proceedButton.full{width:100%}.custom-select-container,select.replaced{position:relative}select.replaced{z-index:8;width:100%;height:44px;border:0;line-height:2;opacity:0;filter:alpha(opacity=0)}.custom-select{position:absolute;top:0;left:0;z-index:1;width:100%;transition:border-color .3s ease 0s;border-radius:5px}.custom-select,.custom-select>span{display:block;background-clip:padding-box}.custom-select>span{padding:7px 30px 7px 13px;border:1px solid #ccd0d4;border-radius:5px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:right -7px top -1178px;color:#000;line-height:28px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.disabled .custom-select>span{background-position:right -7px top -6990px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat right 10px center;background-size:16px;color:#c72e2e;border:1px solid #c72e2e}.custom-select span span{display:block;overflow:hidden;height:28px;text-overflow:ellipsis;white-space:nowrap;font-size:1em}.custom-select.active>span{border:1px solid #009cde;outline:0}#task .custom-select{border-radius:5px;background-clip:padding-box}.mobile .dob label{position:static;top:0;left:0}input[type=date]{padding:5px 38px 3px 6px;border:1px solid #ccd0d4;border-radius:5px;background-clip:padding-box;color:#333;background-size:24px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_cart_icons.png\") no-repeat 100% 61%}input[type=date]:focus{border-color:#39f}.showDropdopwnLabels .labelText{float:left;color:#aaa}.showDropdopwnLabels .valueText{float:right;min-width:90px}@media (min-width:0) and (max-width:40em){.showDropdopwnLabels .labelText{display:none}.showDropdopwnLabels .valueText{float:none;min-width:0}}.multiline-select-container{outline:0 none}.multiline-select-container:active .innerContainer,.multiline-select-container:focus .innerContainer{border-color:#009cde}.multiline-select-container.open:active .innerContainer,.multiline-select-container.open:focus .innerContainer{border-color:#ccd0d4}.multiline-select-container option,.multiline-select-container select{position:absolute!important;left:-9999px}.multiline-select-container .custom-select{position:relative}.multiline-select-container .custom-select span span{height:auto;white-space:normal}.multiline-select-container .custom-select>span{background:none}.multiline-select-container.open .custom-select>span{border-radius:5px 5px 0 0;border-bottom-color:#eee}.multiline-select-container .arrow{background-clip:padding-box;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_forms.png\");background-position:left -8px top -1198px;background-repeat:no-repeat;height:10px;position:absolute;width:14px;top:40%;right:12px}.backendError .multiline-select-container .ng-invalid+.custom-select .arrow,.validated .multiline-select-container .ng-invalid+.custom-select .arrow{display:none}.multiline-select-list{position:absolute;list-style:none;margin:0;background-color:#fff;z-index:1000;border-radius:0 0 5px 5px;border-bottom:1px solid #ccd0d4;max-height:200px;overflow:auto;box-shadow:0 -1px 1px 0 #ccc}.multiline-select-list li{padding:10px;border:1px solid;border-color:#eee #ccd0d4;border-top:0 none;cursor:pointer;line-height:1.35em;vertical-align:middle}.multiline-select-list li:active,.multiline-select-list li:focus,.multiline-select-list li:hover{background-color:#e5f5fc;outline:0 none}.multiline-select-list li:first-of-type{border-top:0 none}.multiline-select-list li:last-of-type{border-bottom:0 none}.multiline-select-list:hover li:focus{background-color:#fff}.multiline-select-list:hover li:focus:active,.multiline-select-list:hover li:focus:hover{background-color:#e5f5fc}#midflash,.accessAid{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}body{-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#fff}a{text-decoration:none;-webkit-tap-highlight-color:rgba(0,0,0,.2)}a:focus,a:hover{color:#005ea6;text-decoration:underline;outline:none}a.dashed{text-decoration:none;border-bottom:1px dashed #0070ba;font-size:.9em}[tabindex=\"-1\"]{outline:none}em{font-style:normal;font-weight:700}fieldset{margin:0;padding:0;border:0}fieldset legend{padding-bottom:.5em;font-size:1.5em}section:focus{outline:none}.show-section{display:block}hr.faded{width:100%;height:1px;margin:10px 0;border:0;background-image:-o-linear-gradient(left,transparent,rgba(0,0,0,.75),transparent)}.alpha{font-size:1.5em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin:.5em 0;line-height:1.154em}#loginSection h1.alpha{max-width:240px}.asideAlpha{font-size:1.44em}aside .aside .header.noButtons .walletHeading{text-align:center;line-height:1.05em}.beta{font-size:1.54em;color:#2c2e2f;font-weight:lighter;line-height:1.2em}.gamma{font-size:1.3em}.gamma,.zeta{font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin-bottom:.75em}.zeta{font-size:1.25em}.delta{font-size:1.1em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;margin-bottom:12px;font-weight:400}.vprop-header{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin:10px 0;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.vprop-content,.vprop-header{color:#2c2e2f;font-weight:lighter;line-height:1.2em}.vprop-content{font-size:1em;font-family:HelveticaNeue,helvetica,arial,sans-serif}.vprop-image{margin-top:25px}.eta{font-size:1.1em}.eta,.theta{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400}.theta{font-size:1em}.value-prop-title{color:#2c2e2f;font-size:24px;font-weight:lighter;margin:10px 0}.props{padding:0 0 0 5px;clear:both;text-align:center}.props li,.props p{line-height:1.154em;font-size:.9em;font-weight:400;line-height:1.2em;margin:5px 0}.secondary{color:#6c7378;font-size:.85em}.legal{color:#6c7378;font-size:.75em;line-height:1.154em}.legal a{font-weight:700}.mu{font-size:2.46em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-weight:400;text-shadow:0 1px 0 #fff;color:#0079c1}.noHead{margin-top:0}.noBottom{margin-bottom:0}.showTray #task{overflow:hidden;margin-left:0}#spinner,.hide{display:none}.clearfix,.loading #spinner,.media .img img,html[xmlns] .clearfix{display:block}#billingToggleLink{display:inline-block}.left{float:left}.right{float:right}.center{text-align:center}.outerWrapper{position:relative;border-radius:5px;background-clip:padding-box;background-color:#fff}header{z-index:2}.framed #wrapper,html.framed{border-radius:5px;background-clip:padding-box}html.framed .trayOpen #main{height:585px}html.framed .trayOpen .asideContent{height:495px}body>iframe,body>img{display:none}#wrapper{margin:0 auto;max-width:780px;border:1px solid #e3e3e3;border-radius:5px;overflow-y:visible;outline:none}#wrapper,#wrapper #header{-ms-box-sizing:border-box;box-sizing:border-box;background-clip:padding-box;position:relative;background-color:#fff}#wrapper #header{border-radius:5px 5px 0 0;width:100%;z-index:4;box-shadow:0 0 3px 0}#contents{position:relative;z-index:1}.active #wrapper{visibility:visible;-webkit-animation-duration:.4s;-webkit-animation-timing-function:ease;-webkit-animation-name:slideUp}#logo{margin:22px 0 0 20px}.container{clear:both;padding:20px}.containerNoHead{padding-top:0}.noPaddingBottom{padding-bottom:0}.noPaddingTop{padding-top:0}.subContainer{border-top:1px solid #e3e3e3;padding:20px 0;position:relative}#proceedButton{width:46.4%;-ms-box-sizing:border-box;box-sizing:border-box;float:right}#proceedButton.full{width:100%}#proceedButton:focus{color:#fff}#backButton{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box;float:left}#backButton:focus,#backButton:hover{color:#2c2e2f}.middleName{display:none;float:right}.h2,h2{font-size:1.2em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin-top:0;font-weight:400;color:#0666b3}.clearfix:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}* html .clearfix{height:1%}#sliding-area{overflow:hidden}#main{padding:25px 30px 15px;transition:margin .3s ease-out;width:100%;float:right;-ms-box-sizing:border-box;box-sizing:border-box}.loading #main{background:none}.bmlLoadingMessage,.loginLoadingMessage,.loginProcessing .genericLoadingMessage{display:none}.loginProcessing .loginLoadingMessage{display:block}.full{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;text-decoration:none}.trayInner{padding:20px 0}.disclaimer{font-size:.75em;color:#6c7378}.reviewMsg{margin-top:10px;line-height:1.5}.infoTxt{clear:both;padding-top:10px}.help{color:#a9a9a9}.keyValue label{color:#292929}.frontArrow{position:absolute;display:inline-block;width:9px;height:15px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-196px -177px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.frontArrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.focusableIcon:focus{box-shadow:0 0 1px #6c7378}input[type=button],input[type=submit]{-webkit-appearance:none}.inputField input[disabled=disabled],.inputField input[disabled=disabled]:active,input[disabled=disabled]{background:#f7f9fa;border:1px solid #cbd2d6;color:#6c7378}input::-ms-clear{display:none}input.link:hover{cursor:pointer}input.xsmall{width:2em}input.small{width:3.35em;font-size:1em}input.medium{width:7em}input.large{width:14em}input.xlarge{width:20em}.button-as-link{margin:0;padding:0;border:none;width:auto;font-size:.85em;background:transparent;color:#0070ba;cursor:pointer}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.buttons{margin-top:15px;margin-bottom:15px;overflow:hidden}.inputField{position:relative}.inputField input,.inputField label{display:block;vertical-align:top}.ignoreValidation .inputField.error input,.inputField input,.validated .ignoreValidation .inputField input.backendError,.validated .ignoreValidation .inputField input.ng-invalid{width:100%;height:44px;padding:0 14px;border-radius:5px;background-clip:padding-box;border:1px solid #c5ccd1;color:#000;transition:border-color .3s ease 0s;-ms-box-sizing:border-box;box-sizing:border-box;background:none}.ignoreValidation .inputField.error input::-webkit-input-placeholder,.inputField input::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.backendError::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-webkit-input-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-moz-placeholder,.ignoreValidation .inputField.error input::-moz-placeholder,.inputField input:-moz-placeholder,.inputField input::-moz-placeholder,.validated .ignoreValidation .inputField input.backendError:-moz-placeholder,.validated .ignoreValidation .inputField input.backendError::-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-moz-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-ms-input-placeholder,.inputField input:-ms-input-placeholder,.validated .ignoreValidation .inputField input.backendError:-ms-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-ms-input-placeholder{color:#6c7378}.inputField input:active,.inputField input:focus{border:1px solid #009cde;outline:0}.inputField select{font-size:1.5em;margin-bottom:10px}.custom-select-container select{font-size:15px}.inputField label{position:absolute;top:14px;left:14px;cursor:text;text-align:left;color:#666;font-size:1em}.no-js .dropdown label,.no-js .inputField label{position:static}.fieldGroup .inputField{float:left;padding:0 .5em 0 0}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.inputField.error input::-webkit-input-placeholder,.validated .inputField input.backendError::-webkit-input-placeholder,.validated .inputField input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.inputField.error input:-moz-placeholder,.inputField.error input::-moz-placeholder,.validated .inputField input.backendError:-moz-placeholder,.validated .inputField input.backendError::-moz-placeholder,.validated .inputField input.ng-invalid:-moz-placeholder,.validated .inputField input.ng-invalid::-moz-placeholder{color:#c72e2e}.inputField.error input:-ms-input-placeholder,.validated .inputField input.backendError:-ms-input-placeholder,.validated .inputField input.ng-invalid:-ms-input-placeholder{color:#c72e2e}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}.inputField.valid input{background:#fff url(https://www.paypalobjects.com/images/checkout/hermes/icon_checkmark_wallet_2x.png) no-repeat 98%;background-size:14px}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.creditCardField.valid input{background:#fff}.dropdown.error select,.inputField.error select{border:1px solid #c72e2e}.selectLabel{display:block}input::-webkit-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:1em}input:-moz-placeholder,input::-moz-placeholder{color:#6c7378;opacity:1;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}input:-ms-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.checkbox input[type=checkbox]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.checkbox input[type=checkbox]~label,.checkbox input[type=checkbox]~label.bgImgOnSpan span.bgImg{display:inline-block;position:static;min-height:25px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px 0;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.checkbox input[type=checkbox]~label,.checkbox input[type=checkbox]~label.bgImgOnSpan span.bgImg{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.checkbox input[type=checkbox]~label.bgImgOnSpan span.bgImg{display:block;float:left;width:0;height:25px;margin-left:-35px}.checkbox input[type=checkbox]~label.bgImgOnSpan{background-image:none}.checkbox.error input[type=checkbox]:focus~label,.checkbox.error input[type=checkbox]:focus~label.bgImgOnSpan span.bgImg,.checkbox.error input[type=checkbox]~label,.checkbox.error input[type=checkbox]~label.bgImgOnSpan span.bgImg{background-position:-9px -600px}.checkbox input[type=checkbox]:checked~label,.checkbox input[type=checkbox]:checked~label.bgImgOnSpan span.bgImg{background-position:-9px -400px}.checkbox input[type=checkbox]:focus:checked~label,.checkbox input[type=checkbox]:focus:checked~label.bgImgOnSpan span.bgImg{background-position:-9px -4801px}.checkbox input[type=checkbox]:focus~label,.checkbox input[type=checkbox]:focus~label.bgImgOnSpan span.bgImg{background-position:-9px -4601px}.checkbox input[type=checkbox][disabled=disabled]~label,.checkbox input[type=checkbox][disabled=disabled]~label.bgImgOnSpan span.bgImg{background-position:-9px -800px}.checkbox input[type=checkbox][disabled=disabled]:checked~label,.checkbox input[type=checkbox][disabled=disabled]:checked~label.bgImgOnSpan span.bgImg{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:25px 25px}.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label.bgImgOnSpan span.bgImg,.validated .ignoreValidation input[type=checkbox].ng-invalid~label,.validated .ignoreValidation input[type=checkbox].ng-invalid~label.bgImgOnSpan span.bgImg{background-position:-9px 0}.validated .ignoreValidation .sCheckbox.checkbox input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation .sCheckbox.checkbox input[type=checkbox].ng-invalid:focus~label.bgImgOnSpan span.bgImg,.validated .ignoreValidation .sCheckbox.checkbox input[type=checkbox].ng-invalid~label,.validated .ignoreValidation .sCheckbox.checkbox input[type=checkbox].ng-invalid~label.bgImgOnSpan span.bgImg{background-position:-9px 2600px}.validated input[type=checkbox].ng-invalid~label,.validated input[type=checkbox].ng-invalid~label.bgImgOnSpan span.bgImg{background-position:-9px -600px}.validated input[type=radio].ng-invalid+label,.validated input[type=radio].ng-invalid+label.bgImgOnSpan span.bgImg,.validated input[type=radio].ng-invalid:focus+label,.validated input[type=radio].ng-invalid:focus+label.bgImgOnSpan span.bgImg{background-position:-10px -2200px}.validated .sCheckbox.checkbox input[type=checkbox].ng-invalid~label,.validated .sCheckbox.checkbox input[type=checkbox].ng-invalid~label.bgImgOnSpan span.bgImg{background-position:-9px -3200px}.sCheckbox.checkbox{position:relative}.sCheckbox.checkbox input[type=checkbox]~label,.sCheckbox.checkbox input[type=checkbox]~label.bgImgOnSpan span.bgImg{line-height:19px;padding-left:27px;font-size:.85em;background-position:-9px -2600px}.sCheckbox.checkbox input[type=checkbox]~label.bgImgOnSpan span.bgImg{display:block;float:left;width:0;height:19px;margin-left:-27px}.sCheckbox.checkbox input[type=checkbox]~label.bgImgOnSpan{background-image:none}.sCheckbox.checkbox.error input[type=checkbox]:focus~label,.sCheckbox.checkbox.error input[type=checkbox]:focus~label.bgImgOnSpan span.bgImg,.sCheckbox.checkbox.error input[type=checkbox]~label,.sCheckbox.checkbox.error input[type=checkbox]~label.bgImgOnSpan span.bgImg{background-position:-9px -3200px}.sCheckbox.checkbox input[type=checkbox]:checked~label,.sCheckbox.checkbox input[type=checkbox]:checked~label.bgImgOnSpan span.bgImg{background-position:-9px -3000px}.sCheckbox.checkbox input[type=checkbox]:focus:checked~label,.sCheckbox.checkbox input[type=checkbox]:focus:checked~label.bgImgOnSpan span.bgImg{background-position:-9px -5409px}.sCheckbox.checkbox input[type=checkbox]:focus~label,.sCheckbox.checkbox input[type=checkbox]:focus~label.bgImgOnSpan span.bgImg{background-position:-9px -2800px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]~label,.sCheckbox.checkbox input[type=checkbox][disabled=disabled]~label.bgImgOnSpan span.bgImg{background-position:-9px -3400px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]:checked~label,.sCheckbox.checkbox input[type=checkbox][disabled=disabled]:checked~label.bgImgOnSpan span.bgImg{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:18px 19px}.radioButton input[type=radio]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.radioButton input[type=radio]~label{display:inline-block;min-height:26px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px -1600px;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.radioButton input[type=radio]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.radioButton.error input[type=radio]+label,.radioButton.error input[type=radio]:focus+label{background-position:-9px -2200px}.radioButton.warning input[type=radio]+label,.radioButton.warning input[type=radio]:focus+label{background-position:-9px -7405px}.radioButton input[type=radio]:checked+label{background-position:-9px -2000px}.radioButton input[type=radio]:focus:checked+label{background-position:-9px -6010px}.radioButton input[type=radio]:focus+label{background-position:-9px -1800px}.inputField label.nolap{position:relative;top:auto;left:auto;color:#2c2e2f}.inputField.half{width:48.15%;margin-right:3.7%;padding-right:0}.multistepSignupForm .inputField.half,.singlePagePaymentForm .inputField.half{width:48.7%;margin-right:2.6%;padding-right:0}.inputField.half.issueNo{width:42%;margin-top:15px}.inputField.half.startDate{width:54%;margin-right:10px}#cardIssueInfo .inputField.half.startDate{width:48%;margin-right:0}#cardIssueInfo .inputField.half.issueNo{width:48%;margin-top:0;float:right}#cardIssueInfo .inputField.half.issueNo:before{content:\"\\200C\"}.inputField.half.last-child{margin-right:0}.fieldGroup .inputField.last-child{padding-right:0}.fidobDay{width:30%;float:left}.fidobDay .custom-select>span{border-radius:5px 0 0 5px;border-right:0}.fidobMonth{width:30%;float:left}.fidobMonth .custom-select>span{border-radius:0}.fidobYear{width:40%;float:left}.fidobYear .custom-select>span{border-radius:0 5px 5px 0;border-left:0}.cardDOB{width:100%;clear:both}.dobLabel{top:auto;left:auto;position:relative;display:block;bottom:4px}.dobTXT{margin-top:10px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}}.submitted input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.submitted input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.submitted input.ng-invalid:-moz-placeholder,.submitted input.ng-invalid::-moz-placeholder{color:#c72e2e}.submitted input.ng-invalid:-ms-input-placeholder{color:#c72e2e}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.submitted input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}.merchantHeader{height:90px;margin:0 auto}.merchantHeader .headerWrapper{max-width:780px;margin:0 auto;overflow:hidden;max-height:90px;line-height:90px}.merchantHeader .merchantName{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400;width:575px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block}.merchantHeader img{vertical-align:middle}.paypalHeaderWrapper .logo{float:left;width:112px;height:29px;margin-top:5px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.paypalHeaderWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.paypalHeaderWrapper .span14{padding-bottom:20px;border-bottom:1px solid #dbdbdb}.paypalHeaderWrapper .cartContainer{position:static;line-height:29px}.paypalHeaderWrapper .transctionCartDetails{z-index:2}.paypalHeaderWrapper.paypalCredit .logo{height:35px;background-position:0 -129px}.aside .header{padding:15px;vertical-align:middle;line-height:50px;border-bottom:1px solid #e3e3e3}.aside .header.tall{min-height:65px;line-height:normal;padding:13px 15px 10px;margin-bottom:0}.aside .asideAlpha{padding:0 30px;text-align:center;line-height:1.2em}.aside .walletHeading{text-align:center}.aside .close{top:10px;right:15px;padding:5px;border-radius:3px}.aside .close,.aside .close:before{position:absolute;width:19px;height:19px}.aside .close:before{content:\"\";display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .close:focus:before,.aside .close:hover:before{background-position:-223px -22px}.aside .backArrow{position:absolute;top:10px;left:15px;width:9px;height:18px;padding:5px;border-radius:3px}.aside .backArrow:before{content:\"\";display:inline-block;position:absolute;width:9px;height:18px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -46px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .backArrow:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .backArrow:focus:before,.aside .backArrow:hover:before{background-position:-232px -68px}.aside .addOptions{margin-top:20px}.aside .addOptions h2{float:left;width:70%;margin-bottom:0}.aside .addOptions a{float:right;display:block;line-height:1.9em;font-size:.85em}.aside .subHeader{margin-top:20px}.CYCOPage .paypalHeader.span14,.pageSepaAgreementContingency .paypalHeader.span14,.pageSepaMandate .paypalHeader.span14,.pageSepaMandateContingency .paypalHeader.span14{width:100%}#mobileMerchantHeader{display:none}@media (max-width:41.3125em){.merchantHeader{display:none}.paypalHeaderWrapper{height:65px}.paypalHeaderWrapper .cartContainer{margin-top:10px;margin-bottom:-5px;margin-right:15px}.paypalHeaderWrapper .logo{margin:15px 0 0 30px}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}}@media (max-width:30em) and (min-width:0){.paypalHeaderWrapper .cartContainer{margin-top:15px;margin-bottom:-10px;margin-right:0}.paypalHeaderWrapper .logo{margin:15px 0 0}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}.header{height:55px}.aside .header{height:auto}.aside .close{right:15px}}.footer{max-width:780px;margin:10px auto;font-size:.75em}.cancelUrl{float:left;width:39%}.micaLender{display:none;color:#2c2e2f;clear:both}.footerWrapper table{display:inline;float:left;table-layout:fixed;border:none;width:75%}.footerWrapper td,.footerWrapper th,.footerWrapper tr{border:none;font-weight:400;padding-bottom:0;padding-top:0;text-align:left}.footerWrapper .footerLinks th{color:#6c7378}.footerWrapper .footerLinks th.feedbackLink{color:#0070ba}.footerWrapper .footerLinks .underline th{border-bottom:1px solid #ccc}.footerLinks{margin:0;display:inline-block}.footerLinks a{color:#6c7378}.footerLinks a.feedbackLink{color:#0070ba;margin-left:5px}.footerLinks th,td{border:none}.copyright{display:inline;width:auto;vertical-align:top;color:#6c7378}.secureIcon{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:0 -33px;margin-left:3px;margin-right:3px;margin-top:3px;width:10px;height:12px;vertical-align:top}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.secureIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.poweredBy{float:right;margin-top:-49px}.poweredBy .text{float:left;margin-top:8px;margin-right:8px;font-size:12px;font-weight:400;font-style:italic;color:#6c7378}.footerLinks li{padding:0 12px 0 0;display:inline-block}.footerLinks .last{padding-right:18px;border-right:none}.footer .policyInfoWrapper p{line-height:1.3em}.footer .policyInfoWrapper p a{font-weight:700}.minibrowser .APAC.footer,.minibrowser.AU .footer{position:relative;bottom:0;width:auto}.minibrowser .APAC.footer .policyInfoWrapper,.minibrowser.AU .footer .policyInfoWrapper{padding:0}.minibrowser .cancelUrl{display:none}.minibrowser .footerWrapper{padding:0 10px;float:none;width:95%;margin:0}.minibrowser .footerLinks li{padding:0 5px 0 0}.DE .footerWrapper,.fr.CA .footerWrapper,.fr.FR .footerWrapper{float:none;width:auto}.DE .footerWrapper:after,.fr.CA .footerWrapper:after,.fr.FR .footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.DE .footerLinks,.fr.CA .footerLinks,.fr.FR .footerLinks{float:left;width:70%;text-align:left}.DE .footerLinks li:first-child,.fr.CA .footerLinks li:first-child,.fr.FR .footerLinks li:first-child{padding-left:0}.DE .copyright,.fr.CA .copyright,.fr.FR .copyright{float:right;width:30%;margin:0}.DE .cancelUrl,.fr.CA .cancelUrl,.fr.FR .cancelUrl{float:none;margin:5px 0;width:100%}.APAC .policyInfoWrapper{padding:5px 0 10px;color:#6c7378}.APAC .policyInfoWrapper p.moreInfo{padding:15px 0 20px;float:left;line-height:1.3em}.AU .policyInfoWrapper,.en_AU .policyInfoWrapper{padding:20px 0 10px;color:#6c7378}.AU .policyInfoWrapper p.moreInfo,.en_AU .policyInfoWrapper p.moreInfo{padding:15px 0 20px;border-bottom:1px solid #ccc;float:left}.AU .policyInfoWrapper p.moreCopyRight,.en_AU .policyInfoWrapper p.moreCopyRight{padding:5px 0 0;clear:both}.fr_XC .footerWrapper{float:left;width:70%;text-align:left;padding-left:0;margin-left:-7px}@media (max-width:41.25em){.footer{border-top:1px solid #ccc;padding:5px 20px;margin-top:10px}.footer .policyInfoWrapper{padding:0 10px}.footerWrapper{float:none;width:100%;padding:0;margin:0}.footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.cancelUrl{width:95%;padding:0}.footerLinks{float:left;width:70%;text-align:left}.footerLinks .feedback{display:none}.minibrowser .footerLinks .feedback{display:inline-block}.copyright{width:20%}.cancelUrl{float:none;margin:5px 0}}@media (max-width:30em) and (min-width:0){.footer{margin-top:0;padding:5px 10px}.footer .policyInfoWrapper{padding:0}.cancelUrl,.footerWrapper{padding:0;margin:5px 0;width:100%}.DE .footerLinks,.footerLinks,.fr.FR .footerLinks{width:65%}.DE .footerLinks li,.footerLinks li,.fr.FR .footerLinks li{padding:0;margin-right:10px}.DE .footerLinks li.last,.footerLinks li.last,.fr.FR .footerLinks li.last{margin-right:0}.DE .footerLinks .feedback,.footerLinks .feedback,.fr.FR .footerLinks .feedback{display:none}.copyright,.DE .copyright{width:33%;margin:0}.minibrowser .copyright{margin-right:0;width:30%}.minibrowser .footerLinks .feedback{display:inline-block}}.modal-open{overflow:hidden}.modal-open #contents,.modal-open #wrapper,.modal-open .outerWrapper{position:static}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:140;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop,.modal-backdrop.fade.in{opacity:.54}.modal{display:none;overflow:auto;overflow-y:scroll;position:fixed;top:0;right:0;bottom:0;left:0;z-index:150}.modal.fade .modal-wrap{-webkit-transform:translateY(-25%);transform:translateY(-25%);transition:transform .3s ease-out}.modal.fade.in .modal-wrap{-webkit-transform:translate(0);transform:translate(0)}.modal-wrap{position:relative;margin:10px;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.3);border-radius:6px;background-clip:padding-box;box-shadow:0 3px 9px rgba(0,0,0,.3);outline:none}.modal-header{padding:9px 15px;border-bottom:1px solid #eee}.modal-header .close{margin-top:2px}.modal-header h3{margin:0;line-height:30px}.modal-body{position:relative;overflow-y:auto;max-height:400px;padding:15px}.modal-footer,.modal-form{margin-bottom:0}.modal-footer{padding:14px 15px 15px;text-align:right;background-color:#f5f5f5;border-top:1px solid #ddd;border-radius:0 0 6px 6px;background-clip:padding-box;box-shadow:inset 0 1px 0 #fff}.modal-footer:after,.modal-footer:before{display:table;content:\"\";line-height:0}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.spinner{height:100%;width:100%;position:absolute;z-index:10}.spinner .spinWrap{width:200px;height:100px;position:absolute;top:50%;left:50%;margin-left:-100px;margin-top:-50px}.spinner .spinnerImage{margin:28px 0 0 -25px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/icon_ot_spin_lock_skinny.png\") no-repeat}.spinner .loader,.spinner .spinnerImage{height:100px;width:100px;position:absolute;top:0;left:50%;opacity:1;filter:alpha(opacity=100)}.spinner .loader{margin:0 0 0 -55px;background-color:transparent;-webkit-animation:rotation .7s infinite linear;animation:rotation .7s infinite linear;border-left:5px solid #cbcbca;border-right:5px solid #cbcbca;border-bottom:5px solid #cbcbca;border-top:5px solid #2380be;border-radius:100%}.spinner .bmlLoadingMessage,.spinner .genericLoadingMessage,.spinner .loginLoadingMessage{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;margin-top:125px;text-align:center;z-index:100}.spinner.preloader{position:fixed;top:0;left:0;z-index:1000;background-color:#fff}@-webkit-keyframes rotation{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(359deg)}}@keyframes rotation{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.aside{min-height:380px}.aside .container{padding:15px}.asideContent{height:100%}.centerText{text-align:center}.fsIcons{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;min-width:32px;width:25px;height:21px;padding-right:5px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.BALANCE .fsIcons,.DELAYED_TRANSFER .fsIcons,.HOLDING .fsIcons{background-position:0 0}.ELO .fsIcons{background-position:0 -479px}.HIPER .fsIcons{background-position:0 -458px}.HIPERCARD .fsIcons{background-position:0 -500px}.pinlessGlyphIcon{display:inline-block;position:relative;top:-5px;left:-8px;width:32px;height:20px;font-size:3.1rem;padding-right:5px}.BANK .fsIcons,.BANK_ACCOUNT .fsIcons,.IACH .fsIcons{background-position:0 -252px;height:19px;left:19px}.ECHECK .fsIcons,.ELV .fsIcons,.TAB.DELAYED_TRANSFER .fsIcons{background-position:0 -252px;height:19px}.TAB.DELAYED_TRANSFER .fsIcons{left:19px}.BILL_ME_LATER .fsIcons,.BML .fsIcons,.CREDIT_OPTION .fsIcons,.PPCREDIT .fsIcons{background-position:0 -105px}.PAYPAL_SMART_CONNECT .fsIcons{background-position:0 0}.VISA .fsIcons{background-position:0 -21px}.MASTERCARD .fsIcons{background-position:0 -42px}.AMEX .fsIcons{background-position:0 -63px;left:19px;height:20px}.DISC .fsIcons,.DISCOVER .fsIcons{background-position:0 -84px}.JCB .fsIcons{background-position:0 -353px}.CHINA_UNION_PAY .fsIcons{background-position:0 -563px}.ELECTRON .fsIcons{background-position:0 -146px}.MAESTRO .fsIcons,.MSTRO .fsIcons,.SWITCH .fsIcons{background-position:0 -168px}.CB_NATIONALE .fsIcons,.CBN .fsIcons{background-position:0 -210px}.CELEM .fsIcons,.CETELEM .fsIcons{background-position:0 -311px}.COFINOGA .fsIcons,.CONF .fsIcons{background-position:0 -231px}.COFID .fsIcons,.COFIDIS .fsIcons{background-position:0 -437px;left:20px}.INCENTIVE .fsIcons{background-position:0 -271px;height:18px}.PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -374px}.PPSMTCONNECT .fsIcons{background-position:0 0}.ES .PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -521px}.fsIcon{display:block;position:absolute;width:25px;height:21px;left:15px;top:20px;min-width:32px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;background-position:0 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.fsIcon.BANK,.fsIcon.PAD{background-position:6px -252px;height:19px;left:19px}.fsIcon.MASTER,.fsIcon.MASTERCARD,.fsIcon.MCARD{background-position:0 -42px}.fsIcon.ELO{background-position:0 -479px}.fsIcon.HIPER{background-position:0 -458px}.fsIcon.HIPERCARD{background-position:0 -500px}.fsIcon.DISC,.fsIcon.DISCOVER{background-position:0 -84px}.fsIcon.VISA{background-position:0 -21px}.fsIcon.JCB{background-position:0 -353px}.fsIcon.AMEX,.fsIcon.Amex{background-position:6px -63px;left:19px;height:20px}.fsIcon.MAESTRO,.fsIcon.MSTRO,.fsIcon.SWITCH{background-position:0 -168px}.fsIcon.PAYPAL_SMART_CONNECT{background-position:0 0}.fsIcon.CB_NATIONALE,.fsIcon.CBN{background-position:0 -210px}.fsIcon.CELEM,.fsIcon.CETELEM{background-position:0 -311px}.fsIcon.COFID,.fsIcon.COFIDIS{background-position:0 -437px;left:20px;height:20px}.fsIcon.CHINA_UNION_PAY,.fsIcon.CUP{background-position:0 -563px}.fsIcon.COFINOGA,.fsIcon.CONF{background-position:0 -231px}.fsIcon.PAYPAL_EXTRAS_MASTERCARD,.fsIcon.PPXMCARD{background-position:0 -374px}.fsIcon.EBAY_MASTERCARD,.fsIcon.EBAYMCARD{background-position:0 0}.fsIcon.BILL_ME_LATER,.fsIcon .BML,.fsIcon .PPCREDIT{background-position:0 -105px}.fsIcon.PPSMTCONNECT{background-position:0 0}.fsIcon.pinlessIcon{background-image:none;font-size:3.1rem;left:5px;top:14px}.ES .fsIcon.PAYPAL_EXTRAS_MASTERCARD,.ES .fsIcon.PPXMCARD{background-position:0 -521px}.infoIcon{width:19px;height:18px;display:inline-block;position:absolute;top:25px;right:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-89px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.infoIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.addOption{padding:25px 10px;margin:0 0 0 44px;color:#0070ba;font-size:.85em}.plusicon{display:block;position:absolute;left:15px;top:22px;width:20px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.plusicon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.infoIcon+.checkIcon{display:none}.infoMsg{margin:0;overflow:hidden;font-size:.85em}.expiredIcon{background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%;width:16px;height:16px;top:6px}.expiredIcon,.plccIcon{display:inline-block;position:relative}.plccIcon{float:left;height:20px;background:none;width:32px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.fsIcon,.fsIcons{height:20px}}.walletIcons{position:absolute;width:30px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.walletIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons_2x.png\");background-size:90px 970px}}.walletIcons.BANK,.walletIcons.BANK_ACCOUNT{background-position:-50px -460px}.walletIcons.BANK.BOFA,.walletIcons.BANK_ACCOUNT.BOFA{background-position:-50px -10px}.walletIcons.BANK.CHASE,.walletIcons.BANK_ACCOUNT.CHASE{background-position:-50px -130px}.walletIcons.BANK.WELLSFARGO,.walletIcons.BANK_ACCOUNT.WELLSFARGO{background-position:-50px -100px}.walletIcons.BANK.CITI,.walletIcons.BANK_ACCOUNT.CITI{background-position:-50px -40px}.walletIcons.BANK.FIFTHTHIRD,.walletIcons.BANK_ACCOUNT.FIFTHTHIRD{background-position:-50px -220px}.walletIcons.BANK.CAPITAL,.walletIcons.BANK_ACCOUNT.CAPITAL{background-position:-50px -70px}.walletIcons.BANK.AMERITRADE,.walletIcons.BANK_ACCOUNT.AMERITRADE{background-position:-50px -160px}.walletIcons.BANK.SUNTRUST,.walletIcons.BANK_ACCOUNT.SUNTRUST{background-position:-50px -280px}.walletIcons.BANK.USBANK,.walletIcons.BANK_ACCOUNT.USBANK{background-position:-50px -310px}.walletIcons.BANK.USAA,.walletIcons.BANK_ACCOUNT.USAA{background-position:-50px -250px}.walletIcons.CARD.VISA,.walletIcons.PAYMENT_CARD.VISA{background-position:-10px -40px}.walletIcons.CARD.MASTER,.walletIcons.CARD.MASTERCARD,.walletIcons.PAYMENT_CARD.MASTER,.walletIcons.PAYMENT_CARD.MASTERCARD{background-position:-10px -70px}.walletIcons.CARD.DISCOVER,.walletIcons.PAYMENT_CARD.DISCOVER{background-position:-10px -100px}.walletIcons.CARD.AMEX,.walletIcons.PAYMENT_CARD.AMEX{background-position:-10px -130px}hr.sep,hr.sepPlain{padding:0;margin-top:25px;height:auto;border:none;border-top:1px solid #ccc;color:#2c2e2f;text-align:center;overflow:visible}hr.sep:after,hr.sepPlain:after{content:\"or\";display:inline-block;position:relative;top:-.7em;font-size:1em;padding:0 .5em;background:#fff;color:#6c7378;font-weight:400}.de hr.sep:after{content:\"oder\"}.da hr.sep:after{content:\"eller\"}.es hr.sep:after{content:\"o\"}.fr hr.sep:after{content:\"ou\"}.he hr.sep:after{content:\"\\5D0\\5D5\"}.id hr.sep:after{content:\"Atau\"}.it hr.sep:after{content:\"oppure\"}.ja hr.sep:after{content:\"\\307E\\305F\\306F\"}.ko hr.sep:after{content:\"\\B610\\B294\"}.nl hr.sep:after{content:\"of\"}.no hr.sep:after{content:\"eller\"}.pl hr.sep:after{content:\"lub\"}.pt hr.sep:after{content:\"ou\"}.ru hr.sep:after{content:\"\\418\\43B\\438\"}.sv hr.sep:after{content:\"eller\"}.th hr.sep:after{content:\"\\E2B\\E23\\E37\\E2D\"}.tr hr.sep:after{content:\"Veya\"}.zh hr.sep:after{content:\"\\6216\"}hr.sepPlain:after{content:\"\"}@media (min-width:0) and (max-width:23em){#loginSection .xoTitle h1{max-width:10em}}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){body{-webkit-text-size-adjust:100%}.merchantBrand{display:none}.outerWrapper{background-position:left 50px}.centerTray.loginSignup{margin-bottom:60px}#main{padding:0;background:none;z-index:2}#contents{padding:0 20px;-ms-box-sizing:border-box;box-sizing:border-box}.tokenization #contents{padding:0 30px}.paypalHeader{padding:0 20px 20px;-ms-box-sizing:border-box;box-sizing:border-box}.props,header{display:none}.review #wrapper{min-height:512px}#contents{min-height:0;margin-bottom:0}.bmlAppProcessing,.loginProcessing{background-color:#f9f9f9}.loggingIn{margin:0 25px}.mobile .loggingIn{margin:0}.saferEasier,.simpler{display:none}#login .row-fluid{padding-top:0}#login .centerTray{padding:0}#login #signupLink.btn{margin:5px 0}#wrapper{margin:0;width:auto;border-radius:0;background-clip:padding-box;border:none}#task{width:295px}.loading .spinner{background-position-y:35%}.centerTray{width:auto}.accountTerms .tray .inner,.tray .inner{padding:10px}.row-fluid>[class*=span],.signup{width:100%;margin-left:0;float:none}#notifications{width:100%}.delta,.gamma{font-size:1.2em}.inputField label{left:7px;top:13px}.saferEasier{display:none}#fundingInstruments .buttons{height:40px}.cityState select{font-size:14px}.cityState .city{width:100%}.cityState .state{width:55%}.cityState .postalCode{width:40.8%}#tab{margin-top:0;height:125px}.toolTip.whatsthis ul{width:242px;left:9px}.toolTip.whatsthis ul li{font-size:.9em}#expiration.varB .expires{width:49%}#expiration .inputField{padding:0}#expiration .cvc{width:44%;float:right}#expiration.varB .cvc{width:49%}.month{margin-left:46px}.separator{margin-left:5px;margin-top:3px}.year{margin-left:0}#expiration .cardIcon{position:absolute;right:4px}.details{margin-right:2px}.mask #closeButton,.mask #header{display:none}}@media (min-width:30.0625em) and (max-width:41.25em){#notifications,.row-fluid>.span10,.row-fluid>.span12,.row-fluid>.span14{width:100%}.outerWrapper{background-position:left 59px}.props,header{display:none}#wrapper{margin:0;border:none}#main{padding:0}#contents{padding:0 25px}}@media (min-width:41.3125em){.banner{display:block}#wrapper{min-height:0}#wrapper,.footer,.merchantHeader{width:95%}.largeScreen .centerTray{margin-top:0}.signup{margin-bottom:0}#genericError{min-height:375px;background:url(https://www.paypalobjects.com/images/checkout/hermes/scr_cloud_balloon.png) no-repeat bottom}#transactionDetails .merchantName{display:none}}@media (device-height:568px) and (-webkit-min-device-pixel-ratio:2){#contents{min-height:0;margin-bottom:0}.pageLanding #contents{margin:70px auto 40px 0}}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.cardType{display:none}ul.validations li.restriction.active{background:url(https://www.paypalobjects.com/images/checkout/hermes/close3_2x.png) no-repeat 0 2px;background-size:10px}.inputField.error input{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.inputField.error input,.inputField.valid input{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.error .custom-select.active>span,.error .custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}@media only screen and (-webkit-min-device-pixel-ratio:2) and (min-width:41.3125em){#genericError{background-size:640px 242px}}.inputField.floatingLabel input{height:49px}.inputField.floatingLabel select{height:48px;font-size:15px}.inputField.floatingLabel select.focused~label.hide,.inputField.floatingLabel select:focus~label.hide{display:none}.inputField.floatingLabel.dropdown label{color:transparent}.inputField.floatingLabel.dropdown .custom-select span{padding:0 14px;position:relative;height:47px}.inputField.floatingLabel.dropdown .custom-select span span{top:18px;padding:0}.inputField.floatingLabel.dropdown .custom-select span span.noValue{top:9px}.inputField.floatingLabel input.focused,.inputField.floatingLabel input:focus,.inputField.floatingLabel select.focused,.inputField.floatingLabel select:focus{padding-top:16px}.inputField.floatingLabel input.focused::-webkit-input-placeholder,.inputField.floatingLabel input:focus::-webkit-input-placeholder,.inputField.floatingLabel select.focused::-webkit-input-placeholder,.inputField.floatingLabel select:focus::-webkit-input-placeholder{color:#6c7378}.inputField.floatingLabel input.focused:-moz-placeholder,.inputField.floatingLabel input.focused::-moz-placeholder,.inputField.floatingLabel input:focus:-moz-placeholder,.inputField.floatingLabel input:focus::-moz-placeholder,.inputField.floatingLabel select.focused:-moz-placeholder,.inputField.floatingLabel select.focused::-moz-placeholder,.inputField.floatingLabel select:focus:-moz-placeholder,.inputField.floatingLabel select:focus::-moz-placeholder{color:#6c7378}.inputField.floatingLabel input.focused:-ms-input-placeholder,.inputField.floatingLabel input:focus:-ms-input-placeholder,.inputField.floatingLabel select.focused:-ms-input-placeholder,.inputField.floatingLabel select:focus:-ms-input-placeholder{color:#6c7378}.inputField.floatingLabel input.focused~label,.inputField.floatingLabel input:focus~label,.inputField.floatingLabel select.focused~label,.inputField.floatingLabel select:focus~label{color:#0070ba;-webkit-transform:translate3d(0,-7px,0) scale(.8);transform:translate3d(0,-7px,0) scale(.8);text-overflow:ellipsis;overflow-x:hidden;width:100%;display:inline-block;white-space:nowrap}.inputField.floatingLabel input.focused:not(:focus)~label,.inputField.floatingLabel select.focused:not(:focus)~label{color:#6c7378}.inputField.floatingLabel input::-webkit-input-placeholder,.inputField.floatingLabel select::-webkit-input-placeholder{color:transparent}.inputField.floatingLabel input:-moz-placeholder,.inputField.floatingLabel input::-moz-placeholder,.inputField.floatingLabel select:-moz-placeholder,.inputField.floatingLabel select::-moz-placeholder{color:transparent}.inputField.floatingLabel input:-ms-input-placeholder,.inputField.floatingLabel select:-ms-input-placeholder{color:transparent}.inputField.floatingLabel label{color:#6c7378;position:absolute;top:14px;left:14px;pointer-events:none;-webkit-transform:translateZ(0) scale(1);transform:translateZ(0) scale(1);transform-origin:left top 0;transition:all .25s ease-in-out;text-overflow:ellipsis;overflow-x:hidden;width:90%;display:inline-block;white-space:nowrap}.validated .inputField.floatingLabelDropdown input.ng-invalid.focused::-webkit-input-placeholder,.validated .inputField.floatingLabelDropdown input.ng-invalid:focus::-webkit-input-placeholder,.validated .inputField.floatingLabel input.ng-invalid.focused::-webkit-input-placeholder,.validated .inputField.floatingLabel input.ng-invalid:focus::-webkit-input-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid.focused::-webkit-input-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid:focus::-webkit-input-placeholder{color:#6c7378}.validated .inputField.floatingLabelDropdown input.ng-invalid.focused:-moz-placeholder,.validated .inputField.floatingLabelDropdown input.ng-invalid.focused::-moz-placeholder,.validated .inputField.floatingLabelDropdown input.ng-invalid:focus:-moz-placeholder,.validated .inputField.floatingLabelDropdown input.ng-invalid:focus::-moz-placeholder,.validated .inputField.floatingLabel input.ng-invalid.focused:-moz-placeholder,.validated .inputField.floatingLabel input.ng-invalid.focused::-moz-placeholder,.validated .inputField.floatingLabel input.ng-invalid:focus:-moz-placeholder,.validated .inputField.floatingLabel input.ng-invalid:focus::-moz-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid.focused:-moz-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid.focused::-moz-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid:focus:-moz-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid:focus::-moz-placeholder{color:#6c7378}.validated .inputField.floatingLabelDropdown input.ng-invalid.focused:-ms-input-placeholder,.validated .inputField.floatingLabelDropdown input.ng-invalid:focus:-ms-input-placeholder,.validated .inputField.floatingLabel input.ng-invalid.focused:-ms-input-placeholder,.validated .inputField.floatingLabel input.ng-invalid:focus:-ms-input-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid.focused:-ms-input-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid:focus:-ms-input-placeholder{color:#6c7378}.validated .inputField.floatingLabelDropdown input.ng-invalid:not(:focus):not(.focused)~label,.validated .inputField.floatingLabel input.ng-invalid:not(:focus):not(.focused)~label,.validated .inputField.noFloatingLabel input.ng-invalid:not(:focus):not(.focused)~label{color:#c72e2e}.validated .inputField.floatingLabelDropdown input.ng-invalid::-webkit-input-placeholder,.validated .inputField.floatingLabel input.ng-invalid::-webkit-input-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid::-webkit-input-placeholder{color:transparent}.validated .inputField.floatingLabelDropdown input.ng-invalid:-moz-placeholder,.validated .inputField.floatingLabelDropdown input.ng-invalid::-moz-placeholder,.validated .inputField.floatingLabel input.ng-invalid:-moz-placeholder,.validated .inputField.floatingLabel input.ng-invalid::-moz-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid:-moz-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid::-moz-placeholder{color:transparent}.validated .inputField.floatingLabelDropdown input.ng-invalid:-ms-input-placeholder,.validated .inputField.floatingLabel input.ng-invalid:-ms-input-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid:-ms-input-placeholder{color:transparent}.validated .inputField.floatingLabelDropdown input.ng-invalid~label,.validated .inputField.floatingLabel input.ng-invalid~label,.validated .inputField.noFloatingLabel input.ng-invalid~label{color:#c72e2e}.validated .inputField.floatingLabelDropdown input.ng-invalid~label.hide,.validated .inputField.floatingLabel input.ng-invalid~label.hide,.validated .inputField.noFloatingLabel input.ng-invalid.focused~label,.validated .inputField.noFloatingLabel input.ng-invalid~label.hide{color:transparent}.inputField.noFloatingLabel label{color:transparent;left:14px;text-overflow:ellipsis;overflow-x:hidden;width:90%;white-space:nowrap;pointer-events:none}.inputField.noFloatingLabel input{height:49px}.inputField.noFloatingLabel input::-webkit-input-placeholder{color:transparent}.inputField.noFloatingLabel input:-moz-placeholder,.inputField.noFloatingLabel input::-moz-placeholder{color:transparent}.inputField.noFloatingLabel input:-ms-input-placeholder{color:transparent}.inputField.noFloatingLabel input:focus.focused~label{color:transparent}.inputField.noFloatingLabel input:not(.focused):focus~label{color:#6c7378}.inputField.noFloatingLabel input:not(.focused):focus.hasPlaceholder~label{color:transparent}.inputField.noFloatingLabel input:not(.focused):focus.hasPlaceholder::-webkit-input-placeholder{color:#6c7378}.inputField.noFloatingLabel input:not(.focused):focus.hasPlaceholder:-moz-placeholder,.inputField.noFloatingLabel input:not(.focused):focus.hasPlaceholder::-moz-placeholder{color:#6c7378}.inputField.noFloatingLabel input:not(.focused):focus.hasPlaceholder:-ms-input-placeholder{color:#6c7378}.inputField.noFloatingLabel input:not(:focus):not(.focused)~label{color:#6c7378}.inputField.noFloatingLabel select{height:48px;font-size:15px}.inputField.noFloatingLabel select.focused~label,.inputField.noFloatingLabel select:focus~label{color:transparent}.inputField.noFloatingLabel .custom-select span{padding:0 14px;position:relative;height:47px}.inputField.noFloatingLabel .custom-select span span{top:11px;padding:0}.inputField.noFloatingLabel#countryOfResidenceDropDown,.inputField.noFloatingLabel#nationalityDropDown{min-height:87px}.inputField.noFloatingLabel#countryOfResidenceDropDown .custom-select,.inputField.noFloatingLabel#countryOfResidenceDropDown select,.inputField.noFloatingLabel#nationalityDropDown .custom-select,.inputField.noFloatingLabel#nationalityDropDown select{top:20px}.inputField.noFloatingLabel#countryOfResidenceDropDown label,.inputField.noFloatingLabel#nationalityDropDown label{color:#6c7378;top:0;left:0}", ""]);
	
	// exports


/***/ }),

/***/ "./components/xo-guest-components/src/guest/countryList/template.html":
/***/ (function(module, exports) {

	module.exports = "<div id=\"countryList\" class=\"countryList dropdown confidential inputField\" ng-class=\"{'validated': showMessage}\"\n     ng-cloak content floating-label-dropdown>\n    <div id=\"blockNonDomesticPayer\" ng-if=\"blockNonDomesticPayer\" class=\"infoMsg errorMsgRuleSpecific\">\n        <span class=\"infoIcon\"></span>\n        <span>{{content('billing.blockNonDomesticPayer', {countryCode: selectedCountryObj.code})}}</span>\n    </div>\n    <div ng-class=\"{'showMask': disableCountryList}\">\n        <select xo-dropdown compliance-validation dropdown-text-bind-var=\"selectedCountryObj.name\"\n                ng-model=\"selectedCountryObj\" name=\"countryName\" id=\"countrySelector\"\n                ng-required=\"true\" ng-disabled=\"disableCountryList\"\n                aria-describedby=\"errorSignupAgree\"\n                ng-options=\"country.name for country in supportedCountries track by country.code\"\n                ng-change=\"actions.countryChanged(selectedCountryObj.code)\">\n        </select>\n        <label for=\"countrySelector\" id=\"countryListLabel\">{{content('country.country')}}</label>\n    </div>\n\n    <div id=\"errorSignupAgree\" ng-if=\"showMessage\" class=\"errorMsg errorMsgRuleSpecific\">\n        {{content('common.complianceRestricted', {merchantCountry: selectedCountryObj.name})}}\n    </div>\n</div>\n"

/***/ }),

/***/ "./components/xo-guest-components/src/guest/emailInput/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/directionality/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js");
	
	__webpack_require__("./components/xo-validation/dist/directive.js");
	
	__webpack_require__("./components/xo-guest-components/src/guest/emailInput/styles.less");
	
	var _template = __webpack_require__("./components/xo-guest-components/src/guest/emailInput/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('xoEmailInput', {
	    tag: 'xo-email-input',
	    template: _template2['default'],
	    props: {
	        user: {
	            type: 'var',
	            required: 'true'
	        },
	        disabled: {
	            type: 'var',
	            required: 'false'
	        },
	        hideHelper: {
	            type: 'var', // flow: Optional string, if "signup" then use the Signup tooltip
	            required: 'false'
	        },
	        flags: {
	            type: 'var',
	            required: 'false'
	        }
	    },
	    lifecycle: {
	        enter: function enter() {
	            this.flags = this.flags ? this.flags : {};
	        }
	    }
	});
	
	
	_squid.$Component;
	module.exports = exports['default'];

/***/ }),

/***/ "./components/xo-validation/dist/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular, squid) {
	    squid.module('xo-validation.directive', ['squid']).directive('xoValidation', function () {
	        return {
	            template: '',
	            restrict: 'A',
	            require: 'ngModel',
	
	            link: function link(scope, elem, attr, ngModel) {
	
	                var validationUtil = {
	
	                    // because IE8 doesnt have String.prototype.trim()
	                    trim: function trim(value) {
	                        var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	                        return value.replace(rtrim, '');
	                    },
	
	                    /**
	                     * Generic function that runs a given input against
	                     * a given regular expression
	                     *
	                     * @param {String} value input to test
	                     * @param {String/RegExp} regex Regular expression to test against
	                     * @returns {Boolean} matches or does not match given pattern
	                     */
	                    valid: function valid(value, regex) {
	                        if (this.empty(value)) {
	                            return false;
	                        }
	
	                        if (angular.isString(regex)) {
	                            regex = new RegExp(regex);
	                        }
	
	                        return regex ? regex.test(value) : true;
	                    },
	
	                    // returns whether empty or not
	                    empty: function empty(value) {
	                        if (!value) {
	                            return true;
	                        }
	
	                        // IE8 and below doesn't have native .trim()
	                        return !this.trim(value);
	                    },
	
	                    // returns whether alphabetic or not
	                    alphabetic: function alphabetic(value) {
	                        return this.valid(value, /[A-Za-z]+$/);
	                    },
	
	                    // returns whether numeric or not
	                    numeric: function numeric(value) {
	                        var NUMERIC_REGEX = new RegExp('^[0-9]+$');
	
	                        return this.valid(value, NUMERIC_REGEX);
	                    },
	
	                    validBankAccount: function validBankAccount(value) {
	                        if (!scope.showIBAN) {
	                            return this.numeric(value);
	                        }
	
	                        return true;
	                    },
	
	                    validRouting: function validRouting(value) {
	                        if (!scope.showIBAN) {
	                            return this.valid(value, /^\d{8}$/);
	                        }
	                        return true;
	                    },
	
	                    validIBANCode: function validIBANCode(value) {
	                        if (scope.showIBAN) {
	                            value = value && value.replace(/ +/g, '');
	                            return this.valid(value, /^([A-Z]){2}\d{2}[A-Z0-9]{1,30}$/);
	                        }
	                        return true;
	                    },
	
	                    validIBAN: function validIBAN(value) {
	                        if (scope.showIBAN) {
	                            value = value && value.replace(/ +/g, '');
	                            return this.valid(value, /^DE\d{20}$/);
	                        }
	                        return true;
	                    },
	
	                    validIBANCountry: function validIBANCountry(value) {
	                        value = value && value.replace(/ +/g, '');
	                        return !this.valid(value, /^([^D0-9][E]|[D][^E0-9]|[^D0-9][^E0-9])\d{2}[A-Z0-9]{1,30}$/i);
	                    },
	
	                    // first two letters are the country code the rest are the bank account numbers max length 32
	                    validIBANWithValidCountryCode: function validIBANWithValidCountryCode(value) {
	                        value = value && value.replace(/ +/g, '');
	                        return this.valid(value, /^(AT|BE|CY|EE|FI|FR|DE|EL|IE|IT|LV|LT|LU|MT|MC|NL|PT|SK|SI|ES)\d{3,32}$/i);
	                    },
	
	                    validLast4: function validLast4(value) {
	                        // @TODO - Unsafe regular expression, need to fix.
	                        var LAST_4 = /^([0-9]{4})?$/; // eslint-disable-line fasec/no-unsafe-regex
	                        return this.valid(value, LAST_4);
	                    },
	
	                    validStreet: function validStreet(value) {
	                        return this.valid(value, /^([A-Za-z0-9-. ]*)$/);
	                    },
	
	                    // Validating phone format with metadata from griffin
	                    validPhone: function validPhone(value) {
	                        var regex = scope.pattern;
	                        /*
	                         * User can enter phone format in various manner according to griffin mask
	                         * (00) 0000-0000
	                         * 00 000 0000
	                         * Since the griffin pattern only validates against numbers, need to trim the input
	                         * to only validate the numbers
	                         */
	                        value = value && value.replace(/[^0-9]/gi, '');
	                        return this.valid(value, regex);
	                    },
	
	                    validDobYear: function validDobYear(value) {
	                        return value !== 'YYYY';
	                    },
	
	                    validDobDay: function validDobDay(value) {
	                        return value !== 'DD';
	                    },
	
	                    validDobMonth: function validDobMonth(value) {
	                        return value !== 'MM';
	                    },
	
	                    validPoBox: function validPoBox(value) {
	                        // @TODO - Unsafe regular expression, need to fix.
	                        var boxRE = /\b(((general\s+)?post\s+(office|mail)?)|((g\.?)?p[-\.]?\s?[om][\.-]?))\s?(b(ox|\.)?)?(\s+\d+)\b/i; // eslint-disable-line fasec/no-unsafe-regex
	
	                        if (boxRE.test(value)) {
	                            return true;
	                        }
	                        return false;
	                    },
	
	                    validAddressSansPoBox: function validAddressSansPoBox(value) {
	                        var boxRE = /(p[-.]? ?[om]?[-.]? ?|post ?(office|mail)?)? ?b(.|ox)[^,]*\d+/i;
	                        var cassRE = /(drawer|locker|bin|firm caller)\s?#?[0-9]+/i;
	
	                        if (boxRE.test(value) || cassRE.test(value)) {
	                            return false;
	                        }
	                        return true;
	                    },
	
	                    validEmailOrPhone: function validEmailOrPhone(value) {
	                        if (!value) {
	                            return false;
	                        }
	
	                        return this.validEmail(value) || this.validPhone(value);
	                    },
	
	                    validEmail: function validEmail(value) {
	                        if (!value) {
	                            return false;
	                        }
	                        var trimmedValue = this.trim(value); // Trim leading and trailing whitespace
	                        // @TODO - Unsafe regular expression, need to fix.
	                        var EMAIL_REGEX = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i; // eslint-disable-line
	
	                        return this.valid(trimmedValue, EMAIL_REGEX) && !this.highAscii(trimmedValue);
	                    },
	
	                    highAscii: function highAscii(value) {
	                        var trimmedValue = this.trim(value);
	                        // @TODO - Unsafe regular expression, need to fix.
	                        var HIGH_ASCII_REGEX = /[^\x00-\x7F]/; // eslint-disable-line no-control-regex
	
	                        return this.valid(trimmedValue, HIGH_ASCII_REGEX);
	                    },
	
	                    // expected format: MM/DD/YYYY
	                    validDate: function validDate(value) {
	                        var re = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
	                        var dArr = value.split('/');
	                        var d = new Date(value);
	                        var isValid = false;
	
	                        if (re.test(value)) {
	                            isValid = d.getMonth() + 1 === dArr[0] && d.getDate() === dArr[1] && d.getFullYear() === dArr[2];
	                        }
	
	                        return isValid;
	                    },
	
	                    /* Expects value and state. state can be "past" or "future".
	                     NOTE: This function validates only month and year, not day!
	                     Please use validDate() if you need to validate the whole date. */
	                    validDateWithoutDay: function validDateWithoutDay(value, options) {
	                        var state = options.state;
	
	                        value = value.replace(/\s/g, '');
	
	                        if (value === '') {
	                            return true;
	                        }
	
	                        var split = value.split('/');
	                        var month = split[0];
	                        var year = split[1];
	                        var currentYear = parseInt(new Date().getFullYear().toString().substr(2, 2), 10);
	                        var currentMonth = parseInt(new Date().getMonth(), 10) + 1;
	                        var validYear = true;
	                        var validMonth = true;
	
	                        if (value.length < 5) {
	                            return false;
	                        }
	
	                        if (this.validDobMonth(month)) {
	                            month = parseInt(month, 10);
	                        } else {
	                            return false;
	                        }
	
	                        year = parseInt(year, 10);
	
	                        if (state === 'past') {
	                            validYear = year <= currentYear;
	                            if (!validYear) {
	                                return false;
	                            }
	                            if (year === currentYear) {
	                                validMonth = month <= currentMonth;
	                            }
	                        } else if (state === 'future') {
	                            validYear = year >= currentYear;
	                            if (!validYear) {
	                                return false;
	                            }
	                            if (year === currentYear) {
	                                validMonth = month >= currentMonth;
	                            }
	                        }
	
	                        if (!validYear || !validMonth) {
	                            return false;
	                        }
	
	                        return true;
	                    },
	
	                    // formats to MM/DD/YYYY
	                    mmddyyyy: function mmddyyyy(day, month, year) {
	                        if (year.length < 4) {
	                            year = '20' + year;
	                        }
	
	                        return this.twoDigits(month) + '/' + this.twoDigits(day) + '/' + this.twoDigits(year);
	                    },
	
	                    // formats to YY-MMM-DDDD
	                    yyyymmdd: function yyyymmdd(day, month, year) {
	                        if (year.length < 4) {
	                            year = '20' + year;
	                        }
	
	                        return year + '-' + this.twoDigits(month) + '-' + this.twoDigits(day);
	                    },
	
	                    // pads a number to two digits
	                    twoDigits: function twoDigits(value) {
	                        return value < 10 ? '0' + value : '' + value;
	                    },
	
	                    // expects YYYY-MM-DD
	                    legalAge: function legalAge(value) {
	                        if (this.empty(value)) {
	                            return false;
	                        }
	
	                        var dateParts = value.split('-'); // expecting YYYY-MM-DD
	                        var birthDate = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
	                        var yr = 365.25 * 24 * 60 * 60 * 1000; // milliseconds in a year
	                        var validBD = new Date(new Date() - 18 * yr);
	
	                        return validBD >= birthDate;
	                    },
	
	                    validZip: function validZip(value, options) {
	
	                        var postalCodeRegex = {
	                            // TODO: Once this is removed from the xo-add-address template, we can remove it...
	                            'GB': /[A-Z]{1,2}[0-9][0-9A-Z]?\s?[0-9][A-Z]{2}/,
	                            /*
	                             * Note: These are "nice to have".
	                             * Once we add support for these countries, we can remove these.
	                             */
	                            'BA': /^\d{5}$/,
	                            'CY': /^\d{4}$/,
	                            'EE': /^\d{5}$/,
	                            'HR': /^\d{5}$/,
	                            'LU': /^\d{4}$/,
	                            'LV': /^\d{4}$/,
	                            'MT': /^\d{3,4}$/,
	                            'SI': /^\d{4}$/,
	                            'SK': /^[0-9]{3}[\s][0-9]{2}$/,
	                            'NZ': /^\d{4}$/,
	                            'LT': /^\d{5}$/,
	                            'BG': /^\d{4}$/,
	                            'CZ': /^\d{5}$/,
	                            'GR': /^\d{3}[\s]\d{2}$/,
	                            'HU': /^\d{4}$/,
	                            'MX': /^\d{5}$/
	                        };
	
	                        var country = options && options.country;
	                        var regex = scope.zipEntry && scope.zipEntry.validationPattern || postalCodeRegex[country];
	                        var isRequired = scope.zipEntry && scope.zipEntry.required;
	
	                        if (!isRequired && this.empty(value)) {
	                            return true;
	                        }
	
	                        // If there is no regex, or it's not populated yet...
	                        if (!regex || angular.isString(regex) && regex.indexOf('validationPattern') > -1) {
	                            return !this.empty(value);
	                        }
	
	                        value = value && value.toUpperCase();
	
	                        return this.valid(value, regex);
	                    },
	
	                    validExpiry: function validExpiry(value, options) {
	                        var $monthEl = $('[ng-model="card.expiry_month"]');
	                        var $yearEl = $('[ng-model="card.expiry_year"]');
	                        var month = $monthEl.val();
	                        var year = $yearEl.val();
	                        var isValid = false;
	                        var monthElName = 'card.expiry_month';
	                        var yearElName = 'card.expiry_year';
	                        var cardType = options.cardType;
	
	                        if (month) {
	                            month = $monthEl.find('option')[$monthEl.val() * 1 + 1].label;
	                        }
	
	                        if (year) {
	                            year = $yearEl.find('option')[$yearEl.val() * 1 + 1].label;
	                        }
	
	                        if (month && year) {
	                            isValid = this.validExpires(month, year);
	                        }
	
	                        var formName = $monthEl.closest('form').attr('id');
	                        var form = scope[formName] || scope.$parent[formName];
	                        var monthFieldName = monthElName;
	                        var yearFieldName = yearElName;
	
	                        if (monthFieldName.indexOf('.') !== -1) {
	                            monthFieldName = monthFieldName.split('.')[1];
	                        }
	
	                        if (yearFieldName.indexOf('.') !== -1) {
	                            yearFieldName = yearFieldName.split('.')[1];
	                        }
	
	                        var cardsDontNeedExpiry = ['COFIDIS', 'COFINOGA', 'CETELEM'];
	
	                        if (cardType && cardsDontNeedExpiry.indexOf(cardType) !== -1) {
	                            isValid = true;
	                        }
	
	                        if (form) {
	                            form[monthFieldName].$setValidity('validExpiry', isValid);
	                            form[yearFieldName].$setValidity('validExpiry', isValid);
	                        }
	
	                        return isValid;
	                    },
	
	                    validExpires: function validExpires(month, year) {
	                        var date = new Date();
	                        var currentYear = parseInt(date.getFullYear().toString().substr(2, 2), 10);
	                        var currentMonth;
	
	                        if (year < currentYear) {
	                            return false;
	                        } else if (year > currentYear) {
	                            return this.validDobMonth(month);
	                        }
	
	                        // account for display date vs. system date
	                        currentMonth = date.getMonth() + 1;
	                        return this.validDobMonth(month) && month >= currentMonth;
	                    },
	
	                    startDate: function startDate(value, options) {
	                        var valueOptions = {
	                            cardType: scope.card.type
	                        };
	                        valueOptions[elem.attr('id')] = value;
	
	                        return this.setStartDateValidity(valueOptions);
	                    },
	
	                    setExpiryValidity: function setExpiryValidity(options) {
	                        if (!options) {
	                            return true;
	                        }
	
	                        var cardType = options.cardType || '',
	                            expiryValidity = this.validExpiry(null, {
	                            cardType: cardType
	                        });
	
	                        return expiryValidity;
	                    },
	
	                    // start date validation for Maestro card
	                    setStartDateValidity: function setStartDateValidity(options) {
	                        if (!options) {
	                            return true;
	                        }
	
	                        var cardType = options.cardType || '';
	                        var startDateValidity = true;
	                        var $monthEl = $('#startmonth');
	                        var $yearEl = $('#startyear');
	                        var month = $monthEl.val();
	                        var year = $yearEl.val();
	
	                        if (cardType === 'MAESTRO') {
	                            if (!month || !year) {
	                                startDateValidity = false;
	                            }
	                        }
	
	                        var formName = $monthEl.closest('form').attr('id'),
	                            form = scope[formName] || scope.$parent[formName];
	
	                        if (form) {
	                            form.startmonth.$setValidity('startDate', startDateValidity);
	                            form.startyear.$setValidity('startDate', startDateValidity);
	                        }
	
	                        return startDateValidity;
	                    },
	
	                    dobField: function dobField(value, options) {
	                        var valueOptions = {};
	                        var fieldMap = {
	                            'dobDayCC': 'day',
	                            'dobMonthCC': 'month',
	                            'dobYearCC': 'year'
	                        };
	
	                        valueOptions.cardType = scope.card.type;
	                        valueOptions[fieldMap[elem.attr('id')]] = value;
	
	                        return this.setDOBValidity(valueOptions);
	                    },
	
	                    setDOBValidity: function setDOBValidity(options) {
	                        if (!options) {
	                            return true;
	                        }
	
	                        var dobEnabledCards = ['COFIDIS', 'COFINOGA', 'CETELEM'];
	
	                        var dobValidity = true;
	
	                        var $monthEl = $('#dobMonthCC');
	                        var $dayEl = $('#dobDayCC');
	                        var $yearEl = $('#dobYearCC');
	
	                        var month = options.month || $monthEl.val();
	                        var year = options.year || $yearEl.val();
	                        var day = options.day || $dayEl.val();
	
	                        if (month) {
	                            month = $monthEl.find('option')[$monthEl.val() * 1 + 1].label;
	                        }
	
	                        if (day) {
	                            day = $dayEl.find('option')[$dayEl.val() * 1 + 1].label;
	                        }
	
	                        if (year) {
	                            year = $yearEl.find('option')[$yearEl.val() * 1 + 1].label;
	                        }
	
	                        var cardType = options.cardType;
	                        if (cardType && dobEnabledCards.indexOf(cardType) !== -1) {
	                            if (!month || !year || !day) {
	                                dobValidity = false;
	                                // invalidate if < 18 y/o.
	                            } else if (!this.legalAge(this.yyyymmdd(day, month, year))) {
	                                dobValidity = false;
	                            } else if (!this.validDate(this.mmddyyyy(day, month, year))) {
	                                dobValidity = false;
	                            }
	                        }
	
	                        var formName = $monthEl.closest('form').attr('id');
	                        var form = scope[formName] || scope.$parent[formName];
	
	                        if (form) {
	                            form.dobMonthCC.$setValidity('dobField', dobValidity);
	                            form.dobDayCC.$setValidity('dobField', dobValidity);
	                            form.dobYearCC.$setValidity('dobField', dobValidity);
	                        }
	
	                        return dobValidity;
	                    },
	
	                    validName: function validName(value) {
	                        return this.valid(value, /^([a-zA-Z,\xC0-\xFF,\u00C0-\u017F\,\-\s\,\'])*$/);
	                        // ' this comment is to un-confuse editors on synax coloring because of the single quote above
	                    },
	
	                    isChecked: function isChecked(value, options) {
	                        // $.is does not exist in $
	                        // eslint-disable-line angular/ng_angularelement
	                        var $el = $(options.el);
	
	                        return $el.is(':checked');
	                    },
	
	                    validRUPassport: function validRUPassport(value, options) {
	                        if (scope.user.countryOfResidence === 'RU') {
	                            return this.valid(value, /^\d{10}$/);
	                        }
	                        return true;
	                    }
	                };
	
	                var customValidator = function customValidator(value) {
	                    var ruleJson = angular.fromJson(elem.attr('xo-validation'));
	                    var validator = ruleJson.validator;
	                    var options = ruleJson.options;
	
	                    ngModel.$setValidity(validator, validationUtil[validator](value, options));
	
	                    return value;
	                };
	
	                ngModel.$parsers.unshift(customValidator);
	                ngModel.$formatters.unshift(customValidator);
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "./components/xo-guest-components/src/guest/emailInput/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-guest-components/src/guest/emailInput/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-guest-components/src/guest/emailInput/styles.less":
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "blockquote,body,code,dd,div,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,html,input,legend,li,ol,p,pre,td,textarea,th,ul{margin:0;padding:0}table{border-collapse:collapse;border-spacing:0}fieldset,img{border:0}address,caption,cite,code,dfn,em,strong,th,var{font-style:normal;font-weight:400}ol,ul{list-style:none}caption,th{text-align:left}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:400}q:after,q:before{content:\"\"}abbr,acronym{border:0;font-variant:normal}sup{vertical-align:text-top}sub{vertical-align:text-bottom}input,select,textarea{font-family:inherit;font-size:inherit;font-weight:inherit;font-size:100%}legend{color:#000}body{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:95%;color:#2c2e2f;line-height:1.35em}h1{font-size:138.5%}h2{font-size:123.1%}h3{font-size:108%}h1,h2,h3{margin:1em 0}h1,h2,h3,h4,h5,h6,strong{font-weight:700}a{color:#0070ba}abbr,acronym{border-bottom:1px dotted #000;cursor:help}em{font-style:italic}blockquote,dl,ol,ul{margin:1em}dl,ol,ul{margin-left:2em}ol{list-style:decimal outside}ul{list-style:disc outside}dl dd{margin-left:1em}td,th{border:1px solid #000;padding:.5em}th{font-weight:700;text-align:center}input{margin-bottom:10px}caption{margin-bottom:.5em;text-align:center}fieldset,legend,p,pre,table{margin-bottom:1em}input[type=password],input[type=text],textarea{width:12.25em;*width:11.9em}.row-fluid{width:100%;*zoom:1}.row-fluid:after,.row-fluid:before{display:table;content:\"\"}.row-fluid:after{clear:both}.row-fluid>[class*=span]{float:left;margin-left:4.12765957%}.row-fluid>[class*=span]:first-child{margin-left:0}.row-fluid>.span24{width:99.99999998%}.row-fluid>.span23{width:95.74468083%}.row-fluid>.span22{width:91.48936168%}.row-fluid>.span21{width:87.23404253%}.row-fluid>.span20{width:82.97872339%}.row-fluid>.span19{width:78.72340424%}.row-fluid>.span18{width:74.46808509%}.row-fluid>.span17{width:70.21276594%}.row-fluid>.span16{width:65.95744679%}.row-fluid>.span15{width:61.70212765%}.row-fluid>.span14{width:54.4468085%}.row-fluid>.span13{width:53.19148935%}.row-fluid>.span12{width:48.9361702%}.row-fluid>.span11{width:44.68085105%}.row-fluid>.span10{width:40.42553191%}.row-fluid>.span9{width:36.17021276%}.row-fluid>.span8{width:31.91489361%}.row-fluid>.span7{width:27.65957446%}.row-fluid>.span6{width:23.40425531%}.row-fluid>.span5{width:19.14893617%}.row-fluid>.span4{width:14.89361702%}.row-fluid>.span3{width:10.63829787%}.row-fluid>.span2{width:6.38297872%}.row-fluid>.span1{width:2.12765957%}.container-fluid{padding-left:20px;padding-right:20px;*zoom:1}.container-fluid:after,.container-fluid:before{display:table;content:\"\"}.container-fluid:after{clear:both}.mt10,.mt15{margin-top:10px}.pt10{padding-top:10px}.pt15{padding-top:15px}.mb10{margin-bottom:10px}.mb15{margin-bottom:15px}.pb10{padding-bottom:10px}.pb15{padding-bottom:15px}.ml10{margin-left:10px}.ml15{margin-left:15px}.pl10{padding-left:10px}.pl15{padding-left:15px}.mr10{margin-right:10px}.mr15{margin-right:15px}.pr10{padding-right:10px}.pr15{padding-right:15px}.btn{height:44px;margin-bottom:0;border:1px solid #0070ba;border-radius:5px;*margin-left:.3em;display:inline-block;*display:inline;*zoom:1;background-color:#0070ba;transition:background-color .4s ease-out 0s;font-size:1em;font-weight:700;line-height:42px;color:#fff;text-align:center;vertical-align:middle;cursor:pointer;outline:none;-webkit-font-smoothing:antialiased}.btn .btn-secondary{-webkit-font-smoothing:auto}.btn:focus,.btn:hover{background-color:#005ea6}.btn:focus{text-decoration:underline}.btn.active,.btn:active{background-color:#005ea6;outline:0}.btn.disabled,.btn[disabled]{background-color:#b2d9ea;border-color:#b2d9ea;cursor:default}.btn.firstHalf{float:left}.btn.firstHalf,.btn.secondHalf{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box}.btn.secondHalf{float:right}a.btn:focus,a.btn:hover{color:#fff}.btn:first-child{*margin-left:0}.btn-large{padding:8px 15px;font-size:18px;line-height:normal;border-radius:5px}.btn-small{padding:5px 9px;font-size:11px;line-height:16px}.btn-mini{padding:2px 6px;font-size:11px;line-height:14px}.btn-secondary{border-style:solid;border-color:#e1e7eb;color:#393f44;background-color:#e1e7eb}.btn-secondary:hover{color:#393f44;border-color:#edf2f5;background-color:#edf2f5;text-decoration:none}.btn-secondary:active,.btn-secondary:focus{border-color:#c5ccd1;background-color:#c5ccd1;text-decoration:underline}.btn-secondary.disabled,.btn-secondary[disabled]{color:#393f55}a.btn-secondary:active,a.btn-secondary:focus,a.btn-secondary:hover{color:#393f44;border-color:#c5ccd1;background-color:#c5ccd1}a.btn-secondary.disabled,a.btn-secondary[disabled]{color:#393f55;background-color:#e7edf0}button.btn,input[type=submit].btn{*padding-top:2px;*padding-bottom:2px}button.btn::-moz-focus-inner,input[type=submit].btn::-moz-focus-inner{padding:0;border:0}button.btn.btn-large,input[type=submit].btn.btn-large{*padding-top:7px;*padding-bottom:7px}button.btn.btn-small,input[type=submit].btn.btn-small{*padding-top:3px;*padding-bottom:3px}button.btn.btn-mini,input[type=submit].btn.btn-mini{*padding-top:1px;*padding-bottom:1px}#largeScreenAccountCreation .buttons #backButton,section .buttons #backButton{width:30%}#largeScreenAccountCreation .buttons #proceedButton,section .buttons #proceedButton{width:65%}#largeScreenAccountCreation .buttons #proceedButton-venmoBA,#largeScreenAccountCreation .buttons #proceedButton.full,section .buttons #proceedButton-venmoBA,section .buttons #proceedButton.full{width:100%}.custom-select-container,select.replaced{position:relative}select.replaced{z-index:8;width:100%;height:44px;border:0;line-height:2;opacity:0;filter:alpha(opacity=0)}.custom-select{position:absolute;top:0;left:0;z-index:1;width:100%;transition:border-color .3s ease 0s;border-radius:5px}.custom-select,.custom-select>span{display:block;background-clip:padding-box}.custom-select>span{padding:7px 30px 7px 13px;border:1px solid #ccd0d4;border-radius:5px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:right -7px top -1178px;color:#000;line-height:28px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.disabled .custom-select>span{background-position:right -7px top -6990px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat right 10px center;background-size:16px;color:#c72e2e;border:1px solid #c72e2e}.custom-select span span{display:block;overflow:hidden;height:28px;text-overflow:ellipsis;white-space:nowrap;font-size:1em}.custom-select.active>span{border:1px solid #009cde;outline:0}#task .custom-select{border-radius:5px;background-clip:padding-box}.mobile .dob label{position:static;top:0;left:0}input[type=date]{padding:5px 38px 3px 6px;border:1px solid #ccd0d4;border-radius:5px;background-clip:padding-box;color:#333;background-size:24px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_cart_icons.png\") no-repeat 100% 61%}input[type=date]:focus{border-color:#39f}.showDropdopwnLabels .labelText{float:left;color:#aaa}.showDropdopwnLabels .valueText{float:right;min-width:90px}@media (min-width:0) and (max-width:40em){.showDropdopwnLabels .labelText{display:none}.showDropdopwnLabels .valueText{float:none;min-width:0}}.multiline-select-container{outline:0 none}.multiline-select-container:active .innerContainer,.multiline-select-container:focus .innerContainer{border-color:#009cde}.multiline-select-container.open:active .innerContainer,.multiline-select-container.open:focus .innerContainer{border-color:#ccd0d4}.multiline-select-container option,.multiline-select-container select{position:absolute!important;left:-9999px}.multiline-select-container .custom-select{position:relative}.multiline-select-container .custom-select span span{height:auto;white-space:normal}.multiline-select-container .custom-select>span{background:none}.multiline-select-container.open .custom-select>span{border-radius:5px 5px 0 0;border-bottom-color:#eee}.multiline-select-container .arrow{background-clip:padding-box;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_forms.png\");background-position:left -8px top -1198px;background-repeat:no-repeat;height:10px;position:absolute;width:14px;top:40%;right:12px}.backendError .multiline-select-container .ng-invalid+.custom-select .arrow,.validated .multiline-select-container .ng-invalid+.custom-select .arrow{display:none}.multiline-select-list{position:absolute;list-style:none;margin:0;background-color:#fff;z-index:1000;border-radius:0 0 5px 5px;border-bottom:1px solid #ccd0d4;max-height:200px;overflow:auto;box-shadow:0 -1px 1px 0 #ccc}.multiline-select-list li{padding:10px;border:1px solid;border-color:#eee #ccd0d4;border-top:0 none;cursor:pointer;line-height:1.35em;vertical-align:middle}.multiline-select-list li:active,.multiline-select-list li:focus,.multiline-select-list li:hover{background-color:#e5f5fc;outline:0 none}.multiline-select-list li:first-of-type{border-top:0 none}.multiline-select-list li:last-of-type{border-bottom:0 none}.multiline-select-list:hover li:focus{background-color:#fff}.multiline-select-list:hover li:focus:active,.multiline-select-list:hover li:focus:hover{background-color:#e5f5fc}#midflash,.accessAid{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}body{-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#fff}a{text-decoration:none;-webkit-tap-highlight-color:rgba(0,0,0,.2)}a:focus,a:hover{color:#005ea6;text-decoration:underline;outline:none}a.dashed{text-decoration:none;border-bottom:1px dashed #0070ba;font-size:.9em}[tabindex=\"-1\"]{outline:none}em{font-style:normal;font-weight:700}fieldset{margin:0;padding:0;border:0}fieldset legend{padding-bottom:.5em;font-size:1.5em}section:focus{outline:none}.show-section{display:block}hr.faded{width:100%;height:1px;margin:10px 0;border:0;background-image:-o-linear-gradient(left,transparent,rgba(0,0,0,.75),transparent)}.alpha{font-size:1.5em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin:.5em 0;line-height:1.154em}#loginSection h1.alpha{max-width:240px}.asideAlpha{font-size:1.44em}aside .aside .header.noButtons .walletHeading{text-align:center;line-height:1.05em}.beta{font-size:1.54em;color:#2c2e2f;font-weight:lighter;line-height:1.2em}.gamma{font-size:1.3em}.gamma,.zeta{font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin-bottom:.75em}.zeta{font-size:1.25em}.delta{font-size:1.1em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;margin-bottom:12px;font-weight:400}.vprop-header{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin:10px 0;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.vprop-content,.vprop-header{color:#2c2e2f;font-weight:lighter;line-height:1.2em}.vprop-content{font-size:1em;font-family:HelveticaNeue,helvetica,arial,sans-serif}.vprop-image{margin-top:25px}.eta{font-size:1.1em}.eta,.theta{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400}.theta{font-size:1em}.value-prop-title{color:#2c2e2f;font-size:24px;font-weight:lighter;margin:10px 0}.props{padding:0 0 0 5px;clear:both;text-align:center}.props li,.props p{line-height:1.154em;font-size:.9em;font-weight:400;line-height:1.2em;margin:5px 0}.secondary{color:#6c7378;font-size:.85em}.legal{color:#6c7378;font-size:.75em;line-height:1.154em}.legal a{font-weight:700}.mu{font-size:2.46em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-weight:400;text-shadow:0 1px 0 #fff;color:#0079c1}.noHead{margin-top:0}.noBottom{margin-bottom:0}.showTray #task{overflow:hidden;margin-left:0}#spinner,.hide{display:none}.clearfix,.loading #spinner,.media .img img,html[xmlns] .clearfix{display:block}#billingToggleLink{display:inline-block}.left{float:left}.right{float:right}.center{text-align:center}.outerWrapper{position:relative;border-radius:5px;background-clip:padding-box;background-color:#fff}header{z-index:2}.framed #wrapper,html.framed{border-radius:5px;background-clip:padding-box}html.framed .trayOpen #main{height:585px}html.framed .trayOpen .asideContent{height:495px}body>iframe,body>img{display:none}#wrapper{margin:0 auto;max-width:780px;border:1px solid #e3e3e3;border-radius:5px;overflow-y:visible;outline:none}#wrapper,#wrapper #header{-ms-box-sizing:border-box;box-sizing:border-box;background-clip:padding-box;position:relative;background-color:#fff}#wrapper #header{border-radius:5px 5px 0 0;width:100%;z-index:4;box-shadow:0 0 3px 0}#contents{position:relative;z-index:1}.active #wrapper{visibility:visible;-webkit-animation-duration:.4s;-webkit-animation-timing-function:ease;-webkit-animation-name:slideUp}#logo{margin:22px 0 0 20px}.container{clear:both;padding:20px}.containerNoHead{padding-top:0}.noPaddingBottom{padding-bottom:0}.noPaddingTop{padding-top:0}.subContainer{border-top:1px solid #e3e3e3;padding:20px 0;position:relative}#proceedButton{width:46.4%;-ms-box-sizing:border-box;box-sizing:border-box;float:right}#proceedButton.full{width:100%}#proceedButton:focus{color:#fff}#backButton{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box;float:left}#backButton:focus,#backButton:hover{color:#2c2e2f}.middleName{display:none;float:right}.h2,h2{font-size:1.2em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin-top:0;font-weight:400;color:#0666b3}.clearfix:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}* html .clearfix{height:1%}#sliding-area{overflow:hidden}#main{padding:25px 30px 15px;transition:margin .3s ease-out;width:100%;float:right;-ms-box-sizing:border-box;box-sizing:border-box}.loading #main{background:none}.bmlLoadingMessage,.loginLoadingMessage,.loginProcessing .genericLoadingMessage{display:none}.loginProcessing .loginLoadingMessage{display:block}.full{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;text-decoration:none}.trayInner{padding:20px 0}.disclaimer{font-size:.75em;color:#6c7378}.reviewMsg{margin-top:10px;line-height:1.5}.infoTxt{clear:both;padding-top:10px}.help{color:#a9a9a9}.keyValue label{color:#292929}.frontArrow{position:absolute;display:inline-block;width:9px;height:15px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-196px -177px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.frontArrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.focusableIcon:focus{box-shadow:0 0 1px #6c7378}input[type=button],input[type=submit]{-webkit-appearance:none}.inputField input[disabled=disabled],.inputField input[disabled=disabled]:active,input[disabled=disabled]{background:#f7f9fa;border:1px solid #cbd2d6;color:#6c7378}input::-ms-clear{display:none}input.link:hover{cursor:pointer}input.xsmall{width:2em}input.small{width:3.35em;font-size:1em}input.medium{width:7em}input.large{width:14em}input.xlarge{width:20em}.button-as-link{margin:0;padding:0;border:none;width:auto;font-size:.85em;background:transparent;color:#0070ba;cursor:pointer}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.buttons{margin-top:15px;margin-bottom:15px;overflow:hidden}.inputField{position:relative}.inputField input,.inputField label{display:block;vertical-align:top}.ignoreValidation .inputField.error input,.inputField input,.validated .ignoreValidation .inputField input.backendError,.validated .ignoreValidation .inputField input.ng-invalid{width:100%;height:44px;padding:0 14px;border-radius:5px;background-clip:padding-box;border:1px solid #c5ccd1;color:#000;transition:border-color .3s ease 0s;-ms-box-sizing:border-box;box-sizing:border-box;background:none}.ignoreValidation .inputField.error input::-webkit-input-placeholder,.inputField input::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.backendError::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-webkit-input-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-moz-placeholder,.ignoreValidation .inputField.error input::-moz-placeholder,.inputField input:-moz-placeholder,.inputField input::-moz-placeholder,.validated .ignoreValidation .inputField input.backendError:-moz-placeholder,.validated .ignoreValidation .inputField input.backendError::-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-moz-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-ms-input-placeholder,.inputField input:-ms-input-placeholder,.validated .ignoreValidation .inputField input.backendError:-ms-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-ms-input-placeholder{color:#6c7378}.inputField input:active,.inputField input:focus{border:1px solid #009cde;outline:0}.inputField select{font-size:1.5em;margin-bottom:10px}.custom-select-container select{font-size:15px}.inputField label{position:absolute;top:14px;left:14px;cursor:text;text-align:left;color:#666;font-size:1em}.no-js .dropdown label,.no-js .inputField label{position:static}.fieldGroup .inputField{float:left;padding:0 .5em 0 0}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.inputField.error input::-webkit-input-placeholder,.validated .inputField input.backendError::-webkit-input-placeholder,.validated .inputField input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.inputField.error input:-moz-placeholder,.inputField.error input::-moz-placeholder,.validated .inputField input.backendError:-moz-placeholder,.validated .inputField input.backendError::-moz-placeholder,.validated .inputField input.ng-invalid:-moz-placeholder,.validated .inputField input.ng-invalid::-moz-placeholder{color:#c72e2e}.inputField.error input:-ms-input-placeholder,.validated .inputField input.backendError:-ms-input-placeholder,.validated .inputField input.ng-invalid:-ms-input-placeholder{color:#c72e2e}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}.inputField.valid input{background:#fff url(https://www.paypalobjects.com/images/checkout/hermes/icon_checkmark_wallet_2x.png) no-repeat 98%;background-size:14px}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.creditCardField.valid input{background:#fff}.dropdown.error select,.inputField.error select{border:1px solid #c72e2e}.selectLabel{display:block}input::-webkit-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:1em}input:-moz-placeholder,input::-moz-placeholder{color:#6c7378;opacity:1;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}input:-ms-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.checkbox input[type=checkbox]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.checkbox input[type=checkbox]~label,.checkbox input[type=checkbox]~label.bgImgOnSpan span.bgImg{display:inline-block;position:static;min-height:25px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px 0;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.checkbox input[type=checkbox]~label,.checkbox input[type=checkbox]~label.bgImgOnSpan span.bgImg{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.checkbox input[type=checkbox]~label.bgImgOnSpan span.bgImg{display:block;float:left;width:0;height:25px;margin-left:-35px}.checkbox input[type=checkbox]~label.bgImgOnSpan{background-image:none}.checkbox.error input[type=checkbox]:focus~label,.checkbox.error input[type=checkbox]:focus~label.bgImgOnSpan span.bgImg,.checkbox.error input[type=checkbox]~label,.checkbox.error input[type=checkbox]~label.bgImgOnSpan span.bgImg{background-position:-9px -600px}.checkbox input[type=checkbox]:checked~label,.checkbox input[type=checkbox]:checked~label.bgImgOnSpan span.bgImg{background-position:-9px -400px}.checkbox input[type=checkbox]:focus:checked~label,.checkbox input[type=checkbox]:focus:checked~label.bgImgOnSpan span.bgImg{background-position:-9px -4801px}.checkbox input[type=checkbox]:focus~label,.checkbox input[type=checkbox]:focus~label.bgImgOnSpan span.bgImg{background-position:-9px -4601px}.checkbox input[type=checkbox][disabled=disabled]~label,.checkbox input[type=checkbox][disabled=disabled]~label.bgImgOnSpan span.bgImg{background-position:-9px -800px}.checkbox input[type=checkbox][disabled=disabled]:checked~label,.checkbox input[type=checkbox][disabled=disabled]:checked~label.bgImgOnSpan span.bgImg{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:25px 25px}.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label.bgImgOnSpan span.bgImg,.validated .ignoreValidation input[type=checkbox].ng-invalid~label,.validated .ignoreValidation input[type=checkbox].ng-invalid~label.bgImgOnSpan span.bgImg{background-position:-9px 0}.validated .ignoreValidation .sCheckbox.checkbox input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation .sCheckbox.checkbox input[type=checkbox].ng-invalid:focus~label.bgImgOnSpan span.bgImg,.validated .ignoreValidation .sCheckbox.checkbox input[type=checkbox].ng-invalid~label,.validated .ignoreValidation .sCheckbox.checkbox input[type=checkbox].ng-invalid~label.bgImgOnSpan span.bgImg{background-position:-9px 2600px}.validated input[type=checkbox].ng-invalid~label,.validated input[type=checkbox].ng-invalid~label.bgImgOnSpan span.bgImg{background-position:-9px -600px}.validated input[type=radio].ng-invalid+label,.validated input[type=radio].ng-invalid+label.bgImgOnSpan span.bgImg,.validated input[type=radio].ng-invalid:focus+label,.validated input[type=radio].ng-invalid:focus+label.bgImgOnSpan span.bgImg{background-position:-10px -2200px}.validated .sCheckbox.checkbox input[type=checkbox].ng-invalid~label,.validated .sCheckbox.checkbox input[type=checkbox].ng-invalid~label.bgImgOnSpan span.bgImg{background-position:-9px -3200px}.sCheckbox.checkbox{position:relative}.sCheckbox.checkbox input[type=checkbox]~label,.sCheckbox.checkbox input[type=checkbox]~label.bgImgOnSpan span.bgImg{line-height:19px;padding-left:27px;font-size:.85em;background-position:-9px -2600px}.sCheckbox.checkbox input[type=checkbox]~label.bgImgOnSpan span.bgImg{display:block;float:left;width:0;height:19px;margin-left:-27px}.sCheckbox.checkbox input[type=checkbox]~label.bgImgOnSpan{background-image:none}.sCheckbox.checkbox.error input[type=checkbox]:focus~label,.sCheckbox.checkbox.error input[type=checkbox]:focus~label.bgImgOnSpan span.bgImg,.sCheckbox.checkbox.error input[type=checkbox]~label,.sCheckbox.checkbox.error input[type=checkbox]~label.bgImgOnSpan span.bgImg{background-position:-9px -3200px}.sCheckbox.checkbox input[type=checkbox]:checked~label,.sCheckbox.checkbox input[type=checkbox]:checked~label.bgImgOnSpan span.bgImg{background-position:-9px -3000px}.sCheckbox.checkbox input[type=checkbox]:focus:checked~label,.sCheckbox.checkbox input[type=checkbox]:focus:checked~label.bgImgOnSpan span.bgImg{background-position:-9px -5409px}.sCheckbox.checkbox input[type=checkbox]:focus~label,.sCheckbox.checkbox input[type=checkbox]:focus~label.bgImgOnSpan span.bgImg{background-position:-9px -2800px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]~label,.sCheckbox.checkbox input[type=checkbox][disabled=disabled]~label.bgImgOnSpan span.bgImg{background-position:-9px -3400px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]:checked~label,.sCheckbox.checkbox input[type=checkbox][disabled=disabled]:checked~label.bgImgOnSpan span.bgImg{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:18px 19px}.radioButton input[type=radio]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.radioButton input[type=radio]~label{display:inline-block;min-height:26px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px -1600px;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.radioButton input[type=radio]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.radioButton.error input[type=radio]+label,.radioButton.error input[type=radio]:focus+label{background-position:-9px -2200px}.radioButton.warning input[type=radio]+label,.radioButton.warning input[type=radio]:focus+label{background-position:-9px -7405px}.radioButton input[type=radio]:checked+label{background-position:-9px -2000px}.radioButton input[type=radio]:focus:checked+label{background-position:-9px -6010px}.radioButton input[type=radio]:focus+label{background-position:-9px -1800px}.inputField label.nolap{position:relative;top:auto;left:auto;color:#2c2e2f}.inputField.half{width:48.15%;margin-right:3.7%;padding-right:0}.multistepSignupForm .inputField.half,.singlePagePaymentForm .inputField.half{width:48.7%;margin-right:2.6%;padding-right:0}.inputField.half.issueNo{width:42%;margin-top:15px}.inputField.half.startDate{width:54%;margin-right:10px}#cardIssueInfo .inputField.half.startDate{width:48%;margin-right:0}#cardIssueInfo .inputField.half.issueNo{width:48%;margin-top:0;float:right}#cardIssueInfo .inputField.half.issueNo:before{content:\"\\200C\"}.inputField.half.last-child{margin-right:0}.fieldGroup .inputField.last-child{padding-right:0}.fidobDay{width:30%;float:left}.fidobDay .custom-select>span{border-radius:5px 0 0 5px;border-right:0}.fidobMonth{width:30%;float:left}.fidobMonth .custom-select>span{border-radius:0}.fidobYear{width:40%;float:left}.fidobYear .custom-select>span{border-radius:0 5px 5px 0;border-left:0}.cardDOB{width:100%;clear:both}.dobLabel{top:auto;left:auto;position:relative;display:block;bottom:4px}.dobTXT{margin-top:10px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}}.submitted input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.submitted input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.submitted input.ng-invalid:-moz-placeholder,.submitted input.ng-invalid::-moz-placeholder{color:#c72e2e}.submitted input.ng-invalid:-ms-input-placeholder{color:#c72e2e}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.submitted input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}.merchantHeader{height:90px;margin:0 auto}.merchantHeader .headerWrapper{max-width:780px;margin:0 auto;overflow:hidden;max-height:90px;line-height:90px}.merchantHeader .merchantName{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400;width:575px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block}.merchantHeader img{vertical-align:middle}.paypalHeaderWrapper .logo{float:left;width:112px;height:29px;margin-top:5px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.paypalHeaderWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.paypalHeaderWrapper .span14{padding-bottom:20px;border-bottom:1px solid #dbdbdb}.paypalHeaderWrapper .cartContainer{position:static;line-height:29px}.paypalHeaderWrapper .transctionCartDetails{z-index:2}.paypalHeaderWrapper.paypalCredit .logo{height:35px;background-position:0 -129px}.aside .header{padding:15px;vertical-align:middle;line-height:50px;border-bottom:1px solid #e3e3e3}.aside .header.tall{min-height:65px;line-height:normal;padding:13px 15px 10px;margin-bottom:0}.aside .asideAlpha{padding:0 30px;text-align:center;line-height:1.2em}.aside .walletHeading{text-align:center}.aside .close{top:10px;right:15px;padding:5px;border-radius:3px}.aside .close,.aside .close:before{position:absolute;width:19px;height:19px}.aside .close:before{content:\"\";display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .close:focus:before,.aside .close:hover:before{background-position:-223px -22px}.aside .backArrow{position:absolute;top:10px;left:15px;width:9px;height:18px;padding:5px;border-radius:3px}.aside .backArrow:before{content:\"\";display:inline-block;position:absolute;width:9px;height:18px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -46px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .backArrow:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .backArrow:focus:before,.aside .backArrow:hover:before{background-position:-232px -68px}.aside .addOptions{margin-top:20px}.aside .addOptions h2{float:left;width:70%;margin-bottom:0}.aside .addOptions a{float:right;display:block;line-height:1.9em;font-size:.85em}.aside .subHeader{margin-top:20px}.CYCOPage .paypalHeader.span14,.pageSepaAgreementContingency .paypalHeader.span14,.pageSepaMandate .paypalHeader.span14,.pageSepaMandateContingency .paypalHeader.span14{width:100%}#mobileMerchantHeader{display:none}@media (max-width:41.3125em){.merchantHeader{display:none}.paypalHeaderWrapper{height:65px}.paypalHeaderWrapper .cartContainer{margin-top:10px;margin-bottom:-5px;margin-right:15px}.paypalHeaderWrapper .logo{margin:15px 0 0 30px}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}}@media (max-width:30em) and (min-width:0){.paypalHeaderWrapper .cartContainer{margin-top:15px;margin-bottom:-10px;margin-right:0}.paypalHeaderWrapper .logo{margin:15px 0 0}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}.header{height:55px}.aside .header{height:auto}.aside .close{right:15px}}.footer{max-width:780px;margin:10px auto;font-size:.75em}.cancelUrl{float:left;width:39%}.micaLender{display:none;color:#2c2e2f;clear:both}.footerWrapper table{display:inline;float:left;table-layout:fixed;border:none;width:75%}.footerWrapper td,.footerWrapper th,.footerWrapper tr{border:none;font-weight:400;padding-bottom:0;padding-top:0;text-align:left}.footerWrapper .footerLinks th{color:#6c7378}.footerWrapper .footerLinks th.feedbackLink{color:#0070ba}.footerWrapper .footerLinks .underline th{border-bottom:1px solid #ccc}.footerLinks{margin:0;display:inline-block}.footerLinks a{color:#6c7378}.footerLinks a.feedbackLink{color:#0070ba;margin-left:5px}.footerLinks th,td{border:none}.copyright{display:inline;width:auto;vertical-align:top;color:#6c7378}.secureIcon{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:0 -33px;margin-left:3px;margin-right:3px;margin-top:3px;width:10px;height:12px;vertical-align:top}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.secureIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.poweredBy{float:right;margin-top:-49px}.poweredBy .text{float:left;margin-top:8px;margin-right:8px;font-size:12px;font-weight:400;font-style:italic;color:#6c7378}.footerLinks li{padding:0 12px 0 0;display:inline-block}.footerLinks .last{padding-right:18px;border-right:none}.footer .policyInfoWrapper p{line-height:1.3em}.footer .policyInfoWrapper p a{font-weight:700}.minibrowser .APAC.footer,.minibrowser.AU .footer{position:relative;bottom:0;width:auto}.minibrowser .APAC.footer .policyInfoWrapper,.minibrowser.AU .footer .policyInfoWrapper{padding:0}.minibrowser .cancelUrl{display:none}.minibrowser .footerWrapper{padding:0 10px;float:none;width:95%;margin:0}.minibrowser .footerLinks li{padding:0 5px 0 0}.DE .footerWrapper,.fr.CA .footerWrapper,.fr.FR .footerWrapper{float:none;width:auto}.DE .footerWrapper:after,.fr.CA .footerWrapper:after,.fr.FR .footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.DE .footerLinks,.fr.CA .footerLinks,.fr.FR .footerLinks{float:left;width:70%;text-align:left}.DE .footerLinks li:first-child,.fr.CA .footerLinks li:first-child,.fr.FR .footerLinks li:first-child{padding-left:0}.DE .copyright,.fr.CA .copyright,.fr.FR .copyright{float:right;width:30%;margin:0}.DE .cancelUrl,.fr.CA .cancelUrl,.fr.FR .cancelUrl{float:none;margin:5px 0;width:100%}.APAC .policyInfoWrapper{padding:5px 0 10px;color:#6c7378}.APAC .policyInfoWrapper p.moreInfo{padding:15px 0 20px;float:left;line-height:1.3em}.AU .policyInfoWrapper,.en_AU .policyInfoWrapper{padding:20px 0 10px;color:#6c7378}.AU .policyInfoWrapper p.moreInfo,.en_AU .policyInfoWrapper p.moreInfo{padding:15px 0 20px;border-bottom:1px solid #ccc;float:left}.AU .policyInfoWrapper p.moreCopyRight,.en_AU .policyInfoWrapper p.moreCopyRight{padding:5px 0 0;clear:both}.fr_XC .footerWrapper{float:left;width:70%;text-align:left;padding-left:0;margin-left:-7px}@media (max-width:41.25em){.footer{border-top:1px solid #ccc;padding:5px 20px;margin-top:10px}.footer .policyInfoWrapper{padding:0 10px}.footerWrapper{float:none;width:100%;padding:0;margin:0}.footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.cancelUrl{width:95%;padding:0}.footerLinks{float:left;width:70%;text-align:left}.footerLinks .feedback{display:none}.minibrowser .footerLinks .feedback{display:inline-block}.copyright{width:20%}.cancelUrl{float:none;margin:5px 0}}@media (max-width:30em) and (min-width:0){.footer{margin-top:0;padding:5px 10px}.footer .policyInfoWrapper{padding:0}.cancelUrl,.footerWrapper{padding:0;margin:5px 0;width:100%}.DE .footerLinks,.footerLinks,.fr.FR .footerLinks{width:65%}.DE .footerLinks li,.footerLinks li,.fr.FR .footerLinks li{padding:0;margin-right:10px}.DE .footerLinks li.last,.footerLinks li.last,.fr.FR .footerLinks li.last{margin-right:0}.DE .footerLinks .feedback,.footerLinks .feedback,.fr.FR .footerLinks .feedback{display:none}.copyright,.DE .copyright{width:33%;margin:0}.minibrowser .copyright{margin-right:0;width:30%}.minibrowser .footerLinks .feedback{display:inline-block}}.modal-open{overflow:hidden}.modal-open #contents,.modal-open #wrapper,.modal-open .outerWrapper{position:static}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:140;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop,.modal-backdrop.fade.in{opacity:.54}.modal{display:none;overflow:auto;overflow-y:scroll;position:fixed;top:0;right:0;bottom:0;left:0;z-index:150}.modal.fade .modal-wrap{-webkit-transform:translateY(-25%);transform:translateY(-25%);transition:transform .3s ease-out}.modal.fade.in .modal-wrap{-webkit-transform:translate(0);transform:translate(0)}.modal-wrap{position:relative;margin:10px;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.3);border-radius:6px;background-clip:padding-box;box-shadow:0 3px 9px rgba(0,0,0,.3);outline:none}.modal-header{padding:9px 15px;border-bottom:1px solid #eee}.modal-header .close{margin-top:2px}.modal-header h3{margin:0;line-height:30px}.modal-body{position:relative;overflow-y:auto;max-height:400px;padding:15px}.modal-footer,.modal-form{margin-bottom:0}.modal-footer{padding:14px 15px 15px;text-align:right;background-color:#f5f5f5;border-top:1px solid #ddd;border-radius:0 0 6px 6px;background-clip:padding-box;box-shadow:inset 0 1px 0 #fff}.modal-footer:after,.modal-footer:before{display:table;content:\"\";line-height:0}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.spinner{height:100%;width:100%;position:absolute;z-index:10}.spinner .spinWrap{width:200px;height:100px;position:absolute;top:50%;left:50%;margin-left:-100px;margin-top:-50px}.spinner .spinnerImage{margin:28px 0 0 -25px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/icon_ot_spin_lock_skinny.png\") no-repeat}.spinner .loader,.spinner .spinnerImage{height:100px;width:100px;position:absolute;top:0;left:50%;opacity:1;filter:alpha(opacity=100)}.spinner .loader{margin:0 0 0 -55px;background-color:transparent;-webkit-animation:rotation .7s infinite linear;animation:rotation .7s infinite linear;border-left:5px solid #cbcbca;border-right:5px solid #cbcbca;border-bottom:5px solid #cbcbca;border-top:5px solid #2380be;border-radius:100%}.spinner .bmlLoadingMessage,.spinner .genericLoadingMessage,.spinner .loginLoadingMessage{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;margin-top:125px;text-align:center;z-index:100}.spinner.preloader{position:fixed;top:0;left:0;z-index:1000;background-color:#fff}@-webkit-keyframes rotation{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(359deg)}}@keyframes rotation{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.aside{min-height:380px}.aside .container{padding:15px}.asideContent{height:100%}.centerText{text-align:center}.fsIcons{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;min-width:32px;width:25px;height:21px;padding-right:5px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.BALANCE .fsIcons,.DELAYED_TRANSFER .fsIcons,.HOLDING .fsIcons{background-position:0 0}.ELO .fsIcons{background-position:0 -479px}.HIPER .fsIcons{background-position:0 -458px}.HIPERCARD .fsIcons{background-position:0 -500px}.pinlessGlyphIcon{display:inline-block;position:relative;top:-5px;left:-8px;width:32px;height:20px;font-size:3.1rem;padding-right:5px}.BANK .fsIcons,.BANK_ACCOUNT .fsIcons,.IACH .fsIcons{background-position:0 -252px;height:19px;left:19px}.ECHECK .fsIcons,.ELV .fsIcons,.TAB.DELAYED_TRANSFER .fsIcons{background-position:0 -252px;height:19px}.TAB.DELAYED_TRANSFER .fsIcons{left:19px}.BILL_ME_LATER .fsIcons,.BML .fsIcons,.CREDIT_OPTION .fsIcons,.PPCREDIT .fsIcons{background-position:0 -105px}.PAYPAL_SMART_CONNECT .fsIcons{background-position:0 0}.VISA .fsIcons{background-position:0 -21px}.MASTERCARD .fsIcons{background-position:0 -42px}.AMEX .fsIcons{background-position:0 -63px;left:19px;height:20px}.DISC .fsIcons,.DISCOVER .fsIcons{background-position:0 -84px}.JCB .fsIcons{background-position:0 -353px}.CHINA_UNION_PAY .fsIcons{background-position:0 -563px}.ELECTRON .fsIcons{background-position:0 -146px}.MAESTRO .fsIcons,.MSTRO .fsIcons,.SWITCH .fsIcons{background-position:0 -168px}.CB_NATIONALE .fsIcons,.CBN .fsIcons{background-position:0 -210px}.CELEM .fsIcons,.CETELEM .fsIcons{background-position:0 -311px}.COFINOGA .fsIcons,.CONF .fsIcons{background-position:0 -231px}.COFID .fsIcons,.COFIDIS .fsIcons{background-position:0 -437px;left:20px}.INCENTIVE .fsIcons{background-position:0 -271px;height:18px}.PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -374px}.PPSMTCONNECT .fsIcons{background-position:0 0}.ES .PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -521px}.fsIcon{display:block;position:absolute;width:25px;height:21px;left:15px;top:20px;min-width:32px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;background-position:0 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.fsIcon.BANK,.fsIcon.PAD{background-position:6px -252px;height:19px;left:19px}.fsIcon.MASTER,.fsIcon.MASTERCARD,.fsIcon.MCARD{background-position:0 -42px}.fsIcon.ELO{background-position:0 -479px}.fsIcon.HIPER{background-position:0 -458px}.fsIcon.HIPERCARD{background-position:0 -500px}.fsIcon.DISC,.fsIcon.DISCOVER{background-position:0 -84px}.fsIcon.VISA{background-position:0 -21px}.fsIcon.JCB{background-position:0 -353px}.fsIcon.AMEX,.fsIcon.Amex{background-position:6px -63px;left:19px;height:20px}.fsIcon.MAESTRO,.fsIcon.MSTRO,.fsIcon.SWITCH{background-position:0 -168px}.fsIcon.PAYPAL_SMART_CONNECT{background-position:0 0}.fsIcon.CB_NATIONALE,.fsIcon.CBN{background-position:0 -210px}.fsIcon.CELEM,.fsIcon.CETELEM{background-position:0 -311px}.fsIcon.COFID,.fsIcon.COFIDIS{background-position:0 -437px;left:20px;height:20px}.fsIcon.CHINA_UNION_PAY,.fsIcon.CUP{background-position:0 -563px}.fsIcon.COFINOGA,.fsIcon.CONF{background-position:0 -231px}.fsIcon.PAYPAL_EXTRAS_MASTERCARD,.fsIcon.PPXMCARD{background-position:0 -374px}.fsIcon.EBAY_MASTERCARD,.fsIcon.EBAYMCARD{background-position:0 0}.fsIcon.BILL_ME_LATER,.fsIcon .BML,.fsIcon .PPCREDIT{background-position:0 -105px}.fsIcon.PPSMTCONNECT{background-position:0 0}.fsIcon.pinlessIcon{background-image:none;font-size:3.1rem;left:5px;top:14px}.ES .fsIcon.PAYPAL_EXTRAS_MASTERCARD,.ES .fsIcon.PPXMCARD{background-position:0 -521px}.infoIcon{width:19px;height:18px;display:inline-block;position:absolute;top:25px;right:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-89px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.infoIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.addOption{padding:25px 10px;margin:0 0 0 44px;color:#0070ba;font-size:.85em}.plusicon{display:block;position:absolute;left:15px;top:22px;width:20px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.plusicon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.infoIcon+.checkIcon{display:none}.infoMsg{margin:0;overflow:hidden;font-size:.85em}.expiredIcon{background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%;width:16px;height:16px;top:6px}.expiredIcon,.plccIcon{display:inline-block;position:relative}.plccIcon{float:left;height:20px;background:none;width:32px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.fsIcon,.fsIcons{height:20px}}.walletIcons{position:absolute;width:30px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.walletIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons_2x.png\");background-size:90px 970px}}.walletIcons.BANK,.walletIcons.BANK_ACCOUNT{background-position:-50px -460px}.walletIcons.BANK.BOFA,.walletIcons.BANK_ACCOUNT.BOFA{background-position:-50px -10px}.walletIcons.BANK.CHASE,.walletIcons.BANK_ACCOUNT.CHASE{background-position:-50px -130px}.walletIcons.BANK.WELLSFARGO,.walletIcons.BANK_ACCOUNT.WELLSFARGO{background-position:-50px -100px}.walletIcons.BANK.CITI,.walletIcons.BANK_ACCOUNT.CITI{background-position:-50px -40px}.walletIcons.BANK.FIFTHTHIRD,.walletIcons.BANK_ACCOUNT.FIFTHTHIRD{background-position:-50px -220px}.walletIcons.BANK.CAPITAL,.walletIcons.BANK_ACCOUNT.CAPITAL{background-position:-50px -70px}.walletIcons.BANK.AMERITRADE,.walletIcons.BANK_ACCOUNT.AMERITRADE{background-position:-50px -160px}.walletIcons.BANK.SUNTRUST,.walletIcons.BANK_ACCOUNT.SUNTRUST{background-position:-50px -280px}.walletIcons.BANK.USBANK,.walletIcons.BANK_ACCOUNT.USBANK{background-position:-50px -310px}.walletIcons.BANK.USAA,.walletIcons.BANK_ACCOUNT.USAA{background-position:-50px -250px}.walletIcons.CARD.VISA,.walletIcons.PAYMENT_CARD.VISA{background-position:-10px -40px}.walletIcons.CARD.MASTER,.walletIcons.CARD.MASTERCARD,.walletIcons.PAYMENT_CARD.MASTER,.walletIcons.PAYMENT_CARD.MASTERCARD{background-position:-10px -70px}.walletIcons.CARD.DISCOVER,.walletIcons.PAYMENT_CARD.DISCOVER{background-position:-10px -100px}.walletIcons.CARD.AMEX,.walletIcons.PAYMENT_CARD.AMEX{background-position:-10px -130px}hr.sep,hr.sepPlain{padding:0;margin-top:25px;height:auto;border:none;border-top:1px solid #ccc;color:#2c2e2f;text-align:center;overflow:visible}hr.sep:after,hr.sepPlain:after{content:\"or\";display:inline-block;position:relative;top:-.7em;font-size:1em;padding:0 .5em;background:#fff;color:#6c7378;font-weight:400}.de hr.sep:after{content:\"oder\"}.da hr.sep:after{content:\"eller\"}.es hr.sep:after{content:\"o\"}.fr hr.sep:after{content:\"ou\"}.he hr.sep:after{content:\"\\5D0\\5D5\"}.id hr.sep:after{content:\"Atau\"}.it hr.sep:after{content:\"oppure\"}.ja hr.sep:after{content:\"\\307E\\305F\\306F\"}.ko hr.sep:after{content:\"\\B610\\B294\"}.nl hr.sep:after{content:\"of\"}.no hr.sep:after{content:\"eller\"}.pl hr.sep:after{content:\"lub\"}.pt hr.sep:after{content:\"ou\"}.ru hr.sep:after{content:\"\\418\\43B\\438\"}.sv hr.sep:after{content:\"eller\"}.th hr.sep:after{content:\"\\E2B\\E23\\E37\\E2D\"}.tr hr.sep:after{content:\"Veya\"}.zh hr.sep:after{content:\"\\6216\"}hr.sepPlain:after{content:\"\"}@media (min-width:0) and (max-width:23em){#loginSection .xoTitle h1{max-width:10em}}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){body{-webkit-text-size-adjust:100%}.merchantBrand{display:none}.outerWrapper{background-position:left 50px}.centerTray.loginSignup{margin-bottom:60px}#main{padding:0;background:none;z-index:2}#contents{padding:0 20px;-ms-box-sizing:border-box;box-sizing:border-box}.tokenization #contents{padding:0 30px}.paypalHeader{padding:0 20px 20px;-ms-box-sizing:border-box;box-sizing:border-box}.props,header{display:none}.review #wrapper{min-height:512px}#contents{min-height:0;margin-bottom:0}.bmlAppProcessing,.loginProcessing{background-color:#f9f9f9}.loggingIn{margin:0 25px}.mobile .loggingIn{margin:0}.saferEasier,.simpler{display:none}#login .row-fluid{padding-top:0}#login .centerTray{padding:0}#login #signupLink.btn{margin:5px 0}#wrapper{margin:0;width:auto;border-radius:0;background-clip:padding-box;border:none}#task{width:295px}.loading .spinner{background-position-y:35%}.centerTray{width:auto}.accountTerms .tray .inner,.tray .inner{padding:10px}.row-fluid>[class*=span],.signup{width:100%;margin-left:0;float:none}#notifications{width:100%}.delta,.gamma{font-size:1.2em}.inputField label{left:7px;top:13px}.saferEasier{display:none}#fundingInstruments .buttons{height:40px}.cityState select{font-size:14px}.cityState .city{width:100%}.cityState .state{width:55%}.cityState .postalCode{width:40.8%}#tab{margin-top:0;height:125px}.toolTip.whatsthis ul{width:242px;left:9px}.toolTip.whatsthis ul li{font-size:.9em}#expiration.varB .expires{width:49%}#expiration .inputField{padding:0}#expiration .cvc{width:44%;float:right}#expiration.varB .cvc{width:49%}.month{margin-left:46px}.separator{margin-left:5px;margin-top:3px}.year{margin-left:0}#expiration .cardIcon{position:absolute;right:4px}.details{margin-right:2px}.mask #closeButton,.mask #header{display:none}}@media (min-width:30.0625em) and (max-width:41.25em){#notifications,.row-fluid>.span10,.row-fluid>.span12,.row-fluid>.span14{width:100%}.outerWrapper{background-position:left 59px}.props,header{display:none}#wrapper{margin:0;border:none}#main{padding:0}#contents{padding:0 25px}}@media (min-width:41.3125em){.banner{display:block}#wrapper{min-height:0}#wrapper,.footer,.merchantHeader{width:95%}.largeScreen .centerTray{margin-top:0}.signup{margin-bottom:0}#genericError{min-height:375px;background:url(https://www.paypalobjects.com/images/checkout/hermes/scr_cloud_balloon.png) no-repeat bottom}#transactionDetails .merchantName{display:none}}@media (device-height:568px) and (-webkit-min-device-pixel-ratio:2){#contents{min-height:0;margin-bottom:0}.pageLanding #contents{margin:70px auto 40px 0}}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.cardType{display:none}ul.validations li.restriction.active{background:url(https://www.paypalobjects.com/images/checkout/hermes/close3_2x.png) no-repeat 0 2px;background-size:10px}.inputField.error input{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.inputField.error input,.inputField.valid input{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.error .custom-select.active>span,.error .custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}@media only screen and (-webkit-min-device-pixel-ratio:2) and (min-width:41.3125em){#genericError{background-size:640px 242px}}.emailHelper{position:absolute;right:7px;top:14px;z-index:1}.emailHelper .verifyHelp{text-indent:-999em}.emailHelper .verifyHelp img{display:inline-block;height:20px;width:20px;vertical-align:middle;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-164px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.emailHelper .verifyHelp img{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.emailHelper .verifyHelp:focus img{background-position:-164px -44px}.backendError~div.emailHelper,.validated #email.ng-invalid~div.emailHelper{display:none}", ""]);
	
	// exports


/***/ }),

/***/ "./components/xo-guest-components/src/guest/emailInput/template.html":
/***/ (function(module, exports) {

	module.exports = "<div class=\"inputField emailField confidential\" content floating-label directionality>\n    <input ng-model=\"user.email\" id=\"email\" name=\"email\" type=\"email\" value=\"\" autocapitalize=\"off\"\n           aria-required=\"false\" xo-validation='{ \"validator\": \"validEmail\" }' autocomplete=\"off\"\n           data-error-key='email.invalid'\n           ng-disabled=\"disabled\" xo-error-tooltip required />\n    <div class=\"emailHelper\" ng-if=\"!hideHelper\">\n        <a href=\"#\" id=\"verifyHelp\" class=\"verifyHelp\">\n            <img alt=\"{{ content('email.whyTooltip') }}\" />\n        </a>\n    </div>\n    <label for=\"email\">\n        {{ content('index.EmailLabel') }}\n    </label>\n    <xo-tooltip trigger=\"#verifyHelp\" ng-switch=\"flags.mode\" ng-if=\"!hideHelper\">\n        <div id=\"emailToolTipText\" class=\"tip tipDesc emailToolTip\">\n            <span data-type=\"signup_email_tooltip\" ng-switch-when=\"signup\">\n                {{ content('common.emailHelper') }}\n            </span>\n            <span data-type=\"guest_email_tooltip\" ng-switch-default>\n                {{ content('common.emailTooltipGuest') }}\n            </span>\n        </div>\n    </xo-tooltip>\n</div>\n"

/***/ }),

/***/ "./components/xo-guest-components/src/guest/passwordInput/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	__webpack_require__("./components/xo-ui-components/src/directionality/directive.js");
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-guest-components/src/guest/passwordInput/template.html"), __webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular, template) {
	
	    return angular.module('xo-guest.passwordInput', ['squid', 'xo-error-tooltip.directive']).directive('xoPasswordInput', function ($timeout, $locale) {
	        return {
	            template: template,
	
	            scope: {
	                user: '=',
	                singlePassword: '=?', // enable single password - optional attribute
	                isDisabled: '=?' // disable password field - optional attribute
	            },
	
	            controller: function controller($scope) {
	                $scope.locale = $locale;
	
	                $scope.passwordToolTip = 'show';
	                $scope.passwordMismatch = 'hide';
	
	                $scope.requirementLength = 'active';
	                $scope.requirementNumberSymbol = 'active';
	
	                /*
	                 * single password case
	                 * flags and functions to enable single password hide and
	                 * show password feature
	                 */
	                function enableSinglePassword() {
	                    $scope.showRawPassword = false;
	                    $scope.showPasswordTextToggleLink = false;
	
	                    $scope.toggleShowRawPassword = function ($event) {
	                        var $passwordEl = $('#password');
	                        var valLength = $passwordEl.val().length;
	
	                        $event.preventDefault();
	                        $scope.showRawPassword = !$scope.showRawPassword;
	
	                        if ($scope.showRawPassword) {
	                            $passwordEl.prop('type', 'text');
	                        } else {
	                            $passwordEl.prop('type', 'password');
	                        }
	
	                        // timeout is need to get this function running after
	                        // the onPasswordBlur function
	                        $timeout(function () {
	                            $passwordEl.focus();
	                            // firefox set the cursor to the end of the value text
	                            $passwordEl.get(0).setSelectionRange(valLength, valLength);
	                        });
	                    };
	                }
	
	                /*
	                    The next 2 methods serve to allow passwordValidate & confirmPasswordValidate directives
	                    to access + change the scope variables inside here as the scopes
	                    in these directives are different and do not inherit from here.
	                */
	                this.setScopeProp = function (prop, newVal) {
	                    $scope[prop] = newVal;
	                };
	
	                this.getScopeProp = function (prop) {
	                    return $scope[prop];
	                };
	
	                // 'singlePassword' case - show the 'hide/show' password link
	                $scope.onPasswordFocusBlur = function ($event, focused) {
	                    var passwordValLength = $scope.user.password && $scope.user.password.length;
	                    if ($scope.singlePassword) {
	                        if (focused) {
	                            $scope.showPasswordTextToggleLink = true;
	                        } else {
	                            // if length is zero then it is false
	                            $scope.showPasswordTextToggleLink = passwordValLength ? true : false;
	                        }
	                    }
	                };
	
	                // enable singlepassword if $scope.singlePassword is set to true
	                $scope.$watch('singlePassword', function (newVal, oldVal) {
	                    if (newVal) {
	                        enableSinglePassword();
	                    }
	                });
	            }
	        };
	    }).directive('passwordValidate', function () {
	        return {
	            require: ['^ngModel', '^xoPasswordInput'],
	            link: function link(scope, elem, attrls, controllers) {
	                var ngModelC = controllers[0];
	                var passwordInputC = controllers[1];
	
	                ngModelC.$setValidity('password', false);
	
	                var fourSequence = function fourSequence(value) {
	                    value += ' ' + value.split('').reverse().join('');
	                    var sequences = '`1231234234534564567567867897890890-90-= ' + // row 1
	                    'qwerwertertyrtyutyuiyuiouiopiop[op[]p[]\\ ' + // row 2
	                    'asdfsdfgdfghfghjghjkhjkljkl;kl;\' ' + // row 3
	                    'zxcvxcvbcvbnvbnmbnm,nm,.m,./ ' + // row 4
	                    '~!@#!@#$@#$%#$%^$%^&%^&*^&*(&*()*()_()_+ ' + // shift + row 1
	                    'QWERWERTERTYRTYUTYUIYUIOUIOPIOP{OP{}P{}| ' + // shift + row 2
	                    'ASDFSDFGDFGHFGHJGHJKHJKLJKL:KL:\' ' + // shift + row 3
	                    'ZXCVXCVBCVBNVBNMBNM<NM<>M<>?'; // shift + row 4
	
	                    var len = value.length;
	                    for (var i = 0; i < len - 3; i++) {
	                        if (sequences.indexOf(value.substr(i, 4)) > -1) {
	                            return false;
	                        }
	                    }
	                    return true;
	                };
	
	                ngModelC.$parsers.unshift(function (viewValue) {
	                    passwordInputC.setScopeProp('requirementLength', viewValue.length >= 8 && viewValue.length <= 20 ? false : 'active');
	                    passwordInputC.setScopeProp('requirementNumberSymbol', /\d/.test(viewValue) || /[\-!@#$%\^&*()_+|~=`{}\[\]:';'<>?,.\/\\]/.test(viewValue) ? false : 'active');
	
	                    passwordInputC.setScopeProp('requirementInfoSec', false);
	                    if (scope.user.country === 'AU') {
	                        var lcViewVal = viewValue.toLowerCase();
	                        var firstName = scope.user && scope.user.first_name && scope.user.first_name.toLowerCase();
	                        var lastName = scope.user && scope.user.last_name && scope.user.last_name.toLowerCase();
	                        var dob = scope.user && scope.user.dob_day + '/' + scope.user.dob_month + '/' + scope.user.dob_year;
	                        if (lcViewVal.indexOf(firstName) !== -1 || lcViewVal.indexOf(lastName) !== -1 || lcViewVal.indexOf(dob) !== -1) {
	                            passwordInputC.setScopeProp('requirementInfoSec', 'active');
	                        }
	                    }
	
	                    passwordInputC.setScopeProp('restrictionEmail', false);
	                    passwordInputC.setScopeProp('restrictionFourRepeated', viewValue.length > 3 && /(.)\1{3}/.test(viewValue) ? 'active' : false);
	                    passwordInputC.setScopeProp('restrictionNonValidCharacters', /[\x00-\x08\x0E-\x1F\x80-\xFF ]/.test(viewValue) ? 'active' : false);
	                    passwordInputC.setScopeProp('restrictionFourSequence', viewValue.length > 3 && !fourSequence(viewValue) ? 'active' : false);
	
	                    var requirements = !(passwordInputC.getScopeProp('requirementLength') || passwordInputC.getScopeProp('requirementNumberSymbol') || passwordInputC.getScopeProp('requirementInfoSec'));
	                    var restrictions = !(passwordInputC.getScopeProp('restrictionEmail') || passwordInputC.getScopeProp('restrictionFourRepeated') || passwordInputC.getScopeProp('restrictionNonValidCharacters') || passwordInputC.getScopeProp('restrictionFourSequence'));
	
	                    ngModelC.$setValidity('password', requirements && restrictions);
	                    passwordInputC.setScopeProp('passwordToolTip', requirements && restrictions ? 'hide' : 'show');
	                    return viewValue;
	                });
	            }
	        };
	    }).directive('confirmPasswordValidate', function () {
	        return {
	            require: ['^ngModel', '^xoPasswordInput'],
	            link: function link(scope, elem, attrls, controllers) {
	                var ngModelC = controllers[0];
	                var passwordInputC = controllers[1];
	
	                ngModelC.$setValidity('confirmPassword', false);
	
	                scope.$watch('user.password', function (newValue) {
	                    var cPass = scope.user.confirmPassword;
	                    if (cPass && cPass.length && cPass !== newValue) {
	                        ngModelC.$setValidity('confirmPassword', false);
	                        passwordInputC.setScopeProp('passwordMismatch', 'show');
	                    }
	                });
	
	                ngModelC.$parsers.unshift(function (viewValue) {
	                    var passwordVal = scope.user.password;
	
	                    passwordInputC.setScopeProp('restrictionMatch', passwordVal && viewValue.length > 0 && passwordVal.indexOf(viewValue) === 0 && passwordVal === viewValue);
	
	                    ngModelC.$setValidity('confirmPassword', passwordVal === viewValue);
	
	                    passwordInputC.setScopeProp('passwordMismatch', passwordInputC.getScopeProp('restrictionMatch') ? 'hide' : 'show');
	                    return viewValue;
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-guest-components/src/guest/passwordInput/template.html":
/***/ (function(module, exports) {

	module.exports = "<div class=\"fieldGroup passwords clearfix\" content>\n    <div ng-switch=\"isDisabled\" class=\"inputField passwordField confidential {{locale.metadata.directionality}}\"\n         ng-class=\"{ 'half': !singlePassword, 'full': singlePassword }\" floating-label>\n\n         <div ng-switch-when=\"true\">\n            <input id=\"password\" name=\"password\" type=\"password\" autocapitalize=\"off\" autocomplete=\"off\"\n               maxlength=\"22\" value=\"\" ng-disabled=\"isDisabled\" />\n            <label for=\"password\">{{ content('common.password') }}</label>\n         </div>\n\n         <div ng-switch-default directionality>\n            <input ng-model=\"user.password\" ng-focus=\"onPasswordFocusBlur($event, true)\" ng-blur=\"onPasswordFocusBlur($event, false)\" id=\"password\" name=\"password\" type=\"password\" autocapitalize=\"off\" autocomplete=\"off\" aria-required=\"true\" aria-describedby=\"passwordToolTip\" maxlength=\"22\" value=\"\" password-validate />\n            <label for=\"password\">{{ content('common.password') }}</label>\n         </div>\n\n        <div ng-if=\"singlePassword && !isDisabled && showPasswordTextToggleLink\" class=\"showHidePasswordLinks\" ng-switch=\"showRawPassword\">\n            <a href=\"#\" id=\"showPasswordLink\" ng-switch-when=\"false\" title=\"{{ content('password.showPassword') }}\" ng-mousedown=\"toggleShowRawPassword($event)\">{{ content('common.show') }}</a>\n            <a href=\"#\" id=\"hidePasswordLink\" ng-switch-when=\"true\" title=\"{{ content('password.hidePassword') }}\" ng-mousedown=\"toggleShowRawPassword($event)\">{{ content('common.hide') }}</a>\n        </div>\n\n        <div ng-class=\"passwordToolTip\">\n            <xo-tooltip trigger=\"#password\" show-event=\"keyup\" ng-class=\"passwordToolTip\" id=\"passwordToolTip\">\n                <div class=\"tip tipDesc passwordToolTip\">\n                    <ul class=\"tipInfoText\">\n                        <li class=\"requirement\" ng-class=\"requirementLength\">{{ content('scripts.requirementLength') }}</li>\n                        <li class=\"requirement\" ng-class=\"requirementNumberSymbol\">{{ content('scripts.requirementNumberSymbol') }}</li>\n                        <li class=\"requirement\" ng-class=\"requirementInfoSec\" feature=\"requirementInfoSec\">{{ content('scripts.informationSecurity') }}</li>\n                        <li class=\"restriction\" ng-class=\"restrictionEmail\">{{ content('scripts.restrictionEmail') }}</li>\n                        <li class=\"restriction\" ng-class=\"restrictionFourRepeated\">{{ content('scripts.restrictionFourRepeated') }}</li>\n                        <li class=\"restriction\" ng-class=\"restrictionNonValidCharacters\">{{ content('scripts.restrictionNonValidCharacters') }}</li>\n                        <li class=\"restriction\" ng-class=\"restrictionFourSequence\">{{ content('scripts.restrictionFourSequence') }}</li>\n                    </ul>\n                </div>\n            </xo-tooltip>\n        </div>\n    </div>\n    <div ng-if=\"!singlePassword\" ng-switch=\"isDisabled\"\n         class=\"inputField confirmPasswordField half last-child confidential\" floating-label>\n\n         <div ng-switch-when=\"true\">\n            <input id=\"confirmPassword\" name=\"confirmPassword\" type=\"password\" autocapitalize=\"off\" autocomplete=\"off\"\n               maxlength=\"22\" value=\"\" ng-disabled=\"isDisabled\" />\n            <label for=\"confirmPassword\">{{ content('common.confirmPassword') }}</label>\n         </div>\n\n         <div ng-switch-default directionality>\n            <input ng-model=\"user.confirmPassword\" id=\"confirmPassword\" name=\"confirmPassword\" type=\"password\" autocapitalize=\"off\" autocomplete=\"off\"\n               aria-required=\"true\" maxlength=\"22\" value=\"\" confirm-password-validate />\n            <label for=\"confirmPassword\">{{ content('common.confirmPassword') }}</label>\n         </div>\n\n        <div ng-class=\"passwordMismatch\">\n            <xo-tooltip trigger=\"#confirmPassword\" show-event=\"keyup\" id=\"confirmPasswordToolTip\">\n                <div class=\"tip tipDesc confirmPasswordToolTip\">\n                    <ul class=\"tipInfoText\">\n                        <li class=\"restriction active\">{{ content('scripts.restrictionMatch') }}</li>\n                    </ul>\n                </div>\n            </xo-tooltip>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "./components/xo-guest-components/src/guest/onboardOptions/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	
	exports.__esModule = true;
	
	var _index = __webpack_require__("./components/squid/dist/index.js");
	
	var _index2 = __webpack_require__("./components/xo-models/src/user/index.js");
	
	var _index3 = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _index4 = __webpack_require__("./components/xo-models/src/profilemanagement/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _index5 = __webpack_require__("./components/xo-device-info/dist/index.js");
	
	var _contentKeys = __webpack_require__("./components/xo-guest-components/src/lib/contentKeys.js");
	
	var _pxpExperimentConstants = __webpack_require__("./components/xo-guest-components/src/guest/constants/pxpExperimentConstants.js");
	
	var _pxpExperimentConstants2 = _interopRequireDefault(_pxpExperimentConstants);
	
	__webpack_require__("./components/xo-guest-components/src/guest/onboardOptions/guest/directive.js");
	
	__webpack_require__("./components/xo-guest-components/src/guest/onboardOptions/signup/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/marketingOffers/directive.js");
	
	var _template = __webpack_require__("./components/xo-guest-components/src/guest/onboardOptions/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _index.$Component.extend('xoOnboardOptions', {
	    tag: 'xo-onboard-options',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            type: 'var'
	        },
	        flags: {
	            type: 'var'
	        },
	        mode: {
	            type: 'var'
	        },
	        onboard: {
	            type: 'var'
	        },
	        singlePagePaymentForm: {
	            type: 'var'
	        },
	        validated: {
	            type: 'var'
	        },
	        sepa: {
	            type: 'var'
	        },
	        merchant: {
	            type: 'var'
	        },
	        isUnbranded: {
	            type: 'var'
	        }
	    },
	
	    resolve: {
	        models: function models() {
	            return {
	                checkoutInputData: _index2.$CheckoutInputDataModel.instance(this.token).retrieve(),
	                payee: _index3.$CheckoutPayeeModel.instance(this.token).retrieve(),
	                checkoutAppData: _index3.$CheckoutAppDataModel.instance(this.token).retrieve(),
	                checkoutCart: _index3.$CheckoutCartModel.instance(this.token).retrieve(),
	                flowEligibility: _index3.$FlowEligibilityModel.instance(this.token).retrieve()
	            };
	        },
	        pomaExperiment: function pomaExperiment() {
	            if (this.mode === 'guest') {
	                return {
	                    poma: (0, _index.$pxp)('XO_XOONBOARDING_POMA_GLOBAL', { 'ctx.COUNTRY': _index.$locale.country }, '(XO_XOONBOARDING_POMA_GLOBAL_)(.*)')
	                };
	            }
	        },
	        experiments: function experiments() {
	            var experiment = 'xo_xoonboarding_dcc_';
	            var pilotCountries = ['US', 'GB', 'CA', 'AU'];
	
	            if (pilotCountries.indexOf(_index.$locale.country) > -1) {
	                experiment += 'pilot';
	            } else if (_index.$config.regions.EMEA.indexOf(_index.$locale.country) > -1) {
	                experiment += 'emea';
	            } else {
	                experiment += 'row';
	            }
	            return {
	                optionalSignupContent: (0, _index.$pxp)('xoon_optional_signup_content_change', { 'ctx.COUNTRY': _index.$locale.country }, '(xoon_optional_signup_content_change_)(.*)'),
	                wpsInterstitial: (0, _index.$pxp)('XO_XOONBOARDING_WPS_INTERSTITIAL_OPTIONAL_SIGNUP', { 'ctx.COUNTRY': _index.$locale.country }, 'XO_XOONBOARDING_WPS_INTERSTITIAL_OPTIONAL_SIGNUP.*'),
	                dccEligibility: (0, _index.$pxp)(experiment, { 'ctx.COUNTRY': _index.$locale.country }, experiment + '_treatment')
	            };
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            this.locale = _index.$locale;
	        },
	        populate: function populate() {
	            var _this = this;
	
	            this.models.merchantPreference = _index4.$MerchantPreferenceModel.instance(this.models.payee.merchant.id);
	            this.isRP = this.models.checkoutCart.billing && this.models.checkoutCart.billing.type === 'RECURRING_PAYMENTS';
	            this.showBAContent = this.models.checkoutCart.isBilling() && !this.models.checkoutCart.isWalletTokenization();
	            this.contentKeys = {};
	
	            var setUnbrandedContent = function setUnbrandedContent() {
	
	                _this.onboardTitleLine1 = _this.isUnbranded ? 'common.getBenefitsUnBrandedLine1' : 'common.getBenefitsLine1';
	                _this.subTitle = _this.isUnbranded ? 'common.createPayPalUnBrandedProp' : 'common.createPayPalProp';
	                _this.paypalSubTitle = _this.isUnbranded ? 'common.createPayPalUnBrandedSubTitle' : 'common.createPayPalSubTitle';
	                _this.guestSignup1 = _this.isUnbranded ? 'common.yesCreateUnBrandedAccount' : 'common.yesCreateAccount';
	                _this.guestSignup2 = _this.isUnbranded ? 'common.nothanksUnBranded' : 'common.nothanks';
	            };
	
	            setUnbrandedContent();
	
	            var contentOpts = {
	                $config: _index.$config,
	                cart: this.models.checkoutCart,
	                appData: this.models.checkoutAppData
	            };
	            this.baContentKey = (0, _contentKeys.getBAContentKey)(contentOpts);
	            this.rpContentKey = (0, _contentKeys.getRPContentKey)(contentOpts);
	            this.wpsFlow = this.models.checkoutAppData.doec_on_approve();
	
	            var setDCCEligibilityFlag = function setDCCEligibilityFlag(mode) {
	
	                if (mode === 'signup') {
	                    return;
	                }
	
	                var experiment = _this.experiments.dccEligibility;
	                _this.flags.dccCountryEligibility = experiment && experiment.treatment_name;
	            };
	
	            /**
	             * show WPS interstitial page, if
	             * 1. its optional sign up flow and
	             * 2. not multistep flow and not DE
	             * 3. merchant pref not have pdt or auto return and
	             * 4. one touch throttle is not control
	             * 5. wps interstitial throttle return treatment experiment
	             **/
	            var checkWPSInterstitialEligibility = function checkWPSInterstitialEligibility(mode) {
	                if (!_this.wpsFlow) {
	                    return;
	                }
	                if (_this.mode === 'signup') {
	                    _logger.$logger.info('wps_interstitial_not_eligible_force_signup');
	                    return;
	                }
	                if (_this.models.merchantPreference) {
	                    if (_this.models.merchantPreference.autoReturn()) {
	                        _logger.$logger.info('wps_interstitial_not_eligible_merchant_prefer_auto_return');
	                        return;
	                    }
	                    if (_this.models.merchantPreference.pdtEnabled()) {
	                        _logger.$logger.info('wps_interstitial_not_eligible_merchant_prefer_pdt_enabled');
	                        return;
	                    }
	                }
	
	                /*
	                 * pxp XO_XOONBOARDING_WPS_INTERSTITIAL_OPTIONAL_SIGNUP will test 3 variants:
	                 * 1. XO_XOONBOARDING_WPS_INTERSTITIAL_OPTIONAL_SIGNUP_control - wps interstitial with guest only experience
	                 * 2. XO_XOONBOARDING_WPS_INTERSTITIAL_OPTIONAL_SIGNUP_treatment1 - optional guest without wps interstitial
	                 * 3. XO_XOONBOARDING_WPS_INTERSTITIAL_OPTIONAL_SIGNUP_treatment2 - wps interstitial with optional signup
	                 */
	                var wpsPXP = _this.experiments.wpsInterstitial;
	                var treatment = wpsPXP && _pxpExperimentConstants2['default'].test['xoon_wps_interstitial_optional_signup'][wpsPXP.treatment_name];
	                if (treatment) {
	                    _logger.$logger.info('wps_interstitial_pxp_' + wpsPXP.treatment_name);
	                    _this.flags.wpsInterstitialEligible = treatment['interstitialEligible'];
	                    _this.flags.buyerMode = treatment['buyerMode'];
	                    _this.mode = treatment['mode'];
	                }
	            };
	
	            var setEcPomaFlag = function setEcPomaFlag() {
	                var pomaPXP = _this.pomaExperiment.poma;
	                if (pomaPXP && pomaPXP.treatment_name.indexOf('XO_XOONBOARDING_POMA_GLOBAL_TREATMENT') > -1) {
	                    _logger.$logger.info('checkout_fpti', { is_poma: 1 });
	                    _this.flags.wpsInterstitialEligible = false;
	                    _this.flags.show_poma_ui = true;
	                    _this.POMAContentType = pomaPXP.treatment_name.indexOf('TREATMENT_A') > -1 ? 'TREATMENT_A' : 'TREATMENT_B';
	                }
	            };
	
	            var setOptionalSignupPromotionContent = function setOptionalSignupPromotionContent(mode) {
	                if (mode !== 'guest') {
	                    return;
	                }
	
	                var optionSignupContentPXP = _this.experiments.optionalSignupContent;
	                if (optionSignupContentPXP && optionSignupContentPXP.treatment_name) {
	                    var treatmentContentKeys = _pxpExperimentConstants2['default'].test['xoon_optional_signup_content_change'][optionSignupContentPXP.treatment_name];
	
	                    _this.contentKeys = treatmentContentKeys ? treatmentContentKeys : {};
	                }
	            };
	
	            var setFlagsPostFlowEligibility = function setFlagsPostFlowEligibility(mode) {
	                var trackingModes = ['guest', 'guestonly'];
	                _this.flags.track_submit_transition = trackingModes.indexOf(_this.mode) > -1 ? 'guest_xo' : 'signup';
	
	                checkWPSInterstitialEligibility(mode);
	                setDCCEligibilityFlag(mode);
	                setOptionalSignupPromotionContent(mode);
	
	                // POMA - Passwordless Onboarding of Member Accounts
	                if (mode === 'guest' && _index.$locale.country === 'US' && !_index5.$DeviceInfo.isWebView()) {
	                    if (!_this.wpsFlow) {
	                        setEcPomaFlag();
	                    }
	                }
	
	                _this.flags.mode = _this.mode;
	                _this.flags.signupEnabled = _this.mode !== 'guestonly';
	                _this.flags.allowChoice = _this.mode !== 'signup';
	
	                // Initialize showDisabledPasswordField to true.
	                // NOTE: We use the if condition to check for undefined so the variable is assigned only once.
	                // This method is called on every locale change, so we don't want it to be true on every change.
	                // In future cases, signupSelected and guestSelected will set it accordingly.
	                if (_this.flags.showDisabledPasswordField === undefined) {
	                    _this.flags.showDisabledPasswordField = true;
	                }
	            };
	            setFlagsPostFlowEligibility(this.mode);
	        }
	    },
	    actions: {
	        setBuyerModeFlags: function setBuyerModeFlags(newValue) {
	            switch (newValue) {
	                case 'guest':
	                case 'guestonly':
	                    // show disabled password field for variant2
	                    this.flags.showDisabledPasswordField = true;
	                    this.flags.showEmailBelowName = true;
	                    _logger.$logger.info('Guest_Signup_No');
	                    this.flags.mode = newValue;
	                    this.flags.track_submit_transition = 'guest_xo';
	                    break;
	                case 'signup':
	                    // hide disabled password field
	                    this.flags.showEmailBelowName = false;
	                    this.flags.showDisabledPasswordField = false;
	                    this.flags.ignoreValidationTheFirstTime = true;
	                    _logger.$logger.info('Guest_Signup_Yes');
	                    this.flags.mode = newValue;
	                    this.flags.track_submit_transition = 'guest_optional_signup';
	                    break;
	                default:
	                // Do Nothing
	            }
	            this.accountCreationSectionErrorMessage = '';
	            $('.signupFieldsContainer .radioButton').removeClass('warning');
	            _uiRouter.$state.current.trackingData.pageQualifier = newValue;
	            return true;
	        },
	        triggerTimerForSignupClicked: function triggerTimerForSignupClicked() {
	            if (window.performance) {
	                _logger.$logger.info('sign up option clicked, start timer...', window.performance.now());
	                this.$emit('signupClickedTimerStarted', window.performance.now());
	            }
	        },
	        onCheckedSavedMyInfo: function onCheckedSavedMyInfo($event) {
	            if ($event.target.checked) {
	                // populating the legal terms key to send the TCPA details to OAS later during onboarding
	                this.flags.tcpa_identifier = 'poma.legalTerms';
	                this.flags.poma_flow = true;
	                this.flags.track_submit_transition = 'poma_signup';
	                $('.pomaFieldsContainer').addClass('focusBorder');
	                $('.pomaFieldsContainer').addClass('active');
	                _logger.$logger.info('POMA_CHECKBOX_SELECTED');
	                if ($('#pomaSubmit').offset()) {
	                    window.scrollTo(0, this.$element.parent().find('#pomaSubmit').offset().top);
	                }
	            } else {
	                this.flags.tcpa_identifier = undefined;
	                this.flags.poma_flow = false;
	                this.flags.track_submit_transition = 'guest_xo';
	                $('.pomaFieldsContainer').removeClass('focusBorder');
	                $('.pomaFieldsContainer').removeClass('active');
	                _logger.$logger.info('POMA_CHECKBOX_DESELECTED');
	            }
	        }
	    }
	});
	
	
	_index.$Component;
	
	_index.$locale;
	
	_index.$pxp;
	
	_index.$config;
	
	_index2.$CheckoutInputDataModel;
	
	_index3.$CheckoutAppDataModel;
	
	_index3.$CheckoutPayeeModel;
	
	_index3.$CheckoutCartModel;
	
	_index3.$FlowEligibilityModel;
	
	_index4.$MerchantPreferenceModel;
	
	_logger.$logger;
	
	_uiRouter.$state;
	
	_index5.$DeviceInfo;
	
	_contentKeys.getBAContentKey;
	
	_contentKeys.getRPContentKey;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "./components/xo-guest-components/src/lib/contentKeys.js":
/***/ (function(module, exports) {

	
	
	exports.__esModule = true;
	/**
	 * Returns the appropriate billing agreement xo-content key.
	 *
	 *   enterpriseAgreement.{CODE}NoFiStickyConsentSignup
	 *   billingAgreement.signupAgreementCibStickyPay
	 *   billingAgreement.signupAgreementCibStickyContinue
	 *   billingAgreement.signupAgreementFiStickyPay
	 *   billingAgreement.signupAgreementFiStickyContinue
	 *
	 * @param {Object} opts
	 * @param {opts.cart} a CheckoutCartModel instance
	 * @param {opts.appData} a CheckoutAppDataModel instance
	 * @return {String}
	 */
	
	var getBAContentKey = exports.getBAContentKey = function getBAContentKey(opts) {
	    var consentCode = opts.cart.get('billing.consent_code');
	
	    if (consentCode) {
	        var signupKey = 'NoFiStickyConsentSignup';
	        return 'enterpriseAgreement.' + consentCode + signupKey;
	    }
	
	    var keyPrefix = 'billingAgreement.signupAgreement';
	    var isCIB = opts.cart.get('billing.type') === 'CHANNEL_INITIATED_BILLING';
	    var type = isCIB ? 'Cib' : 'Fi';
	
	    var useraction = opts.appData.useraction();
	    var action = useraction === 'commit' ? 'Pay' : 'Continue';
	
	    var keySuffix = type + 'Sticky' + action;
	    return '' + keyPrefix + keySuffix;
	};
	
	/**
	 * Returns the appropriate RP xo-content key.
	 *
	 *   billingAgreement.signupRpAgreementFiStickyPay
	 *   billingAgreement.signupRpAgreementFiStickyContinue
	 *
	 * @param {Object} opts
	 * @param {opts.cart} a CheckoutCartModel instance
	 * @param {opts.appData} a CheckoutAppDataModel instance
	 * @return {String}
	 */
	var getRPContentKey = exports.getRPContentKey = function getRPContentKey(opts) {
	    var keyPrefix = 'billingAgreement.signupRpAgreementFiSticky';
	    var useraction = opts.appData.useraction();
	    var action = useraction === 'commit' ? 'Pay' : 'Continue';
	    return '' + keyPrefix + action;
	};

/***/ }),

/***/ "./components/xo-guest-components/src/guest/onboardOptions/guest/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _template = __webpack_require__("./components/xo-guest-components/src/guest/onboardOptions/guest/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('xoGuestOptions', {
	    tag: 'xo-guest-options',
	    template: _template2['default'],
	
	    props: {
	        flags: {
	            type: 'var',
	            required: true
	        },
	        onboard: {
	            type: 'var',
	            required: true
	        },
	        singlePagePaymentForm: {
	            type: 'var'
	        },
	        validated: {
	            type: 'var'
	        },
	        sepa: {
	            type: 'var'
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            this.locale = _squid.$locale;
	        }
	    },
	    actions: {
	        openSepa: function openSepa() {
	            this.props.sepa.show = true;
	        }
	    }
	});
	
	
	_squid.$Component;
	
	_squid.$locale;
	module.exports = exports['default'];

/***/ }),

/***/ "./components/xo-guest-components/src/guest/onboardOptions/guest/template.html":
/***/ (function(module, exports) {

	module.exports = "<div class=\"guestOption\" content>\n    <div ng-if=\"flags.buyerMode === 'guest' || flags.mode === 'guestonly'\"\n         ng-class=\"{'signupFieldsContainer': !flags.signupEnabled, 'signupFields': flags.mode === 'guest'}\">\n        <div class=\"row-fluid inputField checkbox legal\" feature=\"econsentGuest\">\n            <div id=\"errorGuestAgree\" ng-show=\"!flags.ignoreValidationTheFirstTime && singlePagePaymentForm.guestagree.$error.required\" class=\"errorTooltip errorTooltipRuleSpecific\">{{ content('largeScreenAccountCreation.agrementError') }}</div>\n            <input ng-model=\"guestagree\" type=\"checkbox\" name=\"guestagree\" id=\"guestagree\" required aria-describedby=\"errorGuestAgree\"/>\n            <label class=\"noBottom\" for=\"guestagree\" ng-bind-html=\"onboard.fiMode === 'bank' ? htmlContent('signupTerms.guestBank') : htmlContent('signupTerms.guest', {country:locale.country, lang:locale.lang})\" aria-describedby=\"errorGuestAgree\"></label>\n        </div>\n        <div class=\"row-fluid inputField checkbox legal\" feature=\"guestTerms\">\n            <div id=\"errorGuestTerms\" ng-show=\"!flags.ignoreValidationTheFirstTime && singlePagePaymentForm.guestTerms.$error.required\" class=\"errorTooltip errorTooltipRuleSpecific\">{{ content('largeScreenAccountCreation.agrementError') }}</div>\n            <input ng-model=\"guestTerms\" type=\"checkbox\" name=\"guestTerms\" id=\"guestTerms\" required aria-describedby=\"errorGuestTerms\"/>\n            <label class=\"noBottom\" for=\"guestTerms\" ng-bind-html=\"htmlContent('signupTerms.guestTerms', {country:locale.country, lang:locale.lang})\" aria-describedby=\"errorGuestTerms\"></label>\n        </div>\n        <div class=\"row-fluid inputField checkbox legal sepaTerms\" ng-if=\"onboard.fiMode === 'bank' && !flags.show_sepa_overlay\">\n            <div id=\"errorSepaGuestAgree\" ng-show=\"!flags.ignoreValidationTheFirstTime && singlePagePaymentForm.sepaGuestAgree.$error.required\" class=\"errorTooltip errorTooltipRuleSpecific\">{{ content('largeScreenAccountCreation.agrementError') }}</div>\n            <input ng-model=\"sepa.sepaGuestAgree\" type=\"checkbox\" name=\"sepaGuestAgree\" id=\"sepaGuestAgree\" required aria-describedby=\"errorSepaGuestAgree\"/>\n            <label class=\"noBottom agreeSepaTerms\" for=\"sepaGuestAgree\"\n                   bind-html-compile=\"htmlContent('signupTerms.agreeSepaTermsV2')\"\n                   aria-describedby=\"errorSepaGuestAgree\"></label>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "./components/xo-guest-components/src/guest/onboardOptions/signup/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _index = __webpack_require__("./components/squid/dist/index.js");
	
	var _index2 = __webpack_require__("./components/xo-device-info/dist/index.js");
	
	var _template = __webpack_require__("./components/xo-guest-components/src/guest/onboardOptions/signup/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-form-components/src/place-of-birth/directive.js");
	
	__webpack_require__("./components/xo-form-components/src/gender-type/directive.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _index.$Component.extend('xoSignupOptions', {
	    tag: 'xo-signup-options',
	    template: _template2['default'],
	
	    props: {
	        flags: {
	            type: 'var'
	        },
	        onboard: {
	            type: 'var'
	        },
	        singlePagePaymentForm: {
	            type: 'var'
	        },
	        validated: {
	            type: 'var'
	        },
	        sepa: {
	            type: 'var'
	        },
	        guestUpgrade: {
	            type: 'var'
	        },
	        isUnbranded: {
	            type: 'var'
	        }
	    },
	
	    resolve: {
	        experiments: function experiments() {
	            return {
	                singlePassword: (0, _index.$pxp)('xoon_single_password', { 'ctx.COUNTRY': _index.$locale.country }, 'xoon_single_password_test')
	            };
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            this.locale = _index.$locale;
	            this.flags.nationalIdFlag = _index.$config.nationalIdRequiredCountries && _index.$config.nationalIdRequiredCountries.indexOf(_index.$locale.country) > -1;
	            this.isGenderFieldEnabled = (0, _index.$feature)('gender', false, this.locale.country);
	            // Market Opt-in checked if country is canada
	            this.marketingOptInChecked = (0, _index.$feature)('checkMarketingOptIn', false, this.locale.country);
	        },
	        populate: function populate() {
	            if (_index.$locale.country === 'US') {
	                this.onboard.eConsentTermsContent = 'signupTerms.signupTCPA3';
	            } else if (this.isUnbranded) {
	                this.onboard.eConsentTermsContent = this.onboard.fiMode === 'bank' ? 'signupTerms.signupBankUnBranded' : 'signupTerms.signupC';
	            } else {
	                this.onboard.eConsentTermsContent = this.onboard.fiMode === 'bank' ? 'signupTerms.signupBank' : 'signupTerms.signupC';
	            }
	
	            if (this.isUnbranded) {
	                this.flags.singlePassword = true;
	            } else {
	                var singlePasswordPXP = this.experiments.singlePassword;
	                if (singlePasswordPXP) {
	                    if (singlePasswordPXP.treatment_name || _index2.$DeviceInfo.isDevice()) {
	                        this.flags.singlePassword = true;
	                    }
	                }
	            }
	        }
	    },
	
	    actions: {
	        openSepa: function openSepa() {
	            this.sepa.show = true;
	        }
	    }
	});
	
	
	_index.$Component;
	
	_index.$locale;
	
	_index.$pxp;
	
	_index.$config;
	
	_index.$feature;
	
	_index2.$DeviceInfo;
	module.exports = exports['default'];

/***/ }),

/***/ "./components/xo-guest-components/src/guest/onboardOptions/signup/template.html":
/***/ (function(module, exports) {

	module.exports = "<div class=\"signupOptions\" content>\n    <div ng-if=\"flags.showDisabledPasswordField && flags.allowChoice && !guestUpgrade\" class=\"signupFields\">\n        <xo-password-input user=\"onboard.user\" is-disabled=\"true\" single-password=\"flags.singlePassword\"></xo-password-input>\n    </div>\n    <div class=\"signupFields\" ng-if=\"guestUpgrade || flags.mode === 'signup' || flags.buyerMode === 'signup'\"\n         ng-class=\"{'fullSignup': fullSignup || !flags.allowChoice, 'ignoreValidation': flags.ignoreValidationTheFirstTime }\">\n            <xo-email-input flow=\"signup\" flags=\"flags\" user=\"onboard.user\" ng-if=\"!flags.allowChoice && !flags.cupDetected\"></xo-email-input>\n            <xo-password-input class=\"highZindexTooltip\" user=\"onboard.user\" single-password=\"flags.singlePassword\"></xo-password-input>\n\n            <!--As per the UI design, DOB and Gender needs to be side by side for HK and others just DOB-->\n            <div class=\"dualInputElements clearfix\">\n                <span feature=\"dobRequired\" ng-class=\"{'halfInputElement': isGenderFieldEnabled}\" ng-if=\"onboard.fiMode === 'card'\">\n                    <xo-dob-input user=\"onboard.user\" id=\"dob\"></xo-dob-input>\n                </span>\n                <!--gender is enabled only for HK-->\n                <span feature=\"gender\">\n                    <xo-gender-type user=\"onboard.user\" id=\"gender\"></xo-gender-type>\n                </span>\n            </div>\n\n            <!--placeOfBirth is enabled only for HK-->\n            <span feature=\"placeOfBirth\">\n                <xo-place-of-birth user=\"onboard.user\" id=\"placeofbirth\"></xo-place-of-birth>\n            </span>\n\n            <span feature=\"collectOccupation\">\n                <xo-occupation user=\"onboard.user\"></xo-occupation>\n            </span>\n\n            <span feature=\"nationalityRequired\">\n                <xo-nationality user=\"onboard.user\"></xo-nationality>\n            </span>\n\n            <span ng-if=\"flags.nationalIdFlag\">\n                <xo-national-id-input country=\"{{locale.country}}\" user=\"onboard.user\"></xo-national-id-input>\n            </span>\n\n            <xo-citizenship user=\"onboard.user\"></xo-citizenship>\n\n            <div class=\"row-fluid inputField checkbox legal ltrOverride\" directionality feature=\"econsent\">\n                <div id=\"errorSignupAgree\" ng-show=\"!flags.ignoreValidationTheFirstTime && singlePagePaymentForm.agree.$error.required\" class=\"errorTooltip errorTooltipRuleSpecific\">{{ content('largeScreenAccountCreation.agrementError') }}</div>\n                <input ng-model=\"agree\" type=\"checkbox\" name=\"agree\" id=\"agree\" required aria-describedby=\"errorSignupAgree\"/>\n                <label class=\"noBottom signupTerms bgImgOnSpan\" for=\"agree\" aria-describedby=\"errorSignupAgree\">\n                    <span class=\"bgImg\">&nbsp;</span>\n                    <span id=\"consentTerms\" ng-bind-html=\"htmlContent(onboard.eConsentTermsContent, {country:locale.country, lang:locale.lang})\"><span>\n                </label>\n            </div>\n            <div class=\"terms\" feature=\"signupTerms\">\n                <p class=\"signupTerms\" id=\"consumerAdvisory\" ng-if=\"flags.commit\" ng-bind-html=\"htmlContent('signupTerms.consumerAdvisory',{country:locale.country})\"></p>\n                <p class=\"signupTerms\" id=\"consumerAdvisory\" ng-if=\"!flags.commit\" ng-bind-html=\"htmlContent('signupTerms.consumerAdvisoryB',{country:locale.country})\"></p>\n            </div>\n            <div class=\"row-fluid inputField checkbox legal sepaTerms\" ng-if=\"onboard.fiMode === 'bank' && !flags.wpsInterstitial\">\n                <div id=\"errorSepaSignupAgree\" ng-show=\"!flags.ignoreValidationTheFirstTime && singlePagePaymentForm.sepaAgree.$error.required\" class=\"errorTooltip errorTooltipRuleSpecific\">{{ content('largeScreenAccountCreation.agrementError') }}</div>\n                <input ng-model=\"sepa.sepaAgree\" type=\"checkbox\" name=\"sepaAgree\" id=\"sepaAgree\" required aria-describedby=\"errorSepaSignupAgree\"/>\n                <label class=\"noBottom agreeSepaTerms\" for=\"sepaAgree\"\n                       bind-html-compile=\"htmlContent('signupTerms.agreeSepaTermsV2')\"\n                       aria-describedby=\"errorSepaSignupAgree\"></label>\n            </div>\n            <div class=\"row-fluid checkbox legal marketingOptin\" feature=\"marketingOptinMember\">\n                <input ng-model=\"onboard.marketingOptin\" type=\"checkbox\" name=\"marketingOptin\" id=\"marketingOptin\" ng-checked=\"marketingOptInChecked\"/>\n                <label class=\"noBottom marketingOptin\" for=\"marketingOptin\"\n                       ng-bind-html=\"htmlContent('signupTerms.agreeMarketing')\"></label>\n            </div>\n        </div>\n</div>\n"

/***/ }),

/***/ "./components/xo-form-components/src/place-of-birth/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _index = __webpack_require__("./components/squid/dist/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/floating-label/directive.js");
	
	var _template = __webpack_require__("./components/xo-form-components/src/place-of-birth/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _index.$Component.extend('$xoPlaceOfBirth', {
	    tag: 'xo-place-of-birth',
	    template: _template2['default'],
	
	    props: {
	        user: {
	            type: 'var'
	        }
	    },
	
	    lifecycle: {
	        populate: function populate() {
	            var _this = this;
	
	            this.populateCountryList = function () {
	                var guestBlockedCountries = _index.$config.guestBlockedCountries || [];
	                _this.metadata = _angular2['default'].copy(_index.$locale.metadata);
	                var placeOfBirth = {};
	
	                _this.countriesList = _this.metadata.territory.filter(function (c) {
	
	                    if (c.code === _index.$locale.country) {
	                        placeOfBirth = c;
	                    }
	                    return !(guestBlockedCountries.indexOf(c.code) > -1);
	                });
	                // set the default select option in the place of birth dropdown
	                _this.selectedPlaceOfBirth = placeOfBirth;
	                _this.user.placeofbirth = placeOfBirth.code;
	            };
	            this.populateCountryList();
	            this.$on('metadataChange', this.populateCountryList);
	        }
	    },
	
	    actions: {
	        updatePlaceOfBirth: function updatePlaceOfBirth(country_code) {
	            this.user.placeofbirth = country_code;
	        }
	    }
	});
	
	
	_index.$Component;
	
	_index.$locale;
	
	_index.$config;
	module.exports = exports['default'];

/***/ }),

/***/ "./components/xo-form-components/src/place-of-birth/template.html":
/***/ (function(module, exports) {

	module.exports = "<div class=\"dropdown confidential country clearfix inputField\" floating-label-dropdown content>\n    <select xo-dropdown name=\"placeofbirth\" dropdown-text-bind-var=\"selectedPlaceOfBirth.name\"\n            ng-model=\"selectedPlaceOfBirth\"\n            ng-options=\"country.name for country in countriesList track by country.code\"\n            id=\"placeofbirth\"\n            ng-change=\"actions.updatePlaceOfBirth(selectedPlaceOfBirth.code)\"\n            xo-error-tooltip required>\n    </select>\n    <label for=\"placeofbirth\" id=\"placeofbirthlabel\">{{ content('common.placeOfBirth') }}</label>\n</div>\n"

/***/ }),

/***/ "./components/xo-form-components/src/gender-type/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _index = __webpack_require__("./components/squid/dist/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/floating-label/directive.js");
	
	__webpack_require__("./components/xo-form-components/src/gender-type/styles.less");
	
	var _template = __webpack_require__("./components/xo-form-components/src/gender-type/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _index.$Component.extend('$xoGenderType', {
	    tag: 'xo-gender-type',
	    template: _template2['default'],
	
	    props: {
	        user: {
	            type: 'var'
	        }
	    }
	});
	
	
	_index.$Component;
	module.exports = exports['default'];

/***/ }),

/***/ "./components/xo-form-components/src/gender-type/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-form-components/src/gender-type/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-form-components/src/gender-type/styles.less":
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, ".dualInputElements .halfInputElement{width:48.7%;margin-right:2.6%;float:left}.dualInputElements .halfInputElement.last-child{margin-right:0}@media (max-width:30em) and (min-width:0){.dualInputElements .halfInputElement{width:100%;float:none;margin-right:0}}", ""]);
	
	// exports


/***/ }),

/***/ "./components/xo-form-components/src/gender-type/template.html":
/***/ (function(module, exports) {

	module.exports = "<div content>\n    <div id=\"genderTypeContainer\" class=\"dropdown gender confidential halfInputElement inputField last-child\"\n         floating-label-dropdown directionality>\n        <select ng-model=\"user.gendertype\" name=\"gender\" xo-dropdown id=\"gender\"\n                aria-required=\"true\" ng-required=\"true\">\n            <option value=\"\">{{ content('common.genderLabel') }}</option>\n            <option value=\"MALE\">{{ content('common.genderMale') }}</option>\n            <option value=\"FEMALE\">{{ content('common.genderFemale') }}</option>\n        </select>\n        <label for=\"gender\" id=\"genderLabel\">{{ content('common.genderLabel') }}</label>\n    </div>\n</div>\n"

/***/ }),

/***/ "./components/xo-page-components/src/marketingOffers/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-page-components/src/marketingOffers/template.html"), __webpack_require__("./components/xo-title/dist/directive.js"), __webpack_require__("./components/xo-models/src/marketingoffer/index.js"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/auth/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, template) {
	
	    return angular.module('xo-page-components.marketingOffers', ['squid', 'xo-title.directive', 'xomodel.marketingoffer', 'xomodel.checkout', 'xomodel.auth']).directive('xoMarketingOffers', function () {
	        return {
	            template: template,
	
	            scope: {
	                placementCode: '=',
	                titleTxtProperty: '=',
	                subtitleProperty: '=',
	                token: '=',
	                pageName: '=',
	                backgroundImage: '='
	            },
	
	            controller: function controller($scope, $sce, $rootScope, $populate, $state, $locale, $renderContent, $logger, $pxp, $config, $CheckoutCartModel, $MarketingOfferModel, $fireMORSBeacon, $element, $feature, $CheckoutSessionModel, $CheckoutPayeeModel, $AuthModel) {
	                var morsOfferFlag = $scope.placementCode === '202003' && $feature('morsValuePropOffers');
	                var populateObj;
	                if (morsOfferFlag) {
	                    populateObj = {
	                        checkoutCart: $CheckoutCartModel.instance($scope.token),
	                        checkoutSession: $CheckoutSessionModel.instance($scope.token),
	                        payee: $CheckoutPayeeModel.instance($scope.token),
	                        auth: $AuthModel.instance()
	                    };
	                } else {
	                    populateObj = {
	                        checkoutCart: $CheckoutCartModel.instance($scope.token)
	                    };
	                }
	                $populate($scope, populateObj).then(function () {
	                    $scope.locale = $locale;
	                    $scope.token = $rootScope.token;
	                    function setDefaultValues() {
	                        $scope.ad = {
	                            Title: $renderContent($scope.titleTxtProperty),
	                            Body: $renderContent($scope.subtitleProperty),
	                            backgroundImage: $scope.backgroundImage
	                        };
	                    }
	
	                    $scope.$watch('ad.backgroundImage', function (imageUrl) {
	                        if (imageUrl) {
	                            var url = imageUrl;
	                            var propImg = angular.element($element[0].querySelector('div.prop-img'));
	                            var isRetina = window && window.matchMedia && window.matchMedia('(-webkit-min-device-pixel-ratio: 2), ' + '(min--moz-device-pixel-ratio: 2), ' + '(-o-min-device-pixel-ratio: 2/1),' + '(min-device-pixel-ratio: 2),' + '(min-resolution: 192dpi), ' + '(min-resolution: 2dppx)').matches;
	
	                            if (isRetina && url) {
	                                var index = url.lastIndexOf('.'); // index at which file extension start
	                                url = url.substring(0, index) + '_2x' + url.substring(index, url.length);
	                                propImg.css({
	                                    'background-image': 'url(' + url + ')',
	                                    'height': '150px',
	                                    'margin-top': '0px'
	                                });
	                            } else {
	                                propImg.css({
	                                    'background-image': 'url(' + url + ')',
	                                    'height': '150px',
	                                    'margin-top': '0px'
	                                });
	                            }
	                        }
	                    });
	
	                    if ($scope.placementCode === '202002') {
	                        $scope.pu_type = 'ANONYMOUS';
	                        $scope.presentation_types = ['CompositeText'];
	                        $scope.pxpInfo = {
	                            name: 'xo_xoon_hermes_mors',
	                            pattern: '(xo_xoon_hermes_mors_)(.*)',
	                            treatment: 'xo_xoon_hermes_mors_treatment'
	                        };
	                    } else if ($scope.placementCode === '202003') {
	                        $scope.className = 'props';
	                        $scope.pu_type = 'PERSONAL';
	                        $scope.presentation_types = ['GenericComposite'];
	                        $scope.pxpInfo = {
	                            name: 'xo_mors_hermes_placements_ryi',
	                            pattern: '(xo_mors_hermes_placements_ryi_)(.*)',
	                            treatment: 'xo_mors_hermes_placements_ryi_treatment'
	                        };
	                    } else {
	                        setDefaultValues();
	                    }
	
	                    //  serve ads only if pxp is true, country is US and lang is en
	                    if ($locale.country === 'US' && $locale.lang === 'en' && $scope.placementCode && $feature('morsValuePropOffers')) {
	                        $scope.marketingOfferData = new $MarketingOfferModel({
	                            countryCode: $scope.locale.country,
	                            page: $scope.pageName,
	                            puType: $scope.pu_type,
	                            locale: $locale.lang + '_' + $locale.country,
	                            totalTransactionAmount: {
	                                'currency_code': $scope.checkoutCart.get('purchase.amounts.total.currency_code', ''),
	                                // Round the calculation to eliminate Floating point Rounding Error (69.99 * 100 === 6998.999999999999)
	                                // http://docs.oracle.com/cd/E19957-01/806-3568/ncg_goldberg.html
	                                'value': Math.round($scope.checkoutCart.get('purchase.amounts.total.amount', 0) * 100)
	                            },
	                            totalShippingAmount: {
	                                'currency_code': $scope.checkoutCart.get('purchase.amounts.total.currency_code', ''),
	                                // Round the calculation to eliminate Floating point Rounding Error (69.99 * 100 === 6998.999999999999)        
	                                // http://docs.oracle.com/cd/E19957-01/806-3568/ncg_goldberg.html                            
	                                'value': Math.round($scope.checkoutCart.get('purchase.amounts.shipping.amount', 0) * 100)
	                            },
	                            payee: morsOfferFlag ? $scope.payee.merchant.id : '',
	                            payer: morsOfferFlag ? $scope.checkoutSession.payer.id : '',
	                            si: morsOfferFlag ? $scope.checkoutSession.id : '',
	                            visitor_id: morsOfferFlag ? $scope.auth.visitor_id : '',
	                            targetPlacements: [{
	                                'placement_code': $scope.placementCode,
	                                'presentation_types': $scope.presentation_types
	                            }]
	                        });
	                        $pxp($scope.pxpInfo.name, { 'ctx.COUNTRY': $locale.country }, $scope.pxpInfo.pattern).then(function (res) {
	
	                            $logger.info('MO treatment: ' + (res ? res.treatment_name : '[no pxp response!]'));
	                            if (res && res.treatment_name === $scope.pxpInfo.treatment) {
	
	                                return $MarketingOfferModel.instance($scope.token).save({
	
	                                    silent: true,
	                                    data: $scope.marketingOfferData.serialize(),
	                                    success: function success(result) {
	                                        var ads_arr = result && result.ads || [];
	                                        var adFound = false;
	
	                                        // MORS could serve multiple ads for a given page. Iterate to get the
	                                        // correct one based on the ad placement_id
	                                        ads_arr.forEach(function (ad) {
	                                            var adunit_id = ad.campaign.adunit_id;
	
	                                            if (adunit_id.toString() === $scope.placementCode.toString() && ad.valid) {
	                                                adFound = true;
	                                                $scope.ad = {};
	                                                var content = ad.content.nvp;
	                                                content.forEach(function (obj) {
	                                                    $scope.ad[obj.name] = obj.value;
	                                                });
	                                                $scope.ad['impressionUrl'] = ad.tracking.impression_url;
	                                                $scope.ad['clickUrl'] = ad.tracking.click_url;
	                                            }
	                                        });
	
	                                        if (adFound) {
	                                            $scope.ad.Body = $sce.trustAsHtml($scope.ad.Body);
	                                            // $scope.ad.Title does not need to be assigned. for 202001, 202002,
	                                            // and 202003 placement_ids as this will already be assigned.
	
	                                            // notify MORS of successful rendering by firing the impressionurl
	                                            // beacon and by setting the click url to be fired for future
	                                            // conversion.
	                                            // setting the placement_id helps to differentiate between multiple ads
	                                            // displayed on the same page
	
	                                            $logger.info('MORS_ad_displayed');
	                                            $fireMORSBeacon.fireBeacon($scope.ad.impressionUrl);
	
	                                            $rootScope.$broadcast('MORSDisplayed', {
	                                                clickUrl: $scope.ad.clickUrl,
	                                                placementId: $scope.placementCode
	                                            });
	                                        } else {
	                                            $logger.info('MORS_ad_not_found');
	                                            setDefaultValues();
	                                            $rootScope.$broadcast('MORSNotDisplayed');
	                                        }
	                                    },
	
	                                    error: function error(err) {
	                                        setDefaultValues();
	                                        $logger.error('MORS_api_failure', { error: err });
	                                    }
	                                });
	                            } else {
	                                setDefaultValues();
	                                $rootScope.$broadcast('MORSNotDisplayed');
	                            }
	                        });
	                    } else {
	                        setDefaultValues();
	                        $rootScope.$broadcast('MORSNotDisplayed');
	                    }
	                    $scope.$on('localeChange', function () {
	                        setDefaultValues();
	                    });
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-page-components/src/marketingOffers/template.html":
/***/ (function(module, exports) {

	module.exports = "<div class=\"marketingOffers {{className}}\" content >\n    <div ng-if=\"ad.backgroundImage\" class=\"prop-img\"></div>\n    <xo-title title-txt=\"{{ ad.Title }}\"></xo-title>\n    <p class=\"subTitle\" ng-bind-html=\"ad.Body\"></p>\n</div>\n"

/***/ }),

/***/ "./components/xo-title/dist/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-title/dist/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	
	    squid.module('xo-title.directive', ['squid']).directive('xoTitle', function () {
	        return {
	            template: template,
	            restrict: 'E',
	            scope: {
	                titleTxt: '@',
	                className: '@'
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-title/dist/template.html":
/***/ (function(module, exports) {

	module.exports = "<h1 class=\"alpha\">\n    {{ titleTxt }}\n</h1>\n"

/***/ }),

/***/ "./components/xo-guest-components/src/guest/onboardOptions/template.html":
/***/ (function(module, exports) {

	module.exports = "<div class=\"onboardOptions\" content>\n    <div ng-if=\"flags.signupEnabled && !flags.show_poma_ui\" class=\"signupFieldsContainer\" id=\"signupContainer\">\n\n        <div ng-if=\"flags.allowChoice\">\n\n            <h1 class=\"alpha\" ng-if=\"!contentKeys.title\">\n                <p id=\"onboardTitleLine1\" class=\"onboardTitleLine1\">{{content(onboardTitleLine1)}}</p>\n                <p class=\"onboardTitleLine2\">{{content('common.getBenefitsLine2')}}</p>\n            </h1>\n            <h1 class=\"alpha\" ng-if=\"contentKeys.title\">\n                <p class=\"onboardTitleLine1\">{{content(contentKeys.title)}}</p>\n            </h1>\n\n            <p class=\"subTitle\" id=\"subTitle\" ng-if=\"!contentKeys.subTitle\" ng-bind-html=\"htmlContent(subTitle, {country: locale.country, lang: locale.lang})\"></p>\n            <p class=\"subTitle\" ng-if=\"contentKeys.subTitle\" ng-bind-html=\"htmlContent(contentKeys.subTitle, {country: locale.country, lang: locale.lang})\"></p>\n\n            <xo-message ng-if=\"validated && singlePagePaymentForm.guestSignup.$error.required\" id=\"guestSignupErrorMessage\"\n                        message=\"{ msgs: [content('largeScreenPayment.chooseAnOption')], type: 'warning' }\"></xo-message>\n\n            <p id =\"paypalSubTitle\" ng-bind-html=\"htmlContent(paypalSubTitle)\"></p>\n        </div>\n\n        <div ng-if=\"!flags.allowChoice && !models.checkoutCart.isWalletTokenization()\">\n            <xo-marketing-offers placement-code=\"'202002'\"\n                                 token=\"token\"\n                                 page-name=\"'HERMES_GUEST_CHECKOUT'\"\n                                 title-txt-property=\"'common.createPayPalSubTitleSignup'\"\n                                 subtitle-property=\"'common.buyerProtectionSignup'\">\n            </xo-marketing-offers>\n        </div>\n\n        <div ng-if=\"models.checkoutCart.isWalletTokenization()\">\n            <h2 class=\"sectionTitle\">{{content('signup.loginDetails')}}</h2>\n        </div>\n        <div class=\"signupFieldGroup\">\n\n            <div class=\"row-fluid radioButton\" ng-if=\"flags.allowChoice\"\n                 ng-class=\"{ 'warning': (validated && singlePagePaymentForm.guestSignup.$error.required) }\">\n                <input track-input=\"Guest_Signup_Yes\" ng-model=\"flags.buyerMode\" type=\"radio\" name=\"guestSignup\" id=\"guestSignup1\"\n                       value=\"signup\" required tabindex=\"0\" aria-describedby=\"guestSignupErrorMessage\"\n                       ng-change=\"actions.setBuyerModeFlags(flags.buyerMode) && actions.triggerTimerForSignupClicked()\" />\n\n                <label class=\"noBottom\" id=\"guestSignup1\" for=\"guestSignup1\" ng-if=\"!contentKeys.yesCreateAccount\">{{ content(guestSignup1)}}</label>\n                <label class=\"noBottom\" for=\"guestSignup1\" ng-if=\"contentKeys.yesCreateAccount\">{{ content(contentKeys.yesCreateAccount) }}</label>\n            </div>\n\n            <xo-signup-options single-page-payment-form=\"singlePagePaymentForm\" validated=\"validated\" flags=\"flags\" is-unbranded=\"isUnbranded\"\n                    onboard=\"onboard\" sepa=\"sepa\"></xo-signup-options>\n\n        </div>\n\n        <div class=\"row-fluid radioButton\"\n             ng-class=\"{ 'warning': (validated && singlePagePaymentForm.guestSignup.$error.required) }\" ng-if=\"flags.allowChoice\">\n            <input track-input=\"Guest_Signup_No\" ng-model=\"flags.buyerMode\" ng-change=\"actions.setBuyerModeFlags(flags.buyerMode)\" type=\"radio\" name=\"guestSignup\" id=\"guestSignup2\" value=\"guest\"\n                   required tabindex=\"0\" aria-describedby=\"guestSignupErrorMessage\" />\n            <label class=\"noBottom\" id=\"guestSignup2\" for=\"guestSignup2\">{{ content('common.noCreateAccount') || content(guestSignup2) }}</label>\n        </div>\n\n        <xo-guest-options single-page-payment-form=\"singlePagePaymentForm\" validated=\"validated\"  flags=\"flags\"\n                          onboard=\"onboard\" sepa=\"sepa\"></xo-guest-options>\n    </div>\n\n    <div ng-if=\"mode === 'guestonly'\">\n        <xo-guest-options single-page-payment-form=\"singlePagePaymentForm\" validated=\"validated\"  flags=\"flags\"\n                          onboard=\"onboard\" sepa=\"sepa\"></xo-guest-options>\n    </div>\n\n    <div ng-if=\"flags.show_poma_ui\" class=\"pomaFieldsContainer\" id=\"pomaContainer\">\n        <div class=\"pomaBgImg cardIcon VISA\">&nbsp;</div>\n\n        <div ng-switch on=\"POMAContentType\">\n            <div ng-switch-when=\"TREATMENT_B\">\n                <h2 class=\"alpha\">{{content('poma.headingB')}}</h2>\n                <div>\n                    <p class=\"subTitle\">{{content('poma.para1B')}}</p>\n                    <p class=\"subTitle\">{{content('poma.para2B')}}</p>\n                </div>\n                <div class=\"checkbox saveMyInfoBoxB\">\n                    <input track-input=\"POMA_CHECKBOX\" ng-model=\"saveMyInfo\" type=\"checkbox\" name=\"saveMyInfo\" id=\"saveMyInfo\" ng-click=\"actions.onCheckedSavedMyInfo($event)\"/>\n                    <label for=\"saveMyInfo\">{{content('poma.saveMyInfoCheckBoxB')}}</label>\n                </div>\n                <div ng-if=\"saveMyInfo\">\n                    <p class=\"legal\" id=\"pomaLegalterms\" ng-bind-html=\"htmlContent('poma.legalTerms', {country:locale.country, lang:locale.lang})\"></p>\n                </div>\n            </div>\n            <div ng-switch-default>\n                <h2 class=\"alpha\">{{content('poma.heading')}}</h2>\n                <div>\n                    <p class=\"subTitle\">{{content('poma.para1')}}</p>\n                    <p class=\"hfast noMarginBottom\">{{content('poma.para2')}}</p>\n                    <ul class=\"hfast fastList\">\n                        <li>{{content('poma.para2Bullet1')}}</li>\n                        <li>{{content('poma.para2Bullet2')}}</li>\n                    </ul>\n                    <p class=\"subTitle\">{{content('poma.para3')}}</p>\n                    <p class=\"subTitle\">{{content('poma.para4')}}</p>\n                </div>\n                <div class=\"checkbox saveMyInfoBox\">\n                    <input track-input=\"POMA_CHECKBOX\" ng-model=\"saveMyInfo\" type=\"checkbox\" name=\"saveMyInfo\" id=\"saveMyInfo\" ng-click=\"actions.onCheckedSavedMyInfo($event)\"/>\n                    <label for=\"saveMyInfo\">{{content('poma.saveMyInfoCheckBox')}}</label>\n                </div>\n                <div ng-if=\"saveMyInfo\">\n                    <p class=\"legal\" id=\"pomaLegalterms\" ng-bind-html=\"htmlContent('poma.legalTerms', {country:locale.country, lang:locale.lang})\"></p>\n                </div>\n            </div>\n        </div>\n\n    </div>\n\n    <p class=\"billingTxt secondary legal\" ng-if=\"showBAContent && !isRP\">\n        <span id=\"billingAgreement\" data-ng-bind-html=\"htmlContent(baContentKey, {merchantName: merchant, country: locale.country, lang: locale.lang})\"></span>\n    </p>\n\n    <p class=\"billingTxt secondary legal\" ng-if=\"showBAContent && isRP\">\n        <span id=\"rpAgreement\" data-ng-bind-html=\"htmlContent(rpContentKey, {merchantName: merchant, country: locale.country, lang: locale.lang})\"></span>\n    </p>\n</div>\n"

/***/ }),

/***/ "./components/xo-guest-components/src/guest/currencyConversion/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _index = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	__webpack_require__("./components/xo-guest-components/src/guest/currencyConversion/styles.less");
	
	var _template = __webpack_require__("./components/xo-guest-components/src/guest/currencyConversion/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoCurrencyConversionLightbox', {
	    tag: 'xo-currency-conversion-lightbox',
	    template: _template2['default'],
	
	    props: {
	        isPrePlan: {
	            type: 'str'
	        },
	        parentModel: {
	            type: 'var'
	        },
	        token: {
	            type: 'var'
	        },
	        doneFn: {
	            type: 'var'
	        }
	    },
	
	    resolve: {
	        models: function models() {
	            this.isPrePlanVal = true;
	            if (!this.props.isPrePlan || this.props.isPrePlan !== 'true') {
	                this.isPrePlanVal = false;
	            }
	            return {
	                checkoutSession: this.props.isPrePlan ? undefined : _index.$CheckoutSessionModel.instance(this.props.token).retrieve(),
	                checkoutCart: _index.$CheckoutCartModel.instance(this.props.token).retrieve()
	            };
	        }
	    },
	
	    actions: {
	        onSubmit: function onSubmit() {
	            var _this = this;
	
	            if (!this.models.ppconversion) {
	                this.message = {
	                    msgKeys: ['currencyOptions.noneSelected'],
	                    type: 'error'
	                };
	                return;
	            }
	
	            _logger.$logger.info('checkout_fpti', { from: 'CURRENCY_CONVERSION', to: 'process_currency_conversion' });
	
	            if (this.parentModel) {
	                this.parentModel.onboard.card.ppconversion = this.models.ppconversion;
	            }
	
	            /*
	             * This check cuts off flow to the updateConversion service call in postPlanUpdateConversionVendor function for:
	             * 1. Pre-Planning (Non-Visa DCC) for both PAYPAL and VENDOR selections, since service call done on createXO
	             * 2. Post-Plan (Visa DCC) PAYPAL selection, since no updateConversion call needed.
	             * Only will allow Post-Plan (Visa DCC) VENDOR selection to go through to updateConversion call below.
	             */
	            if (this.isPrePlanVal || this.models.ppconversion === 'PAYPAL') {
	                var dccType = this.isPrePlanVal ? 'nonvisa_dcc' : 'visa_dcc';
	                var toState = 'process_' + this.models.ppconversion.toLowerCase() + '_conversion_' + dccType;
	                _logger.$logger.info('checkout_fpti', { from: 'CURRENCY_CONVERSION', to: toState });
	
	                this.closeModal();
	                return;
	            }
	
	            var payload = {
	                conversionType: this.models.ppconversion,
	                planId: this.models.checkoutSession && this.models.checkoutSession.plan.id
	            };
	
	            var postPlanUpdateConversionVendor = function postPlanUpdateConversionVendor(_payload) {
	                if (_payload.planId) {
	                    _this.models.checkoutSession.fundingOptions.action('updateConversion', {
	
	                        data: _payload,
	
	                        success: function success(result) {
	                            _logger.$logger.info('checkout_fpti', { from: 'CURRENCY_CONVERSION', to: 'process_vendor_conversion_visa_dcc' });
	                            _this.closeModal();
	                        },
	                        error: function error() {
	                            _this.message = {
	                                msgKeys: ['genericError.genericError'],
	                                type: 'error'
	                            };
	                            return;
	                        },
	                        contingency: function contingency() {
	                            _this.message = {
	                                msgKeys: ['genericError.genericError'],
	                                type: 'error'
	                            };
	                            return;
	                        }
	                    });
	                }
	            };
	
	            // Post-Plan Visa DCC call to update slection to VENDOR
	            postPlanUpdateConversionVendor(payload);
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var _this2 = this;
	
	            _logger.$logger.info('checkout_fpti', { from: 'CURRENCY_CONVERSION', to: 'prepare_currency_conversion' });
	
	            this.continueButton = _squid.$locale.content.get('common.payLabel');
	            this.conversionOptions = {
	                PAYPAL: 'PAYPAL',
	                VENDOR: 'VENDOR'
	            };
	
	            this.locale = _squid.$locale;
	
	            this.closeModal = function (event) {
	                if (event) {
	                    event.preventDefault();
	                }
	
	                var onComplete = _squid.$util.once(function () {
	                    _logger.$logger.info('close_currency_conversion_lightbox');
	                    return _this2.isPrePlanVal ? _this2.props.doneFn('close') : _this2.props.doneFn();
	                });
	
	                _this2.modalOpen = false;
	                // Hook css transition completion event 'transitionend' to call onComplete function, guarentees best timing
	                $('#conversionSection .conversion').on('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function (e) {
	                    $(_this2).off(e);
	                    onComplete();
	                });
	                // transitionend event not supported fallback
	                // if browser doesn't support transitionend event callback, we call onComplete after 350ms as fallback
	                (0, _angular.$timeout)(onComplete, 350);
	            };
	
	            // Javascript for interstitial opening
	            (0, _angular.$timeout)(function () {
	                _this2.modalOpen = true;
	            });
	        },
	        populate: function populate() {
	            var unformattedAmount = this.models.checkoutCart.get('purchase.amounts.total.amount');
	            var merchantCurrencyCode = this.models.checkoutCart.get('purchase.amounts.total.currency_code');
	            this.metadata = angular.copy(_squid.$locale.metadata);
	            this.dccPPRate = this.metadata && this.metadata.localization && this.metadata.localization.isEMEA3PLCountry ? 'currencyOptions.dccPPRate3PL' : 'currencyOptions.dccPPRate';
	            this.merchantTotal = (0, _squid.formatCurrency)(unformattedAmount, merchantCurrencyCode, false);
	            if (this.models.checkoutSession) {
	                // Post-Plan Case, Visa
	                this.conversion = this.models.checkoutSession.plan.conversion;
	                this.paypalConversionTotal = this.models.checkoutSession.get('plan.sources.0.amount.amount_formatted_currency');
	            } else {
	                // Pre-Plan Case, Non-Visa
	                this.conversion = this.parentModel.onboard.card.currencyConvData;
	                var convertedTotal = this.conversion.payment_amt;
	                this.paypalConversionTotal = (0, _squid.formatCurrency)(convertedTotal.value, convertedTotal.currency, false);
	            }
	
	            if (!this.conversion.formattedFromStr || !this.conversion.formattedToStr) {
	                this.conversion.formattedFromStr = truncateCurrencyConversionStr(this.conversion.from, this.conversion.from_amount);
	                this.conversion.formattedToStr = truncateCurrencyConversionStr(this.conversion.to, this.conversion.to_amount);
	            }
	
	            if (this.parentModel) {
	                this.models.ppconversion = this.parentModel.onboard.card.ppconversion ? this.parentModel.onboard.card.ppconversion : 'PAYPAL';
	            }
	        }
	    }
	});
	
	/* @params
	    * fullStr: The full formatted currency conversion string returned from downstream service.
	    * amtStr: Just the currency conversion amount portion of the full string returned from downstream.
	    */
	
	function truncateCurrencyConversionStr(fullStr, amtStr) {
	    try {
	        var fixedPrecision = Number(amtStr).toFixed(4);
	        var formattedStr = fullStr.replace(amtStr, fixedPrecision);
	        if (fixedPrecision == 0) {
	            // eslint-disable-line
	            throw new Error('Currency conversion truncation error encountered, defaulting to full unformatted currencyConversion string.');
	        }
	        return formattedStr;
	    } catch (e) {
	        _logger.$logger.warn('currency_conversion_error', {
	            reason: 'Error formatting currency conversion data to formatted str in guest/currencyConversion/directive',
	            error: e
	        });
	        return fullStr;
	    }
	}
	
	_squid.$Component;
	
	_squid.$locale;
	
	_squid.formatCurrency;
	
	_squid.$util;
	
	_logger.$logger;
	
	_index.$CheckoutSessionModel;
	
	_index.$CheckoutCartModel;
	
	_angular.$timeout;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "./components/xo-guest-components/src/guest/currencyConversion/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-guest-components/src/guest/currencyConversion/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-guest-components/src/guest/currencyConversion/styles.less":
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "blockquote,body,code,dd,div,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,html,input,legend,li,ol,p,pre,td,textarea,th,ul{margin:0;padding:0}table{border-collapse:collapse;border-spacing:0}fieldset,img{border:0}address,caption,cite,code,dfn,em,strong,th,var{font-style:normal;font-weight:400}ol,ul{list-style:none}caption,th{text-align:left}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:400}q:after,q:before{content:\"\"}abbr,acronym{border:0;font-variant:normal}sup{vertical-align:text-top}sub{vertical-align:text-bottom}input,select,textarea{font-family:inherit;font-size:inherit;font-weight:inherit;font-size:100%}legend{color:#000}body{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:95%;color:#2c2e2f;line-height:1.35em}h1{font-size:138.5%}h2{font-size:123.1%}h3{font-size:108%}h1,h2,h3{margin:1em 0}h1,h2,h3,h4,h5,h6,strong{font-weight:700}a{color:#0070ba}abbr,acronym{border-bottom:1px dotted #000;cursor:help}em{font-style:italic}blockquote,dl,ol,ul{margin:1em}dl,ol,ul{margin-left:2em}ol{list-style:decimal outside}ul{list-style:disc outside}dl dd{margin-left:1em}td,th{border:1px solid #000;padding:.5em}th{font-weight:700;text-align:center}input{margin-bottom:10px}caption{margin-bottom:.5em;text-align:center}fieldset,legend,p,pre,table{margin-bottom:1em}input[type=password],input[type=text],textarea{width:12.25em;*width:11.9em}.row-fluid{width:100%;*zoom:1}.row-fluid:after,.row-fluid:before{display:table;content:\"\"}.row-fluid:after{clear:both}.row-fluid>[class*=span]{float:left;margin-left:4.12765957%}.row-fluid>[class*=span]:first-child{margin-left:0}.row-fluid>.span24{width:99.99999998%}.row-fluid>.span23{width:95.74468083%}.row-fluid>.span22{width:91.48936168%}.row-fluid>.span21{width:87.23404253%}.row-fluid>.span20{width:82.97872339%}.row-fluid>.span19{width:78.72340424%}.row-fluid>.span18{width:74.46808509%}.row-fluid>.span17{width:70.21276594%}.row-fluid>.span16{width:65.95744679%}.row-fluid>.span15{width:61.70212765%}.row-fluid>.span14{width:54.4468085%}.row-fluid>.span13{width:53.19148935%}.row-fluid>.span12{width:48.9361702%}.row-fluid>.span11{width:44.68085105%}.row-fluid>.span10{width:40.42553191%}.row-fluid>.span9{width:36.17021276%}.row-fluid>.span8{width:31.91489361%}.row-fluid>.span7{width:27.65957446%}.row-fluid>.span6{width:23.40425531%}.row-fluid>.span5{width:19.14893617%}.row-fluid>.span4{width:14.89361702%}.row-fluid>.span3{width:10.63829787%}.row-fluid>.span2{width:6.38297872%}.row-fluid>.span1{width:2.12765957%}.container-fluid{padding-left:20px;padding-right:20px;*zoom:1}.container-fluid:after,.container-fluid:before{display:table;content:\"\"}.container-fluid:after{clear:both}.mt10,.mt15{margin-top:10px}.pt10{padding-top:10px}.pt15{padding-top:15px}.mb10{margin-bottom:10px}.mb15{margin-bottom:15px}.pb10{padding-bottom:10px}.pb15{padding-bottom:15px}.ml10{margin-left:10px}.ml15{margin-left:15px}.pl10{padding-left:10px}.pl15{padding-left:15px}.mr10{margin-right:10px}.mr15{margin-right:15px}.pr10{padding-right:10px}.pr15{padding-right:15px}.btn{height:44px;margin-bottom:0;border:1px solid #0070ba;border-radius:5px;*margin-left:.3em;display:inline-block;*display:inline;*zoom:1;background-color:#0070ba;transition:background-color .4s ease-out 0s;font-size:1em;font-weight:700;line-height:42px;color:#fff;text-align:center;vertical-align:middle;cursor:pointer;outline:none;-webkit-font-smoothing:antialiased}.btn .btn-secondary{-webkit-font-smoothing:auto}.btn:focus,.btn:hover{background-color:#005ea6}.btn:focus{text-decoration:underline}.btn.active,.btn:active{background-color:#005ea6;outline:0}.btn.disabled,.btn[disabled]{background-color:#b2d9ea;border-color:#b2d9ea;cursor:default}.btn.firstHalf{float:left}.btn.firstHalf,.btn.secondHalf{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box}.btn.secondHalf{float:right}a.btn:focus,a.btn:hover{color:#fff}.btn:first-child{*margin-left:0}.btn-large{padding:8px 15px;font-size:18px;line-height:normal;border-radius:5px}.btn-small{padding:5px 9px;font-size:11px;line-height:16px}.btn-mini{padding:2px 6px;font-size:11px;line-height:14px}.btn-secondary{border-style:solid;border-color:#e1e7eb;color:#393f44;background-color:#e1e7eb}.btn-secondary:hover{color:#393f44;border-color:#edf2f5;background-color:#edf2f5;text-decoration:none}.btn-secondary:active,.btn-secondary:focus{border-color:#c5ccd1;background-color:#c5ccd1;text-decoration:underline}.btn-secondary.disabled,.btn-secondary[disabled]{color:#393f55}a.btn-secondary:active,a.btn-secondary:focus,a.btn-secondary:hover{color:#393f44;border-color:#c5ccd1;background-color:#c5ccd1}a.btn-secondary.disabled,a.btn-secondary[disabled]{color:#393f55;background-color:#e7edf0}button.btn,input[type=submit].btn{*padding-top:2px;*padding-bottom:2px}button.btn::-moz-focus-inner,input[type=submit].btn::-moz-focus-inner{padding:0;border:0}button.btn.btn-large,input[type=submit].btn.btn-large{*padding-top:7px;*padding-bottom:7px}button.btn.btn-small,input[type=submit].btn.btn-small{*padding-top:3px;*padding-bottom:3px}button.btn.btn-mini,input[type=submit].btn.btn-mini{*padding-top:1px;*padding-bottom:1px}#largeScreenAccountCreation .buttons #backButton,section .buttons #backButton{width:30%}#largeScreenAccountCreation .buttons #proceedButton,section .buttons #proceedButton{width:65%}#largeScreenAccountCreation .buttons #proceedButton-venmoBA,#largeScreenAccountCreation .buttons #proceedButton.full,section .buttons #proceedButton-venmoBA,section .buttons #proceedButton.full{width:100%}.custom-select-container,select.replaced{position:relative}select.replaced{z-index:8;width:100%;height:44px;border:0;line-height:2;opacity:0;filter:alpha(opacity=0)}.custom-select{position:absolute;top:0;left:0;z-index:1;width:100%;transition:border-color .3s ease 0s;border-radius:5px}.custom-select,.custom-select>span{display:block;background-clip:padding-box}.custom-select>span{padding:7px 30px 7px 13px;border:1px solid #ccd0d4;border-radius:5px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:right -7px top -1178px;color:#000;line-height:28px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.disabled .custom-select>span{background-position:right -7px top -6990px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat right 10px center;background-size:16px;color:#c72e2e;border:1px solid #c72e2e}.custom-select span span{display:block;overflow:hidden;height:28px;text-overflow:ellipsis;white-space:nowrap;font-size:1em}.custom-select.active>span{border:1px solid #009cde;outline:0}#task .custom-select{border-radius:5px;background-clip:padding-box}.mobile .dob label{position:static;top:0;left:0}input[type=date]{padding:5px 38px 3px 6px;border:1px solid #ccd0d4;border-radius:5px;background-clip:padding-box;color:#333;background-size:24px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_cart_icons.png\") no-repeat 100% 61%}input[type=date]:focus{border-color:#39f}.showDropdopwnLabels .labelText{float:left;color:#aaa}.showDropdopwnLabels .valueText{float:right;min-width:90px}@media (min-width:0) and (max-width:40em){.showDropdopwnLabels .labelText{display:none}.showDropdopwnLabels .valueText{float:none;min-width:0}}.multiline-select-container{outline:0 none}.multiline-select-container:active .innerContainer,.multiline-select-container:focus .innerContainer{border-color:#009cde}.multiline-select-container.open:active .innerContainer,.multiline-select-container.open:focus .innerContainer{border-color:#ccd0d4}.multiline-select-container option,.multiline-select-container select{position:absolute!important;left:-9999px}.multiline-select-container .custom-select{position:relative}.multiline-select-container .custom-select span span{height:auto;white-space:normal}.multiline-select-container .custom-select>span{background:none}.multiline-select-container.open .custom-select>span{border-radius:5px 5px 0 0;border-bottom-color:#eee}.multiline-select-container .arrow{background-clip:padding-box;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_forms.png\");background-position:left -8px top -1198px;background-repeat:no-repeat;height:10px;position:absolute;width:14px;top:40%;right:12px}.backendError .multiline-select-container .ng-invalid+.custom-select .arrow,.validated .multiline-select-container .ng-invalid+.custom-select .arrow{display:none}.multiline-select-list{position:absolute;list-style:none;margin:0;background-color:#fff;z-index:1000;border-radius:0 0 5px 5px;border-bottom:1px solid #ccd0d4;max-height:200px;overflow:auto;box-shadow:0 -1px 1px 0 #ccc}.multiline-select-list li{padding:10px;border:1px solid;border-color:#eee #ccd0d4;border-top:0 none;cursor:pointer;line-height:1.35em;vertical-align:middle}.multiline-select-list li:active,.multiline-select-list li:focus,.multiline-select-list li:hover{background-color:#e5f5fc;outline:0 none}.multiline-select-list li:first-of-type{border-top:0 none}.multiline-select-list li:last-of-type{border-bottom:0 none}.multiline-select-list:hover li:focus{background-color:#fff}.multiline-select-list:hover li:focus:active,.multiline-select-list:hover li:focus:hover{background-color:#e5f5fc}#midflash,.accessAid{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}body{-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#fff}a{text-decoration:none;-webkit-tap-highlight-color:rgba(0,0,0,.2)}a:focus,a:hover{color:#005ea6;text-decoration:underline;outline:none}a.dashed{text-decoration:none;border-bottom:1px dashed #0070ba;font-size:.9em}[tabindex=\"-1\"]{outline:none}em{font-style:normal;font-weight:700}fieldset{margin:0;padding:0;border:0}fieldset legend{padding-bottom:.5em;font-size:1.5em}section:focus{outline:none}.show-section{display:block}hr.faded{width:100%;height:1px;margin:10px 0;border:0;background-image:-o-linear-gradient(left,transparent,rgba(0,0,0,.75),transparent)}.alpha{font-size:1.5em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin:.5em 0;line-height:1.154em}#loginSection h1.alpha{max-width:240px}.asideAlpha{font-size:1.44em}aside .aside .header.noButtons .walletHeading{text-align:center;line-height:1.05em}.beta{font-size:1.54em;color:#2c2e2f;font-weight:lighter;line-height:1.2em}.gamma{font-size:1.3em}.gamma,.zeta{font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin-bottom:.75em}.zeta{font-size:1.25em}.delta{font-size:1.1em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;margin-bottom:12px;font-weight:400}.vprop-header{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin:10px 0;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.vprop-content,.vprop-header{color:#2c2e2f;font-weight:lighter;line-height:1.2em}.vprop-content{font-size:1em;font-family:HelveticaNeue,helvetica,arial,sans-serif}.vprop-image{margin-top:25px}.eta{font-size:1.1em}.eta,.theta{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400}.theta{font-size:1em}.value-prop-title{color:#2c2e2f;font-size:24px;font-weight:lighter;margin:10px 0}.props{padding:0 0 0 5px;clear:both;text-align:center}.props li,.props p{line-height:1.154em;font-size:.9em;font-weight:400;line-height:1.2em;margin:5px 0}.secondary{color:#6c7378;font-size:.85em}.legal{color:#6c7378;font-size:.75em;line-height:1.154em}.legal a{font-weight:700}.mu{font-size:2.46em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-weight:400;text-shadow:0 1px 0 #fff;color:#0079c1}.noHead{margin-top:0}.noBottom{margin-bottom:0}.showTray #task{overflow:hidden;margin-left:0}#spinner,.hide{display:none}.clearfix,.loading #spinner,.media .img img,html[xmlns] .clearfix{display:block}#billingToggleLink{display:inline-block}.left{float:left}.right{float:right}.center{text-align:center}.outerWrapper{position:relative;border-radius:5px;background-clip:padding-box;background-color:#fff}header{z-index:2}.framed #wrapper,html.framed{border-radius:5px;background-clip:padding-box}html.framed .trayOpen #main{height:585px}html.framed .trayOpen .asideContent{height:495px}body>iframe,body>img{display:none}#wrapper{margin:0 auto;max-width:780px;border:1px solid #e3e3e3;border-radius:5px;overflow-y:visible;outline:none}#wrapper,#wrapper #header{-ms-box-sizing:border-box;box-sizing:border-box;background-clip:padding-box;position:relative;background-color:#fff}#wrapper #header{border-radius:5px 5px 0 0;width:100%;z-index:4;box-shadow:0 0 3px 0}#contents{position:relative;z-index:1}.active #wrapper{visibility:visible;-webkit-animation-duration:.4s;-webkit-animation-timing-function:ease;-webkit-animation-name:slideUp}#logo{margin:22px 0 0 20px}.container{clear:both;padding:20px}.containerNoHead{padding-top:0}.noPaddingBottom{padding-bottom:0}.noPaddingTop{padding-top:0}.subContainer{border-top:1px solid #e3e3e3;padding:20px 0;position:relative}#proceedButton{width:46.4%;-ms-box-sizing:border-box;box-sizing:border-box;float:right}#proceedButton.full{width:100%}#proceedButton:focus{color:#fff}#backButton{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box;float:left}#backButton:focus,#backButton:hover{color:#2c2e2f}.middleName{display:none;float:right}.h2,h2{font-size:1.2em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin-top:0;font-weight:400;color:#0666b3}.clearfix:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}* html .clearfix{height:1%}#sliding-area{overflow:hidden}#main{padding:25px 30px 15px;transition:margin .3s ease-out;width:100%;float:right;-ms-box-sizing:border-box;box-sizing:border-box}.loading #main{background:none}.bmlLoadingMessage,.loginLoadingMessage,.loginProcessing .genericLoadingMessage{display:none}.loginProcessing .loginLoadingMessage{display:block}.full{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;text-decoration:none}.trayInner{padding:20px 0}.disclaimer{font-size:.75em;color:#6c7378}.reviewMsg{margin-top:10px;line-height:1.5}.infoTxt{clear:both;padding-top:10px}.help{color:#a9a9a9}.keyValue label{color:#292929}.frontArrow{position:absolute;display:inline-block;width:9px;height:15px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-196px -177px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.frontArrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.focusableIcon:focus{box-shadow:0 0 1px #6c7378}input[type=button],input[type=submit]{-webkit-appearance:none}.inputField input[disabled=disabled],.inputField input[disabled=disabled]:active,input[disabled=disabled]{background:#f7f9fa;border:1px solid #cbd2d6;color:#6c7378}input::-ms-clear{display:none}input.link:hover{cursor:pointer}input.xsmall{width:2em}input.small{width:3.35em;font-size:1em}input.medium{width:7em}input.large{width:14em}input.xlarge{width:20em}.button-as-link{margin:0;padding:0;border:none;width:auto;font-size:.85em;background:transparent;color:#0070ba;cursor:pointer}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.buttons{margin-top:15px;margin-bottom:15px;overflow:hidden}.inputField{position:relative}.inputField input,.inputField label{display:block;vertical-align:top}.ignoreValidation .inputField.error input,.inputField input,.validated .ignoreValidation .inputField input.backendError,.validated .ignoreValidation .inputField input.ng-invalid{width:100%;height:44px;padding:0 14px;border-radius:5px;background-clip:padding-box;border:1px solid #c5ccd1;color:#000;transition:border-color .3s ease 0s;-ms-box-sizing:border-box;box-sizing:border-box;background:none}.ignoreValidation .inputField.error input::-webkit-input-placeholder,.inputField input::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.backendError::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-webkit-input-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-moz-placeholder,.ignoreValidation .inputField.error input::-moz-placeholder,.inputField input:-moz-placeholder,.inputField input::-moz-placeholder,.validated .ignoreValidation .inputField input.backendError:-moz-placeholder,.validated .ignoreValidation .inputField input.backendError::-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-moz-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-ms-input-placeholder,.inputField input:-ms-input-placeholder,.validated .ignoreValidation .inputField input.backendError:-ms-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-ms-input-placeholder{color:#6c7378}.inputField input:active,.inputField input:focus{border:1px solid #009cde;outline:0}.inputField select{font-size:1.5em;margin-bottom:10px}.custom-select-container select{font-size:15px}.inputField label{position:absolute;top:14px;left:14px;cursor:text;text-align:left;color:#666;font-size:1em}.no-js .dropdown label,.no-js .inputField label{position:static}.fieldGroup .inputField{float:left;padding:0 .5em 0 0}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.inputField.error input::-webkit-input-placeholder,.validated .inputField input.backendError::-webkit-input-placeholder,.validated .inputField input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.inputField.error input:-moz-placeholder,.inputField.error input::-moz-placeholder,.validated .inputField input.backendError:-moz-placeholder,.validated .inputField input.backendError::-moz-placeholder,.validated .inputField input.ng-invalid:-moz-placeholder,.validated .inputField input.ng-invalid::-moz-placeholder{color:#c72e2e}.inputField.error input:-ms-input-placeholder,.validated .inputField input.backendError:-ms-input-placeholder,.validated .inputField input.ng-invalid:-ms-input-placeholder{color:#c72e2e}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}.inputField.valid input{background:#fff url(https://www.paypalobjects.com/images/checkout/hermes/icon_checkmark_wallet_2x.png) no-repeat 98%;background-size:14px}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.creditCardField.valid input{background:#fff}.dropdown.error select,.inputField.error select{border:1px solid #c72e2e}.selectLabel{display:block}input::-webkit-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:1em}input:-moz-placeholder,input::-moz-placeholder{color:#6c7378;opacity:1;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}input:-ms-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.checkbox input[type=checkbox]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.checkbox input[type=checkbox]~label,.checkbox input[type=checkbox]~label.bgImgOnSpan span.bgImg{display:inline-block;position:static;min-height:25px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px 0;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.checkbox input[type=checkbox]~label,.checkbox input[type=checkbox]~label.bgImgOnSpan span.bgImg{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.checkbox input[type=checkbox]~label.bgImgOnSpan span.bgImg{display:block;float:left;width:0;height:25px;margin-left:-35px}.checkbox input[type=checkbox]~label.bgImgOnSpan{background-image:none}.checkbox.error input[type=checkbox]:focus~label,.checkbox.error input[type=checkbox]:focus~label.bgImgOnSpan span.bgImg,.checkbox.error input[type=checkbox]~label,.checkbox.error input[type=checkbox]~label.bgImgOnSpan span.bgImg{background-position:-9px -600px}.checkbox input[type=checkbox]:checked~label,.checkbox input[type=checkbox]:checked~label.bgImgOnSpan span.bgImg{background-position:-9px -400px}.checkbox input[type=checkbox]:focus:checked~label,.checkbox input[type=checkbox]:focus:checked~label.bgImgOnSpan span.bgImg{background-position:-9px -4801px}.checkbox input[type=checkbox]:focus~label,.checkbox input[type=checkbox]:focus~label.bgImgOnSpan span.bgImg{background-position:-9px -4601px}.checkbox input[type=checkbox][disabled=disabled]~label,.checkbox input[type=checkbox][disabled=disabled]~label.bgImgOnSpan span.bgImg{background-position:-9px -800px}.checkbox input[type=checkbox][disabled=disabled]:checked~label,.checkbox input[type=checkbox][disabled=disabled]:checked~label.bgImgOnSpan span.bgImg{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:25px 25px}.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label.bgImgOnSpan span.bgImg,.validated .ignoreValidation input[type=checkbox].ng-invalid~label,.validated .ignoreValidation input[type=checkbox].ng-invalid~label.bgImgOnSpan span.bgImg{background-position:-9px 0}.validated .ignoreValidation .sCheckbox.checkbox input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation .sCheckbox.checkbox input[type=checkbox].ng-invalid:focus~label.bgImgOnSpan span.bgImg,.validated .ignoreValidation .sCheckbox.checkbox input[type=checkbox].ng-invalid~label,.validated .ignoreValidation .sCheckbox.checkbox input[type=checkbox].ng-invalid~label.bgImgOnSpan span.bgImg{background-position:-9px 2600px}.validated input[type=checkbox].ng-invalid~label,.validated input[type=checkbox].ng-invalid~label.bgImgOnSpan span.bgImg{background-position:-9px -600px}.validated input[type=radio].ng-invalid+label,.validated input[type=radio].ng-invalid+label.bgImgOnSpan span.bgImg,.validated input[type=radio].ng-invalid:focus+label,.validated input[type=radio].ng-invalid:focus+label.bgImgOnSpan span.bgImg{background-position:-10px -2200px}.validated .sCheckbox.checkbox input[type=checkbox].ng-invalid~label,.validated .sCheckbox.checkbox input[type=checkbox].ng-invalid~label.bgImgOnSpan span.bgImg{background-position:-9px -3200px}.sCheckbox.checkbox{position:relative}.sCheckbox.checkbox input[type=checkbox]~label,.sCheckbox.checkbox input[type=checkbox]~label.bgImgOnSpan span.bgImg{line-height:19px;padding-left:27px;font-size:.85em;background-position:-9px -2600px}.sCheckbox.checkbox input[type=checkbox]~label.bgImgOnSpan span.bgImg{display:block;float:left;width:0;height:19px;margin-left:-27px}.sCheckbox.checkbox input[type=checkbox]~label.bgImgOnSpan{background-image:none}.sCheckbox.checkbox.error input[type=checkbox]:focus~label,.sCheckbox.checkbox.error input[type=checkbox]:focus~label.bgImgOnSpan span.bgImg,.sCheckbox.checkbox.error input[type=checkbox]~label,.sCheckbox.checkbox.error input[type=checkbox]~label.bgImgOnSpan span.bgImg{background-position:-9px -3200px}.sCheckbox.checkbox input[type=checkbox]:checked~label,.sCheckbox.checkbox input[type=checkbox]:checked~label.bgImgOnSpan span.bgImg{background-position:-9px -3000px}.sCheckbox.checkbox input[type=checkbox]:focus:checked~label,.sCheckbox.checkbox input[type=checkbox]:focus:checked~label.bgImgOnSpan span.bgImg{background-position:-9px -5409px}.sCheckbox.checkbox input[type=checkbox]:focus~label,.sCheckbox.checkbox input[type=checkbox]:focus~label.bgImgOnSpan span.bgImg{background-position:-9px -2800px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]~label,.sCheckbox.checkbox input[type=checkbox][disabled=disabled]~label.bgImgOnSpan span.bgImg{background-position:-9px -3400px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]:checked~label,.sCheckbox.checkbox input[type=checkbox][disabled=disabled]:checked~label.bgImgOnSpan span.bgImg{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:18px 19px}.radioButton input[type=radio]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.radioButton input[type=radio]~label{display:inline-block;min-height:26px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px -1600px;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.radioButton input[type=radio]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.radioButton.error input[type=radio]+label,.radioButton.error input[type=radio]:focus+label{background-position:-9px -2200px}.radioButton.warning input[type=radio]+label,.radioButton.warning input[type=radio]:focus+label{background-position:-9px -7405px}.radioButton input[type=radio]:checked+label{background-position:-9px -2000px}.radioButton input[type=radio]:focus:checked+label{background-position:-9px -6010px}.radioButton input[type=radio]:focus+label{background-position:-9px -1800px}.inputField label.nolap{position:relative;top:auto;left:auto;color:#2c2e2f}.inputField.half{width:48.15%;margin-right:3.7%;padding-right:0}.multistepSignupForm .inputField.half,.singlePagePaymentForm .inputField.half{width:48.7%;margin-right:2.6%;padding-right:0}.inputField.half.issueNo{width:42%;margin-top:15px}.inputField.half.startDate{width:54%;margin-right:10px}#cardIssueInfo .inputField.half.startDate{width:48%;margin-right:0}#cardIssueInfo .inputField.half.issueNo{width:48%;margin-top:0;float:right}#cardIssueInfo .inputField.half.issueNo:before{content:\"\\200C\"}.inputField.half.last-child{margin-right:0}.fieldGroup .inputField.last-child{padding-right:0}.fidobDay{width:30%;float:left}.fidobDay .custom-select>span{border-radius:5px 0 0 5px;border-right:0}.fidobMonth{width:30%;float:left}.fidobMonth .custom-select>span{border-radius:0}.fidobYear{width:40%;float:left}.fidobYear .custom-select>span{border-radius:0 5px 5px 0;border-left:0}.cardDOB{width:100%;clear:both}.dobLabel{top:auto;left:auto;position:relative;display:block;bottom:4px}.dobTXT{margin-top:10px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}}.submitted input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.submitted input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.submitted input.ng-invalid:-moz-placeholder,.submitted input.ng-invalid::-moz-placeholder{color:#c72e2e}.submitted input.ng-invalid:-ms-input-placeholder{color:#c72e2e}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.submitted input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}.merchantHeader{height:90px;margin:0 auto}.merchantHeader .headerWrapper{max-width:780px;margin:0 auto;overflow:hidden;max-height:90px;line-height:90px}.merchantHeader .merchantName{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400;width:575px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block}.merchantHeader img{vertical-align:middle}.paypalHeaderWrapper .logo{float:left;width:112px;height:29px;margin-top:5px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.paypalHeaderWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.paypalHeaderWrapper .span14{padding-bottom:20px;border-bottom:1px solid #dbdbdb}.paypalHeaderWrapper .cartContainer{position:static;line-height:29px}.paypalHeaderWrapper .transctionCartDetails{z-index:2}.paypalHeaderWrapper.paypalCredit .logo{height:35px;background-position:0 -129px}.aside .header{padding:15px;vertical-align:middle;line-height:50px;border-bottom:1px solid #e3e3e3}.aside .header.tall{min-height:65px;line-height:normal;padding:13px 15px 10px;margin-bottom:0}.aside .asideAlpha{padding:0 30px;text-align:center;line-height:1.2em}.aside .walletHeading{text-align:center}.aside .close{top:10px;right:15px;padding:5px;border-radius:3px}.aside .close,.aside .close:before{position:absolute;width:19px;height:19px}.aside .close:before{content:\"\";display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .close:focus:before,.aside .close:hover:before{background-position:-223px -22px}.aside .backArrow{position:absolute;top:10px;left:15px;width:9px;height:18px;padding:5px;border-radius:3px}.aside .backArrow:before{content:\"\";display:inline-block;position:absolute;width:9px;height:18px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -46px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .backArrow:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .backArrow:focus:before,.aside .backArrow:hover:before{background-position:-232px -68px}.aside .addOptions{margin-top:20px}.aside .addOptions h2{float:left;width:70%;margin-bottom:0}.aside .addOptions a{float:right;display:block;line-height:1.9em;font-size:.85em}.aside .subHeader{margin-top:20px}.CYCOPage .paypalHeader.span14,.pageSepaAgreementContingency .paypalHeader.span14,.pageSepaMandate .paypalHeader.span14,.pageSepaMandateContingency .paypalHeader.span14{width:100%}#mobileMerchantHeader{display:none}@media (max-width:41.3125em){.merchantHeader{display:none}.paypalHeaderWrapper{height:65px}.paypalHeaderWrapper .cartContainer{margin-top:10px;margin-bottom:-5px;margin-right:15px}.paypalHeaderWrapper .logo{margin:15px 0 0 30px}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}}@media (max-width:30em) and (min-width:0){.paypalHeaderWrapper .cartContainer{margin-top:15px;margin-bottom:-10px;margin-right:0}.paypalHeaderWrapper .logo{margin:15px 0 0}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}.header{height:55px}.aside .header{height:auto}.aside .close{right:15px}}.footer{max-width:780px;margin:10px auto;font-size:.75em}.cancelUrl{float:left;width:39%}.micaLender{display:none;color:#2c2e2f;clear:both}.footerWrapper table{display:inline;float:left;table-layout:fixed;border:none;width:75%}.footerWrapper td,.footerWrapper th,.footerWrapper tr{border:none;font-weight:400;padding-bottom:0;padding-top:0;text-align:left}.footerWrapper .footerLinks th{color:#6c7378}.footerWrapper .footerLinks th.feedbackLink{color:#0070ba}.footerWrapper .footerLinks .underline th{border-bottom:1px solid #ccc}.footerLinks{margin:0;display:inline-block}.footerLinks a{color:#6c7378}.footerLinks a.feedbackLink{color:#0070ba;margin-left:5px}.footerLinks th,td{border:none}.copyright{display:inline;width:auto;vertical-align:top;color:#6c7378}.secureIcon{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:0 -33px;margin-left:3px;margin-right:3px;margin-top:3px;width:10px;height:12px;vertical-align:top}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.secureIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.poweredBy{float:right;margin-top:-49px}.poweredBy .text{float:left;margin-top:8px;margin-right:8px;font-size:12px;font-weight:400;font-style:italic;color:#6c7378}.footerLinks li{padding:0 12px 0 0;display:inline-block}.footerLinks .last{padding-right:18px;border-right:none}.footer .policyInfoWrapper p{line-height:1.3em}.footer .policyInfoWrapper p a{font-weight:700}.minibrowser .APAC.footer,.minibrowser.AU .footer{position:relative;bottom:0;width:auto}.minibrowser .APAC.footer .policyInfoWrapper,.minibrowser.AU .footer .policyInfoWrapper{padding:0}.minibrowser .cancelUrl{display:none}.minibrowser .footerWrapper{padding:0 10px;float:none;width:95%;margin:0}.minibrowser .footerLinks li{padding:0 5px 0 0}.DE .footerWrapper,.fr.CA .footerWrapper,.fr.FR .footerWrapper{float:none;width:auto}.DE .footerWrapper:after,.fr.CA .footerWrapper:after,.fr.FR .footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.DE .footerLinks,.fr.CA .footerLinks,.fr.FR .footerLinks{float:left;width:70%;text-align:left}.DE .footerLinks li:first-child,.fr.CA .footerLinks li:first-child,.fr.FR .footerLinks li:first-child{padding-left:0}.DE .copyright,.fr.CA .copyright,.fr.FR .copyright{float:right;width:30%;margin:0}.DE .cancelUrl,.fr.CA .cancelUrl,.fr.FR .cancelUrl{float:none;margin:5px 0;width:100%}.APAC .policyInfoWrapper{padding:5px 0 10px;color:#6c7378}.APAC .policyInfoWrapper p.moreInfo{padding:15px 0 20px;float:left;line-height:1.3em}.AU .policyInfoWrapper,.en_AU .policyInfoWrapper{padding:20px 0 10px;color:#6c7378}.AU .policyInfoWrapper p.moreInfo,.en_AU .policyInfoWrapper p.moreInfo{padding:15px 0 20px;border-bottom:1px solid #ccc;float:left}.AU .policyInfoWrapper p.moreCopyRight,.en_AU .policyInfoWrapper p.moreCopyRight{padding:5px 0 0;clear:both}.fr_XC .footerWrapper{float:left;width:70%;text-align:left;padding-left:0;margin-left:-7px}@media (max-width:41.25em){.footer{border-top:1px solid #ccc;padding:5px 20px;margin-top:10px}.footer .policyInfoWrapper{padding:0 10px}.footerWrapper{float:none;width:100%;padding:0;margin:0}.footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.cancelUrl{width:95%;padding:0}.footerLinks{float:left;width:70%;text-align:left}.footerLinks .feedback{display:none}.minibrowser .footerLinks .feedback{display:inline-block}.copyright{width:20%}.cancelUrl{float:none;margin:5px 0}}@media (max-width:30em) and (min-width:0){.footer{margin-top:0;padding:5px 10px}.footer .policyInfoWrapper{padding:0}.cancelUrl,.footerWrapper{padding:0;margin:5px 0;width:100%}.DE .footerLinks,.footerLinks,.fr.FR .footerLinks{width:65%}.DE .footerLinks li,.footerLinks li,.fr.FR .footerLinks li{padding:0;margin-right:10px}.DE .footerLinks li.last,.footerLinks li.last,.fr.FR .footerLinks li.last{margin-right:0}.DE .footerLinks .feedback,.footerLinks .feedback,.fr.FR .footerLinks .feedback{display:none}.copyright,.DE .copyright{width:33%;margin:0}.minibrowser .copyright{margin-right:0;width:30%}.minibrowser .footerLinks .feedback{display:inline-block}}.modal-open{overflow:hidden}.modal-open #contents,.modal-open #wrapper,.modal-open .outerWrapper{position:static}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:140;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop,.modal-backdrop.fade.in{opacity:.54}.modal{display:none;overflow:auto;overflow-y:scroll;position:fixed;top:0;right:0;bottom:0;left:0;z-index:150}.modal.fade .modal-wrap{-webkit-transform:translateY(-25%);transform:translateY(-25%);transition:transform .3s ease-out}.modal.fade.in .modal-wrap{-webkit-transform:translate(0);transform:translate(0)}.modal-wrap{position:relative;margin:10px;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.3);border-radius:6px;background-clip:padding-box;box-shadow:0 3px 9px rgba(0,0,0,.3);outline:none}.modal-header{padding:9px 15px;border-bottom:1px solid #eee}.modal-header .close{margin-top:2px}.modal-header h3{margin:0;line-height:30px}.modal-body{position:relative;overflow-y:auto;max-height:400px;padding:15px}.modal-footer,.modal-form{margin-bottom:0}.modal-footer{padding:14px 15px 15px;text-align:right;background-color:#f5f5f5;border-top:1px solid #ddd;border-radius:0 0 6px 6px;background-clip:padding-box;box-shadow:inset 0 1px 0 #fff}.modal-footer:after,.modal-footer:before{display:table;content:\"\";line-height:0}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.spinner{height:100%;width:100%;position:absolute;z-index:10}.spinner .spinWrap{width:200px;height:100px;position:absolute;top:50%;left:50%;margin-left:-100px;margin-top:-50px}.spinner .spinnerImage{margin:28px 0 0 -25px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/icon_ot_spin_lock_skinny.png\") no-repeat}.spinner .loader,.spinner .spinnerImage{height:100px;width:100px;position:absolute;top:0;left:50%;opacity:1;filter:alpha(opacity=100)}.spinner .loader{margin:0 0 0 -55px;background-color:transparent;-webkit-animation:rotation .7s infinite linear;animation:rotation .7s infinite linear;border-left:5px solid #cbcbca;border-right:5px solid #cbcbca;border-bottom:5px solid #cbcbca;border-top:5px solid #2380be;border-radius:100%}.spinner .bmlLoadingMessage,.spinner .genericLoadingMessage,.spinner .loginLoadingMessage{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;margin-top:125px;text-align:center;z-index:100}.spinner.preloader{position:fixed;top:0;left:0;z-index:1000;background-color:#fff}@-webkit-keyframes rotation{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(359deg)}}@keyframes rotation{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.aside{min-height:380px}.aside .container{padding:15px}.asideContent{height:100%}.centerText{text-align:center}.fsIcons{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;min-width:32px;width:25px;height:21px;padding-right:5px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.BALANCE .fsIcons,.DELAYED_TRANSFER .fsIcons,.HOLDING .fsIcons{background-position:0 0}.ELO .fsIcons{background-position:0 -479px}.HIPER .fsIcons{background-position:0 -458px}.HIPERCARD .fsIcons{background-position:0 -500px}.pinlessGlyphIcon{display:inline-block;position:relative;top:-5px;left:-8px;width:32px;height:20px;font-size:3.1rem;padding-right:5px}.BANK .fsIcons,.BANK_ACCOUNT .fsIcons,.IACH .fsIcons{background-position:0 -252px;height:19px;left:19px}.ECHECK .fsIcons,.ELV .fsIcons,.TAB.DELAYED_TRANSFER .fsIcons{background-position:0 -252px;height:19px}.TAB.DELAYED_TRANSFER .fsIcons{left:19px}.BILL_ME_LATER .fsIcons,.BML .fsIcons,.CREDIT_OPTION .fsIcons,.PPCREDIT .fsIcons{background-position:0 -105px}.PAYPAL_SMART_CONNECT .fsIcons{background-position:0 0}.VISA .fsIcons{background-position:0 -21px}.MASTERCARD .fsIcons{background-position:0 -42px}.AMEX .fsIcons{background-position:0 -63px;left:19px;height:20px}.DISC .fsIcons,.DISCOVER .fsIcons{background-position:0 -84px}.JCB .fsIcons{background-position:0 -353px}.CHINA_UNION_PAY .fsIcons{background-position:0 -563px}.ELECTRON .fsIcons{background-position:0 -146px}.MAESTRO .fsIcons,.MSTRO .fsIcons,.SWITCH .fsIcons{background-position:0 -168px}.CB_NATIONALE .fsIcons,.CBN .fsIcons{background-position:0 -210px}.CELEM .fsIcons,.CETELEM .fsIcons{background-position:0 -311px}.COFINOGA .fsIcons,.CONF .fsIcons{background-position:0 -231px}.COFID .fsIcons,.COFIDIS .fsIcons{background-position:0 -437px;left:20px}.INCENTIVE .fsIcons{background-position:0 -271px;height:18px}.PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -374px}.PPSMTCONNECT .fsIcons{background-position:0 0}.ES .PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -521px}.fsIcon{display:block;position:absolute;width:25px;height:21px;left:15px;top:20px;min-width:32px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;background-position:0 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.fsIcon.BANK,.fsIcon.PAD{background-position:6px -252px;height:19px;left:19px}.fsIcon.MASTER,.fsIcon.MASTERCARD,.fsIcon.MCARD{background-position:0 -42px}.fsIcon.ELO{background-position:0 -479px}.fsIcon.HIPER{background-position:0 -458px}.fsIcon.HIPERCARD{background-position:0 -500px}.fsIcon.DISC,.fsIcon.DISCOVER{background-position:0 -84px}.fsIcon.VISA{background-position:0 -21px}.fsIcon.JCB{background-position:0 -353px}.fsIcon.AMEX,.fsIcon.Amex{background-position:6px -63px;left:19px;height:20px}.fsIcon.MAESTRO,.fsIcon.MSTRO,.fsIcon.SWITCH{background-position:0 -168px}.fsIcon.PAYPAL_SMART_CONNECT{background-position:0 0}.fsIcon.CB_NATIONALE,.fsIcon.CBN{background-position:0 -210px}.fsIcon.CELEM,.fsIcon.CETELEM{background-position:0 -311px}.fsIcon.COFID,.fsIcon.COFIDIS{background-position:0 -437px;left:20px;height:20px}.fsIcon.CHINA_UNION_PAY,.fsIcon.CUP{background-position:0 -563px}.fsIcon.COFINOGA,.fsIcon.CONF{background-position:0 -231px}.fsIcon.PAYPAL_EXTRAS_MASTERCARD,.fsIcon.PPXMCARD{background-position:0 -374px}.fsIcon.EBAY_MASTERCARD,.fsIcon.EBAYMCARD{background-position:0 0}.fsIcon.BILL_ME_LATER,.fsIcon .BML,.fsIcon .PPCREDIT{background-position:0 -105px}.fsIcon.PPSMTCONNECT{background-position:0 0}.fsIcon.pinlessIcon{background-image:none;font-size:3.1rem;left:5px;top:14px}.ES .fsIcon.PAYPAL_EXTRAS_MASTERCARD,.ES .fsIcon.PPXMCARD{background-position:0 -521px}.infoIcon{width:19px;height:18px;display:inline-block;position:absolute;top:25px;right:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-89px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.infoIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.addOption{padding:25px 10px;margin:0 0 0 44px;color:#0070ba;font-size:.85em}.plusicon{display:block;position:absolute;left:15px;top:22px;width:20px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.plusicon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.infoIcon+.checkIcon{display:none}.infoMsg{margin:0;overflow:hidden;font-size:.85em}.expiredIcon{background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%;width:16px;height:16px;top:6px}.expiredIcon,.plccIcon{display:inline-block;position:relative}.plccIcon{float:left;height:20px;background:none;width:32px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.fsIcon,.fsIcons{height:20px}}.walletIcons{position:absolute;width:30px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.walletIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons_2x.png\");background-size:90px 970px}}.walletIcons.BANK,.walletIcons.BANK_ACCOUNT{background-position:-50px -460px}.walletIcons.BANK.BOFA,.walletIcons.BANK_ACCOUNT.BOFA{background-position:-50px -10px}.walletIcons.BANK.CHASE,.walletIcons.BANK_ACCOUNT.CHASE{background-position:-50px -130px}.walletIcons.BANK.WELLSFARGO,.walletIcons.BANK_ACCOUNT.WELLSFARGO{background-position:-50px -100px}.walletIcons.BANK.CITI,.walletIcons.BANK_ACCOUNT.CITI{background-position:-50px -40px}.walletIcons.BANK.FIFTHTHIRD,.walletIcons.BANK_ACCOUNT.FIFTHTHIRD{background-position:-50px -220px}.walletIcons.BANK.CAPITAL,.walletIcons.BANK_ACCOUNT.CAPITAL{background-position:-50px -70px}.walletIcons.BANK.AMERITRADE,.walletIcons.BANK_ACCOUNT.AMERITRADE{background-position:-50px -160px}.walletIcons.BANK.SUNTRUST,.walletIcons.BANK_ACCOUNT.SUNTRUST{background-position:-50px -280px}.walletIcons.BANK.USBANK,.walletIcons.BANK_ACCOUNT.USBANK{background-position:-50px -310px}.walletIcons.BANK.USAA,.walletIcons.BANK_ACCOUNT.USAA{background-position:-50px -250px}.walletIcons.CARD.VISA,.walletIcons.PAYMENT_CARD.VISA{background-position:-10px -40px}.walletIcons.CARD.MASTER,.walletIcons.CARD.MASTERCARD,.walletIcons.PAYMENT_CARD.MASTER,.walletIcons.PAYMENT_CARD.MASTERCARD{background-position:-10px -70px}.walletIcons.CARD.DISCOVER,.walletIcons.PAYMENT_CARD.DISCOVER{background-position:-10px -100px}.walletIcons.CARD.AMEX,.walletIcons.PAYMENT_CARD.AMEX{background-position:-10px -130px}hr.sep,hr.sepPlain{padding:0;margin-top:25px;height:auto;border:none;border-top:1px solid #ccc;color:#2c2e2f;text-align:center;overflow:visible}hr.sep:after,hr.sepPlain:after{content:\"or\";display:inline-block;position:relative;top:-.7em;font-size:1em;padding:0 .5em;background:#fff;color:#6c7378;font-weight:400}.de hr.sep:after{content:\"oder\"}.da hr.sep:after{content:\"eller\"}.es hr.sep:after{content:\"o\"}.fr hr.sep:after{content:\"ou\"}.he hr.sep:after{content:\"\\5D0\\5D5\"}.id hr.sep:after{content:\"Atau\"}.it hr.sep:after{content:\"oppure\"}.ja hr.sep:after{content:\"\\307E\\305F\\306F\"}.ko hr.sep:after{content:\"\\B610\\B294\"}.nl hr.sep:after{content:\"of\"}.no hr.sep:after{content:\"eller\"}.pl hr.sep:after{content:\"lub\"}.pt hr.sep:after{content:\"ou\"}.ru hr.sep:after{content:\"\\418\\43B\\438\"}.sv hr.sep:after{content:\"eller\"}.th hr.sep:after{content:\"\\E2B\\E23\\E37\\E2D\"}.tr hr.sep:after{content:\"Veya\"}.zh hr.sep:after{content:\"\\6216\"}hr.sepPlain:after{content:\"\"}@media (min-width:0) and (max-width:23em){#loginSection .xoTitle h1{max-width:10em}}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){body{-webkit-text-size-adjust:100%}.merchantBrand{display:none}.outerWrapper{background-position:left 50px}.centerTray.loginSignup{margin-bottom:60px}#main{padding:0;background:none;z-index:2}#contents{padding:0 20px;-ms-box-sizing:border-box;box-sizing:border-box}.tokenization #contents{padding:0 30px}.paypalHeader{padding:0 20px 20px;-ms-box-sizing:border-box;box-sizing:border-box}.props,header{display:none}.review #wrapper{min-height:512px}#contents{min-height:0;margin-bottom:0}.bmlAppProcessing,.loginProcessing{background-color:#f9f9f9}.loggingIn{margin:0 25px}.mobile .loggingIn{margin:0}.saferEasier,.simpler{display:none}#login .row-fluid{padding-top:0}#login .centerTray{padding:0}#login #signupLink.btn{margin:5px 0}#wrapper{margin:0;width:auto;border-radius:0;background-clip:padding-box;border:none}#task{width:295px}.loading .spinner{background-position-y:35%}.centerTray{width:auto}.accountTerms .tray .inner,.tray .inner{padding:10px}.row-fluid>[class*=span],.signup{width:100%;margin-left:0;float:none}#notifications{width:100%}.delta,.gamma{font-size:1.2em}.inputField label{left:7px;top:13px}.saferEasier{display:none}#fundingInstruments .buttons{height:40px}.cityState select{font-size:14px}.cityState .city{width:100%}.cityState .state{width:55%}.cityState .postalCode{width:40.8%}#tab{margin-top:0;height:125px}.toolTip.whatsthis ul{width:242px;left:9px}.toolTip.whatsthis ul li{font-size:.9em}#expiration.varB .expires{width:49%}#expiration .inputField{padding:0}#expiration .cvc{width:44%;float:right}#expiration.varB .cvc{width:49%}.month{margin-left:46px}.separator{margin-left:5px;margin-top:3px}.year{margin-left:0}#expiration .cardIcon{position:absolute;right:4px}.details{margin-right:2px}.mask #closeButton,.mask #header{display:none}}@media (min-width:30.0625em) and (max-width:41.25em){#notifications,.row-fluid>.span10,.row-fluid>.span12,.row-fluid>.span14{width:100%}.outerWrapper{background-position:left 59px}.props,header{display:none}#wrapper{margin:0;border:none}#main{padding:0}#contents{padding:0 25px}}@media (min-width:41.3125em){.banner{display:block}#wrapper{min-height:0}#wrapper,.footer,.merchantHeader{width:95%}.largeScreen .centerTray{margin-top:0}.signup{margin-bottom:0}#genericError{min-height:375px;background:url(https://www.paypalobjects.com/images/checkout/hermes/scr_cloud_balloon.png) no-repeat bottom}#transactionDetails .merchantName{display:none}}@media (device-height:568px) and (-webkit-min-device-pixel-ratio:2){#contents{min-height:0;margin-bottom:0}.pageLanding #contents{margin:70px auto 40px 0}}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.cardType{display:none}ul.validations li.restriction.active{background:url(https://www.paypalobjects.com/images/checkout/hermes/close3_2x.png) no-repeat 0 2px;background-size:10px}.inputField.error input{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.inputField.error input,.inputField.valid input{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.error .custom-select.active>span,.error .custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}@media only screen and (-webkit-min-device-pixel-ratio:2) and (min-width:41.3125em){#genericError{background-size:640px 242px}}#currencyConversion .modal{position:fixed;top:0;bottom:0;left:0;right:0;z-index:10}#currencyConversion .modalWrapperAnimation{transition:transform .3s ease-out}.conversionoptions{list-style:none;margin:0}.conversionoptions p{margin:0;padding:0}.conversionoptions .dccDetails{font-size:13px;margin-top:8px}.conversionoptions .dccDetails,.conversionoptions .spread{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;line-height:1.3}.conversionoptions .spread{font-size:11px}.conversionoptions .merchantPrice{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:13px;line-height:1.3;margin-top:20px;margin-bottom:20px}.conversionoptions label{font-weight:700;padding-top:2px}.conversionoptions ul{margin:0 0 0 30px;overflow-y:hidden}.conversionoptions .conversion{margin:0 0 4px 35px}.conversionoptions input[name=ppconversion]{margin-bottom:5px;margin-right:5px;vertical-align:middle}.conversionoptions .conversionCC{margin-top:20px}.conversionoptions li{margin-bottom:5px;margin-left:5px;font-size:.92em}.conversionoptions .radioButton input[type=radio]~label{line-height:1.35em}.conversionoptions li:last-child .radioButton{margin:5px 0}.conversionoptions .margin{padding-top:10px}.conversionoptions li ul{list-style-type:none}.currencyConversion{overflow-y:auto;overflow-x:hidden;height:470px}#conversionSection .modalMask,#conversionSection .modalWrapper{position:fixed;top:0;bottom:0;left:0;right:0;z-index:10}#conversionSection .close{position:absolute;top:20px;right:20px;width:19px;height:10px;padding:5px;border-radius:3px}#conversionSection .close:before{content:\"\";position:absolute;width:19px;height:19px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#conversionSection .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#conversionSection .close:focus:before,#conversionSection .close:hover:before{background-position:-223px -22px}#conversionSection .modalMask{background:#cbd2d6;opacity:.7}#conversionSection .modalWrapperAnimation{transition:transform .3s ease-out}#conversionSection .modalWrapper{background:#fff;width:620px;-ms-box-sizing:border-box;box-sizing:border-box;left:50%;padding:80px 120px 0;overflow:auto;border-radius:5px;background-clip:padding-box;-webkit-transform:translate(-50%,100%);transform:translate(-50%,100%)}#conversionSection .modalWrapper .logo{position:relative;margin-top:-60px;left:170px;width:25px;height:30px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#conversionSection .modalWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#conversionSection .modalContainer{min-height:99%;width:380px;display:block}#conversionSection .modalContainer .pushlogo{height:90px}#conversionSection .processing input{background-color:#f2f3f4}#conversionSection .modalOpen .modalWrapper{-webkit-transform:translate(-50%);transform:translate(-50%)}#conversionSection .modalClose .modalWrapper{-webkit-transform:translate(-50%,100%);transform:translate(-50%,100%)}#conversionSection .heading{margin:5px 0 10px;font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){#conversionSection .modalWrapper{width:100%;padding:60px 15px 0}#conversionSection .modalWrapper .modalContainer{width:auto}}", ""]);
	
	// exports


/***/ }),

/***/ "./components/xo-guest-components/src/guest/currencyConversion/template.html":
/***/ (function(module, exports) {

	module.exports = "<section id=\"conversionSection\">\n    <div class=\"conversion\" ng-class=\"{modalClose: !modalOpen, modalOpen: modalOpen}\">\n        <div class=\"modalMask\"></div>\n        <div class=\"modalWrapper modalWrapperAnimation\" modal-box modal-cancel=\"closeModal()\">\n            <div class=\"modalContainer\" content tabindex=\"-1\">\n                <a link-button class=\"close focusableIcon\" href=\"#/checkout/guest\" ng-click=\"closeModal($event)\"></a>\n                <xo-message message=\"message\"></xo-message>\n\n                <form method=\"post\" class=\"curr_conv asideProceed formSmall\" novalidate=\"novalidate\" ng-submit=\"actions.onSubmit()\" content>\n\n                    <div class=\"heading\">{{ content('currencyOptions.dccTitle') }}</div>\n\n                    <ul class=\"conversionoptions\">\n                        <p class=\"merchantPrice\" ng-bind-html=\"htmlContent('currencyOptions.merchPrice', {transactionTotal: merchantTotal})\"></p>\n                        <li>\n                            <div class=\"radioButton\">\n                                <input type=\"radio\" ng-model=\"models.ppconversion\" name=\"ppconversion\" id=\"conversionPayPal\" value=\"{{conversionOptions.PAYPAL}}\" tabindex=\"0\"/>\n                                <label for=\"conversionPayPal\">{{ content('currencyOptions.dccPPDesc') }}</label>\n                            </div>\n                            <ul>\n                                <li class=\"dccDetails\" ng-bind-html=\"htmlContent('currencyOptions.dccPPExchange', {currencyFrom: conversion.formattedFromStr, currencyTo: conversion.formattedToStr})\"></li>\n                                <li class=\"spread\" ng-bind-html=\"htmlContent(dccPPRate, {rate: conversion.spread})\"></li>\n                                <li class=\"ppConversionTotal\" ng-bind-html=\"htmlContent('currencyOptions.dccPPTotal', {total: paypalConversionTotal})\"></li>\n                            </ul>\n                        </li>\n                        <div class=\"margin\"></div>\n                        <li>\n                            <div class=\"radioButton\">\n                                <input type=\"radio\" ng-model=\"models.ppconversion\" name=\"ppconversion\" id=\"conversionVendor\" value=\"{{conversionOptions.VENDOR}}\" tabindex=\"0\"/>\n                                <label for=\"conversionVendor\">{{content('currencyOptions.dccVendorDesc')}}</label>\n                            </div>\n                            <ul>\n                                <li class=\"dccDetails\" ng-bind-html=\"htmlContent('currencyOptions.dccVendorExchange')\"></li>\n                                <li ng-bind-html=\"htmlContent('currencyOptions.dccVendorTotal')\"></li>\n                            </ul>\n                        </li>\n                    </ul>\n\n                    <div class=\"buttons\">\n                        <input id=\"proceedButton\" type=\"submit\" value=\"{{continueButton}}\" class=\"btn full\">\n                    </div>\n\n                </form>\n                <div class=\"pushlogo\"></div>\n            </div>\n            <div class=\"logo\"></div>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "./components/xo-guest-components/src/guest/select-shipping-method/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	
	exports.__esModule = true;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _index = __webpack_require__("./components/squid/dist/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _errorHandlerHelper = __webpack_require__("./components/xo-guest-components/src/guest/lib/errorHandlerHelper.js");
	
	var errorHandlerHelper = _interopRequireWildcard(_errorHandlerHelper);
	
	var _index2 = __webpack_require__("./components/xo-models/src/shippingMethod/index.js");
	
	var _index3 = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _template = __webpack_require__("./components/xo-guest-components/src/guest/select-shipping-method/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js");
	
	__webpack_require__("./components/xo-guest-components/src/guest/select-shipping-method/shipping-method-dropdown/directive.js");
	
	__webpack_require__("./components/xo-guest-components/src/guest/select-shipping-method/styles.less");
	
	var _util = __webpack_require__("./components/xo-guest-components/src/lib/util.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	exports['default'] = _index.$Component.extend('$xoGuestSelectShippingMethodDirective', {
	    tag: 'xo-guest-select-shipping-method',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            type: 'var',
	            required: true
	        },
	        billingAddress: {
	            type: 'var',
	            required: true
	        },
	        shippingAddress: {
	            type: 'var',
	            required: true
	        },
	        isShippingSameAsBilling: {
	            type: 'var',
	            required: true
	        },
	        showShipping: {
	            type: 'var',
	            required: false
	        },
	        buttonParams: {
	            type: 'var',
	            required: true
	        },
	        pageLevelErrorMessage: {
	            type: 'var',
	            required: false
	        },
	        flags: {
	            type: 'var',
	            required: true
	        },
	        trackSntReq: {
	            type: 'var',
	            required: false
	        }
	    },
	
	    resolve: {
	        models: function models() {
	            return {
	                checkoutAppData: _index3.$CheckoutAppDataModel.instance(this.props.token).retrieve(),
	                checkoutCart: _index3.$CheckoutCartModel.instance(this.props.token).retrieve(),
	                checkoutPayee: _index3.$CheckoutPayeeModel.instance(this.props.token).retrieve()
	            };
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var _this = this;
	
	            // Decides whether to show whole section
	            this.showShippingMethodSection = true;
	
	            // Decides whether to show merchant options
	            this.showMerchantOptions = true;
	            this.showZipCode = false;
	            this.zipCode = '';
	
	            // Decides whether to show different DropDown
	            this.isShowShippingMethodsDropDown = false;
	            this.noShippingMethodDropDown = true;
	
	            // Decides whether to show pick up store Text
	            this.isStorePickUp = false;
	
	            // Models
	            this.currencyCode = '';
	
	            this.selectedShippingCharge = '';
	
	            // Initial charges
	            this.charges = [{}];
	
	            // No shipping charges
	            this.noShippingChargesList = this.charges;
	
	            // Hide the additional drop down that is rendered in iOS
	            this.hideSelectDropdown = navigator.appVersion.indexOf('iPhone') !== -1;
	
	            // Models mapped to guest scope component
	            this.billingAddress = this.props.billingAddress;
	            this.shippingAddress = this.props.shippingAddress;
	            this.flags = this.props.flags;
	            this.isShippingSameAsBilling = this.props.isShippingSameAsBilling;
	            this.showShipping = this.props.showShipping;
	            this.trackSntReq = this.props.trackSntReq;
	
	            // Decides on disable/enable of dropdown
	            this.changeShippingMethod = 'changeShippingMethodDisabled';
	            this.selectedShippingMethodText = 'disableShippingMethod';
	            this.dropDownBackground = 'normalBackground';
	
	            // Used for instant update feature
	            this.callbackShippingOptions = [];
	            this.fallbackShippingOptions = [];
	            this.selectedMethod = {};
	            this.callbackInsuranceOffered = false;
	            this.defaultFallbackOptionIndex = 0;
	
	            this.shippingMethodNotSelected = true;
	
	            this.shipAndTaxError = false;
	            this.override = false;
	            this.noErrorOrOverride = true;
	
	            this.triggerFetchShippingMethods = false;
	            this.localeCountry = _index.$locale.country;
	
	            this.trackZipCode = {
	                prev: '',
	                current: ''
	            };
	
	            this.trackState = {
	                prev: '',
	                current: ''
	            };
	
	            var populatePatchAmountDetails = function populatePatchAmountDetails(patchableAmountEntities, constantAmountEntities, decimalDigits, amounts) {
	                var newTotal = _this.buttonCartAmounts.total;
	                Object.keys(patchableAmountEntities).forEach(function (key) {
	                    var detail = patchableAmountEntities[key];
	                    if (!isNaN(detail.value)) {
	                        detail.value = Number(detail.value);
	                        amounts.details[key] = detail.value.toFixed(decimalDigits);
	                    } else {
	                        detail.value = 0;
	                    }
	                    var difference = detail.valueInCart ? detail.value - detail.valueInCart : detail.value;
	                    newTotal += difference;
	                });
	                amounts.total = newTotal.toFixed(decimalDigits);
	                Object.keys(constantAmountEntities).forEach(function (key) {
	                    var detail = constantAmountEntities[key];
	                    if (detail.valueInCart !== undefined) {
	                        amounts.details[key] = detail.valueInCart.toFixed(decimalDigits);
	                    }
	                });
	            };
	
	            var getExternalCallbackOptionsForPatch = function getExternalCallbackOptionsForPatch() {
	                var externalCallbackOptions = _this.models.checkoutCart.getExternalCallbackOptions();
	                if (_this.response.shipping_options_source === 'CALLBACK') {
	                    externalCallbackOptions.callback_shipping_options = _this.callbackShippingOptions;
	                    externalCallbackOptions.callback_insurance_option_offered = _this.callbackInsuranceOffered;
	                } else if (_this.response.shipping_options_source === 'FALLBACK') {
	                    externalCallbackOptions.fallback_shipping_options = _this.fallbackShippingOptions;
	                }
	                return externalCallbackOptions;
	            };
	
	            // Generates the request body to be used for patch Cart
	            var getPatchReqData = function getPatchReqData(shippingAmt, taxAmt, shipMethod, insuranceAmt) {
	                // What will get patched?
	                // 1. amount values in the cart,
	                // 2. shipping method (only in case of non instant update flows)
	                // 3. external_callback_options (only in case of instant update flows)
	
	                var currencyDigits = _index.$locale.metadata && _index.$locale.metadata.currency && _index.$locale.metadata.currency.digits;
	                var decimalDigits = currencyDigits && currencyDigits[_this.currencyCode];
	                if (isNaN(decimalDigits)) {
	                    decimalDigits = 2;
	                }
	                var patchEntities = [];
	                var amounts = {
	                    'currency': _this.currencyCode,
	                    'details': {
	                        'subtotal': _this.buttonCartAmounts.subTotal.toFixed(decimalDigits)
	                    }
	                };
	                var patchableAmountEntities = {
	                    shipping: {
	                        value: shippingAmt,
	                        valueInCart: _this.buttonCartAmounts.shippingAmt
	                    },
	                    tax: {
	                        value: taxAmt,
	                        valueInCart: _this.buttonCartAmounts.taxAmt
	                    },
	                    insurance: {
	                        value: insuranceAmt,
	                        valueInCart: _this.buttonCartAmounts.insuranceAmt
	                    }
	                };
	                // amount details which are not affected by SnT response,
	                // but still need to get included in the patch request if initially present
	                var constantAmountEntities = {
	                    handling_fee: {
	                        valueInCart: _this.buttonCartAmounts.handlingAmt
	                    },
	                    shipping_discount: {
	                        valueInCart: _this.buttonCartAmounts.shippingDiscountAmt
	                    },
	                    discount: {
	                        valueInCart: _this.buttonCartAmounts.discount
	                    }
	                };
	                populatePatchAmountDetails(patchableAmountEntities, constantAmountEntities, decimalDigits, amounts);
	                patchEntities.push({
	                    field: 'purchaseAmount',
	                    value: amounts
	                });
	
	                if (_this.isInstantUpdateFlow) {
	                    patchEntities.push({
	                        field: 'externalCallbackOptions',
	                        value: getExternalCallbackOptionsForPatch()
	                    });
	                } else {
	                    var shippingMethod = '';
	                    if (shipMethod && _this.shippingMethods) {
	                        shippingMethod = _this.shippingMethods.getShippingMethodId(shipMethod);
	                    }
	                    patchEntities.push({
	                        field: 'shippingMethod',
	                        value: shippingMethod
	                    });
	                }
	
	                var patchRequest = {
	                    id: _this.token,
	                    patchEntities: patchEntities
	                };
	                return patchRequest;
	            };
	
	            // Function which will update costs which were patched
	            var updatePreviousCosts = function updatePreviousCosts() {
	                _this.previousCosts = {};
	                if (_this.models.checkoutCart.purchase.amounts.shipping) {
	                    _this.previousCosts.shippingAmount = Number(_this.models.checkoutCart.purchase.amounts.shipping.amount);
	                }
	                if (_this.models.checkoutCart.purchase.amounts.tax) {
	                    _this.previousCosts.taxAmount = Number(_this.models.checkoutCart.purchase.amounts.tax.amount);
	                }
	            };
	
	            // Responsible to patch the cart with shipping, tax (and insurance in case of instant update)
	            var updateShippingTaxCharge = function updateShippingTaxCharge(shippingAmt, taxAmt, shipMethod, insurance) {
	
	                var patchReq = getPatchReqData(shippingAmt, taxAmt, (0, _util.decodeEntities)(shipMethod), insurance);
	                _this.models.checkoutCart.action('patchCartData', {
	                    data: patchReq,
	                    batch: {
	                        name: 'patchCartData',
	                        id: 'checkoutCart'
	                    },
	                    success: function success(result) {
	                        _this.checkoutSession = _index3.$CheckoutSessionModel.instance(_this.token);
	                        updatePreviousCosts();
	                    },
	                    contingencies: {
	                        DEFAULT: function DEFAULT(name, err) {
	                            _logger.$logger.info('patch_cart_failure');
	                            throw err;
	                        }
	                    }
	                });
	            };
	
	            // Checks whether domestic shipping methods are supported for the country or not
	            this.isDomesticShippingMethodsSupported = function () {
	                var country = _this.isShippingSameAsBilling ? _this.billingAddress.country : _this.shippingAddress.country;
	                if (_this.isInstantUpdateFlow) {
	                    // for countries which have no state or zip code in their address templates, SnT must be called based on country change
	                    // which implies isDomesticShippingMethodsSupported would be false
	                    return !(0, _index.$feature)('noZipCodeOrState', false, country);
	                }
	                return (0, _index.$feature)('allowWPSDomesticShippingMethods', false, country);
	            };
	
	            // Sets the zip code whenever user enters the postal code field.
	            this.setZipCode = function () {
	                if (_this.isDomesticShippingMethodsSupported()) {
	                    _this.showZipCode = true;
	                    if (_this.isShippingSameAsBilling) {
	                        _this.zipCode = _this.billingAddress.postal_code;
	                    } else {
	                        _this.zipCode = _this.shippingAddress.postal_code;
	                    }
	                } else {
	                    _this.showZipCode = false;
	                }
	            };
	
	            // Checks whether there was a change in zip code
	            var isZipCodeChange = function isZipCodeChange() {
	                if (_this.trackZipCode.prev && _this.trackZipCode.current) {
	                    return _this.trackZipCode.prev !== _this.trackZipCode.current;
	                }
	                return true;
	            };
	
	            // Checks whether there was a change in state
	            var isStateChange = function isStateChange() {
	                if (_this.trackState.prev && _this.trackState.current) {
	                    return _this.trackState.prev !== _this.trackState.current;
	                }
	                // when the previous and the current state fields are undefined,
	                // isStateChange should return false
	                else if (_this.trackState.prev === undefined && _this.trackState.current === undefined) {
	                        return false;
	                    }
	                return true;
	            };
	
	            // Checks whether there was a change in country
	            var isCountryChange = function isCountryChange() {
	                if (_this.billingAddress.country && _this.localeCountry) {
	                    return _this.billingAddress.country !== _this.localeCountry;
	                }
	                return true;
	            };
	
	            // Util function to help safe convert a value to decimal
	            var safeConvert = function safeConvert(value) {
	                value = Number(value);
	                if (isNaN(value)) {
	                    throw new Error(value + ' cannot be divided');
	                }
	                return value / 100;
	            };
	
	            // Checks whether shipping and tax response has tax in it
	            var responseHasTaxCharges = function responseHasTaxCharges() {
	                if (_this.response.charges.length === 0) {
	                    return false;
	                }
	                return !!_this.response.charges[0].tax;
	            };
	
	            // Checks whether shipping and tax response has shipping charges
	            var responseHasShippingCharges = function responseHasShippingCharges() {
	                if (_this.response.charges.length === 0) {
	                    return false;
	                }
	                return !!_this.response.charges[0].shipping_charge;
	            };
	
	            /*
	             Checks whether patch cart is required or not .
	             Use cases where this is called
	             ------------------------------
	             1. When user selects a shipping method from dropdown.
	             2. User selects store pick Up , wants to change shipping address but shipping address fields are empty ,
	             applicationShippingAmt will be passed as undefined to this function .
	             */
	            var isPatchCartRequired = function isPatchCartRequired(applicableShippingAmt, applicableTaxAmt) {
	                return applicableShippingAmt !== _this.previousCosts.shippingAmount || applicableTaxAmt !== _this.previousCosts.taxAmount;
	            };
	
	            var getTaxFromResponse = function getTaxFromResponse(charge) {
	                var responseCharge = charge || responseHasTaxCharges() && _this.response.charges[0];
	                if (responseCharge && responseCharge.tax) {
	                    if (!_this.buttonCartAmounts.shippingAmt && !_this.showShipping) {
	                        return safeConvert(responseCharge.tax.item_tax.value);
	                    }
	                    return safeConvert(responseCharge.tax.total_tax.value);
	                }
	            };
	
	            // Returns tax amount
	            var getTax = function getTax(charge) {
	                if (_this.isInstantUpdateFlow) {
	                    return getTaxFromResponse(charge);
	                }
	                if ((_this.isBuyNow || _this.isCartUpload) && _this.buttonCartAmounts.taxAmt >= 0) {
	                    return _this.buttonCartAmounts.taxAmt;
	                }
	                return getTaxFromResponse(charge);
	            };
	
	            // Disables the shipping method dropdown
	            var disableDropDown = function disableDropDown() {
	                _this.isShowShippingMethodsDropDown = false;
	                _this.noShippingMethodDropDown = true;
	
	                _this.changeShippingMethod = 'changeShippingMethodDisabled';
	                _this.dropDownBackground = 'normalBackground';
	                _this.selectedShippingMethodText = 'disableShippingMethod';
	
	                var span = $('#noShippingMethod > div > span > span > span');
	                span.html(_index.$locale.content.get('shippingMethod.selectMethod'));
	            };
	
	            // Enable the shipping method dropdown
	            var enableDropDown = function enableDropDown() {
	                _this.isShowShippingMethodsDropDown = true;
	                _this.noShippingMethodDropDown = false;
	                _this.shippingMethodNotSelected = true;
	
	                _this.changeShippingMethod = 'changeShippingMethodEnabled';
	                _this.dropDownBackground = 'normalBackground';
	                _this.selectedShippingMethodText = 'enableShippingMethod';
	            };
	
	            // Enable store pick up to show shipping address
	            var enableStorePickUp = function enableStorePickUp() {
	                _this.flags.hideShippingAddress = true;
	                _this.flags.showSingleAddress = true;
	                _angular.$rootScope.$emit('store_pick_up_selected');
	            };
	
	            // Disable store pick Up
	            var disableStorePickUp = function disableStorePickUp() {
	                _this.flags.hideShippingAddress = false;
	                _this.flags.showSingleAddress = false;
	            };
	
	            // Checks whether zip code is empty or not
	            var isFormZipCodeEmpty = function isFormZipCodeEmpty() {
	                if (_this.isInstantUpdateFlow) {
	                    var zipCodeField = _this.isShippingSameAsBilling ? $('#billingAddress #postalCode')[0] || $('#billingAddress #billingPostalCode')[0] : $('#shippingAddress #postalCode')[0] || $('#shippingAddress #shippingPostalCode')[0];
	                    // The zip code field is not present for some countries.
	                    // isFormZipCodeEmpty() in that case returns false
	                    if (!zipCodeField) {
	                        return false;
	                    }
	                }
	                if (_this.isShippingSameAsBilling) {
	                    return _this.billingAddress && !_this.billingAddress.postal_code;
	                }
	                return _this.shippingAddress && !_this.shippingAddress.postal_code;
	            };
	
	            // Checks whether line1 is emoty or not
	            var isFormAddressLine1Empty = function isFormAddressLine1Empty() {
	                if (_this.isShippingSameAsBilling) {
	                    return _this.billingAddress && !_this.billingAddress.line1;
	                }
	                return _this.shippingAddress && !_this.shippingAddress.line1;
	            };
	
	            // Checks whether state is empty or not
	            var isFormStateEmpty = function isFormStateEmpty() {
	                if (_this.isInstantUpdateFlow) {
	                    var stateField = _this.isShippingSameAsBilling ? $('#billingAddress #state')[0] || $('#billingAddress #billingState')[0] : $('#shippingAddress #state')[0] || $('#shippingAddress #shippingState')[0];
	                    // The state field is not present for some countries.
	                    // isFormStateEmpty() in that case returns false
	                    if (!stateField) {
	                        return false;
	                    }
	                }
	                if (_this.isShippingSameAsBilling) {
	                    return _this.billingAddress && !_this.billingAddress.state;
	                }
	                return _this.shippingAddress && !_this.shippingAddress.state;
	            };
	
	            // Returns the current zip code entered by the user
	            var getCurrentZipCode = function getCurrentZipCode() {
	                if (_this.isShippingSameAsBilling) {
	                    if (_this.billingAddress.postal_code) {
	                        return _this.billingAddress.postal_code;
	                    }
	                }
	                if (_this.shippingAddress.postal_code) {
	                    return _this.shippingAddress.postal_code;
	                }
	            };
	
	            // Returns current state selected by the user
	            var getCurrentState = function getCurrentState() {
	                if (_this.isShippingSameAsBilling) {
	                    if (_this.billingAddress.state) {
	                        return _this.billingAddress.state;
	                    }
	                }
	                if (_this.shippingAddress.state) {
	                    return _this.shippingAddress.state;
	                }
	            };
	
	            var isValidPostalCodeElement = function isValidPostalCodeElement(element) {
	                var isValidBillingPostalCodeElement = (element === 'billingPostalCode' || element === 'postalCode') && _this.isShippingSameAsBilling;
	                var isValidShippingPostalCodeElement = (element === 'shippingPostalCode' || element === 'postalCode') && !_this.isShippingSameAsBilling;
	                return isValidBillingPostalCodeElement || isValidShippingPostalCodeElement;
	            };
	
	            // Function which patches the cart with button parameters
	            var patchCartWithButtonParams = function patchCartWithButtonParams() {
	                if (!_this.buttonCartAmounts) {
	                    return;
	                }
	                var shippingAmt = _this.buttonCartAmounts.shippingAmt,
	                    taxAmt = _this.buttonCartAmounts.taxAmt;
	                if (isPatchCartRequired(shippingAmt, taxAmt)) {
	                    updateShippingTaxCharge(shippingAmt, taxAmt, 'DEFAULT');
	                }
	            };
	
	            // Listener to fetch adapted shipping methods when locale changes
	            var localeChange = _angular.$rootScope.$on('localeChange', function (event) {
	                _this.localeCountry = _index.$locale.country;
	                if (!isCountryChange()) {
	                    disableDropDown();
	                    _this.fetchShippingMethods();
	                }
	            });
	
	            _angular.$rootScope.$on('$destroy', localeChange);
	
	            // Listener which is responsible to patch Cart with button params if shipping address fields are empty
	            var changeInShippingAddress = _angular.$rootScope.$on('change_in_shipping_address', function (event) {
	                if (isFormZipCodeEmpty() || isFormStateEmpty()) {
	                    disableDropDown();
	                    _this.isStorePickUp = false;
	                    patchCartWithButtonParams();
	                }
	            });
	
	            _angular.$rootScope.$on('$destroy', changeInShippingAddress);
	
	            this.setAllowPayWithSnT = function (value) {
	                _this.flags.allowPayWithSnT = value;
	            };
	
	            this.handleZipCodeBlur = function (event) {
	                if (_this.flags.allowSnTCall) {
	                    if (!_this.showShipping) {
	                        disableDropDown();
	                        _this.fetchShippingMethods();
	                    } else if (!isFormZipCodeEmpty() && !isFormStateEmpty()) {
	                        _this.trackZipCode.current = getCurrentZipCode();
	                        _this.trackState.current = getCurrentState();
	                        if (isZipCodeChange() || isStateChange()) {
	                            if (_this.isDomesticShippingMethodsSupported()) {
	                                disableDropDown();
	                                _this.fetchShippingMethods();
	                            } else {
	                                _this.setAllowPayWithSnT(true);
	                            }
	                        } else {
	                            _this.setAllowPayWithSnT(true);
	                        }
	                    } else if (!isFormAddressLine1Empty() && (isFormZipCodeEmpty() || isFormStateEmpty())) {
	                        if (isFormZipCodeEmpty()) {
	                            _this.trackZipCode.prev = '';
	                        }
	                        if (isFormStateEmpty()) {
	                            _this.trackState.prev = '';
	                        }
	                        if (_this.isDomesticShippingMethodsSupported()) {
	                            _angular.$rootScope.$emit('showErrorFields');
	                            disableDropDown();
	                            _this.isStorePickUp = false;
	                            disableStorePickUp();
	                            patchCartWithButtonParams();
	                        }
	                    } else {
	                        _this.showZipCode = false;
	                    }
	                }
	            };
	
	            // Listener which is responsible to call shipping tax API to fetch shipping methods for the given address
	            var zipCodeBlur = _angular.$rootScope.$on('zip_code_blur', this.handleZipCodeBlur);
	
	            _angular.$rootScope.$on('$destroy', zipCodeBlur);
	
	            var handleZipCodeKeyPress = function handleZipCodeKeyPress(event, args) {
	                var zipCodeElement = args && args.event && args.event.target && args.event.target.id;
	                _this.setAllowPayWithSnT(true);
	                /* On keypress of zip code element in US / CA , SnT should be applied before Pay.
	                 For other countries , flag will be set when SnT Call is made during Page load .
	                 */
	                if (zipCodeElement && isValidPostalCodeElement(zipCodeElement) && _this.isDomesticShippingMethodsSupported() && isZipCodeChange()) {
	                    _this.setAllowPayWithSnT(false);
	                }
	            };
	
	            var zipCodeKeyPress = _angular.$rootScope.$on('zip_code_keypress', handleZipCodeKeyPress);
	
	            _angular.$rootScope.$on('$destroy', zipCodeKeyPress);
	
	            /*
	             Watcher on the ship to Billing checkbox
	             Use cases
	             ---------
	             1. User has selected a shipping method , unchecks the ship to my billing checkbox , if shipping address is empty
	             we disable dropdown and patch cart with button params.
	             2. User has selected a shipping method , unchecks the ship to my billing checkbox , if shipping address is not empty,
	             we fetch shipping methods based on shipping address.
	             3. User has selected a shipping method based on shipping address , checks the ship to my billing checkbox ,
	             we fetch shipping methods based on billing address.
	             */
	            this.$watch('isShippingSameAsBilling', function (newVal, oldVal) {
	                if (newVal !== oldVal) {
	                    disableDropDown();
	                    _this.trackZipCode = {
	                        prev: '',
	                        current: ''
	                    };
	
	                    _this.trackState = {
	                        prev: '',
	                        current: ''
	                    };
	                    _this.fetchShippingMethods();
	                    _this.isStorePickUp = false;
	                    _this.setZipCode();
	                }
	            });
	
	            /*
	             For instant update flows, the SnT service call is triggered when there is a change in
	             i. State
	             ii. Zip code
	             Changes to any other address fields will not trigger the SnT call.
	             The address fields are again compared during submit. If they are found to be different, SnT is again called.
	             */
	
	            // Watcher for billing address postal code
	            this.$watch('billingAddress.postal_code', function (newVal, oldVal) {
	                if (newVal !== oldVal) {
	                    _this.shipAndTaxError = false;
	                    _this.setZipCode();
	                }
	            });
	
	            // Watcher for shipping address postal code
	            this.$watch('shippingAddress.postal_code', function (newVal, oldVal) {
	                if (newVal !== oldVal) {
	                    _this.shipAndTaxError = false;
	                    _this.setZipCode();
	                }
	            });
	
	            // Watchers for billing address state change
	            this.$watch('billingAddress.state', function (newVal, oldVal) {
	                if (newVal !== oldVal) {
	                    if (_this.isShippingSameAsBilling && !isFormZipCodeEmpty() && _this.flags.allowSnTCall) {
	                        if (!isFormStateEmpty()) {
	                            if (_this.isDomesticShippingMethodsSupported()) {
	                                disableDropDown();
	                                _this.fetchShippingMethods();
	                            }
	                        }
	                    }
	                }
	            });
	
	            // Watchers for billing address country change
	            this.$watch('billingAddress.country', function (newVal, oldVal) {
	                if (newVal !== oldVal) {
	                    if (_this.isShippingSameAsBilling && _this.flags.allowSnTCall) {
	                        if (!_this.isInstantUpdateFlow || !_this.isDomesticShippingMethodsSupported()) {
	                            _angular.$rootScope.$emit('hideErrorFields');
	                            _this.triggerFetchShippingMethods = true;
	                        }
	                    }
	                }
	            });
	
	            this.$watch('triggerFetchShippingMethods', function (newVal, oldVal) {
	                if (newVal !== oldVal) {
	                    if (newVal) {
	                        disableDropDown();
	                        _this.fetchShippingMethods();
	                    }
	                }
	            });
	
	            // Watchers for shipping address country change
	            this.$watch('shippingAddress.country', function (newVal, oldVal) {
	                if (newVal !== oldVal) {
	                    if (!_this.isShippingSameAsBilling && _this.flags.allowSnTCall) {
	                        if (!_this.isInstantUpdateFlow || !_this.isDomesticShippingMethodsSupported()) {
	                            disableDropDown();
	                            _this.fetchShippingMethods();
	                        }
	                    }
	                }
	            });
	
	            // Watchers for shipping address state change
	            this.$watch('shippingAddress.state', function (newVal, oldVal) {
	                if (newVal !== oldVal) {
	                    if (!_this.isShippingSameAsBilling && !isFormZipCodeEmpty() && _this.flags.allowSnTCall) {
	                        if (_this.isDomesticShippingMethodsSupported()) {
	                            disableDropDown();
	                            _this.fetchShippingMethods();
	                        }
	                    }
	                }
	            });
	
	            // Function responsible to format each item to be shown in the dropdown
	            var getShippingCharge = function getShippingCharge(charge, index) {
	
	                var DASH = '--';
	                var SPACE = ' ';
	
	                function prefix(str, prefixStr) {
	                    if (str) {
	                        return (prefixStr ? prefixStr : '') + str;
	                    }
	                    return '';
	                }
	
	                var shippingMethod = charge.shipping_charge.shipping_method;
	
	                var amount = (parseInt(charge.shipping_charge.shipping_amount.value, 10) / 100).toFixed(2);
	
	                var currencyCode = charge.shipping_charge.shipping_amount.currency_code;
	
	                var formattedAmount = (0, _index.formatCurrency)(amount, currencyCode);
	
	                var shippingCurrency = prefix(SPACE + formattedAmount, SPACE + DASH);
	
	                var shippingDeliveryTime = charge.shipping_charge.delivery_time;
	
	                var displayShippingMethod = (0, _util.decodeEntities)(shippingMethod);
	
	                var displayCurrency = shippingCurrency;
	
	                var displayShippingDeliveryTime = prefix(shippingDeliveryTime, ' \\n ');
	
	                // Format insurance if available
	                var insuranceCurrency = '';
	                if (charge.shipping_charge.insurance_amount) {
	                    var insuranceAmount = (parseInt(charge.shipping_charge.insurance_amount.value, 10) / 100).toFixed(2);
	
	                    var insuranceCurrencyCode = charge.shipping_charge.insurance_amount.currency_code;
	
	                    var formattedInsuranceAmount = (0, _index.formatCurrency)(insuranceAmount, insuranceCurrencyCode);
	
	                    insuranceCurrency = '' + SPACE + formattedInsuranceAmount;
	                }
	
	                return {
	
	                    shippingCharge: charge,
	                    shippingMethod: displayShippingMethod,
	                    shippingCurrency: displayCurrency,
	                    shippingDeliveryTime: displayShippingDeliveryTime,
	                    insuranceCurrency: insuranceCurrency,
	                    index: index
	                };
	            };
	
	            // Function responsible to set default shipping method
	            var setDefaultShippingMethod = function setDefaultShippingMethod() {
	
	                var span = $('#shippingMethodsDropDown > div > span > span > span');
	
	                span.html(_index.$locale.content.get('shippingMethod.selectMethod'));
	
	                _this.isStorePickUp = false;
	
	                disableStorePickUp();
	
	                _this.shippingChargesList = [{}];
	            };
	
	            // Populates the shipping method dropdown with shipping charges .
	            var populateShippingCharges = function populateShippingCharges() {
	                setDefaultShippingMethod();
	                if (_this.charges.length >= 1) {
	                    enableDropDown();
	                    _this.shippingChargesList = _this.charges.map(getShippingCharge);
	                } else {
	                    disableDropDown();
	                }
	            };
	
	            // Checks whether selected shipping method is store pick up or not
	            var isStorePickUpMethod = function isStorePickUpMethod(shipping_method_type) {
	                return shipping_method_type === 'STORE_PICKUP' || shipping_method_type === 'PICKUP';
	            };
	
	            // Function called when user selects a shipping method from the dropdown
	            this.selectShippingMethod = function (selectedShippingCharge) {
	                _this.selectedMethod.index = selectedShippingCharge.index;
	                _this.selectedShippingCharge = selectedShippingCharge;
	
	                // deselect insurance checkbox
	                _this.selectedShippingCharge.insuranceCheckboxChecked = false;
	                _this.selectedShippingCharge.showInsuranceSelectCheckbox = false;
	
	                var taxAmtApplied = void 0;
	                var amountValue = void 0;
	                var methodType = void 0;
	                var insurance = void 0;
	                var patchWithInsurance = false;
	
	                if (_this.selectedShippingCharge && _this.selectedShippingCharge.shippingCharge && _this.selectedShippingCharge.shippingCharge.shipping_charge) {
	                    var shippingCharge = _this.selectedShippingCharge.shippingCharge.shipping_charge;
	                    _this.flags.allowEditShipping = true;
	                    _this.flags.showSingleAddress = false;
	                    _this.isStorePickUp = false;
	                    if (isStorePickUpMethod(shippingCharge.shipping_method_type)) {
	                        _this.isStorePickUp = true;
	                        enableStorePickUp();
	                    }
	                    _this.shippingMethodNotSelected = false;
	                    methodType = shippingCharge.shipping_method_type;
	                    amountValue = safeConvert(shippingCharge.shipping_amount.value);
	                    taxAmtApplied = getTax(_this.selectedShippingCharge.shippingCharge);
	                    insurance = shippingCharge.insurance_amount && shippingCharge.insurance_amount.value;
	                    if (insurance) {
	                        insurance = safeConvert(insurance);
	                        /**
	                         *  Patch Insurance if
	                         *  1. offer_insurance_option=false and there is insurance amount in response;
	                         *  2. offer_insurance_option=true and there is an insurance amount in response,
	                         *     then user needs to select the apply insurance checkbox first
	                         */
	                        if (!shippingCharge.offer_insurance_option) {
	                            patchWithInsurance = true;
	                        } else {
	                            _this.selectedShippingCharge.showInsuranceSelectCheckbox = true;
	                        }
	                    }
	                } else {
	                    _this.isStorePickUp = false;
	                    amountValue = _this.buttonCartAmounts.shippingAmt;
	                    taxAmtApplied = getTax();
	                    methodType = 'DEFAULT';
	                }
	
	                if (_this.isInstantUpdateFlow) {
	                    updateExternalCallbackOptions(_this.response.shipping_options_source, _this.selectedMethod.prevIndex, _this.selectedMethod.index);
	                    if (patchWithInsurance) {
	                        updateShippingTaxCharge(amountValue, taxAmtApplied, methodType, insurance);
	                    } else {
	                        updateShippingTaxCharge(amountValue, taxAmtApplied, methodType);
	                    }
	                } else if (isPatchCartRequired(amountValue, taxAmtApplied)) {
	                    updateShippingTaxCharge(amountValue, taxAmtApplied, methodType);
	                }
	                _this.selectedMethod.prevIndex = _this.selectedMethod.index;
	            };
	            // Function called when user selects a optional insurance field in checkbox
	            this.onInsuranceCheckboxChange = function (insuranceCheckboxChecked) {
	                _this.selectedShippingCharge.insuranceCheckboxChecked = insuranceCheckboxChecked;
	                var shippingCharge = _this.selectedShippingCharge.shippingCharge.shipping_charge;
	                var insurance = safeConvert(shippingCharge.insurance_amount.value);
	                var taxAmtApplied = getTax(_this.selectedShippingCharge.shippingCharge);
	                var amountValue = safeConvert(shippingCharge.shipping_amount.value);
	                var methodType = shippingCharge.shipping_method_type;
	
	                if (_this.selectedShippingCharge.insuranceCheckboxChecked === true) {
	                    // Patch the cart with insurance
	                    updateShippingTaxCharge(amountValue, taxAmtApplied, methodType, insurance);
	                } else {
	                    // Patch the cart without insurance
	                    updateShippingTaxCharge(amountValue, taxAmtApplied, methodType);
	                }
	            };
	
	            // Function responsible to populate Error fields
	            var populateErrorFields = function populateErrorFields() {
	                disableDropDown();
	                _this.showZipCode = false;
	                if (_this.isShippingSameAsBilling) {
	                    _this.city = _this.billingAddress.city;
	                    _this.state = _this.billingAddress.state;
	                } else {
	                    _this.city = _this.shippingAddress.city;
	                    _this.state = _this.shippingAddress.state;
	                }
	            };
	
	            var populateCallbackShippingOptions = function populateCallbackShippingOptions() {
	                if (!_this.charges) {
	                    return;
	                }
	                _this.callbackShippingOptions = _this.charges.map(function (charge, index) {
	                    var shippingCharge = charge.shipping_charge;
	                    var taxCharge = charge.tax;
	                    var insurance = shippingCharge && shippingCharge.insurance_amount;
	                    var option = {};
	                    if (shippingCharge) {
	                        option.method = shippingCharge.shipping_method;
	                        option.amount = {
	                            value: safeConvert(shippingCharge.shipping_amount && shippingCharge.shipping_amount.value),
	                            currency: shippingCharge.shipping_amount && shippingCharge.shipping_amount.currency_code
	                        };
	                        option.is_default = shippingCharge.default_method;
	                        option.is_selected = false;
	                        if (insurance) {
	                            option.insurance = {
	                                value: safeConvert(insurance.value),
	                                currency: insurance.currency_code
	                            };
	                            _this.callbackInsuranceOffered = true;
	                        }
	                        if (taxCharge) {
	                            option.tax = {
	                                value: safeConvert(taxCharge.total_tax.value),
	                                currency: taxCharge.total_tax.currency_code
	                            };
	                        }
	                    }
	                    return option;
	                });
	            };
	
	            var updateExternalCallbackOptions = function updateExternalCallbackOptions(optionsSource, prevIndex, index) {
	                if (optionsSource === 'CALLBACK' && _this.callbackShippingOptions) {
	                    if (!isNaN(prevIndex)) {
	                        _this.callbackShippingOptions[prevIndex].is_selected = false;
	                    }
	                    _this.callbackShippingOptions[index].is_selected = true;
	                } else if (optionsSource === 'FALLBACK' && _this.fallbackShippingOptions) {
	                    if (!isNaN(prevIndex)) {
	                        _this.fallbackShippingOptions[prevIndex].is_selected = false;
	                    }
	                    _this.fallbackShippingOptions[index].is_selected = true;
	                }
	            };
	
	            // Find the charges of the default option and patch cart with corresponding values.
	            var updateShippingTaxChargeWithDefaultOption = function updateShippingTaxChargeWithDefaultOption() {
	                var shippingAmt = void 0,
	                    taxAmt = void 0,
	                    insuranceAmt = void 0,
	                    methodType = void 0;
	                // SnT service always returns FALLBACK response when no_shipping = 1
	                if (_this.response.shipping_options_source === 'FALLBACK' && !isNaN(_this.defaultFallbackOptionIndex)) {
	                    var defaultOption = _this.fallbackShippingOptions[_this.defaultFallbackOptionIndex];
	                    if (defaultOption) {
	                        shippingAmt = defaultOption.amount && defaultOption.amount.value;
	                        taxAmt = defaultOption.tax && defaultOption.tax.value;
	                        insuranceAmt = defaultOption.insurance && defaultOption.insurance.value;
	                    }
	                }
	                updateShippingTaxCharge(shippingAmt, taxAmt, methodType, insuranceAmt);
	            };
	
	            /*  Function which is responsible to process shipping tax response
	             Use cases
	             ---------
	             1. If shipping tax API returns error, show Error fields.
	             2. (i) WPS: If response has shipping charges and shipping options are to be shown, populate the dropdown with charges else patch cart
	             with shipping amount returned.
	                (ii)Instant Update: If the shipping region is unsupported, display error message. Otherwise the above behavior applies.
	             3. If no_shipping = 1
	                (i) WPS:  If profile_override = true , apply shipping from button if it is not empty.
	                (ii) Instant Update: Do not display the shipping options. Apply the default fallback(or callback) shipping option charges.
	             4. Apply tax if applicable.
	             */
	            var processShippingAndTaxResponse = function processShippingAndTaxResponse() {
	
	                var applicableShippingAmt = _this.buttonCartAmounts.shippingAmt;
	
	                // Set selected shipping charge as null to disallow form submit without selecting a shipping method.
	                _this.selectedShippingCharge = null;
	
	                // Handle error from service
	                if (_this.shipAndTaxError) {
	                    populateErrorFields();
	                }
	                if (_this.isInstantUpdateFlow) {
	                    if (!_this.response.shipping_region_supported) {
	                        _this.flags.instantUpdateShippingRegionSupported = false;
	                        _this.pageLevelErrorMessage = {
	                            msgs: errorHandlerHelper.getPageError('shippingMethod.shippingRegionUnsupported', { merchant: _this.merchantId }),
	                            type: 'error'
	                        };
	                        return;
	                    }
	                    if (_this.response.shipping_options_source === 'CALLBACK') {
	                        populateCallbackShippingOptions();
	                    }
	                    if (_this.showShipping) {
	                        // this.showShipping is true when merchant passes no_shipping parameter with value 0 or 2.
	                        // In this case, the shipping values from the SnT response is considered.
	                        if (responseHasShippingCharges()) {
	                            populateShippingCharges();
	                            patchCartWithButtonParams();
	                        }
	                    } else {
	                        // this.showShipping is false when merchant passes no_shipping parameter with value 1
	                        // In this case, shipping options aren't shown. The default fallback shipping option is considered.
	                        _this.showShippingMethodSection = false;
	                        _this.flags.showShippingLabel = false;
	                        updateShippingTaxChargeWithDefaultOption();
	                    }
	                    return;
	                }
	                // non instant update flow, no_shipping = 0
	                else if (_this.showShipping) {
	                        if (responseHasShippingCharges()) {
	                            if (_this.response.show_shipping_options) {
	                                populateShippingCharges();
	                            } else {
	                                applicableShippingAmt = safeConvert(_this.response.charges[0].shipping_charge.shipping_amount.value);
	                                _this.showShippingMethodSection = false;
	                                _this.flags.showShippingLabel = false;
	                            }
	                        }
	                    }
	                    // not instant update flow, no_shipping = 1 , profile_override = true , shipping passed in button.
	                    else if (_this.response.profile_override_allowed) {
	                            // If shipping Amt is not empty , set applicable shipping amt for patch cart
	                            if (_this.buttonCartAmounts.shippingAmt) {
	                                applicableShippingAmt = _this.buttonCartAmounts.shippingAmt;
	                                _this.showShippingMethodSection = false;
	                                _this.flags.showShippingLabel = false;
	                            }
	                        }
	
	                var applicableTaxAmt = getTax();
	
	                // Patch if shipping amt or tax amount has changed
	                if (isPatchCartRequired(applicableShippingAmt, applicableTaxAmt)) {
	                    updateShippingTaxCharge(applicableShippingAmt, applicableTaxAmt, 'DEFAULT');
	                }
	            };
	
	            var clearFallbackOptionsSelectionFlags = function clearFallbackOptionsSelectionFlags() {
	                if (!_this.fallbackShippingOptions) {
	                    return;
	                }
	                for (var i = 0; i < _this.fallbackShippingOptions.length; i++) {
	                    _this.fallbackShippingOptions[i].is_selected = false;
	                }
	            };
	
	            // Function which gets shipping and tax charges from the merchant profile.
	            this.fetchShippingMethods = function () {
	
	                _this.flags.showShippingLabel = true;
	                _this.flags.instantUpdateShippingRegionSupported = true;
	                _this.selectedMethod = {};
	                _this.response = {};
	                _this.callbackShippingOptions = [];
	                _this.callbackInsuranceOffered = false;
	                _this.pageLevelErrorMessage = {};
	
	                _this.showShippingMethodSection = true;
	                _this.shippingChargesList = [{}];
	                _this.setAllowPayWithSnT(false);
	
	                clearFallbackOptionsSelectionFlags();
	
	                var shippingAddress = _this.billingAddress;
	
	                if (!_this.isShippingSameAsBilling) {
	                    shippingAddress = _this.shippingAddress;
	                }
	
	                _this.trackZipCode.prev = shippingAddress.postal_code;
	                _this.trackState.prev = shippingAddress.state;
	
	                _this.dropDownBackground = 'processingBackground';
	
	                _this.selectedShippingMethodText = 'disableShippingMethod';
	
	                _this.changeShippingMethod = 'changeShippingMethodDisabled';
	
	                var cartWeight = void 0,
	                    discount = void 0,
	                    cartHandling = void 0,
	                    currCode = void 0;
	                if (_this.models.checkoutCart.cartWeight && _this.models.checkoutCart.cartWeight.value) {
	                    cartWeight = {
	                        value: Number(_this.models.checkoutCart.cartWeight.value).toFixed(2),
	                        unit: _this.models.checkoutCart.cartWeight.unit
	                    };
	                }
	
	                if (_this.models.checkoutCart.purchase.amounts.discount && _this.models.checkoutCart.purchase.amounts.discount.amount) {
	                    discount = Number(_this.models.checkoutCart.purchase.amounts.discount.amount).toFixed(2);
	                }
	
	                if (_this.models.checkoutCart.purchase.amounts.handling_fee && _this.models.checkoutCart.purchase.amounts.handling_fee.amount) {
	                    cartHandling = Number(_this.models.checkoutCart.purchase.amounts.handling_fee.amount).toFixed(2);
	                }
	
	                currCode = _this.models.checkoutCart.purchase.amounts.total.currency_code;
	
	                var sntRequest = {
	                    'address': {
	                        'line1': shippingAddress.line1,
	                        'line2': shippingAddress.line2,
	                        'city': shippingAddress.city,
	                        'state': shippingAddress.state,
	                        'postal_code': shippingAddress.postal_code,
	                        'country_code': shippingAddress.country
	                    },
	                    'currency_code': _this.currencyCode,
	                    'cart_weight': cartWeight,
	                    'cart_handling': { value: cartHandling, currency_code: currCode },
	                    'discount': { value: discount, currency_code: currCode },
	                    'item_list': _this.models.checkoutCart.purchase.items,
	                    'tax_on_shipping_required': _this.showShipping, //   tax on shipping is not applicable when no_shipping is 1
	                    'merchant_id': _this.models.checkoutPayee.merchant.id,
	                    'locale': _index.$locale.lang + '_' + _index.$locale.country
	                };
	
	                if (_this.isInstantUpdateFlow) {
	                    _this.trackSntReq.address = sntRequest.address;
	                    sntRequest.external_callback_options = _this.models.checkoutCart.getExternalCallbackOptions();
	                    // TODO: For EC flows, populate sntRequest.token as well.
	                }
	                _this.shippingMethods = new _index2.$ShippingMethodModel(sntRequest);
	
	                _this.shippingMethods.save({
	                    data: _this.shippingMethods,
	
	                    contingencies: {
	                        VALIDATION_ERROR: function VALIDATION_ERROR(name, err) {
	                            _logger.$logger.info('get_shipping_methods_VALIDATION_ERROR');
	                            _this.shipAndTaxError = true;
	                            if (!isFormZipCodeEmpty() || !isFormStateEmpty()) {
	                                _angular.$rootScope.$emit('showErrorFields');
	                            }
	                            populateErrorFields();
	                            patchCartWithButtonParams();
	                        },
	                        INTERNAL_SERVICE_ERROR: function INTERNAL_SERVICE_ERROR(name, err) {
	                            _logger.$logger.info('get_shipping_methods_INTERNAL_SERVICE_ERROR');
	                            _this.shipAndTaxError = true;
	                            if (!isFormZipCodeEmpty() || !isFormStateEmpty()) {
	                                _angular.$rootScope.$emit('showErrorFields');
	                            }
	                            populateErrorFields();
	                            patchCartWithButtonParams();
	                        }
	                    },
	                    success: function success(result) {
	                        _this.response = result;
	                        _this.charges = result.charges;
	                        _this.triggerFetchShippingMethods = false;
	                        _this.setAllowPayWithSnT(true);
	                        processShippingAndTaxResponse();
	                    }
	                });
	            };
	            _angular.$rootScope.$on('submission_triggered', function () {
	                disableDropDown();
	                _this.fetchShippingMethods();
	            });
	        },
	
	        populate: function populate() {
	
	            this.currencyCode = this.models.checkoutCart.purchase.amounts.total.currency_code;
	            this.isInstantUpdateFlow = this.models.checkoutCart.instantUpdateIntegration;
	            if (this.isInstantUpdateFlow) {
	                this.fallbackShippingOptions = this.models.checkoutCart.getExternalCallbackOptions().fallback_shipping_options;
	                if (this.fallbackShippingOptions) {
	                    this.defaultFallbackOptionIndex = _index.$util.findIndex(this.fallbackShippingOptions, function (option) {
	                        return option.is_default;
	                    });
	                }
	            }
	
	            this.buttonCartAmounts = {
	                shippingAmt: this.buttonParams.shipping ? Number(this.buttonParams.shipping.amount) : undefined,
	                taxAmt: this.buttonParams.tax ? Number(this.buttonParams.tax.amount) : undefined,
	                discount: this.models.checkoutCart.purchase.amounts.discount ? Number(this.models.checkoutCart.purchase.amounts.discount.amount) : undefined,
	                subTotal: Number(this.models.checkoutCart.purchase.amounts.subtotal.amount),
	                total: Number(this.buttonParams.total.amount)
	            };
	
	            var appDataFlags = this.models.checkoutAppData && this.models.checkoutAppData.flags;
	            var merchant = this.models.checkoutAppData && this.models.checkoutAppData.merchant;
	            this.merchantId = merchant.brand_name || merchant.merchant_name || merchant.merchant_email;
	
	            this.isBuyNow = appDataFlags && appDataFlags.is_buy_now_flow;
	
	            this.isCartUpload = appDataFlags && appDataFlags.is_cart_upload_flow;
	
	            if (this.models.checkoutCart.cartWeight) {
	                if (this.models.checkoutCart.cartWeight.value) {
	                    this.cartWeight = {
	                        value: Number(this.models.checkoutCart.cartWeight.value).toFixed(2),
	                        unit: this.models.checkoutCart.cartWeight.unit
	                    };
	                }
	            }
	
	            if (this.models.checkoutCart.purchase.amounts.discount) {
	                if (this.models.checkoutCart.purchase.amounts.discount.amount) {
	                    this.cartDiscount = {
	                        value: Number(this.models.checkoutCart.purchase.amounts.discount.amount).toFixed(2),
	                        currency_code: this.currencyCode
	                    };
	                }
	            }
	
	            if (this.models.checkoutCart.purchase.amounts.handling_fee) {
	                this.buttonCartAmounts.handlingAmt = Number(this.models.checkoutCart.purchase.amounts.handling_fee.amount);
	            }
	
	            if (this.models.checkoutCart.purchase.amounts.insurance) {
	                this.buttonCartAmounts.insuranceAmt = Number(this.models.checkoutCart.purchase.amounts.insurance.amount);
	            }
	
	            if (this.models.checkoutCart.purchase.amounts.shipping_discount) {
	                this.buttonCartAmounts.shippingDiscountAmt = Number(this.models.checkoutCart.purchase.amounts.shipping_discount.amount);
	            }
	
	            this.previousCosts = {
	                shippingAmount: this.models.checkoutCart.purchase.amounts.shipping ? Number(this.models.checkoutCart.purchase.amounts.shipping.amount) : undefined,
	                taxAmount: this.models.checkoutCart.purchase.amounts.tax ? Number(this.models.checkoutCart.purchase.amounts.tax.amount) : undefined
	            };
	
	            if (!this.isDomesticShippingMethodsSupported()) {
	                this.triggerFetchShippingMethods = true;
	            }
	
	            // trigger zipCodeBlur handler to fetch shipping methods in case of pre-filled address
	            this.handleZipCodeBlur();
	        }
	    }
	}); /**
	     * Created by aaramamurthy on 2/29/16.
	     *
	     * Component responsible to show shipping methods set by merchant to a buyer during guest checkout flow.
	     */
	
	_angular.$rootScope;
	
	_index.$Component;
	
	_index.$locale;
	
	_index.formatCurrency;
	
	_index.$feature;
	
	_index.$util;
	
	_logger.$logger;
	
	_index2.$ShippingMethodModel;
	
	_index3.$CheckoutAppDataModel;
	
	_index3.$CheckoutCartModel;
	
	_index3.$CheckoutSessionModel;
	
	_index3.$CheckoutPayeeModel;
	
	_util.decodeEntities;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "./components/xo-guest-components/src/guest/select-shipping-method/template.html":
/***/ (function(module, exports) {

	module.exports = "<div id=\"selectShippingMethod\" ng-if=\"showShippingMethodSection\" content>\n    <label class=\"shippingMethodTitle\">{{content('shipping.shippingMethodTitle')}}</label>\n\n    <div id=\"merchantOptions\" class=\"merchantOptionsStyle\">\n        <p class=\"guestMerchantOptions\" ng-show=\"showMerchantOptions\">\n            {{content('shippingMethod.guestMerchantOptions')}}\n        </p>\n\n        <p class=\"guestMerchantOptions\" ng-show=\"showZipCode\">\n            {{content('shippingMethod.zipCode')}}:\n        </p>\n\n        <p class=\"zipCodeOptions\" ng-show=\"showZipCode\">\n            {{zipCode}}\n        </p>\n\n        <p class=\"addressOptions\" ng-show=\"shipAndTaxError\">\n            [{{city}},{{state}} {{zipCode}}]\n        </p>\n\n    </div>\n\n    <div id=\"shippingMethodsDropDown\" ng-if=\"isShowShippingMethodsDropDown && !noShippingMethodDropDown\"\n         ng-class=\"[changeShippingMethod,dropDownBackground,selectedShippingMethodText]\" class=\"dropdown confidential clearfix\">\n\n        <select xo-shipping-method-drop-down ng-model=\"selectedShippingCharge\"\n                ng-change=\"selectShippingMethod(selectedShippingCharge)\"\n                id=\"shippingMethodDropDown\" name=\"shippingMethodDropDown\"\n                ng-required = \"shippingMethodNotSelected\" ng-hide=\"hideSelectDropdown\">\n\n\n            <option value=\"\" selected=\"selected\" class=\"selectedShippingMethod\" > {{ content('shippingMethod.selectMethod',\n                { count: shippingChargesList.length}) }}</option>\n\n            <option ng-repeat=\"charge in shippingChargesList\" value=\"{{$index}}\">\n                {{charge.shippingMethod}}{{charge.shippingCurrency}}{{charge.shippingDeliveryTime}}\n            </option>\n\n        </select>\n\n    </div>\n\n    <div class=\"row-fluid checkbox shippingMethodApplyInsuranceContainer\"\n         ng-if=\"selectedShippingCharge && selectedShippingCharge.showInsuranceSelectCheckbox\">\n\n        <input type=\"checkbox\" ng-model=\"selectedShippingCharge.insuranceCheckboxChecked\"\n               name=\"shippingMethodApplyInsurance\" id=\"shippingMethodApplyInsurance\"\n               ng-change=\"onInsuranceCheckboxChange(selectedShippingCharge.insuranceCheckboxChecked)\">\n        <label class=\"noBottom\" for=\"shippingMethodApplyInsurance\"\n               ng-bind-html=\"htmlContent('shippingMethod.addShippingInsurance',{amount: selectedShippingCharge.insuranceCurrency})\">\n        </label>\n\n    </div>\n\n    <div id=\"noShippingMethod\" ng-if=\"noShippingMethodDropDown\"\n         ng-class=\"[changeShippingMethod,selectedShippingMethodText]\" class=\"dropdown confidential clearfix\">\n\n        <select xo-dropdown-multiline id=\"noShippingMethodDropDown\">\n\n\n            <option value=\"\" selected=\"selected\" class=\"selectedShippingMethod\"> {{ content('shippingMethod.selectMethod',\n                { count: shippingChargesList.length}) }}</option>\n\n            <option ng-repeat=\"charge in noShippingChargesList track by $index\" value=\"{{$index}}\">\n\n            </option>\n\n        </select>\n\n    </div>\n\n    <div id=\"shippingMethodProcessing\" ng-show=\"isProcessing\">\n        <div class=\"spinner\">\n            <p class=\"loader\" ></p>\n        </div>\n    </div>\n\n    <div id=\"showPickUpStore\" class=\"pickUpStoreText\" ng-if=\"isStorePickUp\">\n        {{content('shippingMethod.storeLocationInfo')}}\n    </div>\n\n\n</div>\n"

/***/ }),

/***/ "./components/xo-guest-components/src/guest/select-shipping-method/shipping-method-dropdown/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * Created by aaramamurthy on 3/22/16.
	 *
	 * This is a dropdown multiline directive customised for shipping charges dropdown .
	 * Existing multiline dropdown does not provide the functionality to have element based styling inside an dropdown item.
	 * Existing multiline dropdown also shows an empty object in the dropdown if passed.
	 * This directive populates the dropdown by making shipping amount as bold .
	 * This directive populates the dropdown with items which is a valid object and has a value.
	 */
	
	
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/jquery/dist/jquery.min.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, $) {
	
	    squid.module('xo-shipping-method-dropdown.directive', ['squid']).directive('xoShippingMethodDropDown', function ($timeout) {
	        return {
	            restrict: 'A',
	
	            require: '?ngModel',
	
	            link: function link($scope, $select, attrs, ngModel) {
	
	                var isListVisible = false;
	                var listCreated = false;
	
	                $select = $($select);
	
	                var $span = $('<span class="custom-select" aria-hidden="true"><div class="arrow"></div><span class="innerContainer"><span></span></span></span>');
	                var $container = $('<div class="custom-select-container multiline-select-container" tabindex="0" />');
	                var $list;
	
	                function updateCover() {
	                    $timeout(function () {
	                        var span = $span.find('span span');
	
	                        var text = $select.find('[selected]').text().replace(/\\n/gi, '<br>').trim();
	
	                        var shippingAmount = text.substring(text.search('--'), text.search('<br>'));
	
	                        var boldText = text.replace(shippingAmount, shippingAmount.bold());
	
	                        boldText = boldText.replace('--', '-');
	
	                        span.html(boldText);
	                    }, 10);
	                }
	
	                function createList($options) {
	                    if ($options.length < 2) {
	                        return;
	                    }
	
	                    function getModel() {
	                        var modelName;
	                        var model;
	                        var subParts;
	
	                        if ($select.attr('ng-options')) {
	                            modelName = $select.attr('ng-options').substring($select.attr('ng-options').indexOf('in ') + 3, $select.attr('ng-options').length);
	                        } else {
	                            var $option = $($select.find('[ng-repeat]')[0]);
	                            modelName = $option.attr('ng-repeat').substring($option.attr('ng-repeat').indexOf('in ') + 3, $option.attr('ng-repeat').length);
	                        }
	
	                        // This is to handle cases like card.billingAddress
	                        if (modelName.indexOf('.') !== -1) {
	                            subParts = modelName.split('.');
	                            model = $scope;
	
	                            for (var i = 0; i < subParts.length; i++) {
	                                model = model[subParts[i]];
	                            }
	                        } else {
	                            // And this is to handle straightforward model names
	                            model = $scope[modelName];
	                        }
	
	                        return model;
	                    }
	
	                    function hideList(event) {
	                        $list.hide();
	                        $container.append($list);
	                        isListVisible = false;
	                        $container.removeClass('open');
	                    }
	
	                    function positionList() {
	                        $list.css('left', $container.offset().left + 'px');
	                        $list.css('top', $container.offset().top + $container.height() + 'px');
	                        $list.css('width', $container.width() + 'px');
	                    }
	
	                    function setFocusOnSelected() {
	                        var $selected = $select.find('[selected]');
	
	                        if ($selected.length) {
	                            var $item = $list.find('[data-value="' + $selected.attr('value') + '"]');
	                            $item.focus();
	                        } else {
	                            $list.find('li')[0].focus();
	                        }
	                    }
	
	                    function showList() {
	                        $('body').append($list);
	                        $container.addClass('open');
	                        $list.show();
	                        positionList();
	                        isListVisible = true;
	                        setFocusOnSelected();
	                    }
	
	                    function processContainerKeypress(event) {
	                        var keyCode = event.keyCode;
	
	                        if (keyCode === 13 || keyCode === 40) {
	                            // enter or down arrow
	                            if (!isListVisible) {
	                                showList();
	                            } else {
	                                hideList();
	                                $container.focus();
	                            }
	                        } else if (keyCode === 27) {
	                            // escape
	                            if (isListVisible) {
	                                hideList();
	                                $container.focus();
	                            }
	                        }
	                    }
	
	                    if ($list) {
	                        $list.remove();
	                    }
	
	                    $list = $('<ul class="multiline-select-list" tabindex="0"></ul>');
	
	                    Array.prototype.forEach.call($options, function (option) {
	                        var $option = $(option);
	                        var value = $option.attr('value');
	
	                        var text = option.innerHTML.replace(/\\n/gi, '<br>');
	
	                        var shippingAmount = text.substring(text.search('--'), text.search('<br>'));
	
	                        var boldText = text.replace(shippingAmount, shippingAmount.bold());
	
	                        boldText = boldText.replace('--', '- ');
	
	                        if (boldText.indexOf('content(') !== -1) {
	                            boldText = $scope.content(boldText.substring(boldText.indexOf('(\'') + 2, boldText.indexOf('\')')));
	                        }
	
	                        var html = '<li tabindex="0"';
	                        if (value !== $option.text()) {
	                            html = html + ' data-value="' + value + '"';
	                        }
	                        html = html + '>' + boldText + '</li>';
	                        if (value !== '') {
	                            $list.append($(html));
	                        }
	                    });
	
	                    $container.append($list);
	                    $list.hide();
	
	                    $($list.find('li')).click(function (event) {
	                        var $target = $(event.target);
	                        var value = $target.data('value');
	
	                        if ($target[0].nodeName.toLowerCase() !== 'li') {
	                            value = $target.parent().data('value');
	                        }
	
	                        if (typeof value !== 'undefined') {
	                            $select.find('option').removeAttr('selected');
	                            $select.find('option[value="' + value + '"]').attr('selected', 'selected');
	                            $select.find('option').removeProp('selected');
	                            $select.find('option[value="' + value + '"]').prop('selected', 'selected');
	                        } else {
	                            value = $target.html().replace(/\/<br\/>/gi, '\\n');
	                            $select.val(value);
	                        }
	
	                        if ($select.attr('ng-model')) {
	                            if ($select.attr('ng-options') || $select.find('[ng-repeat]').length) {
	                                /* This parses the 'ng-options' directive and returns the options model.
	                                 For example: If you have: ng-options='opt as opt.label for opt in options'
	                                 Here it will parse this attribute and return 'options */
	                                var model = getModel();
	
	                                ngModel.$setViewValue(model[value]);
	                            } else {
	                                ngModel.$setViewValue(value);
	                            }
	                        }
	
	                        updateCover();
	                        hideList();
	                    });
	
	                    var $innerContainer = $container.find('.innerContainer');
	
	                    $container.click(function (event) {
	                        if (isListVisible) {
	                            hideList();
	                            $container.focus();
	                        } else {
	                            showList();
	                        }
	                    });
	
	                    $container.keydown(function (event) {
	                        processContainerKeypress(event);
	                    });
	
	                    $innerContainer.keydown(function (event) {
	                        processContainerKeypress(event);
	                    });
	
	                    $list.find('li').keydown(function (event) {
	                        var keyCode = event.keyCode;
	                        var $target = $(event.target);
	
	                        if (keyCode === 13) {
	                            // enter
	                            $target.click();
	                            event.stopPropagation();
	                        } else if (keyCode === 27) {
	                            // escape
	                            if (isListVisible) {
	                                hideList();
	                                $container.focus();
	                                event.stopPropagation();
	                            }
	                        } else if (keyCode === 40) {
	                            // down arrow
	                            if (!$target.is(':last-of-type')) {
	                                $target.next().focus();
	                                event.preventDefault();
	                                event.stopPropagation();
	                            }
	                        } else if (keyCode === 38) {
	                            // up arrow
	                            if (!$target.is(':first-of-type')) {
	                                $target.prev().focus();
	                            }
	                            event.preventDefault();
	                            event.stopPropagation();
	                        }
	                    });
	
	                    $(window).resize(function () {
	                        if (isListVisible) {
	                            positionList();
	                        }
	                    });
	
	                    $(window).bind('hashchange', function () {
	                        if (isListVisible) {
	                            hideList();
	                        }
	                    });
	
	                    $(document).click(function (event) {
	                        var $target = $(event.target);
	
	                        if (!($target.is($container) || $.contains($container.get()[0], $target.get()[0])) && isListVisible) {
	                            hideList();
	                        }
	                    });
	
	                    listCreated = true;
	                    updateCover();
	                }
	
	                function render() {
	                    var options = $select.find('option');
	                    if (!listCreated) {
	                        createList(options);
	                    }
	                }
	
	                $select.wrap($container);
	                $container = $select.parent();
	
	                // Change class names to enable styling of hover/focus states
	                $select.bind('mouseenter focus', function () {
	                    $span.addClass('active');
	                });
	
	                // Change class names to enable styling of hover/focus states
	                $select.bind('mouseleave blur', function () {
	                    $span.removeClass('active');
	                });
	
	                $select.after($span);
	
	                $select.addClass('replaced');
	
	                $select.attr('tabindex', '-1');
	
	                if (attrs['default']) {
	                    var defaultOption = document.createElement('option');
	                    defaultOption.innerText = attrs['default'];
	                    $select.append(defaultOption);
	                }
	
	                if ($select.attr('ng-options') || $select.find('[ng-repeat]').length) {
	                    $scope.$watch(attrs.ngModel, function () {
	                        render();
	                    });
	                } else {
	                    $timeout(function () {
	                        $scope.$broadcast('pageRendered');
	                    }, 0);
	                }
	
	                $scope.$on('pageRendered', function () {
	                    render();
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "./components/xo-guest-components/src/guest/select-shipping-method/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-guest-components/src/guest/select-shipping-method/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-guest-components/src/guest/select-shipping-method/styles.less":
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "blockquote,body,code,dd,div,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,html,input,legend,li,ol,p,pre,td,textarea,th,ul{margin:0;padding:0}table{border-collapse:collapse;border-spacing:0}fieldset,img{border:0}address,caption,cite,code,dfn,em,strong,th,var{font-style:normal;font-weight:400}ol,ul{list-style:none}caption,th{text-align:left}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:400}q:after,q:before{content:\"\"}abbr,acronym{border:0;font-variant:normal}sup{vertical-align:text-top}sub{vertical-align:text-bottom}input,select,textarea{font-family:inherit;font-size:inherit;font-weight:inherit;font-size:100%}legend{color:#000}body{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:95%;color:#2c2e2f;line-height:1.35em}h1{font-size:138.5%}h2{font-size:123.1%}h3{font-size:108%}h1,h2,h3{margin:1em 0}h1,h2,h3,h4,h5,h6,strong{font-weight:700}a{color:#0070ba}abbr,acronym{border-bottom:1px dotted #000;cursor:help}em{font-style:italic}blockquote,dl,ol,ul{margin:1em}dl,ol,ul{margin-left:2em}ol{list-style:decimal outside}ul{list-style:disc outside}dl dd{margin-left:1em}td,th{border:1px solid #000;padding:.5em}th{font-weight:700;text-align:center}input{margin-bottom:10px}caption{margin-bottom:.5em;text-align:center}fieldset,legend,p,pre,table{margin-bottom:1em}input[type=password],input[type=text],textarea{width:12.25em;*width:11.9em}.row-fluid{width:100%;*zoom:1}.row-fluid:after,.row-fluid:before{display:table;content:\"\"}.row-fluid:after{clear:both}.row-fluid>[class*=span]{float:left;margin-left:4.12765957%}.row-fluid>[class*=span]:first-child{margin-left:0}.row-fluid>.span24{width:99.99999998%}.row-fluid>.span23{width:95.74468083%}.row-fluid>.span22{width:91.48936168%}.row-fluid>.span21{width:87.23404253%}.row-fluid>.span20{width:82.97872339%}.row-fluid>.span19{width:78.72340424%}.row-fluid>.span18{width:74.46808509%}.row-fluid>.span17{width:70.21276594%}.row-fluid>.span16{width:65.95744679%}.row-fluid>.span15{width:61.70212765%}.row-fluid>.span14{width:54.4468085%}.row-fluid>.span13{width:53.19148935%}.row-fluid>.span12{width:48.9361702%}.row-fluid>.span11{width:44.68085105%}.row-fluid>.span10{width:40.42553191%}.row-fluid>.span9{width:36.17021276%}.row-fluid>.span8{width:31.91489361%}.row-fluid>.span7{width:27.65957446%}.row-fluid>.span6{width:23.40425531%}.row-fluid>.span5{width:19.14893617%}.row-fluid>.span4{width:14.89361702%}.row-fluid>.span3{width:10.63829787%}.row-fluid>.span2{width:6.38297872%}.row-fluid>.span1{width:2.12765957%}.container-fluid{padding-left:20px;padding-right:20px;*zoom:1}.container-fluid:after,.container-fluid:before{display:table;content:\"\"}.container-fluid:after{clear:both}.mt10,.mt15{margin-top:10px}.pt10{padding-top:10px}.pt15{padding-top:15px}.mb10{margin-bottom:10px}.mb15{margin-bottom:15px}.pb10{padding-bottom:10px}.pb15{padding-bottom:15px}.ml10{margin-left:10px}.ml15{margin-left:15px}.pl10{padding-left:10px}.pl15{padding-left:15px}.mr10{margin-right:10px}.mr15{margin-right:15px}.pr10{padding-right:10px}.pr15{padding-right:15px}.btn{height:44px;margin-bottom:0;border:1px solid #0070ba;border-radius:5px;*margin-left:.3em;display:inline-block;*display:inline;*zoom:1;background-color:#0070ba;transition:background-color .4s ease-out 0s;font-size:1em;font-weight:700;line-height:42px;color:#fff;text-align:center;vertical-align:middle;cursor:pointer;outline:none;-webkit-font-smoothing:antialiased}.btn .btn-secondary{-webkit-font-smoothing:auto}.btn:focus,.btn:hover{background-color:#005ea6}.btn:focus{text-decoration:underline}.btn.active,.btn:active{background-color:#005ea6;outline:0}.btn.disabled,.btn[disabled]{background-color:#b2d9ea;border-color:#b2d9ea;cursor:default}.btn.firstHalf{float:left}.btn.firstHalf,.btn.secondHalf{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box}.btn.secondHalf{float:right}a.btn:focus,a.btn:hover{color:#fff}.btn:first-child{*margin-left:0}.btn-large{padding:8px 15px;font-size:18px;line-height:normal;border-radius:5px}.btn-small{padding:5px 9px;font-size:11px;line-height:16px}.btn-mini{padding:2px 6px;font-size:11px;line-height:14px}.btn-secondary{border-style:solid;border-color:#e1e7eb;color:#393f44;background-color:#e1e7eb}.btn-secondary:hover{color:#393f44;border-color:#edf2f5;background-color:#edf2f5;text-decoration:none}.btn-secondary:active,.btn-secondary:focus{border-color:#c5ccd1;background-color:#c5ccd1;text-decoration:underline}.btn-secondary.disabled,.btn-secondary[disabled]{color:#393f55}a.btn-secondary:active,a.btn-secondary:focus,a.btn-secondary:hover{color:#393f44;border-color:#c5ccd1;background-color:#c5ccd1}a.btn-secondary.disabled,a.btn-secondary[disabled]{color:#393f55;background-color:#e7edf0}button.btn,input[type=submit].btn{*padding-top:2px;*padding-bottom:2px}button.btn::-moz-focus-inner,input[type=submit].btn::-moz-focus-inner{padding:0;border:0}button.btn.btn-large,input[type=submit].btn.btn-large{*padding-top:7px;*padding-bottom:7px}button.btn.btn-small,input[type=submit].btn.btn-small{*padding-top:3px;*padding-bottom:3px}button.btn.btn-mini,input[type=submit].btn.btn-mini{*padding-top:1px;*padding-bottom:1px}#largeScreenAccountCreation .buttons #backButton,section .buttons #backButton{width:30%}#largeScreenAccountCreation .buttons #proceedButton,section .buttons #proceedButton{width:65%}#largeScreenAccountCreation .buttons #proceedButton-venmoBA,#largeScreenAccountCreation .buttons #proceedButton.full,section .buttons #proceedButton-venmoBA,section .buttons #proceedButton.full{width:100%}.custom-select-container,select.replaced{position:relative}select.replaced{z-index:8;width:100%;height:44px;border:0;line-height:2;opacity:0;filter:alpha(opacity=0)}.custom-select{position:absolute;top:0;left:0;z-index:1;width:100%;transition:border-color .3s ease 0s;border-radius:5px}.custom-select,.custom-select>span{display:block;background-clip:padding-box}.custom-select>span{padding:7px 30px 7px 13px;border:1px solid #ccd0d4;border-radius:5px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:right -7px top -1178px;color:#000;line-height:28px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.disabled .custom-select>span{background-position:right -7px top -6990px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat right 10px center;background-size:16px;color:#c72e2e;border:1px solid #c72e2e}.custom-select span span{display:block;overflow:hidden;height:28px;text-overflow:ellipsis;white-space:nowrap;font-size:1em}.custom-select.active>span{border:1px solid #009cde;outline:0}#task .custom-select{border-radius:5px;background-clip:padding-box}.mobile .dob label{position:static;top:0;left:0}input[type=date]{padding:5px 38px 3px 6px;border:1px solid #ccd0d4;border-radius:5px;background-clip:padding-box;color:#333;background-size:24px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_cart_icons.png\") no-repeat 100% 61%}input[type=date]:focus{border-color:#39f}.showDropdopwnLabels .labelText{float:left;color:#aaa}.showDropdopwnLabels .valueText{float:right;min-width:90px}@media (min-width:0) and (max-width:40em){.showDropdopwnLabels .labelText{display:none}.showDropdopwnLabels .valueText{float:none;min-width:0}}.multiline-select-container{outline:0 none}.multiline-select-container:active .innerContainer,.multiline-select-container:focus .innerContainer{border-color:#009cde}.multiline-select-container.open:active .innerContainer,.multiline-select-container.open:focus .innerContainer{border-color:#ccd0d4}.multiline-select-container option,.multiline-select-container select{position:absolute!important;left:-9999px}.multiline-select-container .custom-select{position:relative}.multiline-select-container .custom-select span span{height:auto;white-space:normal}.multiline-select-container .custom-select>span{background:none}.multiline-select-container.open .custom-select>span{border-radius:5px 5px 0 0;border-bottom-color:#eee}.multiline-select-container .arrow{background-clip:padding-box;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_forms.png\");background-position:left -8px top -1198px;background-repeat:no-repeat;height:10px;position:absolute;width:14px;top:40%;right:12px}.backendError .multiline-select-container .ng-invalid+.custom-select .arrow,.validated .multiline-select-container .ng-invalid+.custom-select .arrow{display:none}.multiline-select-list{position:absolute;list-style:none;margin:0;background-color:#fff;z-index:1000;border-radius:0 0 5px 5px;border-bottom:1px solid #ccd0d4;max-height:200px;overflow:auto;box-shadow:0 -1px 1px 0 #ccc}.multiline-select-list li{padding:10px;border:1px solid;border-color:#eee #ccd0d4;border-top:0 none;cursor:pointer;line-height:1.35em;vertical-align:middle}.multiline-select-list li:active,.multiline-select-list li:focus,.multiline-select-list li:hover{background-color:#e5f5fc;outline:0 none}.multiline-select-list li:first-of-type{border-top:0 none}.multiline-select-list li:last-of-type{border-bottom:0 none}.multiline-select-list:hover li:focus{background-color:#fff}.multiline-select-list:hover li:focus:active,.multiline-select-list:hover li:focus:hover{background-color:#e5f5fc}#midflash,.accessAid{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}body{-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#fff}a{text-decoration:none;-webkit-tap-highlight-color:rgba(0,0,0,.2)}a:focus,a:hover{color:#005ea6;text-decoration:underline;outline:none}a.dashed{text-decoration:none;border-bottom:1px dashed #0070ba;font-size:.9em}[tabindex=\"-1\"]{outline:none}em{font-style:normal;font-weight:700}fieldset{margin:0;padding:0;border:0}fieldset legend{padding-bottom:.5em;font-size:1.5em}section:focus{outline:none}.show-section{display:block}hr.faded{width:100%;height:1px;margin:10px 0;border:0;background-image:-o-linear-gradient(left,transparent,rgba(0,0,0,.75),transparent)}.alpha{font-size:1.5em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin:.5em 0;line-height:1.154em}#loginSection h1.alpha{max-width:240px}.asideAlpha{font-size:1.44em}aside .aside .header.noButtons .walletHeading{text-align:center;line-height:1.05em}.beta{font-size:1.54em;color:#2c2e2f;font-weight:lighter;line-height:1.2em}.gamma{font-size:1.3em}.gamma,.zeta{font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin-bottom:.75em}.zeta{font-size:1.25em}.delta{font-size:1.1em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;margin-bottom:12px;font-weight:400}.vprop-header{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin:10px 0;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.vprop-content,.vprop-header{color:#2c2e2f;font-weight:lighter;line-height:1.2em}.vprop-content{font-size:1em;font-family:HelveticaNeue,helvetica,arial,sans-serif}.vprop-image{margin-top:25px}.eta{font-size:1.1em}.eta,.theta{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400}.theta{font-size:1em}.value-prop-title{color:#2c2e2f;font-size:24px;font-weight:lighter;margin:10px 0}.props{padding:0 0 0 5px;clear:both;text-align:center}.props li,.props p{line-height:1.154em;font-size:.9em;font-weight:400;line-height:1.2em;margin:5px 0}.secondary{color:#6c7378;font-size:.85em}.legal{color:#6c7378;font-size:.75em;line-height:1.154em}.legal a{font-weight:700}.mu{font-size:2.46em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-weight:400;text-shadow:0 1px 0 #fff;color:#0079c1}.noHead{margin-top:0}.noBottom{margin-bottom:0}.showTray #task{overflow:hidden;margin-left:0}#spinner,.hide{display:none}.clearfix,.loading #spinner,.media .img img,html[xmlns] .clearfix{display:block}#billingToggleLink{display:inline-block}.left{float:left}.right{float:right}.center{text-align:center}.outerWrapper{position:relative;border-radius:5px;background-clip:padding-box;background-color:#fff}header{z-index:2}.framed #wrapper,html.framed{border-radius:5px;background-clip:padding-box}html.framed .trayOpen #main{height:585px}html.framed .trayOpen .asideContent{height:495px}body>iframe,body>img{display:none}#wrapper{margin:0 auto;max-width:780px;border:1px solid #e3e3e3;border-radius:5px;overflow-y:visible;outline:none}#wrapper,#wrapper #header{-ms-box-sizing:border-box;box-sizing:border-box;background-clip:padding-box;position:relative;background-color:#fff}#wrapper #header{border-radius:5px 5px 0 0;width:100%;z-index:4;box-shadow:0 0 3px 0}#contents{position:relative;z-index:1}.active #wrapper{visibility:visible;-webkit-animation-duration:.4s;-webkit-animation-timing-function:ease;-webkit-animation-name:slideUp}#logo{margin:22px 0 0 20px}.container{clear:both;padding:20px}.containerNoHead{padding-top:0}.noPaddingBottom{padding-bottom:0}.noPaddingTop{padding-top:0}.subContainer{border-top:1px solid #e3e3e3;padding:20px 0;position:relative}#proceedButton{width:46.4%;-ms-box-sizing:border-box;box-sizing:border-box;float:right}#proceedButton.full{width:100%}#proceedButton:focus{color:#fff}#backButton{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box;float:left}#backButton:focus,#backButton:hover{color:#2c2e2f}.middleName{display:none;float:right}.h2,h2{font-size:1.2em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin-top:0;font-weight:400;color:#0666b3}.clearfix:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}* html .clearfix{height:1%}#sliding-area{overflow:hidden}#main{padding:25px 30px 15px;transition:margin .3s ease-out;width:100%;float:right;-ms-box-sizing:border-box;box-sizing:border-box}.loading #main{background:none}.bmlLoadingMessage,.loginLoadingMessage,.loginProcessing .genericLoadingMessage{display:none}.loginProcessing .loginLoadingMessage{display:block}.full{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;text-decoration:none}.trayInner{padding:20px 0}.disclaimer{font-size:.75em;color:#6c7378}.reviewMsg{margin-top:10px;line-height:1.5}.infoTxt{clear:both;padding-top:10px}.help{color:#a9a9a9}.keyValue label{color:#292929}.frontArrow{position:absolute;display:inline-block;width:9px;height:15px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-196px -177px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.frontArrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.focusableIcon:focus{box-shadow:0 0 1px #6c7378}input[type=button],input[type=submit]{-webkit-appearance:none}.inputField input[disabled=disabled],.inputField input[disabled=disabled]:active,input[disabled=disabled]{background:#f7f9fa;border:1px solid #cbd2d6;color:#6c7378}input::-ms-clear{display:none}input.link:hover{cursor:pointer}input.xsmall{width:2em}input.small{width:3.35em;font-size:1em}input.medium{width:7em}input.large{width:14em}input.xlarge{width:20em}.button-as-link{margin:0;padding:0;border:none;width:auto;font-size:.85em;background:transparent;color:#0070ba;cursor:pointer}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.buttons{margin-top:15px;margin-bottom:15px;overflow:hidden}.inputField{position:relative}.inputField input,.inputField label{display:block;vertical-align:top}.ignoreValidation .inputField.error input,.inputField input,.validated .ignoreValidation .inputField input.backendError,.validated .ignoreValidation .inputField input.ng-invalid{width:100%;height:44px;padding:0 14px;border-radius:5px;background-clip:padding-box;border:1px solid #c5ccd1;color:#000;transition:border-color .3s ease 0s;-ms-box-sizing:border-box;box-sizing:border-box;background:none}.ignoreValidation .inputField.error input::-webkit-input-placeholder,.inputField input::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.backendError::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-webkit-input-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-moz-placeholder,.ignoreValidation .inputField.error input::-moz-placeholder,.inputField input:-moz-placeholder,.inputField input::-moz-placeholder,.validated .ignoreValidation .inputField input.backendError:-moz-placeholder,.validated .ignoreValidation .inputField input.backendError::-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-moz-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-ms-input-placeholder,.inputField input:-ms-input-placeholder,.validated .ignoreValidation .inputField input.backendError:-ms-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-ms-input-placeholder{color:#6c7378}.inputField input:active,.inputField input:focus{border:1px solid #009cde;outline:0}.inputField select{font-size:1.5em;margin-bottom:10px}.custom-select-container select{font-size:15px}.inputField label{position:absolute;top:14px;left:14px;cursor:text;text-align:left;color:#666;font-size:1em}.no-js .dropdown label,.no-js .inputField label{position:static}.fieldGroup .inputField{float:left;padding:0 .5em 0 0}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.inputField.error input::-webkit-input-placeholder,.validated .inputField input.backendError::-webkit-input-placeholder,.validated .inputField input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.inputField.error input:-moz-placeholder,.inputField.error input::-moz-placeholder,.validated .inputField input.backendError:-moz-placeholder,.validated .inputField input.backendError::-moz-placeholder,.validated .inputField input.ng-invalid:-moz-placeholder,.validated .inputField input.ng-invalid::-moz-placeholder{color:#c72e2e}.inputField.error input:-ms-input-placeholder,.validated .inputField input.backendError:-ms-input-placeholder,.validated .inputField input.ng-invalid:-ms-input-placeholder{color:#c72e2e}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}.inputField.valid input{background:#fff url(https://www.paypalobjects.com/images/checkout/hermes/icon_checkmark_wallet_2x.png) no-repeat 98%;background-size:14px}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.creditCardField.valid input{background:#fff}.dropdown.error select,.inputField.error select{border:1px solid #c72e2e}.selectLabel{display:block}input::-webkit-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:1em}input:-moz-placeholder,input::-moz-placeholder{color:#6c7378;opacity:1;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}input:-ms-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.checkbox input[type=checkbox]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.checkbox input[type=checkbox]~label,.checkbox input[type=checkbox]~label.bgImgOnSpan span.bgImg{display:inline-block;position:static;min-height:25px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px 0;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.checkbox input[type=checkbox]~label,.checkbox input[type=checkbox]~label.bgImgOnSpan span.bgImg{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.checkbox input[type=checkbox]~label.bgImgOnSpan span.bgImg{display:block;float:left;width:0;height:25px;margin-left:-35px}.checkbox input[type=checkbox]~label.bgImgOnSpan{background-image:none}.checkbox.error input[type=checkbox]:focus~label,.checkbox.error input[type=checkbox]:focus~label.bgImgOnSpan span.bgImg,.checkbox.error input[type=checkbox]~label,.checkbox.error input[type=checkbox]~label.bgImgOnSpan span.bgImg{background-position:-9px -600px}.checkbox input[type=checkbox]:checked~label,.checkbox input[type=checkbox]:checked~label.bgImgOnSpan span.bgImg{background-position:-9px -400px}.checkbox input[type=checkbox]:focus:checked~label,.checkbox input[type=checkbox]:focus:checked~label.bgImgOnSpan span.bgImg{background-position:-9px -4801px}.checkbox input[type=checkbox]:focus~label,.checkbox input[type=checkbox]:focus~label.bgImgOnSpan span.bgImg{background-position:-9px -4601px}.checkbox input[type=checkbox][disabled=disabled]~label,.checkbox input[type=checkbox][disabled=disabled]~label.bgImgOnSpan span.bgImg{background-position:-9px -800px}.checkbox input[type=checkbox][disabled=disabled]:checked~label,.checkbox input[type=checkbox][disabled=disabled]:checked~label.bgImgOnSpan span.bgImg{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:25px 25px}.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label.bgImgOnSpan span.bgImg,.validated .ignoreValidation input[type=checkbox].ng-invalid~label,.validated .ignoreValidation input[type=checkbox].ng-invalid~label.bgImgOnSpan span.bgImg{background-position:-9px 0}.validated .ignoreValidation .sCheckbox.checkbox input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation .sCheckbox.checkbox input[type=checkbox].ng-invalid:focus~label.bgImgOnSpan span.bgImg,.validated .ignoreValidation .sCheckbox.checkbox input[type=checkbox].ng-invalid~label,.validated .ignoreValidation .sCheckbox.checkbox input[type=checkbox].ng-invalid~label.bgImgOnSpan span.bgImg{background-position:-9px 2600px}.validated input[type=checkbox].ng-invalid~label,.validated input[type=checkbox].ng-invalid~label.bgImgOnSpan span.bgImg{background-position:-9px -600px}.validated input[type=radio].ng-invalid+label,.validated input[type=radio].ng-invalid+label.bgImgOnSpan span.bgImg,.validated input[type=radio].ng-invalid:focus+label,.validated input[type=radio].ng-invalid:focus+label.bgImgOnSpan span.bgImg{background-position:-10px -2200px}.validated .sCheckbox.checkbox input[type=checkbox].ng-invalid~label,.validated .sCheckbox.checkbox input[type=checkbox].ng-invalid~label.bgImgOnSpan span.bgImg{background-position:-9px -3200px}.sCheckbox.checkbox{position:relative}.sCheckbox.checkbox input[type=checkbox]~label,.sCheckbox.checkbox input[type=checkbox]~label.bgImgOnSpan span.bgImg{line-height:19px;padding-left:27px;font-size:.85em;background-position:-9px -2600px}.sCheckbox.checkbox input[type=checkbox]~label.bgImgOnSpan span.bgImg{display:block;float:left;width:0;height:19px;margin-left:-27px}.sCheckbox.checkbox input[type=checkbox]~label.bgImgOnSpan{background-image:none}.sCheckbox.checkbox.error input[type=checkbox]:focus~label,.sCheckbox.checkbox.error input[type=checkbox]:focus~label.bgImgOnSpan span.bgImg,.sCheckbox.checkbox.error input[type=checkbox]~label,.sCheckbox.checkbox.error input[type=checkbox]~label.bgImgOnSpan span.bgImg{background-position:-9px -3200px}.sCheckbox.checkbox input[type=checkbox]:checked~label,.sCheckbox.checkbox input[type=checkbox]:checked~label.bgImgOnSpan span.bgImg{background-position:-9px -3000px}.sCheckbox.checkbox input[type=checkbox]:focus:checked~label,.sCheckbox.checkbox input[type=checkbox]:focus:checked~label.bgImgOnSpan span.bgImg{background-position:-9px -5409px}.sCheckbox.checkbox input[type=checkbox]:focus~label,.sCheckbox.checkbox input[type=checkbox]:focus~label.bgImgOnSpan span.bgImg{background-position:-9px -2800px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]~label,.sCheckbox.checkbox input[type=checkbox][disabled=disabled]~label.bgImgOnSpan span.bgImg{background-position:-9px -3400px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]:checked~label,.sCheckbox.checkbox input[type=checkbox][disabled=disabled]:checked~label.bgImgOnSpan span.bgImg{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:18px 19px}.radioButton input[type=radio]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.radioButton input[type=radio]~label{display:inline-block;min-height:26px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px -1600px;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.radioButton input[type=radio]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.radioButton.error input[type=radio]+label,.radioButton.error input[type=radio]:focus+label{background-position:-9px -2200px}.radioButton.warning input[type=radio]+label,.radioButton.warning input[type=radio]:focus+label{background-position:-9px -7405px}.radioButton input[type=radio]:checked+label{background-position:-9px -2000px}.radioButton input[type=radio]:focus:checked+label{background-position:-9px -6010px}.radioButton input[type=radio]:focus+label{background-position:-9px -1800px}.inputField label.nolap{position:relative;top:auto;left:auto;color:#2c2e2f}.inputField.half{width:48.15%;margin-right:3.7%;padding-right:0}.multistepSignupForm .inputField.half,.singlePagePaymentForm .inputField.half{width:48.7%;margin-right:2.6%;padding-right:0}.inputField.half.issueNo{width:42%;margin-top:15px}.inputField.half.startDate{width:54%;margin-right:10px}#cardIssueInfo .inputField.half.startDate{width:48%;margin-right:0}#cardIssueInfo .inputField.half.issueNo{width:48%;margin-top:0;float:right}#cardIssueInfo .inputField.half.issueNo:before{content:\"\\200C\"}.inputField.half.last-child{margin-right:0}.fieldGroup .inputField.last-child{padding-right:0}.fidobDay{width:30%;float:left}.fidobDay .custom-select>span{border-radius:5px 0 0 5px;border-right:0}.fidobMonth{width:30%;float:left}.fidobMonth .custom-select>span{border-radius:0}.fidobYear{width:40%;float:left}.fidobYear .custom-select>span{border-radius:0 5px 5px 0;border-left:0}.cardDOB{width:100%;clear:both}.dobLabel{top:auto;left:auto;position:relative;display:block;bottom:4px}.dobTXT{margin-top:10px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}}.submitted input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.submitted input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.submitted input.ng-invalid:-moz-placeholder,.submitted input.ng-invalid::-moz-placeholder{color:#c72e2e}.submitted input.ng-invalid:-ms-input-placeholder{color:#c72e2e}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.submitted input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}.merchantHeader{height:90px;margin:0 auto}.merchantHeader .headerWrapper{max-width:780px;margin:0 auto;overflow:hidden;max-height:90px;line-height:90px}.merchantHeader .merchantName{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400;width:575px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block}.merchantHeader img{vertical-align:middle}.paypalHeaderWrapper .logo{float:left;width:112px;height:29px;margin-top:5px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.paypalHeaderWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.paypalHeaderWrapper .span14{padding-bottom:20px;border-bottom:1px solid #dbdbdb}.paypalHeaderWrapper .cartContainer{position:static;line-height:29px}.paypalHeaderWrapper .transctionCartDetails{z-index:2}.paypalHeaderWrapper.paypalCredit .logo{height:35px;background-position:0 -129px}.aside .header{padding:15px;vertical-align:middle;line-height:50px;border-bottom:1px solid #e3e3e3}.aside .header.tall{min-height:65px;line-height:normal;padding:13px 15px 10px;margin-bottom:0}.aside .asideAlpha{padding:0 30px;text-align:center;line-height:1.2em}.aside .walletHeading{text-align:center}.aside .close{top:10px;right:15px;padding:5px;border-radius:3px}.aside .close,.aside .close:before{position:absolute;width:19px;height:19px}.aside .close:before{content:\"\";display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .close:focus:before,.aside .close:hover:before{background-position:-223px -22px}.aside .backArrow{position:absolute;top:10px;left:15px;width:9px;height:18px;padding:5px;border-radius:3px}.aside .backArrow:before{content:\"\";display:inline-block;position:absolute;width:9px;height:18px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -46px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .backArrow:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .backArrow:focus:before,.aside .backArrow:hover:before{background-position:-232px -68px}.aside .addOptions{margin-top:20px}.aside .addOptions h2{float:left;width:70%;margin-bottom:0}.aside .addOptions a{float:right;display:block;line-height:1.9em;font-size:.85em}.aside .subHeader{margin-top:20px}.CYCOPage .paypalHeader.span14,.pageSepaAgreementContingency .paypalHeader.span14,.pageSepaMandate .paypalHeader.span14,.pageSepaMandateContingency .paypalHeader.span14{width:100%}#mobileMerchantHeader{display:none}@media (max-width:41.3125em){.merchantHeader{display:none}.paypalHeaderWrapper{height:65px}.paypalHeaderWrapper .cartContainer{margin-top:10px;margin-bottom:-5px;margin-right:15px}.paypalHeaderWrapper .logo{margin:15px 0 0 30px}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}}@media (max-width:30em) and (min-width:0){.paypalHeaderWrapper .cartContainer{margin-top:15px;margin-bottom:-10px;margin-right:0}.paypalHeaderWrapper .logo{margin:15px 0 0}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}.header{height:55px}.aside .header{height:auto}.aside .close{right:15px}}.footer{max-width:780px;margin:10px auto;font-size:.75em}.cancelUrl{float:left;width:39%}.micaLender{display:none;color:#2c2e2f;clear:both}.footerWrapper table{display:inline;float:left;table-layout:fixed;border:none;width:75%}.footerWrapper td,.footerWrapper th,.footerWrapper tr{border:none;font-weight:400;padding-bottom:0;padding-top:0;text-align:left}.footerWrapper .footerLinks th{color:#6c7378}.footerWrapper .footerLinks th.feedbackLink{color:#0070ba}.footerWrapper .footerLinks .underline th{border-bottom:1px solid #ccc}.footerLinks{margin:0;display:inline-block}.footerLinks a{color:#6c7378}.footerLinks a.feedbackLink{color:#0070ba;margin-left:5px}.footerLinks th,td{border:none}.copyright{display:inline;width:auto;vertical-align:top;color:#6c7378}.secureIcon{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:0 -33px;margin-left:3px;margin-right:3px;margin-top:3px;width:10px;height:12px;vertical-align:top}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.secureIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.poweredBy{float:right;margin-top:-49px}.poweredBy .text{float:left;margin-top:8px;margin-right:8px;font-size:12px;font-weight:400;font-style:italic;color:#6c7378}.footerLinks li{padding:0 12px 0 0;display:inline-block}.footerLinks .last{padding-right:18px;border-right:none}.footer .policyInfoWrapper p{line-height:1.3em}.footer .policyInfoWrapper p a{font-weight:700}.minibrowser .APAC.footer,.minibrowser.AU .footer{position:relative;bottom:0;width:auto}.minibrowser .APAC.footer .policyInfoWrapper,.minibrowser.AU .footer .policyInfoWrapper{padding:0}.minibrowser .cancelUrl{display:none}.minibrowser .footerWrapper{padding:0 10px;float:none;width:95%;margin:0}.minibrowser .footerLinks li{padding:0 5px 0 0}.DE .footerWrapper,.fr.CA .footerWrapper,.fr.FR .footerWrapper{float:none;width:auto}.DE .footerWrapper:after,.fr.CA .footerWrapper:after,.fr.FR .footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.DE .footerLinks,.fr.CA .footerLinks,.fr.FR .footerLinks{float:left;width:70%;text-align:left}.DE .footerLinks li:first-child,.fr.CA .footerLinks li:first-child,.fr.FR .footerLinks li:first-child{padding-left:0}.DE .copyright,.fr.CA .copyright,.fr.FR .copyright{float:right;width:30%;margin:0}.DE .cancelUrl,.fr.CA .cancelUrl,.fr.FR .cancelUrl{float:none;margin:5px 0;width:100%}.APAC .policyInfoWrapper{padding:5px 0 10px;color:#6c7378}.APAC .policyInfoWrapper p.moreInfo{padding:15px 0 20px;float:left;line-height:1.3em}.AU .policyInfoWrapper,.en_AU .policyInfoWrapper{padding:20px 0 10px;color:#6c7378}.AU .policyInfoWrapper p.moreInfo,.en_AU .policyInfoWrapper p.moreInfo{padding:15px 0 20px;border-bottom:1px solid #ccc;float:left}.AU .policyInfoWrapper p.moreCopyRight,.en_AU .policyInfoWrapper p.moreCopyRight{padding:5px 0 0;clear:both}.fr_XC .footerWrapper{float:left;width:70%;text-align:left;padding-left:0;margin-left:-7px}@media (max-width:41.25em){.footer{border-top:1px solid #ccc;padding:5px 20px;margin-top:10px}.footer .policyInfoWrapper{padding:0 10px}.footerWrapper{float:none;width:100%;padding:0;margin:0}.footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.cancelUrl{width:95%;padding:0}.footerLinks{float:left;width:70%;text-align:left}.footerLinks .feedback{display:none}.minibrowser .footerLinks .feedback{display:inline-block}.copyright{width:20%}.cancelUrl{float:none;margin:5px 0}}@media (max-width:30em) and (min-width:0){.footer{margin-top:0;padding:5px 10px}.footer .policyInfoWrapper{padding:0}.cancelUrl,.footerWrapper{padding:0;margin:5px 0;width:100%}.DE .footerLinks,.footerLinks,.fr.FR .footerLinks{width:65%}.DE .footerLinks li,.footerLinks li,.fr.FR .footerLinks li{padding:0;margin-right:10px}.DE .footerLinks li.last,.footerLinks li.last,.fr.FR .footerLinks li.last{margin-right:0}.DE .footerLinks .feedback,.footerLinks .feedback,.fr.FR .footerLinks .feedback{display:none}.copyright,.DE .copyright{width:33%;margin:0}.minibrowser .copyright{margin-right:0;width:30%}.minibrowser .footerLinks .feedback{display:inline-block}}.modal-open{overflow:hidden}.modal-open #contents,.modal-open #wrapper,.modal-open .outerWrapper{position:static}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:140;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop,.modal-backdrop.fade.in{opacity:.54}.modal{display:none;overflow:auto;overflow-y:scroll;position:fixed;top:0;right:0;bottom:0;left:0;z-index:150}.modal.fade .modal-wrap{-webkit-transform:translateY(-25%);transform:translateY(-25%);transition:transform .3s ease-out}.modal.fade.in .modal-wrap{-webkit-transform:translate(0);transform:translate(0)}.modal-wrap{position:relative;margin:10px;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.3);border-radius:6px;background-clip:padding-box;box-shadow:0 3px 9px rgba(0,0,0,.3);outline:none}.modal-header{padding:9px 15px;border-bottom:1px solid #eee}.modal-header .close{margin-top:2px}.modal-header h3{margin:0;line-height:30px}.modal-body{position:relative;overflow-y:auto;max-height:400px;padding:15px}.modal-footer,.modal-form{margin-bottom:0}.modal-footer{padding:14px 15px 15px;text-align:right;background-color:#f5f5f5;border-top:1px solid #ddd;border-radius:0 0 6px 6px;background-clip:padding-box;box-shadow:inset 0 1px 0 #fff}.modal-footer:after,.modal-footer:before{display:table;content:\"\";line-height:0}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.spinner{height:100%;width:100%;position:absolute;z-index:10}.spinner .spinWrap{width:200px;height:100px;position:absolute;top:50%;left:50%;margin-left:-100px;margin-top:-50px}.spinner .spinnerImage{margin:28px 0 0 -25px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/icon_ot_spin_lock_skinny.png\") no-repeat}.spinner .loader,.spinner .spinnerImage{height:100px;width:100px;position:absolute;top:0;left:50%;opacity:1;filter:alpha(opacity=100)}.spinner .loader{margin:0 0 0 -55px;background-color:transparent;-webkit-animation:rotation .7s infinite linear;animation:rotation .7s infinite linear;border-left:5px solid #cbcbca;border-right:5px solid #cbcbca;border-bottom:5px solid #cbcbca;border-top:5px solid #2380be;border-radius:100%}.spinner .bmlLoadingMessage,.spinner .genericLoadingMessage,.spinner .loginLoadingMessage{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;margin-top:125px;text-align:center;z-index:100}.spinner.preloader{position:fixed;top:0;left:0;z-index:1000;background-color:#fff}@-webkit-keyframes rotation{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(359deg)}}@keyframes rotation{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.aside{min-height:380px}.aside .container{padding:15px}.asideContent{height:100%}.centerText{text-align:center}.fsIcons{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;min-width:32px;width:25px;height:21px;padding-right:5px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.BALANCE .fsIcons,.DELAYED_TRANSFER .fsIcons,.HOLDING .fsIcons{background-position:0 0}.ELO .fsIcons{background-position:0 -479px}.HIPER .fsIcons{background-position:0 -458px}.HIPERCARD .fsIcons{background-position:0 -500px}.pinlessGlyphIcon{display:inline-block;position:relative;top:-5px;left:-8px;width:32px;height:20px;font-size:3.1rem;padding-right:5px}.BANK .fsIcons,.BANK_ACCOUNT .fsIcons,.IACH .fsIcons{background-position:0 -252px;height:19px;left:19px}.ECHECK .fsIcons,.ELV .fsIcons,.TAB.DELAYED_TRANSFER .fsIcons{background-position:0 -252px;height:19px}.TAB.DELAYED_TRANSFER .fsIcons{left:19px}.BILL_ME_LATER .fsIcons,.BML .fsIcons,.CREDIT_OPTION .fsIcons,.PPCREDIT .fsIcons{background-position:0 -105px}.PAYPAL_SMART_CONNECT .fsIcons{background-position:0 0}.VISA .fsIcons{background-position:0 -21px}.MASTERCARD .fsIcons{background-position:0 -42px}.AMEX .fsIcons{background-position:0 -63px;left:19px;height:20px}.DISC .fsIcons,.DISCOVER .fsIcons{background-position:0 -84px}.JCB .fsIcons{background-position:0 -353px}.CHINA_UNION_PAY .fsIcons{background-position:0 -563px}.ELECTRON .fsIcons{background-position:0 -146px}.MAESTRO .fsIcons,.MSTRO .fsIcons,.SWITCH .fsIcons{background-position:0 -168px}.CB_NATIONALE .fsIcons,.CBN .fsIcons{background-position:0 -210px}.CELEM .fsIcons,.CETELEM .fsIcons{background-position:0 -311px}.COFINOGA .fsIcons,.CONF .fsIcons{background-position:0 -231px}.COFID .fsIcons,.COFIDIS .fsIcons{background-position:0 -437px;left:20px}.INCENTIVE .fsIcons{background-position:0 -271px;height:18px}.PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -374px}.PPSMTCONNECT .fsIcons{background-position:0 0}.ES .PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -521px}.fsIcon{display:block;position:absolute;width:25px;height:21px;left:15px;top:20px;min-width:32px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;background-position:0 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.fsIcon.BANK,.fsIcon.PAD{background-position:6px -252px;height:19px;left:19px}.fsIcon.MASTER,.fsIcon.MASTERCARD,.fsIcon.MCARD{background-position:0 -42px}.fsIcon.ELO{background-position:0 -479px}.fsIcon.HIPER{background-position:0 -458px}.fsIcon.HIPERCARD{background-position:0 -500px}.fsIcon.DISC,.fsIcon.DISCOVER{background-position:0 -84px}.fsIcon.VISA{background-position:0 -21px}.fsIcon.JCB{background-position:0 -353px}.fsIcon.AMEX,.fsIcon.Amex{background-position:6px -63px;left:19px;height:20px}.fsIcon.MAESTRO,.fsIcon.MSTRO,.fsIcon.SWITCH{background-position:0 -168px}.fsIcon.PAYPAL_SMART_CONNECT{background-position:0 0}.fsIcon.CB_NATIONALE,.fsIcon.CBN{background-position:0 -210px}.fsIcon.CELEM,.fsIcon.CETELEM{background-position:0 -311px}.fsIcon.COFID,.fsIcon.COFIDIS{background-position:0 -437px;left:20px;height:20px}.fsIcon.CHINA_UNION_PAY,.fsIcon.CUP{background-position:0 -563px}.fsIcon.COFINOGA,.fsIcon.CONF{background-position:0 -231px}.fsIcon.PAYPAL_EXTRAS_MASTERCARD,.fsIcon.PPXMCARD{background-position:0 -374px}.fsIcon.EBAY_MASTERCARD,.fsIcon.EBAYMCARD{background-position:0 0}.fsIcon.BILL_ME_LATER,.fsIcon .BML,.fsIcon .PPCREDIT{background-position:0 -105px}.fsIcon.PPSMTCONNECT{background-position:0 0}.fsIcon.pinlessIcon{background-image:none;font-size:3.1rem;left:5px;top:14px}.ES .fsIcon.PAYPAL_EXTRAS_MASTERCARD,.ES .fsIcon.PPXMCARD{background-position:0 -521px}.infoIcon{width:19px;height:18px;display:inline-block;position:absolute;top:25px;right:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-89px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.infoIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.addOption{padding:25px 10px;margin:0 0 0 44px;color:#0070ba;font-size:.85em}.plusicon{display:block;position:absolute;left:15px;top:22px;width:20px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.plusicon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.infoIcon+.checkIcon{display:none}.infoMsg{margin:0;overflow:hidden;font-size:.85em}.expiredIcon{background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%;width:16px;height:16px;top:6px}.expiredIcon,.plccIcon{display:inline-block;position:relative}.plccIcon{float:left;height:20px;background:none;width:32px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.fsIcon,.fsIcons{height:20px}}.walletIcons{position:absolute;width:30px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.walletIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons_2x.png\");background-size:90px 970px}}.walletIcons.BANK,.walletIcons.BANK_ACCOUNT{background-position:-50px -460px}.walletIcons.BANK.BOFA,.walletIcons.BANK_ACCOUNT.BOFA{background-position:-50px -10px}.walletIcons.BANK.CHASE,.walletIcons.BANK_ACCOUNT.CHASE{background-position:-50px -130px}.walletIcons.BANK.WELLSFARGO,.walletIcons.BANK_ACCOUNT.WELLSFARGO{background-position:-50px -100px}.walletIcons.BANK.CITI,.walletIcons.BANK_ACCOUNT.CITI{background-position:-50px -40px}.walletIcons.BANK.FIFTHTHIRD,.walletIcons.BANK_ACCOUNT.FIFTHTHIRD{background-position:-50px -220px}.walletIcons.BANK.CAPITAL,.walletIcons.BANK_ACCOUNT.CAPITAL{background-position:-50px -70px}.walletIcons.BANK.AMERITRADE,.walletIcons.BANK_ACCOUNT.AMERITRADE{background-position:-50px -160px}.walletIcons.BANK.SUNTRUST,.walletIcons.BANK_ACCOUNT.SUNTRUST{background-position:-50px -280px}.walletIcons.BANK.USBANK,.walletIcons.BANK_ACCOUNT.USBANK{background-position:-50px -310px}.walletIcons.BANK.USAA,.walletIcons.BANK_ACCOUNT.USAA{background-position:-50px -250px}.walletIcons.CARD.VISA,.walletIcons.PAYMENT_CARD.VISA{background-position:-10px -40px}.walletIcons.CARD.MASTER,.walletIcons.CARD.MASTERCARD,.walletIcons.PAYMENT_CARD.MASTER,.walletIcons.PAYMENT_CARD.MASTERCARD{background-position:-10px -70px}.walletIcons.CARD.DISCOVER,.walletIcons.PAYMENT_CARD.DISCOVER{background-position:-10px -100px}.walletIcons.CARD.AMEX,.walletIcons.PAYMENT_CARD.AMEX{background-position:-10px -130px}hr.sep,hr.sepPlain{padding:0;margin-top:25px;height:auto;border:none;border-top:1px solid #ccc;color:#2c2e2f;text-align:center;overflow:visible}hr.sep:after,hr.sepPlain:after{content:\"or\";display:inline-block;position:relative;top:-.7em;font-size:1em;padding:0 .5em;background:#fff;color:#6c7378;font-weight:400}.de hr.sep:after{content:\"oder\"}.da hr.sep:after{content:\"eller\"}.es hr.sep:after{content:\"o\"}.fr hr.sep:after{content:\"ou\"}.he hr.sep:after{content:\"\\5D0\\5D5\"}.id hr.sep:after{content:\"Atau\"}.it hr.sep:after{content:\"oppure\"}.ja hr.sep:after{content:\"\\307E\\305F\\306F\"}.ko hr.sep:after{content:\"\\B610\\B294\"}.nl hr.sep:after{content:\"of\"}.no hr.sep:after{content:\"eller\"}.pl hr.sep:after{content:\"lub\"}.pt hr.sep:after{content:\"ou\"}.ru hr.sep:after{content:\"\\418\\43B\\438\"}.sv hr.sep:after{content:\"eller\"}.th hr.sep:after{content:\"\\E2B\\E23\\E37\\E2D\"}.tr hr.sep:after{content:\"Veya\"}.zh hr.sep:after{content:\"\\6216\"}hr.sepPlain:after{content:\"\"}@media (min-width:0) and (max-width:23em){#loginSection .xoTitle h1{max-width:10em}}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){body{-webkit-text-size-adjust:100%}.merchantBrand{display:none}.outerWrapper{background-position:left 50px}.centerTray.loginSignup{margin-bottom:60px}#main{padding:0;background:none;z-index:2}#contents{padding:0 20px;-ms-box-sizing:border-box;box-sizing:border-box}.tokenization #contents{padding:0 30px}.paypalHeader{padding:0 20px 20px;-ms-box-sizing:border-box;box-sizing:border-box}.props,header{display:none}.review #wrapper{min-height:512px}#contents{min-height:0;margin-bottom:0}.bmlAppProcessing,.loginProcessing{background-color:#f9f9f9}.loggingIn{margin:0 25px}.mobile .loggingIn{margin:0}.saferEasier,.simpler{display:none}#login .row-fluid{padding-top:0}#login .centerTray{padding:0}#login #signupLink.btn{margin:5px 0}#wrapper{margin:0;width:auto;border-radius:0;background-clip:padding-box;border:none}#task{width:295px}.loading .spinner{background-position-y:35%}.centerTray{width:auto}.accountTerms .tray .inner,.tray .inner{padding:10px}.row-fluid>[class*=span],.signup{width:100%;margin-left:0;float:none}#notifications{width:100%}.delta,.gamma{font-size:1.2em}.inputField label{left:7px;top:13px}.saferEasier{display:none}#fundingInstruments .buttons{height:40px}.cityState select{font-size:14px}.cityState .city{width:100%}.cityState .state{width:55%}.cityState .postalCode{width:40.8%}#tab{margin-top:0;height:125px}.toolTip.whatsthis ul{width:242px;left:9px}.toolTip.whatsthis ul li{font-size:.9em}#expiration.varB .expires{width:49%}#expiration .inputField{padding:0}#expiration .cvc{width:44%;float:right}#expiration.varB .cvc{width:49%}.month{margin-left:46px}.separator{margin-left:5px;margin-top:3px}.year{margin-left:0}#expiration .cardIcon{position:absolute;right:4px}.details{margin-right:2px}.mask #closeButton,.mask #header{display:none}}@media (min-width:30.0625em) and (max-width:41.25em){#notifications,.row-fluid>.span10,.row-fluid>.span12,.row-fluid>.span14{width:100%}.outerWrapper{background-position:left 59px}.props,header{display:none}#wrapper{margin:0;border:none}#main{padding:0}#contents{padding:0 25px}}@media (min-width:41.3125em){.banner{display:block}#wrapper{min-height:0}#wrapper,.footer,.merchantHeader{width:95%}.largeScreen .centerTray{margin-top:0}.signup{margin-bottom:0}#genericError{min-height:375px;background:url(https://www.paypalobjects.com/images/checkout/hermes/scr_cloud_balloon.png) no-repeat bottom}#transactionDetails .merchantName{display:none}}@media (device-height:568px) and (-webkit-min-device-pixel-ratio:2){#contents{min-height:0;margin-bottom:0}.pageLanding #contents{margin:70px auto 40px 0}}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.cardType{display:none}ul.validations li.restriction.active{background:url(https://www.paypalobjects.com/images/checkout/hermes/close3_2x.png) no-repeat 0 2px;background-size:10px}.inputField.error input{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.inputField.error input,.inputField.valid input{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.error .custom-select.active>span,.error .custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}@media only screen and (-webkit-min-device-pixel-ratio:2) and (min-width:41.3125em){#genericError{background-size:640px 242px}}#selectShippingMethod .merchantOptionsStyle{padding-top:2%;padding-bottom:3%}#selectShippingMethod .shippingMethodTitle{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f}#selectShippingMethod #merchantOptions p{display:inline}#selectShippingMethod #merchantOptions .guestMerchantOptions{font-size:.9em;font-weight:400;line-height:1.385em;height:18px;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#7b8388;margin:10px 0}#selectShippingMethod #merchantOptions .zipCodeOptions{color:#7b8388}#selectShippingMethod #merchantOptions .addressOptions,#selectShippingMethod #merchantOptions .zipCodeOptions{font-size:.9em;font-weight:700;line-height:1.385em;margin:10px 0}#selectShippingMethod .shippingMethod{font-size:1.5em;font-weight:400;line-height:1.2em;margin:10px 0}#selectShippingMethod .shippingAmountWithCurrency{font-size:1.5em;font-weight:700;line-height:1.2em;margin:10px 0}#selectShippingMethod .shippingDeliveryTime{font-size:.8em;font-weight:400;line-height:1.2em;margin:10px 0}#selectShippingMethod .pickUpStoreText{font-size:.9em;font-weight:400;line-height:1.2em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;margin:8px 0}#selectShippingMethod .changeShippingMethodEnabled{cursor:pointer;color:#2c2e2f}#selectShippingMethod .changeShippingMethodDisabled{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#cbd2d6;cursor:default;pointer-events:none;text-decoration:none}#selectShippingMethod .normalBackground{background-color:#fff}#selectShippingMethod .processingBackground{opacity:.8;border-radius:2px;background-color:#e1e7eb;color:#cbd2d6}#selectShippingMethod .singleShipping span{color:#dcdcdc}#selectShippingMethod .disableShippingMethod span{color:#cbd2d6}#selectShippingMethod .enableShippingMethod{color:#2c2e2f}#selectShippingMethod #shippingMethodProcessing{vertical-align:middle;font-size:32px;height:10px}#selectShippingMethod #shippingMethodProcessing .loader,#selectShippingMethod #shippingMethodProcessing .spinner{height:25px;width:25px;position:static;display:inline-block}#selectShippingMethod #shippingMethodProcessing .loader{margin:-38px 10px 100px 180px;padding:0;background-color:transparent;border-left:2px solid rgba(0,0,0,.2);border-right:2px solid rgba(0,0,0,.2);border-width:1.5px;border-style:solid;border-color:#2180c0 #fff #fff}#selectShippingMethod .shippingMethodApplyInsuranceContainer{margin-top:10px}", ""]);
	
	// exports


/***/ }),

/***/ "./components/xo-form-components/src/select-shipping-country/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	__webpack_require__("./components/xo-ui-components/src/dropdown/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js");
	
	var _template = __webpack_require__("./components/xo-form-components/src/select-shipping-country/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoSelectShippingCountry', {
	    tag: 'xo-select-shipping-country',
	    template: _template2['default'],
	    props: {
	        shippingAddress: {
	            type: 'var',
	            required: true
	        },
	        disableChangeShippingCountry: {
	            type: 'var',
	            required: false
	        }
	    },
	    actions: {
	        // Return the country list, with the selected address country at the top
	        getList: function getList(address) {
	            var defaultCountryCode = address && address.country || _squid.$locale.country;
	            var countryList = _squid.$locale.metadata.territory;
	            var isDefaultCountry = function isDefaultCountry(country) {
	                return country.code === defaultCountryCode;
	            };
	            var defaultCountry = _squid.$util.find(countryList, isDefaultCountry);
	            var res = countryList.filter(function (country) {
	                return !isDefaultCountry(country);
	            });
	
	            res.unshift(defaultCountry);
	
	            return res;
	        }
	    },
	    lifecycle: {
	        enter: function enter() {
	            var _this = this;
	
	            this.countryList = this.actions.getList(this.props.shippingAddress);
	
	            this.$on('metadataChange', function () {
	                _this.countryList = _this.actions.getList(_this.props.shippingAddress);
	            });
	        }
	    }
	});
	
	
	_squid.$Component;
	
	_squid.$locale;
	
	_squid.$util;
	module.exports = exports['default'];

/***/ }),

/***/ "./components/xo-ui-components/src/dropdown/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(console) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/jquery/dist/jquery.min.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, $) {
	
	    $.fn.dropdown = function () {
	        console.warn('Dropdown deprecated');
	    };
	
	    squid.module('xo-dropdown.directive', ['squid']).directive('xoDropdown', function ($parse, $window, $timeout, $injector, $rootScope, $config, $locale, $experiment, $util, $compile) {
	
	        var userAgent = ($window.navigator || {}).userAgent;
	        var isWinOS = Boolean(userAgent.match(/\(win/i));
	
	        return {
	
	            restrict: 'A',
	
	            scope: {
	                dropdownTextBindVar: '='
	            },
	
	            link: function link($scope, $element, attrs) {
	                var $parentScope = $scope.$parent;
	
	                var $select = $($element);
	
	                var selectInitialValue = '';
	
	                var ngChange = '';
	                // TODO: This html should be refactored out into a template.
	                var $span = $('<span class="custom-select" aria-hidden="true"><span><span></span></span></span>');
	
	                $select.parent().addClass('custom-select-container');
	
	                // Change class names to enable styling of hover/focus states
	                $select.bind('mouseenter', function () {
	                    $span.addClass('active');
	                });
	
	                // Change class names to enable styling of hover/focus states
	                $select.bind('focus', function () {
	                    selectInitialValue = $parse(attrs.ngModel)($parentScope);
	                    $span.addClass('active');
	                });
	
	                // Change class names to enable styling of hover/focus states
	                $select.bind('mouseleave', function () {
	                    $span.removeClass('active');
	                });
	
	                function executeSelectChange() {
	                    // setTimeout here is to ensure activeElement is set before our function executes
	                    $timeout(function () {
	                        var val = $parse(attrs.ngModel)($parentScope);
	                        if (selectInitialValue !== val) {
	                            if (ngChange) {
	                                ngChange($parentScope);
	                            }
	                            selectInitialValue = val;
	                        }
	                    }, 10);
	                }
	
	                if (isWinOS) {
	                    if (attrs['ngChange']) {
	                        ngChange = $parse(attrs.ngChange);
	                        attrs['ngChange'] = '';
	                    }
	
	                    $select.bind('blur', function () {
	                        executeSelectChange();
	                        $span.removeClass('active');
	                    });
	
	                    $select.bind('click', function () {
	                        executeSelectChange();
	                    });
	                } else {
	                    $select.bind('blur', function () {
	                        $span.removeClass('active');
	                    });
	                }
	
	                $select.after($span);
	
	                $select.addClass('replaced');
	
	                if (attrs['default']) {
	                    var defaultOption = document.createElement('option');
	                    defaultOption.innerText = attrs['default'];
	                    $select.append(defaultOption);
	                }
	
	                var match = (attrs.ngOptions || '').match(/in ([\w\.]+)/);
	                // Text Update Method 1(new): ng-bind on variable passed in directive and that is updated in parent/sibling scope
	                if (angular.isDefined($scope.dropdownTextBindVar)) {
	                    var selectTextElement = $span.find('span span');
	                    if (selectTextElement.length) {
	                        $(selectTextElement).attr('ng-bind', 'dropdownTextBindVar');
	                        $(selectTextElement).html($compile(selectTextElement[0])($scope));
	                    }
	
	                    $scope.$watch('dropdownTextBindVar', function (newVal) {
	                        if (document.documentElement.getAttribute('dir') === 'rtl') {
	                            $span.toggleClass('ltrOverride', !$util.hasRTL(newVal));
	                        }
	                    });
	                }
	                // Text Update Method 2(old): jQuery text update on various conditions (not as reliable for me, ran into timing edge cases)
	                else {
	                        var updateCover = function updateCover() {
	                            $timeout(function () {
	                                var text = $select.find(':selected').text().trim();
	                                $span.find('span span').text(text);
	                                if (document.documentElement.getAttribute('dir') === 'rtl') {
	                                    $span.toggleClass('ltrOverride', !$util.hasRTL(text));
	                                }
	                            }, 10);
	                        };
	
	                        $parentScope.$watch(attrs.ngModel, updateCover);
	
	                        $scope.$on('contentChange', updateCover);
	
	                        if (match) {
	                            $parentScope.$watch(match[1], updateCover);
	                        }
	                        // Update cover on arrow key press, for case where menu is not open
	                        // but user is interacting with dropdown (eg. Firefox)
	                        $select.bind('keyup', function (event) {
	                            // Arrow keys are 37 - 40
	                            if (event.which >= 37 || event.which <= 40) {
	                                updateCover();
	                            }
	                        });
	                    }
	
	                toggleOptionsLTROverride();
	                if (match) {
	                    $parentScope.$watch(match[1], function (newVal) {
	                        toggleOptionsLTROverride();
	                    });
	                }
	
	                function toggleOptionsLTROverride() {
	                    if (document.documentElement.getAttribute('dir') === 'rtl') {
	                        $timeout(function () {
	                            var options = $select.find('option');
	                            for (var i = 0; i < options.length; i++) {
	                                $(options.get(i)).toggleClass('ltrOverride', !$util.hasRTL(options.get(i).text));
	                            }
	                        });
	                    }
	                }
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ }),

/***/ "./components/xo-form-components/src/select-shipping-country/template.html":
/***/ (function(module, exports) {

	module.exports = "<span id=\"selectShippingCountry\" feature=\"changeShippingCountry\">\n    <div class=\"dropdown confidential country clearfix inputField\"\n         ng-class=\"{'disabled': props.disableChangeShippingCountry}\" content floating-label-dropdown>\n        <select xo-dropdown name=\"country\" ng-model=\"props.shippingAddress.country\" ng-options=\"country.code as country.name for country in countryList\" id=\"country\" xo-error-tooltip required ng-disabled=\"props.disableChangeShippingCountry\">\n        </select>\n        <label for=\"country\" id=\"countryLabel\">{{ content('common.country') }}</label>\n    </div>\n</span>\n"

/***/ }),

/***/ "./components/xo-address-components/src/add-address/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	
	exports.__esModule = true;
	exports.$xoAddAddressComponent = undefined;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _template = __webpack_require__("./components/xo-address-components/src/add-address/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/jquery/dist/jquery.min.js");
	
	__webpack_require__("../node_modules/noop-loader/index.js!./components/xo-address-components/src/add-address/template.html");
	
	__webpack_require__("./components/xo-ui-components/src/dropdown/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/dropdown-multiline/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js");
	
	__webpack_require__("./components/xo-form-components/src/name-input/directive.js");
	
	__webpack_require__("./components/xo-models/src/address/index.js");
	
	__webpack_require__("./components/xo-form-components/src/zipcode/directive.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoAddAddressComponent = exports.$xoAddAddressComponent = _squid.$Component.extend('$xoAddAddressComponent', {
	
	    tag: 'xo-add-address',
	    template: _template2['default'],
	
	    props: {
	        address: {
	            type: 'var',
	            required: false
	        },
	        isShipping: {
	            type: 'var',
	            required: false
	        },
	        country: {
	            type: 'var',
	            required: false
	        },
	        metadata: {
	            type: 'str',
	            required: false
	        },
	        hideButtonHandler: {
	            type: 'var',
	            required: false
	        },
	        hideCep: {
	            type: 'var',
	            required: false
	        },
	        hideName: {
	            type: 'var',
	            required: false
	        },
	        triggerZipCodeBlur: {
	            type: 'var',
	            required: false
	        },
	        triggerZipCodeKeyPress: {
	            type: 'var',
	            required: false
	        },
	        renderBillingAddCheckbox: {
	            type: 'var',
	            required: false
	        }
	    },
	
	    controller: function controller($scope, $populate, $rootScope, $locale, $window, $feature, $PrefillAddressModel, $MetadataModel) {
	
	        var country = $scope.country || $scope.address && $scope.address.country;
	
	        $scope.country = country;
	        $scope.locale = $locale;
	        $scope.metadata = $MetadataModel.create();
	
	        // If the user changes their shipping/billing address country, fetch that metadata (if needed) and re-render.
	        $scope.$watch('country', function setMetadata() {
	            $scope.metadata.choose($scope.country, $scope.locale.lang);
	        });
	
	        // If the user changes languagle toggle, fetch that metadata (if needed) and re-render.
	        $scope.$on('contentChange', function setMetadata() {
	            $scope.metadata.choose($scope.country, $scope.locale.lang);
	        });
	
	        // this function is used on ids and fors in the template to add 'shipping' or 'billing'
	        // in front of the identifier in camelCase. Use in conjunction with the 'discriminate' directive
	        $scope.addPrefix = function (baseId) {
	            return ($scope.isShipping ? 'shipping' : 'billing') + baseId.replace(/^(.)/, function (match) {
	                return match[0].toUpperCase();
	            });
	        };
	
	        $scope.normalizeCountry = function (countryCode) {
	            return $feature('AddressFormat', countryCode, countryCode) || countryCode;
	        };
	
	        $scope.isAddPreferred = $feature('preferredShipping', false, $scope.country) && $scope.isShipping;
	
	        $scope.isAddressLookupEnabled = $feature('addressLookup', false, $scope.country);
	        var sortStates = $feature('sortStatesForAddress', false, $scope.country);
	
	        $scope.isShowLookupFields = $scope.isAddressLookupEnabled;
	
	        if ($scope.isShowLookupFields) {
	            // Show the Address Lookup Fields only when the hideButtonHandler function is passed by the caller.
	            if ($scope.hideButtonHandler) {
	                $scope.hideButtonHandler(true);
	            } else {
	                $scope.isShowLookupFields = false;
	            }
	        }
	
	        function getSortedStateList() {
	            var states = $locale.content.get(sortStates, {});
	            var statesList = [];
	            _angular2['default'].forEach(states, function (key, value) {
	                statesList.push({
	                    code: value,
	                    sname: key
	                });
	            });
	
	            statesList.sort(function (a, b) {
	                return a.sname.localeCompare(b.sname);
	            });
	            $scope.sortedStatesList = statesList;
	        }
	
	        if (sortStates) {
	            getSortedStateList();
	        }
	
	        $scope.formatZip = function () {
	            var unformatted = $scope.address.postal_code.replace(/[^0-9]/gi, '');
	            var formatted = [['', unformatted.slice(0, 3)], ['-', unformatted.slice(3)]].map(function (x) {
	                return x[1] && x[0] + x[1] || '';
	            }).join('');
	            $scope.address.postal_code = formatted;
	        };
	
	        function getAddress(address) {
	            var COMMA = ', ';
	            var SPACE = ' ';
	            var line1, line2;
	
	            function prefix(str, prefixStr) {
	                if (str) {
	                    return (prefixStr ? prefixStr : '') + str;
	                }
	                return '';
	            }
	
	            if (!address.deliveryAddresses || _angular2['default'].isArray(address.deliveryAddresses) && address.deliveryAddresses.length === 0) {
	                // if deliveryAddresses is not an array or is empty
	                // line would be empty, hence return to caller.
	                return;
	            }
	
	            var array = address.deliveryAddresses;
	            if (array.length > 1) {
	                // populate line2 from the last element
	                line2 = array.pop();
	            }
	            line1 = array.join(COMMA);
	
	            var displayLine1 = line1 + prefix(line2, COMMA);
	            var displayLine2 = prefix(address.city) + prefix(address.state, COMMA) + prefix(address.postal_code, SPACE);
	            var displayLine3 = prefix(address.country);
	
	            return {
	                line1: line1,
	                line2: line2,
	                city: address.city,
	                state: address.state,
	                postal_code: address.postal_code,
	                country: address.country,
	
	                displayLine1: displayLine1,
	                displayLine2: displayLine2,
	                displayLine3: displayLine3,
	
	                dropDownAddress: displayLine1 + prefix(displayLine2, ' \\n ') + prefix(displayLine3, ' \\n ')
	            };
	        }
	
	        function populateAddressFormFields(address) {
	            $scope.address.line1 = address.line1;
	            $scope.address.line2 = address.line2;
	            $scope.address.city = address.city;
	            $scope.address.state = address.state;
	            $scope.address.postal_code = address.postal_code;
	            $scope.address.neighborhood = address.neighborhood;
	        }
	
	        /**
	         * Show error message and display the full-address fields
	         */
	        function populateErrorMessage() {
	            var messages = [];
	            messages.push($scope.locale.content.get('addressBook.lookupError'));
	
	            $scope.lookupFailureMessage = {
	                msgs: messages,
	                type: 'warning'
	            };
	
	            $scope.isShowLookupFields = false;
	            $scope.isLookupFailure = true;
	        }
	
	        function processLookupResult(list) {
	            if (list.length > 1) {
	                // Show drop-down list of all addresses
	                $scope.isLookupSuccess = true;
	                $scope.isShowLookupDropDown = true;
	                $scope.lookupAddressList = list.map(function (addr) {
	                    return getAddress(addr);
	                });
	            } else if (list.length === 1) {
	                // Show single address component
	                $scope.isLookupSuccess = true;
	                $scope.isShowLookupDropDown = false;
	
	                var address = getAddress(list[0]);
	                $scope.singleAddress = address;
	                populateAddressFormFields(address);
	            } else {
	                populateErrorMessage();
	            }
	        }
	
	        if ($scope.address) {
	            $scope.lastPrefilledZip = $scope.address.postal_code;
	        }
	        $scope.prefill = function () {
	            var cepPattern = /^(\d{5}-\d{3}|\d{5}|\d{8})$/;
	            var first_name;
	            var last_name;
	
	            if ($scope.lastPrefilledZip === $scope.address.postal_code || !cepPattern.test($scope.address.postal_code)) {
	                return;
	            }
	
	            if ($scope.isShipping) {
	                first_name = $scope.address.first_name;
	                last_name = $scope.address.last_name;
	            }
	
	            $scope.prefillAddress = new $PrefillAddressModel({
	                id: $scope.token,
	                address: {
	                    country: $scope.address.country,
	                    postal_code: $scope.address.postal_code
	                }
	            });
	
	            $scope.prefillAddress.save({
	                data: $scope.prefillAddress,
	
	                success: function success(result) {
	                    if (result) {
	                        populateAddressFormFields(result);
	                        $scope.lastPrefilledZip = $scope.address.postal_code;
	                        if ($scope.isShipping) {
	                            $scope.address.first_name = first_name;
	                            $scope.address.last_name = last_name;
	                        }
	                    }
	                }
	            });
	        };
	
	        $scope.findAddress = function () {
	            $scope.lookupAddress = $PrefillAddressModel.create($scope.token, {
	                address: {
	                    country: $scope.address.country,
	                    postal_code: $scope.address.postal_code,
	                    house_number: $scope.address.house_number,
	                    building_name: $scope.address.building_name
	                }
	            });
	
	            if (document.querySelector('#lookupZip.ng-invalid')) {
	                document.querySelector('#addressLookupFields').classList.add('validated');
	            } else {
	                $scope.isLookupProcessing = true;
	                $scope.lookupAddress.save({
	                    data: $scope.lookupAddress,
	                    silent: true,
	
	                    success: function success(result) {
	                        processLookupResult(result);
	                        $scope.hideButtonHandler(false);
	                    },
	
	                    contingencies: {
	                        INTERNAL_ERROR: populateErrorMessage
	                    }
	                });
	            }
	        };
	
	        $scope.changeAddressDropDown = function () {
	            populateAddressFormFields($scope.address.selectedAddress);
	        };
	
	        $scope.showFullAddress = function () {
	            $scope.isShowLookupFields = false;
	            $scope.hideButtonHandler(false);
	        };
	
	        /**
	         * Pass an array of group names to retrieve the list of states
	         * e.g. ['england', 'northernIreland', 'scotland', 'wales', 'ukOffshoreDependencies']
	         */
	        var stateNamesInGroup = [];
	        $scope.retrieveStateNamesInGroup = function (groups) {
	            if (stateNamesInGroup.length) {
	                // Angular keeps watching for this method as its used in ng-model, hence return cached data.
	                return stateNamesInGroup;
	            }
	            var content = $locale.content;
	            _angular2['default'].forEach(groups, function (group) {
	                var groupName = content.common[group];
	                var statesList = content[group];
	                _angular2['default'].forEach(statesList, function (value, key) {
	                    stateNamesInGroup.push({
	                        key: key,
	                        value: value,
	                        group: groupName
	                    });
	                });
	            });
	            return stateNamesInGroup;
	        };
	
	        $scope.zipCodeBlur = function () {
	            if ($scope.triggerZipCodeBlur) {
	                $rootScope.$emit('zip_code_blur');
	            }
	        };
	
	        $scope.zipCodeKeyPress = function (event) {
	            if ($scope.triggerZipCodeKeyPress) {
	                $rootScope.$emit('zip_code_keypress', { event: event });
	            }
	        };
	    }
	});
	
	_angular2['default'].module('xo-add-address.directive', ['squid', 'xo-dropdown.directive', 'xo-dropdown-multiline.directive', 'xo-error-tooltip.directive', 'xo-name-input.directive', 'xomodel.address', 'xo-zipcode.directive']).directive('discriminate', function ($timeout, $parse) {
	    // scans through the rendered elements within a container and
	    // applies the supplied discriminator function to all the 'id'
	    // and 'for' attributes. NOTE: Use the string 'baseId' when
	    // entering the expression for the directive.
	    //
	    // e.g. discriminate='someDiscriminator(baseId)'
	    //
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            // wait for the DOM to settle down
	            $timeout(function () {
	                var discriminatorFn = $parse(attrs.discriminate);
	
	                $(element).find('[for],[id],[name]').each(function () {
	                    // apply the discriminator to the attributes
	                    var baseFor = $(this).attr('for');
	                    var baseId = $(this).attr('id');
	                    var baseName = $(this).attr('name');
	
	                    if (baseFor) {
	                        $(this).attr('for', discriminatorFn(scope, { baseId: baseFor }));
	                    }
	
	                    if (baseId) {
	                        $(this).attr('id', discriminatorFn(scope, { baseId: baseId }));
	                    }
	
	                    if (baseName) {
	                        $(this).attr('name', discriminatorFn(scope, { baseId: baseName }));
	                    }
	                });
	            });
	        }
	    };
	});
	_angular2['default'].value("$xoAddAddressComponent", $xoAddAddressComponent);
	_squid.$Component;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "./components/xo-address-components/src/add-address/template.html":
/***/ (function(module, exports) {

	module.exports = "<div id=\"addressForm\" class=\"addressForm\" content ng-class=\"country\">\n\n    <xo-name-input user=\"address\" country=\"{{country}}\" ng-if=\"isShipping && !hideName\"></xo-name-input>\n\n    <div ng-switch=\"normalizeCountry(country)\" discriminate=\"addPrefix(baseId)\" class=\"addressGroup clearfix\">\n\n        <div ng-switch-when=\"BR\">\n            <xo-zipcode id=\"zipcode\" country=\"BR\" zip-code=\"address.postal_code\" zip-label=\"{{content('common.cep')}}\" zip-error-key=\"common.valueInvalid\" done-fn=\"prefill\" ng-if=\"!hideCep\"></xo-zipcode>\n\n            <div name=\"addressFields\" id=\"addressFields\">\n                <div class=\"streetName clearfix\">\n                    <div class=\"inputField confidential line1\" floating-label>\n                        <input type=\"text\" name=\"line1\" id=\"line1\" ng-model=\"address.line1\" value=\"\" maxlength=\"60\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\" xo-error-tooltip required />\n                        <label for=\"line1\" id=\"line1Label\">{{ content('common.streetAddress') }}</label>\n                    </div>\n                    <div class=\"inputField streetNumber\" floating-label>\n                        <input type=\"text\" name=\"streetNumber\" id=\"streetNumber\" ng-pattern=\"/^(?=.*[0-9])([a-zA-Z0-9]+)$/\" ng-model=\"address.streetNumber\" value=\"\" maxlength=\"6\" ariaRequired=\"true\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\" xo-error-tooltip required />\n                        <label for=\"streetNumber\" id=\"streetNumberLabel\">{{ content('common.streetNumber') }}</label>\n                    </div>\n                </div>\n                <div class=\"inputField confidential line2\" floating-label>\n                    <input type=\"text\" name=\"line2\" id=\"line2\" ng-model=\"address.line2\" value=\"\" maxlength=\"50\" autocapitalize=\"off\" autocomplete=\"off\" />\n                    <label for=\"line2\" id=\"line2Label\">{{ content('common.streetAddress2') }}</label>\n                </div>\n                <div class=\"inputField confidential neighborhood\" floating-label>\n                    <input type=\"text\" name=\"neighborhood\" id=\"neighborhood\" ng-model=\"address.neighborhood\" value=\"\" maxlength=\"50\" autocapitalize=\"off\" autocomplete=\"off\" ariaRequired=\"true\" data-error-key=\"common.valueInvalid\" xo-error-tooltip required />\n                    <label for=\"neighborhood\" id=\"neighborhoodLabel\">{{ content('common.neighborhood') }}</label>\n                </div>\n                <div class=\"inputField confidential clearfix\">\n                    <div class=\"inputField confidential city\" floating-label>\n                        <input type=\"text\" name=\"city\" id=\"city\" maxLength=\"100\" ng-model=\"address.city\" value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\"  data-error-key=\"common.valueInvalid\" xo-error-tooltip required />\n                        <label for=\"city\" id=\"cityLabel\">{{ content('common.onlyCity') }}</label>\n                    </div>\n                    <div class=\"dropdown confidential state nullable inputField\" floating-label-dropdown>\n                        <select xo-dropdown name=\"state\" ng-options=\"state.code as state.sname for state in sortedStatesList\" ng-model=\"address.state\" id=\"state\" aria-labelledby=\"stateLabel\" aria-required=\"true\" required >\n                            <option value=\"\">{{ content('common.otherState') }}</option>\n                        </select>\n                        <label for=\"state\" id=\"stateLabel\">{{ content('common.otherState') }}</label>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div ng-switch-when=\"GB\">\n            <!-- start: Show all the fields for Add Address if isShowLookupFields is false -->\n            <div ng-if=\"!isShowLookupFields\">\n                <div ng-if=\"isAddressLookupEnabled\">\n                    <div ng-if=\"isShipping\" class=\"lookupHeading\">\n                        <span class=\"lookupTitle\">{{ content('addressBook.address') }}</span>\n                    </div>\n                    <div ng-show=\"isLookupFailure\" class=\"lookupFailureMsg\">\n                        <xo-message message=\"lookupFailureMessage\"></xo-message>\n                    </div>\n                </div>\n                <div class=\"inputField confidential line1\" floating-label>\n                    <input type=\"text\" name=\"line1\" id=\"line1\" ng-model=\"address.line1\" value=\"\" maxlength=\"50\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\"  data-error-key=\"common.valueInvalid\" xo-error-tooltip required />\n                    <label for=\"line1\" id=\"line1Label\">{{ content('common.streetAddress') }}</label>\n                </div>\n                <div class=\"inputField confidential line2\" floating-label>\n                    <input type=\"text\" name=\"line2\" id=\"line2\" ng-model=\"address.line2\" value=\"\" maxlength=\"50\" autocapitalize=\"off\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\" />\n                    <label for=\"line2\" id=\"line2Label\">{{ content('common.streetAddress2') }}</label>\n                </div>\n                <div class=\"inputField confidential city\" floating-label>\n                    <input type=\"text\" name=\"city\" id=\"city\" maxLength=\"100\" ng-model=\"address.city\" value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\"  data-error-key=\"common.valueInvalid\" xo-error-tooltip required />\n                    <label for=\"city\" id=\"cityLabel\">{{ content('common.onlyCity') }}</label>\n                </div>\n                <div class=\"stateZip clearfix\">\n                    <div class=\"dropdown confidential state inputField\" floating-label-dropdown>\n                        <select xo-dropdown name=\"state\" ng-model=\"address.state\" id=\"state\" aria-labelledby=\"stateLabel\"\n                                aria-required=\"true\"\n                                ng-options=\"c.key as c.value group by c.group for c in retrieveStateNamesInGroup(['england', 'northernIreland', 'scotland', 'wales', 'ukOffshoreDependencies'])\">\n                            <option value=\"\">{{ content('common.countyOptional') }}</option>\n                        </select>\n                        <label for=\"state\" id=\"stateLabel\">{{ content('common.countyOptional') }}</label>\n                    </div>\n                    <div class=\"inputField confidential postalCode\" floating-label>\n\n                        <input type=\"text\" name=\"postalCode\" id=\"postalCode\" ng-model=\"address.postal_code\" value=\"\"\n                               autocapitalize=\"off\" aria-required=\"true\" ng-blur=\"zipCodeBlur()\"  ng-keypress=\"zipCodeKeyPress()\" autocomplete=\"off\" data-error-key=\"validation.validZipCode\"\n                               xo-validation='{\n                                    \"validator\": \"validZip\",\n                                    \"options\": {\n                                        \"country\": \"GB\"\n                                    }\n                                }'\n                               xo-error-tooltip required />\n                        <label for=\"postalCode\" id=\"postalCodeLabel\">{{ content('common.zip') }}</label>\n                    </div>\n                </div>\n            </div>\n            <!-- end: Show all the fields -->\n            <!-- start: Show only the address lookup fields -->\n            <div ng-if=\"isShowLookupFields\" id=\"addressLookup\" class=\"addressLookup\">\n                <div ng-hide=\"isLookupSuccess\" id=\"addressLookupFields\"> <!-- class=\"validated\" -->\n                    <div class=\"lookupHeading\">\n                        <span class=\"lookupTitle\">{{ content('addBillingAddress.lookupTitle') }}</span>\n                        <a class=\"editAddress\" ng-click=\"showFullAddress()\">{{content('addressBook.enterFullAddress')}}</a>\n                    </div>\n                    <div class=\"fieldGroup\">\n                        <div class=\"inputField confidential lookupZip\">\n                            <input type=\"text\" name=\"lookupZip\" id=\"lookupZip\" ng-model=\"address.postal_code\" value=\"\"\n                                   autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\"\n                                   data-error-key=\"validation.validZipCode\"\n                                   xo-validation='{\n                                     \"validator\": \"validZip\",\n                                     \"options\": {\n                                       \"country\": \"GB\"\n                                     }\n                                   }'\n                                   ng-disabled=\"isLookupProcessing\" xo-error-tooltip required />\n                            <label for=\"lookupZip\" id=\"postalCodeLabel\">{{ content('common.zip') }}</label>\n                        </div>\n                    </div>\n                    <div class=\"inputField confidential houseNo\" floating-label>\n                        <input type=\"text\" id=\"houseNo\" ng-model=\"address.house_number\"\n                               value=\"\" maxlength=\"50\"\n                               autocapitalize=\"off\" aria-required=\"false\" autocomplete=\"off\"\n                               data-error-key=\"common.valueInvalid\" xo-error-tooltip\n                               ng-disabled=\"isLookupProcessing\" />\n                        <label for=\"houseNo\" id=\"houseNoLabel\">{{ content('common.houseBldgNo')}}\n                        </label>\n                    </div>\n                    <div class=\"inputField confidential buildingName\" floating-label>\n                        <input type=\"text\" id=\"buildingName\" ng-model=\"address.building_name\"\n                               value=\"\" maxlength=\"50\" autocapitalize=\"off\" autocomplete=\"off\"\n                               data-error-key=\"common.valueInvalid\"\n                               ng-disabled=\"isLookupProcessing\" />\n                        <label for=\"buildingName\" id=\"buildingNameLabel\"\n                            {{ content('common.houseBldgName') }}\n                        </label>\n                    </div>\n                    <button track-submit ng-click=\"findAddress()\" id=\"findAddressButton\" class=\"btn full continue\"\n                            ng-class=\"{processing: isLookupProcessing}\">\n                        <div ng-show=\"isLookupProcessing\" class=\"spinner\">\n                            <p class=\"loader\" ></p>\n                        </div>\n                        <div ng-hide=\"isLookupProcessing\" class=\"text\">{{ content('addressBook.findAddress') }}</div>\n                    </button>\n                </div>\n                <div ng-show=\"isLookupSuccess\">\n                    <div class=\"lookupHeading\">\n                        <span class=\"lookupTitle\">{{ content('addressBook.address') }}</span>\n                        <a class=\"editAddress\"\n                           ng-click=\"showFullAddress()\">{{ content('common.change') }}</a>\n                    </div>\n                    <div ng-if=\"isShowLookupDropDown\" id=\"lookedupDropDown\"\n                         class=\"dropdown confidential clearfix\">\n\n                        <select xo-dropdown-multiline ng-model=\"address.selectedAddress\"\n                                ng-change=\"changeAddressDropDown()\"\n                                id=\"addressDropDown\" ng-required=\"isShowLookupDropDown\">\n                            <option value=\"\" selected=\"selected\"> {{ content('addressBook.selectYourAddress',\n                                { count: lookupAddressList.length}) }}</option>\n                            <option ng-repeat=\"addr in lookupAddressList\" value=\"{{$index}}\">\n                                {{ addr.dropDownAddress }}\n                            </option>\n                        </select>\n                    </div>\n                    <div ng-hide=\"isShowLookupDropDown\" class=\"singleAddress\">\n                        {{singleAddress.displayLine1}}<br/>\n                        {{singleAddress.displayLine2}}<br/>\n                        {{singleAddress.displayLine3}}\n                    </div>\n                </div>\n            </div>\n            <!-- end: Show only the address lookup fields -->\n        </div>\n        <!-- GB end -->\n        <!-- IE begin -->\n        <div ng-switch-when=\"IE\">\n            <div ng-if=\"metadata.addressEntry.layout\" ng-repeat=\"layoutItem in metadata.addressEntry.layout\">\n                <div ng-if=\"layoutItem.$ === 'line1'\">\n                    <div class=\"inputField confidential line1\" floating-label>\n                        <input type=\"text\" name=\"line1\" id=\"line1\" ng-model=\"address.line1\" value=\"\" maxlength=\"50\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\" xo-error-tooltip ng-required=\"{{layoutItem.required}}\" />\n                        <label for=\"line1\" id=\"line1Label\">{{locale.metadata.addressEntry.strings[country].line1Label}}</label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'line2'\">\n                    <div class=\"inputField confidential line2\" floating-label>\n                        <input type=\"text\" name=\"line2\" id=\"line2\" ng-model=\"address.line2\" value=\"\" maxlength=\"50\" autocapitalize=\"off\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\" />\n                        <label for=\"line2\" id=\"line2Label\">{{locale.metadata.addressEntry.strings[country].line2Label}}</label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'city'\">\n                    <div class=\"inputField confidential city\" floating-label>\n                        <input type=\"text\" name=\"city\" id=\"city\" maxLength=\"100\" ng-model=\"address.city\" value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\" xo-error-tooltip ng-required=\"{{layoutItem.required}}\" />\n                        <label for=\"city\" id=\"cityLabel\">{{locale.metadata.addressEntry.strings[country].cityLabel}}</label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'state'\">\n                    <div ng-if=\"locale.metadata.addressEntry.strings[country].stateList\"\n                         class=\"dropdown confidential state nullable inputField\" floating-label-dropdown>\n                        <select name=\"state\" xo-dropdown ng-options=\"state.$id as state.$id for state in locale.metadata.addressEntry.strings[country].stateList\" ng-model=\"address.state\" id=\"state\" aria-labelledby=\"stateLabel\" aria-required=\"true\" ng-required=\"{{layoutItem.required}}\">\n                            <option value=\"\">{{ locale.metadata.addressEntry.strings[country].stateLabel }}</option>\n                        </select>\n                        <label for=\"state\" id=\"stateLabel\">{{ locale.metadata.addressEntry.strings[country].stateLabel }}</label>\n                    </div>\n                    <div ng-if=\"!locale.metadata.addressEntry.strings[country].stateList\" class=\"inputField confidential state\"\n                         floating-label>\n                        <input type=\"text\" name=\"state\" id=\"state\" ng-model=\"address.state\" value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" />\n                        <label for=\"state\" id=\"stateLabel\">{{ locale.metadata.addressEntry.strings[country].stateLabel }}</label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'postcode'\">\n                    <div class=\"inputField confidential postalCode\" floating-label>\n                        <input type=\"text\" name=\"postalCode\" id=\"postalCode\" ng-model=\"address.postal_code\" ng-blur=\"zipCodeBlur()\"  ng-keypress=\"zipCodeKeyPress()\" value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\"  data-error-key=\"validation.validZipCode\" maxlength=\"{{layoutItem.maxLength}}\" xo-error-tooltip />\n                        <label for=\"postalCode\" id=\"postalCodeLabel\">{{ locale.metadata.addressEntry.strings[country].postcodeLabel }} </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <!-- IE end -->\n\n        <div ng-switch-default>\n            <!-- Griffin metadata DOES exist for this country -->\n            <div ng-if=\"metadata.addressEntry.layout\" ng-repeat=\"layoutItem in metadata.addressEntry.layout\">\n                <div ng-if=\"layoutItem.$ === 'line1'\">\n                    <div class=\"inputField confidential line1\" floating-label directionality>\n                        <input type=\"text\" name=\"line1\" id=\"line1\" ng-model=\"address.line1\" value=\"\" maxlength=\"50\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\" xo-error-tooltip ng-required=\"{{layoutItem.required}}\" />\n                        <label for=\"line1\" id=\"line1Label\">{{locale.metadata.addressEntry.strings[country].line1Label}}</label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'line2'\">\n                    <div class=\"inputField confidential line2\" floating-label directionality>\n                        <input type=\"text\" name=\"line2\" id=\"line2\" ng-model=\"address.line2\" value=\"\" maxlength=\"50\" autocapitalize=\"off\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\" />\n                        <label for=\"line2\" id=\"line2Label\">{{locale.metadata.addressEntry.strings[country].line2Label}}</label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'city'\">\n                    <div class=\"inputField confidential city\" floating-label directionality>\n                        <input type=\"text\" name=\"city\" id=\"city\" maxLength=\"100\" ng-model=\"address.city\" value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\" xo-error-tooltip ng-required=\"{{layoutItem.required}}\" />\n                        <label for=\"city\" id=\"cityLabel\">{{locale.metadata.addressEntry.strings[country].cityLabel}}</label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'state'\">\n                    <div ng-if=\"locale.metadata.addressEntry.strings[country].stateList\"\n                         class=\"dropdown confidential state nullable inputField\" floating-label-dropdown>\n                        <select name=\"state\" xo-dropdown ng-options=\"state.$id as state.$elt for state in locale.metadata.addressEntry.strings[country].stateList\" ng-model=\"address.state\" id=\"state\" aria-required=\"true\" ng-required=\"{{layoutItem.required}}\">\n                            <option value=\"\">{{ locale.metadata.addressEntry.strings[country].stateLabel }}</option>\n                        </select>\n                        <label for=\"state\" id=\"stateLabel\">{{ locale.metadata.addressEntry.strings[country].stateLabel }}</label>\n                    </div>\n                    <div ng-if=\"!locale.metadata.addressEntry.strings[country].stateList\" class=\"inputField confidential state\"\n                         floating-label directionality>\n                        <input type=\"text\" name=\"state\" id=\"state\" ng-model=\"address.state\" value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" />\n                        <label for=\"state\" id=\"stateLabel\">{{ locale.metadata.addressEntry.strings[country].stateLabel }}</label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'postcode'\">\n                    <xo-zipcode id=\"zipcode\" zip-entry=\"layoutItem\" country=\"{{country}}\"\n                                max-length=\"layoutItem.maxLength\" zip-code=\"address.postal_code\"\n                                done-fn=\"zipCodeBlur\"\n                                key-press-fn=\"zipCodeKeyPress\"\n                                zip-label=\"{{ locale.metadata.addressEntry.strings[country].postcodeLabel }}\"\n                                zip-error-key=\"validation.validZipCode\"\n                                zip-required=\"layoutItem.required\"></xo-zipcode>\n                </div>\n            </div>\n            <!-- Griffin metadata DOES NOT exist for this country -->\n            <div ng-if=\"!metadata.addressEntry.layout\">\n                <div class=\"inputField confidential line1\" floating-label directionality>\n                    <input type=\"text\" name=\"line1\" id=\"line1\" ng-model=\"address.line1\" value=\"\" maxlength=\"50\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\" xo-error-tooltip required />\n                    <label for=\"line1\" id=\"line1Label\">{{ content('common.stAddress') }}</label>\n                </div>\n\n                <div class=\"inputField confidential city\" floating-label directionality>\n                    <input type=\"text\" name=\"city\" id=\"city\" maxLength=\"100\" ng-model=\"address.city\" value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\" xo-error-tooltip required />\n                    <label for=\"city\" id=\"cityLabel\">{{ content('common.otherCity') }}</label>\n                </div>\n\n                <div class=\"inputField confidential state\" floating-label directionality>\n                    <input type=\"text\" name=\"state\" id=\"state\" ng-model=\"address.state\" value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" />\n                    <label for=\"state\" id=\"stateLabel\">{{ content('common.optionalState') }}</label>\n                </div>\n\n                <div class=\"inputField confidential postalCode\" floating-label directionality>\n                    <input type=\"text\" name=\"postalCode\" id=\"postalCode\" ng-model=\"address.postal_code\" value=\"\"  ng-blur=\"zipCodeBlur()\" ng-keypress=\"zipCodeKeyPress()\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" data-error-key=\"validation.validZipCode\"/>\n                    <label for=\"postalCode\" id=\"zipLabel\">{{ content('common.optionalPostalCode') }}</label>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div ng-if=\"isAddPreferred\" class=\"addPreferredShipping sCheckbox checkbox\">\n        <input type=\"checkbox\" ng-model=\"address.preferred_address\" name=\"addPreferred\" id=\"addPreferred\" />\n        <label for=\"addPreferred\">{{ content('memberReview.makePreferredShipping') }}</label>\n    </div>\n\n    <div ng-if=\"renderBillingAddCheckbox\" class=\"addPreferredShipping sCheckbox checkbox\">\n        <input type=\"checkbox\"  ng-model=\"address.isBA\" name=\"isBA\" id=\"addVenmoBA\" />\n        <label for=\"addVenmoBA\">{{ content('memberReview.useShippingAsBilling') }}</label>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-address-components/src/add-address/template.html":
"./components/xo-address-components/src/add-address/template.html",

/***/ "./components/xo-ui-components/src/dropdown-multiline/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/jquery/dist/jquery.min.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, $) {
	
	    squid.module('xo-dropdown-multiline.directive', ['squid']).directive('xoDropdownMultiline', function ($timeout) {
	        return {
	            restrict: 'A',
	
	            require: '?ngModel',
	
	            link: function link($scope, $select, attrs, ngModel) {
	
	                var isListVisible = false;
	                var listCreated = false;
	
	                $select = $($select);
	
	                var $span = $('<span class="custom-select" aria-hidden="true"><div class="arrow"></div><span class="innerContainer"><span></span></span></span>');
	                var $container = $('<div class="custom-select-container multiline-select-container" tabindex="0" />');
	                var $list;
	
	                function updateCover() {
	                    $timeout(function () {
	                        $span.find('span span').html($select.find('[selected]').text().replace(/\\n/gi, '<br>').trim());
	                    }, 10);
	                }
	
	                function createList($options) {
	                    if ($options.length < 2) {
	                        return;
	                    }
	
	                    function getModel() {
	                        var modelName;
	                        var model;
	                        var subParts;
	
	                        if ($select.attr('ng-options')) {
	                            modelName = $select.attr('ng-options').substring($select.attr('ng-options').indexOf('in ') + 3, $select.attr('ng-options').length);
	                        } else {
	                            var $option = $($select.find('[ng-repeat]')[0]);
	                            modelName = $option.attr('ng-repeat').substring($option.attr('ng-repeat').indexOf('in ') + 3, $option.attr('ng-repeat').length);
	                        }
	
	                        // This is to handle cases like card.billingAddress
	                        if (modelName.indexOf('.') !== -1) {
	                            subParts = modelName.split('.');
	                            model = $scope;
	
	                            for (var i = 0; i < subParts.length; i++) {
	                                model = model[subParts[i]];
	                            }
	                        } else {
	                            // And this is to handle straightforward model names
	                            model = $scope[modelName];
	                        }
	
	                        return model;
	                    }
	
	                    function hideList(event) {
	                        $list.hide();
	                        $container.append($list);
	                        isListVisible = false;
	                        $container.removeClass('open');
	                    }
	
	                    function positionList() {
	                        $list.css('left', $container.offset().left + 'px');
	                        $list.css('top', $container.offset().top + $container.height() + 'px');
	                        $list.css('width', $container.width() + 'px');
	                    }
	
	                    function setFocusOnSelected() {
	                        var $selected = $select.find('[selected]');
	
	                        if ($selected.length) {
	                            var $item = $list.find('[data-value="' + $selected.attr('value') + '"]');
	                            $item.focus();
	                        } else {
	                            $list.find('li')[0].focus();
	                        }
	                    }
	
	                    function showList() {
	                        $('body').append($list);
	                        $container.addClass('open');
	                        $list.show();
	                        positionList();
	                        isListVisible = true;
	                        setFocusOnSelected();
	                    }
	
	                    function processContainerKeypress(event) {
	                        var keyCode = event.keyCode;
	
	                        if (keyCode === 13 || keyCode === 40) {
	                            // enter or down arrow
	                            if (!isListVisible) {
	                                showList();
	                            } else {
	                                hideList();
	                                $container.focus();
	                            }
	                        } else if (keyCode === 27) {
	                            // escape
	                            if (isListVisible) {
	                                hideList();
	                                $container.focus();
	                            }
	                        }
	                    }
	
	                    if ($list) {
	                        $list.remove();
	                    }
	
	                    $list = $('<ul class="multiline-select-list" tabindex="0"></ul>');
	
	                    Array.prototype.forEach.call($options, function (option) {
	                        var $option = $(option);
	                        var value = $option.attr('value');
	                        var text = option.innerHTML.replace(/\\n/gi, '<br>');
	
	                        if (text.indexOf('content(') !== -1) {
	                            text = $scope.content(text.substring(text.indexOf('(\'') + 2, text.indexOf('\')')));
	                        }
	
	                        var html = '<li tabindex="0"';
	                        if (value !== $option.text()) {
	                            html = html + ' data-value="' + value + '"';
	                        }
	                        html = html + '>' + text + '</li>';
	                        $list.append($(html));
	                    });
	
	                    $container.append($list);
	                    $list.hide();
	
	                    $($list.find('li')).click(function (event) {
	                        var $target = $(event.target);
	                        var value = $target.data('value');
	
	                        if (typeof value !== 'undefined') {
	                            $select.find('option').removeAttr('selected');
	                            $select.find('option[value="' + value + '"]').attr('selected', 'selected');
	                            $select.find('option').removeProp('selected');
	                            $select.find('option[value="' + value + '"]').prop('selected', 'selected');
	                        } else {
	                            value = $target.html().replace(/\/<br\/>/gi, '\\n');
	                            $select.val(value);
	                        }
	
	                        if ($select.attr('ng-model')) {
	                            if ($select.attr('ng-options') || $select.find('[ng-repeat]').length) {
	                                /* This parses the 'ng-options' directive and returns the options model.
	                                For example: If you have: ng-options='opt as opt.label for opt in options'
	                                Here it will parse this attribute and return 'options */
	                                var model = getModel();
	
	                                ngModel.$setViewValue(model[value]);
	                            } else {
	                                ngModel.$setViewValue(value);
	                            }
	                        }
	
	                        updateCover();
	                        hideList();
	                    });
	
	                    var $innerContainer = $container.find('.innerContainer');
	
	                    $container.click(function (event) {
	                        if (isListVisible) {
	                            hideList();
	                            $container.focus();
	                        } else {
	                            showList();
	                        }
	                    });
	
	                    $container.keydown(function (event) {
	                        processContainerKeypress(event);
	                    });
	
	                    $innerContainer.keydown(function (event) {
	                        processContainerKeypress(event);
	                    });
	
	                    $list.find('li').keydown(function (event) {
	                        var keyCode = event.keyCode;
	                        var $target = $(event.target);
	
	                        if (keyCode === 13) {
	                            // enter
	                            $target.click();
	                            event.stopPropagation();
	                        } else if (keyCode === 27) {
	                            // escape
	                            if (isListVisible) {
	                                hideList();
	                                $container.focus();
	                                event.stopPropagation();
	                            }
	                        } else if (keyCode === 40) {
	                            // down arrow
	                            if (!$target.is(':last-of-type')) {
	                                $target.next().focus();
	                                event.preventDefault();
	                                event.stopPropagation();
	                            }
	                        } else if (keyCode === 38) {
	                            // up arrow
	                            if (!$target.is(':first-of-type')) {
	                                $target.prev().focus();
	                            }
	                            event.preventDefault();
	                            event.stopPropagation();
	                        }
	                    });
	
	                    $(window).resize(function () {
	                        if (isListVisible) {
	                            positionList();
	                        }
	                    });
	
	                    $(window).bind('hashchange', function () {
	                        if (isListVisible) {
	                            hideList();
	                        }
	                    });
	
	                    $(document).click(function (event) {
	                        var $target = $(event.target);
	
	                        if (!($target.is($container) || $.contains($container.get()[0], $target.get()[0])) && isListVisible) {
	                            hideList();
	                        }
	                    });
	
	                    $container.blur(function (event) {
	                        // The setTimeout here is to ensure activeElement is set before our function executes
	                        $timeout(function () {
	                            var $newTarget = $(event.explicitOriginalTarget || document.activeElement);
	
	                            if (!($.contains($container.get()[0], $newTarget.get()[0]) || $.contains($list.get()[0], $newTarget.get()[0]))) {
	                                hideList(event);
	                            }
	                        }, 1);
	                    });
	
	                    listCreated = true;
	                    updateCover();
	                }
	
	                function render() {
	                    var options = $select.find('option');
	                    if (!listCreated) {
	                        createList(options);
	                    }
	                }
	
	                $select.wrap($container);
	                $container = $select.parent();
	
	                // Change class names to enable styling of hover/focus states
	                $select.bind('mouseenter focus', function () {
	                    $span.addClass('active');
	                });
	
	                // Change class names to enable styling of hover/focus states
	                $select.bind('mouseleave blur', function () {
	                    $span.removeClass('active');
	                });
	
	                $select.after($span);
	
	                $select.addClass('replaced');
	
	                $select.attr('tabindex', '-1');
	
	                if (attrs['default']) {
	                    var defaultOption = document.createElement('option');
	                    defaultOption.innerText = attrs['default'];
	                    $select.append(defaultOption);
	                }
	
	                if ($select.attr('ng-options')) {
	                    $scope.$watch(attrs.ngModel, function () {
	                        render();
	                    });
	                } else {
	                    $timeout(function () {
	                        $scope.$broadcast('pageRendered');
	                    }, 0);
	                }
	
	                $scope.$on('pageRendered', function () {
	                    render();
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "./components/xo-form-components/src/name-input/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-form-components/src/name-input/template.html"), __webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js"), __webpack_require__("./components/xo-ui-components/src/floating-label/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, template) {
	
	    return angular.module('xo-name-input.directive', ['squid', 'xo-error-tooltip.directive', 'floating-label.directive']).directive('xoNameInput', function () {
	
	        return {
	            template: template,
	
	            scope: {
	                user: '=',
	                country: '@'
	            },
	
	            controller: function controller($populate, $scope, $locale, $MetadataModel) {
	
	                $scope.locale = $locale;
	                $scope.metadata = $MetadataModel.create();
	
	                // Normalizes Griffin's address-related content for rendering.
	
	                $scope.$watch('country', function () {
	                    $scope.metadata.choose($scope.country || $locale.country, $locale.lang);
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "./js/app.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	__webpack_require__("./css/app.less");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _route = __webpack_require__("./pages/xo-checkout/route.js");
	
	var _route2 = __webpack_require__("./pages/xo-guest-upgrade/route.js");
	
	var _middleware = __webpack_require__("./js/lib/middleware.js");
	
	var _index = __webpack_require__("./components/squid/dist/index.js");
	
	_logger.$logger.info('app_bootstrap', {
	    hash: window.location.hash
	});
	
	if (_index.$util.param('data')) {
	    var guestUpgradeRoute = new _route2.$GuestUpgradeRoute();
	
	    guestUpgradeRoute.bootstrap('guestupgrade', _middleware.$Middleware);
	} else {
	    var baseRoute = new _route.$BaseRoute();
	
	    baseRoute.bootstrap('checkout.landing', _middleware.$Middleware);
	}
	
	window.bootstrap = true;
	
	_logger.$logger;
	
	_route.$BaseRoute;
	
	_route2.$GuestUpgradeRoute;
	
	_middleware.$Middleware;
	
	_index.$util;

/***/ }),

/***/ "./components/xo-models/src/address/index.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xomodel.address', ['squid']).factory('$AddressNormalizationModel', function ($Model, $Api) {
	        return $Model.extend('AddressNormalizationModel', {
	            api: new $Api({
	                uri: '/api/address/normalize'
	            })
	        });
	    }).factory('$PrefillAddressModel', function ($Model, $Api) {
	        return $Model.extend('PrefillAddressModel', {
	            api: new $Api({
	                uri: '/api/address/prefill'
	            })
	        });
	    }).factory('$ValidateAddressModel', function ($Model, $Api) {
	        return $Model.extend('ValidateAddressModel', {
	            api: new $Api({
	                uri: '/api/address/validate'
	            })
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/address", "components/xo-models/src/address/index.js"))

/***/ }),

/***/ "./components/xo-form-components/src/zipcode/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-form-components/src/zipcode/template.html"), __webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid, template) {
	    return angular.module('xo-zipcode.directive', ['squid', 'xo-error-tooltip.directive']).directive('xoZipcode', function () {
	        return {
	            template: template,
	            scope: {
	                country: '@',
	                zipLabel: '@',
	                postalCodeLabel: '@',
	                zipErrorKey: '@',
	                doneFn: '=',
	                keyPressFn: '=',
	                zipCode: '=',
	                zipEntry: '=',
	                maxLength: '='
	            },
	
	            controller: function controller($scope, $feature) {
	                var formatRegex;
	                var inputParams = $feature('zipcodeInputParams', undefined, $scope.country);
	                if (inputParams) {
	                    $scope.minLength = inputParams.minLength;
	                    $scope.maxLength = inputParams.maxLength;
	                    if (inputParams.formatPattern) {
	                        formatRegex = new RegExp(inputParams.formatPattern, 'g');
	                    }
	                }
	
	                function formatZipWithDash(zipcode, index) {
	                    if (zipcode.length > index) {
	                        zipcode = [zipcode.slice(0, index), '-', zipcode.slice(index)].join('');
	                    }
	                    return zipcode;
	                }
	
	                $scope.changeZip = function (zipcode) {
	                    if (zipcode) {
	
	                        if (formatRegex) {
	                            zipcode = zipcode.replace(formatRegex, '');
	                        }
	
	                        if (inputParams && inputParams.formatZip) {
	                            zipcode = formatZipWithDash(zipcode, inputParams.minLength);
	                        }
	
	                        $scope.zipCode = zipcode;
	                    }
	                };
	
	                $scope.doneFunction = function () {
	                    if ($scope.doneFn) {
	                        $scope.doneFn();
	                    }
	                };
	
	                $scope.keyPressHandler = function (event) {
	                    if ($scope.keyPressFn) {
	                        $scope.keyPressFn(event);
	                    }
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-form-components/src/zipcode/template.html":
/***/ (function(module, exports) {

	module.exports = "<div id=\"zipField\" class=\"inputField confidential postalCode\" floating-label directionality content>\n    <input type=\"text\" name=\"postalCode\" id=\"postalCode\" ng-model=\"zipCode\"\n       autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" ng-change=\"changeZip(zipCode)\" xo-validation='{\"validator\": \"validZip\"}'\n       minlength=\"{{minLength}}\" maxlength=\"{{maxLength}}\" ng-blur=\"doneFunction()\" ng-keypress=\"keyPressHandler($event)\"\n       data-error-key=\"{{zipErrorKey}}\" xo-error-tooltip ng-required=\"{{zipRequired}}\"/>\n    <label for=\"postalCode\" id=\"postalCodeLabel\" >{{zipLabel}}</label>\n</div>\n\n"

/***/ }),

/***/ "./components/xo-guest-components/src/guest/sepa/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _errorHandlerHelper = __webpack_require__("./components/xo-guest-components/src/guest/lib/errorHandlerHelper.js");
	
	var errorHandlerHelper = _interopRequireWildcard(_errorHandlerHelper);
	
	var _util = __webpack_require__("./components/xo-wallet-components/src/fi-contingency-list/util.js");
	
	var _index = __webpack_require__("./components/xo-models/src/fi/index.js");
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _template = __webpack_require__("./components/xo-guest-components/src/guest/sepa/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	exports['default'] = _squid.$Component.extend('xoGuestSepaLightbox', {
	    tag: 'xo-guest-sepa-lightbox',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            type: 'var'
	        },
	        address: {
	            type: 'var'
	        },
	        singlePagePaymentForm: {
	            type: 'var'
	        },
	        errorMessage: {
	            type: 'var'
	        },
	        validated: {
	            type: 'var'
	        },
	        sepa: {
	            type: 'var'
	        },
	        onboard: {
	            type: 'var'
	        },
	        sectionElement: {
	            type: 'var'
	        },
	        flags: {
	            type: 'var'
	        },
	        isUnbranded: {
	            type: 'var'
	        },
	        doneFn: {
	            type: 'var'
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {},
	        populate: function populate() {
	            var _this = this;
	
	            var openSepa = function openSepa() {
	                var form = _this.singlePagePaymentForm;
	                var formValid = true;
	                var firstFailedElementName = determineFirstFailedElement();
	
	                // Clear existing error messages
	                _this.errorMessage = '';
	                _this.validated = true;
	
	                _this.noErrorShowSepa = false;
	
	                function determineFirstFailedElement() {
	                    var result = void 0;
	                    var sepaNotRequiredFields = ['sepaAgree', 'sepaGuestAgree', 'guestagree', 'agree'];
	
	                    for (var i in form) {
	                        if (form[i] && form[i].hasOwnProperty && form[i].hasOwnProperty('$valid') && sepaNotRequiredFields.indexOf(form[i].$name) === -1 && // Dont check validity for fields we don't need for SEPA
	                        !form[i].$valid) {
	                            formValid = false;
	                            result = form[i].$name;
	                            break;
	                        }
	                    }
	
	                    return result;
	                }
	                // If form is valid then call validateBank Api and then open sepa
	
	                if (formValid) {
	                    _this.addBankModel = new _index.$AddBankModel({
	                        user: _this.onboard.user,
	                        bank: _this.onboard.bank
	                    });
	
	                    _this.addBankModel.action('validate', {
	
	                        data: _this.addBankModel.getBankData(),
	
	                        resultModel: {},
	
	                        success: function success(data) {
	                            _this.addBankModel.creditorDetails = data.creditorDetails;
	                            _this.addBankModel.fiDetails = data.fiDetails;
	                            _this.noErrorShowSepa = true;
	                            (0, _angular.$timeout)(function () {
	                                window.scrollTo(0, 0);
	                            }, 100);
	                        },
	
	                        contingencies: {
	                            VALIDATE_BANK_CONTINGENCY: function VALIDATE_BANK_CONTINGENCY(name, data) {
	                                _this.hideSepa();
	                                _this.errorMessage = _util.$fiErrorUtil.addPageErrors(data, 'bank');
	                                _util.$fiErrorUtil.addFieldErrors(data, _this.sectionElement);
	                                firstFailedElementName = determineFirstFailedElement();
	                                errorHandlerHelper.scrollToElement(firstFailedElementName);
	                            }
	                        },
	                        validation: function validation(data) {
	
	                            var returnObj = { fields: [] };
	                            _this.hideSepa();
	
	                            angular.forEach(data.fields || [], function (field) {
	                                returnObj.fields.push(field.property);
	                            });
	
	                            errorHandlerHelper.addFieldError(returnObj);
	
	                            firstFailedElementName = determineFirstFailedElement();
	                            errorHandlerHelper.scrollToElement(firstFailedElementName);
	                        }
	                    });
	                } else {
	                    _this.hideSepa();
	                    errorHandlerHelper.scrollToElement(firstFailedElementName);
	                }
	            };
	            this.hideSepa = function () {
	                _this.noErrorShowSepa = false;
	                _this.sepa.show = false;
	            };
	            // Added the sepa content change based on US755520
	            var setSepaOverlayContent = function setSepaOverlayContent() {
	                _this.sepaTitle = _this.isUnbranded && _this.flags.show_sepa_overlay ? 'DEMemberGuest.sepaTitleUnbranded' : 'DEMemberGuest.sepaTitle';
	                _this.sepaAgreement = _this.isUnbranded && _this.flags.show_sepa_overlay ? 'DEMemberGuest.ddAgreementUnbrandedPara1' : 'DEMemberGuest.ddAgreementPara1';
	                if (_this.flags.show_sepa_overlay) {
	                    if (_this.flags.isUnbranded && _this.flags.commit) {
	                        _this.sepaSubmit = 'common.acceptAndComplete';
	                    } else {
	                        _this.sepaSubmit = 'common.acceptAndContinue';
	                    }
	                } else {
	                    _this.sepaSubmit = 'header.close';
	                }
	            };
	
	            this.$watch('sepa.show', function (newVal, oldVal) {
	                if (newVal) {
	                    openSepa();
	                }
	            });
	
	            this.$watch('flags.show_sepa_overlay', function (newVal, oldVal) {
	                if (newVal) {
	                    setSepaOverlayContent();
	                }
	            });
	
	            setSepaOverlayContent();
	        }
	    },
	    actions: {
	        closeSepa: function closeSepa($event) {
	            $event.preventDefault();
	            this.hideSepa();
	        },
	        acceptSepa: function acceptSepa($event) {
	            $event.preventDefault();
	
	            this.hideSepa();
	            this.sepa.sepaGuestAgree = true;
	            this.sepa.sepaAgree = true;
	            if (this.flags.show_sepa_overlay) {
	                this.doneFn();
	            }
	        }
	    }
	});
	
	
	_squid.$Component;
	
	_util.$fiErrorUtil;
	
	_index.$AddBankModel;
	
	_angular.$timeout;
	module.exports = exports['default'];

/***/ }),

/***/ "./components/xo-guest-components/src/guest/sepa/template.html":
/***/ (function(module, exports) {

	module.exports = "\n<div class=\"kmliUpsell upsellOpen sepa\" ng-if=\"noErrorShowSepa\">\n    <div class=\"upsellMask\"></div>\n\n    <div class=\"upsellWrapper\" simple-modal=\"modalActive\" modal-cancel=\"hideModal()\" content>\n        <div class=\"sepaContainer\">\n\n\n            <a href=\"#\" class=\"close\" ng-click=\"actions.closeSepa($event)\">close</a>\n\n            <h1 id=\"sepaTitle\" class=\"alpha\">{{ content(sepaTitle) }}</h1>\n\n            <p id=\"sepaAgreement\">{{ content(sepaAgreement) }}</p>\n\n            <div class=\"carrierinfo\">\n                <span><strong>{{ content('DEMemberGuest.accountCarrier') }}</strong></span>\n                <div><span>{{addBankModel.user.first_name}} {{addBankModel.user.last_name}}</span></div>\n                <div><span>{{address.line1}}</span></div>\n                <div><span ng-if=\"address.line2\">{{address.line2}}</span></div>\n                <div><span>{{address.postal_code}} {{address.city}}</span></div>\n            </div>\n\n            <div class=\"bankinfo\">\n                <p>\n                    <span class=\"col1\"> <strong>{{content('DEMemberGuest.IBAN')}} </strong></span><br/>\n                    <span class=\"col2\">{{addBankModel.fiDetails.piDetails.piAccountNumber}}</span>\n                </p>\n\n                <p>\n                    <span class=\"col1\"> <strong> {{content('DEMemberGuest.bankName')}} </strong></span><br/>\n                    <span class=\"col2\">{{addBankModel.fiDetails.piDetails.isssuerDetails.name}}</span>\n                </p>\n\n                <p>\n                    <span class=\"col1\"> <strong> {{content('DEMemberGuest.bic')}} </strong> </span><br/>\n                    <span class=\"col2\">{{addBankModel.fiDetails.piDetails.bic}}</span>\n                </p>\n            </div>\n\n            <input track-submit id=\"sepaSubmit\" type=\"submit\" value=\"{{ content(sepaSubmit) }}\"\n                   class=\"btn full\"\n                   ng-click=\"actions.acceptSepa($event)\" />\n\n            <div id=\"paypalLogo\" class=\"miniLogo\"><span class=\"accessAid\">{{ content('base.payPal') }}</span></div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "./components/xo-form-components/src/phone/phoneInput/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	__webpack_require__("./components/xo-form-components/src/phone/phoneInput/styles.less");
	
	__webpack_require__("./components/xo-ui-components/src/directionality/directive.js");
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-form-components/src/phone/phoneInput/template.html"), __webpack_require__("./components/xo-form-components/src/phone/lib/territoriesByCode.js"), __webpack_require__("./components/xo-ui-components/src/dropdown/directive.js"), __webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js"), __webpack_require__("./components/xo-ui-components/src/floating-label/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular, squid, template, countryPhoneCode) {
	
	    angular.module('xo-phone.phoneInput', ['squid', 'xo-dropdown.directive', 'xo-error-tooltip.directive', 'floating-label.directive']).directive('xoPhoneInput', function () {
	        return {
	            template: template,
	            scope: {
	                phone: '=',
	                showPhoneType: '=',
	                exclude: '@'
	            },
	
	            link: function link(scope, element, attr, controller) {
	                element.on('keyup', function (event) {
	                    $('.telephone').mask(scope.mask, {
	                        'translation': {
	                            0: { pattern: /[0-9]/ }
	                        }
	                    });
	                });
	            },
	
	            controller: function controller($scope, $feature, $locale) {
	                $scope.locale = $locale;
	                $scope.IntDialingCodes = countryPhoneCode;
	                $scope.defaultCountryPhoneCode = countryPhoneCode[$locale.country];
	                $scope.showPhoneType = $feature('phoneType', true, $scope.country) && $scope.showPhoneType !== false;
	
	                // dont display countries that are tagged with hideInOtherCountries flag in territoriesByCode.js.
	                // if localeCountry and dropdown country are same ignore hideInOtherCountries and display the countrycode.
	                $scope.hideCountry = function (dropdownCountry, hideInOtherCountries) {
	                    return $locale.country !== dropdownCountry && hideInOtherCountries;
	                };
	
	                $scope.phone = $scope.phone || {};
	                $scope.phone.phoneType = $scope.phone.phoneType || 'Mobile';
	                $scope.phone.IntDialingCountryCode = $scope.defaultCountryPhoneCode.phoneCountryCode;
	
	                angular.extend($scope.phone, {
	                    phoneCountryCode: $locale.country
	                });
	
	                function getPhoneMask(phoneType, phoneEntry) {
	                    var defaultMask = '0000000000000000';
	                    var masks = phoneEntry && phoneEntry.masks;
	                    var mobileMask = masks && masks.MOBILE ? masks.MOBILE : defaultMask;
	                    var fixedLineMask = masks && masks.FIXED_LINE ? masks.FIXED_LINE : defaultMask;
	                    return phoneType === 'Mobile' ? mobileMask : fixedLineMask;
	                }
	
	                function getPhonePattern(phoneEntry) {
	                    var defaultPattern = '^[0-9]+$';
	                    var patterns = phoneEntry && phoneEntry.patterns;
	                    // less stric regex validation in place for now, just use general regex to match mobile AND fixed-line formats
	                    // for now we use less strict regex validation because we are not ready for this more strict validation
	                    if (patterns) {
	                        return patterns.GENERAL ? patterns.GENERAL : defaultPattern;
	                    }
	                    return defaultPattern;
	
	                    // more strict regex validaiton based on phone type is found commented below
	                    // var ret;
	                    // switch ($scope.phone.phoneType) {
	                    //     case 'Mobile':
	                    //         ret = patterns.MOBILE;
	                    //         break;
	                    //     case 'Home':
	                    //     case 'Work':
	                    //         ret = patterns.FIXED_LINE;
	                    //         break;
	                    //     default:
	                    //         ret = patterns.GENERAL;
	                    //         break;
	                    // }
	                    // return ret ? ret : defaultPattern;
	                }
	
	                function populatePhoneMetadata() {
	                    if (!$scope.metadata || $scope.metadata.country !== $locale.metadata.country) {
	                        $scope.metadata = angular.copy($locale.metadata);
	                    }
	                    var phoneEntry = $scope.metadata.phoneEntry;
	                    $scope.mask = getPhoneMask($scope.phone.phoneType, phoneEntry);
	                    $scope.pattern = getPhonePattern(phoneEntry);
	                }
	
	                populatePhoneMetadata();
	
	                // Reset the phone number mask from according to the phone type
	                $scope.phoneTypeChanged = function () {
	                    $scope.mask = getPhoneMask($scope.phone.phoneType, $scope.metadata.phoneEntry);
	                    $scope.pattern = getPhonePattern($scope.metadata.phoneEntry);
	                    $('.telephone').mask($scope.mask);
	                };
	
	                $scope.$watch('phone.phoneCountryCode', function (newValue) {
	                    $scope.phone.IntDialingCountryCode = countryPhoneCode[newValue].phoneCountryCode;
	                });
	
	                $scope.$on('localeChange', function () {
	                    $scope.defaultCountryPhoneCode = countryPhoneCode[$locale.country];
	                    $scope.phone.phoneCountryCode = $locale.country;
	                    if (!$scope.metadata || $scope.metadata.country !== $locale.metadata.country) {
	                        populatePhoneMetadata();
	                        $('.telephone').mask($scope.mask);
	                    }
	                });
	
	                $scope.showWork = $scope.exclude === 'WORK';
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "./components/xo-form-components/src/phone/phoneInput/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-form-components/src/phone/phoneInput/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-form-components/src/phone/phoneInput/styles.less":
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, ".singleLineMobile{float:none!important}", ""]);
	
	// exports


/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-form-components/src/phone/phoneInput/template.html":
/***/ (function(module, exports) {

	module.exports = "<div class=\"row-fluid fieldGroup clearfix\" ng-class=\"{countryCodeSelect: defaultCountryPhoneCode.showCountryCodeList === true}\" content>\n    <div id=\"phoneTypeContainer\" class=\"phoneTypeContainer dropdown confidential inputField half\" ng-cloak\n         ng-if=\"showPhoneType === true\" ng-class=\"{'rtlPhoneType': locale.metadata.directionality === 'rtl'}\"\n         floating-label-dropdown>\n        <select xo-dropdown ng-model=\"phone.phoneType\" name=\"phoneType\" id=\"phoneType\" ng-change=\"phoneTypeChanged()\" xo-error-tooltip>\n            <option value=\"Mobile\" selected=\"\">{{content('common.mobile')}}</option>\n            <option value=\"Home\">{{content('common.home')}}</option>\n            <option ng-if=\"!showWork\" value=\"Work\">{{content('common.work')}}</option>\n        </select>\n        <label for=\"phoneType\" id=\"phoneTypeLabel\">{{content('common.phoneType')}}</label>\n    </div>\n\n    <div id=\"phoneCodeContainer\" class=\"phoneCodeContainer dropdown confidential half last-child inputField\" ng-cloak\n         ng-if=\"defaultCountryPhoneCode.showCountryCodeList\" floating-label-dropdown>\n        <select xo-dropdown ng-model=\"phone.phoneCountryCode\" name=\"phoneCountryCode\" id=\"phoneCountryCode\" aria-required=\"true\" xo-error-tooltip required>\n            <option ng-repeat=\"(key, value) in IntDialingCodes\" value=\"{{key}}\" ng-if=\"!hideCountry(key, value.hideInOtherCountries)\" ng-selected=\"phone.phoneCountryCode === key\">{{value.phoneCountryCode}} ({{key}})</option>\n        </select>\n        <label for=\"phoneCountryCode\" id=\"phoneCodeLabel\">{{content('common.phoneCountryCode')}}</label>\n    </div>\n\n    <div class=\"inputField confidential last-child\"\n         ng-class=\"{'half': showPhoneType || defaultCountryPhoneCode.showCountryCodeList, 'telephoneField': showPhoneType,\n         'telephoneFieldFull': !showPhoneType, 'rtlPhoneField': locale.metadata.directionality === 'rtl',\n         singleLineMobile: !showPhoneType && !defaultCountryPhoneCode.showCountryCodeList}\" floating-label directionality >\n\n        <input id=\"telephone\"\n               class=\"telephone\"\n               type=\"tel\"\n               ng-model=\"phone.telephone\"\n               name=\"telephone\"\n               value=\"\"\n               autocapitalize=\"off\"\n               autocomplete=\"off\"\n               aria-required=\"true\"\n               country-code=\"phone.phoneCountryCode\"\n               phone-pattern=\"{{pattern}}\"\n               xo-validation='{\"validator\": \"validPhone\"}'\n               data-error-key=\"validation.validPhone\"\n               maxlength=\"{{mask.length}}\"\n               required\n               xo-error-tooltip />\n        <label for=\"telephone\" class=\"focus\">{{content('common.phone')}}</label>\n    </div>\n</div>\n"

/***/ }),

/***/ "./components/xo-form-components/src/phone/lib/territoriesByCode.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return {
	        'AC': {
	            'status': 'reserved',
	            'phoneCountryCode': '247',
	            'showCountryCodeList': false
	        },
	        'AD': {
	            'status': 'assigned',
	            'phoneCountryCode': '376',
	            'showCountryCodeList': false
	        },
	        'AE': {
	            'status': 'assigned',
	            'phoneCountryCode': '971',
	            'showCountryCodeList': false
	        },
	        'AF': {
	            'status': 'assigned',
	            'phoneCountryCode': '93',
	            'showCountryCodeList': false
	        },
	        'AG': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'AI': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'AL': {
	            'status': 'assigned',
	            'phoneCountryCode': '355',
	            'showCountryCodeList': false
	        },
	        'AM': {
	            'status': 'assigned',
	            'phoneCountryCode': '374',
	            'showCountryCodeList': false
	        },
	        'AN': {
	            'status': 'assigned',
	            'phoneCountryCode': '599',
	            'showCountryCodeList': false
	        },
	        'AO': {
	            'status': 'assigned',
	            'phoneCountryCode': '244',
	            'showCountryCodeList': false
	        },
	        'AQ': {
	            'status': 'assigned',
	            'phoneCountryCode': '672',
	            'showCountryCodeList': false
	        },
	        'AR': {
	            'status': 'assigned',
	            'phoneCountryCode': '54',
	            'showCountryCodeList': false
	        },
	        'AS': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'AT': {
	            'status': 'assigned',
	            'phoneCountryCode': '43',
	            'showCountryCodeList': true
	        },
	        'AU': {
	            'status': 'assigned',
	            'phoneCountryCode': '61',
	            'showCountryCodeList': true
	        },
	        'AW': {
	            'status': 'assigned',
	            'phoneCountryCode': '297',
	            'showCountryCodeList': false
	        },
	        'AZ': {
	            'status': 'assigned',
	            'phoneCountryCode': '994',
	            'showCountryCodeList': false
	        },
	        'BA': {
	            'status': 'assigned',
	            'phoneCountryCode': '387',
	            'showCountryCodeList': false
	        },
	        'BB': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'BD': {
	            'status': 'assigned',
	            'phoneCountryCode': '880',
	            'showCountryCodeList': false
	        },
	        'BE': {
	            'status': 'assigned',
	            'phoneCountryCode': '32',
	            'showCountryCodeList': true
	        },
	        'BF': {
	            'status': 'assigned',
	            'phoneCountryCode': '226',
	            'showCountryCodeList': false
	        },
	        'BG': {
	            'status': 'assigned',
	            'phoneCountryCode': '359',
	            'showCountryCodeList': false
	        },
	        'BH': {
	            'status': 'assigned',
	            'phoneCountryCode': '973',
	            'showCountryCodeList': false
	        },
	        'BI': {
	            'status': 'assigned',
	            'phoneCountryCode': '257',
	            'showCountryCodeList': false
	        },
	        'BJ': {
	            'status': 'assigned',
	            'phoneCountryCode': '229',
	            'showCountryCodeList': false
	        },
	        'BL': {
	            'status': 'assigned',
	            'phoneCountryCode': '590',
	            'showCountryCodeList': false
	        },
	        'BM': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'BN': {
	            'status': 'assigned',
	            'phoneCountryCode': '673',
	            'showCountryCodeList': false
	        },
	        'BO': {
	            'status': 'assigned',
	            'phoneCountryCode': '591',
	            'showCountryCodeList': false
	        },
	        'BQ': {
	            'status': 'assigned',
	            'phoneCountryCode': '599',
	            'showCountryCodeList': false
	        },
	        'BR': {
	            'status': 'assigned',
	            'phoneCountryCode': '55',
	            'showCountryCodeList': false
	        },
	        'BS': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'BT': {
	            'status': 'assigned',
	            'phoneCountryCode': '975',
	            'showCountryCodeList': false
	        },
	        'BV': {
	            'status': 'assigned'
	        },
	        'BW': {
	            'status': 'assigned',
	            'phoneCountryCode': '267',
	            'showCountryCodeList': false
	        },
	        'BY': {
	            'status': 'assigned',
	            'phoneCountryCode': '375',
	            'showCountryCodeList': false
	        },
	        'BZ': {
	            'status': 'assigned',
	            'phoneCountryCode': '501',
	            'showCountryCodeList': false
	        },
	        'C2': {
	            'status': 'assigned',
	            'phoneCountryCode': '86',
	            'showCountryCodeList': false
	        },
	        'CA': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'CC': {
	            'status': 'assigned',
	            'phoneCountryCode': '61',
	            'showCountryCodeList': false
	        },
	        'CD': {
	            'status': 'assigned',
	            'phoneCountryCode': '243',
	            'showCountryCodeList': false
	        },
	        'CF': {
	            'status': 'assigned',
	            'phoneCountryCode': '236',
	            'showCountryCodeList': false
	        },
	        'CG': {
	            'status': 'assigned',
	            'phoneCountryCode': '242',
	            'showCountryCodeList': false
	        },
	        'CH': {
	            'status': 'assigned',
	            'phoneCountryCode': '41',
	            'showCountryCodeList': true
	        },
	        'CI': {
	            'status': 'assigned',
	            'phoneCountryCode': '225',
	            'showCountryCodeList': false
	        },
	        'CK': {
	            'status': 'assigned',
	            'phoneCountryCode': '682',
	            'showCountryCodeList': false
	        },
	        'CL': {
	            'status': 'assigned',
	            'phoneCountryCode': '56',
	            'showCountryCodeList': false
	        },
	        'CM': {
	            'status': 'assigned',
	            'phoneCountryCode': '237',
	            'showCountryCodeList': false
	        },
	        'CN': {
	            'status': 'assigned',
	            'phoneCountryCode': '86',
	            'showCountryCodeList': false
	        },
	        'CO': {
	            'status': 'assigned',
	            'phoneCountryCode': '57',
	            'showCountryCodeList': false
	        },
	        'CR': {
	            'status': 'assigned',
	            'phoneCountryCode': '506',
	            'showCountryCodeList': false
	        },
	        'CU': {
	            'status': 'assigned',
	            'phoneCountryCode': '53',
	            'showCountryCodeList': false
	        },
	        'CV': {
	            'status': 'assigned',
	            'phoneCountryCode': '238',
	            'showCountryCodeList': false
	        },
	        'CW': {
	            'status': 'assigned',
	            'phoneCountryCode': '599',
	            'showCountryCodeList': false
	        },
	        'CX': {
	            'status': 'assigned',
	            'phoneCountryCode': '61',
	            'showCountryCodeList': false
	        },
	        'CY': {
	            'status': 'assigned',
	            'phoneCountryCode': '357',
	            'showCountryCodeList': false
	        },
	        'CZ': {
	            'status': 'assigned',
	            'phoneCountryCode': '420',
	            'showCountryCodeList': false
	        },
	        'DE': {
	            'status': 'assigned',
	            'phoneCountryCode': '49',
	            'showCountryCodeList': false
	        },
	        'DJ': {
	            'status': 'assigned',
	            'phoneCountryCode': '253',
	            'showCountryCodeList': false
	        },
	        'DK': {
	            'status': 'assigned',
	            'phoneCountryCode': '45',
	            'showCountryCodeList': true
	        },
	        'DM': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'DO': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'DZ': {
	            'status': 'assigned',
	            'phoneCountryCode': '213',
	            'showCountryCodeList': false
	        },
	        'EC': {
	            'status': 'assigned',
	            'phoneCountryCode': '593',
	            'showCountryCodeList': false
	        },
	        'EE': {
	            'status': 'assigned',
	            'phoneCountryCode': '372',
	            'showCountryCodeList': false
	        },
	        'EG': {
	            'status': 'assigned',
	            'phoneCountryCode': '20',
	            'showCountryCodeList': false
	        },
	        'EH': {
	            'status': 'assigned',
	            'phoneCountryCode': '212',
	            'showCountryCodeList': false
	        },
	        'ER': {
	            'status': 'assigned',
	            'phoneCountryCode': '291',
	            'showCountryCodeList': false
	        },
	        'ES': {
	            'status': 'assigned',
	            'phoneCountryCode': '34',
	            'showCountryCodeList': false
	        },
	        'ET': {
	            'status': 'assigned',
	            'phoneCountryCode': '251',
	            'showCountryCodeList': false
	        },
	        'FI': {
	            'status': 'assigned',
	            'phoneCountryCode': '358',
	            'showCountryCodeList': false
	        },
	        'FJ': {
	            'status': 'assigned',
	            'phoneCountryCode': '679',
	            'showCountryCodeList': false
	        },
	        'FK': {
	            'status': 'assigned',
	            'phoneCountryCode': '500',
	            'showCountryCodeList': false
	        },
	        'FM': {
	            'status': 'assigned',
	            'phoneCountryCode': '691',
	            'showCountryCodeList': false
	        },
	        'FO': {
	            'status': 'assigned',
	            'phoneCountryCode': '298',
	            'showCountryCodeList': false
	        },
	        'FR': {
	            'status': 'assigned',
	            'phoneCountryCode': '33',
	            'showCountryCodeList': false
	        },
	        'GA': {
	            'status': 'assigned',
	            'phoneCountryCode': '241',
	            'showCountryCodeList': false
	        },
	        'GB': {
	            'status': 'assigned',
	            'phoneCountryCode': '44',
	            'showCountryCodeList': false
	        },
	        'GD': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'GE': {
	            'status': 'assigned',
	            'phoneCountryCode': '995',
	            'showCountryCodeList': false
	        },
	        'GF': {
	            'status': 'assigned',
	            'phoneCountryCode': '594',
	            'showCountryCodeList': false
	        },
	        'GG': {
	            'status': 'assigned',
	            'phoneCountryCode': '44',
	            'showCountryCodeList': false
	        },
	        'GH': {
	            'status': 'assigned',
	            'phoneCountryCode': '233',
	            'showCountryCodeList': false
	        },
	        'GI': {
	            'status': 'assigned',
	            'phoneCountryCode': '350',
	            'showCountryCodeList': false
	        },
	        'GL': {
	            'status': 'assigned',
	            'phoneCountryCode': '299',
	            'showCountryCodeList': false
	        },
	        'GM': {
	            'status': 'assigned',
	            'phoneCountryCode': '220',
	            'showCountryCodeList': false
	        },
	        'GN': {
	            'status': 'assigned',
	            'phoneCountryCode': '224',
	            'showCountryCodeList': false
	        },
	        'GP': {
	            'status': 'assigned',
	            'phoneCountryCode': '590',
	            'showCountryCodeList': false
	        },
	        'GQ': {
	            'status': 'assigned',
	            'phoneCountryCode': '240',
	            'showCountryCodeList': false
	        },
	        'GR': {
	            'status': 'assigned',
	            'phoneCountryCode': '30',
	            'showCountryCodeList': false
	        },
	        'GS': {
	            'status': 'assigned',
	            'phoneCountryCode': '500',
	            'showCountryCodeList': false
	        },
	        'GT': {
	            'status': 'assigned',
	            'phoneCountryCode': '502',
	            'showCountryCodeList': false
	        },
	        'GU': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'GW': {
	            'status': 'assigned',
	            'phoneCountryCode': '245',
	            'showCountryCodeList': false
	        },
	        'GY': {
	            'status': 'assigned',
	            'phoneCountryCode': '592',
	            'showCountryCodeList': false
	        },
	        'HK': {
	            'status': 'assigned',
	            'phoneCountryCode': '852',
	            'showCountryCodeList': true
	        },
	        'HM': {
	            'status': 'assigned'
	        },
	        'HN': {
	            'status': 'assigned',
	            'phoneCountryCode': '504',
	            'showCountryCodeList': false
	        },
	        'HR': {
	            'status': 'assigned',
	            'phoneCountryCode': '385',
	            'showCountryCodeList': false
	        },
	        'HT': {
	            'status': 'assigned',
	            'phoneCountryCode': '509',
	            'showCountryCodeList': false
	        },
	        'HU': {
	            'status': 'assigned',
	            'phoneCountryCode': '36',
	            'showCountryCodeList': false
	        },
	        'ID': {
	            'status': 'assigned',
	            'phoneCountryCode': '62',
	            'showCountryCodeList': false
	        },
	        'IE': {
	            'status': 'assigned',
	            'phoneCountryCode': '353',
	            'showCountryCodeList': false
	        },
	        'IL': {
	            'status': 'assigned',
	            'phoneCountryCode': '972',
	            'showCountryCodeList': false
	        },
	        'IM': {
	            'status': 'assigned',
	            'phoneCountryCode': '44',
	            'showCountryCodeList': false
	        },
	        'IN': {
	            'status': 'assigned',
	            'phoneCountryCode': '91',
	            'showCountryCodeList': false
	        },
	        'IO': {
	            'status': 'assigned',
	            'phoneCountryCode': '246',
	            'showCountryCodeList': false
	        },
	        'IQ': {
	            'status': 'assigned',
	            'phoneCountryCode': '964',
	            'showCountryCodeList': false
	        },
	        'IR': {
	            'status': 'assigned',
	            'phoneCountryCode': '98',
	            'showCountryCodeList': false
	        },
	        'IS': {
	            'status': 'assigned',
	            'phoneCountryCode': '354',
	            'showCountryCodeList': false
	        },
	        'IT': {
	            'status': 'assigned',
	            'phoneCountryCode': '39',
	            'showCountryCodeList': false
	        },
	        'JE': {
	            'status': 'assigned',
	            'phoneCountryCode': '44',
	            'showCountryCodeList': false
	        },
	        'JM': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'JO': {
	            'status': 'assigned',
	            'phoneCountryCode': '962',
	            'showCountryCodeList': false
	        },
	        'JP': {
	            'status': 'assigned',
	            'phoneCountryCode': '81',
	            'showCountryCodeList': false
	        },
	        'KE': {
	            'status': 'assigned',
	            'phoneCountryCode': '254',
	            'showCountryCodeList': false
	        },
	        'KG': {
	            'status': 'assigned',
	            'phoneCountryCode': '996',
	            'showCountryCodeList': false
	        },
	        'KH': {
	            'status': 'assigned',
	            'phoneCountryCode': '855',
	            'showCountryCodeList': false
	        },
	        'KI': {
	            'status': 'assigned',
	            'phoneCountryCode': '686',
	            'showCountryCodeList': false
	        },
	        'KM': {
	            'status': 'assigned',
	            'phoneCountryCode': '269',
	            'showCountryCodeList': false
	        },
	        'KN': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'KP': {
	            'status': 'assigned',
	            'phoneCountryCode': '850',
	            'showCountryCodeList': false
	        },
	        'KR': {
	            'status': 'assigned',
	            'phoneCountryCode': '82',
	            'showCountryCodeList': false
	        },
	        'KW': {
	            'status': 'assigned',
	            'phoneCountryCode': '965',
	            'showCountryCodeList': false
	        },
	        'KY': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'KZ': {
	            'status': 'assigned',
	            'phoneCountryCode': '7',
	            'showCountryCodeList': false
	        },
	        'LA': {
	            'status': 'assigned',
	            'phoneCountryCode': '856',
	            'showCountryCodeList': true
	        },
	        'LB': {
	            'status': 'assigned',
	            'phoneCountryCode': '961',
	            'showCountryCodeList': false
	        },
	        'LC': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'LI': {
	            'status': 'assigned',
	            'phoneCountryCode': '423',
	            'showCountryCodeList': false
	        },
	        'LK': {
	            'status': 'assigned',
	            'phoneCountryCode': '94',
	            'showCountryCodeList': false
	        },
	        'LR': {
	            'status': 'assigned',
	            'phoneCountryCode': '231',
	            'showCountryCodeList': false
	        },
	        'LS': {
	            'status': 'assigned',
	            'phoneCountryCode': '266',
	            'showCountryCodeList': false
	        },
	        'LT': {
	            'status': 'assigned',
	            'phoneCountryCode': '370',
	            'showCountryCodeList': false
	        },
	        'LU': {
	            'status': 'assigned',
	            'phoneCountryCode': '352',
	            'showCountryCodeList': false
	        },
	        'LV': {
	            'status': 'assigned',
	            'phoneCountryCode': '371',
	            'showCountryCodeList': false
	        },
	        'LY': {
	            'status': 'assigned',
	            'phoneCountryCode': '218',
	            'showCountryCodeList': false
	        },
	        'MA': {
	            'status': 'assigned',
	            'phoneCountryCode': '212',
	            'showCountryCodeList': false
	        },
	        'MC': {
	            'status': 'assigned',
	            'phoneCountryCode': '377',
	            'showCountryCodeList': false
	        },
	        'MD': {
	            'status': 'assigned',
	            'phoneCountryCode': '373',
	            'showCountryCodeList': false
	        },
	        'ME': {
	            'status': 'assigned',
	            'phoneCountryCode': '382',
	            'showCountryCodeList': false
	        },
	        'MF': {
	            'status': 'assigned',
	            'phoneCountryCode': '590',
	            'showCountryCodeList': false
	        },
	        'MG': {
	            'status': 'assigned',
	            'phoneCountryCode': '261',
	            'showCountryCodeList': false
	        },
	        'MH': {
	            'status': 'assigned',
	            'phoneCountryCode': '692',
	            'showCountryCodeList': false
	        },
	        'MK': {
	            'status': 'assigned',
	            'phoneCountryCode': '389',
	            'showCountryCodeList': false
	        },
	        'ML': {
	            'status': 'assigned',
	            'phoneCountryCode': '223',
	            'showCountryCodeList': false
	        },
	        'MM': {
	            'status': 'assigned',
	            'phoneCountryCode': '95',
	            'showCountryCodeList': false
	        },
	        'MN': {
	            'status': 'assigned',
	            'phoneCountryCode': '976',
	            'showCountryCodeList': false
	        },
	        'MO': {
	            'status': 'assigned',
	            'phoneCountryCode': '853',
	            'showCountryCodeList': false
	        },
	        'MP': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'MQ': {
	            'status': 'assigned',
	            'phoneCountryCode': '596',
	            'showCountryCodeList': false
	        },
	        'MR': {
	            'status': 'assigned',
	            'phoneCountryCode': '222',
	            'showCountryCodeList': false
	        },
	        'MS': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'MT': {
	            'status': 'assigned',
	            'phoneCountryCode': '356',
	            'showCountryCodeList': false
	        },
	        'MU': {
	            'status': 'assigned',
	            'phoneCountryCode': '230',
	            'showCountryCodeList': false
	        },
	        'MV': {
	            'status': 'assigned',
	            'phoneCountryCode': '960',
	            'showCountryCodeList': false
	        },
	        'MW': {
	            'status': 'assigned',
	            'phoneCountryCode': '265',
	            'showCountryCodeList': false
	        },
	        'MX': {
	            'status': 'assigned',
	            'phoneCountryCode': '52',
	            'showCountryCodeList': false
	        },
	        'MY': {
	            'status': 'assigned',
	            'phoneCountryCode': '60',
	            'showCountryCodeList': false
	        },
	        'MZ': {
	            'status': 'assigned',
	            'phoneCountryCode': '258',
	            'showCountryCodeList': false
	        },
	        'NA': {
	            'status': 'assigned',
	            'phoneCountryCode': '264',
	            'showCountryCodeList': false
	        },
	        'NC': {
	            'status': 'assigned',
	            'phoneCountryCode': '687',
	            'showCountryCodeList': false
	        },
	        'NE': {
	            'status': 'assigned',
	            'phoneCountryCode': '227',
	            'showCountryCodeList': false
	        },
	        'NF': {
	            'status': 'assigned',
	            'phoneCountryCode': '672',
	            'showCountryCodeList': false
	        },
	        'NG': {
	            'status': 'assigned',
	            'phoneCountryCode': '234',
	            'showCountryCodeList': false
	        },
	        'NI': {
	            'status': 'assigned',
	            'phoneCountryCode': '505',
	            'showCountryCodeList': false
	        },
	        'NL': {
	            'status': 'assigned',
	            'phoneCountryCode': '31',
	            'showCountryCodeList': true
	        },
	        'NO': {
	            'status': 'assigned',
	            'phoneCountryCode': '47',
	            'showCountryCodeList': true
	        },
	        'NP': {
	            'status': 'assigned',
	            'phoneCountryCode': '977',
	            'showCountryCodeList': false
	        },
	        'NR': {
	            'status': 'assigned',
	            'phoneCountryCode': '674',
	            'showCountryCodeList': false
	        },
	        'NU': {
	            'status': 'assigned',
	            'phoneCountryCode': '683',
	            'showCountryCodeList': false
	        },
	        'NZ': {
	            'status': 'assigned',
	            'phoneCountryCode': '64',
	            'showCountryCodeList': false
	        },
	        'OM': {
	            'status': 'assigned',
	            'phoneCountryCode': '968',
	            'showCountryCodeList': false
	        },
	        'PA': {
	            'status': 'assigned',
	            'phoneCountryCode': '507',
	            'showCountryCodeList': false
	        },
	        'PE': {
	            'status': 'assigned',
	            'phoneCountryCode': '51',
	            'showCountryCodeList': false
	        },
	        'PF': {
	            'status': 'assigned',
	            'phoneCountryCode': '689',
	            'showCountryCodeList': false
	        },
	        'PG': {
	            'status': 'assigned',
	            'phoneCountryCode': '675',
	            'showCountryCodeList': false
	        },
	        'PH': {
	            'status': 'assigned',
	            'phoneCountryCode': '63',
	            'showCountryCodeList': false
	        },
	        'PK': {
	            'status': 'assigned',
	            'phoneCountryCode': '92',
	            'showCountryCodeList': false
	        },
	        'PL': {
	            'status': 'assigned',
	            'phoneCountryCode': '48',
	            'showCountryCodeList': true
	        },
	        'PM': {
	            'status': 'assigned',
	            'phoneCountryCode': '508',
	            'showCountryCodeList': false
	        },
	        'PN': {
	            'status': 'assigned',
	            'phoneCountryCode': '870',
	            'showCountryCodeList': false
	        },
	        'PR': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'PS': {
	            'status': 'assigned',
	            'phoneCountryCode': '970',
	            'showCountryCodeList': false
	        },
	        'PT': {
	            'status': 'assigned',
	            'phoneCountryCode': '351',
	            'showCountryCodeList': false
	        },
	        'PW': {
	            'status': 'assigned',
	            'phoneCountryCode': '680',
	            'showCountryCodeList': false
	        },
	        'PY': {
	            'status': 'assigned',
	            'phoneCountryCode': '595',
	            'showCountryCodeList': false
	        },
	        'QA': {
	            'status': 'assigned',
	            'phoneCountryCode': '974',
	            'showCountryCodeList': false
	        },
	        'RE': {
	            'status': 'assigned',
	            'phoneCountryCode': '262',
	            'showCountryCodeList': false
	        },
	        'RO': {
	            'status': 'assigned',
	            'phoneCountryCode': '40',
	            'showCountryCodeList': false
	        },
	        'RS': {
	            'status': 'assigned',
	            'phoneCountryCode': '381',
	            'showCountryCodeList': false
	        },
	        'RU': {
	            'status': 'assigned',
	            'phoneCountryCode': '7',
	            'showCountryCodeList': false
	        },
	        'RW': {
	            'status': 'assigned',
	            'phoneCountryCode': '250',
	            'showCountryCodeList': false
	        },
	        'SA': {
	            'status': 'assigned',
	            'phoneCountryCode': '966',
	            'showCountryCodeList': false
	        },
	        'SB': {
	            'status': 'assigned',
	            'phoneCountryCode': '677',
	            'showCountryCodeList': false
	        },
	        'SC': {
	            'status': 'assigned',
	            'phoneCountryCode': '248',
	            'showCountryCodeList': false
	        },
	        'SD': {
	            'status': 'assigned',
	            'phoneCountryCode': '249',
	            'showCountryCodeList': false
	        },
	        'SE': {
	            'status': 'assigned',
	            'phoneCountryCode': '46',
	            'showCountryCodeList': true
	        },
	        'SG': {
	            'status': 'assigned',
	            'phoneCountryCode': '65',
	            'showCountryCodeList': true
	        },
	        'SH': {
	            'status': 'assigned',
	            'phoneCountryCode': '290',
	            'showCountryCodeList': false
	        },
	        'SI': {
	            'status': 'assigned',
	            'phoneCountryCode': '386',
	            'showCountryCodeList': false
	        },
	        'SJ': {
	            'status': 'assigned',
	            'phoneCountryCode': '47',
	            'showCountryCodeList': false
	        },
	        'SK': {
	            'status': 'assigned',
	            'phoneCountryCode': '421',
	            'showCountryCodeList': false
	        },
	        'SL': {
	            'status': 'assigned',
	            'phoneCountryCode': '232',
	            'showCountryCodeList': false
	        },
	        'SM': {
	            'status': 'assigned',
	            'phoneCountryCode': '378',
	            'showCountryCodeList': false
	        },
	        'SN': {
	            'status': 'assigned',
	            'phoneCountryCode': '221',
	            'showCountryCodeList': false
	        },
	        'SO': {
	            'status': 'assigned',
	            'phoneCountryCode': '252',
	            'showCountryCodeList': false
	        },
	        'SR': {
	            'status': 'assigned',
	            'phoneCountryCode': '597',
	            'showCountryCodeList': false
	        },
	        'SS': {
	            'status': 'assigned',
	            'phoneCountryCode': '211',
	            'showCountryCodeList': false
	        },
	        'ST': {
	            'status': 'assigned',
	            'phoneCountryCode': '239',
	            'showCountryCodeList': false
	        },
	        'SV': {
	            'status': 'assigned',
	            'phoneCountryCode': '503',
	            'showCountryCodeList': false
	        },
	        'SX': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'SY': {
	            'status': 'assigned',
	            'phoneCountryCode': '963',
	            'showCountryCodeList': false
	        },
	        'SZ': {
	            'status': 'assigned',
	            'phoneCountryCode': '268',
	            'showCountryCodeList': false
	        },
	        'TC': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'TD': {
	            'status': 'assigned',
	            'phoneCountryCode': '235',
	            'showCountryCodeList': false
	        },
	        'TF': {
	            'status': 'assigned',
	            'phoneCountryCode': '262',
	            'showCountryCodeList': false
	        },
	        'TG': {
	            'status': 'assigned',
	            'phoneCountryCode': '228',
	            'showCountryCodeList': false
	        },
	        'TH': {
	            'status': 'assigned',
	            'phoneCountryCode': '66',
	            'showCountryCodeList': false
	        },
	        'TJ': {
	            'status': 'assigned',
	            'phoneCountryCode': '992',
	            'showCountryCodeList': false
	        },
	        'TK': {
	            'status': 'assigned',
	            'phoneCountryCode': '690',
	            'showCountryCodeList': false
	        },
	        'TL': {
	            'status': 'assigned',
	            'phoneCountryCode': '670',
	            'showCountryCodeList': false
	        },
	        'TM': {
	            'status': 'assigned',
	            'phoneCountryCode': '993',
	            'showCountryCodeList': false
	        },
	        'TN': {
	            'status': 'assigned',
	            'phoneCountryCode': '216',
	            'showCountryCodeList': false
	        },
	        'TO': {
	            'status': 'assigned',
	            'phoneCountryCode': '676',
	            'showCountryCodeList': false
	        },
	        'TR': {
	            'status': 'assigned',
	            'phoneCountryCode': '90',
	            'showCountryCodeList': true
	        },
	        'TT': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'TV': {
	            'status': 'assigned',
	            'phoneCountryCode': '688',
	            'showCountryCodeList': false
	        },
	        'TW': {
	            'status': 'assigned',
	            'phoneCountryCode': '886',
	            'showCountryCodeList': true
	        },
	        'TZ': {
	            'status': 'assigned',
	            'phoneCountryCode': '255',
	            'showCountryCodeList': false
	        },
	        'UA': {
	            'status': 'assigned',
	            'phoneCountryCode': '380',
	            'showCountryCodeList': false
	        },
	        'UG': {
	            'status': 'assigned',
	            'phoneCountryCode': '256',
	            'showCountryCodeList': false
	        },
	        'UM': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'US': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false,
	            'hideInOtherCountries': true
	        },
	        'UY': {
	            'status': 'assigned',
	            'phoneCountryCode': '598',
	            'showCountryCodeList': false
	        },
	        'UZ': {
	            'status': 'assigned',
	            'phoneCountryCode': '998',
	            'showCountryCodeList': false
	        },
	        'VA': {
	            'status': 'assigned',
	            'phoneCountryCode': '39',
	            'showCountryCodeList': false
	        },
	        'VC': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'VE': {
	            'status': 'assigned',
	            'phoneCountryCode': '58',
	            'showCountryCodeList': false
	        },
	        'VG': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'VI': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'VN': {
	            'status': 'assigned',
	            'phoneCountryCode': '84',
	            'showCountryCodeList': false
	        },
	        'VU': {
	            'status': 'assigned',
	            'phoneCountryCode': '678',
	            'showCountryCodeList': false
	        },
	        'WF': {
	            'status': 'assigned',
	            'phoneCountryCode': '681',
	            'showCountryCodeList': false
	        },
	        'WS': {
	            'status': 'assigned',
	            'phoneCountryCode': '685',
	            'showCountryCodeList': false
	        },
	        'YE': {
	            'status': 'assigned',
	            'phoneCountryCode': '967',
	            'showCountryCodeList': false
	        },
	        'YT': {
	            'status': 'assigned',
	            'phoneCountryCode': '262',
	            'showCountryCodeList': false
	        },
	        'ZA': {
	            'status': 'assigned',
	            'phoneCountryCode': '27',
	            'showCountryCodeList': false
	        },
	        'ZM': {
	            'status': 'assigned',
	            'phoneCountryCode': '260',
	            'showCountryCodeList': false
	        },
	        'ZW': {
	            'status': 'assigned',
	            'phoneCountryCode': '263',
	            'showCountryCodeList': false
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "./components/xo-wallet-components/src/add-bank/bank-input/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-bank/bank-input/template.html"), __webpack_require__("./components/jquery-mask-plugin/dist/jquery.mask.js"), __webpack_require__("./components/xo-models/src/fi/index.js"), __webpack_require__("./components/xo-ui-components/src/dropdown/directive.js"), __webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid, template) {
	
	    return squid.module('xo-add-bank.bank-input.directive', ['squid', 'xomodel.fi', 'xo-dropdown.directive', 'xo-error-tooltip.directive']).directive('xoBankInput', function ($rootScope) {
	        return {
	            template: template,
	
	            scope: {
	                user: '=',
	                bank: '=',
	                isUnbranded: '='
	            },
	
	            /* auto formatting the user entered IBAN input */
	            link: function link(scope, element, attr) {
	                var IBANMask = 'AA00 0000 0000 0000 0000 0000 0000 0000 00';
	
	                element.on('keyup', function (event) {
	
	                    $('#ibanNumber').mask(IBANMask, {
	                        'translation': {
	                            0: { pattern: /[A-Za-z0-9]/ }
	                        }
	                    });
	                });
	            },
	
	            controller: function controller($scope, $AddBankModel) {
	
	                $scope.showIBAN = $scope.isUnbranded ? true : false;
	
	                var days = [];
	                var months = [];
	                var years = [];
	
	                var i;
	                for (i = 1; i <= 31; i += 1) {
	                    var d = i < 10 ? '0' + i : i.toString();
	                    days.push(d);
	                }
	
	                for (i = 1; i <= 12; i += 1) {
	                    var m = i < 10 ? '0' + i : i.toString();
	                    months.push(m);
	                }
	
	                var year = new Date().getFullYear();
	
	                for (i = year - 17; i >= year - 100; i -= 1) {
	                    years.push(i);
	                }
	
	                $scope.days = days;
	                $scope.months = months;
	                $scope.years = years;
	
	                $scope.toggleIBAN = function () {
	                    $scope.showIBAN = !$scope.showIBAN;
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-bank/bank-input/template.html":
/***/ (function(module, exports) {

	module.exports = "<div id=\"bankFields\" content>\n\n    <div class=\"bban\" ng-if = \"!showIBAN\">\n        <p class=\"entryToggleLinks\">{{content('bank.enterBBAN')}}\n            <a class=\"toggle rightLink\" href ng-click=\"toggleIBAN()\">{{content('bank.insteadIBAN')}}</a>\n        </p>\n\n        <div class=\"inputField restricted\" floating-label>\n            <input id=\"bankAccountNumber\" name=\"bankAccountNumber\" type=\"text\" value=\"\" ng-model=\"bank.bank_account_number\" placeholder=\"{{content('DEMemberGuest.accountPlaceholder')}}\" autocomplete=\"off\" pattern=\"[0-9]*\" maxlength=\"10\" aria-required=\"true\"\n                   xo-validation='{\n                \"validator\": \"validBankAccount\",\n                \"required\":  \"{{showIBAN}}\"\n            }' data-error-key=\"scripts.validNumber\" xo-error-tooltip />\n            <label for=\"bankAccountNumber\">\n                {{content('DEMemberGuest.account')}}\n            </label>\n        </div>\n\n        <div class=\"inputField restricted\" floating-label>\n            <input id=\"blz\" name=\"blz\" type=\"text\" value=\"\" ng-model=\"bank.bank_routing_number\" placeholder=\"{{content('DEMemberGuest.sortPlaceholder')}}\" autocomplete=\"off\" pattern=\"[0-9]*\" maxlength=\"8\" aria-required=\"true\"  xo-validation='{\n                \"validator\": \"validRouting\",\n                \"required\":  \"{{showIBAN}}\"\n            }' data-error-key=\"scripts.validNumber\" xo-error-tooltip />\n            <label for=\"blz\">\n                {{content('DEMemberGuest.sort')}}\n            </label>\n        </div>\n    </div>\n    <div class=\"iban\" ng-if=\"showIBAN\">\n        <p class=\"entryToggleLinks\">{{content('bank.enterIBAN')}}\n            <a class=\"toggle rightLink\" href ng-click=\"toggleIBAN()\">{{content('bank.insteadBBAN')}}</a>\n        </p>\n        <div class=\"inputField restricted\" floating-label>\n            <input id=\"ibanNumber\" name=\"ibanNumber\" type=\"text\" value=\"\" placeholder=\"{{content('bank.IBANPlaceholder')}}\" autocomplete=\"off\" maxlength=\"42\" aria-required=\"true\" ng-model=\"bank.iban_number\" xo-validation='{ \"validator\": \"validIBANWithValidCountryCode\",\n            \"required\":  \"{{showIBAN}}\"} ' data-error-key=\"scripts.validIBAN\" xo-error-tooltip />\n            <label for=\"ibanNumber\">\n                {{content('bank.iban')}}\n            </label>\n        </div>\n    </div>\n\n    <div id=\"dobBank\" class=\"dobbank mb10\">\n        <fieldset>\n            <legend class=\"fieldLegend\" for=\"dob\">{{content('DEMemberGuest.dob')}}</legend>\n\n            <div class=\"dropdown fidobDay\">\n                <select xo-dropdown name=\"dobDay\" ng-model=\"user.dob_day\" id=\"dobDay\" aria-label=\"{{content('applyForBml.bmlApplyDay')}}\" aria-required=\"true\" required>\n                    <option value=\"\">{{content('applyForBml.bmlApplyDD')}}</option>\n                    <option ng-repeat=\"day in days\" value=\"{{day}}\" ng-selected=\"user.dob_day==='{{day}}'\">{{day}}</option>\n                </select>\n            </div>\n\n\n            <div class=\"dropdown fidobMonth\">\n                <select xo-dropdown name=\"dobMonth\" ng-model=\"user.dob_month\" id=\"dobMonth\" aria-label=\"{{content('applyForBml.bmlApplyMonth')}}\" aria-required=\"true\" required>\n                    <option value=\"\">{{content('applyForBml.bmlApplyMM')}}</option>\n                    <option ng-repeat=\"month in months\" value=\"{{month}}\" ng-selected=\"user.dob_month==='{{month}}'\">{{month}}</option>\n                </select>\n            </div>\n\n            <div class=\"dropdown fidobYear\">\n                <select xo-dropdown name=\"dobYear\" ng-model=\"user.dob_year\" id=\"dobYear\" aria-label=\"{{content('applyForBml.bmlApplyYear')}}\" aria-required=\"true\" required>\n                    <option value=\"\">{{content('applyForBml.bmlApplyYYYY')}}</option>\n                    <option ng-repeat=\"year in years\" value=\"{{year}}\" ng-selected=\"user.dob_year==='{{year}}'\">{{year}}</option>\n                </select>\n            </div>\n\n        </fieldset>\n    </div>\n</div>\n"

/***/ }),

/***/ "./components/jquery-mask-plugin/dist/jquery.mask.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/*** IMPORTS FROM imports-loader ***/
	var jquery = __webpack_provided_window_dot_jQuery;
	
	/**
	 * jquery.mask.js
	 * @version: v1.14.11
	 * @author: Igor Escobar
	 *
	 * Created by Igor Escobar on 2012-03-10. Please report any bug at http://blog.igorescobar.com
	 *
	 * Copyright (c) 2012 Igor Escobar http://blog.igorescobar.com
	 *
	 * The MIT License (http://www.opensource.org/licenses/mit-license.php)
	 *
	 * Permission is hereby granted, free of charge, to any person
	 * obtaining a copy of this software and associated documentation
	 * files (the "Software"), to deal in the Software without
	 * restriction, including without limitation the rights to use,
	 * copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the
	 * Software is furnished to do so, subject to the following
	 * conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
	 * OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
	 * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
	 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
	 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
	 * OTHER DEALINGS IN THE SOFTWARE.
	 */
	
	/* jshint laxbreak: true */
	/* jshint maxcomplexity:17 */
	/* global define */
	
	
	
	// UMD (Universal Module Definition) patterns for JavaScript modules that work everywhere.
	// https://github.com/umdjs/umd/blob/master/jqueryPluginCommonjs.js
	(function (factory, jQuery, Zepto) {
	
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        module.exports = factory(require('jquery'));
	    } else {
	        factory(jQuery || Zepto);
	    }
	
	}(function ($) {
	
	    var Mask = function (el, mask, options) {
	
	        var p = {
	            invalid: [],
	            getCaret: function () {
	                try {
	                    var sel,
	                        pos = 0,
	                        ctrl = el.get(0),
	                        dSel = document.selection,
	                        cSelStart = ctrl.selectionStart;
	
	                    // IE Support
	                    if (dSel && navigator.appVersion.indexOf('MSIE 10') === -1) {
	                        sel = dSel.createRange();
	                        sel.moveStart('character', -p.val().length);
	                        pos = sel.text.length;
	                    }
	                    // Firefox support
	                    else if (cSelStart || cSelStart === '0') {
	                        pos = cSelStart;
	                    }
	
	                    return pos;
	                } catch (e) {}
	            },
	            setCaret: function(pos) {
	                try {
	                    if (el.is(':focus')) {
	                        var range, ctrl = el.get(0);
	
	                        // Firefox, WebKit, etc..
	                        if (ctrl.setSelectionRange) {
	                            ctrl.setSelectionRange(pos, pos);
	                        } else { // IE
	                            range = ctrl.createTextRange();
	                            range.collapse(true);
	                            range.moveEnd('character', pos);
	                            range.moveStart('character', pos);
	                            range.select();
	                        }
	                    }
	                } catch (e) {}
	            },
	            events: function() {
	                el
	                .on('keydown.mask', function(e) {
	                    el.data('mask-keycode', e.keyCode || e.which);
	                    el.data('mask-previus-value', el.val());
	                    el.data('mask-previus-caret-pos', p.getCaret());
	                    p.maskDigitPosMapOld = p.maskDigitPosMap;
	                })
	                .on($.jMaskGlobals.useInput ? 'input.mask' : 'keyup.mask', p.behaviour)
	                .on('paste.mask drop.mask', function() {
	                    setTimeout(function() {
	                        el.keydown().keyup();
	                    }, 100);
	                })
	                .on('change.mask', function(){
	                    el.data('changed', true);
	                })
	                .on('blur.mask', function(){
	                    if (oldValue !== p.val() && !el.data('changed')) {
	                        el.trigger('change');
	                    }
	                    el.data('changed', false);
	                })
	                // it's very important that this callback remains in this position
	                // otherwhise oldValue it's going to work buggy
	                .on('blur.mask', function() {
	                    oldValue = p.val();
	                })
	                // select all text on focus
	                .on('focus.mask', function (e) {
	                    if (options.selectOnFocus === true) {
	                        $(e.target).select();
	                    }
	                })
	                // clear the value if it not complete the mask
	                .on('focusout.mask', function() {
	                    if (options.clearIfNotMatch && !regexMask.test(p.val())) {
	                       p.val('');
	                   }
	                });
	            },
	            getRegexMask: function() {
	                var maskChunks = [], translation, pattern, optional, recursive, oRecursive, r;
	
	                for (var i = 0; i < mask.length; i++) {
	                    translation = jMask.translation[mask.charAt(i)];
	
	                    if (translation) {
	
	                        pattern = translation.pattern.toString().replace(/.{1}$|^.{1}/g, '');
	                        optional = translation.optional;
	                        recursive = translation.recursive;
	
	                        if (recursive) {
	                            maskChunks.push(mask.charAt(i));
	                            oRecursive = {digit: mask.charAt(i), pattern: pattern};
	                        } else {
	                            maskChunks.push(!optional && !recursive ? pattern : (pattern + '?'));
	                        }
	
	                    } else {
	                        maskChunks.push(mask.charAt(i).replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'));
	                    }
	                }
	
	                r = maskChunks.join('');
	
	                if (oRecursive) {
	                    r = r.replace(new RegExp('(' + oRecursive.digit + '(.*' + oRecursive.digit + ')?)'), '($1)?')
	                         .replace(new RegExp(oRecursive.digit, 'g'), oRecursive.pattern);
	                }
	
	                return new RegExp(r);
	            },
	            destroyEvents: function() {
	                el.off(['input', 'keydown', 'keyup', 'paste', 'drop', 'blur', 'focusout', ''].join('.mask '));
	            },
	            val: function(v) {
	                var isInput = el.is('input'),
	                    method = isInput ? 'val' : 'text',
	                    r;
	
	                if (arguments.length > 0) {
	                    if (el[method]() !== v) {
	                        el[method](v);
	                    }
	                    r = el;
	                } else {
	                    r = el[method]();
	                }
	
	                return r;
	            },
	            calculateCaretPosition: function() {
	                var oldVal = el.data('mask-previus-value') || '',
	                    newVal = p.getMasked(),
	                    caretPosNew = p.getCaret();
	                if (oldVal !== newVal) {
	                    var caretPosOld = el.data('mask-previus-caret-pos') || 0,
	                        newValL = newVal.length,
	                        oldValL = oldVal.length,
	                        maskDigitsBeforeCaret = 0,
	                        maskDigitsAfterCaret = 0,
	                        maskDigitsBeforeCaretAll = 0,
	                        maskDigitsBeforeCaretAllOld = 0,
	                        i = 0;
	
	                    for (i = caretPosNew; i < newValL; i++) {
	                        if (!p.maskDigitPosMap[i]) {
	                            break;
	                        }
	                        maskDigitsAfterCaret++;
	                    }
	
	                    for (i = caretPosNew - 1; i >= 0; i--) {
	                        if (!p.maskDigitPosMap[i]) {
	                            break;
	                        }
	                        maskDigitsBeforeCaret++;
	                    }
	
	                    for (i = caretPosNew - 1; i >= 0; i--) {
	                        if (p.maskDigitPosMap[i]) {
	                            maskDigitsBeforeCaretAll++;
	                        }
	                    }
	
	                    for (i = caretPosOld - 1; i >= 0; i--) {
	                        if (p.maskDigitPosMapOld[i]) {
	                            maskDigitsBeforeCaretAllOld++;
	                        }
	                    }
	
	                    if (caretPosNew > oldValL) {
	                      // if the cursor is at the end keep it there
	                      caretPosNew = newValL;
	                    }
	                    else if (caretPosOld >= caretPosNew && caretPosOld !== oldValL) {
	                        if (!p.maskDigitPosMapOld[caretPosNew])  {
	                          var caretPos = caretPosNew;
	                          caretPosNew -= maskDigitsBeforeCaretAllOld - maskDigitsBeforeCaretAll;
	                          caretPosNew -= maskDigitsBeforeCaret;
	                          if (p.maskDigitPosMap[caretPosNew])  {
	                            caretPosNew = caretPos;
	                          }
	                        }
	                    }
	                    else if (caretPosNew > caretPosOld) {
	                        caretPosNew += maskDigitsBeforeCaretAll - maskDigitsBeforeCaretAllOld;
	                        caretPosNew += maskDigitsAfterCaret;
	                    }
	                }
	                return caretPosNew;
	            },
	            behaviour: function(e) {
	                e = e || window.event;
	                p.invalid = [];
	
	                var keyCode = el.data('mask-keycode');
	
	                if ($.inArray(keyCode, jMask.byPassKeys) === -1) {
	                    var newVal   = p.getMasked();
	
	                    setTimeout(function() {
	                      p.setCaret(p.calculateCaretPosition());
	                    }, 10);
	
	                    p.val(newVal);
	                    p.setCaret(newVal.length);
	                    return p.callbacks(e);
	                }
	            },
	            getMasked: function(skipMaskChars, val) {
	                var buf = [],
	                    value = val === undefined ? p.val() : val + '',
	                    m = 0, maskLen = mask.length,
	                    v = 0, valLen = value.length,
	                    offset = 1, addMethod = 'push',
	                    resetPos = -1,
	                    maskDigitCount = 0,
	                    maskDigitPosArr = [],
	                    lastMaskChar,
	                    check;
	
	                if (options.reverse) {
	                    addMethod = 'unshift';
	                    offset = -1;
	                    lastMaskChar = 0;
	                    m = maskLen - 1;
	                    v = valLen - 1;
	                    check = function () {
	                        return m > -1 && v > -1;
	                    };
	                } else {
	                    lastMaskChar = maskLen - 1;
	                    check = function () {
	                        return m < maskLen && v < valLen;
	                    };
	                }
	
	                var lastUntranslatedMaskChar;
	                while (check()) {
	                    var maskDigit = mask.charAt(m),
	                        valDigit = value.charAt(v),
	                        translation = jMask.translation[maskDigit];
	
	                    if (translation) {
	                        if (valDigit.match(translation.pattern)) {
	                            buf[addMethod](valDigit);
	                             if (translation.recursive) {
	                                if (resetPos === -1) {
	                                    resetPos = m;
	                                } else if (m === lastMaskChar) {
	                                    m = resetPos - offset;
	                                }
	
	                                if (lastMaskChar === resetPos) {
	                                    m -= offset;
	                                }
	                            }
	                            m += offset;
	                        } else if (valDigit === lastUntranslatedMaskChar) {
	                            // matched the last untranslated (raw) mask character that we encountered
	                            // likely an insert offset the mask character from the last entry; fall
	                            // through and only increment v
	                            maskDigitCount--;
	                            lastUntranslatedMaskChar = undefined;
	                        } else if (translation.optional) {
	                            m += offset;
	                            v -= offset;
	                        } else if (translation.fallback) {
	                            buf[addMethod](translation.fallback);
	                            m += offset;
	                            v -= offset;
	                        } else {
	                          p.invalid.push({p: v, v: valDigit, e: translation.pattern});
	                        }
	                        v += offset;
	                    } else {
	                        if (!skipMaskChars) {
	                            buf[addMethod](maskDigit);
	                        }
	
	                        if (valDigit === maskDigit) {
	                            maskDigitPosArr.push(v);
	                            v += offset;
	                        } else {
	                            lastUntranslatedMaskChar = maskDigit;
	                            maskDigitPosArr.push(v + maskDigitCount);
	                            maskDigitCount++;
	                        }
	
	                        m += offset;
	                    }
	                }
	
	                var lastMaskCharDigit = mask.charAt(lastMaskChar);
	                if (maskLen === valLen + 1 && !jMask.translation[lastMaskCharDigit]) {
	                    buf.push(lastMaskCharDigit);
	                }
	
	                var newVal = buf.join('');
	                p.mapMaskdigitPositions(newVal, maskDigitPosArr, valLen);
	                return newVal;
	            },
	            mapMaskdigitPositions: function(newVal, maskDigitPosArr, valLen) {
	              var maskDiff = options.reverse ? newVal.length - valLen : 0;
	              p.maskDigitPosMap = {};
	              for (var i = 0; i < maskDigitPosArr.length; i++) {
	                p.maskDigitPosMap[maskDigitPosArr[i] + maskDiff] = 1;
	              }
	            },
	            callbacks: function (e) {
	                var val = p.val(),
	                    changed = val !== oldValue,
	                    defaultArgs = [val, e, el, options],
	                    callback = function(name, criteria, args) {
	                        if (typeof options[name] === 'function' && criteria) {
	                            options[name].apply(this, args);
	                        }
	                    };
	
	                callback('onChange', changed === true, defaultArgs);
	                callback('onKeyPress', changed === true, defaultArgs);
	                callback('onComplete', val.length === mask.length, defaultArgs);
	                callback('onInvalid', p.invalid.length > 0, [val, e, el, p.invalid, options]);
	            }
	        };
	
	        el = $(el);
	        var jMask = this, oldValue = p.val(), regexMask;
	
	        mask = typeof mask === 'function' ? mask(p.val(), undefined, el,  options) : mask;
	
	        // public methods
	        jMask.mask = mask;
	        jMask.options = options;
	        jMask.remove = function() {
	            var caret = p.getCaret();
	            p.destroyEvents();
	            p.val(jMask.getCleanVal());
	            p.setCaret(caret);
	            return el;
	        };
	
	        // get value without mask
	        jMask.getCleanVal = function() {
	           return p.getMasked(true);
	        };
	
	        // get masked value without the value being in the input or element
	        jMask.getMaskedVal = function(val) {
	           return p.getMasked(false, val);
	        };
	
	       jMask.init = function(onlyMask) {
	            onlyMask = onlyMask || false;
	            options = options || {};
	
	            jMask.clearIfNotMatch  = $.jMaskGlobals.clearIfNotMatch;
	            jMask.byPassKeys       = $.jMaskGlobals.byPassKeys;
	            jMask.translation      = $.extend({}, $.jMaskGlobals.translation, options.translation);
	
	            jMask = $.extend(true, {}, jMask, options);
	
	            regexMask = p.getRegexMask();
	
	            if (onlyMask) {
	                p.events();
	                p.val(p.getMasked());
	            } else {
	                if (options.placeholder) {
	                    el.attr('placeholder' , options.placeholder);
	                }
	
	                // this is necessary, otherwise if the user submit the form
	                // and then press the "back" button, the autocomplete will erase
	                // the data. Works fine on IE9+, FF, Opera, Safari.
	                if (el.data('mask')) {
	                  el.attr('autocomplete', 'off');
	                }
	
	                // detect if is necessary let the user type freely.
	                // for is a lot faster than forEach.
	                for (var i = 0, maxlength = true; i < mask.length; i++) {
	                    var translation = jMask.translation[mask.charAt(i)];
	                    if (translation && translation.recursive) {
	                        maxlength = false;
	                        break;
	                    }
	                }
	
	                if (maxlength) {
	                    el.attr('maxlength', mask.length);
	                }
	
	                p.destroyEvents();
	                p.events();
	
	                p.val(p.getMasked());
	                p.setCaret(p.getMasked().length);
	            }
	        };
	
	        jMask.init(!el.is('input'));
	    };
	
	    $.maskWatchers = {};
	    var HTMLAttributes = function () {
	        var input = $(this),
	            options = {},
	            prefix = 'data-mask-',
	            mask = input.attr('data-mask');
	
	        if (input.attr(prefix + 'reverse')) {
	            options.reverse = true;
	        }
	
	        if (input.attr(prefix + 'clearifnotmatch')) {
	            options.clearIfNotMatch = true;
	        }
	
	        if (input.attr(prefix + 'selectonfocus') === 'true') {
	           options.selectOnFocus = true;
	        }
	
	        if (notSameMaskObject(input, mask, options)) {
	            return input.data('mask', new Mask(this, mask, options));
	        }
	    },
	    notSameMaskObject = function(field, mask, options) {
	        options = options || {};
	        var maskObject = $(field).data('mask'),
	            stringify = JSON.stringify,
	            value = $(field).val() || $(field).text();
	        try {
	            if (typeof mask === 'function') {
	                mask = mask(value);
	            }
	            return typeof maskObject !== 'object' || stringify(maskObject.options) !== stringify(options) || maskObject.mask !== mask;
	        } catch (e) {}
	    },
	    eventSupported = function(eventName) {
	        var el = document.createElement('div'), isSupported;
	
	        eventName = 'on' + eventName;
	        isSupported = (eventName in el);
	
	        if ( !isSupported ) {
	            el.setAttribute(eventName, 'return;');
	            isSupported = typeof el[eventName] === 'function';
	        }
	        el = null;
	
	        return isSupported;
	    };
	
	    $.fn.mask = function(mask, options) {
	        options = options || {};
	        var selector = this.selector,
	            globals = $.jMaskGlobals,
	            interval = globals.watchInterval,
	            watchInputs = options.watchInputs || globals.watchInputs,
	            maskFunction = function() {
	                if (notSameMaskObject(this, mask, options)) {
	                    return $(this).data('mask', new Mask(this, mask, options));
	                }
	            };
	
	        $(this).each(maskFunction);
	
	        if (selector && selector !== '' && watchInputs) {
	            clearInterval($.maskWatchers[selector]);
	            $.maskWatchers[selector] = setInterval(function(){
	                $(document).find(selector).each(maskFunction);
	            }, interval);
	        }
	        return this;
	    };
	
	    $.fn.masked = function(val) {
	        return this.data('mask').getMaskedVal(val);
	    };
	
	    $.fn.unmask = function() {
	        clearInterval($.maskWatchers[this.selector]);
	        delete $.maskWatchers[this.selector];
	        return this.each(function() {
	            var dataMask = $(this).data('mask');
	            if (dataMask) {
	                dataMask.remove().removeData('mask');
	            }
	        });
	    };
	
	    $.fn.cleanVal = function() {
	        return this.data('mask').getCleanVal();
	    };
	
	    $.applyDataMask = function(selector) {
	        selector = selector || $.jMaskGlobals.maskElements;
	        var $selector = (selector instanceof $) ? selector : $(selector);
	        $selector.filter($.jMaskGlobals.dataMaskAttr).each(HTMLAttributes);
	    };
	
	    var globals = {
	        maskElements: 'input,td,span,div',
	        dataMaskAttr: '*[data-mask]',
	        dataMask: true,
	        watchInterval: 300,
	        watchInputs: true,
	        // old versions of chrome dont work great with input event
	        useInput: !/Chrome\/[2-4][0-9]|SamsungBrowser/.test(window.navigator.userAgent) && eventSupported('input'),
	        watchDataMask: false,
	        byPassKeys: [9, 16, 17, 18, 36, 37, 38, 39, 40, 91],
	        translation: {
	            '0': {pattern: /\d/},
	            '9': {pattern: /\d/, optional: true},
	            '#': {pattern: /\d/, recursive: true},
	            'A': {pattern: /[a-zA-Z0-9]/},
	            'S': {pattern: /[a-zA-Z]/}
	        }
	    };
	
	    $.jMaskGlobals = $.jMaskGlobals || {};
	    globals = $.jMaskGlobals = $.extend(true, {}, globals, $.jMaskGlobals);
	
	    // looking for inputs with data-mask attribute
	    if (globals.dataMask) {
	        $.applyDataMask();
	    }
	
	    setInterval(function() {
	        if ($.jMaskGlobals.watchDataMask) {
	            $.applyDataMask();
	        }
	    }, globals.watchInterval);
	}, __webpack_provided_window_dot_jQuery, window.Zepto));
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "./components/xo-address-components/src/address-normalization/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function($) {
	
	__webpack_require__("./components/xo-address-components/src/address-normalization/styles.less");
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-address-components/src/address-normalization/template.html"), __webpack_require__("./components/xo-models/src/address/index.js"), __webpack_require__("./components/xo-tray-height/dist/directive.js"), __webpack_require__("./components/xo-page-components/src/aside-header/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	
	    squid.module('xo-address-normalization.directive', ['squid', 'xomodel.address', 'xo-aside-header.directive', 'xomodel.address', 'xo-tray-height.directive']).directive('xoAddressNormalization', function () {
	        return {
	            template: template,
	            scope: {
	                id: '=',
	                address: '=',
	                doneFn: '=',
	                sidebar: '=',
	                hideBackButton: '='
	            },
	            controller: function controller($scope, $populate, $feature, $util, $AddressNormalizationModel, $timeout) {
	                $util.assert($scope.address, 'Original Address cannot be empty');
	
	                $scope.showNormalization = false;
	
	                var normalize = $feature('addressNormalization', false, $scope.address.country);
	                if (!normalize) {
	                    $scope.doneFn($scope.address, false);
	                    return;
	                }
	
	                var userEnteredAddress;
	                var addrFormat = $feature('FormatAddressForNormalization', $scope.address.country, $scope.address.country);
	
	                $scope.addressSelected = 'normalizedAddress';
	                $scope.transitionName = 'address_normalization_normalizedAddress';
	
	                // Brazil specific format
	                if (addrFormat === 'AddressBR') {
	                    userEnteredAddress = angular.fromJson(angular.toJson($scope.address));
	                    userEnteredAddress.line1 = $scope.address.line1 + '  ' + $scope.address.streetNumber;
	                    userEnteredAddress.line2 = $scope.address.neighborhood;
	                }
	
	                $scope.servAddress = userEnteredAddress ? userEnteredAddress : $scope.address;
	                $scope.servAddress.normalization_status = 'UNNORMALIZED_USER_PREFERRED';
	
	                $scope.addressNormalization = new $AddressNormalizationModel({
	                    id: $scope.id,
	                    address: $scope.servAddress
	                });
	
	                function centerLightBox() {
	                    var element = $('#lbox');
	                    if (!element.length) {
	                        return;
	                    }
	
	                    var windowElement = $(window);
	                    var lboxContainerElem = $('#lboxContainer');
	                    element.css('top', Math.max(0, (windowElement.height() - element.outerHeight()) / 2) + 'px');
	                    element.css('width', '65%');
	                    var computedLeft = (windowElement.width() - element.outerWidth()) / 2;
	                    var leftBound = lboxContainerElem.offset().left + lboxContainerElem.width() * 0.1;
	                    var elementLeft = computedLeft < leftBound ? leftBound : computedLeft;
	                    if (computedLeft < leftBound) {
	                        element.css('width', lboxContainerElem.width() * 0.8);
	                    }
	                    element.css('left', Math.max(0, elementLeft) + 'px');
	                    return element;
	                }
	
	                function trinityResponseCallback() {
	                    $scope.showNormalization = true;
	
	                    // default behavior of $timeout with no 2nd param is to wait for dom to finish rendering before executing callback
	                    $timeout(function () {
	                        centerLightBox();
	                        $(window).resize(centerLightBox);
	                    });
	                }
	
	                $scope.addressNormalization.save({
	                    data: $scope.addressNormalization,
	
	                    contingencies: {
	                        VALIDATION_ERROR: function VALIDATION_ERROR() {
	                            trinityResponseCallback();
	                            $scope.transitionName = 'address_normalization_enteredAddress';
	                            return;
	                        }
	                    },
	
	                    success: function success(result) {
	                        trinityResponseCallback();
	                        if (result === false) {
	                            // trinity doesn't find any match
	                            $scope.transitionName = 'address_normalization_enteredAddress';
	                            return;
	                        }
	                        $scope.normalizedAddress = result;
	                        $scope.normalizedAddress.normalization_status = 'NORMALIZED';
	
	                        if (addrFormat === 'AddressBR') {
	                            $scope.normalizedAddress.line1 = $scope.normalizedAddress.streetName + '  ' + $scope.normalizedAddress.streetNumber;
	                            $scope.normalizedAddress.line2 = $scope.normalizedAddress.neighborhood;
	                        }
	
	                        // if the two addresses equal, no need to show the panel
	                        if ($scope.isEqual($scope.normalizedAddress, $scope.servAddress)) {
	                            if ($scope.servAddress.preferred_address) {
	                                $scope.normalizedAddress.preferred_address = true;
	                            }
	
	                            if (addrFormat === 'AddressBR' && $scope.address.line2) {
	                                $scope.normalizedAddress.line1 = $scope.normalizedAddress.line1 + '  ' + $scope.address.line2;
	                            }
	                            $scope.callback($scope.normalizedAddress, false);
	                        } else if (addrFormat === 'AddressBR' && $scope.address.line2) {
	                            $scope.normalizedAddress.line1 = $scope.normalizedAddress.line1 + '  ' + $scope.address.line2;
	                        }
	                    },
	
	                    error: trinityResponseCallback
	                });
	
	                // make space and case insensitive. sub empty vals for undefined.
	                function desensitizedAddress(addr) {
	                    for (var key in addr) {
	                        var val = addr[key];
	                        if (addr.hasOwnProperty(key)) {
	                            if (val && val.length) {
	                                addr[key] = val.trim().toLowerCase();
	                            } else {
	                                addr[key] = undefined;
	                            }
	                        }
	                    }
	                    return addr;
	                }
	
	                // check if the two address are the same
	                $scope.isEqual = function (address1, address2) {
	                    var addressOne = desensitizedAddress(JSON.parse(JSON.stringify(address1)));
	                    var addressTwo = desensitizedAddress(JSON.parse(JSON.stringify(address2)));
	
	                    if (!addressOne || !addressTwo) {
	                        return false;
	                    }
	
	                    return addressOne.line1 === addressTwo.line1 && addressOne.line2 === addressTwo.line2 && addressOne.city === addressTwo.city && addressOne.state === addressTwo.state && addressOne.postal_code === addressTwo.postal_code && addressOne.country === addressTwo.country;
	                };
	
	                // Australia displays address line2 first
	                $scope.isLine2First = function () {
	                    return $scope.address.country === 'AU';
	                };
	
	                $scope.onBack = function () {
	                    $scope.callback($scope.address, true);
	                };
	
	                $scope.selection = function (value) {
	                    $scope.transitionName = 'address_normalization_' + value;
	                };
	
	                $scope.onContinue = function () {
	                    $scope.addressSelected = this.addressNormalizationForm.addressSelected;
	
	                    if ($scope.addressSelected && $scope.addressSelected.$modelValue === 'normalizedAddress') {
	                        if ($scope.servAddress.preferred_address) {
	                            $scope.normalizedAddress.preferred_address = true;
	                        }
	                        $scope.callback($scope.normalizedAddress, false);
	                    } else {
	                        $scope.servAddress.normalization_status = 'UNNORMALIZED_USER_PREFERRED';
	                        if (addrFormat === 'AddressBR' && $scope.address.line2) {
	                            $scope.servAddress.line1 = $scope.servAddress.line1 + ' ' + $scope.address.line2;
	                        }
	                        $scope.callback($scope.servAddress, false);
	                    }
	                };
	
	                $scope.callback = function (address, isBack) {
	                    $scope.doneFn(address, isBack);
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "./components/xo-address-components/src/address-normalization/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-address-components/src/address-normalization/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-address-components/src/address-normalization/styles.less":
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "#addressNormalization .addrRadio{position:relative}#addressNormalization .addrLabel{display:inline-block;padding-left:5px;vertical-align:top;width:75%}#addressNormalization .normalizedAdrSection{margin-bottom:10px}#addressNormalization .adr{margin-top:-2px;margin-left:10px}#addressNormalization .subContainer{border-top:none}#addressNormalization #fullContinue{width:100%}@media (min-width:0) and (max-width:30em){#addressNormalization .addrRadio{position:relative;float:left}#addressNormalization .adr{margin-top:-2px;margin-left:20px}#addressNormalization .buttons{margin-top:-5px;overflow:visible}#addressNormalization .subContainer{border-top:none;margin-top:-10px}#addressNormalization .row-fluid>[class*=span]{width:auto}}", ""]);
	
	// exports


/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-address-components/src/address-normalization/template.html":
/***/ (function(module, exports) {

	module.exports = "<div ng-show=\"showNormalization\" content id=\"addressNormalization\" xo-tray-height>\n    <xo-aside-header heading='asideHeader.selectNormalizedAddress' hidex='true' ng-if=\"sidebar\"></xo-aside-header>\n    <div class=\"asideContent\">\n        <form method=\"post\" class=\"formSmall asideView container\" novalidate=\"novalidate\" name=\"addressNormalizationForm\">\n            <div ng-if=\"normalizedAddress\">\n                <h2 class=\"gamma\">{{ content('addressNormalization.title') }}</h2>\n                <p class=\"theta\">{{ content('addressNormalization.intro') }}</p>\n                <div class=\"normalizedAdrSection radio\">\n                    <p class=\"theta\" data-ng-bind-html=\"htmlContent('addressNormalization.addressmatch')\"></p>\n                    <label class=\"noBottom narrow addrLabel row-fluid\">\n                        <input type=\"radio\" id=\"defaultAddress\" ng-model=\"addressSelected\" name=\"addressSelected\" value=\"normalizedAddress\" ng-click=\"selection('normalizedAddress')\" class=\"addrRadio span2\" checked=\"true\">\n                        <div class=\"adr span20\">\n                            <div class=\"confidential streets street-address\">\n                                <div ng-if=\"normalizedAddress.line2\">{{normalizedAddress.line1}}, {{normalizedAddress.line2}},</div>\n                                <div ng-if=\"!normalizedAddress.line2\">{{normalizedAddress.line1}},</div>\n                            </div>\n                            <div class=\"confidential\">\n                                <span class=\"locality\">{{normalizedAddress.city}}</span>, <span class=\"state\">{{normalizedAddress.state}}</span>\n                                <span class=\"postal-code adr-break\">{{normalizedAddress.postal_code}},&nbsp;{{content('countryList.'+servAddress.country)}}</span>\n                            </div>\n                        </div>\n                    </label>\n                </div>\n                <div class=\"enteredAddrSection radio subContainer\">\n                    <p class=\"addressNormalizationIntro\" data-ng-bind-html=\"htmlContent('addressNormalization.addressenter')\"></p>\n\n                    <label class=\"noBottom narrow addrLabel row-fluid\">\n                        <input type=\"radio\" ng-model=\"addressSelected\" name=\"addressSelected\" value=\"enteredAddress\" ng-click=\"selection('enteredAddress')\" class=\"addrRadio span2\">\n                        <div class=\"adr span20\">\n                            <div class=\"confidential streets street-address\" ng-show=\"isLine2First()\">\n                                <div ng-if=\"servAddress.line2\">{{servAddress.line2}}, </div>{{servAddress.line1}},\n                            </div>\n                            <div class=\"confidential streets street-address\" ng-hide=\"isLine2First()\">\n                                <div ng-if=\"address.line2\">{{servAddress.line1}}, {{address.line2}}, {{servAddress.line2}},</div>\n                                <div ng-if=\"!address.line2\">{{servAddress.line1}}, {{servAddress.line2}},</div>\n                            </div>\n                            <div class=\"confidential\">\n                                <span class=\"locality\">{{servAddress.city}}</span>, <span class=\"state\">{{servAddress.state}}</span>\n                                <span class=\"postal-code adr-break\">{{servAddress.postal_code}},&nbsp;{{content('countryList.'+servAddress.country)}}</span>\n                            </div>\n                        </div>\n                    </label>\n                </div>\n            </div>\n            <div ng-if=\"!normalizedAddress\">\n                <h2 class=\"gamma\">{{ content('addressNormalization.noaddressmatchTitle') }}</h2>\n                <p class=\"theta\">{{ content('addressNormalization.noaddressmatchMsg') }}</p>\n                <input type=\"hidden\" name=\"addressdisplay\" value=\"enteredAddress\">\n                <div class=\"enteredAddrSection subContainer\">\n                    <p class=\"theta\">{{ content('addressNormalization.addressyouenter') }}</p>\n                    <div class=\"adr\">\n                        <div class=\"confidential streets street-address\" ng-show=\"isLine2First()\">\n                            {{servAddress.line2}} {{servAddress.line1}},\n                        </div>\n                        <div class=\"confidential streets street-address\" ng-hide=\"isLine2First()\">\n                            <div ng-if=\"address.line2\">{{servAddress.line1}}, {{address.line2}}, {{servAddress.line2}}</div>\n                            <div ng-if=\"!address.line2\">{{servAddress.line1}}, {{servAddress.line2}}</div>\n                        </div>\n                        <div class=\"confidential\">\n                            <span class=\"locality\">{{servAddress.city}}</span>, <span class=\"state\">{{servAddress.state}}</span>\n                            <span class=\"postal-code adr-break\">{{servAddress.postal_code}},&nbsp;{{content('countryList.'+servAddress.country)}}</span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"buttons\" ng-if=\"!hideBackButton\">\n                <input id=\"back\" type=\"submit\" value=\"{{ content('common.back') }}\" class=\"btn firstHalf btn-secondary\" ng-click=\"onBack()\" >\n                <input track-submit=\"{{transitionName}}\" id=\"continue\" type=\"submit\" value=\"{{ content('common.continueLabel') }}\" class=\"btn secondHalf\" ng-click=\"onContinue()\">\n            </div>\n            <div class=\"buttons\" ng-if=\"hideBackButton\">\n                <input track-submit=\"{{transitionName}}\" id=\"fullContinue\" type=\"submit\" value=\"{{ content('common.continueLabel') }}\" class=\"btn\" ng-click=\"onContinue()\">\n            </div>\n        </form>\n    </div>\n</div>\n"

/***/ }),

/***/ "./components/xo-tray-height/dist/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* global define:true */
	
	
	/* grab the logger so we can warn about being in the fallback mode */
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	/** Name:  Tray height helper */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/jquery/dist/jquery.min.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, $) {
	    squid.module('xo-tray-height.directive', ['squid']).directive('xoTrayHeight', function ($timeout) {
	        return {
	            restrict: 'A',
	            link: function link($scope, element, attrs) {
	                // Check to see if we can use the safer full height approach
	                // or if we need to fallback to calculating the height using
	                // math and relying on the "right" timing.
	                var topClass = 'xo-sidebar-wrapper';
	                var topSelector = '.' + topClass;
	                var topElem = document.querySelector(topSelector);
	                var inScope = topElem && topElem.querySelector('[xo-tray-height]');
	                var useNewFlow = topElem && inScope;
	
	                /**
	                 * NOTE:
	                 * The following code, despite being the "new" flow, is still
	                 * a stopgap solution until such time as the markup and or
	                 * CSS undergo an overhaul. It relies on the more stable
	                 * cascading relative/absolute positioning and 100% height
	                 * *and* the fact that the code is an instance of xo-tray-height
	                 * within the xo-sidebar-wrapper.
	                 */
	                function calculate() {
	                    var curElem = element[0];
	
	                    while (!~curElem.className.indexOf(topClass)) {
	                        var style = getComputedStyle(curElem, null);
	
	                        if (style.position !== 'absolute') {
	                            curElem.style.position = 'relative';
	                        }
	                        curElem.style.height = '100%';
	                        curElem = curElem.parentNode;
	                    }
	                }
	
	                /**
	                 * NOTE:
	                 * The following DEPRECATED version of the calculate method
	                 * relies on calculating the heights using math. This heavy
	                 * handed approach is fine if it is called at the right times
	                 * and often enough; however, this criteria is hard to achieve.
	                 *
	                 * A markup and styles overhaul is recommended to do away with
	                 * both of these methods.
	                 */
	                function deprecatedCalculate() {
	                    // DEPRECATED
	                    _logger.$logger.warn('xo-tray-height-fallback', {
	                        message: 'Using the fallback sidebar height calculation. ' + 'height may not be 100%. You should not be here!'
	                    });
	                    var height;
	                    var headerHeight;
	                    var mainHeight;
	                    var trayMinheight = 400;
	                    var asideContentHeight;
	                    var $aside = $(element).parents('aside:visible');
	                    var $asideContent = $aside.find('.asideContent');
	
	                    if (!$aside || !$asideContent) {
	                        return;
	                    }
	
	                    // Updates the tray height to the section height
	                    headerHeight = $aside.find('.header').outerHeight(true);
	                    mainHeight = $('#main').outerHeight(true);
	
	                    height = mainHeight - headerHeight;
	                    asideContentHeight = $asideContent.outerHeight(true);
	                    if ($scope.miniBrowser) {
	                        $aside.find('.aside').css('height', '534px');
	                        var minHeight = 534 - headerHeight;
	
	                        $asideContent.css('height', minHeight);
	                    } else if (asideContentHeight > height) {
	                        $asideContent.css('height', height);
	                        $aside.find('aside:visible').addClass('hasScroll');
	                    } else {
	                        height = height > trayMinheight ? height : trayMinheight;
	                        $asideContent.css('height', height);
	                        $aside.removeClass('hasScroll');
	                    }
	                }
	
	                if (useNewFlow) {
	                    calculate();
	                } else {
	                    $timeout(deprecatedCalculate, 1);
	
	                    $scope.$on('SidebarError', function () {
	                        deprecatedCalculate();
	                    });
	                }
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	_logger.$logger;

/***/ }),

/***/ "./components/xo-page-components/src/aside-header/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-page-components/src/aside-header/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid, template) {
	
	    squid.module('xo-aside-header.directive', ['squid']).directive('xoAsideHeader', function () {
	        return {
	            template: template,
	            restrict: 'E',
	            scope: {
	                hdrtype: '@',
	                heading: '@',
	                subHead: '@',
	                addLink: '@',
	                backUrl: '@',
	                closeUrl: '@',
	                hidex: '@',
	                headerLeftLink: '=',
	                headerLeft: '@',
	                headerLeftIcon: '@',
	                headerRightLink: '=',
	                headerRight: '@',
	                headerRightIcon: '@',
	                subHeaderLeftLink: '@',
	                subHeaderLeft: '@',
	                subHeaderLeftIcon: '@',
	                subHeaderRightLink: '@',
	                subHeaderRight: '@',
	                subHeaderRightIcon: '@',
	                showDualFi: '='
	            },
	            controller: function controller($scope, $element, $state, $timeout) {
	                $timeout(function () {
	                    $element.find('.header').focus();
	                });
	
	                if (angular.isUndefined($scope.closeUrl)) {
	                    $scope.closeUrl = 'checkout.review';
	                }
	
	                if ($scope.addLink) {
	                    $scope.subHeaderRight = 'asideHeader.add';
	                    $scope.subHeaderRightLink = $scope.addLink;
	                }
	
	                $scope.onClickLink = function (event, target, showDualFi) {
	                    event.preventDefault();
	                    if (showDualFi) {
	                        $scope.showFiOptions = true;
	                    } else if (angular.isFunction(target)) {
	                        target();
	                    } else {
	                        $state.go(target);
	                    }
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-page-components/src/aside-header/template.html":
/***/ (function(module, exports) {

	module.exports = "<div class=\"header noButtons\" tabindex=\"-1\" ng-class=\"[hdrtype]\" content>\n    <div class=\"primaryHeader\">\n        <h1 class=\"asideAlpha walletHeading noHead noBottom alpha\">{{ content(heading) }}</h1>\n        <a link-button ui-sref=\"{{backUrl}}\" class=\"backArrow focusableIcon goTray\" ng-if=\"backUrl\"><span class=\"accessAid\">{{ content('common.back') }}</span></a>\n        <a link-button ng-click=\"onClickLink($event, headerLeftLink)\" class=\"left\" ng-if=\"headerLeftLink\">\n            <span ng-if=\"headerLeftIcon\" class=\"leftIcon\"></span>\n            <span class=\"accessAid\">{{ content(headerLeft) }}</span>\n        </a>\n        <a link-button ui-sref=\"{{closeUrl}}\" class=\"close focusableIcon\" ng-if=\"!backUrl && !hidex\"><span class=\"accessAid\">{{ content('common.back') }}</span></a>\n        <a link-button ng-click=\"onClickLink($event, headerRightLink)\" class=\"right focusableIcon\" ng-if=\"headerRightLink\">\n            <span ng-if=\"headerRightIcon\" class=\"rightIcon\"></span>\n            <span class=\"accessAid\">{{ content(headerRight) }}</span>\n        </a>\n    </div>\n\n    <div class=\"subHeader\" ng-class=\"{'addOptions': !subHeaderLeftLink}\" ng-if=\"subHeaderLeftLink || subHeaderRightLink\">\n        <h2 class=\"subheading gamma\" ng-if=\"!subHeaderLeftLink\">{{ content(subHead) }}</h2>\n        <a link-button ui-sref=\"{{subHeaderLeftLink}}\" ng-click=\"onClickLink($event, subHeaderLeftLink, showDualFi)\" ng-if=\"subHeaderLeftLink\" id=\"leftLink\" class=\"left\">\n            <span ng-if=\"subHeaderLeftIcon\" class=\"leftIcon\"></span>\n            <span class=\"leftText\">{{ content(subHeaderLeft) }}</span>\n        </a>\n        <a link-button ui-sref=\"{{subHeaderRightLink}}\" ng-class=\"{'addLink': !subHeaderLeftLink}\"  ng-click=\"onClickLink($event, subHeaderRightLink)\" ng-if=\"subHeaderRightLink\" id=\"rightLink\" class=\"right\">\n            <span ng-if=\"subHeaderRightIcon\" class=\"rightIcon\"></span>\n            <span class=\"rightText\">{{ content(subHeaderRight) }}</span>\n        </a>\n    </div>\n</div>\n<div class=\"fundingInstrumentList\" id=\"fundingInstrumentList\" ng-if=\"showFiOptions\">\n    <ul>\n        <li class=\"bank\">\n            <a link-button ui-sref=\"checkout.review.sidebar.sidebarAddBank.bank.add\" id=\"addBank\" class=\"submit\">\n                <span class=\"icon\"></span>\n                <span class=\"description\">{{ content('DEMemberGuest.addBank')}}</span>\n            </a>\n        </li>\n        <li class=\"cards\">\n            <a link-button ui-sref=\"checkout.review.sidebar.sidebarAddCard.addCardFlow.addCard\" id=\"addCC\" class=\"submit\">\n                <span class=\"icon\"></span>\n                <span class=\"description\">{{ content('DEMemberGuest.addCC')}}</span>\n            </a>\n        </li>\n    </ul>\n</div>\n"

/***/ }),

/***/ "./components/xo-wallet-components/src/3ds/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/3ds/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular, template) {
	    return angular.module('xo-3ds.directive', ['squid']).directive('xo3ds', function () {
	        return {
	            template: template,
	            scope: {
	                token: '=',
	                data: '=',
	                onComplete3dsHandler: '='
	            },
	            controller: function controller($scope, $rootScope, $timeout, $window, $Resolve3DS, $CheckoutAppDataModel, $config, $locale, $logger) {
	
	                var resolve3DS = $Resolve3DS.instance($scope.token);
	
	                $scope.termUrl = window.location.origin + $config.urls.baseUrl + '/process3DS';
	
	                $scope.data = $scope.data || {};
	
	                function handleInitFailure(message) {
	                    // Since init3DS call failed. We disable the feature and proceed to checkout.
	                    $CheckoutAppDataModel.instance($rootScope.token).action('updatePaymentExperience', {
	                        data: {
	                            payment_experience: 'HERMESNODE',
	                            '3d_secure_authentication_supported': false
	                        },
	                        silent: true,
	                        transientError: true
	                    }).then(function () {
	
	                        $logger.info('checkout_fpti', {
	                            from: '3DS_CHALLENGE',
	                            to: 'process_3ds_challenge',
	                            'int_error_description': message,
	                            'error_type': 'soft_decline',
	                            'error_source': 'fiLifecycle'
	                        });
	
	                        $scope.onComplete3dsHandler('success');
	                    });
	                }
	
	                function init3DSApi() {
	                    $rootScope.$emit('loadingMessage', $locale.content.get('threeDS.processing'));
	
	                    return resolve3DS.action('init3DS', {
	                        data: {
	                            cc_id: $scope.data.cc_id,
	                            flow_id: $scope.data.flow_id,
	                            merchant_id: $scope.data.merchant_id,
	                            merchant_country: $scope.data.merchant_country_code,
	                            currency: $scope.data.transaction_amount_currency,
	                            transaction_amount: $scope.data.transaction_amount_value
	                        },
	                        success: function success(response) {
	                            if (response.status === 'SUCCESS' && response.acsUrl) {
	
	                                $logger.info('checkout_fpti', { from: '3DS_CHALLENGE', to: 'prepare_3ds_challenge' });
	
	                                $scope.acsUrl = response.acsUrl;
	                                $scope.acsMethod = response.acsMethod || 'POST';
	                                $scope.acsPaReq = response.acsPaReq;
	
	                                var lightbox;
	                                var form = $('<form/>', {
	                                    action: $scope.acsUrl,
	                                    method: $scope.acsMethod,
	                                    id: 'iFrameForm',
	                                    target: 'threeDSFrame'
	                                });
	                                form.append($('<input/>', {
	                                    type: 'hidden',
	                                    name: 'TermUrl',
	                                    value: $scope.termUrl
	                                }));
	
	                                form.append($('<input/>', {
	                                    type: 'hidden',
	                                    name: 'PaReq',
	                                    value: $scope.acsPaReq
	                                }));
	                                $('#lightBoxAcsWrapper').append(form);
	                                $('#iFrameForm').submit();
	
	                                // put lightbox to display with transition
	                                lightbox = angular.element(document.getElementById('light-box'));
	                                lightbox.addClass('open');
	                            } else {
	                                $logger.info('checkout_fpti', {
	                                    from: '3DS_CHALLENGE',
	                                    to: 'process_3ds_challenge',
	                                    'int_error_description': 'acsUrl_not_presented_on_init',
	                                    'error_type': 'soft_decline',
	                                    'error_source': 'fiLifecycle'
	                                });
	
	                                // When there is no 3DS challenge page to be shown, we return success to the caller
	                                $scope.onComplete3dsHandler('success');
	                            }
	                        },
	                        error: function error() {
	                            handleInitFailure('unknown_error_on_init3DS');
	                        },
	                        validation: function validation() {
	                            handleInitFailure('validation_error_on_init3DS');
	                        },
	                        contingencies: {
	                            DEFAULT: function DEFAULT() {
	                                handleInitFailure('contingency_presented_on_init3DS');
	                            }
	                        }
	                    });
	                }
	
	                function complete3DSApi(paRes) {
	                    return resolve3DS.action('complete3DS', {
	                        data: {
	                            third_party_response: paRes,
	                            cc_id: $scope.data.cc_id,
	                            flow_id: $scope.data.flow_id
	                        },
	                        success: function success(response) {
	
	                            var status;
	
	                            if (response.status === 'SUCCESS') {
	                                status = 'success';
	
	                                $logger.info('checkout_fpti', {
	                                    from: '3DS_CHALLENGE',
	                                    to: 'process_3ds_challenge'
	                                });
	                            } else {
	                                status = 'decline';
	
	                                $logger.info('checkout_fpti', {
	                                    from: '3DS_CHALLENGE',
	                                    to: 'process_3ds_challenge',
	                                    'int_error_description': 'complete3DS_decline',
	                                    'error_type': 'soft_decline',
	                                    'error_source': 'fiLifecycle'
	
	                                });
	                            }
	
	                            $scope.onComplete3dsHandler(status);
	                        }
	                    });
	                }
	
	                $scope.close3DSFrame = function () {
	                    $logger.info('checkout_fpti', { from: '3DS_CHALLENGE', to: 'process_user_close' });
	
	                    var lightbox = angular.element(document.getElementById('light-box'));
	                    lightbox.removeClass('open');
	
	                    $timeout(function () {
	                        var lightboxMask = angular.element(document.getElementById('mask'));
	                        lightboxMask.remove();
	                        $scope.onComplete3dsHandler('close');
	                    }, 200);
	                };
	
	                init3DSApi();
	
	                $scope.complete3DS = function (paRes) {
	                    complete3DSApi(paRes);
	                };
	
	                $window.complete3DSFrame = function (paRes) {
	                    $scope.complete3DS(paRes);
	                };
	
	                // when the esc key is pressed
	                $('html').on('keyup', function (ev) {
	                    if (ev.which === 27) {
	                        $scope.close3DSFrame();
	                    }
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/3ds/template.html":
/***/ (function(module, exports) {

	module.exports = "<div content id=\"light-box-3ds\" class=\"light-box-3ds\">\n    <div content id=\"light-box\" class=\"light-box\" ng-class=\"{mobile: isDevice}\">\n        <div id=\"mask\" class=\"light-box mask\"></div>\n        <div class=\"light-box wrapper\">\n\n            <div class=\"light-box-container\">\n                <div class=\"aside\" id=\"lightBoxAcsWrapper\">\n                    <a class=\"close\" ng-click=\"close3DSFrame()\" href=\"#\">&nbsp;</a>\n                    <p class=\"light-box-header\">\n                        {{ content('threeDS.iFrameTitle') }}\n                    </p>\n                    <iframe name=\"threeDSFrame\" src=\"\" class=\"light-box-iframe\"></iframe>\n                </div>\n\n                <div class=\"logo\"></div>\n            </div>\n\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "./pages/xo-sidebar/route.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./pages/xo-sidebar/directive.js"), __webpack_require__("./pages/xo-sidebar-installment-options/route.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('hermes.page.xo-sidebar.route', ['squid', 'hermes.page.xo-sidebar.directive', 'hermes.page.xo-sidebar-installment-options.route']).factory('$SidebarRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('SidebarRoute', {
	            name: 'sidebar',
	            directive: 'xo-sidebar',
	            titleContent: 'accountCreationGuest.heading',
	            children: [{
	                name: '$SidebarInstallmentOptionsRoute',
	                attributes: {
	                    'back-uri': 'backUri',
	                    'parent-model': 'parentModel'
	                }
	            }]
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-sidebar", "pages/xo-sidebar/route.js"))

/***/ }),

/***/ "./pages/xo-sidebar/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./pages/xo-sidebar/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, index, template) {
	
	    return angular.module('hermes.page.xo-sidebar.directive', ['squid']).directive('xoSidebar', function () {
	
	        return {
	            template: template,
	
	            scope: {
	                backUri: '=',
	                parentModel: '='
	            },
	
	            link: function link($scope, element, attr) {
	
	                $scope.$on('populated', function () {
	                    angular.element('body').addClass('trayOpen');
	                    angular.element('#wrapper').addClass('maskMember');
	
	                    var payButton = angular.element('.confirmButton');
	
	                    if (payButton) {
	                        payButton.attr('disabled', true);
	                    }
	                });
	
	                $scope.$on('$destroy', function () {
	                    angular.element('body').removeClass('trayOpen');
	
	                    var payButton = angular.element('.confirmButton');
	
	                    if (payButton) {
	                        payButton.attr('disabled', false);
	                    }
	                });
	            },
	
	            controller: function controller($scope, $rootScope, $window, $state, $util, $populate) {
	
	                $util.assert($scope.backUri, 'Expected backUri');
	
	                $populate($scope);
	
	                $scope.token = $rootScope.token;
	
	                $scope.onPageClick = function ($event) {
	                    $event.stopPropagation();
	                };
	
	                $scope.close = function () {
	                    $state.go($scope.backUri);
	                };
	
	                $scope.callbacks = {
	                    done: function done() {
	                        $state.go($scope.backUri);
	                    }
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./pages/xo-sidebar/template.html":
/***/ (function(module, exports) {

	module.exports = "<aside class=\"sidebar\" id=\"tray\" ng-click=\"onPageClick($event)\">\n    <div ui-view></div>\n</aside>\n\n<span class=\"trayViewMask\" ng-click=\"close()\"></span>\n"

/***/ }),

/***/ "./pages/xo-sidebar-installment-options/route.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./pages/xo-sidebar-installment-options/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('hermes.page.xo-sidebar-installment-options.route', ['squid', 'hermes.page.xo-sidebar-installment-options.directive']).factory('$SidebarInstallmentOptionsRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('InstallmentOptionsRoute', {
	            name: 'installmentOptions',
	            directive: 'xo-sidebar-installment-options-page',
	            titleContent: 'accountCreationGuest.heading',
	            trackingData: {
	                templateName: 'tray/installmentOptions.dust',
	                pageGoal: 'Installment Options',
	                buzname: {
	                    'fullpage': {
	                        'pagename': '%::fullpage-installment-options',
	                        'pagename2': '%::fullpage-installment-options::hermes:',
	                        'version': ':%:'
	                    }
	                }
	            },
	            children: []
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-sidebar-installment-options", "pages/xo-sidebar-installment-options/route.js"))

/***/ }),

/***/ "./pages/xo-sidebar-installment-options/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./pages/xo-sidebar-installment-options/template.html"), __webpack_require__("./components/xo-page-components/src/aside-header/directive.js"), __webpack_require__("./components/xo-wallet-components/src/installment-options/directive.js"), __webpack_require__("./components/xo-tray-height/dist/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid, template) {
	
	    return angular.module('hermes.page.xo-sidebar-installment-options.directive', ['squid', 'xo-aside-header.directive', 'xo-installment-options.directive', 'xo-tray-height.directive']).directive('xoSidebarInstallmentOptionsPage', function () {
	
	        return {
	            template: template,
	
	            scope: {
	                backUri: '=',
	                parentModel: '='
	            },
	
	            controller: function controller($scope, $rootScope, $state) {
	                $scope.token = $rootScope.token;
	
	                $scope.cardInfo = {
	                    number: $scope.parentModel.onboard.card.number.replace(/ /g, ''),
	                    type: $scope.parentModel.onboard.card.type
	                };
	
	                $scope.onComplete = function (result) {
	                    $scope.parentModel.setProperties({
	                        selectedInstallmentData: result
	                    });
	
	                    angular.element('#paymentMethod').removeClass('ng-invalid'); // FIXME : setup a callback in xo-multistep-signup
	
	                    $state.go($scope.backUri);
	                };
	
	                $scope.$emit('populated');
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./pages/xo-sidebar-installment-options/template.html":
/***/ (function(module, exports) {

	module.exports = "<div class=\"aside\" id=\"installmentOptions\" xo-tray-height>\n    <xo-aside-header close-url=\"{{backUri}}\" heading='asideHeader.installmentsPanel'></xo-aside-header>\n    <div class=\"installmentOptions asideContent container\">\n       <xo-installment-options token=\"token\" done-fn=\"onComplete\" card-number=\"cardInfo.number\"></xo-installment-options>\n    </div>\n</div>\n"

/***/ }),

/***/ "./components/xo-wallet-components/src/installment-options/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/installment-options/template.html"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/auth/index.js"), __webpack_require__("./components/xo-tray-height/dist/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	    squid.module('xo-installment-options.directive', ['squid', 'xomodel.checkout', 'xomodel.auth', 'xo-tray-height.directive']).directive('xoInstallmentOptions', function () {
	        return {
	            template: template,
	
	            scope: {
	                token: '=',
	                doneFn: '=',
	                cardNumber: '='
	            },
	
	            controller: function controller($AuthModel, $scope, $populate, $CheckoutSessionModel, $InstallmentOptionsModel, $CheckoutPayeeModel, $CheckoutCartModel, $CheckoutAppDataModel) {
	
	                $populate($scope, {
	                    auth: $AuthModel.instance($scope.token)
	                }).then(function () {
	
	                    if ($scope.auth.logged_in) {
	
	                        // Installment support for authenticated user
	                        $populate($scope, {
	                            checkoutSession: $CheckoutSessionModel.instance($scope.token)
	                        }).then(function () {
	                            $scope.cardInfo = $scope.checkoutSession.plan.sources[0];
	                            $scope.installments = $scope.checkoutSession.installments;
	                        });
	                    } else {
	                        // Installment support added for not authenticated user, e.g. BR signup flow
	                        var installmentsModel = $InstallmentOptionsModel.instance($scope.token);
	
	                        installmentsModel.save({
	                            data: {
	                                cc: $scope.cardNumber,
	                                payee: $CheckoutPayeeModel.instance($scope.token),
	                                checkoutCart: $CheckoutCartModel.instance($scope.token),
	                                checkoutAppData: $CheckoutAppDataModel.instance($scope.token)
	                            },
	
	                            success: function success(result) {
	                                $scope.cardInfo = result.cardInfo;
	                                $scope.installments = result.installment_options;
	                            }
	                        });
	                    }
	                });
	
	                $scope.onSelect = function (index) {
	                    var selectedInstallmentData = $scope.installments[index];
	                    $scope.installmentsModel = $InstallmentOptionsModel.instance($scope.token);
	
	                    var param = {
	                        term: selectedInstallmentData.term,
	                        payment_value: selectedInstallmentData.monthly_payment.value,
	                        payment_currency: selectedInstallmentData.monthly_payment.currency
	                    };
	
	                    if (selectedInstallmentData.total_cost) {
	                        param.total_cost_value = selectedInstallmentData.total_cost.value;
	                        param.total_cost_currency = selectedInstallmentData.total_cost.currency;
	                    }
	
	                    if (selectedInstallmentData.discount_amount) {
	                        param.discount_value = selectedInstallmentData.discount_amount.value;
	                        param.discount_currency = selectedInstallmentData.monthly_payment.currency;
	                    }
	
	                    if (selectedInstallmentData.discount_percentage) {
	                        param.discount_percentage = selectedInstallmentData.discount_percentage;
	                    }
	
	                    return $scope.installmentsModel.action('select', {
	                        data: param,
	
	                        success: function success(result) {
	                            if ($scope.auth.logged_in) {
	                                $scope.checkoutSession.selectedInstallmentData = selectedInstallmentData;
	                            }
	                            $scope.doneFn(result);
	                        }
	                    });
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/installment-options/template.html":
/***/ (function(module, exports) {

	module.exports = "<div content class=\"aside installmentOptions\" ng-class=\"{true: 'signupflow'}[!auth.logged_in]\" >\n    <div class=\"cardInfo\" ng-if=\"cardInfo\">\n        <span class=\"ccard {{cardInfo.card_type}}\" id=\"creditCard\" role=\"img\" aria-label=\"{{cardInfo.name}}\"></span> {{cardInfo.name}} x-{{cardInfo.last4}}&nbsp;<span class=\"installmentText\" ng-if=\"installments\">{{content('installments.upto')}}&nbsp;{{installments.length}}x</span>\n    </div>\n    <ul class=\"asideContent items\" ng-if=\"installments\">\n        <li class=\"installment\" ng-repeat=\"installment in installments\" ng-click=\"onSelect($index)\" track-submit>\n            <div class=\"term\">\n                <span>{{installment.term}}x {{content('installments.of')}}&nbsp;</span>\n            </div>\n            <div class=\"display\">\n                <span>{{installment.monthly_payment.formatted_value}}</span>\n                <div class=\"confidential total\">\n                    <span>{{content('installments.total')}}: {{installment.total}}</span>\n                    <span class=\"save\" ng-if=\"installment.discount_amount\">\n                        {{content('installments.save')}} {{installment.discount_amount.formatted_value}}\n                    </span>\n                </div>\n            </div>\n\n        </li>\n    </ul>\n</div>"

/***/ }),

/***/ "./components/xo-login-components/src/onetouch-interstitial/route.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-login-components/src/onetouch-interstitial/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('xo-onetouch-upsell.route', ['squid', 'xo-onetouch-upsell.directive']).factory('$OneTouchUpsellRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('OneTouchUpsellRoute', {
	
	            name: 'oneTouchUpsell',
	            directive: 'xo-onetouch-upsell',
	            trackingData: {
	                fptiState: 'onetouch-upsell',
	                buzname: {
	                    'fullpage': {
	                        'pagename': '%::onetouch-upsell',
	                        'pagename2': '%::onetouch-upsell:member:hermes:',
	                        'version': 'member:%:'
	                    }
	                }
	            },
	            query: ['oneTouchFlowName'],
	            children: []
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-login-components/src/onetouch-interstitial", "components/xo-login-components/src/onetouch-interstitial/route.js"))

/***/ }),

/***/ "./components/xo-login-components/src/onetouch-interstitial/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	var _ul = __webpack_require__("./components/xo-login-components/src/unified-login/ul.js");
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-login-components/src/onetouch-interstitial/template.html"), __webpack_require__("./components/xo-ui-components/src/accessibility/ui.js"), __webpack_require__("./components/xo-login-components/src/onetouch-interstitial/kmliUpsell.js"), __webpack_require__("./components/xo-tracking/dist/index.js"), __webpack_require__("./components/ul-inline/dist/inject.js"), __webpack_require__("./components/xo-device-info/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular, squid, template, ui) {
	
	    return angular.module('xo-onetouch-upsell.directive', ['squid', 'xolocale', 'tracking', 'xo-device-info']).directive('xoOnetouchUpsell', function () {
	
	        return {
	            template: template,
	            scope: {
	                token: '=',
	                onComplete: '=',
	                disableCloseButton: '=',
	                ignoreBgClicks: '='
	            },
	            controller: function controller($scope, $rootScope, $state, $element, $timeout, $logger, $KmliUpsell, $LocaleModel, $locale, $CalDataModel, $config, $meta, $DeviceInfo, $stateParams, $AuthModel) {
	                $scope.oneTouchFlowName = $stateParams.oneTouchFlowName;
	                $scope.modalActive = false;
	                $scope.locale = $LocaleModel.instance();
	                $scope.disableCloseButton = $scope.disableCloseButton || $DeviceInfo.isDevice();
	                $scope.upsellOptInDisplayed = false;
	                var ulMeta = $config.ulMeta || {};
	                var PAYPAL = window.PAYPAL || {};
	                var ulTimeOutValue = 5000;
	                var ulTimeoutPromise = null;
	
	                var fptiData = $KmliUpsell.getFPTIAttributes();
	
	                if (!$scope.onComplete) {
	                    $scope.onComplete = function (params) {
	                        $AuthModel.instance().retrieve().then(function (auth) {
	                            auth.isKmliSet = params && params.isKmliSet;
	                            $state.go('checkout.review');
	                        });
	                    };
	                }
	
	                $KmliUpsell.eligible().then(function (eligibility) {
	                    if (eligibility && eligibility.interstitial && eligibility.interstitial.color) {
	                        $scope.color = eligibility.interstitial.color;
	                    }
	                });
	
	                function closeInterstitial(params) {
	                    $('#wrapper > xo-spinner').attr('style', '');
	                    $('body').removeClass('kmliUpsellActive');
	                    $element.removeClass('upsellOpen');
	                    $scope.onComplete(params);
	                }
	
	                function failureHandler(reason) {
	                    $logger.info('KMLI_UPSELL_error_' + reason);
	                    closeInterstitial();
	                }
	
	                var startTimerTS;
	                function startTimer(tag) {
	                    startTimerTS = Date.now();
	                    $logger.info('KMLI_UPSELL_START_TIMER_' + tag, {
	                        startTime: startTimerTS
	                    });
	
	                    $logger.info('checkout_fpti', {
	                        'from': 'Interstitial_Timer',
	                        'to': 'prepare_' + tag
	                    });
	
	                    ulTimeoutPromise = $timeout(function () {
	                        var stop_time = Date.now();
	                        var time_taken = stop_time - startTimerTS;
	                        $logger.info('checkout_fpti', {
	                            'from': 'Interstitial_Timer',
	                            'to': 'process_timeout',
	                            'int_error_code': 'ULLOGIN_TIMEOUT',
	                            'int_error_description': 'ULLOGIN_TIMEOUT',
	                            'error_source': 'unifiedloginnodeweb',
	                            'error_type': 'soft_decline',
	                            'page_load_time': time_taken
	                        });
	                        failureHandler('timedout');
	                        $rootScope.$emit('loaded');
	                    }, ulTimeOutValue);
	                }
	
	                function stopTimer(tag) {
	                    var stopTimerTS = Date.now();
	                    var timeTaken = stopTimerTS - startTimerTS;
	                    $logger.info('KMLI_UPSELL_STOP_TIMER_' + tag, {
	                        stopTimer: stopTimerTS,
	                        page_load_time: timeTaken
	                    });
	
	                    $logger.info('checkout_fpti', {
	                        'from': 'Interstitial_Timer',
	                        'to': 'process_' + tag,
	                        'page_load_time': timeTaken
	                    });
	
	                    if (ulTimeoutPromise) {
	                        $timeout.cancel(ulTimeoutPromise);
	                    }
	                }
	
	                function logSubmit(data) {
	                    var fptiPayload = {
	                        'from': fptiData.stateName,
	                        'to': 'process' + fptiData.transInfix + 'optin'
	                    };
	                    if (data && data.errorCode) {
	                        angular.extend(fptiPayload, {
	                            'int_error_code': data.errorCode,
	                            'error_type': 'hard_decline',
	                            'error_source': 'unifiedloginnodeweb'
	                        });
	                    }
	                    $logger.info('checkout_fpti', fptiPayload);
	                }
	
	                $scope.hideModal = function (event) {
	                    if (event) {
	                        event.preventDefault();
	                    } else if ($scope.ignoreBgClicks) {
	                        return;
	                    }
	
	                    $logger.info('checkout_fpti', {
	                        'from': fptiData.stateName,
	                        'to': 'process' + fptiData.transInfix + 'decline',
	                        'click_source': 'close_button'
	                    });
	
	                    closeInterstitial();
	                };
	
	                var ulEventHandlers = {
	                    'oneTouchInterstitialOptInLoaded': function oneTouchInterstitialOptInLoaded(data) {
	                        stopTimer(data.event);
	                        $rootScope.$emit('loaded');
	                        $('#wrapper > xo-spinner').hide();
	                        $('body').addClass('kmliUpsellActive');
	
	                        // CSS transition to open upsell modal and set modal to trap focus after open
	                        $timeout(function () {
	                            $element.addClass('upsellOpen');
	                            $element.one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
	                                $scope.$apply(function () {
	                                    $scope.modalActive = true;
	                                    // Focus Continue button in iframe
	                                    $('#injectedOneTouchInterstitial').focus();
	
	                                    var escHandler = function escHandler(event) {
	                                        if (event.keyCode === ui.KEYS.ESC) {
	                                            $scope.hideModal();
	                                        }
	                                    };
	
	                                    // Add handler to iframe document, as events do not propagate past the iframe
	                                    $element.find('iframe').contents().on('keydown', escHandler);
	                                    $element.on('keydown', escHandler);
	                                });
	                            });
	                        });
	                    },
	                    'oneTouchInterstitialOptInAttempted': function oneTouchInterstitialOptInAttempted(data) {
	                        $rootScope.$emit('loading');
	                        startTimer(data.event);
	                    },
	                    'oneTouchInterstitialOptInSuccess': function oneTouchInterstitialOptInSuccess(data) {
	                        stopTimer(data.event);
	                        $rootScope.$emit('loaded');
	                        logSubmit();
	                        closeInterstitial(data);
	                    },
	                    'oneTouchInterstitialOptInFailed': function oneTouchInterstitialOptInFailed(data) {
	                        stopTimer(data.event);
	                        $rootScope.$emit('loaded');
	                        logSubmit({ errorCode: data.event });
	                        closeInterstitial(data);
	                    },
	                    'oneTouchInterstitialOptInNotAuthorized': function oneTouchInterstitialOptInNotAuthorized(data) {
	                        stopTimer(data.event);
	                        logSubmit({ errorCode: data.event });
	                        $rootScope.$emit('loaded');
	                        closeInterstitial(data);
	                    },
	                    'oneTouchInterstitialOptInNotNowClicked': function oneTouchInterstitialOptInNotNowClicked(data) {
	                        $logger.info('checkout_fpti', {
	                            'from': fptiData.stateName,
	                            'to': 'process' + fptiData.transInfix + 'decline',
	                            'click_source': 'not_now_link'
	                        });
	                        closeInterstitial(data);
	                    }
	                };
	
	                function postMessageHandler(response) {
	                    $timeout(function () {
	                        $logger.info('ul_postmessaged_received', response);
	                        var data = response.data || response.error;
	                        var eventId = data && data.event;
	                        if (eventId) {
	                            $logger.debug('KMLI_UPSELL_' + eventId, response);
	                            var handler = ulEventHandlers[eventId];
	                            if (handler) {
	                                handler(data);
	                            }
	                        }
	                    });
	                }
	
	                function upsellOptInDisplayed() {
	                    return $AuthModel.instance().retrieve().then(function (auth) {
	                        if (auth.upsellOptInDisplayed) {
	                            $scope.upsellOptInDisplayed = true;
	                        }
	                    });
	                }
	
	                function loadOneTouchUpsell() {
	                    // eslint-disable-line no-unused-vars
	                    upsellOptInDisplayed().then(function () {
	                        // If the optin upsell is already displayed, no need to display again.
	                        if ($scope.upsellOptInDisplayed) {
	                            $scope.onComplete();
	                        } else {
	                            $rootScope.$emit('loading');
	
	                            var options = {
	                                targetElement: document.getElementById('injectedOneTouchInterstitial'),
	                                queryParams: {
	                                    'stsRedirectUri': ulMeta.stsReturnUrl,
	                                    'country.x': $scope.locale.country,
	                                    'locale.x': $scope.locale.getLocaleCode(),
	                                    'flowId': $scope.token,
	                                    'correlationId': $CalDataModel.getCalCorrId(),
	                                    'flowName': $scope.oneTouchFlowName
	                                },
	                                iframePathname: '/signin/activate-one-touch',
	                                onPostMessage: postMessageHandler
	                            };
	
	                            angular.extend(options.queryParams, $KmliUpsell.getOptions());
	
	                            if ($config.deploy.isLocal()) {
	                                if ($meta.stage) {
	                                    options.origin = 'https://' + $meta.stage;
	                                } else {
	                                    // if no stage url shows up then use any backup url for origin
	                                    options.origin = $config.onboarding.url.split('/webapps/')[0];
	                                }
	                            }
	
	                            if (PAYPAL && PAYPAL.unifiedLogin) {
	                                startTimer('initializeUpsell');
	                                PAYPAL.unifiedLogin.inject(options);
	                            } else {
	                                failureHandler('PAYPAL.unifiedLogin_undefined');
	                            }
	                        }
	                    });
	                }
	
	                $timeout(function () {
	                    $element.addClass('upsellOpen');
	                });
	
	                $scope.optinOneTouch = function () {
	                    var flowName = 'checkoutInterstitial'; // login interstitial flow
	                    var fptiPayload = {
	                        stateName: fptiData.stateName,
	                        transInfix: 'process' + fptiData.transInfix + 'optin'
	                    };
	                    var silent = true;
	                    return _ul.$ul.optInToOneTouch($scope.token, $locale.country, $locale.getLocaleCode(), silent, fptiPayload, flowName).then(closeInterstitial({ isKmliSet: true }))['catch'](function (err) {
	                        closeInterstitial({
	                            isKmliSet: false,
	                            error: err
	                        });
	                    });
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	_ul.$ul;

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-login-components/src/onetouch-interstitial/template.html":
/***/ (function(module, exports) {

	module.exports = "<div class=\"kmliUpsell\" ng-class=\"{mobile: isDevice}\" content>\n\n    <div ng-if=\"ulUpsell\">\n        <!-- =============================================\n                Regular interstial (also used by POMA)\n            ============================================== -->\n        <div class=\"upsellMask\"></div>\n        <div class=\"upsellWrapper\" simple-modal=\"modalActive\" modal-cancel=\"hideModal()\">\n            <div class=\"upsellContainer\">\n                <xo-spinner></xo-spinner>\n                <div class=\"aside\">\n                    <a class=\"close\" href=\"#\" title=\"Close\" ng-click=\"hideModal($event)\" ng-hide=\"disableCloseButton\" aria-label=\"{{content('common.back')}}\"></a>\n                    <section class=\"login\" id=\"login\">\n                        <div id=\"injectedOneTouchInterstitial\" tabindex=\"-1\">\n                        </div>\n                    </section>\n                </div>\n                <div class=\"pushLogo\"></div>\n            </div>\n            <div class=\"logo\"></div>\n        </div>\n    </div>\n\n    <div ng-if=\"!ulUpsell\">\n        <!-- ===========================\n                RYI optin interstial\n            ============================ -->\n        <div class=\"upsellMask_white\"></div>\n        <div class=\"upsellWrapper\" ng-class=\"{whiteWithBlur: color === 'white' , blackWithBlur: color === 'black'}\" simple-modal=\"modalActive\" modal-cancel=\"hideModal()\">\n            <div class=\"upsellContainer\">\n                <div class=\"fill\"></div>\n                <div class=\"aside\">\n                    <a class=\"close\" href=\"#\" title=\"Close\" ng-click=\"hideModal($event)\" ng-hide=\"disableCloseButton\" aria-label=\"{{content('common.back')}}\"></a>\n                    <section class=\"login\" id=\"login\">\n                        <div class=\"promoHeading\" ng-bind-html=\"content('oneTouchUpsell.promoHeading')\"></div>\n                        <div class=\"promo\">\n                            <div class=\"icon password\"></div>\n                            <div class=\"text\" ng-bind-html=\"content('oneTouchUpsell.promoText1')\"></div>\n                        </div>\n                        <div class=\"promo\">\n                            <div class=\"icon merchants\"></div>\n                            <div class=\"text\" ng-bind-html=\"content('oneTouchUpsell.promoText2')\"></div>\n                        </div>\n                        <div class=\"promo\">\n                            <div class=\"icon secure\"></div>\n                            <div class=\"text\" ng-bind-html=\"content('oneTouchUpsell.promoText3')\"></div>\n                        </div>\n                        <div class=\"buttons\">\n                            <input type=\"button\" value=\"{{content('common.activate')}}\" class=\"btn full\" ng-click=\"optinOneTouch()\">\n                            <div class=\"cancel\">\n                                <a href=\"#\" prevent-default ng-click=\"hideModal($event)\">{{content('common.noThanks')}}</a>\n                            </div>\n                        </div>\n                    </section>\n                </div>\n                <div class=\"pushLogo\"></div>\n            </div>\n            <div class=\"logo\" id=\"pp_min_logo\"></div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "./components/xo-login-components/src/onetouch-interstitial/kmliUpsell.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-login-components/src/login/kmliEligibility.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('xo-unified-login.kmliUpsell', ['squid']).factory('$KmliUpsell', function ($pxp, $populate, $rootScope, $CheckoutAppDataModel, $CheckoutCartModel, $AuthModel, $DeviceInfo, $feature, $KmliEligibility, $config, $logger, $util, $q) {
	
	        // Model Retrived
	        var idToken, successfulLogin, isOneTouched, upsellOptInDisplayed, kmliEligible, ulAsLanding, walletTokenization, preloadUL, lastUpsellVersion; // eslint-disable-line no-unused-vars
	        var showReactivationInterstitial, kmliChecked; // Passed in init
	        var expPromise; // Promisified experience data
	        var scope = {};
	        scope.token = $rootScope.token;
	
	        return {
	
	            init: function init(params) {
	
	                if (expPromise) {
	                    return; // do not init twice
	                }
	                $logger.debug('kmliUpsell_init', params);
	                expPromise = $KmliEligibility.init().then(function (KmliEligibility) {
	                    kmliEligible = Boolean(KmliEligibility.kmliEligibility) && !params.jwtBasedAssertion;
	                    ulAsLanding = Boolean(KmliEligibility.ulAsLanding);
	                    preloadUL = Boolean(KmliEligibility.preloadUL);
	                    return $populate(scope, {
	                        auth: $AuthModel.instance(),
	                        checkoutCart: $CheckoutCartModel.instance(scope.token),
	                        checkoutAppData: $CheckoutAppDataModel.instance(scope.token)
	                    });
	                }).then(function () {
	                    idToken = Boolean(scope.auth.idTokenPresent);
	                    successfulLogin = scope.auth.loggedIn();
	                    isOneTouched = scope.auth.loggedIn() && scope.auth.refreshToken();
	                    walletTokenization = scope.checkoutCart.isWalletTokenization() || scope.auth.remembered_partner_assertion; // android pay, apple pay, etc
	                    kmliChecked = Boolean(params.isKmliSet); // may not be OT but user has already opted in
	                    upsellOptInDisplayed = Boolean(scope.auth.upsellOptInDisplayed);
	                    lastUpsellVersion = scope.auth.ryiOptIn && scope.auth.ryiOptIn.interstitialDisplayed;
	                    showReactivationInterstitial = Boolean(params.showReactivationInterstitial);
	                    if (walletTokenization || preloadUL) {
	                        // do not trigger pxp for walletTokenization, ulpreload
	                        $logger.debug('kmliUpsell_init_ineligible');
	                        return $q.resolve();
	                    }
	
	                    return $pxp('xo_hermesnode_kmli_upsell', {
	                        'ctx.COUNTRY': scope.auth.buyer_ipcountry
	                    }, 'xo_hermes_kmli_upsell_(web|mobile)_v2_treatment.*');
	                }).then(function (pxpRes) {
	                    var experience = pxpRes ? { name: pxpRes.treatment_name } : '';
	                    lastUpsellVersion = lastUpsellVersion ? lastUpsellVersion : upsellOptInDisplayed ? 0.1 : 0.0; // eslint-disable-line no-nested-ternary
	                    // for lastUpsellVersion use 0.1 when poma and not ryi case else use 0
	                    if (pxpRes && pxpRes.factors) {
	                        var factors = pxpRes.factors.reduce(function (out, factor) {
	                            out[factor.name] = factor.value;
	                            return out;
	                        }, {});
	                        experience.version = +factors.version > +lastUpsellVersion;
	                        experience.color = factors.color;
	                        experience.pxpVersion = factors.version;
	                    }
	                    return experience;
	                });
	            },
	
	            eligible: function eligible() {
	                var eligibility = {};
	                if (!expPromise) {
	                    $logger.debug('kmliUpsell_init_not_executed');
	                    return $q.resolve(eligibility);
	                }
	                return expPromise.then(function (experience) {
	                    var eligibilityCriteria = {
	                        pxp: experience,
	                        profile_country: $feature('ryiOptIn')
	                    };
	                    var ineligibleReasons = $util.filter(Object.keys(eligibilityCriteria), function (key) {
	                        return !eligibilityCriteria[key];
	                    });
	                    var featureEnabled = ineligibleReasons.length === 0;
	                    var activeOT = featureEnabled && isOneTouched;
	                    var regularLogin = featureEnabled && kmliEligible && idToken;
	                    eligibility.banner = activeOT || regularLogin;
	                    eligibility.interstitial = {
	                        eligible: eligibility.banner && !isOneTouched // dont show interstitial for OT
	                        && !kmliChecked // to handle cases where not OT but already optedin
	                        && !scope.auth.remembered && (experience.name.slice(-1) === '1' || experience.name.slice(-1) === '3') // use only treatment 1,3 for interstitial
	                        && experience.version,
	                        type: showReactivationInterstitial ? 'reactivation' : successfulLogin ? 'member' : '', // eslint-disable-line no-nested-ternary
	                        color: experience && experience.color,
	                        pxpVersion: experience && experience.pxpVersion
	                    };
	
	                    var elgStr = 'interstitial-' + eligibility.interstitial.eligible + '&toggle-';
	
	                    $logger.info('ryi_optin', {
	                        'from': 'ryi_optin_elg_chk',
	                        'to': 'process_ryi_optin_elg_chk',
	                        'eligibility_reason': featureEnabled ? elgStr + 'eligible' : elgStr + 'ineligible_' + ineligibleReasons.join()
	                    });
	                    $logger.debug('kmliUpsell_eligibility', {
	                        eligibility: eligibility,
	                        experience: experience,
	                        cases: {
	                            activeOT: activeOT,
	                            regularLogin: regularLogin,
	                            feature: featureEnabled
	                        }
	                    });
	                    return eligibility;
	                });
	            },
	
	            getOptions: function getOptions() {
	
	                if (showReactivationInterstitial) {
	                    return {
	                        flowName: 'expiredUpsell'
	                    };
	                }
	            },
	
	            getFPTIAttributes: function getFPTIAttributes() {
	
	                if (showReactivationInterstitial) {
	                    return {
	                        stateName: 'KMLI_reactivation',
	                        transInfix: '_kmli_reactivation_'
	                    };
	                } else {
	                    return {
	                        stateName: 'KMLI_UPSELL',
	                        transInfix: '_kmli_upsell_'
	                    };
	                }
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-login-components/src/onetouch-interstitial", "components/xo-login-components/src/onetouch-interstitial/kmliUpsell.js"))

/***/ }),

/***/ "./components/xo-login-components/src/login/kmliEligibility.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-device-info/dist/index.js"), __webpack_require__("./components/xo-beaver/dist/logger.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('xo-login.directive.kmliEligibility', ['squid', 'xo-device-info', 'beaver']).factory('$KmliEligibility', function ($DeviceInfo, $window, $meta, $config, $pxp, $pxpMatch, $populate, $logger, $rootScope, $feature, $util, $q, $CheckoutAppDataModel, $CheckoutCartModel, $AuthModel) {
	        var scope = {};
	        scope.token = $rootScope.token;
	        scope.eligibility = {};
	        var ulMeta = $config.ulMeta || {};
	
	        function getPXPList(country) {
	            // returns a list of Pxp's that needs to be executed
	            var countryCTX = { 'ctx.COUNTRY': country };
	            var pxpExpId = ulMeta.pxpExpId;
	            var pxpList = [$pxp(pxpExpId, countryCTX, 'xo_hermesnode_kmli_(web|mobile)_treatment'), $pxp(pxpExpId, countryCTX, 'xo_hermes_ul_timeout_treatment.*'), $pxp(pxpExpId, countryCTX, 'xo_hermes_ul_preload_treatment'), $pxpMatch(ulMeta.hermesnodePxpConfig, countryCTX, { pxpSAFE: 'xo_hermesnode_ul_safe_treatment' })];
	            return pxpList;
	        }
	
	        function routingReason() {
	            // Check for conditions that deviates from the PXP eligibility
	            // Reasons that deviates from control to treatment
	            var isRememberedUser = scope.auth.refreshToken();
	            if (scope.kmli === true) {
	                return 'kmliMandated';
	            } else if (isRememberedUser) {
	                return 'rememberedUser';
	            } else if ($util.param('ul') === '2') {
	                return 'ulParam';
	            } else if ($meta.corp && ulMeta.allowKMLIForInternalIP) {
	                var merchantCountry = scope.checkoutAppData.merchant.merchant_country;
	                if ($feature('enableOneTouchInternalIP', false, merchantCountry)) {
	                    return 'internalIP';
	                }
	            } else if (ulMeta.enableOneTouchByDefault) {
	                return 'oneTouchByDefault';
	            }
	        }
	
	        function compatibility(reasons) {
	            // Check for compatibility/environment issues which impacts UL/KMLI overall
	            // This should override previous decisions
	            if ($DeviceInfo.isApp()) {
	                scope.kmliEligibility = false;
	                reasons.push('Webview');
	            } else if (!$util.cookiesEnabled()) {
	                scope.kmliEligibility = false;
	                reasons.push('cookiesDisabled');
	            } else if (scope.auth.ota) {
	                scope.kmliEligibility = false;
	                reasons.push('otaDevice');
	            }
	
	            if (scope.forcedLogin === true) {
	                scope.kmliEligibility = false;
	                reasons.push('forcedLogin');
	            }
	            if (scope.logoutCallback) {
	                scope.kmliEligibility = true;
	                reasons.push('riskyLoginContingency');
	            }
	        }
	
	        function isULpreload(preloadULTreatments) {
	            // Allow all IE traffic irrespective of PXP
	            var userAgent = $window.navigator.userAgent;
	            var isIE = !!userAgent.match(/MSIE|trident|edge/i);
	            // Check force param
	            var forceUlss = $util.param('_ulss') === 'true';
	            var preloadUL = Boolean(preloadULTreatments && preloadULTreatments.treatment_name) || isIE || forceUlss;
	
	            return preloadUL;
	        }
	
	        function isUlAsLanding() {
	            // markes
	            var forceUlAsLanding = $util.param('ul') === 'landing';
	            var ulAsLandingParam = $util.param('ulReturn') === 'true';
	
	            // tried Ul as landing -> failed -> used iframe
	            var failedAttempt = $util.param('lndgFailedBecause'); // eslint-disable-line no-unused-vars
	
	
	            return forceUlAsLanding || ulAsLandingParam;
	        }
	
	        function isSafeEligible(treatment) {
	            var safeEligibility;
	            var config_pxp_treatments = treatment;
	            if (config_pxp_treatments) {
	                safeEligibility = treatment['pxpSAFE'];
	            }
	            return safeEligibility;
	        }
	
	        function getTimeoutLimit(pxpTimeoutTrt) {
	            var ulTimeoutLimit;
	            var timeoutTrtFact = pxpTimeoutTrt && angular.isArray(pxpTimeoutTrt.factors);
	            var pxpTimeoutVal = timeoutTrtFact && pxpTimeoutTrt.factors[0] && pxpTimeoutTrt.factors[0].value;
	            if (pxpTimeoutVal) {
	                ulTimeoutLimit = pxpTimeoutVal;
	                $logger.info('pxp_timeout_treatment', {
	                    'ulTimeoutLimit': ulTimeoutLimit
	                });
	            }
	            return ulTimeoutLimit;
	        }
	
	        return {
	            init: function init(params) {
	                if (Boolean(scope.eligibility.treatment)) {
	                    // do not init twice
	                    return $q.resolve(scope.eligibility);
	                }
	                $logger.debug('kmliEligibility_init');
	                scope.forcedLogin = params && params.forcedLogin;
	                scope.logoutCallback = params && params.logoutCallback;
	                return $populate(scope, {
	                    auth: $AuthModel.instance(),
	                    checkoutAppData: $CheckoutAppDataModel.instance(scope.token),
	                    checkoutCart: $CheckoutCartModel.instance(scope.token)
	                }).then(function () {
	                    var country = scope.checkoutAppData.merchant.merchant_country;
	                    return $q.all(getPXPList(country)).then(function (result) {
	                        scope.kmliEligibility = Boolean(result[0] && result[0].treatment_name);
	                        scope.eligibility.ulTimeoutLimit = getTimeoutLimit(result[1]);
	                        scope.eligibility.preloadUL = isULpreload(result[2]);
	                        scope.eligibility.safeEligibility = isSafeEligible(result[3]);
	                        scope.eligibility.ulAsLanding = isUlAsLanding();
	                    });
	                }).then(function () {
	                    // STEP1: Check PXP response
	                    var pxpGroup = scope.kmliEligibility ? 'pxpTreatment' : 'pxpControl';
	
	                    // STEP2: Check for conditions that deviates from the PXP eligibility
	                    var reasons = []; // Reasons that deviates from control to treatment
	                    reasons.push(pxpGroup);
	
	                    var reason = pxpGroup === 'pxpControl' && routingReason();
	                    if (reason) {
	                        scope.kmliEligibility = true;
	                        reasons.push(reason);
	                    }
	
	                    // STEP3: Check for compatibility/environment issues which impacts UL/KMLI overall
	                    compatibility(reasons);
	
	                    var routing_reason = reasons[reasons.length - 1];
	
	                    scope.eligibility.treatment = pxpGroup;
	                    scope.eligibility.routingReason = routing_reason;
	                    scope.eligibility.deviatingReasons = reasons;
	                    scope.eligibility.kmliEligibility = scope.kmliEligibility;
	
	                    // STEP4: Instrument deterministically whether KMLI is shown to the user or not
	                    $logger.debug(scope.kmliEligibility ? 'KMLI_ELIGIBLE_USER' : 'KMLI_INELIGIBLE_USER', { userGroup: reasons, routing_reason: routing_reason });
	                    $logger.info('checkout_fpti', {
	                        'from': 'KMLI_ELG_CHK',
	                        'to': 'process_kmli_elg_chk',
	                        'routing_reason': routing_reason
	                    });
	                    return scope.eligibility;
	                });
	            },
	
	            eligible: function eligible() {
	                return scope.eligibility;
	            }
	
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-login-components/src/login", "components/xo-login-components/src/login/kmliEligibility.js"))

/***/ }),

/***/ "./components/ul-inline/dist/inject.js":
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	!function(a,b){a.PAYPAL=a.PAYPAL||{},a.PAYPAL.unifiedLogin=b()}(this,function(){function a(a,b){var c,d={src:a,height:b.height||239,style:"width: 100%;",name:b.name||"injectedUl",frameborder:0,scrolling:b.scrolling||"no",title:b.title||"PayPal",sandbox:"allow-same-origin allow-scripts allow-popups allow-forms allow-top-navigation"},e=document.createElement("iframe");b.hide&&(d.style=d.style+"display: none;");for(c in d)e.setAttribute(c,d[c]);return e}function b(a,b,c){var d,e=a||window.location.origin||window.location.protocol+"//"+window.location.host,f=e+(c||"/signin/inject/"),g=b?"?":"",h=0;if(!b)return f;for(d in b)h>0&&(g+="&"),g=g+d+"="+encodeURIComponent(b[d]),h+=1;return f+g}function c(a){var b,c="";try{if(a.source.name!==q.name)return}catch(d){return}if(b=g(a.origin),!f(b))throw new Error("PostMessage iframe domain ("+b+"), must be a *.paypal.com domain");if(c=a&&a.data,"string"==typeof c)try{c=JSON.parse(c)}catch(h){throw new Error("Invalid JSON string sent to onPostMessage handler: "+c)}c.data&&"resize"===c.data.event?e(q,c.data.heightInPx):c.data&&"htmlRendered"===c.data.event?x=!0:!w&&p?p(c):w&&v.push(c)}function d(a){a&&"resize"===a.event?e(s,a.heightInPx):r(a)}function e(a,b){a.setAttribute("height",b)}function f(a){var b=/\.paypal\.com$/gi;return b.test(a)}function g(a){if(a){var b=/^https?:\/\/(.*\.paypal\.com)(:[0-9]+)?$/gi,c=b.exec(a);return c&&c[1]}}function h(){var a;if(p){for(a=0;a<v.length;a++)p(v[a]);v=[],w=!1}}function i(c){var d,e,h,i,k;if(!c||!c.targetElement)throw h="targetElement",new Error("The "+h+" option is required");if(c.origin&&(i=g(c.origin),!f(i)))throw new Error('All values for the "origin" setting must match *.paypal.com');for(u=c.config||{},e=b(c.origin,c.queryParams,c.iframePathname),k=c.xhrRequest&&c.xhrRequest===!0,d=k||c.preLoadedSource?a("about:blank",u):a(e,u),t=c.targetElement;c.targetElement.hasChildNodes();)c.targetElement.removeChild(c.targetElement.lastChild);return c.targetElement.appendChild(d),"directMessageIframe"===c.iframeType?(s=d,r=c.onPostMessage):(q=d,p=c.onPostMessage,j()),k?n(e,function(a){a&&o(d,a)}):c.preLoadedSource&&o(d,c.preLoadedSource),w=p?!1:!0,{iframe:d,onPostMessageCallback:p}}function j(){window.addEventListener?window.addEventListener("message",c,!1):window.attachEvent("onmessage",c)}function k(a){p=a,h()}function l(){t.parentNode&&t.parentNode.removeChild(t)}function m(b){var c,d,e,f,g="about:blank";if(!x)return void setTimeout(function(){m(b)},50);for(b.onPostMessage&&k(b.onPostMessage),u.hide=!1,c=a(g,u);b.targetElement.hasChildNodes();)b.targetElement.removeChild(b.targetElement.lastChild);b.targetElement.appendChild(c),d=q.contentWindow.document,e=d.documentElement.outerHTML,f=c.contentWindow.document,f.open(),f.write(e),f.close(),l(),q=c,t=b.targetElement}function n(a,b){var c;window.XMLHttpRequest?c=new XMLHttpRequest:window.ActiveXObject&&(c=new ActiveXObject("Microsoft.XMLHTTP")),c&&(c.onreadystatechange=function(){4==c.readyState&&200==c.status&&b(c.responseText)},c.open("GET",a,!0),c.send())}function o(a,b){a.contentWindow.inlineUlContents=b,a.src='javascript:window["inlineUlContents"]'}var p,q,r,s,t,u,v=[],w=!1,x=!1;return{inject:i,copyPasteIframe:m,removeTargetElement:l,messageDispatcher:c,nonPostMessageDispatcher:d}});
	
	}.call(window));

/***/ }),

/***/ "./components/xo-ui-components/src/accessibility/ui.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.filterAll = exports.findAll = exports.tabbable = exports.focusable = exports.visible = exports.KEYS = undefined;
	
	var _jquery = __webpack_require__("./components/jquery/dist/jquery.min.js");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var KEYS = {
	    TAB: 0x09,
	    ENTER: 0x0D,
	    ESC: 0x1B,
	    SPACE: 0x20,
	    LEFT: 0x25,
	    UP: 0x26,
	    RIGHT: 0x27,
	    DOWN: 0x28
	};
	
	function visible(element) {
	    return _jquery2['default'].expr.filters.visible(element) && !(0, _jquery2['default'])(element).parents().addBack().filter(function () {
	        return _jquery2['default'].css(this, 'visibility') === 'hidden';
	    }).length;
	}
	
	// ripped from http://stackoverflow.com/a/7668761
	/* istanbul ignore next */
	function focusable(element) {
	    var nodeName = element.nodeName.toLowerCase();
	    var isTabIndexNotNaN = !isNaN(_jquery2['default'].attr(element, 'tabindex'));
	    var map;
	    var mapName;
	    var img;
	
	    if (nodeName === 'area') {
	        map = element.parentNode;
	        mapName = map.name;
	        if (!element.href || !mapName || map.nodeName.toLowerCase() !== 'map') {
	            return false;
	        }
	        img = (0, _jquery2['default'])('img[usemap=#' + mapName + ']')[0];
	        return !!img && visible(img);
	    }
	    return (/^(input|select|textarea|button|object)$/.test(nodeName) ? // eslint-disable-line no-nested-ternary
	    !element.disabled : nodeName === 'a' ? element.href || isTabIndexNotNaN : isTabIndexNotNaN) &&
	    // the element and all of its ancestors must be visible
	    visible(element);
	}
	
	/* istanbul ignore next */
	function tabbable(element) {
	    var tabIndex = _jquery2['default'].attr(element, 'tabindex');
	    var isTabIndexNaN = isNaN(tabIndex);
	
	    return (isTabIndexNaN || tabIndex >= 0) && focusable(element);
	}
	
	function filterAll(elements, filterFn) {
	    return (0, _jquery2['default'])(elements).filter(function () {
	        return filterFn(this);
	    });
	}
	
	function findAll(container, filterFn) {
	    return filterAll((0, _jquery2['default'])(container).find('*'), filterFn);
	}
	
	exports.KEYS = KEYS;
	exports.visible = visible;
	exports.focusable = focusable;
	exports.tabbable = tabbable;
	exports.findAll = findAll;
	exports.filterAll = filterAll;

/***/ }),

/***/ "./components/xo-guest-components/src/guest-upgrade-interstitial/route.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-guest-components/src/guest-upgrade-interstitial/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('xo-guest-upgrade-interstitial.route', ['squid', 'xo-guest-upgrade-interstitial.directive']).factory('$GuestUpgradeInterstitialRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('GuestUpgradeInterstitialRoute', {
	
	            name: 'guestUpgradeInterstitial',
	            directive: 'xo-guest-upgrade-interstitial',
	            trackingData: {
	                fptiState: 'guest_xo_upgrade_interstitial',
	                trackStateExit: false,
	                pageQualifier: 'guest',
	                buzname: {
	                    'guest': {
	                        'pagename': '%::fullpage-guest-upgrade-interstitial',
	                        'pagename2': '%::fullpage-guest:member:hermes:',
	                        'version': 'guest:%:'
	                        // More page qualifiers come here...
	                    } }
	            },
	            children: []
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-guest-components/src/guest-upgrade-interstitial", "components/xo-guest-components/src/guest-upgrade-interstitial/route.js"))

/***/ }),

/***/ "./components/xo-guest-components/src/guest-upgrade-interstitial/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _index = __webpack_require__("./components/xo-models/src/onboard/index.js");
	
	var _directive = __webpack_require__("./components/xo-form-components/src/national-id-input/directive.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _template = __webpack_require__("./components/xo-guest-components/src/guest-upgrade-interstitial/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-guest-components/src/guest/onboardOptions/signup/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/tooltip/directive.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('xoGuestUpgradeInterstitial', {
	    tag: 'xo-guest-upgrade-interstitial',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            type: 'var'
	        },
	        parentModel: {
	            type: 'var'
	        }
	    },
	
	    resolve: {
	        experiments: function experiments() {
	            return {
	                signupComplianceUS: (0, _squid.$pxp)('xo_xoonboarding_signupcompliance_us', { 'ctx.COUNTRY': _squid.$locale.country }, '(xo_xoonboarding_signupcompliance_us_)(.*)')
	            };
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            this.locale = _squid.$locale;
	            this.flags = this.props.parentModel.flags;
	            if (!this.flags) {
	                _logger.$logger.info('WPS_interstitial_render_error');
	                _uiRouter.$state.go('checkout.genericError', { code: 'PAYMENT_ALREADY_DONE' });
	            }
	            this.flags.wpsInterstitial = true;
	            this.flags.showMobileEmailSection = true;
	            this.onboard = this.props.parentModel.onboard;
	        },
	        populate: function populate() {
	            if (this.experiments.signupComplianceUS && this.experiments.signupComplianceUS.treatment_name === 'xo_xoonboarding_signupcompliance_us_test') {
	                this.showNewSignupComplianceExp = true;
	            }
	        }
	    },
	
	    actions: {
	        onSubmit: function onSubmit() {
	            this.upgrade = new _index.$GuestUpgradeModel();
	
	            this.upgrade.billing_address = this.onboard.billing_address;
	            this.upgrade.user = this.onboard.user;
	            this.upgrade.payerId = this.onboard.payerId;
	            this.upgrade.transaction = this.onboard.transaction;
	            this.upgrade.phone = this.onboard.phone;
	            this.upgrade.nationalIdModel = _directive.$NationalIdModel.instance(this.props.token);
	            this.upgrade.experienceChannel = 'HERMES';
	
	            return this.upgrade.save({
	
	                data: this.upgrade.serialize(),
	
	                success: function success() {
	                    _angular.$rootScope.mode = 'signup';
	                    _logger.$logger.info('WPS_guest_upgrade_success');
	                    return _uiRouter.$state.go('checkout.done');
	                },
	                error: function error() {
	                    _logger.$logger.info('WPS_guest_upgrade_failed_SERVICE_ERROR');
	                    return _uiRouter.$state.go('checkout.done', { code: 'NO_UPGRADE' });
	                },
	                contingencies: {
	                    DOB_INVALID: function DOB_INVALID() {
	                        _logger.$logger.info('WPS_guest_upgrade_failed_DOB_INVALID');
	                        return _uiRouter.$state.go('checkout.done', { code: 'NO_UPGRADE' });
	                    },
	                    NATID_INVALID: function NATID_INVALID() {
	                        _logger.$logger.info('WPS_guest_upgrade_failed_NATID_INVALID');
	                        return _uiRouter.$state.go('checkout.done', { code: 'NO_UPGRADE' });
	                    },
	                    DEFAULT: function DEFAULT() {
	                        _logger.$logger.info('WPS_guest_upgrade_failed_Unknown_contingency');
	                        return _uiRouter.$state.go('checkout.done', { code: 'NO_UPGRADE' });
	                    }
	                },
	                validation: function validation() {
	                    _logger.$logger.info('WPS_guest_upgrade_failed_SERVICE_VALIDATION_ERROR');
	                    return _uiRouter.$state.go('checkout.done', { code: 'NO_UPGRADE' });
	                }
	            });
	        }
	    }
	});
	
	
	_angular.$rootScope;
	
	_squid.$Component;
	
	_squid.$locale;
	
	_squid.$pxp;
	
	_index.$GuestUpgradeModel;
	
	_directive.$NationalIdModel;
	
	_logger.$logger;
	
	_uiRouter.$state;
	module.exports = exports['default'];

/***/ }),

/***/ "./components/xo-guest-components/src/guest-upgrade-interstitial/template.html":
/***/ (function(module, exports) {

	module.exports = "<div class=\"guestUpgradeInterstitial upsellOpen\" ng-class=\"{mobile: isDevice}\" content>\n    <div class=\"upsellMask\"></div>\n    <div class=\"upsellWrapper\" >\n        <div class=\"profile\">&nbsp;</div>\n        <div class=\"upsellScrollWrapper\">\n            <div class=\"upsellContainer\">\n                <div id=\"paypalLogo\" class=\"miniLogo\"><span class=\"accessAid\">{{ content('base.payPal') }}</span></div>\n\n                <div class=\"mainTitle\">\n                    <div>{{content('signup.paymentSuccessTitle')}}</div>\n                    <div>{{content('signup.createAccountToday')}}</div>\n                </div>\n\n                <div class=\"intro-content\">{{ content('signup.createAccountDetails') }}</div>\n\n                <div class=\"emailHelper\" >\n                    <span class=\"email\">{{onboard.user.email}}</span>\n                    <span><a href=\"#\" id=\"emailHelp\" class=\"verifyHelp\"> <img\n                            alt=\"{{ content('login.kmliTooltipTitle') }}\" />\n                    </a></span>\n\n                    <xo-tooltip trigger=\"#emailHelp\" >\n                        <div id=\"emailToolTipText\" class=\"tip tipDesc emailToolTip\">\n                            {{ content('signup.emailHelper') }}\n                        </div>\n                    </xo-tooltip>\n                </div>\n\n                <form id=\"upgradeInterstitialForm\" name=\"upgradeInterstitialForm\" class=\"upgradeInterstitialForm\"\n                      ng-submit=\"upgradeInterstitialForm.$valid && actions.onSubmit()\" ng-class=\"{true: 'validated'}[validated]\"  novalidate>\n\n                    <xo-signup-options flags=\"flags\" onboard=\"onboard\" guest-upgrade=\"true\"></xo-signup-options>\n\n                    <input track-submit=\"xoon_wps_interstitial_submit\" id=\"wpsInterstitialSubmit\" type=\"submit\" ng-click=\"validated=true\"\n                        value=\"{{ content(showNewSignupComplianceExp ? 'common.agreeAndCreateAccount' : 'common.agreeAndContinue') }}\" class=\"btn full\" />\n\n                    <div class=\"intro-content\">\n                        <a aria-hidden=\"false\" class=\"notNow\" id=\"notNow\"\n                           track-link=\"guest_upgrade_interstitial_not_now\"\n                           ui-sref=\"checkout.done\" role=\"button\">\n                            {{content('common.notNow')}}\n                        </a>\n\n                    </div>\n                </form>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "./components/xo-guest-components/src/guest/currencyConversion/route.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-guest-components/src/guest/currencyConversion/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('xo-currency-conversion-lightbox.route', ['squid', 'xo-currency-conversion-lightbox.directive']).factory('$CurrencyConversionOptionsRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('CurrencyConversionOptionsRoute', {
	
	            name: 'currencyConversionOptions',
	            directive: 'xo-currency-conversion-lightbox',
	            trackingData: {
	                fptiState: 'guest_currency_conversion_lightbox',
	                trackStateExit: false,
	                pageQualifier: 'guest',
	                buzname: {
	                    'guest': {
	                        'pagename': '%::fullpage-guest-currency-conversion-lightbox',
	                        'pagename2': '%::fullpage-guest:member:hermes:',
	                        'version': 'guest:%:'
	                    }
	                }
	            },
	
	            children: []
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-guest-components/src/guest/currencyConversion", "components/xo-guest-components/src/guest/currencyConversion/route.js"))

/***/ }),

/***/ "./pages/xo-signup/route.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./pages/xo-signup/directive.js"), __webpack_require__("./pages/xo-sidebar/route.js"), __webpack_require__("./components/xo-login-components/src/onetouch-interstitial/route.js"), __webpack_require__("./components/xo-guest-components/src/guest-upgrade-interstitial/route.js"), __webpack_require__("./components/xo-guest-components/src/guest/currencyConversion/route.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('hermes.page.xo-signup.route', ['squid', 'hermes.page.xo-signup.directive', 'hermes.page.xo-sidebar.route']).factory('$SignupRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('SignupRoute', {
	            name: 'signup',
	            directive: 'xo-signup',
	            titleContent: 'accountCreationGuest.heading',
	            trackingData: {
	                fptiState: 'signup',
	                trackStateExit: true,
	                templateName: 'signup.dust',
	                pageGoal: 'Signup Start',
	                pageQualifier: 'signup',
	                buzname: {
	                    'signup': {
	                        'pagename': '%::fullpage-signup',
	                        'pagename2': '%::fullpage-signup:member:hermes:',
	                        'version': 'guest:%:'
	                        // More page qualifiers come here...
	                    } }
	            },
	            children: [{
	                name: '$SidebarRoute',
	                attributes: {
	                    'back-uri': 'backUri',
	                    'parent-model': 'singleStepModel'
	                }
	            }, {
	                name: '$OneTouchUpsellRoute',
	                attributes: {
	                    token: 'token',
	                    'on-complete': 'onComplete',
	                    'disable-close-button': 'true',
	                    'ignore-bg-clicks': 'true'
	                }
	            }, {
	                name: '$GuestUpgradeInterstitialRoute',
	                attributes: {
	                    token: 'token',
	                    'parent-model': 'singleStepModel'
	                }
	            }, {
	                name: '$CurrencyConversionOptionsRoute',
	                attributes: {
	                    token: 'token',
	                    'parent-model': 'singleStepModel',
	                    'is-pre-plan': 'true',
	                    'done-fn': 'onCurrencyConversionDone'
	                }
	            }]
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-signup", "pages/xo-signup/route.js"))

/***/ }),

/***/ "./pages/xo-signup/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/module.js"), __webpack_require__("../node_modules/noop-loader/index.js!./pages/xo-signup/template.html"), __webpack_require__("./components/xo-page-components/src/value-props/directive.js"), __webpack_require__("./components/xo-guest-components/src/guest/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, module, template) {
	
	    return angular.module('hermes.page.xo-signup.directive', ['squid', 'xo-value-props.directive', 'xo-onboard.payment.directive']).directive('xoSignup', function ($rootScope, $SingleStepModel) {
	
	        return {
	            template: template,
	
	            scope: {
	                token: '=',
	                parentCallbacks: '=',
	                buttonParams: '='
	            },
	
	            controller: function controller($scope, $rootScope, $state, $locale) {
	                // eslint-disable-line no-shadow
	                $scope.mode = 'signup';
	                $scope.backUri = 'checkout.signup';
	                $scope.singleStepModel = new $SingleStepModel();
	
	                $scope.onComplete = function () {
	                    $state.go('checkout.end');
	                };
	
	                $scope.onCurrencyConversionDone = function () {
	                    $state.go($scope.backUri);
	                };
	
	                /*
	                 * This function will run after the spinner is loaded completely on xo-signup.
	                 *
	                 */
	
	                function onLoadedPageUp() {
	                    document.querySelector('#main').scrollIntoView({ behavior: 'smooth' });
	                }
	
	                $rootScope.$on('allLoaded', onLoadedPageUp);
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./pages/xo-signup/template.html":
/***/ (function(module, exports) {

	module.exports = "<section class=\"fullSignup\" id=\"fullSignup\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <xo-onboard-payment token=\"token\" mode=\"mode\" single-step-model=\"singleStepModel\" button-params=\"buttonParams\"></xo-onboard-payment>\n        </div>\n        <div class=\"span10\">\n            <xo-value-props type=\"review\" title=\"{{content('guestVerify.propHead')}}\" text-content=\"guestVerify.propVal\"></xo-value-props>\n        </div>\n    </div>\n    <div ui-view></div>\n</section>\n"

/***/ }),

/***/ "./pages/xo-add-card/route.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-wallet-components/src/add-card/route.js"), __webpack_require__("./pages/xo-add-card/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('hermes.page.xo-add-card.route', ['squid', 'xo-add-card.route', 'hermes.page.xo-add-card.directive']).factory('$AddCardPageRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('AddCardPageRoute', {
	            name: 'pageAddCard',
	            directive: 'xo-page-add-card-page',
	            titleContent: 'asideHeader.addCard',
	            query: ['gaming', 'country', 'fiType', 'mode'],
	            trackingData: {
	                templateName: 'addCard.dust',
	                pageGoal: 'Add Card',
	                buzname: {
	                    'fullpage': {
	                        'pagename': '%::fullpage-add-cc',
	                        'pagename2': '%::fullpage-add-cc:guest:hermes:',
	                        'version': 'guest:%:'
	                        // More page qualifiers come here...
	                    } }
	            },
	            children: [{
	                name: '$AddCardFlowRoute',
	                attributes: {
	                    token: 'token',
	                    message: 'message',
	                    pagetitle: 'pagetitle',
	                    'parent-callbacks': 'callbacks'
	                }
	            }]
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-add-card", "pages/xo-add-card/route.js"))

/***/ }),

/***/ "./components/xo-wallet-components/src/add-card/route.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-wallet-components/src/add-card/directive.js"), __webpack_require__("./components/xo-wallet-components/src/add-card/addcard/route.js"), __webpack_require__("./components/xo-wallet-components/src/add-card/selectcard/route.js"), __webpack_require__("./components/xo-wallet-components/src/add-card/addbilling/route.js"), __webpack_require__("./components/xo-wallet-components/src/add-card/addCep/route.js"), __webpack_require__("./components/xo-wallet-components/src/confirm-upop/route.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-add-card.route', ['squid', 'xo-add-card.directive', 'xo-add-card.addcard.route', 'xo-add-card.selectcard.route', 'xo-add-card.addbilling.route', 'xo-add-card.addcep.route', 'xo-confirm-upop.route']).factory('$AddCardFlowRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('CardRoute', {
	
	            name: 'addCardFlow',
	            directive: 'xo-add-card-flow',
	            titleContent: 'asideHeader.addCard',
	            children: [{
	                name: '$AddCardRoute',
	                attributes: {
	                    token: 'token',
	                    cardmodel: 'cardmodel',
	                    done: 'addCCDone',
	                    message: 'message',
	                    pagetitle: 'pagetitle',
	                    sidebar: 'sidebar',
	                    showmeftsection: 'showmeftsection',
	                    hideparenthead: 'hideparenthead',
	                    billingaddressupdated: 'billingaddressupdated',
	                    isupdatecard: 'isupdatecard',
	                    'parent-callbacks': 'callbacks',
	                    'selected-promotion-card-type': 'selectedPromotionCardType',
	                    promotion: 'promotion',
	                    'page-level': 'pageLevel',
	                    logout: 'logout',
	                    phone: 'phone',
	                    'on-success': 'onSuccess',
	                    'back-uri': 'backUri'
	                }
	
	            }, {
	                name: '$SelectCardRoute',
	                attributes: {
	                    token: 'token',
	                    'parent-callbacks': 'callbacks',
	                    message: 'message',
	                    pagetitle: 'pagetitle',
	                    sidebar: 'sidebar',
	                    'selected-promotion-card-type': 'selectedPromotionCardType',
	                    promotion: 'promotion'
	                }
	            }, {
	                name: '$AddBillingRoute',
	                attributes: {
	                    token: 'token',
	                    sidebar: 'sidebar',
	                    showmeftsection: 'showmeftsection',
	                    'parent-callbacks': 'callbacks',
	                    hideparenthead: 'hideparenthead',
	                    billingaddressupdated: 'billingaddressupdated',
	                    'prefill-address': 'prefillAddress'
	                }
	            }, {
	                name: '$AddCepRoute',
	                attributes: {
	                    token: 'token',
	                    sidebar: 'sidebar',
	                    'done-fn': 'cepDone',
	                    'prefill-address': 'prefillAddress'
	                }
	            }]
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-wallet-components/src/add-card", "components/xo-wallet-components/src/add-card/route.js"))

/***/ }),

/***/ "./components/xo-wallet-components/src/add-card/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-card/template.html"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/fi/index.js"), __webpack_require__("./components/xo-models/src/address/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid, template) {
	
	    return squid.module('xo-add-card.directive', ['squid', 'xomodel.checkout', 'xomodel.fi', 'xomodel.address']).directive('xoAddCardFlow', function () {
	        return {
	            template: template,
	
	            scope: {
	                token: '=',
	                parentCallbacks: '=',
	                message: '=',
	                pagetitle: '=',
	                sidebar: '=',
	                showmeftsection: '=',
	                hideparenthead: '=',
	                promotion: '=',
	                pageLevel: '=',
	                logout: '=',
	                phone: '=',
	                fundingid: '=',
	                onSuccess: '=',
	                backUri: '='
	            },
	
	            controller: function controller($scope, $state, $populate, $AddCardModel, $CardModel, $CheckoutSessionModel, $PrefillAddressModel, $util, $renderContent) {
	
	                $scope.addCCDone = function () {
	                    $scope.parentCallbacks.finish();
	                };
	
	                $scope.callbacks = {
	                    done: function done() {
	                        $scope.parentCallbacks.finish();
	                    },
	
	                    showCep: function showCep() {
	                        $scope.prefillAddress = new $PrefillAddressModel({
	                            id: $scope.token
	                        });
	
	                        $state.go('^.addCep');
	                    },
	
	                    cardTypeSelected: function cardTypeSelected(type) {
	                        $scope.selectedPromotionCardType = {
	                            type: type
	                        };
	                        $state.go('^.addCard');
	                    }
	                };
	
	                $scope.cepDone = function () {
	                    $state.go('^.addBilling');
	                };
	
	                $scope.selectedPromotionCardType = {
	                    type: $scope.promotion && $scope.promotion.type
	                };
	
	                if ($scope.promotion) {
	                    $scope.promotion.type = null;
	                }
	
	                $scope.billingaddressupdated = {
	                    value: false
	                };
	
	                $scope.phone = {
	                    hide_type: true
	                };
	
	                $scope.cardmodel = new $AddCardModel({
	                    card: new $CardModel()
	                });
	
	                $populate($scope, {
	                    checkoutSession: $CheckoutSessionModel.instance($scope.token).retrieve({
	                        contingencies: {
	                            NEED_CREDIT_CARD: angular.noop,
	                            EXPIRED_CREDIT_CARD: angular.noop
	                        }
	                    })
	                }).then(function () {
	
	                    if ($scope.checkoutSession.errorData && $scope.checkoutSession.errorData.resolution) {
	                        var card = $scope.checkoutSession.errorData.resolution.data;
	
	                        if (card.fundingId && card.fi && card.fi.type) {
	                            $scope.cardmodel.id = card.fundingId;
	                            $scope.cardmodel.card = new $CardModel({
	                                number: 'xxxx-xxxx-xxxx-' + card.fi.number,
	                                type: card.fi.type.toUpperCase(),
	                                productType: card.fi.productType
	                            });
	                        }
	                    }
	                    if ($scope.fundingid) {
	                        var fundingSource = $util.find($scope.checkoutSession.fundingOptions.instruments, function (funding) {
	                            if (funding && funding.id === $scope.fundingid) {
	                                return funding;
	                            }
	                        });
	
	                        if (fundingSource) {
	                            $scope.cardmodel.id = fundingSource.id;
	                            $scope.cardmodel.card = new $CardModel({
	                                number: 'xxxx-xxxx-xxxx-' + fundingSource.lastDigits,
	                                lastDigits: fundingSource.lastDigits,
	                                type: fundingSource.name,
	                                name: $renderContent('fsMappings.' + fundingSource.name)
	                            });
	                        }
	                    }
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-card/template.html":
/***/ (function(module, exports) {

	module.exports = "<div ui-view></div>"

/***/ }),

/***/ "./components/xo-wallet-components/src/add-card/addcard/route.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	var _route = __webpack_require__("./components/xo-wallet-components/src/confirm-upop/route.js");
	
	var _route2 = _interopRequireDefault(_route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-wallet-components/src/add-card/addcard/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-add-card.addcard.route', ['squid', 'xo-add-card.addcard.directive']).factory('$AddCardRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('AddCardRoute', {
	
	            name: 'addCard',
	            directive: 'xo-add-card',
	            titleContent: 'asideHeader.addCard',
	
	            trackingData: {
	                fptiState: 'add_or_update_cc'
	            },
	            loginRequired: true,
	            children: [{
	                route: _route2['default'],
	                attributes: {
	                    token: 'token',
	                    phone: 'phone',
	                    cardmodel: 'cardmodel',
	                    'on-success': 'onSuccess'
	                }
	            }]
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-wallet-components/src/add-card/addcard", "components/xo-wallet-components/src/add-card/addcard/route.js"))

/***/ }),

/***/ "./components/xo-wallet-components/src/confirm-upop/route.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _index = __webpack_require__("./components/squid/dist/index.js");
	
	var _directive = __webpack_require__("./components/xo-wallet-components/src/confirm-upop/directive.js");
	
	var _directive2 = _interopRequireDefault(_directive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _index.$Route.extend('$xoConfirmUpopRoute', {
	    path: 'confirmUpop',
	    directive: _directive2['default'],
	    titleContent: 'confirmUpop.confirm',
	    trackingData: {
	        fptiState: 'confirm_upop'
	    },
	    query: ['fromLoginOverlay'],
	    loginRequired: true,
	    pageOnOverlay: true,
	    children: []
	});
	
	
	_index.$Route;
	module.exports = exports['default'];

/***/ }),

/***/ "./components/xo-wallet-components/src/confirm-upop/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _addCard = __webpack_require__("./components/xo-wallet-components/src/add-card/index.js");
	
	var _util = __webpack_require__("./components/xo-wallet-components/src/fi-contingency-list/util.js");
	
	var _jquery = __webpack_require__("./components/jquery/dist/jquery.min.js");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__("./components/xo-wallet-components/src/confirm-upop/init/directive.js");
	
	__webpack_require__("./components/xo-wallet-components/src/confirm-upop/confirm/directive.js");
	
	__webpack_require__("./components/xo-wallet-components/src/confirm-upop/styles.less");
	
	var _template = __webpack_require__("./components/xo-wallet-components/src/confirm-upop/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	var _index = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoConfirmUpopDirective', {
	    tag: 'xo-confirm-upop',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            type: 'var',
	            required: true
	        },
	        phone: {
	            type: 'var',
	            required: false
	        },
	        cardModel: {
	            type: 'var',
	            required: true
	        },
	        onSuccess: {
	            type: 'var',
	            required: false
	        },
	        onCancel: {
	            type: 'var',
	            required: false
	        },
	        buttonTextKey: {
	            type: 'var',
	            required: false
	        },
	        onInitError: {
	            type: 'var',
	            required: false
	        }
	    },
	
	    actions: {
	        initSuccess: function initSuccess() {
	            this.showCollectOtpScreen = true;
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var _this = this;
	
	            this.phone = this.props.phone || {};
	            this.cardLast4 = this.cardModel.last4();
	
	            // Set only from Login page
	            this.fromLoginOverlay = _uiRouter.$stateParams.fromLoginOverlay;
	
	            (0, _angular.$timeout)(function () {
	                (0, _jquery2['default'])('#upopConfirmation .upopConfirm').addClass('upopOpen');
	                if (_this.fromLoginOverlay) {
	                    (0, _angular.$timeout)(function () {
	                        (0, _jquery2['default'])('#upopConfirmation .modalWrapper').addClass('modalWrapperAnimation');
	                    });
	                }
	            });
	
	            var hideModal = function hideModal() {
	                (0, _jquery2['default'])('#upopConfirmation .upopConfirm').removeClass('upopOpen');
	            };
	
	            var done = function done(handler, target, errorData) {
	                hideModal();
	                (0, _angular.$timeout)(function () {
	                    return handler ? handler(errorData) : _this.goto(target);
	                }, 300);
	            };
	
	            var _success = function _success() {
	                done(_this.props.onSuccess, 'checkout.review');
	            };
	
	            this.closeModal = function (event) {
	                if (event) {
	                    event.preventDefault();
	                }
	
	                done(_this.props.onCancel, '^');
	            };
	
	            this.confirmed = function () {
	                if (_this.props.onSuccess) {
	                    // Make sure Guest/Signup always passes the onSuccess callback method.
	                    return _success();
	                }
	
	                // Update is only applicable for Hermes Member flow.
	                var checkoutSession = _index.$CheckoutSessionModel.instance(_this.token);
	                checkoutSession.fundingOptions.action('update', {
	                    resultModel: checkoutSession,
	                    silent: true,
	                    data: {
	                        planId: _this.cardModel.id
	                    },
	                    success: function success() {
	                        if (checkoutSession.cvvData) {
	                            checkoutSession.set('cvvData.security_code', _this.cardModel.security_code);
	                        }
	                        var isNewCard = !_this.cardModel.isExisting();
	
	                        var msg = isNewCard ? ['smallToolTip.cardAddedConfirmed'] : ['smallToolTip.cardConfirmed'];
	
	                        checkoutSession.message = {
	                            type: 'success',
	                            msgKeys: msg
	                        };
	
	                        _success();
	                    },
	                    contingencies: {
	                        TRANSACTION_REFUSED: function TRANSACTION_REFUSED(name) {
	                            checkoutSession.message = {
	                                type: 'info',
	                                msgKeys: 'creditcard.addedButCannotUse'
	                            };
	
	                            _success();
	                        }
	                    }
	                });
	            };
	
	            this.flag = function (field) {
	                return _addCard.$CardMetaData.getMetaData(_this.cardModel, field);
	            };
	
	            this.setMessage = function (message) {
	                _this.message = message;
	            };
	
	            this.setInitErrorData = function (errorData) {
	                if (_this.props.onInitError) {
	                    // Pass on the errorData to onInitError callback function for client specific content adaptation.
	                    done(_this.props.onInitError, '^', errorData);
	                } else {
	
	                    // prop for last 4 digits of card in error message
	                    var prop = {
	                        number: _this.cardModel.last4()
	                    };
	
	                    // Build the content message from errorData
	                    _this.setMessage(_util.$fiErrorUtil.addPageErrors(errorData, 'confirmUpop', prop, 'error'));
	                }
	            };
	        }
	    }
	});
	
	
	_angular.$timeout;
	
	_squid.$Component;
	
	_uiRouter.$stateParams;
	
	_addCard.$CardMetaData;
	
	_util.$fiErrorUtil;
	
	_index.$CheckoutSessionModel;
	module.exports = exports['default'];

/***/ }),

/***/ "./components/xo-wallet-components/src/add-card/index.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _directive = __webpack_require__("./components/xo-wallet-components/src/add-card/cardExpiry/directive.js");
	
	Object.keys(_directive).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _directive[key];
	    }
	  });
	});
	
	var _cardMetaData = __webpack_require__("./components/xo-wallet-components/src/add-card/cardMetaData/index.js");
	
	Object.keys(_cardMetaData).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _cardMetaData[key];
	    }
	  });
	});
	
	var _directive2 = __webpack_require__("./components/xo-wallet-components/src/add-card/cvv/directive.js");
	
	Object.keys(_directive2).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _directive2[key];
	    }
	  });
	});

/***/ }),

/***/ "./components/xo-wallet-components/src/add-card/cardExpiry/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	
	exports.__esModule = true;
	exports.$xoCardExpiryDirective = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/tooltip/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/floating-label/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/directionality/directive.js");
	
	var _template = __webpack_require__("./components/xo-wallet-components/src/add-card/cardExpiry/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoCardExpiryDirective = exports.$xoCardExpiryDirective = _squid.$Component.extend('$xoCardExpiryDirective', {
	    tag: 'xo-card-expiry',
	    template: _template2['default'],
	
	    props: {
	        expiryMonth: {
	            type: 'var',
	            required: false
	        },
	        expiryYear: {
	            type: 'var',
	            required: false
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var _this = this;
	
	            this.expiryFormat = (0, _squid.$feature)('ccExpiryDateFormat', 'MMYY', _squid.$locale.country);
	
	            if (this.expiryMonth && this.expiryYear) {
	                if (this.expiryFormat === 'MMYY') {
	                    this.expiryDate = this.expiryMonth + '/' + this.expiryYear.substring(2, 4);
	                } else if (this.expiryFormat === 'MMYYYY') {
	                    this.expiryDate = this.expiryMonth + '/' + this.expiryYear;
	                }
	            }
	
	            if (this.expiryFormat === 'MMYY') {
	                this.maxlength = 5;
	                this.expiryMask = '99/99';
	            } else {
	                this.maxlength = 7;
	                this.expiryMask = '99/9999';
	            }
	
	            // If Japanese, we are falling back to "tel" keyboard.
	            if (_squid.$locale.country === 'JP') {
	                this.keyType = 'tel';
	            } else {
	                this.keyType = 'text';
	            }
	
	            this.formatExpiry = function (event) {
	                var key = event.keyCode || event.charCode;
	                var $el = $(event.target);
	                var val = $el.val().replace(/[^0-9\/]/gi, '');
	                var strokes = val.length;
	
	                // Ignore delete keys
	                if (key === 8 || key === 46) {
	                    return;
	                }
	
	                // after two characters add a slash char
	                if (strokes === 2) {
	                    val += '/';
	                }
	
	                _this.expiryDate = val;
	                $el.mask(_this.expiryMask);
	            };
	
	            var currentYear = new Date().getFullYear().toString();
	            var validMonths = _squid.$util.map(_squid.$util.range(1, 13), function (num) {
	                return ('0' + num).substr(-2);
	            });
	
	            this.validate = function (expiryDate) {
	                if (!expiryDate) {
	                    return;
	                }
	
	                var month = void 0,
	                    year = void 0,
	                    unformatted = void 0;
	                var isValid = false;
	
	                unformatted = expiryDate.replace(/[^0-9]/gi, '');
	                if (unformatted.length > 3) {
	                    month = unformatted.substring(0, 2);
	                    if (_this.expiryFormat === 'MMYY') {
	                        year = currentYear.substring(0, 2) + unformatted.substring(2, 4);
	                    } else if (_this.expiryFormat === 'MMYYYY') {
	                        year = unformatted.substring(2, 6);
	                    }
	
	                    isValid = validMonths.indexOf(month) > -1 && year >= currentYear;
	                }
	
	                _this.expiryYear = year;
	                _this.expiryMonth = month;
	
	                return isValid;
	            };
	        }
	    }
	});
	
	angular.value("$xoCardExpiryDirective", $xoCardExpiryDirective);
	_squid.$Component;
	
	_squid.$locale;
	
	_squid.$feature;
	
	_squid.$util;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "./components/xo-wallet-components/src/add-card/cardExpiry/template.html":
/***/ (function(module, exports) {

	module.exports = "<div class=\"expirationField inputField\" id=\"expirationField\" content>\n    <div class=\"inputField\" floating-label directionality>\n        <input type=\"{{keyType}}\" \n               ng-model=\"expiryDate\"\n               name=\"expiry_value\"\n               id=\"expiry_value\"\n               value=\"\"\n               maxlength=\"{{maxlength}}\"\n               autocapitalize=\"off\"\n               aria-describedby=\"expiryHelp\"\n               autocomplete=\"off\"\n               ui-validate=\"'validate($value)'\"\n               ng-keyup=\"formatExpiry($event)\"\n               placeholder=\"{{content('creditcard.expiresPlaceholder')}}\"\n               data-error-key=\"validation.validExpirationDate\"\n               xo-error-tooltip\n               required />\n        <span id=\"expiryHelp\" class=\"accessAid\" ng-bind=\"content('creditcard.expiresPlaceholder')\"></span>\n        <label for=\"expiry_value\">{{ content('creditcard.expiresLabel') }}</label>\n    </div>\n</div>\n"

/***/ }),

/***/ "./components/xo-wallet-components/src/add-card/cardMetaData/index.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	
	exports.__esModule = true;
	exports.$CardMetaData = undefined;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var CARD_META_DATA = {
	    DEFAULT: {
	        fields: {
	            address: true,
	            cvv: true,
	            dob: false,
	            expiry: true,
	            issue: false,
	            phone: false
	        },
	        length: {
	            cvv: 3,
	            min: 16,
	            max: 16
	        },
	        luhn: true,
	        phoneType: 'Mobile',
	        spaces: '4,8,12'
	    },
	
	    PLCC: {
	        fields: {
	            expiry: false,
	            cvv: false,
	            address: false
	        },
	        length: {
	            min: 10,
	            max: 16
	        }
	    },
	
	    MAESTRO: {
	        pattern: /^(5018|5020|5038|4903|4911|4936|564182|545250|504834|503615|6333|6304|6759|676[1-3]|0604)/,
	        length: {
	            min: 12,
	            max: 19
	        },
	        spaces: '4,8,12,16'
	    },
	
	    SWITCH: {
	        pattern: /^(5018|5020|5038|4903|4911|4936|564182|545250|504834|503615|6333|6304|6759|676[1-3]|0604)/,
	        fields: {
	            issue: true
	        },
	        length: {
	            min: 12,
	            max: 19
	        },
	        spaces: '4,8,12,16'
	    },
	
	    DINERSCLUB: {
	        pattern: /^(36|38|30[0-5])/,
	        length: {
	            min: 14,
	            max: 14
	        }
	    },
	
	    DISCOVER: {
	        pattern: /^(6011|65|64[4-9]|622|36|38|30[0-5])/,
	        length: {
	            min: 14
	        }
	    },
	
	    MASTERCARD: {
	        pattern: /^(5[1-5]|2(2(2[1-9]|[3-9]\d)|[3-6]\d\d|7[0-1]\d|720))/
	    },
	
	    AMEX: {
	        pattern: /^3[47]/,
	        length: {
	            cvv: 4,
	            min: 15,
	            max: 15
	        },
	        spaces: '4,10'
	    },
	
	    VISA: {
	        pattern: /^4/,
	        length: {
	            min: 13
	        },
	        subTypes: {
	            QIWI: {
	                pattern: /^(428122|489049|469395|446942|462012)/
	            }
	        }
	    },
	
	    JCB: {
	        pattern: /^(?:2131|1800|35[0-9]{3})/,
	        length: {
	            min: 15
	        }
	    },
	
	    CBNATIONALE: {},
	
	    CETELEM: {
	        fields: {
	            dob: true
	        },
	        length: {
	            max: 19
	        },
	        spaces: '4,8,12,16'
	    },
	
	    COFIDIS: {
	        fields: {
	            dob: true,
	            expiry: false,
	            cvv: false
	        },
	        length: {
	            min: 8,
	            max: 9
	        },
	        spaces: '4,8',
	        luhn: false
	    },
	
	    COFINOGA: {
	        fields: {
	            dob: true,
	            cvv: false
	        },
	        length: {
	            min: 17,
	            max: 17
	        },
	        spaces: '4,8,12,16'
	    },
	
	    ELO: {
	        pattern: /^9/,
	        length: {
	            min: 13
	        }
	    },
	
	    HIPER: {
	        pattern: /^6/,
	        length: {
	            min: 13
	        }
	    },
	
	    HIPERCARD: {
	        pattern: /^7/,
	        length: {
	            min: 13
	        }
	    },
	
	    CUPCREDIT: {
	        fields: {
	            address: false,
	            phone: true
	        },
	        length: {
	            max: 19
	        }
	    },
	
	    CUPAMEXCREDIT: {
	        fields: {
	            address: false,
	            phone: true
	        },
	        length: {
	            cvv: 4,
	            min: 15,
	            max: 15
	        }
	    },
	
	    CUPDEBIT: {
	        fields: {
	            address: false,
	            cvv: false,
	            expiry: false,
	            phone: true
	        },
	        length: {
	            max: 19
	        }
	    },
	
	    CUPAMEXDEBIT: {
	        fields: {
	            address: false,
	            cvv: false,
	            expiry: false,
	            phone: true
	        },
	        length: {
	            min: 15,
	            max: 15
	        }
	    }
	};
	
	Object.keys(CARD_META_DATA).forEach(function (key) {
	    CARD_META_DATA[key] = $.extend(true, {}, CARD_META_DATA.DEFAULT, CARD_META_DATA[key]);
	});
	
	Object.keys(CARD_META_DATA).forEach(function (key) {
	    CARD_META_DATA[key].spaces = CARD_META_DATA[key].spaces.split(',').map(Number);
	});
	
	function getTypeByPattern(cardMetaData, types, number) {
	    var result = void 0;
	    types.some(function (type) {
	        var metaData = cardMetaData[type];
	        if (metaData && metaData.pattern && metaData.pattern.test(number)) {
	            result = type;
	            return true;
	        }
	    });
	    return result;
	}
	
	var $CardMetaData = exports.$CardMetaData = {
	    getMetaData: function getMetaData(card, field) {
	        var cardType = card && card.type || 'DEFAULT';
	        if (cardType === 'CUP') {
	            cardType = cardType + (card.dualType ? card.dualType : '');
	            cardType = cardType + (['DEBIT', 'DEBITCARD'].indexOf(card.productType) > -1 ? 'DEBIT' : 'CREDIT');
	        }
	        return _squid.$Class.get(CARD_META_DATA[cardType], field);
	    },
	    getCardType: function getCardType(types, number) {
	        var cardType = {};
	        if (_angular2['default'].isArray(types) && number) {
	            cardType.type = getTypeByPattern(CARD_META_DATA, types, number);
	            var metaData = CARD_META_DATA[cardType.type];
	            if (metaData && metaData.subTypes) {
	                cardType.subType = getTypeByPattern(metaData.subTypes, types, number);
	            }
	        }
	        return cardType;
	    }
	};
	
	_angular2['default'].value("$CardMetaData", $CardMetaData);
	_squid.$Class;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "./components/xo-wallet-components/src/add-card/cvv/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoCvvDirective = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _cardMetaData = __webpack_require__("./components/xo-wallet-components/src/add-card/cardMetaData/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/floating-label/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/directionality/directive.js");
	
	var _template = __webpack_require__("./components/xo-wallet-components/src/add-card/cvv/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoCvvDirective = exports.$xoCvvDirective = _squid.$Component.extend('$xoCvvDirective', {
	    tag: 'xo-cvv',
	    template: _template2['default'],
	
	    props: {
	        card: {
	            type: 'var'
	        },
	        showLabel: {
	            type: 'var'
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var _this = this;
	
	            this.maskCVV = (0, _squid.$feature)('maskCVV', false, _squid.$locale.country);
	            this.cvvLength = function () {
	                return _cardMetaData.$CardMetaData.getMetaData(_this.props.card, 'length.cvv');
	            };
	            this.cvvRequired = function () {
	                return _this.props.card.type !== 'MAESTRO' || (0, _squid.$feature)('maestroCvvRequired', false, _squid.$locale.country);
	            };
	        }
	    }
	});
	
	angular.value("$xoCvvDirective", $xoCvvDirective);
	_squid.$Component;
	
	_squid.$locale;
	
	_squid.$feature;
	
	_cardMetaData.$CardMetaData;

/***/ }),

/***/ "./components/xo-wallet-components/src/add-card/cvv/template.html":
/***/ (function(module, exports) {

	module.exports = "<div content class=\"inputField cvvField\" id=\"cvvField\">\n    <div class=\"cvvSecurityCode inputField\" floating-label directionality>\n        <input type=\"{{maskCVV ? 'password' : 'tel'}}\" id=\"cvv\" name=\"cvv\" ng-model=\"card.security_code\"\n               aria-describedby=\"securityCodeHelp\"\n               ng-pattern=\"/^[0-9]{1,4}$/\" ng-minlength=\"cvvLength()\" maxlength=\"{{cvvLength()}}\"\n               placeholder=\"{{cvvLength() === 3 ? content('creditcard.threeDigits') : content('creditcard.fourDigits')}}\"\n               ng-required=\"cvvRequired()\" ng-class=\"{'four': cvvLength() === 4}\" autocomplete=\"off\"\n               data-error-key=\"validation.validCSC\" xo-error-tooltip />\n\n        <span id=\"securityCode\" class=\"creditCard\" role=\"img\" ng-class=\"{'four': cvvLength() === 4}\"\n              aria-label=\"{{cvvLength() === 4 ? content('creditcard.cscHelp4Digits') : content('creditcard.cscHelp3Digits')}}\">\n        </span>\n        <label ng-if=\"showLabel\" for=\"cvv\">{{ content('creditcard.cscLabel') }}</label>\n        <span id=\"securityCodeHelp\" class=\"accessAid\" ng-bind=\"cvvLength() === 4 ? content('creditcard.cscHelp4Digits') : content('creditcard.cscHelp3Digits')\"></span>\n    </div>\n</div>\n"

/***/ }),

/***/ "./components/xo-wallet-components/src/confirm-upop/init/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _util = __webpack_require__("./components/xo-wallet-components/src/fi-contingency-list/util.js");
	
	var _index = __webpack_require__("./components/xo-models/src/fi/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/spinner-button/directive.js");
	
	var _template = __webpack_require__("./components/xo-wallet-components/src/confirm-upop/init/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoInitOtpDirective', {
	    tag: 'xo-init-otp',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            type: 'var',
	            required: true
	        },
	        phone: {
	            type: 'var',
	            required: false
	        },
	        cardModel: {
	            type: 'var',
	            required: true
	        },
	        onSuccess: {
	            type: 'var',
	            required: true
	        },
	        flag: {
	            type: 'var',
	            required: true
	        },
	        setErrorData: {
	            type: 'var',
	            required: true
	        }
	    },
	
	    actions: {
	        initOtp: function initOtp() {
	            var _this = this;
	
	            var handleContingencies = function handleContingencies() {
	                var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	                var prop = arguments[1];
	
	                var errorData = void 0;
	                if (result.errorCodes) {
	                    errorData = result;
	                } else {
	                    errorData = {
	                        errorCodes: [result['0'] || 'ISSUER_DECLINE']
	                    };
	                }
	
	                _this.setErrorData(errorData);
	
	                if (window.scrollTo) {
	                    window.scrollTo(0, 0);
	                }
	            };
	
	            this.isProcessing = true;
	
	            var resolveOTP = new _index.$ResolveOTP({ id: this.cardModel.id });
	
	            resolveOTP.action('init', {
	                data: {
	                    phone: {
	                        country_code: this.phone.IntDialingCountryCode,
	                        number: this.phone.telephone
	                    }
	                },
	                resultModel: {},
	                success: function success() {
	                    _this.onSuccess();
	                },
	
	                error: function error() {
	                    handleContingencies();
	                },
	
	                contingencies: {
	                    INIT_OTP_CONTINGENCY: function INIT_OTP_CONTINGENCY(name, result) {
	
	                        handleContingencies(result);
	                        _util.$fiErrorUtil.addFieldErrors(result, _this.$element);
	                    },
	                    DEFAULT: function DEFAULT() {
	                        handleContingencies();
	                    }
	                }
	            })['finally'](function () {
	                _this.isProcessing = false;
	            });
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var _this2 = this;
	
	            this.$watch('isProcessing', function (isProcessing) {
	                if (isProcessing) {
	                    _this2.$element.addClass('processing');
	                } else {
	                    _this2.$element.removeClass('processing');
	                }
	            });
	
	            if (this.flag('fields.expiry') && !this.cardModel.get('expiry_month') || this.flag('fields.cvv') && !this.cardModel.get('security_code') || this.flag('fields.phone') && !(this.phone && this.phone.telephone)) {
	
	                this.showInitScreen = true;
	            } else {
	                this.actions.initOtp();
	            }
	
	            $('#upopConfirmation .modalContainer').focus();
	        }
	    }
	});
	
	
	_squid.$Component;
	
	_util.$fiErrorUtil;
	
	_index.$ResolveOTP;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "./components/xo-ui-components/src/spinner-button/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-ui-components/src/spinner-button/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, template) {
	    return angular.module('xo-spinner-button.directive', []).directive('xoSpinnerButton', function () {
	        return {
	            template: template,
	            scope: {
	                token: '=',
	                track: '@',
	                onClick: '=',
	                buttonText: '@',
	                isProcessing: '=',
	                validate: '='
	            },
	            controller: function controller($scope) {
	
	                $scope.submit = function () {
	                    if ($scope.onClick) {
	                        $scope.onClick();
	                    } else {
	                        $scope.validate = true;
	                    }
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-ui-components/src/spinner-button/template.html":
/***/ (function(module, exports) {

	module.exports = "<div class=\"spinnerBtn\" content>\n    <button track-submit={{track}} ng-click=\"submit()\" class=\"btn full\">\n        <div ng-show=\"isProcessing\" ng-class=\"{processing: isProcessing}\" class=\"spinner\"></div>\n        <div ng-hide=\"isProcessing\" class=\"text\" ng-bind-html=\"htmlContent(buttonText)\"></div>\n    </button>\n</div>\n"

/***/ }),

/***/ "./components/xo-wallet-components/src/confirm-upop/init/template.html":
/***/ (function(module, exports) {

	module.exports = "<div ng-if=\"showInitScreen\" class=\"initOtp\" content>\n    <div class=\"confirmMsg\" ng-bind-html=\"htmlContent(flag('fields.expiry') ? 'confirmUpop.creditInitOtp' : 'confirmUpop.debitInitOtp')\"></div>\n\n    <form id=\"otpForm\" name=\"otpForm\" autocomplete=\"off\" ng-submit=\"otpForm.$valid && actions.initOtp()\" ng-class=\"{true: 'validated'}[validated]\" novalidate>\n        <div class=\"expiration confidential\" id=\"expiration\" ng-if=\"flag('fields.expiry') || flag('fields.cvv')\">\n            <xo-card-expiry ng-if=\"flag('fields.expiry')\" expiry-month=\"cardModel.expiry_month\" expiry-year=\"cardModel.expiry_year\"></xo-card-expiry>\n            <xo-cvv ng-if=\"flag('fields.cvv')\" card=\"cardModel\" show-label=\"true\"></xo-cvv>\n        </div>\n        <xo-phone-input token=\"token\" ng-if=\"flag('fields.phone')\" show-phone-type=\"false\" phone=\"phone\"></xo-phone-input>\n\n        <xo-spinner-button track='init_otp_code' token=\"token\" validate=\"validated\"\n                           is-processing=\"isProcessing\" button-text=\"confirmUpop.btnsendOtpCode\"></xo-spinner-button>\n    </form>\n</div>\n"

/***/ }),

/***/ "./components/xo-wallet-components/src/confirm-upop/confirm/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	
	exports.__esModule = true;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _util = __webpack_require__("./components/xo-wallet-components/src/fi-contingency-list/util.js");
	
	var _index = __webpack_require__("./components/xo-models/src/fi/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/spinner-button/directive.js");
	
	var _template = __webpack_require__("./components/xo-wallet-components/src/confirm-upop/confirm/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var VERIFICATION_CODE_COUNTDOWN_IN_SECS = 180; // 3 minutes
	var RESEND_CODE_LINK_TIMEOUT_MILLI_SECS = 60000; // 1 minute
	var ONE_MINUTE_IN_SECS = 60;
	
	exports['default'] = _squid.$Component.extend('$xoConfirmOtpDirective', {
	    tag: 'xo-confirm-otp',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            type: 'var',
	            required: true
	        },
	        phone: {
	            type: 'var',
	            required: false
	        },
	        cardModel: {
	            type: 'var',
	            required: true
	        },
	        onSuccess: {
	            type: 'var',
	            required: true
	        },
	        message: {
	            type: 'var',
	            required: true
	        },
	        buttonTextKey: {
	            type: 'var',
	            required: false
	        }
	    },
	    actions: {
	        addMessage: function addMessage(type, contentKey) {
	            if (contentKey) {
	                this.message({
	                    msgKeys: [_angular2['default'].isArray(contentKey) ? contentKey[0] : contentKey],
	                    type: type || 'error'
	                });
	            }
	        },
	        stopConfirmCodeTimer: function stopConfirmCodeTimer() {
	            if (this.confirmCodeTimer) {
	                _angular.$interval.cancel(this.confirmCodeTimer);
	            }
	            this.countdown = 0;
	        },
	        stopResendCodeTimer: function stopResendCodeTimer() {
	            if (this.resendCodeTimer) {
	                _angular.$timeout.cancel(this.resendCodeTimer);
	            }
	            this.showResendLink = false;
	        },
	        updateCountdown: function updateCountdown() {
	            if (this.countdown > 0) {
	                this.countdown--;
	                this.timer = Math.floor(this.countdown / ONE_MINUTE_IN_SECS) + ':' + ('0' + this.countdown % ONE_MINUTE_IN_SECS).slice(-2);
	            } else {
	                if (!this.isConfirmProcessing) {
	                    this.actions.addMessage('warning', 'confirmUpop.codeExpired');
	                }
	                this.actions.stopConfirmCodeTimer();
	                this.actions.stopResendCodeTimer();
	            }
	        },
	        startCountdown: function startCountdown(resetTimer) {
	            var _this = this;
	
	            if (resetTimer) {
	                this.actions.stopConfirmCodeTimer();
	                this.countdown = VERIFICATION_CODE_COUNTDOWN_IN_SECS;
	                this.actions.updateCountdown();
	                this.confirmCodeTimer = (0, _angular.$interval)(this.actions.updateCountdown, 1000);
	            }
	
	            this.actions.stopResendCodeTimer();
	            this.showResendLink = false;
	            this.resendCodeTimer = (0, _angular.$timeout)(function () {
	                _this.showResendLink = true;
	            }, RESEND_CODE_LINK_TIMEOUT_MILLI_SECS);
	            this.actions.addMessage('success', 'confirmUpop.codeSent');
	        },
	        processed: function processed() {
	            if (!this.countdown && this.isConfirmProcessing) {
	                this.actions.addMessage('warning', 'confirmUpop.codeExpired');
	            }
	            this.isProcessing = this.isConfirmProcessing = false;
	        },
	        handleContingencies: function handleContingencies() {
	            var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	            var prop = arguments[1];
	
	            var errorData = void 0;
	            if (result.errorCodes) {
	                errorData = result;
	            } else {
	                errorData = {
	                    errorCodes: [result['0'] || 'ISSUER_DECLINE']
	                };
	            }
	
	            this.message(_util.$fiErrorUtil.addPageErrors(errorData, 'confirmUpop', prop, 'error'));
	
	            if (window.scrollTo) {
	                window.scrollTo(0, 0);
	            }
	        },
	        sendNewCode: function sendNewCode() {
	            // reset the code field.
	            if (this.cardModel) {
	                this.cardModel.otp_code = '';
	            }
	            this.actions.resendCode(true);
	        },
	        resendCode: function resendCode(resetTimer) {
	            var _this2 = this;
	
	            this.isProcessing = true;
	
	            this.resolveOTP.action('init', {
	                silent: true,
	                data: {
	                    phone: {
	                        country_code: this.phone.IntDialingCountryCode,
	                        number: this.phone.telephone
	                    }
	                },
	                resultModel: {},
	                success: function success() {
	                    _this2.actions.startCountdown(resetTimer);
	                },
	
	                error: function error() {
	                    _this2.actions.handleContingencies();
	                },
	
	                contingencies: {
	                    INIT_OTP_CONTINGENCY: function INIT_OTP_CONTINGENCY(name, result) {
	                        // prop for last 4 digits of card in error message
	                        var prop = {
	                            number: _this2.cardLast4
	                        };
	
	                        _this2.actions.handleContingencies(result, prop);
	                        _util.$fiErrorUtil.addFieldErrors(result, _this2.$element);
	                    },
	                    DEFAULT: function DEFAULT() {
	                        _this2.actions.handleContingencies();
	                    }
	                }
	            })['finally'](this.actions.processed);
	        },
	        confirmOTP: function confirmOTP() {
	            var _this3 = this;
	
	            this.isProcessing = this.isConfirmProcessing = true;
	
	            this.resolveOTP.action('complete', {
	                silent: true,
	                data: {
	                    code: this.cardModel.otp_code,
	                    phone: {
	                        country_code: this.phone.IntDialingCountryCode,
	                        number: this.phone.telephone
	                    },
	                    card_data: {
	                        expiration_time: {
	                            month: this.cardModel.expiry_month,
	                            year: this.cardModel.expiry_year
	                        },
	                        card_verification_code: this.cardModel.security_code
	                    }
	                },
	
	                success: this.onSuccess,
	
	                error: function error() {
	                    _this3.actions.handleContingencies({}, 'confirmUpop');
	                    _this3.actions.processed();
	                },
	
	                contingencies: {
	                    COMPLETE_OTP_CONTINGENCY: function COMPLETE_OTP_CONTINGENCY(name, result) {
	                        // prop for last 4 digits of card in error message
	                        var prop = {
	                            number: _this3.cardLast4
	                        };
	
	                        _this3.actions.handleContingencies(result, prop);
	                        _util.$fiErrorUtil.addFieldErrors(result, _this3.$element);
	                        _this3.actions.processed();
	                    }
	                }
	            })['catch'](function () {
	                _this3.actions.handleContingencies();
	                _this3.actions.processed();
	            });
	        }
	    },
	    lifecycle: {
	        enter: function enter() {
	            var _this4 = this;
	
	            this.resolveOTP = new _index.$ResolveOTP({ id: this.cardModel.id });
	            this.isProcessing = this.showResendLink = false;
	            this.cardLast4 = this.cardModel.last4();
	            this.phoneLast4 = this.phone && this.phone.telephone && this.phone.telephone.slice(-4);
	            this.actions.startCountdown(true);
	
	            if (!this.buttonTextKey) {
	                this.buttonTextKey = 'common.confirm';
	            }
	
	            this.$watch('isProcessing', function (isProcessing) {
	                if (isProcessing) {
	                    _this4.$element.addClass('processing');
	                } else {
	                    _this4.$element.removeClass('processing');
	                }
	            });
	            $('#upopConfirmation .modalContainer').focus();
	        }
	    }
	});
	
	
	_angular.$interval;
	
	_angular.$timeout;
	
	_squid.$Component;
	
	_util.$fiErrorUtil;
	
	_index.$ResolveOTP;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "./components/xo-wallet-components/src/confirm-upop/confirm/template.html":
/***/ (function(module, exports) {

	module.exports = "<div class=\"confirmOtp\" content>\n    <div class=\"confirmMsg\" ng-bind-html=\"htmlContent('confirmUpop.verificationCodeMsg', {phoneLastFour: phoneLast4})\"></div>\n\n    <div class=\"timer\">\n        <span class=\"left\">{{content('confirmUpop.timeRemaining')}}</span>\n        <span class=\"timeLeft\">{{timer}} {{content('confirmUpop.minutes')}}</span>\n        <a link-button class=\"resendLink right focusableIcon\" href=\"\" ng-if=\"showResendLink\" ng-click=\"actions.resendCode(false)\">{{content('confirmUpop.resendCode')}}</a>\n    </div>\n\n    <form id=\"otpForm\" name=\"otpForm\" autocomplete=\"off\" ng-submit=\"otpForm.$valid && actions.confirmOTP()\" ng-class=\"{true: 'validated'}[validated]\" novalidate>\n\n        <div class=\"confirmFields\" ng-show=\"countdown || isConfirmProcessing\">\n            <div class=\"inputField confidential\">\n                <input id=\"otp_code\"\n                       class=\"otp_code\"\n                       type=\"tel\"\n                       ng-model=\"cardModel.otp_code\"\n                       name=\"otp_code\"\n                       value=\"\"\n                       placeholder=\"{{ content('confirmUpop.verificationCodeHint') }}\"\n                       autocapitalize=\"off\"\n                       autocomplete=\"off\"\n                       aria-required=\"false\"\n                       required\n                       scroll-to-top\n                       data-error-key=\"confirmUpop.fieldInvalidOTP\"\n                       xo-error-tooltip/>\n\n            </div>\n            <xo-spinner-button track='confirm_otp_code' token=\"token\" validate=\"validated\"\n                               is-processing=\"isProcessing\" button-text=\"{{buttonTextKey}}\"></xo-spinner-button>\n        </div>\n    </form>\n    <div class=\"sendNewOtp\">\n        <xo-spinner-button ng-if=\"!countdown && !isConfirmProcessing\" track='resend_otp_code' token=\"token\" on-click=\"actions.sendNewCode\"\n                           is-processing=\"isProcessing\" button-text=\"confirmUpop.btnResendCode\"></xo-spinner-button>\n    </div>\n</div>\n"

/***/ }),

/***/ "./components/xo-wallet-components/src/confirm-upop/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-wallet-components/src/confirm-upop/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-wallet-components/src/confirm-upop/styles.less":
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "blockquote,body,code,dd,div,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,html,input,legend,li,ol,p,pre,td,textarea,th,ul{margin:0;padding:0}table{border-collapse:collapse;border-spacing:0}fieldset,img{border:0}address,caption,cite,code,dfn,em,strong,th,var{font-style:normal;font-weight:400}ol,ul{list-style:none}caption,th{text-align:left}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:400}q:after,q:before{content:\"\"}abbr,acronym{border:0;font-variant:normal}sup{vertical-align:text-top}sub{vertical-align:text-bottom}input,select,textarea{font-family:inherit;font-size:inherit;font-weight:inherit;font-size:100%}legend{color:#000}body{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:95%;color:#2c2e2f;line-height:1.35em}h1{font-size:138.5%}h2{font-size:123.1%}h3{font-size:108%}h1,h2,h3{margin:1em 0}h1,h2,h3,h4,h5,h6,strong{font-weight:700}a{color:#0070ba}abbr,acronym{border-bottom:1px dotted #000;cursor:help}em{font-style:italic}blockquote,dl,ol,ul{margin:1em}dl,ol,ul{margin-left:2em}ol{list-style:decimal outside}ul{list-style:disc outside}dl dd{margin-left:1em}td,th{border:1px solid #000;padding:.5em}th{font-weight:700;text-align:center}input{margin-bottom:10px}caption{margin-bottom:.5em;text-align:center}fieldset,legend,p,pre,table{margin-bottom:1em}input[type=password],input[type=text],textarea{width:12.25em;*width:11.9em}.row-fluid{width:100%;*zoom:1}.row-fluid:after,.row-fluid:before{display:table;content:\"\"}.row-fluid:after{clear:both}.row-fluid>[class*=span]{float:left;margin-left:4.12765957%}.row-fluid>[class*=span]:first-child{margin-left:0}.row-fluid>.span24{width:99.99999998%}.row-fluid>.span23{width:95.74468083%}.row-fluid>.span22{width:91.48936168%}.row-fluid>.span21{width:87.23404253%}.row-fluid>.span20{width:82.97872339%}.row-fluid>.span19{width:78.72340424%}.row-fluid>.span18{width:74.46808509%}.row-fluid>.span17{width:70.21276594%}.row-fluid>.span16{width:65.95744679%}.row-fluid>.span15{width:61.70212765%}.row-fluid>.span14{width:54.4468085%}.row-fluid>.span13{width:53.19148935%}.row-fluid>.span12{width:48.9361702%}.row-fluid>.span11{width:44.68085105%}.row-fluid>.span10{width:40.42553191%}.row-fluid>.span9{width:36.17021276%}.row-fluid>.span8{width:31.91489361%}.row-fluid>.span7{width:27.65957446%}.row-fluid>.span6{width:23.40425531%}.row-fluid>.span5{width:19.14893617%}.row-fluid>.span4{width:14.89361702%}.row-fluid>.span3{width:10.63829787%}.row-fluid>.span2{width:6.38297872%}.row-fluid>.span1{width:2.12765957%}.container-fluid{padding-left:20px;padding-right:20px;*zoom:1}.container-fluid:after,.container-fluid:before{display:table;content:\"\"}.container-fluid:after{clear:both}.mt10,.mt15{margin-top:10px}.pt10{padding-top:10px}.pt15{padding-top:15px}.mb10{margin-bottom:10px}.mb15{margin-bottom:15px}.pb10{padding-bottom:10px}.pb15{padding-bottom:15px}.ml10{margin-left:10px}.ml15{margin-left:15px}.pl10{padding-left:10px}.pl15{padding-left:15px}.mr10{margin-right:10px}.mr15{margin-right:15px}.pr10{padding-right:10px}.pr15{padding-right:15px}.btn{height:44px;margin-bottom:0;border:1px solid #0070ba;border-radius:5px;*margin-left:.3em;display:inline-block;*display:inline;*zoom:1;background-color:#0070ba;transition:background-color .4s ease-out 0s;font-size:1em;font-weight:700;line-height:42px;color:#fff;text-align:center;vertical-align:middle;cursor:pointer;outline:none;-webkit-font-smoothing:antialiased}.btn .btn-secondary{-webkit-font-smoothing:auto}.btn:focus,.btn:hover{background-color:#005ea6}.btn:focus{text-decoration:underline}.btn.active,.btn:active{background-color:#005ea6;outline:0}.btn.disabled,.btn[disabled]{background-color:#b2d9ea;border-color:#b2d9ea;cursor:default}.btn.firstHalf{float:left}.btn.firstHalf,.btn.secondHalf{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box}.btn.secondHalf{float:right}a.btn:focus,a.btn:hover{color:#fff}.btn:first-child{*margin-left:0}.btn-large{padding:8px 15px;font-size:18px;line-height:normal;border-radius:5px}.btn-small{padding:5px 9px;font-size:11px;line-height:16px}.btn-mini{padding:2px 6px;font-size:11px;line-height:14px}.btn-secondary{border-style:solid;border-color:#e1e7eb;color:#393f44;background-color:#e1e7eb}.btn-secondary:hover{color:#393f44;border-color:#edf2f5;background-color:#edf2f5;text-decoration:none}.btn-secondary:active,.btn-secondary:focus{border-color:#c5ccd1;background-color:#c5ccd1;text-decoration:underline}.btn-secondary.disabled,.btn-secondary[disabled]{color:#393f55}a.btn-secondary:active,a.btn-secondary:focus,a.btn-secondary:hover{color:#393f44;border-color:#c5ccd1;background-color:#c5ccd1}a.btn-secondary.disabled,a.btn-secondary[disabled]{color:#393f55;background-color:#e7edf0}button.btn,input[type=submit].btn{*padding-top:2px;*padding-bottom:2px}button.btn::-moz-focus-inner,input[type=submit].btn::-moz-focus-inner{padding:0;border:0}button.btn.btn-large,input[type=submit].btn.btn-large{*padding-top:7px;*padding-bottom:7px}button.btn.btn-small,input[type=submit].btn.btn-small{*padding-top:3px;*padding-bottom:3px}button.btn.btn-mini,input[type=submit].btn.btn-mini{*padding-top:1px;*padding-bottom:1px}#largeScreenAccountCreation .buttons #backButton,section .buttons #backButton{width:30%}#largeScreenAccountCreation .buttons #proceedButton,section .buttons #proceedButton{width:65%}#largeScreenAccountCreation .buttons #proceedButton-venmoBA,#largeScreenAccountCreation .buttons #proceedButton.full,section .buttons #proceedButton-venmoBA,section .buttons #proceedButton.full{width:100%}.custom-select-container,select.replaced{position:relative}select.replaced{z-index:8;width:100%;height:44px;border:0;line-height:2;opacity:0;filter:alpha(opacity=0)}.custom-select{position:absolute;top:0;left:0;z-index:1;width:100%;transition:border-color .3s ease 0s;border-radius:5px}.custom-select,.custom-select>span{display:block;background-clip:padding-box}.custom-select>span{padding:7px 30px 7px 13px;border:1px solid #ccd0d4;border-radius:5px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:right -7px top -1178px;color:#000;line-height:28px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.disabled .custom-select>span{background-position:right -7px top -6990px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat right 10px center;background-size:16px;color:#c72e2e;border:1px solid #c72e2e}.custom-select span span{display:block;overflow:hidden;height:28px;text-overflow:ellipsis;white-space:nowrap;font-size:1em}.custom-select.active>span{border:1px solid #009cde;outline:0}#task .custom-select{border-radius:5px;background-clip:padding-box}.mobile .dob label{position:static;top:0;left:0}input[type=date]{padding:5px 38px 3px 6px;border:1px solid #ccd0d4;border-radius:5px;background-clip:padding-box;color:#333;background-size:24px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_cart_icons.png\") no-repeat 100% 61%}input[type=date]:focus{border-color:#39f}.showDropdopwnLabels .labelText{float:left;color:#aaa}.showDropdopwnLabels .valueText{float:right;min-width:90px}@media (min-width:0) and (max-width:40em){.showDropdopwnLabels .labelText{display:none}.showDropdopwnLabels .valueText{float:none;min-width:0}}.multiline-select-container{outline:0 none}.multiline-select-container:active .innerContainer,.multiline-select-container:focus .innerContainer{border-color:#009cde}.multiline-select-container.open:active .innerContainer,.multiline-select-container.open:focus .innerContainer{border-color:#ccd0d4}.multiline-select-container option,.multiline-select-container select{position:absolute!important;left:-9999px}.multiline-select-container .custom-select{position:relative}.multiline-select-container .custom-select span span{height:auto;white-space:normal}.multiline-select-container .custom-select>span{background:none}.multiline-select-container.open .custom-select>span{border-radius:5px 5px 0 0;border-bottom-color:#eee}.multiline-select-container .arrow{background-clip:padding-box;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_forms.png\");background-position:left -8px top -1198px;background-repeat:no-repeat;height:10px;position:absolute;width:14px;top:40%;right:12px}.backendError .multiline-select-container .ng-invalid+.custom-select .arrow,.validated .multiline-select-container .ng-invalid+.custom-select .arrow{display:none}.multiline-select-list{position:absolute;list-style:none;margin:0;background-color:#fff;z-index:1000;border-radius:0 0 5px 5px;border-bottom:1px solid #ccd0d4;max-height:200px;overflow:auto;box-shadow:0 -1px 1px 0 #ccc}.multiline-select-list li{padding:10px;border:1px solid;border-color:#eee #ccd0d4;border-top:0 none;cursor:pointer;line-height:1.35em;vertical-align:middle}.multiline-select-list li:active,.multiline-select-list li:focus,.multiline-select-list li:hover{background-color:#e5f5fc;outline:0 none}.multiline-select-list li:first-of-type{border-top:0 none}.multiline-select-list li:last-of-type{border-bottom:0 none}.multiline-select-list:hover li:focus{background-color:#fff}.multiline-select-list:hover li:focus:active,.multiline-select-list:hover li:focus:hover{background-color:#e5f5fc}#midflash,.accessAid{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}body{-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#fff}a{text-decoration:none;-webkit-tap-highlight-color:rgba(0,0,0,.2)}a:focus,a:hover{color:#005ea6;text-decoration:underline;outline:none}a.dashed{text-decoration:none;border-bottom:1px dashed #0070ba;font-size:.9em}[tabindex=\"-1\"]{outline:none}em{font-style:normal;font-weight:700}fieldset{margin:0;padding:0;border:0}fieldset legend{padding-bottom:.5em;font-size:1.5em}section:focus{outline:none}.show-section{display:block}hr.faded{width:100%;height:1px;margin:10px 0;border:0;background-image:-o-linear-gradient(left,transparent,rgba(0,0,0,.75),transparent)}.alpha{font-size:1.5em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin:.5em 0;line-height:1.154em}#loginSection h1.alpha{max-width:240px}.asideAlpha{font-size:1.44em}aside .aside .header.noButtons .walletHeading{text-align:center;line-height:1.05em}.beta{font-size:1.54em;color:#2c2e2f;font-weight:lighter;line-height:1.2em}.gamma{font-size:1.3em}.gamma,.zeta{font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin-bottom:.75em}.zeta{font-size:1.25em}.delta{font-size:1.1em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;margin-bottom:12px;font-weight:400}.vprop-header{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin:10px 0;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.vprop-content,.vprop-header{color:#2c2e2f;font-weight:lighter;line-height:1.2em}.vprop-content{font-size:1em;font-family:HelveticaNeue,helvetica,arial,sans-serif}.vprop-image{margin-top:25px}.eta{font-size:1.1em}.eta,.theta{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400}.theta{font-size:1em}.value-prop-title{color:#2c2e2f;font-size:24px;font-weight:lighter;margin:10px 0}.props{padding:0 0 0 5px;clear:both;text-align:center}.props li,.props p{line-height:1.154em;font-size:.9em;font-weight:400;line-height:1.2em;margin:5px 0}.secondary{color:#6c7378;font-size:.85em}.legal{color:#6c7378;font-size:.75em;line-height:1.154em}.legal a{font-weight:700}.mu{font-size:2.46em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-weight:400;text-shadow:0 1px 0 #fff;color:#0079c1}.noHead{margin-top:0}.noBottom{margin-bottom:0}.showTray #task{overflow:hidden;margin-left:0}#spinner,.hide{display:none}.clearfix,.loading #spinner,.media .img img,html[xmlns] .clearfix{display:block}#billingToggleLink{display:inline-block}.left{float:left}.right{float:right}.center{text-align:center}.outerWrapper{position:relative;border-radius:5px;background-clip:padding-box;background-color:#fff}header{z-index:2}.framed #wrapper,html.framed{border-radius:5px;background-clip:padding-box}html.framed .trayOpen #main{height:585px}html.framed .trayOpen .asideContent{height:495px}body>iframe,body>img{display:none}#wrapper{margin:0 auto;max-width:780px;border:1px solid #e3e3e3;border-radius:5px;overflow-y:visible;outline:none}#wrapper,#wrapper #header{-ms-box-sizing:border-box;box-sizing:border-box;background-clip:padding-box;position:relative;background-color:#fff}#wrapper #header{border-radius:5px 5px 0 0;width:100%;z-index:4;box-shadow:0 0 3px 0}#contents{position:relative;z-index:1}.active #wrapper{visibility:visible;-webkit-animation-duration:.4s;-webkit-animation-timing-function:ease;-webkit-animation-name:slideUp}#logo{margin:22px 0 0 20px}.container{clear:both;padding:20px}.containerNoHead{padding-top:0}.noPaddingBottom{padding-bottom:0}.noPaddingTop{padding-top:0}.subContainer{border-top:1px solid #e3e3e3;padding:20px 0;position:relative}#proceedButton{width:46.4%;-ms-box-sizing:border-box;box-sizing:border-box;float:right}#proceedButton.full{width:100%}#proceedButton:focus{color:#fff}#backButton{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box;float:left}#backButton:focus,#backButton:hover{color:#2c2e2f}.middleName{display:none;float:right}.h2,h2{font-size:1.2em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin-top:0;font-weight:400;color:#0666b3}.clearfix:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}* html .clearfix{height:1%}#sliding-area{overflow:hidden}#main{padding:25px 30px 15px;transition:margin .3s ease-out;width:100%;float:right;-ms-box-sizing:border-box;box-sizing:border-box}.loading #main{background:none}.bmlLoadingMessage,.loginLoadingMessage,.loginProcessing .genericLoadingMessage{display:none}.loginProcessing .loginLoadingMessage{display:block}.full{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;text-decoration:none}.trayInner{padding:20px 0}.disclaimer{font-size:.75em;color:#6c7378}.reviewMsg{margin-top:10px;line-height:1.5}.infoTxt{clear:both;padding-top:10px}.help{color:#a9a9a9}.keyValue label{color:#292929}.frontArrow{position:absolute;display:inline-block;width:9px;height:15px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-196px -177px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.frontArrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.focusableIcon:focus{box-shadow:0 0 1px #6c7378}input[type=button],input[type=submit]{-webkit-appearance:none}.inputField input[disabled=disabled],.inputField input[disabled=disabled]:active,input[disabled=disabled]{background:#f7f9fa;border:1px solid #cbd2d6;color:#6c7378}input::-ms-clear{display:none}input.link:hover{cursor:pointer}input.xsmall{width:2em}input.small{width:3.35em;font-size:1em}input.medium{width:7em}input.large{width:14em}input.xlarge{width:20em}.button-as-link{margin:0;padding:0;border:none;width:auto;font-size:.85em;background:transparent;color:#0070ba;cursor:pointer}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.buttons{margin-top:15px;margin-bottom:15px;overflow:hidden}.inputField{position:relative}.inputField input,.inputField label{display:block;vertical-align:top}.ignoreValidation .inputField.error input,.inputField input,.validated .ignoreValidation .inputField input.backendError,.validated .ignoreValidation .inputField input.ng-invalid{width:100%;height:44px;padding:0 14px;border-radius:5px;background-clip:padding-box;border:1px solid #c5ccd1;color:#000;transition:border-color .3s ease 0s;-ms-box-sizing:border-box;box-sizing:border-box;background:none}.ignoreValidation .inputField.error input::-webkit-input-placeholder,.inputField input::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.backendError::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-webkit-input-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-moz-placeholder,.ignoreValidation .inputField.error input::-moz-placeholder,.inputField input:-moz-placeholder,.inputField input::-moz-placeholder,.validated .ignoreValidation .inputField input.backendError:-moz-placeholder,.validated .ignoreValidation .inputField input.backendError::-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-moz-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-ms-input-placeholder,.inputField input:-ms-input-placeholder,.validated .ignoreValidation .inputField input.backendError:-ms-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-ms-input-placeholder{color:#6c7378}.inputField input:active,.inputField input:focus{border:1px solid #009cde;outline:0}.inputField select{font-size:1.5em;margin-bottom:10px}.custom-select-container select{font-size:15px}.inputField label{position:absolute;top:14px;left:14px;cursor:text;text-align:left;color:#666;font-size:1em}.no-js .dropdown label,.no-js .inputField label{position:static}.fieldGroup .inputField{float:left;padding:0 .5em 0 0}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.inputField.error input::-webkit-input-placeholder,.validated .inputField input.backendError::-webkit-input-placeholder,.validated .inputField input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.inputField.error input:-moz-placeholder,.inputField.error input::-moz-placeholder,.validated .inputField input.backendError:-moz-placeholder,.validated .inputField input.backendError::-moz-placeholder,.validated .inputField input.ng-invalid:-moz-placeholder,.validated .inputField input.ng-invalid::-moz-placeholder{color:#c72e2e}.inputField.error input:-ms-input-placeholder,.validated .inputField input.backendError:-ms-input-placeholder,.validated .inputField input.ng-invalid:-ms-input-placeholder{color:#c72e2e}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}.inputField.valid input{background:#fff url(https://www.paypalobjects.com/images/checkout/hermes/icon_checkmark_wallet_2x.png) no-repeat 98%;background-size:14px}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.creditCardField.valid input{background:#fff}.dropdown.error select,.inputField.error select{border:1px solid #c72e2e}.selectLabel{display:block}input::-webkit-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:1em}input:-moz-placeholder,input::-moz-placeholder{color:#6c7378;opacity:1;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}input:-ms-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.checkbox input[type=checkbox]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.checkbox input[type=checkbox]~label,.checkbox input[type=checkbox]~label.bgImgOnSpan span.bgImg{display:inline-block;position:static;min-height:25px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px 0;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.checkbox input[type=checkbox]~label,.checkbox input[type=checkbox]~label.bgImgOnSpan span.bgImg{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.checkbox input[type=checkbox]~label.bgImgOnSpan span.bgImg{display:block;float:left;width:0;height:25px;margin-left:-35px}.checkbox input[type=checkbox]~label.bgImgOnSpan{background-image:none}.checkbox.error input[type=checkbox]:focus~label,.checkbox.error input[type=checkbox]:focus~label.bgImgOnSpan span.bgImg,.checkbox.error input[type=checkbox]~label,.checkbox.error input[type=checkbox]~label.bgImgOnSpan span.bgImg{background-position:-9px -600px}.checkbox input[type=checkbox]:checked~label,.checkbox input[type=checkbox]:checked~label.bgImgOnSpan span.bgImg{background-position:-9px -400px}.checkbox input[type=checkbox]:focus:checked~label,.checkbox input[type=checkbox]:focus:checked~label.bgImgOnSpan span.bgImg{background-position:-9px -4801px}.checkbox input[type=checkbox]:focus~label,.checkbox input[type=checkbox]:focus~label.bgImgOnSpan span.bgImg{background-position:-9px -4601px}.checkbox input[type=checkbox][disabled=disabled]~label,.checkbox input[type=checkbox][disabled=disabled]~label.bgImgOnSpan span.bgImg{background-position:-9px -800px}.checkbox input[type=checkbox][disabled=disabled]:checked~label,.checkbox input[type=checkbox][disabled=disabled]:checked~label.bgImgOnSpan span.bgImg{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:25px 25px}.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label.bgImgOnSpan span.bgImg,.validated .ignoreValidation input[type=checkbox].ng-invalid~label,.validated .ignoreValidation input[type=checkbox].ng-invalid~label.bgImgOnSpan span.bgImg{background-position:-9px 0}.validated .ignoreValidation .sCheckbox.checkbox input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation .sCheckbox.checkbox input[type=checkbox].ng-invalid:focus~label.bgImgOnSpan span.bgImg,.validated .ignoreValidation .sCheckbox.checkbox input[type=checkbox].ng-invalid~label,.validated .ignoreValidation .sCheckbox.checkbox input[type=checkbox].ng-invalid~label.bgImgOnSpan span.bgImg{background-position:-9px 2600px}.validated input[type=checkbox].ng-invalid~label,.validated input[type=checkbox].ng-invalid~label.bgImgOnSpan span.bgImg{background-position:-9px -600px}.validated input[type=radio].ng-invalid+label,.validated input[type=radio].ng-invalid+label.bgImgOnSpan span.bgImg,.validated input[type=radio].ng-invalid:focus+label,.validated input[type=radio].ng-invalid:focus+label.bgImgOnSpan span.bgImg{background-position:-10px -2200px}.validated .sCheckbox.checkbox input[type=checkbox].ng-invalid~label,.validated .sCheckbox.checkbox input[type=checkbox].ng-invalid~label.bgImgOnSpan span.bgImg{background-position:-9px -3200px}.sCheckbox.checkbox{position:relative}.sCheckbox.checkbox input[type=checkbox]~label,.sCheckbox.checkbox input[type=checkbox]~label.bgImgOnSpan span.bgImg{line-height:19px;padding-left:27px;font-size:.85em;background-position:-9px -2600px}.sCheckbox.checkbox input[type=checkbox]~label.bgImgOnSpan span.bgImg{display:block;float:left;width:0;height:19px;margin-left:-27px}.sCheckbox.checkbox input[type=checkbox]~label.bgImgOnSpan{background-image:none}.sCheckbox.checkbox.error input[type=checkbox]:focus~label,.sCheckbox.checkbox.error input[type=checkbox]:focus~label.bgImgOnSpan span.bgImg,.sCheckbox.checkbox.error input[type=checkbox]~label,.sCheckbox.checkbox.error input[type=checkbox]~label.bgImgOnSpan span.bgImg{background-position:-9px -3200px}.sCheckbox.checkbox input[type=checkbox]:checked~label,.sCheckbox.checkbox input[type=checkbox]:checked~label.bgImgOnSpan span.bgImg{background-position:-9px -3000px}.sCheckbox.checkbox input[type=checkbox]:focus:checked~label,.sCheckbox.checkbox input[type=checkbox]:focus:checked~label.bgImgOnSpan span.bgImg{background-position:-9px -5409px}.sCheckbox.checkbox input[type=checkbox]:focus~label,.sCheckbox.checkbox input[type=checkbox]:focus~label.bgImgOnSpan span.bgImg{background-position:-9px -2800px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]~label,.sCheckbox.checkbox input[type=checkbox][disabled=disabled]~label.bgImgOnSpan span.bgImg{background-position:-9px -3400px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]:checked~label,.sCheckbox.checkbox input[type=checkbox][disabled=disabled]:checked~label.bgImgOnSpan span.bgImg{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:18px 19px}.radioButton input[type=radio]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.radioButton input[type=radio]~label{display:inline-block;min-height:26px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px -1600px;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.radioButton input[type=radio]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.radioButton.error input[type=radio]+label,.radioButton.error input[type=radio]:focus+label{background-position:-9px -2200px}.radioButton.warning input[type=radio]+label,.radioButton.warning input[type=radio]:focus+label{background-position:-9px -7405px}.radioButton input[type=radio]:checked+label{background-position:-9px -2000px}.radioButton input[type=radio]:focus:checked+label{background-position:-9px -6010px}.radioButton input[type=radio]:focus+label{background-position:-9px -1800px}.inputField label.nolap{position:relative;top:auto;left:auto;color:#2c2e2f}.inputField.half{width:48.15%;margin-right:3.7%;padding-right:0}.multistepSignupForm .inputField.half,.singlePagePaymentForm .inputField.half{width:48.7%;margin-right:2.6%;padding-right:0}.inputField.half.issueNo{width:42%;margin-top:15px}.inputField.half.startDate{width:54%;margin-right:10px}#cardIssueInfo .inputField.half.startDate{width:48%;margin-right:0}#cardIssueInfo .inputField.half.issueNo{width:48%;margin-top:0;float:right}#cardIssueInfo .inputField.half.issueNo:before{content:\"\\200C\"}.inputField.half.last-child{margin-right:0}.fieldGroup .inputField.last-child{padding-right:0}.fidobDay{width:30%;float:left}.fidobDay .custom-select>span{border-radius:5px 0 0 5px;border-right:0}.fidobMonth{width:30%;float:left}.fidobMonth .custom-select>span{border-radius:0}.fidobYear{width:40%;float:left}.fidobYear .custom-select>span{border-radius:0 5px 5px 0;border-left:0}.cardDOB{width:100%;clear:both}.dobLabel{top:auto;left:auto;position:relative;display:block;bottom:4px}.dobTXT{margin-top:10px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}}.submitted input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.submitted input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.submitted input.ng-invalid:-moz-placeholder,.submitted input.ng-invalid::-moz-placeholder{color:#c72e2e}.submitted input.ng-invalid:-ms-input-placeholder{color:#c72e2e}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.submitted input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}.merchantHeader{height:90px;margin:0 auto}.merchantHeader .headerWrapper{max-width:780px;margin:0 auto;overflow:hidden;max-height:90px;line-height:90px}.merchantHeader .merchantName{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400;width:575px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block}.merchantHeader img{vertical-align:middle}.paypalHeaderWrapper .logo{float:left;width:112px;height:29px;margin-top:5px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.paypalHeaderWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.paypalHeaderWrapper .span14{padding-bottom:20px;border-bottom:1px solid #dbdbdb}.paypalHeaderWrapper .cartContainer{position:static;line-height:29px}.paypalHeaderWrapper .transctionCartDetails{z-index:2}.paypalHeaderWrapper.paypalCredit .logo{height:35px;background-position:0 -129px}.aside .header{padding:15px;vertical-align:middle;line-height:50px;border-bottom:1px solid #e3e3e3}.aside .header.tall{min-height:65px;line-height:normal;padding:13px 15px 10px;margin-bottom:0}.aside .asideAlpha{padding:0 30px;text-align:center;line-height:1.2em}.aside .walletHeading{text-align:center}.aside .close{top:10px;right:15px;padding:5px;border-radius:3px}.aside .close,.aside .close:before{position:absolute;width:19px;height:19px}.aside .close:before{content:\"\";display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .close:focus:before,.aside .close:hover:before{background-position:-223px -22px}.aside .backArrow{position:absolute;top:10px;left:15px;width:9px;height:18px;padding:5px;border-radius:3px}.aside .backArrow:before{content:\"\";display:inline-block;position:absolute;width:9px;height:18px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -46px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .backArrow:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .backArrow:focus:before,.aside .backArrow:hover:before{background-position:-232px -68px}.aside .addOptions{margin-top:20px}.aside .addOptions h2{float:left;width:70%;margin-bottom:0}.aside .addOptions a{float:right;display:block;line-height:1.9em;font-size:.85em}.aside .subHeader{margin-top:20px}.CYCOPage .paypalHeader.span14,.pageSepaAgreementContingency .paypalHeader.span14,.pageSepaMandate .paypalHeader.span14,.pageSepaMandateContingency .paypalHeader.span14{width:100%}#mobileMerchantHeader{display:none}@media (max-width:41.3125em){.merchantHeader{display:none}.paypalHeaderWrapper{height:65px}.paypalHeaderWrapper .cartContainer{margin-top:10px;margin-bottom:-5px;margin-right:15px}.paypalHeaderWrapper .logo{margin:15px 0 0 30px}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}}@media (max-width:30em) and (min-width:0){.paypalHeaderWrapper .cartContainer{margin-top:15px;margin-bottom:-10px;margin-right:0}.paypalHeaderWrapper .logo{margin:15px 0 0}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}.header{height:55px}.aside .header{height:auto}.aside .close{right:15px}}.footer{max-width:780px;margin:10px auto;font-size:.75em}.cancelUrl{float:left;width:39%}.micaLender{display:none;color:#2c2e2f;clear:both}.footerWrapper table{display:inline;float:left;table-layout:fixed;border:none;width:75%}.footerWrapper td,.footerWrapper th,.footerWrapper tr{border:none;font-weight:400;padding-bottom:0;padding-top:0;text-align:left}.footerWrapper .footerLinks th{color:#6c7378}.footerWrapper .footerLinks th.feedbackLink{color:#0070ba}.footerWrapper .footerLinks .underline th{border-bottom:1px solid #ccc}.footerLinks{margin:0;display:inline-block}.footerLinks a{color:#6c7378}.footerLinks a.feedbackLink{color:#0070ba;margin-left:5px}.footerLinks th,td{border:none}.copyright{display:inline;width:auto;vertical-align:top;color:#6c7378}.secureIcon{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:0 -33px;margin-left:3px;margin-right:3px;margin-top:3px;width:10px;height:12px;vertical-align:top}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.secureIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.poweredBy{float:right;margin-top:-49px}.poweredBy .text{float:left;margin-top:8px;margin-right:8px;font-size:12px;font-weight:400;font-style:italic;color:#6c7378}.footerLinks li{padding:0 12px 0 0;display:inline-block}.footerLinks .last{padding-right:18px;border-right:none}.footer .policyInfoWrapper p{line-height:1.3em}.footer .policyInfoWrapper p a{font-weight:700}.minibrowser .APAC.footer,.minibrowser.AU .footer{position:relative;bottom:0;width:auto}.minibrowser .APAC.footer .policyInfoWrapper,.minibrowser.AU .footer .policyInfoWrapper{padding:0}.minibrowser .cancelUrl{display:none}.minibrowser .footerWrapper{padding:0 10px;float:none;width:95%;margin:0}.minibrowser .footerLinks li{padding:0 5px 0 0}.DE .footerWrapper,.fr.CA .footerWrapper,.fr.FR .footerWrapper{float:none;width:auto}.DE .footerWrapper:after,.fr.CA .footerWrapper:after,.fr.FR .footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.DE .footerLinks,.fr.CA .footerLinks,.fr.FR .footerLinks{float:left;width:70%;text-align:left}.DE .footerLinks li:first-child,.fr.CA .footerLinks li:first-child,.fr.FR .footerLinks li:first-child{padding-left:0}.DE .copyright,.fr.CA .copyright,.fr.FR .copyright{float:right;width:30%;margin:0}.DE .cancelUrl,.fr.CA .cancelUrl,.fr.FR .cancelUrl{float:none;margin:5px 0;width:100%}.APAC .policyInfoWrapper{padding:5px 0 10px;color:#6c7378}.APAC .policyInfoWrapper p.moreInfo{padding:15px 0 20px;float:left;line-height:1.3em}.AU .policyInfoWrapper,.en_AU .policyInfoWrapper{padding:20px 0 10px;color:#6c7378}.AU .policyInfoWrapper p.moreInfo,.en_AU .policyInfoWrapper p.moreInfo{padding:15px 0 20px;border-bottom:1px solid #ccc;float:left}.AU .policyInfoWrapper p.moreCopyRight,.en_AU .policyInfoWrapper p.moreCopyRight{padding:5px 0 0;clear:both}.fr_XC .footerWrapper{float:left;width:70%;text-align:left;padding-left:0;margin-left:-7px}@media (max-width:41.25em){.footer{border-top:1px solid #ccc;padding:5px 20px;margin-top:10px}.footer .policyInfoWrapper{padding:0 10px}.footerWrapper{float:none;width:100%;padding:0;margin:0}.footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.cancelUrl{width:95%;padding:0}.footerLinks{float:left;width:70%;text-align:left}.footerLinks .feedback{display:none}.minibrowser .footerLinks .feedback{display:inline-block}.copyright{width:20%}.cancelUrl{float:none;margin:5px 0}}@media (max-width:30em) and (min-width:0){.footer{margin-top:0;padding:5px 10px}.footer .policyInfoWrapper{padding:0}.cancelUrl,.footerWrapper{padding:0;margin:5px 0;width:100%}.DE .footerLinks,.footerLinks,.fr.FR .footerLinks{width:65%}.DE .footerLinks li,.footerLinks li,.fr.FR .footerLinks li{padding:0;margin-right:10px}.DE .footerLinks li.last,.footerLinks li.last,.fr.FR .footerLinks li.last{margin-right:0}.DE .footerLinks .feedback,.footerLinks .feedback,.fr.FR .footerLinks .feedback{display:none}.copyright,.DE .copyright{width:33%;margin:0}.minibrowser .copyright{margin-right:0;width:30%}.minibrowser .footerLinks .feedback{display:inline-block}}.modal-open{overflow:hidden}.modal-open #contents,.modal-open #wrapper,.modal-open .outerWrapper{position:static}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:140;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop,.modal-backdrop.fade.in{opacity:.54}.modal{display:none;overflow:auto;overflow-y:scroll;position:fixed;top:0;right:0;bottom:0;left:0;z-index:150}.modal.fade .modal-wrap{-webkit-transform:translateY(-25%);transform:translateY(-25%);transition:transform .3s ease-out}.modal.fade.in .modal-wrap{-webkit-transform:translate(0);transform:translate(0)}.modal-wrap{position:relative;margin:10px;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.3);border-radius:6px;background-clip:padding-box;box-shadow:0 3px 9px rgba(0,0,0,.3);outline:none}.modal-header{padding:9px 15px;border-bottom:1px solid #eee}.modal-header .close{margin-top:2px}.modal-header h3{margin:0;line-height:30px}.modal-body{position:relative;overflow-y:auto;max-height:400px;padding:15px}.modal-footer,.modal-form{margin-bottom:0}.modal-footer{padding:14px 15px 15px;text-align:right;background-color:#f5f5f5;border-top:1px solid #ddd;border-radius:0 0 6px 6px;background-clip:padding-box;box-shadow:inset 0 1px 0 #fff}.modal-footer:after,.modal-footer:before{display:table;content:\"\";line-height:0}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.spinner{height:100%;width:100%;position:absolute;z-index:10}.spinner .spinWrap{width:200px;height:100px;position:absolute;top:50%;left:50%;margin-left:-100px;margin-top:-50px}.spinner .spinnerImage{margin:28px 0 0 -25px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/icon_ot_spin_lock_skinny.png\") no-repeat}.spinner .loader,.spinner .spinnerImage{height:100px;width:100px;position:absolute;top:0;left:50%;opacity:1;filter:alpha(opacity=100)}.spinner .loader{margin:0 0 0 -55px;background-color:transparent;-webkit-animation:rotation .7s infinite linear;animation:rotation .7s infinite linear;border-left:5px solid #cbcbca;border-right:5px solid #cbcbca;border-bottom:5px solid #cbcbca;border-top:5px solid #2380be;border-radius:100%}.spinner .bmlLoadingMessage,.spinner .genericLoadingMessage,.spinner .loginLoadingMessage{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;margin-top:125px;text-align:center;z-index:100}.spinner.preloader{position:fixed;top:0;left:0;z-index:1000;background-color:#fff}@-webkit-keyframes rotation{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(359deg)}}@keyframes rotation{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.aside{min-height:380px}.aside .container{padding:15px}.asideContent{height:100%}.centerText{text-align:center}.fsIcons{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;min-width:32px;width:25px;height:21px;padding-right:5px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.BALANCE .fsIcons,.DELAYED_TRANSFER .fsIcons,.HOLDING .fsIcons{background-position:0 0}.ELO .fsIcons{background-position:0 -479px}.HIPER .fsIcons{background-position:0 -458px}.HIPERCARD .fsIcons{background-position:0 -500px}.pinlessGlyphIcon{display:inline-block;position:relative;top:-5px;left:-8px;width:32px;height:20px;font-size:3.1rem;padding-right:5px}.BANK .fsIcons,.BANK_ACCOUNT .fsIcons,.IACH .fsIcons{background-position:0 -252px;height:19px;left:19px}.ECHECK .fsIcons,.ELV .fsIcons,.TAB.DELAYED_TRANSFER .fsIcons{background-position:0 -252px;height:19px}.TAB.DELAYED_TRANSFER .fsIcons{left:19px}.BILL_ME_LATER .fsIcons,.BML .fsIcons,.CREDIT_OPTION .fsIcons,.PPCREDIT .fsIcons{background-position:0 -105px}.PAYPAL_SMART_CONNECT .fsIcons{background-position:0 0}.VISA .fsIcons{background-position:0 -21px}.MASTERCARD .fsIcons{background-position:0 -42px}.AMEX .fsIcons{background-position:0 -63px;left:19px;height:20px}.DISC .fsIcons,.DISCOVER .fsIcons{background-position:0 -84px}.JCB .fsIcons{background-position:0 -353px}.CHINA_UNION_PAY .fsIcons{background-position:0 -563px}.ELECTRON .fsIcons{background-position:0 -146px}.MAESTRO .fsIcons,.MSTRO .fsIcons,.SWITCH .fsIcons{background-position:0 -168px}.CB_NATIONALE .fsIcons,.CBN .fsIcons{background-position:0 -210px}.CELEM .fsIcons,.CETELEM .fsIcons{background-position:0 -311px}.COFINOGA .fsIcons,.CONF .fsIcons{background-position:0 -231px}.COFID .fsIcons,.COFIDIS .fsIcons{background-position:0 -437px;left:20px}.INCENTIVE .fsIcons{background-position:0 -271px;height:18px}.PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -374px}.PPSMTCONNECT .fsIcons{background-position:0 0}.ES .PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -521px}.fsIcon{display:block;position:absolute;width:25px;height:21px;left:15px;top:20px;min-width:32px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;background-position:0 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.fsIcon.BANK,.fsIcon.PAD{background-position:6px -252px;height:19px;left:19px}.fsIcon.MASTER,.fsIcon.MASTERCARD,.fsIcon.MCARD{background-position:0 -42px}.fsIcon.ELO{background-position:0 -479px}.fsIcon.HIPER{background-position:0 -458px}.fsIcon.HIPERCARD{background-position:0 -500px}.fsIcon.DISC,.fsIcon.DISCOVER{background-position:0 -84px}.fsIcon.VISA{background-position:0 -21px}.fsIcon.JCB{background-position:0 -353px}.fsIcon.AMEX,.fsIcon.Amex{background-position:6px -63px;left:19px;height:20px}.fsIcon.MAESTRO,.fsIcon.MSTRO,.fsIcon.SWITCH{background-position:0 -168px}.fsIcon.PAYPAL_SMART_CONNECT{background-position:0 0}.fsIcon.CB_NATIONALE,.fsIcon.CBN{background-position:0 -210px}.fsIcon.CELEM,.fsIcon.CETELEM{background-position:0 -311px}.fsIcon.COFID,.fsIcon.COFIDIS{background-position:0 -437px;left:20px;height:20px}.fsIcon.CHINA_UNION_PAY,.fsIcon.CUP{background-position:0 -563px}.fsIcon.COFINOGA,.fsIcon.CONF{background-position:0 -231px}.fsIcon.PAYPAL_EXTRAS_MASTERCARD,.fsIcon.PPXMCARD{background-position:0 -374px}.fsIcon.EBAY_MASTERCARD,.fsIcon.EBAYMCARD{background-position:0 0}.fsIcon.BILL_ME_LATER,.fsIcon .BML,.fsIcon .PPCREDIT{background-position:0 -105px}.fsIcon.PPSMTCONNECT{background-position:0 0}.fsIcon.pinlessIcon{background-image:none;font-size:3.1rem;left:5px;top:14px}.ES .fsIcon.PAYPAL_EXTRAS_MASTERCARD,.ES .fsIcon.PPXMCARD{background-position:0 -521px}.infoIcon{width:19px;height:18px;display:inline-block;position:absolute;top:25px;right:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-89px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.infoIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.addOption{padding:25px 10px;margin:0 0 0 44px;color:#0070ba;font-size:.85em}.plusicon{display:block;position:absolute;left:15px;top:22px;width:20px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.plusicon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.infoIcon+.checkIcon{display:none}.infoMsg{margin:0;overflow:hidden;font-size:.85em}.expiredIcon{background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%;width:16px;height:16px;top:6px}.expiredIcon,.plccIcon{display:inline-block;position:relative}.plccIcon{float:left;height:20px;background:none;width:32px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.fsIcon,.fsIcons{height:20px}}.walletIcons{position:absolute;width:30px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.walletIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons_2x.png\");background-size:90px 970px}}.walletIcons.BANK,.walletIcons.BANK_ACCOUNT{background-position:-50px -460px}.walletIcons.BANK.BOFA,.walletIcons.BANK_ACCOUNT.BOFA{background-position:-50px -10px}.walletIcons.BANK.CHASE,.walletIcons.BANK_ACCOUNT.CHASE{background-position:-50px -130px}.walletIcons.BANK.WELLSFARGO,.walletIcons.BANK_ACCOUNT.WELLSFARGO{background-position:-50px -100px}.walletIcons.BANK.CITI,.walletIcons.BANK_ACCOUNT.CITI{background-position:-50px -40px}.walletIcons.BANK.FIFTHTHIRD,.walletIcons.BANK_ACCOUNT.FIFTHTHIRD{background-position:-50px -220px}.walletIcons.BANK.CAPITAL,.walletIcons.BANK_ACCOUNT.CAPITAL{background-position:-50px -70px}.walletIcons.BANK.AMERITRADE,.walletIcons.BANK_ACCOUNT.AMERITRADE{background-position:-50px -160px}.walletIcons.BANK.SUNTRUST,.walletIcons.BANK_ACCOUNT.SUNTRUST{background-position:-50px -280px}.walletIcons.BANK.USBANK,.walletIcons.BANK_ACCOUNT.USBANK{background-position:-50px -310px}.walletIcons.BANK.USAA,.walletIcons.BANK_ACCOUNT.USAA{background-position:-50px -250px}.walletIcons.CARD.VISA,.walletIcons.PAYMENT_CARD.VISA{background-position:-10px -40px}.walletIcons.CARD.MASTER,.walletIcons.CARD.MASTERCARD,.walletIcons.PAYMENT_CARD.MASTER,.walletIcons.PAYMENT_CARD.MASTERCARD{background-position:-10px -70px}.walletIcons.CARD.DISCOVER,.walletIcons.PAYMENT_CARD.DISCOVER{background-position:-10px -100px}.walletIcons.CARD.AMEX,.walletIcons.PAYMENT_CARD.AMEX{background-position:-10px -130px}hr.sep,hr.sepPlain{padding:0;margin-top:25px;height:auto;border:none;border-top:1px solid #ccc;color:#2c2e2f;text-align:center;overflow:visible}hr.sep:after,hr.sepPlain:after{content:\"or\";display:inline-block;position:relative;top:-.7em;font-size:1em;padding:0 .5em;background:#fff;color:#6c7378;font-weight:400}.de hr.sep:after{content:\"oder\"}.da hr.sep:after{content:\"eller\"}.es hr.sep:after{content:\"o\"}.fr hr.sep:after{content:\"ou\"}.he hr.sep:after{content:\"\\5D0\\5D5\"}.id hr.sep:after{content:\"Atau\"}.it hr.sep:after{content:\"oppure\"}.ja hr.sep:after{content:\"\\307E\\305F\\306F\"}.ko hr.sep:after{content:\"\\B610\\B294\"}.nl hr.sep:after{content:\"of\"}.no hr.sep:after{content:\"eller\"}.pl hr.sep:after{content:\"lub\"}.pt hr.sep:after{content:\"ou\"}.ru hr.sep:after{content:\"\\418\\43B\\438\"}.sv hr.sep:after{content:\"eller\"}.th hr.sep:after{content:\"\\E2B\\E23\\E37\\E2D\"}.tr hr.sep:after{content:\"Veya\"}.zh hr.sep:after{content:\"\\6216\"}hr.sepPlain:after{content:\"\"}@media (min-width:0) and (max-width:23em){#loginSection .xoTitle h1{max-width:10em}}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){body{-webkit-text-size-adjust:100%}.merchantBrand{display:none}.outerWrapper{background-position:left 50px}.centerTray.loginSignup{margin-bottom:60px}#main{padding:0;background:none;z-index:2}#contents{padding:0 20px;-ms-box-sizing:border-box;box-sizing:border-box}.tokenization #contents{padding:0 30px}.paypalHeader{padding:0 20px 20px;-ms-box-sizing:border-box;box-sizing:border-box}.props,header{display:none}.review #wrapper{min-height:512px}#contents{min-height:0;margin-bottom:0}.bmlAppProcessing,.loginProcessing{background-color:#f9f9f9}.loggingIn{margin:0 25px}.mobile .loggingIn{margin:0}.saferEasier,.simpler{display:none}#login .row-fluid{padding-top:0}#login .centerTray{padding:0}#login #signupLink.btn{margin:5px 0}#wrapper{margin:0;width:auto;border-radius:0;background-clip:padding-box;border:none}#task{width:295px}.loading .spinner{background-position-y:35%}.centerTray{width:auto}.accountTerms .tray .inner,.tray .inner{padding:10px}.row-fluid>[class*=span],.signup{width:100%;margin-left:0;float:none}#notifications{width:100%}.delta,.gamma{font-size:1.2em}.inputField label{left:7px;top:13px}.saferEasier{display:none}#fundingInstruments .buttons{height:40px}.cityState select{font-size:14px}.cityState .city{width:100%}.cityState .state{width:55%}.cityState .postalCode{width:40.8%}#tab{margin-top:0;height:125px}.toolTip.whatsthis ul{width:242px;left:9px}.toolTip.whatsthis ul li{font-size:.9em}#expiration.varB .expires{width:49%}#expiration .inputField{padding:0}#expiration .cvc{width:44%;float:right}#expiration.varB .cvc{width:49%}.month{margin-left:46px}.separator{margin-left:5px;margin-top:3px}.year{margin-left:0}#expiration .cardIcon{position:absolute;right:4px}.details{margin-right:2px}.mask #closeButton,.mask #header{display:none}}@media (min-width:30.0625em) and (max-width:41.25em){#notifications,.row-fluid>.span10,.row-fluid>.span12,.row-fluid>.span14{width:100%}.outerWrapper{background-position:left 59px}.props,header{display:none}#wrapper{margin:0;border:none}#main{padding:0}#contents{padding:0 25px}}@media (min-width:41.3125em){.banner{display:block}#wrapper{min-height:0}#wrapper,.footer,.merchantHeader{width:95%}.largeScreen .centerTray{margin-top:0}.signup{margin-bottom:0}#genericError{min-height:375px;background:url(https://www.paypalobjects.com/images/checkout/hermes/scr_cloud_balloon.png) no-repeat bottom}#transactionDetails .merchantName{display:none}}@media (device-height:568px) and (-webkit-min-device-pixel-ratio:2){#contents{min-height:0;margin-bottom:0}.pageLanding #contents{margin:70px auto 40px 0}}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.cardType{display:none}ul.validations li.restriction.active{background:url(https://www.paypalobjects.com/images/checkout/hermes/close3_2x.png) no-repeat 0 2px;background-size:10px}.inputField.error input{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.inputField.error input,.inputField.valid input{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.error .custom-select.active>span,.error .custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}@media only screen and (-webkit-min-device-pixel-ratio:2) and (min-width:41.3125em){#genericError{background-size:640px 242px}}.spinnerBtn .spinner{margin:8px 0 0;height:25px;width:25px;position:static;display:inline-block;z-index:10;padding:0;background-color:transparent;border-width:1.5px;border-style:solid;border-radius:100%;border-color:#009cde #fff #fff;top:0;left:50%;opacity:1;filter:alpha(opacity=100);-webkit-animation:rotation .7s infinite linear;animation:rotation .7s infinite linear}#upopConfirmation .ppLogoContainer{text-align:center}#upopConfirmation .ppLogoContainer .logo{display:inline-block}#upopConfirmation .modalMask,#upopConfirmation .modalWrapper{position:fixed;top:0;bottom:0;left:0;right:0;z-index:10}#upopConfirmation .close{position:absolute;top:20px;right:20px;width:19px;height:12px;padding:5px;border-radius:3px}#upopConfirmation .close:before{content:\"\";position:absolute;width:19px;height:19px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#upopConfirmation .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#upopConfirmation .close:focus:before,#upopConfirmation .close:hover:before{background-position:-223px -22px}#upopConfirmation .modalMask{background:#cbd2d6;opacity:.7}#upopConfirmation .modalWrapperAnimation{transition:transform .3s ease-out}#upopConfirmation .modalWrapper{background:#fff;width:620px;-ms-box-sizing:border-box;box-sizing:border-box;left:50%;padding:80px 120px 0;overflow:auto;border-radius:5px;background-clip:padding-box;-webkit-transform:translate(-50%,100%);transform:translate(-50%,100%)}#upopConfirmation .modalWrapper .logo{position:relative;margin-top:-60px;width:25px;height:30px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#upopConfirmation .modalWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#upopConfirmation .modalContainer{min-height:99%;width:380px;display:block}#upopConfirmation .modalContainer .pushlogo{height:90px}#upopConfirmation .processing input{background-color:#f2f3f4}#upopConfirmation .upopOpen .modalWrapper{-webkit-transform:translate(-50%);transform:translate(-50%)}#upopConfirmation .upopConfirm .header{border-bottom:none}#upopConfirmation .upopConfirm .timingFields{padding-bottom:35px}#upopConfirmation .upopConfirm .counter{float:left}#upopConfirmation .upopConfirm a.resendCode{float:right}#upopConfirmation .upopConfirm #notifications{padding:0 0 5px}#upopConfirmation .expiration{display:inline-flex}#upopConfirmation .expiration .expires{position:relative;top:auto;left:auto}#upopConfirmation .expiration .expirationField{margin-right:10px}#upopConfirmation .expiration input.ng-invalid{padding-right:13px}#upopConfirmation .expiration label{margin-bottom:5px;color:#000}#upopConfirmation .telephoneField{clear:both;padding:0;float:none}#upopConfirmation .heading{margin:5px 0 10px;font-size:1.6em;font-family:HelveticaNeue-Light,Helvetica Neue Light,Helvetica,Arial,sans-serif}#upopConfirmation .timer{margin-bottom:20px}#upopConfirmation .timeLeft{margin-left:5px;font-weight:700}#upopConfirmation .confirmMsg{color:#6c7378;margin-bottom:20px}#upopConfirmation .resendLink{font-size:.85em}#upopConfirmation .btn{margin-top:10px}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){#upopConfirmation .modalWrapper{width:100%;padding:60px 15px 0}#upopConfirmation .modalWrapper .modalContainer{width:auto}}#addCard.aside #upopConfirmation #notifications{padding:0 0 5px;margin-bottom:0}", ""]);
	
	// exports


/***/ }),

/***/ "./components/xo-wallet-components/src/confirm-upop/template.html":
/***/ (function(module, exports) {

	module.exports = "<section id=\"upopConfirmation\">\n    <div class=\"upopConfirm\">\n        <div class=\"modalMask\"></div>\n        <div class=\"modalWrapper\" modal-box modal-cancel=\"closeModal()\" ng-class=\"{'modalWrapperAnimation': !fromLoginOverlay}\">\n            <div class=\"modalContainer\" content tabindex=\"-1\">\n                <a link-button track-submit=\"{{collectOtpInput ? 'close_otp_init' : 'close_otp_confirm'}}\" class=\"close focusableIcon\" href=\"#\" ng-click=\"closeModal($event)\"></a>\n                <xo-message message=\"message\"></xo-message>\n                <div class=\"heading\" ng-bind-html=\"htmlContent('confirmUpop.heading', {acctLastFour: cardLast4})\"></div>\n\n                <xo-init-otp token=\"token\" set-error-data=\"setInitErrorData\" phone=\"props.phone\" card-model=\"cardModel\" on-success=\"actions.initSuccess\" flag=\"flag\" ng-if=\"!showCollectOtpScreen\"></xo-init-otp>\n                <xo-confirm-otp token=\"token\" message=\"setMessage\" phone=\"props.phone\" card-model=\"cardModel\" on-success=\"confirmed\" ng-if=\"showCollectOtpScreen\" button-text-key=\"buttonTextKey\"></xo-confirm-otp>\n                <div class=\"pushlogo\"></div>\n            </div>\n            <div class=\"ppLogoContainer\">\n                <div class=\"logo\"></div>\n            </div>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "./components/xo-wallet-components/src/add-card/addcard/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	var _cardMetaData = __webpack_require__("./components/xo-wallet-components/src/add-card/cardMetaData/index.js");
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-card/addcard/template.html"), __webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/auth/index.js"), __webpack_require__("./components/xo-models/src/fi/index.js"), __webpack_require__("./components/xo-wallet-components/src/add-card/creditcard-input/directive.js"), __webpack_require__("./components/xo-ui-components/src/dropdown/directive.js"), __webpack_require__("./components/xo-tray-height/dist/directive.js"), __webpack_require__("./components/xo-page-components/src/aside-header/directive.js"), __webpack_require__("./components/xo-ui-components/src/message/directive.js"), __webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js"), __webpack_require__("./components/angular-ui-utils/ui-utils.min.js"), __webpack_require__("./components/xo-ui-components/src/accessibility/directive.js"), __webpack_require__("./components/xo-wallet-components/src/fi-contingency-list/util.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid, template, $) {
	
	    return squid.module('xo-add-card.addcard.directive', ['squid', 'xomodel.checkout', 'xomodel.auth', 'xomodel.fi', 'xo-add-card.creditcard-input.directive', 'xo-dropdown.directive', 'xo-tray-height.directive', 'xo-aside-header.directive', 'xo-message.directive', 'xo-error-tooltip.directive', 'ui.validate', 'xo-accessibility.directive', 'fi.errorUtil']).directive('xoAddCard', function () {
	
	        return {
	            template: template,
	
	            scope: {
	                token: '=',
	                done: '=',
	                message: '=',
	                pagetitle: '=',
	                sidebar: '=',
	                showmeftsection: '=',
	                hideparenthead: '=',
	                billingaddressupdated: '=',
	                cardmodel: '=',
	                parentCallbacks: '=',
	                selectedPromotionCardType: '=',
	                promotion: '=',
	                pageLevel: '=',
	                logout: '=',
	                phone: '=',
	                manageCardFlow: '=',
	                onSuccess: '=',
	                backUri: '='
	            },
	            controller: function controller($scope, $populate, $state, $BillingAddressesModel, $CardTypesModel, $CheckoutSessionModel, $AuthModel, $CheckoutCartModel, $timeout, $element, $rootScope, $locale, $util, $feature, $ResolveOTP, $Class, $fiErrorUtil, $renderContent) {
	
	                $populate($scope, {
	                    cart: $CheckoutCartModel.instance($scope.token),
	                    auth: $AuthModel.instance(),
	                    billingAddresses: $BillingAddressesModel.instance(),
	                    checkoutSession: $CheckoutSessionModel.instance($scope.token).retrieve({
	                        contingencies: {
	                            NEED_CREDIT_CARD: angular.noop,
	                            EXPIRED_CREDIT_CARD: angular.noop
	                        }
	                    })
	                }).then(function () {
	
	                    // Set up the back url if passed down from the parent or else use the default review route
	                    $scope.backUri = $scope.backUri || 'checkout.review.sidebar.wallet';
	
	                    if ($scope.showmeftsection) {
	                        $scope.showmeftsection.toggle = true;
	                    }
	
	                    if ($scope.hideparenthead) {
	                        $scope.hideparenthead.toggle = false;
	                    }
	
	                    $scope.manageCardFlow = $scope.sidebar && $scope.cardmodel.card.isExisting();
	
	                    var type = $scope.selectedPromotionCardType && $scope.selectedPromotionCardType.type;
	
	                    if ($scope.checkoutSession.plccOffer && !type && $scope.promotion) {
	                        $state.go('^.selectCard');
	                    }
	
	                    $scope.showplcc = type === 'plcc';
	                    $scope.country = $locale.country;
	
	                    $scope.showNotYou = $scope.auth.is_auth_api_call && $util.param('source') !== 'consumerApp' && $scope.logout;
	
	                    $scope.cardmodel.cardType = 'creditCard';
	
	                    if ($scope.checkoutSession.plccOffer && $scope.showplcc) {
	                        $scope.cardmodel.cardType = 'privateLabel';
	                        $scope.cardmodel.sponsor_id = $scope.checkoutSession.plccOffer.sponsor_id;
	                    }
	
	                    $scope.cardmodel.user = {
	                        first_name: $scope.auth.first_name,
	                        last_name: $scope.auth.last_name
	                    };
	
	                    $scope.cardmodel.address = $scope.billingAddresses.addresses[0];
	
	                    if ($scope.billingaddressupdated.value) {
	                        $scope.billingaddressupdated = {
	                            msgs: [$locale.content.get('editCard.newAddressAdded')],
	                            type: 'success',
	                            value: true
	                        };
	                    }
	
	                    $scope.gotoBilling = function (address) {
	                        if ($scope.pageLevel) {
	                            $scope.pageLevel.message = null;
	                        }
	                        if (!address) {
	                            if ($locale.country === 'BR') {
	                                $scope.parentCallbacks.showCep();
	                            } else {
	                                $state.go('^.addBilling');
	                            }
	                        }
	                    };
	
	                    $scope.isCUP = function () {
	                        return $scope.cardmodel.card && $scope.cardmodel.card.type && $scope.cardmodel.card.type === 'CUP';
	                    };
	
	                    $scope.flag = function (field) {
	                        return _cardMetaData.$CardMetaData.getMetaData($scope.cardmodel.card, field);
	                    };
	
	                    $scope.buttonText = function () {
	                        var contentString = 'creditcard.addBtn';
	                        if ($scope.cardmodel.card.isExisting()) {
	                            contentString = 'creditcard.updateBtn';
	                        } else if ($scope.isCUP()) {
	                            contentString = 'creditcard.continuetext';
	                        }
	                        return contentString;
	                    };
	
	                    $scope.cardTypeChanged = function () {
	                        $scope.phone.phoneType = $scope.flag('phoneType');
	                    };
	
	                    function addErrorMessage(contentKey) {
	                        if (contentKey) {
	                            contentKey = angular.isArray(contentKey) ? contentKey[0] : contentKey;
	                            var message = $locale.content.get('creditcard.' + contentKey);
	                            $scope.message.msgs.push(message);
	                        }
	                    }
	
	                    function handleContingencies(result, contentBundle, defaultErrorKey, prop) {
	                        var errorData;
	
	                        if (result.errorCodes) {
	                            errorData = result;
	                        } else {
	                            errorData = {
	                                errorCodes: result && [result['0']]
	                            };
	                        }
	                        $scope.message = $fiErrorUtil.addPageErrors(errorData, contentBundle, prop, defaultErrorKey);
	
	                        if (window.scrollTo) {
	                            window.scrollTo(0, 0);
	                        }
	                    }
	
	                    $scope.cancelFn = function () {
	                        if ($scope.sidebar) {
	                            if (!$scope.checkoutSession.plccOffer) {
	                                $state.go('checkout.review.sidebar.wallet');
	                            } else {
	                                $state.go('^.selectCard');
	                            }
	                        } else {
	                            $scope.done();
	                        }
	                    };
	
	                    function initiateOTP() {
	                        var resolveOTP = new $ResolveOTP({ id: $scope.cardmodel.id });
	                        resolveOTP.action('init', {
	                            data: {
	                                phone: {
	                                    country_code: $scope.phone.IntDialingCountryCode,
	                                    number: $scope.phone.telephone
	                                }
	                            },
	                            resultModel: {},
	                            success: function success() {
	                                $scope.message = {};
	                                $state.go('.confirmUpop');
	                            },
	
	                            error: function error() {
	                                handleContingencies({}, 'confirmUpop', 'declineMessage');
	                            },
	
	                            contingencies: {
	                                INIT_OTP_CONTINGENCY: function INIT_OTP_CONTINGENCY(name, result) {
	                                    // prop for last 4 digits of card in error message
	                                    var prop = {
	                                        number: $scope.cardmodel && $scope.cardmodel.card && $scope.cardmodel.card.last4()
	                                    };
	
	                                    handleContingencies(result, 'confirmUpop', 'declineMessage', prop);
	                                    $fiErrorUtil.addFieldErrors(result, $element);
	                                },
	                                DEFAULT: function DEFAULT() {
	                                    handleContingencies({}, 'confirmUpop', 'declineMessage');
	                                }
	                            }
	                        });
	                    }
	
	                    $scope.onSubmit = function () {
	                        if ($scope.pageLevel) {
	                            $scope.pageLevel.message = null;
	                        }
	                        var isNewCard = !$scope.cardmodel.card.isExisting();
	
	                        if (isNewCard) {
	                            delete $scope.cardmodel.id;
	                        }
	
	                        if ($('#plccAgree').is(':checked')) {
	                            $scope.cardmodel.preference = true;
	                        }
	
	                        // Only initiateOTP needs to be called for unconfirmed CUP contingency. Add card call does not need to be made.
	                        if ($scope.isCUP() && $scope.cardmodel.id && ($scope.checkoutSession.get('errorData.cause') === 'NEED_AUTHENTICATED_CARD' || $scope.checkoutSession.get('errorData.cause') === 'EXPIRED_CREDIT_CARD')) {
	
	                            initiateOTP();
	                        } else {
	                            $scope.cardmodel.save({
	
	                                success: function success() {
	                                    if ($scope.isCUP()) {
	                                        initiateOTP();
	                                    } else {
	
	                                        $scope.checkoutSession.fundingOptions.action('update', {
	
	                                            resultModel: $scope.checkoutSession,
	
	                                            data: {
	                                                planId: $scope.cardmodel.id
	                                            },
	                                            success: function success(result) {
	                                                if ($scope.cardmodel && $scope.cardmodel.cardType === 'privateLabel') {
	                                                    delete $scope.checkoutSession.plccOffer;
	                                                }
	
	                                                delete $scope.checkoutSession.errorData;
	
	                                                var cardAdded = $scope.cardmodel && $scope.cardmodel.card;
	                                                var numberAdded;
	                                                var cardTypeAdded;
	
	                                                if (cardAdded) {
	                                                    numberAdded = angular.isString(cardAdded.number) && cardAdded.number.replace(/\s/g, '');
	                                                    cardTypeAdded = cardAdded.type;
	                                                }
	
	                                                var last4Added = angular.isString(numberAdded) && numberAdded.substr(numberAdded.length - 4);
	                                                var cvvData = $scope.checkoutSession.cvvData;
	                                                var last4ToUse;
	                                                var cardTypeToUse;
	
	                                                if (cvvData) {
	                                                    last4ToUse = cvvData.number;
	                                                    cardTypeToUse = cvvData.type;
	                                                }
	
	                                                if (last4ToUse === last4Added && cardTypeAdded === cardTypeToUse) {
	                                                    $scope.checkoutSession.set('cvvData.security_code', $scope.cardmodel.get('card.security_code'));
	                                                }
	
	                                                var updateCardSidebarMessage = $renderContent('wallet.cardUpdated', {
	                                                    type: cardTypeAdded,
	                                                    number: last4Added
	                                                });
	                                                var updateCardPageMessage = $renderContent('smallToolTip.cardUpdated');
	                                                var addCardMessage = $renderContent('smallToolTip.cardAdded');
	
	                                                var msgs = [addCardMessage];
	
	                                                if (!isNewCard) {
	                                                    msgs = $scope.manageCardFlow ? [updateCardSidebarMessage] : [updateCardPageMessage];
	                                                }
	
	                                                $scope.checkoutSession.message = {
	                                                    type: 'success',
	                                                    msgs: msgs
	                                                };
	
	                                                $scope.done();
	                                            },
	
	                                            contingencies: {
	                                                TRANSACTION_REFUSED: function TRANSACTION_REFUSED(name) {
	                                                    $scope.message.msgs = [];
	                                                    $scope.message.type = 'info';
	                                                    addErrorMessage('addedButCannotUse');
	                                                }
	                                            }
	                                        });
	                                    }
	                                },
	
	                                contingencies: {
	                                    ADD_CARD_CONTINGENCY: function ADD_CARD_CONTINGENCY(name, result) {
	                                        if ($scope.sidebar) {
	                                            $scope.$emit('SidebarError');
	                                        }
	                                        $scope.billingaddressupdated.value = false;
	                                        if (result && result.errorCodes) {
	                                            handleContingencies(result, 'creditcard', 'errorInvalidData');
	                                            $fiErrorUtil.addFieldErrors(result, $element);
	                                        } else if (result && result['0']) {
	                                            handleContingencies(result, 'creditcard');
	                                        } else {
	                                            handleContingencies({}, 'creditcard', 'errorInternalError');
	                                        }
	                                    },
	                                    DISALLOWED_CUPSECURE_ADDITION: function DISALLOWED_CUPSECURE_ADDITION(name, result) {
	                                        handleContingencies({}, 'creditcard', 'errorInternalError');
	                                    },
	                                    VALIDATION_ERROR: function VALIDATION_ERROR(name, result) {
	                                        var $field = $($element).find('[ng-model="card.number"]');
	                                        $field.addClass('backendError');
	                                        $field.attr('aria-invalid', true);
	                                        $field.focus();
	                                    },
	                                    DEFAULT: function DEFAULT(name, result) {
	                                        handleContingencies({ errorCodes: [name] }, 'creditcard', 'errorInternalError');
	                                    }
	
	                                },
	
	                                error: function error() {
	                                    handleContingencies({}, 'creditcard', 'errorInternalError');
	                                },
	
	                                validation: function validation(res) {}
	                            });
	                        }
	                    };
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	_cardMetaData.$CardMetaData;

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-card/addcard/template.html":
/***/ (function(module, exports) {

	module.exports = "\n<div content modal-box=\"!!sidebar\" modal-cancel=\"cancelFn()\" xo-tray-height>\n    <xo-aside-header back-url=\"{{backUri}}\" heading=\"asideHeader.addCard\" ng-if=\"sidebar && !checkoutSession.plccOffer && !cardmodel.card.isExisting()\"></xo-aside-header>\n    <div class=\"header noButtons\" ng-if=\"manageCardFlow\">\n        <h1 class=\"asideAlpha walletHeading noHead noBottom alpha\">{{ content('asideHeader.updateCard', {type: cardmodel.card.name, number: cardmodel.card.lastDigits}) }}</h1>\n        <a link-button ui-sref=\"checkout.review.sidebar.wallet\" class=\"backArrow goTray\"><span class=\"accessAid\">{{ content('common.back') }}</span></a>\n    </div>\n    <xo-aside-header back-url=\"^.selectCard\" heading='asideHeader.selectCard' ng-if=\"sidebar && checkoutSession.plccOffer\"></xo-aside-header>\n    <xo-message message=\"message\" ng-if=\"!sidebar\"></xo-message>\n    <p class=\"userEmail\" id=\"reviewUserInfo\" ng-if=\"showNotYou\">\n        {{ content('memberReview.welcomeBack', {userName: auth.first_name ? auth.first_name : auth.email}) }}\n                <span>\n                    <a track-link=\"login_with_diff_user\" href=\"\" ng-click=\"logout(auth)\">{{ content('memberReview.notYou')}}</a>\n                </span>\n    </p>\n    <h1 class=\"gamma\" ng-if=\"pagetitle\">{{ pagetitle }}</h1>\n\n    <div ng-class=\"{true: 'sidebar'}[asideContent]\" xo-tray-height>\n        <form id=\"creditCardForm\" name=\"creditCardForm\" class=\"addCard asideView asideContent\" content form-autofocus novalidate>\n            <div class=\"trayInner container\">\n                <xo-message message=\"message\" ng-if=\"sidebar\"></xo-message>\n                <xo-message id=\"billingAddressUpdatedMsg\" ng-if=\"billingaddressupdated.value\" message=\"billingaddressupdated\"></xo-message>\n                <xo-name-input user=\"cardmodel.user\" country=\"{{country}}\"></xo-name-input>\n\n                <xo-credit-card token=\"token\" card=\"cardmodel.card\" user=\"cardmodel.user\"\n                                selected-promotion-card-type=\"selectedPromotionCardType\"\n                                card-type-changed=\"cardTypeChanged\" promotion=\"promotion\"\n                                manage-card-flow=\"manageCardFlow\"></xo-credit-card>\n\n                <div ng-if=\"flag('fields.address')\" id=\"billingAddress\" class=\"billingAddress confidential\">\n                    <div class=\"dropdown billingAddress nullable inputField\" floating-label-dropdown>\n                        <select xo-dropdown default=\"{{content('addCard.addNewBillingAddress')}}\" ng-model=\"cardmodel.address\"\n                                ng-change=\"gotoBilling(cardmodel.address)\"\n                                ng-options=\"address.full_address for address in billingAddresses.addresses\"\n                                name=\"billingAddress\" id=\"billingAddressDropdown\" required>\n                        </select>\n                        <label for=\"billingAddressDropdown\" class=\"billingAddressLabel\">\n                            {{ content(\"addressBook.billingAddress\") }}\n                        </label>\n                        <a href=\"\" link-button ng-click=\"gotoBilling()\" class=\"addNewBillingAddress\" aria-label=\"{{ content('addCard.addNewBillingAddress') }}\">{{ content(\"addressBook.add\") }}</a>\n                    </div>\n                </div>\n\n                <div ng-if=\"flag('fields.phone')\">\n                    <div class=\"otpVerification\" ng-bind-html=\"htmlContent('confirmUpop.debitInitOtp')\"></div>\n                    <xo-phone-input token=\"token\" show-phone-type=\"false\" phone=\"phone\"></xo-phone-input>\n                </div>\n\n                <div class=\"addressLabel\">\n                    <a href=\"\" link-button ng-click=\"gotoBilling()\">{{ content(\"addCard.addNewBillingAddress\") }}</a>\n                </div>\n\n                <div ng-if=\"showplcc\">\n                    <div class=\"plccAgree checkbox\">\n                        <input type=\"checkbox\" checked=\"true\" name=\"plccAgree\" id=\"plccAgree\" />\n                        <label class=\"noBottom\" for=\"plccAgree\">{{content('addCard.plccPreferMethod', { merchant: promotion.name})}}</label>\n                    </div>\n                    <div class=\"legal\">{{content('addCard.plccLegal', { merchant: promotion.name})}}</div>\n                </div>\n\n\n                <input track-submit=\"{{cardmodel.card.isExisting() ? 'update_cc' : 'add_cc' }}\" type=\"submit\" value=\"{{ content(buttonText()) }}\" id=\"proceedButton\" class=\"btn full\" validate-submit=\"onSubmit()\" />\n            </div>\n        </form>\n    </div>\n\n    <div ui-view></div>\n</div>\n"

/***/ }),

/***/ "./components/xo-ui-components/src/accessibility/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _ui = __webpack_require__("./components/xo-ui-components/src/accessibility/ui.js");
	
	var _jquery = __webpack_require__("./components/jquery/dist/jquery.min.js");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// Adds role='button' and tabindex='0' to anchor elements
	// so that it is keyboard navigable and recognized by screen
	// readers as a button.
	//
	// As anchors without href do not fire their click event
	// automatically on a Space or ENTER key, this directive forces
	// that functionality.
	//
	// If something is assigned to the link-button attribute, then
	// it is used as an aria-label.
	(0, _angular.$registerDirective)('link-button', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            var ariaLabel = (0, _angular.$parse)(attrs.linkButton)(scope);
	            var $element = (0, _jquery2['default'])(element);
	
	            $element.attr('role', 'button');
	            $element.attr('tabindex', '0');
	            if (ariaLabel) {
	                $element.attr('aria-label', ariaLabel);
	            }
	            $element.on('keydown', function (event) {
	                // do nothing if there is an alt or ctrl key as well
	                if (!(event.altKey || event.ctrlKey)) {
	                    switch (event.keyCode) {
	                        case _ui.KEYS.SPACE:
	                        case _ui.KEYS.ENTER:
	                            element[0].click();
	                            return false;
	                        default:
	                            break;
	                    }
	                }
	                return true;
	            });
	        }
	    };
	});
	
	// this directive gives an element characteristics of a native
	// select element in terms of keyboard navigation. It becomes reachable
	// via the tab key, reflects screenreader characteristics and
	// can be activated by any of the DOWN, SPACE or ENTER KEYS.
	(0, _angular.$registerDirective)('select-button', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            var $element = (0, _jquery2['default'])(element);
	            $element.attr('role', 'button').attr('aria-haspopup', 'true').attr('tabindex', '0').on('keydown', function (event) {
	                // do nothing if there is an alt or ctrl key as well
	                if (!(event.altKey || event.ctrlKey)) {
	                    switch (event.keyCode) {
	                        case _ui.KEYS.DOWN:
	                        case _ui.KEYS.SPACE:
	                        case _ui.KEYS.ENTER:
	                            element[0].click();
	                            return false;
	                        default:
	                            break;
	                    }
	                }
	                return true;
	            });
	        }
	    };
	});
	
	// this directive makes a container with links act as if it were a select dropdown
	// in terms of keyboard accessibility. The following characteristics are implemented:
	//
	// * UP/RIGHT and DOWN/lEFT KEYS navigate through the options.
	// * ESC cancels and closes the dropdown
	// * SPACE or ENTER select an option
	// * You cannot TAB out of a dropdown until you select or cancel
	//
	// in addition, the following extra characteristics are implemented
	//
	// * The TAB (and SHIFT-TAB) key will also function to move between options
	// * Upon reaching the end of the list, the focus will shift back to the first item, and vice versa
	//
	// How to use:
	// 1. The select-cancel attribute is an agnostic expression to implement the cancel / back mechanic.
	//    The expression is run whenever the ESC key is pressed.
	// 2. The select-allow-tab-escape attribute can be added alongside the select-box attribute to allow
	//    tabs to escape the select-box element.
	(0, _angular.$registerDirective)('select-box', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            var allowTabEscape = (0, _angular.isDefined)(attrs.selectAllowTabEscape);
	
	            function escapeToggle() {
	                if (attrs.selectCancel) {
	                    (0, _angular.$parse)(attrs.selectCancel)(scope);
	                    scope.$apply();
	                }
	            }
	
	            element.attr('role', 'menu');
	
	            element.on('keydown.selectBox', function (event) {
	                var $allTabbable = (0, _ui.findAll)(element, _ui.tabbable);
	                var $origin = (0, _jquery2['default'])(event.target);
	
	                if (!(event.altKey || event.ctrlKey)) {
	                    var index = $allTabbable.index($origin);
	
	                    switch (event.keyCode) {
	                        case _ui.KEYS.TAB:
	                            if (allowTabEscape && (index === 0 && event.shiftKey || index === $allTabbable.length && !event.shiftKey)) {
	                                // Enable default behavior to escape select-box
	                                escapeToggle();
	                                break;
	                            } else if (event.shiftKey) {
	                                index = (index - 1 + $allTabbable.length) % $allTabbable.length;
	                            } else {
	                                index = (index + 1) % $allTabbable.length;
	                            }
	                            $allTabbable.eq(index).focus();
	                            event.preventDefault();
	                            break;
	                        case _ui.KEYS.DOWN:
	                        case _ui.KEYS.RIGHT:
	                            index = (index + 1) % $allTabbable.length;
	                            $allTabbable.eq(index).focus();
	                            event.preventDefault();
	                            break;
	                        case _ui.KEYS.UP:
	                        case _ui.KEYS.LEFT:
	                            index = (index - 1 + $allTabbable.length) % $allTabbable.length;
	                            $allTabbable.eq(index).focus();
	                            event.preventDefault();
	                            break;
	                        case _ui.KEYS.SPACE:
	                        case _ui.KEYS.ENTER:
	                            $origin.click();
	                            event.preventDefault();
	                            break;
	                        case _ui.KEYS.ESC:
	                            escapeToggle();
	                            break;
	                        default:
	                            break;
	                    }
	                }
	            });
	        }
	    };
	});
	
	// similar to select-box, this directive restrains tabbing within a container
	// to the container itself.
	//
	// 1. modal-cancel is the equivalent of select-cancel from select-box, and
	// should define a cancellation / ESC function.
	(0, _angular.$registerDirective)('modal-box', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            function escapeToggle() {
	                (0, _angular.$parse)(attrs.modalCancel)(scope);
	                scope.$apply();
	            }
	
	            // Gets the index of the element that should be focused after pressing Tab
	            function getNextIndex($element, $elements, shift) {
	                if (shift) {
	                    return ($elements.index($element) - 1 + $elements.length) % $elements.length;
	                } else {
	                    return ($elements.index($element) + 1) % $elements.length;
	                }
	            }
	
	            if ((0, _angular.$parse)(attrs.modalBox)(scope) !== false) {
	                element.on('keydown.modalBox', function (event) {
	                    var $allTabbable = (0, _ui.findAll)(element, _ui.tabbable);
	                    var $origin = (0, _jquery2['default'])(event.target);
	
	                    if (!(event.altKey || event.ctrlKey)) {
	                        switch (event.keyCode) {
	                            case _ui.KEYS.TAB:
	                                var index = getNextIndex($origin, $allTabbable, event.shiftKey);
	                                $allTabbable.eq(index).focus();
	                                event.preventDefault();
	                                event.stopPropagation();
	                                break;
	                            case _ui.KEYS.ESC:
	                                escapeToggle();
	                                event.preventDefault();
	                                event.stopPropagation();
	                                break;
	                            default:
	                                break;
	                        }
	                    }
	                });
	            }
	        }
	    };
	});
	
	// A simple version of modal that doesn't rely on controlling keyboard behavior
	// as strictly. Should be used in cases where tab items are not as easily accessible
	// via JS (ie. iframes)
	// Redirects focus to container when focusin event fired on element not in container
	(0, _angular.$registerDirective)('simple-modal', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            element.attr('tabindex', '-1');
	
	            var cancelFn;
	            if (attrs.modalCancel) {
	                cancelFn = function cancelFn() {
	                    (0, _angular.$parse)(attrs.modalCancel)(scope);
	                    scope.$apply();
	                };
	            }
	
	            function registerModal() {
	                (0, _jquery2['default'])(document).on('focusin.simple-modal', function (event) {
	                    if (!element[0].contains(event.target)) {
	                        event.stopPropagation();
	                        element.focus();
	                    }
	                });
	                if (cancelFn) {
	                    (0, _jquery2['default'])(document).on('click.simple-modal', function (event) {
	                        if (!element[0].contains(event.target)) {
	                            deregisterModal();
	                            cancelFn();
	                        }
	                    });
	                }
	            }
	
	            function deregisterModal() {
	                (0, _jquery2['default'])(document).off('focusin.simple-modal');
	                (0, _jquery2['default'])(document).off('click.simple-modal');
	            }
	
	            // Watch the expression provided to simpleModal and add modal behavior when
	            // expression result changes to truthy
	            if ((0, _angular.isDefined)(element.attr('simpleModal'))) {
	                scope.$watch(attrs['simpleModal'], function (newVal) {
	                    if (newVal) {
	                        registerModal();
	                    } else {
	                        deregisterModal();
	                    }
	                });
	            } else {
	                registerModal();
	            }
	
	            scope.$on('$destroy', deregisterModal);
	        }
	    };
	});
	
	// this directive gives an element characteristics of a native
	// option element in terms of aria attributes. It must be used
	// as a child of a selectBox for proper keyboard behavior as it
	// disables default tabbing behavior.
	//
	// The expression provided to the directive is used to set the
	// aria-selected attribute when the expression evaluates to true.
	(0, _angular.$registerDirective)('select-option', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            (0, _jquery2['default'])(element).attr('role', 'menuitem');
	            if ((0, _angular.$parse)(attrs.selectOption)(scope)) {
	                (0, _jquery2['default'])(element).attr('aria-selected', 'true');
	            }
	        }
	    };
	});
	
	// adapted from http://stackoverflow.com/a/24416690
	// This directive makes the element focused when the expression
	// provided _changes_ to true.
	//
	// In order to avoid conflicts with autofocus when a page first loads,
	// adding the focused-once-before attribute will enable the expression
	// only if it has been focused on before.
	//
	// * if the element itself is not focusable, then it will locate the first focusable
	// element within it.
	// * if the additional attribute focus-element is provided, it is wrapped
	// as a jQuery element (could be selector string or actual element) and focused on
	// it will be parsed when the focus-when attribute is true
	// * if the attribute focus-on is provided, then the focus-when attribute is ignored and
	// the directive listens to the event specified by focus-on
	(0, _angular.$registerDirective)('focus-when', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	
	            function locateAndFocus(active) {
	                (0, _angular.$timeout)(function () {
	                    if (active) {
	                        // deal with figuring out which element to focus on
	                        var $elementToFocus = (0, _jquery2['default'])(); // start with "monad" to make life easier
	                        var directiveElementFocusable = (0, _ui.focusable)(element[0]);
	
	                        // this works by fallthrough. it will try each one
	                        // in succession until an element is found
	                        if (attrs.focusElement) {
	                            // scenario 1 - specific element provided
	                            $elementToFocus = (0, _ui.filterAll)((0, _angular.$parse)(attrs.focusElement)(scope), _ui.focusable);
	                        }
	
	                        if ($elementToFocus.length === 0 && !directiveElementFocusable) {
	                            // scenario 2 - element with directive is not focusable
	                            $elementToFocus = (0, _ui.findAll)(element, _ui.focusable);
	                        }
	
	                        // default / scenario 3 - no valid targets specified or found
	                        if ($elementToFocus.length === 0) {
	                            $elementToFocus = (0, _jquery2['default'])(element);
	                        }
	
	                        $elementToFocus.first().focus();
	                    }
	                });
	            }
	
	            var active = true;
	
	            if ('focusedOnceBefore' in attrs) {
	                active = false;
	                (0, _jquery2['default'])(element).on('focus', function () {
	                    active = true;
	                });
	            }
	
	            if (attrs.focusRefreshOn) {
	                scope.$on((0, _angular.$parse)(attrs.focusRefreshOn)(scope), function () {
	                    locateAndFocus(active);
	                });
	            } else {
	                scope.$watch(attrs.focusWhen, function (val) {
	                    locateAndFocus(active && val);
	                });
	            }
	        }
	    };
	});
	
	// angularUI router specific - listens to a specific transition
	// defined in two attributes, focusWhenState (this directive) and TransitionsTo
	var FOCUS_EVENT_NAME = 'accessible-focus';
	(0, _angular.$registerDirective)('focus-when-state', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            var startState = attrs.focusWhenState;
	            var endState = attrs.transitionsTo;
	            var transitionMessage = startState + ' > ' + endState;
	            var unregisterEventFn = _angular.$rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
	                if (fromState.name === startState && toState.name === endState) {
	                    scope.$broadcast(FOCUS_EVENT_NAME, transitionMessage);
	                }
	            });
	
	            scope.$on(FOCUS_EVENT_NAME, function (event, message) {
	                if (message === transitionMessage) {
	                    (0, _angular.$timeout)(function () {
	                        return element[0].focus();
	                    });
	                }
	            });
	
	            // see http://stackoverflow.com/a/27016855
	            scope.$on('$destroy', unregisterEventFn);
	        }
	    };
	});
	
	// Listens for the next state transition and focuses an element provided by selector
	// Use with links where focus is needed to return to a specific element after the transition
	(0, _angular.$registerDirective)('focus-after-transition', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            element.on('click', function () {
	                var focusSelector = attrs['focusAfterTransition'];
	                var cancel = _angular.$rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
	                    cancel();
	                    (0, _angular.$timeout)(function () {
	                        (0, _jquery2['default'])(focusSelector).focus();
	                    });
	                });
	            });
	        }
	    };
	});
	
	// focuses on the first focusable element on a container containing form elements
	(0, _angular.$registerDirective)('form-autofocus', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            // wait for the entire DOM to settle down first
	            (0, _angular.$timeout)(function () {
	                var $allFocusable = (0, _ui.findAll)(element, _ui.focusable);
	                if ($allFocusable.length > 0) {
	                    $allFocusable.first().focus();
	                }
	            });
	        }
	    };
	});
	
	// Change element to be focusable and tabbable or unfocusable if it is
	// not typically a focusable element by removing the tabindex attribute.
	(0, _angular.$registerDirective)('focusable', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            function setFocusable(value) {
	                if (value) {
	                    element.attr('tabindex', 0);
	                } else {
	                    element.removeAttr('tabindex');
	                }
	            }
	
	            if (attrs.focusable) {
	                scope.$watch(attrs.focusable, function (newVal) {
	                    if (newVal) {
	                        setFocusable(true);
	                    } else {
	                        setFocusable(false);
	                    }
	                });
	            } else {
	                setFocusable(true);
	            }
	        }
	    };
	});
	
	_angular.$registerDirective;
	
	_angular.$parse;
	
	_angular.$timeout;
	
	_angular.$rootScope;
	
	_angular.isDefined;
	
	_ui.KEYS;
	
	_ui.focusable;
	
	_ui.tabbable;
	
	_ui.findAll;
	
	_ui.filterAll;

/***/ }),

/***/ "./components/xo-wallet-components/src/add-card/creditcard-input/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	var _cardMetaData = __webpack_require__("./components/xo-wallet-components/src/add-card/cardMetaData/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/tooltip/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/floating-label/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/directionality/directive.js");
	
	__webpack_require__("./components/xo-wallet-components/src/add-card/cardExpiry/directive.js");
	
	__webpack_require__("./components/xo-wallet-components/src/add-card/cvv/directive.js");
	
	__webpack_require__("./components/xo-wallet-components/src/add-card/dob/directive.js");
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-card/creditcard-input/template.html"), __webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/xo-models/src/fi/index.js"), __webpack_require__("./components/angular-ui-utils/ui-utils.min.js"), __webpack_require__("./components/xo-form-components/src/name-input/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template, $) {
	
	    squid.module('xo-add-card.creditcard-input.directive', ['squid', 'xomodel.fi', 'xo-tooltip.directive', 'xo-error-tooltip.directive', 'xo-name-input.directive', 'ui.validate']).directive('scrollToTop', function () {
	        return {
	            link: function link(scope, element, attr) {
	                $(element).on('focus', function () {
	                    if ($('#mxCardTitle').is(':visible')) {
	                        $('#creditCardForm').scrollTop($(element).offset().top);
	                    }
	                });
	            }
	        };
	    }).directive('xoCreditCard', function ($timeout, $util) {
	        return {
	            template: template,
	            restrict: 'E',
	
	            scope: {
	                token: '=',
	                card: '=',
	                user: '=',
	                selectedPromotionCardType: '=',
	                promotion: '=',
	                cardTypeChanged: '=',
	                cardNumberChanged: '=',
	                manageCardFlow: '='
	            },
	            controller: function controller($scope, $populate, $CardTypesModel, $Class, $locale, $CardTypeFromBinModel, $config, $feature, $pxp, $logger, $CheckoutCartModel, $FlowEligibilityModel, $meta) {
	                $scope.locale = $locale;
	                $scope.country = $scope.locale.country;
	
	                var CARD_TYPE_VISA = 'VISA';
	                var isUnsupportedCard;
	                var lastVerifiedBin = '';
	                var lastRequestedBin = ''; // bin requested to service to fetch card type and pending response.
	
	                function updateNonVisaCurrencyConversion() {
	                    $scope.nonVisaDCCFlag = undefined;
	                    return $pxp('xo_xoonboarding_dcc_nonvisa', { 'ctx.COUNTRY': $scope.locale.country }, 'xo_xoonboarding_dcc_nonvisa_test').then(function (result) {
	                        if (result) {
	                            $scope.nonVisaDCCFlag = true;
	                            checkCardForDccCall();
	                        }
	                    });
	                }
	
	                updateNonVisaCurrencyConversion();
	
	                function getCurrencyConversion(number) {
	                    $scope.checkoutCart.action('calculateCurrencyConversion', {
	                        data: {
	                            cardNumber: number,
	                            country: $locale.country
	                        },
	                        success: function success(result) {
	                            $scope.conversion = $scope.card.currencyConvData = result;
	
	                            if (!result) {
	                                return;
	                            }
	
	                            $scope.conversion.formattedFromStr = truncateCurrencyConversionStr(result.from, result.from_amount);
	                            $scope.conversion.formattedToStr = truncateCurrencyConversionStr(result.to, result.to_amount);
	                        },
	                        contingencies: {
	                            DEFAULT: conversionErrorHandler
	                        },
	                        error: conversionErrorHandler
	                    });
	
	                    function conversionErrorHandler() {
	                        $logger.warn('Contingency encountered during calculateCurrencyConversion call.');
	                        return;
	                    }
	                }
	
	                /* @params
	                 * fullStr: The full formatted currency conversion string returned from downstream service.
	                 * amtStr: Just the currency conversion amount portion of the full string returned from downstream.
	                 */
	                function truncateCurrencyConversionStr(fullStr, amtStr) {
	                    try {
	                        var fixedPrecision = Number(amtStr).toFixed(4);
	                        var formattedStr = fullStr.replace(amtStr, fixedPrecision);
	                        if (fixedPrecision == 0) {
	                            // eslint-disable-line
	                            throw new Error('Currency conversion truncation error encountered, defaulting to full unformatted currencyConversion string.');
	                        }
	                        return formattedStr;
	                    } catch (e) {
	                        $logger.warn('currency_conversion_error', {
	                            reason: 'Error formatting currency conversion data to formatted str in wallet/add-card/creditcard-input directive',
	                            error: e
	                        });
	                        return fullStr;
	                    }
	                }
	
	                function currencyConvCardTypeChangeHandler() {
	                    $scope.card.ppconversion = 'PAYPAL';
	                    $scope.conversion = $scope.card.currencyConvData = undefined;
	                    checkCardForDccCall();
	                }
	
	                function checkCardForDccCall() {
	                    var number = ($scope.card.number || '').replace(/[^0-9]+/g, '').slice(0, $scope.maxLength());
	                    var isCardLenValid = $scope.cardLengthValid(number);
	                    // If the card length isn't valid, we reset scope.conversion because card length has been
	                    // reset, and we are in the process of entering in new valid card number.
	                    if (!isCardLenValid) {
	                        $scope.conversion = undefined;
	                    }
	                    // Combined check for all conditions for a getCurrencyConversion call
	                    if (isCardLenValid && isCardTypeValid() && isCurrencyConversionUncalled() && $scope.nonVisaDCCFlag) {
	                        getCurrencyConversion(number);
	                    }
	                    // if getCurrencyConversion has already been called for card type, don't call it again
	                    function isCurrencyConversionUncalled() {
	                        return $scope.conversion === undefined;
	                    }
	                    // non-visa and not undefined
	                    function isCardTypeValid() {
	                        return $scope.card.type !== CARD_TYPE_VISA && $scope.card.type !== undefined;
	                    }
	                }
	
	                $scope.$watch('card.type', function () {
	                    currencyConvCardTypeChangeHandler();
	                    if ($scope.cardTypeChanged) {
	                        $scope.cardTypeChanged();
	                    }
	                });
	
	                $scope.mxDebitCards = ['BANAMEX', 'BANCOARFACA', 'BBVA', 'BANORTE', 'HSBC', 'INBURSA', 'SANTANDER'];
	
	                $scope.cardLengthValid = function (number) {
	                    if ($scope.card && $scope.card.isExisting()) {
	                        return true;
	                    }
	
	                    number = (number || '').replace(/[^0-9]+/g, '');
	
	                    return number.length >= $scope.flag('length.min') && number.length <= $scope.flag('length.max');
	                };
	
	                $scope.cardLuhnValid = function (input) {
	
	                    if (!$scope.flag('luhn')) {
	                        return true;
	                    }
	
	                    if ($scope.card && $scope.card.isExisting()) {
	                        return true;
	                    }
	
	                    input = (input || '').replace(/[^0-9]+/g, '');
	
	                    var sum = 0;
	                    var numdigits = input.length;
	                    var parity = numdigits % 2;
	                    var i = 0;
	                    var digit;
	
	                    for (; i < numdigits; i++) {
	
	                        digit = parseInt(input.charAt(i), 10);
	
	                        if (i % 2 === parity) {
	                            digit *= 2;
	                        }
	
	                        if (digit > 9) {
	                            digit -= 9;
	                        }
	
	                        sum += digit;
	                    }
	
	                    return sum % 10 === 0;
	                };
	
	                $scope.isPlcc = $scope.selectedPromotionCardType && $scope.selectedPromotionCardType.type === 'plcc' ? true : false;
	
	                $scope.flag = function (field) {
	                    if ($scope.isPlcc && !$scope.card.type) {
	                        $scope.card.type = 'PLCC';
	                    }
	                    return _cardMetaData.$CardMetaData.getMetaData($scope.card, field);
	                };
	
	                $scope.maxLength = function () {
	
	                    if ($scope.card && $scope.card.isExisting()) {
	                        return 30;
	                    }
	
	                    return $scope.flag('length.max') + $scope.flag('spaces.length');
	                };
	
	                if ($scope.card && $scope.card.number) {
	                    $scope.unformattedCardNumber = ($scope.card.number || '').replace(/[^0-9]+/g, '').slice(0, $scope.maxLength());
	                }
	
	                $scope.showMXCardLogos = function () {
	                    return $locale.country === 'MX';
	                };
	
	                function pxpMXCardLabels() {
	                    if ($scope.showMXCardLogos()) {
	                        $pxp('xo_hermes_mx_cardlogo', {}, 'xo_hermes_mx_cardlogo_treatment').then(function (result) {
	                            $scope.showLabels = result && result.treatment_name === 'xo_hermes_mx_cardlogo_treatment';
	                        });
	                    } else {
	                        $scope.showLabels = false;
	                    }
	                }
	
	                $populate($scope, {
	                    cardTypes: $CardTypesModel.instance($scope.token + ':' + $locale.country, {
	                        token: $scope.token,
	                        country: $locale.country
	                    }),
	                    checkoutCart: $CheckoutCartModel.instance($scope.token),
	                    flowEligibility: $FlowEligibilityModel.instance($scope.token).retrieve({
	                        params: {
	                            geolocation: $meta.geolocation,
	                            localeCountry: $locale.country
	                        }
	                    })
	                }).then(function () {
	                    $scope.debitCardFlow = angular.isArray($scope.flowEligibility.paymentCardProductClass) && $scope.flowEligibility.paymentCardProductClass[0] === 'DEBIT';
	                    var cardTypeServiceCall = $feature('cardTypeServiceCallRequired', false, $scope.country) || $scope.debitCardFlow;
	
	                    $scope.cardProductValid = function () {
	                        return $scope.debitCardFlow ? $scope.card.productType === 'DEBIT' : true;
	                    };
	
	                    var forceDropDown = false;
	
	                    function str(item) {
	                        var s = item.toString();
	                        return item < 10 ? '0' + s : s;
	                    }
	
	                    $scope.supportedCardNamesCommaSeparated = $scope.cardTypes.supportedNames().join(', ');
	
	                    $scope.$on('localeChange', function () {
	
	                        $scope.cardTypes = $CardTypesModel.instance($scope.token + ':' + $locale.country, {
	                            token: $scope.token,
	                            country: $locale.country
	                        });
	
	                        $scope.cardTypes.retrieve().then(function () {
	                            if ($scope.card.type && $scope.cardTypes.allowed.indexOf($scope.card.type) === -1) {
	                                delete $scope.card.type;
	                                forceDropDown = false;
	                                $scope.changeCardNumber(true);
	                            }
	                        });
	
	                        $scope.country = $locale.country;
	
	                        pxpMXCardLabels();
	                    });
	
	                    pxpMXCardLabels();
	
	                    $scope.cvvShown = function () {
	                        if ($scope.card.type === 'CETELEM' && $scope.locale.country === 'FR') {
	                            return false;
	                        }
	
	                        if ($scope.card.type === 'CUP' && $scope.card.productType === 'DEBITCARD') {
	                            return false;
	                        }
	
	                        if ($scope.isPlcc && $scope.card.type) {
	                            return true;
	                        }
	
	                        return $scope.flag('fields.cvv');
	                    };
	
	                    $scope.expiryShown = function () {
	
	                        if ($scope.isPlcc && $scope.card.type) {
	                            return true;
	                        }
	                        if ($scope.card.type === 'CUP' && $scope.card.productType === 'DEBITCARD') {
	                            return false;
	                        }
	
	                        return $scope.flag('fields.expiry');
	                    };
	
	                    $scope.enableDropDown = function () {
	                        return Boolean(['ES', 'FR', 'GB', 'IT'].indexOf($scope.locale.country) > -1) || forceDropDown;
	                    };
	
	                    $scope.showDropDown = function () {
	
	                        if ($scope.enableDropDown()) {
	                            return true;
	                        }
	
	                        if (!$scope.card.type && $scope.card.number && $scope.card.number.length >= 4 && !cardTypeServiceCall && !$scope.isPlcc) {
	                            return true;
	                        }
	
	                        if (!$scope.card.type && $scope.card.number && $scope.card.number.length >= 7 && cardTypeServiceCall && isUnsupportedCard) {
	                            return true;
	                        }
	
	                        return false;
	                    };
	
	                    $scope.showAcceptedCardLogos = function () {
	                        return !$scope.showDropDown() && $feature('showAcceptedCardLogos', false, $scope.country);
	                    };
	
	                    $scope.getCardTypeByNumber = function (types, number) {
	                        if ($scope.isPlcc && number.length > 6 || !$scope.isPlcc) {
	                            return _cardMetaData.$CardMetaData.getCardType(types, number);
	                        }
	                    };
	
	                    function formatCardNumber(number) {
	                        var spaces = $scope.flag('spaces');
	                        var formatted = [];
	
	                        for (var i = 0; i < number.length; i++) {
	                            if (spaces.indexOf(i) > -1) {
	                                formatted.push(' ');
	                            }
	
	                            formatted.push(number.charAt(i));
	                        }
	
	                        number = formatted.join('');
	                        return number;
	                    }
	
	                    $scope.$watch('country', function (newValue, oldValue) {
	                        cardTypeServiceCall = $feature('cardTypeServiceCallRequired', false, $scope.country) || $scope.debitCardFlow;
	                    });
	
	                    /**
	                     * Hit Callback(unformatted cc no) when user gets out of the cardNumber field.
	                     */
	                    $scope.ccOnBlur = function () {
	                        if ($scope.cardNumberChanged) {
	                            $scope.cardNumberChanged($scope.unformattedCardNumber);
	                        }
	                    };
	
	                    // e.g for a dual brand = ['CUP' ,'VISA'], select VISA or CUP based
	                    // on regex defined for card type. If not regex was defined, pick one
	                    // of the allowed card type.
	                    function selectCardTypeForDualBrands(result) {
	                        var dualCardTypes = $feature('dualCardTypes', {});
	                        var match;
	                        Object.keys(dualCardTypes).some(function (key) {
	                            return result.some(function (cardType) {
	                                if (cardType.type === key) {
	                                    match = key;
	                                    return true;
	                                }
	                            });
	                        });
	
	                        if (match) {
	                            var regex = new RegExp(dualCardTypes[match]);
	                            var selected = $util.find(result, function (cardType) {
	                                if (regex.test(cardType.type)) {
	                                    return true;
	                                }
	                            });
	                            if (selected && selected.type === 'CUP') {
	                                $util.some(result, function (cardType) {
	                                    if (/^AMEX$/.test(cardType.type)) {
	                                        selected.dualType = cardType.type;
	                                        return true;
	                                    }
	                                });
	                            }
	
	                            return selected;
	                        } else {
	                            return $util.find(result, function (cardType) {
	                                return $scope.cardTypes.allowed.indexOf(cardType.type) > -1;
	                            });
	                        }
	                    }
	
	                    function selectCardType(result) {
	                        if (angular.isArray(result)) {
	                            if (result.length >= 2) {
	                                result = selectCardTypeForDualBrands(result);
	                            } else {
	                                result = result[0];
	                            }
	                        }
	
	                        return result || {};
	                    }
	
	                    function clearCardType() {
	                        $scope.card.type = '';
	                        $scope.card.isCupSecureCard = false;
	                        $scope.card.dualType = '';
	                        $scope.card.productType = '';
	                    }
	
	                    function getCardTypeByNumberServiceCall(number) {
	                        if (number.length >= 9) {
	                            /*
	                             * We have BIN numbers of different lengths - 6, 8, 9
	                             * For a 9 digit BIN number, when users enter 6 digits,
	                             * we might get a response different from what is expected out
	                             * of 9 digit BIN number.
	                             * So, we decided to call fims only when user entered card number
	                             * length is greater than or equal to 9.
	                             * This will also avoid multiple calls to fims at different length
	                             * of card (i.e. calling fims at every new digit after 6th digit until 9th digit)
	                             */
	                            var bin = number.slice(0, 9);
	
	                            if (lastVerifiedBin && lastVerifiedBin.bin === bin) {
	                                $scope.card.type = lastVerifiedBin.type;
	                                $scope.card.isCupSecureCard = lastVerifiedBin.isCupSecureCard;
	                                $scope.card.dualType = lastVerifiedBin.dualType;
	                                $scope.card.productType = lastVerifiedBin.productType;
	                                return;
	                            }
	
	                            if (isUnsupportedCard === bin || bin === lastRequestedBin) {
	                                return;
	                            }
	
	                            // protect against requesting substring of already requested bin
	                            if (bin.length <= lastRequestedBin.length && lastRequestedBin.indexOf(bin) > -1) {
	                                return;
	                            }
	
	                            lastRequestedBin = bin;
	
	                            var params = {
	                                country: $scope.country,
	                                user_country: $scope.country,
	                                bin: bin
	                            };
	
	                            $scope.cardTypeFromBinModel = new $CardTypeFromBinModel(params);
	
	                            // Make sure isCupSecureCard is set to false, as there is a possibility the next
	                            // retrieve could indicate it as a CUP UPOP card.
	                            $scope.card.isCupSecureCard = false;
	
	                            $scope.cardTypeFromBinModel.retrieve({
	                                silent: true,
	                                success: function success(result) {
	
	                                    // Log card brands returned from fims
	                                    if (result) {
	                                        var logObj = {
	                                            totalItems: result.length,
	                                            brands: []
	                                        };
	
	                                        result.forEach(function (brandObj) {
	                                            logObj.brands.push(brandObj.type);
	                                        });
	
	                                        $logger.info('fims_card_type_from_bin_response', logObj);
	                                    }
	
	                                    result = selectCardType(result);
	                                    var type = result.type;
	
	                                    var disallowedCard = false;
	                                    if ($scope.cardTypes.allowed.indexOf(type) === -1) {
	                                        disallowedCard = true;
	                                    } else if ($scope.debitCardFlow) {
	                                        if (result.productType !== 'DEBIT') {
	                                            disallowedCard = true;
	                                        }
	                                    }
	
	                                    if (disallowedCard) {
	                                        clearCardType();
	                                        isUnsupportedCard = bin;
	                                        $scope.allowedCardsTooltip = true;
	                                        return;
	                                    }
	
	                                    isUnsupportedCard = undefined;
	                                    forceDropDown = false;
	                                    if (!$scope.showDropDown()) {
	                                        $scope.card.type = type;
	                                        // CUP Non Upop card is a CUP Secure Card.
	                                        $scope.card.isCupSecureCard = type === 'CUP' && !result.isUpop;
	                                        $scope.card.dualType = result.dualType;
	                                        $scope.card.productType = result.productType;
	                                    }
	
	                                    // check for shorter version of bin coming back after longer version, protect against overwrite
	                                    if (!lastVerifiedBin.bin || lastVerifiedBin.bin.indexOf(bin) === -1) {
	                                        lastVerifiedBin = {
	                                            bin: bin,
	                                            type: type,
	                                            isCupSecureCard: type === 'CUP' && !result.isUpop,
	                                            dualType: result.dualType,
	                                            productType: result.productType
	                                        };
	                                    }
	
	                                    // This logic is to handle copy paste case when all numbers are entered at once
	                                    if ($scope.card.type && number.length >= $scope.flag('length.min')) {
	                                        if (/android/i.test(navigator.userAgent)) {
	                                            return;
	                                        }
	
	                                        var ccNumber = ($scope.card.number || '').replace(/[^0-9]+/g, '').slice(0, $scope.maxLength());
	
	                                        if (ccNumber.indexOf(number) >= 0) {
	                                            $scope.card.number = formatCardNumber(ccNumber);
	                                        }
	                                    }
	
	                                    return;
	                                },
	                                contingencies: {
	                                    GET_FI_ISSUER_DETAILS_ERR: function GET_FI_ISSUER_DETAILS_ERR(name, result) {
	                                        clearCardType();
	                                        isUnsupportedCard = bin;
	                                        lastRequestedBin = undefined;
	                                    }
	                                },
	                                error: function error() {
	                                    clearCardType();
	                                    isUnsupportedCard = bin;
	                                }
	                            });
	                        } else {
	                            isUnsupportedCard = undefined;
	                            forceDropDown = false;
	                            clearCardType();
	                        }
	                    }
	
	                    $scope.isNonVisaCurrencyConversionEnabled = function () {
	                        return $scope.conversion && $scope.card && $scope.card.type && $scope.card.type !== CARD_TYPE_VISA;
	                    };
	
	                    $scope.getAllowedCardTypeByNumber = function (number) {
	                        return $scope.getCardTypeByNumber($scope.cardTypes.allowed, number);
	                    };
	
	                    $scope.getDisallowedCardTypeByNumber = function (number) {
	                        return $scope.getCardTypeByNumber($scope.cardTypes.disallowed, number);
	                    };
	
	                    $scope.enableAddMode = function () {
	
	                        if ($scope.card.isExisting()) {
	                            $scope.card.number = '';
	                        }
	                    };
	
	                    $scope.changeType = function () {
	                        forceDropDown = true;
	
	                        $scope.changeCardNumber(true);
	
	                        // Blank out unsupported fields
	
	                        if (!$scope.flag('fields.expiry')) {
	                            delete $scope.card.expiry_month;
	                            delete $scope.card.expiry_year;
	                        }
	
	                        if (!$scope.flag('fields.issue')) {
	                            delete $scope.card.start_month;
	                            delete $scope.card.start_year;
	                            delete $scope.card.issue_number;
	                        }
	
	                        if (!$scope.flag('fields.dob')) {
	                            delete $scope.card.dob_day;
	                            delete $scope.card.dob_month;
	                            delete $scope.card.dob_year;
	                        }
	
	                        if (!$scope.flag('fields.cvv')) {
	                            delete $scope.card.security_code;
	                        }
	                    };
	
	                    $scope.changeCardNumber = function (isCardTypeChanged) {
	                        // If buyer tries to modify an update card number. We remove the whole string
	                        // so buyer can add a card instead.
	                        $scope.enableAddMode();
	                        $scope.allowedCardsTooltip = false;
	
	                        var regex = /[０-９]/;
	                        if ($feature('disableFullWidthCharacters') && regex.test($scope.card.number)) {
	                            $logger.info('checkout_fpti', {
	                                'is_fullwidth_character': true
	                            });
	                        }
	
	                        var number = ($scope.card.number || '').replace(/[^0-9]+/g, '').slice(0, $scope.maxLength());
	                        var formattedNumber;
	
	                        $scope.unformattedCardNumber = number;
	
	                        // check to see if DCC service call necessary
	                        checkCardForDccCall();
	
	                        // Attempt to determine the card type
	                        var cardType;
	
	                        if (cardTypeServiceCall) {
	                            if (!isCardTypeChanged) {
	                                getCardTypeByNumberServiceCall(number);
	                            }
	
	                            if (isUnsupportedCard) {
	                                $scope.allowedCardsTooltip = true;
	                            }
	                        } else {
	                            if (!isCardTypeChanged) {
	                                // Hide dropdown and trigger bin matching when the cc number is < 4 digits
	                                if (number.length < 4) {
	                                    forceDropDown = false;
	                                }
	
	                                if (!$scope.enableDropDown()) {
	                                    cardType = $scope.getAllowedCardTypeByNumber(number);
	                                    $scope.card.type = cardType.type;
	                                    $scope.card.subType = cardType.subType;
	                                }
	                            }
	
	                            if ($scope.isPlcc && $scope.card.type) {
	                                $scope.cvvShown();
	                                $scope.expiryShown();
	                            }
	
	                            if (!$scope.card.type && !$scope.isPlcc && (number.length >= 4 || $scope.getDisallowedCardTypeByNumber(number).type)) {
	                                $scope.allowedCardsTooltip = true;
	                            }
	                        }
	
	                        // Format the card number
	
	                        /*
	                         * PPPLMER-1563 commented out to fix this bug
	                        if (/android/i.test(navigator.userAgent)) {
	                            return;
	                        }
	                        */
	
	                        formattedNumber = formatCardNumber(number);
	
	                        // If the card is already formatted correctly, we can leave the user to continue in peace.
	                        if ($scope.card.number === formattedNumber) {
	                            return;
	                        }
	
	                        // Wait for the user's input to be reflected on the page (necessary for safari 5 otherwise selectionStart is incorrect)
	                        $timeout(function () {
	
	                            // re-formatting the number, since the card type may not have resolved before the first call
	                            $scope.card.number = formatCardNumber(number);
	
	                            // Save the current cursor positions
	                            var ccField = document.getElementById('cc');
	                            if (!ccField) {
	                                return;
	                            }
	                            var inputLength = ccField.value.length;
	                            var cursorStart = ccField.selectionStart;
	
	                            // Wait for the formatted card to be reflected on the page
	                            $timeout(function () {
	
	                                // If the cursor was at the end of the input field, keep it at the end
	                                if (cursorStart === inputLength) {
	                                    ccField.selectionStart = ccField.selectionEnd = ccField.value.length;
	                                    // Otherwise place the cursor to the position it was in before we replaced with the formatted number
	                                } else {
	                                    ccField.selectionStart = ccField.selectionEnd = cursorStart;
	                                }
	                            });
	                        });
	                    };
	
	                    var year = new Date().getFullYear();
	                    $scope.months = $util.map($util.range(1, 13), str);
	                    $scope.startYears = $util.map($util.range(year - 10, year), str);
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	_cardMetaData.$CardMetaData;

/***/ }),

/***/ "./components/xo-wallet-components/src/add-card/dob/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _template = __webpack_require__("./components/xo-wallet-components/src/add-card/dob/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-ui-components/src/dropdown/directive.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoDobCardInputDirective', {
	    tag: 'xo-dob-card-input',
	    template: _template2['default'],
	
	    props: {
	        user: {
	            type: 'var'
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            function pad() {
	                var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;
	
	                return function (num) {
	                    return (new Array(length + 1).join('0') + num).substr(-length);
	                };
	            }
	
	            var year = new Date().getFullYear();
	            this.days = _squid.$util.map(_squid.$util.range(1, 32), pad());
	            this.months = _squid.$util.map(_squid.$util.range(1, 13), pad());
	            this.years = _squid.$util.map(_squid.$util.range(year - 100, year), pad(4)).reverse();
	        }
	    }
	});
	
	
	_squid.$Component;
	
	_squid.$util;
	module.exports = exports['default'];

/***/ }),

/***/ "./components/xo-wallet-components/src/add-card/dob/template.html":
/***/ (function(module, exports) {

	module.exports = "<div content id=\"cardDOB\" class=\"cardDOB inputField invisiField confidential last-child\">\n    <label class=\"dobLabel nolap\" for=\"dobDayCC\">{{ content('creditcard.dob') }}</label>\n\n    <div class=\"dropdown fidobDay nullable\">\n        <select xo-dropdown name=\"dobDayCC\" id=\"dobDayCC\" ng-model=\"user.dob_day\"\n                ng-options=\"day for day in days track by day\" ng-required=\"true\">\n            <option value=\"\">{{ content('applyForBml.bmlApplyDD') }}</option>\n        </select>\n    </div>\n\n    <div class=\"dropdown fidobMonth nullable\">\n        <select xo-dropdown name=\"dobMonthCC\" id=\"dobMonthCC\" ng-model=\"user.dob_month\"\n                ng-options=\"month for month in months track by month\" ng-required=\"true\">\n            <option value=\"\">{{ content('applyForBml.bmlApplyMM') }}</option>\n        </select>\n    </div>\n\n    <div class=\"dropdown fidobYear nullable\">\n        <select xo-dropdown name=\"dobYearCC\" id=\"dobYearCC\" ng-model=\"user.dob_year\"\n                ng-options=\"year for year in years track by year\" ng-required=\"true\">\n            <option value=\"\">{{ content('applyForBml.bmlApplyYYYY') }}</option>\n        </select>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-card/creditcard-input/template.html":
/***/ (function(module, exports) {

	module.exports = "<div class=\"creditCardInput\" content>\n    <!-- These two hidden fields are added to avoid autofill issue by chome for password and login field -->\n    <input style=\"display:none\">\n    <input type=\"password\" style=\"display:none\">\n\n    <div class=\"cardIconsGroup\" ng-if=\"!debitCardFlow && !manageCardFlow && showAcceptedCardLogos()\">\n        <div class=\"icons\" ng-repeat = \"cardType in cardTypes.allowed\"><div class = \"cardIcon {{cardType}}\"></div></div>\n    </div>\n\n    <div class=\"debitAndCreditIconsGroup\" ng-if=\"!debitCardFlow && !manageCardFlow && showMXCardLogos()\">\n        <p id=\"mxCardTitle\" class=\"cardIconTitle\">{{content('creditcard.cardIconTitle')}} </p>\n        <div class=\"cardIconsSection\">\n            <p class=\"creditIconLabel\" ng-if=\"showLabels\">{{content('creditcard.creditIconLabel')}}</p>\n            <div class=\"mxCardIconGroup\">\n                <div class=\"icons\" ng-repeat=\"cardType in cardTypes.allowed\">\n                    <div class=\"cardIcon {{cardType}}\"></div>\n                </div>\n            </div>\n            <br>\n            <p class=\"debitIconLabel\" ng-if=\"showLabels\">{{content('creditcard.debitIconLabel')}}</p>\n            <div class=\"icons\"\n                 ng-repeat=\"cardType in mxDebitCards\">\n                <div class=\"debitcardIcon {{cardType}}\"></div>\n            </div>\n        </div>\n    </div>\n\n    <div ng-if=\"isPlcc\" class=\"plccCardNumberTitle\" >{{content('addCard.plccAddCard', { merchant: promotion.name})}}</div>\n\n    <div class=\"dropdown cardType confidential nullable inputField\" ng-if=\"!manageCardFlow && showDropDown()\"\n         floating-label-dropdown>\n        <select xo-dropdown name=\"cardType\" ng-model=\"card.type\" ng-change=\"changeType()\" ng-required=\"true\"\n                ng-options=\"cardType as content('cardTypes.' + cardType) for cardType in cardTypes.allowed track by cardType\"\n                id=\"cardType\" aria-labelledby=\"cardTypeLabel\" data-show-card-type=\"false\">\n            <option value=\"\" selected>{{ content('creditcard.typeLabel') }}</option>\n        </select>\n        <label for=\"cardType\" id=\"cardTypeLabel\">{{ content('creditcard.typeLabel') }}</label>\n    </div>\n\n    <div ng-if=\"!manageCardFlow\" class=\"inputField confidential cardNumber creditCardField\" floating-label directionality>\n\n        <input type=\"tel\" ui-validate=\"{luhn: 'cardLuhnValid($value)', len: 'cardLengthValid($value)', prodType: 'cardProductValid($value)'}\"\n                ui-validate-watch=\"'card.type'\"\n                ng-model=\"card.number\" name=\"cardNumber\" id=\"cc\" value=\"\" ng-change=\"changeCardNumber(false)\"\n                ng-blur=\"ccOnBlur()\"\n                maxlength=\"{{maxLength()}}\" data-number=\"{{unformattedCardNumber}}\"\n                autocapitalize=\"off\" data-country=\"{{ locale.country }}\" autocomplete=\"off\"\n                ng-pattern=\"/.*/\"\n                pattern=\"[0-9]*\"\n                scroll-to-top\n                data-error-key=\"{{debitCardFlow ? 'validation.validDebitCard' : 'validation.validCreditCard'}}\" xo-error-tooltip />\n\n        <xo-tooltip trigger=\"#cc\" ng-if=\"allowedCardsTooltip\" show-event=\"keyup\">\n            <div class=\"tip tipDesc tipCreditCard\">\n                {{ !debitCardFlow ? content('creditcard.acceptableCards') : content('creditcard.acceptDebitCardOnly') }}\n                <span class=\"acceptedCards\" ng-if=\"!debitCardFlow\">\n                    {{supportedCardNamesCommaSeparated}}\n                </span>\n            </div>\n        </xo-tooltip>\n\n        <label for=\"cc\" class=\"focus\">\n            {{ !debitCardFlow ? content('creditcard.cardNumber') : content('creditcard.debitCardNumber') }}\n        </label>\n\n        <span ng-if=\"card.type\" class=\"creditCard {{card.type}} {{card.subType}}\" aria-label=\"{{card.type}}\" id=\"creditCard\" role=\"img\"></span>\n    </div>\n\n    <div id=\"currencyConversion\" class=\"conversion\" ng-if=\"isNonVisaCurrencyConversionEnabled()\"\n      ng-click=\"$event.stopPropagation()\" >\n        <div id=\"billingPageCurrencyConversionRates\">\n            <div>\n                <span ng-if=\"card.ppconversion === 'PAYPAL'\"> {{ content('currencyOptions.paypalRate') }} </span>\n                <a id=\"conversionLink\">\n                    <span ng-if=\"card.ppconversion === 'PAYPAL'\"\n                        ng-bind-html=\"htmlContent('currencyOptions.conversionRate', {currencyFrom: conversion.formattedFromStr, currencyTo: conversion.formattedToStr})\">\n                    </span>\n                    <span ng-if=\"card.ppconversion === 'VENDOR'\"\n                        ng-bind-html=\"htmlContent('currencyOptions.cardIssuerRateTitle')\">\n                    </span>\n                </a>\n            </div>\n        </div>\n\n       <xo-tooltip trigger=\"#conversionLink\" show-event=\"mouseover\" hide-event=\"mouseleave\">\n           <div class=\"tip tipDesc\">\n               <div>{{ content('currencyOptions.conversionDate', {date: conversion.date}) }}</div>\n\n               <div bind-html-compile=\"htmlContent('currencyOptions.changeConversionLink', {srefLink: '.currencyConversionOptions'})\"></div>\n           </div>\n       </xo-tooltip>\n    </div>\n\n    <!-- Issue no and start date for maestro cards -->\n    <div id=\"cardIssueInfo\" data-cardspecific=\"true\" class=\"fieldGroup clearfix\" ng-if=\"flag('fields.issue')\">\n\n        <div class=\"startDate inputField invisiField half confidential\">\n            <label class=\"starts nolap\" for=\"startmonth\">{{ content('creditcard.startDate') }}</label>\n\n            <div class=\"dropdown startmonth expmonth nullable\">\n                <select xo-dropdown ng-model=\"card.start_month\" id=\"startmonth\" name=\"startmonth\"\n                        ng-required=\"true\" ng-options=\"month for month in months\">\n                    <option value=\"\">{{ content('creditcard.monthPlaceholder') }}</option>\n                </select>\n            </div>\n\n            <div class=\"dropdown startyear expyear nullable\">\n                <select xo-dropdown ng-model=\"card.start_year\" id=\"startyear\" name=\"startyear\"\n                        ng-required=\"true\" ng-options=\"year for year in startYears\">\n                    <option value=\"\">{{ content('creditcard.yearPlaceholder') }}</option>\n                </select>\n            </div>\n        </div>\n\n        <div class=\"issueNo inputField half last-child confidential last-child\">\n            <input id=\"issueNo\" name=\"issueNo\" placeholder=\"{{content('creditcard.issueNoLabel')}}\" type=\"text\" ng-model=\"card.issue_number\" autocapitalize=\"off\" autocomplete=\"off\" maxlength=\"2\" ng-pattern=\"/^[0-9]+$/\" pattern=\"[0-9]*\"/>\n\n            <xo-tooltip trigger=\"#issueNo\">\n                <div class=\"tip tipDesc tipIssueNo\">\n                    {{ content('creditcard.issueNoLabelToolTip') }}\n                </div>\n            </xo-tooltip>\n        </div>\n    </div>\n\n    <div class=\"expiration confidential\" id=\"expiration\" ng-if=\"expiryShown() || cvvShown()\">\n        <xo-card-expiry ng-if=\"expiryShown()\" expiry-month=\"card.expiry_month\" expiry-year=\"card.expiry_year\"></xo-card-expiry>\n        <xo-cvv ng-if=\"cvvShown()\" card=\"card\" show-label=\"true\"></xo-cvv>\n    </div>\n\n    <!-- DOB fields for Country specific cards -->\n    <xo-dob-card-input ng-if=\"flag('fields.dob')\" user=\"user\"></xo-dob-card-input>\n</div>\n"

/***/ }),

/***/ "./components/xo-wallet-components/src/add-card/selectcard/route.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/xo-wallet-components/src/add-card/selectcard/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('xo-add-card.selectcard.route', ['xo-add-card.selectcard.directive']).factory('$SelectCardRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('SelectCardRoute', {
	
	            name: 'selectCard',
	            directive: 'xo-select-card',
	            titleContent: 'asideHeader.selectCard',
	            children: []
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-wallet-components/src/add-card/selectcard", "components/xo-wallet-components/src/add-card/selectcard/route.js"))

/***/ }),

/***/ "./components/xo-wallet-components/src/add-card/selectcard/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-card/selectcard/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, template) {
	
	    return angular.module('xo-add-card.selectcard.directive', []).directive('xoSelectCard', function () {
	
	        return {
	            template: template,
	
	            scope: {
	                parentCallbacks: '=',
	                token: '=',
	                promotion: '='
	            },
	
	            controller: function controller($scope, $populate, $CheckoutSessionModel) {
	
	                $populate($scope, {
	                    checkoutSession: $CheckoutSessionModel.instance($scope.token)
	                }).then(function () {
	                    $scope.selectCardType = function (type) {
	                        // card type is either 'cc' or 'plcc'
	                        $scope.parentCallbacks.cardTypeSelected(type);
	                    };
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-card/selectcard/template.html":
/***/ (function(module, exports) {

	module.exports = "<div id=\"selectCardType\">\n\t<xo-aside-header hdrtype='tall' heading='asideHeader.selectCard' sub-head='asideHeader.fundingInstrumentsSubHead' back-url=\"checkout.review.sidebar.wallet\"></xo-aside-header>\n\n\t<div class=\"asideContent fundingCards\" id=\"selectFundingType\" content>\n\t\t<div class=\"allCards\">\n\t\t\t<ul class=\"allFundingInstrumentsList clearfix\">\n\n\t\t\t\t<li class=\"fundingsource fs-item\">\n\t\t\t\t\t<a class=\"source\" role=\"button\" ng-click=\"selectCardType('cc')\">\n\t\t\t\t\t\t<span class=\"fsIcon\"></span>\n\t\t\t\t\t\t<p class=\"fsdetails\">\n\t\t\t\t\t\t\t<span class=\"name\">Debit or Credit Card</span>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<span class=\"forwardIcon\"/>\n\t\t\t\t\t</a>\n\t\t\t\t</li>\n\t\t\t\t<li class=\"fundingsource fs-item\">\n\t\t\t\t\t<a class=\"source\" role=\"button\" ng-click=\"selectCardType('plcc')\">\n\t\t\t\t\t\t<img class=\"plccIcon\" ng-src=\"{{promotion.logoUrl}}\"/>\n\t\t\t\t\t\t<p class=\"fsdetails\">\n\t\t\t\t\t\t\t<span class=\"name\">{{content('addCard.plccAddCard', { merchant: promotion.name})}}</span>\n\t\t\t\t\t\t\t<span class=\"secondary\">{{content('addCard.plccSelectIncentive')}}</span>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<span class=\"forwardIcon\"/>\n\t\t\t\t\t</a>\n\t\t\t\t</li>\n\n\t\t\t</ul>\n\t\t</div>\n\t</div>\n</div>\n"

/***/ }),

/***/ "./components/xo-wallet-components/src/add-card/addbilling/route.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-wallet-components/src/add-card/addbilling/directive.js"), __webpack_require__("./components/xo-address-components/src/add-address/directive.js"), __webpack_require__("./components/xo-address-components/src/address-normalization/route.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-add-card.addbilling.route', ['squid', 'xo-add-card.addbilling.directive', 'xo-add-address.directive', 'xo-address-normalization.route']).factory('$AddBillingRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('AddBillingRoute', {
	
	            name: 'addBilling',
	            directive: 'xo-add-billing',
	            titleContent: 'addBillingAddress.title',
	
	            trackingData: {
	                fptiState: 'edit_billing'
	            },
	            loginRequired: true,
	            children: [{
	                name: '$AddressNormalizationRoute',
	                attributes: {
	                    id: 'token',
	                    sidebar: 'sidebar',
	                    address: 'address',
	                    'done-fn': 'uponNormalization'
	                }
	            }]
	
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-wallet-components/src/add-card/addbilling", "components/xo-wallet-components/src/add-card/addbilling/route.js"))

/***/ }),

/***/ "./components/xo-wallet-components/src/add-card/addbilling/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-card/addbilling/template.html"), __webpack_require__("./components/angular-ui-utils/ui-utils.min.js"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/fi/index.js"), __webpack_require__("./components/xo-models/src/address/index.js"), __webpack_require__("./components/xo-address-components/src/add-address/directive.js"), __webpack_require__("./components/xo-page-components/src/aside-header/directive.js"), __webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js"), __webpack_require__("./components/xo-ui-components/src/accessibility/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid, template) {
	
	    return squid.module('xo-add-card.addbilling.directive', ['squid', 'xomodel.checkout', 'xomodel.fi', 'xomodel.address', 'xo-add-address.directive', 'xo-aside-header.directive', 'xo-error-tooltip.directive', 'ui.validate', 'xo-accessibility.directive']).directive('xoAddBilling', function () {
	
	        return {
	            template: template,
	
	            scope: {
	                auth: '=',
	                token: '=',
	                doneFn: '=',
	                parentCallbacks: '=',
	                sidebar: '=',
	                showmeftsection: '=',
	                hideparenthead: '=',
	                billingaddressupdated: '=',
	                prefillAddress: '='
	            },
	
	            controller: function controller($scope, $populate, $BillingAddressesModel, $BillingAddressModel, $PrefillAddressModel, $feature, $state, $element, $config, $locale, $timeout) {
	                var country = $locale.getCountryCodeISO();
	                $scope.billing = true; // to denote its billing address page still
	                $scope.normalize = $feature('addressNormalization');
	                $scope.country = country;
	                var $el = $($element);
	                if ($scope.showmeftsection) {
	                    $scope.showmeftsection.toggle = false;
	                }
	
	                if ($scope.hideparenthead) {
	                    $scope.hideparenthead.toggle = true;
	                }
	
	                function isUserInputtedAddress(address) {
	                    return address.id === '0';
	                }
	
	                // Label fields has having error if needed to, and focus the first error if needed
	                function handleValidation(res) {
	                    if (res && res.fields && res.fields.length) {
	                        res.fields.forEach(function (field) {
	                            if (field.field) {
	                                var $field = $($el.find('[name="' + field.field + '"]'));
	                                if ($field.length === 0 && field.field === 'zip') {
	                                    $field = $($el.find('[ng-model="address.postal_code"], [ng-model="zipCode"]'));
	                                }
	
	                                $field.addClass('backendError');
	                                $field.attr('aria-invalid', true);
	                            }
	                        });
	                    }
	
	                    $el.find('form').find('.backendError, .ng-invalid').first().focus();
	                }
	
	                var prefilledAddress = $scope.prefillAddress && $scope.prefillAddress.address;
	
	                if (prefilledAddress) {
	                    $scope.prefilled = true;
	                }
	
	                $scope.address = $scope.address || prefilledAddress || { country: country };
	
	                $populate($scope, {
	                    billingAddresses: $BillingAddressesModel.instance()
	                }).then(function () {
	
	                    $scope.cancelFn = function () {
	                        $state.go('^.addCard');
	                    };
	
	                    $scope.onSubmit = function () {
	                        $scope.updateAddress();
	                    };
	
	                    $scope.prefill = function () {
	                        $scope.address.country = $scope.country;
	                        $scope.prefillAddress = new $PrefillAddressModel({
	                            id: $scope.token,
	                            address: $scope.address
	                        });
	
	                        $scope.prefillAddress.save({
	                            data: $scope.prefillAddress,
	
	                            success: function success(result) {
	                                $scope.address = result;
	                                $scope.prefilled = true;
	                                $scope.showAddressFields = true;
	
	                                $timeout(function () {
	                                    var value = $scope.address.state;
	
	                                    var $option = $el.find('[value="' + value + '"]');
	                                    $option.prop('selected', 'selected');
	                                    $option.trigger('change');
	
	                                    value = $option.attr('label');
	                                }, 1000);
	                            }
	                        });
	                    };
	
	                    $scope.updateAddress = function () {
	
	                        var newBilling = new $BillingAddressModel({
	                            line1: $scope.address.line1,
	                            line2: $scope.address.line2,
	                            city: $scope.address.city,
	                            state: $scope.address.state,
	                            postal_code: $scope.address.postal_code,
	                            normalization_status: $scope.address.normalization_status,
	                            country: country,
	                            id: '0'
	                        });
	
	                        newBilling.save({
	                            data: $scope.billingAddress,
	
	                            success: function success() {
	                                if ($scope.normalize) {
	                                    // set to false so that html related to billing address is hidden when child is shown
	                                    $scope.billing = false;
	                                    $scope.address.full_address = newBilling.full_address;
	                                    $state.go('.addressNormalization');
	                                } else {
	                                    $scope.updateBillingAddressAndReturn('^.addCard', newBilling);
	                                }
	                            },
	
	                            validation: function validation(res) {
	                                handleValidation(res);
	                            }
	
	                        });
	                    };
	
	                    $scope.uponNormalization = function (normalizedAddress, isBack) {
	                        if (isBack) {
	                            $scope.billing = true;
	                            $state.go('^');
	                        } else {
	                            $scope.updateBillingAddressAndReturn('^.^.addCard', normalizedAddress);
	                        }
	                    };
	
	                    $scope.updateBillingAddressAndReturn = function (target, address) {
	                        var newBillingAddress;
	                        if (address && address instanceof $BillingAddressModel) {
	                            newBillingAddress = address;
	                        } else {
	                            newBillingAddress = new $BillingAddressModel({
	                                line1: address.line1,
	                                line2: address.line2,
	                                city: address.city,
	                                state: address.state,
	                                postal_code: address.postal_code,
	                                normalization_status: address.normalization_status,
	                                country: address.country || $scope.country,
	                                full_address: address.full_address || $scope.address.full_address,
	                                id: '0'
	                            });
	                        }
	
	                        var addresses = $scope.billingAddresses.addresses;
	                        if (!isUserInputtedAddress(addresses[0])) {
	                            addresses.unshift(newBillingAddress);
	                        } else {
	                            addresses[0] = newBillingAddress;
	                        }
	                        $scope.billingaddressupdated.value = true;
	
	                        $state.go(target);
	                    };
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-card/addbilling/template.html":
/***/ (function(module, exports) {

	module.exports = "<div ng-if=\"billing\" modal-box=\"address\" modal-cancel=\"cancelFn()\">\n    <xo-aside-header back-url=\"^.addCard\" heading=\"asideHeader.addBillingAddress\" ng-if=\"sidebar\"></xo-aside-header>\n\n    <h1 class=\"gamma addBillingTitle\" ng-if=\"!sidebar\">{{ content('addBillingAddress.title') }}</h1>\n\n    <form id=\"billingAddressForm\" name=\"billingAddressForm\" class=\"asideView addressForm\" content form-autofocus novalidate>\n        <div class=\"trayInner container\">\n            <div class=\"clearfix\">\n                <xo-add-address country=\"country\" address=\"address\" token=\"token\"></xo-add-address>\n            </div>\n\n            <div class=\"buttons clearfix\">\n                <a ng-hide=\"sidebar\" id=\"backButton\" ui-sref=\"^.addCard\" class=\"btn btn-secondary\" role=\"button\">{{ content('common.back') }}</a>\n                <input ng-if=\"country==='BR' && !prefilled\" type=\"submit\" id=\"proceedButton\" value=\"{{ content('common.continueLabel') }}\" class=\"btn\" ng-class=\"{full:sidebar}\" validate-submit=\"prefill()\" />\n                <input track-submit ng-if=\"country!=='BR' || prefilled\" type=\"submit\" id=\"proceedButton\" value=\"{{ content('common.save') }}\" class=\"btn\" ng-class=\"{full:sidebar}\" validate-submit=\"onSubmit()\" />\n            </div>\n        </div>\n    </form>\n</div>\n<div ui-view></div>\n"

/***/ }),

/***/ "./components/xo-address-components/src/address-normalization/route.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-address-components/src/address-normalization/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-address-normalization.route', ['squid', 'xo-address-normalization.directive']).factory('$AddressNormalizationRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('AddressNormalizationRoute', {
	
	            name: 'addressNormalization',
	            titleContent: 'addressNormalization.addressmatch',
	            directive: 'xo-address-normalization',
	            trackingData: {
	                fptiState: 'address_normalization',
	                buzname: {
	                    'fullpage': {
	                        'pagename': '%::address_normalization',
	                        'pagename2': '%::address_normalization:member:hermes:',
	                        'version': 'member:%:'
	                    }
	                }
	            },
	            loginRequired: true,
	
	            children: []
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-address-components/src/address-normalization", "components/xo-address-components/src/address-normalization/route.js"))

/***/ }),

/***/ "./components/xo-wallet-components/src/add-card/addCep/route.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-wallet-components/src/add-card/addCep/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-add-card.addcep.route', ['squid', 'xo-add-card.addcep.directive']).factory('$AddCepRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('AddCepRoute', {
	
	            name: 'addCep',
	            directive: 'xo-add-cep',
	            titleContent: 'addBillingAddress.title',
	            loginRequired: true,
	            children: []
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-wallet-components/src/add-card/addCep", "components/xo-wallet-components/src/add-card/addCep/route.js"))

/***/ }),

/***/ "./components/xo-wallet-components/src/add-card/addCep/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-card/addCep/template.html"), __webpack_require__("./components/angular-ui-utils/ui-utils.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-models/src/address/index.js"), __webpack_require__("./components/xo-form-components/src/zipcode/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, template) {
	    return angular.module('xo-add-card.addcep.directive', ['squid', 'xomodel.address', 'ui.validate', 'xo-zipcode.directive']).directive('xoAddCep', function () {
	        return {
	            template: template,
	
	            scope: {
	                token: '=',
	                sidebar: '=',
	                prefillAddress: '=',
	                doneFn: '='
	            },
	
	            controller: function controller($scope, $populate, $state, $PrefillAddressModel, $locale) {
	                $scope.country = $locale.country;
	
	                $scope.onSubmit = function () {
	                    $scope.prefillAddress.address = {
	                        country: $locale.country,
	                        postal_code: $scope.postal_code
	                    };
	
	                    $scope.prefillAddress.save({
	                        data: $scope.prefillAddress,
	
	                        success: function success(result) {
	                            $scope.prefillAddress.address = result;
	                            $scope.doneFn();
	                        }
	                    });
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-card/addCep/template.html":
/***/ (function(module, exports) {

	module.exports = "<xo-aside-header back-url=\"^.addCard\" heading=\"asideHeader.addBillingAddress\" ng-if=\"sidebar\"></xo-aside-header>\n\n<h1 class=\"gamma addBillingTitle\" ng-if=\"!sidebar\">{{ content('addBillingAddress.title') }}</h1>\n\n<form id=\"cepForm\" name=\"cepForm\" class=\"asideView addressForm\" content novalidate>\n    <div class=\"trayInner container\">\n        <xo-zipcode id=\"zipcode\" country=\"{{country}}\" zip-code=\"postal_code\" zip-label=\"{{content('common.cep')}}\"\n                    zip-error-key=\"common.valueInvalid\"></xo-zipcode>\n        <div class=\"buttons\">\n            <input track-submit type=\"submit\" id=\"proceedButton\"\n                   value=\"{{ content('common.continueLabel') }}\" class=\"btn full\" validate-submit=\"onSubmit()\" />\n        </div>\n    </div>\n</form>\n\n"

/***/ }),

/***/ "./pages/xo-add-card/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/module.js"), __webpack_require__("../node_modules/noop-loader/index.js!./pages/xo-add-card/template.html"), __webpack_require__("./components/xo-models/src/fi/lib/fiApis.js"), __webpack_require__("./components/xo-beaver/dist/logger.js"), __webpack_require__("./components/xo-wallet-components/src/add-card/directive.js"), __webpack_require__("./components/xo-validation/dist/directive.js"), __webpack_require__("./components/xo-ui-components/src/tooltip/directive.js"), __webpack_require__("./components/xo-ui-components/src/dropdown/directive.js"), __webpack_require__("./components/xo-page-components/src/value-props/directive.js"), __webpack_require__("./components/xo-page-components/src/done/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, module, template) {
	
	    return angular.module('hermes.page.xo-add-card.directive', ['squid', 'fi.apis', 'beaver', 'xo-add-card.directive', 'xo-validation.directive', 'xo-tooltip.directive', 'xo-dropdown.directive', 'xo-value-props.directive', 'xo-done.directive']).directive('xoPageAddCardPage', function ($rootScope) {
	
	        return {
	            template: template,
	
	            scope: {
	                token: '='
	            },
	
	            controller: function controller($scope, $rootScope, $state, $stateParams, $CheckoutSessionModel, $CheckoutAppDataModel, $CheckoutCartModel, // eslint-disable-line no-shadow
	            $ShippingAddressModel, $locale, $fiApis, $logger) {
	                populateInfoMessage();
	
	                $scope.pagetitle = $locale.content.get('addCard.addACard');
	
	                $scope.callbacks = {
	                    finish: function finish() {
	                        var checkoutSession = $CheckoutSessionModel.instance($rootScope.token);
	                        var checkoutAppData = $CheckoutAppDataModel.instance($rootScope.token);
	                        var checkoutCart = $CheckoutCartModel.instance($rootScope.token);
	                        var shippingAddress = $ShippingAddressModel.instance('123');
	
	                        var showGenericError = function showGenericError(code) {
	                            return function () {
	                                $state.go('checkout.genericError', { code: code });
	                            };
	                        };
	
	                        var makePayment = function makePayment() {
	                            return checkoutSession.action('createPayment', {
	                                data: {
	                                    payer_id: checkoutSession.payer.id,
	                                    intent: checkoutCart.payment_action
	                                },
	
	                                success: function success(result) {
	                                    $rootScope.paymentComplete = true;
	                                    $logger.info('wps_cart_to_txn_mapping', {
	                                        cart_id: $rootScope.token,
	                                        txn_id: result.transactionDetails && result.transactionDetails.id,
	                                        txn_receipt_id: result.transactionDetails && result.transactionDetails.receipt_id
	                                    });
	                                    return $state.go('checkout.done');
	                                },
	                                contingencies: {
	                                    TRANSACTION_REFUSED: showGenericError('TRANSACTION_REFUSED'),
	                                    PAYEE_BLOCKED_TRANSACTION: showGenericError('PAYMENT_DENIED'),
	                                    DUPLICATE_TRANSACTION: showGenericError('PAYMENT_ALREADY_DONE')
	                                }
	                            });
	                        };
	
	                        var authorize = function authorize() {
	                            checkoutSession.action('authorize', {
	                                success: function success() {
	                                    if (checkoutAppData.doec_on_approve()) {
	                                        return makePayment();
	                                    } else {
	                                        $state.go('checkout.end');
	                                    }
	                                }
	                            });
	                        };
	
	                        var setStickyInstrument = function setStickyInstrument() {
	
	                            if ($stateParams.mode !== 'signup') {
	                                return;
	                            }
	                            var stickyInstrument = checkoutSession.selectedFuturePaymentInstrument ? undefined : checkoutSession.getSelectedStickyInstrument();
	
	                            if (stickyInstrument) {
	                                return checkoutSession.action('setStickyFI', {
	                                    data: {
	                                        instrument_id: stickyInstrument.instrument_id
	                                    }
	                                });
	                            }
	                        };
	
	                        if (shippingAddress.isNew) {
	                            shippingAddress.save({
	                                data: shippingAddress,
	                                success: function success() {
	                                    _angular.$q.when(setStickyInstrument())['catch'](function (err) {
	                                        $logger.info('setStickyFI Failed', err);
	                                    }).then(function () {
	                                        return authorize();
	                                    });
	                                }
	                            });
	                        } else {
	                            _angular.$q.when(setStickyInstrument())['catch'](function (err) {
	                                $logger.info('setStickyFI Failed', err);
	                            }).then($fiApis.patchCvv(checkoutSession)).then(authorize(), function (err) {
	                                $logger.error('patchCvv error', err);
	                            });
	                        }
	                    }
	                };
	
	                function populateInfoMessage() {
	                    var msg;
	
	                    if ($stateParams.gaming === '1') {
	                        msg = $locale.content.get('creditcard.noEligibleFI');
	                    } else if ($stateParams.country === 'DE') {
	                        if ($stateParams.fiType === 'BANK') {
	                            msg = $locale.content.get('creditcard.cannotUseBank');
	                        } else {
	                            msg = $locale.content.get('creditcard.cannotUseCard');
	                        }
	                    } else {
	                        msg = $locale.content.get('creditcard.noFIContingency');
	                    }
	
	                    $scope.message = {
	                        msgs: [msg],
	                        type: 'error'
	                    };
	                }
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	_angular.$q;

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./pages/xo-add-card/template.html":
/***/ (function(module, exports) {

	module.exports = "<section class=\"addCard\" id=\"addCard\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <ui-view></ui-view>\n        </div>\n\n        <div class=\"span10\">\n            <xo-value-props type=\"addCard\" title=\"{{content('memberReview.propHead')}}\" text-content=\"memberReview.propVal\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "./components/xo-page-components/src/done/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	var _fbMessenger = __webpack_require__("./components/xo-page-components/src/constants/fbMessenger.js");
	
	var _fbMessenger2 = _interopRequireDefault(_fbMessenger);
	
	var _index = __webpack_require__("./components/xo-page-components/src/utils/index.js");
	
	var _index2 = _interopRequireDefault(_index);
	
	var _venmoInfo = __webpack_require__("./components/xo-venmo-components/src/venmo-info/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var AUTORETURN_TIMEOUT = 5000;
	
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-page-components/src/done/template.html"), __webpack_require__("./components/xo-beaver/dist/logger.js"), __webpack_require__("./components/xo-return-to-merchant/dist/util.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, ng, squid, template) {
	
	    return angular.module('xo-done.directive', ['squid', 'beaver', 'xo-error-tooltip.directive', 'xo-return-to-merchant']).directive('xoDone', function () {
	
	        return {
	            template: template,
	            controller: function controller($rootScope, $scope, $populate, $logger, $promise, $CheckoutAppDataModel, $CheckoutSessionModel, $MerchantPreferenceModel, $CheckoutPayeeModel, $CheckoutCartModel, $locale, $ReturnToMerchant, $DeviceInfo, $state, $window, $stateParams, $pxp, $timeout) {
	
	                $scope.isGuestSignup = $rootScope.mode && $rootScope.mode === 'signup';
	                $scope.locale = $locale;
	
	                function addPageMessage(code) {
	                    var CONTENT_KEY_MAPPING = {
	                        NO_UPGRADE: 'accountUpgradeFailed'
	                    };
	                    if (code && CONTENT_KEY_MAPPING[code]) {
	                        $scope.errorMessage = {
	                            msgs: [$locale.content.get('done.' + CONTENT_KEY_MAPPING[code])],
	                            type: 'warning'
	                        };
	                    }
	                }
	
	                function isVenmoFlow() {
	                    return _venmoInfo.venmoExperience.get($rootScope.token);
	                }
	
	                $populate($scope, {
	                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
	                    checkoutSession: $CheckoutSessionModel.instance($scope.token),
	                    checkoutCart: $CheckoutCartModel.instance($scope.token),
	                    payee: $CheckoutPayeeModel.instance($scope.token)
	                }).then(function () {
	
	                    return $populate($scope, {
	                        merchantPreferenceModel: $MerchantPreferenceModel.instance($scope.payee.merchant.id)
	                    }).then(function () {
	                        // Show auto return page when feature is enabled by merchant and txn
	                        $scope.isAutoReturn = $scope.merchantPreferenceModel.autoReturn();
	
	                        $logger.info('wps_autoreturn_' + ($scope.isAutoReturn ? 'enabled' : 'disabled'), {
	                            return_url: $scope.checkoutAppData.urls.return_url || 'not_available',
	                            autoreturn_url: $scope.merchantPreferenceModel.returnUrl() || 'not_available'
	                        });
	
	                        // Set content key based on device
	                        $scope.autoReturnContentKey = $DeviceInfo.isMobile() || $DeviceInfo.isTablet() ? 'done.autoReturnStatement' : 'done.autoReturnStatementWeb';
	                        $scope.guestSignupKey = $scope.isGuestSignup ? 'done.paymentGuest' : 'done.payment';
	                        if ($stateParams.code) {
	                            addPageMessage($stateParams.code);
	                        }
	                        var amount = $scope.checkoutSession.transactionDetails.amount.total;
	                        var code = $scope.checkoutSession.transactionDetails.amount.currency;
	                        $scope.formattedAmount = squid.formatCurrency(amount, code);
	                        var itemList = $scope.checkoutSession.itemsList;
	
	                        itemList.forEach(function (item) {
	                            item.quantity = squid.formatQuantity(item.quantity);
	                        });
	                    });
	                }).then(function () {
	                    var pxpContext = _index2['default'].getMessengerPXPContext();
	                    $logger.info('pxp_xo_wps_fb_messenger_plugin ', pxpContext);
	
	                    // Skipping FB messenger experience if Venmo flow detected as this is only for PayPal users
	                    // Also not loading if merchant auto return is enabled
	
	                    if (!$scope.isAutoReturn && !isVenmoFlow()) {
	                        $promise.all([$pxp(_fbMessenger2['default'].PXP_MESSENGER_EXPT, pxpContext, _fbMessenger2['default'].PXP_SHOW_MESSENGER_PLUGIN_TREATMENT), $pxp(_fbMessenger2['default'].PXP_MESSENGER_G11N, pxpContext, _fbMessenger2['default'].PXP_MESSENGER_PLUGIN_TREATMENT_G11N)]).then(function () {
	                            var results = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	                            var _squid$$locale = squid.$locale;
	                            _squid$$locale = _squid$$locale === undefined ? {} : _squid$$locale;
	                            var country = _squid$$locale.country;
	                            var _$scope$checkoutSessi = $scope.checkoutSession.payer;
	                            _$scope$checkoutSessi = _$scope$checkoutSessi === undefined ? {} : _$scope$checkoutSessi;
	                            var payerId = _$scope$checkoutSessi.id;
	
	                            $logger.info('Messenger_done_page_PXP_RESULT', results);
	
	                            var _results$ = results[0];
	                            _results$ = _results$ === undefined ? {} : _results$;
	                            var treatment_name = _results$.treatment_name,
	                                _results$2 = results[1];
	                            _results$2 = _results$2 === undefined ? {} : _results$2;
	                            var g11n_treatment_name = _results$2.treatment_name;
	
	                            if (treatment_name === _fbMessenger2['default'].PXP_SHOW_MESSENGER_PLUGIN_TREATMENT || g11n_treatment_name === _fbMessenger2['default'].PXP_MESSENGER_PLUGIN_TREATMENT_G11N) {
	                                $logger.info('messenger_done_page_test_traffic');
	                                $logger.info('checkout_fpti', {
	                                    buyer_country: country,
	                                    buyer_id: payerId,
	                                    design: 'fbmessenger',
	                                    from: 'XO_SUCCESS',
	                                    eligibility_reason: 'messenger_treatment'
	                                });
	                                $scope.pxpMessengerIntegrationEnabled = true;
	                            } else {
	                                $logger.info('messenger_done_page_control_traffic');
	                                $logger.info('checkout_fpti', {
	                                    buyer_country: country,
	                                    buyer_id: payerId,
	                                    design: 'fbmessenger',
	                                    from: 'XO_SUCCESS',
	                                    eligibility_reason: 'messenger_control'
	                                });
	                                $scope.pxpMessengerIntegrationEnabled = false;
	                            }
	                        });
	                    }
	
	                    $('#outerWrapper').addClass('xo-done');
	
	                    $scope.expansion = false;
	                    $scope.toggle = function () {
	                        if ($scope.expansion === false) {
	                            $scope.maxHeight = document.getElementsByClassName('details-expand')[0].scrollHeight + 'px';
	                            $scope.expansion = true;
	                        } else {
	                            $scope.expansion = false;
	                        }
	                        return $scope.expansion;
	                    };
	
	                    $scope.autoReturnStatementClick = function (event) {
	                        event.preventDefault();
	                        if (event.target && event.target.nodeName === 'A') {
	                            $logger.info('autoreturn_statement_clicked');
	                            $scope.returnToMerchant();
	                        }
	                    };
	
	                    if ($scope.isAutoReturn) {
	                        $logger.info('autoreturn_to_merchant');
	                        $timeout($scope.returnToMerchant, AUTORETURN_TIMEOUT);
	                    }
	                });
	
	                $scope.$on('localeChange', function () {
	                    if ($stateParams.code) {
	                        addPageMessage($stateParams.code);
	                    }
	                });
	
	                $scope.returnToMerchant = function () {
	                    $logger.info('return_to_merchant_clicked');
	                    return $state.go('checkout.end');
	                };
	
	                $rootScope.$on('$stateChangeSuccess', function (event, newState, newParams, oldState) {
	                    if (oldState.name === 'checkout.done') {
	                        $('#outerWrapper').removeClass('xo-done');
	                    }
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	_venmoInfo.venmoExperience;

/***/ }),

/***/ "./components/xo-venmo-components/src/venmo-info/index.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.venmoExperience = exports.venmoInfo = exports.VENMO_OPTIONS = undefined;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _index = __webpack_require__("./components/xo-device-info/dist/index.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _auth = __webpack_require__("./components/xo-models/src/auth/index.js");
	
	var _checkout = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _sessionStorage = __webpack_require__("./components/xo-venmo-components/src/venmo-info/sessionStorage.js");
	
	var _sessionStorage2 = _interopRequireDefault(_sessionStorage);
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: Check how the cookie should be read/set (through meta? if read on server side)
	var PWV_COOKIE = 'pwv';
	var VENMO_SETUP_COOKIE = 'venmoSetup';
	
	var VENMO_OPTIONS = exports.VENMO_OPTIONS = {
	    PAYPAL: 'PAYPAL',
	    VENMO: 'VENMO'
	};
	
	var venmoInfo = exports.venmoInfo = {
	    // Handler to call to determine if user can use Venmo
	    isVenmoEligible: function isVenmoEligible() {
	
	        var venmoRegex = new RegExp('(?:^|; )' + PWV_COOKIE + '=1(?:;|$)');
	        var appData = _checkout.$CheckoutAppDataModel.instance(_angular.$rootScope.token);
	        var cart = _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token);
	        var merchantID = _checkout.$CheckoutPayeeModel.instance(_angular.$rootScope.token).getId();
	        var isVenmoBillingWhitelisted = _squid.$config.venmoBillingWhitelist && _squid.$config.venmoBillingWhitelist.indexOf(merchantID) > -1;
	
	        var merchantCountry = appData.get('merchant.merchant_country');
	        var isProcessorDeclined = appData.get('flags.processor_declined');
	        var isInvoice = appData.get('flags.is_invoice_flow');
	        // check if whitelisted, else honor billing address flag
	        var isBillingRequired = isVenmoBillingWhitelisted ? false : appData.get('flags.billing_address_consent_required'); // eslint-disable-line no-unused-vars
	        var isOrderTransaction = cart.get('payment_action') === 'order';
	        var isBillingAgreement = cart.isBilling();
	
	        var isMobile = _index.$DeviceInfo.isDevice();
	        var isVenmoCookiePresent = Boolean(document.cookie.match(venmoRegex));
	
	        var eligibilityParams = {
	            isMobile: isMobile,
	            isVenmoCookiePresent: isVenmoCookiePresent,
	            isNotInvoice: !isInvoice,
	            isNotProcessorDeclined: !isProcessorDeclined,
	            isNotOrderTransaction: !isOrderTransaction,
	            isNotBillingAgreement: !isBillingAgreement,
	            isUSMerchant: merchantCountry === 'US'
	        };
	
	        var venmoEligibility = Object.keys(eligibilityParams).filter(function (param) {
	            return !eligibilityParams[param];
	        });
	        venmoEligibility = venmoEligibility && venmoEligibility.length > 0 ? 'ineligible:' + venmoEligibility.join() : 'eligible';
	
	        _logger.$logger.info('venmo_eligibility', venmoEligibility);
	
	        _logger.$logger.info('checkout_fpti', {
	            'is_venmo_cookie': isVenmoCookiePresent ? '1' : '0',
	            'eligibility_reason': venmoEligibility
	        });
	
	        return Boolean(venmoEligibility === 'eligible');
	    },
	
	
	    // Get option user has selected for Venmo, return null if user has not set up yet.
	    venmoState: function venmoState() {
	        var setupRegex = new RegExp('(?:^|; )' + VENMO_SETUP_COOKIE + '=(\\w*)(?:;|$)');
	        var match = document.cookie.match(setupRegex);
	
	        if (match && VENMO_OPTIONS.hasOwnProperty(match[1])) {
	            return match[1];
	        } else {
	            return null;
	        }
	    },
	
	
	    // Delete the venmo state cookie
	    clearVenmoState: function clearVenmoState() {
	        document.cookie = VENMO_SETUP_COOKIE + '=; Max-Age=0';
	    },
	    setVenmoCookie: function setVenmoCookie() {
	        document.cookie = VENMO_SETUP_COOKIE + '=' + VENMO_OPTIONS.VENMO;
	    },
	    setPayPalCookie: function setPayPalCookie() {
	        document.cookie = VENMO_SETUP_COOKIE + '=' + VENMO_OPTIONS.PAYPAL;
	    },
	
	
	    // Build the venmo URL scheme
	    buildVenmoURL: function buildVenmoURL() {
	        var SCHEME = _squid.$config.urls && _squid.$config.urls.venmoAppSwitchURL;
	        var VENMO_ROUTE = '#/checkout/venmo';
	        var LOGIN_ROUTE = '#/checkout/login?venmoError=true';
	
	        var cartModel = _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token);
	
	        var params = (0, _angular.$httpParamSerializer)({
	            'x-success': _angular.$location.absUrl().replace(/#.*$/, VENMO_ROUTE),
	            'x-failure': _angular.$location.absUrl().replace(/#.*$/, LOGIN_ROUTE),
	            'ua': _angular.$window.navigator.userAgent,
	            'merchant_id': _checkout.$CheckoutPayeeModel.instance(_angular.$rootScope.token).getId(),
	            'token': _angular.$rootScope.token,
	            'total': cartModel.purchase.amounts.total.amount,
	            'currency': cartModel.purchase.amounts.total.currency_code,
	            'intent': cartModel.payment_action
	        });
	
	        return SCHEME + 'paypal/checkout?' + params;
	    }
	};
	
	var venmoExperienceKey = 'VENMO_EXPERIENCE';
	
	// Get whether a token is marked as Venmo experience.
	var venmoExperience = exports.venmoExperience = {
	    set: function set(token) {
	        var sessionStorage = (0, _sessionStorage2['default'])();
	        sessionStorage.setItem(venmoExperienceKey, token);
	    },
	    get: function get(token) {
	        var auth = _auth.$AuthModel.instance();
	        var sessionStorage = (0, _sessionStorage2['default'])();
	        if (auth.logged_in && auth.guest && // Check if Venmo guest account logged in
	        sessionStorage.getItem(venmoExperienceKey) === token) {
	            return true;
	        } else {
	            this.set(null);
	            return false;
	        }
	    }
	};
	
	_angular.$rootScope;
	
	_angular.$window;
	
	_angular.$location;
	
	_angular.$httpParamSerializer;
	
	_index.$DeviceInfo;
	
	_squid.$config;
	
	_auth.$AuthModel;
	
	_checkout.$CheckoutPayeeModel;
	
	_checkout.$CheckoutCartModel;
	
	_checkout.$CheckoutAppDataModel;
	
	_logger.$logger;

/***/ }),

/***/ "./components/xo-venmo-components/src/venmo-info/sessionStorage.js":
/***/ (function(module, exports) {

	
	
	exports.__esModule = true;
	exports['default'] = getSessionStorage;
	var store = {};
	
	// Polyfill for sessionStorage if not available. Simple variable store
	
	function getSessionStorage() {
	    try {
	
	        window['sessionStorage'].setItem('__feature_test__', '0');
	        window['sessionStorage'].removeItem('__feature_test__');
	        return window.sessionStorage;
	    } catch (err) {
	        return {
	            getItem: function getItem(key) {
	                if (arguments < 1) {
	                    throw new Error('1 argument required');
	                }
	                return store[key];
	            },
	            setItem: function setItem(key, val) {
	                if (arguments < 2) {
	                    throw new Error('2 arguments required');
	                }
	                store[key] = val;
	            }
	        };
	    }
	}
	module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-page-components/src/done/template.html":
/***/ (function(module, exports) {

	module.exports = "<div class=\"xo-done-content\" content>\n    <div ng-click=\"toggle()\"class=\"splash-receipt\" tabindex=\"-1\">\n        <div class=\"receipt basics\">\n            <div class=\"done\" id=\"circle\"></div>\n            <div id=\"paid-text\" bind-html-compile=\"htmlContent(guestSignupKey, {amt: formattedAmount})\"/>\n            <div id=\"merchant-text\">{{content('done.payment_target', {merchantName: (checkoutAppData.merchant.brand_name || checkoutAppData.merchant.merchant_email)})}}</div>\n            <a id=\"details-text\" link-button href=\"#\" aria-expanded=\"{{expansion}}\">{{content('paymentMethod.msbDetails')}}</a>\n        </div>\n        <div class=\"details-expand\" ng-class=\"{ expansion : expansion}\" ng-style=\"expansion && {'max-height': maxHeight}\"\n            tabindex=\"-1\" focus-when=\"expansion\">\n            <div class=\"grouping\" ng-repeat=\"item in checkoutSession.itemsList\">\n                <div class=\"row\">\n                    <span class=\"ltrOverride\" directionality><span ng-if=\"item.quantity\">{{item.quantity}} x </span>{{item.name}}</span>\n                    <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\" amount=\"item.price\">\n                        </format-currency>\n                    </span>\n                </div>\n                <div ng-if=\"item.sku\" class=\"item-number-container\">\n                    <span>\n                        <strong>{{ content('header.itemNumber') }}</strong> <span class=\"item-number\">{{ item.sku }}</span>\n                    </span>\n                </div>\n                <div ng-if=\"item.item_option_selections\" class=\"item-selections\">\n                    <span class=\"item-selection\" ng-repeat=\"selection in item.item_option_selections track by $index\">\n                        <strong class=\"item-selection-name\">{{ selection.name }}:</strong>\n                        <span class=\"item-selection-value\">{{ selection.select }}</span>\n                    </span>\n                </div>\n            </div>\n            <div class=\"grouping\">\n                <div ng-if=\"checkoutSession.transactionDetails.amount.subtotal\" class=\"row\">\n                    <span>{{content('header.subTotal')}}</span>\n                     <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.subtotal\">\n                        </format-currency>\n                    </span>\n                </div>\n                <div ng-if=\"checkoutSession.transactionDetails.amount.tax\" class=\"row\">\n                    <span>{{content('header.tax')}}</span>\n                    <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.tax\">\n                        </format-currency>\n                    </span>\n                </div>\n                <div ng-if=\"checkoutSession.transactionDetails.amount.shipping\" class=\"row\">\n                    <span>{{content('header.shipping')}}</span>\n                    <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.shipping\">\n                        </format-currency>\n                    </span>\n                </div>\n                <div ng-if=\"checkoutSession.transactionDetails.amount.insurance\" class=\"row\">\n                    <span>{{content('header.insurance')}}</span>\n                    <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.insurance\">\n                        </format-currency>\n                    </span>\n                </div>\n                <div ng-if=\"checkoutSession.transactionDetails.amount.handling_fee\" class=\"row\">\n                    <span>{{content('header.handling')}}</span>\n                    <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.handling_fee\">\n                        </format-currency>\n                    </span>\n                </div>\n                <div ng-if=\"checkoutSession.transactionDetails.amount.discount\" class=\"row\">\n                    <span>{{content('header.discount')}}</span>\n                    <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.discount\">\n                        </format-currency>\n                    </span>\n                </div>\n            </div>\n            <div class=\"row totalAmount\">\n                <b>\n                    <span>{{content('base.totalLabel')}}</span>\n                <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.total\">\n                        </format-currency>\n                    </span>\n                </b>\n            </div>\n        </div>\n        <div id=\"details-button\">\n            <span ng-hide=\"!expansion\" class=\"arrow collapse\"></span>\n            <span ng-hide=\"expansion\" class=\"arrow expand\"></span>\n        </div>\n    </div>\n    <div class=\"essentials\" ng-if=\"checkoutSession.transactionDetails.reason_code === 'REGULATORY_REVIEW'\">\n        <div class=\"alert\" role=\"alert\">\n            {{content('done.temporarily_pending')}}\n        </div>\n    </div>\n    <div class=\"essentials\" ng-if=\"!isAutoReturn\">\n        <xo-message message=\"errorMessage\"></xo-message>\n\n        <div id=\"messenger-ba-integration\" ng-if=\"pxpMessengerIntegrationEnabled\">\n          <div id=\"messenger-ba-integration-content\" style=\"display:none\">\n            <div class=\"text\">{{ content('messenger.integration') }}</div>\n          </div>\n          <div id=\"ba-integration-content\" style=\"display:none\">\n            <div class=\"receipt title\">{{ content('messenger.linkedTitle') }}</div>\n            <div class=\"text\">{{ content('messenger.linkedSubtitle') }}</div>\n          </div>\n          <div id=\"stm-upsell-content\" class=\"text\">{{ content('messenger.upsell') }}</div>\n          <xo-messenger-plugin plugin-type=\"STM\" token=\"token\"></xo-messenger-plugin>\n        </div>\n\n        <h2 ng-if=\"checkoutSession.plan.sources.length > 0\" class=\"receipt title\">{{content('done.paidWith')}}</h2>\n        <div ng-repeat=\"item in checkoutSession.plan.sources\">\n            <div class=\"row clearfix\">\n                <span class=\"money-source\">{{content('fsMappings.'+item.type) || item.name}} <span ng-if=\"item.last4\">x-</span>{{item.last4}}</span>\n                <span class='amount'>\n                        <format-currency code=\"item.amount.currency_code\"\n                                         amount=\"item.amount.amount\">\n                        </format-currency>\n                </span>\n            </div>\n        </div>\n        <div ng-if=\"checkoutSession.transactionDetails.soft_descriptor\" class=\"secondary receipt statement\">{{content('done.transactionInformation', {merchantName: checkoutSession.transactionDetails.soft_descriptor})}}\n        </div>\n        <h2 ng-if=\"checkoutSession.shipping\" class=\"receipt title\">{{content('done.shippedTo')}}</h2>\n        <div class=\"text\" ng-if=\"!checkoutCart.isShippingMethodStorePickUp()\">\n            <div ng-if=\"checkoutSession.shipping.name\">{{checkoutSession.shipping.name}}</div>\n            <div><span directionality-text=\"checkoutSession.shipping.full_address\">{{checkoutSession.shipping.full_address}}</span></div>\n            <div><span>{{content('countryList.'+checkoutSession.shipping.country)}}</span></div>\n        </div>\n        <div class=\"text\" ng-if=\"checkoutCart.isShippingMethodStorePickUp()\">\n            <div class=\"storeLocation\" >{{ content('shippingMethod.storeLocation') }}</div>\n            <p class=\"storeLocationInfo\">{{ content('shippingMethod.storeLocationInfo') }}</p>\n        </div>\n        <h2 class=\"receipt title\">{{content('done.purchaseDetails')}}</h2>\n        <div id=\"receiptNumber\"> {{content('done.receiptNumber')}} {{checkoutSession.transactionDetails.receipt_id}}</div>\n        <div class=\"text\">\n            <div>{{content('done.confirmation')}}</div>\n            <div id=\"buyerEmail\">{{checkoutSession.payer.email}}</div>\n        </div>\n        <h2 text-align=\"left\" class=\"receipt title\">{{content('done.merchantDetails')}}</h2>\n        <div class=\"text\" id=\"merchantInfoSection\">\n            <div><span directionality-text=\"checkoutAppData.merchant.brand_name\">{{checkoutAppData.merchant.brand_name}}</span></div>\n            <div ng-if=\"checkoutAppData.merchant.phone\">{{checkoutAppData.merchant.phone}}</div>\n            <div id=\"merchantEmail\" ng-if=\"checkoutAppData.merchant.merchant_email\">{{checkoutAppData.merchant.merchant_email}}</div>\n        </div>\n        <div ng-if=\"checkoutAppData.urls.return_url\" id=\"button\" class=\"buttons reviewButton\">\n            <input track-submit type=\"submit\" value=\"{{content('common.returnToDefaultMerchant')}}\" id=\"merchantReturnBtn\"\n                   class=\"btn btn-secondary full submit receipt ng-binding ng-scope\" ng-click=\"returnToMerchant()\" />\n        </div>\n    </div>\n    <div class=\"essentials autoReturnSection\" ng-if=\"isAutoReturn\">\n        <div>{{content('done.paymentCompleted')}}</div>\n        <div ng-click=\"autoReturnStatementClick($event)\" bind-html-compile=\"htmlContent(autoReturnContentKey, {merchantName: checkoutAppData.merchant.brand_name, autoReturnUrl: checkoutAppData.urls.return_url})\"/>\n    </div>\n</div>\n"

/***/ }),

/***/ "./components/xo-guest-components/src/multistep-signup/route.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-guest-components/src/multistep-signup/directive.js"), __webpack_require__("./components/xo-guest-components/src/multistep-signup/addCard/route.js"), __webpack_require__("./components/xo-guest-components/src/multistep-signup/addShipping/route.js"), __webpack_require__("./components/xo-guest-components/src/multistep-signup/createAccount/route.js"), __webpack_require__("./components/xo-guest-components/src/multistep-signup/addressNormalization/route.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('xo-multistep-signup.route', ['squid', 'xo-multistep-signup.directive', 'xo-multistep-signup-add-card.route', 'xo-multistep-signup-add-shipping.route', 'xo-multistep-signup-create-account.route', 'xo-multistep-signup-address-normalization.route']).factory('$MultistepSignupRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('MultistepSignupRoute', {
	            name: 'multistepsignup',
	
	            directive: 'xo-multistep-signup',
	
	            children: [{
	                name: '$MultistepSignupAddCardRoute',
	                attributes: {
	                    token: 'token',
	                    'multistep-signup-model': 'multistepSignupModel',
	                    'position-to-error-field': 'positionToErrorField',
	                    'back-state': 'backState',
	                    'backend-error': 'backendError',
	                    'clear-backend-error': 'clearBackendError',
	                    'normalize-address': 'normalizeAddress',
	                    'prefill-address-common': 'prefillAddressCommon',
	                    'button-params': 'buttonParams'
	                }
	            }, {
	                name: '$MultistepSignupAddShippingRoute',
	                attributes: {
	                    token: 'token',
	                    'multistep-signup-model': 'multistepSignupModel',
	                    'position-to-error-field': 'positionToErrorField',
	                    'back-state': 'backState',
	                    'backend-error': 'backendError',
	                    'clear-backend-error': 'clearBackendError',
	                    'normalize-address': 'normalizeAddress',
	                    'prefill-address-common': 'prefillAddressCommon'
	                }
	            }, {
	                name: '$MultistepSignupCreateAccountRoute',
	                attributes: {
	                    token: 'token',
	                    'multistep-signup-model': 'multistepSignupModel',
	                    'position-to-error-field': 'positionToErrorField',
	                    'back-state': 'backState',
	                    'backend-error': 'backendError',
	                    'clear-backend-error': 'clearBackendError'
	                }
	            }, {
	                name: '$MultistepSignupAddressNormalizationRoute',
	                attributes: {
	                    token: 'token',
	                    address: 'multistepSignupModel.onboard.toBeNormalizedAddress',
	                    'done-fn': 'uponNormalization'
	                }
	            }]
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-guest-components/src/multistep-signup", "components/xo-guest-components/src/multistep-signup/route.js"))

/***/ }),

/***/ "./components/xo-guest-components/src/multistep-signup/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/module.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-guest-components/src/multistep-signup/template.html"), __webpack_require__("./components/xo-guest-components/src/multistep-signup/index.js"), __webpack_require__("./components/xo-models/src/onboard/index.js"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/address/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular, module, template) {
	
	    return angular.module('xo-multistep-signup.directive', ['squid', 'xomultistepsignupmodel', 'xomodel.onboard', 'xomodel.checkout', 'xomodel.address', 'xo-fi-contingency-list.util']).directive('xoMultistepSignup', function ($rootScope) {
	
	        return {
	            template: template,
	
	            scope: {
	                token: '=',
	                parentCallbacks: '=',
	                buttonParams: '='
	            },
	
	            controller: function controller($populate, $scope, $state, $locale, $MultistepSignupModel, $OnboardModel, $logger, $PrefillAddressModel, $OnboardUserModel, $OnboardPhoneModel, $ShippingAddressModel, $BillingAddressModel, $InstallmentOptionsModel, $location, $feature, $timeout, $CheckoutPayeeModel, $CheckoutCartModel, $CheckoutAppDataModel, $fiErrorUtil, $util) {
	
	                $scope.locale = $locale;
	
	                $scope.multistepSignupModel = $MultistepSignupModel.instance();
	
	                function triggerPageDesignFPTILog() {
	                    var pageContext = 'Full-context';
	                    if ($rootScope.miniBrowser) {
	                        pageContext = 'In-context';
	                    }
	
	                    $logger.info('checkout_fpti', {
	                        'design': pageContext
	                    });
	                }
	                // Log Initial Page Design
	                triggerPageDesignFPTILog();
	                // Trigger Design FPTI Log on Page Design Change
	                $rootScope.$watch('miniBrowser', triggerPageDesignFPTILog);
	
	                var normalizeCallback;
	                var lastPrefillCall;
	
	                function sanitizeZip(value) {
	                    return (value || '').replace(/[^0-9]+/g, '');
	                }
	
	                $scope.multistepSignupModel.onboard = new $OnboardModel({
	
	                    user: $OnboardUserModel.instance($scope.token, {
	                        country: $locale.country
	                    }),
	
	                    billing_address: $BillingAddressModel.create($scope.token, {
	                        country: $locale.country
	                    }),
	
	                    shipping_address: $ShippingAddressModel.create($scope.token, {
	                        country: $locale.country
	                    }),
	
	                    phone: new $OnboardPhoneModel()
	                });
	
	                $scope.multistepSignupModel.onboard.card.ppconversion = 'PAYPAL';
	
	                // remove this upon oas ramp completion
	                $scope.multistepSignupModel.onboard.testParams = {
	                    oas: $util.param('oas'),
	                    cardCandidate: $util.param('cardCandidate')
	                };
	
	                $populate($scope, {
	                    checkoutCart: $CheckoutCartModel.instance($scope.token)
	                }).then(function () {
	                    $scope.multistepSignupModel.onboard.user.email = $scope.checkoutCart.payer && $scope.checkoutCart.payer.email;
	                });
	
	                $scope.multistepSignupModel.onboard.shipping_address.setProperties({
	                    first_name: '',
	                    last_name: ''
	                });
	
	                $scope.multistepSignupModel.onboard.billing_address.setProperties({
	                    first_name: '',
	                    last_name: ''
	                });
	
	                $scope.multistepSignupModel.flags = {
	                    mode: 'signup',
	                    shipToBilling: true,
	                    allowEditShipping: true,
	
	                    billingAddress: {
	                        addrPrefilled: false
	                    },
	                    shippingAddress: {
	                        addrPrefilled: false
	                    }
	                };
	
	                function sortCountryList() {
	                    $scope.metadata = angular.copy($locale.metadata);
	                    return $scope.metadata.territory;
	                }
	
	                $scope.multistepSignupModel.countries = sortCountryList();
	
	                $scope.positionToErrorField = function positionToErrorField() {
	                    var errorFields = $('.backendError:visible, input:visible.ng-invalid, select:visible.ng-invalid');
	
	                    var firstErrorField = errorFields && errorFields.length && errorFields[0];
	                    if (firstErrorField) {
	                        firstErrorField.focus();
	                        window.document.body.scrollTop = $(firstErrorField).offset().top;
	                    } else {
	                        // If there are no field errors and only page level errors.
	                        window.document.body.scrollTop = 0;
	                    }
	
	                    $('.backendError:visible').on('blur', function (event) {
	                        $(this).removeClass('backendError');
	                    });
	
	                    if ($('#installments').length) {
	                        $('#paymentMethod').addClass('ng-invalid');
	                    } else {
	                        $('#paymentMethod').removeClass('ng-invalid');
	                    }
	
	                    return true;
	                };
	
	                $scope.backState = function backState() {
	                    history.back();
	                    // $scope.$apply();
	                };
	
	                $scope.backendError = function backendError(pageName) {
	                    $timeout(function () {
	                        var modelErrors = $scope.multistepSignupModel.pageError;
	
	                        if (modelErrors && modelErrors[pageName]) {
	                            var pageErrors = modelErrors[pageName];
	
	                            pageErrors.forEach(function (err) {
	                                if (err.name) {
	                                    // Highlight the Error Fields by name
	                                    $fiErrorUtil.addFieldErrorsByName(err, 'form', err.name);
	                                } else {
	                                    // Highlight the Error Fields by ng-model
	                                    $fiErrorUtil.addFieldErrors(err, 'form', err.model);
	                                }
	                            });
	                        }
	                    }, 10);
	                };
	
	                $scope.clearBackendError = function clearBackendError(pageName) {
	                    if ($scope.multistepSignupModel.pageError) {
	                        $scope.multistepSignupModel.pageError[pageName] = [];
	                    }
	                };
	
	                $scope.normalizeAddress = function normalizeAddress(address, callback) {
	                    $scope.multistepSignupModel.onboard.toBeNormalizedAddress = address;
	                    $state.go('checkout.multistepsignup.multistepsignupaddressnormalization');
	                    normalizeCallback = callback;
	                };
	
	                $scope.prefillAddressCommon = function (postal_code, address, user, flag, override) {
	
	                    if (!postal_code) {
	                        return;
	                    }
	
	                    if (!override && lastPrefillCall === sanitizeZip(postal_code)) {
	                        return;
	                    }
	
	                    $scope.prefillAddress = new $PrefillAddressModel({
	                        id: $scope.token,
	                        address: {
	                            country: $locale.country,
	                            postal_code: postal_code
	                        }
	                    });
	
	                    $scope.prefillAddress.save({
	                        data: $scope.prefillAddress,
	
	                        success: function success(result) {
	
	                            if (result) {
	                                lastPrefillCall = sanitizeZip(result.postal_code);
	                                address.setProperties(result);
	                            }
	
	                            if (address.name) {
	                                var names = util.nameUtil.splitName(address.name); // eslint-disable-line block-scoped-var,no-undef
	                                user.setProperties(names);
	                            }
	
	                            flag.addrPrefilled = true;
	
	                            $timeout(function () {
	                                flag.addrPrefilled = true;
	                            }, 1000);
	                        },
	
	                        contingencies: {
	                            DEFAULT: function DEFAULT() {
	                                flag.addrPrefilled = true;
	                            }
	                        }
	                    });
	                };
	
	                $scope.uponNormalization = function uponNormalization(normalizedAddress, isBack) {
	                    if (normalizeCallback) {
	                        normalizeCallback(normalizedAddress, isBack);
	                    }
	                };
	
	                /* Eligibility Check call is done only after first load. Hence is done in the parent directive
	                 * and not in addCard directive. Addcard directive will be called after each back button
	                 * rendering
	                 */
	                function isInstallmentEligible() {
	
	                    $populate($scope, {
	                        payee: $CheckoutPayeeModel.instance($scope.token),
	                        checkoutCart: $CheckoutCartModel.instance($scope.token),
	                        checkoutAppData: $CheckoutAppDataModel.instance($scope.token)
	                    }).then(function () {
	
	                        if ($scope.checkoutCart.isBilling()) {
	                            // Reference transaction detected
	                            $location.path('/checkout/multistepsignup/multistepsignupaddcard').replace();
	                        } else {
	                            $scope.multistepSignupModel.eligibilityModel = {};
	
	                            var installments = $InstallmentOptionsModel.instance($scope.token);
	
	                            /* Updating the eligibilityModel with the installment response.
	                             * Show Or hide of installment depends upon the card type.
	                             * Card model changes for type is checked in addCard directive to determine installment display.
	                             */
	                            installments.save({
	                                data: {
	                                    payee: $scope.payee,
	                                    checkoutCart: $scope.checkoutCart,
	                                    checkoutAppData: $scope.checkoutAppData
	                                },
	
	                                resultModel: $scope.multistepSignupModel.eligibilityModel
	
	                            }).then(function () {
	                                $location.path('/checkout/multistepsignup/multistepsignupaddcard').replace();
	                            });
	                        }
	                    });
	                }
	
	                if ($feature('installments', false, $locale.country)) {
	                    isInstallmentEligible();
	                } else {
	                    // BUG - switching from BR to RU country needs this timeout
	                    // Without timeout the route change is so fast that it just loads an empty cached page
	                    // without the form elements
	                    $timeout(function () {
	                        $location.path('/checkout/multistepsignup/multistepsignupaddcard').replace();
	                    });
	                }
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-guest-components/src/multistep-signup/template.html":
"../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-card/template.html",

/***/ "./components/xo-guest-components/src/multistep-signup/index.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xomultistepsignupmodel', ['squid']).factory('$MultistepSignupModel', function ($Model) {
	        return $Model.extend('MultistepSignupModel', {});
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-guest-components/src/multistep-signup", "components/xo-guest-components/src/multistep-signup/index.js"))

/***/ }),

/***/ "./components/xo-guest-components/src/multistep-signup/addCard/route.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-guest-components/src/multistep-signup/addCard/directive.js"), __webpack_require__("./pages/xo-sidebar/route.js"), __webpack_require__("./components/xo-guest-components/src/guest/currencyConversion/route.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('xo-multistep-signup-add-card.route', ['squid', 'xo-multistep-signup-add-card.directive', 'hermes.page.xo-sidebar.route']).factory('$MultistepSignupAddCardRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('MultistepSignupAddCardRoute', {
	            name: 'multistepsignupaddcard',
	
	            directive: 'xo-multistep-signup-add-card',
	
	            children: [{
	                name: '$SidebarRoute',
	                attributes: {
	                    'back-uri': 'backUri',
	                    'parent-model': 'multistepSignupModel'
	                }
	            }, {
	                name: '$CurrencyConversionOptionsRoute',
	                attributes: {
	                    token: 'token',
	                    'parent-model': 'multistepSignupModel',
	                    'is-pre-plan': 'true',
	                    'done-fn': 'onCurrencyConversionDone'
	                }
	            }]
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-guest-components/src/multistep-signup/addCard", "components/xo-guest-components/src/multistep-signup/addCard/route.js"))

/***/ }),

/***/ "./components/xo-guest-components/src/multistep-signup/addCard/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-guest-components/src/multistep-signup/addCard/template.html"), __webpack_require__("./components/xo-guest-components/src/multistep-signup/lib/util.js"), __webpack_require__("./components/xo-page-components/src/value-props/directive.js"), __webpack_require__("./components/xo-form-components/src/phone/phoneInput/directive.js"), __webpack_require__("./components/xo-form-components/src/name-input/directive.js"), __webpack_require__("./components/xo-guest-components/src/guest/emailInput/directive.js"), __webpack_require__("./components/xo-guest-components/src/guest/passwordInput/directive.js"), __webpack_require__("./components/xo-guest-components/src/guest/countryList/directive.js"), __webpack_require__("./components/xo-guest-components/src/guest/sepa/directive.js"), // TODO: Check if its used
	__webpack_require__("./components/xo-guest-components/src/guest/select-shipping-method/directive.js"), __webpack_require__("./components/xo-models/src/onboard/index.js"), __webpack_require__("./components/xo-guest-components/src/login-button/directive.js"), __webpack_require__("./components/xo-locale/dist/index.js"), __webpack_require__("./components/xo-locale/dist/helper.js"), __webpack_require__("./components/xo-models/src/address/index.js"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/shippingMethod/index.js"), __webpack_require__("./components/xo-ui-components/src/ui-utils/directive.js"), __webpack_require__("./components/xo-ui-components/src/accessibility/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, module, template, util) {
	    return angular.module('xo-multistep-signup-add-card.directive', ['squid', 'xo-value-props.directive', 'xo-phone.phoneInput', 'xo-name-input.directive', 'xo-guest.emailInput', 'xo-guest.passwordInput', 'xo-guest.countryList', 'xo-onboard.sepa.directive', // TODO: Check if its used
	    'xo-guest-select-shipping-method.directive', 'xomodel.onboard', 'xo-login-button.directive', 'locale.helper', 'xomodel.address', 'xomodel.checkout', 'xo-ui-utils.directive', 'xo-accessibility.directive']).directive('formErrorDetect', function () {
	
	        return function ($scope, el, attrs) {
	            $scope.$watch(attrs.name + '.$error', function (newVal, oldVal) {
	                var cardModel = $scope.multistepSignupModel.onboard.card;
	
	                /*
	                 * Here we are making sure that both luhn and len validation
	                 * together marks the cardModel validity which in-tern handles
	                 * form submit and validity in front-end
	                 * Background:
	                 * card input element has luhn and len validation as part of
	                 * ui-validate util
	                 */
	                if (newVal.luhn && newVal.luhn[0].$invalid || newVal.len && newVal.len[0].$invalid) {
	                    cardModel.valid = false;
	                } else {
	                    cardModel.valid = true;
	                }
	            }, true);
	        };
	    }).directive('xoMultistepSignupAddCard', function () {
	
	        return {
	            template: template,
	
	            scope: {
	                token: '=',
	                parentCallbacks: '=',
	                multistepSignupModel: '=',
	                positionToErrorField: '=',
	                backState: '=',
	                backendError: '=',
	                clearBackendError: '=',
	                normalizeAddress: '=',
	                prefillAddressCommon: '=',
	                buttonParams: '='
	            },
	
	            link: function link($scope) {
	
	                $scope.$watch(function () {
	                    return $scope.multistepSignupModel.onboard.card.number;
	                }, function cardNumberChangeHandler(newValue, oldValue) {
	                    // Sanitize the values
	                    newValue = newValue ? newValue.replace(/ /g, '').toLowerCase() : null;
	                    oldValue = oldValue ? oldValue.replace(/ /g, '').toLowerCase() : null;
	
	                    if (newValue) {
	                        if (newValue !== oldValue) {
	                            if ($scope.multistepSignupModel.selectedInstallmentData && !$scope.multistepSignupModel.selectedInstallmentData.preventChange) {
	                                // Resetting selected installment data, if installment change is not explicitly prohibited.
	                                $scope.multistepSignupModel.selectedInstallmentData = undefined;
	                            }
	                        }
	                    }
	                });
	
	                $scope.$watch(function () {
	                    return $scope.multistepSignupModel.onboard.card.type;
	                }, function cardTypeChangeHandler(newValue, oldValue) {
	                    // Sanitize the values
	                    newValue = newValue ? newValue.replace(/ /g, '').toLowerCase() : null;
	
	                    var eligibilityModel = $scope.multistepSignupModel.eligibilityModel;
	                    var cardNetwork;
	
	                    if (newValue && eligibilityModel && eligibilityModel.installments && eligibilityModel.installments.length > 0) {
	
	                        eligibilityModel.installments.some(function cardCheck(card, index, array) {
	                            if (card.cardInfo && card.cardInfo.card_type && card.cardInfo.card_type.toLowerCase() === newValue) {
	                                // Card Network Found
	                                cardNetwork = card;
	                                return true;
	                            }
	                        });
	
	                        if (cardNetwork && cardNetwork.installment_options && cardNetwork.installment_options.length > 0) {
	                            // Card network && installments found
	                            if (cardNetwork.installment_options.length === 1) {
	                                $scope.multistepSignupModel.selectedInstallmentData = {
	                                    installment_option_selected: cardNetwork.installment_options[0],
	                                    preventChange: true
	                                };
	                            }
	
	                            $scope.multistepSignupModel.allowInstallments = true;
	                        } else {
	                            // Card network does not exists Or No installment found
	                            $scope.multistepSignupModel.allowInstallments = false;
	                        }
	                    } else {
	                        $scope.multistepSignupModel.allowInstallments = false;
	                    }
	                });
	
	                $scope.$on('$destroy', function () {
	                    $scope.clearBackendError('multistepsignupaddcard');
	                });
	
	                if ($scope.backendError) {
	                    $scope.backendError('multistepsignupaddcard');
	                }
	            },
	
	            controller: function controller($scope, $rootScope, $populate, $state, $util, $locale, $feature, $q, $CheckoutAppDataModel, $ShippingRuleSummaryModel, $CheckoutPayeeModel, $CheckoutCartModel, $BillingAddressModel, $ShippingAddressModel, $PrefillAddressModel, $pxpFactors, $config, $dispatch, $localeHelper, $location, $meta) {
	
	                $scope.locale = $locale;
	                $scope.formattedValues = {};
	                $scope.backUri = 'checkout.multistepsignup.multistepsignupaddcard';
	                $scope.normalize = $feature('addressNormalization', false, $locale.country);
	                $scope.componentsFlag = util.componentsMap($locale.country);
	
	                $scope.onCurrencyConversionDone = function () {
	                    $state.go($scope.backUri);
	                };
	
	                $scope.$on('localeChange', function () {
	                    $scope.componentsFlag = util.componentsMap($locale.country);
	                    $scope.multistepSignupModel.onboard.billing_address.country = $locale.country;
	                    $scope.multistepSignupModel.onboard.shipping_address.country = $locale.country;
	                });
	
	                $scope.zipMasking = function (newValue) {
	                    $scope.formattedValues.postalCode = util.maskingUtil.maskZip(newValue);
	                    $scope.multistepSignupModel.onboard.billing_address.postal_code = $scope.formattedValues.postalCode.replace(/[^0-9]/gi, '');
	                };
	
	                function checkShippingRulesExist() {
	                    if ($scope.multistepSignupModel.wps_flow) {
	                        return $populate($scope, {
	                            shippingRulesSummary: $ShippingRuleSummaryModel.instance($rootScope.token).retrieve({
	                                params: {
	                                    merchant_id: $scope.payee.merchant.id,
	                                    currency_code: $scope.checkoutCart.purchase.amounts.total.currency_code
	                                }
	                            })
	                        }).then(function () {
	                            if ($scope.shippingRulesSummary.isSnTEnabled) {
	                                $scope.multistepSignupModel.SnT_flow = true;
	                            }
	                        });
	                    } else {
	                        return $q.when();
	                    }
	                }
	
	                $scope.isInstallmentsVisible = function isInstallmentsVisible() {
	                    var model = $scope.multistepSignupModel;
	                    var hasConditionMet = model.allowInstallments && model.onboard.card.number && model.onboard.card.valid;
	                    var isBilling = $scope.checkoutCart.isBilling();
	
	                    return !isBilling && hasConditionMet;
	                };
	
	                if ($scope.multistepSignupModel.onboard.ue_billing_address) {
	                    $scope.multistepSignupModel.onboard.billing_address = $scope.multistepSignupModel.onboard.ue_billing_address;
	                    $scope.zipMasking($scope.multistepSignupModel.onboard.ue_billing_address.postal_code);
	                }
	
	                if ($locale.country === 'BR' && $scope.multistepSignupModel.onboard.billing_address) {
	                    $scope.multistepSignupModel.onboard.billing_address.postal_code = util.maskingUtil.maskZip($scope.multistepSignupModel.onboard.billing_address.postal_code);
	                }
	
	                $populate($scope, {
	                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
	                    payee: $CheckoutPayeeModel.instance($scope.token),
	                    checkoutCart: $CheckoutCartModel.instance($scope.token)
	                }).then(function () {
	                    $scope.multistepSignupModel.flags.allowEditShipping = $scope.checkoutAppData.get('flags.allow_change_shipping', false);
	
	                    $scope.multistepSignupModel.installmentDisabled = $scope.checkoutCart.isBilling();
	
	                    $scope.multistepSignupModel.wps_flow = $scope.checkoutAppData.doec_on_approve();
	
	                    $scope.showShippingAddress = Boolean(!$scope.checkoutAppData.flags.hide_shipping_address && $scope.checkoutAppData.flags.shipping_address_required);
	
	                    checkShippingRulesExist();
	
	                    $scope.prefill = function () {
	                        var postal_code = $scope.multistepSignupModel.onboard.billing_address.postal_code;
	
	                        $scope.prefillAddressCommon(postal_code, $scope.multistepSignupModel.onboard.billing_address, $scope.multistepSignupModel.onboard.user, $scope.multistepSignupModel.flags.billingAddress, false);
	                    };
	
	                    // Get merchant passed shipping address from either purchase plan or billing agreement plan
	                    var merchantSuppliedAddress = $scope.checkoutCart.get('purchase.shipping_address') || $scope.checkoutCart.get('billing.shipping_address');
	                    var merchantSuppliedNumber = $scope.checkoutCart.get('purchase.phone_fields') || $scope.checkoutCart.get('billing.phone_fields');
	
	                    if (merchantSuppliedAddress && !$scope.multistepSignupModel.onboard.ue_billing_address) {
	                        $scope.multistepSignupModel.onboard.billing_address = $BillingAddressModel.create($scope.token, {
	                            country: $locale.country
	                        }, merchantSuppliedAddress);
	
	                        $scope.prefill();
	
	                        $scope.zipMasking($scope.multistepSignupModel.onboard.billing_address.postal_code);
	
	                        $scope.multistepSignupModel.onboard.billing_address.postal_code = $scope.formattedValues.postalCode;
	                        $scope.multistepSignupModel.onboard.user.first_name = merchantSuppliedAddress.first_name;
	                        $scope.multistepSignupModel.onboard.user.last_name = merchantSuppliedAddress.last_name;
	                    }
	
	                    if (merchantSuppliedNumber && merchantSuppliedNumber.telephone_country === $locale.country) {
	                        $scope.multistepSignupModel.onboard.phone.telephone = merchantSuppliedNumber.normalized_phone_number;
	                    }
	                });
	
	                var brPxp;
	                if (!$rootScope.miniBrowser && $locale.country === 'BR') {
	                    brPxp = $config.pxpExperiments.BR.xo_br_hermesnode_addcard_design;
	                    $pxpFactors(brPxp.pgName, brPxp.params, brPxp.pattern).then(function (result) {
	                        $scope.addCardDesignExp = result;
	                    });
	                }
	                var basl_hermes_xoon_redirect = $util.param('hermesXoonRedirect') || $meta.query && $meta.query.hermesXoonRedirect;
	                var basl_abtest_throttle = $util.param('abTestThrottle') || $meta.query && $meta.query.abTestThrottle;
	
	                $scope.showLogin = basl_hermes_xoon_redirect || basl_abtest_throttle;
	
	                $scope.redirect = function () {
	                    $dispatch('hermes', {
	                        hermesLoginRedirect: 'xoon',
	                        token: $scope.token,
	                        'locale.x': $locale.lang + '_' + $locale.country,
	                        'country.x': $locale.country
	                    });
	                };
	
	                $scope.uponNormalization = function (normalizedAddress, isBack) {
	                    if (isBack) {
	                        $location.path('/checkout/multistepsignup/multistepsignupaddcard').replace();
	                    } else {
	                        $scope.normalize = false;
	                        $scope.multistepSignupModel.onboard.billing_address.setProperties(normalizedAddress);
	
	                        if ($scope.multistepSignupModel.flags.shipToBilling) {
	                            $location.path('/checkout/multistepsignup/multistepsignupcreateaccount').replace();
	                        } else {
	                            $location.path('/checkout/multistepsignup/multistepsignupaddshipping').replace();
	                        }
	                    }
	                };
	
	                $scope.changeCountry = function changeCountry() {
	                    if ($scope.multistepSignupModel.onboard.shipping_address.country && $scope.multistepSignupModel.onboard.shipping_address.country !== $locale.country) {
	                        $scope.multistepSignupModel.onboard.shippingCountryChanged = true;
	                        $rootScope.$broadcast('countryChange', $scope.multistepSignupModel.onboard.shipping_address.country);
	                    } else {
	                        $scope.multistepSignupModel.onboard.shippingCountryChanged = false;
	                    }
	                };
	
	                $scope.onSubmit = function onSubmit() {
	                    // Backup user entered address
	                    $scope.multistepSignupModel.onboard.ue_billing_address = $BillingAddressModel.create($scope.token, {
	                        country: $locale.country
	                    }, $scope.multistepSignupModel.onboard.billing_address);
	
	                    if ($scope.componentsFlag.shippingAddress) {
	                        $scope.multistepSignupModel.onboard.ue_shipping_address = $ShippingAddressModel.create($scope.token, {
	                            country: $locale.country
	                        }, $scope.multistepSignupModel.onboard.shipping_address);
	                    }
	
	                    // Remove phone formatting
	                    $scope.multistepSignupModel.onboard.phone.telephone = $scope.multistepSignupModel.onboard.phone.telephone.replace(/[^0-9]/gi, '');
	
	                    if ($scope.normalize) {
	                        $scope.clearBackendError('multistepsignupaddcard');
	                        $scope.normalizeAddress($scope.multistepSignupModel.onboard.billing_address, $scope.uponNormalization);
	                    } else if ($scope.componentsFlag.shippingAddressPage) {
	                        if (!$scope.multistepSignupModel.flags.shipToBilling) {
	                            $state.go('checkout.multistepsignup.multistepsignupaddshipping');
	                        }
	                    } else {
	                        $state.go('checkout.multistepsignup.multistepsignupcreateaccount');
	                    }
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-guest-components/src/multistep-signup/addCard/template.html":
/***/ (function(module, exports) {

	module.exports = "<section class=\"multistepAddCard\" id=\"multistepAddCard\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <xo-login-button ng-if=\"showLogin\" redirect=\"redirect\"></xo-login-button>\n            <xo-message message=\"multistepSignupModel.pageError.multistepsignupaddcard.errorMessage\"></xo-message>\n            <h1 class=\"alpha\">{{content('largeScreenPayment.title')}}</h1>\n            <p class=\"subTitle\">{{content('largeScreenPayment.titleProp')}}</p>\n\n            <form id=\"multistepAddCardForm\" name=\"multistepAddCardForm\" class=\"multistepSignupForm\"\n                  ng-submit=\"multistepAddCardForm.$valid && onSubmit()\" ng-class=\"{'validated': validated}\"\n                  novalidate form-error-detect>\n\n                <xo-country-list token=\"token\" show-mask=\"showMask\"></xo-country-list>\n                <div ng-class=\"{'showMask': showMask}\" disable-form=\"showMask\">\n                    <xo-credit-card token=\"token\" card=\"multistepSignupModel.onboard.card\" user=\"multistepSignupModel.onboard.user\" name-below=\"true\"></xo-credit-card>\n\n                    <div ng-if=\"isInstallmentsVisible()\" class=\"installment\">\n                        <a ng-if=\"!multistepSignupModel.selectedInstallmentData.preventChange\" focus-when=\"multistepSignupModel.selectedInstallmentData\" id=\"paymentMethod\" ui-sref=\"checkout.multistepsignup.multistepsignupaddcard.sidebar.installmentOptions\" class=\"getInstallments installmentsDropDown btn btn-secondary\" scroll-top=\"scroll-top\">\n                            <span ng-if=\"multistepSignupModel.selectedInstallmentData\">\n                                {{multistepSignupModel.selectedInstallmentData.installment_option_selected.term}}X {{content('paymentMethod.of')}} {{multistepSignupModel.selectedInstallmentData.installment_option_selected.monthly_payment.formatted_value}}\n                            </span>\n                            <span ng-if=\"!multistepSignupModel.selectedInstallmentData\">\n                                {{content('paymentMethod.changeInstallmentLongLink')}}\n                            </span>\n                        </a>\n                        <a ng-if=\"multistepSignupModel.selectedInstallmentData.preventChange\"\n                           class=\"getInstallments btn btn-secondary\" disabled>\n                            <span ng-if=\"multistepSignupModel.selectedInstallmentData\">\n                                {{multistepSignupModel.selectedInstallmentData.installment_option_selected.term}}X {{content('paymentMethod.of')}} {{multistepSignupModel.selectedInstallmentData.installment_option_selected.monthly_payment.formatted_value}}\n                            </span>\n                        </a>\n                        <div ng-if=\"multistepSignupModel.selectedInstallmentData.preventChange\" class=\"installmentHelper\">\n                            <a href=\"#\" id=\"installmentHelp\" alt=\"{{ content('common.altHelp') }}\" class=\"verifyHelp\">\n                            </a>\n                        </div>\n                        <xo-tooltip ng-if=\"multistepSignupModel.selectedInstallmentData.preventChange\" trigger=\"#installmentHelp\">\n                            <div class=\"tip tipDesc emailToolTip\">\n                                {{ content('paymentMethod.installmentPreselectedHelp') }}\n                            </div>\n                        </xo-tooltip>\n                    </div>\n\n                    <input ng-if=\"isInstallmentsVisible() && !multistepSignupModel.selectedInstallmentData\"\n                           type=\"text\"\n                           name=\"installments\"\n                           id=\"installments\"\n                           ng-model=\"multistepSignupModel.selectedInstallmentData.installment_option_selected.term\"\n                           value=\"\"\n                           class=\"hiddenInput ng-pristine\"\n                           required/>\n\n                    <xo-name-input user=\"multistepSignupModel.onboard.user\"></xo-name-input>\n\n                    <div id=\"billingAddress\">\n                        <div class=\"inputField confidential zip\" ng-if=\"componentsFlag.zipCode\" floating-label>\n\n                            <input type=\"text\"\n                                   name=\"zip\"\n                                   id=\"zip\"\n                                   ng-model=\"formattedValues.postalCode\"\n                                   value=\"\"\n                                   autocapitalize=\"off\"\n                                   aria-required=\"true\"\n                                   autocomplete=\"off\"\n                                   data-error-key=\"common.valueInvalid\"\n                                   ng-blur=\"prefill(false)\"\n                                   xo-error-tooltip\n                                   maxlength=\"9\"\n                                   ng-change=\"zipMasking(formattedValues.postalCode)\"\n                                   required/>\n                            <label for=\"zip\" id=\"zipLabel\" >{{ content('common.cep') }}</label>\n                        </div>\n\n\n                        <div ng-if=\"componentsFlag.billingAddressLabel\">\n                            <label class=\"labelHeight\">{{ content('addressBook.billingAddress') }}</label>\n                        </div>\n\n                        <div ng-if=\"multistepSignupModel.flags.billingAddress.addrPrefilled || locale.country!=='BR'\">\n                            <xo-add-address address=\"multistepSignupModel.onboard.billing_address\" hide-cep=\"true\" country=\"locale.country\"></xo-add-address>\n                        </div>\n                    </div>\n\n                    <xo-phone-input phone=\"multistepSignupModel.onboard.phone\" countryCode=\"locale.country\"></xo-phone-input>\n\n                    <div class=\"row-fluid checkbox shipToBillingContainer\" ng-if=\"multistepSignupModel.flags.allowEditShipping\">\n                        <input ng-model=\"multistepSignupModel.flags.shipToBilling\" type=\"checkbox\" name=\"shipToBilling\" id=\"shipToBilling\"\n                               class=\"shipToBilling\"/>\n                        <label class=\"noBottom\" for=\"shipToBilling\"\n                               ng-bind-html=\"htmlContent('largeScreenPayment.shipTo')\"></label>\n                    </div>\n\n                    <div ng-if=\"componentsFlag.shippingAddress\">\n                        <div id=\"shippingAddress\" class=\"billingAddressPadding\" ng-if=\"!multistepSignupModel.flags.shipToBilling\">\n                            <label class=\"labelHeight\">{{ content('shipping.shippingTitle') }}</label>\n\n                            <xo-name-input user=\"multistepSignupModel.onboard.shipping_address\"></xo-name-input>\n\n                            <span feature=\"changeShippingCountry\">\n                                <div class=\"dropdown confidential country clearfix inputField\" floating-label-dropdown>\n                                    <select xo-dropdown name=\"country\" ng-model=\"multistepSignupModel.onboard.shipping_address.country\" id=\"country\"\n                                            aria-labelledby=\"countryLabel\" ng-change=\"changeCountry()\" xo-error-tooltip required>\n                                            <option ng-repeat=\"country in multistepSignupModel.countries\" value=\"{{country.code}}\" ng-selected=\"multistepSignupModel.onboard.shipping_address.country === country.code\">{{country.name}}</option>\n                                    </select>\n                                    <label for=\"country\" id=\"countryLabel\">{{ content('common.country') }}</label>\n                                </div>\n                            </span>\n\n                            <xo-add-address address=\"multistepSignupModel.onboard.shipping_address\" hide-cep=\"true\" hide-name=\"true\" is-shipping=\"true\" token=\"token\"\n                                            country=\"multistepSignupModel.onboard.shipping_address.country\"></xo-add-address>\n                        </div>\n                    </div>\n\n                    <div id=\"shippingMethod\" ng-if=\"multistepSignupModel.wps_flow && multistepSignupModel.SnT_flow\">\n                        <xo-guest-select-shipping-method token=\"token\"\n                                                         show-shipping =\"showShippingAddress\"\n                                                 billing-address=\"multistepSignupModel.onboard.billing_address\"\n                                                 shipping-address=\"multistepSignupModel.onboard.shipping_address\"\n                                                 is-shipping-same-as-billing=\"multistepSignupModel.flags.shipToBilling\"\n                                                 button-params=\"buttonParams\"\n                                                 flags = \"multistepSignupModel.flags\"></xo-guest-select-shipping-method>\n                    </div>\n\n                    <div class=\"buttons visible\">\n                        <!--<a id=\"backButton\" class=\"btn btn-secondary half\"\n                           ng-click=\"backState($event)\">\n                            {{ content('common.back') }}\n                        </a>-->\n\n                        <input track-submit id=\"addCardSubmit\" type=\"submit\"\n                               value=\"{{ content('common.continueLabel') }}\"\n                               class=\"btn half signupFlowSubmit\"\n                               ng-click=\"validated=true && positionToErrorField()\"/>\n                    </div>\n                </div>\n            </form>\n            <div ui-view></div>\n        </div>\n        <div class=\"span10\" ng-if=\"!addCardDesignExp\">\n            <xo-value-props type=\"review\" title=\"{{content('guestVerify.propHead')}}\" text-content=\"guestVerify.propVal\"></xo-value-props>\n        </div>\n        <div class=\"span10\" ng-if=\"addCardDesignExp\">\n            <xo-value-props type=\"review\" title=\"{{content(addCardDesignExp.propHeader)}}\" text-content=\"{{addCardDesignExp.propText}}\" image-url=\"{{addCardDesignExp.propImage}}\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "./components/xo-guest-components/src/multistep-signup/lib/util.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    var name = {
	        splitName: function splitName(fullName) {
	            var index = fullName.indexOf(' ');
	            return {
	                first_name: index > 0 ? fullName.substr(0, index) : fullName,
	                last_name: index > 0 ? fullName.substr(index + 1) : ''
	            };
	        }
	    };
	
	    var masking = {
	        maskZip: function maskZip(value) {
	            if (value) {
	                var unformatted = value.replace(/[^0-9]/gi, '');
	                return unformatted.length > 5 ? [unformatted.slice(0, 5), '-', unformatted.slice(5)].join('') : unformatted;
	            }
	
	            return '';
	        }
	    };
	
	    var validateLegalAge = function validateLegalAge(dobMonth, dobDay, dobYear) {
	        var currentDate = new Date();
	        var currentMonth = currentDate.getMonth() + 1;
	        var currentDay = currentDate.getDate();
	        var currentYear = currentDate.getFullYear();
	        var largestDOBYear = currentYear - 18; // Legal age is 18
	
	        var isLegal = dobYear < largestDOBYear || dobYear === largestDOBYear && dobMonth < currentMonth || dobYear === largestDOBYear && dobMonth === currentMonth && dobDay <= currentDay;
	
	        return isLegal;
	    };
	
	    var componentsMap = function componentsMap(locale) {
	        var flags = {};
	
	        switch (locale) {
	            case 'BR':
	                flags = {
	                    zipCode: true,
	                    billingAddressLabel: false,
	                    shippingAddress: false,
	                    shippingAddressPage: true,
	                    dobDropDown: true,
	                    addTaxId: true
	                };
	                break;
	            case 'RU':
	                flags = {
	                    zipCode: false,
	                    billingAddressLabel: true,
	                    shippingAddress: true,
	                    shippingAddressPage: false,
	                    dobDropDown: false,
	                    dobText: true
	                };
	                break;
	            default:
	                flags = {
	                    nameInput: true,
	                    zipCode: true,
	                    billingAddressLabel: true,
	                    shippingAddress: true,
	                    dobDropDown: true
	                };
	                break;
	        }
	
	        return flags;
	    };
	
	    var contingencyMap = function contingencyMap(code) {
	        var errorElementMap = {
	            INVALID_FIRST_NAME: {
	                fields: [{ field: 'first_name' }],
	                model: 'user.',
	                path: 'multistepsignupaddcard'
	            },
	            INVALID_LAST_NAME: {
	                fields: [{ field: 'last_name' }],
	                model: 'user.',
	                path: 'multistepsignupaddcard'
	            },
	            INVALID_MIDDLE_NAME: {
	                fields: [{ field: 'middle_name' }],
	                model: 'user.',
	                path: 'multistepsignupaddcard'
	            },
	            INVALID_NATIVE_FIRST_NAME: {
	                fields: [{ field: 'first_name' }],
	                model: 'user.',
	                path: 'multistepsignupcreateaccount'
	            },
	            INVALID_NATIVE_LAST_NAME: {
	                fields: [{ field: 'last_name' }],
	                model: 'user.',
	                path: 'multistepsignupcreateaccount'
	            },
	            INVALID_NATIVE_MIDDLE_NAME: {
	                fields: [{ field: 'middle_name' }],
	                model: 'user.nativeName.',
	                path: 'multistepsignupcreateaccount'
	            },
	            INVALID_PHONE_TYPE: {
	                fields: [{ field: 'phoneType' }],
	                model: 'phone.',
	                path: 'multistepsignupaddcard'
	            },
	            INVALID_PHONE_NUMBER: {
	                fields: [{ field: 'telephone' }],
	                model: 'phone.',
	                path: 'multistepsignupaddcard'
	            },
	            INVALID_CITY_STATE_ZIPCODE: {
	                fields: [{ field: 'city' }, { field: 'state' }, { field: 'zipCode' }],
	                model: 'address.',
	                path: 'multistepsignupaddcard'
	            },
	            INVALID_LINE1: {
	                fields: [{ field: 'line1' }],
	                model: 'address.',
	                path: 'multistepsignupaddcard'
	            },
	            INVALID_CITY: {
	                fields: [{ field: 'city' }],
	                model: 'address.',
	                path: 'multistepsignupaddcard'
	            },
	            INVALID_STATE: {
	                fields: [{ field: 'state' }],
	                model: 'address.',
	                path: 'multistepsignupaddcard'
	            },
	            INVALID_ZIPCODE: {
	                fields: [{ field: 'zipCode' }],
	                model: 'address.',
	                path: 'multistepsignupaddcard'
	            },
	
	            INVALID_NATIONAL_ID_TYPE: {
	                fields: [{ field: 'type' }],
	                model: 'nationalIdModel.nationalId.',
	                path: 'multistepsignupcreateaccount'
	            },
	            INVALID_NATIONAL_ID: {
	                fields: [{ field: 'Id' }],
	                name: 'national',
	                path: 'multistepsignupcreateaccount'
	            },
	            INVALID_SECONDARY_ID_TYPE: {
	                fields: [{ field: 'secondaryIdType' }],
	                model: 'nationalIdModel.',
	                path: 'multistepsignupcreateaccount'
	            },
	            INVALID_SECONDARY_ID: {
	                fields: [{ field: 'secondaryIdValue' }],
	                model: 'nationalIdModel.',
	                path: 'multistepsignupcreateaccount'
	            },
	
	            INVALID_CARD_NUMBER: {
	                path: 'multistepsignupaddcard'
	            },
	            INVALID_BILLING_ADDRESS: {
	                model: 'address.',
	                path: 'multistepsignupaddcard'
	            },
	            INVALID_SHIPPING_ADDRESS: {
	                model: 'address.',
	                path: 'multistepsignupaddshipping'
	            },
	            INVALID_EXPIRY: {
	                path: 'multistepsignupaddcard'
	            },
	            PASSWORD_CONTAINS_FORBIDDEN_WORDS: {
	                fields: [{
	                    field: 'password'
	                }, {
	                    field: 'confirmPassword'
	                }],
	                model: 'user.',
	                path: 'multistepsignupcreateaccount'
	            },
	            PASSWORD_HAS_ILLEGAL_CHARACTERS: {
	                fields: [{
	                    field: 'password'
	                }, {
	                    field: 'confirmPassword'
	                }],
	                model: 'user.',
	                path: 'multistepsignupcreateaccount'
	            },
	            ACCOUNT_ALREADY_EXISTS: {
	                fields: [{
	                    field: 'user.email'
	                }],
	                pageError: {
	                    contentKey: 'login.userMayHaveAccount'
	                },
	                compileMessageWith: {
	                    href: 'loginRedirectUrl'
	                },
	                path: 'multistepsignupcreateaccount'
	            },
	            DOB_INVALID: {
	                fields: [{
	                    field: 'user.dob_day'
	                }, {
	                    field: 'user.dob_month'
	                }, {
	                    field: 'user.dob_year'
	                }],
	                path: 'multistepsignupcreateaccount'
	            },
	            CC_NUMBER_BLOCKED: {
	                model: 'card.',
	                pageError: {
	                    contentKey: 'creditcard.errorGeneral'
	                },
	                path: 'multistepsignupaddcard'
	            }
	        };
	
	        return errorElementMap[code];
	    };
	
	    var util = {};
	    util.nameUtil = name;
	    util.maskingUtil = masking;
	    util.componentsMap = componentsMap;
	    util.contingencyMap = contingencyMap;
	    util.validateLegalAge = validateLegalAge;
	
	    return util;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "./components/xo-guest-components/src/login-button/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-guest-components/src/login-button/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template, opinionlab) {
	
	    squid.module('xo-login-button.directive', ['squid']).directive('xoLoginButton', function () {
	
	        return {
	            template: template,
	
	            scope: {
	                redirect: '='
	            },
	
	            controller: function controller($scope) {}
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-guest-components/src/login-button/template.html":
/***/ (function(module, exports) {

	module.exports = "<div id=\"loginSection\" content class=\"loginRedirect\">\n    <div class=\"row-fluid\">\n        <div class=\"span13 verticallyCentered baslLoginLabelContainer\">\n            <b>{{content('largeScreenPayment.guestSignUpDesc')}}</b>\n        </div>\n        <div class=\"span11 alignRight baslLoginButtonContainer\">\n            <a class=\"btn full\" ng-click=\"logWebviewLoginClickWrapper(); redirect()\" href=\"\">{{content('login.login')}}</a>\n        </div>\n    </div>\n</div>\n\n<div id=\"loginDivider\">\n      <span class=\"textInDivider\">\n        &nbsp{{content('login.orLowercase')}}&nbsp\n      </span>\n</div>\n"

/***/ }),

/***/ "./components/xo-ui-components/src/ui-utils/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _jquery = __webpack_require__("./components/jquery/dist/jquery.min.js");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	(0, _angular.$registerDirective)('scrollTop', function () {
	    // Generic scroll top.
	    return {
	        link: function link(scope, element, attr) {
	            var targetId = attr['scrollTop'];
	            (0, _jquery2['default'])(element).on('focus', function () {
	                (0, _jquery2['default'])('#' + targetId).scrollTop((0, _jquery2['default'])(element).offset().top);
	            });
	        }
	    };
	});
	
	// Element types that accept disabled attribute
	// See https://www.w3.org/TR/html5/disabled-elements.html#disabled-elements
	//
	//  Usage:
	//      Provide expression to be evaluated to determine if form needs to be disabled
	//      Form will be disabled when the expression evaluates to true
	//          <form disable-form="expression"></form>
	var ACCEPT_DISABLED = 'button, input, select, textarea, optgroup, option, fieldset';
	(0, _angular.$registerDirective)('disable-form', function () {
	    return {
	        link: function link(scope, element, attrs) {
	            var toggleDisabled = function toggleDisabled(disable) {
	                var collection = element.find(ACCEPT_DISABLED);
	                if (disable) {
	                    collection.attr('disabled', true);
	                } else {
	                    collection.removeAttr('disabled');
	                }
	            };
	
	            // Watch number of elements to get a rough idea of if any new inputs are
	            // added that also need to be disabled.
	            scope.$watch(function checkIfDisabled() {
	                return (0, _angular.$parse)(attrs['disableForm'])(scope) && element.find(ACCEPT_DISABLED).length;
	            }, toggleDisabled);
	        }
	    };
	});
	
	_angular.$registerDirective;
	
	_angular.$parse;

/***/ }),

/***/ "./components/xo-guest-components/src/multistep-signup/addShipping/route.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-guest-components/src/multistep-signup/addShipping/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('xo-multistep-signup-add-shipping.route', ['squid', 'xo-multistep-signup-add-shipping.directive']).factory('$MultistepSignupAddShippingRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('MultistepSignupAddShippingRoute', {
	            name: 'multistepsignupaddshipping',
	
	            directive: 'xo-multistep-signup-add-shipping',
	
	            children: [{
	                name: '$AddressNormalizationRoute',
	                attributes: {
	                    id: 'token',
	                    address: 'multistepSignupModel.onboard.shipping_address',
	                    'done-fn': 'uponNormalization'
	                }
	            }]
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-guest-components/src/multistep-signup/addShipping", "components/xo-guest-components/src/multistep-signup/addShipping/route.js"))

/***/ }),

/***/ "./components/xo-guest-components/src/multistep-signup/addShipping/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-guest-components/src/multistep-signup/addShipping/template.html"), __webpack_require__("./components/xo-guest-components/src/multistep-signup/lib/util.js"), __webpack_require__("./components/xo-page-components/src/value-props/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, module, template, util) {
	
	    return angular.module('xo-multistep-signup-add-shipping.directive', ['squid', 'xo-value-props.directive']).directive('xoMultistepSignupAddShipping', function () {
	
	        return {
	            template: template,
	
	            scope: {
	                token: '=',
	                parentCallbacks: '=',
	                multistepSignupModel: '=',
	                positionToErrorField: '=',
	                backState: '=',
	                backendError: '=',
	                clearBackendError: '=',
	                normalizeAddress: '=',
	                prefillAddressCommon: '='
	            },
	
	            link: function link($scope) {
	                if ($scope.backendError) {
	                    $scope.backendError('multistepsignupaddshipping');
	                }
	
	                $scope.$on('$destroy', function () {
	                    $scope.clearBackendError('multistepsignupaddshipping');
	                });
	            },
	
	            controller: function controller($scope, $rootScope, $populate, $state, $util, $locale, $feature, $ShippingAddressModel, $CheckoutAppDataModel, $CheckoutCartModel, $pxpFactors, $config, $location) {
	
	                $scope.locale = $locale;
	                $scope.validated = false;
	                $scope.formattedValues = {};
	                $scope.normalize = $feature('addressNormalization', false, $locale.country);
	                $scope.prefillDone = false;
	
	                if (!$scope.multistepSignupModel.onboard.shippingCountryChanged) {
	                    $scope.multistepSignupModel.onboard.shippingCountryChanged = false;
	                }
	
	                $scope.zipMasking = function (newValue) {
	                    $scope.formattedValues.postalCode = util.maskingUtil.maskZip(newValue);
	                    $scope.multistepSignupModel.onboard.shipping_address.postal_code = $scope.formattedValues.postalCode.replace(/[^0-9]/gi, '');
	                };
	
	                if ($scope.multistepSignupModel.onboard.ue_shipping_address) {
	                    $scope.multistepSignupModel.onboard.shipping_address = $scope.multistepSignupModel.onboard.ue_shipping_address;
	                    $scope.zipMasking($scope.multistepSignupModel.onboard.ue_shipping_address.postal_code);
	                }
	
	                $scope.changeCountry = function changeCountry() {
	                    if ($scope.multistepSignupModel.onboard.shipping_address.country && $scope.multistepSignupModel.onboard.shipping_address.country !== $locale.country) {
	                        $scope.multistepSignupModel.onboard.shippingCountryChanged = true;
	                        $rootScope.$broadcast('countryChange', $scope.multistepSignupModel.onboard.shipping_address.country);
	                    } else {
	                        $scope.multistepSignupModel.onboard.shippingCountryChanged = false;
	                    }
	                };
	
	                $populate($scope, {
	                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
	                    checkoutCart: $CheckoutCartModel.instance($scope.token)
	                }).then(function () {
	                    // To fix the back case where the '-' is not added to zip code
	                    if ($scope.multistepSignupModel.onboard.shipping_address) {
	                        $scope.multistepSignupModel.onboard.shipping_address.postal_code = util.maskingUtil.maskZip($scope.multistepSignupModel.onboard.shipping_address.postal_code);
	                    }
	
	                    $scope.prefill = function (override) {
	                        var postal_code = $scope.multistepSignupModel.onboard.shipping_address.postal_code;
	
	                        $scope.prefillAddressCommon(postal_code, $scope.multistepSignupModel.onboard.shipping_address, $scope.multistepSignupModel.onboard.shipping_address, $scope.multistepSignupModel.flags.shippingAddress, override);
	
	                        if (!$scope.prefillDone) {
	                            $scope.prefillDone = true;
	                        }
	                    };
	
	                    // Get merchant passed shipping address from either purchase plan or billing agreement plan
	                    var merchantSuppliedAddress = $scope.checkoutCart.get('purchase.shipping_address') || $scope.checkoutCart.get('billing.shipping_address');
	
	                    if (merchantSuppliedAddress && !$scope.multistepSignupModel.onboard.ue_shipping_address) {
	                        $scope.multistepSignupModel.onboard.shipping_address = $ShippingAddressModel.create($scope.token, {
	                            country: $locale.country
	                        }, merchantSuppliedAddress);
	                        $scope.prefill(true);
	                        $scope.zipMasking($scope.multistepSignupModel.onboard.shipping_address.postal_code);
	                        $scope.multistepSignupModel.onboard.shipping_address.postal_code = $scope.formattedValues.postalCode;
	                    }
	                });
	
	                var brPxp;
	                if (!$rootScope.miniBrowser && $locale.country === 'BR') {
	                    brPxp = $config.pxpExperiments.BR.xo_br_hermesnode_addcard_design;
	                    $pxpFactors(brPxp.pgName, brPxp.params, brPxp.pattern).then(function (result) {
	                        $scope.addCardDesignExp = result;
	                    });
	                }
	
	                $scope.uponNormalization = function (normalizedAddress, isBack) {
	                    if (isBack) {
	                        $location.path('/checkout/multistepsignup/multistepsignupaddshipping').replace();
	                    } else {
	                        $scope.normalize = false;
	                        $scope.multistepSignupModel.onboard.shipping_address.setProperties(normalizedAddress);
	                        $location.path('/checkout/multistepsignup/multistepsignupcreateaccount').replace();
	                    }
	                };
	
	                $scope.validate = function () {
	                    $scope.validated = true;
	                    return true;
	                };
	
	                $scope.onSubmit = function onSubmit() {
	                    // set recipient_name property
	                    var shippingAddress = $scope.multistepSignupModel.onboard.shipping_address;
	                    // TODO: in some locale, last_name can be displayed first, and space ' ' can be unnecessary.
	                    shippingAddress.recipient_name = shippingAddress.first_name + ' ' + shippingAddress.last_name;
	
	                    // backup user entered address
	                    $scope.multistepSignupModel.onboard.ue_shipping_address = $ShippingAddressModel.create($scope.token, {
	                        country: $locale.country
	                    }, shippingAddress);
	
	                    if ($scope.normalize) {
	                        $scope.clearBackendError('multistepsignupaddshipping');
	                        $scope.normalizeAddress(shippingAddress, $scope.uponNormalization);
	                    } else {
	                        $state.go('checkout.multistepsignup.multistepsignupcreateaccount');
	                    }
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-guest-components/src/multistep-signup/addShipping/template.html":
/***/ (function(module, exports) {

	module.exports = "<section class=\"multiStepAddShipping\" id=\"multiStepAddShipping\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <xo-message message=\"multistepSignupModel.pageError.multistepsignupaddshipping.errorMessage\"></xo-message>\n            <h1 class=\"alpha\">{{content('shipping.shippingTitle')}}</h1>\n\n            <form id=\"addShippingForm\" name=\"addShippingForm\" class=\"multistepSignupForm\" ng-submit=\"addShippingForm.$valid && onSubmit()\" ng-class=\"{'validated': validated}\" novalidate>\n\n                <div id=\"shippingAddress\">\n                    <span feature=\"changeShippingCountry\">\n                        <div class=\"dropdown confidential country clearfix\">\n                            <label for=\"country\" id=\"countryLabel\" class=\"accessAid\">{{content('common.country')}}</label>\n                            <select xo-dropdown name=\"country\" ng-model=\"multistepSignupModel.onboard.shipping_address.country\" id=\"country\"\n                                    aria-labelledby=\"countryLabel\" ng-change=\"changeCountry()\" xo-error-tooltip required>\n                                    <option ng-repeat=\"country in multistepSignupModel.countries\" value=\"{{country.code}}\" ng-selected=\"multistepSignupModel.onboard.shipping_address.country === country.code\">{{country.name}}</option>\n                            </select>\n                        </div>\n                    </span>\n\n                    <xo-name-input user=\"multistepSignupModel.onboard.shipping_address\"></xo-name-input>\n                    <div ng-if=\"!multistepSignupModel.onboard.shippingCountryChanged\"\n                         class=\"inputField confidential zip\" floating-label>\n\n                        <input type=\"text\"\n                               name=\"zip\"\n                               id=\"zip\"\n                               ng-model=\"formattedValues.postalCode\"\n                               value=\"\"\n                               autocapitalize=\"off\"\n                               aria-required=\"true\"\n                               autocomplete=\"off\"\n                               placeholder=\"{{ content('common.cep') }}\"\n                               data-error-key=\"common.valueInvalid\"\n                               ng-blur=\"prefillDone ? prefill(false):prefill(true)\"\n                               xo-error-tooltip\n                               maxlength=\"9\"\n                               ng-change=\"zipMasking(formattedValues.postalCode)\"\n                               required/>\n                        <label for=\"zip\" id=\"zipLabel\">{{content('common.cep')}}</label>\n                    </div>\n\n                    <div ng-if=\"multistepSignupModel.flags.shippingAddress.addrPrefilled || multistepSignupModel.onboard.shipping_address.country!=='BR'\">\n                        <xo-add-address address=\"multistepSignupModel.onboard.shipping_address\" hide-cep=\"true\" hide-name=\"true\" is-shipping=\"true\" token=\"token\"\n                                        country=\"multistepSignupModel.onboard.shipping_address.country\"></xo-add-address>\n                    </div>\n                </div>\n\n                <div class=\"buttons\">\n                    <a id=\"backButton\" class=\"btn btn-secondary half\" ng-click=\"backState($event)\">\n                        {{content('common.back')}}\n                    </a>\n\n                    <input track-submit id=\"addShippingSubmit\" type=\"submit\" value=\"{{ content( 'common.continueLabel' ) }}\" class=\"btn half signupFlowSubmit\"\n                           ng-click=\"validate() && positionToErrorField()\" />\n                </div>\n            </form>\n\n            <div ui-view></div>\n\n        </div>\n        <div class=\"span10\" ng-if=\"!addCardDesignExp\">\n            <xo-value-props type=\"review\" title=\"{{content('guestVerify.propHead')}}\"\n                            text-content=\"guestVerify.propVal\"></xo-value-props>\n        </div>\n        <div class=\"span10\" ng-if=\"addCardDesignExp\">\n            <xo-value-props type=\"review\" title=\"{{content(addCardDesignExp.propHeader)}}\"\n                            text-content=\"{{addCardDesignExp.propText}}\"\n                            image-url=\"{{addCardDesignExp.propImage}}\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "./components/xo-guest-components/src/multistep-signup/createAccount/route.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-guest-components/src/multistep-signup/createAccount/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('xo-multistep-signup-create-account.route', ['squid', 'xo-multistep-signup-create-account.directive']).factory('$MultistepSignupCreateAccountRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('MultistepSignupCreateAccountRoute', {
	            name: 'multistepsignupcreateaccount',
	
	            directive: 'xo-multistep-signup-create-account',
	
	            children: []
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-guest-components/src/multistep-signup/createAccount", "components/xo-guest-components/src/multistep-signup/createAccount/route.js"))

/***/ }),

/***/ "./components/xo-guest-components/src/multistep-signup/createAccount/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	var _util = __webpack_require__("./components/xo-guest-components/src/lib/util.js");
	
	var _contentKeys = __webpack_require__("./components/xo-guest-components/src/lib/contentKeys.js");
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-guest-components/src/multistep-signup/createAccount/template.html"), __webpack_require__("./components/xo-guest-components/src/multistep-signup/lib/util.js"), __webpack_require__("./components/xo-page-components/src/value-props/directive.js"), __webpack_require__("./components/xo-models/src/onboard/index.js"), __webpack_require__("./components/xo-models/src/fi/index.js"), __webpack_require__("./components/xo-form-components/src/dob-input/directive.js"), __webpack_require__("./components/xo-form-components/src/national-id-input/directive.js"), __webpack_require__("./components/xo-models/src/user/index.js"), __webpack_require__("./components/xo-guest-components/src/multistep-signup/apiCalls/factory.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular, module, template, util) {
	
	    return angular.module('xo-multistep-signup-create-account.directive', ['squid', 'xomodel.onboard', 'xo-value-props.directive', 'xo-dob-input.directive', 'xo-national-id-input.directive', 'xomodel.user', 'xomultistepsignupapi']).directive('xoMultistepSignupCreateAccount', function () {
	
	        return {
	            template: template,
	
	            scope: {
	                token: '=',
	                parentCallbacks: '=',
	                multistepSignupModel: '=',
	                positionToErrorField: '=',
	                backState: '=',
	                backendError: '=',
	                clearBackendError: '='
	            },
	
	            controller: function controller($scope, $rootScope, $populate, $state, $util, $locale, $ShippingAddressModel, $logger, $CheckoutSessionModel, $CheckoutAppDataModel, $CheckoutCartModel, $UserInfoModel, $dispatch, $pxpFactors, $config, $MultistepApiCalls, $pxp) {
	
	                $scope.locale = $locale;
	                $scope.componentsFlag = util.componentsMap($locale.country);
	                $scope.metadata = angular.copy($locale.metadata);
	                $scope.countries = $scope.metadata.territory;
	
	                $scope.checkoutCart = $CheckoutCartModel.instance($scope.token);
	                $scope.checkoutAppData = $CheckoutAppDataModel.instance($scope.token);
	
	                if ($scope.checkoutAppData && $scope.checkoutAppData.merchant) {
	                    var merchant = $scope.checkoutAppData.merchant;
	                    $scope.merchant = merchant.brand_name || merchant.merchant_name || merchant.merchant_email;
	                }
	
	                function formatFiLast4(ccNum) {
	                    return 'x-' + ccNum.replace(/\s+/g, '').slice(-4);
	                }
	
	                function formatFiName(ccType) {
	                    var tmp = ccType.toLowerCase();
	                    return tmp.charAt(0).toUpperCase() + tmp.slice(1);
	                }
	
	                var contentOpts = {
	                    cart: $scope.checkoutCart,
	                    appData: $scope.checkoutAppData
	                };
	
	                $scope.baContentKey = (0, _contentKeys.getBAContentKey)(contentOpts);
	                $scope.rpContentKey = (0, _contentKeys.getRPContentKey)(contentOpts);
	
	                $scope.fiName = formatFiName($scope.multistepSignupModel.onboard.card.type);
	                $scope.fiFormatLast4 = formatFiLast4($scope.multistepSignupModel.onboard.card.number);
	
	                // Reset password fields
	                delete $scope.multistepSignupModel.onboard.user.password;
	                delete $scope.multistepSignupModel.onboard.user.confirmPassword;
	
	                var useraction = $scope.checkoutAppData.useraction();
	                $scope.isCommit = useraction && useraction.toLowerCase() === 'commit';
	                $logger.info('checkout_fpti', {
	                    'billing_page_button_text': $scope.isCommit ? 'paynow_y' : 'paynow_n'
	                });
	
	                if (!$rootScope.miniBrowser && $locale.country === 'BR') {
	                    var brPxp = $config.pxpExperiments.BR.xo_br_hermesnode_createaccount_design;
	
	                    $pxpFactors(brPxp.pgName, brPxp.params, brPxp.pattern).then(function (result) {
	                        $scope.createAccountDesignExp = result;
	                    });
	                }
	
	                function handleUIValidation(fields) {
	                    var $fields = $(fields);
	
	                    $fields.addClass('backendError');
	
	                    if (window.scrollTo) {
	                        window.scrollTo(0, 0);
	                    }
	                }
	
	                function isNameCyrillic() {
	                    var result = true;
	                    var regexCyrillic = /[а-яА-ЯЁё]/;
	                    if (!regexCyrillic.test($('#firstName').val())) {
	                        result = false;
	                        handleUIValidation('#firstName');
	                    }
	                    if (!regexCyrillic.test($('#lastName').val())) {
	                        result = false;
	                        handleUIValidation('#lastName');
	                    }
	                    if (!regexCyrillic.test($('#middleName').val())) {
	                        result = false;
	                        handleUIValidation('#middleName');
	                    }
	
	                    if (!result) {
	                        var messages = [];
	                        messages.push($locale.content.get('addTaxId.cyrillicNameError'));
	                        $scope.multistepSignupModel.pageError = $scope.multistepSignupModel.pageError || {};
	                        $scope.multistepSignupModel.pageError.multistepsignupcreateaccount = {
	                            errorMessage: {
	                                msgs: messages,
	                                type: 'error'
	                            }
	                        };
	                    }
	
	                    return result;
	                }
	
	                _util.pxpTreatments.getSinglePassword($locale.country).then(function (res) {
	                    $scope.singlePassword = res;
	                });
	
	                $scope.onContinue = function () {
	                    var validInput = true;
	                    if ($scope.multistepSignupModel.onboard.user.countryOfResidence === 'RU') {
	                        validInput = isNameCyrillic();
	                    }
	
	                    if (!util.validateLegalAge($scope.multistepSignupModel.onboard.user.dob_month, $scope.multistepSignupModel.onboard.user.dob_day, $scope.multistepSignupModel.onboard.user.dob_year)) {
	                        validInput = false;
	                        handleUIValidation('#dobText');
	                    }
	
	                    if (validInput) {
	                        $scope.onSubmit();
	                    }
	                };
	
	                $scope.legalAgreeToolTip = function () {
	                    if ($scope.multistepSignupModel.onboard.agree) {
	                        $scope.showTooltip = false;
	                    } else {
	                        $scope.showTooltip = true;
	                    }
	                };
	
	                $scope.validate = function () {
	                    $scope.legalAgreeToolTip();
	                    $scope.validated = true;
	                    return true;
	                };
	
	                $scope.onComplete3DSHandler = function (status) {
	                    $scope.multistepSignupModel.is3ds = false;
	                    if (status === 'decline' || status === 'close') {
	                        // Flow should route to member review page for sign up case
	                        // up on receiving "decline" or "close" response from 3DS authenticate call
	                        $MultistepApiCalls.routeToHermesOn3DSDeclineForSignUp();
	                    } else if (status === 'success') {
	                        // Up on Successful authenticate, perform Patch on XO session and authorise.
	                        $MultistepApiCalls.clear3DSContingency();
	                    }
	                };
	
	                $scope.onSubmit = function () {
	
	                    $logger.info($scope.multistepSignupModel.flags.mode + '_submit', {
	                        type: $scope.multistepSignupModel.onboard.card.type,
	                        country: $locale.country,
	                        lang: $locale.lang
	                    }).flush();
	
	                    if ($scope.multistepSignupModel.flags.shipToBilling) {
	                        $scope.multistepSignupModel.onboard.shipping_address = $ShippingAddressModel.create($scope.token, $scope.multistepSignupModel.onboard.billing_address, {
	                            first_name: $scope.multistepSignupModel.onboard.user.first_name,
	                            last_name: $scope.multistepSignupModel.onboard.user.last_name
	                        });
	                    }
	
	                    $MultistepApiCalls.onboard()['catch'](function (pageError) {
	                        var addCard = pageError.multistepsignupaddcard;
	                        var addShipping = pageError.multistepsignupaddshipping;
	                        var createAcc = pageError.multistepsignupcreateaccount;
	
	                        // Globally handled contingencies also trigger the catch block.
	                        if (addCard && addCard.length > 0) {
	                            $state.go('checkout.multistepsignup.multistepsignupaddcard');
	                        } else if (addShipping && addShipping.length > 0) {
	                            $state.go('checkout.multistepsignup.multistepsignupaddshipping');
	                        } else if (createAcc && createAcc.length > 0) {
	                            $scope.backendError('multistepsignupcreateaccount');
	                        }
	                    });
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	_util.pxpTreatments;
	
	_contentKeys.getBAContentKey;
	
	_contentKeys.getRPContentKey;

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-guest-components/src/multistep-signup/createAccount/template.html":
/***/ (function(module, exports) {

	module.exports = "<section class=\"multiStepCreateAccount\" id=\"multiStepCreateAccount\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <xo-message message=\"multistepSignupModel.pageError.multistepsignupcreateaccount.errorMessage\"></xo-message>\n            <h1 class=\"alpha\">{{content('largeScreenAccountCreation.title')}}</h1>\n\n            <form id=\"createAccountForm\" name=\"createAccountForm\" class=\"multistepSignupForm\" ng-submit=\"createAccountForm.$valid && onContinue()\" ng-class=\"{'validated': validated}\" novalidate>\n\n                <div class=\"signupFieldsContainer\" id=\"signupContainer\">\n\n                    <div class=\"signupFieldGroup\">\n\n                        <div ng-class=\"{'fullSignup': fullSignup}\">\n                            <xo-email-input user=\"multistepSignupModel.onboard.user\"></xo-email-input>\n\n                            <xo-password-input user=\"multistepSignupModel.onboard.user\" single-password=\"singlePassword\"></xo-password-input>\n\n                            <div ng-if=\"componentsFlag.dobDropDown\">\n                                <xo-dob-input user=\"multistepSignupModel.onboard.user\"></xo-dob-input>\n                            </div>\n\n                            <div class=\"rowPadding\">\n                                <xo-national-id-input country=\"{{locale.country}}\" user=\"multistepSignupModel.onboard.user\"></xo-national-id-input>\n                            </div>\n\n                            <div class=\"row-fluid checkbox legal rowPadding\" feature=\"econsent\">\n                                <input ng-model=\"multistepSignupModel.onboard.agree\" type=\"checkbox\" name=\"agree\" id=\"agree\" ng-change=\"legalAgreeToolTip()\" required/>\n                                <label class=\"noBottom\" for=\"agree\" ng-bind-html=\"htmlContent('signupTerms.signupC', {country:locale.country, lang:locale.lang})\"></label>\n                                <div id=\"legalAgreeToolTip\" ng-show=\"showTooltip\">\n                                     <div class=\"legalAgreeCBToolTip balloon\">\n                                        <div class=\"tip tipDesc legalAgreeToolTip\">\n                                            <ul class=\"tipInfoText\">\n                                                <li class=\"restriction active\">{{content('largeScreenAccountCreation.agrementError')}}</li>\n                                            </ul>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n\n                            <p class=\"billingTxt secondary row-fluid rowPadding legal\" ng-if=\"checkoutCart.isBilling() && !isRP\">\n                                <span id=\"billingAgreement\" data-ng-bind-html=\"htmlContent(baContentKey, {merchantName: merchant, country: locale.country, lang: locale.lang, fiName: fiName, fiFormatLast4: fiFormatLast4})\"></span>\n                            </p>\n\n                            <p class=\"billingTxt secondary row-fluid rowPadding legal\" ng-if=\"checkoutCart.isBilling() && isRP\">\n                                <span id=\"rpAgreement\" data-ng-bind-html=\"htmlContent(rpContentKey, {merchantName: merchant, country: locale.country, lang: locale.lang, fiName: fiName, fiFormatLast4: fiFormatLast4})\"></span>\n                            </p>\n\n                        </div>\n\n                    </div>\n\n                </div>\n\n                <div class=\"buttons\">\n                    <a id=\"backButton\" class=\"btn btn-secondary half\" ng-click=\"backState($event)\">\n                        {{content('common.back')}}\n                    </a>\n\n                    <input track-submit ng-if=\"isCommit\" id=\"signupSubmit\" type=\"submit\" value=\"{{ content( 'common.agreeAndPay' ) }}\" class=\"btn half signupFlowSubmit\"\n                           ng-click=\"validate() &&  positionToErrorField()\" />\n\n                    <input track-submit ng-if=\"!isCommit\" id=\"signupSubmit\" type=\"submit\" value=\"{{ content( 'common.agreeAndContinue' ) }}\" class=\"btn half signupFlowSubmit\"\n                           ng-click=\"validate() &&  positionToErrorField()\" />\n                </div>\n            </form>\n        </div>\n        <div class=\"span10\" ng-if=\"!createAccountDesignExp\">\n            <xo-value-props type=\"review\" title=\"{{content('guestVerify.propHead')}}\"\n                            text-content=\"guestVerify.propVal\"></xo-value-props>\n        </div>\n        <div class=\"span10\" ng-if=\"createAccountDesignExp\">\n            <xo-value-props type=\"review\" title=\"{{content(createAccountDesignExp.propHeader)}}\"\n                            text-content=\"{{createAccountDesignExp.propText}}\"\n                            image-url=\"{{createAccountDesignExp.propImage}}\"></xo-value-props>\n        </div>\n    </div>\n</section>\n\n<xo-3ds on-complete-3ds-handler=\"onComplete3DSHandler\" token=\"token\" data=\"multistepSignupModel.resolve_3ds_data\"\n        ng-if=\"multistepSignupModel.is3ds\"></xo-3ds>\n"

/***/ }),

/***/ "./components/xo-guest-components/src/multistep-signup/apiCalls/factory.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename, $) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-guest-components/src/multistep-signup/lib/util.js"), __webpack_require__("./components/xo-models/src/inventory/index.js"), __webpack_require__("./components/xo-models/src/shoppingcart/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid, util) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xomultistepsignupapi', ['squid']).factory('$MultistepApiCalls', function ($MultistepSignupModel, $CheckoutSessionModel, $CheckoutAppDataModel, $CheckoutPayeeModel, $InventoryModel, $ShoppingCartModel, $CheckoutCartModel, $rootScope, $state, $config, $locale, $logger, $NationalIdModel, $location, $dispatch, $getRedirectUrl, $renderContent, $q, $FundingOptionsModel) {
	
	        function processFieldMap(errorCategory) {
	            var fieldMap = util.contingencyMap(errorCategory.errorCode || errorCategory.code);
	
	            if (fieldMap) {
	                if (!fieldMap.fields && (errorCategory.fields || errorCategory.details && errorCategory.details.fields)) {
	                    // eslint-disable-line no-extra-parens
	                    errorCategory.fields = errorCategory.fields || errorCategory.details && errorCategory.details.fields;
	
	                    var fields = errorCategory.fields.map(function (value, index, array) {
	                        if (angular.isString(value)) {
	                            return {
	                                field: value
	                            };
	                        }
	
	                        return value;
	                    });
	
	                    fieldMap.fields = fields;
	                }
	            } else {
	                $logger.info('signup_validation_error', {
	                    message: errorCategory.errorCode || errorCategory.code + ' not mapped'
	                });
	            }
	
	            return fieldMap;
	        }
	
	        function redirectTohermesCC(path, $location, token) {
	            // eslint-disable-line no-shadow
	            var url;
	            var protocol;
	            var host;
	            var port;
	
	            protocol = $location.protocol() + '://';
	
	            if ($location.host()) {
	                host = $location.host();
	            }
	
	            if ($location.port()) {
	                port = ':' + $location.port();
	            }
	
	            url = protocol + host + port + config.urls.fallbackUrl.hermes + '?token=' + token + path; // eslint-disable-line no-undef,block-scoped-var
	
	            window.location = url;
	        }
	
	        function setStickyInstrument(checkoutSession) {
	            // make billing agreement FI sticky for sign up
	
	            var stickyInstrument = checkoutSession.selectedFuturePaymentInstrument ? undefined : checkoutSession.getSelectedStickyInstrument();
	
	            if (stickyInstrument) {
	                return checkoutSession.action('setStickyFI', {
	                    data: {
	                        instrument_id: stickyInstrument.instrument_id
	                    }
	                });
	            }
	        }
	
	        function showGenericError(code) {
	            return function () {
	                $state.go('checkout.genericError', { code: code });
	            };
	        }
	
	        function markCartCheckedout(checkoutAppData) {
	            var shoppingCartModel = $ShoppingCartModel.instance($rootScope.token);
	            return shoppingCartModel.action('cartCheckedOut', {
	                data: {
	                    payee_email: checkoutAppData.get('merchant.merchant_email')
	                },
	                success: function success(result) {
	                    $logger.info('cart checked out successfully');
	                }
	            });
	        }
	
	        function handlePaymentContingencies(checkoutCart, payee, code) {
	            return function () {
	                inventoryOperation(checkoutCart, payee, 'failed');
	                return $state.go('checkout.genericError', { code: code });
	            };
	        }
	
	        function makePayment(checkoutSession, checkoutCart, checkoutAppData, payee) {
	            return checkoutSession.action('createPayment', {
	                'data': {
	                    payer_id: checkoutSession.payer && checkoutSession.payer.id,
	                    intent: checkoutCart.payment_action
	                },
	                success: function success(result) {
	                    $rootScope.paymentComplete = true;
	                    if ($config.enableShoppingCartWPS && checkoutAppData.flags.is_shopping_cart_flow) {
	                        markCartCheckedout(checkoutAppData);
	                    }
	                    return $state.go('checkout.done');
	                },
	                contingencies: {
	                    TRANSACTION_REFUSED: handlePaymentContingencies(checkoutCart, payee, 'TRANSACTION_REFUSED'),
	                    INSTRUMENT_DECLINED: function INSTRUMENT_DECLINED(err, message) {
	                        inventoryOperation(checkoutCart, payee, 'failed');
	                        $logger.info('INSTRUMENT_DECLINED_contingency', {
	                            name: err,
	                            message: message
	                        });
	                        redirectTohermesCC('#checkout/pageAddCard/addCardFlow/addCard', $location, $rootScope.token);
	                    },
	                    PAYEE_BLOCKED_TRANSACTION: handlePaymentContingencies(checkoutCart, payee, 'PAYMENT_DENIED'),
	                    DUPLICATE_TRANSACTION: handlePaymentContingencies(checkoutCart, payee, 'PAYMENT_ALREADY_DONE'),
	                    DEFAULT: handlePaymentContingencies(checkoutCart, payee, 'DEFAULT')
	                },
	                error: function error(err) {
	                    $logger.info('createPayment Failed due to service error', err);
	                    inventoryOperation(checkoutCart, payee, 'failed');
	                    return $state.go('checkout.genericError', { code: 'DEFAULT' });
	                }
	
	            });
	        }
	
	        function authorizeSession(checkoutSession) {
	            var multistepSignupModel = $MultistepSignupModel.instance();
	            var checkoutAppData = $CheckoutAppDataModel.instance($rootScope.token);
	            var payee = $CheckoutPayeeModel.instance($rootScope.token);
	            var checkoutCart = $CheckoutCartModel.instance($rootScope.token);
	
	            if (checkoutSession.resolve_3ds) {
	                multistepSignupModel.resolve_3ds_data = {
	                    cc_id: checkoutSession.get('resolve_3ds.ccId'),
	                    flow_id: 'HERMES',
	                    merchant_id: payee.get('merchant.id'),
	                    merchant_country_code: checkoutAppData.get('merchant.merchant_country'),
	                    transaction_amount_currency: checkoutCart.get('purchase.amounts.total.currency_code'),
	                    transaction_amount_value: checkoutCart.get('purchase.amounts.total.amount')
	                };
	
	                multistepSignupModel.is3ds = true;
	                $state.go('checkout.multistepsignup.multistepsignupcreateaccount');
	            } else {
	                return $q.when(setStickyInstrument(checkoutSession))['catch'](function (err) {
	                    $logger.info('setStickyFI Failed', err);
	                })['finally'](function () {
	                    return checkoutSession.action('authorize', {
	                        success: function success() {
	                            if (checkoutAppData.doec_on_approve()) {
	                                return checkInventoryAndPay(checkoutSession, checkoutCart, payee, checkoutAppData);
	                            } else {
	                                $state.go('checkout.end');
	                            }
	                        }
	                    });
	                });
	            }
	        }
	
	        function inventoryOperation(checkoutCart, payee, paymentStatus) {
	            var cartHasInventory = checkoutCart.get('cartHasInventory');
	            if (cartHasInventory) {
	                var inventoryModel = $InventoryModel.instance($rootScope.token);
	                var inventoryItems = inventoryModel.getInventoryItems();
	                var purchaseItems = checkoutCart.get('purchaseUnits');
	                var cartItems,
	                    inventoryPatchInput = {};
	                if (purchaseItems && purchaseItems[0] && purchaseItems[0].item_list) {
	                    cartItems = purchaseItems[0].item_list.items;
	                }
	                paymentStatus = paymentStatus ? paymentStatus : 'success';
	                if (cartItems && inventoryItems) {
	                    inventoryPatchInput = {
	                        inventoryItems: inventoryItems,
	                        cartItems: cartItems,
	                        merchantId: payee.get('merchant.id', ''),
	                        paymentStatus: paymentStatus
	                    };
	                } else {
	                    return $q.when(); // don't need to call patchInventory if items not present
	                }
	
	                return inventoryModel.action('patchInventory', {
	                    data: inventoryPatchInput,
	                    success: function success(patchResponse) {
	                        if (patchResponse) {
	                            if (patchResponse.showSoldoutPage) {
	                                // show soldout page
	                                return {
	                                    soldoutpage: true,
	                                    items: patchResponse.soldoutItems,
	                                    soldOutUrl: patchResponse.soldoutUrl
	                                };
	                            } else if (patchResponse.patchCart) {
	                                var purchase_unit = checkoutCart.get('purchaseUnits')[0];
	                                purchase_unit.item_list.items = patchResponse.cartItems;
	                                var patchCartPayload = {
	                                    id: $rootScope.token,
	                                    patchEntities: [{
	                                        field: 'inventoryItems',
	                                        value: purchase_unit.item_list.items
	                                    }]
	                                };
	
	                                return checkoutCart.action('patchCartData', {
	                                    data: patchCartPayload
	                                });
	                            }
	                        } else {
	                            return;
	                        }
	                    }
	                });
	            } else {
	                return $q.when(); // not an inventory request proceed with existing flow
	            }
	        }
	
	        function checkInventoryAndPay(checkoutSession, checkoutCart, payee, checkoutAppData) {
	            return inventoryOperation(checkoutCart, payee).then(function (result) {
	                if (result && result.soldoutpage) {
	                    return $state.go('checkout.soldout', {
	                        items: encodeURIComponent(result.items),
	                        soldOutUrl: encodeURIComponent(result.soldOutUrl)
	                    });
	                }
	                return makePayment(checkoutSession, checkoutCart, checkoutAppData, payee);
	            });
	        }
	
	        function createSession() {
	
	            var multistepSignupModel = $MultistepSignupModel.instance();
	            var checkoutSession = $CheckoutSessionModel.instance($rootScope.token);
	            var checkoutCart = $CheckoutCartModel.instance($rootScope.token);
	
	            return checkoutSession.action('create', {
	                data: {
	                    fraudnet_id: checkoutCart.supplementary && checkoutCart.supplementary.risk_correlation_id,
	                    baToken: checkoutCart.billing && checkoutCart.billing.ba_token
	                },
	                success: function success() {
	                    return $q.when().then(function () {
	                        if (!multistepSignupModel.flags.shipToBilling) {
	                            return multistepSignupModel.onboard.shipping_address.save({
	
	                                data: multistepSignupModel.onboard.shipping_address.serialize(),
	
	                                validation: function validation(message, err) {
	                                    // TODO need to handle
	                                }
	                            });
	                        }
	                    }).then(function () {
	                        if (checkoutSession.get('plan.conversion.paypal') && checkoutSession.get('plan.conversion.changeable') && multistepSignupModel.onboard.card.ppconversion === 'VENDOR') {
	                            return $FundingOptionsModel.instance($rootScope.token).action('updateConversion', {
	                                data: {
	                                    conversionType: 'VENDOR',
	                                    planId: checkoutSession.plan.id
	                                }
	                            })['catch'](function (err) {
	                                $logger.warn('ERROR_updateConversion to VENDOR failed', err);
	                            });
	                        }
	                    }).then(function () {
	                        return authorizeSession(checkoutSession);
	                    });
	                },
	                contingencies: {
	                    TRANSACTION_REFUSED: showGenericError('TRANSACTION_REFUSED'),
	                    NEED_CREDIT_CARD: function NEED_CREDIT_CARD(err, message) {
	                        $logger.info('NEED_CREDIT_CARD_contingency', {
	                            name: err,
	                            message: message
	                        });
	                        redirectTohermesCC('#checkout/pageAddCard/addCardFlow/addCard', $location, $rootScope.token);
	                    }
	                }
	            });
	        }
	
	        var multiStepFunctions = {
	
	            onboard: function onboard() {
	
	                var pageError = { // eslint-disable-line no-reserved-keys
	                    multistepsignupaddcard: [],
	                    multistepsignupaddshipping: [],
	                    multistepsignupcreateaccount: [],
	                    transient: true
	                };
	
	                var multistepSignupModel = $MultistepSignupModel.instance();
	
	                multistepSignupModel.onboard.billing_address.country = $locale.country;
	                multistepSignupModel.onboard.nationalIdModel = $NationalIdModel.instance($rootScope.token);
	
	                return multistepSignupModel.onboard.action(multistepSignupModel.flags.mode, {
	
	                    data: multistepSignupModel.onboard.serialize(),
	
	                    success: createSession,
	
	                    contingencies: {
	                        TRANSACTION_REFUSED: showGenericError('TRANSACTION_REFUSED'),
	                        TOO_MANY_REQUESTS: function TOO_MANY_REQUESTS() {
	                            var messages = [];
	                            messages.push($locale.content.get('genericError.genericError'));
	
	                            multistepSignupModel.pageError = pageError;
	                            pageError.multistepsignupaddcard.errorMessage = {
	                                msgs: messages,
	                                type: 'error'
	                            };
	
	                            $state.go('checkout.multistepsignup.multistepsignupaddcard');
	                        },
	                        ADD_KYC_FAILED: function ADD_KYC_FAILED() {
	                            redirectTohermesCC('#/checkout/addNationalId', $location, $rootScope.token);
	                        },
	                        CC_LINKED_TO_FULL_ACCOUNT: function CC_LINKED_TO_FULL_ACCOUNT() {
	                            var messages = [];
	                            messages.push($locale.content.get('creditcard.linkedCardToAddNewCard'));
	
	                            multistepSignupModel.pageError = pageError;
	                            pageError.multistepsignupaddcard.errorMessage = {
	                                msgs: messages,
	                                type: 'error'
	                            };
	
	                            $state.go('checkout.multistepsignup.multistepsignupaddcard');
	                        },
	                        ADD_CARD_CONTINGENCY: function ADD_CARD_CONTINGENCY(message, result) {
	                            // @TODO send to correct page in hermes
	                            // $dispatch('hermes');
	                            // auth model-> check if user logged in
	                            redirectTohermesCC('#checkout/pageAddCard/addCardFlow/addCard', $location, $rootScope.token);
	                        },
	                        ISSUER_DECLINE: function ISSUER_DECLINE(message, result) {
	                            // @TODO send to correct page in hermes
	                            // $dispatch('hermes');
	                            redirectTohermesCC('#checkout/pageAddCard/addCardFlow/addCard', $location, $rootScope.token);
	                        },
	                        VALIDATION_ERROR: function VALIDATION_ERROR(message, errors) {
	
	                            var messages = [];
	                            var compileVars = {
	                                loginRedirectUrl: $getRedirectUrl('hermes', {
	                                    hermesLoginRedirect: 'xoon'
	                                })
	                            };
	                            // Iterate over the errorData to support multiple error support
	                            Object.keys(errors).forEach(function (key, index, array) {
	
	                                var errorCategory = errors[key];
	                                // errorCategory sanity checks
	                                if (!errorCategory || angular.isString(errorCategory) || key === 'transient' || key === 'payload') {
	                                    return;
	                                }
	
	                                var fieldMap = processFieldMap(errorCategory);
	                                var msg;
	                                var compileMessageWith;
	
	                                if (fieldMap) {
	
	                                    if (fieldMap.pageError) {
	                                        compileMessageWith = fieldMap.compileMessageWith;
	
	                                        if (compileMessageWith) {
	                                            // substitute the actual value
	                                            // this is required as it is not good to have custom
	                                            // code inside library - lib/utils.js
	                                            $.each(compileMessageWith, function (objKey, val) {
	                                                var actualValue = compileVars[val];
	                                                if (actualValue) {
	                                                    compileMessageWith[objKey] = actualValue;
	                                                }
	                                            });
	
	                                            msg = $renderContent(fieldMap.pageError.contentKey, compileMessageWith);
	                                        } else {
	                                            msg = $locale.content.get(fieldMap.pageError.contentKey);
	                                        }
	                                        messages.push(msg);
	                                    }
	
	                                    pageError[fieldMap.path].push(fieldMap);
	
	                                    if (messages.length > 0) {
	                                        pageError[fieldMap.path].errorMessage = {
	                                            msgs: messages,
	                                            type: 'error'
	                                        };
	                                    }
	                                }
	                            });
	
	                            multistepSignupModel.pageError = pageError;
	                            throw pageError;
	                        }
	                    },
	                    validation: function validation(res) {
	                        if (res && (res.field === 'secondaryId' || res.field === 'passport')) {
	                            // The validation error cannot be corrected at this point in onboarding
	                            redirectTohermesCC('#/checkout/addNationalId', $location, $rootScope.token);
	                        } else {
	                            $logger.info('signup_validation', {
	                                message: res
	                            });
	                        }
	                    }
	                });
	            },
	
	            routeToHermesOn3DSDeclineForSignUp: function routeToHermesOn3DSDeclineForSignUp() {
	                // dispatch to hermesnodeweb up on 3DS authenticate decline.
	                $logger.info('xoon_to_hermes_redirect_on_signup_3DS_Authentication_decline');
	                $dispatch('hermes', {
	                    token: $rootScope.token,
	                    redirectToHermesOn3DSDecline: 'xoon'
	                });
	            },
	
	            clear3DSContingency: function clear3DSContingency() {
	                var checkoutSession = $CheckoutSessionModel.instance($rootScope.token);
	                return checkoutSession.action('clear3DSContingency', {
	                    data: {
	                        ccId: checkoutSession.resolve_3ds.ccId
	                    },
	                    success: function success() {
	                        // don't call authorize if the contingency is not cleared
	                        if (!checkoutSession.resolve_3ds) {
	                            return authorizeSession(checkoutSession);
	                        } else {
	                            multiStepFunctions.routeToHermesOn3DSDeclineForSignUp();
	                        }
	                    },
	                    contingencies: {
	                        // contingency may be "no cc" or any thing from clear3DSContingency(patch on xosession)
	                        // for "no cc" symphony throws NEED_CREDIT_CARD or NEED_CREDIT_CARD_OR_BANK_ACCOUNT
	                        DEFAULT: function handleContingency(name, contingency) {
	                            $logger.info('clear3DSContingency_contingency', {
	                                'int_error_description': contingency && contingency.message,
	                                'contingency_name': name
	                            });
	                            // route to member review page upon patch xo throws contingency for signup
	                            multiStepFunctions.routeToHermesOn3DSDeclineForSignUp();
	                        }
	                    }
	
	                });
	            }
	
	        };
	
	        return multiStepFunctions;
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-guest-components/src/multistep-signup/apiCalls", "components/xo-guest-components/src/multistep-signup/apiCalls/factory.js", __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "./components/xo-guest-components/src/multistep-signup/addressNormalization/route.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-guest-components/src/multistep-signup/addressNormalization/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('xo-multistep-signup-address-normalization.route', ['squid', 'xo-multistep-signup-address-normalization.directive']).factory('$MultistepSignupAddressNormalizationRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('MultistepSignupAddressNormalizationRoute', {
	            name: 'multistepsignupaddressnormalization',
	
	            directive: 'xo-multistep-signup-address-normalization',
	
	            children: []
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-guest-components/src/multistep-signup/addressNormalization", "components/xo-guest-components/src/multistep-signup/addressNormalization/route.js"))

/***/ }),

/***/ "./components/xo-guest-components/src/multistep-signup/addressNormalization/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-guest-components/src/multistep-signup/addressNormalization/template.html"), __webpack_require__("./js/lib/index.js"), __webpack_require__("./components/xo-page-components/src/value-props/directive.js"), __webpack_require__("./components/xo-guest-components/src/multistep-signup/lib/util.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, module, template) {
	
	    return angular.module('xo-multistep-signup-address-normalization.directive', ['squid', 'xo-value-props.directive']).directive('xoMultistepSignupAddressNormalization', function ($rootScope) {
	
	        return {
	            template: template,
	
	            scope: {
	                id: '=',
	                address: '=',
	                doneFn: '='
	            },
	
	            controller: function controller($scope, $locale, $MiniBrowser, $pxpFactors, $config) {
	                // TODO: add PXP stuff
	                if (!$rootScope.miniBrowser && $locale.country === 'BR') {
	                    var brPxp = $config.pxpExperiments.BR.xo_br_hermesnode_addressconfirm_design;
	
	                    $pxpFactors(brPxp.pgName, brPxp.params, brPxp.pattern).then(function (result) {
	                        $scope.addressDesignExp = result;
	                    });
	                }
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-guest-components/src/multistep-signup/addressNormalization/template.html":
/***/ (function(module, exports) {

	module.exports = "<section class=\"multiStepAddressNormalization\" id=\"multiStepAddressNormalization\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <xo-address-normalization token=\"token\" address=\"address\" hide-back-button=\"false\" done-fn=\"doneFn\"></xo-address-normalization>\n        </div>\n        <div class=\"span10\" ng-if=\"!addressDesignExp\">\n            <xo-value-props type=\"review\" title=\"{{content('guestVerify.propHead')}}\" text-content=\"guestVerify.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" ng-if=\"addressDesignExp\">\n            <xo-value-props type=\"review\" title=\"{{content(addressDesignExp.propHeader)}}\" text-content=\"{{addressDesignExp.propText}}\" image-url=\"{{addressDesignExp.propImage}}\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "./pages/xo-pay-upon-invoice/route.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./pages/xo-pay-upon-invoice/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('hermes.page.xo-pay-upon-invoice.route', ['squid', 'hermes.page.xo-pay-upon-invoice.directive']).factory('$PayUponInvoiceRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('PayUponInvoiceRoute', {
	            name: 'pay-upon-invoice',
	            directive: 'xo-pay-upon-invoice-page',
	            titleContent: 'payment.payWithCard',
	            trackingData: {
	                templateName: 'pay-upon-invoice.dust',
	                pageGoal: 'Payment Start',
	                pageQualifier: 'pay-upon-invoice',
	                buzname: {
	                    'pay-upon-invoice': {
	                        'pagename': '%::fullpage-pay-upon-invoice',
	                        'pagename2': '%::fullpage-pay-upon-invoice:guest:hermes:',
	                        'version': 'pay-upon-invoice:%:'
	                        // More page qualifiers come here...
	                    } }
	            },
	            children: []
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-pay-upon-invoice", "pages/xo-pay-upon-invoice/route.js"))

/***/ }),

/***/ "./pages/xo-pay-upon-invoice/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/module.js"), __webpack_require__("../node_modules/noop-loader/index.js!./pages/xo-pay-upon-invoice/template.html"), __webpack_require__("./components/xo-beaver/dist/logger.js"), __webpack_require__("./components/xo-page-components/src/value-props/directive.js"), __webpack_require__("./components/xo-wallet-components/src/pay-upon-invoice/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, module, template) {
	
	    return angular.module('hermes.page.xo-pay-upon-invoice.directive', ['squid', 'xo-value-props.directive', 'xo-pay-upon-invoice.directive']).directive('xoPayUponInvoicePage', function ($rootScope, $logger) {
	
	        return {
	            template: template,
	
	            scope: {
	                token: '=',
	                isUnbranded: '='
	            },
	
	            controller: function controller($scope, $rootScope, $state, $locale) {// eslint-disable-line no-shadow
	
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./pages/xo-pay-upon-invoice/template.html":
/***/ (function(module, exports) {

	module.exports = "<section class=\"payUponInvoice\" id=\"payUponInvoice\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <xo-pay-upon-invoice token=\"token\" is-unbranded=\"isUnbranded\"></xo-pay-upon-invoice>\n        </div>\n\n    </div>\n</section>\n"

/***/ }),

/***/ "./components/xo-wallet-components/src/pay-upon-invoice/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _index = __webpack_require__("./components/squid/dist/index.js");
	
	var _index2 = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _index3 = __webpack_require__("./components/xo-models/src/onboard/index.js");
	
	var _index4 = __webpack_require__("./components/xo-models/src/fi/index.js");
	
	var _util = __webpack_require__("./components/xo-wallet-components/src/fi-contingency-list/util.js");
	
	var _index5 = __webpack_require__("./components/xo-models/src/auth/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _index6 = __webpack_require__("./components/xo-models/src/address/index.js");
	
	__webpack_require__("./components/xo-address-components/src/add-address/directive.js");
	
	__webpack_require__("./components/xo-form-components/src/name-input/directive.js");
	
	__webpack_require__("./components/xo-form-components/src/dob-input/directive.js");
	
	__webpack_require__("./components/xo-guest-components/src/guest/emailInput/directive.js");
	
	var _template = __webpack_require__("./components/xo-wallet-components/src/pay-upon-invoice/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _index.$Component.extend('xoPayUponInvoice', {
	    tag: 'xo-pay-upon-invoice',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            type: 'var'
	        },
	        isUnbranded: {
	            type: 'var'
	        }
	    },
	
	    resolve: {
	        models: function models() {
	            return {
	                auth: _index5.$AuthModel.instance(this.token).retrieve(),
	                checkoutAppData: _index2.$CheckoutAppDataModel.instance(this.props.token).retrieve(),
	                checkoutCart: _index2.$CheckoutCartModel.instance(this.token).retrieve()
	            };
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            this.locale = _index.$locale;
	            var days = [];
	            var months = [];
	            var years = [];
	
	            var i = void 0;
	
	            for (i = 1; i <= 31; i += 1) {
	                var d = i < 10 ? '0' + i : i.toString();
	                days.push(d);
	            }
	
	            for (i = 1; i <= 12; i += 1) {
	                var m = i < 10 ? '0' + i : i.toString();
	                months.push(m);
	            }
	
	            var year = new Date().getFullYear();
	
	            for (i = year - 17; i >= year - 100; i -= 1) {
	                years.push(i);
	            }
	
	            this.dobDays = days;
	            this.dobMonths = months;
	            this.dobYears = years;
	
	            this.hideHelper = true;
	        },
	        populate: function populate() {
	            var _this = this;
	
	            var shippingAddress = this.models.checkoutCart.get('purchase.shipping_address');
	            var billingAddress = this.models.checkoutCart.get('billing_address') || {};
	            billingAddress.first_name = this.models.checkoutCart.get('payer.first_name');
	            billingAddress.last_name = this.models.checkoutCart.get('payer.last_name');
	
	            // basic validation to check if any data is missing
	            var validateAddress = function validateAddress(address) {
	                return address && address.line1 && address.city && address.postal_code;
	            };
	
	            /**
	            /* Set prefill billing address. By default set to merchant passed billing address if its valid
	             * Otherwise prefill valid shipping address as billing address
	             */
	
	            var getDefaultAddress = function getDefaultAddress() {
	                var isValidBilling = validateAddress(billingAddress);
	                var isValidShipping = validateAddress(shippingAddress);
	                var defaultAddress = billingAddress;
	                _logger.$logger.info('pay_upon_invoice_is_billing_valid_' + isValidBilling);
	                if (!isValidBilling && isValidShipping) {
	                    defaultAddress = shippingAddress;
	                    _logger.$logger.info('pay_upon_invoice_set_shipping_as_default');
	                }
	                return defaultAddress || {};
	            };
	
	            var prefilledAddress = getDefaultAddress();
	
	            this.isPrefilledAddress = validateAddress(prefilledAddress) && prefilledAddress.first_name && prefilledAddress.last_name;
	            if (this.isPrefilledAddress) {
	                this.shipping = prefilledAddress;
	                this.shipping.recipientName = prefilledAddress.first_name + ' ' + prefilledAddress.last_name;
	                this.shipping.zipAndCity = prefilledAddress.postal_code + ' ' + prefilledAddress.city;
	            }
	
	            var getPayButtonText = function getPayButtonText() {
	                _this.useraction = _this.models.checkoutAppData.useraction();
	
	                var payButtonText = _index.$locale.content.get('common.agreeAndContinue');
	                if (_this.useraction && _this.useraction.toLowerCase() === 'commit') {
	                    payButtonText = _index.$locale.content.get('common.agreeAndPay');
	                }
	                return payButtonText;
	            };
	
	            this.payButtonText = getPayButtonText();
	
	            this.onboard = new _index3.$OnboardModel({
	                user: new _index3.$OnboardUserModel({
	                    country: _index.$locale.country
	                }),
	                billing_address: _index4.$BillingAddressModel.create(this.token, {
	                    country: _index.$locale.country
	                }, prefilledAddress),
	                shipping_address: _index2.$ShippingAddressModel.create(this.token, {
	                    country: _index.$locale.country
	                }, prefilledAddress)
	            });
	
	            // saving in to user object so that email field pre-populate if its passed in from setEc.
	            this.onboard.user.email = this.models.checkoutCart.payer && this.models.checkoutCart.payer.email;
	        }
	    },
	
	    actions: {
	        changeShipping: function changeShipping() {
	            this.isPrefilledAddress = !this.isPrefilledAddress;
	        },
	        onSubmit: function onSubmit() {
	            var _this2 = this;
	
	            this.onboard.billing_address.country = _index.$locale.country;
	            this.addressNormalization = new _index6.$AddressNormalizationModel({
	                address: this.onboard.billing_address
	            });
	
	            var handleValidation = function handleValidation() {
	
	                var data = {
	                    errorCodes: ['BILL_ADDR_NOT_ALLOWED']
	                };
	
	                _this2.errorMessage = _util.$fiErrorUtil.addPageErrors(data, 'payUponInvoice');
	
	                if (window.scrollTo) {
	                    window.scrollTo(0, 0);
	                }
	
	                return _angular.$q.reject();
	            };
	
	            this.addressNormalization.save({
	
	                data: this.addressNormalization,
	
	                contingencies: {
	                    VALIDATION_ERROR: function VALIDATION_ERROR() {
	                        handleValidation();
	                    }
	
	                },
	                error: function error() {
	                    _uiRouter.$state.go('checkout.genericError', { code: 'PAYMENT_PROCESS_ERROR' });
	                },
	                success: function success(result) {
	                    var loginDataGsid = {
	                        user: {
	                            email: _this2.onboard.user.email
	                        },
	                        pui_flow: true
	                    };
	                    // Adding login call to get the Global session ID
	                    // by passing email and actorinfovo(just with actor type) to STS.
	                    // auth_state will be anonymous after the below passive login call.
	                    // since account is not created yet.
	                    return _angular.$q.when().then(function () {
	                        _logger.$logger.info('PUI_Invoking_login_call_to_get_GSID');
	                        return _this2.models.auth.action('login', {
	                            data: loginDataGsid,
	                            success: function success() {
	                                _logger.$logger.info('PUI_login_call_succeeded');
	                            },
	                            error: function error() {
	                                _logger.$logger.info('PUI_login_call_failed_to_get_GSID');
	                                _uiRouter.$state.go('checkout.genericError', { code: 'PAYMENT_PROCESS_ERROR' });
	                            }
	                        }).then(function () {
	                            _this2.normalizedAddress = result;
	
	                            var checkoutSession = _index2.$CheckoutSessionModel.instance(_this2.token);
	
	                            checkoutSession.action('createPUI', {
	                                data: {
	                                    user: _this2.onboard.user,
	                                    address: _this2.onboard.billing_address,
	                                    isPayerRequired: true,
	                                    paymentMethod: 'pay_upon_invoice'
	
	                                },
	                                contingencies: {
	                                    PAYMENT_METHOD_UNUSABLE: function PAYMENT_METHOD_UNUSABLE() {
	                                        _uiRouter.$state.go('checkout.genericError', {
	                                            code: 'PAYMENT_PROCESS_ERROR'
	                                        });
	                                    }
	                                },
	                                error: function error() {
	                                    _logger.$logger.info('PUI: checkout session creation failed');
	                                    _uiRouter.$state.go('checkout.genericError', {
	                                        code: 'PAYMENT_PROCESS_ERROR'
	                                    });
	                                },
	                                success: function success(successResult) {
	                                    var loginData = {
	                                        user: {
	                                            account_number: successResult.payer.account_number,
	                                            email: successResult.payer.email
	                                        }
	                                    };
	
	                                    return _angular.$q.when().then(function () {
	                                        return _this2.models.auth.action('login', {
	                                            data: loginData,
	                                            success: function success() {
	                                                _logger.$logger.info('PUI: guest login', {
	                                                    from: 'LOGIN',
	                                                    to: 'process_login'
	                                                });
	                                            },
	                                            error: function error() {
	                                                _logger.$logger.info('PUI: login guest user failed');
	                                                _uiRouter.$state.go('checkout.genericError', { code: 'PAYMENT_PROCESS_ERROR' });
	                                            }
	                                        }).then(function () {
	                                            return checkoutSession.action('authorize', {
	                                                error: function error() {
	                                                    _logger.$logger.info('PUI: authorize payment failed');
	                                                    _uiRouter.$state.go('checkout.genericError', {
	                                                        code: 'PAYMENT_PROCESS_ERROR'
	                                                    });
	                                                },
	                                                success: function success() {
	                                                    _uiRouter.$state.go('checkout.end');
	                                                }
	                                            });
	                                        });
	                                    });
	                                },
	                                VALIDATION_ERROR: function VALIDATION_ERROR() {
	                                    _uiRouter.$state.go('checkout.genericError', {
	                                        code: 'PAYMENT_PROCESS_ERROR'
	                                    });
	                                }
	                            });
	                        });
	                    });
	                }
	            });
	        }
	    }
	});
	
	
	_angular.$q;
	
	_index.$Component;
	
	_index.$locale;
	
	_index2.$CheckoutSessionModel;
	
	_index2.$CheckoutAppDataModel;
	
	_index2.$CheckoutCartModel;
	
	_index2.$ShippingAddressModel;
	
	_index3.$OnboardModel;
	
	_index3.$OnboardUserModel;
	
	_index4.$BillingAddressModel;
	
	_util.$fiErrorUtil;
	
	_index5.$AuthModel;
	
	_logger.$logger;
	
	_uiRouter.$state;
	
	_index6.$AddressNormalizationModel;
	module.exports = exports['default'];

/***/ }),

/***/ "./components/xo-wallet-components/src/pay-upon-invoice/template.html":
/***/ (function(module, exports) {

	module.exports = "<div content class=\"payUponInvoice\" id=\"payUponInvoice\">\n\n\n    <div class=\"personalInfo\" >{{content('payUponInvoice.title')}}</div>\n    <xo-message message=\"errorMessage\"></xo-message>\n\n    <form id=\"payUponInvoiceForm\" name=\"payUponInvoiceForm\" class=\"payUponInvoiceForm\"\n          ng-submit=\"payUponInvoiceForm.$valid && actions.onSubmit()\" ng-class=\"{true: 'validated'}[validated]\" novalidate>\n\n        <div class=\"addressArea\">\n            <label class=\"nolap billingLabel\">{{content('payUponInvoice.addressTitle')}}</label>\n            <div  ng-if=\"isPrefilledAddress\" class=\"billingArea\">\n                <div class=\"addressDisplay\" >\n                    <div class=\"confidential streets street-address\">\n                        {{shipping.recipientName}}\n                    </div>\n\n                    <div class=\"confidential streets street-address\">\n                        {{shipping.line1}}\n                    </div>\n\n                    <div class=\"confidential streets street-address\" ng-if=\"shipping.line2\">\n                        {{shipping.line2}}\n                    </div>\n\n                    <div class=\"postal-code\">\n                        {{shipping.zipAndCity}}\n                    </div>\n                </div>\n            </div>\n            <a class=\"edits changeShipping\" ng-if=\"isPrefilledAddress\" ng-click=\"actions.changeShipping()\" >\n                {{ content('common.change') }}\n            </a>\n        </div>\n\n        <div id=\"billingAddress\" class=\"billingArea clearfix\" ng-if=\"!isPrefilledAddress\">\n            <div class=\"addressSubTitle\">{{content('payUponInvoice.notification')}}</div>\n            <xo-add-address address=\"onboard.billing_address\" is-shipping=\"true\" country=\"locale.country\"></xo-add-address>\n        </div>\n\n        <xo-email-input user=\"onboard.user\" hide-helper=\"hideHelper\"></xo-email-input>\n\n        <!-- DOB fields for Country specific cards -->\n        <!-- TODO: Pull out DOB fields into a separate component -->\n        <div id=\"cardDOB\" class=\"cardDOB inputField invisiField confidential last-child\" >\n            <label class=\"dobLabel nolap\" for=\"dobDayCC\">{{ content('creditcard.dob') }}</label>\n\n            <span class=\"dobHelper\">\n                <a href=\"#\" id=\"verifyHelp\" alt=\"Why do we need this\" class=\"verifyHelp\">\n                </a>\n            </span>\n\n            <xo-tooltip trigger=\"#verifyHelp\">\n                <div class=\"tip tipDesc emailToolTip\">\n                    {{ content('payUponInvoice.dobTooltip') }}\n                </div>\n            </xo-tooltip>\n            <div class=\"dropdown fidobDay nullable\">\n                <select xo-dropdown name=\"dobDayCC\" ng-model=\"onboard.user.dob_day\"\n                        ng-options=\"day for day in dobDays track by day\"\n                        id=\"dobDayCC\"  ng-required=\"true\">\n                    <option value=\"\">{{ content('applyForBml.bmlApplyDD') }}</option>\n                </select>\n            </div>\n\n            <div class=\"dropdown fidobMonth nullable\">\n                <select xo-dropdown name=\"dobMonthCC\" id=\"dobMonthCC\" ng-model=\"onboard.user.dob_month\"\n                        ng-options=\"month for month in dobMonths track by month\" ng-required=\"true\">\n                    <option value=\"\">{{ content('applyForBml.bmlApplyMM') }}</option>\n                </select>\n            </div>\n\n            <div class=\"dropdown fidobYear nullable\">\n                <select xo-dropdown name=\"dobYearCC\" id=\"dobYearCC\" ng-model=\"onboard.user.dob_year\"\n                        ng-options=\"year for year in dobYears track by year\" ng-required=\"true\">\n                    <option value=\"\">{{ content('applyForBml.bmlApplyYYYY') }}</option>\n                </select>\n            </div>\n        </div>\n        <div class=\"row-fluid checkbox legal\" >\n            <input ng-model=\"sepaAgree\" type=\"checkbox\" name=\"sepaAgree\" id=\"sepaAgree\" required/>\n            <label class=\"noBottom agreeSepaTerms\" for=\"sepaAgree\"\n                   bind-html-compile=\"htmlContent('payUponInvoice.agreeTerms')\"></label>\n        </div>\n\n\n        <div class=\"buttons\">\n            <input track-submit id=\"invoiceSubmit\" type=\"submit\" value=\"{{ payButtonText }}\"\n            class=\"btn\" ng-click=\"validated=true\" />\n        </div>\n    </form>\n</div>\n\n\n\n"

/***/ }),

/***/ "./components/xo-page-components/src/done/route.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-page-components/src/done/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('xo-done', ['squid', 'xo-done.directive']).factory('$DoneRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('DoneRoute', {
	            name: 'done',
	            directive: 'xo-done',
	            titleContent: 'done.paymentCompleted',
	            query: ['code'],
	            trackingData: {
	                fptiState: 'done_page',
	                templateName: 'memberDone.dust',
	                pageGoal: 'Payment Done Receipt',
	                trackStateExit: true,
	                buzname: {
	                    'fullpage': {
	                        'pagename': '%::fullpage-done',
	                        'pagename2': '%::fullpage-done:member:hermes:',
	                        'version': 'member:%:'
	                    }
	                }
	            },
	            children: []
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-page-components/src/done", "components/xo-page-components/src/done/route.js"))

/***/ }),

/***/ "./components/xo-page-components/src/route-to-complete/route.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-page-components/src/route-to-complete/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('xo-route-to-complete', ['squid', 'xo-route-to-complete.directive']).factory('$RouteToCompleteRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('RouteToCompleteRoute', {
	            name: 'routeToComplete',
	            directive: 'xo-route-to-complete',
	            titleContent: 'genericError.pleaseTryAgain',
	            query: ['url', 'urlType'],
	            trackingData: {
	                fptiState: 'route-to-complete',
	                buzname: {
	                    'fullpage': {
	                        'pagename': '%::route-to-complete',
	                        'pagename2': '%::route-to-complete:member:hermes:',
	                        'version': 'member:%:'
	                    }
	                }
	            },
	
	            children: []
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-page-components/src/route-to-complete", "components/xo-page-components/src/route-to-complete/route.js"))

/***/ }),

/***/ "./components/xo-page-components/src/route-to-complete/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	__webpack_require__("./components/xo-page-components/src/route-to-complete/styles.less");
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-page-components/src/route-to-complete/template.html"), __webpack_require__("./components/xo-models/src/checkout/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular, squid, template) {
	
	    return angular.module('xo-route-to-complete.directive', ['squid', 'xomodel.checkout']).directive('xoRouteToComplete', function ($rootScope) {
	
	        return {
	            template: template,
	
	            scope: {
	                token: '='
	            },
	
	            controller: function controller($scope, $rootScope, // eslint-disable-line no-shadow
	            $stateParams, $state, $logger, $CheckoutAppDataModel, $populate, $locale, $window) {
	
	                /* hide the footer cancel link */
	                angular.element('#defaultCancelLink').hide();
	
	                $rootScope.$on('$stateChangeStart', function (event) {
	                    event.preventDefault();
	                });
	
	                /* hide header paypal logo*/
	                $('.paypalHeaderWrapper').hide();
	
	                $('.footerWrapper').addClass('routecss');
	
	                /* urlType is passed from xo-end or from xo-page-components/footer/directive.
	                 * urltype can be either success(incase of successfull flow completion ) or cancel
	                 * */
	                var urlType = $stateParams.urlType;
	
	                // show the return to merchant url only in case of success.
	                if (urlType === 'success') {
	                    $scope.enableSuccessReturnUrl = true;
	                }
	
	                if (urlType === 'cancel') {
	                    // defaulting to False. Once the cancel content is available, turn it to true.
	                    $scope.enableCancelReturnUrl = true;
	                }
	
	                $scope.goToMerchant = function () {
	                    $window.onunload = $window.onbeforeunload = function () {};
	                    $window.location = $stateParams.url;
	                };
	
	                $populate($scope, {
	                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token)
	                }).then(function () {
	                    var merchant = $scope.checkoutAppData.merchant;
	                    $scope.merchant = merchant.brand_name || merchant.merchant_name || merchant.merchant_email;
	                });
	
	                $scope.$on('$destroy', function (event) {
	                    $('.paypalHeaderWrapper').show();
	                    $('.footerWrapper').removeClass('routecss');
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "./components/xo-page-components/src/route-to-complete/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-page-components/src/route-to-complete/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-page-components/src/route-to-complete/styles.less":
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "@media (min-width:41.3125em){section#routecss .container{width:400px}.routecss.footerWrapper{float:none;width:99.4%;padding:0 3px}.routecss.footerWrapper .footerLinks{float:left;width:70%;text-align:left}}section#routecss{height:450px;background:none}section#routecss .container{position:relative;margin:0 auto;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}section#routecss .title{font-size:1.5em;margin-bottom:15px}section#routecss .message{font-size:1em;margin-bottom:15px;color:#7b8388}section#routecss .secondaryMessage{color:#979797;line-height:20px}section#routecss .logo{width:112px;height:29px;margin:5px 0 20px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){section#routecss .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}section#routecss .cancelLink{margin-top:20px}", ""]);
	
	// exports


/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-page-components/src/route-to-complete/template.html":
/***/ (function(module, exports) {

	module.exports = "<section id=\"routecss\" content>\n    <div class=\"container\">\n        <div class=\"logo\"></div>\n        <div class=\"title\">{{content('genericMessage.paymentSuccessTitle')}}</div>\n        <div class=\"message\">{{content('genericMessage.successMessage')}}</div>\n        <div ng-if=\"enableSuccessReturnUrl\">\n            <div>\n                <input class=\"btn full loginBtn\" type=\"button\" value=\"{{content('genericMessage.returnButton')}}\" ng-click=\"goToMerchant()\"/>\n            </div>\n        </div>\n        <div ng-if=\"enableCancelReturnUrl\">\n            <div>\n                <input class=\"btn full loginBtn\" type=\"button\" value=\"{{merchant ? content('base.cancelUrl', { merchantName: merchant }) : content('common.cancelAndReturnToMerchant')}}\" ng-click=\"goToMerchant()\"/>\n            </div>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "./components/xo-form-components/src/inventory-soldout/route.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoSoldOutPageRoute = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _directive = __webpack_require__("./components/xo-form-components/src/inventory-soldout/directive.js");
	
	var _directive2 = _interopRequireDefault(_directive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoSoldOutPageRoute = exports.$xoSoldOutPageRoute = _squid.$ComponentRoute.extend('$xoSoldOutPageRoute', {
	
	    path: 'soldout',
	    directive: _directive2['default'],
	    titleContent: 'soldout.title',
	    query: ['items', 'soldOutUrl'],
	    auth: false,
	    trackingData: {
	        fptiState: 'soldout',
	        templateName: 'soldout.dust',
	        pageGoal: 'soldout page',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-soldout',
	                'pagename2': '%::fullpage-soldout:member:hermes:',
	                'version': 'member:%:'
	                // More page qualifiers come here...
	            } }
	    },
	
	    children: []
	});
	
	angular.value("$xoSoldOutPageRoute", $xoSoldOutPageRoute);
	_squid.$ComponentRoute;

/***/ }),

/***/ "./components/xo-form-components/src/inventory-soldout/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _util = __webpack_require__("./components/xo-return-to-merchant/dist/util.js");
	
	__webpack_require__("./components/xo-ui-components/src/modal/directive.js");
	
	var _template = __webpack_require__("./components/xo-form-components/src/inventory-soldout/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoSoldoutPageDirective', {
	    tag: 'xo-soldout-page',
	    template: _template2['default'],
	    auth: false,
	
	    actions: {
	        continueShoppingHandler: function continueShoppingHandler() {
	            _util.$ReturnToMerchant.goTo(decodeURIComponent(_uiRouter.$state.params.soldOutUrl), true);
	        }
	    },
	    lifecycle: {
	        enter: function enter() {
	            this.locale = _squid.$locale;
	            angular.element('.paypalHeader').css('display', 'none');
	            angular.element('#defaultCancelLink').css('display', 'none');
	        },
	        populate: function populate() {
	            this.item_name = decodeURIComponent(_uiRouter.$state.params.items);
	        }
	    }
	
	});
	
	
	_squid.$Component;
	
	_squid.$locale;
	
	_util.$ReturnToMerchant;
	
	_uiRouter.$state;
	module.exports = exports['default'];

/***/ }),

/***/ "./components/xo-ui-components/src/modal/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	__webpack_require__("./components/xo-ui-components/src/accessibility/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _template = __webpack_require__("./components/xo-ui-components/src/modal/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// Directives used in the template
	(0, _squid.$registerDirective)('xoModal', function () {
	    return {
	        template: _template2['default'],
	        restrict: 'E',
	        replace: true,
	        transclude: true,
	
	        scope: {
	            show: '=?',
	            showCloseButton: '=?',
	            onClose: '=?',
	            overrideDefaultContainer: '@?' // Boolean to determine if default styling should be applied to container
	        },
	
	        controller: function controller($scope) {
	            $scope.hideModal = function ($event) {
	                if ($event) {
	                    $event.preventDefault();
	                }
	
	                $scope.show = false;
	
	                if ($scope.onClose) {
	                    $scope.onClose();
	                }
	            };
	        }
	    };
	});
	
	_squid.$registerDirective;

/***/ }),

/***/ "./components/xo-ui-components/src/modal/template.html":
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-wrapper\" ng-show='show' content>\n\t<div class=\"modal-overlay\" ng-click=\"hideModal()\"></div>\n\t<div class=\"modal-dialog\" modal-box modal-cancel=\"hideModal()\">\n\t\t<div class=\"modal-content\" ng-class=\"{'modal-default': !overrideDefaultContainer}\" tabindex=\"-1\" focus-when=\"show\">\n\t\t\t<div ng-transclude>\n\t\t\t</div>\n\t\t\t<a link-button ng-if=\"showCloseButton\" ng-click=\"hideModal($event)\" class=\"close\"><span class=\"accessAid\">{{ content('common.back') }}</span></a>\n\t\t</div>\n\t</div>\n</div>\n"

/***/ }),

/***/ "./components/xo-form-components/src/inventory-soldout/template.html":
/***/ (function(module, exports) {

	module.exports = "<div id=\"soldOut\" content>\n    <div id=\"soldouticon\">\n        <div class=\"left_section\"> </div>\n\n        <div class=\"text_lines\">\n            <span id=\"text\">{{content ('soldout.icon')}}</span>\n        </div>\n\n        <div id=\"rightSection\">\n            <span class=\"shape-right\">   </span>\n        </div>\n    </div>\n\n    <div class=\"soldOutMessage\" ng-bind-html=\"htmlContent('soldout.message', {item: item_name})\">\n    </div>\n    <div>\n        <input id= \"Continue-Shopping\" class=\"btn full confirmButton continueButton\" type=\"button\" value=\"{{content ('soldout.continueShoppingButton')}}\" ng-click=\"actions.continueShoppingHandler()\"/>\n\n    </div>\n\n</div>\n"

/***/ }),

/***/ "./pages/xo-checkout/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	var _fn = __webpack_require__("./components/xo-guest-components/src/fraudnet/fn.js");
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./pages/xo-checkout/template.html"), __webpack_require__("./components/xo-ui-components/src/spinner/directive.js"), __webpack_require__("./components/xo-page-components/src/merchant-header/directive.js"), __webpack_require__("./components/xo-page-components/src/header/directive.js"), __webpack_require__("./components/xo-page-components/src/footer/directive.js"), __webpack_require__("./components/xo-page-components/src/cart/directive.js"), __webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js"), __webpack_require__("./components/xo-validation/dist/directive.js"), __webpack_require__("./components/xo-device-info/dist/index.js"), __webpack_require__("./components/xo-models/src/shippingMethod/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid, template) {
	
	    return angular.module('hermes.page.xo-checkout.directive', ['squid', 'xo-spinner.directive', 'xo-merchant-header.directive', 'xo-header.directive', 'xo-footer.directive', 'xo-cart.directive', 'xo-error-tooltip.directive', 'xo-validation.directive', 'xo-device-info']).directive('xoCheckout', function ($document, $config, $util) {
	
	        return {
	            template: template,
	            scope: {},
	
	            controller: function controller($scope, $rootScope, $state, $renderContent, $locale, $LocaleResolver, $DeviceInfo, $FallbackError, $feature, $populate, $CheckoutAppDataModel, $CheckoutCartModel, $CheckoutPayeeModel, $ShippingRuleSummaryModel) {
	
	                $scope.token = $rootScope.token;
	                $scope.locale = $locale;
	
	                _fn.$fn.trigger();
	
	                function setLanguageToggleFlags() {
	                    var landingPage = $scope.checkoutAppData.get('flags.landing_page');
	                    var hermesLoginRedirectParam = $util.param('hermesLoginRedirect');
	                    var languageToggleFeature = $feature('languageToggle');
	
	                    // Language Toggle - header
	                    if (landingPage === 'BILLING' && !hermesLoginRedirectParam) {
	                        $scope.languageSwitchHeader = { show: languageToggleFeature };
	                    } else {
	                        $scope.languageSwitchFooter = { show: languageToggleFeature };
	                    }
	                }
	
	                function checkShippingRulesExist() {
	                    return $populate($scope, {
	                        shippingRulesSummary: $ShippingRuleSummaryModel.instance($rootScope.token).retrieve({
	                            params: {
	                                merchant_id: $scope.checkoutPayee.merchant.id,
	                                currency_code: $scope.checkoutCart.purchase.amounts.total.currency_code
	                            }
	                        })
	                    });
	                }
	
	                $populate($scope, {
	                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
	                    checkoutCart: $CheckoutCartModel.instance($scope.token),
	                    checkoutPayee: $CheckoutPayeeModel.instance($scope.token)
	                }).then(function () {
	                    setLanguageToggleFlags();
	
	                    var isWpsFlow = $scope.checkoutAppData.doec_on_approve();
	                    if (isWpsFlow) {
	                        checkShippingRulesExist().then(function () {
	                            if ($scope.shippingRulesSummary && $scope.shippingRulesSummary.isSnTEnabled || $scope.checkoutCart.instantUpdateIntegration) {
	                                // preserve these cart amount values passed from the merchant
	                                // since they could get changed after SnT from profile/callback (in case instant update) is applied
	                                $scope.buttonParams = {
	                                    shipping: $scope.checkoutCart.purchase.amounts.shipping,
	                                    tax: $scope.checkoutCart.purchase.amounts.tax,
	                                    total: $scope.checkoutCart.purchase.amounts.total
	                                };
	                            }
	                        });
	                    }
	                });
	
	                // Change html dir attribute for RTL/LTR, append RTL styling if needed.
	                function setDirectionality() {
	                    $document.prop('documentElement').setAttribute('dir', $locale.metadata.directionality);
	                }
	
	                // Change html lang attribute and document title
	                function localizeHead() {
	                    $document.prop('documentElement').setAttribute('lang', $locale.lang);
	                    setDirectionality();
	
	                    var content = $renderContent('base.payPal');
	
	                    if (content) {
	                        $document.title = content;
	                    }
	                }
	
	                function getPaymentMethod() {
	                    var paymentMethodViaUrl = $util.param('paymentMethod');
	                    var paymentMethodViaCheckoutAppData = $scope.checkoutAppData.get('user_selected_funding_source_type') === 'PAY_UPON_INVOICE' ? 'invoice' : undefined;
	
	                    return paymentMethodViaCheckoutAppData || paymentMethodViaUrl;
	                }
	
	                function checkUnbranded() {
	                    var paymentMethod = getPaymentMethod();
	
	                    if (!paymentMethod || !config.allowedUnbrandedPayments) {
	                        // eslint-disable-line block-scoped-var, no-undef
	                        return false;
	                    }
	
	                    // If paymentMethod in URL is NOT in the list of allowed payment methods, return false
	                    if ($config.allowedUnbrandedPayments.indexOf(paymentMethod) === -1) {
	                        return false;
	                    }
	
	                    return true;
	                }
	
	                $scope.isUnbranded = checkUnbranded();
	
	                $scope.paymentMethod = '';
	
	                if ($scope.isUnbranded) {
	                    $scope.paymentMethod = getPaymentMethod();
	
	                    if ($scope.paymentMethod === 'invoice') {
	                        $scope.unbrandedTitle = 'payUponInvoice.header';
	                        $scope.unbrandedSubTitle = 'payUponInvoice.processedBy';
	                    }
	                }
	
	                $scope.isApp = $DeviceInfo.isApp();
	
	                var contentChange = $rootScope.$on('contentChange', localizeHead);
	
	                localizeHead();
	
	                var cancel = $rootScope.$on('allLoaded', function () {
	                    angular.element('#preloaderSpinner').hide();
	                    cancel();
	                });
	
	                $scope.$on('localeChange', function () {
	                    localizeHead();
	                    setLanguageToggleFlags();
	                });
	
	                $scope.$on('$destroy', function () {
	                    cancel();
	                    contentChange();
	                });
	
	                $document.bind('click', function (event) {
	                    $scope.$broadcast('clickBody', event.target);
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	_fn.$fn;

/***/ }),

/***/ "./components/xo-guest-components/src/fraudnet/fn.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _angular2 = _interopRequireDefault(_angular);
	
	__webpack_require__("./components/squid/dist/index.js");
	
	__webpack_require__("./components/xo-device-info/dist/index.js");
	
	__webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	(function exportProviders(angular) {
	    angular && angular.exportProviders(module, exports, __dirname, __filename);
	})(window.angular);
	
	_angular2['default'].module().factory('$fn', function ($populate, $rootScope, $window, $DeviceInfo, $logger, $config, $util, $meta, $q) {
	
	    var fncls = 'fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99';
	
	    function getFnCorrId() {
	
	        var fnCorrId = $rootScope.token || $meta.token;
	
	        if ($meta.baToken) {
	            $logger.info('BEAM_In_Hermes_Checkout');
	            fnCorrId = $meta.baToken;
	        } else if ($rootScope.fraudNetId) {
	            fnCorrId = $rootScope.fraudNetId;
	        }
	
	        return fnCorrId;
	    }
	
	    var options = {
	        fnSessionId: getFnCorrId(),
	        sourceId: 'XOONBOARDINGNODEWEB',
	        allowsCustomEvent: typeof CustomEvent !== 'undefined' && _angular2['default'].isFunction(CustomEvent),
	        fnUrl: $config.urls.fraudnetUrl.passive,
	        passive: true
	    };
	
	    $logger.info('FN_Initialised', {
	        'allowsCustomEvent': options.allowsCustomEvent
	    });
	
	    function injectScript(fnUrl) {
	        var script = document.createElement('script');
	        script.id = 'js-sync';
	        script.src = fnUrl;
	        document.body.appendChild(script);
	    }
	
	    function injectIframe(beaconOptions) {
	        var iframe = document.createElement('iframe');
	        var dom = void 0;
	        var doc = void 0;
	        var where = void 0;
	
	        iframe.src = 'javascript:false'; // eslint-disable-line no-script-url
	        iframe.title = '';
	        iframe.role = 'presentation';
	        (iframe.frameElement || iframe).style.cssText = 'width: 0; height: 0; border: 0; display: none;';
	
	        where = document.getElementsByTagName('script');
	        where = where[where.length - 1];
	        where.parentNode.insertBefore(iframe, where);
	
	        try {
	            doc = iframe.contentWindow.document;
	        } catch (e) {
	            dom = document.domain;
	            iframe.src = 'javascript:var d=document.open();d.domain="' + dom + '";void(0);'; // eslint-disable-line no-script-url
	            doc = iframe.contentWindow.document;
	        }
	
	        doc.open()._l = function () {
	            var js = this.createElement('script');
	            if (dom) {
	                this.domain = dom;
	            }
	            js.id = 'js-iframe-async';
	            js.src = beaconOptions.fnUrl;
	            this.body.appendChild(js);
	        };
	
	        doc.write('<body onload="document._l();">');
	        doc.close();
	    }
	
	    function _injectConfig(configOptions) {
	        var script = document.getElementById('fconfig');
	
	        if (script) {
	            if (script.parentNode) {
	                script.parentNode.removeChild(script);
	            }
	        }
	
	        script = document.createElement('script');
	        script.id = 'fconfig';
	        script.type = 'application/json';
	        script.setAttribute('fncls', fncls);
	
	        script.text = '{"f": "' + configOptions.fnSessionId + '", "s": "' + configOptions.sourceId + '", "cb": "fnCallback"}';
	        document.body.appendChild(script);
	    }
	
	    /**
	     * Loads the fraudnet beacons (triggers 2 image beacons to c.paypal.com and c6.paypal.com)
	     *
	     * Integration pattern ripped from the Fraudnet Integration guide:
	     * https://confluence.paypal.com/display/RiskDataAcquisition/FraudNet+Client+System+Integration+Guide+3.0#FraudNetClientSystemIntegrationGuide3.0-IntegrationCode
	     */
	    function _loadBeacon(beaconOptions) {
	        if ($DeviceInfo.isApp()) {
	            injectScript(beaconOptions.fnUrl);
	        } else {
	            injectIframe(beaconOptions);
	        }
	    }
	
	    function trigger(scope) {
	        var fnLoaded = !!$rootScope.fnLoaded;
	
	        if (fnLoaded || !(0, _squid.$feature)('enableFraudnet')) {
	            return false;
	        }
	
	        if (options.fnUrl) {
	            $window.fnCallback = function () {
	                if (scope) {
	                    scope.$emit('fnCallback');
	                }
	            };
	            _injectConfig(options);
	            _loadBeacon(options);
	            $rootScope.fnLoaded = true;
	            return true;
	        }
	        return false;
	    }
	
	    return {
	        trigger: trigger
	    };
	});
	
	_squid.$feature;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-guest-components/src/fraudnet", "components/xo-guest-components/src/fraudnet/fn.js"))

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./pages/xo-checkout/template.html":
/***/ (function(module, exports) {

	module.exports = "<div class=\"outerWrapper\" ng-class=\"[locale.metadata.directionality, locale.country, locale.lang, miniBrowser?'minibrowser':'', isApp?'mobileApp':'']\" id=\"outerWrapper\">\n    <xo-merchant-header token=\"token\"></xo-merchant-header>\n    <div id=\"wrapper\" class=\"clearfix\">\n        <div id=\"main\" tabindex=\"-1\">\n            <xo-header token=\"token\" is-unbranded=\"isUnbranded\" unbranded-title=\"unbrandedTitle\"\n                       unbranded-sub-title=\"unbrandedSubTitle\" language-switch=\"languageSwitchHeader\"></xo-header>\n            <div id=\"contents\">\n                <div ui-view></div>\n            </div>\n        </div>\n        <xo-spinner></xo-spinner>\n    </div>\n    <xo-footer token=\"token\" language-switch=\"languageSwitchFooter\"></xo-footer>\n</div>\n"

/***/ }),

/***/ "./components/xo-ui-components/src/spinner/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-ui-components/src/spinner/template.html"), __webpack_require__("./components/xo-beaver/dist/logger.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid, template) {
	
	    squid.module('xo-spinner.directive', ['squid', 'beaver']).directive('xoSpinner', function () {
	
	        return {
	            scope: {},
	            template: template,
	            controller: function controller($scope, $element, $rootScope, $Api, $locale, $logger, $loader, $timeout) {
	
	                var $body = angular.element(document.getElementsByTagName('body'));
	                var $priorActiveElement = $();
	                var $capturedElement = $();
	                var $header = $('header');
	                var $slidingArea = $('#main');
	                var $footer = $('footer');
	
	                /**
	                 * This hides page content from any screen readers.
	                 * When the spinner's active, the only thing that should be read out is the "Loading..." text.
	                 *
	                 * The only crappy thing here is the spinner's nested deep in the content, so please excuse this jQuery crap.
	                 * At the very least, let's cache these selectors :|
	                 */
	                function hidePageContentFromScreenReader(toggle) {
	                    $header.attr('aria-disabled', toggle);
	                    $slidingArea.attr('aria-disabled', toggle);
	                    $footer.attr('aria-disabled', toggle);
	                }
	
	                function preventDefault(event) {
	                    event.preventDefault();
	                }
	
	                function captureFocus(event) {
	                    if (!$element.has(event.target).length) {
	                        $capturedElement = $(event.target);
	                    }
	                }
	
	                function setLoadingMessage(message) {
	                    if (angular.isObject(message)) {
	                        $scope.message = message.heading;
	                        $('#spinnerMessage').css('font-size', '17.5px');
	                        $('#spinnerMessage').html(message.heading);
	                        $('#spinnerSubHeading').html(message.subHeading);
	                    } else {
	                        $scope.message = message;
	                        $('#spinnerMessage').html(message);
	                    }
	                }
	
	                function showSpinner() {
	                    $scope.loading = true;
	                    $logger.info('show_loading_spinner');
	                    $body.addClass('loading');
	
	                    // remember what was previously focused
	                    $priorActiveElement = $(':focus');
	
	                    $(':input, a').blur();
	
	                    hidePageContentFromScreenReader(true);
	
	                    if ($loader.firstLoad()) {
	                        setLoadingMessage($locale.content.get('base.processing'));
	                    }
	
	                    // focus on the message so that screen readers will let the user know the page is loading
	                    $(document).on('keydown', preventDefault);
	                    $(document).on('focusin', captureFocus);
	                    $timeout(function () {
	                        $('#spinner-message').focus();
	                    });
	                }
	
	                function hideSpinner() {
	                    $scope.loading = false;
	                    $logger.info('hide_loading_spinner');
	                    $('#preloaderSpinner').hide();
	                    $body.removeClass('loading');
	                    $(document).off('keydown', preventDefault);
	                    $(document).off('focusin', captureFocus);
	
	                    hidePageContentFromScreenReader(false);
	
	                    // Focus captured element if focus was given to an element while spinner was active.
	                    if ($capturedElement.length && $(document.body).has($capturedElement).length) {
	                        $capturedElement.focus();
	                        // Focus element that had focus before if it is still within the document
	                    } else if ($priorActiveElement.length && $(document.body).has($priorActiveElement).length) {
	                        $priorActiveElement.focus();
	                    } else {
	                        // If focus is not managed, default to focusing sliding area. Fixes FF and IE bug where tab focus starts from
	                        // the element last clicked, rather than top of page.
	                        $slidingArea.focus();
	                    }
	                    $priorActiveElement = $();
	                    $capturedElement = $();
	                }
	
	                var cancelStartLoad = $rootScope.$on('startLoad', showSpinner);
	                var cancelAllLoaded = $rootScope.$on('allLoaded', hideSpinner);
	
	                var cancelSetLoadingMessage = $rootScope.$on('loadingMessage', function (event, text) {
	                    setLoadingMessage(text);
	                });
	
	                $scope.$on('$destroy', function () {
	                    hideSpinner();
	                    cancelStartLoad();
	                    cancelAllLoaded();
	                    cancelSetLoadingMessage();
	                });
	
	                if ($loader.isLoading()) {
	                    showSpinner();
	                }
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-ui-components/src/spinner/template.html":
/***/ (function(module, exports) {

	module.exports = "<div ng-if=\"loading\" id=\"spinner\" class=\"spinner\">\n    <div class=\"spinWrap\">\n        <p class=\"spinnerImage\"></p>\n        <p class=\"loader\"></p>\n        <p id=\"spinner-message\" tabIndex=\"0\" role=\"alert\" class=\"loadingMessage\">{{message}}</p>\n    </div>\n</div>\n"

/***/ }),

/***/ "./components/xo-page-components/src/merchant-header/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _index = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _index2 = __webpack_require__("./components/xo-models/src/user/index.js");
	
	var _template = __webpack_require__("./components/xo-page-components/src/merchant-header/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoMerchantHeaderDirective', {
	    tag: 'xo-merchant-header',
	    template: _template2['default'],
	    props: {
	        token: {
	            type: 'var',
	            required: false
	        },
	        merchant: {
	            type: 'var',
	            required: false
	        }
	    },
	
	    resolve: {
	        models: function models() {
	            if (this.props.token) {
	                return {
	                    checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve()
	                };
	            }
	        }
	    },
	
	    lifecycle: {
	        populate: function populate() {
	            if (this.props.token && !_index2.$CheckoutInputDataModel.instance(this.props.token).isEbayTxn()) {
	                this.merchant = this.models.checkoutAppData.merchant;
	            }
	        }
	    }
	});
	
	
	(0, _squid.$registerDirective)('xoMerchantImageResize', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element) {
	            element.bind('load', function () {
	                var MAX_WIDTH = 780;
	                var MAX_HEIGHT = 90;
	
	                if (this.width > MAX_WIDTH) {
	                    var ratio = MAX_WIDTH / this.width;
	                    var height = this.height * ratio;
	
	                    this.width = MAX_WIDTH;
	                    this.height = height > MAX_HEIGHT ? MAX_HEIGHT : height;
	                }
	            });
	        }
	    };
	});
	
	_squid.$Component;
	
	_squid.$registerDirective;
	
	_index.$CheckoutAppDataModel;
	
	_index2.$CheckoutInputDataModel;
	module.exports = exports['default'];

/***/ }),

/***/ "./components/xo-page-components/src/merchant-header/template.html":
/***/ (function(module, exports) {

	module.exports = "<header role=\"banner\">\n    <div id=\"header\" class=\"merchantHeader clearfix\">\n        <div class=\"headerWrapper\">\n            <span class=\"merchantName\" directionality-text=\"merchant.brand_name || merchant.merchant_name || merchant.merchant_email\" ng-if=\"!(merchant.logo_url || merchant.imageUrl)\">\n             {{ merchant.brand_name || merchant.merchant_name || merchant.merchant_email }}\n         \t</span>\n            <img ng-src=\"{{merchant.logo_url || merchant.imageUrl}}\" alt=\"{{ merchant.brand_name || merchant.merchant_name || merchant.merchant_email }}\" ng-if=\"merchant.logo_url || merchant.imageUrl\" xo-merchant-image-resize/>\n        </div>\n    </div>\n</header>\n"

/***/ }),

/***/ "./components/xo-page-components/src/footer/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-page-components/src/footer/template.html"), __webpack_require__("./components/xo-page-components/src/footer/opinionlab.js"), __webpack_require__("./components/xo-page-components/src/footer/footerMap.js"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-ui-components/src/modal/directive.js"), __webpack_require__("./components/xo-return-to-merchant/dist/util.js"), __webpack_require__("./components/xo-ui-components/src/escape-hatch/escapeHatch/directive.js"), __webpack_require__("./components/xo-device-info/dist/index.js"), __webpack_require__("./components/xo-form-components/src/language-options/directive.js"), __webpack_require__("./components/xo-models/src/user/index.js"), __webpack_require__("./components/xo-models/src/auth/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template, opinionlab, footerMap) {
	    squid.module('xo-footer.directive', ['squid', 'xomodel.checkout', 'xo-modal.directive', 'xo-return-to-merchant', 'xo-escape-hatch.escapeHatch.directive', 'xo-device-info', 'xo-language-options.directive', 'xomodel.user']).directive('xoFooter', function () {
	
	        return {
	            template: template,
	            restrict: 'EA',
	            scope: {
	                token: '=',
	                escapeHatchIncontext: '=',
	                cancel: '@',
	                merchant: '@',
	                languageSwitch: '=?',
	                showVenmoLegalLinks: '='
	            },
	            controller: function controller($scope, $populate, $rootScope, $CheckoutAppDataModel, $CheckoutPayeeModel, $ReturnToMerchant, $util, $integration, $locale, $window, $DeviceInfo, $feature, $config, $state, $CheckoutInputDataModel, $AuthModel) {
	
	                $scope.isIFrame = $util.isIFrame();
	                if ($scope.escapeHatchIncontext) {
	                    $scope.showEscapeHatch = $scope.isIFrame;
	                }
	                $scope.locale = $locale;
	                $scope.proxSignUpFlow = $CheckoutInputDataModel.instance($scope.token).isEbayTxn();
	                $scope.year = new Date().getFullYear();
	
	                $scope.isApac = function () {
	                    return $config.apacCountries && $config.apacCountries.indexOf($scope.locale.country) > -1;
	                };
	
	                // Determine if country belongs to a region to serve correct footer links
	                var getRegion = function getRegion(country) {
	                    var regions = $config.regions;
	                    for (var region in regions) {
	                        if (regions[region].indexOf(country) > -1) {
	                            return region;
	                        }
	                    }
	                    return false;
	                };
	
	                function isDESecondButtonFlow() {
	                    return $scope.locale.country === 'DE' && $scope.checkoutAppData && $scope.checkoutAppData.is_second_button_txn;
	                }
	
	                $scope.footerLinks = function () {
	
	                    if ($scope.isApac()) {
	                        return footerMap.APAC;
	                    }
	
	                    // It is a product requirement that for the DE CYCO page, Hermes only show the footer links
	                    // that were available in Aries
	                    if (isDESecondButtonFlow()) {
	                        return footerMap['DESecondButton'];
	                    }
	
	                    return footerMap[$scope.locale.country] || footerMap[getRegion($scope.locale.country)] || footerMap.DEFAULT;
	                };
	
	                $scope.showPolicyInfo = function () {
	                    return $scope.isApac() || $scope.locale.country === 'AU';
	                };
	
	                $scope.cancelRedirect = function ($event) {
	                    $event.preventDefault();
	
	                    var cancelUri = $scope.cancel;
	                    var redirectUri;
	
	                    // "redirect_uri" as a query param overrides the cancel url in the checkout session
	                    if ($integration.getConfig('REDIRECT_QUERY_PARAM')) {
	                        redirectUri = $util.param('redirect_uri');
	
	                        cancelUri = $util.buildURL(redirectUri, {
	                            opType: 'cancel',
	                            return_uri: $scope.cancel,
	                            token: $scope.token
	                        });
	                    }
	
	                    $ReturnToMerchant.goTo(cancelUri);
	                };
	
	                $scope.isIndiaLegalEntity = function () {
	                    // for PayPal India domestic launch legal entity should be 84
	                    // update footer with indian policy for this case
	                    return $scope.auth && $scope.auth.logged_in && $scope.auth.legalEntity === 84;
	                };
	
	                if ($scope.token) {
	                    $populate($scope, {
	                        checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
	                        checkoutPayee: $CheckoutPayeeModel.instance($scope.token),
	                        auth: $AuthModel.instance()
	                    }).then(function () {
	                        var merchant = $scope.checkoutAppData.merchant;
	
	                        var payee = $scope.checkoutPayee;
	
	                        if (payee && payee.merchant && payee.merchant.id) {
	                            var hcl = $config.hideCancelLinkForMerchant;
	
	                            var shouldHide = hcl && hcl.indexOf(payee.merchant.id) !== -1;
	                            if (shouldHide) {
	                                $scope.hideCancel = true;
	                            }
	                        }
	                        $scope.cancel = $scope.checkoutAppData.urls.cancel_url;
	                        $scope.merchant = merchant.brand_name || merchant.merchant_name || merchant.merchant_email;
	
	                        // for ebay transactions, override the merchant name to ebay instead of the actual merchant.
	                        if ($scope.proxSignUpFlow) {
	                            $scope.merchant = $locale.content.signup.ebay;
	                        }
	                    });
	                }
	
	                var cancelShowModal = $rootScope.$on('showModal', function (event, config) {
	                    $scope.popupUrl = config && config.popupUrl;
	                    $scope.show = true;
	                    $scope.$digest(); // eslint-disable-line angular/ng_no_digest
	                });
	
	                $scope.$on('$destroy', cancelShowModal);
	
	                $scope.showOL = function showOL(event) {
	                    event.preventDefault();
	
	                    var placeholder = 'main:ec:hermes';
	                    var page = $state.current.get('trackingData.buzname.fullpage.pagename2', 'unknown').replace('%', placeholder);
	
	                    var data = {
	                        opVars: {
	                            rlogId: $window.meta.rlogId || '',
	                            page: page || window.location.hash,
	                            csci: 'Unknown',
	                            calc: $window.meta.correlationId,
	                            custId: 'Unknown',
	                            merchantId: 'Unknown',
	                            token: $scope.token || 'Unknown'
	                        },
	                        locale: {
	                            country: $locale.country,
	                            languageCode: $locale.lang + '_' + $locale.country
	                        }
	                    };
	
	                    opinionlab(data);
	                };
	
	                $scope.showFeedback = function () {
	                    return !$DeviceInfo.isDevice() && !isDESecondButtonFlow();
	                };
	
	                $scope.hideReturnCancelUrl = function () {
	                    return !$scope.cancel || $state.current && $state.current.name === 'checkout.done';
	                };
	
	                $scope.showVenmoLinks = function () {
	                    // if on payWithSelection State, always show it, else we choose whatever 'checkout' directive says.
	                    if ($state.current && $state.current.name === 'checkout.payWithSelection') {
	                        return true;
	                    } else {
	
	                        return Boolean($scope.showVenmoLegalLinks);
	                    }
	                };
	
	                $scope.showPaypalLinks = function () {
	                    // will force Paypal Links if on payWithSelection state. Hide paypal links if we explicitly request venmo Links
	
	                    if ($state.current && $state.current.name === 'checkout.payWithSelection') {
	                        return true;
	                    } else {
	
	                        return !Boolean($scope.showVenmoLegalLinks);
	                    }
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "./components/xo-page-components/src/footer/opinionlab.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	    var _doc = document;
	    var _w = window;
	    var _tm = new Date().getTime();
	    var _sH = screen.height;
	    var _ht = escape(_w.location.href); // eslint-disable-line block-scoped-var,no-undef
	    var _hr = escape(_doc.referrer); // eslint-disable-line block-scoped-var,no-undef
	    var _sW = screen.width;
	
	    function popUp(opinionlabURL) {
	        _w.open(opinionlabURL, 'comments', 'width=535,height=192' + ',screenX=' + (_sW - 535) / 2 + ',screenY=' + (_sH - 192) / 2 + ',top=' + (_sH - 192) / 2 + ',left=' + (_sW - 535) / 2 + ',resizable=yes' + ',copyhistory=yes' + ',scrollbars=no');
	    }
	
	    function updateCustomVars(data) {
	
	        var opVars = data.opVars;
	        var locale = data.locale;
	
	        _ht = 'https://' + locale.country + '.paypal.com/' + locale.languageCode + '/00/' + escape(opVars.page.replace(/\s|\//g, '_')) + '.page'; // eslint-disable-line block-scoped-var,no-undef
	
	        var customVar = (opVars.rlogId || opVars.calc) + '|' + opVars.csci + '|' + opVars.page + '|' + locale.country + '|' + locale.languageCode + '|' + opVars.custId + '|' + opVars.merchantId + '|' + opVars.token + '|' + 'Unknown';
	        return customVar;
	    }
	
	    function _fC(_u) {
	        var _sp = '%3A\\/\\/';
	        var _rp = '%3A//';
	        var _aT = _sp + ',\\/,\\.,-,_,' + _rp + ',%2F,%2E,%2D,%5F';
	        var _aA = _aT.split(',');
	
	        for (var i = 0; i < 5; i++) {
	            eval('_u=_u.replace(/' + _aA[i] + '/g,_aA[i+5])'); // eslint-disable-line no-eval
	        }
	        return _u;
	    }
	
	    return function (locale) {
	
	        var custom_var = updateCustomVars(locale);
	
	        var opinionlabURL = 'https://secure.opinionlab.com/ccc01/comment_card.asp?' + 'time1=' + _tm + '&time2=' + new Date().getTime() + '&prev=' + _fC(_hr) + '&referer=' + _fC(_ht) + '&height=' + _sH + '&width=' + _sW + '&custom_var=' + custom_var;
	        popUp(opinionlabURL);
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "./components/xo-page-components/src/footer/footerMap.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	!(module.exports = {
	    CA: [{
	        id: 'policy',
	        content: 'footer.policiesCA'
	    }, {
	        id: 'terms',
	        content: 'footer.termsCA'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacyCA'
	    }],
	
	    BE: [{
	        id: 'legal',
	        content: 'footer.legal'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	
	    DE: [{
	        id: 'imprint',
	        content: 'footer.DEImprint'
	    }, {
	        id: 'legal',
	        content: 'footer.DELegal'
	    }, {
	        id: 'privacy',
	        content: 'footer.DEPrivacy'
	    }, {
	        id: 'paymentdesc',
	        content: 'footer.DEKeyPaymentDesc'
	    }],
	
	    ES: [{
	        id: 'legal',
	        content: 'footer.legal'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	
	    FR: [{
	        id: 'legal',
	        content: 'footer.FRLegal'
	    }, {
	        id: 'useragreement',
	        content: 'footer.FRUserAgreement'
	    }, {
	        id: 'privacy',
	        content: 'footer.FRPrivacy'
	    }],
	
	    IT: [{
	        id: 'legal',
	        content: 'footer.legal'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	
	    NL: [{
	        id: 'legal',
	        content: 'footer.legal'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	
	    IE: [{
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'useragreement',
	        content: 'footer.userAgreement'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	
	    APAC: [{
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'useragreement',
	        content: 'footer.userAgreement'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    EMEA: [{
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'useragreement',
	        content: 'footer.userAgreement'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    EM: [{
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'useragreement',
	        content: 'footer.userAgreement'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    LATAM: [{
	        id: 'help',
	        content: 'footer.help'
	    }, {
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	
	    AU: [{
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    AT: [{
	        id: 'imprint',
	        content: 'footer.ATImprint'
	    }, {
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    CH: [{
	        id: 'imprint',
	        content: 'footer.CHImprint'
	    }, {
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    DK: [{
	        id: 'useragreement',
	        content: 'footer.DKUserAgreement'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    SE: [{
	        id: 'useragreement',
	        content: 'footer.SEUserAgreement'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    PL: [{
	        id: 'useragreement',
	        content: 'footer.PLUserAgreement'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    NO: [{
	        id: 'useragreement',
	        content: 'footer.NOUserAgreement'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    TR: [{
	        id: 'useragreement',
	        content: 'footer.TRUserAgreement'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    BR: [{
	        id: 'help',
	        content: 'footer.help'
	    }, {
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    MX: [{
	        id: 'help',
	        content: 'footer.help'
	    }, {
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    RU: [{
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	
	    DESecondButton: [{
	        id: 'imprint',
	        content: 'footer.DEImprint'
	    }, {
	        id: 'privacy',
	        content: 'footer.DEPrivacy'
	    }],
	
	    DEFAULT: [{
	        id: 'policy',
	        content: 'footer.policies',
	        venmoContent: 'footer.venmo_policies'
	    }, {
	        id: 'terms',
	        content: 'footer.terms',
	        venmoContent: 'footer.venmo_terms'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy',
	        venmoContent: 'footer.venmo_privacy'
	    }]
	});

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-page-components/src/footer/template.html":
/***/ (function(module, exports) {

	module.exports = "<footer content>\n    <div class=\"footer clearfix commonFooter\" role=\"contentinfo\" ng-class=\"{APAC: isApac()}\">\n        <p ng-if=\"!hideCancel\" id=\"defaultCancelLink\" class=\"cancelUrl\">\n            <a track-link=\"cancel_and_return_to_merchant\" href=\"{{cancel}}\" ng-click=\"cancelRedirect($event)\" role=\"button\" id=\"cancelLink\" ng-hide=\"hideReturnCancelUrl()\">\n               <span ng-bind-html=\"merchant ? content('base.cancelUrl', { merchantName: merchant, modelName: 'merchant' }) : content('common.cancelAndReturnToMerchant')\"></span>\n            </a>\n        </p>\n\n        <div class=\"footerWrapper\">\n            <table class=\"footerLinks\">\n                <tr ng-if=\"showPaypalLinks()\">\n                    <th ng-repeat=\"link in footerLinks()\" id =\"footer_{{link.id}}\" bind-html-compile=\"htmlContent(link.content, {country: locale.country.toLowerCase(), lang: locale.lang})\"></th>\n                    <th ng-if=\"showFeedback()\"><a href=\"#\" id=\"footer_sfLink\" ng-click=\"showOL($event)\">{{content('OpinionLab.SiteFeedback')}}</a></th>\n                </tr>\n                <tr ng-if=\"showVenmoLinks()\">\n                    <td ng-repeat=\"link in footerLinks()\" id =\"venmoFooter_{{link.id}}\" bind-html-compile=\"htmlContent(link.venmoContent, {country: locale.country.toLowerCase(), lang: locale.lang})\"></td>\n                    <td ng-if=\"showFeedback()\"></td>\n                </tr>\n            </table>\n            <p class=\"copyright\">\n                {{ content('footer.copyright', {year: year}) }}\n                <span class=\"secureIcon\"></span>\n                <span class=\"accessAid\">{{ content('memberReview.propHead') }}</span>\n            </p>\n\n            <xo-language-options ng-if=\"languageSwitch && languageSwitch.show\"></xo-language-options>\n        </div>\n\n        <div class=\"policyInfoWrapper\" ng-if=\"showPolicyInfo()\">\n            <p class=\"moreInfo\" ng-if=\"isIndiaLegalEntity()\" ng-bind-html=\"htmlContent('footer.4plpolicyInformation', {country: locale.country})\"> </p>\n            <p class=\"moreInfo\" ng-if=\"!isIndiaLegalEntity()\" ng-bind-html=\"htmlContent('footer.policyInformation', {country: locale.country})\"> </p>\n            <p class=\"moreCopyRight\" ng-if=\"locale.country === 'AU'\">{{ content('footer.moreCopyright', {year: year}) }}</P>\n        </div>\n\n    </div>\n    <xo-modal>\n        <p>{{ content('footer.openLinks') }}</p>\n        <p class=\"popLink\">{{popupUrl}}</p>\n        <input class=\"btn btn-submit full\" type=\"button\" ng-click=\"hideModal()\" value=\"{{ content('footer.okBtn') }}\">\n    </xo-modal>\n</footer>\n"

/***/ }),

/***/ "./components/xo-ui-components/src/escape-hatch/escapeHatch/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-ui-components/src/escape-hatch/escapeHatch/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	
	    squid.module('xo-escape-hatch.escapeHatch.directive', ['squid']).directive('xoEscapeHatch', function () {
	        return {
	            template: template,
	
	            restrict: 'E',
	
	            controller: function controller($scope, $rootScope, $window, $util, $logger) {
	                $scope.isIFrame = $util.isIFrame();
	                $scope.closeFrame = function (event) {
	                    var url = $window.location.href && $window.location.href.split('#')[0] || '';
	
	                    if (url.indexOf('proxflow') > -1) {
	                        url = url.replace('proxflow', 'webapps/helios');
	                    }
	
	                    url += url.slice(-1) === '&' ? 'escape_hatch=1' : '&escape_hatch=1';
	
	                    if (url.indexOf('hermes') > -1 || url.indexOf('checkoutnow')) {
	                        $logger.info('HERMES_ESCAPE_HATCH_CLICKED');
	                    } else {
	                        $logger.info('HELIOS_ESCAPE_HATCH_CLICKED');
	                    }
	
	                    $window.top.location = url;
	                    $scope.$emit('exitFrame');
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-ui-components/src/escape-hatch/escapeHatch/template.html":
/***/ (function(module, exports) {

	module.exports = "<button ng-show=\"isIFrame\" title=\"{{content('footer.escHatch')}}\" class='btn escapeHatch' ng-click=\"closeFrame()\"><span class=\"accessAid\">{{content('footer.escHatch')}}</span></button>\n"

/***/ }),

/***/ "./components/xo-form-components/src/language-options/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-form-components/src/language-options/template.html"), __webpack_require__("./components/xo-ui-components/src/accessibility/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid, template) {
	    squid.module('xo-language-options.directive', ['squid', 'xo-accessibility.directive']).directive('xoLanguageOptions', function () {
	        return {
	            template: template,
	
	            scope: {},
	
	            controller: function controller($scope, $populate, $locale, $Class, $config, $meta) {
	                $scope.showLanguages = false;
	
	                function setLanguageVars() {
	                    $scope.localeModel = $locale;
	                    $scope.currentLanguage = $scope.localeModel.lang;
	                    $scope.currentCountry = $scope.localeModel.country;
	                    $scope.languageList = $scope.localeModel.metadata.languageLabel;
	                    $scope.supportedLanguages = $config.supportedCountries[$scope.currentCountry];
	                    $scope.hasMultipleLanguages = $scope.supportedLanguages && $scope.supportedLanguages.length > 1 ? true : false;
	                }
	
	                $scope.selectLanguage = function (language) {
	                    $scope.currentLanguage = language;
	                    $locale.chooseLang(language);
	                };
	
	                $scope.toggle = function ($event) {
	                    if ($event) {
	                        $event.preventDefault();
	                    }
	
	                    $scope.showLanguages = !$scope.showLanguages;
	                };
	
	                setLanguageVars();
	
	                // Reset locale properties for languageToggle
	                $scope.$on('localeChange', function () {
	                    setLanguageVars();
	                });
	
	                // "clickBody" is an artifical event broadcast by the xo-checkout component (essentially document.click)
	                $scope.$on('clickBody', function ($event, target) {
	                    if ($(target).parents('.languageToggleDisplay div').length === 0) {
	                        $scope.showLanguages = false;
	                        $scope.$apply();
	                    }
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-form-components/src/language-options/template.html":
/***/ (function(module, exports) {

	module.exports = "<div class=\"languageToggleDisplay\" content feature=\"languageToggle\" ng-if=\"hasMultipleLanguages\">\n    <div>\n        <a id=\"clickLanguageToggle\" lang=\"{{ currentLanguage }}\" aria-expanded=\"{{showLanguages}}\" aria-label=\"{{ content('languages.label', {language: languageList[currentLanguage]}) }}\" ng-click=\"toggle()\" select-button focus-when=\"!showLanguages\" focused-once-before><span class=\"displayText\">{{languageList[currentLanguage]}}</span><span class=\"changeLanguage\" ng-class=\"{expand:showLanguages}\"></span></a>\n    </div>\n    <div id=\"langDropdownBlock\" ng-show=\"showLanguages\" class=\"bottom\">\n        <div class=\"arrow\"></div>\n        <div ng-click=\"toggle()\">\n            <ul aria-labelledby=\"clickLanguageToggle\" select-box=\"showLanguages && supportedLanguages\" select-cancel=\"toggle()\">\n                <li role=\"presentation\" ng-repeat=\"lang in supportedLanguages\" lang=\"{{ lang }}\">\n                    <a track-link=\"language_change\" class=\"submit\" ng-click=\"selectLanguage(lang)\" link-button select-option=\"lang == currentLanguage\" focus-when=\"showLanguages && lang == currentLanguage\">{{languageList[lang]}}</a>\n                </li>\n            </ul>\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ "./components/xo-page-components/src/cart/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-page-components/src/cart/template.html"), __webpack_require__("./components/xo-page-components/src/cart/lib/pxp.js"), __webpack_require__("./components/xo-page-components/src/cart/lib/cart_pxp.js"), __webpack_require__("./components/xo-page-components/src/cart/lib/ui.js"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-ui-components/src/accessibility/directive.js"), __webpack_require__("./components/xo-page-components/src/cart/cartWrapper/directive.js"), __webpack_require__("./components/xo-page-components/src/cart/itemDetails/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid, template) {
	
	    squid.module('xo-cart.directive', ['squid', 'xomodel.checkout', 'xo-cart.pxp', 'xo-cart.ui', 'xo-cart.cart-wrapper.directive', 'xo-cart.item-details.directive', 'xo-accessibility.directive']).directive('xoCart', function () {
	
	        return {
	            template: template,
	            restrict: 'E',
	            scope: {
	                showCartTotal: '=',
	                renderCartContainer: '=',
	                token: '='
	            },
	            controller: function controller( // eslint-disable-line max-params
	            $scope, $populate, $rootScope, $util, $state, $CheckoutCartModel, $CheckoutAppDataModel, $CheckoutPayeeModel, $pxpCartAmt, $pxpCartDesc) {
	
	                $util.assert($scope.token, 'Expected token');
	
	                $populate($scope, {
	                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
	                    checkoutCart: $CheckoutCartModel.instance($scope.token),
	                    payee: $CheckoutPayeeModel.instance($scope.token)
	                }).then($pxpCartDesc).then(function loadCartData(canShowCart) {
	
	                    var emptyCart = $scope.checkoutCart.get('purchase.items.length', 0) <= 0;
	                    var cartDesc = $scope.checkoutCart.get('purchase.description');
	                    $scope.note = $scope.checkoutCart.get('note');
	
	                    if (!canShowCart) {
	                        cartDesc = '';
	                    } else
	                        // resolve string in descriptions array since the only element may be `null`
	                        // TODO: fix backend to return a string, to avoid this conditional
	                        if (cartDesc && angular.isString(cartDesc[0])) {
	                            cartDesc = cartDesc[0];
	                        } else {
	                            cartDesc = '';
	                        }
	
	                    $scope.desc = cartDesc;
	                    $scope.hasItems = !$scope.renderCartContainer && !emptyCart;
	                    $scope.showArrow = !$scope.checkoutAppData.flags.hide_cart_details && (cartDesc || $scope.hasItems || $scope.note) && !$scope.checkoutCart.isMultiSellerPurchase();
	
	                    // add details to render to the checkoutCart items
	                    $scope.checkoutCart.get('purchase.items', []).forEach(function addDetails(item) {
	                        item.details = {};
	
	                        if (item.quantity > 1) {
	                            item.details.price = item.price.amount;
	                            item.details.quantity = squid.formatQuantity(item.quantity);
	                        }
	
	                        if (item.description) {
	                            if (!item.name) {
	                                item.name = item.description;
	                            } else {
	                                item.details.description = item.description;
	                            }
	                        }
	
	                        // move options to detail section
	                        if (item.item_option_selections) {
	                            item.details.hasSelections = true;
	                            item.details.item_option_selections = item.item_option_selections;
	                        }
	
	                        if (item.sku) {
	                            item.details.sku = item.sku;
	                        }
	
	                        item.hasDetails = Object.keys(item.details).length > 0;
	                        item.details.hasMore = item.hasDetails || item.details.hasSelections;
	                    });
	
	                    // Mapping of field name as recieved by API to corresponding property key
	                    $scope.amountHeaders = {
	                        'total': 'header.total',
	                        'subtotal': 'header.itemTotal',
	                        'tax': 'header.tax',
	                        'shipping': 'header.shipping',
	                        'insurance': 'header.insurance',
	                        'handling_fee': 'header.handling',
	                        'shipping_discount': 'header.shippingDiscount',
	                        'description': 'header.description',
	                        'discount': 'header.discount'
	                    };
	
	                    // Non-AU merchants are subjected to PXP test when user action is not commit and line item details
	                    // are not available and purchase amount is not zero.
	                    var userAction = $scope.userAction = $scope.checkoutAppData.useraction();
	                    var noLineItemDetails = !(userAction && userAction.toLowerCase() === 'commit') && emptyCart;
	
	                    return $pxpCartAmt($scope.checkoutAppData.get('merchant.merchant_country'), $scope.payee.get('merchant.id', ''), noLineItemDetails, $scope.checkoutCart.isPurchase()).then(function (showAmount) {
	                        $scope.showAmt = showAmount;
	                    });
	                }).then(function handleCartOpenClose() {
	                    // the cart is only automatically open under the following criteria:
	                    // 1. the cart has a 'note to buyer' ($scope.note is defined)
	                    // 2. the cart was not previously automatically opened before
	                    // 3. the state has transitioned to checkout.review or checkout.guest
	                    function decideShowCart(currentState) {
	                        if ($scope.note && !$scope.openedAlready && /^checkout\.(review|guest)$/.test(currentState)) {
	                            $scope.openedAlready = true; // may have been undefined before
	                            return true;
	                        }
	
	                        return false;
	                    }
	
	                    $scope.showCartItem = function (breakdown) {
	                        return breakdown.field_name !== 'total' && Number(breakdown.amount) !== 0;
	                    };
	
	                    $scope.showCart = decideShowCart($state.current.name);
	
	                    // TODO: Must we really couple this so tightly with the state transition names?
	                    var openCartListener = $rootScope.$on('$stateChangeSuccess', function (event, toState) {
	                        $scope.showCart = decideShowCart(toState.name);
	                    });
	                    $scope.$on('$destroy', openCartListener); // see http://stackoverflow.com/a/27016855 on why $destroy
	
	                    $scope.toggleCart = function ($event) {
	                        $scope.showCart = !$scope.showCart;
	                        $event.preventDefault();
	                    };
	
	                    $scope.closeCart = function ($event) {
	                        $scope.showCart = false;
	                        // for accessible autofocus on cart toggle link button
	                        $scope.$broadcast('cart-closed');
	                        if ($event) {
	                            $event.preventDefault();
	                        }
	                    };
	
	                    $scope.$on('clickBody', function ($event, target) {
	                        if ($scope.showCart && $(target).parents('.cartContainer').length === 0) {
	                            $scope.closeCart($event);
	                            $scope.$apply();
	                        }
	                    });
	
	                    // this listener / broadcast allows accessibility components to scan and focus inside the cart
	                    // when the cart is displayed
	                    $scope.$watch('showCart', function (showCart) {
	                        if (showCart) {
	                            $scope.$broadcast('cart-updated');
	                        }
	                    });
	                }).then(function handleEllipsisIssues() {
	                    // NOTE: the scattered broadcasts of "cart-updated" events are mostly
	                    // to allow the accessibility directives modal-box and focus-when to
	                    // know when to recalculate keyboard behavior / focus
	                    $scope.toolongTracker = {};
	
	                    // this function is invoked by the onEllipsis directive that tracks
	                    // if the item name won't fit within the restricted space.
	                    $scope.toolong = function (idx) {
	                        $scope.toolongTracker[idx] = true;
	                        $scope.$broadcast('cart-updated');
	                    };
	
	                    $scope.showMore = function (idx, type) {
	                        // there are 2 types of more, "floating" when the name is too long
	                        // and "inline" when the name can fit, but there are additional details.
	                        //
	                        // Show a more if the item
	                        // 1. has an expanded state
	                        // 2. is not already expanded
	                        // 3. if it is appropriate to show that type.
	                        var itemIsTooLong = $scope.toolongTracker[idx];
	                        var isAppropriateType = itemIsTooLong && type === 'floating' || !itemIsTooLong && type === 'inline';
	
	                        return $scope.hasExpandedState(idx) && !$scope.isExpanded(idx) && isAppropriateType;
	                    };
	
	                    $scope.expandedIndex = -1; // initially, none of the line items are expanded
	                    $scope.isExpanded = function isExpanded(idx) {
	                        return idx === $scope.expandedIndex;
	                    };
	                    $scope.hasExpandedState = function hasExpandedState(idx) {
	                        // A line item is exandable if
	                        // 1. the name cannot fit in one line ($scope.toolongTracker) and/or
	                        // 2. there are details (attached to purchase.items in the cart)
	                        // 3. there is item number (sku) in the item
	                        var item = $scope.checkoutCart.get('purchase.items', [])[idx] || {};
	                        var nameTooLong = $scope.toolongTracker[idx];
	                        return nameTooLong || item.hasDetails || item.sku;
	                    };
	                    $scope.expand = function expand(idx) {
	                        $scope.expandedIndex = idx;
	                        $scope.$broadcast('cart-updated');
	                    };
	                    $scope.collapse = function collapse() {
	                        $scope.expandedIndex = -1;
	                        $scope.$broadcast('cart-updated');
	                    };
	
	                    $scope.$emit('dataLoaded');
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "./components/xo-page-components/src/cart/lib/ui.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	var _jquery = __webpack_require__("./components/jquery/dist/jquery.min.js");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _decode_entities = __webpack_require__("./components/xo-page-components/src/cart/lib/decode_entities.js");
	
	var _decode_entities2 = _interopRequireDefault(_decode_entities);
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// Register entity decoding filter in Angular
	_angular.$filterProvider.register('decodeEntities', _decode_entities2['default']);
	
	// if an element has an ellipsis text-overflow in effect (it must already have
	// the appropriate css styling) then invoke the function that is passed to the directive
	function getVisibleWidth(elem) {
	    var elemRect = elem.getBoundingClientRect();
	    // cross browser, returns decimals for ultra-precision
	    return elemRect.right - elemRect.left;
	}
	
	function getNaturalWidth(elem) {
	    var old = {
	        overflow: elem.style.overflow,
	        width: elem.style.width,
	        display: elem.style.display
	    };
	    var result;
	
	    elem.style.overflow = 'visible';
	    elem.style.width = 'auto';
	    elem.style.display = 'inline-block';
	    result = getVisibleWidth(elem);
	    elem.style.overflow = old.overflow;
	    elem.style.width = old.width;
	    elem.style.display = old.display;
	
	    return result;
	}
	
	// pre-determine approach to reading styles
	var getStyle = _angular.$window.getComputedStyle ?
	// modern browsers
	function (elem, style) {
	    return _angular.$window.getComputedStyle(elem)[style];
	} :
	// IE
	function (elem, style) {
	    return elem.currentStyle[style];
	};
	
	function hasEllipsis(elem) {
	    var overflowHidden = getStyle(elem, 'overflow') === 'hidden';
	    var textOverflowEllipsis = getStyle(elem, 'text-overflow') === 'ellipsis';
	    var whiteSpaceNowrap = getStyle(elem, 'white-space') === 'nowrap';
	
	    if (overflowHidden && textOverflowEllipsis && whiteSpaceNowrap) {
	        return getVisibleWidth(elem) < getNaturalWidth(elem);
	    }
	
	    return false;
	}
	
	(0, _angular.$registerDirective)('onEllipsis', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            function invokeSubscriber() {
	                (0, _angular.$parse)(attrs.onEllipsis)(scope);
	                scope.$apply();
	            }
	
	            (0, _angular.$timeout)(function () {
	                if (hasEllipsis(element[0])) {
	                    invokeSubscriber();
	                }
	            });
	        }
	
	    };
	});
	
	// Makes an element examine the outerHeight of its siblings
	// and the max-height of its parent, then sets a max-height for itself
	// so that everything fits within the limits of the parent. Note that it assumes
	// no other sibling also has dynamic-maxheight.
	(0, _angular.$registerDirective)('dynamicMaxheight', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            function resizeContainer() {
	                var $element = (0, _jquery2['default'])(element);
	                var parentHeight = parseFloat(getStyle($element.parent()[0], 'max-height'));
	                var siblings = $element.siblings().filter(function () {
	                    var pos = getStyle((0, _jquery2['default'])(this)[0], 'position');
	                    return pos !== 'fixed' && pos !== 'absolute';
	                }).map(function getOuterHeights() {
	                    return (0, _jquery2['default'])(this).outerHeight();
	                });
	                var siblingsHeight = 0;
	                var i;
	
	                for (i = 0; i < siblings.length; i += 1) {
	                    siblingsHeight += siblings[i];
	                }
	
	                var spaceAvailable = parentHeight - siblingsHeight;
	
	                if (!isNaN(spaceAvailable)) {
	                    $element.css('max-height', spaceAvailable + 'px');
	                }
	            }
	
	            // if an expression is provided, it is used as an event to listen for and recalculate the height
	            if (attrs.dynamicMaxheight) {
	                scope.$on((0, _angular.$parse)(attrs.dynamicMaxheight)(scope), resizeContainer);
	            }
	
	            (0, _angular.$timeout)(resizeContainer);
	        }
	    };
	});
	
	_angular.$registerDirective;
	
	_angular.$filterProvider;
	
	_angular.$parse;
	
	_angular.$timeout;
	
	_angular.$window;

/***/ }),

/***/ "./components/xo-page-components/src/cart/lib/decode_entities.js":
/***/ (function(module, exports) {

	
	
	/**
	 * Takes a string with HTML entities within and renders it as the unicode
	 * characters they represent. This is done by leveraging the browser to
	 * perform this transformation internally. InnerText is chosen as the output
	 * so as to kill any HTML itself that was supplied.
	 *
	 * @param {Element} element any HTML element supporting innerText and
	 * innerHTML. Preferably one not connected to the DOM or visible in any way.
	 * @param {String} input a String containing HTML entities that need to be
	 * decoded and HTML stripped.
	 * @return {String} the same string with HTML tags removed and entities
	 * decoded.
	 */
	
	exports.__esModule = true;
	exports.decodeEntities = decodeEntities;
	exports['default'] = decodeEntitiesAngularFilter;
	function decodeEntities(element, input) {
	    // Escape opening tags on vulnerable tags
	    input = input.replace(/<(\/?)(html|script|body|meta|style|img|iframe|svg|link)/ig, '&lt;$1$2');
	    element.innerHTML = input;
	    return element.textContent || element.innerText;
	}
	
	function decodeEntitiesAngularFilter() {
	    // A constant key that can be used to find the element
	    var ENTITY_ELEM = '__xpc_entitydecoder__';
	
	    // Create the element if this is the first time this is called
	    if (!window[ENTITY_ELEM]) {
	        window[ENTITY_ELEM] = document.createElement('p');
	    }
	
	    // Retrieve the converter element rather than create one every
	    // time. Angular may call this filter many times repeatedly and
	    // we should make a small effort to optimize the process
	    var converter = window[ENTITY_ELEM];
	
	    /**
	     * Takes a string with HTML entities within and renders it as the unicode
	     * characters they represent. This is done by leveraging the browser to
	     * perform this transformation internally. InnerText is chosen as the output
	     * so as to kill any HTML itself that was supplied.
	     *
	     * @param {String} input a String containing HTML entities that need to be
	     * decoded and HTML stripped.
	     * @return {String} the same string with HTML tags removed and entities
	     * decoded.
	     */
	    return decodeEntities.bind(null, converter);
	}

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-page-components/src/cart/template.html":
/***/ (function(module, exports) {

	module.exports = "<div class=\"cartContainer\" content ng-if=\"showAmt || showArrow\">\n    <div class=\"transactionDetailsContainer\" ng-class=\"{cart:showCart, hasAmount:showAmt}\">\n\n        <a href=\"#transactionCartDetails\"\n           class=\"transactionDetails scTrack:hermes-cartExpanded\"\n           aria-controls=\"transctionCartDetails\" aria-label=\"{{ content('base.shoppingCart') }}\" aria-haspopup=\"true\"\n           role=\"button\" ng-click=\"toggleCart($event)\"\n           focus-when focus-refresh-on=\"'cart-closed'\" ng-if=\"showArrow\">\n            <cart-wrapper ng-if=\"showArrow\" show-amt=\"showAmt\" show-arrow=\"showArrow\" token=\"token\"></cart-wrapper>\n        </a>\n\n        <cart-wrapper ng-if=\"!showArrow\" show-amt=\"showAmt\" show-arrow=\"showArrow\"\n                      token=\"token\"></cart-wrapper>\n\n        <div class=\"transctionCartDetails\" modal-box modal-refresh-on=\"'cart-updated'\" modal-cancel=\"closeCart()\" aria-hidden=\"{{ !showArrow }}\" ng-if=\"showArrow\">\n            <div class=\"details\" role=\"document\" focus-when focus-refresh-on=\"'cart-updated'\" focus-element=\"expandedIndex === -1 ? 'a.more': 'a.less'\">\n\n                <a id=\"closeCart\" link-button=\"content('header.close')\" class=\"actions focusableIcon\" ng-click=\"closeCart($event)\" ></a>\n\n                <div>\n                    <h3 ng-if=\"checkoutAppData.merchant\" class=\"merchantName\" ng-class=\"{merchantTitle: showAmt && (note || desc)}\" id=\"merchantName\">\n                        <span ng-if=\"note\">{{ content('header.noteFromMerchant', {merchant: checkoutAppData.merchant.brand_name}) }}</span>\n                        <span ng-if=\"!note\">{{ checkoutAppData.merchant.brand_name }}</span>\n                    </h3>\n                    <p ng-if=\"note || desc\"class=\"note\" ng-class=\"{ noteHighlighted: desc || !showAmt }\">\n                        <span ng-if=\"note\">{{ note | decodeEntities }}</span>\n                        <span ng-if=\"!note\">{{ desc | decodeEntities }}</span>\n                    </p>\n                </div>\n\n                <div dynamic-maxheight=\"'cart-updated'\" class=\"scrollable-middle\">\n                    <ul class=\"detail-items\" ng-if=\"hasItems\">\n                        <li ng-repeat=\"item in checkoutCart.purchase.items\" class=\"items\">\n\n                            <div class=\"itemNameContainer\" ng-class=\"{expanded: isExpanded($index)}\">\n                                <a class=\"more\" link-button=\"content('header.srMore')\" ng-show=\"showMore($index, 'floating')\" ng-click=\"expand($index)\">{{ content('header.more') }}</a>\n                                <span on-ellipsis=\"toolong($index)\" title=\"{{ item.name }}\" class=\"itemName\">{{ item.name }} <a class=\"less\" link-button=\"content('header.srLess')\" ng-show=\"isExpanded($index) && !item.hasDetails\" ng-click=\"collapse()\">{{ content('header.less') }}</a><a class=\"more inline-more\" link-button=\"content('header.srMore')\" ng-show=\"showMore($index, 'inline')\" ng-click=\"expand($index)\">{{ content('header.more') }}</a></span>\n                            </div>\n                            <span class=\"itemPrice\">\n                                <format-currency code=\"item.amount.currency_code\" amount=\"item.amount.amount\"></format-currency>\n                            </span>\n                            <item-details ng-show=\"isExpanded($index) && item.hasDetails\" currency-code=\"item.amount.currency_code\" details=\"item.details\" on-click-less=\"collapse()\">\n                        </li>\n                    </ul>\n\n                    <ul class=\"detail-extras\" ng-if=\"showAmt && hasItems\">\n                        <li class=\"detail-breakdown\" ng-if=\"checkoutCart.purchase.amounts\">\n                            <li ng-repeat=\"breakdown in checkoutCart.purchase.amounts\" class=\"amounts\" ng-if=\"showCartItem(breakdown)\">\n                                <span class=\"itemNameContainer\">{{ content(amountHeaders[breakdown.field_name]) }}</span>\n                                <span class=\"itemPrice\">\n                                    <format-currency code=\"breakdown.currency_code\" amount=\"breakdown.amount\"></format-currency>\n                                </span>\n                            </li>\n                        </li>\n                    </ul>\n                </div>\n\n                <div class=\"subTotal\" ng-if=\"showAmt && checkoutCart.purchase.amounts.total\">\n                    <span class=\"itemNameContainer\">{{ userAction === 'commit' || showCartTotal === true ? content('header.total') : content('header.subTotal') }}</span>\n                    <span class=\"itemPrice\">\n                        <format-currency code=\"checkoutCart.purchase.amounts.total.currency_code\"\n                                         amount=\"checkoutCart.purchase.amounts.total.amount\"></format-currency>\n                    </span>\n                </div>\n\n            </div>\n            <div class=\"pointer\"> </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "./components/xo-page-components/src/cart/lib/pxp.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-cart.pxp', ['squid.pxp']).factory('$pxpCartAmt', function ($pxp, $q) {
	        return function (merchantCountry, merchantId, noLineItemDetails, isPurchase) {
	
	            if (merchantCountry !== 'AU' && noLineItemDetails && isPurchase) {
	
	                var pageName = 'xo_hermes_no_line_item_details';
	                var showAmtBlacklistTreatment = 'xo_hermes_no_line_items_show_amount_blacklist_test_group';
	                var showAmtTreatment = 'xo_hermes_no_line_items_show_amount_test_group';
	
	                return $q.all([$pxp(pageName, {
	                    'ctx.merchantID': merchantId,
	                    uid: merchantId
	                }, showAmtBlacklistTreatment), $pxp(pageName, {
	                    'ctx.merchantID': merchantId,
	                    uid: merchantId
	                }, showAmtTreatment)]).then(function (results) {
	                    var showAmtBlacklist = results[0];
	                    var showAmt = results[1];
	
	                    if (showAmtBlacklist && showAmtBlacklist.treatment_name === showAmtBlacklistTreatment) {
	                        return true;
	                    }
	
	                    if (showAmt && showAmt.treatment_name === showAmtTreatment) {
	                        return true;
	                    }
	
	                    return false; // default to hide
	                });
	            }
	
	            return $q.when(!noLineItemDetails && isPurchase);
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-page-components/src/cart/lib", "components/xo-page-components/src/cart/lib/pxp.js"))

/***/ }),

/***/ "./components/xo-page-components/src/cart/lib/cart_pxp.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$pxpCartDesc = $pxpCartDesc;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	function $pxpCartDesc() {
	    // ask if the show desc treatment is present
	    return (0, _squid.$pxp)('xo_hermesnodeweb_all_cart_DESC_v1', 'xo_hermesnodeweb_all_cart_DESC_Treatment').then(function (result) {
	        return !!result;
	    });
	}
	
	angular.value("$pxpCartDesc", $pxpCartDesc);
	_squid.$pxp;

/***/ }),

/***/ "./components/xo-page-components/src/cart/cartWrapper/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-page-components/src/cart/cartWrapper/template.html"), __webpack_require__("./components/xo-models/src/checkout/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	    squid.module('xo-cart.cart-wrapper.directive', ['squid', 'xomodel.checkout']).directive('cartWrapper', function () {
	        return {
	            template: template,
	            restrict: 'E',
	            scope: {
	                showAmt: '=',
	                showArrow: '=',
	                token: '='
	            },
	            controller: function controller($scope, $populate, $util, $CheckoutCartModel) {
	
	                $util.assert($scope.token, 'Expected token');
	
	                $populate($scope, {
	                    checkoutCart: $CheckoutCartModel.instance($scope.token)
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-page-components/src/cart/cartWrapper/template.html":
/***/ (function(module, exports) {

	module.exports = "<span class=\"totalWrapper clearfix\" id=\"totalWrapper\" content>\n    <span id=\"transactionCart\" ng-class=\"{hasItems:showArrow}\">\n        <span class=\"cartIcon\" aria-label=\"{{ content('base.shoppingCart') }}\"></span>\n        <span ng-if=\"showAmt\">\n            <format-currency class=\"formatCurrency\" code=\"checkoutCart.purchase.amounts.total.currency_code\"\n                             amount=\"checkoutCart.purchase.amounts.total.amount\"></format-currency>\n        </span>\n        <span ng-if=\"showArrow && checkoutCart.purchase.items\" class=\"arrow\" aria-label=\"{{ content('common.show') }}\"/>\n    </span>\n</span>"

/***/ }),

/***/ "./components/xo-page-components/src/cart/itemDetails/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-page-components/src/cart/itemDetails/template.html"), __webpack_require__("./components/xo-ui-components/src/accessibility/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	    squid.module('xo-cart.item-details.directive', ['squid', 'xo-accessibility.directive']).directive('itemDetails', function () {
	        return {
	            template: template,
	            restrict: 'E',
	            scope: {
	                details: '=',
	                sku: '=',
	                currencyCode: '=',
	                onClickLess: '&'
	            },
	            controller: function controller() {/* dumb component */}
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-page-components/src/cart/itemDetails/template.html":
/***/ (function(module, exports) {

	module.exports = "<!-- this directive requires\n  * visible boolean\n  * details object (with .price, .quantity, .description,\n  * possible .item_option_selections)\n  * currency-code string\n  * possible sku (item number)\n  * on-click-less - function invocation expression\n-->\n<ul content class=\"itemDetails\">\n  <li ng-if=\"details.sku\">\n      <span>\n          <strong>{{ content('header.itemNumber') }}</strong> <span class=\"item-number\">{{ details.sku }}</span>\n      </span>\n  </li>\n  <li ng-if=\"details.price\">{{ content('header.price') }}\n    <format-currency code=\"currencyCode\" amount=\"details.price\"></format-currency>\n  </li>\n  <li ng-if=\"details.quantity\">{{ content('header.quantity') }} <span class=\"item-quantity\">{{ details.quantity }}</span></li>\n  <li ng-if=\"details.hasMore\">\n    <div ng-if=\"details.hasSelections\" class=\"item-selections\">\n      <span class=\"item-selection\" ng-repeat=\"selection in details.item_option_selections\">\n        <strong class=\"item-selection-name\">{{ selection.name }}:</strong>\n        <span class=\"item-selection-value\">{{ selection.select }}</span>\n      </span>\n    </div>\n\n    <div ng-if=\"details.description\">\n      <strong class=\"item-selection-name\">{{ content('header.description') }}</strong> <span class=\"item-description\">{{ details.description }}</span>\n    </div>\n    <a class=\"less\" link-button=\"content('header.srLess')\" ng-click=\"onClickLess()\">{{ content('header.less') }}</a>\n  </li>\n</ul>\n"

/***/ }),

/***/ "./components/xo-page-components/src/header/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	__webpack_require__("./components/xo-page-components/src/header/styles.less");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _index = __webpack_require__("./components/xo-device-info/dist/index.js");
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-page-components/src/header/template.html"), __webpack_require__("./components/xo-page-components/src/cart/directive.js"), __webpack_require__("./components/xo-ui-components/src/escape-hatch/closeFrame/directive.js"), __webpack_require__("./components/xo-form-components/src/language-options/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-header.directive', ['squid', 'xo-cart.directive', 'xo-escape-hatch.closeFrame.directive', 'xo-language-options.directive']).directive('xoHeader', function () {
	        return {
	            template: template,
	            scope: {
	                showCartTotal: '=',
	                renderCartContainer: '=',
	                token: '=',
	                isUnbranded: '=',
	                unbrandedTitle: '=',
	                unbrandedSubTitle: '=',
	                languageSwitch: '=?',
	                redirectiframe: '=',
	                redirectLightbox: '=',
	                isVenmoFlow: '='
	            },
	            controller: function controller($scope, $rootScope, $renderContent, $SetHeaderText) {
	                $scope.isMessengerBAIntegration = _squid.$integration.getConfig('IS_MESSENGER_BA_INTEGRATION');
	                $scope.isMobile = _index.$DeviceInfo.isMobile() || _index.$DeviceInfo.isTablet();
	                // $util.assert($scope.token, 'Expected token');
	                $scope.title = $renderContent($scope.unbrandedTitle);
	                $scope.subTitle = $renderContent($scope.unbrandedSubTitle);
	
	                $SetHeaderText.subscribe($scope, function (event, text) {
	                    $scope.unbrandedTitle = text;
	                    $scope.title = $renderContent($scope.unbrandedTitle);
	                });
	            }
	        };
	    }).factory('$SetHeaderText', function ($rootScope) {
	        var headerText = '';
	
	        return {
	            setText: function setText(text) {
	                headerText = text;
	                $rootScope.$emit('update_header_text', text);
	            },
	            getText: function getText() {
	                return headerText;
	            },
	            subscribe: function subscribe($scope, callback) {
	                var handler = $rootScope.$on('update_header_text', callback);
	                $scope.$on('$destroy', handler);
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	_squid.$integration;
	
	_index.$DeviceInfo;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-page-components/src/header", "components/xo-page-components/src/header/directive.js"))

/***/ }),

/***/ "./components/xo-page-components/src/header/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-page-components/src/header/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-page-components/src/header/styles.less":
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, ".paypalHeader .languageToggleDisplay{position:relative;bottom:0;clear:left;right:0;top:20px;margin-bottom:20px}.paypalHeader #langDropdownBlock{right:auto}.paypalHeader .messengerLogo{margin-left:25%;padding-top:20px}.paypalHeader .venmoLogo{position:relative;width:100px;float:left;height:20px;margin-top:0;background-image:url(https://www.paypalobjects.com/images/checkout/venmo/venmo-logo-blue.png);background-repeat:no-repeat;background-size:100px 20px}#mobileMerchantHeader{display:none}@media (max-width:41.3125em){.paypalHeaderWrapper.langDropdown{margin-bottom:30px}.paypalHeader .venmoLogo{position:relative;width:100px;float:left;height:20px;margin-top:30px;background-image:url(https://www.paypalobjects.com/images/checkout/venmo/venmo-logo-blue.png);background-repeat:no-repeat;background-size:100px 20px}}", ""]);
	
	// exports


/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-page-components/src/header/template.html":
/***/ (function(module, exports) {

	module.exports = "<div class=\"row-fluid paypalHeaderWrapper\" ng-class=\"{ 'langDropdown': languageSwitch && languageSwitch.show }\" content>\n    <div class=\"span14 clearfix paypalHeader\">\n        <div id=\"mobileMerchantHeader\">\n            <xo-merchant-header token=\"token\"></xo-merchant-header>\n        </div>\n        <span class=\"pageTitle\" ng-if=\"unbrandedTitle\">{{title}}</span>\n        <div ng-if=\"!isMessengerBAIntegration && !isUnbranded && !isVenmoFlow\" id=\"paypalLogo\" class=\"logo\"><span class=\"accessAid\">{{ content('base.payPal') }}</span></div>\n        <div ng-if=\"!isMessengerBAIntegration && !isUnbranded && isVenmoFlow\" class=\"venmoLogo\"><span class=\"accessAid\">Venmo Checkout</span></div>\n        <div ng-if=\"isMessengerBAIntegration\">\n            <div ng-if=\"isMobile\">\n                <img src=\"https://www.paypalobjects.com/images/checkout/hermes/PP_Messenger_mobile_logo_lockup_2x.png\" class=\"messengerLogo\" width=\"50%\" height=\"50%\" alt=\"PayPal and Messenger\">\n            </div>\n            <div ng-if=\"!isMobile\">\n                <img src=\"https://www.paypalobjects.com/images/checkout/hermes/PP_Messenger_logo_lockup_2x.png\" class=\"messengerLogo\" width=\"50%\" height=\"50%\" alt=\"PayPal and Messenger\">\n            </div>\n        </div>\n        <xo-cart token=\"token\" show-cart-total=\"showCartTotal\" render-cart-container=\"renderCartContainer\"></xo-cart>\n\n        <xo-language-options ng-if=\"languageSwitch && languageSwitch.show\"></xo-language-options>\n\n        <div class=\"subTitle\" ng-if=\"unbrandedSubTitle\">{{subTitle}}</div>\n        <xo-close-frame redirectiframe=\"redirectiframe\" redirect-lightbox=\"redirectLightbox\"></xo-close-frame>\n    </div>\n</div>"

/***/ }),

/***/ "./components/xo-ui-components/src/escape-hatch/closeFrame/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-ui-components/src/escape-hatch/closeFrame/template.html"), __webpack_require__("./components/xo-models/src/user/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	
	    squid.module('xo-escape-hatch.closeFrame.directive', ['squid', 'xomodel.user']).directive('xoCloseFrame', function () {
	        return {
	            template: template,
	
	            restrict: 'E',
	
	            scope: {
	                redirectiframe: '=',
	                redirectLightbox: '='
	            },
	
	            controller: function controller($scope, $rootScope, $populate, $CheckoutInputDataModel, $window, $CheckoutAppDataModel, $util, $injector, $logger, $ReturnToMerchant) {
	
	                $populate($scope, {
	                    checkoutAppData: $CheckoutAppDataModel.instance($rootScope.token)
	                }).then(function () {
	                    var cancel_url = $scope.checkoutAppData.urls.cancel_url;
	
	                    $scope.checkoutInputData = $CheckoutInputDataModel.instance($scope.token);
	                    $scope.isIFrame = $util.isIFrame();
	
	                    $scope.closeFrame = function (event) {
	                        event.preventDefault();
	                        event.stopPropagation();
	
	                        if (window.xchild) {
	                            if (window.xprops.onCancel) {
	                                return window.xprops.onCancel({
	                                    token: $scope.token,
	                                    cancelUrl: cancel_url
	                                });
	                            } else {
	                                return window.xchild.close();
	                            }
	                        }
	
	                        if ($scope.redirectLightbox) {
	                            var result = $ReturnToMerchant.postToMerchant({
	                                operation: 'return_to_merchant',
	                                returnUrl: cancel_url,
	                                updateParent: true
	                            });
	
	                            // Otherwise we have no choice but to return to the merchant
	                            if (!result) {
	                                $util.redirect(cancel_url);
	                            }
	
	                            // TODO - Move out helios specific logic. Apps should provide a callback instead.
	                        } else if ($scope.redirectiframe) {
	                            $window.location.replace(cancel_url);
	
	                            // TODO - Move out helios specific logic. Apps should provide a callback instead.
	                        } else {
	
	                            var iFrameFlow = $injector.get('$IFrameFlow');
	
	                            $logger.info('HELIOS_FLOW_FALLBACK'); // overall fallbacks
	                            $logger.info('HELIOS_FALLBACK_TO_MERCHANT');
	                            $logger.info('HELIOS_FALLBACK_MERCHANT_USER_CANCELLED');
	
	                            var url = $scope.checkoutInputData.errorUrl('user_cancelled');
	
	                            if ($scope.auth && $scope.auth.code) {
	                                url += '&code=' + $scope.auth.code;
	                            }
	
	                            iFrameFlow.findWindowAndRedirect($scope.checkoutInputData, url);
	                        }
	                        $scope.$emit('exitFrame');
	                    };
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-ui-components/src/escape-hatch/closeFrame/template.html":
/***/ (function(module, exports) {

	module.exports = "<a ng-show=\"isIFrame\" href=\"{{redirectURL}}\" id=\"closeButton\" target=\"_parent\" role=\"button\" ng-click=\"closeFrame($event)\">{{ content('base.closePayPalCheckoutLabel') }}</a>\n"

/***/ }),

/***/ "./pages/xo-guest-upgrade/route.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	__webpack_require__("./components/jquery/dist/jquery.min.js");
	
	__webpack_require__("./components/angular-shims-placeholder/dist/angular-shims-placeholder.min.js");
	
	__webpack_require__("./js/lib/index.js");
	
	__webpack_require__("./components/xo-tracking/dist/index.js");
	
	var _middleware = __webpack_require__("./js/lib/middleware.js");
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./pages/xo-generic-error/route.js"), __webpack_require__("./components/xo-guest-components/src/guest-upgrade/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('hermes.page.xo-guest-upgrade.route', ['squid', 'hermes.page.xo-generic-error.route', 'xo-guest-upgrade.directive']).factory('$GuestUpgradeRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('GuestUpgradeRoute', {
	
	            defaultState: 'guestupgrade',
	            middleware: _middleware.$Middleware,
	
	            name: 'guestupgrade',
	            directive: 'xo-guest-upgrade',
	            titleContent: 'accountCreationGuest.heading',
	            trackingData: {
	                templateName: 'xoguestupgrade.dust',
	                pageGoal: 'guest upgrade',
	                pageQualifier: 'guestupgrade',
	                buzname: {
	                    'guestupgrade': {
	                        'pagename': '%::guestupgrade',
	                        'pagename2': '%::guestupgrade:prox-guest-upgrade',
	                        'version': 'version-1:%:'
	                    }
	                }
	            },
	            children: [{
	                name: '$GenericErrorRoute'
	            }]
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	_middleware.$Middleware;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-guest-upgrade", "pages/xo-guest-upgrade/route.js"))

/***/ }),

/***/ "./components/xo-guest-components/src/guest-upgrade/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/module.js"), __webpack_require__("./components/xo-guest-components/src/guest-upgrade/lib/mapper.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-guest-components/src/guest-upgrade/template.html"), __webpack_require__("./components/xo-guest-components/src/guest-upgrade/occupation/directive.js"), __webpack_require__("./components/xo-guest-components/src/guest/nationality/directive.js"), __webpack_require__("./components/xo-models/src/fi/index.js"), __webpack_require__("./components/xo-models/src/onboard/index.js"), __webpack_require__("./components/xo-tracking/dist/index.js"), __webpack_require__("./components/xo-form-components/src/phone/directive.js"), __webpack_require__("./components/xo-page-components/src/footer/directive.js"), __webpack_require__("./components/xo-ui-components/src/tooltip/directive.js"), __webpack_require__("./components/xo-ui-components/src/message/directive.js"), __webpack_require__("./components/xo-ui-components/src/spinner/directive.js"), __webpack_require__("./components/xo-form-components/src/dob-input/directive.js"), __webpack_require__("./components/xo-address-components/src/add-address/directive.js"), __webpack_require__("./components/xo-page-components/src/value-props/directive.js"), __webpack_require__("./components/xo-return-to-merchant/dist/util.js"), __webpack_require__("./components/xo-guest-components/src/guest/emailInput/directive.js"), __webpack_require__("./components/xo-guest-components/src/guest/passwordInput/directive.js"), __webpack_require__("./components/xo-address-components/src/address-normalization/directive.js"), __webpack_require__("./components/xo-form-components/src/national-id-input/directive.js"), __webpack_require__("./components/xo-form-components/src/place-of-birth/directive.js"), __webpack_require__("./components/xo-form-components/src/gender-type/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular, module, mapper, template) {
	
	    return angular.module('xo-guest-upgrade.directive', ['squid', 'xomodel.fi', 'tracking.fpti', 'xomodel.onboard', 'xo-phone.phoneInput', 'xo-footer.directive', 'xo-guest.emailInput', 'xo-tooltip.directive', 'xo-spinner.directive', 'xo-message.directive', 'xo-return-to-merchant', 'xo-guest.passwordInput', 'xo-dob-input.directive', 'xo-value-props.directive', 'xo-add-address.directive', 'xo-guest-upgrade.occupation', 'xo-guest.nationality', 'xo-address-normalization.directive', 'xo-national-id-input.directive', 'xo-gender-type.directive', 'xo-place-of-birth.directive']).directive('xoGuestUpgrade', function ($rootScope, $ReturnToMerchant, $OnboardUserModel, $OnboardPhoneModel, $GuestUpgradeModel, $BillingAddressModel) {
	
	        return {
	
	            template: template,
	
	            scope: {
	                token: '='
	            },
	
	            controller: function controller($q, $fpti, $scope, $util, $state, $config, $logger, $window, $pxpMatch, $locale, $interval, $rootScope, // eslint-disable-line no-shadow
	            $renderContent, $NationalIdModel) {
	                var _this = this;
	
	                var modelSchema = void 0;
	                var fpti = {
	                    trackSuccess: function trackSuccess() {
	                        this.track(':success');
	                    },
	                    trackError: function trackError(err) {
	                        this.track(':error', err);
	                    },
	                    track: function track(suffix, err) {
	                        var error = void 0;
	                        if (err) {
	                            error = {
	                                type: 'pageError',
	                                msg: err.message
	                            };
	                        }
	                        $state.current.trackingData.buzname.guestupgrade.pagename2 = $state.current.trackingData.buzname.guestupgrade.pagename2 + suffix;
	                        $fpti.setupDataString($state.current, error);
	                    }
	                };
	                var options = {
	                    params: {
	                        data: $util.param('data')
	                    }
	                };
	
	                $scope.upgradeFromEmail = $util.param('data').length === 15 || $util.param('data').length === 16 ? true : false;
	                $scope.flags = { singlePassword: false };
	                $scope.locale = $locale;
	                $scope.merchant = $locale.content.get('signup.ebay');
	                $scope.returnToMerchantTimerMsg = '';
	                $scope.valueTitle = $renderContent('guestVerify.propHead');
	                $scope.valueText = $renderContent('guestVerify.propVal');
	                $scope.pageTitle = $scope.upgradeFromEmail ? $scope.locale.content.guestUpgrade.emailFlowTitle : $scope.locale.content.signup.title;
	                $scope.footerStyle = 'fullFooter';
	
	                // Do not show cancel URL if experience is set to minibrowser
	                if (!$rootScope.miniBrowser) {
	                    $scope.cancelUrl = $util.param('cancel_url');
	                }
	
	                // Change the message of the overlay on the site that lauched this flow.
	                $ReturnToMerchant.postToMerchant({
	                    secureWindowmsg: $locale.content.get('signup.overlayMsg')
	                });
	
	                function showSuccessPage() {
	                    // This changes the footer wapper ID and appropriate css classes gets applied
	                    $scope.footerStyle = 'confirmationFooter';
	
	                    if (!$scope.upgradeFromEmail) {
	                        var timerExecutor = function timerExecutor() {
	                            // eslint-disable-line no-inner-declarations
	                            // We wait for 5 secs on live and 10 secs on stage/local(helpful for automation)
	                            var waitTime = $config.deploy.isLive() ? 20 : 10;
	
	                            function updateMsg() {
	                                $scope.returnToMerchantTimerMsg = $renderContent('signup.returnTimerMsg', {
	                                    waitTime: waitTime
	                                });
	                            }
	
	                            $scope.stopTimerAndRedirect = function () {
	                                if (angular.isDefined(timer)) {
	                                    $interval.cancel(timer);
	                                    timer = undefined;
	                                }
	                                $ReturnToMerchant.goTo($scope.successUrl);
	                            };
	
	                            updateMsg();
	                            // When $scope.onboard becomes null, the success page is shown.
	                            $scope.onboard = null;
	
	                            return function () {
	                                waitTime -= 1;
	                                updateMsg();
	                                if (waitTime === 0) {
	                                    return $scope.stopTimerAndRedirect();
	                                }
	                            };
	                        };
	
	                        var timer = void 0;
	
	                        $scope.successUrl = $util.buildURL($util.param('return_url'), {
	                            status: 'success'
	                        });
	
	                        fpti.trackSuccess();
	                        $ReturnToMerchant.postToMerchant($scope.successUrl);
	
	                        timer = $interval(timerExecutor(), 1000);
	                    } else {
	                        // When $scope.onboard becomes null, the success page is shown.
	                        $scope.onboard = null;
	                    }
	                }
	
	                function handleUIValidation(errorData, displayGenericMessage) {
	                    var element = mapper.errorMapper(errorData);
	                    if (element) {
	                        var $fields = $(element);
	                        $fields.addClass('backendError');
	                    }
	                    if (displayGenericMessage) {
	                        $scope.pageErrorMsg = { msgs: [$scope.locale.content.genericError.incontextGenericPageError], type: 'error' };
	                    }
	                }
	
	                function upgrade() {
	                    var data = $scope.upgradeFromEmail ? $scope.onboard.serializeEmailFlow() : $scope.onboard.serialize();
	
	                    $scope.onboard.save({
	                        data: data,
	                        success: showSuccessPage,
	                        contingencies: {
	                            DOB_INVALID: function DOB_INVALID(err, message) {
	                                handleUIValidation(err);
	                                $scope.pageErrorMsg = { msgs: [$scope.locale.content.validation.validDOB], type: 'error' };
	                            },
	                            PHONE_INVALID: function PHONE_INVALID(err, message) {
	                                handleUIValidation(err);
	                                $scope.pageErrorMsg = { msgs: [$scope.locale.content.validation.validPhone], type: 'error' };
	                            },
	                            NATID_INVALID: function NATID_INVALID(err, message) {
	                                handleUIValidation(err);
	                                $scope.pageErrorMsg = { msgs: [$scope.locale.content.validation.validNationalId], type: 'error' };
	                            },
	                            ADDRESS_LINEONE_INVALID: function ADDRESS_LINEONE_INVALID(err, message) {
	                                handleUIValidation(err, true);
	                            },
	                            ADDRESS_CITY_INVALID: function ADDRESS_CITY_INVALID(err, message) {
	                                handleUIValidation(err, true);
	                            },
	                            ADDRESS_STATE_INVALID: function ADDRESS_STATE_INVALID(err, message) {
	                                handleUIValidation(err, true);
	                            },
	                            ADDRESS_POSTAL_CODE_INVALID: function ADDRESS_POSTAL_CODE_INVALID(err, message) {
	                                handleUIValidation(err, true);
	                            },
	                            PASSWORD_INVALID: function PASSWORD_INVALID(err, message) {
	                                handleUIValidation(err, true);
	                            },
	                            FI_INVALID: function FI_INVALID(err, message) {
	                                handleUIValidation(err);
	                            },
	                            DEFAULT: function handleContingency(name, contingency) {
	                                $logger.info('guest_upgrade_contingency', {
	                                    'int_error_description': contingency && contingency.message,
	                                    'contingency_name': name
	                                });
	                            }
	                        }
	                    })['catch'](function (err) {
	                        fpti.trackError(err);
	
	                        $logger.error('guest_upgrade_error', { error: err });
	
	                        if ($util.param('return_url')) {
	                            var url = $util.buildURL($util.param('return_url'), {
	                                status: 'fail'
	                            });
	
	                            $scope.cancelUrl = url;
	
	                            $ReturnToMerchant.postToMerchant({
	                                cancelUrl: url
	                            });
	                        }
	                    });
	                }
	
	                function getContentIdentifier() {
	                    return [$locale.country, $locale.lang, (0, _squid.$contentVersion)(), 'signupTerms.easySignupTCPA'].join(':');
	                }
	
	                function setTCPAFlags() {
	                    $scope.flags.tcpa_content = false;
	
	                    if ($scope.locale.country === 'US') {
	                        $scope.flags.tcpa_content = true;
	                    }
	
	                    $logger.info('guest_upgrade_tcpa', {
	                        tcpa: $scope.flags.tcpa_content,
	                        content_identifier: $scope.onboard.contentIdentifier,
	                        experience_identifier: $scope.onboard.experienceIdentifier
	                    });
	                }
	
	                modelSchema = {
	                    user: new $OnboardUserModel({
	                        country: $locale.country,
	                        nationality: $locale.country
	                    }),
	
	                    phone: new $OnboardPhoneModel(),
	
	                    billing_address: $BillingAddressModel.create(null, {
	                        country: $locale.country
	                    })
	                };
	
	                $scope.onboard = new $GuestUpgradeModel(modelSchema);
	
	                $scope.onSubmit = function () {
	                    if ($scope.specialFields.nationalId) {
	                        $scope.onboard.nationalIdModel = $NationalIdModel.instance($rootScope.token);
	                    }
	
	                    if ($scope.specialFields.address) {
	                        $scope.showAddressNormalizationLightbox = true;
	                        return;
	                    }
	
	                    upgrade();
	                };
	
	                $GuestUpgradeModel.instance().retrieve(options).then(function (preloadedData) {
	                    if (preloadedData.guestUpgradeNewAppRedirect === true) {
	                        var redirectUrl = window.location.href.replace('xoonboarding', 'prox');
	                        $logger.info('guest_upgrade_new_app_redirect', {
	                            redirectUrl: redirectUrl,
	                            transactionId: preloadedData.transaction
	                        });
	                        return $util.redirect(redirectUrl);
	                    }
	                    $scope.onboard.payerId = preloadedData.payerId;
	                    $scope.onboard.billing_address.populate(mapper.getFormattedAddress(preloadedData.billing_address));
	                    $scope.onboard.user.populate(preloadedData.user);
	                    $scope.specialFields = mapper.getSpecialFieldsFor(preloadedData.user.country);
	                    $scope.onboard.contentIdentifier = getContentIdentifier();
	
	                    setTCPAFlags();
	
	                    if ($scope.upgradeFromEmail) {
	                        // Email based gxo flow
	
	                        $scope.onboard.card = preloadedData.card;
	                        $scope.onboard.receiptId = preloadedData.receiptId;
	                        $scope.onboard.transaction = preloadedData.transaction;
	                        $scope.onboard.experienceIdentifier = 'proxemailupgrade';
	                    } else {
	                        // Ad based gxo flow
	
	                        // Check if return_url and cancel_url are present and if the session has timed out
	                        if (!$util.param('cancel_url') || !$util.param('return_url') || !preloadedData.email || !preloadedData.payerId || !preloadedData.transaction) {
	                            fpti.trackError(new Error('malformed payload'));
	                            $state.go('guestupgrade.genericError', {
	                                code: 'GUEST_UPGRADE_SESSION_ERROR'
	                            });
	                            return;
	                        }
	                        mapper.pxpMapper($scope, $pxpMatch, preloadedData);
	                        $scope.onboard.transaction = preloadedData.transaction;
	                        $scope.onboard.experienceIdentifier = 'proxupgrade';
	
	                        $logger.info('guest_upgrade_ui_fields', {
	                            special_fields: $scope.specialFields,
	                            txn_id: preloadedData.transaction
	                        });
	
	                        if ($scope.specialFields.address) {
	                            $scope.uponNormalization = function (normalizedAddress, isBack) {
	                                $scope.showAddressNormalizationLightbox = false;
	
	                                // Update the new address
	                                $scope.onboard.billing_address = $BillingAddressModel.create(null, normalizedAddress, {
	                                    id: '0',
	                                    normalization_status: normalizedAddress.normalization_status
	                                });
	
	                                upgrade();
	                            };
	                        }
	                    }
	                });
	
	                $rootScope.$on('allLoaded', function () {
	                    document.getElementById('preloaderSpinner').style.display = 'none';
	                });
	
	                $scope.formatExpiry = function (event) {
	                    var key = event.keyCode || event.charCode;
	                    var $el = $(event.target);
	                    var val = $el.val().replace(/[^0-9\/]/gi, '');
	                    var strokes = val.length;
	
	                    // Ignore delete keys
	                    if (key === 8 || key === 46) {
	                        return;
	                    }
	
	                    // after two characters add a slash char
	                    if (strokes === 2) {
	                        val += '/';
	                    }
	
	                    _this.expiryDate = val;
	                    $el.mask('99/99');
	                };
	
	                var currentYear = new Date().getFullYear().toString();
	                var validMonths = $util.map($util.range(1, 13), function (num) {
	                    return ('0' + num).substr(-2);
	                });
	
	                $scope.validate = function (expiryDate) {
	                    if (!expiryDate) {
	                        return;
	                    }
	
	                    var month = void 0,
	                        year = void 0,
	                        unformatted = void 0;
	                    var isValid = false;
	
	                    unformatted = expiryDate.replace(/[^0-9]/gi, '');
	                    if (unformatted.length > 3) {
	                        month = unformatted.substring(0, 2);
	                        year = currentYear.substring(0, 2) + unformatted.substring(2, 4);
	
	                        isValid = validMonths.indexOf(month) > -1 && year >= currentYear;
	
	                        if (isValid) {
	                            var expDate = new Date(year, parseInt(month, 10) - 1);
	                            var today = new Date();
	                            isValid = expDate > today;
	                        }
	                    }
	
	                    return isValid;
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	_squid.$contentVersion;

/***/ }),

/***/ "./components/xo-guest-components/src/guest-upgrade/lib/mapper.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	    var FIELD_SETS = { // eslint-disable-line no-reserved-keys
	        'default': [],
	        set1: ['dob', 'nationality'],
	        set2: ['dob', 'nationality', 'marketing'],
	        set3: ['address', 'dob', 'marketing'],
	        set4: ['dob', 'nationality', 'occupation'],
	        set5: ['dob', 'nationality', 'nationalId'],
	        set6: ['dob', 'gender', 'placeOfBirth', 'nationality', 'nationalId']
	    };
	
	    var FIELDS = {
	        US: FIELD_SETS['default'],
	        IL: FIELD_SETS.set5,
	        AT: FIELD_SETS.set1,
	        BE: FIELD_SETS.set1,
	        DK: FIELD_SETS.set1,
	        NO: FIELD_SETS.set1,
	        PL: FIELD_SETS.set1,
	        SE: FIELD_SETS.set1,
	        AU: FIELD_SETS.set3,
	        CA: FIELD_SETS.set4,
	        SG: FIELD_SETS.set5,
	        MY: FIELD_SETS.set2,
	        KR: FIELD_SETS.set5,
	        NZ: FIELD_SETS.set5,
	        ID: FIELD_SETS.set5,
	        TH: FIELD_SETS.set5,
	        FR: FIELD_SETS.set1,
	        DE: FIELD_SETS.set1,
	        IT: FIELD_SETS.set1,
	        ES: FIELD_SETS.set1,
	        GB: FIELD_SETS.set1,
	        NL: FIELD_SETS.set1,
	        CH: FIELD_SETS.set5,
	        TR: FIELD_SETS.set1,
	        CZ: FIELD_SETS.set1,
	        FI: FIELD_SETS.set1,
	        EE: FIELD_SETS.set1,
	        LV: FIELD_SETS.set1,
	        HR: FIELD_SETS.set5,
	        UA: FIELD_SETS.set1,
	        PT: FIELD_SETS.set1,
	        IE: FIELD_SETS.set1,
	        HU: FIELD_SETS.set1,
	        GR: FIELD_SETS.set1,
	        SK: FIELD_SETS.set1,
	        BA: FIELD_SETS.set1,
	        BG: FIELD_SETS.set1,
	        CY: FIELD_SETS.set1,
	        HK: FIELD_SETS.set6,
	        LT: FIELD_SETS.set1,
	        LU: FIELD_SETS.set1,
	        MT: FIELD_SETS.set1,
	        PH: FIELD_SETS.set5,
	        RO: FIELD_SETS.set1,
	        SI: FIELD_SETS.set1,
	        TW: FIELD_SETS.set1,
	        AE: FIELD_SETS.set5,
	        AL: FIELD_SETS.set1,
	        AM: FIELD_SETS.set1,
	        AZ: FIELD_SETS.set1,
	        BH: FIELD_SETS.set5,
	        BN: FIELD_SETS.set1,
	        BY: FIELD_SETS.set1,
	        EG: FIELD_SETS.set1,
	        FO: FIELD_SETS.set5,
	        GE: FIELD_SETS.set5,
	        NG: FIELD_SETS.set1,
	        OM: FIELD_SETS.set5,
	        QA: FIELD_SETS.set5,
	        RE: FIELD_SETS.set1,
	        RS: FIELD_SETS.set5,
	        SA: FIELD_SETS.set5,
	        VA: FIELD_SETS.set1,
	        ZA: FIELD_SETS.set5,
	        ZM: FIELD_SETS.set1,
	        LK: FIELD_SETS.set1,
	        FM: FIELD_SETS.set1,
	        MN: FIELD_SETS.set1,
	        MV: FIELD_SETS.set1,
	        VN: FIELD_SETS.set5,
	        MK: FIELD_SETS.set1,
	        GI: FIELD_SETS.set1,
	        MQ: FIELD_SETS.set1,
	        GP: FIELD_SETS.set1,
	        MU: FIELD_SETS.set5,
	        MD: FIELD_SETS.set5,
	        IS: FIELD_SETS.set5,
	        GL: FIELD_SETS.set5,
	        KZ: FIELD_SETS.set5,
	        KW: FIELD_SETS.set5,
	        BT: FIELD_SETS.set1,
	        KH: FIELD_SETS.set1,
	        LA: FIELD_SETS.set1,
	        NP: FIELD_SETS.set1,
	        TO: FIELD_SETS.set1,
	        WS: FIELD_SETS.set1,
	        AO: FIELD_SETS.set1,
	        BF: FIELD_SETS.set1,
	        BI: FIELD_SETS.set1,
	        BJ: FIELD_SETS.set1,
	        CD: FIELD_SETS.set1,
	        CG: FIELD_SETS.set1,
	        CI: FIELD_SETS.set1,
	        CK: FIELD_SETS.set1,
	        CM: FIELD_SETS.set1,
	        CV: FIELD_SETS.set1,
	        DJ: FIELD_SETS.set1,
	        ER: FIELD_SETS.set1,
	        ET: FIELD_SETS.set1,
	        FJ: FIELD_SETS.set1,
	        GA: FIELD_SETS.set1,
	        GF: FIELD_SETS.set1,
	        GM: FIELD_SETS.set1,
	        GN: FIELD_SETS.set1,
	        GW: FIELD_SETS.set1,
	        KG: FIELD_SETS.set1,
	        KI: FIELD_SETS.set1,
	        KM: FIELD_SETS.set1,
	        LI: FIELD_SETS.set1,
	        ME: FIELD_SETS.set1,
	        MG: FIELD_SETS.set1,
	        MH: FIELD_SETS.set1,
	        ML: FIELD_SETS.set1,
	        MR: FIELD_SETS.set1,
	        MS: FIELD_SETS.set1,
	        MW: FIELD_SETS.set1,
	        NA: FIELD_SETS.set1,
	        NC: FIELD_SETS.set1,
	        NE: FIELD_SETS.set1,
	        NF: FIELD_SETS.set1,
	        NR: FIELD_SETS.set1,
	        NU: FIELD_SETS.set1,
	        PF: FIELD_SETS.set1,
	        SZ: FIELD_SETS.set1,
	        TD: FIELD_SETS.set1,
	        TG: FIELD_SETS.set1,
	        TJ: FIELD_SETS.set1,
	        TM: FIELD_SETS.set1,
	        TV: FIELD_SETS.set1,
	        TZ: FIELD_SETS.set1,
	        UG: FIELD_SETS.set5,
	        VU: FIELD_SETS.set1,
	        WF: FIELD_SETS.set1,
	        YT: FIELD_SETS.set1,
	        ZW: FIELD_SETS.set1,
	        DZ: FIELD_SETS.set1,
	        JO: FIELD_SETS.set5,
	        MA: FIELD_SETS.set5,
	        TN: FIELD_SETS.set1,
	        YE: FIELD_SETS.set1,
	        AD: FIELD_SETS.set5,
	        BW: FIELD_SETS.set5,
	        KE: FIELD_SETS.set5,
	        LS: FIELD_SETS.set5,
	        MC: FIELD_SETS.set5,
	        MZ: FIELD_SETS.set5,
	        SN: FIELD_SETS.set5,
	        PG: FIELD_SETS.set1,
	        PM: FIELD_SETS.set1,
	        PN: FIELD_SETS.set1,
	        PY: FIELD_SETS.set1,
	        RW: FIELD_SETS.set1,
	        SB: FIELD_SETS.set1,
	        SC: FIELD_SETS.set1,
	        SH: FIELD_SETS.set1,
	        SJ: FIELD_SETS.set1,
	        SL: FIELD_SETS.set1,
	        SM: FIELD_SETS.set1,
	        SO: FIELD_SETS.set1,
	        ST: FIELD_SETS.set1,
	        PW: FIELD_SETS.set1,
	        AG: FIELD_SETS.set1,
	        AN: FIELD_SETS.set1,
	        AW: FIELD_SETS.set1,
	        BB: FIELD_SETS.set1,
	        BO: FIELD_SETS.set1,
	        BZ: FIELD_SETS.set1,
	        DM: FIELD_SETS.set1,
	        FK: FIELD_SETS.set1,
	        GD: FIELD_SETS.set1,
	        GY: FIELD_SETS.set1,
	        KN: FIELD_SETS.set1,
	        LC: FIELD_SETS.set1,
	        SR: FIELD_SETS.set1,
	        TC: FIELD_SETS.set1,
	        TT: FIELD_SETS.set1,
	        VC: FIELD_SETS.set1,
	        VG: FIELD_SETS.set1,
	        AI: FIELD_SETS.set1,
	        MX: FIELD_SETS.set1,
	        AR: FIELD_SETS.set5,
	        BM: FIELD_SETS.set5,
	        BS: FIELD_SETS.set5,
	        CL: FIELD_SETS.set5,
	        CO: FIELD_SETS.set5,
	        CR: FIELD_SETS.set5,
	        DO: FIELD_SETS.set5,
	        EC: FIELD_SETS.set5,
	        GT: FIELD_SETS.set5,
	        HN: FIELD_SETS.set5,
	        JM: FIELD_SETS.set5,
	        KY: FIELD_SETS.set5,
	        NI: FIELD_SETS.set5,
	        PA: FIELD_SETS.set5,
	        PE: FIELD_SETS.set5,
	        SV: FIELD_SETS.set5,
	        UY: FIELD_SETS.set5,
	        VE: FIELD_SETS.set5,
	        C2: FIELD_SETS.set1
	    };
	
	    // converts ['a', 'b'] to {a:true, b:true}
	    function arrayToObject(array) {
	        var obj = {};
	
	        array.map(function (key) {
	            obj[key] = true;
	        });
	
	        return obj;
	    }
	
	    return {
	        getSpecialFieldsFor: function getSpecialFieldsFor(country) {
	            return arrayToObject(FIELDS[country] || FIELDS.US);
	        },
	
	        getFormattedAddress: function getFormattedAddress(address) {
	            if (address.country === 'AU') {
	                var AUStateCodeMap = {
	                    australiancapitalterritory: 'ACT',
	                    newsouthwales: 'NSW',
	                    northernterritory: 'NT',
	                    queensland: 'QLD',
	                    southaustralia: 'SA',
	                    tasmania: 'TAS',
	                    victoria: 'VIC',
	                    westernaustralia: 'WA'
	                };
	
	                address.state = AUStateCodeMap[address.state.replace(/\s/g, '').toLowerCase()] || address.state;
	            }
	
	            return address;
	        },
	
	        errorMapper: function errorMapper(errorData) {
	            var errorMap = {
	                DOB_INVALID: { field: '#dobText' },
	                PHONE_INVALID: { field: '#telephone' },
	                NATID_INVALID: { field: '#idValue' },
	                FI_INVALID: { field: '#expiry_value, #cvv' },
	                ADDRESS_LINEONE_INVALID: { field: '#billingLine1' },
	                ADDRESS_CITY_INVALID: { field: '#billingCity' },
	                ADDRESS_STATE_INVALID: { field: '#billingState' },
	                ADDRESS_POSTAL_CODE_INVALID: { field: '#billingPostalCode' },
	                PASSWORD_INVALID: { field: '#password, #confirmPassword' }
	            };
	            return errorMap[errorData].field;
	        },
	
	        pxpMapper: function pxpMapper($scope, $pxpMatch, preloadedData) {
	            var patterns = {
	                proxSignupTitleTreatment: 'prox_signup_title_treatment',
	                proxSinglePasswordTreatment: 'prox_single_password_treatment'
	            };
	            var logPayload = {
	                txn_id: preloadedData.transaction
	            };
	
	            if ($scope.locale.metadata.country === 'US') {
	                $pxpMatch('prox_single_password', {}, patterns, logPayload).then(function (result) {
	                    if (result && result.proxSinglePasswordTreatment) {
	                        $scope.flags.singlePassword = true;
	                    }
	                });
	            }
	            if ($scope.locale.metadata.country === 'US' && $scope.locale.metadata.lang === 'en') {
	                $pxpMatch('prox_signup_title', {}, patterns, logPayload).then(function (result) {
	                    if (result && result.proxSignupTitleTreatment) {
	                        $scope.pageTitle = $scope.locale.content.signup.eBayTitle;
	                    } else {
	                        $scope.pageTitle = $scope.locale.content.signup.title;
	                    }
	                });
	            }
	        }
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-guest-components/src/guest-upgrade/template.html":
/***/ (function(module, exports) {

	module.exports = "<div content class=\"outerWrapper\" ng-class=\"[locale.metadata.directionality, locale.country, locale.lang, miniBrowser?'minibrowser':'', isApp?'mobileApp':'']\" id=\"outerWrapper\">\n    <header>\n        <div id=\"header\" class=\"merchantHeader clearfix\">\n            <div class=\"headerWrapper\"></div>\n        </div>\n    </header>\n    <div id=\"wrapper\" class=\"clearfix\" ng-class=\"{confirmationPage: !onboard}\">\n        <div id=\"main\">\n            <div class=\"row-fluid paypalHeaderWrapper\">\n                <div class=\"clearfix paypalHeader\" ng-class=\"{span14: onboard, spanConfirmation: !onboard}\">\n                    <div id=\"paypalLogo\" class=\"logo\">\n                        <span class=\"accessAid\">{{content('signup.paypal')}}</span>\n                    </div>\n                </div>\n            </div>\n            <div content ui-view id=\"contents\">\n                <section class=\"guestUpgrade\" id=\"guestUpgrade\">\n                    <div class=\"row-fluid\">\n                        <div ng-if=\"!onboard\">\n                            <div class=\"tick\">\n                                <div id=\"circle\"></div>\n                                <h1 id=\"successTitle\" class=\"alpha successTitle\">{{content('signup.successTitle')}}</h1>\n                            </div>\n\n                            <p id=\"successText1\">{{content('signup.successText1')}} {{content('signup.successText2')}}</p>\n                            <p id=\"successText3\" ng-bind-html=\"htmlContent('signup.successText3')\"></p>\n                            <p ng-if=\"successUrl\" id=\"returnToEbay\" class=\"returnToMerchant\">{{content('signup.returnToEbayMsg')}}</p>\n\n                            <a ng-if=\"successUrl\" id=\"returnToEbayBtn\" track-link=\"success_redirect_return_to_merchant\" href=\"{{successUrl}}\" ng-click=\"stopTimerAndRedirect($event)\" role=\"button\" class=\"ng-binding btn btnGrey\">\n                                {{content('signup.backToEbay')}}\n                            </a>\n                        </div>\n                        <div ng-if=\"onboard\" class=\"span14\">\n                            <div>\n                                <xo-message message=\"pageErrorMsg\"></xo-message>\n\n                                <form id=\"guestUpgradeForm\" name=\"guestUpgradeForm\" class=\"guestUpgradeForm singlePagePaymentForm\" ng-submit=\"guestUpgradeForm.$valid && onSubmit()\" ng-class=\"{'validated': validated}\" novalidate>\n\n                                    <div class=\"titlePadding\">\n                                        <h1 class=\"alpha\">{{pageTitle}}</h1>\n                                        <p>{{pageSubTitle}}</p>\n                                    </div>\n\n                                    <div ng-if=\"upgradeFromEmail\" class=\"confidential\">\n                                        <div class=\"fieldGroup clearfix\">\n                                            <div class=\"inputField half\">\n                                                <p class=\"contactInfoFont\"><b>{{content('guestUpgrade.contactInfo')}}</b></p>\n                                                <p class=\"contactInfoFont\">{{onboard.user.first_name}} {{onboard.user.last_name}}</p>\n                                                <p class=\"contactInfoFont\">{{onboard.user.email}}</p>\n                                                <p class=\"contactInfoFont\">{{onboard.user.phone}}</p>\n                                            </div>\n                                            <div class=\"inputField half last-child\">\n                                                <p class=\"contactInfoFont\"><b>{{content('guestUpgrade.billingAddress')}}</b></p>\n                                                <p class=\"contactInfoFont\">{{onboard.billing_address.line1}}</p>\n                                                <p class=\"contactInfoFont\">{{onboard.billing_address.city}}, {{onboard.billing_address.state}} {{onboard.billing_address.postal_code}}</p>\n                                            </div>\n                                        </div>\n\n                                        <p class=\"contactInfoFont fullsignup-link\" ng-bind-html=\"htmlContent('guestUpgrade.fullSignupLink', {country: locale.country})\"></p>\n\n                                        <div class=\"fieldGroup confirmCard\">\n                                            <p>{{content('guestUpgrade.confirmCard')}} {{onboard.card.brand}} x-{{onboard.card.lastFour}}</p>\n\n                                            <div class=\"inputField half expirationField\" floating-label>\n                                                <input ng-model=\"onboard.card.expiry_month\"\n                                                name=\"expiry_value\"\n                                                id=\"expiry_value\"\n                                                value=\"\"\n                                                maxlength=\"5\"\n                                                autocapitalize=\"off\"\n                                                autocomplete=\"off\"\n                                                ui-validate=\"'validate($value)'\"\n                                                ng-keyup=\"formatExpiry($event)\"\n                                                required />\n\n                                                <label for=\"expiry_value\" class=\"focus\">{{content('creditcard.expiresPlaceholder')}}</label>\n                                            </div>\n\n                                            <div class=\"inputField cvvField half last-child cvvSecurityCode\" floating-label>\n                                                <input type=\"tel\"\n                                                id=\"cvv\"\n                                                name=\"cvv\"\n                                                ng-model=\"onboard.card.security_code\"\n                                                ng-pattern=\"/^[0-9]{1,4}$/\"\n                                                ng-minlength=\"3\"\n                                                ng-maxlength=\"4\"\n                                                required/>\n\n                                                <label for=\"cvv\" class=\"focus\">{{content('creditcard.cscLabel')}}</label>\n\n                                                <span id=\"securityCode\" class=\"creditCard\" role=\"img\"></span>\n                                            </div>\n                                        </div>\n                                    </div>\n\n                                    <xo-email-input flags=\"flags\" ng-if=\"!upgradeFromEmail\" user=\"onboard.user\" disabled=\"true\"></xo-email-input>\n                                    <xo-password-input user=\"onboard.user\" single-password=\"flags.singlePassword\"></xo-password-input>\n\n                                    <!--As per the UI design, DOB and Gender needs to be side by side -->\n                                    <div class=\"dualInputElements clearfix\">\n                                        <span ng-class=\"{'halfInputElement': specialFields.gender}\" ng-if=\"specialFields.dob\">\n                                            <xo-dob-input user=\"onboard.user\" id=\"dob\"></xo-dob-input>\n                                        </span>\n                                        <!--gender is enabled only for HK-->\n                                        <span ng-if=\"specialFields.gender\">\n                                            <xo-gender-type user=\"onboard.user\" id=\"gender\"></xo-gender-type>\n                                        </span>\n                                    </div>\n\n                                    <!--placeOfBirth -->\n                                    <xo-place-of-birth ng-if=\"specialFields.placeOfBirth\" user=\"onboard.user\" id=\"placeofbirth\"></xo-place-of-birth>\n\n                                    <xo-nationality ng-if=\"specialFields.nationality\" user=\"onboard.user\"></xo-nationality>\n                                    <xo-phone-input phone=\"onboard.phone\" optional=\"false\" countryCode=\"locale.country\"></xo-phone-input>\n                                    <xo-occupation ng-if=\"specialFields.occupation\" user=\"onboard.user\"></xo-occupation>\n\n                                    <xo-national-id-input ng-if=\"specialFields.nationalId\" country=\"{{locale.country}}\" user=\"onboard.user\"></xo-national-id-input>\n\n                                    <div ng-if=\"specialFields.address\" id=\"billingAddress\">\n                                        <xo-add-address address=\"onboard.billing_address\" country=\"locale.country\"></xo-add-address>\n                                    </div>\n                                    <div class=\"terms\" feature=\"signupTerms\">\n                                        <p class=\"signupTerms\" id=\"consumerAdvisory\" ng-bind-html=\"htmlContent('signupTerms.consumerAdvisoryB',{country:locale.country})\"></p>\n                                    </div>\n                                    <div class=\"row-fluid checkbox legal\">\n                                        <input ng-if=\"!specialFields.marketing\" ng-model=\"agree\" type=\"checkbox\" name=\"agree\" id=\"agree\" required/>\n                                        <label ng-if=\"!flags.tcpa_content\" class=\"noBottom\" for=\"agree\" ng-bind-html=\"htmlContent('signupTerms.agreeMarketing')\"></label>\n                                        <label ng-if=\"flags.tcpa_content\" class=\"noBottom\" for=\"agree\" ng-bind-html=\"htmlContent('signupTerms.easySignupTCPA', {country:locale.country, lang:locale.lang})\"></label>\n                                        <div id=\"legalAgreeToolTip\">\n                                            <xo-tooltip trigger=\"#agree\" show-event=\"keyup\" class=\"legalToolTip\">\n                                                <div class=\"tip tipDesc legalAgreeToolTip\">\n                                                    <ul class=\"tipInfoText\">\n                                                        <li class=\"restriction active\">{{content('signup.agrementError')}}</li>\n                                                    </ul>\n                                                </div>\n                                            </xo-tooltip>\n                                        </div>\n                                    </div>\n\n                                    <div ng-if=\"specialFields.marketing\" class=\"row-fluid checkbox legal marketing\">\n                                        <input ng-model=\"onboard.marketing_optin\" type=\"checkbox\" name=\"marketing_optin\" id=\"marketing_optin\" />\n                                        <label class=\"noBottom\" for=\"marketing_optin\" ng-bind-html=\"htmlContent('signup.marketingTerms')\"></label>\n                                    </div>\n\n                                    <div class=\"buttons\">\n                                        <input track-submit id=\"guestUpgradeSubmit\" type=\"submit\" value=\"{{ content('signup.agreeAndCreateAcc')}}\" class=\"btn\"\n                                        ng-click=\"validated=true\" />\n                                    </div>\n                                </form>\n                            </div>\n                        </div>\n\n                        <div ng-if=\"onboard\" class=\"span10\">\n                            <xo-value-props type=\"review\" title=\"{{valueTitle}}\" text-content=\"guestVerify.propVal\"></xo-value-props>\n                        </div>\n                    </div>\n                </section>\n                <xo-modal ng-if=\"showAddressNormalizationLightbox && specialFields.address\" show=\"true\">\n                    <xo-address-normalization token=\"token\" address=\"onboard.billing_address\" hide-back-button=\"true\" done-fn=\"uponNormalization\"></xo-address-normalization>\n                </xo-modal>\n            </div>\n        </div>\n        <xo-spinner></xo-spinner>\n    </div>\n    <div ng-attr-id=\"{{footerStyle}}\">\n        <xo-footer merchant=\"{{content('signup.ebay')}}\" cancel=\"{{cancelUrl}}\"></xo-footer>\n    </div>\n</div>\n"

/***/ }),

/***/ "./components/xo-guest-components/src/guest-upgrade/occupation/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-guest-components/src/guest-upgrade/occupation/template.html"), __webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, template) {
	
	    return angular.module('xo-guest-upgrade.occupation', ['squid', 'xo-error-tooltip.directive']).directive('xoOccupation', function () {
	        return {
	            template: template,
	
	            scope: {
	                user: '='
	            },
	
	            controller: function controller($scope, $locale) {
	
	                $scope.locale = $locale;
	
	                $scope.occupations = function () {
	                    return $locale.content.signup.occupationList;
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-guest-components/src/guest-upgrade/occupation/template.html":
/***/ (function(module, exports) {

	module.exports = "<div id=\"occupationDropDown\" class=\"dropdown confidential occupation clearfix inputField\"\n     floating-label-dropdown content>\n    <select xo-dropdown name=\"occupation\" id=\"occupation\" ng-model=\"user.occupation\"\n            ng-options=\"occupation as name for (occupation, name) in occupations()\"\n            aria-labelledby=\"occupationLabel\" ng-required=\"true\" aria-required=\"true\" required>\n        <option value=\"\">{{ content('signup.occupationLabel') }}</option>\n    </select>\n    <label for=\"occupation\" id=\"occupationLabel\">{{ content('signup.occupationLabel') }}</label>\n</div>"

/***/ }),

/***/ "./components/xo-guest-components/src/guest/nationality/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js");
	
	__webpack_require__("./components/xo-guest-components/src/guest/nationality/styles.less");
	
	var _template = __webpack_require__("./components/xo-guest-components/src/guest/nationality/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('xoNationality', {
	    tag: 'xo-nationality',
	    template: _template2['default'],
	    props: {
	        user: {
	            type: 'var',
	            required: 'true'
	        }
	    },
	    lifecycle: {
	        enter: function enter() {
	            var _this = this;
	
	            var bindLocalizedCountries = function bindLocalizedCountries() {
	
	                var guestBlockedCountries = _squid.$config.guestBlockedCountries || [];
	                _this.metadata = angular.copy(_squid.$locale.metadata);
	
	                _this.countries = _this.metadata.territory.filter(function (c) {
	                    // don't show the blocked countries in the dropdown
	                    return !(guestBlockedCountries.indexOf(c.code) > -1);
	                });
	            };
	
	            bindLocalizedCountries();
	            this.$on('metadataChange', bindLocalizedCountries);
	        }
	    }
	});
	
	
	_squid.$Component;
	
	_squid.$locale;
	
	_squid.$config;
	module.exports = exports['default'];

/***/ }),

/***/ "./components/xo-guest-components/src/guest/nationality/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-guest-components/src/guest/nationality/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-guest-components/src/guest/nationality/styles.less":
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),

/***/ "./components/xo-guest-components/src/guest/nationality/template.html":
/***/ (function(module, exports) {

	module.exports = "<div id=\"nationalityDropDown\" class=\"dropdown confidential nationality clearfix inputField\"\n     floating-label-dropdown content>\n    <select xo-dropdown id=\"nationality\"\n            name=\"nationality\"\n            ng-model=\"user.nationality\"\n            ng-options=\"countryList.code as countryList.name for countryList in countries | filter: {country: '!others'} | filter: {country: '!change'}\"\n            aria-labelledby=\"nationalityLabel\"\n            xo-error-tooltip\n            required>\n    </select>\n    <label id=\"nationalityLabel\" for=\"nationality\">{{ content('country.nationality') }}</label>\n</div>"

/***/ }),

/***/ "./components/xo-form-components/src/phone/directive.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-form-components/src/phone/template.html"), __webpack_require__("./components/xo-form-components/src/phone/phoneInput/directive.js"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/user/index.js"), __webpack_require__("./components/xo-ui-components/src/message/directive.js"), __webpack_require__("./components/xo-models/src/auth/index.js"), __webpack_require__("./components/xo-title/dist/directive.js"), __webpack_require__("./components/xo-page-components/src/value-props/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	
	    squid.module('xo-phone.directive', ['squid', 'xo-phone.phoneInput', 'xomodel.checkout', 'xomodel.user', 'xomodel.auth', 'xo-message.directive', 'xo-title.directive', 'xo-value-props.directive']).directive('xoAddPhone', function () {
	        return {
	            template: template,
	            scope: {},
	            controller: function controller($scope, $rootScope, $location, $populate, $contentVersion, $UserInfoModel, $state, $locale, $featureCountries, $CheckoutSessionModel, $util, $logger, $AuthModel, $feature) {
	
	                $scope.showPhoneDisclosure = $featureCountries('showPhoneDisclosure').indexOf($locale.country) > -1;
	                $scope.phoneConsent = $feature('phoneConsent');
	                $scope.consentContentKey = $scope.phoneConsent ? 'addPhone.phoneConsent' : 'addPhone.phoneDisclosure';
	                $scope.errorMessage = {
	                    msgKeys: ['addPhone.addPhoneNumberConsent'],
	                    type: 'info'
	                };
	
	                $scope.userInfo = $UserInfoModel.instance($rootScope.token);
	
	                var CONTENT_KEY = {
	                    INVALID_PHONE_NUMBER: 'validPhone'
	                };
	
	                var CONTENT_MAPPING = {
	                    numberError: CONTENT_KEY.INVALID_PHONE_NUMBER,
	                    typeError: CONTENT_KEY.INVALID_PHONE_NUMBER
	                };
	
	                var populateErrorMessage = function populateErrorMessage(name) {
	                    var contentKey = CONTENT_MAPPING[name];
	                    var msg = contentKey ? $locale.content.get('scripts.' + contentKey) : 'unresolved content for login error ' + name;
	
	                    $scope.errorMessage = {
	                        msgs: [msg],
	                        type: 'error'
	                    };
	                };
	
	                var validationErrorHandler = {
	                    numberError: populateErrorMessage,
	                    typeError: populateErrorMessage
	                };
	
	                $populate($scope, {
	                    auth: $AuthModel.instance()
	                }).then(function () {
	
	                    $scope.logout = function () {
	                        $logger.info('not_you_logout');
	                        $scope.auth.action('logout').then(function () {
	                            $state.go('checkout.login');
	                        });
	                    };
	
	                    $scope.showNotYou = $scope.auth.is_auth_api_call && $util.param('source') !== 'consumerApp' && $scope.logout;
	
	                    $scope.onSubmit = function () {
	                        if ($scope.phoneConsent) {
	                            $scope.phone.consent = {
	                                agreed: true,
	                                contentId: $locale.country + ':' + $locale.lang + ':' + $scope.consentContentKey + ':' + $contentVersion()
	                            };
	                        }
	                        $scope.userInfo.action('addPhone', {
	
	                            data: $scope.phone,
	
	                            success: function success(data) {
	                                return $CheckoutSessionModel.instance($rootScope.token).action('create', {
	                                    success: function success() {
	                                        $state.go('checkout.review');
	                                    }
	                                });
	                            },
	
	                            contingencies: {
	                                NEED_CREDIT_CARD: function NEED_CREDIT_CARD() {
	                                    $location.path('/checkout/addCard');
	                                },
	
	                                EXPIRED_CREDIT_CARD: function EXPIRED_CREDIT_CARD() {
	                                    $location.path('/checkout/updateCard');
	                                }
	                            },
	
	                            validation: function validation(data) {
	                                angular.forEach(data, function (value, key) {
	                                    validationErrorHandler[key](key);
	                                });
	                            }
	                        });
	                    };
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-form-components/src/phone/template.html":
/***/ (function(module, exports) {

	module.exports = "<section class=\"addPhone\" id=\"addPhone\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14 trayInner\">\n            <xo-message message=\"errorMessage\"></xo-message>\n            <p class=\"userEmail\" id=\"reviewUserInfo\" ng-if=\"showNotYou\">\n                {{ content('creditcard.hi', {userName: auth.first_name ? auth.first_name : auth.email}) }}\n                <span>\n                    <a track-link=\"login_with_diff_user\" href=\"\" ng-click=\"logout()\">{{ content('memberReview.notYou')}}</a>\n                </span>\n            </p>\n            <xo-title title-txt=\"{{content('addPhone.addPhoneNumber')}}\"></xo-title>\n            <form name=\"addPhoneForm\" class=\"proceed\" content autocomplete=\"off\" ng-submit=\"addPhoneForm.$valid && onSubmit()\" ng-class=\"{true: 'validated'}[validated]\" novalidate>\n\n                <xo-phone-input phone=\"phone\"></xo-phone-input>\n                <p class=\"disclaimer\" id=\"phoneDisclosure\" ng-if=\"showPhoneDisclosure\">\n                    <span data-ng-bind-html=\"htmlContent(consentContentKey)\"></span>\n                </p>\n                <input track-submit type=\"submit\" value=\"{{showPhoneDisclosure ? content('addPhone.agreeContinue') : content('common.continueLabel') }}\" class=\"btn full\" ng-click=\"validated=true\" />\n            </form>\n        </div>\n        <div class=\"span10\">\n            <xo-value-props type=\"login\" title=\"{{content('login.propHead')}}\" text-content=\"login.propVal\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "./..":
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(__webpack_module_template_argument_0__);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__("../node_modules/style-loader/addStyles.js")(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/less-loader/index.js!./styles.less", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/less-loader/index.js!./styles.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./components/xo-form-components/src/name-input/template.html":
/***/ (function(module, exports) {

	module.exports = "<div class=\"fieldGroup name clearfix\" ng-class=\"country || locale.country\" content>\n  <div ng-if=\"metadata.nameEntry.layout\" ng-repeat=\"layoutItem in metadata.nameEntry.layout\">\n\n    <!-- First name -->\n    <div ng-if=\"layoutItem.$ === 'givenName'\">\n      <div class=\"inputField half confidential\" ng-class=\"{'last-child': $last}\" floating-label directionality>\n\n        <input ng-model=\"user.first_name\"\n               id=\"firstName\"\n               name=\"firstName\"\n               value=\"\"\n               pattern=\"(?!^\\d+$)^.+$\"\n               autocapitalize=\"off\"\n               aria-required=\"false\"\n               autocomplete=\"off\"\n               maxlength=\"100\"\n               xo-error-tooltip\n               ng-required=\"{{layoutItem.required}}\" />\n          <label for=\"firstName\">\n              {{content('common.firstName')}}\n          </label>\n      </div>\n    </div>\n\n    <!-- Last name -->\n    <div ng-if=\"layoutItem.$ === 'surname'\">\n      <div class=\"inputField half confidential\" ng-class=\"{'last-child': $last}\" floating-label directionality>\n        <input ng-model=\"user.last_name\"\n               id=\"lastName\"\n               name=\"lastName\"\n               value=\"\"\n               pattern=\"(?!^\\d+$)^.+$\"\n               autocapitalize=\"off\"\n               aria-required=\"false\"\n               autocomplete=\"off\"\n               maxlength=\"100\"\n               xo-error-tooltip\n               ng-required=\"{{layoutItem.required}}\" />\n          <label for=\"lastName\">\n              {{content('common.lastName')}}\n          </label>\n      </div>\n    </div>\n  </div>\n  <div ng-if=\"!metadata.nameEntry.layout\">\n    <div class=\"inputField half confidential\" floating-label directionality>\n\n      <input ng-model=\"user.first_name\"\n             id=\"firstName\"\n             name=\"firstName\"\n             value=\"\"\n             pattern=\"(?!^\\d+$)^.+$\"\n             autocapitalize=\"off\"\n             aria-required=\"false\"\n             autocomplete=\"off\"\n             maxlength=\"100\"\n             xo-error-tooltip\n             ng-required=\"true\" />\n        <label for=\"firstName\">\n            {{content('common.firstName')}}\n        </label>\n    </div>\n\n    <!-- Last name -->\n    <div class=\"inputField half confidential last-child\" floating-label directionality>\n\n      <input ng-model=\"user.last_name\"\n             id=\"lastName\"\n             name=\"lastName\"\n             value=\"\"\n             pattern=\"(?!^\\d+$)^.+$\"\n             autocapitalize=\"off\"\n             aria-required=\"false\"\n             autocomplete=\"off\"\n             maxlength=\"100\"\n             xo-error-tooltip\n             ng-required=\"true\" />\n        <label for=\"lastName\">\n            {{content('common.lastName')}}\n        </label>\n    </div>\n  </div>\n</div>\n"

/***/ })

});


// WEBPACK FOOTER //
// js/main.js